//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming



/** Classe base astratta di tutte le risposte API */
export abstract class ApiResponse implements IApiResponse {
    /** Codice facoltativo che identifica il tipo di risposta */
    code?: string | null;
    /** ID univoco della richiesta alla quale viene fornita la risposta */
    requestID?: string | null;
    /** Timestamp UTC della risposta */
    timestamp?: number;
    /** ID univoco della risposta */
    uniqueID?: string;

    constructor(data?: IApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.requestID = _data["requestID"] !== undefined ? _data["requestID"] : null as any;
            this.timestamp = _data["timestamp"] !== undefined ? _data["timestamp"] : null as any;
            this.uniqueID = _data["uniqueID"] !== undefined ? _data["uniqueID"] : null as any;
        }
    }

    static fromJS(data: any): ApiResponse {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ApiResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["requestID"] = this.requestID !== undefined ? this.requestID : null as any;
        data["timestamp"] = this.timestamp !== undefined ? this.timestamp : null as any;
        data["uniqueID"] = this.uniqueID !== undefined ? this.uniqueID : null as any;
        return data;
    }
}

/** Classe base astratta di tutte le risposte API */
export interface IApiResponse {
    /** Codice facoltativo che identifica il tipo di risposta */
    code?: string | null;
    /** ID univoco della richiesta alla quale viene fornita la risposta */
    requestID?: string | null;
    /** Timestamp UTC della risposta */
    timestamp?: number;
    /** ID univoco della risposta */
    uniqueID?: string;
}

/** Classe base delle risposte positive API */
export class OkApiResponse extends ApiResponse implements IOkApiResponse {
    /** Risultato dell'elaborazione. Vale sempre "OK"  */
    result?: EOkResponseType;

    constructor(data?: IOkApiResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.result = _data["result"] !== undefined ? _data["result"] : null as any;
        }
    }

    static override fromJS(data: any): OkApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OkApiResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result !== undefined ? this.result : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Classe base delle risposte positive API */
export interface IOkApiResponse extends IApiResponse {
    /** Risultato dell'elaborazione. Vale sempre "OK"  */
    result?: EOkResponseType;
}

export class AccordoReadResponse extends OkApiResponse implements IAccordoReadResponse {
    accordo?: Accordo | null;

    constructor(data?: IAccordoReadResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordo = _data["accordo"] ? Accordo.fromJS(_data["accordo"]) : null as any;
        }
    }

    static override fromJS(data: any): AccordoReadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccordoReadResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordo"] = this.accordo ? this.accordo.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAccordoReadResponse extends IOkApiResponse {
    accordo?: Accordo | null;
}

export class Accordo implements IAccordo {
    accordoID?: number;
    operatore?: EOperatore | null;
    contattoID?: number | null;
    pagamentoID?: number | null;
    tipo?: ETipoAccordo;
    nome!: string;
    memo?: string | null;
    dal?: string | null;
    al?: string | null;
    tipoEmissioneVoucher?: ETipoEmissioneVoucher | null;
    notaPiePaginaVoucher?: string | null;
    valutaID?: number | null;
    contabilizzazione?: EContabilizzazione | null;
    centroDiCosto?: ECentroDiCosto | null;
    deregolamentato?: boolean;
    fornitore?: EFornitore | null;
    host2Host?: boolean | null;
    prenotazioneAutomatica?: boolean;
    commissioniBiglietteriaDeregolamentate?: boolean;
    prezziLordi?: boolean | null;
    contattoSupportoID?: number | null;
    reservationsFrom?: string | null;
    margine?: number | null;
    conversioneCosti?: number | null;
    conversionePrezzi?: number | null;
    margineNetto?: number | null;
    conversionePrezziNetto?: number | null;
    marginePacchetto?: number | null;
    conversionePrezziPacchetto?: number | null;
    codiceContabile?: number | null;
    deleted?: string | null;
    commissioneBiglietteriaCustom?: number | null;

    constructor(data?: IAccordo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.pagamentoID = _data["pagamentoID"] !== undefined ? _data["pagamentoID"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.memo = _data["memo"] !== undefined ? _data["memo"] : null as any;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.al = _data["al"] !== undefined ? _data["al"] : null as any;
            this.tipoEmissioneVoucher = _data["tipoEmissioneVoucher"] !== undefined ? _data["tipoEmissioneVoucher"] : null as any;
            this.notaPiePaginaVoucher = _data["notaPiePaginaVoucher"] !== undefined ? _data["notaPiePaginaVoucher"] : null as any;
            this.valutaID = _data["valutaID"] !== undefined ? _data["valutaID"] : null as any;
            this.contabilizzazione = _data["contabilizzazione"] !== undefined ? _data["contabilizzazione"] : null as any;
            this.centroDiCosto = _data["centroDiCosto"] !== undefined ? _data["centroDiCosto"] : null as any;
            this.deregolamentato = _data["deregolamentato"] !== undefined ? _data["deregolamentato"] : null as any;
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : null as any;
            this.host2Host = _data["host2Host"] !== undefined ? _data["host2Host"] : null as any;
            this.prenotazioneAutomatica = _data["prenotazioneAutomatica"] !== undefined ? _data["prenotazioneAutomatica"] : null as any;
            this.commissioniBiglietteriaDeregolamentate = _data["commissioniBiglietteriaDeregolamentate"] !== undefined ? _data["commissioniBiglietteriaDeregolamentate"] : null as any;
            this.prezziLordi = _data["prezziLordi"] !== undefined ? _data["prezziLordi"] : null as any;
            this.contattoSupportoID = _data["contattoSupportoID"] !== undefined ? _data["contattoSupportoID"] : null as any;
            this.reservationsFrom = _data["reservationsFrom"] !== undefined ? _data["reservationsFrom"] : null as any;
            this.margine = _data["margine"] !== undefined ? _data["margine"] : null as any;
            this.conversioneCosti = _data["conversioneCosti"] !== undefined ? _data["conversioneCosti"] : null as any;
            this.conversionePrezzi = _data["conversionePrezzi"] !== undefined ? _data["conversionePrezzi"] : null as any;
            this.margineNetto = _data["margineNetto"] !== undefined ? _data["margineNetto"] : null as any;
            this.conversionePrezziNetto = _data["conversionePrezziNetto"] !== undefined ? _data["conversionePrezziNetto"] : null as any;
            this.marginePacchetto = _data["marginePacchetto"] !== undefined ? _data["marginePacchetto"] : null as any;
            this.conversionePrezziPacchetto = _data["conversionePrezziPacchetto"] !== undefined ? _data["conversionePrezziPacchetto"] : null as any;
            this.codiceContabile = _data["codiceContabile"] !== undefined ? _data["codiceContabile"] : null as any;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : null as any;
            this.commissioneBiglietteriaCustom = _data["commissioneBiglietteriaCustom"] !== undefined ? _data["commissioneBiglietteriaCustom"] : null as any;
        }
    }

    static fromJS(data: any): Accordo {
        data = typeof data === 'object' ? data : {};
        let result = new Accordo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["pagamentoID"] = this.pagamentoID !== undefined ? this.pagamentoID : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["memo"] = this.memo !== undefined ? this.memo : null as any;
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["al"] = this.al !== undefined ? this.al : null as any;
        data["tipoEmissioneVoucher"] = this.tipoEmissioneVoucher !== undefined ? this.tipoEmissioneVoucher : null as any;
        data["notaPiePaginaVoucher"] = this.notaPiePaginaVoucher !== undefined ? this.notaPiePaginaVoucher : null as any;
        data["valutaID"] = this.valutaID !== undefined ? this.valutaID : null as any;
        data["contabilizzazione"] = this.contabilizzazione !== undefined ? this.contabilizzazione : null as any;
        data["centroDiCosto"] = this.centroDiCosto !== undefined ? this.centroDiCosto : null as any;
        data["deregolamentato"] = this.deregolamentato !== undefined ? this.deregolamentato : null as any;
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : null as any;
        data["host2Host"] = this.host2Host !== undefined ? this.host2Host : null as any;
        data["prenotazioneAutomatica"] = this.prenotazioneAutomatica !== undefined ? this.prenotazioneAutomatica : null as any;
        data["commissioniBiglietteriaDeregolamentate"] = this.commissioniBiglietteriaDeregolamentate !== undefined ? this.commissioniBiglietteriaDeregolamentate : null as any;
        data["prezziLordi"] = this.prezziLordi !== undefined ? this.prezziLordi : null as any;
        data["contattoSupportoID"] = this.contattoSupportoID !== undefined ? this.contattoSupportoID : null as any;
        data["reservationsFrom"] = this.reservationsFrom !== undefined ? this.reservationsFrom : null as any;
        data["margine"] = this.margine !== undefined ? this.margine : null as any;
        data["conversioneCosti"] = this.conversioneCosti !== undefined ? this.conversioneCosti : null as any;
        data["conversionePrezzi"] = this.conversionePrezzi !== undefined ? this.conversionePrezzi : null as any;
        data["margineNetto"] = this.margineNetto !== undefined ? this.margineNetto : null as any;
        data["conversionePrezziNetto"] = this.conversionePrezziNetto !== undefined ? this.conversionePrezziNetto : null as any;
        data["marginePacchetto"] = this.marginePacchetto !== undefined ? this.marginePacchetto : null as any;
        data["conversionePrezziPacchetto"] = this.conversionePrezziPacchetto !== undefined ? this.conversionePrezziPacchetto : null as any;
        data["codiceContabile"] = this.codiceContabile !== undefined ? this.codiceContabile : null as any;
        data["deleted"] = this.deleted !== undefined ? this.deleted : null as any;
        data["commissioneBiglietteriaCustom"] = this.commissioneBiglietteriaCustom !== undefined ? this.commissioneBiglietteriaCustom : null as any;
        return data;
    }
}

export interface IAccordo {
    accordoID?: number;
    operatore?: EOperatore | null;
    contattoID?: number | null;
    pagamentoID?: number | null;
    tipo?: ETipoAccordo;
    nome: string;
    memo?: string | null;
    dal?: string | null;
    al?: string | null;
    tipoEmissioneVoucher?: ETipoEmissioneVoucher | null;
    notaPiePaginaVoucher?: string | null;
    valutaID?: number | null;
    contabilizzazione?: EContabilizzazione | null;
    centroDiCosto?: ECentroDiCosto | null;
    deregolamentato?: boolean;
    fornitore?: EFornitore | null;
    host2Host?: boolean | null;
    prenotazioneAutomatica?: boolean;
    commissioniBiglietteriaDeregolamentate?: boolean;
    prezziLordi?: boolean | null;
    contattoSupportoID?: number | null;
    reservationsFrom?: string | null;
    margine?: number | null;
    conversioneCosti?: number | null;
    conversionePrezzi?: number | null;
    margineNetto?: number | null;
    conversionePrezziNetto?: number | null;
    marginePacchetto?: number | null;
    conversionePrezziPacchetto?: number | null;
    codiceContabile?: number | null;
    deleted?: string | null;
    commissioneBiglietteriaCustom?: number | null;
}

export enum EOperatore {
    Indefinito = "Indefinito",
    Naar = "Naar",
    NaarFrance = "NaarFrance",
    NaarGermany = "NaarGermany",
    Aviomar = "Aviomar",
    NaarBenelux = "NaarBenelux",
    Salaun = "Salaun",
    NaarSwiss = "NaarSwiss",
}

export enum ETipoAccordo {
    Fornitori = "Fornitori",
    Agenzie = "Agenzie",
    Biglietteria = "Biglietteria",
    Scaduto = "Scaduto",
}

export enum ETipoEmissioneVoucher {
    Nessuna = "Nessuna",
    UnVoucherAServizio = "UnVoucherAServizio",
    UnVoucherAOfferta = "UnVoucherAOfferta",
    VoucherFornitore = "VoucherFornitore",
}

export enum EContabilizzazione {
    ExtraCee = "ExtraCee",
    Cee = "Cee",
    Italia = "Italia",
}

export enum ECentroDiCosto {
    Naar = "Naar",
    Aliviaggi = "Aliviaggi",
    DriveOut = "DriveOut",
    Anyway = "Anyway",
    Aviomar = "Aviomar",
}

export enum EFornitore {
    NONE = "NONE",
    NAAR_INTERNO = "NAAR_INTERNO",
    GTA = "GTA",
    KOBRA = "KOBRA",
    TOURICO = "TOURICO",
    ATI = "ATI",
    PANORAMA = "PANORAMA",
    CLICKONLINE = "CLICKONLINE",
    JONVIEW = "JONVIEW",
    NAAR_INTERNO_NUOVO = "NAAR_INTERNO_NUOVO",
    HOTELBEDS = "HOTELBEDS",
    JACTRAVEL = "JACTRAVEL",
    TRAVCO = "TRAVCO",
    BONOTEL = "BONOTEL",
    AMADEUS = "AMADEUS",
    TEAM_AMERICA = "TEAM_AMERICA",
    YOUTRAVEL = "YOUTRAVEL",
    AVIOMAR = "AVIOMAR",
    GALILEO = "GALILEO",
    PANPACIFIC = "PANPACIFIC",
    DELTANET = "DELTANET",
    ARABIAN = "ARABIAN",
    EUROTOURS = "EUROTOURS",
    EXPEDIA = "EXPEDIA",
    TRAVELFUSION = "TRAVELFUSION",
    KUONI = "KUONI",
    TIRRENIA = "TIRRENIA",
    ALLIED = "ALLIED",
    INTRA = "INTRA",
    ITALCAMEL = "ITALCAMEL",
    MONDIAL = "MONDIAL",
    UNILINE = "UNILINE",
    WELCOMEBEDS = "WELCOMEBEDS",
    RESTEL = "RESTEL",
    ATI_2012 = "ATI_2012",
    MIKITRAVEL_OLD = "MIKITRAVEL_OLD",
    MARK = "MARK",
    EUROTUR = "EUROTUR",
    CTN = "CTN",
    RMHTOURS = "RMHTOURS",
    OPENTOURS = "OPENTOURS",
    TRANSHOTEL = "TRANSHOTEL",
    TEAM_AMERICA_2013 = "TEAM_AMERICA_2013",
    TEKURA = "TEKURA",
    AOT = "AOT",
    TRAVALCO = "TRAVALCO",
    WTS = "WTS",
    ASIAN = "ASIAN",
    VOLATOUR = "VOLATOUR",
    JTB = "JTB",
    GOWEST_OLD = "GOWEST_OLD",
    TOURMAPPERS = "TOURMAPPERS",
    TOURICO_2014 = "TOURICO_2014",
    TEAM_AMERICA_2014 = "TEAM_AMERICA_2014",
    EAN = "EAN",
    GLOBAL = "GLOBAL",
    VISION = "VISION",
    ROSIE = "ROSIE",
    MECA = "MECA",
    MARK_2016 = "MARK_2016",
    CONDOR = "CONDOR",
    SANDALS = "SANDALS",
    RTS = "RTS",
    A4Y = "A4Y",
    DUMMY = "DUMMY",
    AIC = "AIC",
    TRAVALCO_2018 = "TRAVALCO_2018",
    OLYMPIA = "OLYMPIA",
    HOTELSTON = "HOTELSTON",
    ALLIEDTPRO = "ALLIEDTPRO",
    PACIFIC_DNZ = "PACIFIC_DNZ",
    CREOLE = "CREOLE",
    WTS_2018 = "WTS_2018",
    PACIFIC_DAU = "PACIFIC_DAU",
    ALAMO = "ALAMO",
    WHL = "WHL",
    MSC = "MSC",
    PRICELINE = "PRICELINE",
    TOURMAPPERS_2018 = "TOURMAPPERS_2018",
    MISTER_ROOM = "MISTER_ROOM",
    RIU = "RIU",
    WTS_NAMIBIA = "WTS_NAMIBIA",
    W2M = "W2M",
    MAGIC_TRAVELS = "MAGIC_TRAVELS",
    BOOK_ME = "BOOK_ME",
    CLUBMED = "CLUBMED",
    MAGIC_TRAVELS_2022 = "MAGIC_TRAVELS_2022",
    NTA = "NTA",
    HASHNAP = "HASHNAP",
    WEBBEDS = "WEBBEDS",
    HOTEL_TRADER = "HOTEL_TRADER",
    MIKITRAVEL = "MIKITRAVEL",
    G2_TRAVEL = "G2_TRAVEL",
    NUITEE = "NUITEE",
    GOWEST_2024 = "GOWEST_2024",
    RATE_HAWK = "RATE_HAWK",
    WEBBEDS_2024 = "WEBBEDS_2024",
    GO_WAY = "GO_WAY",
    GO_GLOBAL = "GO_GLOBAL",
    DIDA_TRAVEL = "DIDA_TRAVEL",
    HYPER_GUEST = "HYPER_GUEST",
    G2_TRAVEL_2024 = "G2_TRAVEL_2024",
    MIKITRAVEL_2024 = "MIKITRAVEL_2024",
    JUMBONLINE = "JUMBONLINE",
    NORDBEDS = "NORDBEDS",
    TBO = "TBO",
    AMADEUS_NDC = "AMADEUS_NDC",
    DIDA_TRAVEL_2025 = "DIDA_TRAVEL_2025",
    EXPEDIA_RAPID = "EXPEDIA_RAPID",
    DOTW = "DOTW",
    WTS_EAST_AFRICA = "WTS_EAST_AFRICA",
    ENTERPRISE = "ENTERPRISE",
    TOUNDRA = "TOUNDRA",
    WTS_VMP_SA = "WTS_VMP_SA",
    W2M_2026 = "W2M_2026",
    WTS_VMP_NA = "WTS_VMP_NA",
}

export enum EOkResponseType {
    OK = "OK",
}

/** Classe base delle risposte di errore */
export class ErrorResponse extends ApiResponse implements IErrorResponse {
    /** Risultato dell'elaborazione. Vale sempre "ERROR"  */
    result?: EErrorResponseType;
    /** Descrizione testuale dell'errore */
    error?: string | null;
    /** Valori custom associati all'errore */
    values?: { [key: string]: any; } | null;

    constructor(data?: IErrorResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.result = _data["result"] !== undefined ? _data["result"] : null as any;
            this.error = _data["error"] !== undefined ? _data["error"] : null as any;
            if (_data["values"]) {
                this.values = {} as any;
                for (let key in _data["values"]) {
                    if (_data["values"].hasOwnProperty(key))
                        (this.values as any)![key] = _data["values"][key] !== undefined ? _data["values"][key] : null as any;
                }
            }
            else {
                this.values = null as any;
            }
        }
    }

    static override fromJS(data: any): ErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result !== undefined ? this.result : null as any;
        data["error"] = this.error !== undefined ? this.error : null as any;
        if (this.values) {
            data["values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    (data["values"] as any)[key] = this.values[key] !== undefined ? this.values[key] : null as any;
            }
        }
        super.toJSON(data);
        return data;
    }
}

/** Classe base delle risposte di errore */
export interface IErrorResponse extends IApiResponse {
    /** Risultato dell'elaborazione. Vale sempre "ERROR"  */
    result?: EErrorResponseType;
    /** Descrizione testuale dell'errore */
    error?: string | null;
    /** Valori custom associati all'errore */
    values?: { [key: string]: any; } | null;
}

export enum EErrorResponseType {
    ERROR = "ERROR",
}

export class ModelValidationFailedResponse extends ErrorResponse implements IModelValidationFailedResponse {
    errors?: string[] | null;

    constructor(data?: IModelValidationFailedResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            else {
                this.errors = null as any;
            }
        }
    }

    static override fromJS(data: any): ModelValidationFailedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ModelValidationFailedResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IModelValidationFailedResponse extends IErrorResponse {
    errors?: string[] | null;
}

/** Classe base di tutte le richieste API */
export class ApiRequest implements IApiRequest {
    /** ID univoco facoltativo della richiesta */
    uniqueID?: string | null;

    constructor(data?: IApiRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueID = _data["uniqueID"] !== undefined ? _data["uniqueID"] : null as any;
        }
    }

    static fromJS(data: any): ApiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueID"] = this.uniqueID !== undefined ? this.uniqueID : null as any;
        return data;
    }
}

/** Classe base di tutte le richieste API */
export interface IApiRequest {
    /** ID univoco facoltativo della richiesta */
    uniqueID?: string | null;
}

export class AccordoReadRequest extends ApiRequest implements IAccordoReadRequest {
    accordoID?: number;

    constructor(data?: IAccordoReadRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
        }
    }

    static override fromJS(data: any): AccordoReadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AccordoReadRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAccordoReadRequest extends IApiRequest {
    accordoID?: number;
}

export class AccordoWriteRequest extends ApiRequest implements IAccordoWriteRequest {
    accordo?: Accordo | null;

    constructor(data?: IAccordoWriteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordo = _data["accordo"] ? Accordo.fromJS(_data["accordo"]) : null as any;
        }
    }

    static override fromJS(data: any): AccordoWriteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AccordoWriteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordo"] = this.accordo ? this.accordo.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAccordoWriteRequest extends IApiRequest {
    accordo?: Accordo | null;
}

export class AccordoDeleteRequest extends ApiRequest implements IAccordoDeleteRequest {
    /** Id dell'accordo da eliminare */
    accordoID?: number;

    constructor(data?: IAccordoDeleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
        }
    }

    static override fromJS(data: any): AccordoDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AccordoDeleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAccordoDeleteRequest extends IApiRequest {
    /** Id dell'accordo da eliminare */
    accordoID?: number;
}

export class RestoreAccordoRequest extends ApiRequest implements IRestoreAccordoRequest {
    /** Id dell'accordo da eliminare */
    accordoID?: number;

    constructor(data?: IRestoreAccordoRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
        }
    }

    static override fromJS(data: any): RestoreAccordoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreAccordoRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IRestoreAccordoRequest extends IApiRequest {
    /** Id dell'accordo da eliminare */
    accordoID?: number;
}

export class AccordiDeleteMultiRequest extends ApiRequest implements IAccordiDeleteMultiRequest {
    /** Lista degli id degli accordi da eliminare */
    accordiIds?: number[] | null;

    constructor(data?: IAccordiDeleteMultiRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["accordiIds"])) {
                this.accordiIds = [] as any;
                for (let item of _data["accordiIds"])
                    this.accordiIds!.push(item);
            }
            else {
                this.accordiIds = null as any;
            }
        }
    }

    static override fromJS(data: any): AccordiDeleteMultiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AccordiDeleteMultiRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accordiIds)) {
            data["accordiIds"] = [];
            for (let item of this.accordiIds)
                data["accordiIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAccordiDeleteMultiRequest extends IApiRequest {
    /** Lista degli id degli accordi da eliminare */
    accordiIds?: number[] | null;
}

export class NrTableResponseOfContraenteRow extends OkApiResponse implements INrTableResponseOfContraenteRow {
    /** Array delle righe della pagina richiesta */
    rows?: ContraenteRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfContraenteRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ContraenteRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfContraenteRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfContraenteRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfContraenteRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: ContraenteRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class ContraenteRow implements IContraenteRow {
    /** Id riga accordo/contraente */
    id?: number;
    /** Id del contatto contraente */
    contattoID?: number;
    /** Nome visualizzato del contatto */
    contatto?: string | null;
    /** Operatore di riferimento */
    operatore?: EOperatore;
    /** Id del pricing */
    pricing?: string | null;
    /** True se i viaggi netti sono abilitati */
    viaggiNetti?: boolean | null;
    /** Il Markup dei viaggi netti */
    markup_vn?: number | null;
    /** Il Markup dei teds */
    markup_teds?: number | null;
    /** Data di validità */
    data?: string | null;

    constructor(data?: IContraenteRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.contatto = _data["contatto"] !== undefined ? _data["contatto"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.pricing = _data["pricing"] !== undefined ? _data["pricing"] : null as any;
            this.viaggiNetti = _data["viaggiNetti"] !== undefined ? _data["viaggiNetti"] : null as any;
            this.markup_vn = _data["markup_vn"] !== undefined ? _data["markup_vn"] : null as any;
            this.markup_teds = _data["markup_teds"] !== undefined ? _data["markup_teds"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
        }
    }

    static fromJS(data: any): ContraenteRow {
        data = typeof data === 'object' ? data : {};
        let result = new ContraenteRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["contatto"] = this.contatto !== undefined ? this.contatto : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["pricing"] = this.pricing !== undefined ? this.pricing : null as any;
        data["viaggiNetti"] = this.viaggiNetti !== undefined ? this.viaggiNetti : null as any;
        data["markup_vn"] = this.markup_vn !== undefined ? this.markup_vn : null as any;
        data["markup_teds"] = this.markup_teds !== undefined ? this.markup_teds : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        return data;
    }
}

export interface IContraenteRow {
    /** Id riga accordo/contraente */
    id?: number;
    /** Id del contatto contraente */
    contattoID?: number;
    /** Nome visualizzato del contatto */
    contatto?: string | null;
    /** Operatore di riferimento */
    operatore?: EOperatore;
    /** Id del pricing */
    pricing?: string | null;
    /** True se i viaggi netti sono abilitati */
    viaggiNetti?: boolean | null;
    /** Il Markup dei viaggi netti */
    markup_vn?: number | null;
    /** Il Markup dei teds */
    markup_teds?: number | null;
    /** Data di validità */
    data?: string | null;
}

/** Riferimento ad un file esportato */
export class ExportFileResponse extends OkApiResponse implements IExportFileResponse {
    /** Parametro da passare a /export/get se TempFileID è nullo */
    file?: string | null;
    /** ID del file temporaneo da passare a /export/get/temp e che prevale su File quando valorizzato */
    tempFileID?: number | null;

    constructor(data?: IExportFileResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.file = _data["file"] !== undefined ? _data["file"] : null as any;
            this.tempFileID = _data["tempFileID"] !== undefined ? _data["tempFileID"] : null as any;
        }
    }

    static override fromJS(data: any): ExportFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExportFileResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file !== undefined ? this.file : null as any;
        data["tempFileID"] = this.tempFileID !== undefined ? this.tempFileID : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Riferimento ad un file esportato */
export interface IExportFileResponse extends IOkApiResponse {
    /** Parametro da passare a /export/get se TempFileID è nullo */
    file?: string | null;
    /** ID del file temporaneo da passare a /export/get/temp e che prevale su File quando valorizzato */
    tempFileID?: number | null;
}

export class LocalizedRequest extends ApiRequest implements ILocalizedRequest {
    /** Lingua richiesta */
    lingua!: ELingua;

    constructor(data?: ILocalizedRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : null as any;
        }
    }

    static override fromJS(data: any): LocalizedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizedRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lingua"] = this.lingua !== undefined ? this.lingua : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ILocalizedRequest extends IApiRequest {
    /** Lingua richiesta */
    lingua: ELingua;
}

/** Base per richieste paginate */
export class NrTableRequest extends LocalizedRequest implements INrTableRequest {
    /** Numero della pagina 1 based */
    page?: number;
    /** Dimensione della pagina */
    pageSize?: number;
    /** Nome della colonna su cui effettuare l'ordinamento (facoltativo) */
    sortColumn?: string | null;
    /** Direzione dell'ordinamento (facoltativo): asc / desc / '' */
    sortDirection?: string | null;
    /** Se true esporta il file Excel invece di generare la tabella */
    export?: boolean;
    exportEntityName?: string | null;
    exportFieldsNames?: { [key: string]: string; } | null;
    fieldsDecoders?: { [key: string]: { [key: string]: string; }; } | null;

    constructor(data?: INrTableRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.page = _data["page"] !== undefined ? _data["page"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
            this.sortColumn = _data["sortColumn"] !== undefined ? _data["sortColumn"] : null as any;
            this.sortDirection = _data["sortDirection"] !== undefined ? _data["sortDirection"] : null as any;
            this.export = _data["export"] !== undefined ? _data["export"] : null as any;
            this.exportEntityName = _data["exportEntityName"] !== undefined ? _data["exportEntityName"] : null as any;
            if (_data["exportFieldsNames"]) {
                this.exportFieldsNames = {} as any;
                for (let key in _data["exportFieldsNames"]) {
                    if (_data["exportFieldsNames"].hasOwnProperty(key))
                        (this.exportFieldsNames as any)![key] = _data["exportFieldsNames"][key] !== undefined ? _data["exportFieldsNames"][key] : null as any;
                }
            }
            else {
                this.exportFieldsNames = null as any;
            }
            if (_data["fieldsDecoders"]) {
                this.fieldsDecoders = {} as any;
                for (let key in _data["fieldsDecoders"]) {
                    if (_data["fieldsDecoders"].hasOwnProperty(key))
                        (this.fieldsDecoders as any)![key] = _data["fieldsDecoders"][key] !== undefined ? _data["fieldsDecoders"][key] : {};
                }
            }
            else {
                this.fieldsDecoders = null as any;
            }
        }
    }

    static override fromJS(data: any): NrTableRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page !== undefined ? this.page : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        data["sortColumn"] = this.sortColumn !== undefined ? this.sortColumn : null as any;
        data["sortDirection"] = this.sortDirection !== undefined ? this.sortDirection : null as any;
        data["export"] = this.export !== undefined ? this.export : null as any;
        data["exportEntityName"] = this.exportEntityName !== undefined ? this.exportEntityName : null as any;
        if (this.exportFieldsNames) {
            data["exportFieldsNames"] = {};
            for (let key in this.exportFieldsNames) {
                if (this.exportFieldsNames.hasOwnProperty(key))
                    (data["exportFieldsNames"] as any)[key] = this.exportFieldsNames[key] !== undefined ? this.exportFieldsNames[key] : null as any;
            }
        }
        if (this.fieldsDecoders) {
            data["fieldsDecoders"] = {};
            for (let key in this.fieldsDecoders) {
                if (this.fieldsDecoders.hasOwnProperty(key))
                    (data["fieldsDecoders"] as any)[key] = this.fieldsDecoders[key] !== undefined ? this.fieldsDecoders[key] : null as any;
            }
        }
        super.toJSON(data);
        return data;
    }
}

/** Base per richieste paginate */
export interface INrTableRequest extends ILocalizedRequest {
    /** Numero della pagina 1 based */
    page?: number;
    /** Dimensione della pagina */
    pageSize?: number;
    /** Nome della colonna su cui effettuare l'ordinamento (facoltativo) */
    sortColumn?: string | null;
    /** Direzione dell'ordinamento (facoltativo): asc / desc / '' */
    sortDirection?: string | null;
    /** Se true esporta il file Excel invece di generare la tabella */
    export?: boolean;
    exportEntityName?: string | null;
    exportFieldsNames?: { [key: string]: string; } | null;
    fieldsDecoders?: { [key: string]: { [key: string]: string; }; } | null;
}

export class ContraentiSearchRequest extends NrTableRequest implements IContraentiSearchRequest {
    /** Id dell'accordo del quale visualizzare i contraenti */
    accordoId?: number;

    constructor(data?: IContraentiSearchRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoId = _data["accordoId"] !== undefined ? _data["accordoId"] : null as any;
        }
    }

    static override fromJS(data: any): ContraentiSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContraentiSearchRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoId"] = this.accordoId !== undefined ? this.accordoId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IContraentiSearchRequest extends INrTableRequest {
    /** Id dell'accordo del quale visualizzare i contraenti */
    accordoId?: number;
}

export enum ELingua {
    Italiano = "Italiano",
    English = "English",
    Francais = "Francais",
    Deutsch = "Deutsch",
    Dutch = "Dutch",
    Spanish = "Spanish",
    Portuguese = "Portuguese",
    Debug = "Debug",
}

export class ContraenteReadResponse extends OkApiResponse implements IContraenteReadResponse {
    accordoContatto?: AccordoContatto | null;

    constructor(data?: IContraenteReadResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoContatto = _data["accordoContatto"] ? AccordoContatto.fromJS(_data["accordoContatto"]) : null as any;
        }
    }

    static override fromJS(data: any): ContraenteReadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ContraenteReadResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoContatto"] = this.accordoContatto ? this.accordoContatto.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IContraenteReadResponse extends IOkApiResponse {
    accordoContatto?: AccordoContatto | null;
}

export class AccordoContatto implements IAccordoContatto {
    id?: number;
    operatore?: EOperatore;
    contattoID?: number;
    accordoID?: number;
    pagamentoID?: number | null;
    pagamentoBiglietteriaID?: number | null;
    percentualeAcconto?: number | null;
    percentualeAccontoNozze?: number | null;
    credito?: number | null;
    corrente?: number | null;
    data?: string | null;
    bancaID?: number | null;
    noAnticipoBiglietti?: boolean;
    noAnticipoQuote?: boolean;
    commissioniBiglietteriaDeregolamentate?: boolean;
    pricingID?: number | null;
    viaggiNetti?: boolean | null;
    markup_vn?: number | null;
    markup_teds?: number | null;
    enable_teds?: boolean;
    commissioneBiglietteriaCustom?: number | null;

    constructor(data?: IAccordoContatto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.pagamentoID = _data["pagamentoID"] !== undefined ? _data["pagamentoID"] : null as any;
            this.pagamentoBiglietteriaID = _data["pagamentoBiglietteriaID"] !== undefined ? _data["pagamentoBiglietteriaID"] : null as any;
            this.percentualeAcconto = _data["percentualeAcconto"] !== undefined ? _data["percentualeAcconto"] : null as any;
            this.percentualeAccontoNozze = _data["percentualeAccontoNozze"] !== undefined ? _data["percentualeAccontoNozze"] : null as any;
            this.credito = _data["credito"] !== undefined ? _data["credito"] : null as any;
            this.corrente = _data["corrente"] !== undefined ? _data["corrente"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
            this.bancaID = _data["bancaID"] !== undefined ? _data["bancaID"] : null as any;
            this.noAnticipoBiglietti = _data["noAnticipoBiglietti"] !== undefined ? _data["noAnticipoBiglietti"] : null as any;
            this.noAnticipoQuote = _data["noAnticipoQuote"] !== undefined ? _data["noAnticipoQuote"] : null as any;
            this.commissioniBiglietteriaDeregolamentate = _data["commissioniBiglietteriaDeregolamentate"] !== undefined ? _data["commissioniBiglietteriaDeregolamentate"] : null as any;
            this.pricingID = _data["pricingID"] !== undefined ? _data["pricingID"] : null as any;
            this.viaggiNetti = _data["viaggiNetti"] !== undefined ? _data["viaggiNetti"] : null as any;
            this.markup_vn = _data["markup_vn"] !== undefined ? _data["markup_vn"] : null as any;
            this.markup_teds = _data["markup_teds"] !== undefined ? _data["markup_teds"] : null as any;
            this.enable_teds = _data["enable_teds"] !== undefined ? _data["enable_teds"] : null as any;
            this.commissioneBiglietteriaCustom = _data["commissioneBiglietteriaCustom"] !== undefined ? _data["commissioneBiglietteriaCustom"] : null as any;
        }
    }

    static fromJS(data: any): AccordoContatto {
        data = typeof data === 'object' ? data : {};
        let result = new AccordoContatto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["pagamentoID"] = this.pagamentoID !== undefined ? this.pagamentoID : null as any;
        data["pagamentoBiglietteriaID"] = this.pagamentoBiglietteriaID !== undefined ? this.pagamentoBiglietteriaID : null as any;
        data["percentualeAcconto"] = this.percentualeAcconto !== undefined ? this.percentualeAcconto : null as any;
        data["percentualeAccontoNozze"] = this.percentualeAccontoNozze !== undefined ? this.percentualeAccontoNozze : null as any;
        data["credito"] = this.credito !== undefined ? this.credito : null as any;
        data["corrente"] = this.corrente !== undefined ? this.corrente : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["bancaID"] = this.bancaID !== undefined ? this.bancaID : null as any;
        data["noAnticipoBiglietti"] = this.noAnticipoBiglietti !== undefined ? this.noAnticipoBiglietti : null as any;
        data["noAnticipoQuote"] = this.noAnticipoQuote !== undefined ? this.noAnticipoQuote : null as any;
        data["commissioniBiglietteriaDeregolamentate"] = this.commissioniBiglietteriaDeregolamentate !== undefined ? this.commissioniBiglietteriaDeregolamentate : null as any;
        data["pricingID"] = this.pricingID !== undefined ? this.pricingID : null as any;
        data["viaggiNetti"] = this.viaggiNetti !== undefined ? this.viaggiNetti : null as any;
        data["markup_vn"] = this.markup_vn !== undefined ? this.markup_vn : null as any;
        data["markup_teds"] = this.markup_teds !== undefined ? this.markup_teds : null as any;
        data["enable_teds"] = this.enable_teds !== undefined ? this.enable_teds : null as any;
        data["commissioneBiglietteriaCustom"] = this.commissioneBiglietteriaCustom !== undefined ? this.commissioneBiglietteriaCustom : null as any;
        return data;
    }
}

export interface IAccordoContatto {
    id?: number;
    operatore?: EOperatore;
    contattoID?: number;
    accordoID?: number;
    pagamentoID?: number | null;
    pagamentoBiglietteriaID?: number | null;
    percentualeAcconto?: number | null;
    percentualeAccontoNozze?: number | null;
    credito?: number | null;
    corrente?: number | null;
    data?: string | null;
    bancaID?: number | null;
    noAnticipoBiglietti?: boolean;
    noAnticipoQuote?: boolean;
    commissioniBiglietteriaDeregolamentate?: boolean;
    pricingID?: number | null;
    viaggiNetti?: boolean | null;
    markup_vn?: number | null;
    markup_teds?: number | null;
    enable_teds?: boolean;
    commissioneBiglietteriaCustom?: number | null;
}

export class ContraenteReadRequest extends ApiRequest implements IContraenteReadRequest {
    accordoID?: number;
    accordoContattoID?: number;

    constructor(data?: IContraenteReadRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.accordoContattoID = _data["accordoContattoID"] !== undefined ? _data["accordoContattoID"] : null as any;
        }
    }

    static override fromJS(data: any): ContraenteReadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContraenteReadRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["accordoContattoID"] = this.accordoContattoID !== undefined ? this.accordoContattoID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IContraenteReadRequest extends IApiRequest {
    accordoID?: number;
    accordoContattoID?: number;
}

export class ContraenteWriteResponse extends OkApiResponse implements IContraenteWriteResponse {
    accordoContatto?: AccordoContatto | null;

    constructor(data?: IContraenteWriteResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoContatto = _data["accordoContatto"] ? AccordoContatto.fromJS(_data["accordoContatto"]) : null as any;
        }
    }

    static override fromJS(data: any): ContraenteWriteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ContraenteWriteResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoContatto"] = this.accordoContatto ? this.accordoContatto.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IContraenteWriteResponse extends IOkApiResponse {
    accordoContatto?: AccordoContatto | null;
}

export class ContraenteWriteRequest extends ApiRequest implements IContraenteWriteRequest {
    accordoID?: number;
    accordoContatto?: AccordoContatto | null;

    constructor(data?: IContraenteWriteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.accordoContatto = _data["accordoContatto"] ? AccordoContatto.fromJS(_data["accordoContatto"]) : null as any;
        }
    }

    static override fromJS(data: any): ContraenteWriteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContraenteWriteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["accordoContatto"] = this.accordoContatto ? this.accordoContatto.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IContraenteWriteRequest extends IApiRequest {
    accordoID?: number;
    accordoContatto?: AccordoContatto | null;
}

export class ContraenteDeleteRequest extends ApiRequest implements IContraenteDeleteRequest {
    accordoID?: number;
    accordoContattoID?: number;

    constructor(data?: IContraenteDeleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.accordoContattoID = _data["accordoContattoID"] !== undefined ? _data["accordoContattoID"] : null as any;
        }
    }

    static override fromJS(data: any): ContraenteDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContraenteDeleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["accordoContattoID"] = this.accordoContattoID !== undefined ? this.accordoContattoID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IContraenteDeleteRequest extends IApiRequest {
    accordoID?: number;
    accordoContattoID?: number;
}

export class ContraenteDeleteMultiRequest extends ApiRequest implements IContraenteDeleteMultiRequest {
    accordoID?: number;
    accordiContattiIDs?: number[] | null;

    constructor(data?: IContraenteDeleteMultiRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            if (Array.isArray(_data["accordiContattiIDs"])) {
                this.accordiContattiIDs = [] as any;
                for (let item of _data["accordiContattiIDs"])
                    this.accordiContattiIDs!.push(item);
            }
            else {
                this.accordiContattiIDs = null as any;
            }
        }
    }

    static override fromJS(data: any): ContraenteDeleteMultiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContraenteDeleteMultiRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        if (Array.isArray(this.accordiContattiIDs)) {
            data["accordiContattiIDs"] = [];
            for (let item of this.accordiContattiIDs)
                data["accordiContattiIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IContraenteDeleteMultiRequest extends IApiRequest {
    accordoID?: number;
    accordiContattiIDs?: number[] | null;
}

export class NrTableResponseOfDatoAggiuntivoRow extends OkApiResponse implements INrTableResponseOfDatoAggiuntivoRow {
    /** Array delle righe della pagina richiesta */
    rows?: DatoAggiuntivoRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfDatoAggiuntivoRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(DatoAggiuntivoRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfDatoAggiuntivoRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfDatoAggiuntivoRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfDatoAggiuntivoRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: DatoAggiuntivoRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class DatoAggiuntivoRow implements IDatoAggiuntivoRow {
    id?: number;
    iban?: string | null;
    swift?: string | null;
    banca?: string | null;

    constructor(data?: IDatoAggiuntivoRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.iban = _data["iban"] !== undefined ? _data["iban"] : null as any;
            this.swift = _data["swift"] !== undefined ? _data["swift"] : null as any;
            this.banca = _data["banca"] !== undefined ? _data["banca"] : null as any;
        }
    }

    static fromJS(data: any): DatoAggiuntivoRow {
        data = typeof data === 'object' ? data : {};
        let result = new DatoAggiuntivoRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["iban"] = this.iban !== undefined ? this.iban : null as any;
        data["swift"] = this.swift !== undefined ? this.swift : null as any;
        data["banca"] = this.banca !== undefined ? this.banca : null as any;
        return data;
    }
}

export interface IDatoAggiuntivoRow {
    id?: number;
    iban?: string | null;
    swift?: string | null;
    banca?: string | null;
}

export class DatiAggiuntiviSearchRequest extends NrTableRequest implements IDatiAggiuntiviSearchRequest {
    accordoId?: number;

    constructor(data?: IDatiAggiuntiviSearchRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoId = _data["accordoId"] !== undefined ? _data["accordoId"] : null as any;
        }
    }

    static override fromJS(data: any): DatiAggiuntiviSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DatiAggiuntiviSearchRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoId"] = this.accordoId !== undefined ? this.accordoId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDatiAggiuntiviSearchRequest extends INrTableRequest {
    accordoId?: number;
}

export class DatoAggiuntivoReadResponse extends OkApiResponse implements IDatoAggiuntivoReadResponse {
    accordoDatoAggiuntivo?: AccordoDatoAggiuntivo | null;

    constructor(data?: IDatoAggiuntivoReadResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoDatoAggiuntivo = _data["accordoDatoAggiuntivo"] ? AccordoDatoAggiuntivo.fromJS(_data["accordoDatoAggiuntivo"]) : null as any;
        }
    }

    static override fromJS(data: any): DatoAggiuntivoReadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DatoAggiuntivoReadResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoDatoAggiuntivo"] = this.accordoDatoAggiuntivo ? this.accordoDatoAggiuntivo.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDatoAggiuntivoReadResponse extends IOkApiResponse {
    accordoDatoAggiuntivo?: AccordoDatoAggiuntivo | null;
}

export class AccordoDatoAggiuntivo implements IAccordoDatoAggiuntivo {
    datoAggiuntivoID?: number;
    accordoID?: number;
    iban?: string | null;
    swift?: string | null;
    fax?: string | null;
    email?: string | null;
    banca?: string | null;

    constructor(data?: IAccordoDatoAggiuntivo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datoAggiuntivoID = _data["datoAggiuntivoID"] !== undefined ? _data["datoAggiuntivoID"] : null as any;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.iban = _data["iban"] !== undefined ? _data["iban"] : null as any;
            this.swift = _data["swift"] !== undefined ? _data["swift"] : null as any;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.banca = _data["banca"] !== undefined ? _data["banca"] : null as any;
        }
    }

    static fromJS(data: any): AccordoDatoAggiuntivo {
        data = typeof data === 'object' ? data : {};
        let result = new AccordoDatoAggiuntivo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datoAggiuntivoID"] = this.datoAggiuntivoID !== undefined ? this.datoAggiuntivoID : null as any;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["iban"] = this.iban !== undefined ? this.iban : null as any;
        data["swift"] = this.swift !== undefined ? this.swift : null as any;
        data["fax"] = this.fax !== undefined ? this.fax : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["banca"] = this.banca !== undefined ? this.banca : null as any;
        return data;
    }
}

export interface IAccordoDatoAggiuntivo {
    datoAggiuntivoID?: number;
    accordoID?: number;
    iban?: string | null;
    swift?: string | null;
    fax?: string | null;
    email?: string | null;
    banca?: string | null;
}

export class DatoAggiuntivoReadRequest extends ApiRequest implements IDatoAggiuntivoReadRequest {
    accordoID?: number;
    accordoDatoAggiuntivoID?: number;

    constructor(data?: IDatoAggiuntivoReadRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.accordoDatoAggiuntivoID = _data["accordoDatoAggiuntivoID"] !== undefined ? _data["accordoDatoAggiuntivoID"] : null as any;
        }
    }

    static override fromJS(data: any): DatoAggiuntivoReadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DatoAggiuntivoReadRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["accordoDatoAggiuntivoID"] = this.accordoDatoAggiuntivoID !== undefined ? this.accordoDatoAggiuntivoID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDatoAggiuntivoReadRequest extends IApiRequest {
    accordoID?: number;
    accordoDatoAggiuntivoID?: number;
}

export class DatoAggiuntivoWriteResponse extends OkApiResponse implements IDatoAggiuntivoWriteResponse {
    accordoDatoAggiuntivo?: AccordoDatoAggiuntivo | null;

    constructor(data?: IDatoAggiuntivoWriteResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoDatoAggiuntivo = _data["accordoDatoAggiuntivo"] ? AccordoDatoAggiuntivo.fromJS(_data["accordoDatoAggiuntivo"]) : null as any;
        }
    }

    static override fromJS(data: any): DatoAggiuntivoWriteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DatoAggiuntivoWriteResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoDatoAggiuntivo"] = this.accordoDatoAggiuntivo ? this.accordoDatoAggiuntivo.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDatoAggiuntivoWriteResponse extends IOkApiResponse {
    accordoDatoAggiuntivo?: AccordoDatoAggiuntivo | null;
}

export class DatoAggiuntivoWriteRequest extends ApiRequest implements IDatoAggiuntivoWriteRequest {
    accordoID?: number;
    accordoDatoAggiuntivo?: AccordoDatoAggiuntivo | null;

    constructor(data?: IDatoAggiuntivoWriteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.accordoDatoAggiuntivo = _data["accordoDatoAggiuntivo"] ? AccordoDatoAggiuntivo.fromJS(_data["accordoDatoAggiuntivo"]) : null as any;
        }
    }

    static override fromJS(data: any): DatoAggiuntivoWriteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DatoAggiuntivoWriteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["accordoDatoAggiuntivo"] = this.accordoDatoAggiuntivo ? this.accordoDatoAggiuntivo.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDatoAggiuntivoWriteRequest extends IApiRequest {
    accordoID?: number;
    accordoDatoAggiuntivo?: AccordoDatoAggiuntivo | null;
}

export class DatoAggiuntivoDeleteRequest extends ApiRequest implements IDatoAggiuntivoDeleteRequest {
    accordoID?: number;
    accordoDatoAggiuntivoID?: number;

    constructor(data?: IDatoAggiuntivoDeleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.accordoDatoAggiuntivoID = _data["accordoDatoAggiuntivoID"] !== undefined ? _data["accordoDatoAggiuntivoID"] : null as any;
        }
    }

    static override fromJS(data: any): DatoAggiuntivoDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DatoAggiuntivoDeleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["accordoDatoAggiuntivoID"] = this.accordoDatoAggiuntivoID !== undefined ? this.accordoDatoAggiuntivoID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDatoAggiuntivoDeleteRequest extends IApiRequest {
    accordoID?: number;
    accordoDatoAggiuntivoID?: number;
}

export class DatoAggiuntivoDeleteMultiRequest extends ApiRequest implements IDatoAggiuntivoDeleteMultiRequest {
    accordoID?: number;
    accordiContattiIDs?: number[] | null;

    constructor(data?: IDatoAggiuntivoDeleteMultiRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            if (Array.isArray(_data["accordiContattiIDs"])) {
                this.accordiContattiIDs = [] as any;
                for (let item of _data["accordiContattiIDs"])
                    this.accordiContattiIDs!.push(item);
            }
            else {
                this.accordiContattiIDs = null as any;
            }
        }
    }

    static override fromJS(data: any): DatoAggiuntivoDeleteMultiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DatoAggiuntivoDeleteMultiRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        if (Array.isArray(this.accordiContattiIDs)) {
            data["accordiContattiIDs"] = [];
            for (let item of this.accordiContattiIDs)
                data["accordiContattiIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDatoAggiuntivoDeleteMultiRequest extends IApiRequest {
    accordoID?: number;
    accordiContattiIDs?: number[] | null;
}

export class NrTableResponseOfTabellaCostiCommissioniRow extends OkApiResponse implements INrTableResponseOfTabellaCostiCommissioniRow {
    /** Array delle righe della pagina richiesta */
    rows?: TabellaCostiCommissioniRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfTabellaCostiCommissioniRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TabellaCostiCommissioniRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfTabellaCostiCommissioniRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfTabellaCostiCommissioniRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfTabellaCostiCommissioniRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: TabellaCostiCommissioniRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class TabellaCostiCommissioniRow implements ITabellaCostiCommissioniRow {
    id?: number;
    nome?: string | null;
    dal?: string | null;
    al?: string | null;
    commissionePercentuale?: number;
    commissionePercentualeWeb?: number;

    constructor(data?: ITabellaCostiCommissioniRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.al = _data["al"] !== undefined ? _data["al"] : null as any;
            this.commissionePercentuale = _data["commissionePercentuale"] !== undefined ? _data["commissionePercentuale"] : null as any;
            this.commissionePercentualeWeb = _data["commissionePercentualeWeb"] !== undefined ? _data["commissionePercentualeWeb"] : null as any;
        }
    }

    static fromJS(data: any): TabellaCostiCommissioniRow {
        data = typeof data === 'object' ? data : {};
        let result = new TabellaCostiCommissioniRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["al"] = this.al !== undefined ? this.al : null as any;
        data["commissionePercentuale"] = this.commissionePercentuale !== undefined ? this.commissionePercentuale : null as any;
        data["commissionePercentualeWeb"] = this.commissionePercentualeWeb !== undefined ? this.commissionePercentualeWeb : null as any;
        return data;
    }
}

export interface ITabellaCostiCommissioniRow {
    id?: number;
    nome?: string | null;
    dal?: string | null;
    al?: string | null;
    commissionePercentuale?: number;
    commissionePercentualeWeb?: number;
}

export class TabelleCostiCommissioniSearchRequest extends NrTableRequest implements ITabelleCostiCommissioniSearchRequest {
    accordoId?: number;

    constructor(data?: ITabelleCostiCommissioniSearchRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoId = _data["accordoId"] !== undefined ? _data["accordoId"] : null as any;
        }
    }

    static override fromJS(data: any): TabelleCostiCommissioniSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TabelleCostiCommissioniSearchRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoId"] = this.accordoId !== undefined ? this.accordoId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITabelleCostiCommissioniSearchRequest extends INrTableRequest {
    accordoId?: number;
}

export class TabelleCostiCommissioniListResponse extends OkApiResponse implements ITabelleCostiCommissioniListResponse {
    tabelle?: TabellaCostiCommissioniList[] | null;

    constructor(data?: ITabelleCostiCommissioniListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tabelle"])) {
                this.tabelle = [] as any;
                for (let item of _data["tabelle"])
                    this.tabelle!.push(TabellaCostiCommissioniList.fromJS(item));
            }
            else {
                this.tabelle = null as any;
            }
        }
    }

    static override fromJS(data: any): TabelleCostiCommissioniListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TabelleCostiCommissioniListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tabelle)) {
            data["tabelle"] = [];
            for (let item of this.tabelle)
                data["tabelle"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITabelleCostiCommissioniListResponse extends IOkApiResponse {
    tabelle?: TabellaCostiCommissioniList[] | null;
}

export class TabellaCostiCommissioniList implements ITabellaCostiCommissioniList {
    tabella?: TabellaCostiCommissioni | null;
    nome?: string | null;
    codiceValuta?: string | null;

    constructor(data?: ITabellaCostiCommissioniList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tabella = _data["tabella"] ? TabellaCostiCommissioni.fromJS(_data["tabella"]) : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.codiceValuta = _data["codiceValuta"] !== undefined ? _data["codiceValuta"] : null as any;
        }
    }

    static fromJS(data: any): TabellaCostiCommissioniList {
        data = typeof data === 'object' ? data : {};
        let result = new TabellaCostiCommissioniList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tabella"] = this.tabella ? this.tabella.toJSON() : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["codiceValuta"] = this.codiceValuta !== undefined ? this.codiceValuta : null as any;
        return data;
    }
}

export interface ITabellaCostiCommissioniList {
    tabella?: TabellaCostiCommissioni | null;
    nome?: string | null;
    codiceValuta?: string | null;
}

export class TabellaCostiCommissioni implements ITabellaCostiCommissioni {
    tabellaCostiCommissioniID?: number;
    accordoID?: number;
    nome!: string;
    nomeOriginale?: string | null;
    descrizioneWeb?: string | null;
    dal?: string;
    al?: string;
    tipo?: ETipoTabellaCostiCommissioni | null;
    tipoCommissione?: ETipoCommissione | null;
    prenotaEntro?: string | null;
    prenotaDopo?: string | null;
    prenotaEntroGiorni?: number | null;
    regolaInserimentoID?: number | null;
    commissionePercentuale?: number;
    commissionePercentualeWeb?: number;
    commissionePercentualePacchetti?: number | null;
    permutaBambini?: boolean | null;
    nonRimborsabile?: boolean;
    pagaSubito?: boolean;
    nozze?: boolean;
    fisso?: boolean;
    codiceAviomar?: number | null;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    ordine?: number | null;

    constructor(data?: ITabellaCostiCommissioni) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tabellaCostiCommissioniID = _data["tabellaCostiCommissioniID"] !== undefined ? _data["tabellaCostiCommissioniID"] : null as any;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nomeOriginale = _data["nomeOriginale"] !== undefined ? _data["nomeOriginale"] : null as any;
            this.descrizioneWeb = _data["descrizioneWeb"] !== undefined ? _data["descrizioneWeb"] : null as any;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.al = _data["al"] !== undefined ? _data["al"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.tipoCommissione = _data["tipoCommissione"] !== undefined ? _data["tipoCommissione"] : null as any;
            this.prenotaEntro = _data["prenotaEntro"] !== undefined ? _data["prenotaEntro"] : null as any;
            this.prenotaDopo = _data["prenotaDopo"] !== undefined ? _data["prenotaDopo"] : null as any;
            this.prenotaEntroGiorni = _data["prenotaEntroGiorni"] !== undefined ? _data["prenotaEntroGiorni"] : null as any;
            this.regolaInserimentoID = _data["regolaInserimentoID"] !== undefined ? _data["regolaInserimentoID"] : null as any;
            this.commissionePercentuale = _data["commissionePercentuale"] !== undefined ? _data["commissionePercentuale"] : null as any;
            this.commissionePercentualeWeb = _data["commissionePercentualeWeb"] !== undefined ? _data["commissionePercentualeWeb"] : null as any;
            this.commissionePercentualePacchetti = _data["commissionePercentualePacchetti"] !== undefined ? _data["commissionePercentualePacchetti"] : null as any;
            this.permutaBambini = _data["permutaBambini"] !== undefined ? _data["permutaBambini"] : null as any;
            this.nonRimborsabile = _data["nonRimborsabile"] !== undefined ? _data["nonRimborsabile"] : null as any;
            this.pagaSubito = _data["pagaSubito"] !== undefined ? _data["pagaSubito"] : null as any;
            this.nozze = _data["nozze"] !== undefined ? _data["nozze"] : null as any;
            this.fisso = _data["fisso"] !== undefined ? _data["fisso"] : null as any;
            this.codiceAviomar = _data["codiceAviomar"] !== undefined ? _data["codiceAviomar"] : null as any;
            this.nome_fr = _data["nome_fr"] !== undefined ? _data["nome_fr"] : null as any;
            this.nome_de = _data["nome_de"] !== undefined ? _data["nome_de"] : null as any;
            this.nome_es = _data["nome_es"] !== undefined ? _data["nome_es"] : null as any;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
        }
    }

    static fromJS(data: any): TabellaCostiCommissioni {
        data = typeof data === 'object' ? data : {};
        let result = new TabellaCostiCommissioni();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tabellaCostiCommissioniID"] = this.tabellaCostiCommissioniID !== undefined ? this.tabellaCostiCommissioniID : null as any;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nomeOriginale"] = this.nomeOriginale !== undefined ? this.nomeOriginale : null as any;
        data["descrizioneWeb"] = this.descrizioneWeb !== undefined ? this.descrizioneWeb : null as any;
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["al"] = this.al !== undefined ? this.al : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["tipoCommissione"] = this.tipoCommissione !== undefined ? this.tipoCommissione : null as any;
        data["prenotaEntro"] = this.prenotaEntro !== undefined ? this.prenotaEntro : null as any;
        data["prenotaDopo"] = this.prenotaDopo !== undefined ? this.prenotaDopo : null as any;
        data["prenotaEntroGiorni"] = this.prenotaEntroGiorni !== undefined ? this.prenotaEntroGiorni : null as any;
        data["regolaInserimentoID"] = this.regolaInserimentoID !== undefined ? this.regolaInserimentoID : null as any;
        data["commissionePercentuale"] = this.commissionePercentuale !== undefined ? this.commissionePercentuale : null as any;
        data["commissionePercentualeWeb"] = this.commissionePercentualeWeb !== undefined ? this.commissionePercentualeWeb : null as any;
        data["commissionePercentualePacchetti"] = this.commissionePercentualePacchetti !== undefined ? this.commissionePercentualePacchetti : null as any;
        data["permutaBambini"] = this.permutaBambini !== undefined ? this.permutaBambini : null as any;
        data["nonRimborsabile"] = this.nonRimborsabile !== undefined ? this.nonRimborsabile : null as any;
        data["pagaSubito"] = this.pagaSubito !== undefined ? this.pagaSubito : null as any;
        data["nozze"] = this.nozze !== undefined ? this.nozze : null as any;
        data["fisso"] = this.fisso !== undefined ? this.fisso : null as any;
        data["codiceAviomar"] = this.codiceAviomar !== undefined ? this.codiceAviomar : null as any;
        data["nome_fr"] = this.nome_fr !== undefined ? this.nome_fr : null as any;
        data["nome_de"] = this.nome_de !== undefined ? this.nome_de : null as any;
        data["nome_es"] = this.nome_es !== undefined ? this.nome_es : null as any;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        return data;
    }
}

export interface ITabellaCostiCommissioni {
    tabellaCostiCommissioniID?: number;
    accordoID?: number;
    nome: string;
    nomeOriginale?: string | null;
    descrizioneWeb?: string | null;
    dal?: string;
    al?: string;
    tipo?: ETipoTabellaCostiCommissioni | null;
    tipoCommissione?: ETipoCommissione | null;
    prenotaEntro?: string | null;
    prenotaDopo?: string | null;
    prenotaEntroGiorni?: number | null;
    regolaInserimentoID?: number | null;
    commissionePercentuale?: number;
    commissionePercentualeWeb?: number;
    commissionePercentualePacchetti?: number | null;
    permutaBambini?: boolean | null;
    nonRimborsabile?: boolean;
    pagaSubito?: boolean;
    nozze?: boolean;
    fisso?: boolean;
    codiceAviomar?: number | null;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    ordine?: number | null;
}

export enum ETipoTabellaCostiCommissioni {
    Standard = "Standard",
    LastMinute = "LastMinute",
    PrenotaPrima = "PrenotaPrima",
}

export enum ETipoCommissione {
    ContrattiAlNetto = "ContrattiAlNetto",
    SuLordo = "SuLordo",
    SuImponibile = "SuImponibile",
    ScontoCommerciale = "ScontoCommerciale",
}

export class SiteRequest extends LocalizedRequest implements ISiteRequest {
    siteID?: number;

    constructor(data?: ISiteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.siteID = _data["siteID"] !== undefined ? _data["siteID"] : null as any;
        }
    }

    static override fromJS(data: any): SiteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SiteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteID"] = this.siteID !== undefined ? this.siteID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISiteRequest extends ILocalizedRequest {
    siteID?: number;
}

export class TabelleCostiCommissioniListRequest extends SiteRequest implements ITabelleCostiCommissioniListRequest {
    accordoID?: number;

    constructor(data?: ITabelleCostiCommissioniListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
        }
    }

    static override fromJS(data: any): TabelleCostiCommissioniListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TabelleCostiCommissioniListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITabelleCostiCommissioniListRequest extends ISiteRequest {
    accordoID?: number;
}

export class TabellaCostiCommissioniReadResponse extends OkApiResponse implements ITabellaCostiCommissioniReadResponse {
    tabellaCostiCommissioni?: TabellaCostiCommissioni | null;

    constructor(data?: ITabellaCostiCommissioniReadResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tabellaCostiCommissioni = _data["tabellaCostiCommissioni"] ? TabellaCostiCommissioni.fromJS(_data["tabellaCostiCommissioni"]) : null as any;
        }
    }

    static override fromJS(data: any): TabellaCostiCommissioniReadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TabellaCostiCommissioniReadResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tabellaCostiCommissioni"] = this.tabellaCostiCommissioni ? this.tabellaCostiCommissioni.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITabellaCostiCommissioniReadResponse extends IOkApiResponse {
    tabellaCostiCommissioni?: TabellaCostiCommissioni | null;
}

export class TabellaCostiCommissioniReadRequest extends ApiRequest implements ITabellaCostiCommissioniReadRequest {
    accordoID?: number;
    tabellaCostiCommissioniID?: number;

    constructor(data?: ITabellaCostiCommissioniReadRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.tabellaCostiCommissioniID = _data["tabellaCostiCommissioniID"] !== undefined ? _data["tabellaCostiCommissioniID"] : null as any;
        }
    }

    static override fromJS(data: any): TabellaCostiCommissioniReadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TabellaCostiCommissioniReadRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["tabellaCostiCommissioniID"] = this.tabellaCostiCommissioniID !== undefined ? this.tabellaCostiCommissioniID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITabellaCostiCommissioniReadRequest extends IApiRequest {
    accordoID?: number;
    tabellaCostiCommissioniID?: number;
}

export class TabellaCostiCommissioniWriteResponse extends OkApiResponse implements ITabellaCostiCommissioniWriteResponse {
    tabellaCostiCommissioni?: TabellaCostiCommissioni | null;

    constructor(data?: ITabellaCostiCommissioniWriteResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tabellaCostiCommissioni = _data["tabellaCostiCommissioni"] ? TabellaCostiCommissioni.fromJS(_data["tabellaCostiCommissioni"]) : null as any;
        }
    }

    static override fromJS(data: any): TabellaCostiCommissioniWriteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TabellaCostiCommissioniWriteResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tabellaCostiCommissioni"] = this.tabellaCostiCommissioni ? this.tabellaCostiCommissioni.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITabellaCostiCommissioniWriteResponse extends IOkApiResponse {
    tabellaCostiCommissioni?: TabellaCostiCommissioni | null;
}

export class TabellaCostiCommissioniWriteRequest extends ApiRequest implements ITabellaCostiCommissioniWriteRequest {
    accordoID?: number;
    tabellaCostiCommissioni?: TabellaCostiCommissioni | null;

    constructor(data?: ITabellaCostiCommissioniWriteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.tabellaCostiCommissioni = _data["tabellaCostiCommissioni"] ? TabellaCostiCommissioni.fromJS(_data["tabellaCostiCommissioni"]) : null as any;
        }
    }

    static override fromJS(data: any): TabellaCostiCommissioniWriteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TabellaCostiCommissioniWriteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["tabellaCostiCommissioni"] = this.tabellaCostiCommissioni ? this.tabellaCostiCommissioni.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITabellaCostiCommissioniWriteRequest extends IApiRequest {
    accordoID?: number;
    tabellaCostiCommissioni?: TabellaCostiCommissioni | null;
}

export class TabellaCostiCommissioniDeleteRequest extends ApiRequest implements ITabellaCostiCommissioniDeleteRequest {
    accordoID?: number;
    tabellaCostiCommissioniID?: number;

    constructor(data?: ITabellaCostiCommissioniDeleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.tabellaCostiCommissioniID = _data["tabellaCostiCommissioniID"] !== undefined ? _data["tabellaCostiCommissioniID"] : null as any;
        }
    }

    static override fromJS(data: any): TabellaCostiCommissioniDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TabellaCostiCommissioniDeleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["tabellaCostiCommissioniID"] = this.tabellaCostiCommissioniID !== undefined ? this.tabellaCostiCommissioniID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITabellaCostiCommissioniDeleteRequest extends IApiRequest {
    accordoID?: number;
    tabellaCostiCommissioniID?: number;
}

export class TabellaCostiCommissioniDeleteMultiRequest extends ApiRequest implements ITabellaCostiCommissioniDeleteMultiRequest {
    accordoID?: number;
    tabelleCostiCommissioniIDs?: number[] | null;

    constructor(data?: ITabellaCostiCommissioniDeleteMultiRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            if (Array.isArray(_data["tabelleCostiCommissioniIDs"])) {
                this.tabelleCostiCommissioniIDs = [] as any;
                for (let item of _data["tabelleCostiCommissioniIDs"])
                    this.tabelleCostiCommissioniIDs!.push(item);
            }
            else {
                this.tabelleCostiCommissioniIDs = null as any;
            }
        }
    }

    static override fromJS(data: any): TabellaCostiCommissioniDeleteMultiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TabellaCostiCommissioniDeleteMultiRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        if (Array.isArray(this.tabelleCostiCommissioniIDs)) {
            data["tabelleCostiCommissioniIDs"] = [];
            for (let item of this.tabelleCostiCommissioniIDs)
                data["tabelleCostiCommissioniIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITabellaCostiCommissioniDeleteMultiRequest extends IApiRequest {
    accordoID?: number;
    tabelleCostiCommissioniIDs?: number[] | null;
}

export class NrTableResponseOfAccordoRow extends OkApiResponse implements INrTableResponseOfAccordoRow {
    /** Array delle righe della pagina richiesta */
    rows?: AccordoRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfAccordoRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AccordoRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfAccordoRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfAccordoRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfAccordoRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: AccordoRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

/** Vista di riga per l'elenco accordi */
export class AccordoRow implements IAccordoRow {
    /** ID dell'accordo */
    id?: number;
    /** Nome dell'accordo */
    nome?: string | null;
    /** Operatore al quale si applica l'accordo */
    operatore?: EOperatore | null;
    /** Nome visualizzato del contatto dell'accordo */
    contatto?: string | null;
    /** Nome del luogo del contatto dell'accordo */
    luogo?: string | null;
    /** Se true il luogo è eliminato */
    luogoEliminato?: boolean;
    /** Codice mnemonico dell'accordo */
    memo?: string | null;
    /** Data di validità "dal" */
    dal?: string | null;
    /** Data di validità "al" */
    al?: string | null;
    deleted?: string | null;

    constructor(data?: IAccordoRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.contatto = _data["contatto"] !== undefined ? _data["contatto"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.luogoEliminato = _data["luogoEliminato"] !== undefined ? _data["luogoEliminato"] : null as any;
            this.memo = _data["memo"] !== undefined ? _data["memo"] : null as any;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.al = _data["al"] !== undefined ? _data["al"] : null as any;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : null as any;
        }
    }

    static fromJS(data: any): AccordoRow {
        data = typeof data === 'object' ? data : {};
        let result = new AccordoRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["contatto"] = this.contatto !== undefined ? this.contatto : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["luogoEliminato"] = this.luogoEliminato !== undefined ? this.luogoEliminato : null as any;
        data["memo"] = this.memo !== undefined ? this.memo : null as any;
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["al"] = this.al !== undefined ? this.al : null as any;
        data["deleted"] = this.deleted !== undefined ? this.deleted : null as any;
        return data;
    }
}

/** Vista di riga per l'elenco accordi */
export interface IAccordoRow {
    /** ID dell'accordo */
    id?: number;
    /** Nome dell'accordo */
    nome?: string | null;
    /** Operatore al quale si applica l'accordo */
    operatore?: EOperatore | null;
    /** Nome visualizzato del contatto dell'accordo */
    contatto?: string | null;
    /** Nome del luogo del contatto dell'accordo */
    luogo?: string | null;
    /** Se true il luogo è eliminato */
    luogoEliminato?: boolean;
    /** Codice mnemonico dell'accordo */
    memo?: string | null;
    /** Data di validità "dal" */
    dal?: string | null;
    /** Data di validità "al" */
    al?: string | null;
    deleted?: string | null;
}

/** Filtri per la ricerca paginata degli accordi */
export class AccordiSearchRequest extends NrTableRequest implements IAccordiSearchRequest {
    /** Nome da ricercare, o parte. Case insensitive */
    nome?: string | null;
    /** Tipo di accordo, obbligatorio */
    tipo?: ETipoAccordo;
    /** Id del contatto. Facoltativo */
    contattoId?: number | null;
    /** Filtro sul tipo di scadenza */
    filtroScadenza?: EFiltroScadenzaAccordi;
    operatore?: EOperatore | null;
    /** Show also deleted items */
    showValid?: boolean | null;

    constructor(data?: IAccordiSearchRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.contattoId = _data["contattoId"] !== undefined ? _data["contattoId"] : null as any;
            this.filtroScadenza = _data["filtroScadenza"] !== undefined ? _data["filtroScadenza"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.showValid = _data["showValid"] !== undefined ? _data["showValid"] : null as any;
        }
    }

    static override fromJS(data: any): AccordiSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AccordiSearchRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["contattoId"] = this.contattoId !== undefined ? this.contattoId : null as any;
        data["filtroScadenza"] = this.filtroScadenza !== undefined ? this.filtroScadenza : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["showValid"] = this.showValid !== undefined ? this.showValid : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Filtri per la ricerca paginata degli accordi */
export interface IAccordiSearchRequest extends INrTableRequest {
    /** Nome da ricercare, o parte. Case insensitive */
    nome?: string | null;
    /** Tipo di accordo, obbligatorio */
    tipo?: ETipoAccordo;
    /** Id del contatto. Facoltativo */
    contattoId?: number | null;
    /** Filtro sul tipo di scadenza */
    filtroScadenza?: EFiltroScadenzaAccordi;
    operatore?: EOperatore | null;
    /** Show also deleted items */
    showValid?: boolean | null;
}

/** Modalità del filtro scadenza per gli accordi */
export enum EFiltroScadenzaAccordi {
    Qualsiasi = "Qualsiasi",
    Scaduti = "Scaduti",
    NonScaduti = "NonScaduti",
    ValidiAdesso = "ValidiAdesso",
    ValidiInFuturo = "ValidiInFuturo",
}

export class GetCurrenciesExportRequest extends LocalizedRequest implements IGetCurrenciesExportRequest {
    exportEntityName?: string | null;
    exportFieldsNames?: { [key: string]: string; } | null;
    fieldsDecoders?: { [key: string]: { [key: string]: string; }; } | null;

    constructor(data?: IGetCurrenciesExportRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.exportEntityName = _data["exportEntityName"] !== undefined ? _data["exportEntityName"] : null as any;
            if (_data["exportFieldsNames"]) {
                this.exportFieldsNames = {} as any;
                for (let key in _data["exportFieldsNames"]) {
                    if (_data["exportFieldsNames"].hasOwnProperty(key))
                        (this.exportFieldsNames as any)![key] = _data["exportFieldsNames"][key] !== undefined ? _data["exportFieldsNames"][key] : null as any;
                }
            }
            else {
                this.exportFieldsNames = null as any;
            }
            if (_data["fieldsDecoders"]) {
                this.fieldsDecoders = {} as any;
                for (let key in _data["fieldsDecoders"]) {
                    if (_data["fieldsDecoders"].hasOwnProperty(key))
                        (this.fieldsDecoders as any)![key] = _data["fieldsDecoders"][key] !== undefined ? _data["fieldsDecoders"][key] : {};
                }
            }
            else {
                this.fieldsDecoders = null as any;
            }
        }
    }

    static override fromJS(data: any): GetCurrenciesExportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrenciesExportRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exportEntityName"] = this.exportEntityName !== undefined ? this.exportEntityName : null as any;
        if (this.exportFieldsNames) {
            data["exportFieldsNames"] = {};
            for (let key in this.exportFieldsNames) {
                if (this.exportFieldsNames.hasOwnProperty(key))
                    (data["exportFieldsNames"] as any)[key] = this.exportFieldsNames[key] !== undefined ? this.exportFieldsNames[key] : null as any;
            }
        }
        if (this.fieldsDecoders) {
            data["fieldsDecoders"] = {};
            for (let key in this.fieldsDecoders) {
                if (this.fieldsDecoders.hasOwnProperty(key))
                    (data["fieldsDecoders"] as any)[key] = this.fieldsDecoders[key] !== undefined ? this.fieldsDecoders[key] : null as any;
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetCurrenciesExportRequest extends ILocalizedRequest {
    exportEntityName?: string | null;
    exportFieldsNames?: { [key: string]: string; } | null;
    fieldsDecoders?: { [key: string]: { [key: string]: string; }; } | null;
}

export class GetCurrenciesListResponse extends OkApiResponse implements IGetCurrenciesListResponse {
    /** Elenco delle valute e relativi cambi */
    currencies?: CurrencyRow[];

    constructor(data?: IGetCurrenciesListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["currencies"])) {
                this.currencies = [] as any;
                for (let item of _data["currencies"])
                    this.currencies!.push(CurrencyRow.fromJS(item));
            }
            else {
                this.currencies = null as any;
            }
        }
    }

    static override fromJS(data: any): GetCurrenciesListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrenciesListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.currencies)) {
            data["currencies"] = [];
            for (let item of this.currencies)
                data["currencies"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetCurrenciesListResponse extends IOkApiResponse {
    /** Elenco delle valute e relativi cambi */
    currencies?: CurrencyRow[];
}

export class CurrencyRow implements ICurrencyRow {
    /** ID della valuta */
    id?: number;
    /** Codice a 3 lettere della valuta */
    code?: string;
    /** Nome della valuta */
    name?: string;
    /** Valore di cambio corrente */
    valoreCorrente?: number | null;
    /** Valore di cambio applicato alle offerte corrente */
    valoreApplicato?: number | null;
    /** Ultimo aggiornamento del valore */
    lastUpdate?: string | null;

    constructor(data?: ICurrencyRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.valoreCorrente = _data["valoreCorrente"] !== undefined ? _data["valoreCorrente"] : null as any;
            this.valoreApplicato = _data["valoreApplicato"] !== undefined ? _data["valoreApplicato"] : null as any;
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : null as any;
        }
    }

    static fromJS(data: any): CurrencyRow {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["valoreCorrente"] = this.valoreCorrente !== undefined ? this.valoreCorrente : null as any;
        data["valoreApplicato"] = this.valoreApplicato !== undefined ? this.valoreApplicato : null as any;
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : null as any;
        return data;
    }
}

export interface ICurrencyRow {
    /** ID della valuta */
    id?: number;
    /** Codice a 3 lettere della valuta */
    code?: string;
    /** Nome della valuta */
    name?: string;
    /** Valore di cambio corrente */
    valoreCorrente?: number | null;
    /** Valore di cambio applicato alle offerte corrente */
    valoreApplicato?: number | null;
    /** Ultimo aggiornamento del valore */
    lastUpdate?: string | null;
}

export class NrTableResponseOfValutaValore extends OkApiResponse implements INrTableResponseOfValutaValore {
    /** Array delle righe della pagina richiesta */
    rows?: ValutaValore[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfValutaValore) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ValutaValore.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfValutaValore {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfValutaValore();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfValutaValore extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: ValutaValore[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class GetCurrencyHistoryResponse extends NrTableResponseOfValutaValore implements IGetCurrencyHistoryResponse {

    constructor(data?: IGetCurrencyHistoryResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetCurrencyHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrencyHistoryResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetCurrencyHistoryResponse extends INrTableResponseOfValutaValore {
}

export class ValutaValore implements IValutaValore {
    valutaValoreID?: number;
    valutaID?: number;
    data?: string;
    valoreCorrente?: number;
    valore?: number;
    valoreApplicato?: number;
    attiva?: boolean | null;
    operatoreID?: number | null;

    constructor(data?: IValutaValore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valutaValoreID = _data["valutaValoreID"] !== undefined ? _data["valutaValoreID"] : null as any;
            this.valutaID = _data["valutaID"] !== undefined ? _data["valutaID"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
            this.valoreCorrente = _data["valoreCorrente"] !== undefined ? _data["valoreCorrente"] : null as any;
            this.valore = _data["valore"] !== undefined ? _data["valore"] : null as any;
            this.valoreApplicato = _data["valoreApplicato"] !== undefined ? _data["valoreApplicato"] : null as any;
            this.attiva = _data["attiva"] !== undefined ? _data["attiva"] : null as any;
            this.operatoreID = _data["operatoreID"] !== undefined ? _data["operatoreID"] : null as any;
        }
    }

    static fromJS(data: any): ValutaValore {
        data = typeof data === 'object' ? data : {};
        let result = new ValutaValore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valutaValoreID"] = this.valutaValoreID !== undefined ? this.valutaValoreID : null as any;
        data["valutaID"] = this.valutaID !== undefined ? this.valutaID : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["valoreCorrente"] = this.valoreCorrente !== undefined ? this.valoreCorrente : null as any;
        data["valore"] = this.valore !== undefined ? this.valore : null as any;
        data["valoreApplicato"] = this.valoreApplicato !== undefined ? this.valoreApplicato : null as any;
        data["attiva"] = this.attiva !== undefined ? this.attiva : null as any;
        data["operatoreID"] = this.operatoreID !== undefined ? this.operatoreID : null as any;
        return data;
    }
}

export interface IValutaValore {
    valutaValoreID?: number;
    valutaID?: number;
    data?: string;
    valoreCorrente?: number;
    valore?: number;
    valoreApplicato?: number;
    attiva?: boolean | null;
    operatoreID?: number | null;
}

export class GetCurrencyHistoryRequest extends NrTableRequest implements IGetCurrencyHistoryRequest {
    /** ID della valuta di cui caricare lo storico */
    valutaID?: number;

    constructor(data?: IGetCurrencyHistoryRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.valutaID = _data["valutaID"] !== undefined ? _data["valutaID"] : null as any;
        }
    }

    static override fromJS(data: any): GetCurrencyHistoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrencyHistoryRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valutaID"] = this.valutaID !== undefined ? this.valutaID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetCurrencyHistoryRequest extends INrTableRequest {
    /** ID della valuta di cui caricare lo storico */
    valutaID?: number;
}

export class CurrencyRateInsertResponse extends OkApiResponse implements ICurrencyRateInsertResponse {
    /** Singola riga aggiornata */
    valutaAggiornata?: CurrencyRow;

    constructor(data?: ICurrencyRateInsertResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.valutaAggiornata = _data["valutaAggiornata"] ? CurrencyRow.fromJS(_data["valutaAggiornata"]) : null as any;
        }
    }

    static override fromJS(data: any): CurrencyRateInsertResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyRateInsertResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valutaAggiornata"] = this.valutaAggiornata ? this.valutaAggiornata.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICurrencyRateInsertResponse extends IOkApiResponse {
    /** Singola riga aggiornata */
    valutaAggiornata?: CurrencyRow;
}

export class CurrencyRateInsertRequest extends LocalizedRequest implements ICurrencyRateInsertRequest {
    /** ID della valuta alla quale aggiungere un nuovo cambio */
    valutaID?: number;
    /** Nuovo valore corrente */
    valoreCorrente?: number;
    /** Nuovo valore applicato */
    valoreApplicato?: number;

    constructor(data?: ICurrencyRateInsertRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.valutaID = _data["valutaID"] !== undefined ? _data["valutaID"] : null as any;
            this.valoreCorrente = _data["valoreCorrente"] !== undefined ? _data["valoreCorrente"] : null as any;
            this.valoreApplicato = _data["valoreApplicato"] !== undefined ? _data["valoreApplicato"] : null as any;
        }
    }

    static override fromJS(data: any): CurrencyRateInsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyRateInsertRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valutaID"] = this.valutaID !== undefined ? this.valutaID : null as any;
        data["valoreCorrente"] = this.valoreCorrente !== undefined ? this.valoreCorrente : null as any;
        data["valoreApplicato"] = this.valoreApplicato !== undefined ? this.valoreApplicato : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICurrencyRateInsertRequest extends ILocalizedRequest {
    /** ID della valuta alla quale aggiungere un nuovo cambio */
    valutaID?: number;
    /** Nuovo valore corrente */
    valoreCorrente?: number;
    /** Nuovo valore applicato */
    valoreApplicato?: number;
}

export class GetNewExchangeRatesResponse extends OkApiResponse implements IGetNewExchangeRatesResponse {
    /** Elenco dei cambi */
    cambi?: ValutaValore[];

    constructor(data?: IGetNewExchangeRatesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["cambi"])) {
                this.cambi = [] as any;
                for (let item of _data["cambi"])
                    this.cambi!.push(ValutaValore.fromJS(item));
            }
            else {
                this.cambi = null as any;
            }
        }
    }

    static override fromJS(data: any): GetNewExchangeRatesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetNewExchangeRatesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cambi)) {
            data["cambi"] = [];
            for (let item of this.cambi)
                data["cambi"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetNewExchangeRatesResponse extends IOkApiResponse {
    /** Elenco dei cambi */
    cambi?: ValutaValore[];
}

export class ImportTicketsDeleteResponse extends OkApiResponse implements IImportTicketsDeleteResponse {

    constructor(data?: IImportTicketsDeleteResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ImportTicketsDeleteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportTicketsDeleteResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IImportTicketsDeleteResponse extends IOkApiResponse {
}

export class ImportTicketsDeleteRequest extends ApiRequest implements IImportTicketsDeleteRequest {
    id?: number;

    constructor(data?: IImportTicketsDeleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): ImportTicketsDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportTicketsDeleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IImportTicketsDeleteRequest extends IApiRequest {
    id?: number;
}

export class ImportTicketsGetResponse extends OkApiResponse implements IImportTicketsGetResponse {
    id?: number;
    dataBolla?: string | null;
    numeroBolla?: string | null;
    vettore?: string | null;
    codiceV?: string | null;
    pax?: string | null;
    serie?: string | null;
    tkt?: string | null;
    routing?: string | null;
    classe?: string | null;
    nazInt?: string | null;
    partenza?: string | null;
    c_Costo?: number | null;
    commessa?: string | null;
    tariffaApplicata?: number | null;
    tax?: number | null;
    totale?: number | null;
    tariffaOrdinaria?: number | null;
    f_Pag?: string | null;
    offertaID?: number | null;
    iva?: string | null;
    note?: string | null;
    partenzaPratica?: string | null;

    constructor(data?: IImportTicketsGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.dataBolla = _data["dataBolla"] !== undefined ? _data["dataBolla"] : null as any;
            this.numeroBolla = _data["numeroBolla"] !== undefined ? _data["numeroBolla"] : null as any;
            this.vettore = _data["vettore"] !== undefined ? _data["vettore"] : null as any;
            this.codiceV = _data["codiceV"] !== undefined ? _data["codiceV"] : null as any;
            this.pax = _data["pax"] !== undefined ? _data["pax"] : null as any;
            this.serie = _data["serie"] !== undefined ? _data["serie"] : null as any;
            this.tkt = _data["tkt"] !== undefined ? _data["tkt"] : null as any;
            this.routing = _data["routing"] !== undefined ? _data["routing"] : null as any;
            this.classe = _data["classe"] !== undefined ? _data["classe"] : null as any;
            this.nazInt = _data["nazInt"] !== undefined ? _data["nazInt"] : null as any;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : null as any;
            this.c_Costo = _data["c_Costo"] !== undefined ? _data["c_Costo"] : null as any;
            this.commessa = _data["commessa"] !== undefined ? _data["commessa"] : null as any;
            this.tariffaApplicata = _data["tariffaApplicata"] !== undefined ? _data["tariffaApplicata"] : null as any;
            this.tax = _data["tax"] !== undefined ? _data["tax"] : null as any;
            this.totale = _data["totale"] !== undefined ? _data["totale"] : null as any;
            this.tariffaOrdinaria = _data["tariffaOrdinaria"] !== undefined ? _data["tariffaOrdinaria"] : null as any;
            this.f_Pag = _data["f_Pag"] !== undefined ? _data["f_Pag"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.iva = _data["iva"] !== undefined ? _data["iva"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.partenzaPratica = _data["partenzaPratica"] !== undefined ? _data["partenzaPratica"] : null as any;
        }
    }

    static override fromJS(data: any): ImportTicketsGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportTicketsGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["dataBolla"] = this.dataBolla !== undefined ? this.dataBolla : null as any;
        data["numeroBolla"] = this.numeroBolla !== undefined ? this.numeroBolla : null as any;
        data["vettore"] = this.vettore !== undefined ? this.vettore : null as any;
        data["codiceV"] = this.codiceV !== undefined ? this.codiceV : null as any;
        data["pax"] = this.pax !== undefined ? this.pax : null as any;
        data["serie"] = this.serie !== undefined ? this.serie : null as any;
        data["tkt"] = this.tkt !== undefined ? this.tkt : null as any;
        data["routing"] = this.routing !== undefined ? this.routing : null as any;
        data["classe"] = this.classe !== undefined ? this.classe : null as any;
        data["nazInt"] = this.nazInt !== undefined ? this.nazInt : null as any;
        data["partenza"] = this.partenza !== undefined ? this.partenza : null as any;
        data["c_Costo"] = this.c_Costo !== undefined ? this.c_Costo : null as any;
        data["commessa"] = this.commessa !== undefined ? this.commessa : null as any;
        data["tariffaApplicata"] = this.tariffaApplicata !== undefined ? this.tariffaApplicata : null as any;
        data["tax"] = this.tax !== undefined ? this.tax : null as any;
        data["totale"] = this.totale !== undefined ? this.totale : null as any;
        data["tariffaOrdinaria"] = this.tariffaOrdinaria !== undefined ? this.tariffaOrdinaria : null as any;
        data["f_Pag"] = this.f_Pag !== undefined ? this.f_Pag : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["iva"] = this.iva !== undefined ? this.iva : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["partenzaPratica"] = this.partenzaPratica !== undefined ? this.partenzaPratica : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IImportTicketsGetResponse extends IOkApiResponse {
    id?: number;
    dataBolla?: string | null;
    numeroBolla?: string | null;
    vettore?: string | null;
    codiceV?: string | null;
    pax?: string | null;
    serie?: string | null;
    tkt?: string | null;
    routing?: string | null;
    classe?: string | null;
    nazInt?: string | null;
    partenza?: string | null;
    c_Costo?: number | null;
    commessa?: string | null;
    tariffaApplicata?: number | null;
    tax?: number | null;
    totale?: number | null;
    tariffaOrdinaria?: number | null;
    f_Pag?: string | null;
    offertaID?: number | null;
    iva?: string | null;
    note?: string | null;
    partenzaPratica?: string | null;
}

export class ImportTicketsGetRequest extends ApiRequest implements IImportTicketsGetRequest {
    id!: number;

    constructor(data?: IImportTicketsGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): ImportTicketsGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportTicketsGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IImportTicketsGetRequest extends IApiRequest {
    id: number;
}

export class NrTableResponseOfTicketsRows extends OkApiResponse implements INrTableResponseOfTicketsRows {
    /** Array delle righe della pagina richiesta */
    rows?: TicketsRows[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfTicketsRows) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TicketsRows.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfTicketsRows {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfTicketsRows();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfTicketsRows extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: TicketsRows[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class ListTicketsResponse extends NrTableResponseOfTicketsRows implements IListTicketsResponse {

    constructor(data?: IListTicketsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ListTicketsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListTicketsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IListTicketsResponse extends INrTableResponseOfTicketsRows {
}

export class TicketsRows implements ITicketsRows {
    id?: number;
    dataBolla?: string | null;
    numeroBolla?: string | null;
    vettore?: string | null;
    codiceV?: string | null;
    pax?: string | null;
    serie?: string | null;
    tkt?: string | null;
    routing?: string | null;
    classe?: string | null;
    nazInt?: string | null;
    partenza?: string | null;
    c_Costo?: number | null;
    commessa?: string | null;
    tariffaApplicata?: number | null;
    tax?: number | null;
    totale?: number | null;
    tariffaOrdinaria?: number | null;
    f_Pag?: string | null;
    offertaID?: number | null;
    iva?: string | null;
    note?: string | null;
    partenzaPratica?: string | null;
    ticketType?: ETicketsType;

    constructor(data?: ITicketsRows) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.dataBolla = _data["dataBolla"] !== undefined ? _data["dataBolla"] : null as any;
            this.numeroBolla = _data["numeroBolla"] !== undefined ? _data["numeroBolla"] : null as any;
            this.vettore = _data["vettore"] !== undefined ? _data["vettore"] : null as any;
            this.codiceV = _data["codiceV"] !== undefined ? _data["codiceV"] : null as any;
            this.pax = _data["pax"] !== undefined ? _data["pax"] : null as any;
            this.serie = _data["serie"] !== undefined ? _data["serie"] : null as any;
            this.tkt = _data["tkt"] !== undefined ? _data["tkt"] : null as any;
            this.routing = _data["routing"] !== undefined ? _data["routing"] : null as any;
            this.classe = _data["classe"] !== undefined ? _data["classe"] : null as any;
            this.nazInt = _data["nazInt"] !== undefined ? _data["nazInt"] : null as any;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : null as any;
            this.c_Costo = _data["c_Costo"] !== undefined ? _data["c_Costo"] : null as any;
            this.commessa = _data["commessa"] !== undefined ? _data["commessa"] : null as any;
            this.tariffaApplicata = _data["tariffaApplicata"] !== undefined ? _data["tariffaApplicata"] : null as any;
            this.tax = _data["tax"] !== undefined ? _data["tax"] : null as any;
            this.totale = _data["totale"] !== undefined ? _data["totale"] : null as any;
            this.tariffaOrdinaria = _data["tariffaOrdinaria"] !== undefined ? _data["tariffaOrdinaria"] : null as any;
            this.f_Pag = _data["f_Pag"] !== undefined ? _data["f_Pag"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.iva = _data["iva"] !== undefined ? _data["iva"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.partenzaPratica = _data["partenzaPratica"] !== undefined ? _data["partenzaPratica"] : null as any;
            this.ticketType = _data["ticketType"] !== undefined ? _data["ticketType"] : null as any;
        }
    }

    static fromJS(data: any): TicketsRows {
        data = typeof data === 'object' ? data : {};
        let result = new TicketsRows();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["dataBolla"] = this.dataBolla !== undefined ? this.dataBolla : null as any;
        data["numeroBolla"] = this.numeroBolla !== undefined ? this.numeroBolla : null as any;
        data["vettore"] = this.vettore !== undefined ? this.vettore : null as any;
        data["codiceV"] = this.codiceV !== undefined ? this.codiceV : null as any;
        data["pax"] = this.pax !== undefined ? this.pax : null as any;
        data["serie"] = this.serie !== undefined ? this.serie : null as any;
        data["tkt"] = this.tkt !== undefined ? this.tkt : null as any;
        data["routing"] = this.routing !== undefined ? this.routing : null as any;
        data["classe"] = this.classe !== undefined ? this.classe : null as any;
        data["nazInt"] = this.nazInt !== undefined ? this.nazInt : null as any;
        data["partenza"] = this.partenza !== undefined ? this.partenza : null as any;
        data["c_Costo"] = this.c_Costo !== undefined ? this.c_Costo : null as any;
        data["commessa"] = this.commessa !== undefined ? this.commessa : null as any;
        data["tariffaApplicata"] = this.tariffaApplicata !== undefined ? this.tariffaApplicata : null as any;
        data["tax"] = this.tax !== undefined ? this.tax : null as any;
        data["totale"] = this.totale !== undefined ? this.totale : null as any;
        data["tariffaOrdinaria"] = this.tariffaOrdinaria !== undefined ? this.tariffaOrdinaria : null as any;
        data["f_Pag"] = this.f_Pag !== undefined ? this.f_Pag : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["iva"] = this.iva !== undefined ? this.iva : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["partenzaPratica"] = this.partenzaPratica !== undefined ? this.partenzaPratica : null as any;
        data["ticketType"] = this.ticketType !== undefined ? this.ticketType : null as any;
        return data;
    }
}

export interface ITicketsRows {
    id?: number;
    dataBolla?: string | null;
    numeroBolla?: string | null;
    vettore?: string | null;
    codiceV?: string | null;
    pax?: string | null;
    serie?: string | null;
    tkt?: string | null;
    routing?: string | null;
    classe?: string | null;
    nazInt?: string | null;
    partenza?: string | null;
    c_Costo?: number | null;
    commessa?: string | null;
    tariffaApplicata?: number | null;
    tax?: number | null;
    totale?: number | null;
    tariffaOrdinaria?: number | null;
    f_Pag?: string | null;
    offertaID?: number | null;
    iva?: string | null;
    note?: string | null;
    partenzaPratica?: string | null;
    ticketType?: ETicketsType;
}

export enum ETicketsType {
    Meridiano = "Meridiano",
    Amadeus = "Amadeus",
}

export class ListTicketsRequest extends NrTableRequest implements IListTicketsRequest {
    /** Termine di ricerca: ID, titolo, parti di testo */
    term?: string | null;
    emessoDal?: string | null;
    emessoAl?: string | null;
    pax?: string | null;
    f_Pag?: string | null;
    offertaID?: number | null;
    iva?: string | null;
    tkt?: string | null;
    ticketType?: ETicketsType | null;

    constructor(data?: IListTicketsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : null as any;
            this.emessoDal = _data["emessoDal"] !== undefined ? _data["emessoDal"] : null as any;
            this.emessoAl = _data["emessoAl"] !== undefined ? _data["emessoAl"] : null as any;
            this.pax = _data["pax"] !== undefined ? _data["pax"] : null as any;
            this.f_Pag = _data["f_Pag"] !== undefined ? _data["f_Pag"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.iva = _data["iva"] !== undefined ? _data["iva"] : null as any;
            this.tkt = _data["tkt"] !== undefined ? _data["tkt"] : null as any;
            this.ticketType = _data["ticketType"] !== undefined ? _data["ticketType"] : null as any;
        }
    }

    static override fromJS(data: any): ListTicketsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListTicketsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : null as any;
        data["emessoDal"] = this.emessoDal !== undefined ? this.emessoDal : null as any;
        data["emessoAl"] = this.emessoAl !== undefined ? this.emessoAl : null as any;
        data["pax"] = this.pax !== undefined ? this.pax : null as any;
        data["f_Pag"] = this.f_Pag !== undefined ? this.f_Pag : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["iva"] = this.iva !== undefined ? this.iva : null as any;
        data["tkt"] = this.tkt !== undefined ? this.tkt : null as any;
        data["ticketType"] = this.ticketType !== undefined ? this.ticketType : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IListTicketsRequest extends INrTableRequest {
    /** Termine di ricerca: ID, titolo, parti di testo */
    term?: string | null;
    emessoDal?: string | null;
    emessoAl?: string | null;
    pax?: string | null;
    f_Pag?: string | null;
    offertaID?: number | null;
    iva?: string | null;
    tkt?: string | null;
    ticketType?: ETicketsType | null;
}

export class ImportTicketsUpdateResponse extends OkApiResponse implements IImportTicketsUpdateResponse {

    constructor(data?: IImportTicketsUpdateResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ImportTicketsUpdateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportTicketsUpdateResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IImportTicketsUpdateResponse extends IOkApiResponse {
}

export class ImportTicketsUpdateRequest extends ImportTicketsGetRequest implements IImportTicketsUpdateRequest {
    importTickets?: ImportTicket | null;

    constructor(data?: IImportTicketsUpdateRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.importTickets = _data["importTickets"] ? ImportTicket.fromJS(_data["importTickets"]) : null as any;
        }
    }

    static override fromJS(data: any): ImportTicketsUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportTicketsUpdateRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["importTickets"] = this.importTickets ? this.importTickets.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IImportTicketsUpdateRequest extends IImportTicketsGetRequest {
    importTickets?: ImportTicket | null;
}

export class ImportTicket implements IImportTicket {
    id?: number;
    dataBolla?: string | null;
    numeroBolla?: string | null;
    vettore?: string | null;
    codiceV?: string | null;
    pax?: string | null;
    serie?: string | null;
    tkt?: string | null;
    routing?: string | null;
    classe?: string | null;
    nazInt?: string | null;
    partenza?: string | null;
    c_Costo?: number | null;
    commessa?: string | null;
    tariffaApplicata?: number | null;
    tax?: number | null;
    totale?: number | null;
    tariffaOrdinaria?: number | null;
    f_Pag?: string | null;
    offertaID?: number | null;
    iva?: string | null;
    note?: string | null;
    partenzaPratica?: string | null;
    ticketType?: ETicketsType;
    searchTerms?: string;

    constructor(data?: IImportTicket) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.dataBolla = _data["dataBolla"] !== undefined ? _data["dataBolla"] : null as any;
            this.numeroBolla = _data["numeroBolla"] !== undefined ? _data["numeroBolla"] : null as any;
            this.vettore = _data["vettore"] !== undefined ? _data["vettore"] : null as any;
            this.codiceV = _data["codiceV"] !== undefined ? _data["codiceV"] : null as any;
            this.pax = _data["pax"] !== undefined ? _data["pax"] : null as any;
            this.serie = _data["serie"] !== undefined ? _data["serie"] : null as any;
            this.tkt = _data["tkt"] !== undefined ? _data["tkt"] : null as any;
            this.routing = _data["routing"] !== undefined ? _data["routing"] : null as any;
            this.classe = _data["classe"] !== undefined ? _data["classe"] : null as any;
            this.nazInt = _data["nazInt"] !== undefined ? _data["nazInt"] : null as any;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : null as any;
            this.c_Costo = _data["c_Costo"] !== undefined ? _data["c_Costo"] : null as any;
            this.commessa = _data["commessa"] !== undefined ? _data["commessa"] : null as any;
            this.tariffaApplicata = _data["tariffaApplicata"] !== undefined ? _data["tariffaApplicata"] : null as any;
            this.tax = _data["tax"] !== undefined ? _data["tax"] : null as any;
            this.totale = _data["totale"] !== undefined ? _data["totale"] : null as any;
            this.tariffaOrdinaria = _data["tariffaOrdinaria"] !== undefined ? _data["tariffaOrdinaria"] : null as any;
            this.f_Pag = _data["f_Pag"] !== undefined ? _data["f_Pag"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.iva = _data["iva"] !== undefined ? _data["iva"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.partenzaPratica = _data["partenzaPratica"] !== undefined ? _data["partenzaPratica"] : null as any;
            this.ticketType = _data["ticketType"] !== undefined ? _data["ticketType"] : null as any;
            this.searchTerms = _data["searchTerms"] !== undefined ? _data["searchTerms"] : null as any;
        }
    }

    static fromJS(data: any): ImportTicket {
        data = typeof data === 'object' ? data : {};
        let result = new ImportTicket();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["dataBolla"] = this.dataBolla !== undefined ? this.dataBolla : null as any;
        data["numeroBolla"] = this.numeroBolla !== undefined ? this.numeroBolla : null as any;
        data["vettore"] = this.vettore !== undefined ? this.vettore : null as any;
        data["codiceV"] = this.codiceV !== undefined ? this.codiceV : null as any;
        data["pax"] = this.pax !== undefined ? this.pax : null as any;
        data["serie"] = this.serie !== undefined ? this.serie : null as any;
        data["tkt"] = this.tkt !== undefined ? this.tkt : null as any;
        data["routing"] = this.routing !== undefined ? this.routing : null as any;
        data["classe"] = this.classe !== undefined ? this.classe : null as any;
        data["nazInt"] = this.nazInt !== undefined ? this.nazInt : null as any;
        data["partenza"] = this.partenza !== undefined ? this.partenza : null as any;
        data["c_Costo"] = this.c_Costo !== undefined ? this.c_Costo : null as any;
        data["commessa"] = this.commessa !== undefined ? this.commessa : null as any;
        data["tariffaApplicata"] = this.tariffaApplicata !== undefined ? this.tariffaApplicata : null as any;
        data["tax"] = this.tax !== undefined ? this.tax : null as any;
        data["totale"] = this.totale !== undefined ? this.totale : null as any;
        data["tariffaOrdinaria"] = this.tariffaOrdinaria !== undefined ? this.tariffaOrdinaria : null as any;
        data["f_Pag"] = this.f_Pag !== undefined ? this.f_Pag : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["iva"] = this.iva !== undefined ? this.iva : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["partenzaPratica"] = this.partenzaPratica !== undefined ? this.partenzaPratica : null as any;
        data["ticketType"] = this.ticketType !== undefined ? this.ticketType : null as any;
        data["searchTerms"] = this.searchTerms !== undefined ? this.searchTerms : null as any;
        return data;
    }
}

export interface IImportTicket {
    id?: number;
    dataBolla?: string | null;
    numeroBolla?: string | null;
    vettore?: string | null;
    codiceV?: string | null;
    pax?: string | null;
    serie?: string | null;
    tkt?: string | null;
    routing?: string | null;
    classe?: string | null;
    nazInt?: string | null;
    partenza?: string | null;
    c_Costo?: number | null;
    commessa?: string | null;
    tariffaApplicata?: number | null;
    tax?: number | null;
    totale?: number | null;
    tariffaOrdinaria?: number | null;
    f_Pag?: string | null;
    offertaID?: number | null;
    iva?: string | null;
    note?: string | null;
    partenzaPratica?: string | null;
    ticketType?: ETicketsType;
    searchTerms?: string;
}

export class ImportTicketsUploadResponse extends OkApiResponse implements IImportTicketsUploadResponse {

    constructor(data?: IImportTicketsUploadResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ImportTicketsUploadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportTicketsUploadResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IImportTicketsUploadResponse extends IOkApiResponse {
}

export class IncomingDeleteRequest extends ApiRequest implements IIncomingDeleteRequest {
    offertaID?: number;
    incassoID?: number;

    constructor(data?: IIncomingDeleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.incassoID = _data["incassoID"] !== undefined ? _data["incassoID"] : null as any;
        }
    }

    static override fromJS(data: any): IncomingDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingDeleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["incassoID"] = this.incassoID !== undefined ? this.incassoID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IIncomingDeleteRequest extends IApiRequest {
    offertaID?: number;
    incassoID?: number;
}

export class IncomingGetResponse extends OkApiResponse implements IIncomingGetResponse {
    /** Entità dell'incasso */
    incasso?: OffertaIncasso;

    constructor(data?: IIncomingGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.incasso = _data["incasso"] ? OffertaIncasso.fromJS(_data["incasso"]) : null as any;
        }
    }

    static override fromJS(data: any): IncomingGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incasso"] = this.incasso ? this.incasso.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IIncomingGetResponse extends IOkApiResponse {
    /** Entità dell'incasso */
    incasso?: OffertaIncasso;
}

export class OffertaIncasso implements IOffertaIncasso {
    incassoID?: number;
    offertaID?: number;
    importo?: number | null;
    importoValuta?: number;
    dataPagamento?: string | null;
    dataScadenza?: string | null;
    dataCessione?: string | null;
    tipoPagamentoIncasso?: ETipoPagamentoIncasso | null;
    tipoPagamento?: number | null;
    tipoOperazioneIncasso?: ETipoOperazioneIncasso | null;
    tipoOperazione?: number | null;
    offertaDatoID?: number | null;
    descrizione?: string | null;
    tipoTicketBiglietteria?: ETipoTicketBiglietteria | null;
    tipoBiglietteria?: number | null;
    tipoPrepagamentoIncasso?: ETipoAcconto | null;
    tipoPrepagamento?: number | null;
    banca?: number | null;
    causale?: string | null;
    contattoID?: number;
    operatoreID?: number | null;
    estrattoContoID?: number | null;
    dareAvere?: EDareAvere | null;
    flussoID?: number | null;
    importoIncassato?: number;
    importoResiduo?: number;
    importoIncassatoValuta?: number;
    importoResiduoValuta?: number;

    constructor(data?: IOffertaIncasso) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incassoID = _data["incassoID"] !== undefined ? _data["incassoID"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : null as any;
            this.importoValuta = _data["importoValuta"] !== undefined ? _data["importoValuta"] : null as any;
            this.dataPagamento = _data["dataPagamento"] !== undefined ? _data["dataPagamento"] : null as any;
            this.dataScadenza = _data["dataScadenza"] !== undefined ? _data["dataScadenza"] : null as any;
            this.dataCessione = _data["dataCessione"] !== undefined ? _data["dataCessione"] : null as any;
            this.tipoPagamentoIncasso = _data["tipoPagamentoIncasso"] !== undefined ? _data["tipoPagamentoIncasso"] : null as any;
            this.tipoPagamento = _data["tipoPagamento"] !== undefined ? _data["tipoPagamento"] : null as any;
            this.tipoOperazioneIncasso = _data["tipoOperazioneIncasso"] !== undefined ? _data["tipoOperazioneIncasso"] : null as any;
            this.tipoOperazione = _data["tipoOperazione"] !== undefined ? _data["tipoOperazione"] : null as any;
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.tipoTicketBiglietteria = _data["tipoTicketBiglietteria"] !== undefined ? _data["tipoTicketBiglietteria"] : null as any;
            this.tipoBiglietteria = _data["tipoBiglietteria"] !== undefined ? _data["tipoBiglietteria"] : null as any;
            this.tipoPrepagamentoIncasso = _data["tipoPrepagamentoIncasso"] !== undefined ? _data["tipoPrepagamentoIncasso"] : null as any;
            this.tipoPrepagamento = _data["tipoPrepagamento"] !== undefined ? _data["tipoPrepagamento"] : null as any;
            this.banca = _data["banca"] !== undefined ? _data["banca"] : null as any;
            this.causale = _data["causale"] !== undefined ? _data["causale"] : null as any;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.operatoreID = _data["operatoreID"] !== undefined ? _data["operatoreID"] : null as any;
            this.estrattoContoID = _data["estrattoContoID"] !== undefined ? _data["estrattoContoID"] : null as any;
            this.dareAvere = _data["dareAvere"] !== undefined ? _data["dareAvere"] : null as any;
            this.flussoID = _data["flussoID"] !== undefined ? _data["flussoID"] : null as any;
            this.importoIncassato = _data["importoIncassato"] !== undefined ? _data["importoIncassato"] : null as any;
            this.importoResiduo = _data["importoResiduo"] !== undefined ? _data["importoResiduo"] : null as any;
            this.importoIncassatoValuta = _data["importoIncassatoValuta"] !== undefined ? _data["importoIncassatoValuta"] : null as any;
            this.importoResiduoValuta = _data["importoResiduoValuta"] !== undefined ? _data["importoResiduoValuta"] : null as any;
        }
    }

    static fromJS(data: any): OffertaIncasso {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaIncasso();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incassoID"] = this.incassoID !== undefined ? this.incassoID : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["importo"] = this.importo !== undefined ? this.importo : null as any;
        data["importoValuta"] = this.importoValuta !== undefined ? this.importoValuta : null as any;
        data["dataPagamento"] = this.dataPagamento !== undefined ? this.dataPagamento : null as any;
        data["dataScadenza"] = this.dataScadenza !== undefined ? this.dataScadenza : null as any;
        data["dataCessione"] = this.dataCessione !== undefined ? this.dataCessione : null as any;
        data["tipoPagamentoIncasso"] = this.tipoPagamentoIncasso !== undefined ? this.tipoPagamentoIncasso : null as any;
        data["tipoPagamento"] = this.tipoPagamento !== undefined ? this.tipoPagamento : null as any;
        data["tipoOperazioneIncasso"] = this.tipoOperazioneIncasso !== undefined ? this.tipoOperazioneIncasso : null as any;
        data["tipoOperazione"] = this.tipoOperazione !== undefined ? this.tipoOperazione : null as any;
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["tipoTicketBiglietteria"] = this.tipoTicketBiglietteria !== undefined ? this.tipoTicketBiglietteria : null as any;
        data["tipoBiglietteria"] = this.tipoBiglietteria !== undefined ? this.tipoBiglietteria : null as any;
        data["tipoPrepagamentoIncasso"] = this.tipoPrepagamentoIncasso !== undefined ? this.tipoPrepagamentoIncasso : null as any;
        data["tipoPrepagamento"] = this.tipoPrepagamento !== undefined ? this.tipoPrepagamento : null as any;
        data["banca"] = this.banca !== undefined ? this.banca : null as any;
        data["causale"] = this.causale !== undefined ? this.causale : null as any;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["operatoreID"] = this.operatoreID !== undefined ? this.operatoreID : null as any;
        data["estrattoContoID"] = this.estrattoContoID !== undefined ? this.estrattoContoID : null as any;
        data["dareAvere"] = this.dareAvere !== undefined ? this.dareAvere : null as any;
        data["flussoID"] = this.flussoID !== undefined ? this.flussoID : null as any;
        data["importoIncassato"] = this.importoIncassato !== undefined ? this.importoIncassato : null as any;
        data["importoResiduo"] = this.importoResiduo !== undefined ? this.importoResiduo : null as any;
        data["importoIncassatoValuta"] = this.importoIncassatoValuta !== undefined ? this.importoIncassatoValuta : null as any;
        data["importoResiduoValuta"] = this.importoResiduoValuta !== undefined ? this.importoResiduoValuta : null as any;
        return data;
    }
}

export interface IOffertaIncasso {
    incassoID?: number;
    offertaID?: number;
    importo?: number | null;
    importoValuta?: number;
    dataPagamento?: string | null;
    dataScadenza?: string | null;
    dataCessione?: string | null;
    tipoPagamentoIncasso?: ETipoPagamentoIncasso | null;
    tipoPagamento?: number | null;
    tipoOperazioneIncasso?: ETipoOperazioneIncasso | null;
    tipoOperazione?: number | null;
    offertaDatoID?: number | null;
    descrizione?: string | null;
    tipoTicketBiglietteria?: ETipoTicketBiglietteria | null;
    tipoBiglietteria?: number | null;
    tipoPrepagamentoIncasso?: ETipoAcconto | null;
    tipoPrepagamento?: number | null;
    banca?: number | null;
    causale?: string | null;
    contattoID?: number;
    operatoreID?: number | null;
    estrattoContoID?: number | null;
    dareAvere?: EDareAvere | null;
    flussoID?: number | null;
    importoIncassato?: number;
    importoResiduo?: number;
    importoIncassatoValuta?: number;
    importoResiduoValuta?: number;
}

export enum ETipoPagamentoIncasso {
    Bonifico = "Bonifico",
    Factoring = "Factoring",
    TravelFactoring = "TravelFactoring",
    RID = "RID",
    POS = "POS",
    PAYPAL = "PAYPAL",
    Assegno = "Assegno",
    Contanti = "Contanti",
    Compensazione = "Compensazione",
}

export enum ETipoOperazioneIncasso {
    Acconto = "Acconto",
    Saldo = "Saldo",
    Cessione = "Cessione",
}

export enum ETipoTicketBiglietteria {
    Tutto = "Tutto",
    IP = "IP",
    TO = "TO",
}

export enum ETipoAcconto {
    Acconto = "Acconto",
    Hotel = "Hotel",
    Tour = "Tour",
    TariffaIP = "TariffaIP",
    TariffaTO = "TariffaTO",
    AltriVoli = "AltriVoli",
}

export enum EDareAvere {
    Avere = "Avere",
    Dare = "Dare",
    Previsione = "Previsione",
}

export class IncomingGetRequest extends ApiRequest implements IIncomingGetRequest {
    /** ID dell'incasso da caricare */
    incassoID?: number;

    constructor(data?: IIncomingGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.incassoID = _data["incassoID"] !== undefined ? _data["incassoID"] : null as any;
        }
    }

    static override fromJS(data: any): IncomingGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incassoID"] = this.incassoID !== undefined ? this.incassoID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IIncomingGetRequest extends IApiRequest {
    /** ID dell'incasso da caricare */
    incassoID?: number;
}

export class IncomingsBatchResponse extends OkApiResponse implements IIncomingsBatchResponse {
    count?: number;
    taskID?: number;

    constructor(data?: IIncomingsBatchResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.taskID = _data["taskID"] !== undefined ? _data["taskID"] : null as any;
        }
    }

    static override fromJS(data: any): IncomingsBatchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingsBatchResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["taskID"] = this.taskID !== undefined ? this.taskID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IIncomingsBatchResponse extends IOkApiResponse {
    count?: number;
    taskID?: number;
}

export class IncomingsListRequest extends LocalizedRequest implements IIncomingsListRequest {
    /** Filtro su offerta singola. NOTA: Invalida tutti gli altri filtri */
    offertaID?: number | null;
    /** Modalità della gestione incassi */
    modalita?: EModalitaIncassi;
    /** Filtro Dare/Avere */
    modalitaDareAvere?: EModalitaDareAvere;
    /** Filtro sull'operatore della pratica */
    operatore?: EOperatore | null;
    /** ID del contatto agenzia associato alle righe */
    contattoAgenziaID?: number | null;
    /** Filtro sulla partita IVA del contatto agenzia */
    partitaIVA?: string | null;
    /** Filtro sulla data di partenza "dal" incluso */
    partenzaDal?: string | null;
    /** Filtro sulla data di partenza "al" incluso */
    partenzaAl?: string | null;
    /** Filtro sulla data di scadenza "dal" incluso */
    scadenzaDal?: string | null;
    /** Filtro sulla data di scadenza "al" incluso */
    scadenzaAl?: string | null;
    /** ID della modalità di pagamento (riferita all'offerta) */
    modalitaPagamentoID?: number | null;
    /** ID della banca (come stringa) */
    bancaID?: number | null;
    /** ID del promotore dell'agenzia */
    contattoPromotoreID?: number | null;

    constructor(data?: IIncomingsListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.modalita = _data["modalita"] !== undefined ? _data["modalita"] : null as any;
            this.modalitaDareAvere = _data["modalitaDareAvere"] !== undefined ? _data["modalitaDareAvere"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.contattoAgenziaID = _data["contattoAgenziaID"] !== undefined ? _data["contattoAgenziaID"] : null as any;
            this.partitaIVA = _data["partitaIVA"] !== undefined ? _data["partitaIVA"] : null as any;
            this.partenzaDal = _data["partenzaDal"] !== undefined ? _data["partenzaDal"] : null as any;
            this.partenzaAl = _data["partenzaAl"] !== undefined ? _data["partenzaAl"] : null as any;
            this.scadenzaDal = _data["scadenzaDal"] !== undefined ? _data["scadenzaDal"] : null as any;
            this.scadenzaAl = _data["scadenzaAl"] !== undefined ? _data["scadenzaAl"] : null as any;
            this.modalitaPagamentoID = _data["modalitaPagamentoID"] !== undefined ? _data["modalitaPagamentoID"] : null as any;
            this.bancaID = _data["bancaID"] !== undefined ? _data["bancaID"] : null as any;
            this.contattoPromotoreID = _data["contattoPromotoreID"] !== undefined ? _data["contattoPromotoreID"] : null as any;
        }
    }

    static override fromJS(data: any): IncomingsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingsListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["modalita"] = this.modalita !== undefined ? this.modalita : null as any;
        data["modalitaDareAvere"] = this.modalitaDareAvere !== undefined ? this.modalitaDareAvere : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["contattoAgenziaID"] = this.contattoAgenziaID !== undefined ? this.contattoAgenziaID : null as any;
        data["partitaIVA"] = this.partitaIVA !== undefined ? this.partitaIVA : null as any;
        data["partenzaDal"] = this.partenzaDal !== undefined ? this.partenzaDal : null as any;
        data["partenzaAl"] = this.partenzaAl !== undefined ? this.partenzaAl : null as any;
        data["scadenzaDal"] = this.scadenzaDal !== undefined ? this.scadenzaDal : null as any;
        data["scadenzaAl"] = this.scadenzaAl !== undefined ? this.scadenzaAl : null as any;
        data["modalitaPagamentoID"] = this.modalitaPagamentoID !== undefined ? this.modalitaPagamentoID : null as any;
        data["bancaID"] = this.bancaID !== undefined ? this.bancaID : null as any;
        data["contattoPromotoreID"] = this.contattoPromotoreID !== undefined ? this.contattoPromotoreID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IIncomingsListRequest extends ILocalizedRequest {
    /** Filtro su offerta singola. NOTA: Invalida tutti gli altri filtri */
    offertaID?: number | null;
    /** Modalità della gestione incassi */
    modalita?: EModalitaIncassi;
    /** Filtro Dare/Avere */
    modalitaDareAvere?: EModalitaDareAvere;
    /** Filtro sull'operatore della pratica */
    operatore?: EOperatore | null;
    /** ID del contatto agenzia associato alle righe */
    contattoAgenziaID?: number | null;
    /** Filtro sulla partita IVA del contatto agenzia */
    partitaIVA?: string | null;
    /** Filtro sulla data di partenza "dal" incluso */
    partenzaDal?: string | null;
    /** Filtro sulla data di partenza "al" incluso */
    partenzaAl?: string | null;
    /** Filtro sulla data di scadenza "dal" incluso */
    scadenzaDal?: string | null;
    /** Filtro sulla data di scadenza "al" incluso */
    scadenzaAl?: string | null;
    /** ID della modalità di pagamento (riferita all'offerta) */
    modalitaPagamentoID?: number | null;
    /** ID della banca (come stringa) */
    bancaID?: number | null;
    /** ID del promotore dell'agenzia */
    contattoPromotoreID?: number | null;
}

export class IncomingsBatchRequest extends IncomingsListRequest implements IIncomingsBatchRequest {
    /** Se true non crea il task ma fa solo i conteggi */
    preview?: boolean;
    /** Se true esegue il ricalcolo accorpato */
    grouped?: boolean;

    constructor(data?: IIncomingsBatchRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.preview = _data["preview"] !== undefined ? _data["preview"] : null as any;
            this.grouped = _data["grouped"] !== undefined ? _data["grouped"] : null as any;
        }
    }

    static override fromJS(data: any): IncomingsBatchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingsBatchRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preview"] = this.preview !== undefined ? this.preview : null as any;
        data["grouped"] = this.grouped !== undefined ? this.grouped : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IIncomingsBatchRequest extends IIncomingsListRequest {
    /** Se true non crea il task ma fa solo i conteggi */
    preview?: boolean;
    /** Se true esegue il ricalcolo accorpato */
    grouped?: boolean;
}

export enum EModalitaIncassi {
    Scadenziario = "Scadenziario",
    DareAvere = "DareAvere",
}

export enum EModalitaDareAvere {
    Tutto = "Tutto",
    Dare = "Dare",
    Avere = "Avere",
}

export class IncomingsBatchQueryResponse extends OkApiResponse implements IIncomingsBatchQueryResponse {
    hasWork?: boolean;
    done?: number;
    total?: number;

    constructor(data?: IIncomingsBatchQueryResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hasWork = _data["hasWork"] !== undefined ? _data["hasWork"] : null as any;
            this.done = _data["done"] !== undefined ? _data["done"] : null as any;
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): IncomingsBatchQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingsBatchQueryResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasWork"] = this.hasWork !== undefined ? this.hasWork : null as any;
        data["done"] = this.done !== undefined ? this.done : null as any;
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IIncomingsBatchQueryResponse extends IOkApiResponse {
    hasWork?: boolean;
    done?: number;
    total?: number;
}

export class IncomingsChangeRequest extends ApiRequest implements IIncomingsChangeRequest {
    incassiIDs?: number[];
    pagamentoIncassoID?: number | null;
    bancaID?: number | null;
    data?: string | null;

    constructor(data?: IIncomingsChangeRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["incassiIDs"])) {
                this.incassiIDs = [] as any;
                for (let item of _data["incassiIDs"])
                    this.incassiIDs!.push(item);
            }
            else {
                this.incassiIDs = null as any;
            }
            this.pagamentoIncassoID = _data["pagamentoIncassoID"] !== undefined ? _data["pagamentoIncassoID"] : null as any;
            this.bancaID = _data["bancaID"] !== undefined ? _data["bancaID"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
        }
    }

    static override fromJS(data: any): IncomingsChangeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingsChangeRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.incassiIDs)) {
            data["incassiIDs"] = [];
            for (let item of this.incassiIDs)
                data["incassiIDs"].push(item);
        }
        data["pagamentoIncassoID"] = this.pagamentoIncassoID !== undefined ? this.pagamentoIncassoID : null as any;
        data["bancaID"] = this.bancaID !== undefined ? this.bancaID : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IIncomingsChangeRequest extends IApiRequest {
    incassiIDs?: number[];
    pagamentoIncassoID?: number | null;
    bancaID?: number | null;
    data?: string | null;
}

export class IncomingsCreateRequest extends ApiRequest implements IIncomingsCreateRequest {
    offertaID?: number;
    grouped?: boolean;

    constructor(data?: IIncomingsCreateRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.grouped = _data["grouped"] !== undefined ? _data["grouped"] : null as any;
        }
    }

    static override fromJS(data: any): IncomingsCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingsCreateRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["grouped"] = this.grouped !== undefined ? this.grouped : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IIncomingsCreateRequest extends IApiRequest {
    offertaID?: number;
    grouped?: boolean;
}

export class IncomingsDeleteRequest extends ApiRequest implements IIncomingsDeleteRequest {
    incassiIDs?: number[];

    constructor(data?: IIncomingsDeleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["incassiIDs"])) {
                this.incassiIDs = [] as any;
                for (let item of _data["incassiIDs"])
                    this.incassiIDs!.push(item);
            }
            else {
                this.incassiIDs = null as any;
            }
        }
    }

    static override fromJS(data: any): IncomingsDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingsDeleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.incassiIDs)) {
            data["incassiIDs"] = [];
            for (let item of this.incassiIDs)
                data["incassiIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IIncomingsDeleteRequest extends IApiRequest {
    incassiIDs?: number[];
}

export class IncomingsListResponse extends OkApiResponse implements IIncomingsListResponse {
    /** Lista delle righe */
    rows?: IncomingListRow[];
    /** Numero di righe massimo estratto */
    maxRows?: number;
    /** Numero di righe totali che corrispondono al criterio */
    totalRows?: number;
    /** Modalità della lista (se chiedo un'offerta specifica potrebbe essere diversa da quella del filtro) */
    modalita?: EModalitaIncassi;
    /** Toale dare, incluse non visualizzate */
    totaleDare?: number;
    /** Totale avere, incluse non visualizzate */
    totaleAvere?: number;
    /** Totale avere incluse le non visualizzate, con data inferiore ad oggi ed importo non coperto dal totale dare */
    totaleAvereScaduto?: number;
    /** Totale sbilancio, incluse non visualizzate */
    totaleSbilancio?: number;
    /** Se true ci sono altri record che rispettano il criterio ma non sono visualizzati */
    hasMore?: boolean;

    constructor(data?: IIncomingsListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(IncomingListRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.maxRows = _data["maxRows"] !== undefined ? _data["maxRows"] : null as any;
            this.totalRows = _data["totalRows"] !== undefined ? _data["totalRows"] : null as any;
            this.modalita = _data["modalita"] !== undefined ? _data["modalita"] : null as any;
            this.totaleDare = _data["totaleDare"] !== undefined ? _data["totaleDare"] : null as any;
            this.totaleAvere = _data["totaleAvere"] !== undefined ? _data["totaleAvere"] : null as any;
            this.totaleAvereScaduto = _data["totaleAvereScaduto"] !== undefined ? _data["totaleAvereScaduto"] : null as any;
            this.totaleSbilancio = _data["totaleSbilancio"] !== undefined ? _data["totaleSbilancio"] : null as any;
            this.hasMore = _data["hasMore"] !== undefined ? _data["hasMore"] : null as any;
        }
    }

    static override fromJS(data: any): IncomingsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingsListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["maxRows"] = this.maxRows !== undefined ? this.maxRows : null as any;
        data["totalRows"] = this.totalRows !== undefined ? this.totalRows : null as any;
        data["modalita"] = this.modalita !== undefined ? this.modalita : null as any;
        data["totaleDare"] = this.totaleDare !== undefined ? this.totaleDare : null as any;
        data["totaleAvere"] = this.totaleAvere !== undefined ? this.totaleAvere : null as any;
        data["totaleAvereScaduto"] = this.totaleAvereScaduto !== undefined ? this.totaleAvereScaduto : null as any;
        data["totaleSbilancio"] = this.totaleSbilancio !== undefined ? this.totaleSbilancio : null as any;
        data["hasMore"] = this.hasMore !== undefined ? this.hasMore : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IIncomingsListResponse extends IOkApiResponse {
    /** Lista delle righe */
    rows?: IncomingListRow[];
    /** Numero di righe massimo estratto */
    maxRows?: number;
    /** Numero di righe totali che corrispondono al criterio */
    totalRows?: number;
    /** Modalità della lista (se chiedo un'offerta specifica potrebbe essere diversa da quella del filtro) */
    modalita?: EModalitaIncassi;
    /** Toale dare, incluse non visualizzate */
    totaleDare?: number;
    /** Totale avere, incluse non visualizzate */
    totaleAvere?: number;
    /** Totale avere incluse le non visualizzate, con data inferiore ad oggi ed importo non coperto dal totale dare */
    totaleAvereScaduto?: number;
    /** Totale sbilancio, incluse non visualizzate */
    totaleSbilancio?: number;
    /** Se true ci sono altri record che rispettano il criterio ma non sono visualizzati */
    hasMore?: boolean;
}

export class IncomingListRow implements IIncomingListRow {
    id?: number;
    offertaID?: number;
    descrizioneOfferta?: string | null;
    partenza?: string;
    offertaDatoID?: number | null;
    data?: string;
    importo?: number;
    descrizioneIncasso?: string | null;
    dareAvere?: EDareAvere | null;
    contattoID?: number;
    nomeContatto?: string | null;
    contattoNetworkID?: number | null;
    nomeContattoNetwork?: string | null;
    dataIncasso?: string | null;
    dataCessione?: string | null;
    pagamentoOffertaID?: number | null;
    nomePagamentoOfferta?: string | null;
    bancaID?: number | null;
    nomeBanca?: string | null;
    tipoOperazione?: ETipoOperazioneIncasso | null;
    tipoPagamento?: ETipoPagamentoIncasso | null;
    tipoTicketBiglietteria?: ETipoTicketBiglietteria | null;
    tipoPrepagamento?: ETipoAcconto | null;
    contattoPromotoreID?: number | null;
    nomeContattoPromotore?: string | null;
    valutaID?: number | null;
    cambio?: number | null;
    codiceValuta?: string | null;
    incasso?: OffertaIncasso | null;

    constructor(data?: IIncomingListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.descrizioneOfferta = _data["descrizioneOfferta"] !== undefined ? _data["descrizioneOfferta"] : null as any;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : null as any;
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : null as any;
            this.descrizioneIncasso = _data["descrizioneIncasso"] !== undefined ? _data["descrizioneIncasso"] : null as any;
            this.dareAvere = _data["dareAvere"] !== undefined ? _data["dareAvere"] : null as any;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.nomeContatto = _data["nomeContatto"] !== undefined ? _data["nomeContatto"] : null as any;
            this.contattoNetworkID = _data["contattoNetworkID"] !== undefined ? _data["contattoNetworkID"] : null as any;
            this.nomeContattoNetwork = _data["nomeContattoNetwork"] !== undefined ? _data["nomeContattoNetwork"] : null as any;
            this.dataIncasso = _data["dataIncasso"] !== undefined ? _data["dataIncasso"] : null as any;
            this.dataCessione = _data["dataCessione"] !== undefined ? _data["dataCessione"] : null as any;
            this.pagamentoOffertaID = _data["pagamentoOffertaID"] !== undefined ? _data["pagamentoOffertaID"] : null as any;
            this.nomePagamentoOfferta = _data["nomePagamentoOfferta"] !== undefined ? _data["nomePagamentoOfferta"] : null as any;
            this.bancaID = _data["bancaID"] !== undefined ? _data["bancaID"] : null as any;
            this.nomeBanca = _data["nomeBanca"] !== undefined ? _data["nomeBanca"] : null as any;
            this.tipoOperazione = _data["tipoOperazione"] !== undefined ? _data["tipoOperazione"] : null as any;
            this.tipoPagamento = _data["tipoPagamento"] !== undefined ? _data["tipoPagamento"] : null as any;
            this.tipoTicketBiglietteria = _data["tipoTicketBiglietteria"] !== undefined ? _data["tipoTicketBiglietteria"] : null as any;
            this.tipoPrepagamento = _data["tipoPrepagamento"] !== undefined ? _data["tipoPrepagamento"] : null as any;
            this.contattoPromotoreID = _data["contattoPromotoreID"] !== undefined ? _data["contattoPromotoreID"] : null as any;
            this.nomeContattoPromotore = _data["nomeContattoPromotore"] !== undefined ? _data["nomeContattoPromotore"] : null as any;
            this.valutaID = _data["valutaID"] !== undefined ? _data["valutaID"] : null as any;
            this.cambio = _data["cambio"] !== undefined ? _data["cambio"] : null as any;
            this.codiceValuta = _data["codiceValuta"] !== undefined ? _data["codiceValuta"] : null as any;
            this.incasso = _data["incasso"] ? OffertaIncasso.fromJS(_data["incasso"]) : null as any;
        }
    }

    static fromJS(data: any): IncomingListRow {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["descrizioneOfferta"] = this.descrizioneOfferta !== undefined ? this.descrizioneOfferta : null as any;
        data["partenza"] = this.partenza !== undefined ? this.partenza : null as any;
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["importo"] = this.importo !== undefined ? this.importo : null as any;
        data["descrizioneIncasso"] = this.descrizioneIncasso !== undefined ? this.descrizioneIncasso : null as any;
        data["dareAvere"] = this.dareAvere !== undefined ? this.dareAvere : null as any;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["nomeContatto"] = this.nomeContatto !== undefined ? this.nomeContatto : null as any;
        data["contattoNetworkID"] = this.contattoNetworkID !== undefined ? this.contattoNetworkID : null as any;
        data["nomeContattoNetwork"] = this.nomeContattoNetwork !== undefined ? this.nomeContattoNetwork : null as any;
        data["dataIncasso"] = this.dataIncasso !== undefined ? this.dataIncasso : null as any;
        data["dataCessione"] = this.dataCessione !== undefined ? this.dataCessione : null as any;
        data["pagamentoOffertaID"] = this.pagamentoOffertaID !== undefined ? this.pagamentoOffertaID : null as any;
        data["nomePagamentoOfferta"] = this.nomePagamentoOfferta !== undefined ? this.nomePagamentoOfferta : null as any;
        data["bancaID"] = this.bancaID !== undefined ? this.bancaID : null as any;
        data["nomeBanca"] = this.nomeBanca !== undefined ? this.nomeBanca : null as any;
        data["tipoOperazione"] = this.tipoOperazione !== undefined ? this.tipoOperazione : null as any;
        data["tipoPagamento"] = this.tipoPagamento !== undefined ? this.tipoPagamento : null as any;
        data["tipoTicketBiglietteria"] = this.tipoTicketBiglietteria !== undefined ? this.tipoTicketBiglietteria : null as any;
        data["tipoPrepagamento"] = this.tipoPrepagamento !== undefined ? this.tipoPrepagamento : null as any;
        data["contattoPromotoreID"] = this.contattoPromotoreID !== undefined ? this.contattoPromotoreID : null as any;
        data["nomeContattoPromotore"] = this.nomeContattoPromotore !== undefined ? this.nomeContattoPromotore : null as any;
        data["valutaID"] = this.valutaID !== undefined ? this.valutaID : null as any;
        data["cambio"] = this.cambio !== undefined ? this.cambio : null as any;
        data["codiceValuta"] = this.codiceValuta !== undefined ? this.codiceValuta : null as any;
        data["incasso"] = this.incasso ? this.incasso.toJSON() : null as any;
        return data;
    }
}

export interface IIncomingListRow {
    id?: number;
    offertaID?: number;
    descrizioneOfferta?: string | null;
    partenza?: string;
    offertaDatoID?: number | null;
    data?: string;
    importo?: number;
    descrizioneIncasso?: string | null;
    dareAvere?: EDareAvere | null;
    contattoID?: number;
    nomeContatto?: string | null;
    contattoNetworkID?: number | null;
    nomeContattoNetwork?: string | null;
    dataIncasso?: string | null;
    dataCessione?: string | null;
    pagamentoOffertaID?: number | null;
    nomePagamentoOfferta?: string | null;
    bancaID?: number | null;
    nomeBanca?: string | null;
    tipoOperazione?: ETipoOperazioneIncasso | null;
    tipoPagamento?: ETipoPagamentoIncasso | null;
    tipoTicketBiglietteria?: ETipoTicketBiglietteria | null;
    tipoPrepagamento?: ETipoAcconto | null;
    contattoPromotoreID?: number | null;
    nomeContattoPromotore?: string | null;
    valutaID?: number | null;
    cambio?: number | null;
    codiceValuta?: string | null;
    incasso?: OffertaIncasso | null;
}

/** Currency of a trip ("offerta"). Used by the incomings editor to display/enter amounts in the trip currency and convert them to EUR on save. */
export class IncomingTripCurrencyResponse extends OkApiResponse implements IIncomingTripCurrencyResponse {
    /** Currency ID of the trip; null for trips in EUR. */
    valutaID?: number | null;
    /** Exchange rate EUR -> trip currency; null or 1 means EUR. Range: > 0. */
    cambio?: number | null;
    /** ISO currency code of the trip (e.g. CHF); EUR or null for euro trips. */
    codiceValuta?: string | null;

    constructor(data?: IIncomingTripCurrencyResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.valutaID = _data["valutaID"] !== undefined ? _data["valutaID"] : null as any;
            this.cambio = _data["cambio"] !== undefined ? _data["cambio"] : null as any;
            this.codiceValuta = _data["codiceValuta"] !== undefined ? _data["codiceValuta"] : null as any;
        }
    }

    static override fromJS(data: any): IncomingTripCurrencyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingTripCurrencyResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valutaID"] = this.valutaID !== undefined ? this.valutaID : null as any;
        data["cambio"] = this.cambio !== undefined ? this.cambio : null as any;
        data["codiceValuta"] = this.codiceValuta !== undefined ? this.codiceValuta : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Currency of a trip ("offerta"). Used by the incomings editor to display/enter amounts in the trip currency and convert them to EUR on save. */
export interface IIncomingTripCurrencyResponse extends IOkApiResponse {
    /** Currency ID of the trip; null for trips in EUR. */
    valutaID?: number | null;
    /** Exchange rate EUR -> trip currency; null or 1 means EUR. Range: > 0. */
    cambio?: number | null;
    /** ISO currency code of the trip (e.g. CHF); EUR or null for euro trips. */
    codiceValuta?: string | null;
}

/** Request for the currency of a trip ("offerta"). */
export class IncomingTripCurrencyRequest extends ApiRequest implements IIncomingTripCurrencyRequest {
    /** ID of the trip ("offerta") whose currency is requested. */
    offertaID?: number;

    constructor(data?: IIncomingTripCurrencyRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
        }
    }

    static override fromJS(data: any): IncomingTripCurrencyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingTripCurrencyRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Request for the currency of a trip ("offerta"). */
export interface IIncomingTripCurrencyRequest extends IApiRequest {
    /** ID of the trip ("offerta") whose currency is requested. */
    offertaID?: number;
}

export class IncomingUpsertResponse extends OkApiResponse implements IIncomingUpsertResponse {
    incasso?: OffertaIncasso;

    constructor(data?: IIncomingUpsertResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.incasso = _data["incasso"] ? OffertaIncasso.fromJS(_data["incasso"]) : null as any;
        }
    }

    static override fromJS(data: any): IncomingUpsertResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingUpsertResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incasso"] = this.incasso ? this.incasso.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IIncomingUpsertResponse extends IOkApiResponse {
    incasso?: OffertaIncasso;
}

export class IncomingUpsertRequest extends ApiRequest implements IIncomingUpsertRequest {
    incasso?: OffertaIncasso;

    constructor(data?: IIncomingUpsertRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.incasso = _data["incasso"] ? OffertaIncasso.fromJS(_data["incasso"]) : null as any;
        }
    }

    static override fromJS(data: any): IncomingUpsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingUpsertRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incasso"] = this.incasso ? this.incasso.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IIncomingUpsertRequest extends IApiRequest {
    incasso?: OffertaIncasso;
}

export class NrTableResponseOfBillableTrip extends OkApiResponse implements INrTableResponseOfBillableTrip {
    /** Array delle righe della pagina richiesta */
    rows?: BillableTrip[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfBillableTrip) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(BillableTrip.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfBillableTrip {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfBillableTrip();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfBillableTrip extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: BillableTrip[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class BillableTripsListResponse extends NrTableResponseOfBillableTrip implements IBillableTripsListResponse {

    constructor(data?: IBillableTripsListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): BillableTripsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BillableTripsListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IBillableTripsListResponse extends INrTableResponseOfBillableTrip {
}

/** Classe che rappresenta una singola riga di viaggio fatturabile */
export class BillableTrip implements IBillableTrip {
    /** ID dell'offerta */
    offertaID?: number;
    /** ID dell'offerta / agenzia */
    offertaAgenziaID?: number;
    /** Nome del network, se l'agenzia appartiene ad un network */
    network?: string | null;
    /** ID del contatto agenzia */
    contattoAgenziaID?: number | null;
    /** Nome dell'agenzia */
    agenzia?: string | null;
    /** Data di partenza dell'offerta */
    partenza?: string;
    /** Nome del viaggio */
    descrizione?: string | null;
    /** Totale netto dell'offerta */
    totale?: number;
    /** Totale commissioni sull'offerta */
    totaleCommissione?: number;
    /** ISO code of the offer currency, e.g. EUR or CHF. Falls back to
VALUTA_EURO_ACRONIM when the offer carries no currency. */
    codiceValuta?: string;
    /** true when the offer currency is not the Euro. */
    valutaNonEuro?: boolean;
    /** Exchange rate applied to the offer, as a EUR to CodiceValuta multiplier.
Greater than 0; 1 when the offer carries no rate. */
    cambioValuta?: number;
    /** Totale converted into CodiceValuta. */
    totaleValuta?: number;
    /** TotaleCommissione converted into CodiceValuta. */
    totaleCommissioneValuta?: number;
    /** Viaggio al netto */
    alNetto?: boolean;
    /** Data di cancellazione */
    dataCancellazione?: string | null;
    /** True se la fattura è stata emessa */
    fatturaEmessa?: boolean;
    /** True se l'autofattura è stata emessa */
    autofatturaEmessa?: boolean;

    constructor(data?: IBillableTrip) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.offertaAgenziaID = _data["offertaAgenziaID"] !== undefined ? _data["offertaAgenziaID"] : null as any;
            this.network = _data["network"] !== undefined ? _data["network"] : null as any;
            this.contattoAgenziaID = _data["contattoAgenziaID"] !== undefined ? _data["contattoAgenziaID"] : null as any;
            this.agenzia = _data["agenzia"] !== undefined ? _data["agenzia"] : null as any;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.totale = _data["totale"] !== undefined ? _data["totale"] : null as any;
            this.totaleCommissione = _data["totaleCommissione"] !== undefined ? _data["totaleCommissione"] : null as any;
            this.codiceValuta = _data["codiceValuta"] !== undefined ? _data["codiceValuta"] : null as any;
            this.valutaNonEuro = _data["valutaNonEuro"] !== undefined ? _data["valutaNonEuro"] : null as any;
            this.cambioValuta = _data["cambioValuta"] !== undefined ? _data["cambioValuta"] : null as any;
            this.totaleValuta = _data["totaleValuta"] !== undefined ? _data["totaleValuta"] : null as any;
            this.totaleCommissioneValuta = _data["totaleCommissioneValuta"] !== undefined ? _data["totaleCommissioneValuta"] : null as any;
            this.alNetto = _data["alNetto"] !== undefined ? _data["alNetto"] : null as any;
            this.dataCancellazione = _data["dataCancellazione"] !== undefined ? _data["dataCancellazione"] : null as any;
            this.fatturaEmessa = _data["fatturaEmessa"] !== undefined ? _data["fatturaEmessa"] : null as any;
            this.autofatturaEmessa = _data["autofatturaEmessa"] !== undefined ? _data["autofatturaEmessa"] : null as any;
        }
    }

    static fromJS(data: any): BillableTrip {
        data = typeof data === 'object' ? data : {};
        let result = new BillableTrip();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["offertaAgenziaID"] = this.offertaAgenziaID !== undefined ? this.offertaAgenziaID : null as any;
        data["network"] = this.network !== undefined ? this.network : null as any;
        data["contattoAgenziaID"] = this.contattoAgenziaID !== undefined ? this.contattoAgenziaID : null as any;
        data["agenzia"] = this.agenzia !== undefined ? this.agenzia : null as any;
        data["partenza"] = this.partenza !== undefined ? this.partenza : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["totale"] = this.totale !== undefined ? this.totale : null as any;
        data["totaleCommissione"] = this.totaleCommissione !== undefined ? this.totaleCommissione : null as any;
        data["codiceValuta"] = this.codiceValuta !== undefined ? this.codiceValuta : null as any;
        data["valutaNonEuro"] = this.valutaNonEuro !== undefined ? this.valutaNonEuro : null as any;
        data["cambioValuta"] = this.cambioValuta !== undefined ? this.cambioValuta : null as any;
        data["totaleValuta"] = this.totaleValuta !== undefined ? this.totaleValuta : null as any;
        data["totaleCommissioneValuta"] = this.totaleCommissioneValuta !== undefined ? this.totaleCommissioneValuta : null as any;
        data["alNetto"] = this.alNetto !== undefined ? this.alNetto : null as any;
        data["dataCancellazione"] = this.dataCancellazione !== undefined ? this.dataCancellazione : null as any;
        data["fatturaEmessa"] = this.fatturaEmessa !== undefined ? this.fatturaEmessa : null as any;
        data["autofatturaEmessa"] = this.autofatturaEmessa !== undefined ? this.autofatturaEmessa : null as any;
        return data;
    }
}

/** Classe che rappresenta una singola riga di viaggio fatturabile */
export interface IBillableTrip {
    /** ID dell'offerta */
    offertaID?: number;
    /** ID dell'offerta / agenzia */
    offertaAgenziaID?: number;
    /** Nome del network, se l'agenzia appartiene ad un network */
    network?: string | null;
    /** ID del contatto agenzia */
    contattoAgenziaID?: number | null;
    /** Nome dell'agenzia */
    agenzia?: string | null;
    /** Data di partenza dell'offerta */
    partenza?: string;
    /** Nome del viaggio */
    descrizione?: string | null;
    /** Totale netto dell'offerta */
    totale?: number;
    /** Totale commissioni sull'offerta */
    totaleCommissione?: number;
    /** ISO code of the offer currency, e.g. EUR or CHF. Falls back to
VALUTA_EURO_ACRONIM when the offer carries no currency. */
    codiceValuta?: string;
    /** true when the offer currency is not the Euro. */
    valutaNonEuro?: boolean;
    /** Exchange rate applied to the offer, as a EUR to CodiceValuta multiplier.
Greater than 0; 1 when the offer carries no rate. */
    cambioValuta?: number;
    /** Totale converted into CodiceValuta. */
    totaleValuta?: number;
    /** TotaleCommissione converted into CodiceValuta. */
    totaleCommissioneValuta?: number;
    /** Viaggio al netto */
    alNetto?: boolean;
    /** Data di cancellazione */
    dataCancellazione?: string | null;
    /** True se la fattura è stata emessa */
    fatturaEmessa?: boolean;
    /** True se l'autofattura è stata emessa */
    autofatturaEmessa?: boolean;
}

export class BillableTripsListRequest extends NrTableRequest implements IBillableTripsListRequest {
    /** Filtro per operatore obbligatorio */
    operatore?: EOperatore;
    /** ID di una singola offerta, prevale sugli altri filtri */
    offertaID?: number | null;
    /** ID del contatto agenzia associato alle offerte */
    contattoAgenziaID?: number | null;
    /** Partita IVA dell'agenzia */
    partitaIVA?: string | null;
    /** Data di partenza, DAL */
    partenzaDal?: string | null;
    /** Data di partenza, AL */
    partenzaAl?: string | null;
    /** Data di conferma, DAL */
    confermaDal?: string | null;
    /** Data di conferma, AL */
    confermaAl?: string | null;
    /** ID della modalità di pagamento (dallo status pratiche) */
    tipoPagamentoID?: number | null;
    /** Solo offerte al netto */
    soloNetto?: boolean;
    /** Solo offerte cancellate */
    soloCancellate?: boolean;

    constructor(data?: IBillableTripsListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.contattoAgenziaID = _data["contattoAgenziaID"] !== undefined ? _data["contattoAgenziaID"] : null as any;
            this.partitaIVA = _data["partitaIVA"] !== undefined ? _data["partitaIVA"] : null as any;
            this.partenzaDal = _data["partenzaDal"] !== undefined ? _data["partenzaDal"] : null as any;
            this.partenzaAl = _data["partenzaAl"] !== undefined ? _data["partenzaAl"] : null as any;
            this.confermaDal = _data["confermaDal"] !== undefined ? _data["confermaDal"] : null as any;
            this.confermaAl = _data["confermaAl"] !== undefined ? _data["confermaAl"] : null as any;
            this.tipoPagamentoID = _data["tipoPagamentoID"] !== undefined ? _data["tipoPagamentoID"] : null as any;
            this.soloNetto = _data["soloNetto"] !== undefined ? _data["soloNetto"] : null as any;
            this.soloCancellate = _data["soloCancellate"] !== undefined ? _data["soloCancellate"] : null as any;
        }
    }

    static override fromJS(data: any): BillableTripsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BillableTripsListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["contattoAgenziaID"] = this.contattoAgenziaID !== undefined ? this.contattoAgenziaID : null as any;
        data["partitaIVA"] = this.partitaIVA !== undefined ? this.partitaIVA : null as any;
        data["partenzaDal"] = this.partenzaDal !== undefined ? this.partenzaDal : null as any;
        data["partenzaAl"] = this.partenzaAl !== undefined ? this.partenzaAl : null as any;
        data["confermaDal"] = this.confermaDal !== undefined ? this.confermaDal : null as any;
        data["confermaAl"] = this.confermaAl !== undefined ? this.confermaAl : null as any;
        data["tipoPagamentoID"] = this.tipoPagamentoID !== undefined ? this.tipoPagamentoID : null as any;
        data["soloNetto"] = this.soloNetto !== undefined ? this.soloNetto : null as any;
        data["soloCancellate"] = this.soloCancellate !== undefined ? this.soloCancellate : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IBillableTripsListRequest extends INrTableRequest {
    /** Filtro per operatore obbligatorio */
    operatore?: EOperatore;
    /** ID di una singola offerta, prevale sugli altri filtri */
    offertaID?: number | null;
    /** ID del contatto agenzia associato alle offerte */
    contattoAgenziaID?: number | null;
    /** Partita IVA dell'agenzia */
    partitaIVA?: string | null;
    /** Data di partenza, DAL */
    partenzaDal?: string | null;
    /** Data di partenza, AL */
    partenzaAl?: string | null;
    /** Data di conferma, DAL */
    confermaDal?: string | null;
    /** Data di conferma, AL */
    confermaAl?: string | null;
    /** ID della modalità di pagamento (dallo status pratiche) */
    tipoPagamentoID?: number | null;
    /** Solo offerte al netto */
    soloNetto?: boolean;
    /** Solo offerte cancellate */
    soloCancellate?: boolean;
}

export class GetNextDocumentNumberResponse extends OkApiResponse implements IGetNextDocumentNumberResponse {
    /** Next "free" document number */
    nextDocumentNumber?: number;
    /** Document date. Today if not supplied by DocDate */
    docDate?: string;

    constructor(data?: IGetNextDocumentNumberResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nextDocumentNumber = _data["nextDocumentNumber"] !== undefined ? _data["nextDocumentNumber"] : null as any;
            this.docDate = _data["docDate"] !== undefined ? _data["docDate"] : null as any;
        }
    }

    static override fromJS(data: any): GetNextDocumentNumberResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetNextDocumentNumberResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nextDocumentNumber"] = this.nextDocumentNumber !== undefined ? this.nextDocumentNumber : null as any;
        data["docDate"] = this.docDate !== undefined ? this.docDate : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetNextDocumentNumberResponse extends IOkApiResponse {
    /** Next "free" document number */
    nextDocumentNumber?: number;
    /** Document date. Today if not supplied by DocDate */
    docDate?: string;
}

export class GetNextDocumentNumberRequest extends ApiRequest implements IGetNextDocumentNumberRequest {
    /** Document type to retrive. Document numbers are "per type" */
    documentType?: ETipoDocumento;
    /** Tour operator */
    operator?: EOperatore;
    /** Document date */
    docDate?: string | null;

    constructor(data?: IGetNextDocumentNumberRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentType = _data["documentType"] !== undefined ? _data["documentType"] : null as any;
            this.operator = _data["operator"] !== undefined ? _data["operator"] : null as any;
            this.docDate = _data["docDate"] !== undefined ? _data["docDate"] : null as any;
        }
    }

    static override fromJS(data: any): GetNextDocumentNumberRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetNextDocumentNumberRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType !== undefined ? this.documentType : null as any;
        data["operator"] = this.operator !== undefined ? this.operator : null as any;
        data["docDate"] = this.docDate !== undefined ? this.docDate : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetNextDocumentNumberRequest extends IApiRequest {
    /** Document type to retrive. Document numbers are "per type" */
    documentType?: ETipoDocumento;
    /** Tour operator */
    operator?: EOperatore;
    /** Document date */
    docDate?: string | null;
}

export enum ETipoDocumento {
    Generico = "Generico",
    NotaCredito = "NotaCredito",
    Fattura = "Fattura",
    EstrattoConto = "EstrattoConto",
    Autofattura = "Autofattura",
    RapportoContabile = "RapportoContabile",
    Offerta = "Offerta",
    Conferma = "Conferma",
    Prenotazione = "Prenotazione",
    Voucher = "Voucher",
    ProgrammaViaggio = "ProgrammaViaggio",
    PreventivoCliente = "PreventivoCliente",
    Miniguida = "Miniguida",
    Corrispondenza = "Corrispondenza",
    EstrattoContoConfermaServizi = "EstrattoContoConfermaServizi",
    NotaCreditoOrdinaria = "NotaCreditoOrdinaria",
    FatturaOrdinaria = "FatturaOrdinaria",
    RiepilogoPrenotazioni = "RiepilogoPrenotazioni",
    RiepilogoPrenotazioniAccordo = "RiepilogoPrenotazioniAccordo",
    RiepilogoPrenotazioniNU = "RiepilogoPrenotazioniNU",
    StornoAutofattura = "StornoAutofattura",
    FatturaAcquisto = "FatturaAcquisto",
    NotaCreditoAcquisto = "NotaCreditoAcquisto",
    FatturaAcquistoOrdinaria = "FatturaAcquistoOrdinaria",
    NotaCreditoAcquistoOrdinaria = "NotaCreditoAcquistoOrdinaria",
    RispostaPrenotazione = "RispostaPrenotazione",
    PrenotazioneH2H = "PrenotazioneH2H",
    DocumentiDiViaggio = "DocumentiDiViaggio",
    MultiDocumento = "MultiDocumento",
    MailPrenotazioneClienteFinale = "MailPrenotazioneClienteFinale",
    Biglietteria = "Biglietteria",
    Assicurazioni = "Assicurazioni",
    MailConfermaClienteFinale = "MailConfermaClienteFinale",
    RispostaPerAdv = "RispostaPerAdv",
    DocumentoContabile = "DocumentoContabile",
    PreventivoClienteTraducibile = "PreventivoClienteTraducibile",
    ProgrammaViaggioTraducibile = "ProgrammaViaggioTraducibile",
    DocumentoCondiviso = "DocumentoCondiviso",
    AutofatturaBis = "AutofatturaBis",
    NotaDiDebito = "NotaDiDebito",
    NotaDiDebitoOrdinaria = "NotaDiDebitoOrdinaria",
    VoucherTuristico = "VoucherTuristico",
    PreventivoClientePlus = "PreventivoClientePlus",
    ConfermaCliente = "ConfermaCliente",
    ConfermaProvvisoriaAgenzia = "ConfermaProvvisoriaAgenzia",
    EstrattoContoPenale = "EstrattoContoPenale",
    ProgrammaViaggio2022 = "ProgrammaViaggio2022",
    ProgrammaViaggio2023 = "ProgrammaViaggio2023",
    Kanban = "Kanban",
}

export class InvoiceDeleteRequest extends ApiRequest implements IInvoiceDeleteRequest {
    /** ID del documento da eliminare */
    documentoID?: number;

    constructor(data?: IInvoiceDeleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : null as any;
        }
    }

    static override fromJS(data: any): InvoiceDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDeleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IInvoiceDeleteRequest extends IApiRequest {
    /** ID del documento da eliminare */
    documentoID?: number;
}

export class InvoiceGetResponse extends OkApiResponse implements IInvoiceGetResponse {
    /** Dati, testata e righe del documento */
    listRow?: InvoicesListRow | null;

    constructor(data?: IInvoiceGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.listRow = _data["listRow"] ? InvoicesListRow.fromJS(_data["listRow"]) : null as any;
        }
    }

    static override fromJS(data: any): InvoiceGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listRow"] = this.listRow ? this.listRow.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IInvoiceGetResponse extends IOkApiResponse {
    /** Dati, testata e righe del documento */
    listRow?: InvoicesListRow | null;
}

export class InvoicesListRowBase implements IInvoicesListRowBase {
    /** ID del documento */
    id?: number;
    /** Tipo di documento */
    tipoDocumento?: ETipoDocumento;
    /** Numero del documento */
    numeroDocumento?: number;
    /** Data del documento */
    dataDocumento?: string;
    /** ID del contatto associato */
    contattoID?: number | null;
    /** Ragione sociale del contatto associato */
    contatto?: string | null;
    /** Descrizione testuale del cliente */
    cliente?: string | null;
    /** Data partenza viaggio */
    partenza?: string | null;
    /** Importo del documento */
    importo?: number;
    /** Iva totale del documento */
    totaleIva?: number;
    linguaDocumento?: ELingua;

    constructor(data?: IInvoicesListRowBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.tipoDocumento = _data["tipoDocumento"] !== undefined ? _data["tipoDocumento"] : null as any;
            this.numeroDocumento = _data["numeroDocumento"] !== undefined ? _data["numeroDocumento"] : null as any;
            this.dataDocumento = _data["dataDocumento"] !== undefined ? _data["dataDocumento"] : null as any;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.contatto = _data["contatto"] !== undefined ? _data["contatto"] : null as any;
            this.cliente = _data["cliente"] !== undefined ? _data["cliente"] : null as any;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : null as any;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : null as any;
            this.totaleIva = _data["totaleIva"] !== undefined ? _data["totaleIva"] : null as any;
            this.linguaDocumento = _data["linguaDocumento"] !== undefined ? _data["linguaDocumento"] : null as any;
        }
    }

    static fromJS(data: any): InvoicesListRowBase {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicesListRowBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["tipoDocumento"] = this.tipoDocumento !== undefined ? this.tipoDocumento : null as any;
        data["numeroDocumento"] = this.numeroDocumento !== undefined ? this.numeroDocumento : null as any;
        data["dataDocumento"] = this.dataDocumento !== undefined ? this.dataDocumento : null as any;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["contatto"] = this.contatto !== undefined ? this.contatto : null as any;
        data["cliente"] = this.cliente !== undefined ? this.cliente : null as any;
        data["partenza"] = this.partenza !== undefined ? this.partenza : null as any;
        data["importo"] = this.importo !== undefined ? this.importo : null as any;
        data["totaleIva"] = this.totaleIva !== undefined ? this.totaleIva : null as any;
        data["linguaDocumento"] = this.linguaDocumento !== undefined ? this.linguaDocumento : null as any;
        return data;
    }
}

export interface IInvoicesListRowBase {
    /** ID del documento */
    id?: number;
    /** Tipo di documento */
    tipoDocumento?: ETipoDocumento;
    /** Numero del documento */
    numeroDocumento?: number;
    /** Data del documento */
    dataDocumento?: string;
    /** ID del contatto associato */
    contattoID?: number | null;
    /** Ragione sociale del contatto associato */
    contatto?: string | null;
    /** Descrizione testuale del cliente */
    cliente?: string | null;
    /** Data partenza viaggio */
    partenza?: string | null;
    /** Importo del documento */
    importo?: number;
    /** Iva totale del documento */
    totaleIva?: number;
    linguaDocumento?: ELingua;
}

export class InvoicesListRow extends InvoicesListRowBase implements IInvoicesListRow {
    /** Entità del documento */
    documento?: DocumentoContabileTestata;
    /** Righe della fattura */
    righe?: InvoicesListRowDetail[];

    constructor(data?: IInvoicesListRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documento = _data["documento"] ? DocumentoContabileTestata.fromJS(_data["documento"]) : null as any;
            if (Array.isArray(_data["righe"])) {
                this.righe = [] as any;
                for (let item of _data["righe"])
                    this.righe!.push(InvoicesListRowDetail.fromJS(item));
            }
            else {
                this.righe = null as any;
            }
        }
    }

    static override fromJS(data: any): InvoicesListRow {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicesListRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documento"] = this.documento ? this.documento.toJSON() : null as any;
        if (Array.isArray(this.righe)) {
            data["righe"] = [];
            for (let item of this.righe)
                data["righe"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInvoicesListRow extends IInvoicesListRowBase {
    /** Entità del documento */
    documento?: DocumentoContabileTestata;
    /** Righe della fattura */
    righe?: InvoicesListRowDetail[];
}

export class DocumentoContabileTestata implements IDocumentoContabileTestata {
    documentoID?: number;
    tipoDocumentoID?: number;
    tipoDocumento?: ETipoDocumento;
    alfanum?: string | null;
    num_doc?: number | null;
    dataDocumento?: string;
    cliente?: string | null;
    indirizzo?: string | null;
    piva?: string | null;
    descrizione?: string | null;
    dataPartenza?: string | null;
    pagamentoID?: number | null;
    totale_doc?: number | null;
    stampato?: boolean;
    contabilizzato?: boolean;
    note?: string | null;
    nota_credito?: boolean;
    riferimento_id?: number | null;
    contattoID?: number | null;
    cliente_age?: boolean;
    causale?: string | null;
    codfisc?: string | null;
    resultSentMail?: string | null;
    operatore?: EOperatore;
    idsede?: number | null;
    statoSDI?: EStatoSDI | null;
    documentoParentID?: number | null;
    ragioneSociale?: string | null;
    nome?: string | null;
    cognome?: string | null;
    indirizzoFatt?: string | null;
    numeroCivico?: string | null;
    cap?: string | null;
    comune?: string | null;
    provincia?: string | null;
    nazione?: string | null;

    constructor(data?: IDocumentoContabileTestata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : null as any;
            this.tipoDocumentoID = _data["tipoDocumentoID"] !== undefined ? _data["tipoDocumentoID"] : null as any;
            this.tipoDocumento = _data["tipoDocumento"] !== undefined ? _data["tipoDocumento"] : null as any;
            this.alfanum = _data["alfanum"] !== undefined ? _data["alfanum"] : null as any;
            this.num_doc = _data["num_doc"] !== undefined ? _data["num_doc"] : null as any;
            this.dataDocumento = _data["dataDocumento"] !== undefined ? _data["dataDocumento"] : null as any;
            this.cliente = _data["cliente"] !== undefined ? _data["cliente"] : null as any;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : null as any;
            this.piva = _data["piva"] !== undefined ? _data["piva"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.dataPartenza = _data["dataPartenza"] !== undefined ? _data["dataPartenza"] : null as any;
            this.pagamentoID = _data["pagamentoID"] !== undefined ? _data["pagamentoID"] : null as any;
            this.totale_doc = _data["totale_doc"] !== undefined ? _data["totale_doc"] : null as any;
            this.stampato = _data["stampato"] !== undefined ? _data["stampato"] : null as any;
            this.contabilizzato = _data["contabilizzato"] !== undefined ? _data["contabilizzato"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.nota_credito = _data["nota_credito"] !== undefined ? _data["nota_credito"] : null as any;
            this.riferimento_id = _data["riferimento_id"] !== undefined ? _data["riferimento_id"] : null as any;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.cliente_age = _data["cliente_age"] !== undefined ? _data["cliente_age"] : null as any;
            this.causale = _data["causale"] !== undefined ? _data["causale"] : null as any;
            this.codfisc = _data["codfisc"] !== undefined ? _data["codfisc"] : null as any;
            this.resultSentMail = _data["resultSentMail"] !== undefined ? _data["resultSentMail"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.idsede = _data["idsede"] !== undefined ? _data["idsede"] : null as any;
            this.statoSDI = _data["statoSDI"] !== undefined ? _data["statoSDI"] : null as any;
            this.documentoParentID = _data["documentoParentID"] !== undefined ? _data["documentoParentID"] : null as any;
            this.ragioneSociale = _data["ragioneSociale"] !== undefined ? _data["ragioneSociale"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : null as any;
            this.indirizzoFatt = _data["indirizzoFatt"] !== undefined ? _data["indirizzoFatt"] : null as any;
            this.numeroCivico = _data["numeroCivico"] !== undefined ? _data["numeroCivico"] : null as any;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : null as any;
            this.comune = _data["comune"] !== undefined ? _data["comune"] : null as any;
            this.provincia = _data["provincia"] !== undefined ? _data["provincia"] : null as any;
            this.nazione = _data["nazione"] !== undefined ? _data["nazione"] : null as any;
        }
    }

    static fromJS(data: any): DocumentoContabileTestata {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentoContabileTestata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : null as any;
        data["tipoDocumentoID"] = this.tipoDocumentoID !== undefined ? this.tipoDocumentoID : null as any;
        data["tipoDocumento"] = this.tipoDocumento !== undefined ? this.tipoDocumento : null as any;
        data["alfanum"] = this.alfanum !== undefined ? this.alfanum : null as any;
        data["num_doc"] = this.num_doc !== undefined ? this.num_doc : null as any;
        data["dataDocumento"] = this.dataDocumento !== undefined ? this.dataDocumento : null as any;
        data["cliente"] = this.cliente !== undefined ? this.cliente : null as any;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : null as any;
        data["piva"] = this.piva !== undefined ? this.piva : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["dataPartenza"] = this.dataPartenza !== undefined ? this.dataPartenza : null as any;
        data["pagamentoID"] = this.pagamentoID !== undefined ? this.pagamentoID : null as any;
        data["totale_doc"] = this.totale_doc !== undefined ? this.totale_doc : null as any;
        data["stampato"] = this.stampato !== undefined ? this.stampato : null as any;
        data["contabilizzato"] = this.contabilizzato !== undefined ? this.contabilizzato : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["nota_credito"] = this.nota_credito !== undefined ? this.nota_credito : null as any;
        data["riferimento_id"] = this.riferimento_id !== undefined ? this.riferimento_id : null as any;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["cliente_age"] = this.cliente_age !== undefined ? this.cliente_age : null as any;
        data["causale"] = this.causale !== undefined ? this.causale : null as any;
        data["codfisc"] = this.codfisc !== undefined ? this.codfisc : null as any;
        data["resultSentMail"] = this.resultSentMail !== undefined ? this.resultSentMail : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["idsede"] = this.idsede !== undefined ? this.idsede : null as any;
        data["statoSDI"] = this.statoSDI !== undefined ? this.statoSDI : null as any;
        data["documentoParentID"] = this.documentoParentID !== undefined ? this.documentoParentID : null as any;
        data["ragioneSociale"] = this.ragioneSociale !== undefined ? this.ragioneSociale : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["cognome"] = this.cognome !== undefined ? this.cognome : null as any;
        data["indirizzoFatt"] = this.indirizzoFatt !== undefined ? this.indirizzoFatt : null as any;
        data["numeroCivico"] = this.numeroCivico !== undefined ? this.numeroCivico : null as any;
        data["cap"] = this.cap !== undefined ? this.cap : null as any;
        data["comune"] = this.comune !== undefined ? this.comune : null as any;
        data["provincia"] = this.provincia !== undefined ? this.provincia : null as any;
        data["nazione"] = this.nazione !== undefined ? this.nazione : null as any;
        return data;
    }
}

export interface IDocumentoContabileTestata {
    documentoID?: number;
    tipoDocumentoID?: number;
    tipoDocumento?: ETipoDocumento;
    alfanum?: string | null;
    num_doc?: number | null;
    dataDocumento?: string;
    cliente?: string | null;
    indirizzo?: string | null;
    piva?: string | null;
    descrizione?: string | null;
    dataPartenza?: string | null;
    pagamentoID?: number | null;
    totale_doc?: number | null;
    stampato?: boolean;
    contabilizzato?: boolean;
    note?: string | null;
    nota_credito?: boolean;
    riferimento_id?: number | null;
    contattoID?: number | null;
    cliente_age?: boolean;
    causale?: string | null;
    codfisc?: string | null;
    resultSentMail?: string | null;
    operatore?: EOperatore;
    idsede?: number | null;
    statoSDI?: EStatoSDI | null;
    documentoParentID?: number | null;
    ragioneSociale?: string | null;
    nome?: string | null;
    cognome?: string | null;
    indirizzoFatt?: string | null;
    numeroCivico?: string | null;
    cap?: string | null;
    comune?: string | null;
    provincia?: string | null;
    nazione?: string | null;
}

export enum EStatoSDI {
    Nessuno = "Nessuno",
    Pronto = "Pronto",
    Inviato = "Inviato",
    RifiutatoVAR = "RifiutatoVAR",
    Accettato = "Accettato",
    RifiutatoSDI = "RifiutatoSDI",
}

export class InvoicesListRowDetail implements IInvoicesListRowDetail {
    /** ID della riga */
    id?: number;
    /** Descrizione della riga */
    descrizione?: string | null;
    /** Importo della riga */
    importo?: number;
    /** Se true è un importo CEE */
    isCee?: boolean;
    valutaNonEuro?: boolean;
    codiceValuta?: string;
    cambioValuta?: number;
    importoValuta?: number;
    /** VAT on the row, in Euro. */
    iva?: number;
    /** Iva converted into CodiceValuta with CambioValuta. */
    ivaValuta?: number;
    /** Entità della riga */
    riga?: DocumentoContabileRiga;

    constructor(data?: IInvoicesListRowDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : null as any;
            this.isCee = _data["isCee"] !== undefined ? _data["isCee"] : null as any;
            this.valutaNonEuro = _data["valutaNonEuro"] !== undefined ? _data["valutaNonEuro"] : null as any;
            this.codiceValuta = _data["codiceValuta"] !== undefined ? _data["codiceValuta"] : null as any;
            this.cambioValuta = _data["cambioValuta"] !== undefined ? _data["cambioValuta"] : null as any;
            this.importoValuta = _data["importoValuta"] !== undefined ? _data["importoValuta"] : null as any;
            this.iva = _data["iva"] !== undefined ? _data["iva"] : null as any;
            this.ivaValuta = _data["ivaValuta"] !== undefined ? _data["ivaValuta"] : null as any;
            this.riga = _data["riga"] ? DocumentoContabileRiga.fromJS(_data["riga"]) : null as any;
        }
    }

    static fromJS(data: any): InvoicesListRowDetail {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicesListRowDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["importo"] = this.importo !== undefined ? this.importo : null as any;
        data["isCee"] = this.isCee !== undefined ? this.isCee : null as any;
        data["valutaNonEuro"] = this.valutaNonEuro !== undefined ? this.valutaNonEuro : null as any;
        data["codiceValuta"] = this.codiceValuta !== undefined ? this.codiceValuta : null as any;
        data["cambioValuta"] = this.cambioValuta !== undefined ? this.cambioValuta : null as any;
        data["importoValuta"] = this.importoValuta !== undefined ? this.importoValuta : null as any;
        data["iva"] = this.iva !== undefined ? this.iva : null as any;
        data["ivaValuta"] = this.ivaValuta !== undefined ? this.ivaValuta : null as any;
        data["riga"] = this.riga ? this.riga.toJSON() : null as any;
        return data;
    }
}

export interface IInvoicesListRowDetail {
    /** ID della riga */
    id?: number;
    /** Descrizione della riga */
    descrizione?: string | null;
    /** Importo della riga */
    importo?: number;
    /** Se true è un importo CEE */
    isCee?: boolean;
    valutaNonEuro?: boolean;
    codiceValuta?: string;
    cambioValuta?: number;
    importoValuta?: number;
    /** VAT on the row, in Euro. */
    iva?: number;
    /** Iva converted into CodiceValuta with CambioValuta. */
    ivaValuta?: number;
    /** Entità della riga */
    riga?: DocumentoContabileRiga;
}

export class DocumentoContabileRiga implements IDocumentoContabileRiga {
    idriga?: number;
    idsede?: number;
    iddocumento?: number;
    idoffagenzia?: number | null;
    descrizione?: string | null;
    importo?: number | null;
    iva?: number | null;
    codiva?: string | null;
    natura?: NaturaType | null;

    constructor(data?: IDocumentoContabileRiga) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idriga = _data["idriga"] !== undefined ? _data["idriga"] : null as any;
            this.idsede = _data["idsede"] !== undefined ? _data["idsede"] : null as any;
            this.iddocumento = _data["iddocumento"] !== undefined ? _data["iddocumento"] : null as any;
            this.idoffagenzia = _data["idoffagenzia"] !== undefined ? _data["idoffagenzia"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : null as any;
            this.iva = _data["iva"] !== undefined ? _data["iva"] : null as any;
            this.codiva = _data["codiva"] !== undefined ? _data["codiva"] : null as any;
            this.natura = _data["natura"] !== undefined ? _data["natura"] : null as any;
        }
    }

    static fromJS(data: any): DocumentoContabileRiga {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentoContabileRiga();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idriga"] = this.idriga !== undefined ? this.idriga : null as any;
        data["idsede"] = this.idsede !== undefined ? this.idsede : null as any;
        data["iddocumento"] = this.iddocumento !== undefined ? this.iddocumento : null as any;
        data["idoffagenzia"] = this.idoffagenzia !== undefined ? this.idoffagenzia : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["importo"] = this.importo !== undefined ? this.importo : null as any;
        data["iva"] = this.iva !== undefined ? this.iva : null as any;
        data["codiva"] = this.codiva !== undefined ? this.codiva : null as any;
        data["natura"] = this.natura !== undefined ? this.natura : null as any;
        return data;
    }
}

export interface IDocumentoContabileRiga {
    idriga?: number;
    idsede?: number;
    iddocumento?: number;
    idoffagenzia?: number | null;
    descrizione?: string | null;
    importo?: number | null;
    iva?: number | null;
    codiva?: string | null;
    natura?: NaturaType | null;
}

export enum NaturaType {
    N1 = "N1",
    N2 = "N2",
    N3 = "N3",
    N4 = "N4",
    N5 = "N5",
    N6 = "N6",
    N7 = "N7",
}

export class InvoiceGetRequest extends ApiRequest implements IInvoiceGetRequest {
    /** ID del documento da richiedere */
    documentoID?: number;

    constructor(data?: IInvoiceGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : null as any;
        }
    }

    static override fromJS(data: any): InvoiceGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IInvoiceGetRequest extends IApiRequest {
    /** ID del documento da richiedere */
    documentoID?: number;
}

export class InvoicesCreateResponse extends OkApiResponse implements IInvoicesCreateResponse {
    docs?: InvoicesListRow[] | null;

    constructor(data?: IInvoicesCreateResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["docs"])) {
                this.docs = [] as any;
                for (let item of _data["docs"])
                    this.docs!.push(InvoicesListRow.fromJS(item));
            }
            else {
                this.docs = null as any;
            }
        }
    }

    static override fromJS(data: any): InvoicesCreateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicesCreateResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.docs)) {
            data["docs"] = [];
            for (let item of this.docs)
                data["docs"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInvoicesCreateResponse extends IOkApiResponse {
    docs?: InvoicesListRow[] | null;
}

export class InvoicesCreateRequest extends ApiRequest implements IInvoicesCreateRequest {
    tipoDocumento?: ETipoDocumento;
    dataEmissione?: string;
    offerte?: DatiDocumentoContabile[] | null;

    constructor(data?: IInvoicesCreateRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tipoDocumento = _data["tipoDocumento"] !== undefined ? _data["tipoDocumento"] : null as any;
            this.dataEmissione = _data["dataEmissione"] !== undefined ? _data["dataEmissione"] : null as any;
            if (Array.isArray(_data["offerte"])) {
                this.offerte = [] as any;
                for (let item of _data["offerte"])
                    this.offerte!.push(DatiDocumentoContabile.fromJS(item));
            }
            else {
                this.offerte = null as any;
            }
        }
    }

    static override fromJS(data: any): InvoicesCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicesCreateRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoDocumento"] = this.tipoDocumento !== undefined ? this.tipoDocumento : null as any;
        data["dataEmissione"] = this.dataEmissione !== undefined ? this.dataEmissione : null as any;
        if (Array.isArray(this.offerte)) {
            data["offerte"] = [];
            for (let item of this.offerte)
                data["offerte"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInvoicesCreateRequest extends IApiRequest {
    tipoDocumento?: ETipoDocumento;
    dataEmissione?: string;
    offerte?: DatiDocumentoContabile[] | null;
}

export class DatiDocumentoContabile implements IDatiDocumentoContabile {
    offertaID?: number;
    contattoAgenziaID?: number;
    offertaAgenziaID?: number;
    alNetto?: boolean;

    constructor(data?: IDatiDocumentoContabile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.contattoAgenziaID = _data["contattoAgenziaID"] !== undefined ? _data["contattoAgenziaID"] : null as any;
            this.offertaAgenziaID = _data["offertaAgenziaID"] !== undefined ? _data["offertaAgenziaID"] : null as any;
            this.alNetto = _data["alNetto"] !== undefined ? _data["alNetto"] : null as any;
        }
    }

    static fromJS(data: any): DatiDocumentoContabile {
        data = typeof data === 'object' ? data : {};
        let result = new DatiDocumentoContabile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["contattoAgenziaID"] = this.contattoAgenziaID !== undefined ? this.contattoAgenziaID : null as any;
        data["offertaAgenziaID"] = this.offertaAgenziaID !== undefined ? this.offertaAgenziaID : null as any;
        data["alNetto"] = this.alNetto !== undefined ? this.alNetto : null as any;
        return data;
    }
}

export interface IDatiDocumentoContabile {
    offertaID?: number;
    contattoAgenziaID?: number;
    offertaAgenziaID?: number;
    alNetto?: boolean;
}

export class NrTableResponseOfInvoicesListRow extends OkApiResponse implements INrTableResponseOfInvoicesListRow {
    /** Array delle righe della pagina richiesta */
    rows?: InvoicesListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfInvoicesListRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(InvoicesListRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfInvoicesListRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfInvoicesListRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfInvoicesListRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: InvoicesListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class InvoicesListResponse extends NrTableResponseOfInvoicesListRow implements IInvoicesListResponse {

    constructor(data?: IInvoicesListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): InvoicesListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicesListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IInvoicesListResponse extends INrTableResponseOfInvoicesListRow {
}

export class InvoicesListRequest extends NrTableRequest implements IInvoicesListRequest {
    /** ID del contatto (agenzia) */
    contattoID?: number | null;
    /** Operatore del documento */
    operatore?: EOperatore | null;
    /** Partita IVA associata al documento */
    partitaIVA?: string | null;
    /** Inizio range data del documento */
    dataDocumentoFrom?: string | null;
    /** Fine range data del documento */
    dataDocumentoTo?: string | null;
    /** Intestazione (come testo) */
    intestazione?: string | null;
    /** Tipo di documento */
    tipoDocumento?: ETipoDocumento | null;
    /** ID del tipo di pagamento */
    tipoPagamentoID?: number | null;
    /** Numero di documento */
    numeroDocumento?: number | null;
    /** Anno di emissione del documento */
    annoDocumento?: number | null;
    /** Trip id */
    tripId?: number | null;

    constructor(data?: IInvoicesListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.partitaIVA = _data["partitaIVA"] !== undefined ? _data["partitaIVA"] : null as any;
            this.dataDocumentoFrom = _data["dataDocumentoFrom"] !== undefined ? _data["dataDocumentoFrom"] : null as any;
            this.dataDocumentoTo = _data["dataDocumentoTo"] !== undefined ? _data["dataDocumentoTo"] : null as any;
            this.intestazione = _data["intestazione"] !== undefined ? _data["intestazione"] : null as any;
            this.tipoDocumento = _data["tipoDocumento"] !== undefined ? _data["tipoDocumento"] : null as any;
            this.tipoPagamentoID = _data["tipoPagamentoID"] !== undefined ? _data["tipoPagamentoID"] : null as any;
            this.numeroDocumento = _data["numeroDocumento"] !== undefined ? _data["numeroDocumento"] : null as any;
            this.annoDocumento = _data["annoDocumento"] !== undefined ? _data["annoDocumento"] : null as any;
            this.tripId = _data["tripId"] !== undefined ? _data["tripId"] : null as any;
        }
    }

    static override fromJS(data: any): InvoicesListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicesListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["partitaIVA"] = this.partitaIVA !== undefined ? this.partitaIVA : null as any;
        data["dataDocumentoFrom"] = this.dataDocumentoFrom !== undefined ? this.dataDocumentoFrom : null as any;
        data["dataDocumentoTo"] = this.dataDocumentoTo !== undefined ? this.dataDocumentoTo : null as any;
        data["intestazione"] = this.intestazione !== undefined ? this.intestazione : null as any;
        data["tipoDocumento"] = this.tipoDocumento !== undefined ? this.tipoDocumento : null as any;
        data["tipoPagamentoID"] = this.tipoPagamentoID !== undefined ? this.tipoPagamentoID : null as any;
        data["numeroDocumento"] = this.numeroDocumento !== undefined ? this.numeroDocumento : null as any;
        data["annoDocumento"] = this.annoDocumento !== undefined ? this.annoDocumento : null as any;
        data["tripId"] = this.tripId !== undefined ? this.tripId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IInvoicesListRequest extends INrTableRequest {
    /** ID del contatto (agenzia) */
    contattoID?: number | null;
    /** Operatore del documento */
    operatore?: EOperatore | null;
    /** Partita IVA associata al documento */
    partitaIVA?: string | null;
    /** Inizio range data del documento */
    dataDocumentoFrom?: string | null;
    /** Fine range data del documento */
    dataDocumentoTo?: string | null;
    /** Intestazione (come testo) */
    intestazione?: string | null;
    /** Tipo di documento */
    tipoDocumento?: ETipoDocumento | null;
    /** ID del tipo di pagamento */
    tipoPagamentoID?: number | null;
    /** Numero di documento */
    numeroDocumento?: number | null;
    /** Anno di emissione del documento */
    annoDocumento?: number | null;
    /** Trip id */
    tripId?: number | null;
}

export class InvoiceUpsertResponse extends OkApiResponse implements IInvoiceUpsertResponse {
    /** Documento creato o aggiornato */
    documento?: DocumentoContabileTestata;
    /** Righe create o aggiornate */
    righe?: DocumentoContabileRiga[] | null;

    constructor(data?: IInvoiceUpsertResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documento = _data["documento"] ? DocumentoContabileTestata.fromJS(_data["documento"]) : null as any;
            if (Array.isArray(_data["righe"])) {
                this.righe = [] as any;
                for (let item of _data["righe"])
                    this.righe!.push(DocumentoContabileRiga.fromJS(item));
            }
            else {
                this.righe = null as any;
            }
        }
    }

    static override fromJS(data: any): InvoiceUpsertResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceUpsertResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documento"] = this.documento ? this.documento.toJSON() : null as any;
        if (Array.isArray(this.righe)) {
            data["righe"] = [];
            for (let item of this.righe)
                data["righe"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInvoiceUpsertResponse extends IOkApiResponse {
    /** Documento creato o aggiornato */
    documento?: DocumentoContabileTestata;
    /** Righe create o aggiornate */
    righe?: DocumentoContabileRiga[] | null;
}

export class InvoiceUpsertRequest extends ApiRequest implements IInvoiceUpsertRequest {
    /** Testata del documento */
    documento!: DocumentoContabileTestata;
    /** Righe del documento. Se mancanti in un update le righe restano invariate */
    righe?: DocumentoContabileRiga[] | null;

    constructor(data?: IInvoiceUpsertRequest) {
        super(data);
        if (!data) {
            this.documento = new DocumentoContabileTestata();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documento = _data["documento"] ? DocumentoContabileTestata.fromJS(_data["documento"]) : new DocumentoContabileTestata();
            if (Array.isArray(_data["righe"])) {
                this.righe = [] as any;
                for (let item of _data["righe"])
                    this.righe!.push(DocumentoContabileRiga.fromJS(item));
            }
            else {
                this.righe = null as any;
            }
        }
    }

    static override fromJS(data: any): InvoiceUpsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceUpsertRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documento"] = this.documento ? this.documento.toJSON() : null as any;
        if (Array.isArray(this.righe)) {
            data["righe"] = [];
            for (let item of this.righe)
                data["righe"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInvoiceUpsertRequest extends IApiRequest {
    /** Testata del documento */
    documento: DocumentoContabileTestata;
    /** Righe del documento. Se mancanti in un update le righe restano invariate */
    righe?: DocumentoContabileRiga[] | null;
}

export class PaymentDeleteRequest extends ApiRequest implements IPaymentDeleteRequest {
    /** ID del pagamento da eliminare */
    pagamentoID?: number;

    constructor(data?: IPaymentDeleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pagamentoID = _data["pagamentoID"] !== undefined ? _data["pagamentoID"] : null as any;
        }
    }

    static override fromJS(data: any): PaymentDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentDeleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pagamentoID"] = this.pagamentoID !== undefined ? this.pagamentoID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPaymentDeleteRequest extends IApiRequest {
    /** ID del pagamento da eliminare */
    pagamentoID?: number;
}

export class PaymentGetResponse extends OkApiResponse implements IPaymentGetResponse {
    /** Entità del pagamenti */
    pagamento?: Pagamento;
    /** Codice della valuta del pagamento */
    valuta?: string | null;
    /** Nome del contatto */
    contatto?: string | null;
    /** Nome della banca */
    banca?: string | null;
    /** Offerte associate al pagamento, ordinate per partenza e ID */
    offerte?: PaymentTripRow[] | null;
    /** Totale dei "Pagare" delle offerte */
    totalePagare?: number;

    constructor(data?: IPaymentGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pagamento = _data["pagamento"] ? Pagamento.fromJS(_data["pagamento"]) : null as any;
            this.valuta = _data["valuta"] !== undefined ? _data["valuta"] : null as any;
            this.contatto = _data["contatto"] !== undefined ? _data["contatto"] : null as any;
            this.banca = _data["banca"] !== undefined ? _data["banca"] : null as any;
            if (Array.isArray(_data["offerte"])) {
                this.offerte = [] as any;
                for (let item of _data["offerte"])
                    this.offerte!.push(PaymentTripRow.fromJS(item));
            }
            else {
                this.offerte = null as any;
            }
            this.totalePagare = _data["totalePagare"] !== undefined ? _data["totalePagare"] : null as any;
        }
    }

    static override fromJS(data: any): PaymentGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pagamento"] = this.pagamento ? this.pagamento.toJSON() : null as any;
        data["valuta"] = this.valuta !== undefined ? this.valuta : null as any;
        data["contatto"] = this.contatto !== undefined ? this.contatto : null as any;
        data["banca"] = this.banca !== undefined ? this.banca : null as any;
        if (Array.isArray(this.offerte)) {
            data["offerte"] = [];
            for (let item of this.offerte)
                data["offerte"].push(item ? item.toJSON() : null as any);
        }
        data["totalePagare"] = this.totalePagare !== undefined ? this.totalePagare : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPaymentGetResponse extends IOkApiResponse {
    /** Entità del pagamenti */
    pagamento?: Pagamento;
    /** Codice della valuta del pagamento */
    valuta?: string | null;
    /** Nome del contatto */
    contatto?: string | null;
    /** Nome della banca */
    banca?: string | null;
    /** Offerte associate al pagamento, ordinate per partenza e ID */
    offerte?: PaymentTripRow[] | null;
    /** Totale dei "Pagare" delle offerte */
    totalePagare?: number;
}

export class Pagamento implements IPagamento {
    id?: number;
    contattoID?: number;
    offertaID?: number | null;
    data?: string | null;
    commissioniBancarie?: number | null;
    valutaID?: number;
    cambio?: number | null;
    tipoOperazioneID?: number | null;
    navBanca?: string | null;
    navCausale?: string | null;
    operatoreID?: EOperatore | null;
    note?: string | null;
    datiBancaFor?: string | null;
    importo?: number | null;

    constructor(data?: IPagamento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
            this.commissioniBancarie = _data["commissioniBancarie"] !== undefined ? _data["commissioniBancarie"] : null as any;
            this.valutaID = _data["valutaID"] !== undefined ? _data["valutaID"] : null as any;
            this.cambio = _data["cambio"] !== undefined ? _data["cambio"] : null as any;
            this.tipoOperazioneID = _data["tipoOperazioneID"] !== undefined ? _data["tipoOperazioneID"] : null as any;
            this.navBanca = _data["navBanca"] !== undefined ? _data["navBanca"] : null as any;
            this.navCausale = _data["navCausale"] !== undefined ? _data["navCausale"] : null as any;
            this.operatoreID = _data["operatoreID"] !== undefined ? _data["operatoreID"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.datiBancaFor = _data["datiBancaFor"] !== undefined ? _data["datiBancaFor"] : null as any;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : null as any;
        }
    }

    static fromJS(data: any): Pagamento {
        data = typeof data === 'object' ? data : {};
        let result = new Pagamento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["commissioniBancarie"] = this.commissioniBancarie !== undefined ? this.commissioniBancarie : null as any;
        data["valutaID"] = this.valutaID !== undefined ? this.valutaID : null as any;
        data["cambio"] = this.cambio !== undefined ? this.cambio : null as any;
        data["tipoOperazioneID"] = this.tipoOperazioneID !== undefined ? this.tipoOperazioneID : null as any;
        data["navBanca"] = this.navBanca !== undefined ? this.navBanca : null as any;
        data["navCausale"] = this.navCausale !== undefined ? this.navCausale : null as any;
        data["operatoreID"] = this.operatoreID !== undefined ? this.operatoreID : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["datiBancaFor"] = this.datiBancaFor !== undefined ? this.datiBancaFor : null as any;
        data["importo"] = this.importo !== undefined ? this.importo : null as any;
        return data;
    }
}

export interface IPagamento {
    id?: number;
    contattoID?: number;
    offertaID?: number | null;
    data?: string | null;
    commissioniBancarie?: number | null;
    valutaID?: number;
    cambio?: number | null;
    tipoOperazioneID?: number | null;
    navBanca?: string | null;
    navCausale?: string | null;
    operatoreID?: EOperatore | null;
    note?: string | null;
    datiBancaFor?: string | null;
    importo?: number | null;
}

export class PaymentTripRow implements IPaymentTripRow {
    /** ID dell'offerta */
    offertaID?: number;
    /** Operatore dell'offerta */
    operatore?: EOperatore;
    /** Data di partenza */
    partenza?: string;
    /** Data di conferma */
    conferma?: string | null;
    /** Se true c'è cancellazione conferma */
    cancellataADV?: boolean;
    /** Se true è cancellata TO */
    cancellataTO?: boolean;
    /** Importo da pagare in valuta */
    pagare?: number;
    /** Tipo di contabilizzazione */
    contabilizzazione?: EContabilizzazione | null;
    /** Nomi abbreviati dei clienti */
    clienti?: string;
    /** Nome dell'utente di conferma */
    utenteConferma?: string | null;
    /** Indirizzo email dell'utente di conferma */
    emailUtenteConferma?: string | null;
    /** Codice booking se presente */
    bookingRef?: string | null;

    constructor(data?: IPaymentTripRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : null as any;
            this.conferma = _data["conferma"] !== undefined ? _data["conferma"] : null as any;
            this.cancellataADV = _data["cancellataADV"] !== undefined ? _data["cancellataADV"] : null as any;
            this.cancellataTO = _data["cancellataTO"] !== undefined ? _data["cancellataTO"] : null as any;
            this.pagare = _data["pagare"] !== undefined ? _data["pagare"] : null as any;
            this.contabilizzazione = _data["contabilizzazione"] !== undefined ? _data["contabilizzazione"] : null as any;
            this.clienti = _data["clienti"] !== undefined ? _data["clienti"] : null as any;
            this.utenteConferma = _data["utenteConferma"] !== undefined ? _data["utenteConferma"] : null as any;
            this.emailUtenteConferma = _data["emailUtenteConferma"] !== undefined ? _data["emailUtenteConferma"] : null as any;
            this.bookingRef = _data["bookingRef"] !== undefined ? _data["bookingRef"] : null as any;
        }
    }

    static fromJS(data: any): PaymentTripRow {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTripRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["partenza"] = this.partenza !== undefined ? this.partenza : null as any;
        data["conferma"] = this.conferma !== undefined ? this.conferma : null as any;
        data["cancellataADV"] = this.cancellataADV !== undefined ? this.cancellataADV : null as any;
        data["cancellataTO"] = this.cancellataTO !== undefined ? this.cancellataTO : null as any;
        data["pagare"] = this.pagare !== undefined ? this.pagare : null as any;
        data["contabilizzazione"] = this.contabilizzazione !== undefined ? this.contabilizzazione : null as any;
        data["clienti"] = this.clienti !== undefined ? this.clienti : null as any;
        data["utenteConferma"] = this.utenteConferma !== undefined ? this.utenteConferma : null as any;
        data["emailUtenteConferma"] = this.emailUtenteConferma !== undefined ? this.emailUtenteConferma : null as any;
        data["bookingRef"] = this.bookingRef !== undefined ? this.bookingRef : null as any;
        return data;
    }
}

export interface IPaymentTripRow {
    /** ID dell'offerta */
    offertaID?: number;
    /** Operatore dell'offerta */
    operatore?: EOperatore;
    /** Data di partenza */
    partenza?: string;
    /** Data di conferma */
    conferma?: string | null;
    /** Se true c'è cancellazione conferma */
    cancellataADV?: boolean;
    /** Se true è cancellata TO */
    cancellataTO?: boolean;
    /** Importo da pagare in valuta */
    pagare?: number;
    /** Tipo di contabilizzazione */
    contabilizzazione?: EContabilizzazione | null;
    /** Nomi abbreviati dei clienti */
    clienti?: string;
    /** Nome dell'utente di conferma */
    utenteConferma?: string | null;
    /** Indirizzo email dell'utente di conferma */
    emailUtenteConferma?: string | null;
    /** Codice booking se presente */
    bookingRef?: string | null;
}

export class PaymentGetRequest extends LocalizedRequest implements IPaymentGetRequest {
    /** ID del pagamento da caricare */
    pagamentoID?: number;
    /** Se true include le righe di pagamento sulle offerte */
    includiRighe?: boolean;

    constructor(data?: IPaymentGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pagamentoID = _data["pagamentoID"] !== undefined ? _data["pagamentoID"] : null as any;
            this.includiRighe = _data["includiRighe"] !== undefined ? _data["includiRighe"] : null as any;
        }
    }

    static override fromJS(data: any): PaymentGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pagamentoID"] = this.pagamentoID !== undefined ? this.pagamentoID : null as any;
        data["includiRighe"] = this.includiRighe !== undefined ? this.includiRighe : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPaymentGetRequest extends ILocalizedRequest {
    /** ID del pagamento da caricare */
    pagamentoID?: number;
    /** Se true include le righe di pagamento sulle offerte */
    includiRighe?: boolean;
}

export class PaymentsAssignRequest extends ApiRequest implements IPaymentsAssignRequest {
    /** Lista dei pagamenti da impostare */
    pagamenti!: ServicePayment[];

    constructor(data?: IPaymentsAssignRequest) {
        super(data);
        if (!data) {
            this.pagamenti = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["pagamenti"])) {
                this.pagamenti = [] as any;
                for (let item of _data["pagamenti"])
                    this.pagamenti!.push(ServicePayment.fromJS(item));
            }
            else {
                this.pagamenti = null as any;
            }
        }
    }

    static override fromJS(data: any): PaymentsAssignRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentsAssignRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pagamenti)) {
            data["pagamenti"] = [];
            for (let item of this.pagamenti)
                data["pagamenti"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaymentsAssignRequest extends IApiRequest {
    /** Lista dei pagamenti da impostare */
    pagamenti: ServicePayment[];
}

export class ServicePayment implements IServicePayment {
    offertaID?: number;
    offertaDatoID?: number;
    pagamentoID?: number | null;
    importo?: number;

    constructor(data?: IServicePayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : null as any;
            this.pagamentoID = _data["pagamentoID"] !== undefined ? _data["pagamentoID"] : null as any;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : null as any;
        }
    }

    static fromJS(data: any): ServicePayment {
        data = typeof data === 'object' ? data : {};
        let result = new ServicePayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : null as any;
        data["pagamentoID"] = this.pagamentoID !== undefined ? this.pagamentoID : null as any;
        data["importo"] = this.importo !== undefined ? this.importo : null as any;
        return data;
    }
}

export interface IServicePayment {
    offertaID?: number;
    offertaDatoID?: number;
    pagamentoID?: number | null;
    importo?: number;
}

export class NrTableResponseOfPaymentRow extends OkApiResponse implements INrTableResponseOfPaymentRow {
    /** Array delle righe della pagina richiesta */
    rows?: PaymentRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfPaymentRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(PaymentRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfPaymentRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfPaymentRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfPaymentRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: PaymentRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class GetPaymentsListResponse extends NrTableResponseOfPaymentRow implements IGetPaymentsListResponse {
    /** Totali divisi per moneta */
    currenciesTotals?: PaymentCurrencyTotal[];
    /** Totale Euro */
    euroTotal?: number;

    constructor(data?: IGetPaymentsListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["currenciesTotals"])) {
                this.currenciesTotals = [] as any;
                for (let item of _data["currenciesTotals"])
                    this.currenciesTotals!.push(PaymentCurrencyTotal.fromJS(item));
            }
            else {
                this.currenciesTotals = null as any;
            }
            this.euroTotal = _data["euroTotal"] !== undefined ? _data["euroTotal"] : null as any;
        }
    }

    static override fromJS(data: any): GetPaymentsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentsListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.currenciesTotals)) {
            data["currenciesTotals"] = [];
            for (let item of this.currenciesTotals)
                data["currenciesTotals"].push(item ? item.toJSON() : null as any);
        }
        data["euroTotal"] = this.euroTotal !== undefined ? this.euroTotal : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPaymentsListResponse extends INrTableResponseOfPaymentRow {
    /** Totali divisi per moneta */
    currenciesTotals?: PaymentCurrencyTotal[];
    /** Totale Euro */
    euroTotal?: number;
}

export class PaymentCurrencyTotal implements IPaymentCurrencyTotal {
    /** Codice della valuta */
    codiceValuta?: string | null;
    /** Importo totale in valuta */
    importoValuta?: number;
    /** Importo totale in Euro */
    importoEuro?: number;
    /** Totale dei "Pagato" in riga delle offerte */
    importoCosti?: number;

    constructor(data?: IPaymentCurrencyTotal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codiceValuta = _data["codiceValuta"] !== undefined ? _data["codiceValuta"] : null as any;
            this.importoValuta = _data["importoValuta"] !== undefined ? _data["importoValuta"] : null as any;
            this.importoEuro = _data["importoEuro"] !== undefined ? _data["importoEuro"] : null as any;
            this.importoCosti = _data["importoCosti"] !== undefined ? _data["importoCosti"] : null as any;
        }
    }

    static fromJS(data: any): PaymentCurrencyTotal {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentCurrencyTotal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codiceValuta"] = this.codiceValuta !== undefined ? this.codiceValuta : null as any;
        data["importoValuta"] = this.importoValuta !== undefined ? this.importoValuta : null as any;
        data["importoEuro"] = this.importoEuro !== undefined ? this.importoEuro : null as any;
        data["importoCosti"] = this.importoCosti !== undefined ? this.importoCosti : null as any;
        return data;
    }
}

export interface IPaymentCurrencyTotal {
    /** Codice della valuta */
    codiceValuta?: string | null;
    /** Importo totale in valuta */
    importoValuta?: number;
    /** Importo totale in Euro */
    importoEuro?: number;
    /** Totale dei "Pagato" in riga delle offerte */
    importoCosti?: number;
}

/** Vista dell'export Excel */
export class PaymentExportRow implements IPaymentExportRow {
    /** ID del pagamento */
    id?: number;
    /** Operatore del pagamento */
    operatore?: EOperatore | null;
    /** ID del contatto fornitore */
    contattoID?: number | null;
    /** Nome / Ragione sociale del fornitore */
    contattoFornitore?: string | null;
    /** Data di effettuazione del pagamento */
    dataEffettuazione?: string | null;
    /** Codice 3 lettere della valuta */
    codiceValuta?: string | null;
    /** Cambio della valuta al momento del pagamento */
    cambioValuta?: number | null;
    /** ID della banca d'appoggio */
    bancaID?: number | null;
    /** Nome della banca */
    banca?: string | null;
    /** Importo in valuta del pagamento */
    importoValuta?: number | null;
    /** Importo in Euro */
    importoEuro?: number | null;
    /** Totale dei "Pagato" in riga delle offerte */
    totaleCosti?: number | null;

    constructor(data?: IPaymentExportRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.contattoFornitore = _data["contattoFornitore"] !== undefined ? _data["contattoFornitore"] : null as any;
            this.dataEffettuazione = _data["dataEffettuazione"] !== undefined ? _data["dataEffettuazione"] : null as any;
            this.codiceValuta = _data["codiceValuta"] !== undefined ? _data["codiceValuta"] : null as any;
            this.cambioValuta = _data["cambioValuta"] !== undefined ? _data["cambioValuta"] : null as any;
            this.bancaID = _data["bancaID"] !== undefined ? _data["bancaID"] : null as any;
            this.banca = _data["banca"] !== undefined ? _data["banca"] : null as any;
            this.importoValuta = _data["importoValuta"] !== undefined ? _data["importoValuta"] : null as any;
            this.importoEuro = _data["importoEuro"] !== undefined ? _data["importoEuro"] : null as any;
            this.totaleCosti = _data["totaleCosti"] !== undefined ? _data["totaleCosti"] : null as any;
        }
    }

    static fromJS(data: any): PaymentExportRow {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentExportRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["contattoFornitore"] = this.contattoFornitore !== undefined ? this.contattoFornitore : null as any;
        data["dataEffettuazione"] = this.dataEffettuazione !== undefined ? this.dataEffettuazione : null as any;
        data["codiceValuta"] = this.codiceValuta !== undefined ? this.codiceValuta : null as any;
        data["cambioValuta"] = this.cambioValuta !== undefined ? this.cambioValuta : null as any;
        data["bancaID"] = this.bancaID !== undefined ? this.bancaID : null as any;
        data["banca"] = this.banca !== undefined ? this.banca : null as any;
        data["importoValuta"] = this.importoValuta !== undefined ? this.importoValuta : null as any;
        data["importoEuro"] = this.importoEuro !== undefined ? this.importoEuro : null as any;
        data["totaleCosti"] = this.totaleCosti !== undefined ? this.totaleCosti : null as any;
        return data;
    }
}

/** Vista dell'export Excel */
export interface IPaymentExportRow {
    /** ID del pagamento */
    id?: number;
    /** Operatore del pagamento */
    operatore?: EOperatore | null;
    /** ID del contatto fornitore */
    contattoID?: number | null;
    /** Nome / Ragione sociale del fornitore */
    contattoFornitore?: string | null;
    /** Data di effettuazione del pagamento */
    dataEffettuazione?: string | null;
    /** Codice 3 lettere della valuta */
    codiceValuta?: string | null;
    /** Cambio della valuta al momento del pagamento */
    cambioValuta?: number | null;
    /** ID della banca d'appoggio */
    bancaID?: number | null;
    /** Nome della banca */
    banca?: string | null;
    /** Importo in valuta del pagamento */
    importoValuta?: number | null;
    /** Importo in Euro */
    importoEuro?: number | null;
    /** Totale dei "Pagato" in riga delle offerte */
    totaleCosti?: number | null;
}

/** View della singola riga di pagamento (Export + ID vari) */
export class PaymentRow extends PaymentExportRow implements IPaymentRow {
    /** ID del contatto fornitore */
    contattoFornitoreID?: number;
    /** ID della valuta */
    valutaID?: number;
    /** Entità del pagamento */
    pagamento?: Pagamento;

    constructor(data?: IPaymentRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoFornitoreID = _data["contattoFornitoreID"] !== undefined ? _data["contattoFornitoreID"] : null as any;
            this.valutaID = _data["valutaID"] !== undefined ? _data["valutaID"] : null as any;
            this.pagamento = _data["pagamento"] ? Pagamento.fromJS(_data["pagamento"]) : null as any;
        }
    }

    static override fromJS(data: any): PaymentRow {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoFornitoreID"] = this.contattoFornitoreID !== undefined ? this.contattoFornitoreID : null as any;
        data["valutaID"] = this.valutaID !== undefined ? this.valutaID : null as any;
        data["pagamento"] = this.pagamento ? this.pagamento.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

/** View della singola riga di pagamento (Export + ID vari) */
export interface IPaymentRow extends IPaymentExportRow {
    /** ID del contatto fornitore */
    contattoFornitoreID?: number;
    /** ID della valuta */
    valutaID?: number;
    /** Entità del pagamento */
    pagamento?: Pagamento;
}

export class GetPaymentsListRequest extends NrTableRequest implements IGetPaymentsListRequest {
    /** Filtro per operatore */
    operatore?: EOperatore | null;
    /** ID del contatto fornitore associato al pagamento */
    contattoFornitoreID?: number | null;
    /** ID offerta singola */
    offertaID?: number | null;
    /** Pagamento singolo */
    pagamentoID?: number | null;
    /** ID della banca */
    bancaID?: number | null;
    /** Data iniziale */
    dataDal?: string | null;
    /** Data finale */
    dataAl?: string | null;

    constructor(data?: IGetPaymentsListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.contattoFornitoreID = _data["contattoFornitoreID"] !== undefined ? _data["contattoFornitoreID"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.pagamentoID = _data["pagamentoID"] !== undefined ? _data["pagamentoID"] : null as any;
            this.bancaID = _data["bancaID"] !== undefined ? _data["bancaID"] : null as any;
            this.dataDal = _data["dataDal"] !== undefined ? _data["dataDal"] : null as any;
            this.dataAl = _data["dataAl"] !== undefined ? _data["dataAl"] : null as any;
        }
    }

    static override fromJS(data: any): GetPaymentsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentsListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["contattoFornitoreID"] = this.contattoFornitoreID !== undefined ? this.contattoFornitoreID : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["pagamentoID"] = this.pagamentoID !== undefined ? this.pagamentoID : null as any;
        data["bancaID"] = this.bancaID !== undefined ? this.bancaID : null as any;
        data["dataDal"] = this.dataDal !== undefined ? this.dataDal : null as any;
        data["dataAl"] = this.dataAl !== undefined ? this.dataAl : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPaymentsListRequest extends INrTableRequest {
    /** Filtro per operatore */
    operatore?: EOperatore | null;
    /** ID del contatto fornitore associato al pagamento */
    contattoFornitoreID?: number | null;
    /** ID offerta singola */
    offertaID?: number | null;
    /** Pagamento singolo */
    pagamentoID?: number | null;
    /** ID della banca */
    bancaID?: number | null;
    /** Data iniziale */
    dataDal?: string | null;
    /** Data finale */
    dataAl?: string | null;
}

export class PaymentUpsertResponse extends OkApiResponse implements IPaymentUpsertResponse {
    /** Entità del pagamento dopo il salvataggio */
    pagamento?: Pagamento;

    constructor(data?: IPaymentUpsertResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pagamento = _data["pagamento"] ? Pagamento.fromJS(_data["pagamento"]) : null as any;
        }
    }

    static override fromJS(data: any): PaymentUpsertResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentUpsertResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pagamento"] = this.pagamento ? this.pagamento.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPaymentUpsertResponse extends IOkApiResponse {
    /** Entità del pagamento dopo il salvataggio */
    pagamento?: Pagamento;
}

export class PaymentUpsertRequest extends ApiRequest implements IPaymentUpsertRequest {
    /** Entità del pagamento */
    pagamento!: Pagamento;

    constructor(data?: IPaymentUpsertRequest) {
        super(data);
        if (!data) {
            this.pagamento = new Pagamento();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pagamento = _data["pagamento"] ? Pagamento.fromJS(_data["pagamento"]) : new Pagamento();
        }
    }

    static override fromJS(data: any): PaymentUpsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentUpsertRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pagamento"] = this.pagamento ? this.pagamento.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPaymentUpsertRequest extends IApiRequest {
    /** Entità del pagamento */
    pagamento: Pagamento;
}

export class ServicesToPayListResponse extends OkApiResponse implements IServicesToPayListResponse {
    /** Lista dei servizi da pagare */
    rows?: ServiceToPayRow[];

    constructor(data?: IServicesToPayListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ServiceToPayRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
        }
    }

    static override fromJS(data: any): ServicesToPayListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ServicesToPayListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IServicesToPayListResponse extends IOkApiResponse {
    /** Lista dei servizi da pagare */
    rows?: ServiceToPayRow[];
}

export class ServiceToPayExportRow implements IServiceToPayExportRow {
    /** ID dell'offerta */
    offertaID?: number;
    /** Operatore dell'offerta */
    operatore?: EOperatore;
    /** Se true è annullata TO */
    annullataTO?: boolean;
    /** Se true è annullata ADV */
    annullataADV?: boolean;
    /** Nome del contatto dell'accordo */
    contattoAccordo?: string | null;
    /** Data di partenza */
    partenza?: string;
    /** Clienti (dall'abbinamento) */
    clienti?: string | null;
    /** Paese (dal luogo della tappa) */
    paese?: string | null;
    /** Luogo della tappa */
    luogo?: string | null;
    /** Descrizione servizio in riga */
    servizio?: string | null;
    /** Prezzo totale */
    prezzo?: number;
    /** Codice della valuta */
    valuta?: string | null;
    /** Addebito in valuta */
    addebito?: number;
    /** Costo progressivo per offerta */
    costoProgressivoOfferta?: number;
    /** Importo già pagato */
    pagato?: number;
    /** Importo da pagare */
    pagare?: number;
    /** ID del pagamento associato */
    pagamentoID?: number | null;
    /** Verificato */
    verificato?: boolean;
    /** Tipo di contabilizzazione */
    contabilizzazione?: EContabilizzazione;
    /** Codice della conferma del fornitore */
    bookingRef?: string | null;

    constructor(data?: IServiceToPayExportRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.annullataTO = _data["annullataTO"] !== undefined ? _data["annullataTO"] : null as any;
            this.annullataADV = _data["annullataADV"] !== undefined ? _data["annullataADV"] : null as any;
            this.contattoAccordo = _data["contattoAccordo"] !== undefined ? _data["contattoAccordo"] : null as any;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : null as any;
            this.clienti = _data["clienti"] !== undefined ? _data["clienti"] : null as any;
            this.paese = _data["paese"] !== undefined ? _data["paese"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : null as any;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : null as any;
            this.valuta = _data["valuta"] !== undefined ? _data["valuta"] : null as any;
            this.addebito = _data["addebito"] !== undefined ? _data["addebito"] : null as any;
            this.costoProgressivoOfferta = _data["costoProgressivoOfferta"] !== undefined ? _data["costoProgressivoOfferta"] : null as any;
            this.pagato = _data["pagato"] !== undefined ? _data["pagato"] : null as any;
            this.pagare = _data["pagare"] !== undefined ? _data["pagare"] : null as any;
            this.pagamentoID = _data["pagamentoID"] !== undefined ? _data["pagamentoID"] : null as any;
            this.verificato = _data["verificato"] !== undefined ? _data["verificato"] : null as any;
            this.contabilizzazione = _data["contabilizzazione"] !== undefined ? _data["contabilizzazione"] : null as any;
            this.bookingRef = _data["bookingRef"] !== undefined ? _data["bookingRef"] : null as any;
        }
    }

    static fromJS(data: any): ServiceToPayExportRow {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceToPayExportRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["annullataTO"] = this.annullataTO !== undefined ? this.annullataTO : null as any;
        data["annullataADV"] = this.annullataADV !== undefined ? this.annullataADV : null as any;
        data["contattoAccordo"] = this.contattoAccordo !== undefined ? this.contattoAccordo : null as any;
        data["partenza"] = this.partenza !== undefined ? this.partenza : null as any;
        data["clienti"] = this.clienti !== undefined ? this.clienti : null as any;
        data["paese"] = this.paese !== undefined ? this.paese : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["servizio"] = this.servizio !== undefined ? this.servizio : null as any;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : null as any;
        data["valuta"] = this.valuta !== undefined ? this.valuta : null as any;
        data["addebito"] = this.addebito !== undefined ? this.addebito : null as any;
        data["costoProgressivoOfferta"] = this.costoProgressivoOfferta !== undefined ? this.costoProgressivoOfferta : null as any;
        data["pagato"] = this.pagato !== undefined ? this.pagato : null as any;
        data["pagare"] = this.pagare !== undefined ? this.pagare : null as any;
        data["pagamentoID"] = this.pagamentoID !== undefined ? this.pagamentoID : null as any;
        data["verificato"] = this.verificato !== undefined ? this.verificato : null as any;
        data["contabilizzazione"] = this.contabilizzazione !== undefined ? this.contabilizzazione : null as any;
        data["bookingRef"] = this.bookingRef !== undefined ? this.bookingRef : null as any;
        return data;
    }
}

export interface IServiceToPayExportRow {
    /** ID dell'offerta */
    offertaID?: number;
    /** Operatore dell'offerta */
    operatore?: EOperatore;
    /** Se true è annullata TO */
    annullataTO?: boolean;
    /** Se true è annullata ADV */
    annullataADV?: boolean;
    /** Nome del contatto dell'accordo */
    contattoAccordo?: string | null;
    /** Data di partenza */
    partenza?: string;
    /** Clienti (dall'abbinamento) */
    clienti?: string | null;
    /** Paese (dal luogo della tappa) */
    paese?: string | null;
    /** Luogo della tappa */
    luogo?: string | null;
    /** Descrizione servizio in riga */
    servizio?: string | null;
    /** Prezzo totale */
    prezzo?: number;
    /** Codice della valuta */
    valuta?: string | null;
    /** Addebito in valuta */
    addebito?: number;
    /** Costo progressivo per offerta */
    costoProgressivoOfferta?: number;
    /** Importo già pagato */
    pagato?: number;
    /** Importo da pagare */
    pagare?: number;
    /** ID del pagamento associato */
    pagamentoID?: number | null;
    /** Verificato */
    verificato?: boolean;
    /** Tipo di contabilizzazione */
    contabilizzazione?: EContabilizzazione;
    /** Codice della conferma del fornitore */
    bookingRef?: string | null;
}

export class ServiceToPayRow extends ServiceToPayExportRow implements IServiceToPayRow {
    /** ID della riga */
    offertaDatoID?: number;
    /** Contatto indicato nell'accordo */
    contattoAccordoID?: number | null;
    /** Check di corrispondenza contatto fornitore */
    supplierCheck?: ESupplierCheck;
    /** Valuta del pagamento già assegnato */
    valutaPagamento?: string | null;
    /** Check sull'ID pagamento associato */
    check?: EPaymentCheck;
    /** Se true è una riga "dispari" (per guidare la colorazione raggruppata per ID offerta */
    odd?: boolean;
    /** Span della riga per visualizzare correttamente la tabella */
    rowSpan?: number;

    constructor(data?: IServiceToPayRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : null as any;
            this.contattoAccordoID = _data["contattoAccordoID"] !== undefined ? _data["contattoAccordoID"] : null as any;
            this.supplierCheck = _data["supplierCheck"] !== undefined ? _data["supplierCheck"] : null as any;
            this.valutaPagamento = _data["valutaPagamento"] !== undefined ? _data["valutaPagamento"] : null as any;
            this.check = _data["check"] !== undefined ? _data["check"] : null as any;
            this.odd = _data["odd"] !== undefined ? _data["odd"] : null as any;
            this.rowSpan = _data["rowSpan"] !== undefined ? _data["rowSpan"] : null as any;
        }
    }

    static override fromJS(data: any): ServiceToPayRow {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceToPayRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : null as any;
        data["contattoAccordoID"] = this.contattoAccordoID !== undefined ? this.contattoAccordoID : null as any;
        data["supplierCheck"] = this.supplierCheck !== undefined ? this.supplierCheck : null as any;
        data["valutaPagamento"] = this.valutaPagamento !== undefined ? this.valutaPagamento : null as any;
        data["check"] = this.check !== undefined ? this.check : null as any;
        data["odd"] = this.odd !== undefined ? this.odd : null as any;
        data["rowSpan"] = this.rowSpan !== undefined ? this.rowSpan : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IServiceToPayRow extends IServiceToPayExportRow {
    /** ID della riga */
    offertaDatoID?: number;
    /** Contatto indicato nell'accordo */
    contattoAccordoID?: number | null;
    /** Check di corrispondenza contatto fornitore */
    supplierCheck?: ESupplierCheck;
    /** Valuta del pagamento già assegnato */
    valutaPagamento?: string | null;
    /** Check sull'ID pagamento associato */
    check?: EPaymentCheck;
    /** Se true è una riga "dispari" (per guidare la colorazione raggruppata per ID offerta */
    odd?: boolean;
    /** Span della riga per visualizzare correttamente la tabella */
    rowSpan?: number;
}

export enum ESupplierCheck {
    Missing = "Missing",
    Ok = "Ok",
    Mismatch = "Mismatch",
}

export enum EPaymentCheck {
    None = "None",
    Exists = "Exists",
    Missing = "Missing",
    Checking = "Checking",
}

export class ServicesToPayListRequest extends LocalizedRequest implements IServicesToPayListRequest {
    /** ID dell'operatore */
    operatore?: EOperatore | null;
    /** ID del contatto fornitore (da cercare sull'accordo) */
    contattoID?: number | null;
    /** ID dell'accordo */
    accordoID?: number | null;
    /** Data di partenza Dal */
    partenzaDal!: string;
    /** Data di partenza Al */
    partenzaAl!: string;
    /** ID di un'offerta */
    offertaID?: number | null;
    /** Se true è richiesta l'esportazione Excel */
    export?: boolean;
    /** Nome o parte del nome di un pax */
    nomePax?: string | null;
    /** Data inizio servizio "Dal" */
    inizioServizioDal?: string | null;
    /** Data inizio servizio "Al" */
    inizioServizioAl?: string | null;

    constructor(data?: IServicesToPayListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.partenzaDal = _data["partenzaDal"] !== undefined ? _data["partenzaDal"] : null as any;
            this.partenzaAl = _data["partenzaAl"] !== undefined ? _data["partenzaAl"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.export = _data["export"] !== undefined ? _data["export"] : null as any;
            this.nomePax = _data["nomePax"] !== undefined ? _data["nomePax"] : null as any;
            this.inizioServizioDal = _data["inizioServizioDal"] !== undefined ? _data["inizioServizioDal"] : null as any;
            this.inizioServizioAl = _data["inizioServizioAl"] !== undefined ? _data["inizioServizioAl"] : null as any;
        }
    }

    static override fromJS(data: any): ServicesToPayListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ServicesToPayListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["partenzaDal"] = this.partenzaDal !== undefined ? this.partenzaDal : null as any;
        data["partenzaAl"] = this.partenzaAl !== undefined ? this.partenzaAl : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["export"] = this.export !== undefined ? this.export : null as any;
        data["nomePax"] = this.nomePax !== undefined ? this.nomePax : null as any;
        data["inizioServizioDal"] = this.inizioServizioDal !== undefined ? this.inizioServizioDal : null as any;
        data["inizioServizioAl"] = this.inizioServizioAl !== undefined ? this.inizioServizioAl : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IServicesToPayListRequest extends ILocalizedRequest {
    /** ID dell'operatore */
    operatore?: EOperatore | null;
    /** ID del contatto fornitore (da cercare sull'accordo) */
    contattoID?: number | null;
    /** ID dell'accordo */
    accordoID?: number | null;
    /** Data di partenza Dal */
    partenzaDal: string;
    /** Data di partenza Al */
    partenzaAl: string;
    /** ID di un'offerta */
    offertaID?: number | null;
    /** Se true è richiesta l'esportazione Excel */
    export?: boolean;
    /** Nome o parte del nome di un pax */
    nomePax?: string | null;
    /** Data inizio servizio "Dal" */
    inizioServizioDal?: string | null;
    /** Data inizio servizio "Al" */
    inizioServizioAl?: string | null;
}

export class CreateSepaRidResponse extends OkApiResponse implements ICreateSepaRidResponse {
    row?: TempIncassiSepaRow;

    constructor(data?: ICreateSepaRidResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.row = _data["row"] ? TempIncassiSepaRow.fromJS(_data["row"]) : null as any;
        }
    }

    static override fromJS(data: any): CreateSepaRidResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSepaRidResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["row"] = this.row ? this.row.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateSepaRidResponse extends IOkApiResponse {
    row?: TempIncassiSepaRow;
}

export class TempIncassiSepaRow implements ITempIncassiSepaRow {
    id?: number;
    contactID?: number | null;
    proceedsID?: number | null;
    instrID?: number | null;
    endToEndID?: string | null;
    instdAmt?: number | null;
    mndtID?: string | null;
    dtOfSgntr?: string | null;
    dbtrNm?: string | null;
    dbtrCtry?: string | null;
    dbtrAdrLine?: string | null;
    dbtrIban?: string | null;
    tripName?: string | null;
    selected?: boolean;
    locked?: boolean;
    inserted?: string | null;
    departureDate?: string | null;
    bankDebitValueDate?: string | null;
    sequenceType?: string | null;

    constructor(data?: ITempIncassiSepaRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.contactID = _data["contactID"] !== undefined ? _data["contactID"] : null as any;
            this.proceedsID = _data["proceedsID"] !== undefined ? _data["proceedsID"] : null as any;
            this.instrID = _data["instrID"] !== undefined ? _data["instrID"] : null as any;
            this.endToEndID = _data["endToEndID"] !== undefined ? _data["endToEndID"] : null as any;
            this.instdAmt = _data["instdAmt"] !== undefined ? _data["instdAmt"] : null as any;
            this.mndtID = _data["mndtID"] !== undefined ? _data["mndtID"] : null as any;
            this.dtOfSgntr = _data["dtOfSgntr"] !== undefined ? _data["dtOfSgntr"] : null as any;
            this.dbtrNm = _data["dbtrNm"] !== undefined ? _data["dbtrNm"] : null as any;
            this.dbtrCtry = _data["dbtrCtry"] !== undefined ? _data["dbtrCtry"] : null as any;
            this.dbtrAdrLine = _data["dbtrAdrLine"] !== undefined ? _data["dbtrAdrLine"] : null as any;
            this.dbtrIban = _data["dbtrIban"] !== undefined ? _data["dbtrIban"] : null as any;
            this.tripName = _data["tripName"] !== undefined ? _data["tripName"] : null as any;
            this.selected = _data["selected"] !== undefined ? _data["selected"] : null as any;
            this.locked = _data["locked"] !== undefined ? _data["locked"] : null as any;
            this.inserted = _data["inserted"] !== undefined ? _data["inserted"] : null as any;
            this.departureDate = _data["departureDate"] !== undefined ? _data["departureDate"] : null as any;
            this.bankDebitValueDate = _data["bankDebitValueDate"] !== undefined ? _data["bankDebitValueDate"] : null as any;
            this.sequenceType = _data["sequenceType"] !== undefined ? _data["sequenceType"] : null as any;
        }
    }

    static fromJS(data: any): TempIncassiSepaRow {
        data = typeof data === 'object' ? data : {};
        let result = new TempIncassiSepaRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["contactID"] = this.contactID !== undefined ? this.contactID : null as any;
        data["proceedsID"] = this.proceedsID !== undefined ? this.proceedsID : null as any;
        data["instrID"] = this.instrID !== undefined ? this.instrID : null as any;
        data["endToEndID"] = this.endToEndID !== undefined ? this.endToEndID : null as any;
        data["instdAmt"] = this.instdAmt !== undefined ? this.instdAmt : null as any;
        data["mndtID"] = this.mndtID !== undefined ? this.mndtID : null as any;
        data["dtOfSgntr"] = this.dtOfSgntr !== undefined ? this.dtOfSgntr : null as any;
        data["dbtrNm"] = this.dbtrNm !== undefined ? this.dbtrNm : null as any;
        data["dbtrCtry"] = this.dbtrCtry !== undefined ? this.dbtrCtry : null as any;
        data["dbtrAdrLine"] = this.dbtrAdrLine !== undefined ? this.dbtrAdrLine : null as any;
        data["dbtrIban"] = this.dbtrIban !== undefined ? this.dbtrIban : null as any;
        data["tripName"] = this.tripName !== undefined ? this.tripName : null as any;
        data["selected"] = this.selected !== undefined ? this.selected : null as any;
        data["locked"] = this.locked !== undefined ? this.locked : null as any;
        data["inserted"] = this.inserted !== undefined ? this.inserted : null as any;
        data["departureDate"] = this.departureDate !== undefined ? this.departureDate : null as any;
        data["bankDebitValueDate"] = this.bankDebitValueDate !== undefined ? this.bankDebitValueDate : null as any;
        data["sequenceType"] = this.sequenceType !== undefined ? this.sequenceType : null as any;
        return data;
    }
}

export interface ITempIncassiSepaRow {
    id?: number;
    contactID?: number | null;
    proceedsID?: number | null;
    instrID?: number | null;
    endToEndID?: string | null;
    instdAmt?: number | null;
    mndtID?: string | null;
    dtOfSgntr?: string | null;
    dbtrNm?: string | null;
    dbtrCtry?: string | null;
    dbtrAdrLine?: string | null;
    dbtrIban?: string | null;
    tripName?: string | null;
    selected?: boolean;
    locked?: boolean;
    inserted?: string | null;
    departureDate?: string | null;
    bankDebitValueDate?: string | null;
    sequenceType?: string | null;
}

export class CreateSepaRidRequest extends ApiRequest implements ICreateSepaRidRequest {
    contactID!: number;
    proceedsID!: number;
    instdAmt!: number;
    mndtID!: string;
    dtOfSgntr!: string;
    dbtrNm!: string;
    dbtrCtry!: string;
    dbtrAdrLine!: string;
    dbtrIban!: string;
    selected!: boolean;
    inserted!: string;
    bankDebitValueDate!: string;
    sequenceType!: string;
    locked!: boolean;

    constructor(data?: ICreateSepaRidRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contactID = _data["contactID"] !== undefined ? _data["contactID"] : null as any;
            this.proceedsID = _data["proceedsID"] !== undefined ? _data["proceedsID"] : null as any;
            this.instdAmt = _data["instdAmt"] !== undefined ? _data["instdAmt"] : null as any;
            this.mndtID = _data["mndtID"] !== undefined ? _data["mndtID"] : null as any;
            this.dtOfSgntr = _data["dtOfSgntr"] !== undefined ? _data["dtOfSgntr"] : null as any;
            this.dbtrNm = _data["dbtrNm"] !== undefined ? _data["dbtrNm"] : null as any;
            this.dbtrCtry = _data["dbtrCtry"] !== undefined ? _data["dbtrCtry"] : null as any;
            this.dbtrAdrLine = _data["dbtrAdrLine"] !== undefined ? _data["dbtrAdrLine"] : null as any;
            this.dbtrIban = _data["dbtrIban"] !== undefined ? _data["dbtrIban"] : null as any;
            this.selected = _data["selected"] !== undefined ? _data["selected"] : null as any;
            this.inserted = _data["inserted"] !== undefined ? _data["inserted"] : null as any;
            this.bankDebitValueDate = _data["bankDebitValueDate"] !== undefined ? _data["bankDebitValueDate"] : null as any;
            this.sequenceType = _data["sequenceType"] !== undefined ? _data["sequenceType"] : null as any;
            this.locked = _data["locked"] !== undefined ? _data["locked"] : null as any;
        }
    }

    static override fromJS(data: any): CreateSepaRidRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSepaRidRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactID"] = this.contactID !== undefined ? this.contactID : null as any;
        data["proceedsID"] = this.proceedsID !== undefined ? this.proceedsID : null as any;
        data["instdAmt"] = this.instdAmt !== undefined ? this.instdAmt : null as any;
        data["mndtID"] = this.mndtID !== undefined ? this.mndtID : null as any;
        data["dtOfSgntr"] = this.dtOfSgntr !== undefined ? this.dtOfSgntr : null as any;
        data["dbtrNm"] = this.dbtrNm !== undefined ? this.dbtrNm : null as any;
        data["dbtrCtry"] = this.dbtrCtry !== undefined ? this.dbtrCtry : null as any;
        data["dbtrAdrLine"] = this.dbtrAdrLine !== undefined ? this.dbtrAdrLine : null as any;
        data["dbtrIban"] = this.dbtrIban !== undefined ? this.dbtrIban : null as any;
        data["selected"] = this.selected !== undefined ? this.selected : null as any;
        data["inserted"] = this.inserted !== undefined ? this.inserted : null as any;
        data["bankDebitValueDate"] = this.bankDebitValueDate !== undefined ? this.bankDebitValueDate : null as any;
        data["sequenceType"] = this.sequenceType !== undefined ? this.sequenceType : null as any;
        data["locked"] = this.locked !== undefined ? this.locked : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateSepaRidRequest extends IApiRequest {
    contactID: number;
    proceedsID: number;
    instdAmt: number;
    mndtID: string;
    dtOfSgntr: string;
    dbtrNm: string;
    dbtrCtry: string;
    dbtrAdrLine: string;
    dbtrIban: string;
    selected: boolean;
    inserted: string;
    bankDebitValueDate: string;
    sequenceType: string;
    locked: boolean;
}

export class DeleteSepaRidRequest extends ApiRequest implements IDeleteSepaRidRequest {
    id?: number;

    constructor(data?: IDeleteSepaRidRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): DeleteSepaRidRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteSepaRidRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteSepaRidRequest extends IApiRequest {
    id?: number;
}

export class SepaRidExportRequest extends ApiRequest implements ISepaRidExportRequest {

    constructor(data?: ISepaRidExportRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SepaRidExportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SepaRidExportRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISepaRidExportRequest extends IApiRequest {
}

export class SepaRidExportCsvRequest extends ApiRequest implements ISepaRidExportCsvRequest {

    constructor(data?: ISepaRidExportCsvRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SepaRidExportCsvRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SepaRidExportCsvRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISepaRidExportCsvRequest extends IApiRequest {
}

export class ExtractSepaRidRequest extends ApiRequest implements IExtractSepaRidRequest {
    expirationFrom!: string;
    expirationTo!: string;
    valutaDate!: string;

    constructor(data?: IExtractSepaRidRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.expirationFrom = _data["expirationFrom"] !== undefined ? _data["expirationFrom"] : null as any;
            this.expirationTo = _data["expirationTo"] !== undefined ? _data["expirationTo"] : null as any;
            this.valutaDate = _data["valutaDate"] !== undefined ? _data["valutaDate"] : null as any;
        }
    }

    static override fromJS(data: any): ExtractSepaRidRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExtractSepaRidRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expirationFrom"] = this.expirationFrom !== undefined ? this.expirationFrom : null as any;
        data["expirationTo"] = this.expirationTo !== undefined ? this.expirationTo : null as any;
        data["valutaDate"] = this.valutaDate !== undefined ? this.valutaDate : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IExtractSepaRidRequest extends IApiRequest {
    expirationFrom: string;
    expirationTo: string;
    valutaDate: string;
}

export class GetSepaRidResponse extends OkApiResponse implements IGetSepaRidResponse {
    data?: TempIncassiSepaRow;

    constructor(data?: IGetSepaRidResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? TempIncassiSepaRow.fromJS(_data["data"]) : null as any;
        }
    }

    static override fromJS(data: any): GetSepaRidResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSepaRidResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetSepaRidResponse extends IOkApiResponse {
    data?: TempIncassiSepaRow;
}

export class GetSepaRidRequest extends ApiRequest implements IGetSepaRidRequest {
    id!: number;

    constructor(data?: IGetSepaRidRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): GetSepaRidRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSepaRidRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetSepaRidRequest extends IApiRequest {
    id: number;
}

export class NrTableResponseOfTempIncassiSepaRow extends OkApiResponse implements INrTableResponseOfTempIncassiSepaRow {
    /** Array delle righe della pagina richiesta */
    rows?: TempIncassiSepaRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfTempIncassiSepaRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TempIncassiSepaRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfTempIncassiSepaRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfTempIncassiSepaRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfTempIncassiSepaRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: TempIncassiSepaRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class SepaRidListResponse extends NrTableResponseOfTempIncassiSepaRow implements ISepaRidListResponse {

    constructor(data?: ISepaRidListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SepaRidListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SepaRidListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISepaRidListResponse extends INrTableResponseOfTempIncassiSepaRow {
}

export class SepaRidListRequest extends NrTableRequest implements ISepaRidListRequest {

    constructor(data?: ISepaRidListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SepaRidListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SepaRidListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISepaRidListRequest extends INrTableRequest {
}

export class UpdateSepaRidRequest extends ApiRequest implements IUpdateSepaRidRequest {
    id!: number;
    mndtID!: string;
    selected!: boolean;
    instdAmt!: number;
    bankDebitValueDate!: string;
    sequenceType!: string;
    dbtrIban!: string;
    locked!: boolean;

    constructor(data?: IUpdateSepaRidRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.mndtID = _data["mndtID"] !== undefined ? _data["mndtID"] : null as any;
            this.selected = _data["selected"] !== undefined ? _data["selected"] : null as any;
            this.instdAmt = _data["instdAmt"] !== undefined ? _data["instdAmt"] : null as any;
            this.bankDebitValueDate = _data["bankDebitValueDate"] !== undefined ? _data["bankDebitValueDate"] : null as any;
            this.sequenceType = _data["sequenceType"] !== undefined ? _data["sequenceType"] : null as any;
            this.dbtrIban = _data["dbtrIban"] !== undefined ? _data["dbtrIban"] : null as any;
            this.locked = _data["locked"] !== undefined ? _data["locked"] : null as any;
        }
    }

    static override fromJS(data: any): UpdateSepaRidRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSepaRidRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["mndtID"] = this.mndtID !== undefined ? this.mndtID : null as any;
        data["selected"] = this.selected !== undefined ? this.selected : null as any;
        data["instdAmt"] = this.instdAmt !== undefined ? this.instdAmt : null as any;
        data["bankDebitValueDate"] = this.bankDebitValueDate !== undefined ? this.bankDebitValueDate : null as any;
        data["sequenceType"] = this.sequenceType !== undefined ? this.sequenceType : null as any;
        data["dbtrIban"] = this.dbtrIban !== undefined ? this.dbtrIban : null as any;
        data["locked"] = this.locked !== undefined ? this.locked : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateSepaRidRequest extends IApiRequest {
    id: number;
    mndtID: string;
    selected: boolean;
    instdAmt: number;
    bankDebitValueDate: string;
    sequenceType: string;
    dbtrIban: string;
    locked: boolean;
}

export class CreateTravelfactoringResponse extends OkApiResponse implements ICreateTravelfactoringResponse {
    /** Flusso creato. Se null non c'erano righe da aggiungere */
    flusso?: Travelfactoring_Flusso | null;

    constructor(data?: ICreateTravelfactoringResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.flusso = _data["flusso"] ? Travelfactoring_Flusso.fromJS(_data["flusso"]) : null as any;
        }
    }

    static override fromJS(data: any): CreateTravelfactoringResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTravelfactoringResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flusso"] = this.flusso ? this.flusso.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateTravelfactoringResponse extends IOkApiResponse {
    /** Flusso creato. Se null non c'erano righe da aggiungere */
    flusso?: Travelfactoring_Flusso | null;
}

export class Travelfactoring_Flusso implements ITravelfactoring_Flusso {
    id?: number;
    creato?: string;
    inviato?: string | null;

    constructor(data?: ITravelfactoring_Flusso) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creato = _data["creato"] !== undefined ? _data["creato"] : null as any;
            this.inviato = _data["inviato"] !== undefined ? _data["inviato"] : null as any;
        }
    }

    static fromJS(data: any): Travelfactoring_Flusso {
        data = typeof data === 'object' ? data : {};
        let result = new Travelfactoring_Flusso();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creato"] = this.creato !== undefined ? this.creato : null as any;
        data["inviato"] = this.inviato !== undefined ? this.inviato : null as any;
        return data;
    }
}

export interface ITravelfactoring_Flusso {
    id?: number;
    creato?: string;
    inviato?: string | null;
}

export class TravelfactoringGetRequest extends ApiRequest implements ITravelfactoringGetRequest {
    flussoID?: number;

    constructor(data?: ITravelfactoringGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.flussoID = _data["flussoID"] !== undefined ? _data["flussoID"] : null as any;
        }
    }

    static override fromJS(data: any): TravelfactoringGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TravelfactoringGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flussoID"] = this.flussoID !== undefined ? this.flussoID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITravelfactoringGetRequest extends IApiRequest {
    flussoID?: number;
}

export class ExportTravelfactoringResponse extends OkApiResponse implements IExportTravelfactoringResponse {
    fileName?: string;
    fileContent?: string;

    constructor(data?: IExportTravelfactoringResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.fileContent = _data["fileContent"] !== undefined ? _data["fileContent"] : null as any;
        }
    }

    static override fromJS(data: any): ExportTravelfactoringResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExportTravelfactoringResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["fileContent"] = this.fileContent !== undefined ? this.fileContent : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IExportTravelfactoringResponse extends IOkApiResponse {
    fileName?: string;
    fileContent?: string;
}

export class TravelfactoringGetResponse extends OkApiResponse implements ITravelfactoringGetResponse {
    righe?: Travelfactoring_Riga[];

    constructor(data?: ITravelfactoringGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["righe"])) {
                this.righe = [] as any;
                for (let item of _data["righe"])
                    this.righe!.push(Travelfactoring_Riga.fromJS(item));
            }
            else {
                this.righe = null as any;
            }
        }
    }

    static override fromJS(data: any): TravelfactoringGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TravelfactoringGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.righe)) {
            data["righe"] = [];
            for (let item of this.righe)
                data["righe"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITravelfactoringGetResponse extends IOkApiResponse {
    righe?: Travelfactoring_Riga[];
}

export class Travelfactoring_Riga implements ITravelfactoring_Riga {
    id?: number;
    flussoID?: number;
    agenziaID?: number;
    offertaID?: number | null;
    pratica!: string;
    partenza?: string;
    scadenza?: string;
    operazione?: EOperazioneFactoring;
    importo?: number;
    passeggero?: string | null;

    constructor(data?: ITravelfactoring_Riga) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.flussoID = _data["flussoID"] !== undefined ? _data["flussoID"] : null as any;
            this.agenziaID = _data["agenziaID"] !== undefined ? _data["agenziaID"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.pratica = _data["pratica"] !== undefined ? _data["pratica"] : null as any;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : null as any;
            this.scadenza = _data["scadenza"] !== undefined ? _data["scadenza"] : null as any;
            this.operazione = _data["operazione"] !== undefined ? _data["operazione"] : null as any;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : null as any;
            this.passeggero = _data["passeggero"] !== undefined ? _data["passeggero"] : null as any;
        }
    }

    static fromJS(data: any): Travelfactoring_Riga {
        data = typeof data === 'object' ? data : {};
        let result = new Travelfactoring_Riga();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["flussoID"] = this.flussoID !== undefined ? this.flussoID : null as any;
        data["agenziaID"] = this.agenziaID !== undefined ? this.agenziaID : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["pratica"] = this.pratica !== undefined ? this.pratica : null as any;
        data["partenza"] = this.partenza !== undefined ? this.partenza : null as any;
        data["scadenza"] = this.scadenza !== undefined ? this.scadenza : null as any;
        data["operazione"] = this.operazione !== undefined ? this.operazione : null as any;
        data["importo"] = this.importo !== undefined ? this.importo : null as any;
        data["passeggero"] = this.passeggero !== undefined ? this.passeggero : null as any;
        return data;
    }
}

export interface ITravelfactoring_Riga {
    id?: number;
    flussoID?: number;
    agenziaID?: number;
    offertaID?: number | null;
    pratica: string;
    partenza?: string;
    scadenza?: string;
    operazione?: EOperazioneFactoring;
    importo?: number;
    passeggero?: string | null;
}

export enum EOperazioneFactoring {
    PrimaCessione = "PrimaCessione",
    Integrazione = "Integrazione",
    StornoParziale = "StornoParziale",
    AccreditoTotale = "AccreditoTotale",
    Rinuncia = "Rinuncia",
    AccreditoAutofattura = "AccreditoAutofattura",
}

export class NrTableResponseOfTravelfactoringFlussoView extends OkApiResponse implements INrTableResponseOfTravelfactoringFlussoView {
    /** Array delle righe della pagina richiesta */
    rows?: TravelfactoringFlussoView[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfTravelfactoringFlussoView) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TravelfactoringFlussoView.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfTravelfactoringFlussoView {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfTravelfactoringFlussoView();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfTravelfactoringFlussoView extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: TravelfactoringFlussoView[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class TravelfactoringListResponse extends NrTableResponseOfTravelfactoringFlussoView implements ITravelfactoringListResponse {

    constructor(data?: ITravelfactoringListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): TravelfactoringListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TravelfactoringListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITravelfactoringListResponse extends INrTableResponseOfTravelfactoringFlussoView {
}

export class TravelfactoringFlussoView implements ITravelfactoringFlussoView {
    id?: number;
    creato?: string;
    inviato?: string | null;
    righe?: number;
    importo?: number;

    constructor(data?: ITravelfactoringFlussoView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.creato = _data["creato"] !== undefined ? _data["creato"] : null as any;
            this.inviato = _data["inviato"] !== undefined ? _data["inviato"] : null as any;
            this.righe = _data["righe"] !== undefined ? _data["righe"] : null as any;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : null as any;
        }
    }

    static fromJS(data: any): TravelfactoringFlussoView {
        data = typeof data === 'object' ? data : {};
        let result = new TravelfactoringFlussoView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["creato"] = this.creato !== undefined ? this.creato : null as any;
        data["inviato"] = this.inviato !== undefined ? this.inviato : null as any;
        data["righe"] = this.righe !== undefined ? this.righe : null as any;
        data["importo"] = this.importo !== undefined ? this.importo : null as any;
        return data;
    }
}

export interface ITravelfactoringFlussoView {
    id?: number;
    creato?: string;
    inviato?: string | null;
    righe?: number;
    importo?: number;
}

export class TravelfactoringListRequest extends NrTableRequest implements ITravelfactoringListRequest {
    dal?: string | null;
    al?: string | null;

    constructor(data?: ITravelfactoringListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.al = _data["al"] !== undefined ? _data["al"] : null as any;
        }
    }

    static override fromJS(data: any): TravelfactoringListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TravelfactoringListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["al"] = this.al !== undefined ? this.al : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITravelfactoringListRequest extends INrTableRequest {
    dal?: string | null;
    al?: string | null;
}

export class UpdateTravelfactoringRequest extends TravelfactoringGetRequest implements IUpdateTravelfactoringRequest {
    righe?: Travelfactoring_Riga[];

    constructor(data?: IUpdateTravelfactoringRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["righe"])) {
                this.righe = [] as any;
                for (let item of _data["righe"])
                    this.righe!.push(Travelfactoring_Riga.fromJS(item));
            }
            else {
                this.righe = null as any;
            }
        }
    }

    static override fromJS(data: any): UpdateTravelfactoringRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTravelfactoringRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.righe)) {
            data["righe"] = [];
            for (let item of this.righe)
                data["righe"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateTravelfactoringRequest extends ITravelfactoringGetRequest {
    righe?: Travelfactoring_Riga[];
}

export class NrTableResponseOfActivityLogsRow extends OkApiResponse implements INrTableResponseOfActivityLogsRow {
    /** Array delle righe della pagina richiesta */
    rows?: ActivityLogsRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfActivityLogsRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ActivityLogsRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfActivityLogsRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfActivityLogsRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfActivityLogsRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: ActivityLogsRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class TripActivityLogItem implements ITripActivityLogItem {
    transactionID?: string;
    ip?: string | null;
    context?: EActivityContext;
    userID?: number | null;
    tripID?: number | null;
    date?: string;
    operations?: ActivityLogOperation[];

    constructor(data?: ITripActivityLogItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionID = _data["transactionID"] !== undefined ? _data["transactionID"] : null as any;
            this.ip = _data["ip"] !== undefined ? _data["ip"] : null as any;
            this.context = _data["context"] !== undefined ? _data["context"] : null as any;
            this.userID = _data["userID"] !== undefined ? _data["userID"] : null as any;
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : null as any;
            this.date = _data["date"] !== undefined ? _data["date"] : null as any;
            if (Array.isArray(_data["operations"])) {
                this.operations = [] as any;
                for (let item of _data["operations"])
                    this.operations!.push(ActivityLogOperation.fromJS(item));
            }
            else {
                this.operations = null as any;
            }
        }
    }

    static fromJS(data: any): TripActivityLogItem {
        data = typeof data === 'object' ? data : {};
        let result = new TripActivityLogItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionID"] = this.transactionID !== undefined ? this.transactionID : null as any;
        data["ip"] = this.ip !== undefined ? this.ip : null as any;
        data["context"] = this.context !== undefined ? this.context : null as any;
        data["userID"] = this.userID !== undefined ? this.userID : null as any;
        data["tripID"] = this.tripID !== undefined ? this.tripID : null as any;
        data["date"] = this.date !== undefined ? this.date : null as any;
        if (Array.isArray(this.operations)) {
            data["operations"] = [];
            for (let item of this.operations)
                data["operations"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ITripActivityLogItem {
    transactionID?: string;
    ip?: string | null;
    context?: EActivityContext;
    userID?: number | null;
    tripID?: number | null;
    date?: string;
    operations?: ActivityLogOperation[];
}

export class SqlTripActivityLogItem extends TripActivityLogItem implements ISqlTripActivityLogItem {
    id?: number;

    constructor(data?: ISqlTripActivityLogItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): SqlTripActivityLogItem {
        data = typeof data === 'object' ? data : {};
        let result = new SqlTripActivityLogItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISqlTripActivityLogItem extends ITripActivityLogItem {
    id?: number;
}

export class ActivityLogsRow extends SqlTripActivityLogItem implements IActivityLogsRow {
    /** OperationsItems but re-declared without JsonIgnore */
    items?: SqlActivityLogOperation[] | null;
    userName?: string | null;

    constructor(data?: IActivityLogsRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SqlActivityLogOperation.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
        }
    }

    static override fromJS(data: any): ActivityLogsRow {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLogsRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IActivityLogsRow extends ISqlTripActivityLogItem {
    /** OperationsItems but re-declared without JsonIgnore */
    items?: SqlActivityLogOperation[] | null;
    userName?: string | null;
}

export class ActivityLogOperation implements IActivityLogOperation {
    operationNr?: number;
    methodType?: string;
    operation?: EDataOperation;
    message?: string | null;
    methodName?: string;
    masterRecordID?: number | null;
    masterTable?: string | null;
    table?: string | null;
    date?: string;
    recordID?: number | null;
    rawDataJObject?: any | null;

    constructor(data?: IActivityLogOperation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operationNr = _data["operationNr"] !== undefined ? _data["operationNr"] : null as any;
            this.methodType = _data["methodType"] !== undefined ? _data["methodType"] : null as any;
            this.operation = _data["operation"] !== undefined ? _data["operation"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
            this.methodName = _data["methodName"] !== undefined ? _data["methodName"] : null as any;
            this.masterRecordID = _data["masterRecordID"] !== undefined ? _data["masterRecordID"] : null as any;
            this.masterTable = _data["masterTable"] !== undefined ? _data["masterTable"] : null as any;
            this.table = _data["table"] !== undefined ? _data["table"] : null as any;
            this.date = _data["date"] !== undefined ? _data["date"] : null as any;
            this.recordID = _data["recordID"] !== undefined ? _data["recordID"] : null as any;
            this.rawDataJObject = _data["rawDataJObject"] !== undefined ? _data["rawDataJObject"] : null as any;
        }
    }

    static fromJS(data: any): ActivityLogOperation {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLogOperation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operationNr"] = this.operationNr !== undefined ? this.operationNr : null as any;
        data["methodType"] = this.methodType !== undefined ? this.methodType : null as any;
        data["operation"] = this.operation !== undefined ? this.operation : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        data["methodName"] = this.methodName !== undefined ? this.methodName : null as any;
        data["masterRecordID"] = this.masterRecordID !== undefined ? this.masterRecordID : null as any;
        data["masterTable"] = this.masterTable !== undefined ? this.masterTable : null as any;
        data["table"] = this.table !== undefined ? this.table : null as any;
        data["date"] = this.date !== undefined ? this.date : null as any;
        data["recordID"] = this.recordID !== undefined ? this.recordID : null as any;
        data["rawDataJObject"] = this.rawDataJObject !== undefined ? this.rawDataJObject : null as any;
        return data;
    }
}

export interface IActivityLogOperation {
    operationNr?: number;
    methodType?: string;
    operation?: EDataOperation;
    message?: string | null;
    methodName?: string;
    masterRecordID?: number | null;
    masterTable?: string | null;
    table?: string | null;
    date?: string;
    recordID?: number | null;
    rawDataJObject?: any | null;
}

export class SqlActivityLogOperation extends ActivityLogOperation implements ISqlActivityLogOperation {
    id?: number;
    logItemID?: number;

    constructor(data?: ISqlActivityLogOperation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.logItemID = _data["logItemID"] !== undefined ? _data["logItemID"] : null as any;
        }
    }

    static override fromJS(data: any): SqlActivityLogOperation {
        data = typeof data === 'object' ? data : {};
        let result = new SqlActivityLogOperation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["logItemID"] = this.logItemID !== undefined ? this.logItemID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISqlActivityLogOperation extends IActivityLogOperation {
    id?: number;
    logItemID?: number;
}

export enum EDataOperation {
    Create = "Create",
    Update = "Update",
    Delete = "Delete",
    Select = "Select",
    Restore = "Restore",
}

export enum EActivityContext {
    WEB = "WEB",
    INTRANET = "INTRANET",
    B2B = "B2B",
    B2C = "B2C",
    AGENT = "AGENT",
    AUTOFILL = "AUTOFILL",
    MOBILE = "MOBILE",
}

export class ActivityLogsListRequest extends NrTableRequest implements IActivityLogsListRequest {
    userID?: number | null;
    date?: string | null;
    context?: EActivityContext | null;

    constructor(data?: IActivityLogsListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userID = _data["userID"] !== undefined ? _data["userID"] : null as any;
            this.date = _data["date"] !== undefined ? _data["date"] : null as any;
            this.context = _data["context"] !== undefined ? _data["context"] : null as any;
        }
    }

    static override fromJS(data: any): ActivityLogsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLogsListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID !== undefined ? this.userID : null as any;
        data["date"] = this.date !== undefined ? this.date : null as any;
        data["context"] = this.context !== undefined ? this.context : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IActivityLogsListRequest extends INrTableRequest {
    userID?: number | null;
    date?: string | null;
    context?: EActivityContext | null;
}

export class AdditionalDataGetResponse extends OkApiResponse implements IAdditionalDataGetResponse {
    additionalData?: DatoAggiuntivo | null;

    constructor(data?: IAdditionalDataGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.additionalData = _data["additionalData"] ? DatoAggiuntivo.fromJS(_data["additionalData"]) : null as any;
        }
    }

    static override fromJS(data: any): AdditionalDataGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalDataGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalData"] = this.additionalData ? this.additionalData.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalDataGetResponse extends IOkApiResponse {
    additionalData?: DatoAggiuntivo | null;
}

export class DatoAggiuntivo implements IDatoAggiuntivo {
    id?: number;
    tipoDatiID?: number;
    traduzioni?: AdditionalDataTranslation[] | null;
    codice?: string | null;
    nome?: string | null;
    nome_en?: string | null;
    ordine?: number | null;
    mostraDescrizione?: boolean;
    priorita?: number | null;
    luogoID?: number | null;
    tipoServizioID?: number | null;
    variabili?: number | null;
    temporizzato?: boolean;
    gif?: number | null;
    gifName?: string | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean | null;
    confirmed_en?: boolean | null;

    constructor(data?: IDatoAggiuntivo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.tipoDatiID = _data["tipoDatiID"] !== undefined ? _data["tipoDatiID"] : null as any;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(AdditionalDataTranslation.fromJS(item));
            }
            else {
                this.traduzioni = null as any;
            }
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.mostraDescrizione = _data["mostraDescrizione"] !== undefined ? _data["mostraDescrizione"] : null as any;
            this.priorita = _data["priorita"] !== undefined ? _data["priorita"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.tipoServizioID = _data["tipoServizioID"] !== undefined ? _data["tipoServizioID"] : null as any;
            this.variabili = _data["variabili"] !== undefined ? _data["variabili"] : null as any;
            this.temporizzato = _data["temporizzato"] !== undefined ? _data["temporizzato"] : null as any;
            this.gif = _data["gif"] !== undefined ? _data["gif"] : null as any;
            this.gifName = _data["gifName"] !== undefined ? _data["gifName"] : null as any;
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : null as any;
            this.lastUpdate_en = _data["lastUpdate_en"] !== undefined ? _data["lastUpdate_en"] : null as any;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : null as any;
            this.confirmed_en = _data["confirmed_en"] !== undefined ? _data["confirmed_en"] : null as any;
        }
    }

    static fromJS(data: any): DatoAggiuntivo {
        data = typeof data === 'object' ? data : {};
        let result = new DatoAggiuntivo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["tipoDatiID"] = this.tipoDatiID !== undefined ? this.tipoDatiID : null as any;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item ? item.toJSON() : null as any);
        }
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["mostraDescrizione"] = this.mostraDescrizione !== undefined ? this.mostraDescrizione : null as any;
        data["priorita"] = this.priorita !== undefined ? this.priorita : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["tipoServizioID"] = this.tipoServizioID !== undefined ? this.tipoServizioID : null as any;
        data["variabili"] = this.variabili !== undefined ? this.variabili : null as any;
        data["temporizzato"] = this.temporizzato !== undefined ? this.temporizzato : null as any;
        data["gif"] = this.gif !== undefined ? this.gif : null as any;
        data["gifName"] = this.gifName !== undefined ? this.gifName : null as any;
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : null as any;
        data["lastUpdate_en"] = this.lastUpdate_en !== undefined ? this.lastUpdate_en : null as any;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : null as any;
        data["confirmed_en"] = this.confirmed_en !== undefined ? this.confirmed_en : null as any;
        return data;
    }
}

export interface IDatoAggiuntivo {
    id?: number;
    tipoDatiID?: number;
    traduzioni?: AdditionalDataTranslation[] | null;
    codice?: string | null;
    nome?: string | null;
    nome_en?: string | null;
    ordine?: number | null;
    mostraDescrizione?: boolean;
    priorita?: number | null;
    luogoID?: number | null;
    tipoServizioID?: number | null;
    variabili?: number | null;
    temporizzato?: boolean;
    gif?: number | null;
    gifName?: string | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean | null;
    confirmed_en?: boolean | null;
}

export class WebTranslation implements IWebTranslation {
    id?: number;
    table!: string;
    entityID!: number;
    lang!: ELingua;
    culture?: string | null;
    translation!: string;
    lastUpdate?: string | null;
    confirmed?: boolean | null;
    deleted?: string | null;

    constructor(data?: IWebTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.table = _data["table"] !== undefined ? _data["table"] : null as any;
            this.entityID = _data["entityID"] !== undefined ? _data["entityID"] : null as any;
            this.lang = _data["lang"] !== undefined ? _data["lang"] : null as any;
            this.culture = _data["culture"] !== undefined ? _data["culture"] : null as any;
            this.translation = _data["translation"] !== undefined ? _data["translation"] : null as any;
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : null as any;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : null as any;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : null as any;
        }
    }

    static fromJS(data: any): WebTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new WebTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["table"] = this.table !== undefined ? this.table : null as any;
        data["entityID"] = this.entityID !== undefined ? this.entityID : null as any;
        data["lang"] = this.lang !== undefined ? this.lang : null as any;
        data["culture"] = this.culture !== undefined ? this.culture : null as any;
        data["translation"] = this.translation !== undefined ? this.translation : null as any;
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : null as any;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : null as any;
        data["deleted"] = this.deleted !== undefined ? this.deleted : null as any;
        return data;
    }
}

export interface IWebTranslation {
    id?: number;
    table: string;
    entityID: number;
    lang: ELingua;
    culture?: string | null;
    translation: string;
    lastUpdate?: string | null;
    confirmed?: boolean | null;
    deleted?: string | null;
}

export class AdditionalDataTranslation extends WebTranslation implements IAdditionalDataTranslation {

    constructor(data?: IAdditionalDataTranslation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): AdditionalDataTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalDataTranslation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalDataTranslation extends IWebTranslation {
}

export class AdditionalDataGetRequest extends ApiRequest implements IAdditionalDataGetRequest {
    additionalDataID!: number;

    constructor(data?: IAdditionalDataGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.additionalDataID = _data["additionalDataID"] !== undefined ? _data["additionalDataID"] : null as any;
        }
    }

    static override fromJS(data: any): AdditionalDataGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalDataGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalDataID"] = this.additionalDataID !== undefined ? this.additionalDataID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalDataGetRequest extends IApiRequest {
    additionalDataID: number;
}

export class AdditionalDataUpdateRequest extends AdditionalDataGetRequest implements IAdditionalDataUpdateRequest {
    additionalData!: DatoAggiuntivo;

    constructor(data?: IAdditionalDataUpdateRequest) {
        super(data);
        if (!data) {
            this.additionalData = new DatoAggiuntivo();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.additionalData = _data["additionalData"] ? DatoAggiuntivo.fromJS(_data["additionalData"]) : new DatoAggiuntivo();
        }
    }

    static override fromJS(data: any): AdditionalDataUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalDataUpdateRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalData"] = this.additionalData ? this.additionalData.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalDataUpdateRequest extends IAdditionalDataGetRequest {
    additionalData: DatoAggiuntivo;
}

export class AdditionalDataDeleteRequest extends AdditionalDataGetRequest implements IAdditionalDataDeleteRequest {

    constructor(data?: IAdditionalDataDeleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): AdditionalDataDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalDataDeleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalDataDeleteRequest extends IAdditionalDataGetRequest {
}

export class NrTableResponseOfAdditionalDataRow extends OkApiResponse implements INrTableResponseOfAdditionalDataRow {
    /** Array delle righe della pagina richiesta */
    rows?: AdditionalDataRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfAdditionalDataRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AdditionalDataRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfAdditionalDataRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfAdditionalDataRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfAdditionalDataRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: AdditionalDataRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class AdditionalDataListResponse extends NrTableResponseOfAdditionalDataRow implements IAdditionalDataListResponse {

    constructor(data?: IAdditionalDataListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): AdditionalDataListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalDataListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalDataListResponse extends INrTableResponseOfAdditionalDataRow {
}

export class AdditionalDataRow implements IAdditionalDataRow {
    id?: number;
    type?: string;
    name?: string | null;
    place?: string;
    serviceType?: string;
    order?: number | null;
    priority?: number | null;
    additionalData?: DatoAggiuntivo | null;

    constructor(data?: IAdditionalDataRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.place = _data["place"] !== undefined ? _data["place"] : null as any;
            this.serviceType = _data["serviceType"] !== undefined ? _data["serviceType"] : null as any;
            this.order = _data["order"] !== undefined ? _data["order"] : null as any;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : null as any;
            this.additionalData = _data["additionalData"] ? DatoAggiuntivo.fromJS(_data["additionalData"]) : null as any;
        }
    }

    static fromJS(data: any): AdditionalDataRow {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalDataRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["place"] = this.place !== undefined ? this.place : null as any;
        data["serviceType"] = this.serviceType !== undefined ? this.serviceType : null as any;
        data["order"] = this.order !== undefined ? this.order : null as any;
        data["priority"] = this.priority !== undefined ? this.priority : null as any;
        data["additionalData"] = this.additionalData ? this.additionalData.toJSON() : null as any;
        return data;
    }
}

export interface IAdditionalDataRow {
    id?: number;
    type?: string;
    name?: string | null;
    place?: string;
    serviceType?: string;
    order?: number | null;
    priority?: number | null;
    additionalData?: DatoAggiuntivo | null;
}

export class AdditionalDataListRequest extends NrTableRequest implements IAdditionalDataListRequest {
    term?: string | null;
    typeID?: number | null;
    placeID?: number | null;

    constructor(data?: IAdditionalDataListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : null as any;
            this.typeID = _data["typeID"] !== undefined ? _data["typeID"] : null as any;
            this.placeID = _data["placeID"] !== undefined ? _data["placeID"] : null as any;
        }
    }

    static override fromJS(data: any): AdditionalDataListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalDataListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : null as any;
        data["typeID"] = this.typeID !== undefined ? this.typeID : null as any;
        data["placeID"] = this.placeID !== undefined ? this.placeID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalDataListRequest extends INrTableRequest {
    term?: string | null;
    typeID?: number | null;
    placeID?: number | null;
}

export class AdditionalDataUpdateResponse extends AdditionalDataGetResponse implements IAdditionalDataUpdateResponse {

    constructor(data?: IAdditionalDataUpdateResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): AdditionalDataUpdateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalDataUpdateResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalDataUpdateResponse extends IAdditionalDataGetResponse {
}

export class AdditionalsDataTypesGetRequest extends ApiRequest implements IAdditionalsDataTypesGetRequest {
    id!: number;

    constructor(data?: IAdditionalsDataTypesGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): AdditionalsDataTypesGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalsDataTypesGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalsDataTypesGetRequest extends IApiRequest {
    id: number;
}

export class AdditionalsDataTypesUpdateRequest extends AdditionalsDataTypesGetRequest implements IAdditionalsDataTypesUpdateRequest {
    additionalDataType!: DatoAggiuntivoTipo;

    constructor(data?: IAdditionalsDataTypesUpdateRequest) {
        super(data);
        if (!data) {
            this.additionalDataType = new DatoAggiuntivoTipo();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.additionalDataType = _data["additionalDataType"] ? DatoAggiuntivoTipo.fromJS(_data["additionalDataType"]) : new DatoAggiuntivoTipo();
        }
    }

    static override fromJS(data: any): AdditionalsDataTypesUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalsDataTypesUpdateRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalDataType"] = this.additionalDataType ? this.additionalDataType.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalsDataTypesUpdateRequest extends IAdditionalsDataTypesGetRequest {
    additionalDataType: DatoAggiuntivoTipo;
}

export class DatoAggiuntivoTipo implements IDatoAggiuntivoTipo {
    id?: number;
    tipoDatiID?: number;
    traduzioni?: AdditionalDataTypeTranslation[] | null;
    tipoServizio?: ETipoServizio | null;
    nome!: string;
    ordine?: number | null;
    usaPerRicerca?: boolean;
    codice?: string | null;
    standard?: boolean;
    nome_en?: string | null;
    mostra_descr?: number | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean | null;
    confirmed_en?: boolean | null;

    constructor(data?: IDatoAggiuntivoTipo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.tipoDatiID = _data["tipoDatiID"] !== undefined ? _data["tipoDatiID"] : null as any;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(AdditionalDataTypeTranslation.fromJS(item));
            }
            else {
                this.traduzioni = null as any;
            }
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.usaPerRicerca = _data["usaPerRicerca"] !== undefined ? _data["usaPerRicerca"] : null as any;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
            this.standard = _data["standard"] !== undefined ? _data["standard"] : null as any;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : null as any;
            this.mostra_descr = _data["mostra_descr"] !== undefined ? _data["mostra_descr"] : null as any;
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : null as any;
            this.lastUpdate_en = _data["lastUpdate_en"] !== undefined ? _data["lastUpdate_en"] : null as any;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : null as any;
            this.confirmed_en = _data["confirmed_en"] !== undefined ? _data["confirmed_en"] : null as any;
        }
    }

    static fromJS(data: any): DatoAggiuntivoTipo {
        data = typeof data === 'object' ? data : {};
        let result = new DatoAggiuntivoTipo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["tipoDatiID"] = this.tipoDatiID !== undefined ? this.tipoDatiID : null as any;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item ? item.toJSON() : null as any);
        }
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["usaPerRicerca"] = this.usaPerRicerca !== undefined ? this.usaPerRicerca : null as any;
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        data["standard"] = this.standard !== undefined ? this.standard : null as any;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : null as any;
        data["mostra_descr"] = this.mostra_descr !== undefined ? this.mostra_descr : null as any;
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : null as any;
        data["lastUpdate_en"] = this.lastUpdate_en !== undefined ? this.lastUpdate_en : null as any;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : null as any;
        data["confirmed_en"] = this.confirmed_en !== undefined ? this.confirmed_en : null as any;
        return data;
    }
}

export interface IDatoAggiuntivoTipo {
    id?: number;
    tipoDatiID?: number;
    traduzioni?: AdditionalDataTypeTranslation[] | null;
    tipoServizio?: ETipoServizio | null;
    nome: string;
    ordine?: number | null;
    usaPerRicerca?: boolean;
    codice?: string | null;
    standard?: boolean;
    nome_en?: string | null;
    mostra_descr?: number | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean | null;
    confirmed_en?: boolean | null;
}

export class AdditionalDataTypeTranslation extends WebTranslation implements IAdditionalDataTypeTranslation {

    constructor(data?: IAdditionalDataTypeTranslation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): AdditionalDataTypeTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalDataTypeTranslation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalDataTypeTranslation extends IWebTranslation {
}

export enum ETipoServizio {
    TrasferimentiEVisite = "TrasferimentiEVisite",
    NoleggiAuto = "NoleggiAuto",
    SelfDrive = "SelfDrive",
    TourECrociere = "TourECrociere",
    Hotel = "Hotel",
    KitViaggio = "KitViaggio",
    Pacchetti = "Pacchetti",
    Voli = "Voli",
    KitViaggioOLD = "KitViaggioOLD",
    ItinerariConsigliati = "ItinerariConsigliati",
    PacchettiDinamici = "PacchettiDinamici",
    PacchettiCatalogo = "PacchettiCatalogo",
}

export class AdditionalsDataTypesDeleteResponse extends OkApiResponse implements IAdditionalsDataTypesDeleteResponse {

    constructor(data?: IAdditionalsDataTypesDeleteResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): AdditionalsDataTypesDeleteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalsDataTypesDeleteResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalsDataTypesDeleteResponse extends IOkApiResponse {
}

export class AdditionalsDataTypesDeleteRequest extends AdditionalsDataTypesGetRequest implements IAdditionalsDataTypesDeleteRequest {

    constructor(data?: IAdditionalsDataTypesDeleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): AdditionalsDataTypesDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalsDataTypesDeleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalsDataTypesDeleteRequest extends IAdditionalsDataTypesGetRequest {
}

export class AdditionalsDataTypesGetResponse extends OkApiResponse implements IAdditionalsDataTypesGetResponse {
    additionalDataType?: DatoAggiuntivoTipo | null;

    constructor(data?: IAdditionalsDataTypesGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.additionalDataType = _data["additionalDataType"] ? DatoAggiuntivoTipo.fromJS(_data["additionalDataType"]) : null as any;
        }
    }

    static override fromJS(data: any): AdditionalsDataTypesGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalsDataTypesGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalDataType"] = this.additionalDataType ? this.additionalDataType.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalsDataTypesGetResponse extends IOkApiResponse {
    additionalDataType?: DatoAggiuntivoTipo | null;
}

export class NrTableResponseOfAdditionalDataTypeRow extends OkApiResponse implements INrTableResponseOfAdditionalDataTypeRow {
    /** Array delle righe della pagina richiesta */
    rows?: AdditionalDataTypeRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfAdditionalDataTypeRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AdditionalDataTypeRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfAdditionalDataTypeRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfAdditionalDataTypeRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfAdditionalDataTypeRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: AdditionalDataTypeRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class AdditionalDataTypeListResponse extends NrTableResponseOfAdditionalDataTypeRow implements IAdditionalDataTypeListResponse {

    constructor(data?: IAdditionalDataTypeListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): AdditionalDataTypeListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalDataTypeListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalDataTypeListResponse extends INrTableResponseOfAdditionalDataTypeRow {
}

export class AdditionalDataTypeRow implements IAdditionalDataTypeRow {
    id?: number;
    order?: number | null;
    type?: string | null;
    ricerca?: boolean;
    standard?: boolean;
    mostra_desc?: number | null;
    name?: string;
    name_en?: string | null;
    name_ep?: string | null;
    name_fr?: string | null;
    name_de?: string | null;
    name_es?: string | null;
    serviceType?: ETipoServizio | null;

    constructor(data?: IAdditionalDataTypeRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.order = _data["order"] !== undefined ? _data["order"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.ricerca = _data["ricerca"] !== undefined ? _data["ricerca"] : null as any;
            this.standard = _data["standard"] !== undefined ? _data["standard"] : null as any;
            this.mostra_desc = _data["mostra_desc"] !== undefined ? _data["mostra_desc"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.name_en = _data["name_en"] !== undefined ? _data["name_en"] : null as any;
            this.name_ep = _data["name_ep"] !== undefined ? _data["name_ep"] : null as any;
            this.name_fr = _data["name_fr"] !== undefined ? _data["name_fr"] : null as any;
            this.name_de = _data["name_de"] !== undefined ? _data["name_de"] : null as any;
            this.name_es = _data["name_es"] !== undefined ? _data["name_es"] : null as any;
            this.serviceType = _data["serviceType"] !== undefined ? _data["serviceType"] : null as any;
        }
    }

    static fromJS(data: any): AdditionalDataTypeRow {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalDataTypeRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["order"] = this.order !== undefined ? this.order : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["ricerca"] = this.ricerca !== undefined ? this.ricerca : null as any;
        data["standard"] = this.standard !== undefined ? this.standard : null as any;
        data["mostra_desc"] = this.mostra_desc !== undefined ? this.mostra_desc : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["name_en"] = this.name_en !== undefined ? this.name_en : null as any;
        data["name_ep"] = this.name_ep !== undefined ? this.name_ep : null as any;
        data["name_fr"] = this.name_fr !== undefined ? this.name_fr : null as any;
        data["name_de"] = this.name_de !== undefined ? this.name_de : null as any;
        data["name_es"] = this.name_es !== undefined ? this.name_es : null as any;
        data["serviceType"] = this.serviceType !== undefined ? this.serviceType : null as any;
        return data;
    }
}

export interface IAdditionalDataTypeRow {
    id?: number;
    order?: number | null;
    type?: string | null;
    ricerca?: boolean;
    standard?: boolean;
    mostra_desc?: number | null;
    name?: string;
    name_en?: string | null;
    name_ep?: string | null;
    name_fr?: string | null;
    name_de?: string | null;
    name_es?: string | null;
    serviceType?: ETipoServizio | null;
}

export class AdditionalsDataTypesListRequest extends NrTableRequest implements IAdditionalsDataTypesListRequest {
    term?: string | null;
    serviceID?: number | null;

    constructor(data?: IAdditionalsDataTypesListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : null as any;
            this.serviceID = _data["serviceID"] !== undefined ? _data["serviceID"] : null as any;
        }
    }

    static override fromJS(data: any): AdditionalsDataTypesListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalsDataTypesListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : null as any;
        data["serviceID"] = this.serviceID !== undefined ? this.serviceID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalsDataTypesListRequest extends INrTableRequest {
    term?: string | null;
    serviceID?: number | null;
}

export class NrTableResponseOfEmailForwarderLogRow extends OkApiResponse implements INrTableResponseOfEmailForwarderLogRow {
    /** Array delle righe della pagina richiesta */
    rows?: EmailForwarderLogRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfEmailForwarderLogRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(EmailForwarderLogRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfEmailForwarderLogRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfEmailForwarderLogRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfEmailForwarderLogRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: EmailForwarderLogRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class GetEmailForwarderLogResponse extends NrTableResponseOfEmailForwarderLogRow implements IGetEmailForwarderLogResponse {

    constructor(data?: IGetEmailForwarderLogResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetEmailForwarderLogResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmailForwarderLogResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetEmailForwarderLogResponse extends INrTableResponseOfEmailForwarderLogRow {
}

export class EmailForwarderLogRow implements IEmailForwarderLogRow {
    id?: number;
    contactID?: number | null;
    forwardedDate?: string | null;
    senderEmail?: string | null;
    forwardedToEmail?: string | null;
    statusID?: EEmailForwardedStatus | null;
    mailSubject?: string | null;
    reservationNumber?: string | null;
    offertaID?: number | null;

    constructor(data?: IEmailForwarderLogRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.contactID = _data["contactID"] !== undefined ? _data["contactID"] : null as any;
            this.forwardedDate = _data["forwardedDate"] !== undefined ? _data["forwardedDate"] : null as any;
            this.senderEmail = _data["senderEmail"] !== undefined ? _data["senderEmail"] : null as any;
            this.forwardedToEmail = _data["forwardedToEmail"] !== undefined ? _data["forwardedToEmail"] : null as any;
            this.statusID = _data["statusID"] !== undefined ? _data["statusID"] : null as any;
            this.mailSubject = _data["mailSubject"] !== undefined ? _data["mailSubject"] : null as any;
            this.reservationNumber = _data["reservationNumber"] !== undefined ? _data["reservationNumber"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
        }
    }

    static fromJS(data: any): EmailForwarderLogRow {
        data = typeof data === 'object' ? data : {};
        let result = new EmailForwarderLogRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["contactID"] = this.contactID !== undefined ? this.contactID : null as any;
        data["forwardedDate"] = this.forwardedDate !== undefined ? this.forwardedDate : null as any;
        data["senderEmail"] = this.senderEmail !== undefined ? this.senderEmail : null as any;
        data["forwardedToEmail"] = this.forwardedToEmail !== undefined ? this.forwardedToEmail : null as any;
        data["statusID"] = this.statusID !== undefined ? this.statusID : null as any;
        data["mailSubject"] = this.mailSubject !== undefined ? this.mailSubject : null as any;
        data["reservationNumber"] = this.reservationNumber !== undefined ? this.reservationNumber : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        return data;
    }
}

export interface IEmailForwarderLogRow {
    id?: number;
    contactID?: number | null;
    forwardedDate?: string | null;
    senderEmail?: string | null;
    forwardedToEmail?: string | null;
    statusID?: EEmailForwardedStatus | null;
    mailSubject?: string | null;
    reservationNumber?: string | null;
    offertaID?: number | null;
}

export enum EEmailForwardedStatus {
    Ok = "Ok",
    Error = "Error",
    NotForwarded = "NotForwarded",
}

export class GetEmailForwarderLogRequest extends NrTableRequest implements IGetEmailForwarderLogRequest {
    startDate?: string | null;
    endDate?: string | null;
    toEmail?: string | null;
    fromEmail?: string | null;
    subject?: string | null;
    status?: EEmailForwardedStatus | null;
    contactID?: number | null;
    reservationNumber?: string | null;
    offertaID?: number | null;
    externalOnly?: boolean;

    constructor(data?: IGetEmailForwarderLogRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.startDate = _data["startDate"] !== undefined ? _data["startDate"] : null as any;
            this.endDate = _data["endDate"] !== undefined ? _data["endDate"] : null as any;
            this.toEmail = _data["toEmail"] !== undefined ? _data["toEmail"] : null as any;
            this.fromEmail = _data["fromEmail"] !== undefined ? _data["fromEmail"] : null as any;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.contactID = _data["contactID"] !== undefined ? _data["contactID"] : null as any;
            this.reservationNumber = _data["reservationNumber"] !== undefined ? _data["reservationNumber"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.externalOnly = _data["externalOnly"] !== undefined ? _data["externalOnly"] : null as any;
        }
    }

    static override fromJS(data: any): GetEmailForwarderLogRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmailForwarderLogRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate !== undefined ? this.startDate : null as any;
        data["endDate"] = this.endDate !== undefined ? this.endDate : null as any;
        data["toEmail"] = this.toEmail !== undefined ? this.toEmail : null as any;
        data["fromEmail"] = this.fromEmail !== undefined ? this.fromEmail : null as any;
        data["subject"] = this.subject !== undefined ? this.subject : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["contactID"] = this.contactID !== undefined ? this.contactID : null as any;
        data["reservationNumber"] = this.reservationNumber !== undefined ? this.reservationNumber : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["externalOnly"] = this.externalOnly !== undefined ? this.externalOnly : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetEmailForwarderLogRequest extends INrTableRequest {
    startDate?: string | null;
    endDate?: string | null;
    toEmail?: string | null;
    fromEmail?: string | null;
    subject?: string | null;
    status?: EEmailForwardedStatus | null;
    contactID?: number | null;
    reservationNumber?: string | null;
    offertaID?: number | null;
    externalOnly?: boolean;
}

export class AdvancePaymentGetRequest extends LocalizedRequest implements IAdvancePaymentGetRequest {
    /** ID dell'entità da recuperare */
    id?: number;

    constructor(data?: IAdvancePaymentGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): AdvancePaymentGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancePaymentGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAdvancePaymentGetRequest extends ILocalizedRequest {
    /** ID dell'entità da recuperare */
    id?: number;
}

export class AdvancePaymentDeletePreviewResponse extends OkApiResponse implements IAdvancePaymentDeletePreviewResponse {
    /** Se true è possibile procedere all'eliminazione */
    okToDelete?: boolean;
    /** Numero di righe di dati offerte che hanno l'ID che si sta per cancellare */
    affectedCount?: number;

    constructor(data?: IAdvancePaymentDeletePreviewResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.okToDelete = _data["okToDelete"] !== undefined ? _data["okToDelete"] : null as any;
            this.affectedCount = _data["affectedCount"] !== undefined ? _data["affectedCount"] : null as any;
        }
    }

    static override fromJS(data: any): AdvancePaymentDeletePreviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancePaymentDeletePreviewResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["okToDelete"] = this.okToDelete !== undefined ? this.okToDelete : null as any;
        data["affectedCount"] = this.affectedCount !== undefined ? this.affectedCount : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAdvancePaymentDeletePreviewResponse extends IOkApiResponse {
    /** Se true è possibile procedere all'eliminazione */
    okToDelete?: boolean;
    /** Numero di righe di dati offerte che hanno l'ID che si sta per cancellare */
    affectedCount?: number;
}

export class AdvancePaymentGetResponse extends OkApiResponse implements IAdvancePaymentGetResponse {
    /** Entità letta */
    servizioAnticipoFornitore?: ServizioAnticipoFornitore;

    constructor(data?: IAdvancePaymentGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioAnticipoFornitore = _data["servizioAnticipoFornitore"] ? ServizioAnticipoFornitore.fromJS(_data["servizioAnticipoFornitore"]) : null as any;
        }
    }

    static override fromJS(data: any): AdvancePaymentGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancePaymentGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioAnticipoFornitore"] = this.servizioAnticipoFornitore ? this.servizioAnticipoFornitore.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAdvancePaymentGetResponse extends IOkApiResponse {
    /** Entità letta */
    servizioAnticipoFornitore?: ServizioAnticipoFornitore;
}

export class ServizioAnticipoFornitore implements IServizioAnticipoFornitore {
    id?: number;
    nome!: string;
    servizioID?: number | null;
    accordoID?: number | null;
    luogoID?: number | null;
    tipoServizio?: ETipoServizio | null;
    dal?: string | null;
    al?: string | null;
    ordine?: number;
    note?: string | null;
    tipoAnticipo?: ETipoAnticipoFornitore;
    valore?: number;
    moltiplicaPerPax?: boolean;
    valutaID?: number | null;
    entroGiorni?: number | null;
    entroGiorniDaInizioServizio?: boolean;

    constructor(data?: IServizioAnticipoFornitore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.al = _data["al"] !== undefined ? _data["al"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.tipoAnticipo = _data["tipoAnticipo"] !== undefined ? _data["tipoAnticipo"] : null as any;
            this.valore = _data["valore"] !== undefined ? _data["valore"] : null as any;
            this.moltiplicaPerPax = _data["moltiplicaPerPax"] !== undefined ? _data["moltiplicaPerPax"] : null as any;
            this.valutaID = _data["valutaID"] !== undefined ? _data["valutaID"] : null as any;
            this.entroGiorni = _data["entroGiorni"] !== undefined ? _data["entroGiorni"] : null as any;
            this.entroGiorniDaInizioServizio = _data["entroGiorniDaInizioServizio"] !== undefined ? _data["entroGiorniDaInizioServizio"] : null as any;
        }
    }

    static fromJS(data: any): ServizioAnticipoFornitore {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioAnticipoFornitore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["al"] = this.al !== undefined ? this.al : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["tipoAnticipo"] = this.tipoAnticipo !== undefined ? this.tipoAnticipo : null as any;
        data["valore"] = this.valore !== undefined ? this.valore : null as any;
        data["moltiplicaPerPax"] = this.moltiplicaPerPax !== undefined ? this.moltiplicaPerPax : null as any;
        data["valutaID"] = this.valutaID !== undefined ? this.valutaID : null as any;
        data["entroGiorni"] = this.entroGiorni !== undefined ? this.entroGiorni : null as any;
        data["entroGiorniDaInizioServizio"] = this.entroGiorniDaInizioServizio !== undefined ? this.entroGiorniDaInizioServizio : null as any;
        return data;
    }
}

export interface IServizioAnticipoFornitore {
    id?: number;
    nome: string;
    servizioID?: number | null;
    accordoID?: number | null;
    luogoID?: number | null;
    tipoServizio?: ETipoServizio | null;
    dal?: string | null;
    al?: string | null;
    ordine?: number;
    note?: string | null;
    tipoAnticipo?: ETipoAnticipoFornitore;
    valore?: number;
    moltiplicaPerPax?: boolean;
    valutaID?: number | null;
    entroGiorni?: number | null;
    entroGiorniDaInizioServizio?: boolean;
}

export enum ETipoAnticipoFornitore {
    ImportoFisso = "ImportoFisso",
    Percentuale = "Percentuale",
    Notti = "Notti",
}

export class NrTableResponseOfAdvancePaymentRow extends OkApiResponse implements INrTableResponseOfAdvancePaymentRow {
    /** Array delle righe della pagina richiesta */
    rows?: AdvancePaymentRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfAdvancePaymentRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AdvancePaymentRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfAdvancePaymentRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfAdvancePaymentRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfAdvancePaymentRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: AdvancePaymentRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class AdvancePaymentsList extends NrTableResponseOfAdvancePaymentRow implements IAdvancePaymentsList {

    constructor(data?: IAdvancePaymentsList) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): AdvancePaymentsList {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancePaymentsList();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAdvancePaymentsList extends INrTableResponseOfAdvancePaymentRow {
}

export class AdvancePaymentRow implements IAdvancePaymentRow {
    /** ID dell'entità */
    id?: number;
    /** Entità */
    servizioAnticipoFornitore?: ServizioAnticipoFornitore;
    /** Nome in lingua del servizio (se c'è) */
    servizio?: string | null;
    /** True se il servizio è obsoleto */
    servizioObsoleto?: boolean;
    /** True se il servizio è eliminato */
    servizioEliminato?: boolean;
    /** Nome dell'accordo (se c'è) */
    accordo?: string | null;
    /** Nome in lingua del luogo (se c'è) */
    luogo?: string | null;
    luogoEliminato?: boolean;

    constructor(data?: IAdvancePaymentRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.servizioAnticipoFornitore = _data["servizioAnticipoFornitore"] ? ServizioAnticipoFornitore.fromJS(_data["servizioAnticipoFornitore"]) : null as any;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : null as any;
            this.servizioObsoleto = _data["servizioObsoleto"] !== undefined ? _data["servizioObsoleto"] : null as any;
            this.servizioEliminato = _data["servizioEliminato"] !== undefined ? _data["servizioEliminato"] : null as any;
            this.accordo = _data["accordo"] !== undefined ? _data["accordo"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.luogoEliminato = _data["luogoEliminato"] !== undefined ? _data["luogoEliminato"] : null as any;
        }
    }

    static fromJS(data: any): AdvancePaymentRow {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancePaymentRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["servizioAnticipoFornitore"] = this.servizioAnticipoFornitore ? this.servizioAnticipoFornitore.toJSON() : null as any;
        data["servizio"] = this.servizio !== undefined ? this.servizio : null as any;
        data["servizioObsoleto"] = this.servizioObsoleto !== undefined ? this.servizioObsoleto : null as any;
        data["servizioEliminato"] = this.servizioEliminato !== undefined ? this.servizioEliminato : null as any;
        data["accordo"] = this.accordo !== undefined ? this.accordo : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["luogoEliminato"] = this.luogoEliminato !== undefined ? this.luogoEliminato : null as any;
        return data;
    }
}

export interface IAdvancePaymentRow {
    /** ID dell'entità */
    id?: number;
    /** Entità */
    servizioAnticipoFornitore?: ServizioAnticipoFornitore;
    /** Nome in lingua del servizio (se c'è) */
    servizio?: string | null;
    /** True se il servizio è obsoleto */
    servizioObsoleto?: boolean;
    /** True se il servizio è eliminato */
    servizioEliminato?: boolean;
    /** Nome dell'accordo (se c'è) */
    accordo?: string | null;
    /** Nome in lingua del luogo (se c'è) */
    luogo?: string | null;
    luogoEliminato?: boolean;
}

export class AdvancePaymentsListRequest extends NrTableRequest implements IAdvancePaymentsListRequest {
    /** Testo da cercare nelle note */
    term?: string | null;
    /** Accordo associato */
    accordoID?: number | null;
    /** Solo non associati ad accordo */
    noAccordo?: boolean;
    /** Tipo di servizio associato */
    tipoServizio?: ETipoServizio | null;
    /** Sono non associati a tipo servizio */
    noTipoServizio?: boolean;
    /** Servizio associato */
    servizioID?: number | null;
    /** Solo non associati a servizio */
    noServizio?: boolean;
    /** Luogo associato */
    luogoID?: number | null;
    /** Solo non associati a luogo */
    noLuogo?: boolean;

    constructor(data?: IAdvancePaymentsListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : null as any;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.noAccordo = _data["noAccordo"] !== undefined ? _data["noAccordo"] : null as any;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
            this.noTipoServizio = _data["noTipoServizio"] !== undefined ? _data["noTipoServizio"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.noServizio = _data["noServizio"] !== undefined ? _data["noServizio"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.noLuogo = _data["noLuogo"] !== undefined ? _data["noLuogo"] : null as any;
        }
    }

    static override fromJS(data: any): AdvancePaymentsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancePaymentsListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : null as any;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["noAccordo"] = this.noAccordo !== undefined ? this.noAccordo : null as any;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        data["noTipoServizio"] = this.noTipoServizio !== undefined ? this.noTipoServizio : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["noServizio"] = this.noServizio !== undefined ? this.noServizio : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["noLuogo"] = this.noLuogo !== undefined ? this.noLuogo : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAdvancePaymentsListRequest extends INrTableRequest {
    /** Testo da cercare nelle note */
    term?: string | null;
    /** Accordo associato */
    accordoID?: number | null;
    /** Solo non associati ad accordo */
    noAccordo?: boolean;
    /** Tipo di servizio associato */
    tipoServizio?: ETipoServizio | null;
    /** Sono non associati a tipo servizio */
    noTipoServizio?: boolean;
    /** Servizio associato */
    servizioID?: number | null;
    /** Solo non associati a servizio */
    noServizio?: boolean;
    /** Luogo associato */
    luogoID?: number | null;
    /** Solo non associati a luogo */
    noLuogo?: boolean;
}

export class AdvancePaymentUpsertRequest extends LocalizedRequest implements IAdvancePaymentUpsertRequest {
    /** Entità da persistere (nuova o modificata) */
    servizioAnticipoFornitore?: ServizioAnticipoFornitoreBase;

    constructor(data?: IAdvancePaymentUpsertRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioAnticipoFornitore = _data["servizioAnticipoFornitore"] ? ServizioAnticipoFornitoreBase.fromJS(_data["servizioAnticipoFornitore"]) : null as any;
        }
    }

    static override fromJS(data: any): AdvancePaymentUpsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancePaymentUpsertRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioAnticipoFornitore"] = this.servizioAnticipoFornitore ? this.servizioAnticipoFornitore.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAdvancePaymentUpsertRequest extends ILocalizedRequest {
    /** Entità da persistere (nuova o modificata) */
    servizioAnticipoFornitore?: ServizioAnticipoFornitoreBase;
}

export abstract class ServizioAnticipoFornitoreBase implements IServizioAnticipoFornitoreBase {
    id?: number;
    nome?: string;
    servizioID?: number | null;
    accordoID?: number | null;
    luogoID?: number | null;
    tipoServizio?: ETipoServizio | null;
    dal?: string | null;
    al?: string | null;
    ordine?: number;
    note?: string | null;
    tipoAnticipo?: ETipoAnticipoFornitore;
    valore?: number;
    moltiplicaPerPax?: boolean;
    valutaID?: number | null;
    entroGiorni?: number | null;
    entroGiorniDaInizioServizio?: boolean;

    constructor(data?: IServizioAnticipoFornitoreBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.al = _data["al"] !== undefined ? _data["al"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.tipoAnticipo = _data["tipoAnticipo"] !== undefined ? _data["tipoAnticipo"] : null as any;
            this.valore = _data["valore"] !== undefined ? _data["valore"] : null as any;
            this.moltiplicaPerPax = _data["moltiplicaPerPax"] !== undefined ? _data["moltiplicaPerPax"] : null as any;
            this.valutaID = _data["valutaID"] !== undefined ? _data["valutaID"] : null as any;
            this.entroGiorni = _data["entroGiorni"] !== undefined ? _data["entroGiorni"] : null as any;
            this.entroGiorniDaInizioServizio = _data["entroGiorniDaInizioServizio"] !== undefined ? _data["entroGiorniDaInizioServizio"] : null as any;
        }
    }

    static fromJS(data: any): ServizioAnticipoFornitoreBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ServizioAnticipoFornitoreBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["al"] = this.al !== undefined ? this.al : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["tipoAnticipo"] = this.tipoAnticipo !== undefined ? this.tipoAnticipo : null as any;
        data["valore"] = this.valore !== undefined ? this.valore : null as any;
        data["moltiplicaPerPax"] = this.moltiplicaPerPax !== undefined ? this.moltiplicaPerPax : null as any;
        data["valutaID"] = this.valutaID !== undefined ? this.valutaID : null as any;
        data["entroGiorni"] = this.entroGiorni !== undefined ? this.entroGiorni : null as any;
        data["entroGiorniDaInizioServizio"] = this.entroGiorniDaInizioServizio !== undefined ? this.entroGiorniDaInizioServizio : null as any;
        return data;
    }
}

export interface IServizioAnticipoFornitoreBase {
    id?: number;
    nome?: string;
    servizioID?: number | null;
    accordoID?: number | null;
    luogoID?: number | null;
    tipoServizio?: ETipoServizio | null;
    dal?: string | null;
    al?: string | null;
    ordine?: number;
    note?: string | null;
    tipoAnticipo?: ETipoAnticipoFornitore;
    valore?: number;
    moltiplicaPerPax?: boolean;
    valutaID?: number | null;
    entroGiorni?: number | null;
    entroGiorniDaInizioServizio?: boolean;
}

export class HelpContentGetResponse extends OkApiResponse implements IHelpContentGetResponse {
    videos?: YouTubeVideo[] | null;
    nextPageToken?: string | null;
    prevPageToken?: string | null;

    constructor(data?: IHelpContentGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["videos"])) {
                this.videos = [] as any;
                for (let item of _data["videos"])
                    this.videos!.push(YouTubeVideo.fromJS(item));
            }
            else {
                this.videos = null as any;
            }
            this.nextPageToken = _data["nextPageToken"] !== undefined ? _data["nextPageToken"] : null as any;
            this.prevPageToken = _data["prevPageToken"] !== undefined ? _data["prevPageToken"] : null as any;
        }
    }

    static override fromJS(data: any): HelpContentGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HelpContentGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.videos)) {
            data["videos"] = [];
            for (let item of this.videos)
                data["videos"].push(item ? item.toJSON() : null as any);
        }
        data["nextPageToken"] = this.nextPageToken !== undefined ? this.nextPageToken : null as any;
        data["prevPageToken"] = this.prevPageToken !== undefined ? this.prevPageToken : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IHelpContentGetResponse extends IOkApiResponse {
    videos?: YouTubeVideo[] | null;
    nextPageToken?: string | null;
    prevPageToken?: string | null;
}

export class YouTubeVideo implements IYouTubeVideo {
    id?: string | null;
    publishedAt?: string;
    player?: string | null;
    title?: string | null;
    tags?: string[] | null;
    thumbnails?: YouTubeThumbnails | null;

    constructor(data?: IYouTubeVideo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.publishedAt = _data["publishedAt"] !== undefined ? _data["publishedAt"] : null as any;
            this.player = _data["player"] !== undefined ? _data["player"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            else {
                this.tags = null as any;
            }
            this.thumbnails = _data["thumbnails"] ? YouTubeThumbnails.fromJS(_data["thumbnails"]) : null as any;
        }
    }

    static fromJS(data: any): YouTubeVideo {
        data = typeof data === 'object' ? data : {};
        let result = new YouTubeVideo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["publishedAt"] = this.publishedAt !== undefined ? this.publishedAt : null as any;
        data["player"] = this.player !== undefined ? this.player : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["thumbnails"] = this.thumbnails ? this.thumbnails.toJSON() : null as any;
        return data;
    }
}

export interface IYouTubeVideo {
    id?: string | null;
    publishedAt?: string;
    player?: string | null;
    title?: string | null;
    tags?: string[] | null;
    thumbnails?: YouTubeThumbnails | null;
}

export class YouTubeThumbnails implements IYouTubeThumbnails {
    default?: YouTubeThumbnail | null;
    medium?: YouTubeThumbnail | null;
    high?: YouTubeThumbnail | null;
    standard?: YouTubeThumbnail | null;
    maxres?: YouTubeThumbnail | null;

    constructor(data?: IYouTubeThumbnails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.default = _data["default"] ? YouTubeThumbnail.fromJS(_data["default"]) : null as any;
            this.medium = _data["medium"] ? YouTubeThumbnail.fromJS(_data["medium"]) : null as any;
            this.high = _data["high"] ? YouTubeThumbnail.fromJS(_data["high"]) : null as any;
            this.standard = _data["standard"] ? YouTubeThumbnail.fromJS(_data["standard"]) : null as any;
            this.maxres = _data["maxres"] ? YouTubeThumbnail.fromJS(_data["maxres"]) : null as any;
        }
    }

    static fromJS(data: any): YouTubeThumbnails {
        data = typeof data === 'object' ? data : {};
        let result = new YouTubeThumbnails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["default"] = this.default ? this.default.toJSON() : null as any;
        data["medium"] = this.medium ? this.medium.toJSON() : null as any;
        data["high"] = this.high ? this.high.toJSON() : null as any;
        data["standard"] = this.standard ? this.standard.toJSON() : null as any;
        data["maxres"] = this.maxres ? this.maxres.toJSON() : null as any;
        return data;
    }
}

export interface IYouTubeThumbnails {
    default?: YouTubeThumbnail | null;
    medium?: YouTubeThumbnail | null;
    high?: YouTubeThumbnail | null;
    standard?: YouTubeThumbnail | null;
    maxres?: YouTubeThumbnail | null;
}

export class YouTubeThumbnail implements IYouTubeThumbnail {
    url?: string | null;
    width?: number;
    height?: number;

    constructor(data?: IYouTubeThumbnail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
            this.width = _data["width"] !== undefined ? _data["width"] : null as any;
            this.height = _data["height"] !== undefined ? _data["height"] : null as any;
        }
    }

    static fromJS(data: any): YouTubeThumbnail {
        data = typeof data === 'object' ? data : {};
        let result = new YouTubeThumbnail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url !== undefined ? this.url : null as any;
        data["width"] = this.width !== undefined ? this.width : null as any;
        data["height"] = this.height !== undefined ? this.height : null as any;
        return data;
    }
}

export interface IYouTubeThumbnail {
    url?: string | null;
    width?: number;
    height?: number;
}

export class HelpContentGetRequest extends ApiRequest implements IHelpContentGetRequest {
    pageSize?: number;
    pageToken?: string | null;

    constructor(data?: IHelpContentGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
            this.pageToken = _data["pageToken"] !== undefined ? _data["pageToken"] : null as any;
        }
    }

    static override fromJS(data: any): HelpContentGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HelpContentGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        data["pageToken"] = this.pageToken !== undefined ? this.pageToken : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IHelpContentGetRequest extends IApiRequest {
    pageSize?: number;
    pageToken?: string | null;
}

/** Response for the delete chat operation. */
export class DeleteChatResponse extends ApiResponse implements IDeleteChatResponse {
    /** Whether the chat was successfully deleted. */
    success?: boolean;
    /** ID of the chat that was deleted. */
    chatID?: number;

    constructor(data?: IDeleteChatResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.success = _data["success"] !== undefined ? _data["success"] : null as any;
            this.chatID = _data["chatID"] !== undefined ? _data["chatID"] : null as any;
        }
    }

    static override fromJS(data: any): DeleteChatResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteChatResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : null as any;
        data["chatID"] = this.chatID !== undefined ? this.chatID : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Response for the delete chat operation. */
export interface IDeleteChatResponse extends IApiResponse {
    /** Whether the chat was successfully deleted. */
    success?: boolean;
    /** ID of the chat that was deleted. */
    chatID?: number;
}

export class AIChatRequest extends ApiRequest implements IAIChatRequest {

    constructor(data?: IAIChatRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): AIChatRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AIChatRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAIChatRequest extends IApiRequest {
}

/** Request for deleting a conversation. */
export class DeleteChatRequest extends AIChatRequest implements IDeleteChatRequest {
    /** ID of the chat to delete.
Range: 1 to MaxValue. */
    chatID!: number;

    constructor(data?: IDeleteChatRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.chatID = _data["chatID"] !== undefined ? _data["chatID"] : null as any;
        }
    }

    static override fromJS(data: any): DeleteChatRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteChatRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chatID"] = this.chatID !== undefined ? this.chatID : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Request for deleting a conversation. */
export interface IDeleteChatRequest extends IAIChatRequest {
    /** ID of the chat to delete.
Range: 1 to MaxValue. */
    chatID: number;
}

/** Request body for get/delete attachment by blob path id. */
export class AttachmentByIdRequest implements IAttachmentByIdRequest {
    /** Blob path (format: userId_date_guid_filename). */
    id?: string | null;

    constructor(data?: IAttachmentByIdRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): AttachmentByIdRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentByIdRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

/** Request body for get/delete attachment by blob path id. */
export interface IAttachmentByIdRequest {
    /** Blob path (format: userId_date_guid_filename). */
    id?: string | null;
}

export class GetChatResponse extends ApiResponse implements IGetChatResponse {
    chat?: ChatDto | null;
    found?: boolean;

    constructor(data?: IGetChatResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.chat = _data["chat"] ? ChatDto.fromJS(_data["chat"]) : null as any;
            this.found = _data["found"] !== undefined ? _data["found"] : null as any;
        }
    }

    static override fromJS(data: any): GetChatResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetChatResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chat"] = this.chat ? this.chat.toJSON() : null as any;
        data["found"] = this.found !== undefined ? this.found : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetChatResponse extends IApiResponse {
    chat?: ChatDto | null;
    found?: boolean;
}

/** Data transfer object representing a full chat for API responses. Contains chat information and the full message chat as JSON. Used when retrieving a single chat by ID. */
export class ChatDto implements IChatDto {
    /** Unique identifier for this chat. */
    id?: number;
    /** Auto-generated title for the chat.
Derived from the first user message.
Example: "How to reset password" */
    title?: string;
    /** Full chat as JSON string.
Contains an array of messages with sender ID, message text, timestamp, and optional file link.
This can be loaded and reconstructed in the frontend to display the full chat.
            
Example structure:
[
  { "id": "123", "message": "Hello", "timestamp": "2026-02-18T10:00:00Z", "fileLink": null },
  { "id": "ai", "message": "Hi there!", "timestamp": "2026-02-18T10:00:05Z", "fileLink": null }
] */
    chat?: string;
    /** UTC timestamp when this chat was first created.
ISO 8601 format: "2024-01-15T14:30:00Z" */
    createdAt?: string;
    /** UTC timestamp when this chat was last updated.
ISO 8601 format: "2024-01-15T14:35:00Z" */
    updatedAt?: string;

    constructor(data?: IChatDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.chat = _data["chat"] !== undefined ? _data["chat"] : null as any;
            this.createdAt = _data["createdAt"] !== undefined ? _data["createdAt"] : null as any;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : null as any;
        }
    }

    static fromJS(data: any): ChatDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChatDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["chat"] = this.chat !== undefined ? this.chat : null as any;
        data["createdAt"] = this.createdAt !== undefined ? this.createdAt : null as any;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : null as any;
        return data;
    }
}

/** Data transfer object representing a full chat for API responses. Contains chat information and the full message chat as JSON. Used when retrieving a single chat by ID. */
export interface IChatDto {
    /** Unique identifier for this chat. */
    id?: number;
    /** Auto-generated title for the chat.
Derived from the first user message.
Example: "How to reset password" */
    title?: string;
    /** Full chat as JSON string.
Contains an array of messages with sender ID, message text, timestamp, and optional file link.
This can be loaded and reconstructed in the frontend to display the full chat.
            
Example structure:
[
  { "id": "123", "message": "Hello", "timestamp": "2026-02-18T10:00:00Z", "fileLink": null },
  { "id": "ai", "message": "Hi there!", "timestamp": "2026-02-18T10:00:05Z", "fileLink": null }
] */
    chat?: string;
    /** UTC timestamp when this chat was first created.
ISO 8601 format: "2024-01-15T14:30:00Z" */
    createdAt?: string;
    /** UTC timestamp when this chat was last updated.
ISO 8601 format: "2024-01-15T14:35:00Z" */
    updatedAt?: string;
}

export class GetChatByIDRequest extends AIChatRequest implements IGetChatByIDRequest {
    chatID!: number;

    constructor(data?: IGetChatByIDRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.chatID = _data["chatID"] !== undefined ? _data["chatID"] : null as any;
        }
    }

    static override fromJS(data: any): GetChatByIDRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetChatByIDRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chatID"] = this.chatID !== undefined ? this.chatID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetChatByIDRequest extends IAIChatRequest {
    chatID: number;
}

export class NrTableResponseOfChatListItemDto extends OkApiResponse implements INrTableResponseOfChatListItemDto {
    /** Array delle righe della pagina richiesta */
    rows?: ChatListItemDto[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfChatListItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ChatListItemDto.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfChatListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfChatListItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfChatListItemDto extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: ChatListItemDto[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class ListChatsResponse extends NrTableResponseOfChatListItemDto implements IListChatsResponse {

    constructor(data?: IListChatsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ListChatsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListChatsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IListChatsResponse extends INrTableResponseOfChatListItemDto {
}

/** Lightweight data transfer object for chat list view. Contains only essential information (ID, title, dates) for listing. */
export class ChatListItemDto implements IChatListItemDto {
    /** Unique identifier for this chat. */
    id?: number;
    /** Auto-generated title for the chat.
Derived from the first user message.
Example: "How to reset password" */
    title?: string;
    /** UTC timestamp when this chat was first created.
ISO 8601 format: "2024-01-15T14:30:00Z" */
    createdAt?: string;
    /** UTC timestamp when this chat was last updated.
ISO 8601 format: "2024-01-15T14:35:00Z" */
    updatedAt?: string;

    constructor(data?: IChatListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.createdAt = _data["createdAt"] !== undefined ? _data["createdAt"] : null as any;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : null as any;
        }
    }

    static fromJS(data: any): ChatListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChatListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["createdAt"] = this.createdAt !== undefined ? this.createdAt : null as any;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : null as any;
        return data;
    }
}

/** Lightweight data transfer object for chat list view. Contains only essential information (ID, title, dates) for listing. */
export interface IChatListItemDto {
    /** Unique identifier for this chat. */
    id?: number;
    /** Auto-generated title for the chat.
Derived from the first user message.
Example: "How to reset password" */
    title?: string;
    /** UTC timestamp when this chat was first created.
ISO 8601 format: "2024-01-15T14:30:00Z" */
    createdAt?: string;
    /** UTC timestamp when this chat was last updated.
ISO 8601 format: "2024-01-15T14:35:00Z" */
    updatedAt?: string;
}

export class ListChatsRequest extends NrTableRequest implements IListChatsRequest {
    term?: string | null;

    constructor(data?: IListChatsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : null as any;
        }
    }

    static override fromJS(data: any): ListChatsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListChatsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IListChatsRequest extends INrTableRequest {
    term?: string | null;
}

/** Response for the rename chat operation. */
export class RenameChatResponse extends ApiResponse implements IRenameChatResponse {
    /** Whether the chat was successfully renamed. */
    success?: boolean;
    /** ID of the chat that was renamed. */
    chatID?: number;

    constructor(data?: IRenameChatResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.success = _data["success"] !== undefined ? _data["success"] : null as any;
            this.chatID = _data["chatID"] !== undefined ? _data["chatID"] : null as any;
        }
    }

    static override fromJS(data: any): RenameChatResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RenameChatResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : null as any;
        data["chatID"] = this.chatID !== undefined ? this.chatID : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Response for the rename chat operation. */
export interface IRenameChatResponse extends IApiResponse {
    /** Whether the chat was successfully renamed. */
    success?: boolean;
    /** ID of the chat that was renamed. */
    chatID?: number;
}

/** Request for renaming a chat. */
export class RenameChatRequest extends AIChatRequest implements IRenameChatRequest {
    /** ID of the chat to rename.
Range: 1 to MaxValue. */
    chatID!: number;
    /** New title for the chat.
Range: 1–100 characters. */
    title!: string;

    constructor(data?: IRenameChatRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.chatID = _data["chatID"] !== undefined ? _data["chatID"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
        }
    }

    static override fromJS(data: any): RenameChatRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RenameChatRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chatID"] = this.chatID !== undefined ? this.chatID : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Request for renaming a chat. */
export interface IRenameChatRequest extends IAIChatRequest {
    /** ID of the chat to rename.
Range: 1 to MaxValue. */
    chatID: number;
    /** New title for the chat.
Range: 1–100 characters. */
    title: string;
}

export class NaarAIChatRequestResponse extends OkApiResponse implements INaarAIChatRequestResponse {
    message?: string;

    constructor(data?: INaarAIChatRequestResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
        }
    }

    static override fromJS(data: any): NaarAIChatRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAIChatRequestResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarAIChatRequestResponse extends IOkApiResponse {
    message?: string;
}

export class NaarAIChatRequestRequest extends LocalizedRequest implements INaarAIChatRequestRequest {
    message?: string;
    newChat?: boolean;

    constructor(data?: INaarAIChatRequestRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
            this.newChat = _data["newChat"] !== undefined ? _data["newChat"] : null as any;
        }
    }

    static override fromJS(data: any): NaarAIChatRequestRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAIChatRequestRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : null as any;
        data["newChat"] = this.newChat !== undefined ? this.newChat : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarAIChatRequestRequest extends ILocalizedRequest {
    message?: string;
    newChat?: boolean;
}

export class NaarAIListH2HDescriptionsResponse extends OkApiResponse implements INaarAIListH2HDescriptionsResponse {
    /** One entry per supplier that has content. Empty if none. */
    items?: NaarAIH2HDescriptionItem[] | null;

    constructor(data?: INaarAIListH2HDescriptionsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NaarAIH2HDescriptionItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
        }
    }

    static override fromJS(data: any): NaarAIListH2HDescriptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAIListH2HDescriptionsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface INaarAIListH2HDescriptionsResponse extends IOkApiResponse {
    /** One entry per supplier that has content. Empty if none. */
    items?: NaarAIH2HDescriptionItem[] | null;
}

export class NaarAIH2HDescriptionItem implements INaarAIH2HDescriptionItem {
    /** The supplier name, e.g. "EXPEDIA_RAPID". */
    supplier?: string | null;
    /** English description text (auto-translated when the source was not English). */
    text?: string | null;

    constructor(data?: INaarAIH2HDescriptionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : null as any;
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
        }
    }

    static fromJS(data: any): NaarAIH2HDescriptionItem {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAIH2HDescriptionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplier"] = this.supplier !== undefined ? this.supplier : null as any;
        data["text"] = this.text !== undefined ? this.text : null as any;
        return data;
    }
}

export interface INaarAIH2HDescriptionItem {
    /** The supplier name, e.g. "EXPEDIA_RAPID". */
    supplier?: string | null;
    /** English description text (auto-translated when the source was not English). */
    text?: string | null;
}

/** Request to list English descriptions for a service from H2H content suppliers (EXPEDIA_RAPID, HOTELBEDS, RATE_HAWK). Used to populate the AI workbench seed picker. */
export class NaarAIListH2HDescriptionsRequest extends LocalizedRequest implements INaarAIListH2HDescriptionsRequest {
    servizioID?: number;

    constructor(data?: INaarAIListH2HDescriptionsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
        }
    }

    static override fromJS(data: any): NaarAIListH2HDescriptionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAIListH2HDescriptionsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Request to list English descriptions for a service from H2H content suppliers (EXPEDIA_RAPID, HOTELBEDS, RATE_HAWK). Used to populate the AI workbench seed picker. */
export interface INaarAIListH2HDescriptionsRequest extends ILocalizedRequest {
    servizioID?: number;
}

export class NaarAIGenerateHotelDescriptionResponse extends OkApiResponse implements INaarAIGenerateHotelDescriptionResponse {
    testi?: TestoCompleto[] | null;

    constructor(data?: INaarAIGenerateHotelDescriptionResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["testi"])) {
                this.testi = [] as any;
                for (let item of _data["testi"])
                    this.testi!.push(TestoCompleto.fromJS(item));
            }
            else {
                this.testi = null as any;
            }
        }
    }

    static override fromJS(data: any): NaarAIGenerateHotelDescriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAIGenerateHotelDescriptionResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.testi)) {
            data["testi"] = [];
            for (let item of this.testi)
                data["testi"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface INaarAIGenerateHotelDescriptionResponse extends IOkApiResponse {
    testi?: TestoCompleto[] | null;
}

export class TestoCompleto implements ITestoCompleto {
    testoID?: number;
    lingua?: ELingua;
    tipoTesto?: ETipoTesto;
    titolo?: string | null;
    sunto?: string | null;
    testo?: string | null;
    giorno?: number;
    ordine?: number;
    tradottoAutomaticamente?: boolean;
    generatoAI?: boolean;
    allegati?: TestoCompletoAllegato[] | null;

    constructor(data?: ITestoCompleto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.testoID = _data["testoID"] !== undefined ? _data["testoID"] : null as any;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : null as any;
            this.tipoTesto = _data["tipoTesto"] !== undefined ? _data["tipoTesto"] : null as any;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            this.sunto = _data["sunto"] !== undefined ? _data["sunto"] : null as any;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : null as any;
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.tradottoAutomaticamente = _data["tradottoAutomaticamente"] !== undefined ? _data["tradottoAutomaticamente"] : null as any;
            this.generatoAI = _data["generatoAI"] !== undefined ? _data["generatoAI"] : null as any;
            if (Array.isArray(_data["allegati"])) {
                this.allegati = [] as any;
                for (let item of _data["allegati"])
                    this.allegati!.push(TestoCompletoAllegato.fromJS(item));
            }
            else {
                this.allegati = null as any;
            }
        }
    }

    static fromJS(data: any): TestoCompleto {
        data = typeof data === 'object' ? data : {};
        let result = new TestoCompleto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["testoID"] = this.testoID !== undefined ? this.testoID : null as any;
        data["lingua"] = this.lingua !== undefined ? this.lingua : null as any;
        data["tipoTesto"] = this.tipoTesto !== undefined ? this.tipoTesto : null as any;
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        data["sunto"] = this.sunto !== undefined ? this.sunto : null as any;
        data["testo"] = this.testo !== undefined ? this.testo : null as any;
        data["giorno"] = this.giorno !== undefined ? this.giorno : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["tradottoAutomaticamente"] = this.tradottoAutomaticamente !== undefined ? this.tradottoAutomaticamente : null as any;
        data["generatoAI"] = this.generatoAI !== undefined ? this.generatoAI : null as any;
        if (Array.isArray(this.allegati)) {
            data["allegati"] = [];
            for (let item of this.allegati)
                data["allegati"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ITestoCompleto {
    testoID?: number;
    lingua?: ELingua;
    tipoTesto?: ETipoTesto;
    titolo?: string | null;
    sunto?: string | null;
    testo?: string | null;
    giorno?: number;
    ordine?: number;
    tradottoAutomaticamente?: boolean;
    generatoAI?: boolean;
    allegati?: TestoCompletoAllegato[] | null;
}

export enum ETipoTesto {
    Articolo = "Articolo",
    ArticoloTraducibile = "ArticoloTraducibile",
    TestoFornitore = "TestoFornitore",
}

export class TestoCompletoAllegato implements ITestoCompletoAllegato {
    id?: number;
    nome?: string | null;

    constructor(data?: ITestoCompletoAllegato) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
        }
    }

    static fromJS(data: any): TestoCompletoAllegato {
        data = typeof data === 'object' ? data : {};
        let result = new TestoCompletoAllegato();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        return data;
    }
}

export interface ITestoCompletoAllegato {
    id?: number;
    nome?: string | null;
}

export class NaarAIGenerateHotelDescriptionRequest extends LocalizedRequest implements INaarAIGenerateHotelDescriptionRequest {
    servizioID?: number;
    /** true when the hotel is a top-performer city Preferred property
(exhaustive, resort-level depth); false for rest-of-world city/province
hotels (concise but covering every fundamental section). */
    isPreferred?: boolean;
    /** When true, the AI may use web search to fill gaps when the user-provided
input is insufficient and inline cited source links into the article. When false
(default), the AI relies only on the supplied inputs and does not browse the web. */
    useWebSearch?: boolean;

    constructor(data?: INaarAIGenerateHotelDescriptionRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.isPreferred = _data["isPreferred"] !== undefined ? _data["isPreferred"] : null as any;
            this.useWebSearch = _data["useWebSearch"] !== undefined ? _data["useWebSearch"] : null as any;
        }
    }

    static override fromJS(data: any): NaarAIGenerateHotelDescriptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAIGenerateHotelDescriptionRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["isPreferred"] = this.isPreferred !== undefined ? this.isPreferred : null as any;
        data["useWebSearch"] = this.useWebSearch !== undefined ? this.useWebSearch : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarAIGenerateHotelDescriptionRequest extends ILocalizedRequest {
    servizioID?: number;
    /** true when the hotel is a top-performer city Preferred property
(exhaustive, resort-level depth); false for rest-of-world city/province
hotels (concise but covering every fundamental section). */
    isPreferred?: boolean;
    /** When true, the AI may use web search to fill gaps when the user-provided
input is insufficient and inline cited source links into the article. When false
(default), the AI relies only on the supplied inputs and does not browse the web. */
    useWebSearch?: boolean;
}

export class GeneratePlaceDescriptionResponse extends OkApiResponse implements IGeneratePlaceDescriptionResponse {
    /** The generated description in the requested language (Lingua), as flowing prose. */
    testo?: string | null;
    /** The same description translated into Italian, for the base (required) phrase field. */
    testoIta?: string | null;

    constructor(data?: IGeneratePlaceDescriptionResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.testo = _data["testo"] !== undefined ? _data["testo"] : null as any;
            this.testoIta = _data["testoIta"] !== undefined ? _data["testoIta"] : null as any;
        }
    }

    static override fromJS(data: any): GeneratePlaceDescriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GeneratePlaceDescriptionResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["testo"] = this.testo !== undefined ? this.testo : null as any;
        data["testoIta"] = this.testoIta !== undefined ? this.testoIta : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGeneratePlaceDescriptionResponse extends IOkApiResponse {
    /** The generated description in the requested language (Lingua), as flowing prose. */
    testo?: string | null;
    /** The same description translated into Italian, for the base (required) phrase field. */
    testoIta?: string | null;
}

/** Request to generate an AI travel description for a place (luogo). Generation does NOT persist anything; the caller is expected to review the returned text and save through the standard descriptions/phrases/create or descriptions/phrases/update endpoints. */
export class GeneratePlaceDescriptionRequest extends LocalizedRequest implements IGeneratePlaceDescriptionRequest {
    /** The Naar place (luogo) ID the sentence is linked to. */
    luogoID?: number;

    constructor(data?: IGeneratePlaceDescriptionRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
        }
    }

    static override fromJS(data: any): GeneratePlaceDescriptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GeneratePlaceDescriptionRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Request to generate an AI travel description for a place (luogo). Generation does NOT persist anything; the caller is expected to review the returned text and save through the standard descriptions/phrases/create or descriptions/phrases/update endpoints. */
export interface IGeneratePlaceDescriptionRequest extends ILocalizedRequest {
    /** The Naar place (luogo) ID the sentence is linked to. */
    luogoID?: number;
}

/** Response containing generated tour/cruise description */
export class NaarAIGenerateTourDescriptionResponse extends OkApiResponse implements INaarAIGenerateTourDescriptionResponse {
    /** List of generated texts */
    testi?: TestoCompleto[];

    constructor(data?: INaarAIGenerateTourDescriptionResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["testi"])) {
                this.testi = [] as any;
                for (let item of _data["testi"])
                    this.testi!.push(TestoCompleto.fromJS(item));
            }
            else {
                this.testi = null as any;
            }
        }
    }

    static override fromJS(data: any): NaarAIGenerateTourDescriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAIGenerateTourDescriptionResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.testi)) {
            data["testi"] = [];
            for (let item of this.testi)
                data["testi"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Response containing generated tour/cruise description */
export interface INaarAIGenerateTourDescriptionResponse extends IOkApiResponse {
    /** List of generated texts */
    testi?: TestoCompleto[];
}

/** Request to generate tour/cruise description */
export class NaarAIGenerateTourDescriptionRequest extends LocalizedRequest implements INaarAIGenerateTourDescriptionRequest {
    /** The service ID (must be of type TourECrociere) */
    servizioID?: number;

    constructor(data?: INaarAIGenerateTourDescriptionRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
        }
    }

    static override fromJS(data: any): NaarAIGenerateTourDescriptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAIGenerateTourDescriptionRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Request to generate tour/cruise description */
export interface INaarAIGenerateTourDescriptionRequest extends ILocalizedRequest {
    /** The service ID (must be of type TourECrociere) */
    servizioID?: number;
}

export class NaarAITimeZoneGapResponse extends OkApiResponse implements INaarAITimeZoneGapResponse {
    timeZoneOne?: string | null;
    timeZoneTwo?: string | null;
    timeFromGreenwichOne?: string | null;
    timeFromGreenwichTwo?: string | null;
    gap?: number;

    constructor(data?: INaarAITimeZoneGapResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.timeZoneOne = _data["timeZoneOne"] !== undefined ? _data["timeZoneOne"] : null as any;
            this.timeZoneTwo = _data["timeZoneTwo"] !== undefined ? _data["timeZoneTwo"] : null as any;
            this.timeFromGreenwichOne = _data["timeFromGreenwichOne"] !== undefined ? _data["timeFromGreenwichOne"] : null as any;
            this.timeFromGreenwichTwo = _data["timeFromGreenwichTwo"] !== undefined ? _data["timeFromGreenwichTwo"] : null as any;
            this.gap = _data["gap"] !== undefined ? _data["gap"] : null as any;
        }
    }

    static override fromJS(data: any): NaarAITimeZoneGapResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAITimeZoneGapResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZoneOne"] = this.timeZoneOne !== undefined ? this.timeZoneOne : null as any;
        data["timeZoneTwo"] = this.timeZoneTwo !== undefined ? this.timeZoneTwo : null as any;
        data["timeFromGreenwichOne"] = this.timeFromGreenwichOne !== undefined ? this.timeFromGreenwichOne : null as any;
        data["timeFromGreenwichTwo"] = this.timeFromGreenwichTwo !== undefined ? this.timeFromGreenwichTwo : null as any;
        data["gap"] = this.gap !== undefined ? this.gap : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarAITimeZoneGapResponse extends IOkApiResponse {
    timeZoneOne?: string | null;
    timeZoneTwo?: string | null;
    timeFromGreenwichOne?: string | null;
    timeFromGreenwichTwo?: string | null;
    gap?: number;
}

export class NaarAITimeZoneGapRequest extends ApiRequest implements INaarAITimeZoneGapRequest {
    placeFromID!: number;
    placeToID!: number;

    constructor(data?: INaarAITimeZoneGapRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.placeFromID = _data["placeFromID"] !== undefined ? _data["placeFromID"] : null as any;
            this.placeToID = _data["placeToID"] !== undefined ? _data["placeToID"] : null as any;
        }
    }

    static override fromJS(data: any): NaarAITimeZoneGapRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAITimeZoneGapRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["placeFromID"] = this.placeFromID !== undefined ? this.placeFromID : null as any;
        data["placeToID"] = this.placeToID !== undefined ? this.placeToID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarAITimeZoneGapRequest extends IApiRequest {
    placeFromID: number;
    placeToID: number;
}

export class NaarAIQueryDBResponse extends OkApiResponse implements INaarAIQueryDBResponse {
    sqlQuery?: string | null;
    resultData?: StatisticTable | null;

    constructor(data?: INaarAIQueryDBResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sqlQuery = _data["sqlQuery"] !== undefined ? _data["sqlQuery"] : null as any;
            this.resultData = _data["resultData"] ? StatisticTable.fromJS(_data["resultData"]) : null as any;
        }
    }

    static override fromJS(data: any): NaarAIQueryDBResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAIQueryDBResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sqlQuery"] = this.sqlQuery !== undefined ? this.sqlQuery : null as any;
        data["resultData"] = this.resultData ? this.resultData.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarAIQueryDBResponse extends IOkApiResponse {
    sqlQuery?: string | null;
    resultData?: StatisticTable | null;
}

export class StatisticTable implements IStatisticTable {
    columns?: StatisticTableColumn[];
    rows?: { [key: string]: any; }[];
    rowCount?: number;

    constructor(data?: IStatisticTable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(StatisticTableColumn.fromJS(item));
            }
            else {
                this.columns = null as any;
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(item);
            }
            else {
                this.rows = null as any;
            }
            this.rowCount = _data["rowCount"] !== undefined ? _data["rowCount"] : null as any;
        }
    }

    static fromJS(data: any): StatisticTable {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticTable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item);
        }
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : null as any;
        return data;
    }
}

export interface IStatisticTable {
    columns?: StatisticTableColumn[];
    rows?: { [key: string]: any; }[];
    rowCount?: number;
}

export class StatisticTableColumn implements IStatisticTableColumn {
    name?: string;
    format?: string;
    text?: string;
    alignment?: string;

    constructor(data?: IStatisticTableColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.format = _data["format"] !== undefined ? _data["format"] : null as any;
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
            this.alignment = _data["alignment"] !== undefined ? _data["alignment"] : null as any;
        }
    }

    static fromJS(data: any): StatisticTableColumn {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticTableColumn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["format"] = this.format !== undefined ? this.format : null as any;
        data["text"] = this.text !== undefined ? this.text : null as any;
        data["alignment"] = this.alignment !== undefined ? this.alignment : null as any;
        return data;
    }
}

export interface IStatisticTableColumn {
    name?: string;
    format?: string;
    text?: string;
    alignment?: string;
}

export class NaarAIQueryDBRequest extends LocalizedRequest implements INaarAIQueryDBRequest {
    contextTableName?: string | null;
    query?: string | null;

    constructor(data?: INaarAIQueryDBRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contextTableName = _data["contextTableName"] !== undefined ? _data["contextTableName"] : null as any;
            this.query = _data["query"] !== undefined ? _data["query"] : null as any;
        }
    }

    static override fromJS(data: any): NaarAIQueryDBRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAIQueryDBRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contextTableName"] = this.contextTableName !== undefined ? this.contextTableName : null as any;
        data["query"] = this.query !== undefined ? this.query : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarAIQueryDBRequest extends ILocalizedRequest {
    contextTableName?: string | null;
    query?: string | null;
}

export class GenerateArticleResponse extends OkApiResponse implements IGenerateArticleResponse {
    titolo?: string | null;
    sunto?: string | null;
    testo?: string | null;
    /** Web sources used during this generation. Empty when web search was disabled or no
sources were collected. Each entry has Url, RootDomain, Name. */
    sources?: Source[] | null;

    constructor(data?: IGenerateArticleResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            this.sunto = _data["sunto"] !== undefined ? _data["sunto"] : null as any;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : null as any;
            if (Array.isArray(_data["sources"])) {
                this.sources = [] as any;
                for (let item of _data["sources"])
                    this.sources!.push(Source.fromJS(item));
            }
            else {
                this.sources = null as any;
            }
        }
    }

    static override fromJS(data: any): GenerateArticleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateArticleResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        data["sunto"] = this.sunto !== undefined ? this.sunto : null as any;
        data["testo"] = this.testo !== undefined ? this.testo : null as any;
        if (Array.isArray(this.sources)) {
            data["sources"] = [];
            for (let item of this.sources)
                data["sources"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGenerateArticleResponse extends IOkApiResponse {
    titolo?: string | null;
    sunto?: string | null;
    testo?: string | null;
    /** Web sources used during this generation. Empty when web search was disabled or no
sources were collected. Each entry has Url, RootDomain, Name. */
    sources?: Source[] | null;
}

export class Source implements ISource {
    /** The root domain og the website from which information are extracted */
    rootDomain!: string;
    /** Use the path of the url to identify the source with a meaningful name */
    name!: string;
    /** The url of the source */
    url!: string;
    reachable?: boolean;
    failureReason?: string | null;

    constructor(data?: ISource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rootDomain = _data["rootDomain"] !== undefined ? _data["rootDomain"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
            this.reachable = _data["reachable"] !== undefined ? _data["reachable"] : null as any;
            this.failureReason = _data["failureReason"] !== undefined ? _data["failureReason"] : null as any;
        }
    }

    static fromJS(data: any): Source {
        data = typeof data === 'object' ? data : {};
        let result = new Source();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rootDomain"] = this.rootDomain !== undefined ? this.rootDomain : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        data["reachable"] = this.reachable !== undefined ? this.reachable : null as any;
        data["failureReason"] = this.failureReason !== undefined ? this.failureReason : null as any;
        return data;
    }
}

export interface ISource {
    /** The root domain og the website from which information are extracted */
    rootDomain: string;
    /** Use the path of the url to identify the source with a meaningful name */
    name: string;
    /** The url of the source */
    url: string;
    reachable?: boolean;
    failureReason?: string | null;
}

/** Request to regenerate an article description using an AI template. Generation does NOT persist the article; the caller is expected to save through the standard articles/create or articles/update endpoints after previewing. */
export class GenerateArticleRequest extends LocalizedRequest implements IGenerateArticleRequest {
    /** The Naar service ID. */
    servizioID?: number;
    /** Which AI template to use. See eNaarAIArticleTemplate. */
    template?: ENaarAIArticleTemplate;
    /** Optional seed description. Plain text. May be null or empty. */
    seedDescription?: string | null;
    /** Optional freeform instructions from the editor that are injected into the prompt as an
"additional context" block (tone, angle, must-mention details). May be null, empty or whitespace. */
    additionalContext?: string | null;
    /** Honored only when Template is HotelStandard.
true = top-performer city Preferred hotel (exhaustive, resort-level depth);
false = rest-of-world city/province hotel (concise but covering every fundamental section).
Ignored for resort and experience templates. */
    isPreferred?: boolean;
    /** Optional user-uploaded files to use as the highest-priority source material. Each
entry carries the raw file bytes inline (base64). Image-kind attachments are
inlined into the chat request as image_url data URLs; document-kind
attachments are staged in the OpenAI Files API just-in-time and the allocated
file_ids are deleted once the response comes back. Nothing is persisted on
Naar storage. May be null or empty. */
    attachments?: NaarAIAttachmentHandle[] | null;
    /** When true, the AI may use web search to fill gaps when the
user-provided input is insufficient and inline cited source links into the article.
When false (default), the AI relies only on the supplied inputs
and does not browse the web. */
    useWebSearch?: boolean;

    constructor(data?: IGenerateArticleRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.template = _data["template"] !== undefined ? _data["template"] : null as any;
            this.seedDescription = _data["seedDescription"] !== undefined ? _data["seedDescription"] : null as any;
            this.additionalContext = _data["additionalContext"] !== undefined ? _data["additionalContext"] : null as any;
            this.isPreferred = _data["isPreferred"] !== undefined ? _data["isPreferred"] : null as any;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(NaarAIAttachmentHandle.fromJS(item));
            }
            else {
                this.attachments = null as any;
            }
            this.useWebSearch = _data["useWebSearch"] !== undefined ? _data["useWebSearch"] : null as any;
        }
    }

    static override fromJS(data: any): GenerateArticleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateArticleRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["template"] = this.template !== undefined ? this.template : null as any;
        data["seedDescription"] = this.seedDescription !== undefined ? this.seedDescription : null as any;
        data["additionalContext"] = this.additionalContext !== undefined ? this.additionalContext : null as any;
        data["isPreferred"] = this.isPreferred !== undefined ? this.isPreferred : null as any;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : null as any);
        }
        data["useWebSearch"] = this.useWebSearch !== undefined ? this.useWebSearch : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Request to regenerate an article description using an AI template. Generation does NOT persist the article; the caller is expected to save through the standard articles/create or articles/update endpoints after previewing. */
export interface IGenerateArticleRequest extends ILocalizedRequest {
    /** The Naar service ID. */
    servizioID?: number;
    /** Which AI template to use. See eNaarAIArticleTemplate. */
    template?: ENaarAIArticleTemplate;
    /** Optional seed description. Plain text. May be null or empty. */
    seedDescription?: string | null;
    /** Optional freeform instructions from the editor that are injected into the prompt as an
"additional context" block (tone, angle, must-mention details). May be null, empty or whitespace. */
    additionalContext?: string | null;
    /** Honored only when Template is HotelStandard.
true = top-performer city Preferred hotel (exhaustive, resort-level depth);
false = rest-of-world city/province hotel (concise but covering every fundamental section).
Ignored for resort and experience templates. */
    isPreferred?: boolean;
    /** Optional user-uploaded files to use as the highest-priority source material. Each
entry carries the raw file bytes inline (base64). Image-kind attachments are
inlined into the chat request as image_url data URLs; document-kind
attachments are staged in the OpenAI Files API just-in-time and the allocated
file_ids are deleted once the response comes back. Nothing is persisted on
Naar storage. May be null or empty. */
    attachments?: NaarAIAttachmentHandle[] | null;
    /** When true, the AI may use web search to fill gaps when the
user-provided input is insufficient and inline cited source links into the article.
When false (default), the AI relies only on the supplied inputs
and does not browse the web. */
    useWebSearch?: boolean;
}

export enum ENaarAIArticleTemplate {
    HotelStandard = "HotelStandard",
    HotelResort = "HotelResort",
    Experience = "Experience",
}

export class NaarAIAttachmentHandle implements INaarAIAttachmentHandle {
    fileName?: string;
    contentType?: string;
    base64Data?: string;

    constructor(data?: INaarAIAttachmentHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.contentType = _data["contentType"] !== undefined ? _data["contentType"] : null as any;
            this.base64Data = _data["base64Data"] !== undefined ? _data["base64Data"] : null as any;
        }
    }

    static fromJS(data: any): NaarAIAttachmentHandle {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAIAttachmentHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["contentType"] = this.contentType !== undefined ? this.contentType : null as any;
        data["base64Data"] = this.base64Data !== undefined ? this.base64Data : null as any;
        return data;
    }
}

export interface INaarAIAttachmentHandle {
    fileName?: string;
    contentType?: string;
    base64Data?: string;
}

export class NaarAISummarizeTextResponse extends OkApiResponse implements INaarAISummarizeTextResponse {
    summarizedText?: string | null;

    constructor(data?: INaarAISummarizeTextResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.summarizedText = _data["summarizedText"] !== undefined ? _data["summarizedText"] : null as any;
        }
    }

    static override fromJS(data: any): NaarAISummarizeTextResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAISummarizeTextResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summarizedText"] = this.summarizedText !== undefined ? this.summarizedText : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarAISummarizeTextResponse extends IOkApiResponse {
    summarizedText?: string | null;
}

export class NaarAISummarizeTextRequest extends LocalizedRequest implements INaarAISummarizeTextRequest {
    text?: string | null;

    constructor(data?: INaarAISummarizeTextRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
        }
    }

    static override fromJS(data: any): NaarAISummarizeTextRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAISummarizeTextRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text !== undefined ? this.text : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarAISummarizeTextRequest extends ILocalizedRequest {
    text?: string | null;
}

export class NaarAITuningGetRequest extends ApiRequest implements INaarAITuningGetRequest {
    id?: number;

    constructor(data?: INaarAITuningGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): NaarAITuningGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAITuningGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarAITuningGetRequest extends IApiRequest {
    id?: number;
}

export class NaarAITuningDeleteRequest extends NaarAITuningGetRequest implements INaarAITuningDeleteRequest {

    constructor(data?: INaarAITuningDeleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): NaarAITuningDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAITuningDeleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface INaarAITuningDeleteRequest extends INaarAITuningGetRequest {
}

export class NaarAITuningGetResponse extends OkApiResponse implements INaarAITuningGetResponse {
    tuning?: NaarAIRequestTuning | null;

    constructor(data?: INaarAITuningGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tuning = _data["tuning"] ? NaarAIRequestTuning.fromJS(_data["tuning"]) : null as any;
        }
    }

    static override fromJS(data: any): NaarAITuningGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAITuningGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tuning"] = this.tuning ? this.tuning.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarAITuningGetResponse extends IOkApiResponse {
    tuning?: NaarAIRequestTuning | null;
}

export class NaarAIRequestTuning implements INaarAIRequestTuning {
    id!: number;
    name!: string;
    model!: string;
    message!: string;
    params?: { [key: string]: NaarAIRequestTuningParam; } | null;
    assistantMessage?: string | null;
    assistantParams?: { [key: string]: NaarAIRequestTuningParam; } | null;

    constructor(data?: INaarAIRequestTuning) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.model = _data["model"] !== undefined ? _data["model"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
            if (_data["params"]) {
                this.params = {} as any;
                for (let key in _data["params"]) {
                    if (_data["params"].hasOwnProperty(key))
                        (this.params as any)![key] = _data["params"][key] ? NaarAIRequestTuningParam.fromJS(_data["params"][key]) : new NaarAIRequestTuningParam();
                }
            }
            else {
                this.params = null as any;
            }
            this.assistantMessage = _data["assistantMessage"] !== undefined ? _data["assistantMessage"] : null as any;
            if (_data["assistantParams"]) {
                this.assistantParams = {} as any;
                for (let key in _data["assistantParams"]) {
                    if (_data["assistantParams"].hasOwnProperty(key))
                        (this.assistantParams as any)![key] = _data["assistantParams"][key] ? NaarAIRequestTuningParam.fromJS(_data["assistantParams"][key]) : new NaarAIRequestTuningParam();
                }
            }
            else {
                this.assistantParams = null as any;
            }
        }
    }

    static fromJS(data: any): NaarAIRequestTuning {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAIRequestTuning();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["model"] = this.model !== undefined ? this.model : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        if (this.params) {
            data["params"] = {};
            for (let key in this.params) {
                if (this.params.hasOwnProperty(key))
                    (data["params"] as any)[key] = this.params[key] ? this.params[key].toJSON() : null as any;
            }
        }
        data["assistantMessage"] = this.assistantMessage !== undefined ? this.assistantMessage : null as any;
        if (this.assistantParams) {
            data["assistantParams"] = {};
            for (let key in this.assistantParams) {
                if (this.assistantParams.hasOwnProperty(key))
                    (data["assistantParams"] as any)[key] = this.assistantParams[key] ? this.assistantParams[key].toJSON() : null as any;
            }
        }
        return data;
    }
}

export interface INaarAIRequestTuning {
    id: number;
    name: string;
    model: string;
    message: string;
    params?: { [key: string]: NaarAIRequestTuningParam; } | null;
    assistantMessage?: string | null;
    assistantParams?: { [key: string]: NaarAIRequestTuningParam; } | null;
}

export class NaarAIRequestTuningParam implements INaarAIRequestTuningParam {
    type?: string;
    labelId?: string | null;

    constructor(data?: INaarAIRequestTuningParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.labelId = _data["labelId"] !== undefined ? _data["labelId"] : null as any;
        }
    }

    static fromJS(data: any): NaarAIRequestTuningParam {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAIRequestTuningParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["labelId"] = this.labelId !== undefined ? this.labelId : null as any;
        return data;
    }
}

export interface INaarAIRequestTuningParam {
    type?: string;
    labelId?: string | null;
}

export class NrTableResponseOfNaarAIRequestTuning extends OkApiResponse implements INrTableResponseOfNaarAIRequestTuning {
    /** Array delle righe della pagina richiesta */
    rows?: NaarAIRequestTuning[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfNaarAIRequestTuning) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(NaarAIRequestTuning.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfNaarAIRequestTuning {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfNaarAIRequestTuning();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfNaarAIRequestTuning extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: NaarAIRequestTuning[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class NaarAITuningListRequest extends NrTableRequest implements INaarAITuningListRequest {
    name?: string | null;
    model?: string | null;

    constructor(data?: INaarAITuningListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.model = _data["model"] !== undefined ? _data["model"] : null as any;
        }
    }

    static override fromJS(data: any): NaarAITuningListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAITuningListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["model"] = this.model !== undefined ? this.model : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarAITuningListRequest extends INrTableRequest {
    name?: string | null;
    model?: string | null;
}

export class NaarAITuningTestResponse extends OkApiResponse implements INaarAITuningTestResponse {
    response?: string | null;

    constructor(data?: INaarAITuningTestResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.response = _data["response"] !== undefined ? _data["response"] : null as any;
        }
    }

    static override fromJS(data: any): NaarAITuningTestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAITuningTestResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["response"] = this.response !== undefined ? this.response : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarAITuningTestResponse extends IOkApiResponse {
    response?: string | null;
}

export class NaarAITuningTestRequest extends ApiRequest implements INaarAITuningTestRequest {
    tuning?: NaarAIRequestTuning | null;
    userMessage?: string | null;
    parameters?: { [key: string]: string; } | null;

    constructor(data?: INaarAITuningTestRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tuning = _data["tuning"] ? NaarAIRequestTuning.fromJS(_data["tuning"]) : null as any;
            this.userMessage = _data["userMessage"] !== undefined ? _data["userMessage"] : null as any;
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (this.parameters as any)![key] = _data["parameters"][key] !== undefined ? _data["parameters"][key] : null as any;
                }
            }
            else {
                this.parameters = null as any;
            }
        }
    }

    static override fromJS(data: any): NaarAITuningTestRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAITuningTestRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tuning"] = this.tuning ? this.tuning.toJSON() : null as any;
        data["userMessage"] = this.userMessage !== undefined ? this.userMessage : null as any;
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (data["parameters"] as any)[key] = this.parameters[key] !== undefined ? this.parameters[key] : null as any;
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface INaarAITuningTestRequest extends IApiRequest {
    tuning?: NaarAIRequestTuning | null;
    userMessage?: string | null;
    parameters?: { [key: string]: string; } | null;
}

export class NaarAITuningUpsertRequest extends ApiRequest implements INaarAITuningUpsertRequest {
    tuning?: NaarAIRequestTuning | null;

    constructor(data?: INaarAITuningUpsertRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tuning = _data["tuning"] ? NaarAIRequestTuning.fromJS(_data["tuning"]) : null as any;
        }
    }

    static override fromJS(data: any): NaarAITuningUpsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAITuningUpsertRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tuning"] = this.tuning ? this.tuning.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarAITuningUpsertRequest extends IApiRequest {
    tuning?: NaarAIRequestTuning | null;
}

export class AirlineGetResponse extends OkApiResponse implements IAirlineGetResponse {
    airline?: CompagniaAerea;

    constructor(data?: IAirlineGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.airline = _data["airline"] ? CompagniaAerea.fromJS(_data["airline"]) : null as any;
        }
    }

    static override fromJS(data: any): AirlineGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AirlineGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airline"] = this.airline ? this.airline.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAirlineGetResponse extends IOkApiResponse {
    airline?: CompagniaAerea;
}

export class CompagniaAerea implements ICompagniaAerea {
    id?: number;
    codice!: string;
    nome!: string;
    idCpf?: number | null;
    rank?: number | null;
    commissione?: number | null;
    commNazionali?: number | null;
    codiceBSP?: string | null;
    icao?: string | null;
    createdAt?: string;
    updatedAt?: string;
    deletedAt?: string | null;
    searchTerms?: string | null;

    constructor(data?: ICompagniaAerea) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.idCpf = _data["idCpf"] !== undefined ? _data["idCpf"] : null as any;
            this.rank = _data["rank"] !== undefined ? _data["rank"] : null as any;
            this.commissione = _data["commissione"] !== undefined ? _data["commissione"] : null as any;
            this.commNazionali = _data["commNazionali"] !== undefined ? _data["commNazionali"] : null as any;
            this.codiceBSP = _data["codiceBSP"] !== undefined ? _data["codiceBSP"] : null as any;
            this.icao = _data["icao"] !== undefined ? _data["icao"] : null as any;
            this.createdAt = _data["createdAt"] !== undefined ? _data["createdAt"] : null as any;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : null as any;
            this.deletedAt = _data["deletedAt"] !== undefined ? _data["deletedAt"] : null as any;
            this.searchTerms = _data["searchTerms"] !== undefined ? _data["searchTerms"] : null as any;
        }
    }

    static fromJS(data: any): CompagniaAerea {
        data = typeof data === 'object' ? data : {};
        let result = new CompagniaAerea();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["idCpf"] = this.idCpf !== undefined ? this.idCpf : null as any;
        data["rank"] = this.rank !== undefined ? this.rank : null as any;
        data["commissione"] = this.commissione !== undefined ? this.commissione : null as any;
        data["commNazionali"] = this.commNazionali !== undefined ? this.commNazionali : null as any;
        data["codiceBSP"] = this.codiceBSP !== undefined ? this.codiceBSP : null as any;
        data["icao"] = this.icao !== undefined ? this.icao : null as any;
        data["createdAt"] = this.createdAt !== undefined ? this.createdAt : null as any;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : null as any;
        data["deletedAt"] = this.deletedAt !== undefined ? this.deletedAt : null as any;
        data["searchTerms"] = this.searchTerms !== undefined ? this.searchTerms : null as any;
        return data;
    }
}

export interface ICompagniaAerea {
    id?: number;
    codice: string;
    nome: string;
    idCpf?: number | null;
    rank?: number | null;
    commissione?: number | null;
    commNazionali?: number | null;
    codiceBSP?: string | null;
    icao?: string | null;
    createdAt?: string;
    updatedAt?: string;
    deletedAt?: string | null;
    searchTerms?: string | null;
}

export class AirlineGetRequest extends LocalizedRequest implements IAirlineGetRequest {
    airlineID?: number;

    constructor(data?: IAirlineGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.airlineID = _data["airlineID"] !== undefined ? _data["airlineID"] : null as any;
        }
    }

    static override fromJS(data: any): AirlineGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AirlineGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airlineID"] = this.airlineID !== undefined ? this.airlineID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAirlineGetRequest extends ILocalizedRequest {
    airlineID?: number;
}

export class AirlineUpdateRequest extends AirlineGetRequest implements IAirlineUpdateRequest {
    airline?: CompagniaAerea | null;

    constructor(data?: IAirlineUpdateRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.airline = _data["airline"] ? CompagniaAerea.fromJS(_data["airline"]) : null as any;
        }
    }

    static override fromJS(data: any): AirlineUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AirlineUpdateRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airline"] = this.airline ? this.airline.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAirlineUpdateRequest extends IAirlineGetRequest {
    airline?: CompagniaAerea | null;
}

export class AirlineDeleteRequest extends ApiRequest implements IAirlineDeleteRequest {
    airlineID?: number;

    constructor(data?: IAirlineDeleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.airlineID = _data["airlineID"] !== undefined ? _data["airlineID"] : null as any;
        }
    }

    static override fromJS(data: any): AirlineDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AirlineDeleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airlineID"] = this.airlineID !== undefined ? this.airlineID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAirlineDeleteRequest extends IApiRequest {
    airlineID?: number;
}

export class NrTableResponseOfAirlineRow extends OkApiResponse implements INrTableResponseOfAirlineRow {
    /** Array delle righe della pagina richiesta */
    rows?: AirlineRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfAirlineRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AirlineRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfAirlineRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfAirlineRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfAirlineRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: AirlineRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class AirlinesListResponse extends NrTableResponseOfAirlineRow implements IAirlinesListResponse {

    constructor(data?: IAirlinesListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): AirlinesListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AirlinesListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAirlinesListResponse extends INrTableResponseOfAirlineRow {
}

export class AirlineRow implements IAirlineRow {
    id?: number;
    name?: string;
    code?: string;
    rank?: string;
    airline?: CompagniaAerea | null;

    constructor(data?: IAirlineRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.rank = _data["rank"] !== undefined ? _data["rank"] : null as any;
            this.airline = _data["airline"] ? CompagniaAerea.fromJS(_data["airline"]) : null as any;
        }
    }

    static fromJS(data: any): AirlineRow {
        data = typeof data === 'object' ? data : {};
        let result = new AirlineRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["rank"] = this.rank !== undefined ? this.rank : null as any;
        data["airline"] = this.airline ? this.airline.toJSON() : null as any;
        return data;
    }
}

export interface IAirlineRow {
    id?: number;
    name?: string;
    code?: string;
    rank?: string;
    airline?: CompagniaAerea | null;
}

export class AirlinesListRequest extends NrTableRequest implements IAirlinesListRequest {
    code?: string | null;
    name?: string | null;

    constructor(data?: IAirlinesListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static override fromJS(data: any): AirlinesListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AirlinesListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAirlinesListRequest extends INrTableRequest {
    code?: string | null;
    name?: string | null;
}

export class AirportGetResponse extends OkApiResponse implements IAirportGetResponse {
    airport?: Aeroporto;

    constructor(data?: IAirportGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.airport = _data["airport"] ? Aeroporto.fromJS(_data["airport"]) : null as any;
        }
    }

    static override fromJS(data: any): AirportGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AirportGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airport"] = this.airport ? this.airport.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAirportGetResponse extends IOkApiResponse {
    airport?: Aeroporto;
}

export class Aeroporto implements IAeroporto {
    id?: number;
    codice?: string | null;
    codiceArea?: string | null;
    nome?: string | null;
    airport?: string | null;
    paese?: string | null;
    nomeItaliano?: string | null;
    tipo?: number | null;
    luogoID?: number | null;
    latitudine?: number | null;
    longitudine?: number | null;
    mainAirport?: boolean | null;
    gmt?: number | null;
    domesticCheckin?: number | null;
    internationalCheckin?: number | null;
    frenchName?: string | null;
    germanName?: string | null;
    spanishName?: string | null;
    dutchName?: string | null;
    createdAt?: string;
    updatedAt?: string;
    deletedAt?: string | null;
    isAreaCode?: boolean;

    constructor(data?: IAeroporto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
            this.codiceArea = _data["codiceArea"] !== undefined ? _data["codiceArea"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.airport = _data["airport"] !== undefined ? _data["airport"] : null as any;
            this.paese = _data["paese"] !== undefined ? _data["paese"] : null as any;
            this.nomeItaliano = _data["nomeItaliano"] !== undefined ? _data["nomeItaliano"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.latitudine = _data["latitudine"] !== undefined ? _data["latitudine"] : null as any;
            this.longitudine = _data["longitudine"] !== undefined ? _data["longitudine"] : null as any;
            this.mainAirport = _data["mainAirport"] !== undefined ? _data["mainAirport"] : null as any;
            this.gmt = _data["gmt"] !== undefined ? _data["gmt"] : null as any;
            this.domesticCheckin = _data["domesticCheckin"] !== undefined ? _data["domesticCheckin"] : null as any;
            this.internationalCheckin = _data["internationalCheckin"] !== undefined ? _data["internationalCheckin"] : null as any;
            this.frenchName = _data["frenchName"] !== undefined ? _data["frenchName"] : null as any;
            this.germanName = _data["germanName"] !== undefined ? _data["germanName"] : null as any;
            this.spanishName = _data["spanishName"] !== undefined ? _data["spanishName"] : null as any;
            this.dutchName = _data["dutchName"] !== undefined ? _data["dutchName"] : null as any;
            this.createdAt = _data["createdAt"] !== undefined ? _data["createdAt"] : null as any;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : null as any;
            this.deletedAt = _data["deletedAt"] !== undefined ? _data["deletedAt"] : null as any;
            this.isAreaCode = _data["isAreaCode"] !== undefined ? _data["isAreaCode"] : null as any;
        }
    }

    static fromJS(data: any): Aeroporto {
        data = typeof data === 'object' ? data : {};
        let result = new Aeroporto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        data["codiceArea"] = this.codiceArea !== undefined ? this.codiceArea : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["airport"] = this.airport !== undefined ? this.airport : null as any;
        data["paese"] = this.paese !== undefined ? this.paese : null as any;
        data["nomeItaliano"] = this.nomeItaliano !== undefined ? this.nomeItaliano : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["latitudine"] = this.latitudine !== undefined ? this.latitudine : null as any;
        data["longitudine"] = this.longitudine !== undefined ? this.longitudine : null as any;
        data["mainAirport"] = this.mainAirport !== undefined ? this.mainAirport : null as any;
        data["gmt"] = this.gmt !== undefined ? this.gmt : null as any;
        data["domesticCheckin"] = this.domesticCheckin !== undefined ? this.domesticCheckin : null as any;
        data["internationalCheckin"] = this.internationalCheckin !== undefined ? this.internationalCheckin : null as any;
        data["frenchName"] = this.frenchName !== undefined ? this.frenchName : null as any;
        data["germanName"] = this.germanName !== undefined ? this.germanName : null as any;
        data["spanishName"] = this.spanishName !== undefined ? this.spanishName : null as any;
        data["dutchName"] = this.dutchName !== undefined ? this.dutchName : null as any;
        data["createdAt"] = this.createdAt !== undefined ? this.createdAt : null as any;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : null as any;
        data["deletedAt"] = this.deletedAt !== undefined ? this.deletedAt : null as any;
        data["isAreaCode"] = this.isAreaCode !== undefined ? this.isAreaCode : null as any;
        return data;
    }
}

export interface IAeroporto {
    id?: number;
    codice?: string | null;
    codiceArea?: string | null;
    nome?: string | null;
    airport?: string | null;
    paese?: string | null;
    nomeItaliano?: string | null;
    tipo?: number | null;
    luogoID?: number | null;
    latitudine?: number | null;
    longitudine?: number | null;
    mainAirport?: boolean | null;
    gmt?: number | null;
    domesticCheckin?: number | null;
    internationalCheckin?: number | null;
    frenchName?: string | null;
    germanName?: string | null;
    spanishName?: string | null;
    dutchName?: string | null;
    createdAt?: string;
    updatedAt?: string;
    deletedAt?: string | null;
    isAreaCode?: boolean;
}

export class AirportGetRequest extends LocalizedRequest implements IAirportGetRequest {
    airportID?: number;

    constructor(data?: IAirportGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.airportID = _data["airportID"] !== undefined ? _data["airportID"] : null as any;
        }
    }

    static override fromJS(data: any): AirportGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AirportGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airportID"] = this.airportID !== undefined ? this.airportID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAirportGetRequest extends ILocalizedRequest {
    airportID?: number;
}

export class AirportUpdateRequest extends AirportGetRequest implements IAirportUpdateRequest {
    airport?: Aeroporto | null;

    constructor(data?: IAirportUpdateRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.airport = _data["airport"] ? Aeroporto.fromJS(_data["airport"]) : null as any;
        }
    }

    static override fromJS(data: any): AirportUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AirportUpdateRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airport"] = this.airport ? this.airport.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAirportUpdateRequest extends IAirportGetRequest {
    airport?: Aeroporto | null;
}

export class AirportDeleteRequest extends ApiRequest implements IAirportDeleteRequest {
    airportID?: number;

    constructor(data?: IAirportDeleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.airportID = _data["airportID"] !== undefined ? _data["airportID"] : null as any;
        }
    }

    static override fromJS(data: any): AirportDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AirportDeleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airportID"] = this.airportID !== undefined ? this.airportID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAirportDeleteRequest extends IApiRequest {
    airportID?: number;
}

export class NrTableResponseOfAirportRow extends OkApiResponse implements INrTableResponseOfAirportRow {
    /** Array delle righe della pagina richiesta */
    rows?: AirportRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfAirportRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AirportRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfAirportRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfAirportRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfAirportRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: AirportRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class AirportsListResponse extends NrTableResponseOfAirportRow implements IAirportsListResponse {

    constructor(data?: IAirportsListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): AirportsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AirportsListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAirportsListResponse extends INrTableResponseOfAirportRow {
}

export class AirportRow implements IAirportRow {
    id?: number;
    name?: string;
    iataCode?: string;
    country?: string | null;
    airport?: Aeroporto | null;

    constructor(data?: IAirportRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.iataCode = _data["iataCode"] !== undefined ? _data["iataCode"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.airport = _data["airport"] ? Aeroporto.fromJS(_data["airport"]) : null as any;
        }
    }

    static fromJS(data: any): AirportRow {
        data = typeof data === 'object' ? data : {};
        let result = new AirportRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["iataCode"] = this.iataCode !== undefined ? this.iataCode : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["airport"] = this.airport ? this.airport.toJSON() : null as any;
        return data;
    }
}

export interface IAirportRow {
    id?: number;
    name?: string;
    iataCode?: string;
    country?: string | null;
    airport?: Aeroporto | null;
}

export class AirportsListRequest extends NrTableRequest implements IAirportsListRequest {
    iataCode?: string | null;
    name?: string | null;
    luogoId?: number | null;
    country?: string | null;
    mainAirport?: boolean;

    constructor(data?: IAirportsListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.iataCode = _data["iataCode"] !== undefined ? _data["iataCode"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.luogoId = _data["luogoId"] !== undefined ? _data["luogoId"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.mainAirport = _data["mainAirport"] !== undefined ? _data["mainAirport"] : null as any;
        }
    }

    static override fromJS(data: any): AirportsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AirportsListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iataCode"] = this.iataCode !== undefined ? this.iataCode : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["luogoId"] = this.luogoId !== undefined ? this.luogoId : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["mainAirport"] = this.mainAirport !== undefined ? this.mainAirport : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAirportsListRequest extends INrTableRequest {
    iataCode?: string | null;
    name?: string | null;
    luogoId?: number | null;
    country?: string | null;
    mainAirport?: boolean;
}

export class AddAttachmentResponse extends OkApiResponse implements IAddAttachmentResponse {
    allegato?: ArticoloAllegato;

    constructor(data?: IAddAttachmentResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.allegato = _data["allegato"] ? ArticoloAllegato.fromJS(_data["allegato"]) : null as any;
        }
    }

    static override fromJS(data: any): AddAttachmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddAttachmentResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allegato"] = this.allegato ? this.allegato.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAddAttachmentResponse extends IOkApiResponse {
    allegato?: ArticoloAllegato;
}

export class ArticoloAllegato implements IArticoloAllegato {
    /** Entit� dell'allegato */
    allegato?: ArticoloAttachment;
    /** Dimensione in byte, se il file esiste */
    dimensione?: number | null;
    /** True se il file esiste ed � accessibile */
    esiste?: boolean;

    constructor(data?: IArticoloAllegato) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allegato = _data["allegato"] ? ArticoloAttachment.fromJS(_data["allegato"]) : null as any;
            this.dimensione = _data["dimensione"] !== undefined ? _data["dimensione"] : null as any;
            this.esiste = _data["esiste"] !== undefined ? _data["esiste"] : null as any;
        }
    }

    static fromJS(data: any): ArticoloAllegato {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloAllegato();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allegato"] = this.allegato ? this.allegato.toJSON() : null as any;
        data["dimensione"] = this.dimensione !== undefined ? this.dimensione : null as any;
        data["esiste"] = this.esiste !== undefined ? this.esiste : null as any;
        return data;
    }
}

export interface IArticoloAllegato {
    /** Entit� dell'allegato */
    allegato?: ArticoloAttachment;
    /** Dimensione in byte, se il file esiste */
    dimensione?: number | null;
    /** True se il file esiste ed � accessibile */
    esiste?: boolean;
}

export class ArticoloAttachment implements IArticoloAttachment {
    articoloAttachmentID?: number;
    articoloID?: number;
    filename?: string | null;
    originalFilename?: string | null;
    descrizione?: string | null;

    constructor(data?: IArticoloAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articoloAttachmentID = _data["articoloAttachmentID"] !== undefined ? _data["articoloAttachmentID"] : null as any;
            this.articoloID = _data["articoloID"] !== undefined ? _data["articoloID"] : null as any;
            this.filename = _data["filename"] !== undefined ? _data["filename"] : null as any;
            this.originalFilename = _data["originalFilename"] !== undefined ? _data["originalFilename"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
        }
    }

    static fromJS(data: any): ArticoloAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articoloAttachmentID"] = this.articoloAttachmentID !== undefined ? this.articoloAttachmentID : null as any;
        data["articoloID"] = this.articoloID !== undefined ? this.articoloID : null as any;
        data["filename"] = this.filename !== undefined ? this.filename : null as any;
        data["originalFilename"] = this.originalFilename !== undefined ? this.originalFilename : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        return data;
    }
}

export interface IArticoloAttachment {
    articoloAttachmentID?: number;
    articoloID?: number;
    filename?: string | null;
    originalFilename?: string | null;
    descrizione?: string | null;
}

export class ArticoloGetResponse extends OkApiResponse implements IArticoloGetResponse {
    /** Entit� dell'articolo */
    articolo?: Articolo;
    /** Elenco dei testi nelle varie lingue */
    testi?: ArticoloTestoLingua[];
    /** Elenco degli allegati */
    allegati?: ArticoloAllegato[];
    /** Riferimenti agli articoli padre, in ordine dal pi� prossimo alla radice */
    padri?: ArticoloRiferimento[];
    /** Riferimenti agli articoli figlio */
    figli?: ArticoloRiferimento[];
    /** True se sono presenti riferimenti circolari */
    riferimentiCircolari?: boolean;
    /** Eventuale link associato */
    link?: ArticoloLink | null;
    /** Testo per la UI */
    testo?: TripTextHtml | null;

    constructor(data?: IArticoloGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.articolo = _data["articolo"] ? Articolo.fromJS(_data["articolo"]) : null as any;
            if (Array.isArray(_data["testi"])) {
                this.testi = [] as any;
                for (let item of _data["testi"])
                    this.testi!.push(ArticoloTestoLingua.fromJS(item));
            }
            else {
                this.testi = null as any;
            }
            if (Array.isArray(_data["allegati"])) {
                this.allegati = [] as any;
                for (let item of _data["allegati"])
                    this.allegati!.push(ArticoloAllegato.fromJS(item));
            }
            else {
                this.allegati = null as any;
            }
            if (Array.isArray(_data["padri"])) {
                this.padri = [] as any;
                for (let item of _data["padri"])
                    this.padri!.push(ArticoloRiferimento.fromJS(item));
            }
            else {
                this.padri = null as any;
            }
            if (Array.isArray(_data["figli"])) {
                this.figli = [] as any;
                for (let item of _data["figli"])
                    this.figli!.push(ArticoloRiferimento.fromJS(item));
            }
            else {
                this.figli = null as any;
            }
            this.riferimentiCircolari = _data["riferimentiCircolari"] !== undefined ? _data["riferimentiCircolari"] : null as any;
            this.link = _data["link"] ? ArticoloLink.fromJS(_data["link"]) : null as any;
            this.testo = _data["testo"] ? TripTextHtml.fromJS(_data["testo"]) : null as any;
        }
    }

    static override fromJS(data: any): ArticoloGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articolo"] = this.articolo ? this.articolo.toJSON() : null as any;
        if (Array.isArray(this.testi)) {
            data["testi"] = [];
            for (let item of this.testi)
                data["testi"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.allegati)) {
            data["allegati"] = [];
            for (let item of this.allegati)
                data["allegati"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.padri)) {
            data["padri"] = [];
            for (let item of this.padri)
                data["padri"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.figli)) {
            data["figli"] = [];
            for (let item of this.figli)
                data["figli"].push(item ? item.toJSON() : null as any);
        }
        data["riferimentiCircolari"] = this.riferimentiCircolari !== undefined ? this.riferimentiCircolari : null as any;
        data["link"] = this.link ? this.link.toJSON() : null as any;
        data["testo"] = this.testo ? this.testo.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IArticoloGetResponse extends IOkApiResponse {
    /** Entit� dell'articolo */
    articolo?: Articolo;
    /** Elenco dei testi nelle varie lingue */
    testi?: ArticoloTestoLingua[];
    /** Elenco degli allegati */
    allegati?: ArticoloAllegato[];
    /** Riferimenti agli articoli padre, in ordine dal pi� prossimo alla radice */
    padri?: ArticoloRiferimento[];
    /** Riferimenti agli articoli figlio */
    figli?: ArticoloRiferimento[];
    /** True se sono presenti riferimenti circolari */
    riferimentiCircolari?: boolean;
    /** Eventuale link associato */
    link?: ArticoloLink | null;
    /** Testo per la UI */
    testo?: TripTextHtml | null;
}

export class Articolo implements IArticolo {
    id?: number;
    linguaID?: ELingua;
    accordoID?: number | null;
    luogoID?: number | null;
    servizioID?: number | null;
    articoloPadreID?: number | null;
    linkPadre?: boolean;
    articoloTestataID?: number | null;
    categoria?: ECategoriaArticolo | null;
    titolo?: string | null;
    sunto?: string | null;
    ordine1?: number | null;
    ordine2?: number | null;
    pubblicaWeb?: boolean;
    pubblicaCatalogo?: boolean;
    pubblicaOfferta?: boolean;
    pubblicaProgramma?: boolean;
    pubblicaPreventivo?: boolean;
    pubblicaMiniguida?: boolean;
    pubblicaVoucher?: boolean;
    pubblicaEstrattoConto?: boolean;
    pubblicaDal?: string | null;
    pubblicaAl?: string | null;
    priority?: number | null;
    ultimoAggiornamento?: string | null;
    tipoServizio?: ETipoServizio | null;
    pageLinkID?: number | null;
    faIcon?: string | null;
    rawEdit?: boolean;
    showAsLink?: boolean;
    compagniaID?: number | null;
    operatore?: EOperatore | null;
    eliminato?: string | null;
    generatoAI?: boolean;

    constructor(data?: IArticolo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.linguaID = _data["linguaID"] !== undefined ? _data["linguaID"] : null as any;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.articoloPadreID = _data["articoloPadreID"] !== undefined ? _data["articoloPadreID"] : null as any;
            this.linkPadre = _data["linkPadre"] !== undefined ? _data["linkPadre"] : null as any;
            this.articoloTestataID = _data["articoloTestataID"] !== undefined ? _data["articoloTestataID"] : null as any;
            this.categoria = _data["categoria"] !== undefined ? _data["categoria"] : null as any;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            this.sunto = _data["sunto"] !== undefined ? _data["sunto"] : null as any;
            this.ordine1 = _data["ordine1"] !== undefined ? _data["ordine1"] : null as any;
            this.ordine2 = _data["ordine2"] !== undefined ? _data["ordine2"] : null as any;
            this.pubblicaWeb = _data["pubblicaWeb"] !== undefined ? _data["pubblicaWeb"] : null as any;
            this.pubblicaCatalogo = _data["pubblicaCatalogo"] !== undefined ? _data["pubblicaCatalogo"] : null as any;
            this.pubblicaOfferta = _data["pubblicaOfferta"] !== undefined ? _data["pubblicaOfferta"] : null as any;
            this.pubblicaProgramma = _data["pubblicaProgramma"] !== undefined ? _data["pubblicaProgramma"] : null as any;
            this.pubblicaPreventivo = _data["pubblicaPreventivo"] !== undefined ? _data["pubblicaPreventivo"] : null as any;
            this.pubblicaMiniguida = _data["pubblicaMiniguida"] !== undefined ? _data["pubblicaMiniguida"] : null as any;
            this.pubblicaVoucher = _data["pubblicaVoucher"] !== undefined ? _data["pubblicaVoucher"] : null as any;
            this.pubblicaEstrattoConto = _data["pubblicaEstrattoConto"] !== undefined ? _data["pubblicaEstrattoConto"] : null as any;
            this.pubblicaDal = _data["pubblicaDal"] !== undefined ? _data["pubblicaDal"] : null as any;
            this.pubblicaAl = _data["pubblicaAl"] !== undefined ? _data["pubblicaAl"] : null as any;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : null as any;
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] !== undefined ? _data["ultimoAggiornamento"] : null as any;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
            this.pageLinkID = _data["pageLinkID"] !== undefined ? _data["pageLinkID"] : null as any;
            this.faIcon = _data["faIcon"] !== undefined ? _data["faIcon"] : null as any;
            this.rawEdit = _data["rawEdit"] !== undefined ? _data["rawEdit"] : null as any;
            this.showAsLink = _data["showAsLink"] !== undefined ? _data["showAsLink"] : null as any;
            this.compagniaID = _data["compagniaID"] !== undefined ? _data["compagniaID"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.eliminato = _data["eliminato"] !== undefined ? _data["eliminato"] : null as any;
            this.generatoAI = _data["generatoAI"] !== undefined ? _data["generatoAI"] : null as any;
        }
    }

    static fromJS(data: any): Articolo {
        data = typeof data === 'object' ? data : {};
        let result = new Articolo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["linguaID"] = this.linguaID !== undefined ? this.linguaID : null as any;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["articoloPadreID"] = this.articoloPadreID !== undefined ? this.articoloPadreID : null as any;
        data["linkPadre"] = this.linkPadre !== undefined ? this.linkPadre : null as any;
        data["articoloTestataID"] = this.articoloTestataID !== undefined ? this.articoloTestataID : null as any;
        data["categoria"] = this.categoria !== undefined ? this.categoria : null as any;
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        data["sunto"] = this.sunto !== undefined ? this.sunto : null as any;
        data["ordine1"] = this.ordine1 !== undefined ? this.ordine1 : null as any;
        data["ordine2"] = this.ordine2 !== undefined ? this.ordine2 : null as any;
        data["pubblicaWeb"] = this.pubblicaWeb !== undefined ? this.pubblicaWeb : null as any;
        data["pubblicaCatalogo"] = this.pubblicaCatalogo !== undefined ? this.pubblicaCatalogo : null as any;
        data["pubblicaOfferta"] = this.pubblicaOfferta !== undefined ? this.pubblicaOfferta : null as any;
        data["pubblicaProgramma"] = this.pubblicaProgramma !== undefined ? this.pubblicaProgramma : null as any;
        data["pubblicaPreventivo"] = this.pubblicaPreventivo !== undefined ? this.pubblicaPreventivo : null as any;
        data["pubblicaMiniguida"] = this.pubblicaMiniguida !== undefined ? this.pubblicaMiniguida : null as any;
        data["pubblicaVoucher"] = this.pubblicaVoucher !== undefined ? this.pubblicaVoucher : null as any;
        data["pubblicaEstrattoConto"] = this.pubblicaEstrattoConto !== undefined ? this.pubblicaEstrattoConto : null as any;
        data["pubblicaDal"] = this.pubblicaDal !== undefined ? this.pubblicaDal : null as any;
        data["pubblicaAl"] = this.pubblicaAl !== undefined ? this.pubblicaAl : null as any;
        data["priority"] = this.priority !== undefined ? this.priority : null as any;
        data["ultimoAggiornamento"] = this.ultimoAggiornamento !== undefined ? this.ultimoAggiornamento : null as any;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        data["pageLinkID"] = this.pageLinkID !== undefined ? this.pageLinkID : null as any;
        data["faIcon"] = this.faIcon !== undefined ? this.faIcon : null as any;
        data["rawEdit"] = this.rawEdit !== undefined ? this.rawEdit : null as any;
        data["showAsLink"] = this.showAsLink !== undefined ? this.showAsLink : null as any;
        data["compagniaID"] = this.compagniaID !== undefined ? this.compagniaID : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["eliminato"] = this.eliminato !== undefined ? this.eliminato : null as any;
        data["generatoAI"] = this.generatoAI !== undefined ? this.generatoAI : null as any;
        return data;
    }
}

export interface IArticolo {
    id?: number;
    linguaID?: ELingua;
    accordoID?: number | null;
    luogoID?: number | null;
    servizioID?: number | null;
    articoloPadreID?: number | null;
    linkPadre?: boolean;
    articoloTestataID?: number | null;
    categoria?: ECategoriaArticolo | null;
    titolo?: string | null;
    sunto?: string | null;
    ordine1?: number | null;
    ordine2?: number | null;
    pubblicaWeb?: boolean;
    pubblicaCatalogo?: boolean;
    pubblicaOfferta?: boolean;
    pubblicaProgramma?: boolean;
    pubblicaPreventivo?: boolean;
    pubblicaMiniguida?: boolean;
    pubblicaVoucher?: boolean;
    pubblicaEstrattoConto?: boolean;
    pubblicaDal?: string | null;
    pubblicaAl?: string | null;
    priority?: number | null;
    ultimoAggiornamento?: string | null;
    tipoServizio?: ETipoServizio | null;
    pageLinkID?: number | null;
    faIcon?: string | null;
    rawEdit?: boolean;
    showAsLink?: boolean;
    compagniaID?: number | null;
    operatore?: EOperatore | null;
    eliminato?: string | null;
    generatoAI?: boolean;
}

export enum ECategoriaArticolo {
    Produzione = "Produzione",
    PreProduzione = "PreProduzione",
    Miniguida = "Miniguida",
    Offerte = "Offerte",
    ElementiArticoli = "ElementiArticoli",
    TestiCatalogo = "TestiCatalogo",
    TestiStampe = "TestiStampe",
    Obsoleto = "Obsoleto",
}

export class ArticoloTestoLingua implements IArticoloTestoLingua {
    articoloID?: number;
    articoloTraduzioneID?: number | null;
    lingua?: ELingua;
    titolo?: string | null;
    sunto?: string | null;
    testo?: string | null;
    confermato?: boolean;
    ultimoAggiornamento?: string | null;

    constructor(data?: IArticoloTestoLingua) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articoloID = _data["articoloID"] !== undefined ? _data["articoloID"] : null as any;
            this.articoloTraduzioneID = _data["articoloTraduzioneID"] !== undefined ? _data["articoloTraduzioneID"] : null as any;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : null as any;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            this.sunto = _data["sunto"] !== undefined ? _data["sunto"] : null as any;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : null as any;
            this.confermato = _data["confermato"] !== undefined ? _data["confermato"] : null as any;
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] !== undefined ? _data["ultimoAggiornamento"] : null as any;
        }
    }

    static fromJS(data: any): ArticoloTestoLingua {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloTestoLingua();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articoloID"] = this.articoloID !== undefined ? this.articoloID : null as any;
        data["articoloTraduzioneID"] = this.articoloTraduzioneID !== undefined ? this.articoloTraduzioneID : null as any;
        data["lingua"] = this.lingua !== undefined ? this.lingua : null as any;
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        data["sunto"] = this.sunto !== undefined ? this.sunto : null as any;
        data["testo"] = this.testo !== undefined ? this.testo : null as any;
        data["confermato"] = this.confermato !== undefined ? this.confermato : null as any;
        data["ultimoAggiornamento"] = this.ultimoAggiornamento !== undefined ? this.ultimoAggiornamento : null as any;
        return data;
    }
}

export interface IArticoloTestoLingua {
    articoloID?: number;
    articoloTraduzioneID?: number | null;
    lingua?: ELingua;
    titolo?: string | null;
    sunto?: string | null;
    testo?: string | null;
    confermato?: boolean;
    ultimoAggiornamento?: string | null;
}

export class ArticoloRiferimento implements IArticoloRiferimento {
    /** ID dell'articolo puntato */
    id?: number;
    /** Titolo dell'articolo (se c'�) */
    titolo?: string | null;
    /** Servizio associato (se c'�) */
    servizio?: string | null;

    constructor(data?: IArticoloRiferimento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : null as any;
        }
    }

    static fromJS(data: any): ArticoloRiferimento {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloRiferimento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        data["servizio"] = this.servizio !== undefined ? this.servizio : null as any;
        return data;
    }
}

export interface IArticoloRiferimento {
    /** ID dell'articolo puntato */
    id?: number;
    /** Titolo dell'articolo (se c'�) */
    titolo?: string | null;
    /** Servizio associato (se c'�) */
    servizio?: string | null;
}

export class ArticoloLink implements IArticoloLink {
    id?: number;
    nome?: string | null;
    luogo?: string | null;
    posizione?: EPosizioneLink;

    constructor(data?: IArticoloLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.posizione = _data["posizione"] !== undefined ? _data["posizione"] : null as any;
        }
    }

    static fromJS(data: any): ArticoloLink {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["posizione"] = this.posizione !== undefined ? this.posizione : null as any;
        return data;
    }
}

export interface IArticoloLink {
    id?: number;
    nome?: string | null;
    luogo?: string | null;
    posizione?: EPosizioneLink;
}

export enum EPosizioneLink {
    Default = "Default",
    MenuNavigazione = "MenuNavigazione",
    BannerTop = "BannerTop",
    BannerBottom = "BannerBottom",
    BannerLeft = "BannerLeft",
    BannerRight = "BannerRight",
    MenuSecondario = "MenuSecondario",
    BoxNews = "BoxNews",
    FooterLinks = "FooterLinks",
}

/** Contentiore generico dei testi */
export class TripTextHtml implements ITripTextHtml {
    /** Sorgente del testo */
    source?: ETripTextHtmlSource;
    /** ID riferimento, usato secondo i contesti */
    refID?: number;
    /** Hash ad uso interno */
    hash?: string;
    /** Titolo facoltativo */
    titolo?: string | null;
    /** Testo HTML */
    testo?: string;
    /** Se true in un documento deve apparire come URL. In questo caso il titolo deve esserci */
    usaUrlInDocumenti?: boolean;
    /** Url da utilizzare */
    url?: string | null;
    luogoID?: number;
    ordine?: number;

    constructor(data?: ITripTextHtml) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.refID = _data["refID"] !== undefined ? _data["refID"] : null as any;
            this.hash = _data["hash"] !== undefined ? _data["hash"] : null as any;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : null as any;
            this.usaUrlInDocumenti = _data["usaUrlInDocumenti"] !== undefined ? _data["usaUrlInDocumenti"] : null as any;
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
        }
    }

    static fromJS(data: any): TripTextHtml {
        data = typeof data === 'object' ? data : {};
        let result = new TripTextHtml();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["refID"] = this.refID !== undefined ? this.refID : null as any;
        data["hash"] = this.hash !== undefined ? this.hash : null as any;
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        data["testo"] = this.testo !== undefined ? this.testo : null as any;
        data["usaUrlInDocumenti"] = this.usaUrlInDocumenti !== undefined ? this.usaUrlInDocumenti : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        return data;
    }
}

/** Contentiore generico dei testi */
export interface ITripTextHtml {
    /** Sorgente del testo */
    source?: ETripTextHtmlSource;
    /** ID riferimento, usato secondo i contesti */
    refID?: number;
    /** Hash ad uso interno */
    hash?: string;
    /** Titolo facoltativo */
    titolo?: string | null;
    /** Testo HTML */
    testo?: string;
    /** Se true in un documento deve apparire come URL. In questo caso il titolo deve esserci */
    usaUrlInDocumenti?: boolean;
    /** Url da utilizzare */
    url?: string | null;
    luogoID?: number;
    ordine?: number;
}

/** Sorgente del testo, ad uso interno */
export enum ETripTextHtmlSource {
    Articolo = "Articolo",
    NotaOfferta = "NotaOfferta",
    DatiAggiuntiviServizio = "DatiAggiuntiviServizio",
    PenaleH2H = "PenaleH2H",
    Custom = "Custom",
}

export class ArticoloGetRequest extends LocalizedRequest implements IArticoloGetRequest {
    articoloID?: number;
    includiTesto?: boolean | null;

    constructor(data?: IArticoloGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.articoloID = _data["articoloID"] !== undefined ? _data["articoloID"] : null as any;
            this.includiTesto = _data["includiTesto"] !== undefined ? _data["includiTesto"] : null as any;
        }
    }

    static override fromJS(data: any): ArticoloGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articoloID"] = this.articoloID !== undefined ? this.articoloID : null as any;
        data["includiTesto"] = this.includiTesto !== undefined ? this.includiTesto : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IArticoloGetRequest extends ILocalizedRequest {
    articoloID?: number;
    includiTesto?: boolean | null;
}

export class UpdateArticoloRequest extends ArticoloGetRequest implements IUpdateArticoloRequest {
    articolo?: Articolo | null;
    testoPrincipale?: ArticoloTestoLingua | null;
    traduzioni?: ArticoloTestoLingua[] | null;
    allegati?: ArticoloAttachment[] | null;

    constructor(data?: IUpdateArticoloRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.articolo = _data["articolo"] ? Articolo.fromJS(_data["articolo"]) : null as any;
            this.testoPrincipale = _data["testoPrincipale"] ? ArticoloTestoLingua.fromJS(_data["testoPrincipale"]) : null as any;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(ArticoloTestoLingua.fromJS(item));
            }
            else {
                this.traduzioni = null as any;
            }
            if (Array.isArray(_data["allegati"])) {
                this.allegati = [] as any;
                for (let item of _data["allegati"])
                    this.allegati!.push(ArticoloAttachment.fromJS(item));
            }
            else {
                this.allegati = null as any;
            }
        }
    }

    static override fromJS(data: any): UpdateArticoloRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateArticoloRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articolo"] = this.articolo ? this.articolo.toJSON() : null as any;
        data["testoPrincipale"] = this.testoPrincipale ? this.testoPrincipale.toJSON() : null as any;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.allegati)) {
            data["allegati"] = [];
            for (let item of this.allegati)
                data["allegati"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateArticoloRequest extends IArticoloGetRequest {
    articolo?: Articolo | null;
    testoPrincipale?: ArticoloTestoLingua | null;
    traduzioni?: ArticoloTestoLingua[] | null;
    allegati?: ArticoloAttachment[] | null;
}

export class ArticoloDeleteRequest extends ApiRequest implements IArticoloDeleteRequest {
    articoloID?: number;

    constructor(data?: IArticoloDeleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.articoloID = _data["articoloID"] !== undefined ? _data["articoloID"] : null as any;
        }
    }

    static override fromJS(data: any): ArticoloDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloDeleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articoloID"] = this.articoloID !== undefined ? this.articoloID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IArticoloDeleteRequest extends IApiRequest {
    articoloID?: number;
}

export class NrTableResponseOfArticoloFraseListRow extends OkApiResponse implements INrTableResponseOfArticoloFraseListRow {
    /** Array delle righe della pagina richiesta */
    rows?: ArticoloFraseListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfArticoloFraseListRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ArticoloFraseListRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfArticoloFraseListRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfArticoloFraseListRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfArticoloFraseListRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: ArticoloFraseListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class GetArticoliFraseListResponse extends NrTableResponseOfArticoloFraseListRow implements IGetArticoliFraseListResponse {

    constructor(data?: IGetArticoliFraseListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetArticoliFraseListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetArticoliFraseListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetArticoliFraseListResponse extends INrTableResponseOfArticoloFraseListRow {
}

export class ArticoloFraseListRow implements IArticoloFraseListRow {
    id?: number;
    title?: string;

    constructor(data?: IArticoloFraseListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
        }
    }

    static fromJS(data: any): ArticoloFraseListRow {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloFraseListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        return data;
    }
}

export interface IArticoloFraseListRow {
    id?: number;
    title?: string;
}

export class GetArticoliFraseListRequest extends NrTableRequest implements IGetArticoliFraseListRequest {
    phraseID?: number;

    constructor(data?: IGetArticoliFraseListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phraseID = _data["phraseID"] !== undefined ? _data["phraseID"] : null as any;
        }
    }

    static override fromJS(data: any): GetArticoliFraseListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetArticoliFraseListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phraseID"] = this.phraseID !== undefined ? this.phraseID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetArticoliFraseListRequest extends INrTableRequest {
    phraseID?: number;
}

export class ArticoloGetPublishedResponse extends OkApiResponse implements IArticoloGetPublishedResponse {
    id?: number;
    titolo?: string | null;
    testo?: string | null;
    allegati?: ArticoloAllegato[] | null;

    constructor(data?: IArticoloGetPublishedResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : null as any;
            if (Array.isArray(_data["allegati"])) {
                this.allegati = [] as any;
                for (let item of _data["allegati"])
                    this.allegati!.push(ArticoloAllegato.fromJS(item));
            }
            else {
                this.allegati = null as any;
            }
        }
    }

    static override fromJS(data: any): ArticoloGetPublishedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloGetPublishedResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        data["testo"] = this.testo !== undefined ? this.testo : null as any;
        if (Array.isArray(this.allegati)) {
            data["allegati"] = [];
            for (let item of this.allegati)
                data["allegati"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IArticoloGetPublishedResponse extends IOkApiResponse {
    id?: number;
    titolo?: string | null;
    testo?: string | null;
    allegati?: ArticoloAllegato[] | null;
}

export class ArticoloGetPublishedRequest extends SiteRequest implements IArticoloGetPublishedRequest {
    articoloID?: number;

    constructor(data?: IArticoloGetPublishedRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.articoloID = _data["articoloID"] !== undefined ? _data["articoloID"] : null as any;
        }
    }

    static override fromJS(data: any): ArticoloGetPublishedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloGetPublishedRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articoloID"] = this.articoloID !== undefined ? this.articoloID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IArticoloGetPublishedRequest extends ISiteRequest {
    articoloID?: number;
}

export class GetAllSectionsResponse extends OkApiResponse implements IGetAllSectionsResponse {
    sezioni?: SectionsRow[];

    constructor(data?: IGetAllSectionsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["sezioni"])) {
                this.sezioni = [] as any;
                for (let item of _data["sezioni"])
                    this.sezioni!.push(SectionsRow.fromJS(item));
            }
            else {
                this.sezioni = null as any;
            }
        }
    }

    static override fromJS(data: any): GetAllSectionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSectionsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sezioni)) {
            data["sezioni"] = [];
            for (let item of this.sezioni)
                data["sezioni"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetAllSectionsResponse extends IOkApiResponse {
    sezioni?: SectionsRow[];
}

export class SectionsRow implements ISectionsRow {
    id?: number;
    nome?: string;
    codice?: string;
    visibilita?: EVisibilitaSezione;
    tipoServizio?: ETipoServizioFlags;

    constructor(data?: ISectionsRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
            this.visibilita = _data["visibilita"] !== undefined ? _data["visibilita"] : null as any;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
        }
    }

    static fromJS(data: any): SectionsRow {
        data = typeof data === 'object' ? data : {};
        let result = new SectionsRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        data["visibilita"] = this.visibilita !== undefined ? this.visibilita : null as any;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        return data;
    }
}

export interface ISectionsRow {
    id?: number;
    nome?: string;
    codice?: string;
    visibilita?: EVisibilitaSezione;
    tipoServizio?: ETipoServizioFlags;
}

export enum EVisibilitaSezione {
    Nessuno = "Nessuno",
    Articoli = "Articoli",
    PreventivoCliente = "PreventivoCliente",
    ProgrammaDiViaggio = "ProgrammaDiViaggio",
}

export enum ETipoServizioFlags {
    Nessuno = "Nessuno",
    Hotel = "Hotel",
    Tour = "Tour",
    Crociere = "Crociere",
    SelfDrive = "SelfDrive",
    Trasferimenti = "Trasferimenti",
    Visite = "Visite",
    Noleggi = "Noleggi",
    Pacchetti = "Pacchetti",
}

export class GetArticoloTextResponse extends OkApiResponse implements IGetArticoloTextResponse {
    id?: number;
    testo?: TripTextHtml;

    constructor(data?: IGetArticoloTextResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.testo = _data["testo"] ? TripTextHtml.fromJS(_data["testo"]) : null as any;
        }
    }

    static override fromJS(data: any): GetArticoloTextResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetArticoloTextResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["testo"] = this.testo ? this.testo.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetArticoloTextResponse extends IOkApiResponse {
    id?: number;
    testo?: TripTextHtml;
}

export class NrTableResponseOfArticoloListRow extends OkApiResponse implements INrTableResponseOfArticoloListRow {
    /** Array delle righe della pagina richiesta */
    rows?: ArticoloListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfArticoloListRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ArticoloListRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfArticoloListRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfArticoloListRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfArticoloListRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: ArticoloListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class ArticoloListRow implements IArticoloListRow {
    articoloID?: number;
    categoria?: ECategoriaArticolo;
    luogo?: string | null;
    luogoEliminato?: boolean;
    servizio?: string | null;
    servizioObsoleto?: boolean;
    servizioEliminato?: boolean;
    accordo?: string | null;
    compagniaAerea?: string | null;
    ultimoAggiornamento?: string | null;
    titolo?: string | null;
    titoloOriginale?: string | null;
    giorno?: number;
    ordine?: number;
    ordineStr?: string;
    link?: string | null;
    luogoLink?: string | null;
    intestazione?: string | null;
    operatore?: EOperatore | null;
    deleted?: string | null;

    constructor(data?: IArticoloListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articoloID = _data["articoloID"] !== undefined ? _data["articoloID"] : null as any;
            this.categoria = _data["categoria"] !== undefined ? _data["categoria"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.luogoEliminato = _data["luogoEliminato"] !== undefined ? _data["luogoEliminato"] : null as any;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : null as any;
            this.servizioObsoleto = _data["servizioObsoleto"] !== undefined ? _data["servizioObsoleto"] : null as any;
            this.servizioEliminato = _data["servizioEliminato"] !== undefined ? _data["servizioEliminato"] : null as any;
            this.accordo = _data["accordo"] !== undefined ? _data["accordo"] : null as any;
            this.compagniaAerea = _data["compagniaAerea"] !== undefined ? _data["compagniaAerea"] : null as any;
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] !== undefined ? _data["ultimoAggiornamento"] : null as any;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            this.titoloOriginale = _data["titoloOriginale"] !== undefined ? _data["titoloOriginale"] : null as any;
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.ordineStr = _data["ordineStr"] !== undefined ? _data["ordineStr"] : null as any;
            this.link = _data["link"] !== undefined ? _data["link"] : null as any;
            this.luogoLink = _data["luogoLink"] !== undefined ? _data["luogoLink"] : null as any;
            this.intestazione = _data["intestazione"] !== undefined ? _data["intestazione"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : null as any;
        }
    }

    static fromJS(data: any): ArticoloListRow {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articoloID"] = this.articoloID !== undefined ? this.articoloID : null as any;
        data["categoria"] = this.categoria !== undefined ? this.categoria : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["luogoEliminato"] = this.luogoEliminato !== undefined ? this.luogoEliminato : null as any;
        data["servizio"] = this.servizio !== undefined ? this.servizio : null as any;
        data["servizioObsoleto"] = this.servizioObsoleto !== undefined ? this.servizioObsoleto : null as any;
        data["servizioEliminato"] = this.servizioEliminato !== undefined ? this.servizioEliminato : null as any;
        data["accordo"] = this.accordo !== undefined ? this.accordo : null as any;
        data["compagniaAerea"] = this.compagniaAerea !== undefined ? this.compagniaAerea : null as any;
        data["ultimoAggiornamento"] = this.ultimoAggiornamento !== undefined ? this.ultimoAggiornamento : null as any;
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        data["titoloOriginale"] = this.titoloOriginale !== undefined ? this.titoloOriginale : null as any;
        data["giorno"] = this.giorno !== undefined ? this.giorno : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["ordineStr"] = this.ordineStr !== undefined ? this.ordineStr : null as any;
        data["link"] = this.link !== undefined ? this.link : null as any;
        data["luogoLink"] = this.luogoLink !== undefined ? this.luogoLink : null as any;
        data["intestazione"] = this.intestazione !== undefined ? this.intestazione : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["deleted"] = this.deleted !== undefined ? this.deleted : null as any;
        return data;
    }
}

export interface IArticoloListRow {
    articoloID?: number;
    categoria?: ECategoriaArticolo;
    luogo?: string | null;
    luogoEliminato?: boolean;
    servizio?: string | null;
    servizioObsoleto?: boolean;
    servizioEliminato?: boolean;
    accordo?: string | null;
    compagniaAerea?: string | null;
    ultimoAggiornamento?: string | null;
    titolo?: string | null;
    titoloOriginale?: string | null;
    giorno?: number;
    ordine?: number;
    ordineStr?: string;
    link?: string | null;
    luogoLink?: string | null;
    intestazione?: string | null;
    operatore?: EOperatore | null;
    deleted?: string | null;
}

export class ArticoliListRequest extends NrTableRequest implements IArticoliListRequest {
    tipoRicercaArticolo?: ETipoRicercaArticolo;
    tipoDocumento?: ETipoDocumento | null;
    articoliIdEsclusi?: number[] | null;
    servizioID?: number | null;
    noServizio?: boolean;
    categoria?: ECategoriaArticolo | null;
    testataID?: number | null;
    luogoID?: number | null;
    noLuogo?: boolean;
    accordoID?: number | null;
    noAccordo?: boolean;
    compagniaID?: number | null;
    noCompagnia?: boolean;
    noLink?: boolean;
    titolo?: string | null;
    testo?: string | null;
    linguaArticolo?: ELingua | null;
    nomiCategorie?: { [key in keyof typeof ECategoriaArticolo]?: string; } | null;
    operatore?: EOperatore | null;
    pubblicaWeb?: boolean;
    pubblicaCatalogo?: boolean;
    pubblicaOfferta?: boolean;
    pubblicaProgramma?: boolean;
    pubblicaPreventivo?: boolean;
    pubblicaMiniguida?: boolean;
    pubblicaVoucher?: boolean;
    pubblicaEstrattoConto?: boolean;
    showDeleted?: boolean | null;
    showActiveOnly?: boolean | null;

    constructor(data?: IArticoliListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tipoRicercaArticolo = _data["tipoRicercaArticolo"] !== undefined ? _data["tipoRicercaArticolo"] : null as any;
            this.tipoDocumento = _data["tipoDocumento"] !== undefined ? _data["tipoDocumento"] : null as any;
            if (Array.isArray(_data["articoliIdEsclusi"])) {
                this.articoliIdEsclusi = [] as any;
                for (let item of _data["articoliIdEsclusi"])
                    this.articoliIdEsclusi!.push(item);
            }
            else {
                this.articoliIdEsclusi = null as any;
            }
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.noServizio = _data["noServizio"] !== undefined ? _data["noServizio"] : null as any;
            this.categoria = _data["categoria"] !== undefined ? _data["categoria"] : null as any;
            this.testataID = _data["testataID"] !== undefined ? _data["testataID"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.noLuogo = _data["noLuogo"] !== undefined ? _data["noLuogo"] : null as any;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.noAccordo = _data["noAccordo"] !== undefined ? _data["noAccordo"] : null as any;
            this.compagniaID = _data["compagniaID"] !== undefined ? _data["compagniaID"] : null as any;
            this.noCompagnia = _data["noCompagnia"] !== undefined ? _data["noCompagnia"] : null as any;
            this.noLink = _data["noLink"] !== undefined ? _data["noLink"] : null as any;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : null as any;
            this.linguaArticolo = _data["linguaArticolo"] !== undefined ? _data["linguaArticolo"] : null as any;
            if (_data["nomiCategorie"]) {
                this.nomiCategorie = {} as any;
                for (let key in _data["nomiCategorie"]) {
                    if (_data["nomiCategorie"].hasOwnProperty(key))
                        (this.nomiCategorie as any)![key] = _data["nomiCategorie"][key] !== undefined ? _data["nomiCategorie"][key] : null as any;
                }
            }
            else {
                this.nomiCategorie = null as any;
            }
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.pubblicaWeb = _data["pubblicaWeb"] !== undefined ? _data["pubblicaWeb"] : null as any;
            this.pubblicaCatalogo = _data["pubblicaCatalogo"] !== undefined ? _data["pubblicaCatalogo"] : null as any;
            this.pubblicaOfferta = _data["pubblicaOfferta"] !== undefined ? _data["pubblicaOfferta"] : null as any;
            this.pubblicaProgramma = _data["pubblicaProgramma"] !== undefined ? _data["pubblicaProgramma"] : null as any;
            this.pubblicaPreventivo = _data["pubblicaPreventivo"] !== undefined ? _data["pubblicaPreventivo"] : null as any;
            this.pubblicaMiniguida = _data["pubblicaMiniguida"] !== undefined ? _data["pubblicaMiniguida"] : null as any;
            this.pubblicaVoucher = _data["pubblicaVoucher"] !== undefined ? _data["pubblicaVoucher"] : null as any;
            this.pubblicaEstrattoConto = _data["pubblicaEstrattoConto"] !== undefined ? _data["pubblicaEstrattoConto"] : null as any;
            this.showDeleted = _data["showDeleted"] !== undefined ? _data["showDeleted"] : null as any;
            this.showActiveOnly = _data["showActiveOnly"] !== undefined ? _data["showActiveOnly"] : null as any;
        }
    }

    static override fromJS(data: any): ArticoliListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoliListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoRicercaArticolo"] = this.tipoRicercaArticolo !== undefined ? this.tipoRicercaArticolo : null as any;
        data["tipoDocumento"] = this.tipoDocumento !== undefined ? this.tipoDocumento : null as any;
        if (Array.isArray(this.articoliIdEsclusi)) {
            data["articoliIdEsclusi"] = [];
            for (let item of this.articoliIdEsclusi)
                data["articoliIdEsclusi"].push(item);
        }
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["noServizio"] = this.noServizio !== undefined ? this.noServizio : null as any;
        data["categoria"] = this.categoria !== undefined ? this.categoria : null as any;
        data["testataID"] = this.testataID !== undefined ? this.testataID : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["noLuogo"] = this.noLuogo !== undefined ? this.noLuogo : null as any;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["noAccordo"] = this.noAccordo !== undefined ? this.noAccordo : null as any;
        data["compagniaID"] = this.compagniaID !== undefined ? this.compagniaID : null as any;
        data["noCompagnia"] = this.noCompagnia !== undefined ? this.noCompagnia : null as any;
        data["noLink"] = this.noLink !== undefined ? this.noLink : null as any;
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        data["testo"] = this.testo !== undefined ? this.testo : null as any;
        data["linguaArticolo"] = this.linguaArticolo !== undefined ? this.linguaArticolo : null as any;
        if (this.nomiCategorie) {
            data["nomiCategorie"] = {};
            for (let key in this.nomiCategorie) {
                if (this.nomiCategorie.hasOwnProperty(key))
                    (data["nomiCategorie"] as any)[key] = this.nomiCategorie[key] !== undefined ? this.nomiCategorie[key] : null as any;
            }
        }
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["pubblicaWeb"] = this.pubblicaWeb !== undefined ? this.pubblicaWeb : null as any;
        data["pubblicaCatalogo"] = this.pubblicaCatalogo !== undefined ? this.pubblicaCatalogo : null as any;
        data["pubblicaOfferta"] = this.pubblicaOfferta !== undefined ? this.pubblicaOfferta : null as any;
        data["pubblicaProgramma"] = this.pubblicaProgramma !== undefined ? this.pubblicaProgramma : null as any;
        data["pubblicaPreventivo"] = this.pubblicaPreventivo !== undefined ? this.pubblicaPreventivo : null as any;
        data["pubblicaMiniguida"] = this.pubblicaMiniguida !== undefined ? this.pubblicaMiniguida : null as any;
        data["pubblicaVoucher"] = this.pubblicaVoucher !== undefined ? this.pubblicaVoucher : null as any;
        data["pubblicaEstrattoConto"] = this.pubblicaEstrattoConto !== undefined ? this.pubblicaEstrattoConto : null as any;
        data["showDeleted"] = this.showDeleted !== undefined ? this.showDeleted : null as any;
        data["showActiveOnly"] = this.showActiveOnly !== undefined ? this.showActiveOnly : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IArticoliListRequest extends INrTableRequest {
    tipoRicercaArticolo?: ETipoRicercaArticolo;
    tipoDocumento?: ETipoDocumento | null;
    articoliIdEsclusi?: number[] | null;
    servizioID?: number | null;
    noServizio?: boolean;
    categoria?: ECategoriaArticolo | null;
    testataID?: number | null;
    luogoID?: number | null;
    noLuogo?: boolean;
    accordoID?: number | null;
    noAccordo?: boolean;
    compagniaID?: number | null;
    noCompagnia?: boolean;
    noLink?: boolean;
    titolo?: string | null;
    testo?: string | null;
    linguaArticolo?: ELingua | null;
    nomiCategorie?: { [key in keyof typeof ECategoriaArticolo]?: string; } | null;
    operatore?: EOperatore | null;
    pubblicaWeb?: boolean;
    pubblicaCatalogo?: boolean;
    pubblicaOfferta?: boolean;
    pubblicaProgramma?: boolean;
    pubblicaPreventivo?: boolean;
    pubblicaMiniguida?: boolean;
    pubblicaVoucher?: boolean;
    pubblicaEstrattoConto?: boolean;
    showDeleted?: boolean | null;
    showActiveOnly?: boolean | null;
}

export enum ETipoRicercaArticolo {
    Standard = "Standard",
    NoteDocumento = "NoteDocumento",
    NoteCompagniaAerea = "NoteCompagniaAerea",
    NoteServizio = "NoteServizio",
}

export class ArticoloRestoreRequest extends ApiRequest implements IArticoloRestoreRequest {
    articoloID?: number;

    constructor(data?: IArticoloRestoreRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.articoloID = _data["articoloID"] !== undefined ? _data["articoloID"] : null as any;
        }
    }

    static override fromJS(data: any): ArticoloRestoreRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloRestoreRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articoloID"] = this.articoloID !== undefined ? this.articoloID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IArticoloRestoreRequest extends IApiRequest {
    articoloID?: number;
}

export class SetArticoliOrderRequest extends ApiRequest implements ISetArticoliOrderRequest {
    sortedIds?: number[] | null;

    constructor(data?: ISetArticoliOrderRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["sortedIds"])) {
                this.sortedIds = [] as any;
                for (let item of _data["sortedIds"])
                    this.sortedIds!.push(item);
            }
            else {
                this.sortedIds = null as any;
            }
        }
    }

    static override fromJS(data: any): SetArticoliOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetArticoliOrderRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sortedIds)) {
            data["sortedIds"] = [];
            for (let item of this.sortedIds)
                data["sortedIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetArticoliOrderRequest extends IApiRequest {
    sortedIds?: number[] | null;
}

export class SetLinkRequest extends ArticoloGetRequest implements ISetLinkRequest {
    pageLinkID?: number | null;

    constructor(data?: ISetLinkRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pageLinkID = _data["pageLinkID"] !== undefined ? _data["pageLinkID"] : null as any;
        }
    }

    static override fromJS(data: any): SetLinkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetLinkRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageLinkID"] = this.pageLinkID !== undefined ? this.pageLinkID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISetLinkRequest extends IArticoloGetRequest {
    pageLinkID?: number | null;
}

export class TranslateArticoloResponse extends OkApiResponse implements ITranslateArticoloResponse {
    testoTradotto?: ArticoloTestoLingua | null;

    constructor(data?: ITranslateArticoloResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.testoTradotto = _data["testoTradotto"] ? ArticoloTestoLingua.fromJS(_data["testoTradotto"]) : null as any;
        }
    }

    static override fromJS(data: any): TranslateArticoloResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TranslateArticoloResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["testoTradotto"] = this.testoTradotto ? this.testoTradotto.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslateArticoloResponse extends IOkApiResponse {
    testoTradotto?: ArticoloTestoLingua | null;
}

export class TranslateArticoloRequest extends ApiRequest implements ITranslateArticoloRequest {
    testo?: ArticoloTestoLingua | null;
    linguaDestinazione?: ELingua;

    constructor(data?: ITranslateArticoloRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.testo = _data["testo"] ? ArticoloTestoLingua.fromJS(_data["testo"]) : null as any;
            this.linguaDestinazione = _data["linguaDestinazione"] !== undefined ? _data["linguaDestinazione"] : null as any;
        }
    }

    static override fromJS(data: any): TranslateArticoloRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TranslateArticoloRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["testo"] = this.testo ? this.testo.toJSON() : null as any;
        data["linguaDestinazione"] = this.linguaDestinazione !== undefined ? this.linguaDestinazione : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslateArticoloRequest extends IApiRequest {
    testo?: ArticoloTestoLingua | null;
    linguaDestinazione?: ELingua;
}

export class UpdateAttachmentResponse extends AddAttachmentResponse implements IUpdateAttachmentResponse {

    constructor(data?: IUpdateAttachmentResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UpdateAttachmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAttachmentResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateAttachmentResponse extends IAddAttachmentResponse {
}

export class ArticoliTemplateGetResponse extends OkApiResponse implements IArticoliTemplateGetResponse {
    articoloTemplate?: ArticoloTemplate;
    nomeTipoServizio?: string;

    constructor(data?: IArticoliTemplateGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.articoloTemplate = _data["articoloTemplate"] ? ArticoloTemplate.fromJS(_data["articoloTemplate"]) : null as any;
            this.nomeTipoServizio = _data["nomeTipoServizio"] !== undefined ? _data["nomeTipoServizio"] : null as any;
        }
    }

    static override fromJS(data: any): ArticoliTemplateGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoliTemplateGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articoloTemplate"] = this.articoloTemplate ? this.articoloTemplate.toJSON() : null as any;
        data["nomeTipoServizio"] = this.nomeTipoServizio !== undefined ? this.nomeTipoServizio : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IArticoliTemplateGetResponse extends IOkApiResponse {
    articoloTemplate?: ArticoloTemplate;
    nomeTipoServizio?: string;
}

export class ArticoloTemplate implements IArticoloTemplate {
    id?: number;
    nome!: string;
    servizioTipoID?: number | null;
    createdAt?: string;
    updatedAt?: string | null;
    deletedAt?: string | null;

    constructor(data?: IArticoloTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.servizioTipoID = _data["servizioTipoID"] !== undefined ? _data["servizioTipoID"] : null as any;
            this.createdAt = _data["createdAt"] !== undefined ? _data["createdAt"] : null as any;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : null as any;
            this.deletedAt = _data["deletedAt"] !== undefined ? _data["deletedAt"] : null as any;
        }
    }

    static fromJS(data: any): ArticoloTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["servizioTipoID"] = this.servizioTipoID !== undefined ? this.servizioTipoID : null as any;
        data["createdAt"] = this.createdAt !== undefined ? this.createdAt : null as any;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : null as any;
        data["deletedAt"] = this.deletedAt !== undefined ? this.deletedAt : null as any;
        return data;
    }
}

export interface IArticoloTemplate {
    id?: number;
    nome: string;
    servizioTipoID?: number | null;
    createdAt?: string;
    updatedAt?: string | null;
    deletedAt?: string | null;
}

export class ArticoliTemplateGetRequest extends LocalizedRequest implements IArticoliTemplateGetRequest {
    templateID!: number;

    constructor(data?: IArticoliTemplateGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.templateID = _data["templateID"] !== undefined ? _data["templateID"] : null as any;
        }
    }

    static override fromJS(data: any): ArticoliTemplateGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoliTemplateGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateID"] = this.templateID !== undefined ? this.templateID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IArticoliTemplateGetRequest extends ILocalizedRequest {
    templateID: number;
}

export class UpdateArticoliTemplateRequest extends ArticoliTemplateGetRequest implements IUpdateArticoliTemplateRequest {
    articolotemplate?: ArticoloTemplate | null;

    constructor(data?: IUpdateArticoliTemplateRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.articolotemplate = _data["articolotemplate"] ? ArticoloTemplate.fromJS(_data["articolotemplate"]) : null as any;
        }
    }

    static override fromJS(data: any): UpdateArticoliTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateArticoliTemplateRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articolotemplate"] = this.articolotemplate ? this.articolotemplate.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateArticoliTemplateRequest extends IArticoliTemplateGetRequest {
    articolotemplate?: ArticoloTemplate | null;
}

export class ArticoloTemplateDeleteRequest extends ApiRequest implements IArticoloTemplateDeleteRequest {
    templateID?: number;

    constructor(data?: IArticoloTemplateDeleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.templateID = _data["templateID"] !== undefined ? _data["templateID"] : null as any;
        }
    }

    static override fromJS(data: any): ArticoloTemplateDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloTemplateDeleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateID"] = this.templateID !== undefined ? this.templateID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IArticoloTemplateDeleteRequest extends IApiRequest {
    templateID?: number;
}

export class GetAllTemplatesResponse extends OkApiResponse implements IGetAllTemplatesResponse {
    template?: TemplatesRow[];

    constructor(data?: IGetAllTemplatesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["template"])) {
                this.template = [] as any;
                for (let item of _data["template"])
                    this.template!.push(TemplatesRow.fromJS(item));
            }
            else {
                this.template = null as any;
            }
        }
    }

    static override fromJS(data: any): GetAllTemplatesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllTemplatesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.template)) {
            data["template"] = [];
            for (let item of this.template)
                data["template"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetAllTemplatesResponse extends IOkApiResponse {
    template?: TemplatesRow[];
}

export class TemplatesRow implements ITemplatesRow {
    id?: number;
    nome?: string;
    tipoServizio?: string;
    tipoServizioID?: number | null;

    constructor(data?: ITemplatesRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
            this.tipoServizioID = _data["tipoServizioID"] !== undefined ? _data["tipoServizioID"] : null as any;
        }
    }

    static fromJS(data: any): TemplatesRow {
        data = typeof data === 'object' ? data : {};
        let result = new TemplatesRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        data["tipoServizioID"] = this.tipoServizioID !== undefined ? this.tipoServizioID : null as any;
        return data;
    }
}

export interface ITemplatesRow {
    id?: number;
    nome?: string;
    tipoServizio?: string;
    tipoServizioID?: number | null;
}

export class GetTemplatesRequest extends LocalizedRequest implements IGetTemplatesRequest {
    servizioID?: number | null;

    constructor(data?: IGetTemplatesRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
        }
    }

    static override fromJS(data: any): GetTemplatesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTemplatesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTemplatesRequest extends ILocalizedRequest {
    servizioID?: number | null;
}

export class NrTableResponseOfTemplatesRow extends OkApiResponse implements INrTableResponseOfTemplatesRow {
    /** Array delle righe della pagina richiesta */
    rows?: TemplatesRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfTemplatesRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TemplatesRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfTemplatesRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfTemplatesRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfTemplatesRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: TemplatesRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class ListTemplatesResponse extends NrTableResponseOfTemplatesRow implements IListTemplatesResponse {

    constructor(data?: IListTemplatesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ListTemplatesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListTemplatesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IListTemplatesResponse extends INrTableResponseOfTemplatesRow {
}

export class ListTemplatesRequest extends NrTableRequest implements IListTemplatesRequest {
    /** Termine di ricerca: ID, titolo, parti di testo */
    term?: string | null;

    constructor(data?: IListTemplatesRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : null as any;
        }
    }

    static override fromJS(data: any): ListTemplatesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListTemplatesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IListTemplatesRequest extends INrTableRequest {
    /** Termine di ricerca: ID, titolo, parti di testo */
    term?: string | null;
}

export class TypeSericesGetResponse extends OkApiResponse implements ITypeSericesGetResponse {
    serviceTypeList?: ServizioTipo[];

    constructor(data?: ITypeSericesGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["serviceTypeList"])) {
                this.serviceTypeList = [] as any;
                for (let item of _data["serviceTypeList"])
                    this.serviceTypeList!.push(ServizioTipo.fromJS(item));
            }
            else {
                this.serviceTypeList = null as any;
            }
        }
    }

    static override fromJS(data: any): TypeSericesGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TypeSericesGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.serviceTypeList)) {
            data["serviceTypeList"] = [];
            for (let item of this.serviceTypeList)
                data["serviceTypeList"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITypeSericesGetResponse extends IOkApiResponse {
    serviceTypeList?: ServizioTipo[];
}

export class ServizioTipo implements IServizioTipo {
    id?: number;
    tipo?: ETipoServizio;
    traduzioni?: ServiceTypeTranslation[] | null;
    ordine?: number | null;
    nome?: string | null;
    nome_en?: string | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean | null;
    confirmed_en?: boolean | null;
    serviziTipologieStandard?: ServizioTipologiaStandard[] | null;

    constructor(data?: IServizioTipo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(ServiceTypeTranslation.fromJS(item));
            }
            else {
                this.traduzioni = null as any;
            }
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : null as any;
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : null as any;
            this.lastUpdate_en = _data["lastUpdate_en"] !== undefined ? _data["lastUpdate_en"] : null as any;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : null as any;
            this.confirmed_en = _data["confirmed_en"] !== undefined ? _data["confirmed_en"] : null as any;
            if (Array.isArray(_data["serviziTipologieStandard"])) {
                this.serviziTipologieStandard = [] as any;
                for (let item of _data["serviziTipologieStandard"])
                    this.serviziTipologieStandard!.push(ServizioTipologiaStandard.fromJS(item));
            }
            else {
                this.serviziTipologieStandard = null as any;
            }
        }
    }

    static fromJS(data: any): ServizioTipo {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioTipo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item ? item.toJSON() : null as any);
        }
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : null as any;
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : null as any;
        data["lastUpdate_en"] = this.lastUpdate_en !== undefined ? this.lastUpdate_en : null as any;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : null as any;
        data["confirmed_en"] = this.confirmed_en !== undefined ? this.confirmed_en : null as any;
        if (Array.isArray(this.serviziTipologieStandard)) {
            data["serviziTipologieStandard"] = [];
            for (let item of this.serviziTipologieStandard)
                data["serviziTipologieStandard"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IServizioTipo {
    id?: number;
    tipo?: ETipoServizio;
    traduzioni?: ServiceTypeTranslation[] | null;
    ordine?: number | null;
    nome?: string | null;
    nome_en?: string | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean | null;
    confirmed_en?: boolean | null;
    serviziTipologieStandard?: ServizioTipologiaStandard[] | null;
}

export class ServiceTypeTranslation extends WebTranslation implements IServiceTypeTranslation {

    constructor(data?: IServiceTypeTranslation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ServiceTypeTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTypeTranslation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IServiceTypeTranslation extends IWebTranslation {
}

export class ServizioTipologiaStandard implements IServizioTipologiaStandard {
    id?: number;
    eTipoServizio?: ETipoServizio;
    nome?: string | null;
    nomeInglese?: string | null;
    aggiornato?: string | null;
    eliminato?: string | null;
    traduzioni?: ServiceDefinitionStandardTranslation[] | null;
    paramNames?: TipologiaStandardParam[] | null;

    constructor(data?: IServizioTipologiaStandard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.eTipoServizio = _data["eTipoServizio"] !== undefined ? _data["eTipoServizio"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nomeInglese = _data["nomeInglese"] !== undefined ? _data["nomeInglese"] : null as any;
            this.aggiornato = _data["aggiornato"] !== undefined ? _data["aggiornato"] : null as any;
            this.eliminato = _data["eliminato"] !== undefined ? _data["eliminato"] : null as any;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(ServiceDefinitionStandardTranslation.fromJS(item));
            }
            else {
                this.traduzioni = null as any;
            }
            if (Array.isArray(_data["paramNames"])) {
                this.paramNames = [] as any;
                for (let item of _data["paramNames"])
                    this.paramNames!.push(TipologiaStandardParam.fromJS(item));
            }
            else {
                this.paramNames = null as any;
            }
        }
    }

    static fromJS(data: any): ServizioTipologiaStandard {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioTipologiaStandard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["eTipoServizio"] = this.eTipoServizio !== undefined ? this.eTipoServizio : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nomeInglese"] = this.nomeInglese !== undefined ? this.nomeInglese : null as any;
        data["aggiornato"] = this.aggiornato !== undefined ? this.aggiornato : null as any;
        data["eliminato"] = this.eliminato !== undefined ? this.eliminato : null as any;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.paramNames)) {
            data["paramNames"] = [];
            for (let item of this.paramNames)
                data["paramNames"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IServizioTipologiaStandard {
    id?: number;
    eTipoServizio?: ETipoServizio;
    nome?: string | null;
    nomeInglese?: string | null;
    aggiornato?: string | null;
    eliminato?: string | null;
    traduzioni?: ServiceDefinitionStandardTranslation[] | null;
    paramNames?: TipologiaStandardParam[] | null;
}

export class ServiceDefinitionStandardTranslation extends WebTranslation implements IServiceDefinitionStandardTranslation {

    constructor(data?: IServiceDefinitionStandardTranslation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ServiceDefinitionStandardTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDefinitionStandardTranslation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IServiceDefinitionStandardTranslation extends IWebTranslation {
}

export class TipologiaStandardParam implements ITipologiaStandardParam {
    name?: string | null;
    languages?: ELingua[] | null;
    isSpecial?: boolean;

    constructor(data?: ITipologiaStandardParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(item);
            }
            else {
                this.languages = null as any;
            }
            this.isSpecial = _data["isSpecial"] !== undefined ? _data["isSpecial"] : null as any;
        }
    }

    static fromJS(data: any): TipologiaStandardParam {
        data = typeof data === 'object' ? data : {};
        let result = new TipologiaStandardParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item);
        }
        data["isSpecial"] = this.isSpecial !== undefined ? this.isSpecial : null as any;
        return data;
    }
}

export interface ITipologiaStandardParam {
    name?: string | null;
    languages?: ELingua[] | null;
    isSpecial?: boolean;
}

export class TypeSericesGetRequest extends LocalizedRequest implements ITypeSericesGetRequest {
    servicetypeID?: number;

    constructor(data?: ITypeSericesGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servicetypeID = _data["servicetypeID"] !== undefined ? _data["servicetypeID"] : null as any;
        }
    }

    static override fromJS(data: any): TypeSericesGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TypeSericesGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servicetypeID"] = this.servicetypeID !== undefined ? this.servicetypeID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITypeSericesGetRequest extends ILocalizedRequest {
    servicetypeID?: number;
}

export class CloneArticoloTraducibileResponse extends OkApiResponse implements ICloneArticoloTraducibileResponse {
    testoId?: number | null;

    constructor(data?: ICloneArticoloTraducibileResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.testoId = _data["testoId"] !== undefined ? _data["testoId"] : null as any;
        }
    }

    static override fromJS(data: any): CloneArticoloTraducibileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CloneArticoloTraducibileResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["testoId"] = this.testoId !== undefined ? this.testoId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICloneArticoloTraducibileResponse extends IOkApiResponse {
    testoId?: number | null;
}

export class TextsGetRequest extends LocalizedRequest implements ITextsGetRequest {
    testoID?: number;

    constructor(data?: ITextsGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.testoID = _data["testoID"] !== undefined ? _data["testoID"] : null as any;
        }
    }

    static override fromJS(data: any): TextsGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TextsGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["testoID"] = this.testoID !== undefined ? this.testoID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITextsGetRequest extends ILocalizedRequest {
    testoID?: number;
}

export class CloneTextsRequest extends TextsGetRequest implements ICloneTextsRequest {

    constructor(data?: ICloneTextsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CloneTextsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CloneTextsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICloneTextsRequest extends ITextsGetRequest {
}

export class TextsGetResponse extends OkApiResponse implements ITextsGetResponse {
    service?: Servizio | null;
    articoloTraducibile?: ArticoloTraducibile;
    sections?: TranslateArticleSection[] | null;
    services?: IdValore[] | null;
    locations?: IdValore[] | null;

    constructor(data?: ITextsGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.service = _data["service"] ? Servizio.fromJS(_data["service"]) : null as any;
            this.articoloTraducibile = _data["articoloTraducibile"] ? ArticoloTraducibile.fromJS(_data["articoloTraducibile"]) : null as any;
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(TranslateArticleSection.fromJS(item));
            }
            else {
                this.sections = null as any;
            }
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(IdValore.fromJS(item));
            }
            else {
                this.services = null as any;
            }
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(IdValore.fromJS(item));
            }
            else {
                this.locations = null as any;
            }
        }
    }

    static override fromJS(data: any): TextsGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TextsGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["service"] = this.service ? this.service.toJSON() : null as any;
        data["articoloTraducibile"] = this.articoloTraducibile ? this.articoloTraducibile.toJSON() : null as any;
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITextsGetResponse extends IOkApiResponse {
    service?: Servizio | null;
    articoloTraducibile?: ArticoloTraducibile;
    sections?: TranslateArticleSection[] | null;
    services?: IdValore[] | null;
    locations?: IdValore[] | null;
}

export abstract class ServizioBase implements IServizioBase {
    servizioID?: number;
    luogoID?: number;
    tipo?: ETipoServizio;
    markup?: number | null;
    penaleID?: number | null;
    giorniPenale?: number | null;
    parametroPenale?: number | null;

    constructor(data?: IServizioBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.markup = _data["markup"] !== undefined ? _data["markup"] : null as any;
            this.penaleID = _data["penaleID"] !== undefined ? _data["penaleID"] : null as any;
            this.giorniPenale = _data["giorniPenale"] !== undefined ? _data["giorniPenale"] : null as any;
            this.parametroPenale = _data["parametroPenale"] !== undefined ? _data["parametroPenale"] : null as any;
        }
    }

    static fromJS(data: any): ServizioBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ServizioBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["markup"] = this.markup !== undefined ? this.markup : null as any;
        data["penaleID"] = this.penaleID !== undefined ? this.penaleID : null as any;
        data["giorniPenale"] = this.giorniPenale !== undefined ? this.giorniPenale : null as any;
        data["parametroPenale"] = this.parametroPenale !== undefined ? this.parametroPenale : null as any;
        return data;
    }
}

export interface IServizioBase {
    servizioID?: number;
    luogoID?: number;
    tipo?: ETipoServizio;
    markup?: number | null;
    penaleID?: number | null;
    giorniPenale?: number | null;
    parametroPenale?: number | null;
}

export class Servizio extends ServizioBase implements IServizio {
    traduzioni?: ServiceTranslation[] | null;
    pubblicazioni?: ServicePublish[] | null;
    contattoFornitoreID?: number | null;
    deleted?: string | null;
    nome!: string;
    nomeInglese?: string | null;
    nomeOriginale?: string | null;
    popolarita?: number | null;
    ordine?: number | null;
    pubblicazione1?: EStatoPubblicazioneServizio | null;
    pubblicazione2?: EStatoPubblicazioneServizio | null;
    pubblicazione3?: EStatoPubblicazioneServizio | null;
    note?: string | null;
    status?: EStatoUtilizzoServizio | null;
    preferito?: boolean;
    codice?: string | null;
    giataID?: number | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean | null;
    confirmed_en?: boolean | null;

    constructor(data?: IServizio) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(ServiceTranslation.fromJS(item));
            }
            else {
                this.traduzioni = null as any;
            }
            if (Array.isArray(_data["pubblicazioni"])) {
                this.pubblicazioni = [] as any;
                for (let item of _data["pubblicazioni"])
                    this.pubblicazioni!.push(ServicePublish.fromJS(item));
            }
            else {
                this.pubblicazioni = null as any;
            }
            this.contattoFornitoreID = _data["contattoFornitoreID"] !== undefined ? _data["contattoFornitoreID"] : null as any;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nomeInglese = _data["nomeInglese"] !== undefined ? _data["nomeInglese"] : null as any;
            this.nomeOriginale = _data["nomeOriginale"] !== undefined ? _data["nomeOriginale"] : null as any;
            this.popolarita = _data["popolarita"] !== undefined ? _data["popolarita"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.pubblicazione1 = _data["pubblicazione1"] !== undefined ? _data["pubblicazione1"] : null as any;
            this.pubblicazione2 = _data["pubblicazione2"] !== undefined ? _data["pubblicazione2"] : null as any;
            this.pubblicazione3 = _data["pubblicazione3"] !== undefined ? _data["pubblicazione3"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.preferito = _data["preferito"] !== undefined ? _data["preferito"] : null as any;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
            this.giataID = _data["giataID"] !== undefined ? _data["giataID"] : null as any;
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : null as any;
            this.lastUpdate_en = _data["lastUpdate_en"] !== undefined ? _data["lastUpdate_en"] : null as any;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : null as any;
            this.confirmed_en = _data["confirmed_en"] !== undefined ? _data["confirmed_en"] : null as any;
        }
    }

    static override fromJS(data: any): Servizio {
        data = typeof data === 'object' ? data : {};
        let result = new Servizio();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.pubblicazioni)) {
            data["pubblicazioni"] = [];
            for (let item of this.pubblicazioni)
                data["pubblicazioni"].push(item ? item.toJSON() : null as any);
        }
        data["contattoFornitoreID"] = this.contattoFornitoreID !== undefined ? this.contattoFornitoreID : null as any;
        data["deleted"] = this.deleted !== undefined ? this.deleted : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nomeInglese"] = this.nomeInglese !== undefined ? this.nomeInglese : null as any;
        data["nomeOriginale"] = this.nomeOriginale !== undefined ? this.nomeOriginale : null as any;
        data["popolarita"] = this.popolarita !== undefined ? this.popolarita : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["pubblicazione1"] = this.pubblicazione1 !== undefined ? this.pubblicazione1 : null as any;
        data["pubblicazione2"] = this.pubblicazione2 !== undefined ? this.pubblicazione2 : null as any;
        data["pubblicazione3"] = this.pubblicazione3 !== undefined ? this.pubblicazione3 : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["preferito"] = this.preferito !== undefined ? this.preferito : null as any;
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        data["giataID"] = this.giataID !== undefined ? this.giataID : null as any;
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : null as any;
        data["lastUpdate_en"] = this.lastUpdate_en !== undefined ? this.lastUpdate_en : null as any;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : null as any;
        data["confirmed_en"] = this.confirmed_en !== undefined ? this.confirmed_en : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IServizio extends IServizioBase {
    traduzioni?: ServiceTranslation[] | null;
    pubblicazioni?: ServicePublish[] | null;
    contattoFornitoreID?: number | null;
    deleted?: string | null;
    nome: string;
    nomeInglese?: string | null;
    nomeOriginale?: string | null;
    popolarita?: number | null;
    ordine?: number | null;
    pubblicazione1?: EStatoPubblicazioneServizio | null;
    pubblicazione2?: EStatoPubblicazioneServizio | null;
    pubblicazione3?: EStatoPubblicazioneServizio | null;
    note?: string | null;
    status?: EStatoUtilizzoServizio | null;
    preferito?: boolean;
    codice?: string | null;
    giataID?: number | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean | null;
    confirmed_en?: boolean | null;
}

export class ServiceTranslation extends WebTranslation implements IServiceTranslation {

    constructor(data?: IServiceTranslation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ServiceTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTranslation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IServiceTranslation extends IWebTranslation {
}

export class WebsitePublish implements IWebsitePublish {
    id?: number;
    websiteID!: number;
    table!: string;
    entityID!: number;
    publish?: number;
    publishFrom?: string | null;
    publishTo?: string | null;
    markupOverride?: number | null;

    constructor(data?: IWebsitePublish) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.websiteID = _data["websiteID"] !== undefined ? _data["websiteID"] : null as any;
            this.table = _data["table"] !== undefined ? _data["table"] : null as any;
            this.entityID = _data["entityID"] !== undefined ? _data["entityID"] : null as any;
            this.publish = _data["publish"] !== undefined ? _data["publish"] : null as any;
            this.publishFrom = _data["publishFrom"] !== undefined ? _data["publishFrom"] : null as any;
            this.publishTo = _data["publishTo"] !== undefined ? _data["publishTo"] : null as any;
            this.markupOverride = _data["markupOverride"] !== undefined ? _data["markupOverride"] : null as any;
        }
    }

    static fromJS(data: any): WebsitePublish {
        data = typeof data === 'object' ? data : {};
        let result = new WebsitePublish();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["websiteID"] = this.websiteID !== undefined ? this.websiteID : null as any;
        data["table"] = this.table !== undefined ? this.table : null as any;
        data["entityID"] = this.entityID !== undefined ? this.entityID : null as any;
        data["publish"] = this.publish !== undefined ? this.publish : null as any;
        data["publishFrom"] = this.publishFrom !== undefined ? this.publishFrom : null as any;
        data["publishTo"] = this.publishTo !== undefined ? this.publishTo : null as any;
        data["markupOverride"] = this.markupOverride !== undefined ? this.markupOverride : null as any;
        return data;
    }
}

export interface IWebsitePublish {
    id?: number;
    websiteID: number;
    table: string;
    entityID: number;
    publish?: number;
    publishFrom?: string | null;
    publishTo?: string | null;
    markupOverride?: number | null;
}

export class ServicePublish extends WebsitePublish implements IServicePublish {
    statoPubblicazione?: EStatoPubblicazioneServizio;

    constructor(data?: IServicePublish) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.statoPubblicazione = _data["statoPubblicazione"] !== undefined ? _data["statoPubblicazione"] : null as any;
        }
    }

    static override fromJS(data: any): ServicePublish {
        data = typeof data === 'object' ? data : {};
        let result = new ServicePublish();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statoPubblicazione"] = this.statoPubblicazione !== undefined ? this.statoPubblicazione : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IServicePublish extends IWebsitePublish {
    statoPubblicazione?: EStatoPubblicazioneServizio;
}

export enum EStatoPubblicazioneServizio {
    NonPubblicare = "NonPubblicare",
    PubblicaWeb = "PubblicaWeb",
    PubblicaIntranet = "PubblicaIntranet",
    PubblicaWebPreferito = "PubblicaWebPreferito",
    VisibilePubblicamente = "VisibilePubblicamente",
    InLavorazione = "InLavorazione",
}

export enum EStatoUtilizzoServizio {
    Attivo = "Attivo",
    Occasionale = "Occasionale",
    InLavorazione = "InLavorazione",
    Obsoleto = "Obsoleto",
}

export class ArticoloTraducibile implements IArticoloTraducibile {
    id?: number;
    templateID?: number | null;
    titoloInterno?: string | null;
    entita?: EArticoloEntita;
    recordID?: number;
    pubblicaDal?: string | null;
    pubblicaAl?: string | null;
    partenzaDal?: string | null;
    partenzaAl?: string | null;
    visibilita?: EArticoloVisibilita;
    status?: EStatoArticolo;
    createdAt?: string;
    updatedAt?: string;
    deletedAt?: string | null;
    sortOrder?: number;

    constructor(data?: IArticoloTraducibile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.templateID = _data["templateID"] !== undefined ? _data["templateID"] : null as any;
            this.titoloInterno = _data["titoloInterno"] !== undefined ? _data["titoloInterno"] : null as any;
            this.entita = _data["entita"] !== undefined ? _data["entita"] : null as any;
            this.recordID = _data["recordID"] !== undefined ? _data["recordID"] : null as any;
            this.pubblicaDal = _data["pubblicaDal"] !== undefined ? _data["pubblicaDal"] : null as any;
            this.pubblicaAl = _data["pubblicaAl"] !== undefined ? _data["pubblicaAl"] : null as any;
            this.partenzaDal = _data["partenzaDal"] !== undefined ? _data["partenzaDal"] : null as any;
            this.partenzaAl = _data["partenzaAl"] !== undefined ? _data["partenzaAl"] : null as any;
            this.visibilita = _data["visibilita"] !== undefined ? _data["visibilita"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.createdAt = _data["createdAt"] !== undefined ? _data["createdAt"] : null as any;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : null as any;
            this.deletedAt = _data["deletedAt"] !== undefined ? _data["deletedAt"] : null as any;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null as any;
        }
    }

    static fromJS(data: any): ArticoloTraducibile {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloTraducibile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["templateID"] = this.templateID !== undefined ? this.templateID : null as any;
        data["titoloInterno"] = this.titoloInterno !== undefined ? this.titoloInterno : null as any;
        data["entita"] = this.entita !== undefined ? this.entita : null as any;
        data["recordID"] = this.recordID !== undefined ? this.recordID : null as any;
        data["pubblicaDal"] = this.pubblicaDal !== undefined ? this.pubblicaDal : null as any;
        data["pubblicaAl"] = this.pubblicaAl !== undefined ? this.pubblicaAl : null as any;
        data["partenzaDal"] = this.partenzaDal !== undefined ? this.partenzaDal : null as any;
        data["partenzaAl"] = this.partenzaAl !== undefined ? this.partenzaAl : null as any;
        data["visibilita"] = this.visibilita !== undefined ? this.visibilita : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["createdAt"] = this.createdAt !== undefined ? this.createdAt : null as any;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : null as any;
        data["deletedAt"] = this.deletedAt !== undefined ? this.deletedAt : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        return data;
    }
}

export interface IArticoloTraducibile {
    id?: number;
    templateID?: number | null;
    titoloInterno?: string | null;
    entita?: EArticoloEntita;
    recordID?: number;
    pubblicaDal?: string | null;
    pubblicaAl?: string | null;
    partenzaDal?: string | null;
    partenzaAl?: string | null;
    visibilita?: EArticoloVisibilita;
    status?: EStatoArticolo;
    createdAt?: string;
    updatedAt?: string;
    deletedAt?: string | null;
    sortOrder?: number;
}

export enum EArticoloEntita {
    Luogo = "Luogo",
    Servizio = "Servizio",
    Tipologia = "Tipologia",
    Itinerario = "Itinerario",
    WebsiteTree = "WebsiteTree",
}

export enum EArticoloVisibilita {
    Nessuna = "Nessuna",
    Web = "Web",
    Offerta = "Offerta",
    Preventivo = "Preventivo",
    ProgrammaDiViaggio = "ProgrammaDiViaggio",
    Voucher = "Voucher",
    EstrattoConto = "EstrattoConto",
    Template = "Template",
}

export enum EStatoArticolo {
    Bozza = "Bozza",
    Pronto = "Pronto",
    Pubblicato = "Pubblicato",
    PubblicatoIntranet = "PubblicatoIntranet",
}

export class TranslateArticleSection implements ITranslateArticleSection {
    id?: number;
    name?: string;
    itinerary?: string | null;
    phrases?: ArticlePhrase[] | null;
    days?: TranslateArticleSectionDay[] | null;

    constructor(data?: ITranslateArticleSection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.itinerary = _data["itinerary"] !== undefined ? _data["itinerary"] : null as any;
            if (Array.isArray(_data["phrases"])) {
                this.phrases = [] as any;
                for (let item of _data["phrases"])
                    this.phrases!.push(ArticlePhrase.fromJS(item));
            }
            else {
                this.phrases = null as any;
            }
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(TranslateArticleSectionDay.fromJS(item));
            }
            else {
                this.days = null as any;
            }
        }
    }

    static fromJS(data: any): TranslateArticleSection {
        data = typeof data === 'object' ? data : {};
        let result = new TranslateArticleSection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["itinerary"] = this.itinerary !== undefined ? this.itinerary : null as any;
        if (Array.isArray(this.phrases)) {
            data["phrases"] = [];
            for (let item of this.phrases)
                data["phrases"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ITranslateArticleSection {
    id?: number;
    name?: string;
    itinerary?: string | null;
    phrases?: ArticlePhrase[] | null;
    days?: TranslateArticleSectionDay[] | null;
}

export class ArticoloFrase implements IArticoloFrase {
    id?: number;
    articoloID?: number;
    fraseID?: number | null;
    frase?: Frase | null;
    terminatore?: EFraseTerminatore;
    articoloTestoID?: number | null;
    sezioneID?: number;
    ordine?: number;
    giorno?: number | null;
    parametri?: string | null;
    visibilita?: EFraseVisibilita;

    constructor(data?: IArticoloFrase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.articoloID = _data["articoloID"] !== undefined ? _data["articoloID"] : null as any;
            this.fraseID = _data["fraseID"] !== undefined ? _data["fraseID"] : null as any;
            this.frase = _data["frase"] ? Frase.fromJS(_data["frase"]) : null as any;
            this.terminatore = _data["terminatore"] !== undefined ? _data["terminatore"] : null as any;
            this.articoloTestoID = _data["articoloTestoID"] !== undefined ? _data["articoloTestoID"] : null as any;
            this.sezioneID = _data["sezioneID"] !== undefined ? _data["sezioneID"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : null as any;
            this.parametri = _data["parametri"] !== undefined ? _data["parametri"] : null as any;
            this.visibilita = _data["visibilita"] !== undefined ? _data["visibilita"] : null as any;
        }
    }

    static fromJS(data: any): ArticoloFrase {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloFrase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["articoloID"] = this.articoloID !== undefined ? this.articoloID : null as any;
        data["fraseID"] = this.fraseID !== undefined ? this.fraseID : null as any;
        data["frase"] = this.frase ? this.frase.toJSON() : null as any;
        data["terminatore"] = this.terminatore !== undefined ? this.terminatore : null as any;
        data["articoloTestoID"] = this.articoloTestoID !== undefined ? this.articoloTestoID : null as any;
        data["sezioneID"] = this.sezioneID !== undefined ? this.sezioneID : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["giorno"] = this.giorno !== undefined ? this.giorno : null as any;
        data["parametri"] = this.parametri !== undefined ? this.parametri : null as any;
        data["visibilita"] = this.visibilita !== undefined ? this.visibilita : null as any;
        return data;
    }
}

export interface IArticoloFrase {
    id?: number;
    articoloID?: number;
    fraseID?: number | null;
    frase?: Frase | null;
    terminatore?: EFraseTerminatore;
    articoloTestoID?: number | null;
    sezioneID?: number;
    ordine?: number;
    giorno?: number | null;
    parametri?: string | null;
    visibilita?: EFraseVisibilita;
}

export class ArticlePhrase extends ArticoloFrase implements IArticlePhrase {
    variables?: { [key: string]: VariabileValore; } | null;

    constructor(data?: IArticlePhrase) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["variables"]) {
                this.variables = {} as any;
                for (let key in _data["variables"]) {
                    if (_data["variables"].hasOwnProperty(key))
                        (this.variables as any)![key] = _data["variables"][key] ? VariabileValore.fromJS(_data["variables"][key]) : new VariabileValore();
                }
            }
            else {
                this.variables = null as any;
            }
        }
    }

    static override fromJS(data: any): ArticlePhrase {
        data = typeof data === 'object' ? data : {};
        let result = new ArticlePhrase();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.variables) {
            data["variables"] = {};
            for (let key in this.variables) {
                if (this.variables.hasOwnProperty(key))
                    (data["variables"] as any)[key] = this.variables[key] ? this.variables[key].toJSON() : null as any;
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IArticlePhrase extends IArticoloFrase {
    variables?: { [key: string]: VariabileValore; } | null;
}

export class VariabileValore implements IVariabileValore {
    default?: string | null;
    valore?: string | null;

    constructor(data?: IVariabileValore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.default = _data["default"] !== undefined ? _data["default"] : null as any;
            this.valore = _data["valore"] !== undefined ? _data["valore"] : null as any;
        }
    }

    static fromJS(data: any): VariabileValore {
        data = typeof data === 'object' ? data : {};
        let result = new VariabileValore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["default"] = this.default !== undefined ? this.default : null as any;
        data["valore"] = this.valore !== undefined ? this.valore : null as any;
        return data;
    }
}

export interface IVariabileValore {
    default?: string | null;
    valore?: string | null;
}

export class Frase implements IFrase {
    id!: number;
    traduzioni?: FraseTraduzione[] | null;
    sezioneID?: number | null;
    luogoID?: number | null;
    luogoDestID?: number | null;
    servizioID?: number | null;
    contattoID?: number | null;
    documentoID?: number | null;
    titoloInterno?: string | null;
    testoITA!: string;
    testoENG?: string | null;
    testoEstesoITA?: string | null;
    testoEstesoENG?: string | null;
    default!: boolean;
    usaFIT!: boolean;
    defaultFIT!: boolean;
    sistema!: boolean;
    codice?: string | null;
    sortOrder?: number | null;
    visibilita!: EFraseVisibilita;
    pasti!: EFrasiPasti;
    createdAt!: string;
    updatedAt!: string;
    deletedAt?: string | null;
    pubblicaDal?: string | null;
    pubblicaAl?: string | null;
    confermato?: boolean | null;
    createdAtENG?: string | null;
    updatedAtENG?: string | null;
    deletedAtENG?: string | null;
    confermatoENG?: boolean | null;

    constructor(data?: IFrase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(FraseTraduzione.fromJS(item));
            }
            else {
                this.traduzioni = null as any;
            }
            this.sezioneID = _data["sezioneID"] !== undefined ? _data["sezioneID"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.luogoDestID = _data["luogoDestID"] !== undefined ? _data["luogoDestID"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : null as any;
            this.titoloInterno = _data["titoloInterno"] !== undefined ? _data["titoloInterno"] : null as any;
            this.testoITA = _data["testoITA"] !== undefined ? _data["testoITA"] : null as any;
            this.testoENG = _data["testoENG"] !== undefined ? _data["testoENG"] : null as any;
            this.testoEstesoITA = _data["testoEstesoITA"] !== undefined ? _data["testoEstesoITA"] : null as any;
            this.testoEstesoENG = _data["testoEstesoENG"] !== undefined ? _data["testoEstesoENG"] : null as any;
            this.default = _data["default"] !== undefined ? _data["default"] : null as any;
            this.usaFIT = _data["usaFIT"] !== undefined ? _data["usaFIT"] : null as any;
            this.defaultFIT = _data["defaultFIT"] !== undefined ? _data["defaultFIT"] : null as any;
            this.sistema = _data["sistema"] !== undefined ? _data["sistema"] : null as any;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null as any;
            this.visibilita = _data["visibilita"] !== undefined ? _data["visibilita"] : null as any;
            this.pasti = _data["pasti"] !== undefined ? _data["pasti"] : null as any;
            this.createdAt = _data["createdAt"] !== undefined ? _data["createdAt"] : null as any;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : null as any;
            this.deletedAt = _data["deletedAt"] !== undefined ? _data["deletedAt"] : null as any;
            this.pubblicaDal = _data["pubblicaDal"] !== undefined ? _data["pubblicaDal"] : null as any;
            this.pubblicaAl = _data["pubblicaAl"] !== undefined ? _data["pubblicaAl"] : null as any;
            this.confermato = _data["confermato"] !== undefined ? _data["confermato"] : null as any;
            this.createdAtENG = _data["createdAtENG"] !== undefined ? _data["createdAtENG"] : null as any;
            this.updatedAtENG = _data["updatedAtENG"] !== undefined ? _data["updatedAtENG"] : null as any;
            this.deletedAtENG = _data["deletedAtENG"] !== undefined ? _data["deletedAtENG"] : null as any;
            this.confermatoENG = _data["confermatoENG"] !== undefined ? _data["confermatoENG"] : null as any;
        }
    }

    static fromJS(data: any): Frase {
        data = typeof data === 'object' ? data : {};
        let result = new Frase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item ? item.toJSON() : null as any);
        }
        data["sezioneID"] = this.sezioneID !== undefined ? this.sezioneID : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["luogoDestID"] = this.luogoDestID !== undefined ? this.luogoDestID : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : null as any;
        data["titoloInterno"] = this.titoloInterno !== undefined ? this.titoloInterno : null as any;
        data["testoITA"] = this.testoITA !== undefined ? this.testoITA : null as any;
        data["testoENG"] = this.testoENG !== undefined ? this.testoENG : null as any;
        data["testoEstesoITA"] = this.testoEstesoITA !== undefined ? this.testoEstesoITA : null as any;
        data["testoEstesoENG"] = this.testoEstesoENG !== undefined ? this.testoEstesoENG : null as any;
        data["default"] = this.default !== undefined ? this.default : null as any;
        data["usaFIT"] = this.usaFIT !== undefined ? this.usaFIT : null as any;
        data["defaultFIT"] = this.defaultFIT !== undefined ? this.defaultFIT : null as any;
        data["sistema"] = this.sistema !== undefined ? this.sistema : null as any;
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        data["visibilita"] = this.visibilita !== undefined ? this.visibilita : null as any;
        data["pasti"] = this.pasti !== undefined ? this.pasti : null as any;
        data["createdAt"] = this.createdAt !== undefined ? this.createdAt : null as any;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : null as any;
        data["deletedAt"] = this.deletedAt !== undefined ? this.deletedAt : null as any;
        data["pubblicaDal"] = this.pubblicaDal !== undefined ? this.pubblicaDal : null as any;
        data["pubblicaAl"] = this.pubblicaAl !== undefined ? this.pubblicaAl : null as any;
        data["confermato"] = this.confermato !== undefined ? this.confermato : null as any;
        data["createdAtENG"] = this.createdAtENG !== undefined ? this.createdAtENG : null as any;
        data["updatedAtENG"] = this.updatedAtENG !== undefined ? this.updatedAtENG : null as any;
        data["deletedAtENG"] = this.deletedAtENG !== undefined ? this.deletedAtENG : null as any;
        data["confermatoENG"] = this.confermatoENG !== undefined ? this.confermatoENG : null as any;
        return data;
    }
}

export interface IFrase {
    id: number;
    traduzioni?: FraseTraduzione[] | null;
    sezioneID?: number | null;
    luogoID?: number | null;
    luogoDestID?: number | null;
    servizioID?: number | null;
    contattoID?: number | null;
    documentoID?: number | null;
    titoloInterno?: string | null;
    testoITA: string;
    testoENG?: string | null;
    testoEstesoITA?: string | null;
    testoEstesoENG?: string | null;
    default: boolean;
    usaFIT: boolean;
    defaultFIT: boolean;
    sistema: boolean;
    codice?: string | null;
    sortOrder?: number | null;
    visibilita: EFraseVisibilita;
    pasti: EFrasiPasti;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string | null;
    pubblicaDal?: string | null;
    pubblicaAl?: string | null;
    confermato?: boolean | null;
    createdAtENG?: string | null;
    updatedAtENG?: string | null;
    deletedAtENG?: string | null;
    confermatoENG?: boolean | null;
}

export class FraseTraduzione implements IFraseTraduzione {
    id?: number;
    fraseID?: number;
    lingua?: ELingua;
    testo?: string | null;
    confermata?: boolean;
    creazione?: string | null;
    ultimoAggiornamento?: string | null;

    constructor(data?: IFraseTraduzione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.fraseID = _data["fraseID"] !== undefined ? _data["fraseID"] : null as any;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : null as any;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : null as any;
            this.confermata = _data["confermata"] !== undefined ? _data["confermata"] : null as any;
            this.creazione = _data["creazione"] !== undefined ? _data["creazione"] : null as any;
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] !== undefined ? _data["ultimoAggiornamento"] : null as any;
        }
    }

    static fromJS(data: any): FraseTraduzione {
        data = typeof data === 'object' ? data : {};
        let result = new FraseTraduzione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["fraseID"] = this.fraseID !== undefined ? this.fraseID : null as any;
        data["lingua"] = this.lingua !== undefined ? this.lingua : null as any;
        data["testo"] = this.testo !== undefined ? this.testo : null as any;
        data["confermata"] = this.confermata !== undefined ? this.confermata : null as any;
        data["creazione"] = this.creazione !== undefined ? this.creazione : null as any;
        data["ultimoAggiornamento"] = this.ultimoAggiornamento !== undefined ? this.ultimoAggiornamento : null as any;
        return data;
    }
}

export interface IFraseTraduzione {
    id?: number;
    fraseID?: number;
    lingua?: ELingua;
    testo?: string | null;
    confermata?: boolean;
    creazione?: string | null;
    ultimoAggiornamento?: string | null;
}

export enum EFraseVisibilita {
    Tutto = "Tutto",
    ProgrammaDiViaggio = "ProgrammaDiViaggio",
    Web = "Web",
    PreventivoCliente = "PreventivoCliente",
}

export enum EFrasiPasti {
    Nessuno = "Nessuno",
    Colazione = "Colazione",
    PranzoAlSacco = "PranzoAlSacco",
    Pranzo = "Pranzo",
    Cena = "Cena",
}

export enum EFraseTerminatore {
    Nessuno = "Nessuno",
    ACapo = "ACapo",
    Punto = "Punto",
    PuntoACapo = "PuntoACapo",
    Virgola = "Virgola",
    PuntoEVirgola = "PuntoEVirgola",
    Duepunti = "Duepunti",
    Trattino = "Trattino",
    PuntoEVirgolaACapo = "PuntoEVirgolaACapo",
    DoppioACapo = "DoppioACapo",
    PuntoEDoppioACapo = "PuntoEDoppioACapo",
    SegueMaiuscolo = "SegueMaiuscolo",
    ACapoESegueMaiuscolo = "ACapoESegueMaiuscolo",
    Separatore = "Separatore",
}

export class TranslateArticleSectionDay implements ITranslateArticleSectionDay {
    day?: number;
    dayName?: string;
    place?: string | null;
    serviceID?: number | null;
    duration?: number | null;
    phrases?: ArticlePhrase[];

    constructor(data?: ITranslateArticleSectionDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.day = _data["day"] !== undefined ? _data["day"] : null as any;
            this.dayName = _data["dayName"] !== undefined ? _data["dayName"] : null as any;
            this.place = _data["place"] !== undefined ? _data["place"] : null as any;
            this.serviceID = _data["serviceID"] !== undefined ? _data["serviceID"] : null as any;
            this.duration = _data["duration"] !== undefined ? _data["duration"] : null as any;
            if (Array.isArray(_data["phrases"])) {
                this.phrases = [] as any;
                for (let item of _data["phrases"])
                    this.phrases!.push(ArticlePhrase.fromJS(item));
            }
            else {
                this.phrases = null as any;
            }
        }
    }

    static fromJS(data: any): TranslateArticleSectionDay {
        data = typeof data === 'object' ? data : {};
        let result = new TranslateArticleSectionDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day !== undefined ? this.day : null as any;
        data["dayName"] = this.dayName !== undefined ? this.dayName : null as any;
        data["place"] = this.place !== undefined ? this.place : null as any;
        data["serviceID"] = this.serviceID !== undefined ? this.serviceID : null as any;
        data["duration"] = this.duration !== undefined ? this.duration : null as any;
        if (Array.isArray(this.phrases)) {
            data["phrases"] = [];
            for (let item of this.phrases)
                data["phrases"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ITranslateArticleSectionDay {
    day?: number;
    dayName?: string;
    place?: string | null;
    serviceID?: number | null;
    duration?: number | null;
    phrases?: ArticlePhrase[];
}

export class IdValore implements IIdValore {
    id?: number;
    valore?: string;

    constructor(data?: IIdValore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.valore = _data["valore"] !== undefined ? _data["valore"] : null as any;
        }
    }

    static fromJS(data: any): IdValore {
        data = typeof data === 'object' ? data : {};
        let result = new IdValore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["valore"] = this.valore !== undefined ? this.valore : null as any;
        return data;
    }
}

export interface IIdValore {
    id?: number;
    valore?: string;
}

export class UpdateTextsRequest extends TextsGetRequest implements IUpdateTextsRequest {
    articoloTraducibile?: ArticoloTraducibile | null;
    sections?: TranslateArticleSection[] | null;

    constructor(data?: IUpdateTextsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.articoloTraducibile = _data["articoloTraducibile"] ? ArticoloTraducibile.fromJS(_data["articoloTraducibile"]) : null as any;
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(TranslateArticleSection.fromJS(item));
            }
            else {
                this.sections = null as any;
            }
        }
    }

    static override fromJS(data: any): UpdateTextsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTextsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articoloTraducibile"] = this.articoloTraducibile ? this.articoloTraducibile.toJSON() : null as any;
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateTextsRequest extends ITextsGetRequest {
    articoloTraducibile?: ArticoloTraducibile | null;
    sections?: TranslateArticleSection[] | null;
}

export class TextDeleteRequest extends ApiRequest implements ITextDeleteRequest {
    testoID?: number;

    constructor(data?: ITextDeleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.testoID = _data["testoID"] !== undefined ? _data["testoID"] : null as any;
        }
    }

    static override fromJS(data: any): TextDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TextDeleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["testoID"] = this.testoID !== undefined ? this.testoID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITextDeleteRequest extends IApiRequest {
    testoID?: number;
}

export class TextsGetFrasiDefaultResponse extends OkApiResponse implements ITextsGetFrasiDefaultResponse {
    section?: TranslateArticleSection;

    constructor(data?: ITextsGetFrasiDefaultResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.section = _data["section"] ? TranslateArticleSection.fromJS(_data["section"]) : null as any;
        }
    }

    static override fromJS(data: any): TextsGetFrasiDefaultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TextsGetFrasiDefaultResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["section"] = this.section ? this.section.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITextsGetFrasiDefaultResponse extends IOkApiResponse {
    section?: TranslateArticleSection;
}

export class TextsGetFrasiDefaultRequest extends LocalizedRequest implements ITextsGetFrasiDefaultRequest {
    sezioneID?: number | null;
    luogoID?: number | null;
    servizioID?: number | null;

    constructor(data?: ITextsGetFrasiDefaultRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sezioneID = _data["sezioneID"] !== undefined ? _data["sezioneID"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
        }
    }

    static override fromJS(data: any): TextsGetFrasiDefaultRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TextsGetFrasiDefaultRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sezioneID"] = this.sezioneID !== undefined ? this.sezioneID : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITextsGetFrasiDefaultRequest extends ILocalizedRequest {
    sezioneID?: number | null;
    luogoID?: number | null;
    servizioID?: number | null;
}

export class TextsGetItinerarioResponse extends OkApiResponse implements ITextsGetItinerarioResponse {
    section?: TranslateArticleSection;

    constructor(data?: ITextsGetItinerarioResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.section = _data["section"] ? TranslateArticleSection.fromJS(_data["section"]) : null as any;
        }
    }

    static override fromJS(data: any): TextsGetItinerarioResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TextsGetItinerarioResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["section"] = this.section ? this.section.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITextsGetItinerarioResponse extends IOkApiResponse {
    section?: TranslateArticleSection;
}

export class TextsGetItinerarioRequest extends LocalizedRequest implements ITextsGetItinerarioRequest {
    servizioID?: number | null;

    constructor(data?: ITextsGetItinerarioRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
        }
    }

    static override fromJS(data: any): TextsGetItinerarioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TextsGetItinerarioRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITextsGetItinerarioRequest extends ILocalizedRequest {
    servizioID?: number | null;
}

export class TextGetArticlePhraseResponse extends OkApiResponse implements ITextGetArticlePhraseResponse {
    articlePhrase?: ArticlePhrase;

    constructor(data?: ITextGetArticlePhraseResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.articlePhrase = _data["articlePhrase"] ? ArticlePhrase.fromJS(_data["articlePhrase"]) : null as any;
        }
    }

    static override fromJS(data: any): TextGetArticlePhraseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TextGetArticlePhraseResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articlePhrase"] = this.articlePhrase ? this.articlePhrase.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITextGetArticlePhraseResponse extends IOkApiResponse {
    articlePhrase?: ArticlePhrase;
}

export class TextGetArticlePhraseRequest extends LocalizedRequest implements ITextGetArticlePhraseRequest {
    phraseID?: number;

    constructor(data?: ITextGetArticlePhraseRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phraseID = _data["phraseID"] !== undefined ? _data["phraseID"] : null as any;
        }
    }

    static override fromJS(data: any): TextGetArticlePhraseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TextGetArticlePhraseRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phraseID"] = this.phraseID !== undefined ? this.phraseID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITextGetArticlePhraseRequest extends ILocalizedRequest {
    phraseID?: number;
}

export class NrTableResponseOfTextsRow extends OkApiResponse implements INrTableResponseOfTextsRow {
    /** Array delle righe della pagina richiesta */
    rows?: TextsRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfTextsRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TextsRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfTextsRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfTextsRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfTextsRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: TextsRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class ListTextsResponse extends NrTableResponseOfTextsRow implements IListTextsResponse {

    constructor(data?: IListTextsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ListTextsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListTextsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IListTextsResponse extends INrTableResponseOfTextsRow {
}

export class TextsRow implements ITextsRow {
    id?: number;
    title?: string | null;
    luogo?: string | null;
    servizio?: string | null;
    contatto?: string | null;
    paese?: string | null;
    tipoServizio?: ETipoServizioFlags | null;
    status?: EStatoArticolo | null;

    constructor(data?: ITextsRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : null as any;
            this.contatto = _data["contatto"] !== undefined ? _data["contatto"] : null as any;
            this.paese = _data["paese"] !== undefined ? _data["paese"] : null as any;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
        }
    }

    static fromJS(data: any): TextsRow {
        data = typeof data === 'object' ? data : {};
        let result = new TextsRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["servizio"] = this.servizio !== undefined ? this.servizio : null as any;
        data["contatto"] = this.contatto !== undefined ? this.contatto : null as any;
        data["paese"] = this.paese !== undefined ? this.paese : null as any;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        return data;
    }
}

export interface ITextsRow {
    id?: number;
    title?: string | null;
    luogo?: string | null;
    servizio?: string | null;
    contatto?: string | null;
    paese?: string | null;
    tipoServizio?: ETipoServizioFlags | null;
    status?: EStatoArticolo | null;
}

export class ListTextsRequest extends NrTableRequest implements IListTextsRequest {
    /** Termine di ricerca: ID, titolo, parti di testo */
    term?: string | null;
    /** Se true cerca solo frasi non associate a luogo */
    noLuogo?: boolean;
    /** Se true cerca solo frasi non associate a servizio */
    noServizio?: boolean;
    /** Se true cerca solo frasi non associate a contatto */
    noContatto?: boolean;
    /** Filtro sugli ID luogo. Se presente la frase deve appartenere ad uno di questi luoghi */
    luoghiIds?: number[] | null;
    /** Filtro sugli ID servizio. Se presente la frase deve appartenere ad uno di questi servizi */
    serviziIds?: number[] | null;
    /** Filtro sugli ID contatto. Se presente la frase deve appartenere ad uno di questi contatti */
    contattiIds?: number[] | null;
    paeseID?: number | null;
    status?: EStatoArticolo | null;
    tipoServizio?: ETipoServizioFlags | null;

    constructor(data?: IListTextsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : null as any;
            this.noLuogo = _data["noLuogo"] !== undefined ? _data["noLuogo"] : null as any;
            this.noServizio = _data["noServizio"] !== undefined ? _data["noServizio"] : null as any;
            this.noContatto = _data["noContatto"] !== undefined ? _data["noContatto"] : null as any;
            if (Array.isArray(_data["luoghiIds"])) {
                this.luoghiIds = [] as any;
                for (let item of _data["luoghiIds"])
                    this.luoghiIds!.push(item);
            }
            else {
                this.luoghiIds = null as any;
            }
            if (Array.isArray(_data["serviziIds"])) {
                this.serviziIds = [] as any;
                for (let item of _data["serviziIds"])
                    this.serviziIds!.push(item);
            }
            else {
                this.serviziIds = null as any;
            }
            if (Array.isArray(_data["contattiIds"])) {
                this.contattiIds = [] as any;
                for (let item of _data["contattiIds"])
                    this.contattiIds!.push(item);
            }
            else {
                this.contattiIds = null as any;
            }
            this.paeseID = _data["paeseID"] !== undefined ? _data["paeseID"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
        }
    }

    static override fromJS(data: any): ListTextsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListTextsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : null as any;
        data["noLuogo"] = this.noLuogo !== undefined ? this.noLuogo : null as any;
        data["noServizio"] = this.noServizio !== undefined ? this.noServizio : null as any;
        data["noContatto"] = this.noContatto !== undefined ? this.noContatto : null as any;
        if (Array.isArray(this.luoghiIds)) {
            data["luoghiIds"] = [];
            for (let item of this.luoghiIds)
                data["luoghiIds"].push(item);
        }
        if (Array.isArray(this.serviziIds)) {
            data["serviziIds"] = [];
            for (let item of this.serviziIds)
                data["serviziIds"].push(item);
        }
        if (Array.isArray(this.contattiIds)) {
            data["contattiIds"] = [];
            for (let item of this.contattiIds)
                data["contattiIds"].push(item);
        }
        data["paeseID"] = this.paeseID !== undefined ? this.paeseID : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IListTextsRequest extends INrTableRequest {
    /** Termine di ricerca: ID, titolo, parti di testo */
    term?: string | null;
    /** Se true cerca solo frasi non associate a luogo */
    noLuogo?: boolean;
    /** Se true cerca solo frasi non associate a servizio */
    noServizio?: boolean;
    /** Se true cerca solo frasi non associate a contatto */
    noContatto?: boolean;
    /** Filtro sugli ID luogo. Se presente la frase deve appartenere ad uno di questi luoghi */
    luoghiIds?: number[] | null;
    /** Filtro sugli ID servizio. Se presente la frase deve appartenere ad uno di questi servizi */
    serviziIds?: number[] | null;
    /** Filtro sugli ID contatto. Se presente la frase deve appartenere ad uno di questi contatti */
    contattiIds?: number[] | null;
    paeseID?: number | null;
    status?: EStatoArticolo | null;
    tipoServizio?: ETipoServizioFlags | null;
}

/** Dati dell'utente */
export class UserDataResponse extends OkApiResponse implements IUserDataResponse {
    /** ID in chiaro */
    id?: number;
    /** User email */
    email?: string | null;
    /** ID criptato per operazioni in SSO */
    ssoToken?: string;
    /** Nome */
    nome?: string | null;
    /** Cognome */
    cognome?: string | null;
    /** Tipo di utente */
    tipo?: ETipoUtente;
    /** Elenco complessivo dei suoi permessi */
    permessi?: string[];
    /** Can Book Flight -> diverso dai permessi!!! e su userinfo */
    canBookFlights?: boolean;
    /** Può prenotare? */
    canBook?: boolean;
    master?: EUserMaster | null;
    /** Opzioni del frontend */
    opzioniUI?: OpzioniUI;
    /** Dati dell'agenzia dell'utente, se ne ha una */
    agencyData?: AgencyData | null;
    /** Dati di debug con le impostazioni del server */
    debugData?: DebugData;
    operator?: EOperatore;
    mustChangePassword?: boolean;
    resetPasswordCode?: string | null;

    constructor(data?: IUserDataResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.ssoToken = _data["ssoToken"] !== undefined ? _data["ssoToken"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            if (Array.isArray(_data["permessi"])) {
                this.permessi = [] as any;
                for (let item of _data["permessi"])
                    this.permessi!.push(item);
            }
            else {
                this.permessi = null as any;
            }
            this.canBookFlights = _data["canBookFlights"] !== undefined ? _data["canBookFlights"] : null as any;
            this.canBook = _data["canBook"] !== undefined ? _data["canBook"] : null as any;
            this.master = _data["master"] !== undefined ? _data["master"] : null as any;
            this.opzioniUI = _data["opzioniUI"] ? OpzioniUI.fromJS(_data["opzioniUI"]) : null as any;
            this.agencyData = _data["agencyData"] ? AgencyData.fromJS(_data["agencyData"]) : null as any;
            this.debugData = _data["debugData"] ? DebugData.fromJS(_data["debugData"]) : null as any;
            this.operator = _data["operator"] !== undefined ? _data["operator"] : null as any;
            this.mustChangePassword = _data["mustChangePassword"] !== undefined ? _data["mustChangePassword"] : null as any;
            this.resetPasswordCode = _data["resetPasswordCode"] !== undefined ? _data["resetPasswordCode"] : null as any;
        }
    }

    static override fromJS(data: any): UserDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserDataResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["ssoToken"] = this.ssoToken !== undefined ? this.ssoToken : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["cognome"] = this.cognome !== undefined ? this.cognome : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        if (Array.isArray(this.permessi)) {
            data["permessi"] = [];
            for (let item of this.permessi)
                data["permessi"].push(item);
        }
        data["canBookFlights"] = this.canBookFlights !== undefined ? this.canBookFlights : null as any;
        data["canBook"] = this.canBook !== undefined ? this.canBook : null as any;
        data["master"] = this.master !== undefined ? this.master : null as any;
        data["opzioniUI"] = this.opzioniUI ? this.opzioniUI.toJSON() : null as any;
        data["agencyData"] = this.agencyData ? this.agencyData.toJSON() : null as any;
        data["debugData"] = this.debugData ? this.debugData.toJSON() : null as any;
        data["operator"] = this.operator !== undefined ? this.operator : null as any;
        data["mustChangePassword"] = this.mustChangePassword !== undefined ? this.mustChangePassword : null as any;
        data["resetPasswordCode"] = this.resetPasswordCode !== undefined ? this.resetPasswordCode : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Dati dell'utente */
export interface IUserDataResponse extends IOkApiResponse {
    /** ID in chiaro */
    id?: number;
    /** User email */
    email?: string | null;
    /** ID criptato per operazioni in SSO */
    ssoToken?: string;
    /** Nome */
    nome?: string | null;
    /** Cognome */
    cognome?: string | null;
    /** Tipo di utente */
    tipo?: ETipoUtente;
    /** Elenco complessivo dei suoi permessi */
    permessi?: string[];
    /** Can Book Flight -> diverso dai permessi!!! e su userinfo */
    canBookFlights?: boolean;
    /** Può prenotare? */
    canBook?: boolean;
    master?: EUserMaster | null;
    /** Opzioni del frontend */
    opzioniUI?: OpzioniUI;
    /** Dati dell'agenzia dell'utente, se ne ha una */
    agencyData?: AgencyData | null;
    /** Dati di debug con le impostazioni del server */
    debugData?: DebugData;
    operator?: EOperatore;
    mustChangePassword?: boolean;
    resetPasswordCode?: string | null;
}

export enum ETipoUtente {
    Privato = "Privato",
    Agenzia = "Agenzia",
    Intranet = "Intranet",
    TestCertificazioni = "TestCertificazioni",
}

export enum EUserMaster {
    Master = "Master",
    NetworkMaster = "NetworkMaster",
}

/** Classe con le opzioni di frontend dell'utene */
export class OpzioniUI implements IOpzioniUI {
    /** Nome del tema del sito (usato dal sito vecchio) */
    theme?: string | null;
    /** Nome del tema Nebular della intranet */
    intranetTheme?: string | null;
    /** Lingua preferita */
    lang?: string | null;
    presaVisionePrivacy?: string | null;

    constructor(data?: IOpzioniUI) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"] !== undefined ? _data["theme"] : null as any;
            this.intranetTheme = _data["intranetTheme"] !== undefined ? _data["intranetTheme"] : null as any;
            this.lang = _data["lang"] !== undefined ? _data["lang"] : null as any;
            this.presaVisionePrivacy = _data["presaVisionePrivacy"] !== undefined ? _data["presaVisionePrivacy"] : null as any;
        }
    }

    static fromJS(data: any): OpzioniUI {
        data = typeof data === 'object' ? data : {};
        let result = new OpzioniUI();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme !== undefined ? this.theme : null as any;
        data["intranetTheme"] = this.intranetTheme !== undefined ? this.intranetTheme : null as any;
        data["lang"] = this.lang !== undefined ? this.lang : null as any;
        data["presaVisionePrivacy"] = this.presaVisionePrivacy !== undefined ? this.presaVisionePrivacy : null as any;
        return data;
    }
}

/** Classe con le opzioni di frontend dell'utene */
export interface IOpzioniUI {
    /** Nome del tema del sito (usato dal sito vecchio) */
    theme?: string | null;
    /** Nome del tema Nebular della intranet */
    intranetTheme?: string | null;
    /** Lingua preferita */
    lang?: string | null;
    presaVisionePrivacy?: string | null;
}

/** Dati dell'agenzia dell'utente */
export class AgencyData implements IAgencyData {
    /** ID del contatto agenzia */
    agencyID?: number;
    /** Nome visualizzato del contatto */
    agencyName?: string;
    /** Url del logo dell'agenzia, se ce l'ha */
    agencyLogoUrl?: string | null;

    constructor(data?: IAgencyData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agencyID = _data["agencyID"] !== undefined ? _data["agencyID"] : null as any;
            this.agencyName = _data["agencyName"] !== undefined ? _data["agencyName"] : null as any;
            this.agencyLogoUrl = _data["agencyLogoUrl"] !== undefined ? _data["agencyLogoUrl"] : null as any;
        }
    }

    static fromJS(data: any): AgencyData {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agencyID"] = this.agencyID !== undefined ? this.agencyID : null as any;
        data["agencyName"] = this.agencyName !== undefined ? this.agencyName : null as any;
        data["agencyLogoUrl"] = this.agencyLogoUrl !== undefined ? this.agencyLogoUrl : null as any;
        return data;
    }
}

/** Dati dell'agenzia dell'utente */
export interface IAgencyData {
    /** ID del contatto agenzia */
    agencyID?: number;
    /** Nome visualizzato del contatto */
    agencyName?: string;
    /** Url del logo dell'agenzia, se ce l'ha */
    agencyLogoUrl?: string | null;
}

export class DebugData implements IDebugData {
    /** Se true il server è compilato in debug */
    isDebug?: boolean;
    /** IP/Nome del server del database Naar7 */
    naarDatabaseServer?: string | null;
    /** Nome del database Naar7 */
    naarDatabaseName?: string | null;
    /** IP/Nome del server del database NaarHH */
    hhDatabaseServer?: string | null;
    /** Nome del database NaarHH */
    hhDatabaseName?: string | null;
    /** IP/Nome del server del database NaarDocs */
    docsDatabaseServer?: string | null;
    /** Nome del database NaarDocs */
    docsDatabaseName?: string | null;
    /** Coda delle richieste al pricer */
    pricerQueueName?: string | null;
    /** Coda delle richiestea all'agent */
    agentQueueName?: string | null;

    constructor(data?: IDebugData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDebug = _data["isDebug"] !== undefined ? _data["isDebug"] : null as any;
            this.naarDatabaseServer = _data["naarDatabaseServer"] !== undefined ? _data["naarDatabaseServer"] : null as any;
            this.naarDatabaseName = _data["naarDatabaseName"] !== undefined ? _data["naarDatabaseName"] : null as any;
            this.hhDatabaseServer = _data["hhDatabaseServer"] !== undefined ? _data["hhDatabaseServer"] : null as any;
            this.hhDatabaseName = _data["hhDatabaseName"] !== undefined ? _data["hhDatabaseName"] : null as any;
            this.docsDatabaseServer = _data["docsDatabaseServer"] !== undefined ? _data["docsDatabaseServer"] : null as any;
            this.docsDatabaseName = _data["docsDatabaseName"] !== undefined ? _data["docsDatabaseName"] : null as any;
            this.pricerQueueName = _data["pricerQueueName"] !== undefined ? _data["pricerQueueName"] : null as any;
            this.agentQueueName = _data["agentQueueName"] !== undefined ? _data["agentQueueName"] : null as any;
        }
    }

    static fromJS(data: any): DebugData {
        data = typeof data === 'object' ? data : {};
        let result = new DebugData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDebug"] = this.isDebug !== undefined ? this.isDebug : null as any;
        data["naarDatabaseServer"] = this.naarDatabaseServer !== undefined ? this.naarDatabaseServer : null as any;
        data["naarDatabaseName"] = this.naarDatabaseName !== undefined ? this.naarDatabaseName : null as any;
        data["hhDatabaseServer"] = this.hhDatabaseServer !== undefined ? this.hhDatabaseServer : null as any;
        data["hhDatabaseName"] = this.hhDatabaseName !== undefined ? this.hhDatabaseName : null as any;
        data["docsDatabaseServer"] = this.docsDatabaseServer !== undefined ? this.docsDatabaseServer : null as any;
        data["docsDatabaseName"] = this.docsDatabaseName !== undefined ? this.docsDatabaseName : null as any;
        data["pricerQueueName"] = this.pricerQueueName !== undefined ? this.pricerQueueName : null as any;
        data["agentQueueName"] = this.agentQueueName !== undefined ? this.agentQueueName : null as any;
        return data;
    }
}

export interface IDebugData {
    /** Se true il server è compilato in debug */
    isDebug?: boolean;
    /** IP/Nome del server del database Naar7 */
    naarDatabaseServer?: string | null;
    /** Nome del database Naar7 */
    naarDatabaseName?: string | null;
    /** IP/Nome del server del database NaarHH */
    hhDatabaseServer?: string | null;
    /** Nome del database NaarHH */
    hhDatabaseName?: string | null;
    /** IP/Nome del server del database NaarDocs */
    docsDatabaseServer?: string | null;
    /** Nome del database NaarDocs */
    docsDatabaseName?: string | null;
    /** Coda delle richieste al pricer */
    pricerQueueName?: string | null;
    /** Coda delle richiestea all'agent */
    agentQueueName?: string | null;
}

export class CheckCrossLoginResponse extends OkApiResponse implements ICheckCrossLoginResponse {
    /** Nome visualizzato dell'utente che ha chiesto il token e che dovrà autenticarsi */
    requestUserDiplayName?: string | null;
    /** Nome visualzzato dell'utente target */
    targetUserDisplayName?: string | null;

    constructor(data?: ICheckCrossLoginResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.requestUserDiplayName = _data["requestUserDiplayName"] !== undefined ? _data["requestUserDiplayName"] : null as any;
            this.targetUserDisplayName = _data["targetUserDisplayName"] !== undefined ? _data["targetUserDisplayName"] : null as any;
        }
    }

    static override fromJS(data: any): CheckCrossLoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CheckCrossLoginResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestUserDiplayName"] = this.requestUserDiplayName !== undefined ? this.requestUserDiplayName : null as any;
        data["targetUserDisplayName"] = this.targetUserDisplayName !== undefined ? this.targetUserDisplayName : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICheckCrossLoginResponse extends IOkApiResponse {
    /** Nome visualizzato dell'utente che ha chiesto il token e che dovrà autenticarsi */
    requestUserDiplayName?: string | null;
    /** Nome visualzzato dell'utente target */
    targetUserDisplayName?: string | null;
}

export class CheckCrossLoginRequest extends ApiRequest implements ICheckCrossLoginRequest {
    /** Codice univoco monouso da testare */
    codice?: string;

    constructor(data?: ICheckCrossLoginRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
        }
    }

    static override fromJS(data: any): CheckCrossLoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckCrossLoginRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICheckCrossLoginRequest extends IApiRequest {
    /** Codice univoco monouso da testare */
    codice?: string;
}

/** Response containing the user's onboarding tour progress JSON. */
export class GetOnboardingProgressResponse extends OkApiResponse implements IGetOnboardingProgressResponse {
    /** JSON string with the user's onboarding progress.
null if the user has no progress yet. */
    onboardingProgress?: string | null;

    constructor(data?: IGetOnboardingProgressResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.onboardingProgress = _data["onboardingProgress"] !== undefined ? _data["onboardingProgress"] : null as any;
        }
    }

    static override fromJS(data: any): GetOnboardingProgressResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOnboardingProgressResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onboardingProgress"] = this.onboardingProgress !== undefined ? this.onboardingProgress : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Response containing the user's onboarding tour progress JSON. */
export interface IGetOnboardingProgressResponse extends IOkApiResponse {
    /** JSON string with the user's onboarding progress.
null if the user has no progress yet. */
    onboardingProgress?: string | null;
}

/** Form di login */
export class LoginRequest extends ApiRequest implements ILoginRequest {
    /** Nome utente */
    username!: string;
    /** Password */
    password!: string;
    /** Eventuale codice di cross login per impersonare un altro utente */
    crossLoginCode?: string | null;

    constructor(data?: ILoginRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.username = _data["username"] !== undefined ? _data["username"] : null as any;
            this.password = _data["password"] !== undefined ? _data["password"] : null as any;
            this.crossLoginCode = _data["crossLoginCode"] !== undefined ? _data["crossLoginCode"] : null as any;
        }
    }

    static override fromJS(data: any): LoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username !== undefined ? this.username : null as any;
        data["password"] = this.password !== undefined ? this.password : null as any;
        data["crossLoginCode"] = this.crossLoginCode !== undefined ? this.crossLoginCode : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Form di login */
export interface ILoginRequest extends IApiRequest {
    /** Nome utente */
    username: string;
    /** Password */
    password: string;
    /** Eventuale codice di cross login per impersonare un altro utente */
    crossLoginCode?: string | null;
}

export class LoginViaEmailRequest extends ApiRequest implements ILoginViaEmailRequest {
    /** Nome utente */
    username!: string;
    /** Codice per accesso temporaneo */
    emailLoginCode!: string;

    constructor(data?: ILoginViaEmailRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.username = _data["username"] !== undefined ? _data["username"] : null as any;
            this.emailLoginCode = _data["emailLoginCode"] !== undefined ? _data["emailLoginCode"] : null as any;
        }
    }

    static override fromJS(data: any): LoginViaEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginViaEmailRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username !== undefined ? this.username : null as any;
        data["emailLoginCode"] = this.emailLoginCode !== undefined ? this.emailLoginCode : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ILoginViaEmailRequest extends IApiRequest {
    /** Nome utente */
    username: string;
    /** Codice per accesso temporaneo */
    emailLoginCode: string;
}

/** Request to save the user's onboarding tour progress. */
export class SaveOnboardingProgressRequest extends ApiRequest implements ISaveOnboardingProgressRequest {
    /** JSON string containing the onboarding progress array.
Expected format: [{ "path": "...", "stepId": "...", "seenDate": "..." }, ...]. */
    onboardingProgress!: string;

    constructor(data?: ISaveOnboardingProgressRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.onboardingProgress = _data["onboardingProgress"] !== undefined ? _data["onboardingProgress"] : null as any;
        }
    }

    static override fromJS(data: any): SaveOnboardingProgressRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveOnboardingProgressRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onboardingProgress"] = this.onboardingProgress !== undefined ? this.onboardingProgress : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Request to save the user's onboarding tour progress. */
export interface ISaveOnboardingProgressRequest extends IApiRequest {
    /** JSON string containing the onboarding progress array.
Expected format: [{ "path": "...", "stepId": "...", "seenDate": "..." }, ...]. */
    onboardingProgress: string;
}

/** Risposta al salvataggio delle opzioni utente */
export class SaveUserOptionsResponse extends OkApiResponse implements ISaveUserOptionsResponse {
    /** Oggetto utente aggiornato */
    user?: Utente;
    /** Opzioni utente aggiorntate */
    uiOptions?: any;

    constructor(data?: ISaveUserOptionsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.user = _data["user"] ? Utente.fromJS(_data["user"]) : null as any;
            this.uiOptions = _data["uiOptions"] !== undefined ? _data["uiOptions"] : null as any;
        }
    }

    static override fromJS(data: any): SaveUserOptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveUserOptionsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : null as any;
        data["uiOptions"] = this.uiOptions !== undefined ? this.uiOptions : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Risposta al salvataggio delle opzioni utente */
export interface ISaveUserOptionsResponse extends IOkApiResponse {
    /** Oggetto utente aggiornato */
    user?: Utente;
    /** Opzioni utente aggiorntate */
    uiOptions?: any;
}

export class Utente implements IUtente {
    id?: number;
    contattoAgenziaID?: number | null;
    contattoUtenteID?: number | null;
    tipoUtente?: ETipoUtente | null;
    registrationDate?: string;
    email?: string | null;
    nome?: string | null;
    cognome?: string | null;
    passwordInChiaro?: string | null;
    passwordCifrata?: string | null;
    abilitato?: boolean;
    deleted?: string | null;
    operatoreID?: number | null;
    operatore?: EOperatore | null;
    abilitazioneCrs?: number | null;
    telefono?: string | null;
    teamID?: string | null;
    npr?: boolean;
    uiOptions?: string | null;
    fuorisede?: boolean;
    emailFuorisede?: string | null;
    categoriaContattoID?: number | null;
    utentePadreID?: number | null;
    basecampRefreshToken?: string | null;
    ultimoAccesso?: string | null;
    ultimoAggiornamentoPassword?: string | null;
    fastLoginEnabled?: boolean | null;
    fastLogingEnabledDate?: string | null;
    fastLoginTokenValidityDays?: number | null;
    fastLoginToken?: string | null;
    emailLoginEnabled?: boolean | null;
    master?: EUserMaster | null;
    onboardingProgress?: string | null;
    hasNaarGoAccount?: boolean;

    constructor(data?: IUtente) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.contattoAgenziaID = _data["contattoAgenziaID"] !== undefined ? _data["contattoAgenziaID"] : null as any;
            this.contattoUtenteID = _data["contattoUtenteID"] !== undefined ? _data["contattoUtenteID"] : null as any;
            this.tipoUtente = _data["tipoUtente"] !== undefined ? _data["tipoUtente"] : null as any;
            this.registrationDate = _data["registrationDate"] !== undefined ? _data["registrationDate"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : null as any;
            this.passwordInChiaro = _data["passwordInChiaro"] !== undefined ? _data["passwordInChiaro"] : null as any;
            this.passwordCifrata = _data["passwordCifrata"] !== undefined ? _data["passwordCifrata"] : null as any;
            this.abilitato = _data["abilitato"] !== undefined ? _data["abilitato"] : null as any;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : null as any;
            this.operatoreID = _data["operatoreID"] !== undefined ? _data["operatoreID"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.abilitazioneCrs = _data["abilitazioneCrs"] !== undefined ? _data["abilitazioneCrs"] : null as any;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : null as any;
            this.teamID = _data["teamID"] !== undefined ? _data["teamID"] : null as any;
            this.npr = _data["npr"] !== undefined ? _data["npr"] : null as any;
            this.uiOptions = _data["uiOptions"] !== undefined ? _data["uiOptions"] : null as any;
            this.fuorisede = _data["fuorisede"] !== undefined ? _data["fuorisede"] : null as any;
            this.emailFuorisede = _data["emailFuorisede"] !== undefined ? _data["emailFuorisede"] : null as any;
            this.categoriaContattoID = _data["categoriaContattoID"] !== undefined ? _data["categoriaContattoID"] : null as any;
            this.utentePadreID = _data["utentePadreID"] !== undefined ? _data["utentePadreID"] : null as any;
            this.basecampRefreshToken = _data["basecampRefreshToken"] !== undefined ? _data["basecampRefreshToken"] : null as any;
            this.ultimoAccesso = _data["ultimoAccesso"] !== undefined ? _data["ultimoAccesso"] : null as any;
            this.ultimoAggiornamentoPassword = _data["ultimoAggiornamentoPassword"] !== undefined ? _data["ultimoAggiornamentoPassword"] : null as any;
            this.fastLoginEnabled = _data["fastLoginEnabled"] !== undefined ? _data["fastLoginEnabled"] : null as any;
            this.fastLogingEnabledDate = _data["fastLogingEnabledDate"] !== undefined ? _data["fastLogingEnabledDate"] : null as any;
            this.fastLoginTokenValidityDays = _data["fastLoginTokenValidityDays"] !== undefined ? _data["fastLoginTokenValidityDays"] : null as any;
            this.fastLoginToken = _data["fastLoginToken"] !== undefined ? _data["fastLoginToken"] : null as any;
            this.emailLoginEnabled = _data["emailLoginEnabled"] !== undefined ? _data["emailLoginEnabled"] : null as any;
            this.master = _data["master"] !== undefined ? _data["master"] : null as any;
            this.onboardingProgress = _data["onboardingProgress"] !== undefined ? _data["onboardingProgress"] : null as any;
            this.hasNaarGoAccount = _data["hasNaarGoAccount"] !== undefined ? _data["hasNaarGoAccount"] : null as any;
        }
    }

    static fromJS(data: any): Utente {
        data = typeof data === 'object' ? data : {};
        let result = new Utente();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["contattoAgenziaID"] = this.contattoAgenziaID !== undefined ? this.contattoAgenziaID : null as any;
        data["contattoUtenteID"] = this.contattoUtenteID !== undefined ? this.contattoUtenteID : null as any;
        data["tipoUtente"] = this.tipoUtente !== undefined ? this.tipoUtente : null as any;
        data["registrationDate"] = this.registrationDate !== undefined ? this.registrationDate : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["cognome"] = this.cognome !== undefined ? this.cognome : null as any;
        data["passwordInChiaro"] = this.passwordInChiaro !== undefined ? this.passwordInChiaro : null as any;
        data["passwordCifrata"] = this.passwordCifrata !== undefined ? this.passwordCifrata : null as any;
        data["abilitato"] = this.abilitato !== undefined ? this.abilitato : null as any;
        data["deleted"] = this.deleted !== undefined ? this.deleted : null as any;
        data["operatoreID"] = this.operatoreID !== undefined ? this.operatoreID : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["abilitazioneCrs"] = this.abilitazioneCrs !== undefined ? this.abilitazioneCrs : null as any;
        data["telefono"] = this.telefono !== undefined ? this.telefono : null as any;
        data["teamID"] = this.teamID !== undefined ? this.teamID : null as any;
        data["npr"] = this.npr !== undefined ? this.npr : null as any;
        data["uiOptions"] = this.uiOptions !== undefined ? this.uiOptions : null as any;
        data["fuorisede"] = this.fuorisede !== undefined ? this.fuorisede : null as any;
        data["emailFuorisede"] = this.emailFuorisede !== undefined ? this.emailFuorisede : null as any;
        data["categoriaContattoID"] = this.categoriaContattoID !== undefined ? this.categoriaContattoID : null as any;
        data["utentePadreID"] = this.utentePadreID !== undefined ? this.utentePadreID : null as any;
        data["basecampRefreshToken"] = this.basecampRefreshToken !== undefined ? this.basecampRefreshToken : null as any;
        data["ultimoAccesso"] = this.ultimoAccesso !== undefined ? this.ultimoAccesso : null as any;
        data["ultimoAggiornamentoPassword"] = this.ultimoAggiornamentoPassword !== undefined ? this.ultimoAggiornamentoPassword : null as any;
        data["fastLoginEnabled"] = this.fastLoginEnabled !== undefined ? this.fastLoginEnabled : null as any;
        data["fastLogingEnabledDate"] = this.fastLogingEnabledDate !== undefined ? this.fastLogingEnabledDate : null as any;
        data["fastLoginTokenValidityDays"] = this.fastLoginTokenValidityDays !== undefined ? this.fastLoginTokenValidityDays : null as any;
        data["fastLoginToken"] = this.fastLoginToken !== undefined ? this.fastLoginToken : null as any;
        data["emailLoginEnabled"] = this.emailLoginEnabled !== undefined ? this.emailLoginEnabled : null as any;
        data["master"] = this.master !== undefined ? this.master : null as any;
        data["onboardingProgress"] = this.onboardingProgress !== undefined ? this.onboardingProgress : null as any;
        data["hasNaarGoAccount"] = this.hasNaarGoAccount !== undefined ? this.hasNaarGoAccount : null as any;
        return data;
    }
}

export interface IUtente {
    id?: number;
    contattoAgenziaID?: number | null;
    contattoUtenteID?: number | null;
    tipoUtente?: ETipoUtente | null;
    registrationDate?: string;
    email?: string | null;
    nome?: string | null;
    cognome?: string | null;
    passwordInChiaro?: string | null;
    passwordCifrata?: string | null;
    abilitato?: boolean;
    deleted?: string | null;
    operatoreID?: number | null;
    operatore?: EOperatore | null;
    abilitazioneCrs?: number | null;
    telefono?: string | null;
    teamID?: string | null;
    npr?: boolean;
    uiOptions?: string | null;
    fuorisede?: boolean;
    emailFuorisede?: string | null;
    categoriaContattoID?: number | null;
    utentePadreID?: number | null;
    basecampRefreshToken?: string | null;
    ultimoAccesso?: string | null;
    ultimoAggiornamentoPassword?: string | null;
    fastLoginEnabled?: boolean | null;
    fastLogingEnabledDate?: string | null;
    fastLoginTokenValidityDays?: number | null;
    fastLoginToken?: string | null;
    emailLoginEnabled?: boolean | null;
    master?: EUserMaster | null;
    onboardingProgress?: string | null;
    hasNaarGoAccount?: boolean;
}

/** Richiesta di salvataggio delle opzioni utente */
export class SaveUserOptionsRequest extends ApiRequest implements ISaveUserOptionsRequest {
    /** Dati dell'utente */
    user?: Utente;
    /** Opzioni di frontend */
    uiOptions?: any;

    constructor(data?: ISaveUserOptionsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.user = _data["user"] ? Utente.fromJS(_data["user"]) : null as any;
            this.uiOptions = _data["uiOptions"] !== undefined ? _data["uiOptions"] : null as any;
        }
    }

    static override fromJS(data: any): SaveUserOptionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveUserOptionsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : null as any;
        data["uiOptions"] = this.uiOptions !== undefined ? this.uiOptions : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Richiesta di salvataggio delle opzioni utente */
export interface ISaveUserOptionsRequest extends IApiRequest {
    /** Dati dell'utente */
    user?: Utente;
    /** Opzioni di frontend */
    uiOptions?: any;
}

export class SendLoginViaEmailResponse extends OkApiResponse implements ISendLoginViaEmailResponse {

    constructor(data?: ISendLoginViaEmailResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SendLoginViaEmailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendLoginViaEmailResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISendLoginViaEmailResponse extends IOkApiResponse {
}

export class SendLoginViaEmailRequest extends LocalizedRequest implements ISendLoginViaEmailRequest {
    emailAddress?: string | null;

    constructor(data?: ISendLoginViaEmailRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
        }
    }

    static override fromJS(data: any): SendLoginViaEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendLoginViaEmailRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISendLoginViaEmailRequest extends ILocalizedRequest {
    emailAddress?: string | null;
}

export class AutocompleteValueResponse extends OkApiResponse implements IAutocompleteValueResponse {
    value?: AutocompleteValue | null;

    constructor(data?: IAutocompleteValueResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? AutocompleteValue.fromJS(_data["value"]) : null as any;
        }
    }

    static override fromJS(data: any): AutocompleteValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AutocompleteValueResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAutocompleteValueResponse extends IOkApiResponse {
    value?: AutocompleteValue | null;
}

export class AutocompleteValue implements IAutocompleteValue {
    id?: string | null;
    label?: string | null;
    value?: string | null;
    qualifier?: string | null;
    extraInt?: number | null;
    extraString?: string | null;
    extraString2?: string | null;
    extraDecimal?: number | null;
    extraBool?: boolean;
    inactive?: boolean;
    deleted?: boolean;

    constructor(data?: IAutocompleteValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.label = _data["label"] !== undefined ? _data["label"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
            this.qualifier = _data["qualifier"] !== undefined ? _data["qualifier"] : null as any;
            this.extraInt = _data["extraInt"] !== undefined ? _data["extraInt"] : null as any;
            this.extraString = _data["extraString"] !== undefined ? _data["extraString"] : null as any;
            this.extraString2 = _data["extraString2"] !== undefined ? _data["extraString2"] : null as any;
            this.extraDecimal = _data["extraDecimal"] !== undefined ? _data["extraDecimal"] : null as any;
            this.extraBool = _data["extraBool"] !== undefined ? _data["extraBool"] : null as any;
            this.inactive = _data["inactive"] !== undefined ? _data["inactive"] : null as any;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : null as any;
        }
    }

    static fromJS(data: any): AutocompleteValue {
        data = typeof data === 'object' ? data : {};
        let result = new AutocompleteValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["label"] = this.label !== undefined ? this.label : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["qualifier"] = this.qualifier !== undefined ? this.qualifier : null as any;
        data["extraInt"] = this.extraInt !== undefined ? this.extraInt : null as any;
        data["extraString"] = this.extraString !== undefined ? this.extraString : null as any;
        data["extraString2"] = this.extraString2 !== undefined ? this.extraString2 : null as any;
        data["extraDecimal"] = this.extraDecimal !== undefined ? this.extraDecimal : null as any;
        data["extraBool"] = this.extraBool !== undefined ? this.extraBool : null as any;
        data["inactive"] = this.inactive !== undefined ? this.inactive : null as any;
        data["deleted"] = this.deleted !== undefined ? this.deleted : null as any;
        return data;
    }
}

export interface IAutocompleteValue {
    id?: string | null;
    label?: string | null;
    value?: string | null;
    qualifier?: string | null;
    extraInt?: number | null;
    extraString?: string | null;
    extraString2?: string | null;
    extraDecimal?: number | null;
    extraBool?: boolean;
    inactive?: boolean;
    deleted?: boolean;
}

export class AutocompleteRequest extends SiteRequest implements IAutocompleteRequest {
    tableName?: string | null;
    term?: string | null;
    limit?: number | null;
    pageNr?: number | null;
    fieldName?: string | null;
    nameFormat?: string | null;
    foreingKeyValue?: string | null;
    id?: string | null;

    constructor(data?: IAutocompleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tableName = _data["tableName"] !== undefined ? _data["tableName"] : null as any;
            this.term = _data["term"] !== undefined ? _data["term"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.pageNr = _data["pageNr"] !== undefined ? _data["pageNr"] : null as any;
            this.fieldName = _data["fieldName"] !== undefined ? _data["fieldName"] : null as any;
            this.nameFormat = _data["nameFormat"] !== undefined ? _data["nameFormat"] : null as any;
            this.foreingKeyValue = _data["foreingKeyValue"] !== undefined ? _data["foreingKeyValue"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): AutocompleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AutocompleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName !== undefined ? this.tableName : null as any;
        data["term"] = this.term !== undefined ? this.term : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["pageNr"] = this.pageNr !== undefined ? this.pageNr : null as any;
        data["fieldName"] = this.fieldName !== undefined ? this.fieldName : null as any;
        data["nameFormat"] = this.nameFormat !== undefined ? this.nameFormat : null as any;
        data["foreingKeyValue"] = this.foreingKeyValue !== undefined ? this.foreingKeyValue : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAutocompleteRequest extends ISiteRequest {
    tableName?: string | null;
    term?: string | null;
    limit?: number | null;
    pageNr?: number | null;
    fieldName?: string | null;
    nameFormat?: string | null;
    foreingKeyValue?: string | null;
    id?: string | null;
}

export class AutocompleteSearchResponse extends OkApiResponse implements IAutocompleteSearchResponse {
    values?: AutocompleteValue[] | null;
    hasMore?: boolean;

    constructor(data?: IAutocompleteSearchResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(AutocompleteValue.fromJS(item));
            }
            else {
                this.values = null as any;
            }
            this.hasMore = _data["hasMore"] !== undefined ? _data["hasMore"] : null as any;
        }
    }

    static override fromJS(data: any): AutocompleteSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AutocompleteSearchResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item ? item.toJSON() : null as any);
        }
        data["hasMore"] = this.hasMore !== undefined ? this.hasMore : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAutocompleteSearchResponse extends IOkApiResponse {
    values?: AutocompleteValue[] | null;
    hasMore?: boolean;
}

export class GetB2cArticleResponse extends OkApiResponse implements IGetB2cArticleResponse {
    article?: B2cArticle | null;

    constructor(data?: IGetB2cArticleResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.article = _data["article"] ? B2cArticle.fromJS(_data["article"]) : null as any;
        }
    }

    static override fromJS(data: any): GetB2cArticleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetB2cArticleResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["article"] = this.article ? this.article.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetB2cArticleResponse extends IOkApiResponse {
    article?: B2cArticle | null;
}

export class B2cArticle implements IB2cArticle {
    articleId?: number;
    title?: string | null;
    text?: string | null;
    luogoId?: number;
    numberOfImages?: number;

    constructor(data?: IB2cArticle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
            this.luogoId = _data["luogoId"] !== undefined ? _data["luogoId"] : null as any;
            this.numberOfImages = _data["numberOfImages"] !== undefined ? _data["numberOfImages"] : null as any;
        }
    }

    static fromJS(data: any): B2cArticle {
        data = typeof data === 'object' ? data : {};
        let result = new B2cArticle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["text"] = this.text !== undefined ? this.text : null as any;
        data["luogoId"] = this.luogoId !== undefined ? this.luogoId : null as any;
        data["numberOfImages"] = this.numberOfImages !== undefined ? this.numberOfImages : null as any;
        return data;
    }
}

export interface IB2cArticle {
    articleId?: number;
    title?: string | null;
    text?: string | null;
    luogoId?: number;
    numberOfImages?: number;
}

export class GetB2cArticleRequest extends SiteRequest implements IGetB2cArticleRequest {
    articleID?: number;
    parseToken?: boolean;

    constructor(data?: IGetB2cArticleRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.articleID = _data["articleID"] !== undefined ? _data["articleID"] : null as any;
            this.parseToken = _data["parseToken"] !== undefined ? _data["parseToken"] : null as any;
        }
    }

    static override fromJS(data: any): GetB2cArticleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetB2cArticleRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleID"] = this.articleID !== undefined ? this.articleID : null as any;
        data["parseToken"] = this.parseToken !== undefined ? this.parseToken : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetB2cArticleRequest extends ISiteRequest {
    articleID?: number;
    parseToken?: boolean;
}

export class NrTableResponseOfAgenciesListRow extends OkApiResponse implements INrTableResponseOfAgenciesListRow {
    /** Array delle righe della pagina richiesta */
    rows?: AgenciesListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfAgenciesListRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AgenciesListRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfAgenciesListRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfAgenciesListRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfAgenciesListRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: AgenciesListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class AgenciesListRow implements IAgenciesListRow {
    contactID?: number;
    nome?: string | null;
    indirizzo?: string | null;
    cap?: string | null;
    telefono?: string | null;
    prov?: string | null;
    luogo?: string | null;

    constructor(data?: IAgenciesListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactID = _data["contactID"] !== undefined ? _data["contactID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : null as any;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : null as any;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : null as any;
            this.prov = _data["prov"] !== undefined ? _data["prov"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
        }
    }

    static fromJS(data: any): AgenciesListRow {
        data = typeof data === 'object' ? data : {};
        let result = new AgenciesListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactID"] = this.contactID !== undefined ? this.contactID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : null as any;
        data["cap"] = this.cap !== undefined ? this.cap : null as any;
        data["telefono"] = this.telefono !== undefined ? this.telefono : null as any;
        data["prov"] = this.prov !== undefined ? this.prov : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        return data;
    }
}

export interface IAgenciesListRow {
    contactID?: number;
    nome?: string | null;
    indirizzo?: string | null;
    cap?: string | null;
    telefono?: string | null;
    prov?: string | null;
    luogo?: string | null;
}

export class AgenciesListRequest extends NrTableRequest implements IAgenciesListRequest {
    cap?: number | null;
    prov?: string | null;
    citta?: string | null;
    position?: string | null;
    raggio?: number | null;

    constructor(data?: IAgenciesListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cap = _data["cap"] !== undefined ? _data["cap"] : null as any;
            this.prov = _data["prov"] !== undefined ? _data["prov"] : null as any;
            this.citta = _data["citta"] !== undefined ? _data["citta"] : null as any;
            this.position = _data["position"] !== undefined ? _data["position"] : null as any;
            this.raggio = _data["raggio"] !== undefined ? _data["raggio"] : null as any;
        }
    }

    static override fromJS(data: any): AgenciesListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AgenciesListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cap"] = this.cap !== undefined ? this.cap : null as any;
        data["prov"] = this.prov !== undefined ? this.prov : null as any;
        data["citta"] = this.citta !== undefined ? this.citta : null as any;
        data["position"] = this.position !== undefined ? this.position : null as any;
        data["raggio"] = this.raggio !== undefined ? this.raggio : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAgenciesListRequest extends INrTableRequest {
    cap?: number | null;
    prov?: string | null;
    citta?: string | null;
    position?: string | null;
    raggio?: number | null;
}

export class GetDestinationResponse extends OkApiResponse implements IGetDestinationResponse {
    destination?: DestinationInfo | null;

    constructor(data?: IGetDestinationResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.destination = _data["destination"] ? DestinationInfo.fromJS(_data["destination"]) : null as any;
        }
    }

    static override fromJS(data: any): GetDestinationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDestinationResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["destination"] = this.destination ? this.destination.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetDestinationResponse extends IOkApiResponse {
    destination?: DestinationInfo | null;
}

/** Intestazione di una destinazione;    nome, Abstract (Descrizione), Immagine di copertina */
export class Destination implements IDestination {
    lingua?: ELingua;
    luogoID?: number;
    coverImageUrl?: string | null;
    nome?: string | null;
    nomeAbbreviato?: string | null;
    abstract?: string | null;
    gaColor?: string | null;
    gaBgColor?: string | null;
    gaIcon?: string | null;
    ordine?: number;

    constructor(data?: IDestination) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.coverImageUrl = _data["coverImageUrl"] !== undefined ? _data["coverImageUrl"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nomeAbbreviato = _data["nomeAbbreviato"] !== undefined ? _data["nomeAbbreviato"] : null as any;
            this.abstract = _data["abstract"] !== undefined ? _data["abstract"] : null as any;
            this.gaColor = _data["gaColor"] !== undefined ? _data["gaColor"] : null as any;
            this.gaBgColor = _data["gaBgColor"] !== undefined ? _data["gaBgColor"] : null as any;
            this.gaIcon = _data["gaIcon"] !== undefined ? _data["gaIcon"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
        }
    }

    static fromJS(data: any): Destination {
        data = typeof data === 'object' ? data : {};
        let result = new Destination();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lingua"] = this.lingua !== undefined ? this.lingua : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["coverImageUrl"] = this.coverImageUrl !== undefined ? this.coverImageUrl : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nomeAbbreviato"] = this.nomeAbbreviato !== undefined ? this.nomeAbbreviato : null as any;
        data["abstract"] = this.abstract !== undefined ? this.abstract : null as any;
        data["gaColor"] = this.gaColor !== undefined ? this.gaColor : null as any;
        data["gaBgColor"] = this.gaBgColor !== undefined ? this.gaBgColor : null as any;
        data["gaIcon"] = this.gaIcon !== undefined ? this.gaIcon : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        return data;
    }
}

/** Intestazione di una destinazione;    nome, Abstract (Descrizione), Immagine di copertina */
export interface IDestination {
    lingua?: ELingua;
    luogoID?: number;
    coverImageUrl?: string | null;
    nome?: string | null;
    nomeAbbreviato?: string | null;
    abstract?: string | null;
    gaColor?: string | null;
    gaBgColor?: string | null;
    gaIcon?: string | null;
    ordine?: number;
}

/** Versione completa di una Destinazione    tutti i viaggi ad essa legati */
export class DestinationInfo extends Destination implements IDestinationInfo {
    elencoViaggi?: TripHead[] | null;
    elencoImmagini?: ImageSeed[] | null;

    constructor(data?: IDestinationInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["elencoViaggi"])) {
                this.elencoViaggi = [] as any;
                for (let item of _data["elencoViaggi"])
                    this.elencoViaggi!.push(TripHead.fromJS(item));
            }
            else {
                this.elencoViaggi = null as any;
            }
            if (Array.isArray(_data["elencoImmagini"])) {
                this.elencoImmagini = [] as any;
                for (let item of _data["elencoImmagini"])
                    this.elencoImmagini!.push(ImageSeed.fromJS(item));
            }
            else {
                this.elencoImmagini = null as any;
            }
        }
    }

    static override fromJS(data: any): DestinationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DestinationInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elencoViaggi)) {
            data["elencoViaggi"] = [];
            for (let item of this.elencoViaggi)
                data["elencoViaggi"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.elencoImmagini)) {
            data["elencoImmagini"] = [];
            for (let item of this.elencoImmagini)
                data["elencoImmagini"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Versione completa di una Destinazione    tutti i viaggi ad essa legati */
export interface IDestinationInfo extends IDestination {
    elencoViaggi?: TripHead[] | null;
    elencoImmagini?: ImageSeed[] | null;
}

/** È l'intestazione di un viaggio;    Nome, Luogo, Descrizione sommaria (Abstract), immagine di copertina */
export class TripHead implements ITripHead {
    tripID?: number;
    nome?: string | null;
    luogo?: string | null;
    descr?: string | null;
    cover?: string | null;
    lingua?: ELingua;
    durata?: ServiceDuration | null;
    ideas?: number[] | null;
    destinations?: number[] | null;
    map?: TripMap | null;

    constructor(data?: ITripHead) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.descr = _data["descr"] !== undefined ? _data["descr"] : null as any;
            this.cover = _data["cover"] !== undefined ? _data["cover"] : null as any;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : null as any;
            this.durata = _data["durata"] ? ServiceDuration.fromJS(_data["durata"]) : null as any;
            if (Array.isArray(_data["ideas"])) {
                this.ideas = [] as any;
                for (let item of _data["ideas"])
                    this.ideas!.push(item);
            }
            else {
                this.ideas = null as any;
            }
            if (Array.isArray(_data["destinations"])) {
                this.destinations = [] as any;
                for (let item of _data["destinations"])
                    this.destinations!.push(item);
            }
            else {
                this.destinations = null as any;
            }
            this.map = _data["map"] ? TripMap.fromJS(_data["map"]) : null as any;
        }
    }

    static fromJS(data: any): TripHead {
        data = typeof data === 'object' ? data : {};
        let result = new TripHead();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripID"] = this.tripID !== undefined ? this.tripID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["descr"] = this.descr !== undefined ? this.descr : null as any;
        data["cover"] = this.cover !== undefined ? this.cover : null as any;
        data["lingua"] = this.lingua !== undefined ? this.lingua : null as any;
        data["durata"] = this.durata ? this.durata.toJSON() : null as any;
        if (Array.isArray(this.ideas)) {
            data["ideas"] = [];
            for (let item of this.ideas)
                data["ideas"].push(item);
        }
        if (Array.isArray(this.destinations)) {
            data["destinations"] = [];
            for (let item of this.destinations)
                data["destinations"].push(item);
        }
        data["map"] = this.map ? this.map.toJSON() : null as any;
        return data;
    }
}

/** È l'intestazione di un viaggio;    Nome, Luogo, Descrizione sommaria (Abstract), immagine di copertina */
export interface ITripHead {
    tripID?: number;
    nome?: string | null;
    luogo?: string | null;
    descr?: string | null;
    cover?: string | null;
    lingua?: ELingua;
    durata?: ServiceDuration | null;
    ideas?: number[] | null;
    destinations?: number[] | null;
    map?: TripMap | null;
}

export class ServiceDuration implements IServiceDuration {
    giorni?: number;
    notti?: number;

    constructor(data?: IServiceDuration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.giorni = _data["giorni"] !== undefined ? _data["giorni"] : null as any;
            this.notti = _data["notti"] !== undefined ? _data["notti"] : null as any;
        }
    }

    static fromJS(data: any): ServiceDuration {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDuration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giorni"] = this.giorni !== undefined ? this.giorni : null as any;
        data["notti"] = this.notti !== undefined ? this.notti : null as any;
        return data;
    }
}

export interface IServiceDuration {
    giorni?: number;
    notti?: number;
}

export class TripMap implements ITripMap {
    lat?: number;
    long?: number;
    zoom?: number;

    constructor(data?: ITripMap) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lat = _data["lat"] !== undefined ? _data["lat"] : null as any;
            this.long = _data["long"] !== undefined ? _data["long"] : null as any;
            this.zoom = _data["zoom"] !== undefined ? _data["zoom"] : null as any;
        }
    }

    static fromJS(data: any): TripMap {
        data = typeof data === 'object' ? data : {};
        let result = new TripMap();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lat"] = this.lat !== undefined ? this.lat : null as any;
        data["long"] = this.long !== undefined ? this.long : null as any;
        data["zoom"] = this.zoom !== undefined ? this.zoom : null as any;
        return data;
    }
}

export interface ITripMap {
    lat?: number;
    long?: number;
    zoom?: number;
}

export class ImageSeed implements IImageSeed {
    id?: number;
    url?: string;
    caption?: string;

    constructor(data?: IImageSeed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
            this.caption = _data["caption"] !== undefined ? _data["caption"] : null as any;
        }
    }

    static fromJS(data: any): ImageSeed {
        data = typeof data === 'object' ? data : {};
        let result = new ImageSeed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        data["caption"] = this.caption !== undefined ? this.caption : null as any;
        return data;
    }
}

export interface IImageSeed {
    id?: number;
    url?: string;
    caption?: string;
}

export class GetDestinationRequest extends SiteRequest implements IGetDestinationRequest {
    destinationID?: number;

    constructor(data?: IGetDestinationRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.destinationID = _data["destinationID"] !== undefined ? _data["destinationID"] : null as any;
        }
    }

    static override fromJS(data: any): GetDestinationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDestinationRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["destinationID"] = this.destinationID !== undefined ? this.destinationID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetDestinationRequest extends ISiteRequest {
    destinationID?: number;
}

export class GetDestinationsResponse extends OkApiResponse implements IGetDestinationsResponse {
    destinazioni?: Destination[] | null;

    constructor(data?: IGetDestinationsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["destinazioni"])) {
                this.destinazioni = [] as any;
                for (let item of _data["destinazioni"])
                    this.destinazioni!.push(Destination.fromJS(item));
            }
            else {
                this.destinazioni = null as any;
            }
        }
    }

    static override fromJS(data: any): GetDestinationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDestinationsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.destinazioni)) {
            data["destinazioni"] = [];
            for (let item of this.destinazioni)
                data["destinazioni"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetDestinationsResponse extends IOkApiResponse {
    destinazioni?: Destination[] | null;
}

export class GetOpenDestinationsResponse extends OkApiResponse implements IGetOpenDestinationsResponse {
    destinazioni?: OpenDestination[] | null;

    constructor(data?: IGetOpenDestinationsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["destinazioni"])) {
                this.destinazioni = [] as any;
                for (let item of _data["destinazioni"])
                    this.destinazioni!.push(OpenDestination.fromJS(item));
            }
            else {
                this.destinazioni = null as any;
            }
        }
    }

    static override fromJS(data: any): GetOpenDestinationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOpenDestinationsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.destinazioni)) {
            data["destinazioni"] = [];
            for (let item of this.destinazioni)
                data["destinazioni"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetOpenDestinationsResponse extends IOkApiResponse {
    destinazioni?: OpenDestination[] | null;
}

export class OpenDestination implements IOpenDestination {
    articles?: OpenDestinationArticle[] | null;
    destinazione?: Destination | null;
    order?: number;

    constructor(data?: IOpenDestination) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["articles"])) {
                this.articles = [] as any;
                for (let item of _data["articles"])
                    this.articles!.push(OpenDestinationArticle.fromJS(item));
            }
            else {
                this.articles = null as any;
            }
            this.destinazione = _data["destinazione"] ? Destination.fromJS(_data["destinazione"]) : null as any;
            this.order = _data["order"] !== undefined ? _data["order"] : null as any;
        }
    }

    static fromJS(data: any): OpenDestination {
        data = typeof data === 'object' ? data : {};
        let result = new OpenDestination();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.articles)) {
            data["articles"] = [];
            for (let item of this.articles)
                data["articles"].push(item ? item.toJSON() : null as any);
        }
        data["destinazione"] = this.destinazione ? this.destinazione.toJSON() : null as any;
        data["order"] = this.order !== undefined ? this.order : null as any;
        return data;
    }
}

export interface IOpenDestination {
    articles?: OpenDestinationArticle[] | null;
    destinazione?: Destination | null;
    order?: number;
}

export class OpenDestinationArticle implements IOpenDestinationArticle {
    id?: number;
    title?: string | null;
    text?: string | null;
    updateAt?: string | null;
    order?: number;
    allegati?: ArticoloAllegato[] | null;

    constructor(data?: IOpenDestinationArticle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
            this.updateAt = _data["updateAt"] !== undefined ? _data["updateAt"] : null as any;
            this.order = _data["order"] !== undefined ? _data["order"] : null as any;
            if (Array.isArray(_data["allegati"])) {
                this.allegati = [] as any;
                for (let item of _data["allegati"])
                    this.allegati!.push(ArticoloAllegato.fromJS(item));
            }
            else {
                this.allegati = null as any;
            }
        }
    }

    static fromJS(data: any): OpenDestinationArticle {
        data = typeof data === 'object' ? data : {};
        let result = new OpenDestinationArticle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["text"] = this.text !== undefined ? this.text : null as any;
        data["updateAt"] = this.updateAt !== undefined ? this.updateAt : null as any;
        data["order"] = this.order !== undefined ? this.order : null as any;
        if (Array.isArray(this.allegati)) {
            data["allegati"] = [];
            for (let item of this.allegati)
                data["allegati"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IOpenDestinationArticle {
    id?: number;
    title?: string | null;
    text?: string | null;
    updateAt?: string | null;
    order?: number;
    allegati?: ArticoloAllegato[] | null;
}

export class GetIdeasResponse extends OkApiResponse implements IGetIdeasResponse {
    idee?: Idea[] | null;

    constructor(data?: IGetIdeasResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["idee"])) {
                this.idee = [] as any;
                for (let item of _data["idee"])
                    this.idee!.push(Idea.fromJS(item));
            }
            else {
                this.idee = null as any;
            }
        }
    }

    static override fromJS(data: any): GetIdeasResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetIdeasResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.idee)) {
            data["idee"] = [];
            for (let item of this.idee)
                data["idee"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetIdeasResponse extends IOkApiResponse {
    idee?: Idea[] | null;
}

/** Descrittore dell'Idea di viaggio */
export class Idea implements IIdea {
    ideaID?: number;
    nome?: string | null;
    gliphIdx?: number | null;
    gliphName?: string | null;
    gliphColor?: string | null;
    variabili?: number | null;
    luogoID?: number | null;
    coverImageUrl?: string | null;
    abstract?: string | null;
    ordine?: number;

    constructor(data?: IIdea) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ideaID = _data["ideaID"] !== undefined ? _data["ideaID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.gliphIdx = _data["gliphIdx"] !== undefined ? _data["gliphIdx"] : null as any;
            this.gliphName = _data["gliphName"] !== undefined ? _data["gliphName"] : null as any;
            this.gliphColor = _data["gliphColor"] !== undefined ? _data["gliphColor"] : null as any;
            this.variabili = _data["variabili"] !== undefined ? _data["variabili"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.coverImageUrl = _data["coverImageUrl"] !== undefined ? _data["coverImageUrl"] : null as any;
            this.abstract = _data["abstract"] !== undefined ? _data["abstract"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
        }
    }

    static fromJS(data: any): Idea {
        data = typeof data === 'object' ? data : {};
        let result = new Idea();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ideaID"] = this.ideaID !== undefined ? this.ideaID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["gliphIdx"] = this.gliphIdx !== undefined ? this.gliphIdx : null as any;
        data["gliphName"] = this.gliphName !== undefined ? this.gliphName : null as any;
        data["gliphColor"] = this.gliphColor !== undefined ? this.gliphColor : null as any;
        data["variabili"] = this.variabili !== undefined ? this.variabili : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["coverImageUrl"] = this.coverImageUrl !== undefined ? this.coverImageUrl : null as any;
        data["abstract"] = this.abstract !== undefined ? this.abstract : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        return data;
    }
}

/** Descrittore dell'Idea di viaggio */
export interface IIdea {
    ideaID?: number;
    nome?: string | null;
    gliphIdx?: number | null;
    gliphName?: string | null;
    gliphColor?: string | null;
    variabili?: number | null;
    luogoID?: number | null;
    coverImageUrl?: string | null;
    abstract?: string | null;
    ordine?: number;
}

export class GetIdeaResponse extends OkApiResponse implements IGetIdeaResponse {
    idea?: IdeaInfo | null;

    constructor(data?: IGetIdeaResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idea = _data["idea"] ? IdeaInfo.fromJS(_data["idea"]) : null as any;
        }
    }

    static override fromJS(data: any): GetIdeaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetIdeaResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idea"] = this.idea ? this.idea.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetIdeaResponse extends IOkApiResponse {
    idea?: IdeaInfo | null;
}

/** Estendo la classe integrando la lista dei viaggi e la lista dei testi */
export class IdeaInfo extends Idea implements IIdeaInfo {
    elencoViaggi?: TripHead[] | null;
    elencoTesti?: string[] | null;

    constructor(data?: IIdeaInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["elencoViaggi"])) {
                this.elencoViaggi = [] as any;
                for (let item of _data["elencoViaggi"])
                    this.elencoViaggi!.push(TripHead.fromJS(item));
            }
            else {
                this.elencoViaggi = null as any;
            }
            if (Array.isArray(_data["elencoTesti"])) {
                this.elencoTesti = [] as any;
                for (let item of _data["elencoTesti"])
                    this.elencoTesti!.push(item);
            }
            else {
                this.elencoTesti = null as any;
            }
        }
    }

    static override fromJS(data: any): IdeaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new IdeaInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elencoViaggi)) {
            data["elencoViaggi"] = [];
            for (let item of this.elencoViaggi)
                data["elencoViaggi"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.elencoTesti)) {
            data["elencoTesti"] = [];
            for (let item of this.elencoTesti)
                data["elencoTesti"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

/** Estendo la classe integrando la lista dei viaggi e la lista dei testi */
export interface IIdeaInfo extends IIdea {
    elencoViaggi?: TripHead[] | null;
    elencoTesti?: string[] | null;
}

export class GetIdeaRequest extends SiteRequest implements IGetIdeaRequest {
    ideaID?: number;

    constructor(data?: IGetIdeaRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ideaID = _data["ideaID"] !== undefined ? _data["ideaID"] : null as any;
        }
    }

    static override fromJS(data: any): GetIdeaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetIdeaRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ideaID"] = this.ideaID !== undefined ? this.ideaID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetIdeaRequest extends ISiteRequest {
    ideaID?: number;
}

export class GetMenuDataResponse extends OkApiResponse implements IGetMenuDataResponse {
    menuData?: MenuData[] | null;

    constructor(data?: IGetMenuDataResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["menuData"])) {
                this.menuData = [] as any;
                for (let item of _data["menuData"])
                    this.menuData!.push(MenuData.fromJS(item));
            }
            else {
                this.menuData = null as any;
            }
        }
    }

    static override fromJS(data: any): GetMenuDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMenuDataResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.menuData)) {
            data["menuData"] = [];
            for (let item of this.menuData)
                data["menuData"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetMenuDataResponse extends IOkApiResponse {
    menuData?: MenuData[] | null;
}

export class MenuData implements IMenuData {
    nome?: string | null;
    idPagelink?: number;
    url?: string | null;
    icon?: string | null;
    idLuogo?: number;

    constructor(data?: IMenuData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.idPagelink = _data["idPagelink"] !== undefined ? _data["idPagelink"] : null as any;
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
            this.icon = _data["icon"] !== undefined ? _data["icon"] : null as any;
            this.idLuogo = _data["idLuogo"] !== undefined ? _data["idLuogo"] : null as any;
        }
    }

    static fromJS(data: any): MenuData {
        data = typeof data === 'object' ? data : {};
        let result = new MenuData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["idPagelink"] = this.idPagelink !== undefined ? this.idPagelink : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        data["icon"] = this.icon !== undefined ? this.icon : null as any;
        data["idLuogo"] = this.idLuogo !== undefined ? this.idLuogo : null as any;
        return data;
    }
}

export interface IMenuData {
    nome?: string | null;
    idPagelink?: number;
    url?: string | null;
    icon?: string | null;
    idLuogo?: number;
}

export class GetPageDataResponse extends OkApiResponse implements IGetPageDataResponse {
    pageData?: PageData | null;

    constructor(data?: IGetPageDataResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pageData = _data["pageData"] ? PageData.fromJS(_data["pageData"]) : null as any;
        }
    }

    static override fromJS(data: any): GetPageDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageDataResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageData"] = this.pageData ? this.pageData.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPageDataResponse extends IOkApiResponse {
    pageData?: PageData | null;
}

/** Acquisizione dei testi relativi ad una pagina */
export class PageData implements IPageData {
    id?: number;
    nome?: string | null;
    tipo?: ETipoLink;
    elencoDati?: PageDataGeneric[] | null;

    constructor(data?: IPageData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            if (Array.isArray(_data["elencoDati"])) {
                this.elencoDati = [] as any;
                for (let item of _data["elencoDati"])
                    this.elencoDati!.push(PageDataGeneric.fromJS(item));
            }
            else {
                this.elencoDati = null as any;
            }
        }
    }

    static fromJS(data: any): PageData {
        data = typeof data === 'object' ? data : {};
        let result = new PageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        if (Array.isArray(this.elencoDati)) {
            data["elencoDati"] = [];
            for (let item of this.elencoDati)
                data["elencoDati"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** Acquisizione dei testi relativi ad una pagina */
export interface IPageData {
    id?: number;
    nome?: string | null;
    tipo?: ETipoLink;
    elencoDati?: PageDataGeneric[] | null;
}

export enum ETipoLink {
    Url = "Url",
    RouterLink = "RouterLink",
    Contenitore = "Contenitore",
}

export class PageDataGeneric implements IPageDataGeneric {
    id?: number;
    entityId?: number;
    entityType?: ETipoEntita;
    name?: string | null;
    content?: string | null;
    group?: number;
    order?: number;
    style?: number;

    constructor(data?: IPageDataGeneric) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.entityId = _data["entityId"] !== undefined ? _data["entityId"] : null as any;
            this.entityType = _data["entityType"] !== undefined ? _data["entityType"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.content = _data["content"] !== undefined ? _data["content"] : null as any;
            this.group = _data["group"] !== undefined ? _data["group"] : null as any;
            this.order = _data["order"] !== undefined ? _data["order"] : null as any;
            this.style = _data["style"] !== undefined ? _data["style"] : null as any;
        }
    }

    static fromJS(data: any): PageDataGeneric {
        data = typeof data === 'object' ? data : {};
        let result = new PageDataGeneric();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["entityId"] = this.entityId !== undefined ? this.entityId : null as any;
        data["entityType"] = this.entityType !== undefined ? this.entityType : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["content"] = this.content !== undefined ? this.content : null as any;
        data["group"] = this.group !== undefined ? this.group : null as any;
        data["order"] = this.order !== undefined ? this.order : null as any;
        data["style"] = this.style !== undefined ? this.style : null as any;
        return data;
    }
}

export interface IPageDataGeneric {
    id?: number;
    entityId?: number;
    entityType?: ETipoEntita;
    name?: string | null;
    content?: string | null;
    group?: number;
    order?: number;
    style?: number;
}

export enum ETipoEntita {
    Articolo = "Articolo",
}

export class GetPageDataRequest extends SiteRequest implements IGetPageDataRequest {
    pageDataID?: number;

    constructor(data?: IGetPageDataRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pageDataID = _data["pageDataID"] !== undefined ? _data["pageDataID"] : null as any;
        }
    }

    static override fromJS(data: any): GetPageDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageDataRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageDataID"] = this.pageDataID !== undefined ? this.pageDataID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPageDataRequest extends ISiteRequest {
    pageDataID?: number;
}

export class GetPageFooterResponse extends OkApiResponse implements IGetPageFooterResponse {
    footerData?: PageData | null;
    contactInfo?: PageContact | null;

    constructor(data?: IGetPageFooterResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.footerData = _data["footerData"] ? PageData.fromJS(_data["footerData"]) : null as any;
            this.contactInfo = _data["contactInfo"] ? PageContact.fromJS(_data["contactInfo"]) : null as any;
        }
    }

    static override fromJS(data: any): GetPageFooterResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageFooterResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["footerData"] = this.footerData ? this.footerData.toJSON() : null as any;
        data["contactInfo"] = this.contactInfo ? this.contactInfo.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPageFooterResponse extends IOkApiResponse {
    footerData?: PageData | null;
    contactInfo?: PageContact | null;
}

export class Contatto implements IContatto {
    contattoID?: number;
    contattoTipo?: ETipoContatto;
    luogoID?: number | null;
    nome?: string | null;
    cognome?: string | null;
    indirizzo?: string | null;
    civico?: string | null;
    cap?: string | null;
    telefono?: string | null;
    fax?: string | null;
    email?: string | null;
    note?: string | null;
    noFee?: boolean;
    categoriaContattoID?: number | null;
    titolo?: ETitolo;
    mansioneID?: number | null;
    abilitatoBookingVoli?: boolean;
    markupAdv?: number | null;
    indirizzoFatturazione?: string | null;
    luogoFatturazioneID?: number | null;
    capFatturazione?: string | null;
    civicoFatturazione?: string | null;
    eliminato?: boolean;
    lingua?: number | null;
    fatturazioneAlNetto?: boolean;

    constructor(data?: IContatto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.contattoTipo = _data["contattoTipo"] !== undefined ? _data["contattoTipo"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : null as any;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : null as any;
            this.civico = _data["civico"] !== undefined ? _data["civico"] : null as any;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : null as any;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : null as any;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.noFee = _data["noFee"] !== undefined ? _data["noFee"] : null as any;
            this.categoriaContattoID = _data["categoriaContattoID"] !== undefined ? _data["categoriaContattoID"] : null as any;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            this.mansioneID = _data["mansioneID"] !== undefined ? _data["mansioneID"] : null as any;
            this.abilitatoBookingVoli = _data["abilitatoBookingVoli"] !== undefined ? _data["abilitatoBookingVoli"] : null as any;
            this.markupAdv = _data["markupAdv"] !== undefined ? _data["markupAdv"] : null as any;
            this.indirizzoFatturazione = _data["indirizzoFatturazione"] !== undefined ? _data["indirizzoFatturazione"] : null as any;
            this.luogoFatturazioneID = _data["luogoFatturazioneID"] !== undefined ? _data["luogoFatturazioneID"] : null as any;
            this.capFatturazione = _data["capFatturazione"] !== undefined ? _data["capFatturazione"] : null as any;
            this.civicoFatturazione = _data["civicoFatturazione"] !== undefined ? _data["civicoFatturazione"] : null as any;
            this.eliminato = _data["eliminato"] !== undefined ? _data["eliminato"] : null as any;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : null as any;
            this.fatturazioneAlNetto = _data["fatturazioneAlNetto"] !== undefined ? _data["fatturazioneAlNetto"] : null as any;
        }
    }

    static fromJS(data: any): Contatto {
        data = typeof data === 'object' ? data : {};
        let result = new Contatto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["contattoTipo"] = this.contattoTipo !== undefined ? this.contattoTipo : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["cognome"] = this.cognome !== undefined ? this.cognome : null as any;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : null as any;
        data["civico"] = this.civico !== undefined ? this.civico : null as any;
        data["cap"] = this.cap !== undefined ? this.cap : null as any;
        data["telefono"] = this.telefono !== undefined ? this.telefono : null as any;
        data["fax"] = this.fax !== undefined ? this.fax : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["noFee"] = this.noFee !== undefined ? this.noFee : null as any;
        data["categoriaContattoID"] = this.categoriaContattoID !== undefined ? this.categoriaContattoID : null as any;
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        data["mansioneID"] = this.mansioneID !== undefined ? this.mansioneID : null as any;
        data["abilitatoBookingVoli"] = this.abilitatoBookingVoli !== undefined ? this.abilitatoBookingVoli : null as any;
        data["markupAdv"] = this.markupAdv !== undefined ? this.markupAdv : null as any;
        data["indirizzoFatturazione"] = this.indirizzoFatturazione !== undefined ? this.indirizzoFatturazione : null as any;
        data["luogoFatturazioneID"] = this.luogoFatturazioneID !== undefined ? this.luogoFatturazioneID : null as any;
        data["capFatturazione"] = this.capFatturazione !== undefined ? this.capFatturazione : null as any;
        data["civicoFatturazione"] = this.civicoFatturazione !== undefined ? this.civicoFatturazione : null as any;
        data["eliminato"] = this.eliminato !== undefined ? this.eliminato : null as any;
        data["lingua"] = this.lingua !== undefined ? this.lingua : null as any;
        data["fatturazioneAlNetto"] = this.fatturazioneAlNetto !== undefined ? this.fatturazioneAlNetto : null as any;
        return data;
    }
}

export interface IContatto {
    contattoID?: number;
    contattoTipo?: ETipoContatto;
    luogoID?: number | null;
    nome?: string | null;
    cognome?: string | null;
    indirizzo?: string | null;
    civico?: string | null;
    cap?: string | null;
    telefono?: string | null;
    fax?: string | null;
    email?: string | null;
    note?: string | null;
    noFee?: boolean;
    categoriaContattoID?: number | null;
    titolo?: ETitolo;
    mansioneID?: number | null;
    abilitatoBookingVoli?: boolean;
    markupAdv?: number | null;
    indirizzoFatturazione?: string | null;
    luogoFatturazioneID?: number | null;
    capFatturazione?: string | null;
    civicoFatturazione?: string | null;
    eliminato?: boolean;
    lingua?: number | null;
    fatturazioneAlNetto?: boolean;
}

export class PageContact extends Contatto implements IPageContact {
    citta?: string | null;
    paese?: string | null;

    constructor(data?: IPageContact) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.citta = _data["citta"] !== undefined ? _data["citta"] : null as any;
            this.paese = _data["paese"] !== undefined ? _data["paese"] : null as any;
        }
    }

    static override fromJS(data: any): PageContact {
        data = typeof data === 'object' ? data : {};
        let result = new PageContact();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["citta"] = this.citta !== undefined ? this.citta : null as any;
        data["paese"] = this.paese !== undefined ? this.paese : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPageContact extends IContatto {
    citta?: string | null;
    paese?: string | null;
}

export enum ETipoContatto {
    Fornitore = "Fornitore",
    Addetto = "Addetto",
    Agenzia = "Agenzia",
    UfficioFornitore = "UfficioFornitore",
    Produttore = "Produttore",
    TourOperator = "TourOperator",
    GruppiAgenzie = "GruppiAgenzie",
    ContrattiAgenti = "ContrattiAgenti",
    Hotel = "Hotel",
    Corrieri = "Corrieri",
    CompagnieAeree = "CompagnieAeree",
    FornitoreIndiretto = "FornitoreIndiretto",
    Giornali = "Giornali",
    ClienteDiretto = "ClienteDiretto",
    Appartamenti = "Appartamenti",
    AgenzieChiuse = "AgenzieChiuse",
    SottogruppiAgenzie = "SottogruppiAgenzie",
    FornitoreContabilita = "FornitoreContabilita",
    PuntoPickup = "PuntoPickup",
    ClienteContabilita = "ClienteContabilita",
}

export enum ETitolo {
    Signor = "Signor",
    Signora = "Signora",
    Bambina = "Bambina",
    Bambino = "Bambino",
    Dottor = "Dottor",
    Dottssa = "Dottssa",
    Sconosciuto = "Sconosciuto",
    Srl = "Srl",
    SpA = "SpA",
    Sas = "Sas",
    Snc = "Snc",
}

export class GetPageFooterRequest extends SiteRequest implements IGetPageFooterRequest {
    pageDataID?: number;

    constructor(data?: IGetPageFooterRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pageDataID = _data["pageDataID"] !== undefined ? _data["pageDataID"] : null as any;
        }
    }

    static override fromJS(data: any): GetPageFooterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageFooterRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageDataID"] = this.pageDataID !== undefined ? this.pageDataID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPageFooterRequest extends ISiteRequest {
    pageDataID?: number;
}

export class GetPagesResponse extends OkApiResponse implements IGetPagesResponse {
    pages?: PageLinkDetails[];
    footer?: PageLinkDetails | null;
    secondMenu?: PageLinkDetails[] | null;

    constructor(data?: IGetPagesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(PageLinkDetails.fromJS(item));
            }
            else {
                this.pages = null as any;
            }
            this.footer = _data["footer"] ? PageLinkDetails.fromJS(_data["footer"]) : null as any;
            if (Array.isArray(_data["secondMenu"])) {
                this.secondMenu = [] as any;
                for (let item of _data["secondMenu"])
                    this.secondMenu!.push(PageLinkDetails.fromJS(item));
            }
            else {
                this.secondMenu = null as any;
            }
        }
    }

    static override fromJS(data: any): GetPagesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPagesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item ? item.toJSON() : null as any);
        }
        data["footer"] = this.footer ? this.footer.toJSON() : null as any;
        if (Array.isArray(this.secondMenu)) {
            data["secondMenu"] = [];
            for (let item of this.secondMenu)
                data["secondMenu"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPagesResponse extends IOkApiResponse {
    pages?: PageLinkDetails[];
    footer?: PageLinkDetails | null;
    secondMenu?: PageLinkDetails[] | null;
}

export class PageLink implements IPageLink {
    id?: number;
    luogoID?: number | null;
    servizioID?: number | null;
    ordine?: number;
    operatore?: EOperatore | null;
    tipo?: ETipoLink;
    posizione?: EPosizioneLink;
    memo?: string | null;
    pubblicaDal?: string | null;
    pubblicaAl?: string | null;
    url?: string | null;
    nome!: string;
    nome_fr?: string | null;
    nome_en?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_be?: string | null;
    faIcon?: string | null;
    deleted?: string | null;

    constructor(data?: IPageLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.posizione = _data["posizione"] !== undefined ? _data["posizione"] : null as any;
            this.memo = _data["memo"] !== undefined ? _data["memo"] : null as any;
            this.pubblicaDal = _data["pubblicaDal"] !== undefined ? _data["pubblicaDal"] : null as any;
            this.pubblicaAl = _data["pubblicaAl"] !== undefined ? _data["pubblicaAl"] : null as any;
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nome_fr = _data["nome_fr"] !== undefined ? _data["nome_fr"] : null as any;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : null as any;
            this.nome_de = _data["nome_de"] !== undefined ? _data["nome_de"] : null as any;
            this.nome_es = _data["nome_es"] !== undefined ? _data["nome_es"] : null as any;
            this.nome_be = _data["nome_be"] !== undefined ? _data["nome_be"] : null as any;
            this.faIcon = _data["faIcon"] !== undefined ? _data["faIcon"] : null as any;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : null as any;
        }
    }

    static fromJS(data: any): PageLink {
        data = typeof data === 'object' ? data : {};
        let result = new PageLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["posizione"] = this.posizione !== undefined ? this.posizione : null as any;
        data["memo"] = this.memo !== undefined ? this.memo : null as any;
        data["pubblicaDal"] = this.pubblicaDal !== undefined ? this.pubblicaDal : null as any;
        data["pubblicaAl"] = this.pubblicaAl !== undefined ? this.pubblicaAl : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nome_fr"] = this.nome_fr !== undefined ? this.nome_fr : null as any;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : null as any;
        data["nome_de"] = this.nome_de !== undefined ? this.nome_de : null as any;
        data["nome_es"] = this.nome_es !== undefined ? this.nome_es : null as any;
        data["nome_be"] = this.nome_be !== undefined ? this.nome_be : null as any;
        data["faIcon"] = this.faIcon !== undefined ? this.faIcon : null as any;
        data["deleted"] = this.deleted !== undefined ? this.deleted : null as any;
        return data;
    }
}

export interface IPageLink {
    id?: number;
    luogoID?: number | null;
    servizioID?: number | null;
    ordine?: number;
    operatore?: EOperatore | null;
    tipo?: ETipoLink;
    posizione?: EPosizioneLink;
    memo?: string | null;
    pubblicaDal?: string | null;
    pubblicaAl?: string | null;
    url?: string | null;
    nome: string;
    nome_fr?: string | null;
    nome_en?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_be?: string | null;
    faIcon?: string | null;
    deleted?: string | null;
}

export class PageLinkDetails extends PageLink implements IPageLinkDetails {
    contents?: PageLinkContent[] | null;

    constructor(data?: IPageLinkDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["contents"])) {
                this.contents = [] as any;
                for (let item of _data["contents"])
                    this.contents!.push(PageLinkContent.fromJS(item));
            }
            else {
                this.contents = null as any;
            }
        }
    }

    static override fromJS(data: any): PageLinkDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PageLinkDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contents)) {
            data["contents"] = [];
            for (let item of this.contents)
                data["contents"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPageLinkDetails extends IPageLink {
    contents?: PageLinkContent[] | null;
}

export class PageLinkContent implements IPageLinkContent {
    id?: number;
    pageLinkID?: number;
    entityType?: ETipoEntita;
    entityID?: number;
    sortOrder?: number;
    faIcon?: string | null;
    deleted?: string | null;

    constructor(data?: IPageLinkContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.pageLinkID = _data["pageLinkID"] !== undefined ? _data["pageLinkID"] : null as any;
            this.entityType = _data["entityType"] !== undefined ? _data["entityType"] : null as any;
            this.entityID = _data["entityID"] !== undefined ? _data["entityID"] : null as any;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null as any;
            this.faIcon = _data["faIcon"] !== undefined ? _data["faIcon"] : null as any;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : null as any;
        }
    }

    static fromJS(data: any): PageLinkContent {
        data = typeof data === 'object' ? data : {};
        let result = new PageLinkContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["pageLinkID"] = this.pageLinkID !== undefined ? this.pageLinkID : null as any;
        data["entityType"] = this.entityType !== undefined ? this.entityType : null as any;
        data["entityID"] = this.entityID !== undefined ? this.entityID : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        data["faIcon"] = this.faIcon !== undefined ? this.faIcon : null as any;
        data["deleted"] = this.deleted !== undefined ? this.deleted : null as any;
        return data;
    }
}

export interface IPageLinkContent {
    id?: number;
    pageLinkID?: number;
    entityType?: ETipoEntita;
    entityID?: number;
    sortOrder?: number;
    faIcon?: string | null;
    deleted?: string | null;
}

export class GetPagesRequest extends LocalizedRequest implements IGetPagesRequest {
    operator!: EOperatore;

    constructor(data?: IGetPagesRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operator = _data["operator"] !== undefined ? _data["operator"] : null as any;
        }
    }

    static override fromJS(data: any): GetPagesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPagesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operator"] = this.operator !== undefined ? this.operator : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPagesRequest extends ILocalizedRequest {
    operator: EOperatore;
}

/** Response containing the public trip data displayed on the B2C trip page. No financial or internal information is included. */
export class GetPublicTripResponse extends OkApiResponse implements IGetPublicTripResponse {
    /** Trip header: name, destination, period, nights. */
    header?: PublicTripHeader;
    /** Language used to localise the trip content; derived from the agency
language and falling back to the request language. */
    language?: ELingua;
    /** List of passengers with their names. */
    paxes?: PublicTripPax[];
    /** Full flight plan ordered by departure time; all legs of all PNRs. */
    flightPlan?: PublicTripFlightSegment[];
    /** Itinerary steps ordered by day, each with its destination, cover image and services. */
    itinerary?: PublicTripItineraryStep[];
    /** Trip documents available for download. */
    documents?: PublicTripDocument[];
    /** Insurance services attached to the trip. */
    insurances?: PublicTripInsurance[];

    constructor(data?: IGetPublicTripResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.header = _data["header"] ? PublicTripHeader.fromJS(_data["header"]) : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
            if (Array.isArray(_data["paxes"])) {
                this.paxes = [] as any;
                for (let item of _data["paxes"])
                    this.paxes!.push(PublicTripPax.fromJS(item));
            }
            else {
                this.paxes = null as any;
            }
            if (Array.isArray(_data["flightPlan"])) {
                this.flightPlan = [] as any;
                for (let item of _data["flightPlan"])
                    this.flightPlan!.push(PublicTripFlightSegment.fromJS(item));
            }
            else {
                this.flightPlan = null as any;
            }
            if (Array.isArray(_data["itinerary"])) {
                this.itinerary = [] as any;
                for (let item of _data["itinerary"])
                    this.itinerary!.push(PublicTripItineraryStep.fromJS(item));
            }
            else {
                this.itinerary = null as any;
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(PublicTripDocument.fromJS(item));
            }
            else {
                this.documents = null as any;
            }
            if (Array.isArray(_data["insurances"])) {
                this.insurances = [] as any;
                for (let item of _data["insurances"])
                    this.insurances!.push(PublicTripInsurance.fromJS(item));
            }
            else {
                this.insurances = null as any;
            }
        }
    }

    static override fromJS(data: any): GetPublicTripResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicTripResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header ? this.header.toJSON() : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        if (Array.isArray(this.paxes)) {
            data["paxes"] = [];
            for (let item of this.paxes)
                data["paxes"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.flightPlan)) {
            data["flightPlan"] = [];
            for (let item of this.flightPlan)
                data["flightPlan"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.itinerary)) {
            data["itinerary"] = [];
            for (let item of this.itinerary)
                data["itinerary"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.insurances)) {
            data["insurances"] = [];
            for (let item of this.insurances)
                data["insurances"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Response containing the public trip data displayed on the B2C trip page. No financial or internal information is included. */
export interface IGetPublicTripResponse extends IOkApiResponse {
    /** Trip header: name, destination, period, nights. */
    header?: PublicTripHeader;
    /** Language used to localise the trip content; derived from the agency
language and falling back to the request language. */
    language?: ELingua;
    /** List of passengers with their names. */
    paxes?: PublicTripPax[];
    /** Full flight plan ordered by departure time; all legs of all PNRs. */
    flightPlan?: PublicTripFlightSegment[];
    /** Itinerary steps ordered by day, each with its destination, cover image and services. */
    itinerary?: PublicTripItineraryStep[];
    /** Trip documents available for download. */
    documents?: PublicTripDocument[];
    /** Insurance services attached to the trip. */
    insurances?: PublicTripInsurance[];
}

/** Trip header shown at the top of the public page: name, destination, period, nights. */
export class PublicTripHeader implements IPublicTripHeader {
    /** Trip name (internal travel title). */
    name?: string;
    /** Main destination name in the requested language. */
    destination?: string | null;
    /** Departure date. */
    departureDate?: string;
    /** Return date; null when not yet defined. */
    returnDate?: string | null;
    /** Number of nights. */
    nights?: number;
    /** Number of paxes. */
    paxesNum?: number;
    isDocumentPublishing?: boolean;

    constructor(data?: IPublicTripHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.destination = _data["destination"] !== undefined ? _data["destination"] : null as any;
            this.departureDate = _data["departureDate"] !== undefined ? _data["departureDate"] : null as any;
            this.returnDate = _data["returnDate"] !== undefined ? _data["returnDate"] : null as any;
            this.nights = _data["nights"] !== undefined ? _data["nights"] : null as any;
            this.paxesNum = _data["paxesNum"] !== undefined ? _data["paxesNum"] : null as any;
            this.isDocumentPublishing = _data["isDocumentPublishing"] !== undefined ? _data["isDocumentPublishing"] : null as any;
        }
    }

    static fromJS(data: any): PublicTripHeader {
        data = typeof data === 'object' ? data : {};
        let result = new PublicTripHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["destination"] = this.destination !== undefined ? this.destination : null as any;
        data["departureDate"] = this.departureDate !== undefined ? this.departureDate : null as any;
        data["returnDate"] = this.returnDate !== undefined ? this.returnDate : null as any;
        data["nights"] = this.nights !== undefined ? this.nights : null as any;
        data["paxesNum"] = this.paxesNum !== undefined ? this.paxesNum : null as any;
        data["isDocumentPublishing"] = this.isDocumentPublishing !== undefined ? this.isDocumentPublishing : null as any;
        return data;
    }
}

/** Trip header shown at the top of the public page: name, destination, period, nights. */
export interface IPublicTripHeader {
    /** Trip name (internal travel title). */
    name?: string;
    /** Main destination name in the requested language. */
    destination?: string | null;
    /** Departure date. */
    departureDate?: string;
    /** Return date; null when not yet defined. */
    returnDate?: string | null;
    /** Number of nights. */
    nights?: number;
    /** Number of paxes. */
    paxesNum?: number;
    isDocumentPublishing?: boolean;
}

/** Passenger name shown in the passengers list. */
export class PublicTripPax implements IPublicTripPax {
    /** Given name of the passenger. */
    firstName?: string | null;
    /** Family name of the passenger. */
    lastName?: string | null;

    constructor(data?: IPublicTripPax) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
        }
    }

    static fromJS(data: any): PublicTripPax {
        data = typeof data === 'object' ? data : {};
        let result = new PublicTripPax();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        return data;
    }
}

/** Passenger name shown in the passengers list. */
export interface IPublicTripPax {
    /** Given name of the passenger. */
    firstName?: string | null;
    /** Family name of the passenger. */
    lastName?: string | null;
}

/** A single flight segment (leg) within the trip's full flight plan. */
export class PublicTripFlightSegment implements IPublicTripFlightSegment {
    /** PNR code of the booking that contains this segment. */
    pnr?: string | null;
    /** Scheduled departure date and time. */
    departureDate?: string | null;
    /** Scheduled arrival date and time. */
    arrivalDate?: string | null;
    /** IATA code of the departure airport. */
    departureAirportCode?: string | null;
    /** Full name of the departure airport in the requested language. */
    departureAirportName?: string | null;
    /** IATA code of the arrival airport. */
    arrivalAirportCode?: string | null;
    /** Full name of the arrival airport in the requested language. */
    arrivalAirportName?: string | null;
    /** IATA code of the operating airline. */
    airlineCode?: string | null;
    /** Full name of the operating airline. */
    airlineName?: string | null;
    /** Flight number. */
    flightNumber?: number | null;
    /** Booking class code. */
    class?: string | null;
    /** true when the arrival is on the calendar day after departure. */
    arrivalNextDay?: boolean;

    constructor(data?: IPublicTripFlightSegment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pnr = _data["pnr"] !== undefined ? _data["pnr"] : null as any;
            this.departureDate = _data["departureDate"] !== undefined ? _data["departureDate"] : null as any;
            this.arrivalDate = _data["arrivalDate"] !== undefined ? _data["arrivalDate"] : null as any;
            this.departureAirportCode = _data["departureAirportCode"] !== undefined ? _data["departureAirportCode"] : null as any;
            this.departureAirportName = _data["departureAirportName"] !== undefined ? _data["departureAirportName"] : null as any;
            this.arrivalAirportCode = _data["arrivalAirportCode"] !== undefined ? _data["arrivalAirportCode"] : null as any;
            this.arrivalAirportName = _data["arrivalAirportName"] !== undefined ? _data["arrivalAirportName"] : null as any;
            this.airlineCode = _data["airlineCode"] !== undefined ? _data["airlineCode"] : null as any;
            this.airlineName = _data["airlineName"] !== undefined ? _data["airlineName"] : null as any;
            this.flightNumber = _data["flightNumber"] !== undefined ? _data["flightNumber"] : null as any;
            this.class = _data["class"] !== undefined ? _data["class"] : null as any;
            this.arrivalNextDay = _data["arrivalNextDay"] !== undefined ? _data["arrivalNextDay"] : null as any;
        }
    }

    static fromJS(data: any): PublicTripFlightSegment {
        data = typeof data === 'object' ? data : {};
        let result = new PublicTripFlightSegment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pnr"] = this.pnr !== undefined ? this.pnr : null as any;
        data["departureDate"] = this.departureDate !== undefined ? this.departureDate : null as any;
        data["arrivalDate"] = this.arrivalDate !== undefined ? this.arrivalDate : null as any;
        data["departureAirportCode"] = this.departureAirportCode !== undefined ? this.departureAirportCode : null as any;
        data["departureAirportName"] = this.departureAirportName !== undefined ? this.departureAirportName : null as any;
        data["arrivalAirportCode"] = this.arrivalAirportCode !== undefined ? this.arrivalAirportCode : null as any;
        data["arrivalAirportName"] = this.arrivalAirportName !== undefined ? this.arrivalAirportName : null as any;
        data["airlineCode"] = this.airlineCode !== undefined ? this.airlineCode : null as any;
        data["airlineName"] = this.airlineName !== undefined ? this.airlineName : null as any;
        data["flightNumber"] = this.flightNumber !== undefined ? this.flightNumber : null as any;
        data["class"] = this.class !== undefined ? this.class : null as any;
        data["arrivalNextDay"] = this.arrivalNextDay !== undefined ? this.arrivalNextDay : null as any;
        return data;
    }
}

/** A single flight segment (leg) within the trip's full flight plan. */
export interface IPublicTripFlightSegment {
    /** PNR code of the booking that contains this segment. */
    pnr?: string | null;
    /** Scheduled departure date and time. */
    departureDate?: string | null;
    /** Scheduled arrival date and time. */
    arrivalDate?: string | null;
    /** IATA code of the departure airport. */
    departureAirportCode?: string | null;
    /** Full name of the departure airport in the requested language. */
    departureAirportName?: string | null;
    /** IATA code of the arrival airport. */
    arrivalAirportCode?: string | null;
    /** Full name of the arrival airport in the requested language. */
    arrivalAirportName?: string | null;
    /** IATA code of the operating airline. */
    airlineCode?: string | null;
    /** Full name of the operating airline. */
    airlineName?: string | null;
    /** Flight number. */
    flightNumber?: number | null;
    /** Booking class code. */
    class?: string | null;
    /** true when the arrival is on the calendar day after departure. */
    arrivalNextDay?: boolean;
}

/** A destination stop in the trip itinerary, with its date range, cover image and services. */
export class PublicTripItineraryStep implements IPublicTripItineraryStep {
    /** Destination name in the trip language. */
    destination?: string | null;
    /** Public URL of the destination cover image; empty string when unavailable. */
    coverImage?: string;
    /** Date of arrival at this destination. */
    arrivalDate?: string | null;
    /** Date of departure from this destination. */
    departureDate?: string | null;
    /** Services attached to this itinerary stop. */
    services?: PublicTripItineraryService[];

    constructor(data?: IPublicTripItineraryStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.destination = _data["destination"] !== undefined ? _data["destination"] : null as any;
            this.coverImage = _data["coverImage"] !== undefined ? _data["coverImage"] : null as any;
            this.arrivalDate = _data["arrivalDate"] !== undefined ? _data["arrivalDate"] : null as any;
            this.departureDate = _data["departureDate"] !== undefined ? _data["departureDate"] : null as any;
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(PublicTripItineraryService.fromJS(item));
            }
            else {
                this.services = null as any;
            }
        }
    }

    static fromJS(data: any): PublicTripItineraryStep {
        data = typeof data === 'object' ? data : {};
        let result = new PublicTripItineraryStep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["destination"] = this.destination !== undefined ? this.destination : null as any;
        data["coverImage"] = this.coverImage !== undefined ? this.coverImage : null as any;
        data["arrivalDate"] = this.arrivalDate !== undefined ? this.arrivalDate : null as any;
        data["departureDate"] = this.departureDate !== undefined ? this.departureDate : null as any;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** A destination stop in the trip itinerary, with its date range, cover image and services. */
export interface IPublicTripItineraryStep {
    /** Destination name in the trip language. */
    destination?: string | null;
    /** Public URL of the destination cover image; empty string when unavailable. */
    coverImage?: string;
    /** Date of arrival at this destination. */
    arrivalDate?: string | null;
    /** Date of departure from this destination. */
    departureDate?: string | null;
    /** Services attached to this itinerary stop. */
    services?: PublicTripItineraryService[];
}

/** A service (hotel, transfer, excursion, etc.) within an itinerary step. */
export class PublicTripItineraryService implements IPublicTripItineraryService {
    /** Service name in the trip language. */
    name?: string | null;
    /** Client-facing description for the travel program.
Falls back to the row description when client notes are absent. */
    description?: string | null;
    /** Public URL of the service cover image; null when unavailable. */
    imageUrl?: string | null;

    constructor(data?: IPublicTripItineraryService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : null as any;
        }
    }

    static fromJS(data: any): PublicTripItineraryService {
        data = typeof data === 'object' ? data : {};
        let result = new PublicTripItineraryService();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : null as any;
        return data;
    }
}

/** A service (hotel, transfer, excursion, etc.) within an itinerary step. */
export interface IPublicTripItineraryService {
    /** Service name in the trip language. */
    name?: string | null;
    /** Client-facing description for the travel program.
Falls back to the row description when client notes are absent. */
    description?: string | null;
    /** Public URL of the service cover image; null when unavailable. */
    imageUrl?: string | null;
}

/** A trip document available for download. */
export class PublicTripDocument implements IPublicTripDocument {
    /** Document ID. */
    id?: number;
    /** Document display name. */
    name?: string | null;
    /** Public download URL; null when the document has no public URL. */
    publicUrl?: string | null;

    constructor(data?: IPublicTripDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.publicUrl = _data["publicUrl"] !== undefined ? _data["publicUrl"] : null as any;
        }
    }

    static fromJS(data: any): PublicTripDocument {
        data = typeof data === 'object' ? data : {};
        let result = new PublicTripDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["publicUrl"] = this.publicUrl !== undefined ? this.publicUrl : null as any;
        return data;
    }
}

/** A trip document available for download. */
export interface IPublicTripDocument {
    /** Document ID. */
    id?: number;
    /** Document display name. */
    name?: string | null;
    /** Public download URL; null when the document has no public URL. */
    publicUrl?: string | null;
}

/** An insurance service attached to the trip. */
export class PublicTripInsurance implements IPublicTripInsurance {
    /** Insurance service name in the trip language. */
    name?: string | null;
    /** Client-facing description; null when not provided. */
    description?: string | null;

    constructor(data?: IPublicTripInsurance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
        }
    }

    static fromJS(data: any): PublicTripInsurance {
        data = typeof data === 'object' ? data : {};
        let result = new PublicTripInsurance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        return data;
    }
}

/** An insurance service attached to the trip. */
export interface IPublicTripInsurance {
    /** Insurance service name in the trip language. */
    name?: string | null;
    /** Client-facing description; null when not provided. */
    description?: string | null;
}

/** Request to retrieve public trip data. */
export class GetPublicTripRequest extends SiteRequest implements IGetPublicTripRequest {
    /** Authentication key derived from the trip ID and server-side salt. */
    key!: string;
    /** ID of the trip (offerta). */
    offertaID!: number;

    constructor(data?: IGetPublicTripRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
        }
    }

    static override fromJS(data: any): GetPublicTripRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicTripRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Request to retrieve public trip data. */
export interface IGetPublicTripRequest extends ISiteRequest {
    /** Authentication key derived from the trip ID and server-side salt. */
    key: string;
    /** ID of the trip (offerta). */
    offertaID: number;
}

export class GetTripResponse extends OkApiResponse implements IGetTripResponse {
    trip?: TripInfo | null;

    constructor(data?: IGetTripResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trip = _data["trip"] ? TripInfo.fromJS(_data["trip"]) : null as any;
        }
    }

    static override fromJS(data: any): GetTripResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trip"] = this.trip ? this.trip.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTripResponse extends IOkApiResponse {
    trip?: TripInfo | null;
}

/** Versione completa di un viaggio    Articoli, Immagini, Partenze e Itinerario */
export class TripInfo extends TripHead implements ITripInfo {
    articoli?: TripArticle[] | null;
    articoliTraducibili?: TripArticle[] | null;
    immagini?: TripImage[] | null;
    partenze?: TripDeparture[] | null;
    itinerario?: TripItinerary | null;
    tipoServizio?: ETipoServizio;
    popolarita?: number | null;
    attributi?: ServiceAttribute[] | null;
    allegati?: TripAttachment[] | null;

    constructor(data?: ITripInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["articoli"])) {
                this.articoli = [] as any;
                for (let item of _data["articoli"])
                    this.articoli!.push(TripArticle.fromJS(item));
            }
            else {
                this.articoli = null as any;
            }
            if (Array.isArray(_data["articoliTraducibili"])) {
                this.articoliTraducibili = [] as any;
                for (let item of _data["articoliTraducibili"])
                    this.articoliTraducibili!.push(TripArticle.fromJS(item));
            }
            else {
                this.articoliTraducibili = null as any;
            }
            if (Array.isArray(_data["immagini"])) {
                this.immagini = [] as any;
                for (let item of _data["immagini"])
                    this.immagini!.push(TripImage.fromJS(item));
            }
            else {
                this.immagini = null as any;
            }
            if (Array.isArray(_data["partenze"])) {
                this.partenze = [] as any;
                for (let item of _data["partenze"])
                    this.partenze!.push(TripDeparture.fromJS(item));
            }
            else {
                this.partenze = null as any;
            }
            this.itinerario = _data["itinerario"] ? TripItinerary.fromJS(_data["itinerario"]) : null as any;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
            this.popolarita = _data["popolarita"] !== undefined ? _data["popolarita"] : null as any;
            if (Array.isArray(_data["attributi"])) {
                this.attributi = [] as any;
                for (let item of _data["attributi"])
                    this.attributi!.push(ServiceAttribute.fromJS(item));
            }
            else {
                this.attributi = null as any;
            }
            if (Array.isArray(_data["allegati"])) {
                this.allegati = [] as any;
                for (let item of _data["allegati"])
                    this.allegati!.push(TripAttachment.fromJS(item));
            }
            else {
                this.allegati = null as any;
            }
        }
    }

    static override fromJS(data: any): TripInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TripInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.articoli)) {
            data["articoli"] = [];
            for (let item of this.articoli)
                data["articoli"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.articoliTraducibili)) {
            data["articoliTraducibili"] = [];
            for (let item of this.articoliTraducibili)
                data["articoliTraducibili"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.immagini)) {
            data["immagini"] = [];
            for (let item of this.immagini)
                data["immagini"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.partenze)) {
            data["partenze"] = [];
            for (let item of this.partenze)
                data["partenze"].push(item ? item.toJSON() : null as any);
        }
        data["itinerario"] = this.itinerario ? this.itinerario.toJSON() : null as any;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        data["popolarita"] = this.popolarita !== undefined ? this.popolarita : null as any;
        if (Array.isArray(this.attributi)) {
            data["attributi"] = [];
            for (let item of this.attributi)
                data["attributi"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.allegati)) {
            data["allegati"] = [];
            for (let item of this.allegati)
                data["allegati"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Versione completa di un viaggio    Articoli, Immagini, Partenze e Itinerario */
export interface ITripInfo extends ITripHead {
    articoli?: TripArticle[] | null;
    articoliTraducibili?: TripArticle[] | null;
    immagini?: TripImage[] | null;
    partenze?: TripDeparture[] | null;
    itinerario?: TripItinerary | null;
    tipoServizio?: ETipoServizio;
    popolarita?: number | null;
    attributi?: ServiceAttribute[] | null;
    allegati?: TripAttachment[] | null;
}

export class TripArticle implements ITripArticle {
    titolo?: string | null;
    testo?: string | null;

    constructor(data?: ITripArticle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : null as any;
        }
    }

    static fromJS(data: any): TripArticle {
        data = typeof data === 'object' ? data : {};
        let result = new TripArticle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        data["testo"] = this.testo !== undefined ? this.testo : null as any;
        return data;
    }
}

export interface ITripArticle {
    titolo?: string | null;
    testo?: string | null;
}

export class TripImage implements ITripImage {
    titolo?: string | null;
    url?: string | null;

    constructor(data?: ITripImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
        }
    }

    static fromJS(data: any): TripImage {
        data = typeof data === 'object' ? data : {};
        let result = new TripImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        return data;
    }
}

export interface ITripImage {
    titolo?: string | null;
    url?: string | null;
}

export class TripDeparture implements ITripDeparture {
    dataFirst?: string;
    anno?: number;
    parts?: TripDeparturePart[] | null;

    constructor(data?: ITripDeparture) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataFirst = _data["dataFirst"] !== undefined ? _data["dataFirst"] : null as any;
            this.anno = _data["anno"] !== undefined ? _data["anno"] : null as any;
            if (Array.isArray(_data["parts"])) {
                this.parts = [] as any;
                for (let item of _data["parts"])
                    this.parts!.push(TripDeparturePart.fromJS(item));
            }
            else {
                this.parts = null as any;
            }
        }
    }

    static fromJS(data: any): TripDeparture {
        data = typeof data === 'object' ? data : {};
        let result = new TripDeparture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataFirst"] = this.dataFirst !== undefined ? this.dataFirst : null as any;
        data["anno"] = this.anno !== undefined ? this.anno : null as any;
        if (Array.isArray(this.parts)) {
            data["parts"] = [];
            for (let item of this.parts)
                data["parts"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ITripDeparture {
    dataFirst?: string;
    anno?: number;
    parts?: TripDeparturePart[] | null;
}

export class TripDeparturePart implements ITripDeparturePart {
    mese?: number;
    giorni?: number[] | null;

    constructor(data?: ITripDeparturePart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mese = _data["mese"] !== undefined ? _data["mese"] : null as any;
            if (Array.isArray(_data["giorni"])) {
                this.giorni = [] as any;
                for (let item of _data["giorni"])
                    this.giorni!.push(item);
            }
            else {
                this.giorni = null as any;
            }
        }
    }

    static fromJS(data: any): TripDeparturePart {
        data = typeof data === 'object' ? data : {};
        let result = new TripDeparturePart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mese"] = this.mese !== undefined ? this.mese : null as any;
        if (Array.isArray(this.giorni)) {
            data["giorni"] = [];
            for (let item of this.giorni)
                data["giorni"].push(item);
        }
        return data;
    }
}

export interface ITripDeparturePart {
    mese?: number;
    giorni?: number[] | null;
}

export class TripItinerary implements ITripItinerary {
    nome?: string | null;
    giorni?: number;
    notti?: number;
    days?: TripItineraryDay[] | null;

    constructor(data?: ITripItinerary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.giorni = _data["giorni"] !== undefined ? _data["giorni"] : null as any;
            this.notti = _data["notti"] !== undefined ? _data["notti"] : null as any;
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(TripItineraryDay.fromJS(item));
            }
            else {
                this.days = null as any;
            }
        }
    }

    static fromJS(data: any): TripItinerary {
        data = typeof data === 'object' ? data : {};
        let result = new TripItinerary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["giorni"] = this.giorni !== undefined ? this.giorni : null as any;
        data["notti"] = this.notti !== undefined ? this.notti : null as any;
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ITripItinerary {
    nome?: string | null;
    giorni?: number;
    notti?: number;
    days?: TripItineraryDay[] | null;
}

export class TripItineraryDay implements ITripItineraryDay {
    giorno?: number;
    ordine?: number;
    luogo?: string | null;
    durata?: number;
    hotel?: string | null;
    immagine?: TripImage | null;
    lat?: number;
    lon?: number;
    tipoTrasporto?: ETipoTrasporto | null;

    constructor(data?: ITripItineraryDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.durata = _data["durata"] !== undefined ? _data["durata"] : null as any;
            this.hotel = _data["hotel"] !== undefined ? _data["hotel"] : null as any;
            this.immagine = _data["immagine"] ? TripImage.fromJS(_data["immagine"]) : null as any;
            this.lat = _data["lat"] !== undefined ? _data["lat"] : null as any;
            this.lon = _data["lon"] !== undefined ? _data["lon"] : null as any;
            this.tipoTrasporto = _data["tipoTrasporto"] !== undefined ? _data["tipoTrasporto"] : null as any;
        }
    }

    static fromJS(data: any): TripItineraryDay {
        data = typeof data === 'object' ? data : {};
        let result = new TripItineraryDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giorno"] = this.giorno !== undefined ? this.giorno : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["durata"] = this.durata !== undefined ? this.durata : null as any;
        data["hotel"] = this.hotel !== undefined ? this.hotel : null as any;
        data["immagine"] = this.immagine ? this.immagine.toJSON() : null as any;
        data["lat"] = this.lat !== undefined ? this.lat : null as any;
        data["lon"] = this.lon !== undefined ? this.lon : null as any;
        data["tipoTrasporto"] = this.tipoTrasporto !== undefined ? this.tipoTrasporto : null as any;
        return data;
    }
}

export interface ITripItineraryDay {
    giorno?: number;
    ordine?: number;
    luogo?: string | null;
    durata?: number;
    hotel?: string | null;
    immagine?: TripImage | null;
    lat?: number;
    lon?: number;
    tipoTrasporto?: ETipoTrasporto | null;
}

export enum ETipoTrasporto {
    Aereo = "Aereo",
    Auto = "Auto",
    Traghetto = "Traghetto",
    Indefinito = "Indefinito",
    Treno = "Treno",
    Pullman = "Pullman",
}

export class ServiceAttribute implements IServiceAttribute {
    tipoID?: number;
    nomeTipo?: string | null;
    valori?: string[] | null;

    constructor(data?: IServiceAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoID = _data["tipoID"] !== undefined ? _data["tipoID"] : null as any;
            this.nomeTipo = _data["nomeTipo"] !== undefined ? _data["nomeTipo"] : null as any;
            if (Array.isArray(_data["valori"])) {
                this.valori = [] as any;
                for (let item of _data["valori"])
                    this.valori!.push(item);
            }
            else {
                this.valori = null as any;
            }
        }
    }

    static fromJS(data: any): ServiceAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoID"] = this.tipoID !== undefined ? this.tipoID : null as any;
        data["nomeTipo"] = this.nomeTipo !== undefined ? this.nomeTipo : null as any;
        if (Array.isArray(this.valori)) {
            data["valori"] = [];
            for (let item of this.valori)
                data["valori"].push(item);
        }
        return data;
    }
}

export interface IServiceAttribute {
    tipoID?: number;
    nomeTipo?: string | null;
    valori?: string[] | null;
}

export class TripAttachment implements ITripAttachment {
    fileUrl?: string | null;
    fileExt?: string | null;
    descr?: string | null;

    constructor(data?: ITripAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileUrl = _data["fileUrl"] !== undefined ? _data["fileUrl"] : null as any;
            this.fileExt = _data["fileExt"] !== undefined ? _data["fileExt"] : null as any;
            this.descr = _data["descr"] !== undefined ? _data["descr"] : null as any;
        }
    }

    static fromJS(data: any): TripAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new TripAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileUrl"] = this.fileUrl !== undefined ? this.fileUrl : null as any;
        data["fileExt"] = this.fileExt !== undefined ? this.fileExt : null as any;
        data["descr"] = this.descr !== undefined ? this.descr : null as any;
        return data;
    }
}

export interface ITripAttachment {
    fileUrl?: string | null;
    fileExt?: string | null;
    descr?: string | null;
}

export class GetTripRequest extends SiteRequest implements IGetTripRequest {
    tripID?: number;

    constructor(data?: IGetTripRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : null as any;
        }
    }

    static override fromJS(data: any): GetTripRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripID"] = this.tripID !== undefined ? this.tripID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTripRequest extends ISiteRequest {
    tripID?: number;
}

export class SetInfosRequest extends SiteRequest implements ISetInfosRequest {
    cognome?: string | null;
    nome?: string | null;
    email?: string | null;
    viaggioDiNozze?: string | null;
    budget?: string | null;
    note?: string | null;
    selectedADV?: TinySelectedAdv | null;
    interestedTrip?: TinyTripOfInterest[] | null;
    sentOn?: string | null;
    destinazioni?: string[] | null;
    selectedTrip?: string | null;

    constructor(data?: ISetInfosRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.viaggioDiNozze = _data["viaggioDiNozze"] !== undefined ? _data["viaggioDiNozze"] : null as any;
            this.budget = _data["budget"] !== undefined ? _data["budget"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.selectedADV = _data["selectedADV"] ? TinySelectedAdv.fromJS(_data["selectedADV"]) : null as any;
            if (Array.isArray(_data["interestedTrip"])) {
                this.interestedTrip = [] as any;
                for (let item of _data["interestedTrip"])
                    this.interestedTrip!.push(TinyTripOfInterest.fromJS(item));
            }
            else {
                this.interestedTrip = null as any;
            }
            this.sentOn = _data["sentOn"] !== undefined ? _data["sentOn"] : null as any;
            if (Array.isArray(_data["destinazioni"])) {
                this.destinazioni = [] as any;
                for (let item of _data["destinazioni"])
                    this.destinazioni!.push(item);
            }
            else {
                this.destinazioni = null as any;
            }
            this.selectedTrip = _data["selectedTrip"] !== undefined ? _data["selectedTrip"] : null as any;
        }
    }

    static override fromJS(data: any): SetInfosRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetInfosRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cognome"] = this.cognome !== undefined ? this.cognome : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["viaggioDiNozze"] = this.viaggioDiNozze !== undefined ? this.viaggioDiNozze : null as any;
        data["budget"] = this.budget !== undefined ? this.budget : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["selectedADV"] = this.selectedADV ? this.selectedADV.toJSON() : null as any;
        if (Array.isArray(this.interestedTrip)) {
            data["interestedTrip"] = [];
            for (let item of this.interestedTrip)
                data["interestedTrip"].push(item ? item.toJSON() : null as any);
        }
        data["sentOn"] = this.sentOn !== undefined ? this.sentOn : null as any;
        if (Array.isArray(this.destinazioni)) {
            data["destinazioni"] = [];
            for (let item of this.destinazioni)
                data["destinazioni"].push(item);
        }
        data["selectedTrip"] = this.selectedTrip !== undefined ? this.selectedTrip : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISetInfosRequest extends ISiteRequest {
    cognome?: string | null;
    nome?: string | null;
    email?: string | null;
    viaggioDiNozze?: string | null;
    budget?: string | null;
    note?: string | null;
    selectedADV?: TinySelectedAdv | null;
    interestedTrip?: TinyTripOfInterest[] | null;
    sentOn?: string | null;
    destinazioni?: string[] | null;
    selectedTrip?: string | null;
}

export class TinySelectedAdv implements ITinySelectedAdv {
    contactID?: string | null;
    nome?: string | null;
    telefono?: string | null;
    indirizzo?: string | null;

    constructor(data?: ITinySelectedAdv) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactID = _data["contactID"] !== undefined ? _data["contactID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : null as any;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : null as any;
        }
    }

    static fromJS(data: any): TinySelectedAdv {
        data = typeof data === 'object' ? data : {};
        let result = new TinySelectedAdv();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactID"] = this.contactID !== undefined ? this.contactID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["telefono"] = this.telefono !== undefined ? this.telefono : null as any;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : null as any;
        return data;
    }
}

export interface ITinySelectedAdv {
    contactID?: string | null;
    nome?: string | null;
    telefono?: string | null;
    indirizzo?: string | null;
}

export class TinyTripOfInterest implements ITinyTripOfInterest {
    id?: string | null;
    nome?: string | null;
    durata?: string | null;

    constructor(data?: ITinyTripOfInterest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.durata = _data["durata"] !== undefined ? _data["durata"] : null as any;
        }
    }

    static fromJS(data: any): TinyTripOfInterest {
        data = typeof data === 'object' ? data : {};
        let result = new TinyTripOfInterest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["durata"] = this.durata !== undefined ? this.durata : null as any;
        return data;
    }
}

export interface ITinyTripOfInterest {
    id?: string | null;
    nome?: string | null;
    durata?: string | null;
}

export class BasecampAuthorizeRequest extends ApiRequest implements IBasecampAuthorizeRequest {
    /** Il codice di autorizzazione ottenuto da Basecamp */
    code!: string;

    constructor(data?: IBasecampAuthorizeRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
        }
    }

    static override fromJS(data: any): BasecampAuthorizeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BasecampAuthorizeRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IBasecampAuthorizeRequest extends IApiRequest {
    /** Il codice di autorizzazione ottenuto da Basecamp */
    code: string;
}

export class NrTableResponseOfBasecampMessageData extends OkApiResponse implements INrTableResponseOfBasecampMessageData {
    /** Array delle righe della pagina richiesta */
    rows?: BasecampMessageData[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfBasecampMessageData) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(BasecampMessageData.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfBasecampMessageData {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfBasecampMessageData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfBasecampMessageData extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: BasecampMessageData[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class BasecampMessageData implements IBasecampMessageData {
    id?: number;
    avatarUrl?: string | null;
    appUrl?: string | null;
    title?: string | null;
    creatorName?: string | null;
    createdAt?: string;

    constructor(data?: IBasecampMessageData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.avatarUrl = _data["avatarUrl"] !== undefined ? _data["avatarUrl"] : null as any;
            this.appUrl = _data["appUrl"] !== undefined ? _data["appUrl"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.creatorName = _data["creatorName"] !== undefined ? _data["creatorName"] : null as any;
            this.createdAt = _data["createdAt"] !== undefined ? _data["createdAt"] : null as any;
        }
    }

    static fromJS(data: any): BasecampMessageData {
        data = typeof data === 'object' ? data : {};
        let result = new BasecampMessageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["avatarUrl"] = this.avatarUrl !== undefined ? this.avatarUrl : null as any;
        data["appUrl"] = this.appUrl !== undefined ? this.appUrl : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["creatorName"] = this.creatorName !== undefined ? this.creatorName : null as any;
        data["createdAt"] = this.createdAt !== undefined ? this.createdAt : null as any;
        return data;
    }
}

export interface IBasecampMessageData {
    id?: number;
    avatarUrl?: string | null;
    appUrl?: string | null;
    title?: string | null;
    creatorName?: string | null;
    createdAt?: string;
}

export class BasecampGetMessagesRequest extends NrTableRequest implements IBasecampGetMessagesRequest {
    projectId?: number;
    dockId?: number;

    constructor(data?: IBasecampGetMessagesRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : null as any;
            this.dockId = _data["dockId"] !== undefined ? _data["dockId"] : null as any;
        }
    }

    static override fromJS(data: any): BasecampGetMessagesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BasecampGetMessagesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId !== undefined ? this.projectId : null as any;
        data["dockId"] = this.dockId !== undefined ? this.dockId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IBasecampGetMessagesRequest extends INrTableRequest {
    projectId?: number;
    dockId?: number;
}

export class BasecampGetProjectsResponse extends OkApiResponse implements IBasecampGetProjectsResponse {
    projects?: BasecampProjectData[] | null;

    constructor(data?: IBasecampGetProjectsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(BasecampProjectData.fromJS(item));
            }
            else {
                this.projects = null as any;
            }
        }
    }

    static override fromJS(data: any): BasecampGetProjectsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BasecampGetProjectsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IBasecampGetProjectsResponse extends IOkApiResponse {
    projects?: BasecampProjectData[] | null;
}

export class BasecampProjectData implements IBasecampProjectData {
    projectName?: string | null;
    projectId?: number;
    dockId?: number;
    appUrl?: string | null;

    constructor(data?: IBasecampProjectData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectName = _data["projectName"] !== undefined ? _data["projectName"] : null as any;
            this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : null as any;
            this.dockId = _data["dockId"] !== undefined ? _data["dockId"] : null as any;
            this.appUrl = _data["appUrl"] !== undefined ? _data["appUrl"] : null as any;
        }
    }

    static fromJS(data: any): BasecampProjectData {
        data = typeof data === 'object' ? data : {};
        let result = new BasecampProjectData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName !== undefined ? this.projectName : null as any;
        data["projectId"] = this.projectId !== undefined ? this.projectId : null as any;
        data["dockId"] = this.dockId !== undefined ? this.dockId : null as any;
        data["appUrl"] = this.appUrl !== undefined ? this.appUrl : null as any;
        return data;
    }
}

export interface IBasecampProjectData {
    projectName?: string | null;
    projectId?: number;
    dockId?: number;
    appUrl?: string | null;
}

export class GetTrattamentiResponse extends OkApiResponse implements IGetTrattamentiResponse {
    trattamenti?: TrattamentoTradotto[] | null;

    constructor(data?: IGetTrattamentiResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["trattamenti"])) {
                this.trattamenti = [] as any;
                for (let item of _data["trattamenti"])
                    this.trattamenti!.push(TrattamentoTradotto.fromJS(item));
            }
            else {
                this.trattamenti = null as any;
            }
        }
    }

    static override fromJS(data: any): GetTrattamentiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTrattamentiResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.trattamenti)) {
            data["trattamenti"] = [];
            for (let item of this.trattamenti)
                data["trattamenti"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetTrattamentiResponse extends IOkApiResponse {
    trattamenti?: TrattamentoTradotto[] | null;
}

export class TrattamentoTradotto implements ITrattamentoTradotto {
    trattamento?: Trattamento | null;
    nome?: string | null;

    constructor(data?: ITrattamentoTradotto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trattamento = _data["trattamento"] ? Trattamento.fromJS(_data["trattamento"]) : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
        }
    }

    static fromJS(data: any): TrattamentoTradotto {
        data = typeof data === 'object' ? data : {};
        let result = new TrattamentoTradotto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trattamento"] = this.trattamento ? this.trattamento.toJSON() : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        return data;
    }
}

export interface ITrattamentoTradotto {
    trattamento?: Trattamento | null;
    nome?: string | null;
}

export class Trattamento implements ITrattamento {
    id?: number;
    traduzioni?: TreatmentTranslation[] | null;
    nome?: string | null;
    nome_en?: string | null;
    nomeVoucher?: string | null;
    ordine?: number;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean | null;
    confirmed_en?: boolean | null;

    constructor(data?: ITrattamento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(TreatmentTranslation.fromJS(item));
            }
            else {
                this.traduzioni = null as any;
            }
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : null as any;
            this.nomeVoucher = _data["nomeVoucher"] !== undefined ? _data["nomeVoucher"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : null as any;
            this.lastUpdate_en = _data["lastUpdate_en"] !== undefined ? _data["lastUpdate_en"] : null as any;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : null as any;
            this.confirmed_en = _data["confirmed_en"] !== undefined ? _data["confirmed_en"] : null as any;
        }
    }

    static fromJS(data: any): Trattamento {
        data = typeof data === 'object' ? data : {};
        let result = new Trattamento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item ? item.toJSON() : null as any);
        }
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : null as any;
        data["nomeVoucher"] = this.nomeVoucher !== undefined ? this.nomeVoucher : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : null as any;
        data["lastUpdate_en"] = this.lastUpdate_en !== undefined ? this.lastUpdate_en : null as any;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : null as any;
        data["confirmed_en"] = this.confirmed_en !== undefined ? this.confirmed_en : null as any;
        return data;
    }
}

export interface ITrattamento {
    id?: number;
    traduzioni?: TreatmentTranslation[] | null;
    nome?: string | null;
    nome_en?: string | null;
    nomeVoucher?: string | null;
    ordine?: number;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean | null;
    confirmed_en?: boolean | null;
}

export class TreatmentTranslation extends WebTranslation implements ITreatmentTranslation {

    constructor(data?: ITreatmentTranslation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): TreatmentTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentTranslation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITreatmentTranslation extends IWebTranslation {
}

export class GetFornitoriResponse extends OkApiResponse implements IGetFornitoriResponse {
    fornitori?: Fornitore[] | null;

    constructor(data?: IGetFornitoriResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["fornitori"])) {
                this.fornitori = [] as any;
                for (let item of _data["fornitori"])
                    this.fornitori!.push(Fornitore.fromJS(item));
            }
            else {
                this.fornitori = null as any;
            }
        }
    }

    static override fromJS(data: any): GetFornitoriResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFornitoriResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fornitori)) {
            data["fornitori"] = [];
            for (let item of this.fornitori)
                data["fornitori"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetFornitoriResponse extends IOkApiResponse {
    fornitori?: Fornitore[] | null;
}

export class Fornitore implements IFornitore {
    id?: number;
    codice?: EFornitore;
    nome?: string | null;
    attivo?: boolean;
    ricercaHotel?: boolean;
    bookingHotel?: boolean;
    ricercaVoli?: boolean;
    bookingVoli?: boolean;
    ricercaVisite?: boolean;
    bookingVisite?: boolean;
    ricercaNoleggi?: boolean;
    bookingNoleggi?: boolean;
    accordoObbligatorio?: boolean;

    constructor(data?: IFornitore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.attivo = _data["attivo"] !== undefined ? _data["attivo"] : null as any;
            this.ricercaHotel = _data["ricercaHotel"] !== undefined ? _data["ricercaHotel"] : null as any;
            this.bookingHotel = _data["bookingHotel"] !== undefined ? _data["bookingHotel"] : null as any;
            this.ricercaVoli = _data["ricercaVoli"] !== undefined ? _data["ricercaVoli"] : null as any;
            this.bookingVoli = _data["bookingVoli"] !== undefined ? _data["bookingVoli"] : null as any;
            this.ricercaVisite = _data["ricercaVisite"] !== undefined ? _data["ricercaVisite"] : null as any;
            this.bookingVisite = _data["bookingVisite"] !== undefined ? _data["bookingVisite"] : null as any;
            this.ricercaNoleggi = _data["ricercaNoleggi"] !== undefined ? _data["ricercaNoleggi"] : null as any;
            this.bookingNoleggi = _data["bookingNoleggi"] !== undefined ? _data["bookingNoleggi"] : null as any;
            this.accordoObbligatorio = _data["accordoObbligatorio"] !== undefined ? _data["accordoObbligatorio"] : null as any;
        }
    }

    static fromJS(data: any): Fornitore {
        data = typeof data === 'object' ? data : {};
        let result = new Fornitore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["attivo"] = this.attivo !== undefined ? this.attivo : null as any;
        data["ricercaHotel"] = this.ricercaHotel !== undefined ? this.ricercaHotel : null as any;
        data["bookingHotel"] = this.bookingHotel !== undefined ? this.bookingHotel : null as any;
        data["ricercaVoli"] = this.ricercaVoli !== undefined ? this.ricercaVoli : null as any;
        data["bookingVoli"] = this.bookingVoli !== undefined ? this.bookingVoli : null as any;
        data["ricercaVisite"] = this.ricercaVisite !== undefined ? this.ricercaVisite : null as any;
        data["bookingVisite"] = this.bookingVisite !== undefined ? this.bookingVisite : null as any;
        data["ricercaNoleggi"] = this.ricercaNoleggi !== undefined ? this.ricercaNoleggi : null as any;
        data["bookingNoleggi"] = this.bookingNoleggi !== undefined ? this.bookingNoleggi : null as any;
        data["accordoObbligatorio"] = this.accordoObbligatorio !== undefined ? this.accordoObbligatorio : null as any;
        return data;
    }
}

export interface IFornitore {
    id?: number;
    codice?: EFornitore;
    nome?: string | null;
    attivo?: boolean;
    ricercaHotel?: boolean;
    bookingHotel?: boolean;
    ricercaVoli?: boolean;
    bookingVoli?: boolean;
    ricercaVisite?: boolean;
    bookingVisite?: boolean;
    ricercaNoleggi?: boolean;
    bookingNoleggi?: boolean;
    accordoObbligatorio?: boolean;
}

export class GetPagamentiDocumentoContabileResponse extends OkApiResponse implements IGetPagamentiDocumentoContabileResponse {
    modalitaPagamento?: ModalitaPagamento[] | null;

    constructor(data?: IGetPagamentiDocumentoContabileResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["modalitaPagamento"])) {
                this.modalitaPagamento = [] as any;
                for (let item of _data["modalitaPagamento"])
                    this.modalitaPagamento!.push(ModalitaPagamento.fromJS(item));
            }
            else {
                this.modalitaPagamento = null as any;
            }
        }
    }

    static override fromJS(data: any): GetPagamentiDocumentoContabileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPagamentiDocumentoContabileResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.modalitaPagamento)) {
            data["modalitaPagamento"] = [];
            for (let item of this.modalitaPagamento)
                data["modalitaPagamento"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPagamentiDocumentoContabileResponse extends IOkApiResponse {
    modalitaPagamento?: ModalitaPagamento[] | null;
}

export class ModalitaPagamento implements IModalitaPagamento {
    id?: number;
    nome?: string | null;

    constructor(data?: IModalitaPagamento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
        }
    }

    static fromJS(data: any): ModalitaPagamento {
        data = typeof data === 'object' ? data : {};
        let result = new ModalitaPagamento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        return data;
    }
}

export interface IModalitaPagamento {
    id?: number;
    nome?: string | null;
}

export class GetBancheResponse extends OkApiResponse implements IGetBancheResponse {
    banche?: Banca[] | null;

    constructor(data?: IGetBancheResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["banche"])) {
                this.banche = [] as any;
                for (let item of _data["banche"])
                    this.banche!.push(Banca.fromJS(item));
            }
            else {
                this.banche = null as any;
            }
        }
    }

    static override fromJS(data: any): GetBancheResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBancheResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.banche)) {
            data["banche"] = [];
            for (let item of this.banche)
                data["banche"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetBancheResponse extends IOkApiResponse {
    banche?: Banca[] | null;
}

export class Banca implements IBanca {
    id?: number;
    nome?: string | null;
    iban?: string | null;

    constructor(data?: IBanca) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.iban = _data["iban"] !== undefined ? _data["iban"] : null as any;
        }
    }

    static fromJS(data: any): Banca {
        data = typeof data === 'object' ? data : {};
        let result = new Banca();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["iban"] = this.iban !== undefined ? this.iban : null as any;
        return data;
    }
}

export interface IBanca {
    id?: number;
    nome?: string | null;
    iban?: string | null;
}

export class GetSystemEmailsResponse extends OkApiResponse implements IGetSystemEmailsResponse {
    emails?: SystemEmailRow[] | null;

    constructor(data?: IGetSystemEmailsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(SystemEmailRow.fromJS(item));
            }
            else {
                this.emails = null as any;
            }
        }
    }

    static override fromJS(data: any): GetSystemEmailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSystemEmailsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetSystemEmailsResponse extends IOkApiResponse {
    emails?: SystemEmailRow[] | null;
}

export class SystemEmailRow implements ISystemEmailRow {
    id?: number;
    code?: string | null;
    hasDynamicBody?: boolean;
    hasDynamicRecipient?: boolean;
    isHtmlBody?: boolean;
    name?: string | null;
    texts?: SystemEmailTextRow[] | null;

    constructor(data?: ISystemEmailRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.hasDynamicBody = _data["hasDynamicBody"] !== undefined ? _data["hasDynamicBody"] : null as any;
            this.hasDynamicRecipient = _data["hasDynamicRecipient"] !== undefined ? _data["hasDynamicRecipient"] : null as any;
            this.isHtmlBody = _data["isHtmlBody"] !== undefined ? _data["isHtmlBody"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            if (Array.isArray(_data["texts"])) {
                this.texts = [] as any;
                for (let item of _data["texts"])
                    this.texts!.push(SystemEmailTextRow.fromJS(item));
            }
            else {
                this.texts = null as any;
            }
        }
    }

    static fromJS(data: any): SystemEmailRow {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEmailRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["hasDynamicBody"] = this.hasDynamicBody !== undefined ? this.hasDynamicBody : null as any;
        data["hasDynamicRecipient"] = this.hasDynamicRecipient !== undefined ? this.hasDynamicRecipient : null as any;
        data["isHtmlBody"] = this.isHtmlBody !== undefined ? this.isHtmlBody : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        if (Array.isArray(this.texts)) {
            data["texts"] = [];
            for (let item of this.texts)
                data["texts"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ISystemEmailRow {
    id?: number;
    code?: string | null;
    hasDynamicBody?: boolean;
    hasDynamicRecipient?: boolean;
    isHtmlBody?: boolean;
    name?: string | null;
    texts?: SystemEmailTextRow[] | null;
}

export class SystemEmailTextRow implements ISystemEmailTextRow {
    id?: number;
    body?: string | null;
    language?: ELingua;
    senderAddress?: string | null;
    senderName?: string | null;
    subject?: string | null;
    addresses?: SystemEmailAddress[] | null;

    constructor(data?: ISystemEmailTextRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.body = _data["body"] !== undefined ? _data["body"] : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
            this.senderAddress = _data["senderAddress"] !== undefined ? _data["senderAddress"] : null as any;
            this.senderName = _data["senderName"] !== undefined ? _data["senderName"] : null as any;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : null as any;
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(SystemEmailAddress.fromJS(item));
            }
            else {
                this.addresses = null as any;
            }
        }
    }

    static fromJS(data: any): SystemEmailTextRow {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEmailTextRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["body"] = this.body !== undefined ? this.body : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        data["senderAddress"] = this.senderAddress !== undefined ? this.senderAddress : null as any;
        data["senderName"] = this.senderName !== undefined ? this.senderName : null as any;
        data["subject"] = this.subject !== undefined ? this.subject : null as any;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ISystemEmailTextRow {
    id?: number;
    body?: string | null;
    language?: ELingua;
    senderAddress?: string | null;
    senderName?: string | null;
    subject?: string | null;
    addresses?: SystemEmailAddress[] | null;
}

export class SystemEmailAddress implements ISystemEmailAddress {
    id?: number;
    emailTextID?: number;
    addressType?: EEmailAddressType;
    name?: string | null;
    address!: string;

    constructor(data?: ISystemEmailAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.emailTextID = _data["emailTextID"] !== undefined ? _data["emailTextID"] : null as any;
            this.addressType = _data["addressType"] !== undefined ? _data["addressType"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.address = _data["address"] !== undefined ? _data["address"] : null as any;
        }
    }

    static fromJS(data: any): SystemEmailAddress {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEmailAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["emailTextID"] = this.emailTextID !== undefined ? this.emailTextID : null as any;
        data["addressType"] = this.addressType !== undefined ? this.addressType : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["address"] = this.address !== undefined ? this.address : null as any;
        return data;
    }
}

export interface ISystemEmailAddress {
    id?: number;
    emailTextID?: number;
    addressType?: EEmailAddressType;
    name?: string | null;
    address: string;
}

export enum EEmailAddressType {
    To = "To",
    Cc = "Cc",
    Bcc = "Bcc",
}

export class GetCompagnieAereeResponse extends OkApiResponse implements IGetCompagnieAereeResponse {
    compagnie?: CompagniaAerea[] | null;

    constructor(data?: IGetCompagnieAereeResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["compagnie"])) {
                this.compagnie = [] as any;
                for (let item of _data["compagnie"])
                    this.compagnie!.push(CompagniaAerea.fromJS(item));
            }
            else {
                this.compagnie = null as any;
            }
        }
    }

    static override fromJS(data: any): GetCompagnieAereeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompagnieAereeResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.compagnie)) {
            data["compagnie"] = [];
            for (let item of this.compagnie)
                data["compagnie"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetCompagnieAereeResponse extends IOkApiResponse {
    compagnie?: CompagniaAerea[] | null;
}

export class GetAeroportiResponse extends OkApiResponse implements IGetAeroportiResponse {
    aeroporti?: Aeroporto[] | null;

    constructor(data?: IGetAeroportiResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["aeroporti"])) {
                this.aeroporti = [] as any;
                for (let item of _data["aeroporti"])
                    this.aeroporti!.push(Aeroporto.fromJS(item));
            }
            else {
                this.aeroporti = null as any;
            }
        }
    }

    static override fromJS(data: any): GetAeroportiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAeroportiResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.aeroporti)) {
            data["aeroporti"] = [];
            for (let item of this.aeroporti)
                data["aeroporti"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetAeroportiResponse extends IOkApiResponse {
    aeroporti?: Aeroporto[] | null;
}

export class GetStatiVoloResponse extends OkApiResponse implements IGetStatiVoloResponse {
    stati?: StatoVolo[] | null;

    constructor(data?: IGetStatiVoloResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["stati"])) {
                this.stati = [] as any;
                for (let item of _data["stati"])
                    this.stati!.push(StatoVolo.fromJS(item));
            }
            else {
                this.stati = null as any;
            }
        }
    }

    static override fromJS(data: any): GetStatiVoloResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStatiVoloResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stati)) {
            data["stati"] = [];
            for (let item of this.stati)
                data["stati"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetStatiVoloResponse extends IOkApiResponse {
    stati?: StatoVolo[] | null;
}

export class StatoVolo implements IStatoVolo {
    statoID?: number;
    codice?: string;
    nome!: string;
    nome_en?: string | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean | null;
    confirmed_en?: boolean | null;
    ok?: boolean;

    constructor(data?: IStatoVolo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statoID = _data["statoID"] !== undefined ? _data["statoID"] : null as any;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : null as any;
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : null as any;
            this.lastUpdate_en = _data["lastUpdate_en"] !== undefined ? _data["lastUpdate_en"] : null as any;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : null as any;
            this.confirmed_en = _data["confirmed_en"] !== undefined ? _data["confirmed_en"] : null as any;
            this.ok = _data["ok"] !== undefined ? _data["ok"] : null as any;
        }
    }

    static fromJS(data: any): StatoVolo {
        data = typeof data === 'object' ? data : {};
        let result = new StatoVolo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statoID"] = this.statoID !== undefined ? this.statoID : null as any;
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : null as any;
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : null as any;
        data["lastUpdate_en"] = this.lastUpdate_en !== undefined ? this.lastUpdate_en : null as any;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : null as any;
        data["confirmed_en"] = this.confirmed_en !== undefined ? this.confirmed_en : null as any;
        data["ok"] = this.ok !== undefined ? this.ok : null as any;
        return data;
    }
}

export interface IStatoVolo {
    statoID?: number;
    codice?: string;
    nome: string;
    nome_en?: string | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean | null;
    confirmed_en?: boolean | null;
    ok?: boolean;
}

export class GetImmaginiPubblicitarieResponse extends OkApiResponse implements IGetImmaginiPubblicitarieResponse {
    immagini?: ImmaginePubblicitaria[] | null;

    constructor(data?: IGetImmaginiPubblicitarieResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["immagini"])) {
                this.immagini = [] as any;
                for (let item of _data["immagini"])
                    this.immagini!.push(ImmaginePubblicitaria.fromJS(item));
            }
            else {
                this.immagini = null as any;
            }
        }
    }

    static override fromJS(data: any): GetImmaginiPubblicitarieResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetImmaginiPubblicitarieResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.immagini)) {
            data["immagini"] = [];
            for (let item of this.immagini)
                data["immagini"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetImmaginiPubblicitarieResponse extends IOkApiResponse {
    immagini?: ImmaginePubblicitaria[] | null;
}

export class ImmaginePubblicitaria implements IImmaginePubblicitaria {
    url?: string | null;
    titolo?: string | null;
    testo?: string | null;

    constructor(data?: IImmaginePubblicitaria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : null as any;
        }
    }

    static fromJS(data: any): ImmaginePubblicitaria {
        data = typeof data === 'object' ? data : {};
        let result = new ImmaginePubblicitaria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url !== undefined ? this.url : null as any;
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        data["testo"] = this.testo !== undefined ? this.testo : null as any;
        return data;
    }
}

export interface IImmaginePubblicitaria {
    url?: string | null;
    titolo?: string | null;
    testo?: string | null;
}

export class GetLuoghiTopResponse extends OkApiResponse implements IGetLuoghiTopResponse {
    luoghiTop?: LuogoTop[] | null;

    constructor(data?: IGetLuoghiTopResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["luoghiTop"])) {
                this.luoghiTop = [] as any;
                for (let item of _data["luoghiTop"])
                    this.luoghiTop!.push(LuogoTop.fromJS(item));
            }
            else {
                this.luoghiTop = null as any;
            }
        }
    }

    static override fromJS(data: any): GetLuoghiTopResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLuoghiTopResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.luoghiTop)) {
            data["luoghiTop"] = [];
            for (let item of this.luoghiTop)
                data["luoghiTop"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetLuoghiTopResponse extends IOkApiResponse {
    luoghiTop?: LuogoTop[] | null;
}

export class LuogoTop implements ILuogoTop {
    id?: number;
    nome?: string | null;
    latitudine?: number;
    longitudine?: number;
    popolarita?: number;

    constructor(data?: ILuogoTop) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.latitudine = _data["latitudine"] !== undefined ? _data["latitudine"] : null as any;
            this.longitudine = _data["longitudine"] !== undefined ? _data["longitudine"] : null as any;
            this.popolarita = _data["popolarita"] !== undefined ? _data["popolarita"] : null as any;
        }
    }

    static fromJS(data: any): LuogoTop {
        data = typeof data === 'object' ? data : {};
        let result = new LuogoTop();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["latitudine"] = this.latitudine !== undefined ? this.latitudine : null as any;
        data["longitudine"] = this.longitudine !== undefined ? this.longitudine : null as any;
        data["popolarita"] = this.popolarita !== undefined ? this.popolarita : null as any;
        return data;
    }
}

export interface ILuogoTop {
    id?: number;
    nome?: string | null;
    latitudine?: number;
    longitudine?: number;
    popolarita?: number;
}

export class GetMediaLabelsResponse extends OkApiResponse implements IGetMediaLabelsResponse {
    mediaLabels?: MediaLabel[] | null;

    constructor(data?: IGetMediaLabelsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["mediaLabels"])) {
                this.mediaLabels = [] as any;
                for (let item of _data["mediaLabels"])
                    this.mediaLabels!.push(MediaLabel.fromJS(item));
            }
            else {
                this.mediaLabels = null as any;
            }
        }
    }

    static override fromJS(data: any): GetMediaLabelsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMediaLabelsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mediaLabels)) {
            data["mediaLabels"] = [];
            for (let item of this.mediaLabels)
                data["mediaLabels"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetMediaLabelsResponse extends IOkApiResponse {
    mediaLabels?: MediaLabel[] | null;
}

export class MediaLabel implements IMediaLabel {
    id?: number;
    name?: string | null;
    updatedAt?: string;
    deleted?: boolean;

    constructor(data?: IMediaLabel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : null as any;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : null as any;
        }
    }

    static fromJS(data: any): MediaLabel {
        data = typeof data === 'object' ? data : {};
        let result = new MediaLabel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : null as any;
        data["deleted"] = this.deleted !== undefined ? this.deleted : null as any;
        return data;
    }
}

export interface IMediaLabel {
    id?: number;
    name?: string | null;
    updatedAt?: string;
    deleted?: boolean;
}

export class GetArticleHeadsResponse extends OkApiResponse implements IGetArticleHeadsResponse {
    intestazioni?: ArticoloTestataRow[];

    constructor(data?: IGetArticleHeadsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["intestazioni"])) {
                this.intestazioni = [] as any;
                for (let item of _data["intestazioni"])
                    this.intestazioni!.push(ArticoloTestataRow.fromJS(item));
            }
            else {
                this.intestazioni = null as any;
            }
        }
    }

    static override fromJS(data: any): GetArticleHeadsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetArticleHeadsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.intestazioni)) {
            data["intestazioni"] = [];
            for (let item of this.intestazioni)
                data["intestazioni"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetArticleHeadsResponse extends IOkApiResponse {
    intestazioni?: ArticoloTestataRow[];
}

/** Rappresenta sul frontent una testa articolo con id e nome tradotto */
export class ArticoloTestataRow implements IArticoloTestataRow {
    /** ID dell'intestazione articolo */
    articoloTestataID?: number;
    /** Nome nella lingua richiesta */
    nome?: string;

    constructor(data?: IArticoloTestataRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articoloTestataID = _data["articoloTestataID"] !== undefined ? _data["articoloTestataID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
        }
    }

    static fromJS(data: any): ArticoloTestataRow {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloTestataRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articoloTestataID"] = this.articoloTestataID !== undefined ? this.articoloTestataID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        return data;
    }
}

/** Rappresenta sul frontent una testa articolo con id e nome tradotto */
export interface IArticoloTestataRow {
    /** ID dell'intestazione articolo */
    articoloTestataID?: number;
    /** Nome nella lingua richiesta */
    nome?: string;
}

export class GetContactCategoriesResponse extends OkApiResponse implements IGetContactCategoriesResponse {
    /** Lista delle categorie contatto */
    categories?: ContactCategory[];

    constructor(data?: IGetContactCategoriesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(ContactCategory.fromJS(item));
            }
            else {
                this.categories = null as any;
            }
        }
    }

    static override fromJS(data: any): GetContactCategoriesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetContactCategoriesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetContactCategoriesResponse extends IOkApiResponse {
    /** Lista delle categorie contatto */
    categories?: ContactCategory[];
}

export class ContactCategory implements IContactCategory {
    /** ID della categoria */
    id?: number;
    /** Nome della categoria */
    name?: string;

    constructor(data?: IContactCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): ContactCategory {
        data = typeof data === 'object' ? data : {};
        let result = new ContactCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export interface IContactCategory {
    /** ID della categoria */
    id?: number;
    /** Nome della categoria */
    name?: string;
}

export class GetContattoTipiDatoResponse extends OkApiResponse implements IGetContattoTipiDatoResponse {
    contattoTipiDato?: ContattoTipoDatoRow[] | null;

    constructor(data?: IGetContattoTipiDatoResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["contattoTipiDato"])) {
                this.contattoTipiDato = [] as any;
                for (let item of _data["contattoTipiDato"])
                    this.contattoTipiDato!.push(ContattoTipoDatoRow.fromJS(item));
            }
            else {
                this.contattoTipiDato = null as any;
            }
        }
    }

    static override fromJS(data: any): GetContattoTipiDatoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetContattoTipiDatoResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contattoTipiDato)) {
            data["contattoTipiDato"] = [];
            for (let item of this.contattoTipiDato)
                data["contattoTipiDato"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetContattoTipiDatoResponse extends IOkApiResponse {
    contattoTipiDato?: ContattoTipoDatoRow[] | null;
}

export class ContattoTipoDatoRow implements IContattoTipoDatoRow {
    id?: number;
    nome?: string | null;

    constructor(data?: IContattoTipoDatoRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
        }
    }

    static fromJS(data: any): ContattoTipoDatoRow {
        data = typeof data === 'object' ? data : {};
        let result = new ContattoTipoDatoRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        return data;
    }
}

export interface IContattoTipoDatoRow {
    id?: number;
    nome?: string | null;
}

export class GetDatiAggiuntiviServiziResponse extends OkApiResponse implements IGetDatiAggiuntiviServiziResponse {
    tipiDatoAggiuntivo?: DatoAggiuntivoTipoRow[];

    constructor(data?: IGetDatiAggiuntiviServiziResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tipiDatoAggiuntivo"])) {
                this.tipiDatoAggiuntivo = [] as any;
                for (let item of _data["tipiDatoAggiuntivo"])
                    this.tipiDatoAggiuntivo!.push(DatoAggiuntivoTipoRow.fromJS(item));
            }
            else {
                this.tipiDatoAggiuntivo = null as any;
            }
        }
    }

    static override fromJS(data: any): GetDatiAggiuntiviServiziResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDatiAggiuntiviServiziResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tipiDatoAggiuntivo)) {
            data["tipiDatoAggiuntivo"] = [];
            for (let item of this.tipiDatoAggiuntivo)
                data["tipiDatoAggiuntivo"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetDatiAggiuntiviServiziResponse extends IOkApiResponse {
    tipiDatoAggiuntivo?: DatoAggiuntivoTipoRow[];
}

export class DatoAggiuntivoTipoRow implements IDatoAggiuntivoTipoRow {
    /** ID del tipo di dato */
    id?: number;
    /** Se valorizzato il tipo di dato va ristretto al tipo servizio */
    tipoServizio?: ETipoServizio | null;
    /** Nome localizzato del tipo di dato aggiuntivo */
    nome?: string;
    dati?: DatoAggiuntivoServizioRow[];

    constructor(data?: IDatoAggiuntivoTipoRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            if (Array.isArray(_data["dati"])) {
                this.dati = [] as any;
                for (let item of _data["dati"])
                    this.dati!.push(DatoAggiuntivoServizioRow.fromJS(item));
            }
            else {
                this.dati = null as any;
            }
        }
    }

    static fromJS(data: any): DatoAggiuntivoTipoRow {
        data = typeof data === 'object' ? data : {};
        let result = new DatoAggiuntivoTipoRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        if (Array.isArray(this.dati)) {
            data["dati"] = [];
            for (let item of this.dati)
                data["dati"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IDatoAggiuntivoTipoRow {
    /** ID del tipo di dato */
    id?: number;
    /** Se valorizzato il tipo di dato va ristretto al tipo servizio */
    tipoServizio?: ETipoServizio | null;
    /** Nome localizzato del tipo di dato aggiuntivo */
    nome?: string;
    dati?: DatoAggiuntivoServizioRow[];
}

export class DatoAggiuntivoServizioRow implements IDatoAggiuntivoServizioRow {
    /** ID del dato */
    id?: number;
    /** Nome localizzato */
    nome?: string;
    /** Se usato vale solo nel luogo indicato */
    luogoID?: number | null;
    /** Se usato vale solo per il tipo di servizio indicato */
    tipoServizio?: ETipoServizio | null;
    /** Se true l'attributo accetta una variabile stringa */
    variabili?: boolean;
    /** Se true l'attributo è limitabile nel tempo */
    temporizzato?: boolean;

    constructor(data?: IDatoAggiuntivoServizioRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
            this.variabili = _data["variabili"] !== undefined ? _data["variabili"] : null as any;
            this.temporizzato = _data["temporizzato"] !== undefined ? _data["temporizzato"] : null as any;
        }
    }

    static fromJS(data: any): DatoAggiuntivoServizioRow {
        data = typeof data === 'object' ? data : {};
        let result = new DatoAggiuntivoServizioRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        data["variabili"] = this.variabili !== undefined ? this.variabili : null as any;
        data["temporizzato"] = this.temporizzato !== undefined ? this.temporizzato : null as any;
        return data;
    }
}

export interface IDatoAggiuntivoServizioRow {
    /** ID del dato */
    id?: number;
    /** Nome localizzato */
    nome?: string;
    /** Se usato vale solo nel luogo indicato */
    luogoID?: number | null;
    /** Se usato vale solo per il tipo di servizio indicato */
    tipoServizio?: ETipoServizio | null;
    /** Se true l'attributo accetta una variabile stringa */
    variabili?: boolean;
    /** Se true l'attributo è limitabile nel tempo */
    temporizzato?: boolean;
}

export class GetDocumentTypesResponse extends OkApiResponse implements IGetDocumentTypesResponse {
    documentTypes?: { [key in keyof typeof ETipoDocumento]?: DocumentType; };

    constructor(data?: IGetDocumentTypesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["documentTypes"]) {
                this.documentTypes = {} as any;
                for (let key in _data["documentTypes"]) {
                    if (_data["documentTypes"].hasOwnProperty(key))
                        (this.documentTypes as any)![key] = _data["documentTypes"][key] ? DocumentType.fromJS(_data["documentTypes"][key]) : new DocumentType();
                }
            }
            else {
                this.documentTypes = null as any;
            }
        }
    }

    static override fromJS(data: any): GetDocumentTypesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentTypesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.documentTypes) {
            data["documentTypes"] = {};
            for (let key in this.documentTypes) {
                if (this.documentTypes.hasOwnProperty(key))
                    (data["documentTypes"] as any)[key] = this.documentTypes[key] ? this.documentTypes[key].toJSON() : null as any;
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetDocumentTypesResponse extends IOkApiResponse {
    documentTypes?: { [key in keyof typeof ETipoDocumento]?: DocumentType; };
}

export class DocumentType implements IDocumentType {
    /** Tipo */
    tipoDocumento?: ETipoDocumento;
    /** True se è un documento a frasi da creare con CreateDocumentoFrasi */
    usaFrasi?: boolean;
    /** True se consente di fare la preview */
    consentePreview?: boolean;
    /** Se true il documento è ancora sul NaarPrintServer */
    usaNps?: boolean;

    constructor(data?: IDocumentType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoDocumento = _data["tipoDocumento"] !== undefined ? _data["tipoDocumento"] : null as any;
            this.usaFrasi = _data["usaFrasi"] !== undefined ? _data["usaFrasi"] : null as any;
            this.consentePreview = _data["consentePreview"] !== undefined ? _data["consentePreview"] : null as any;
            this.usaNps = _data["usaNps"] !== undefined ? _data["usaNps"] : null as any;
        }
    }

    static fromJS(data: any): DocumentType {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoDocumento"] = this.tipoDocumento !== undefined ? this.tipoDocumento : null as any;
        data["usaFrasi"] = this.usaFrasi !== undefined ? this.usaFrasi : null as any;
        data["consentePreview"] = this.consentePreview !== undefined ? this.consentePreview : null as any;
        data["usaNps"] = this.usaNps !== undefined ? this.usaNps : null as any;
        return data;
    }
}

export interface IDocumentType {
    /** Tipo */
    tipoDocumento?: ETipoDocumento;
    /** True se è un documento a frasi da creare con CreateDocumentoFrasi */
    usaFrasi?: boolean;
    /** True se consente di fare la preview */
    consentePreview?: boolean;
    /** Se true il documento è ancora sul NaarPrintServer */
    usaNps?: boolean;
}

export class GetExtraDocumentsResponse extends OkApiResponse implements IGetExtraDocumentsResponse {
    extraDocuments?: ExtraDocument[] | null;
    groups?: string[] | null;

    constructor(data?: IGetExtraDocumentsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["extraDocuments"])) {
                this.extraDocuments = [] as any;
                for (let item of _data["extraDocuments"])
                    this.extraDocuments!.push(ExtraDocument.fromJS(item));
            }
            else {
                this.extraDocuments = null as any;
            }
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(item);
            }
            else {
                this.groups = null as any;
            }
        }
    }

    static override fromJS(data: any): GetExtraDocumentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetExtraDocumentsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.extraDocuments)) {
            data["extraDocuments"] = [];
            for (let item of this.extraDocuments)
                data["extraDocuments"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetExtraDocumentsResponse extends IOkApiResponse {
    extraDocuments?: ExtraDocument[] | null;
    groups?: string[] | null;
}

export class ExtraDocument implements IExtraDocument {
    id?: number;
    nome?: string | null;
    ordine?: number;
    pagine?: number;
    gruppo?: string | null;
    default?: boolean;
    luogoID?: number | null;
    tipoDocID?: number;

    constructor(data?: IExtraDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.pagine = _data["pagine"] !== undefined ? _data["pagine"] : null as any;
            this.gruppo = _data["gruppo"] !== undefined ? _data["gruppo"] : null as any;
            this.default = _data["default"] !== undefined ? _data["default"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.tipoDocID = _data["tipoDocID"] !== undefined ? _data["tipoDocID"] : null as any;
        }
    }

    static fromJS(data: any): ExtraDocument {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["pagine"] = this.pagine !== undefined ? this.pagine : null as any;
        data["gruppo"] = this.gruppo !== undefined ? this.gruppo : null as any;
        data["default"] = this.default !== undefined ? this.default : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["tipoDocID"] = this.tipoDocID !== undefined ? this.tipoDocID : null as any;
        return data;
    }
}

export interface IExtraDocument {
    id?: number;
    nome?: string | null;
    ordine?: number;
    pagine?: number;
    gruppo?: string | null;
    default?: boolean;
    luogoID?: number | null;
    tipoDocID?: number;
}

/** Represents the response containing categorized attribute lists for hashcodes, including class, room, view, and feature attributes. */
export class GetHashcodesAttributesResponse extends OkApiResponse implements IGetHashcodesAttributesResponse {
    /** Class attributes */
    classAttributes?: HHAttrituteItem[] | null;
    /** Room attributes */
    roomAttributes?: HHAttrituteItem[] | null;
    /** View attributes */
    viewAttributes?: HHAttrituteItem[] | null;
    /** Feature attributes */
    featureAttributes?: HHAttrituteItem[] | null;

    constructor(data?: IGetHashcodesAttributesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["classAttributes"])) {
                this.classAttributes = [] as any;
                for (let item of _data["classAttributes"])
                    this.classAttributes!.push(HHAttrituteItem.fromJS(item));
            }
            else {
                this.classAttributes = null as any;
            }
            if (Array.isArray(_data["roomAttributes"])) {
                this.roomAttributes = [] as any;
                for (let item of _data["roomAttributes"])
                    this.roomAttributes!.push(HHAttrituteItem.fromJS(item));
            }
            else {
                this.roomAttributes = null as any;
            }
            if (Array.isArray(_data["viewAttributes"])) {
                this.viewAttributes = [] as any;
                for (let item of _data["viewAttributes"])
                    this.viewAttributes!.push(HHAttrituteItem.fromJS(item));
            }
            else {
                this.viewAttributes = null as any;
            }
            if (Array.isArray(_data["featureAttributes"])) {
                this.featureAttributes = [] as any;
                for (let item of _data["featureAttributes"])
                    this.featureAttributes!.push(HHAttrituteItem.fromJS(item));
            }
            else {
                this.featureAttributes = null as any;
            }
        }
    }

    static override fromJS(data: any): GetHashcodesAttributesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetHashcodesAttributesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.classAttributes)) {
            data["classAttributes"] = [];
            for (let item of this.classAttributes)
                data["classAttributes"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.roomAttributes)) {
            data["roomAttributes"] = [];
            for (let item of this.roomAttributes)
                data["roomAttributes"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.viewAttributes)) {
            data["viewAttributes"] = [];
            for (let item of this.viewAttributes)
                data["viewAttributes"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.featureAttributes)) {
            data["featureAttributes"] = [];
            for (let item of this.featureAttributes)
                data["featureAttributes"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Represents the response containing categorized attribute lists for hashcodes, including class, room, view, and feature attributes. */
export interface IGetHashcodesAttributesResponse extends IOkApiResponse {
    /** Class attributes */
    classAttributes?: HHAttrituteItem[] | null;
    /** Room attributes */
    roomAttributes?: HHAttrituteItem[] | null;
    /** View attributes */
    viewAttributes?: HHAttrituteItem[] | null;
    /** Feature attributes */
    featureAttributes?: HHAttrituteItem[] | null;
}

/** Short info about an H2H attribute */
export class HHAttrituteItem implements IHHAttrituteItem {
    /** Attribute unique ID */
    id?: number;
    /** Attribute description (english) */
    description?: string | null;

    constructor(data?: IHHAttrituteItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
        }
    }

    static fromJS(data: any): HHAttrituteItem {
        data = typeof data === 'object' ? data : {};
        let result = new HHAttrituteItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        return data;
    }
}

/** Short info about an H2H attribute */
export interface IHHAttrituteItem {
    /** Attribute unique ID */
    id?: number;
    /** Attribute description (english) */
    description?: string | null;
}

export class GetMiniguideResponse extends OkApiResponse implements IGetMiniguideResponse {
    miniguide?: MiniguidaHeader[];

    constructor(data?: IGetMiniguideResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["miniguide"])) {
                this.miniguide = [] as any;
                for (let item of _data["miniguide"])
                    this.miniguide!.push(MiniguidaHeader.fromJS(item));
            }
            else {
                this.miniguide = null as any;
            }
        }
    }

    static override fromJS(data: any): GetMiniguideResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMiniguideResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.miniguide)) {
            data["miniguide"] = [];
            for (let item of this.miniguide)
                data["miniguide"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetMiniguideResponse extends IOkApiResponse {
    miniguide?: MiniguidaHeader[];
}

export class MiniguidaHeader implements IMiniguidaHeader {
    id?: number;
    luogoID?: number;
    titolo?: string | null;
    ordine?: number;
    lingua?: ELingua;
    selected?: boolean;
    paeseID?: number;
    paese?: string | null;

    constructor(data?: IMiniguidaHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : null as any;
            this.selected = _data["selected"] !== undefined ? _data["selected"] : null as any;
            this.paeseID = _data["paeseID"] !== undefined ? _data["paeseID"] : null as any;
            this.paese = _data["paese"] !== undefined ? _data["paese"] : null as any;
        }
    }

    static fromJS(data: any): MiniguidaHeader {
        data = typeof data === 'object' ? data : {};
        let result = new MiniguidaHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["lingua"] = this.lingua !== undefined ? this.lingua : null as any;
        data["selected"] = this.selected !== undefined ? this.selected : null as any;
        data["paeseID"] = this.paeseID !== undefined ? this.paeseID : null as any;
        data["paese"] = this.paese !== undefined ? this.paese : null as any;
        return data;
    }
}

export interface IMiniguidaHeader {
    id?: number;
    luogoID?: number;
    titolo?: string | null;
    ordine?: number;
    lingua?: ELingua;
    selected?: boolean;
    paeseID?: number;
    paese?: string | null;
}

export class MiniguideRequest extends LocalizedRequest implements IMiniguideRequest {
    /** ID dell'offerta da cui estrarre i luoghi */
    offertaId!: number;

    constructor(data?: IMiniguideRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaId = _data["offertaId"] !== undefined ? _data["offertaId"] : null as any;
        }
    }

    static override fromJS(data: any): MiniguideRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MiniguideRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaId"] = this.offertaId !== undefined ? this.offertaId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IMiniguideRequest extends ILocalizedRequest {
    /** ID dell'offerta da cui estrarre i luoghi */
    offertaId: number;
}

export class GetOperatorsResponse extends OkApiResponse implements IGetOperatorsResponse {
    /** Lista degli operatori */
    operators?: OperatorData[];

    constructor(data?: IGetOperatorsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["operators"])) {
                this.operators = [] as any;
                for (let item of _data["operators"])
                    this.operators!.push(OperatorData.fromJS(item));
            }
            else {
                this.operators = null as any;
            }
        }
    }

    static override fromJS(data: any): GetOperatorsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOperatorsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.operators)) {
            data["operators"] = [];
            for (let item of this.operators)
                data["operators"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetOperatorsResponse extends IOkApiResponse {
    /** Lista degli operatori */
    operators?: OperatorData[];
}

export class OperatorData implements IOperatorData {
    /** ID dell'operatore */
    id?: number;
    /** Nome dell'operatore */
    name?: string;
    /** Enum dell'operatore */
    operatore?: EOperatore;
    /** Lingue supportate dall'operatore */
    lingue?: ELingua[];
    /** Lingua di default */
    linguaDiDefault?: ELingua;
    /** Se l'operatore è visibile */
    visible?: boolean;
    /** Currency ID associated with the operator.
Maps to ValutaID. */
    valutaID?: number | null;
    /** ISO currency code (e.g. "EUR", "CHF") for the operator. */
    codiceValuta?: string | null;
    advHomeConf?: ActionBoxConfig[] | null;

    constructor(data?: IOperatorData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            if (Array.isArray(_data["lingue"])) {
                this.lingue = [] as any;
                for (let item of _data["lingue"])
                    this.lingue!.push(item);
            }
            else {
                this.lingue = null as any;
            }
            this.linguaDiDefault = _data["linguaDiDefault"] !== undefined ? _data["linguaDiDefault"] : null as any;
            this.visible = _data["visible"] !== undefined ? _data["visible"] : null as any;
            this.valutaID = _data["valutaID"] !== undefined ? _data["valutaID"] : null as any;
            this.codiceValuta = _data["codiceValuta"] !== undefined ? _data["codiceValuta"] : null as any;
            if (Array.isArray(_data["advHomeConf"])) {
                this.advHomeConf = [] as any;
                for (let item of _data["advHomeConf"])
                    this.advHomeConf!.push(ActionBoxConfig.fromJS(item));
            }
            else {
                this.advHomeConf = null as any;
            }
        }
    }

    static fromJS(data: any): OperatorData {
        data = typeof data === 'object' ? data : {};
        let result = new OperatorData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        if (Array.isArray(this.lingue)) {
            data["lingue"] = [];
            for (let item of this.lingue)
                data["lingue"].push(item);
        }
        data["linguaDiDefault"] = this.linguaDiDefault !== undefined ? this.linguaDiDefault : null as any;
        data["visible"] = this.visible !== undefined ? this.visible : null as any;
        data["valutaID"] = this.valutaID !== undefined ? this.valutaID : null as any;
        data["codiceValuta"] = this.codiceValuta !== undefined ? this.codiceValuta : null as any;
        if (Array.isArray(this.advHomeConf)) {
            data["advHomeConf"] = [];
            for (let item of this.advHomeConf)
                data["advHomeConf"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IOperatorData {
    /** ID dell'operatore */
    id?: number;
    /** Nome dell'operatore */
    name?: string;
    /** Enum dell'operatore */
    operatore?: EOperatore;
    /** Lingue supportate dall'operatore */
    lingue?: ELingua[];
    /** Lingua di default */
    linguaDiDefault?: ELingua;
    /** Se l'operatore è visibile */
    visible?: boolean;
    /** Currency ID associated with the operator.
Maps to ValutaID. */
    valutaID?: number | null;
    /** ISO currency code (e.g. "EUR", "CHF") for the operator. */
    codiceValuta?: string | null;
    advHomeConf?: ActionBoxConfig[] | null;
}

export class ActionBoxConfig implements IActionBoxConfig {
    type?: EActionBoxType;
    orientation?: EActionBoxOrientation;
    showImage?: boolean;

    constructor(data?: IActionBoxConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.orientation = _data["orientation"] !== undefined ? _data["orientation"] : null as any;
            this.showImage = _data["showImage"] !== undefined ? _data["showImage"] : null as any;
        }
    }

    static fromJS(data: any): ActionBoxConfig {
        data = typeof data === 'object' ? data : {};
        let result = new ActionBoxConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["orientation"] = this.orientation !== undefined ? this.orientation : null as any;
        data["showImage"] = this.showImage !== undefined ? this.showImage : null as any;
        return data;
    }
}

export interface IActionBoxConfig {
    type?: EActionBoxType;
    orientation?: EActionBoxOrientation;
    showImage?: boolean;
}

export enum EActionBoxType {
    CreaInLiberta = "CreaInLiberta",
    FlyBeach = "FlyBeach",
    FlyCity = "FlyCity",
    FlyCruise = "FlyCruise",
    FlyTour = "FlyTour",
    ItinConsigliati = "ItinConsigliati",
    RicercaViaggi = "RicercaViaggi",
    RichiestaPreventivo = "RichiestaPreventivo",
    Separator = "Separator",
    TourGuidati = "TourGuidati",
    Packages = "Packages",
    Help = "Help",
}

export enum EActionBoxOrientation {
    Vertical = "Vertical",
    Horizontal = "Horizontal",
    VerticalTiny = "VerticalTiny",
    HorizontalTiny = "HorizontalTiny",
}

export class GetOrdersTagsResponse extends OkApiResponse implements IGetOrdersTagsResponse {
    tags?: OrderTagData[] | null;

    constructor(data?: IGetOrdersTagsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(OrderTagData.fromJS(item));
            }
            else {
                this.tags = null as any;
            }
        }
    }

    static override fromJS(data: any): GetOrdersTagsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrdersTagsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetOrdersTagsResponse extends IOkApiResponse {
    tags?: OrderTagData[] | null;
}

/** Rappresentazione di un Tag offerta, per uso lista generica/visualizzazione */
export class OrderTagData implements IOrderTagData {
    /** ID del tag */
    id?: number;
    /** Nome visualizzato del tag */
    tag?: string | null;
    /** JSON Opzioni UI */
    uiOptions?: string | null;

    constructor(data?: IOrderTagData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.tag = _data["tag"] !== undefined ? _data["tag"] : null as any;
            this.uiOptions = _data["uiOptions"] !== undefined ? _data["uiOptions"] : null as any;
        }
    }

    static fromJS(data: any): OrderTagData {
        data = typeof data === 'object' ? data : {};
        let result = new OrderTagData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["tag"] = this.tag !== undefined ? this.tag : null as any;
        data["uiOptions"] = this.uiOptions !== undefined ? this.uiOptions : null as any;
        return data;
    }
}

/** Rappresentazione di un Tag offerta, per uso lista generica/visualizzazione */
export interface IOrderTagData {
    /** ID del tag */
    id?: number;
    /** Nome visualizzato del tag */
    tag?: string | null;
    /** JSON Opzioni UI */
    uiOptions?: string | null;
}

export class GetPageLinksResponse extends OkApiResponse implements IGetPageLinksResponse {
    menuLinks?: SitePageLink[] | null;
    bannerLinks?: SitePageLink[] | null;
    newsLinks?: SitePageLink[] | null;

    constructor(data?: IGetPageLinksResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["menuLinks"])) {
                this.menuLinks = [] as any;
                for (let item of _data["menuLinks"])
                    this.menuLinks!.push(SitePageLink.fromJS(item));
            }
            else {
                this.menuLinks = null as any;
            }
            if (Array.isArray(_data["bannerLinks"])) {
                this.bannerLinks = [] as any;
                for (let item of _data["bannerLinks"])
                    this.bannerLinks!.push(SitePageLink.fromJS(item));
            }
            else {
                this.bannerLinks = null as any;
            }
            if (Array.isArray(_data["newsLinks"])) {
                this.newsLinks = [] as any;
                for (let item of _data["newsLinks"])
                    this.newsLinks!.push(SitePageLink.fromJS(item));
            }
            else {
                this.newsLinks = null as any;
            }
        }
    }

    static override fromJS(data: any): GetPageLinksResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageLinksResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.menuLinks)) {
            data["menuLinks"] = [];
            for (let item of this.menuLinks)
                data["menuLinks"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.bannerLinks)) {
            data["bannerLinks"] = [];
            for (let item of this.bannerLinks)
                data["bannerLinks"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.newsLinks)) {
            data["newsLinks"] = [];
            for (let item of this.newsLinks)
                data["newsLinks"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPageLinksResponse extends IOkApiResponse {
    menuLinks?: SitePageLink[] | null;
    bannerLinks?: SitePageLink[] | null;
    newsLinks?: SitePageLink[] | null;
}

export class SitePageLink implements ISitePageLink {
    nome?: string | null;
    tipo?: ETipoLink;
    url?: string | null;
    routerLink?: any[] | null;
    icona?: string | null;
    articoli?: PageArticle[] | null;
    collapseFlag?: boolean;

    constructor(data?: ISitePageLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
            if (Array.isArray(_data["routerLink"])) {
                this.routerLink = [] as any;
                for (let item of _data["routerLink"])
                    this.routerLink!.push(item);
            }
            else {
                this.routerLink = null as any;
            }
            this.icona = _data["icona"] !== undefined ? _data["icona"] : null as any;
            if (Array.isArray(_data["articoli"])) {
                this.articoli = [] as any;
                for (let item of _data["articoli"])
                    this.articoli!.push(PageArticle.fromJS(item));
            }
            else {
                this.articoli = null as any;
            }
            this.collapseFlag = _data["collapseFlag"] !== undefined ? _data["collapseFlag"] : null as any;
        }
    }

    static fromJS(data: any): SitePageLink {
        data = typeof data === 'object' ? data : {};
        let result = new SitePageLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        if (Array.isArray(this.routerLink)) {
            data["routerLink"] = [];
            for (let item of this.routerLink)
                data["routerLink"].push(item);
        }
        data["icona"] = this.icona !== undefined ? this.icona : null as any;
        if (Array.isArray(this.articoli)) {
            data["articoli"] = [];
            for (let item of this.articoli)
                data["articoli"].push(item ? item.toJSON() : null as any);
        }
        data["collapseFlag"] = this.collapseFlag !== undefined ? this.collapseFlag : null as any;
        return data;
    }
}

export interface ISitePageLink {
    nome?: string | null;
    tipo?: ETipoLink;
    url?: string | null;
    routerLink?: any[] | null;
    icona?: string | null;
    articoli?: PageArticle[] | null;
    collapseFlag?: boolean;
}

export class PageArticle implements IPageArticle {
    id?: number;
    titolo?: string | null;
    icona?: string | null;

    constructor(data?: IPageArticle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            this.icona = _data["icona"] !== undefined ? _data["icona"] : null as any;
        }
    }

    static fromJS(data: any): PageArticle {
        data = typeof data === 'object' ? data : {};
        let result = new PageArticle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        data["icona"] = this.icona !== undefined ? this.icona : null as any;
        return data;
    }
}

export interface IPageArticle {
    id?: number;
    titolo?: string | null;
    icona?: string | null;
}

export class GetPageLinksRequest extends SiteRequest implements IGetPageLinksRequest {
    luogoPaginaID?: number;

    constructor(data?: IGetPageLinksRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogoPaginaID = _data["luogoPaginaID"] !== undefined ? _data["luogoPaginaID"] : null as any;
        }
    }

    static override fromJS(data: any): GetPageLinksRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageLinksRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoPaginaID"] = this.luogoPaginaID !== undefined ? this.luogoPaginaID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPageLinksRequest extends ISiteRequest {
    luogoPaginaID?: number;
}

export class GetPermissionsResponse extends OkApiResponse implements IGetPermissionsResponse {
    /** Categorie di permessi (e relativi permessi) */
    categories?: PermissionCategoryData[];
    /** Elenco "flat" dei permessi */
    permissions?: PermissionData[];

    constructor(data?: IGetPermissionsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(PermissionCategoryData.fromJS(item));
            }
            else {
                this.categories = null as any;
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(PermissionData.fromJS(item));
            }
            else {
                this.permissions = null as any;
            }
        }
    }

    static override fromJS(data: any): GetPermissionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPermissionsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPermissionsResponse extends IOkApiResponse {
    /** Categorie di permessi (e relativi permessi) */
    categories?: PermissionCategoryData[];
    /** Elenco "flat" dei permessi */
    permissions?: PermissionData[];
}

export class PermissionCategoryData implements IPermissionCategoryData {
    /** ID della categoria */
    id?: number;
    /** Nome della categoria */
    name?: string;
    /** Lista dei permessi di questa categoria */
    permissions?: PermissionData[];

    constructor(data?: IPermissionCategoryData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(PermissionData.fromJS(item));
            }
            else {
                this.permissions = null as any;
            }
        }
    }

    static fromJS(data: any): PermissionCategoryData {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionCategoryData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPermissionCategoryData {
    /** ID della categoria */
    id?: number;
    /** Nome della categoria */
    name?: string;
    /** Lista dei permessi di questa categoria */
    permissions?: PermissionData[];
}

export class PermissionData implements IPermissionData {
    /** ID del permesso */
    id?: number;
    /** Codice alfanumerico del permesso */
    code?: string;
    /** Descrizione del permesso */
    description?: string;

    constructor(data?: IPermissionData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
        }
    }

    static fromJS(data: any): PermissionData {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        return data;
    }
}

export interface IPermissionData {
    /** ID del permesso */
    id?: number;
    /** Codice alfanumerico del permesso */
    code?: string;
    /** Descrizione del permesso */
    description?: string;
}

export class GetPhraseTagsResponse extends OkApiResponse implements IGetPhraseTagsResponse {
    tags?: TagView[];

    constructor(data?: IGetPhraseTagsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagView.fromJS(item));
            }
            else {
                this.tags = null as any;
            }
        }
    }

    static override fromJS(data: any): GetPhraseTagsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPhraseTagsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPhraseTagsResponse extends IOkApiResponse {
    tags?: TagView[];
}

export class TagView implements ITagView {
    id?: number;
    /** Nome localizzato del tag */
    tag?: string;
    /** True se è un tag di sistema */
    isSystem?: boolean;
    /** Codice del tag */
    code?: string | null;
    /** Opzioni UI (colore e sfondo) */
    uiOptions?: string | null;
    /** Numero di frasi associate */
    usageCount?: number;

    constructor(data?: ITagView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.tag = _data["tag"] !== undefined ? _data["tag"] : null as any;
            this.isSystem = _data["isSystem"] !== undefined ? _data["isSystem"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.uiOptions = _data["uiOptions"] !== undefined ? _data["uiOptions"] : null as any;
            this.usageCount = _data["usageCount"] !== undefined ? _data["usageCount"] : null as any;
        }
    }

    static fromJS(data: any): TagView {
        data = typeof data === 'object' ? data : {};
        let result = new TagView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["tag"] = this.tag !== undefined ? this.tag : null as any;
        data["isSystem"] = this.isSystem !== undefined ? this.isSystem : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["uiOptions"] = this.uiOptions !== undefined ? this.uiOptions : null as any;
        data["usageCount"] = this.usageCount !== undefined ? this.usageCount : null as any;
        return data;
    }
}

export interface ITagView {
    id?: number;
    /** Nome localizzato del tag */
    tag?: string;
    /** True se è un tag di sistema */
    isSystem?: boolean;
    /** Codice del tag */
    code?: string | null;
    /** Opzioni UI (colore e sfondo) */
    uiOptions?: string | null;
    /** Numero di frasi associate */
    usageCount?: number;
}

export class GetPoliciesListResponse extends OkApiResponse implements IGetPoliciesListResponse {
    penali?: PenaleRow[] | null;

    constructor(data?: IGetPoliciesListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["penali"])) {
                this.penali = [] as any;
                for (let item of _data["penali"])
                    this.penali!.push(PenaleRow.fromJS(item));
            }
            else {
                this.penali = null as any;
            }
        }
    }

    static override fromJS(data: any): GetPoliciesListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPoliciesListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.penali)) {
            data["penali"] = [];
            for (let item of this.penali)
                data["penali"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPoliciesListResponse extends IOkApiResponse {
    penali?: PenaleRow[] | null;
}

export class PenaleRow implements IPenaleRow {
    id?: number;
    nome?: string | null;
    cfgDataLimite?: EConfigurazioneParametro;
    cfgImporto?: EConfigurazioneParametro;
    utilizzabileSuRegolaVendita?: boolean;

    constructor(data?: IPenaleRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.cfgDataLimite = _data["cfgDataLimite"] !== undefined ? _data["cfgDataLimite"] : null as any;
            this.cfgImporto = _data["cfgImporto"] !== undefined ? _data["cfgImporto"] : null as any;
            this.utilizzabileSuRegolaVendita = _data["utilizzabileSuRegolaVendita"] !== undefined ? _data["utilizzabileSuRegolaVendita"] : null as any;
        }
    }

    static fromJS(data: any): PenaleRow {
        data = typeof data === 'object' ? data : {};
        let result = new PenaleRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["cfgDataLimite"] = this.cfgDataLimite !== undefined ? this.cfgDataLimite : null as any;
        data["cfgImporto"] = this.cfgImporto !== undefined ? this.cfgImporto : null as any;
        data["utilizzabileSuRegolaVendita"] = this.utilizzabileSuRegolaVendita !== undefined ? this.utilizzabileSuRegolaVendita : null as any;
        return data;
    }
}

export interface IPenaleRow {
    id?: number;
    nome?: string | null;
    cfgDataLimite?: EConfigurazioneParametro;
    cfgImporto?: EConfigurazioneParametro;
    utilizzabileSuRegolaVendita?: boolean;
}

export enum EConfigurazioneParametro {
    NonUsato = "NonUsato",
    SolaLettura = "SolaLettura",
    Modificabile = "Modificabile",
}

export class GetPricingResponse extends OkApiResponse implements IGetPricingResponse {
    pricings?: PricingItem[];

    constructor(data?: IGetPricingResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["pricings"])) {
                this.pricings = [] as any;
                for (let item of _data["pricings"])
                    this.pricings!.push(PricingItem.fromJS(item));
            }
            else {
                this.pricings = null as any;
            }
        }
    }

    static override fromJS(data: any): GetPricingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPricingResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pricings)) {
            data["pricings"] = [];
            for (let item of this.pricings)
                data["pricings"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPricingResponse extends IOkApiResponse {
    pricings?: PricingItem[];
}

export class PricingItem implements IPricingItem {
    pricing?: Pricing;
    tourOperator?: string;

    constructor(data?: IPricingItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pricing = _data["pricing"] ? Pricing.fromJS(_data["pricing"]) : null as any;
            this.tourOperator = _data["tourOperator"] !== undefined ? _data["tourOperator"] : null as any;
        }
    }

    static fromJS(data: any): PricingItem {
        data = typeof data === 'object' ? data : {};
        let result = new PricingItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pricing"] = this.pricing ? this.pricing.toJSON() : null as any;
        data["tourOperator"] = this.tourOperator !== undefined ? this.tourOperator : null as any;
        return data;
    }
}

export interface IPricingItem {
    pricing?: Pricing;
    tourOperator?: string;
}

export class Pricing implements IPricing {
    id?: number;
    name!: string;
    operator?: EOperatore;

    constructor(data?: IPricing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.operator = _data["operator"] !== undefined ? _data["operator"] : null as any;
        }
    }

    static fromJS(data: any): Pricing {
        data = typeof data === 'object' ? data : {};
        let result = new Pricing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["operator"] = this.operator !== undefined ? this.operator : null as any;
        return data;
    }
}

export interface IPricing {
    id?: number;
    name: string;
    operator?: EOperatore;
}

export class GetRolesResponse extends OkApiResponse implements IGetRolesResponse {
    /** Lista degli ruoli */
    roles?: RoleData[] | null;

    constructor(data?: IGetRolesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(RoleData.fromJS(item));
            }
            else {
                this.roles = null as any;
            }
        }
    }

    static override fromJS(data: any): GetRolesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRolesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetRolesResponse extends IOkApiResponse {
    /** Lista degli ruoli */
    roles?: RoleData[] | null;
}

export class RoleData implements IRoleData {
    /** ID del ruolo */
    id?: number;
    /** Nome del ruolo */
    name?: string | null;

    constructor(data?: IRoleData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): RoleData {
        data = typeof data === 'object' ? data : {};
        let result = new RoleData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export interface IRoleData {
    /** ID del ruolo */
    id?: number;
    /** Nome del ruolo */
    name?: string | null;
}

export class GetServicesOffersTypesResponse extends OkApiResponse implements IGetServicesOffersTypesResponse {
    offersTypes?: ServiceOfferTypeRow[];

    constructor(data?: IGetServicesOffersTypesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["offersTypes"])) {
                this.offersTypes = [] as any;
                for (let item of _data["offersTypes"])
                    this.offersTypes!.push(ServiceOfferTypeRow.fromJS(item));
            }
            else {
                this.offersTypes = null as any;
            }
        }
    }

    static override fromJS(data: any): GetServicesOffersTypesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetServicesOffersTypesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.offersTypes)) {
            data["offersTypes"] = [];
            for (let item of this.offersTypes)
                data["offersTypes"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetServicesOffersTypesResponse extends IOkApiResponse {
    offersTypes?: ServiceOfferTypeRow[];
}

export class ServiceOfferTypeRow implements IServiceOfferTypeRow {
    id?: number;
    name?: string;

    constructor(data?: IServiceOfferTypeRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): ServiceOfferTypeRow {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceOfferTypeRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export interface IServiceOfferTypeRow {
    id?: number;
    name?: string;
}

export class GetSistemazioniResponse extends OkApiResponse implements IGetSistemazioniResponse {
    sistemazioni?: SistemazioneListRow[] | null;

    constructor(data?: IGetSistemazioniResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["sistemazioni"])) {
                this.sistemazioni = [] as any;
                for (let item of _data["sistemazioni"])
                    this.sistemazioni!.push(SistemazioneListRow.fromJS(item));
            }
            else {
                this.sistemazioni = null as any;
            }
        }
    }

    static override fromJS(data: any): GetSistemazioniResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSistemazioniResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sistemazioni)) {
            data["sistemazioni"] = [];
            for (let item of this.sistemazioni)
                data["sistemazioni"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetSistemazioniResponse extends IOkApiResponse {
    sistemazioni?: SistemazioneListRow[] | null;
}

export class SistemazioneListRow implements ISistemazioneListRow {
    /** ID del bedding */
    sistemazioneID?: number;
    /** Nome localizzato */
    nome?: string | null;

    constructor(data?: ISistemazioneListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sistemazioneID = _data["sistemazioneID"] !== undefined ? _data["sistemazioneID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
        }
    }

    static fromJS(data: any): SistemazioneListRow {
        data = typeof data === 'object' ? data : {};
        let result = new SistemazioneListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sistemazioneID"] = this.sistemazioneID !== undefined ? this.sistemazioneID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        return data;
    }
}

export interface ISistemazioneListRow {
    /** ID del bedding */
    sistemazioneID?: number;
    /** Nome localizzato */
    nome?: string | null;
}

export class GetTeamsResponse extends OkApiResponse implements IGetTeamsResponse {
    /** Lista dei team */
    teams?: TeamData[];

    constructor(data?: IGetTeamsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["teams"])) {
                this.teams = [] as any;
                for (let item of _data["teams"])
                    this.teams!.push(TeamData.fromJS(item));
            }
            else {
                this.teams = null as any;
            }
        }
    }

    static override fromJS(data: any): GetTeamsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTeamsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.teams)) {
            data["teams"] = [];
            for (let item of this.teams)
                data["teams"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetTeamsResponse extends IOkApiResponse {
    /** Lista dei team */
    teams?: TeamData[];
}

export class TeamData implements ITeamData {
    /** ID del team */
    id?: string;
    /** ID numerico del team */
    teamID?: number;
    /** Nome del team */
    name?: string;
    /** Visibilità del team */
    visibilita?: EVisibilitaTeam;
    operatore?: EOperatore;

    constructor(data?: ITeamData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.teamID = _data["teamID"] !== undefined ? _data["teamID"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.visibilita = _data["visibilita"] !== undefined ? _data["visibilita"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
        }
    }

    static fromJS(data: any): TeamData {
        data = typeof data === 'object' ? data : {};
        let result = new TeamData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["teamID"] = this.teamID !== undefined ? this.teamID : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["visibilita"] = this.visibilita !== undefined ? this.visibilita : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        return data;
    }
}

export interface ITeamData {
    /** ID del team */
    id?: string;
    /** ID numerico del team */
    teamID?: number;
    /** Nome del team */
    name?: string;
    /** Visibilità del team */
    visibilita?: EVisibilitaTeam;
    operatore?: EOperatore;
}

export enum EVisibilitaTeam {
    NonVisibile = "NonVisibile",
    Privato = "Privato",
    Pubblico = "Pubblico",
    Obsoleto = "Obsoleto",
}

export class GetTipologiaStandardResponse extends OkApiResponse implements IGetTipologiaStandardResponse {
    tipologieStandard?: ServizioTipologiaStandard[] | null;

    constructor(data?: IGetTipologiaStandardResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tipologieStandard"])) {
                this.tipologieStandard = [] as any;
                for (let item of _data["tipologieStandard"])
                    this.tipologieStandard!.push(ServizioTipologiaStandard.fromJS(item));
            }
            else {
                this.tipologieStandard = null as any;
            }
        }
    }

    static override fromJS(data: any): GetTipologiaStandardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTipologiaStandardResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tipologieStandard)) {
            data["tipologieStandard"] = [];
            for (let item of this.tipologieStandard)
                data["tipologieStandard"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetTipologiaStandardResponse extends IOkApiResponse {
    tipologieStandard?: ServizioTipologiaStandard[] | null;
}

export class GetValuteResponse extends OkApiResponse implements IGetValuteResponse {
    valute?: ValutaCorrente[];

    constructor(data?: IGetValuteResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["valute"])) {
                this.valute = [] as any;
                for (let item of _data["valute"])
                    this.valute!.push(ValutaCorrente.fromJS(item));
            }
            else {
                this.valute = null as any;
            }
        }
    }

    static override fromJS(data: any): GetValuteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetValuteResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.valute)) {
            data["valute"] = [];
            for (let item of this.valute)
                data["valute"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetValuteResponse extends IOkApiResponse {
    valute?: ValutaCorrente[];
}

export class ValutaCorrente implements IValutaCorrente {
    /** ID della valuta */
    id?: number;
    /** Nome visualizzato */
    nome?: string;
    /** Codice a tre lettere della valuta */
    codice?: string;
    /** Cambio applicato nelle offerte */
    cambio?: number | null;
    /** Cambio reale da usare nei pagamenti */
    cambioReale?: number | null;

    constructor(data?: IValutaCorrente) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
            this.cambio = _data["cambio"] !== undefined ? _data["cambio"] : null as any;
            this.cambioReale = _data["cambioReale"] !== undefined ? _data["cambioReale"] : null as any;
        }
    }

    static fromJS(data: any): ValutaCorrente {
        data = typeof data === 'object' ? data : {};
        let result = new ValutaCorrente();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        data["cambio"] = this.cambio !== undefined ? this.cambio : null as any;
        data["cambioReale"] = this.cambioReale !== undefined ? this.cambioReale : null as any;
        return data;
    }
}

export interface IValutaCorrente {
    /** ID della valuta */
    id?: number;
    /** Nome visualizzato */
    nome?: string;
    /** Codice a tre lettere della valuta */
    codice?: string;
    /** Cambio applicato nelle offerte */
    cambio?: number | null;
    /** Cambio reale da usare nei pagamenti */
    cambioReale?: number | null;
}

export class NrTableResponseOfEmissioneRow extends OkApiResponse implements INrTableResponseOfEmissioneRow {
    /** Array delle righe della pagina richiesta */
    rows?: EmissioneRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfEmissioneRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(EmissioneRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfEmissioneRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfEmissioneRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfEmissioneRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: EmissioneRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class EmissioneRow implements IEmissioneRow {
    offertaID?: number;
    offertaDatoID?: number;
    partenza?: string;
    contattoAgenziaID?: number;
    operatore?: EOperatore;
    agenzia?: string | null;
    pagamento?: string | null;
    descrizione?: string | null;
    pnr?: string | null;
    pagaSubito?: boolean;
    dataPagamento?: string | null;
    dataPresaInCarico?: string | null;
    dataRichiesta?: string | null;
    dataEmissione?: string | null;
    okContabilita?: boolean;
    emesso?: boolean;
    utenteConferma?: string | null;

    constructor(data?: IEmissioneRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : null as any;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : null as any;
            this.contattoAgenziaID = _data["contattoAgenziaID"] !== undefined ? _data["contattoAgenziaID"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.agenzia = _data["agenzia"] !== undefined ? _data["agenzia"] : null as any;
            this.pagamento = _data["pagamento"] !== undefined ? _data["pagamento"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.pnr = _data["pnr"] !== undefined ? _data["pnr"] : null as any;
            this.pagaSubito = _data["pagaSubito"] !== undefined ? _data["pagaSubito"] : null as any;
            this.dataPagamento = _data["dataPagamento"] !== undefined ? _data["dataPagamento"] : null as any;
            this.dataPresaInCarico = _data["dataPresaInCarico"] !== undefined ? _data["dataPresaInCarico"] : null as any;
            this.dataRichiesta = _data["dataRichiesta"] !== undefined ? _data["dataRichiesta"] : null as any;
            this.dataEmissione = _data["dataEmissione"] !== undefined ? _data["dataEmissione"] : null as any;
            this.okContabilita = _data["okContabilita"] !== undefined ? _data["okContabilita"] : null as any;
            this.emesso = _data["emesso"] !== undefined ? _data["emesso"] : null as any;
            this.utenteConferma = _data["utenteConferma"] !== undefined ? _data["utenteConferma"] : null as any;
        }
    }

    static fromJS(data: any): EmissioneRow {
        data = typeof data === 'object' ? data : {};
        let result = new EmissioneRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : null as any;
        data["partenza"] = this.partenza !== undefined ? this.partenza : null as any;
        data["contattoAgenziaID"] = this.contattoAgenziaID !== undefined ? this.contattoAgenziaID : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["agenzia"] = this.agenzia !== undefined ? this.agenzia : null as any;
        data["pagamento"] = this.pagamento !== undefined ? this.pagamento : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["pnr"] = this.pnr !== undefined ? this.pnr : null as any;
        data["pagaSubito"] = this.pagaSubito !== undefined ? this.pagaSubito : null as any;
        data["dataPagamento"] = this.dataPagamento !== undefined ? this.dataPagamento : null as any;
        data["dataPresaInCarico"] = this.dataPresaInCarico !== undefined ? this.dataPresaInCarico : null as any;
        data["dataRichiesta"] = this.dataRichiesta !== undefined ? this.dataRichiesta : null as any;
        data["dataEmissione"] = this.dataEmissione !== undefined ? this.dataEmissione : null as any;
        data["okContabilita"] = this.okContabilita !== undefined ? this.okContabilita : null as any;
        data["emesso"] = this.emesso !== undefined ? this.emesso : null as any;
        data["utenteConferma"] = this.utenteConferma !== undefined ? this.utenteConferma : null as any;
        return data;
    }
}

export interface IEmissioneRow {
    offertaID?: number;
    offertaDatoID?: number;
    partenza?: string;
    contattoAgenziaID?: number;
    operatore?: EOperatore;
    agenzia?: string | null;
    pagamento?: string | null;
    descrizione?: string | null;
    pnr?: string | null;
    pagaSubito?: boolean;
    dataPagamento?: string | null;
    dataPresaInCarico?: string | null;
    dataRichiesta?: string | null;
    dataEmissione?: string | null;
    okContabilita?: boolean;
    emesso?: boolean;
    utenteConferma?: string | null;
}

export class GetEmissioniRequest extends NrTableRequest implements IGetEmissioniRequest {
    offertaID?: number | null;
    utenteConfermaID?: number | null;
    tipoLista?: ETipoListaEmissioni;
    contattoAgenziaID?: number | null;
    pagamentoID?: number | null;
    partenzaDal?: string | null;
    partenzaAl?: string | null;
    scadenzaEmissioneDal?: string | null;
    scadenzaEmissioneAl?: string | null;
    scadenzaPagamentoDal?: string | null;
    scadenzaPagamentoAl?: string | null;
    operatore?: EOperatore | null;

    constructor(data?: IGetEmissioniRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.utenteConfermaID = _data["utenteConfermaID"] !== undefined ? _data["utenteConfermaID"] : null as any;
            this.tipoLista = _data["tipoLista"] !== undefined ? _data["tipoLista"] : null as any;
            this.contattoAgenziaID = _data["contattoAgenziaID"] !== undefined ? _data["contattoAgenziaID"] : null as any;
            this.pagamentoID = _data["pagamentoID"] !== undefined ? _data["pagamentoID"] : null as any;
            this.partenzaDal = _data["partenzaDal"] !== undefined ? _data["partenzaDal"] : null as any;
            this.partenzaAl = _data["partenzaAl"] !== undefined ? _data["partenzaAl"] : null as any;
            this.scadenzaEmissioneDal = _data["scadenzaEmissioneDal"] !== undefined ? _data["scadenzaEmissioneDal"] : null as any;
            this.scadenzaEmissioneAl = _data["scadenzaEmissioneAl"] !== undefined ? _data["scadenzaEmissioneAl"] : null as any;
            this.scadenzaPagamentoDal = _data["scadenzaPagamentoDal"] !== undefined ? _data["scadenzaPagamentoDal"] : null as any;
            this.scadenzaPagamentoAl = _data["scadenzaPagamentoAl"] !== undefined ? _data["scadenzaPagamentoAl"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
        }
    }

    static override fromJS(data: any): GetEmissioniRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmissioniRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["utenteConfermaID"] = this.utenteConfermaID !== undefined ? this.utenteConfermaID : null as any;
        data["tipoLista"] = this.tipoLista !== undefined ? this.tipoLista : null as any;
        data["contattoAgenziaID"] = this.contattoAgenziaID !== undefined ? this.contattoAgenziaID : null as any;
        data["pagamentoID"] = this.pagamentoID !== undefined ? this.pagamentoID : null as any;
        data["partenzaDal"] = this.partenzaDal !== undefined ? this.partenzaDal : null as any;
        data["partenzaAl"] = this.partenzaAl !== undefined ? this.partenzaAl : null as any;
        data["scadenzaEmissioneDal"] = this.scadenzaEmissioneDal !== undefined ? this.scadenzaEmissioneDal : null as any;
        data["scadenzaEmissioneAl"] = this.scadenzaEmissioneAl !== undefined ? this.scadenzaEmissioneAl : null as any;
        data["scadenzaPagamentoDal"] = this.scadenzaPagamentoDal !== undefined ? this.scadenzaPagamentoDal : null as any;
        data["scadenzaPagamentoAl"] = this.scadenzaPagamentoAl !== undefined ? this.scadenzaPagamentoAl : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetEmissioniRequest extends INrTableRequest {
    offertaID?: number | null;
    utenteConfermaID?: number | null;
    tipoLista?: ETipoListaEmissioni;
    contattoAgenziaID?: number | null;
    pagamentoID?: number | null;
    partenzaDal?: string | null;
    partenzaAl?: string | null;
    scadenzaEmissioneDal?: string | null;
    scadenzaEmissioneAl?: string | null;
    scadenzaPagamentoDal?: string | null;
    scadenzaPagamentoAl?: string | null;
    operatore?: EOperatore | null;
}

export enum ETipoListaEmissioni {
    Tutti = "Tutti",
    DaAutorizzare = "DaAutorizzare",
    DaEmettere = "DaEmettere",
    Emessi = "Emessi",
    NonPresiInCarico = "NonPresiInCarico",
    PresiInCarico = "PresiInCarico",
}

export class SetOkContabilitaRequest extends ApiRequest implements ISetOkContabilitaRequest {
    righe?: OffertaRiga[] | null;

    constructor(data?: ISetOkContabilitaRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["righe"])) {
                this.righe = [] as any;
                for (let item of _data["righe"])
                    this.righe!.push(OffertaRiga.fromJS(item));
            }
            else {
                this.righe = null as any;
            }
        }
    }

    static override fromJS(data: any): SetOkContabilitaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetOkContabilitaRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.righe)) {
            data["righe"] = [];
            for (let item of this.righe)
                data["righe"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetOkContabilitaRequest extends IApiRequest {
    righe?: OffertaRiga[] | null;
}

export class OffertaRiga implements IOffertaRiga {
    offertaID?: number;
    rigaID?: number;

    constructor(data?: IOffertaRiga) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.rigaID = _data["rigaID"] !== undefined ? _data["rigaID"] : null as any;
        }
    }

    static fromJS(data: any): OffertaRiga {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaRiga();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["rigaID"] = this.rigaID !== undefined ? this.rigaID : null as any;
        return data;
    }
}

export interface IOffertaRiga {
    offertaID?: number;
    rigaID?: number;
}

export class SetPresaInCaricoRequest extends ApiRequest implements ISetPresaInCaricoRequest {
    righe?: OffertaRiga[] | null;

    constructor(data?: ISetPresaInCaricoRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["righe"])) {
                this.righe = [] as any;
                for (let item of _data["righe"])
                    this.righe!.push(OffertaRiga.fromJS(item));
            }
            else {
                this.righe = null as any;
            }
        }
    }

    static override fromJS(data: any): SetPresaInCaricoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetPresaInCaricoRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.righe)) {
            data["righe"] = [];
            for (let item of this.righe)
                data["righe"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetPresaInCaricoRequest extends IApiRequest {
    righe?: OffertaRiga[] | null;
}

export class LinkEditResponse extends OkApiResponse implements ILinkEditResponse {
    link?: PageLink | null;

    constructor(data?: ILinkEditResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.link = _data["link"] ? PageLink.fromJS(_data["link"]) : null as any;
        }
    }

    static override fromJS(data: any): LinkEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LinkEditResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["link"] = this.link ? this.link.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ILinkEditResponse extends IOkApiResponse {
    link?: PageLink | null;
}

export class AddLinkContentRequest extends LocalizedRequest implements IAddLinkContentRequest {
    linkID?: number;
    tipoEntita?: ETipoEntita;
    entitaID?: number;

    constructor(data?: IAddLinkContentRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.linkID = _data["linkID"] !== undefined ? _data["linkID"] : null as any;
            this.tipoEntita = _data["tipoEntita"] !== undefined ? _data["tipoEntita"] : null as any;
            this.entitaID = _data["entitaID"] !== undefined ? _data["entitaID"] : null as any;
        }
    }

    static override fromJS(data: any): AddLinkContentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddLinkContentRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkID"] = this.linkID !== undefined ? this.linkID : null as any;
        data["tipoEntita"] = this.tipoEntita !== undefined ? this.tipoEntita : null as any;
        data["entitaID"] = this.entitaID !== undefined ? this.entitaID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAddLinkContentRequest extends ILocalizedRequest {
    linkID?: number;
    tipoEntita?: ETipoEntita;
    entitaID?: number;
}

export class LinkEditRequest extends ApiRequest implements ILinkEditRequest {
    link?: PageLink | null;

    constructor(data?: ILinkEditRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.link = _data["link"] ? PageLink.fromJS(_data["link"]) : null as any;
        }
    }

    static override fromJS(data: any): LinkEditRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LinkEditRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["link"] = this.link ? this.link.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ILinkEditRequest extends IApiRequest {
    link?: PageLink | null;
}

export class EditLinkContentRequest extends LocalizedRequest implements IEditLinkContentRequest {
    contenuto?: PageLinkContent | null;

    constructor(data?: IEditLinkContentRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contenuto = _data["contenuto"] ? PageLinkContent.fromJS(_data["contenuto"]) : null as any;
        }
    }

    static override fromJS(data: any): EditLinkContentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditLinkContentRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contenuto"] = this.contenuto ? this.contenuto.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IEditLinkContentRequest extends ILocalizedRequest {
    contenuto?: PageLinkContent | null;
}

export class DeleteLinkContentRequest extends LocalizedRequest implements IDeleteLinkContentRequest {
    linkID?: number;
    linkContentID?: number;

    constructor(data?: IDeleteLinkContentRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.linkID = _data["linkID"] !== undefined ? _data["linkID"] : null as any;
            this.linkContentID = _data["linkContentID"] !== undefined ? _data["linkContentID"] : null as any;
        }
    }

    static override fromJS(data: any): DeleteLinkContentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteLinkContentRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkID"] = this.linkID !== undefined ? this.linkID : null as any;
        data["linkContentID"] = this.linkContentID !== undefined ? this.linkContentID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteLinkContentRequest extends ILocalizedRequest {
    linkID?: number;
    linkContentID?: number;
}

export class GetCmsPagesResponse extends OkApiResponse implements IGetCmsPagesResponse {
    pages?: CmsPage[] | null;

    constructor(data?: IGetCmsPagesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(CmsPage.fromJS(item));
            }
            else {
                this.pages = null as any;
            }
        }
    }

    static override fromJS(data: any): GetCmsPagesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCmsPagesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetCmsPagesResponse extends IOkApiResponse {
    pages?: CmsPage[] | null;
}

export class CmsPage implements ICmsPage {
    id?: number;
    nome?: string | null;
    sezioni?: { [key in keyof typeof EPosizioneLink]?: CmsPageSection; } | null;

    constructor(data?: ICmsPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            if (_data["sezioni"]) {
                this.sezioni = {} as any;
                for (let key in _data["sezioni"]) {
                    if (_data["sezioni"].hasOwnProperty(key))
                        (this.sezioni as any)![key] = _data["sezioni"][key] ? CmsPageSection.fromJS(_data["sezioni"][key]) : new CmsPageSection();
                }
            }
            else {
                this.sezioni = null as any;
            }
        }
    }

    static fromJS(data: any): CmsPage {
        data = typeof data === 'object' ? data : {};
        let result = new CmsPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        if (this.sezioni) {
            data["sezioni"] = {};
            for (let key in this.sezioni) {
                if (this.sezioni.hasOwnProperty(key))
                    (data["sezioni"] as any)[key] = this.sezioni[key] ? this.sezioni[key].toJSON() : null as any;
            }
        }
        return data;
    }
}

export interface ICmsPage {
    id?: number;
    nome?: string | null;
    sezioni?: { [key in keyof typeof EPosizioneLink]?: CmsPageSection; } | null;
}

export class CmsPageSection implements ICmsPageSection {
    nome?: string | null;
    help?: string | null;
    links?: CmsPageLink[] | null;
    linkConsentiti?: ETipoLink[] | null;
    contenutiConsentiti?: ETipoEntita[] | null;

    constructor(data?: ICmsPageSection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.help = _data["help"] !== undefined ? _data["help"] : null as any;
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(CmsPageLink.fromJS(item));
            }
            else {
                this.links = null as any;
            }
            if (Array.isArray(_data["linkConsentiti"])) {
                this.linkConsentiti = [] as any;
                for (let item of _data["linkConsentiti"])
                    this.linkConsentiti!.push(item);
            }
            else {
                this.linkConsentiti = null as any;
            }
            if (Array.isArray(_data["contenutiConsentiti"])) {
                this.contenutiConsentiti = [] as any;
                for (let item of _data["contenutiConsentiti"])
                    this.contenutiConsentiti!.push(item);
            }
            else {
                this.contenutiConsentiti = null as any;
            }
        }
    }

    static fromJS(data: any): CmsPageSection {
        data = typeof data === 'object' ? data : {};
        let result = new CmsPageSection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["help"] = this.help !== undefined ? this.help : null as any;
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.linkConsentiti)) {
            data["linkConsentiti"] = [];
            for (let item of this.linkConsentiti)
                data["linkConsentiti"].push(item);
        }
        if (Array.isArray(this.contenutiConsentiti)) {
            data["contenutiConsentiti"] = [];
            for (let item of this.contenutiConsentiti)
                data["contenutiConsentiti"].push(item);
        }
        return data;
    }
}

export interface ICmsPageSection {
    nome?: string | null;
    help?: string | null;
    links?: CmsPageLink[] | null;
    linkConsentiti?: ETipoLink[] | null;
    contenutiConsentiti?: ETipoEntita[] | null;
}

export class CmsPageLink implements ICmsPageLink {
    id?: number;
    nome?: string | null;
    ordine?: number;
    tipo?: ETipoLink;
    url?: string | null;
    icona?: string | null;
    link?: PageLink | null;
    contenuti?: CmsPageContent[] | null;

    constructor(data?: ICmsPageLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
            this.icona = _data["icona"] !== undefined ? _data["icona"] : null as any;
            this.link = _data["link"] ? PageLink.fromJS(_data["link"]) : null as any;
            if (Array.isArray(_data["contenuti"])) {
                this.contenuti = [] as any;
                for (let item of _data["contenuti"])
                    this.contenuti!.push(CmsPageContent.fromJS(item));
            }
            else {
                this.contenuti = null as any;
            }
        }
    }

    static fromJS(data: any): CmsPageLink {
        data = typeof data === 'object' ? data : {};
        let result = new CmsPageLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        data["icona"] = this.icona !== undefined ? this.icona : null as any;
        data["link"] = this.link ? this.link.toJSON() : null as any;
        if (Array.isArray(this.contenuti)) {
            data["contenuti"] = [];
            for (let item of this.contenuti)
                data["contenuti"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ICmsPageLink {
    id?: number;
    nome?: string | null;
    ordine?: number;
    tipo?: ETipoLink;
    url?: string | null;
    icona?: string | null;
    link?: PageLink | null;
    contenuti?: CmsPageContent[] | null;
}

export class CmsPageContent implements ICmsPageContent {
    id?: number;
    contenuto?: PageLinkContent | null;
    title?: string | null;
    visibile?: boolean;
    missing?: boolean;

    constructor(data?: ICmsPageContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.contenuto = _data["contenuto"] ? PageLinkContent.fromJS(_data["contenuto"]) : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.visibile = _data["visibile"] !== undefined ? _data["visibile"] : null as any;
            this.missing = _data["missing"] !== undefined ? _data["missing"] : null as any;
        }
    }

    static fromJS(data: any): CmsPageContent {
        data = typeof data === 'object' ? data : {};
        let result = new CmsPageContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["contenuto"] = this.contenuto ? this.contenuto.toJSON() : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["visibile"] = this.visibile !== undefined ? this.visibile : null as any;
        data["missing"] = this.missing !== undefined ? this.missing : null as any;
        return data;
    }
}

export interface ICmsPageContent {
    id?: number;
    contenuto?: PageLinkContent | null;
    title?: string | null;
    visibile?: boolean;
    missing?: boolean;
}

export class PageContentResponse extends OkApiResponse implements IPageContentResponse {
    content?: PageLinkContent | null;

    constructor(data?: IPageContentResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.content = _data["content"] ? PageLinkContent.fromJS(_data["content"]) : null as any;
        }
    }

    static override fromJS(data: any): PageContentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PageContentResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content ? this.content.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPageContentResponse extends IOkApiResponse {
    content?: PageLinkContent | null;
}

export class PageContentRequest extends LocalizedRequest implements IPageContentRequest {
    id?: number;

    constructor(data?: IPageContentRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): PageContentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PageContentRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPageContentRequest extends ILocalizedRequest {
    id?: number;
}

export class NrTableResponseOfPageContentRow extends OkApiResponse implements INrTableResponseOfPageContentRow {
    /** Array delle righe della pagina richiesta */
    rows?: PageContentRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfPageContentRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(PageContentRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfPageContentRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfPageContentRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfPageContentRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: PageContentRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class PageContentListResponse extends NrTableResponseOfPageContentRow implements IPageContentListResponse {

    constructor(data?: IPageContentListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PageContentListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PageContentListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPageContentListResponse extends INrTableResponseOfPageContentRow {
}

export class PageContentRow implements IPageContentRow {
    pageContentName?: string | null;
    pageContent?: PageLinkContent | null;

    constructor(data?: IPageContentRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageContentName = _data["pageContentName"] !== undefined ? _data["pageContentName"] : null as any;
            this.pageContent = _data["pageContent"] ? PageLinkContent.fromJS(_data["pageContent"]) : null as any;
        }
    }

    static fromJS(data: any): PageContentRow {
        data = typeof data === 'object' ? data : {};
        let result = new PageContentRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageContentName"] = this.pageContentName !== undefined ? this.pageContentName : null as any;
        data["pageContent"] = this.pageContent ? this.pageContent.toJSON() : null as any;
        return data;
    }
}

export interface IPageContentRow {
    pageContentName?: string | null;
    pageContent?: PageLinkContent | null;
}

export class PageContentListRequest extends NrTableRequest implements IPageContentListRequest {
    pagelinkId?: number;
    showDeleted?: boolean;

    constructor(data?: IPageContentListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pagelinkId = _data["pagelinkId"] !== undefined ? _data["pagelinkId"] : null as any;
            this.showDeleted = _data["showDeleted"] !== undefined ? _data["showDeleted"] : null as any;
        }
    }

    static override fromJS(data: any): PageContentListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PageContentListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pagelinkId"] = this.pagelinkId !== undefined ? this.pagelinkId : null as any;
        data["showDeleted"] = this.showDeleted !== undefined ? this.showDeleted : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPageContentListRequest extends INrTableRequest {
    pagelinkId?: number;
    showDeleted?: boolean;
}

export class PageLinkResponse extends OkApiResponse implements IPageLinkResponse {
    link?: PageLink | null;

    constructor(data?: IPageLinkResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.link = _data["link"] ? PageLink.fromJS(_data["link"]) : null as any;
        }
    }

    static override fromJS(data: any): PageLinkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PageLinkResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["link"] = this.link ? this.link.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPageLinkResponse extends IOkApiResponse {
    link?: PageLink | null;
}

export class PageLinkRequest extends LocalizedRequest implements IPageLinkRequest {
    id?: number;

    constructor(data?: IPageLinkRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): PageLinkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PageLinkRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPageLinkRequest extends ILocalizedRequest {
    id?: number;
}

export class NrTableResponseOfPageLinkRow extends OkApiResponse implements INrTableResponseOfPageLinkRow {
    /** Array delle righe della pagina richiesta */
    rows?: PageLinkRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfPageLinkRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(PageLinkRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfPageLinkRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfPageLinkRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfPageLinkRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: PageLinkRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class PageLinkListResponse extends NrTableResponseOfPageLinkRow implements IPageLinkListResponse {

    constructor(data?: IPageLinkListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PageLinkListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PageLinkListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPageLinkListResponse extends INrTableResponseOfPageLinkRow {
}

export class PageLinkRow implements IPageLinkRow {
    pageLink?: PageLink | null;

    constructor(data?: IPageLinkRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageLink = _data["pageLink"] ? PageLink.fromJS(_data["pageLink"]) : null as any;
        }
    }

    static fromJS(data: any): PageLinkRow {
        data = typeof data === 'object' ? data : {};
        let result = new PageLinkRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageLink"] = this.pageLink ? this.pageLink.toJSON() : null as any;
        return data;
    }
}

export interface IPageLinkRow {
    pageLink?: PageLink | null;
}

export class PageLinkListRequest extends NrTableRequest implements IPageLinkListRequest {
    operator?: EOperatore | null;
    position?: EPosizioneLink | null;
    type?: ETipoLink | null;
    name?: string | null;
    showDeleted?: boolean | null;

    constructor(data?: IPageLinkListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operator = _data["operator"] !== undefined ? _data["operator"] : null as any;
            this.position = _data["position"] !== undefined ? _data["position"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.showDeleted = _data["showDeleted"] !== undefined ? _data["showDeleted"] : null as any;
        }
    }

    static override fromJS(data: any): PageLinkListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PageLinkListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operator"] = this.operator !== undefined ? this.operator : null as any;
        data["position"] = this.position !== undefined ? this.position : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["showDeleted"] = this.showDeleted !== undefined ? this.showDeleted : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPageLinkListRequest extends INrTableRequest {
    operator?: EOperatore | null;
    position?: EPosizioneLink | null;
    type?: ETipoLink | null;
    name?: string | null;
    showDeleted?: boolean | null;
}

export class GetSiteBannersResponse extends OkApiResponse implements IGetSiteBannersResponse {
    banners?: Banner[] | null;

    constructor(data?: IGetSiteBannersResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["banners"])) {
                this.banners = [] as any;
                for (let item of _data["banners"])
                    this.banners!.push(Banner.fromJS(item));
            }
            else {
                this.banners = null as any;
            }
        }
    }

    static override fromJS(data: any): GetSiteBannersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSiteBannersResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.banners)) {
            data["banners"] = [];
            for (let item of this.banners)
                data["banners"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetSiteBannersResponse extends IOkApiResponse {
    banners?: Banner[] | null;
}

export class Banner implements IBanner {
    id?: number;
    imgUrl?: string | null;
    title?: string | null;
    sunto?: string | null;
    destCode?: string | null;
    offViaggio?: boolean;
    destination?: Destination | null;
    bannerType?: EBannerType;
    ordine?: number;
    attachment?: string | null;
    attachmentId?: number;
    attachmentFileType?: string | null;

    constructor(data?: IBanner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.imgUrl = _data["imgUrl"] !== undefined ? _data["imgUrl"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.sunto = _data["sunto"] !== undefined ? _data["sunto"] : null as any;
            this.destCode = _data["destCode"] !== undefined ? _data["destCode"] : null as any;
            this.offViaggio = _data["offViaggio"] !== undefined ? _data["offViaggio"] : null as any;
            this.destination = _data["destination"] ? Destination.fromJS(_data["destination"]) : null as any;
            this.bannerType = _data["bannerType"] !== undefined ? _data["bannerType"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.attachment = _data["attachment"] !== undefined ? _data["attachment"] : null as any;
            this.attachmentId = _data["attachmentId"] !== undefined ? _data["attachmentId"] : null as any;
            this.attachmentFileType = _data["attachmentFileType"] !== undefined ? _data["attachmentFileType"] : null as any;
        }
    }

    static fromJS(data: any): Banner {
        data = typeof data === 'object' ? data : {};
        let result = new Banner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["imgUrl"] = this.imgUrl !== undefined ? this.imgUrl : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["sunto"] = this.sunto !== undefined ? this.sunto : null as any;
        data["destCode"] = this.destCode !== undefined ? this.destCode : null as any;
        data["offViaggio"] = this.offViaggio !== undefined ? this.offViaggio : null as any;
        data["destination"] = this.destination ? this.destination.toJSON() : null as any;
        data["bannerType"] = this.bannerType !== undefined ? this.bannerType : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["attachment"] = this.attachment !== undefined ? this.attachment : null as any;
        data["attachmentId"] = this.attachmentId !== undefined ? this.attachmentId : null as any;
        data["attachmentFileType"] = this.attachmentFileType !== undefined ? this.attachmentFileType : null as any;
        return data;
    }
}

export interface IBanner {
    id?: number;
    imgUrl?: string | null;
    title?: string | null;
    sunto?: string | null;
    destCode?: string | null;
    offViaggio?: boolean;
    destination?: Destination | null;
    bannerType?: EBannerType;
    ordine?: number;
    attachment?: string | null;
    attachmentId?: number;
    attachmentFileType?: string | null;
}

export enum EBannerType {
    Offerta = "offerta",
    Banner = "banner",
}

export class GetSiteBannersRequest extends SiteRequest implements IGetSiteBannersRequest {
    addCoBranded?: boolean;

    constructor(data?: IGetSiteBannersRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.addCoBranded = _data["addCoBranded"] !== undefined ? _data["addCoBranded"] : null as any;
        }
    }

    static override fromJS(data: any): GetSiteBannersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSiteBannersRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addCoBranded"] = this.addCoBranded !== undefined ? this.addCoBranded : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetSiteBannersRequest extends ISiteRequest {
    addCoBranded?: boolean;
}

export class GetSiteBannerSXResponse extends OkApiResponse implements IGetSiteBannerSXResponse {
    bannerSX?: BannerSX[] | null;

    constructor(data?: IGetSiteBannerSXResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["bannerSX"])) {
                this.bannerSX = [] as any;
                for (let item of _data["bannerSX"])
                    this.bannerSX!.push(BannerSX.fromJS(item));
            }
            else {
                this.bannerSX = null as any;
            }
        }
    }

    static override fromJS(data: any): GetSiteBannerSXResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSiteBannerSXResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bannerSX)) {
            data["bannerSX"] = [];
            for (let item of this.bannerSX)
                data["bannerSX"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetSiteBannerSXResponse extends IOkApiResponse {
    bannerSX?: BannerSX[] | null;
}

export class BannerSX implements IBannerSX {
    id?: number;
    title?: string | null;
    content?: string | null;
    grp?: number;

    constructor(data?: IBannerSX) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.content = _data["content"] !== undefined ? _data["content"] : null as any;
            this.grp = _data["grp"] !== undefined ? _data["grp"] : null as any;
        }
    }

    static fromJS(data: any): BannerSX {
        data = typeof data === 'object' ? data : {};
        let result = new BannerSX();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["content"] = this.content !== undefined ? this.content : null as any;
        data["grp"] = this.grp !== undefined ? this.grp : null as any;
        return data;
    }
}

export interface IBannerSX {
    id?: number;
    title?: string | null;
    content?: string | null;
    grp?: number;
}

export class GetSiteBannerSXRequest extends SiteRequest implements IGetSiteBannerSXRequest {

    constructor(data?: IGetSiteBannerSXRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetSiteBannerSXRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSiteBannerSXRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetSiteBannerSXRequest extends ISiteRequest {
}

export class GetSiteNewsResponse extends OkApiResponse implements IGetSiteNewsResponse {
    news?: NewsArticle[] | null;

    constructor(data?: IGetSiteNewsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["news"])) {
                this.news = [] as any;
                for (let item of _data["news"])
                    this.news!.push(NewsArticle.fromJS(item));
            }
            else {
                this.news = null as any;
            }
        }
    }

    static override fromJS(data: any): GetSiteNewsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSiteNewsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.news)) {
            data["news"] = [];
            for (let item of this.news)
                data["news"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetSiteNewsResponse extends IOkApiResponse {
    news?: NewsArticle[] | null;
}

export class NewsArticle implements INewsArticle {
    id?: number;
    titolo?: string | null;
    sunto?: string | null;
    testo?: string | null;
    testoShort?: string | null;
    tipoNews?: ENewsType;
    updated?: string | null;
    allegati?: ArticoloAllegato[] | null;

    constructor(data?: INewsArticle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            this.sunto = _data["sunto"] !== undefined ? _data["sunto"] : null as any;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : null as any;
            this.testoShort = _data["testoShort"] !== undefined ? _data["testoShort"] : null as any;
            this.tipoNews = _data["tipoNews"] !== undefined ? _data["tipoNews"] : null as any;
            this.updated = _data["updated"] !== undefined ? _data["updated"] : null as any;
            if (Array.isArray(_data["allegati"])) {
                this.allegati = [] as any;
                for (let item of _data["allegati"])
                    this.allegati!.push(ArticoloAllegato.fromJS(item));
            }
            else {
                this.allegati = null as any;
            }
        }
    }

    static fromJS(data: any): NewsArticle {
        data = typeof data === 'object' ? data : {};
        let result = new NewsArticle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        data["sunto"] = this.sunto !== undefined ? this.sunto : null as any;
        data["testo"] = this.testo !== undefined ? this.testo : null as any;
        data["testoShort"] = this.testoShort !== undefined ? this.testoShort : null as any;
        data["tipoNews"] = this.tipoNews !== undefined ? this.tipoNews : null as any;
        data["updated"] = this.updated !== undefined ? this.updated : null as any;
        if (Array.isArray(this.allegati)) {
            data["allegati"] = [];
            for (let item of this.allegati)
                data["allegati"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface INewsArticle {
    id?: number;
    titolo?: string | null;
    sunto?: string | null;
    testo?: string | null;
    testoShort?: string | null;
    tipoNews?: ENewsType;
    updated?: string | null;
    allegati?: ArticoloAllegato[] | null;
}

export enum ENewsType {
    Approfondimenti = "approfondimenti",
    UltimeNotizie = "ultimeNotizie",
    InPrimoPiano = "inPrimoPiano",
}

export class GetSiteNewsRequest extends SiteRequest implements IGetSiteNewsRequest {

    constructor(data?: IGetSiteNewsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetSiteNewsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSiteNewsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetSiteNewsRequest extends ISiteRequest {
}

export class ContentEditRequest extends ApiRequest implements IContentEditRequest {
    content?: PageLinkContent | null;

    constructor(data?: IContentEditRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.content = _data["content"] ? PageLinkContent.fromJS(_data["content"]) : null as any;
        }
    }

    static override fromJS(data: any): ContentEditRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContentEditRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content ? this.content.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IContentEditRequest extends IApiRequest {
    content?: PageLinkContent | null;
}

export class SetLinkContentsOrderRequest extends LocalizedRequest implements ISetLinkContentsOrderRequest {
    linkID?: number;
    sortedIds?: number[] | null;

    constructor(data?: ISetLinkContentsOrderRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.linkID = _data["linkID"] !== undefined ? _data["linkID"] : null as any;
            if (Array.isArray(_data["sortedIds"])) {
                this.sortedIds = [] as any;
                for (let item of _data["sortedIds"])
                    this.sortedIds!.push(item);
            }
            else {
                this.sortedIds = null as any;
            }
        }
    }

    static override fromJS(data: any): SetLinkContentsOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetLinkContentsOrderRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkID"] = this.linkID !== undefined ? this.linkID : null as any;
        if (Array.isArray(this.sortedIds)) {
            data["sortedIds"] = [];
            for (let item of this.sortedIds)
                data["sortedIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetLinkContentsOrderRequest extends ILocalizedRequest {
    linkID?: number;
    sortedIds?: number[] | null;
}

export class SetLinksOrderRequest extends ApiRequest implements ISetLinksOrderRequest {
    sortedIds?: number[] | null;

    constructor(data?: ISetLinksOrderRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["sortedIds"])) {
                this.sortedIds = [] as any;
                for (let item of _data["sortedIds"])
                    this.sortedIds!.push(item);
            }
            else {
                this.sortedIds = null as any;
            }
        }
    }

    static override fromJS(data: any): SetLinksOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetLinksOrderRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sortedIds)) {
            data["sortedIds"] = [];
            for (let item of this.sortedIds)
                data["sortedIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetLinksOrderRequest extends IApiRequest {
    sortedIds?: number[] | null;
}

export class ContactActivityDeleteRequest extends ApiRequest implements IContactActivityDeleteRequest {
    id?: number;

    constructor(data?: IContactActivityDeleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): ContactActivityDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContactActivityDeleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IContactActivityDeleteRequest extends IApiRequest {
    id?: number;
}

export class ContactActivityGetResponse extends OkApiResponse implements IContactActivityGetResponse {
    activity?: ContactActivityRow | null;

    constructor(data?: IContactActivityGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activity = _data["activity"] ? ContactActivityRow.fromJS(_data["activity"]) : null as any;
        }
    }

    static override fromJS(data: any): ContactActivityGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ContactActivityGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activity"] = this.activity ? this.activity.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IContactActivityGetResponse extends IOkApiResponse {
    activity?: ContactActivityRow | null;
}

export class ContactActivity implements IContactActivity {
    contactActivityID?: number;
    activityName?: string | null;
    operatorID?: number;
    validFrom?: string | null;
    validTo?: string | null;
    description?: string | null;
    displayOrder?: number | null;
    isDeleted?: boolean;
    userID?: number | null;
    lastUpdated?: string | null;
    operatore?: Operatore | null;

    constructor(data?: IContactActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactActivityID = _data["contactActivityID"] !== undefined ? _data["contactActivityID"] : null as any;
            this.activityName = _data["activityName"] !== undefined ? _data["activityName"] : null as any;
            this.operatorID = _data["operatorID"] !== undefined ? _data["operatorID"] : null as any;
            this.validFrom = _data["validFrom"] !== undefined ? _data["validFrom"] : null as any;
            this.validTo = _data["validTo"] !== undefined ? _data["validTo"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.displayOrder = _data["displayOrder"] !== undefined ? _data["displayOrder"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.userID = _data["userID"] !== undefined ? _data["userID"] : null as any;
            this.lastUpdated = _data["lastUpdated"] !== undefined ? _data["lastUpdated"] : null as any;
            this.operatore = _data["operatore"] ? Operatore.fromJS(_data["operatore"]) : null as any;
        }
    }

    static fromJS(data: any): ContactActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ContactActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactActivityID"] = this.contactActivityID !== undefined ? this.contactActivityID : null as any;
        data["activityName"] = this.activityName !== undefined ? this.activityName : null as any;
        data["operatorID"] = this.operatorID !== undefined ? this.operatorID : null as any;
        data["validFrom"] = this.validFrom !== undefined ? this.validFrom : null as any;
        data["validTo"] = this.validTo !== undefined ? this.validTo : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["displayOrder"] = this.displayOrder !== undefined ? this.displayOrder : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["userID"] = this.userID !== undefined ? this.userID : null as any;
        data["lastUpdated"] = this.lastUpdated !== undefined ? this.lastUpdated : null as any;
        data["operatore"] = this.operatore ? this.operatore.toJSON() : null as any;
        return data;
    }
}

export interface IContactActivity {
    contactActivityID?: number;
    activityName?: string | null;
    operatorID?: number;
    validFrom?: string | null;
    validTo?: string | null;
    description?: string | null;
    displayOrder?: number | null;
    isDeleted?: boolean;
    userID?: number | null;
    lastUpdated?: string | null;
    operatore?: Operatore | null;
}

export class ContactActivityRow extends ContactActivity implements IContactActivityRow {
    operatorName?: string | null;

    constructor(data?: IContactActivityRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operatorName = _data["operatorName"] !== undefined ? _data["operatorName"] : null as any;
        }
    }

    static override fromJS(data: any): ContactActivityRow {
        data = typeof data === 'object' ? data : {};
        let result = new ContactActivityRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operatorName"] = this.operatorName !== undefined ? this.operatorName : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IContactActivityRow extends IContactActivity {
    operatorName?: string | null;
}

export class Operatore implements IOperatore {
    operatoreID?: number;
    contattoID?: number;
    nome!: string;
    nomeVisualizzato?: string | null;
    valutaID?: number;
    visibile?: boolean;
    includeTaxesInFlightCommissions?: boolean;
    advHomeConf?: ActionBoxConfig[] | null;
    cambio?: number;

    constructor(data?: IOperatore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operatoreID = _data["operatoreID"] !== undefined ? _data["operatoreID"] : null as any;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nomeVisualizzato = _data["nomeVisualizzato"] !== undefined ? _data["nomeVisualizzato"] : null as any;
            this.valutaID = _data["valutaID"] !== undefined ? _data["valutaID"] : null as any;
            this.visibile = _data["visibile"] !== undefined ? _data["visibile"] : null as any;
            this.includeTaxesInFlightCommissions = _data["includeTaxesInFlightCommissions"] !== undefined ? _data["includeTaxesInFlightCommissions"] : null as any;
            if (Array.isArray(_data["advHomeConf"])) {
                this.advHomeConf = [] as any;
                for (let item of _data["advHomeConf"])
                    this.advHomeConf!.push(ActionBoxConfig.fromJS(item));
            }
            else {
                this.advHomeConf = null as any;
            }
            this.cambio = _data["cambio"] !== undefined ? _data["cambio"] : null as any;
        }
    }

    static fromJS(data: any): Operatore {
        data = typeof data === 'object' ? data : {};
        let result = new Operatore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operatoreID"] = this.operatoreID !== undefined ? this.operatoreID : null as any;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nomeVisualizzato"] = this.nomeVisualizzato !== undefined ? this.nomeVisualizzato : null as any;
        data["valutaID"] = this.valutaID !== undefined ? this.valutaID : null as any;
        data["visibile"] = this.visibile !== undefined ? this.visibile : null as any;
        data["includeTaxesInFlightCommissions"] = this.includeTaxesInFlightCommissions !== undefined ? this.includeTaxesInFlightCommissions : null as any;
        if (Array.isArray(this.advHomeConf)) {
            data["advHomeConf"] = [];
            for (let item of this.advHomeConf)
                data["advHomeConf"].push(item ? item.toJSON() : null as any);
        }
        data["cambio"] = this.cambio !== undefined ? this.cambio : null as any;
        return data;
    }
}

export interface IOperatore {
    operatoreID?: number;
    contattoID?: number;
    nome: string;
    nomeVisualizzato?: string | null;
    valutaID?: number;
    visibile?: boolean;
    includeTaxesInFlightCommissions?: boolean;
    advHomeConf?: ActionBoxConfig[] | null;
    cambio?: number;
}

export class ContactActivityGetRequest extends ApiRequest implements IContactActivityGetRequest {
    id?: number;

    constructor(data?: IContactActivityGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): ContactActivityGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContactActivityGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IContactActivityGetRequest extends IApiRequest {
    id?: number;
}

export class NrTableResponseOfContactActivityRow extends OkApiResponse implements INrTableResponseOfContactActivityRow {
    /** Array delle righe della pagina richiesta */
    rows?: ContactActivityRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfContactActivityRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ContactActivityRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfContactActivityRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfContactActivityRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfContactActivityRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: ContactActivityRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class ContactActivityListRequest extends NrTableRequest implements IContactActivityListRequest {
    /** Filtro facoltativo per operatore (enum eOperatore) */
    operator?: EOperatore | null;
    /** Data inizio (formato yyyyMMdd) */
    dateFrom?: string | null;
    /** Data fine (formato yyyyMMdd) */
    dateTo?: string | null;

    constructor(data?: IContactActivityListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operator = _data["operator"] !== undefined ? _data["operator"] : null as any;
            this.dateFrom = _data["dateFrom"] !== undefined ? _data["dateFrom"] : null as any;
            this.dateTo = _data["dateTo"] !== undefined ? _data["dateTo"] : null as any;
        }
    }

    static override fromJS(data: any): ContactActivityListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContactActivityListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operator"] = this.operator !== undefined ? this.operator : null as any;
        data["dateFrom"] = this.dateFrom !== undefined ? this.dateFrom : null as any;
        data["dateTo"] = this.dateTo !== undefined ? this.dateTo : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IContactActivityListRequest extends INrTableRequest {
    /** Filtro facoltativo per operatore (enum eOperatore) */
    operator?: EOperatore | null;
    /** Data inizio (formato yyyyMMdd) */
    dateFrom?: string | null;
    /** Data fine (formato yyyyMMdd) */
    dateTo?: string | null;
}

export class ContactActivityUpsertRequest extends ContactActivityGetRequest implements IContactActivityUpsertRequest {
    activity!: ContactActivity;

    constructor(data?: IContactActivityUpsertRequest) {
        super(data);
        if (!data) {
            this.activity = new ContactActivity();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activity = _data["activity"] ? ContactActivity.fromJS(_data["activity"]) : new ContactActivity();
        }
    }

    static override fromJS(data: any): ContactActivityUpsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContactActivityUpsertRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activity"] = this.activity ? this.activity.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IContactActivityUpsertRequest extends IContactActivityGetRequest {
    activity: ContactActivity;
}

export class ContactAgencyDataDeleteRequest extends ApiRequest implements IContactAgencyDataDeleteRequest {
    id?: number;

    constructor(data?: IContactAgencyDataDeleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): ContactAgencyDataDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContactAgencyDataDeleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IContactAgencyDataDeleteRequest extends IApiRequest {
    id?: number;
}

export class ContactAgencyDataGetResponse extends OkApiResponse implements IContactAgencyDataGetResponse {
    data?: ContactAgencyDataRow | null;

    constructor(data?: IContactAgencyDataGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? ContactAgencyDataRow.fromJS(_data["data"]) : null as any;
        }
    }

    static override fromJS(data: any): ContactAgencyDataGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ContactAgencyDataGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IContactAgencyDataGetResponse extends IOkApiResponse {
    data?: ContactAgencyDataRow | null;
}

export class ContactAgencyData implements IContactAgencyData {
    contactAgencyDataID?: number;
    contactID?: number;
    agencyType?: EContactAgencyType | null;
    employeeCount?: EContactAgencyEmployeeRange | null;
    luxuryPercent?: number | null;
    honeymoonPercent?: number | null;
    familiesPercent?: number | null;
    charterPercent?: number | null;
    cruisesPercent?: number | null;
    groupsPercent?: number | null;
    otherPercent?: number | null;
    potentialRevenue?: number | null;
    estimatedTurnover?: number | null;
    tourOperator1?: string | null;
    tourOperator2?: string | null;
    tourOperator3?: string | null;
    notes?: string | null;
    isDeleted?: boolean;
    userID?: number | null;
    lastUpdated?: string;
    contatto?: Contatto | null;

    constructor(data?: IContactAgencyData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactAgencyDataID = _data["contactAgencyDataID"] !== undefined ? _data["contactAgencyDataID"] : null as any;
            this.contactID = _data["contactID"] !== undefined ? _data["contactID"] : null as any;
            this.agencyType = _data["agencyType"] !== undefined ? _data["agencyType"] : null as any;
            this.employeeCount = _data["employeeCount"] !== undefined ? _data["employeeCount"] : null as any;
            this.luxuryPercent = _data["luxuryPercent"] !== undefined ? _data["luxuryPercent"] : null as any;
            this.honeymoonPercent = _data["honeymoonPercent"] !== undefined ? _data["honeymoonPercent"] : null as any;
            this.familiesPercent = _data["familiesPercent"] !== undefined ? _data["familiesPercent"] : null as any;
            this.charterPercent = _data["charterPercent"] !== undefined ? _data["charterPercent"] : null as any;
            this.cruisesPercent = _data["cruisesPercent"] !== undefined ? _data["cruisesPercent"] : null as any;
            this.groupsPercent = _data["groupsPercent"] !== undefined ? _data["groupsPercent"] : null as any;
            this.otherPercent = _data["otherPercent"] !== undefined ? _data["otherPercent"] : null as any;
            this.potentialRevenue = _data["potentialRevenue"] !== undefined ? _data["potentialRevenue"] : null as any;
            this.estimatedTurnover = _data["estimatedTurnover"] !== undefined ? _data["estimatedTurnover"] : null as any;
            this.tourOperator1 = _data["tourOperator1"] !== undefined ? _data["tourOperator1"] : null as any;
            this.tourOperator2 = _data["tourOperator2"] !== undefined ? _data["tourOperator2"] : null as any;
            this.tourOperator3 = _data["tourOperator3"] !== undefined ? _data["tourOperator3"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.userID = _data["userID"] !== undefined ? _data["userID"] : null as any;
            this.lastUpdated = _data["lastUpdated"] !== undefined ? _data["lastUpdated"] : null as any;
            this.contatto = _data["contatto"] ? Contatto.fromJS(_data["contatto"]) : null as any;
        }
    }

    static fromJS(data: any): ContactAgencyData {
        data = typeof data === 'object' ? data : {};
        let result = new ContactAgencyData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactAgencyDataID"] = this.contactAgencyDataID !== undefined ? this.contactAgencyDataID : null as any;
        data["contactID"] = this.contactID !== undefined ? this.contactID : null as any;
        data["agencyType"] = this.agencyType !== undefined ? this.agencyType : null as any;
        data["employeeCount"] = this.employeeCount !== undefined ? this.employeeCount : null as any;
        data["luxuryPercent"] = this.luxuryPercent !== undefined ? this.luxuryPercent : null as any;
        data["honeymoonPercent"] = this.honeymoonPercent !== undefined ? this.honeymoonPercent : null as any;
        data["familiesPercent"] = this.familiesPercent !== undefined ? this.familiesPercent : null as any;
        data["charterPercent"] = this.charterPercent !== undefined ? this.charterPercent : null as any;
        data["cruisesPercent"] = this.cruisesPercent !== undefined ? this.cruisesPercent : null as any;
        data["groupsPercent"] = this.groupsPercent !== undefined ? this.groupsPercent : null as any;
        data["otherPercent"] = this.otherPercent !== undefined ? this.otherPercent : null as any;
        data["potentialRevenue"] = this.potentialRevenue !== undefined ? this.potentialRevenue : null as any;
        data["estimatedTurnover"] = this.estimatedTurnover !== undefined ? this.estimatedTurnover : null as any;
        data["tourOperator1"] = this.tourOperator1 !== undefined ? this.tourOperator1 : null as any;
        data["tourOperator2"] = this.tourOperator2 !== undefined ? this.tourOperator2 : null as any;
        data["tourOperator3"] = this.tourOperator3 !== undefined ? this.tourOperator3 : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["userID"] = this.userID !== undefined ? this.userID : null as any;
        data["lastUpdated"] = this.lastUpdated !== undefined ? this.lastUpdated : null as any;
        data["contatto"] = this.contatto ? this.contatto.toJSON() : null as any;
        return data;
    }
}

export interface IContactAgencyData {
    contactAgencyDataID?: number;
    contactID?: number;
    agencyType?: EContactAgencyType | null;
    employeeCount?: EContactAgencyEmployeeRange | null;
    luxuryPercent?: number | null;
    honeymoonPercent?: number | null;
    familiesPercent?: number | null;
    charterPercent?: number | null;
    cruisesPercent?: number | null;
    groupsPercent?: number | null;
    otherPercent?: number | null;
    potentialRevenue?: number | null;
    estimatedTurnover?: number | null;
    tourOperator1?: string | null;
    tourOperator2?: string | null;
    tourOperator3?: string | null;
    notes?: string | null;
    isDeleted?: boolean;
    userID?: number | null;
    lastUpdated?: string;
    contatto?: Contatto | null;
}

export class ContactAgencyDataRow extends ContactAgencyData implements IContactAgencyDataRow {
    firstName?: string | null;
    lastName?: string | null;
    phone?: string | null;
    email?: string | null;
    address?: string | null;
    postalCode?: string | null;
    luogoId?: number | null;
    city?: string | null;

    constructor(data?: IContactAgencyDataRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.address = _data["address"] !== undefined ? _data["address"] : null as any;
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : null as any;
            this.luogoId = _data["luogoId"] !== undefined ? _data["luogoId"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
        }
    }

    static override fromJS(data: any): ContactAgencyDataRow {
        data = typeof data === 'object' ? data : {};
        let result = new ContactAgencyDataRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["address"] = this.address !== undefined ? this.address : null as any;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : null as any;
        data["luogoId"] = this.luogoId !== undefined ? this.luogoId : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IContactAgencyDataRow extends IContactAgencyData {
    firstName?: string | null;
    lastName?: string | null;
    phone?: string | null;
    email?: string | null;
    address?: string | null;
    postalCode?: string | null;
    luogoId?: number | null;
    city?: string | null;
}

export enum EContactAgencyType {
    Independent = "Independent",
    Chain = "Chain",
    Online = "Online",
    Consortium = "Consortium",
    Network = "Network",
}

export enum EContactAgencyEmployeeRange {
    LessThan5 = "LessThan5",
    Between6And10 = "Between6And10",
    Between10And20 = "Between10And20",
    MoreThan20 = "MoreThan20",
}

export class ContactAgencyDataGetRequest extends ApiRequest implements IContactAgencyDataGetRequest {
    id!: number;

    constructor(data?: IContactAgencyDataGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): ContactAgencyDataGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContactAgencyDataGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IContactAgencyDataGetRequest extends IApiRequest {
    id: number;
}

export class NrTableResponseOfContactAgencyDataRow extends OkApiResponse implements INrTableResponseOfContactAgencyDataRow {
    /** Array delle righe della pagina richiesta */
    rows?: ContactAgencyDataRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfContactAgencyDataRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ContactAgencyDataRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfContactAgencyDataRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfContactAgencyDataRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfContactAgencyDataRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: ContactAgencyDataRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class ContactAgencyDataListRequest extends NrTableRequest implements IContactAgencyDataListRequest {
    /** ID specifico del contatto (per filtrare per singola agenzia) */
    contactID?: number | null;

    constructor(data?: IContactAgencyDataListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contactID = _data["contactID"] !== undefined ? _data["contactID"] : null as any;
        }
    }

    static override fromJS(data: any): ContactAgencyDataListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContactAgencyDataListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactID"] = this.contactID !== undefined ? this.contactID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IContactAgencyDataListRequest extends INrTableRequest {
    /** ID specifico del contatto (per filtrare per singola agenzia) */
    contactID?: number | null;
}

export class ContactAgencyDataUpsertRequest extends ContactAgencyDataGetRequest implements IContactAgencyDataUpsertRequest {
    agencyData!: ContactAgencyData;

    constructor(data?: IContactAgencyDataUpsertRequest) {
        super(data);
        if (!data) {
            this.agencyData = new ContactAgencyData();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agencyData = _data["agencyData"] ? ContactAgencyData.fromJS(_data["agencyData"]) : new ContactAgencyData();
        }
    }

    static override fromJS(data: any): ContactAgencyDataUpsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContactAgencyDataUpsertRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agencyData"] = this.agencyData ? this.agencyData.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IContactAgencyDataUpsertRequest extends IContactAgencyDataGetRequest {
    agencyData: ContactAgencyData;
}

export class ContactMeetingDeleteRequest extends ApiRequest implements IContactMeetingDeleteRequest {
    id?: number;

    constructor(data?: IContactMeetingDeleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): ContactMeetingDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContactMeetingDeleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IContactMeetingDeleteRequest extends IApiRequest {
    id?: number;
}

export class ContactMeetingGetResponse extends OkApiResponse implements IContactMeetingGetResponse {
    meeting?: ContactMeetingRow;

    constructor(data?: IContactMeetingGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.meeting = _data["meeting"] ? ContactMeetingRow.fromJS(_data["meeting"]) : null as any;
        }
    }

    static override fromJS(data: any): ContactMeetingGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ContactMeetingGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meeting"] = this.meeting ? this.meeting.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IContactMeetingGetResponse extends IOkApiResponse {
    meeting?: ContactMeetingRow;
}

export class ContactMeeting implements IContactMeeting {
    contactMeetingID?: number;
    contactID?: number;
    authUserId?: number;
    meetingDate?: string;
    contactPerson?: string | null;
    type?: EMeetingType | null;
    status?: EMeetingStatus | null;
    priority?: EMeetingPriority | null;
    location?: EMeetingLocation | null;
    outcome?: EMeetingOutcome | null;
    duration?: number | null;
    followUpDate?: string | null;
    notes?: string | null;
    activityChecklist?: string | null;
    isDeleted?: boolean;
    userID?: number | null;
    lastUpdated?: string;
    utente?: Utente | null;
    contatto?: Contatto | null;

    constructor(data?: IContactMeeting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactMeetingID = _data["contactMeetingID"] !== undefined ? _data["contactMeetingID"] : null as any;
            this.contactID = _data["contactID"] !== undefined ? _data["contactID"] : null as any;
            this.authUserId = _data["authUserId"] !== undefined ? _data["authUserId"] : null as any;
            this.meetingDate = _data["meetingDate"] !== undefined ? _data["meetingDate"] : null as any;
            this.contactPerson = _data["contactPerson"] !== undefined ? _data["contactPerson"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : null as any;
            this.location = _data["location"] !== undefined ? _data["location"] : null as any;
            this.outcome = _data["outcome"] !== undefined ? _data["outcome"] : null as any;
            this.duration = _data["duration"] !== undefined ? _data["duration"] : null as any;
            this.followUpDate = _data["followUpDate"] !== undefined ? _data["followUpDate"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.activityChecklist = _data["activityChecklist"] !== undefined ? _data["activityChecklist"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.userID = _data["userID"] !== undefined ? _data["userID"] : null as any;
            this.lastUpdated = _data["lastUpdated"] !== undefined ? _data["lastUpdated"] : null as any;
            this.utente = _data["utente"] ? Utente.fromJS(_data["utente"]) : null as any;
            this.contatto = _data["contatto"] ? Contatto.fromJS(_data["contatto"]) : null as any;
        }
    }

    static fromJS(data: any): ContactMeeting {
        data = typeof data === 'object' ? data : {};
        let result = new ContactMeeting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactMeetingID"] = this.contactMeetingID !== undefined ? this.contactMeetingID : null as any;
        data["contactID"] = this.contactID !== undefined ? this.contactID : null as any;
        data["authUserId"] = this.authUserId !== undefined ? this.authUserId : null as any;
        data["meetingDate"] = this.meetingDate !== undefined ? this.meetingDate : null as any;
        data["contactPerson"] = this.contactPerson !== undefined ? this.contactPerson : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["priority"] = this.priority !== undefined ? this.priority : null as any;
        data["location"] = this.location !== undefined ? this.location : null as any;
        data["outcome"] = this.outcome !== undefined ? this.outcome : null as any;
        data["duration"] = this.duration !== undefined ? this.duration : null as any;
        data["followUpDate"] = this.followUpDate !== undefined ? this.followUpDate : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["activityChecklist"] = this.activityChecklist !== undefined ? this.activityChecklist : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["userID"] = this.userID !== undefined ? this.userID : null as any;
        data["lastUpdated"] = this.lastUpdated !== undefined ? this.lastUpdated : null as any;
        data["utente"] = this.utente ? this.utente.toJSON() : null as any;
        data["contatto"] = this.contatto ? this.contatto.toJSON() : null as any;
        return data;
    }
}

export interface IContactMeeting {
    contactMeetingID?: number;
    contactID?: number;
    authUserId?: number;
    meetingDate?: string;
    contactPerson?: string | null;
    type?: EMeetingType | null;
    status?: EMeetingStatus | null;
    priority?: EMeetingPriority | null;
    location?: EMeetingLocation | null;
    outcome?: EMeetingOutcome | null;
    duration?: number | null;
    followUpDate?: string | null;
    notes?: string | null;
    activityChecklist?: string | null;
    isDeleted?: boolean;
    userID?: number | null;
    lastUpdated?: string;
    utente?: Utente | null;
    contatto?: Contatto | null;
}

export class ContactMeetingRow extends ContactMeeting implements IContactMeetingRow {
    salesUserName?: string | null;
    agencyName?: string | null;

    constructor(data?: IContactMeetingRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.salesUserName = _data["salesUserName"] !== undefined ? _data["salesUserName"] : null as any;
            this.agencyName = _data["agencyName"] !== undefined ? _data["agencyName"] : null as any;
        }
    }

    static override fromJS(data: any): ContactMeetingRow {
        data = typeof data === 'object' ? data : {};
        let result = new ContactMeetingRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesUserName"] = this.salesUserName !== undefined ? this.salesUserName : null as any;
        data["agencyName"] = this.agencyName !== undefined ? this.agencyName : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IContactMeetingRow extends IContactMeeting {
    salesUserName?: string | null;
    agencyName?: string | null;
}

export enum EMeetingType {
    SalesCall = "SalesCall",
    FollowUp = "FollowUp",
    Demo = "Demo",
    ContractNegotiation = "ContractNegotiation",
    Events = "Events",
}

export enum EMeetingStatus {
    Planned = "Planned",
    Completed = "Completed",
    Cancelled = "Cancelled",
    Rescheduled = "Rescheduled",
}

export enum EMeetingPriority {
    High = "High",
    Medium = "Medium",
    Low = "Low",
}

export enum EMeetingLocation {
    OurOffice = "OurOffice",
    ClientOffice = "ClientOffice",
    VideoCall = "VideoCall",
    PhoneCall = "PhoneCall",
    Other = "Other",
}

export enum EMeetingOutcome {
    Lost = "Lost",
    Won = "Won",
    InProgress = "InProgress",
    Deferred = "Deferred",
}

export class ContactMeetingGetRequest extends ApiRequest implements IContactMeetingGetRequest {
    id?: number;

    constructor(data?: IContactMeetingGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): ContactMeetingGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContactMeetingGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IContactMeetingGetRequest extends IApiRequest {
    id?: number;
}

export class NrTableResponseOfContactMeetingRow extends OkApiResponse implements INrTableResponseOfContactMeetingRow {
    /** Array delle righe della pagina richiesta */
    rows?: ContactMeetingRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfContactMeetingRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ContactMeetingRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfContactMeetingRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfContactMeetingRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfContactMeetingRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: ContactMeetingRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class ContactMeetingListRequest extends NrTableRequest implements IContactMeetingListRequest {
    authUserId?: number | null;
    dateFrom?: string | null;
    dateTo?: string | null;
    contactId?: number | null;

    constructor(data?: IContactMeetingListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.authUserId = _data["authUserId"] !== undefined ? _data["authUserId"] : null as any;
            this.dateFrom = _data["dateFrom"] !== undefined ? _data["dateFrom"] : null as any;
            this.dateTo = _data["dateTo"] !== undefined ? _data["dateTo"] : null as any;
            this.contactId = _data["contactId"] !== undefined ? _data["contactId"] : null as any;
        }
    }

    static override fromJS(data: any): ContactMeetingListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContactMeetingListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authUserId"] = this.authUserId !== undefined ? this.authUserId : null as any;
        data["dateFrom"] = this.dateFrom !== undefined ? this.dateFrom : null as any;
        data["dateTo"] = this.dateTo !== undefined ? this.dateTo : null as any;
        data["contactId"] = this.contactId !== undefined ? this.contactId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IContactMeetingListRequest extends INrTableRequest {
    authUserId?: number | null;
    dateFrom?: string | null;
    dateTo?: string | null;
    contactId?: number | null;
}

export class ContactMeetingUpsertRequest extends ContactMeetingGetRequest implements IContactMeetingUpsertRequest {
    meeting!: ContactMeeting;

    constructor(data?: IContactMeetingUpsertRequest) {
        super(data);
        if (!data) {
            this.meeting = new ContactMeeting();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.meeting = _data["meeting"] ? ContactMeeting.fromJS(_data["meeting"]) : new ContactMeeting();
        }
    }

    static override fromJS(data: any): ContactMeetingUpsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContactMeetingUpsertRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meeting"] = this.meeting ? this.meeting.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IContactMeetingUpsertRequest extends IContactMeetingGetRequest {
    meeting: ContactMeeting;
}

export class ContactsGetAgencyGroupsResponse extends OkApiResponse implements IContactsGetAgencyGroupsResponse {
    agencyGroups?: AgencyGroup[];

    constructor(data?: IContactsGetAgencyGroupsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["agencyGroups"])) {
                this.agencyGroups = [] as any;
                for (let item of _data["agencyGroups"])
                    this.agencyGroups!.push(AgencyGroup.fromJS(item));
            }
            else {
                this.agencyGroups = null as any;
            }
        }
    }

    static override fromJS(data: any): ContactsGetAgencyGroupsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ContactsGetAgencyGroupsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.agencyGroups)) {
            data["agencyGroups"] = [];
            for (let item of this.agencyGroups)
                data["agencyGroups"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IContactsGetAgencyGroupsResponse extends IOkApiResponse {
    agencyGroups?: AgencyGroup[];
}

export class AgencyGroup implements IAgencyGroup {
    id?: number;
    name?: string;

    constructor(data?: IAgencyGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): AgencyGroup {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export interface IAgencyGroup {
    id?: number;
    name?: string;
}

export class ContactsGetAgencyGroupsRequest extends ApiRequest implements IContactsGetAgencyGroupsRequest {

    constructor(data?: IContactsGetAgencyGroupsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ContactsGetAgencyGroupsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContactsGetAgencyGroupsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IContactsGetAgencyGroupsRequest extends IApiRequest {
}

export class GetContattoResponse extends OkApiResponse implements IGetContattoResponse {
    contatto?: ContactListRow;
    mappa?: Mappa;
    logo?: LogoInfo;

    constructor(data?: IGetContattoResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contatto = _data["contatto"] ? ContactListRow.fromJS(_data["contatto"]) : null as any;
            this.mappa = _data["mappa"] ? Mappa.fromJS(_data["mappa"]) : null as any;
            this.logo = _data["logo"] ? LogoInfo.fromJS(_data["logo"]) : null as any;
        }
    }

    static override fromJS(data: any): GetContattoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetContattoResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contatto"] = this.contatto ? this.contatto.toJSON() : null as any;
        data["mappa"] = this.mappa ? this.mappa.toJSON() : null as any;
        data["logo"] = this.logo ? this.logo.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetContattoResponse extends IOkApiResponse {
    contatto?: ContactListRow;
    mappa?: Mappa;
    logo?: LogoInfo;
}

/** Classe che rappresenta una singola riga dell'elenco contatti */
export class ContactListRow implements IContactListRow {
    /** ID del contatto */
    id?: number;
    /** Nome proprio per le persone oppure nome colloquiale per agenzie e società */
    nome?: string | null;
    /** Cognome per le persone fisiche oppure ragione sociale per agenzie e società */
    cognome?: string | null;
    /** Nome del luogo associato al contatto */
    luogo?: string | null;
    /** True se il luogo associato è stato eliminato */
    luogoEliminato?: boolean;
    /** Nome del luogo associato al contatto */
    luogoID?: number | null;
    /** Nome della regione del luogo associato al contatto */
    regione?: string | null;
    /** Nome del paese del luogo associato al contatto */
    paese?: string | null;
    /** CAP dell'indirizzo del contatto  */
    cap?: string | null;
    /** Indirizzo del contatto, incluso il numero civico */
    indirizzo?: string | null;
    /** Numero di telefono del contatto */
    telefono?: string | null;
    /** Partita IVA del contatto */
    partitaIVA?: string | null;
    /** Indirizzo email del contatto */
    email?: string | null;
    /** Nome visualizzato del contatto promotore */
    promotore?: string | null;
    /** Nome della categoria per le agenzie */
    categoria?: string | null;
    /** Nome visualizzato del contatto network per le agenzie */
    network?: string | null;
    /** Nome dell'accordo */
    accordoCommerciale?: string | null;
    /** Nome del metodo di pagamento dei servizi a terra */
    pagamentoServiziTerra?: string | null;
    /** Nome del metodo di pagamento dei servizi volo (biglietteria) */
    pagamentoServiziVolo?: string | null;
    /** True se i dati di un contatto hotel sono completi */
    datiHotelOk?: boolean;
    /** True se il contatto hotel ha la mappa */
    mappaOk?: boolean;
    /** True se il contatto hotel ha almeno un servizio associato */
    haServizi?: boolean;
    lingua?: number | null;
    contatto?: Contatto;

    constructor(data?: IContactListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.luogoEliminato = _data["luogoEliminato"] !== undefined ? _data["luogoEliminato"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.regione = _data["regione"] !== undefined ? _data["regione"] : null as any;
            this.paese = _data["paese"] !== undefined ? _data["paese"] : null as any;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : null as any;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : null as any;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : null as any;
            this.partitaIVA = _data["partitaIVA"] !== undefined ? _data["partitaIVA"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.promotore = _data["promotore"] !== undefined ? _data["promotore"] : null as any;
            this.categoria = _data["categoria"] !== undefined ? _data["categoria"] : null as any;
            this.network = _data["network"] !== undefined ? _data["network"] : null as any;
            this.accordoCommerciale = _data["accordoCommerciale"] !== undefined ? _data["accordoCommerciale"] : null as any;
            this.pagamentoServiziTerra = _data["pagamentoServiziTerra"] !== undefined ? _data["pagamentoServiziTerra"] : null as any;
            this.pagamentoServiziVolo = _data["pagamentoServiziVolo"] !== undefined ? _data["pagamentoServiziVolo"] : null as any;
            this.datiHotelOk = _data["datiHotelOk"] !== undefined ? _data["datiHotelOk"] : null as any;
            this.mappaOk = _data["mappaOk"] !== undefined ? _data["mappaOk"] : null as any;
            this.haServizi = _data["haServizi"] !== undefined ? _data["haServizi"] : null as any;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : null as any;
            this.contatto = _data["contatto"] ? Contatto.fromJS(_data["contatto"]) : null as any;
        }
    }

    static fromJS(data: any): ContactListRow {
        data = typeof data === 'object' ? data : {};
        let result = new ContactListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["cognome"] = this.cognome !== undefined ? this.cognome : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["luogoEliminato"] = this.luogoEliminato !== undefined ? this.luogoEliminato : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["regione"] = this.regione !== undefined ? this.regione : null as any;
        data["paese"] = this.paese !== undefined ? this.paese : null as any;
        data["cap"] = this.cap !== undefined ? this.cap : null as any;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : null as any;
        data["telefono"] = this.telefono !== undefined ? this.telefono : null as any;
        data["partitaIVA"] = this.partitaIVA !== undefined ? this.partitaIVA : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["promotore"] = this.promotore !== undefined ? this.promotore : null as any;
        data["categoria"] = this.categoria !== undefined ? this.categoria : null as any;
        data["network"] = this.network !== undefined ? this.network : null as any;
        data["accordoCommerciale"] = this.accordoCommerciale !== undefined ? this.accordoCommerciale : null as any;
        data["pagamentoServiziTerra"] = this.pagamentoServiziTerra !== undefined ? this.pagamentoServiziTerra : null as any;
        data["pagamentoServiziVolo"] = this.pagamentoServiziVolo !== undefined ? this.pagamentoServiziVolo : null as any;
        data["datiHotelOk"] = this.datiHotelOk !== undefined ? this.datiHotelOk : null as any;
        data["mappaOk"] = this.mappaOk !== undefined ? this.mappaOk : null as any;
        data["haServizi"] = this.haServizi !== undefined ? this.haServizi : null as any;
        data["lingua"] = this.lingua !== undefined ? this.lingua : null as any;
        data["contatto"] = this.contatto ? this.contatto.toJSON() : null as any;
        return data;
    }
}

/** Classe che rappresenta una singola riga dell'elenco contatti */
export interface IContactListRow {
    /** ID del contatto */
    id?: number;
    /** Nome proprio per le persone oppure nome colloquiale per agenzie e società */
    nome?: string | null;
    /** Cognome per le persone fisiche oppure ragione sociale per agenzie e società */
    cognome?: string | null;
    /** Nome del luogo associato al contatto */
    luogo?: string | null;
    /** True se il luogo associato è stato eliminato */
    luogoEliminato?: boolean;
    /** Nome del luogo associato al contatto */
    luogoID?: number | null;
    /** Nome della regione del luogo associato al contatto */
    regione?: string | null;
    /** Nome del paese del luogo associato al contatto */
    paese?: string | null;
    /** CAP dell'indirizzo del contatto  */
    cap?: string | null;
    /** Indirizzo del contatto, incluso il numero civico */
    indirizzo?: string | null;
    /** Numero di telefono del contatto */
    telefono?: string | null;
    /** Partita IVA del contatto */
    partitaIVA?: string | null;
    /** Indirizzo email del contatto */
    email?: string | null;
    /** Nome visualizzato del contatto promotore */
    promotore?: string | null;
    /** Nome della categoria per le agenzie */
    categoria?: string | null;
    /** Nome visualizzato del contatto network per le agenzie */
    network?: string | null;
    /** Nome dell'accordo */
    accordoCommerciale?: string | null;
    /** Nome del metodo di pagamento dei servizi a terra */
    pagamentoServiziTerra?: string | null;
    /** Nome del metodo di pagamento dei servizi volo (biglietteria) */
    pagamentoServiziVolo?: string | null;
    /** True se i dati di un contatto hotel sono completi */
    datiHotelOk?: boolean;
    /** True se il contatto hotel ha la mappa */
    mappaOk?: boolean;
    /** True se il contatto hotel ha almeno un servizio associato */
    haServizi?: boolean;
    lingua?: number | null;
    contatto?: Contatto;
}

export class Mappa implements IMappa {
    mappaID?: number;
    tabella!: string;
    entitaID?: number;
    latitudine?: number | null;
    longitudine?: number | null;
    provider?: number | null;
    zoom?: number | null;
    layout?: number | null;

    constructor(data?: IMappa) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mappaID = _data["mappaID"] !== undefined ? _data["mappaID"] : null as any;
            this.tabella = _data["tabella"] !== undefined ? _data["tabella"] : null as any;
            this.entitaID = _data["entitaID"] !== undefined ? _data["entitaID"] : null as any;
            this.latitudine = _data["latitudine"] !== undefined ? _data["latitudine"] : null as any;
            this.longitudine = _data["longitudine"] !== undefined ? _data["longitudine"] : null as any;
            this.provider = _data["provider"] !== undefined ? _data["provider"] : null as any;
            this.zoom = _data["zoom"] !== undefined ? _data["zoom"] : null as any;
            this.layout = _data["layout"] !== undefined ? _data["layout"] : null as any;
        }
    }

    static fromJS(data: any): Mappa {
        data = typeof data === 'object' ? data : {};
        let result = new Mappa();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mappaID"] = this.mappaID !== undefined ? this.mappaID : null as any;
        data["tabella"] = this.tabella !== undefined ? this.tabella : null as any;
        data["entitaID"] = this.entitaID !== undefined ? this.entitaID : null as any;
        data["latitudine"] = this.latitudine !== undefined ? this.latitudine : null as any;
        data["longitudine"] = this.longitudine !== undefined ? this.longitudine : null as any;
        data["provider"] = this.provider !== undefined ? this.provider : null as any;
        data["zoom"] = this.zoom !== undefined ? this.zoom : null as any;
        data["layout"] = this.layout !== undefined ? this.layout : null as any;
        return data;
    }
}

export interface IMappa {
    mappaID?: number;
    tabella: string;
    entitaID?: number;
    latitudine?: number | null;
    longitudine?: number | null;
    provider?: number | null;
    zoom?: number | null;
    layout?: number | null;
}

export class LogoInfo implements ILogoInfo {
    id?: number;
    logo?: ContattoLogo;
    exists?: boolean;
    filePath?: string | null;
    url?: string | null;
    base64?: string;

    constructor(data?: ILogoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.logo = _data["logo"] ? ContattoLogo.fromJS(_data["logo"]) : null as any;
            this.exists = _data["exists"] !== undefined ? _data["exists"] : null as any;
            this.filePath = _data["filePath"] !== undefined ? _data["filePath"] : null as any;
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
            this.base64 = _data["base64"] !== undefined ? _data["base64"] : null as any;
        }
    }

    static fromJS(data: any): LogoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new LogoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["logo"] = this.logo ? this.logo.toJSON() : null as any;
        data["exists"] = this.exists !== undefined ? this.exists : null as any;
        data["filePath"] = this.filePath !== undefined ? this.filePath : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        data["base64"] = this.base64 !== undefined ? this.base64 : null as any;
        return data;
    }
}

export interface ILogoInfo {
    id?: number;
    logo?: ContattoLogo;
    exists?: boolean;
    filePath?: string | null;
    url?: string | null;
    base64?: string;
}

export class ContattoLogo implements IContattoLogo {
    contattoLogoID?: number;
    contattoID?: number;
    stampaSuOfferta?: boolean;
    stampaSuPreventivo?: boolean;
    stampaSuProgramma?: boolean;
    stampaSuConferma?: boolean | null;
    caricato?: string;
    nome?: string | null;
    nomeOriginale?: string | null;

    constructor(data?: IContattoLogo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contattoLogoID = _data["contattoLogoID"] !== undefined ? _data["contattoLogoID"] : null as any;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.stampaSuOfferta = _data["stampaSuOfferta"] !== undefined ? _data["stampaSuOfferta"] : null as any;
            this.stampaSuPreventivo = _data["stampaSuPreventivo"] !== undefined ? _data["stampaSuPreventivo"] : null as any;
            this.stampaSuProgramma = _data["stampaSuProgramma"] !== undefined ? _data["stampaSuProgramma"] : null as any;
            this.stampaSuConferma = _data["stampaSuConferma"] !== undefined ? _data["stampaSuConferma"] : null as any;
            this.caricato = _data["caricato"] !== undefined ? _data["caricato"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nomeOriginale = _data["nomeOriginale"] !== undefined ? _data["nomeOriginale"] : null as any;
        }
    }

    static fromJS(data: any): ContattoLogo {
        data = typeof data === 'object' ? data : {};
        let result = new ContattoLogo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoLogoID"] = this.contattoLogoID !== undefined ? this.contattoLogoID : null as any;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["stampaSuOfferta"] = this.stampaSuOfferta !== undefined ? this.stampaSuOfferta : null as any;
        data["stampaSuPreventivo"] = this.stampaSuPreventivo !== undefined ? this.stampaSuPreventivo : null as any;
        data["stampaSuProgramma"] = this.stampaSuProgramma !== undefined ? this.stampaSuProgramma : null as any;
        data["stampaSuConferma"] = this.stampaSuConferma !== undefined ? this.stampaSuConferma : null as any;
        data["caricato"] = this.caricato !== undefined ? this.caricato : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nomeOriginale"] = this.nomeOriginale !== undefined ? this.nomeOriginale : null as any;
        return data;
    }
}

export interface IContattoLogo {
    contattoLogoID?: number;
    contattoID?: number;
    stampaSuOfferta?: boolean;
    stampaSuPreventivo?: boolean;
    stampaSuProgramma?: boolean;
    stampaSuConferma?: boolean | null;
    caricato?: string;
    nome?: string | null;
    nomeOriginale?: string | null;
}

export class UpsertContattoRequest extends LocalizedRequest implements IUpsertContattoRequest {
    contatto?: Contatto | null;
    logo?: LogoUpsert | null;

    constructor(data?: IUpsertContattoRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contatto = _data["contatto"] ? Contatto.fromJS(_data["contatto"]) : null as any;
            this.logo = _data["logo"] ? LogoUpsert.fromJS(_data["logo"]) : null as any;
        }
    }

    static override fromJS(data: any): UpsertContattoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertContattoRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contatto"] = this.contatto ? this.contatto.toJSON() : null as any;
        data["logo"] = this.logo ? this.logo.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertContattoRequest extends ILocalizedRequest {
    contatto?: Contatto | null;
    logo?: LogoUpsert | null;
}

export class LogoUpsert implements ILogoUpsert {
    logoDataBase64?: string | null;
    contentType?: string | null;
    fileName?: string | null;

    constructor(data?: ILogoUpsert) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logoDataBase64 = _data["logoDataBase64"] !== undefined ? _data["logoDataBase64"] : null as any;
            this.contentType = _data["contentType"] !== undefined ? _data["contentType"] : null as any;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
        }
    }

    static fromJS(data: any): LogoUpsert {
        data = typeof data === 'object' ? data : {};
        let result = new LogoUpsert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logoDataBase64"] = this.logoDataBase64 !== undefined ? this.logoDataBase64 : null as any;
        data["contentType"] = this.contentType !== undefined ? this.contentType : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        return data;
    }
}

export interface ILogoUpsert {
    logoDataBase64?: string | null;
    contentType?: string | null;
    fileName?: string | null;
}

export class CreateUtenteAgenziaResponse extends OkApiResponse implements ICreateUtenteAgenziaResponse {
    /** Entità creata */
    utente?: UtenteRow;

    constructor(data?: ICreateUtenteAgenziaResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.utente = _data["utente"] ? UtenteRow.fromJS(_data["utente"]) : null as any;
        }
    }

    static override fromJS(data: any): CreateUtenteAgenziaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUtenteAgenziaResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utente"] = this.utente ? this.utente.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateUtenteAgenziaResponse extends IOkApiResponse {
    /** Entità creata */
    utente?: UtenteRow;
}

export class UtenteRow implements IUtenteRow {
    id?: number;
    nome?: string;
    email?: string | null;
    tipoUtente?: ETipoUtente;
    otherInfo?: Utente | null;
    isSecondaryUser?: boolean;

    constructor(data?: IUtenteRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.tipoUtente = _data["tipoUtente"] !== undefined ? _data["tipoUtente"] : null as any;
            this.otherInfo = _data["otherInfo"] ? Utente.fromJS(_data["otherInfo"]) : null as any;
            this.isSecondaryUser = _data["isSecondaryUser"] !== undefined ? _data["isSecondaryUser"] : null as any;
        }
    }

    static fromJS(data: any): UtenteRow {
        data = typeof data === 'object' ? data : {};
        let result = new UtenteRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["tipoUtente"] = this.tipoUtente !== undefined ? this.tipoUtente : null as any;
        data["otherInfo"] = this.otherInfo ? this.otherInfo.toJSON() : null as any;
        data["isSecondaryUser"] = this.isSecondaryUser !== undefined ? this.isSecondaryUser : null as any;
        return data;
    }
}

export interface IUtenteRow {
    id?: number;
    nome?: string;
    email?: string | null;
    tipoUtente?: ETipoUtente;
    otherInfo?: Utente | null;
    isSecondaryUser?: boolean;
}

export class CreateUtenteAgenziaRequest extends SiteRequest implements ICreateUtenteAgenziaRequest {
    /** Indirizzo email dell'utente */
    email!: string;
    /** Nome proprio */
    nome!: string;
    /** Cognome, facoltativo */
    cognome?: string | null;
    /** Numero di telefono dell'utente, facoltativo */
    telefono?: string | null;
    /** ID del contatto agenzia (Travel agent). Se omesso, usa quello dell'utente corrente. */
    contattoAgenziaID?: number | null;
    /** Tipo utente. Se omesso, default Agenzia. */
    tipoUtente?: ETipoUtente | null;
    /** ID operatore. Se omesso, usa quello dell'utente corrente. */
    operatoreID?: number | null;
    /** Se l'utente è abilitato.  */
    abilitato?: boolean | null;
    /** Se il login tramite email è abilitato.  */
    emailLoginEnabled?: boolean | null;
    /** Inhibit booking (npr).  */
    npr?: boolean | null;

    constructor(data?: ICreateUtenteAgenziaRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : null as any;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : null as any;
            this.contattoAgenziaID = _data["contattoAgenziaID"] !== undefined ? _data["contattoAgenziaID"] : null as any;
            this.tipoUtente = _data["tipoUtente"] !== undefined ? _data["tipoUtente"] : null as any;
            this.operatoreID = _data["operatoreID"] !== undefined ? _data["operatoreID"] : null as any;
            this.abilitato = _data["abilitato"] !== undefined ? _data["abilitato"] : null as any;
            this.emailLoginEnabled = _data["emailLoginEnabled"] !== undefined ? _data["emailLoginEnabled"] : null as any;
            this.npr = _data["npr"] !== undefined ? _data["npr"] : null as any;
        }
    }

    static override fromJS(data: any): CreateUtenteAgenziaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUtenteAgenziaRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["cognome"] = this.cognome !== undefined ? this.cognome : null as any;
        data["telefono"] = this.telefono !== undefined ? this.telefono : null as any;
        data["contattoAgenziaID"] = this.contattoAgenziaID !== undefined ? this.contattoAgenziaID : null as any;
        data["tipoUtente"] = this.tipoUtente !== undefined ? this.tipoUtente : null as any;
        data["operatoreID"] = this.operatoreID !== undefined ? this.operatoreID : null as any;
        data["abilitato"] = this.abilitato !== undefined ? this.abilitato : null as any;
        data["emailLoginEnabled"] = this.emailLoginEnabled !== undefined ? this.emailLoginEnabled : null as any;
        data["npr"] = this.npr !== undefined ? this.npr : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateUtenteAgenziaRequest extends ISiteRequest {
    /** Indirizzo email dell'utente */
    email: string;
    /** Nome proprio */
    nome: string;
    /** Cognome, facoltativo */
    cognome?: string | null;
    /** Numero di telefono dell'utente, facoltativo */
    telefono?: string | null;
    /** ID del contatto agenzia (Travel agent). Se omesso, usa quello dell'utente corrente. */
    contattoAgenziaID?: number | null;
    /** Tipo utente. Se omesso, default Agenzia. */
    tipoUtente?: ETipoUtente | null;
    /** ID operatore. Se omesso, usa quello dell'utente corrente. */
    operatoreID?: number | null;
    /** Se l'utente è abilitato.  */
    abilitato?: boolean | null;
    /** Se il login tramite email è abilitato.  */
    emailLoginEnabled?: boolean | null;
    /** Inhibit booking (npr).  */
    npr?: boolean | null;
}

export class DeleteContattoRequest extends LocalizedRequest implements IDeleteContattoRequest {
    contattoId?: number;

    constructor(data?: IDeleteContattoRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoId = _data["contattoId"] !== undefined ? _data["contattoId"] : null as any;
        }
    }

    static override fromJS(data: any): DeleteContattoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteContattoRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoId"] = this.contattoId !== undefined ? this.contattoId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteContattoRequest extends ILocalizedRequest {
    contattoId?: number;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class DeleteAccordoContattoRequest extends LocalizedRequest implements IDeleteAccordoContattoRequest {
    contattoID?: number;
    accordoContattoID?: number;

    constructor(data?: IDeleteAccordoContattoRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.accordoContattoID = _data["accordoContattoID"] !== undefined ? _data["accordoContattoID"] : null as any;
        }
    }

    static override fromJS(data: any): DeleteAccordoContattoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteAccordoContattoRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["accordoContattoID"] = this.accordoContattoID !== undefined ? this.accordoContattoID : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IDeleteAccordoContattoRequest extends ILocalizedRequest {
    contattoID?: number;
    accordoContattoID?: number;
}

export class DeleteMappaContattoRequest extends LocalizedRequest implements IDeleteMappaContattoRequest {
    contattoId?: number;

    constructor(data?: IDeleteMappaContattoRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoId = _data["contattoId"] !== undefined ? _data["contattoId"] : null as any;
        }
    }

    static override fromJS(data: any): DeleteMappaContattoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMappaContattoRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoId"] = this.contattoId !== undefined ? this.contattoId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteMappaContattoRequest extends ILocalizedRequest {
    contattoId?: number;
}

export class GetContattoRequest extends LocalizedRequest implements IGetContattoRequest {
    contattoId?: number;

    constructor(data?: IGetContattoRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoId = _data["contattoId"] !== undefined ? _data["contattoId"] : null as any;
        }
    }

    static override fromJS(data: any): GetContattoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetContattoRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoId"] = this.contattoId !== undefined ? this.contattoId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetContattoRequest extends ILocalizedRequest {
    contattoId?: number;
}

export class GetAccordiAggiuntiviResoponse extends OkApiResponse implements IGetAccordiAggiuntiviResoponse {
    rows?: AccordoAggiuntivoRow[] | null;

    constructor(data?: IGetAccordiAggiuntiviResoponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AccordoAggiuntivoRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
        }
    }

    static override fromJS(data: any): GetAccordiAggiuntiviResoponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccordiAggiuntiviResoponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetAccordiAggiuntiviResoponse extends IOkApiResponse {
    rows?: AccordoAggiuntivoRow[] | null;
}

export class AccordoAggiuntivoRow implements IAccordoAggiuntivoRow {
    id?: number;
    accordoID?: number;
    nome?: string | null;
    dal?: string | null;
    al?: string | null;
    operatore?: EOperatore;
    accordoContatto?: AccordoContatto | null;

    constructor(data?: IAccordoAggiuntivoRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.al = _data["al"] !== undefined ? _data["al"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.accordoContatto = _data["accordoContatto"] ? AccordoContatto.fromJS(_data["accordoContatto"]) : null as any;
        }
    }

    static fromJS(data: any): AccordoAggiuntivoRow {
        data = typeof data === 'object' ? data : {};
        let result = new AccordoAggiuntivoRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["al"] = this.al !== undefined ? this.al : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["accordoContatto"] = this.accordoContatto ? this.accordoContatto.toJSON() : null as any;
        return data;
    }
}

export interface IAccordoAggiuntivoRow {
    id?: number;
    accordoID?: number;
    nome?: string | null;
    dal?: string | null;
    al?: string | null;
    operatore?: EOperatore;
    accordoContatto?: AccordoContatto | null;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class GetAccordiAggiuntiviRequest extends LocalizedRequest implements IGetAccordiAggiuntiviRequest {
    contattoId?: number;

    constructor(data?: IGetAccordiAggiuntiviRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoId = _data["contattoId"] !== undefined ? _data["contattoId"] : null as any;
        }
    }

    static override fromJS(data: any): GetAccordiAggiuntiviRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccordiAggiuntiviRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoId"] = this.contattoId !== undefined ? this.contattoId : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IGetAccordiAggiuntiviRequest extends ILocalizedRequest {
    contattoId?: number;
}

export class GetAccordiDirettiResponse extends OkApiResponse implements IGetAccordiDirettiResponse {
    rows?: AccordoDirettoRow[] | null;

    constructor(data?: IGetAccordiDirettiResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AccordoDirettoRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
        }
    }

    static override fromJS(data: any): GetAccordiDirettiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccordiDirettiResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetAccordiDirettiResponse extends IOkApiResponse {
    rows?: AccordoDirettoRow[] | null;
}

export class AccordoDirettoRow implements IAccordoDirettoRow {
    id?: number;
    nome?: string | null;
    dal?: string | null;
    al?: string | null;

    constructor(data?: IAccordoDirettoRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.al = _data["al"] !== undefined ? _data["al"] : null as any;
        }
    }

    static fromJS(data: any): AccordoDirettoRow {
        data = typeof data === 'object' ? data : {};
        let result = new AccordoDirettoRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["al"] = this.al !== undefined ? this.al : null as any;
        return data;
    }
}

export interface IAccordoDirettoRow {
    id?: number;
    nome?: string | null;
    dal?: string | null;
    al?: string | null;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class GetAccordiDirettiRequest extends LocalizedRequest implements IGetAccordiDirettiRequest {
    contattoId?: number;

    constructor(data?: IGetAccordiDirettiRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoId = _data["contattoId"] !== undefined ? _data["contattoId"] : null as any;
        }
    }

    static override fromJS(data: any): GetAccordiDirettiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccordiDirettiRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoId"] = this.contattoId !== undefined ? this.contattoId : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IGetAccordiDirettiRequest extends ILocalizedRequest {
    contattoId?: number;
}

export class GetCategorieContattoResoponse extends OkApiResponse implements IGetCategorieContattoResoponse {
    rows?: CategoriaContatto[] | null;

    constructor(data?: IGetCategorieContattoResoponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(CategoriaContatto.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
        }
    }

    static override fromJS(data: any): GetCategorieContattoResoponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCategorieContattoResoponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetCategorieContattoResoponse extends IOkApiResponse {
    rows?: CategoriaContatto[] | null;
}

export class CategoriaContatto implements ICategoriaContatto {
    categoriaContattoID?: number;
    memo?: string | null;
    nome?: string | null;
    operatore?: EOperatore | null;

    constructor(data?: ICategoriaContatto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoriaContattoID = _data["categoriaContattoID"] !== undefined ? _data["categoriaContattoID"] : null as any;
            this.memo = _data["memo"] !== undefined ? _data["memo"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
        }
    }

    static fromJS(data: any): CategoriaContatto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoriaContatto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoriaContattoID"] = this.categoriaContattoID !== undefined ? this.categoriaContattoID : null as any;
        data["memo"] = this.memo !== undefined ? this.memo : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        return data;
    }
}

export interface ICategoriaContatto {
    categoriaContattoID?: number;
    memo?: string | null;
    nome?: string | null;
    operatore?: EOperatore | null;
}

export class GetDatiAggiuntiviContattoResponse extends OkApiResponse implements IGetDatiAggiuntiviContattoResponse {
    rows?: ContattoDato[] | null;

    constructor(data?: IGetDatiAggiuntiviContattoResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ContattoDato.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
        }
    }

    static override fromJS(data: any): GetDatiAggiuntiviContattoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDatiAggiuntiviContattoResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetDatiAggiuntiviContattoResponse extends IOkApiResponse {
    rows?: ContattoDato[] | null;
}

export class ContattoDato implements IContattoDato {
    contattoDatoID?: number;
    contattoID?: number;
    tipoDatoID?: number;
    tipoDato?: ETipoDatoContatto;
    testo?: string | null;

    constructor(data?: IContattoDato) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contattoDatoID = _data["contattoDatoID"] !== undefined ? _data["contattoDatoID"] : null as any;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.tipoDatoID = _data["tipoDatoID"] !== undefined ? _data["tipoDatoID"] : null as any;
            this.tipoDato = _data["tipoDato"] !== undefined ? _data["tipoDato"] : null as any;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : null as any;
        }
    }

    static fromJS(data: any): ContattoDato {
        data = typeof data === 'object' ? data : {};
        let result = new ContattoDato();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoDatoID"] = this.contattoDatoID !== undefined ? this.contattoDatoID : null as any;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["tipoDatoID"] = this.tipoDatoID !== undefined ? this.tipoDatoID : null as any;
        data["tipoDato"] = this.tipoDato !== undefined ? this.tipoDato : null as any;
        data["testo"] = this.testo !== undefined ? this.testo : null as any;
        return data;
    }
}

export interface IContattoDato {
    contattoDatoID?: number;
    contattoID?: number;
    tipoDatoID?: number;
    tipoDato?: ETipoDatoContatto;
    testo?: string | null;
}

export enum ETipoDatoContatto {
    NonDefinito = "NonDefinito",
    PosizioneAgenzia = "PosizioneAgenzia",
    Responsabile = "Responsabile",
    Regione = "Regione",
    PartitaIVA = "PartitaIVA",
    CodiceFiscale = "CodiceFiscale",
    CodiceAdHoc = "CodiceAdHoc",
    NoteOfferta = "NoteOfferta",
    ProvinciaAgenzie = "ProvinciaAgenzie",
    CodAviomar = "CodAviomar",
    CodiceIATA = "CodiceIATA",
    PCC = "PCC",
    PasswordTicketStats = "PasswordTicketStats",
    NotaCommercialeAgenzia = "NotaCommercialeAgenzia",
    Sesso = "Sesso",
    Provincia = "Provincia",
    Citta = "Citta",
    AccessoBetaTest = "AccessoBetaTest",
    SsoToken = "SsoToken",
    ContrattoAgenzia = "ContrattoAgenzia",
    CodicePrioritaTelefonica = "CodicePrioritaTelefonica",
    CodiceUnivocoAgenziaFE = "CodiceUnivocoAgenziaFE",
    IndirizzoPecAgenziaFE = "IndirizzoPecAgenziaFE",
    IndirizzoPEC = "IndirizzoPEC",
    FEsenzaPECneCodice = "FEsenzaPECneCodice",
    SitoWeb = "SitoWeb",
    UrlLogo = "UrlLogo",
    BosysID = "BosysID",
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class GetDatiAggiuntiviContattoRequest extends LocalizedRequest implements IGetDatiAggiuntiviContattoRequest {
    contattoId?: number;

    constructor(data?: IGetDatiAggiuntiviContattoRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoId = _data["contattoId"] !== undefined ? _data["contattoId"] : null as any;
        }
    }

    static override fromJS(data: any): GetDatiAggiuntiviContattoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDatiAggiuntiviContattoRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoId"] = this.contattoId !== undefined ? this.contattoId : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IGetDatiAggiuntiviContattoRequest extends ILocalizedRequest {
    contattoId?: number;
}

export class GetMansioniResoponse extends OkApiResponse implements IGetMansioniResoponse {
    rows?: Mansione[] | null;

    constructor(data?: IGetMansioniResoponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(Mansione.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
        }
    }

    static override fromJS(data: any): GetMansioniResoponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMansioniResoponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetMansioniResoponse extends IOkApiResponse {
    rows?: Mansione[] | null;
}

export class Mansione implements IMansione {
    id?: number;
    nome!: string;
    descrizione?: string | null;

    constructor(data?: IMansione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
        }
    }

    static fromJS(data: any): Mansione {
        data = typeof data === 'object' ? data : {};
        let result = new Mansione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        return data;
    }
}

export interface IMansione {
    id?: number;
    nome: string;
    descrizione?: string | null;
}

export class GetProfileResponse extends OkApiResponse implements IGetProfileResponse {
    /** Dati generici */
    profileData?: ProfileData;
    /** Dati del logo */
    logoData?: LogoData | null;
    /** Dati di fatturazione */
    invoiceData?: ProfileInvoiceData;

    constructor(data?: IGetProfileResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.profileData = _data["profileData"] ? ProfileData.fromJS(_data["profileData"]) : null as any;
            this.logoData = _data["logoData"] ? LogoData.fromJS(_data["logoData"]) : null as any;
            this.invoiceData = _data["invoiceData"] ? ProfileInvoiceData.fromJS(_data["invoiceData"]) : null as any;
        }
    }

    static override fromJS(data: any): GetProfileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfileResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileData"] = this.profileData ? this.profileData.toJSON() : null as any;
        data["logoData"] = this.logoData ? this.logoData.toJSON() : null as any;
        data["invoiceData"] = this.invoiceData ? this.invoiceData.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetProfileResponse extends IOkApiResponse {
    /** Dati generici */
    profileData?: ProfileData;
    /** Dati del logo */
    logoData?: LogoData | null;
    /** Dati di fatturazione */
    invoiceData?: ProfileInvoiceData;
}

/** Dati generici di profilo di un'agenzia */
export class ProfileData implements IProfileData {
    /** Nome colloquiale dell'agenzia */
    nome?: string | null;
    /** Indirizzo generico, senza il civico */
    indirizzo?: string | null;
    /** Codice avviamento postale o assimilabile */
    cap?: string | null;
    /** Numero civico */
    civico?: string | null;
    /** ID del luogo */
    luogoID?: number | null;
    /** Città, prelevata dal luogo */
    citta?: string | null;
    /** Indirizzo email generico */
    email?: string | null;
    /** Numero di telefono */
    telefono?: string | null;
    /** Numero di fax. Ma chi cavolo usa ancora il fax? */
    fax?: string | null;

    constructor(data?: IProfileData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : null as any;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : null as any;
            this.civico = _data["civico"] !== undefined ? _data["civico"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.citta = _data["citta"] !== undefined ? _data["citta"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : null as any;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : null as any;
        }
    }

    static fromJS(data: any): ProfileData {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : null as any;
        data["cap"] = this.cap !== undefined ? this.cap : null as any;
        data["civico"] = this.civico !== undefined ? this.civico : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["citta"] = this.citta !== undefined ? this.citta : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["telefono"] = this.telefono !== undefined ? this.telefono : null as any;
        data["fax"] = this.fax !== undefined ? this.fax : null as any;
        return data;
    }
}

/** Dati generici di profilo di un'agenzia */
export interface IProfileData {
    /** Nome colloquiale dell'agenzia */
    nome?: string | null;
    /** Indirizzo generico, senza il civico */
    indirizzo?: string | null;
    /** Codice avviamento postale o assimilabile */
    cap?: string | null;
    /** Numero civico */
    civico?: string | null;
    /** ID del luogo */
    luogoID?: number | null;
    /** Città, prelevata dal luogo */
    citta?: string | null;
    /** Indirizzo email generico */
    email?: string | null;
    /** Numero di telefono */
    telefono?: string | null;
    /** Numero di fax. Ma chi cavolo usa ancora il fax? */
    fax?: string | null;
}

/** Dati del logo, predisposti per loghi multipli */
export class LogoData implements ILogoData {
    /** Url assoluta del logo attuale */
    logoURL?: string;
    /** Questo logo viene usato sulle offerte */
    stampaSuOfferta?: boolean;
    /** Questo logo viene usato sui preventivi */
    stampaSuPreventivo?: boolean;
    /** Questo logo viene usato sul programma di viaggio */
    stampaSuProgramma?: boolean;
    /** Questo logo viene usato sulle conferme */
    stampaSuConferma?: boolean;

    constructor(data?: ILogoData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logoURL = _data["logoURL"] !== undefined ? _data["logoURL"] : null as any;
            this.stampaSuOfferta = _data["stampaSuOfferta"] !== undefined ? _data["stampaSuOfferta"] : null as any;
            this.stampaSuPreventivo = _data["stampaSuPreventivo"] !== undefined ? _data["stampaSuPreventivo"] : null as any;
            this.stampaSuProgramma = _data["stampaSuProgramma"] !== undefined ? _data["stampaSuProgramma"] : null as any;
            this.stampaSuConferma = _data["stampaSuConferma"] !== undefined ? _data["stampaSuConferma"] : null as any;
        }
    }

    static fromJS(data: any): LogoData {
        data = typeof data === 'object' ? data : {};
        let result = new LogoData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logoURL"] = this.logoURL !== undefined ? this.logoURL : null as any;
        data["stampaSuOfferta"] = this.stampaSuOfferta !== undefined ? this.stampaSuOfferta : null as any;
        data["stampaSuPreventivo"] = this.stampaSuPreventivo !== undefined ? this.stampaSuPreventivo : null as any;
        data["stampaSuProgramma"] = this.stampaSuProgramma !== undefined ? this.stampaSuProgramma : null as any;
        data["stampaSuConferma"] = this.stampaSuConferma !== undefined ? this.stampaSuConferma : null as any;
        return data;
    }
}

/** Dati del logo, predisposti per loghi multipli */
export interface ILogoData {
    /** Url assoluta del logo attuale */
    logoURL?: string;
    /** Questo logo viene usato sulle offerte */
    stampaSuOfferta?: boolean;
    /** Questo logo viene usato sui preventivi */
    stampaSuPreventivo?: boolean;
    /** Questo logo viene usato sul programma di viaggio */
    stampaSuProgramma?: boolean;
    /** Questo logo viene usato sulle conferme */
    stampaSuConferma?: boolean;
}

/** Dati specifici di fatturazione di un'agenzia */
export class ProfileInvoiceData implements IProfileInvoiceData {
    /** Ragione sociale completa dell'agenzia */
    ragioneSociale?: string | null;
    /** Prefisso della partita IVA in base al luogo di fatturazione */
    prefissoPartitaIVA?: string | null;
    /** Partita IVA */
    partitaIVA?: string | null;
    /** Indirizzo di fatturazione, senza il civico */
    indirizzo?: string | null;
    /** Codice avviamento postale o assimilabile */
    cap?: string | null;
    /** Numero civico */
    civico?: string | null;
    /** ID del luogo */
    luogoID?: number | null;
    /** Città, prelevata dal luogo */
    citta?: string | null;
    /** Casella PEC per fatturazione elettronica, solo per partite iva IT
Alternativo al codice univoco */
    pecFatturazioneElettronica?: string | null;
    /** Codice univoco per fatturazione elettronica, solo per partite iva IT
Alternativo alla PEC */
    codiceUnivocoFatturazioneElettronica?: string | null;

    constructor(data?: IProfileInvoiceData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ragioneSociale = _data["ragioneSociale"] !== undefined ? _data["ragioneSociale"] : null as any;
            this.prefissoPartitaIVA = _data["prefissoPartitaIVA"] !== undefined ? _data["prefissoPartitaIVA"] : null as any;
            this.partitaIVA = _data["partitaIVA"] !== undefined ? _data["partitaIVA"] : null as any;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : null as any;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : null as any;
            this.civico = _data["civico"] !== undefined ? _data["civico"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.citta = _data["citta"] !== undefined ? _data["citta"] : null as any;
            this.pecFatturazioneElettronica = _data["pecFatturazioneElettronica"] !== undefined ? _data["pecFatturazioneElettronica"] : null as any;
            this.codiceUnivocoFatturazioneElettronica = _data["codiceUnivocoFatturazioneElettronica"] !== undefined ? _data["codiceUnivocoFatturazioneElettronica"] : null as any;
        }
    }

    static fromJS(data: any): ProfileInvoiceData {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileInvoiceData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ragioneSociale"] = this.ragioneSociale !== undefined ? this.ragioneSociale : null as any;
        data["prefissoPartitaIVA"] = this.prefissoPartitaIVA !== undefined ? this.prefissoPartitaIVA : null as any;
        data["partitaIVA"] = this.partitaIVA !== undefined ? this.partitaIVA : null as any;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : null as any;
        data["cap"] = this.cap !== undefined ? this.cap : null as any;
        data["civico"] = this.civico !== undefined ? this.civico : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["citta"] = this.citta !== undefined ? this.citta : null as any;
        data["pecFatturazioneElettronica"] = this.pecFatturazioneElettronica !== undefined ? this.pecFatturazioneElettronica : null as any;
        data["codiceUnivocoFatturazioneElettronica"] = this.codiceUnivocoFatturazioneElettronica !== undefined ? this.codiceUnivocoFatturazioneElettronica : null as any;
        return data;
    }
}

/** Dati specifici di fatturazione di un'agenzia */
export interface IProfileInvoiceData {
    /** Ragione sociale completa dell'agenzia */
    ragioneSociale?: string | null;
    /** Prefisso della partita IVA in base al luogo di fatturazione */
    prefissoPartitaIVA?: string | null;
    /** Partita IVA */
    partitaIVA?: string | null;
    /** Indirizzo di fatturazione, senza il civico */
    indirizzo?: string | null;
    /** Codice avviamento postale o assimilabile */
    cap?: string | null;
    /** Numero civico */
    civico?: string | null;
    /** ID del luogo */
    luogoID?: number | null;
    /** Città, prelevata dal luogo */
    citta?: string | null;
    /** Casella PEC per fatturazione elettronica, solo per partite iva IT
Alternativo al codice univoco */
    pecFatturazioneElettronica?: string | null;
    /** Codice univoco per fatturazione elettronica, solo per partite iva IT
Alternativo alla PEC */
    codiceUnivocoFatturazioneElettronica?: string | null;
}

export class GetRecapitiContattoResponse extends OkApiResponse implements IGetRecapitiContattoResponse {
    rows?: ContattoRecapito[] | null;

    constructor(data?: IGetRecapitiContattoResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ContattoRecapito.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
        }
    }

    static override fromJS(data: any): GetRecapitiContattoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecapitiContattoResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetRecapitiContattoResponse extends IOkApiResponse {
    rows?: ContattoRecapito[] | null;
}

export class ContattoRecapito implements IContattoRecapito {
    recapitoID?: number;
    contattoID?: number;
    mezzoprenID?: EMezzoPrenotazione;
    recapito?: string | null;
    principale?: number | null;
    ordine?: number | null;
    attivo?: boolean;
    note?: string | null;

    constructor(data?: IContattoRecapito) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recapitoID = _data["recapitoID"] !== undefined ? _data["recapitoID"] : null as any;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.mezzoprenID = _data["mezzoprenID"] !== undefined ? _data["mezzoprenID"] : null as any;
            this.recapito = _data["recapito"] !== undefined ? _data["recapito"] : null as any;
            this.principale = _data["principale"] !== undefined ? _data["principale"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.attivo = _data["attivo"] !== undefined ? _data["attivo"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
        }
    }

    static fromJS(data: any): ContattoRecapito {
        data = typeof data === 'object' ? data : {};
        let result = new ContattoRecapito();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recapitoID"] = this.recapitoID !== undefined ? this.recapitoID : null as any;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["mezzoprenID"] = this.mezzoprenID !== undefined ? this.mezzoprenID : null as any;
        data["recapito"] = this.recapito !== undefined ? this.recapito : null as any;
        data["principale"] = this.principale !== undefined ? this.principale : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["attivo"] = this.attivo !== undefined ? this.attivo : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        return data;
    }
}

export interface IContattoRecapito {
    recapitoID?: number;
    contattoID?: number;
    mezzoprenID?: EMezzoPrenotazione;
    recapito?: string | null;
    principale?: number | null;
    ordine?: number | null;
    attivo?: boolean;
    note?: string | null;
}

export enum EMezzoPrenotazione {
    FaxPrenotazioni = "FaxPrenotazioni",
    Telefono = "Telefono",
    TerminaleAereo = "TerminaleAereo",
    Cellulare = "Cellulare",
    EmailPrenotazioni = "EmailPrenotazioni",
    EmailPromozioni = "EmailPromozioni",
    InvioDocContabili = "InvioDocContabili",
    BigliettiAerei = "BigliettiAerei",
    FaxPromozioni = "FaxPromozioni",
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class GetRecapitiContattoRequest extends LocalizedRequest implements IGetRecapitiContattoRequest {
    contattoId?: number;

    constructor(data?: IGetRecapitiContattoRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoId = _data["contattoId"] !== undefined ? _data["contattoId"] : null as any;
        }
    }

    static override fromJS(data: any): GetRecapitiContattoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecapitiContattoRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoId"] = this.contattoId !== undefined ? this.contattoId : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IGetRecapitiContattoRequest extends ILocalizedRequest {
    contattoId?: number;
}

export class GetRelazioniContattoResponse extends OkApiResponse implements IGetRelazioniContattoResponse {
    rows?: ContattoRelazione[] | null;

    constructor(data?: IGetRelazioniContattoResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ContattoRelazione.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
        }
    }

    static override fromJS(data: any): GetRelazioniContattoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRelazioniContattoResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetRelazioniContattoResponse extends IOkApiResponse {
    rows?: ContattoRelazione[] | null;
}

export class ContattoRelazione implements IContattoRelazione {
    relazioneID?: number;
    contattoID?: number;
    contattoPadreID?: number;
    tipoRelazione?: ETipoRelazioneContatto;
    nome?: string | null;

    constructor(data?: IContattoRelazione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.relazioneID = _data["relazioneID"] !== undefined ? _data["relazioneID"] : null as any;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.contattoPadreID = _data["contattoPadreID"] !== undefined ? _data["contattoPadreID"] : null as any;
            this.tipoRelazione = _data["tipoRelazione"] !== undefined ? _data["tipoRelazione"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
        }
    }

    static fromJS(data: any): ContattoRelazione {
        data = typeof data === 'object' ? data : {};
        let result = new ContattoRelazione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["relazioneID"] = this.relazioneID !== undefined ? this.relazioneID : null as any;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["contattoPadreID"] = this.contattoPadreID !== undefined ? this.contattoPadreID : null as any;
        data["tipoRelazione"] = this.tipoRelazione !== undefined ? this.tipoRelazione : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        return data;
    }
}

export interface IContattoRelazione {
    relazioneID?: number;
    contattoID?: number;
    contattoPadreID?: number;
    tipoRelazione?: ETipoRelazioneContatto;
    nome?: string | null;
}

export enum ETipoRelazioneContatto {
    UfficioDi = "UfficioDi",
    DipendenteDi = "DipendenteDi",
    CompetaA = "CompetaA",
    MembroDelGruppo = "MembroDelGruppo",
    MembroDelSottogruppo = "MembroDelSottogruppo",
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class GetRelazioniContattoRequest extends LocalizedRequest implements IGetRelazioniContattoRequest {
    contattoId?: number;

    constructor(data?: IGetRelazioniContattoRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoId = _data["contattoId"] !== undefined ? _data["contattoId"] : null as any;
        }
    }

    static override fromJS(data: any): GetRelazioniContattoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetRelazioniContattoRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoId"] = this.contattoId !== undefined ? this.contattoId : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IGetRelazioniContattoRequest extends ILocalizedRequest {
    contattoId?: number;
}

export class GetUtentiListResponse extends OkApiResponse implements IGetUtentiListResponse {
    utenti?: UtenteRow[];

    constructor(data?: IGetUtentiListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["utenti"])) {
                this.utenti = [] as any;
                for (let item of _data["utenti"])
                    this.utenti!.push(UtenteRow.fromJS(item));
            }
            else {
                this.utenti = null as any;
            }
        }
    }

    static override fromJS(data: any): GetUtentiListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUtentiListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.utenti)) {
            data["utenti"] = [];
            for (let item of this.utenti)
                data["utenti"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetUtentiListResponse extends IOkApiResponse {
    utenti?: UtenteRow[];
}

export class GetUtentiListRequest extends ApiRequest implements IGetUtentiListRequest {
    contattoID?: number;

    constructor(data?: IGetUtentiListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
        }
    }

    static override fromJS(data: any): GetUtentiListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetUtentiListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetUtentiListRequest extends IApiRequest {
    contattoID?: number;
}

export class GetUtentiSecondariListRequest extends GetUtentiListRequest implements IGetUtentiSecondariListRequest {
    utenteID?: number;

    constructor(data?: IGetUtentiSecondariListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.utenteID = _data["utenteID"] !== undefined ? _data["utenteID"] : null as any;
        }
    }

    static override fromJS(data: any): GetUtentiSecondariListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetUtentiSecondariListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utenteID"] = this.utenteID !== undefined ? this.utenteID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetUtentiSecondariListRequest extends IGetUtentiListRequest {
    utenteID?: number;
}

export class NrTableResponseOfContactListRow extends OkApiResponse implements INrTableResponseOfContactListRow {
    /** Array delle righe della pagina richiesta */
    rows?: ContactListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfContactListRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ContactListRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfContactListRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfContactListRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfContactListRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: ContactListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

/** Classe che rappresenta la risposta ad una richiesta di elenco contatti */
export class ContactsListResponse extends NrTableResponseOfContactListRow implements IContactsListResponse {

    constructor(data?: IContactsListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ContactsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ContactsListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta la risposta ad una richiesta di elenco contatti */
export interface IContactsListResponse extends INrTableResponseOfContactListRow {
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class ContactsListRequest extends NrTableRequest implements IContactsListRequest {
    /** Ragione sociale, email, ID, ecc... da cercare */
    term?: string | null;
    /** Tipo di contatto */
    tipo?: ETipoContatto | null;
    /** ID del luogo associato al contatto */
    luogoCittaID?: number | null;
    /** ID del luogo paese associato al luogo del contatto */
    luogoPaeseID?: number | null;
    /** ID del luogo regione associato al luogo del contatto */
    luogoRegioneID?: number | null;
    /** Partita IVA del contatto */
    partitaIVA?: string | null;
    /** Sigla della provincia */
    provincia?: string | null;
    /** Filter contatscts based on validity (delted or not) */
    showValid?: boolean | null;

    constructor(data?: IContactsListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.luogoCittaID = _data["luogoCittaID"] !== undefined ? _data["luogoCittaID"] : null as any;
            this.luogoPaeseID = _data["luogoPaeseID"] !== undefined ? _data["luogoPaeseID"] : null as any;
            this.luogoRegioneID = _data["luogoRegioneID"] !== undefined ? _data["luogoRegioneID"] : null as any;
            this.partitaIVA = _data["partitaIVA"] !== undefined ? _data["partitaIVA"] : null as any;
            this.provincia = _data["provincia"] !== undefined ? _data["provincia"] : null as any;
            this.showValid = _data["showValid"] !== undefined ? _data["showValid"] : null as any;
        }
    }

    static override fromJS(data: any): ContactsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContactsListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["luogoCittaID"] = this.luogoCittaID !== undefined ? this.luogoCittaID : null as any;
        data["luogoPaeseID"] = this.luogoPaeseID !== undefined ? this.luogoPaeseID : null as any;
        data["luogoRegioneID"] = this.luogoRegioneID !== undefined ? this.luogoRegioneID : null as any;
        data["partitaIVA"] = this.partitaIVA !== undefined ? this.partitaIVA : null as any;
        data["provincia"] = this.provincia !== undefined ? this.provincia : null as any;
        data["showValid"] = this.showValid !== undefined ? this.showValid : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IContactsListRequest extends INrTableRequest {
    /** Ragione sociale, email, ID, ecc... da cercare */
    term?: string | null;
    /** Tipo di contatto */
    tipo?: ETipoContatto | null;
    /** ID del luogo associato al contatto */
    luogoCittaID?: number | null;
    /** ID del luogo paese associato al luogo del contatto */
    luogoPaeseID?: number | null;
    /** ID del luogo regione associato al luogo del contatto */
    luogoRegioneID?: number | null;
    /** Partita IVA del contatto */
    partitaIVA?: string | null;
    /** Sigla della provincia */
    provincia?: string | null;
    /** Filter contatscts based on validity (delted or not) */
    showValid?: boolean | null;
}

export class RestoreContattoRequest extends LocalizedRequest implements IRestoreContattoRequest {
    contattoId?: number;

    constructor(data?: IRestoreContattoRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoId = _data["contattoId"] !== undefined ? _data["contattoId"] : null as any;
        }
    }

    static override fromJS(data: any): RestoreContattoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreContattoRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoId"] = this.contattoId !== undefined ? this.contattoId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IRestoreContattoRequest extends ILocalizedRequest {
    contattoId?: number;
}

export class SaveAccordoContattoResponse extends OkApiResponse implements ISaveAccordoContattoResponse {
    accordoContatto?: AccordoContatto | null;

    constructor(data?: ISaveAccordoContattoResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoContatto = _data["accordoContatto"] ? AccordoContatto.fromJS(_data["accordoContatto"]) : null as any;
        }
    }

    static override fromJS(data: any): SaveAccordoContattoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveAccordoContattoResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoContatto"] = this.accordoContatto ? this.accordoContatto.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISaveAccordoContattoResponse extends IOkApiResponse {
    accordoContatto?: AccordoContatto | null;
}

export class SaveAccordoContattoRequest extends ApiRequest implements ISaveAccordoContattoRequest {
    accordoContatto?: AccordoContatto | null;

    constructor(data?: ISaveAccordoContattoRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoContatto = _data["accordoContatto"] ? AccordoContatto.fromJS(_data["accordoContatto"]) : null as any;
        }
    }

    static override fromJS(data: any): SaveAccordoContattoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveAccordoContattoRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoContatto"] = this.accordoContatto ? this.accordoContatto.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISaveAccordoContattoRequest extends IApiRequest {
    accordoContatto?: AccordoContatto | null;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class SetDatiAggiuntiviContattoRequest extends LocalizedRequest implements ISetDatiAggiuntiviContattoRequest {
    contattoId?: number;
    dati?: ContattoDato[] | null;

    constructor(data?: ISetDatiAggiuntiviContattoRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoId = _data["contattoId"] !== undefined ? _data["contattoId"] : null as any;
            if (Array.isArray(_data["dati"])) {
                this.dati = [] as any;
                for (let item of _data["dati"])
                    this.dati!.push(ContattoDato.fromJS(item));
            }
            else {
                this.dati = null as any;
            }
        }
    }

    static override fromJS(data: any): SetDatiAggiuntiviContattoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetDatiAggiuntiviContattoRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoId"] = this.contattoId !== undefined ? this.contattoId : null as any;
        if (Array.isArray(this.dati)) {
            data["dati"] = [];
            for (let item of this.dati)
                data["dati"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface ISetDatiAggiuntiviContattoRequest extends ILocalizedRequest {
    contattoId?: number;
    dati?: ContattoDato[] | null;
}

export class SetMappaContattoResponse extends OkApiResponse implements ISetMappaContattoResponse {
    mappa?: Mappa | null;

    constructor(data?: ISetMappaContattoResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.mappa = _data["mappa"] ? Mappa.fromJS(_data["mappa"]) : null as any;
        }
    }

    static override fromJS(data: any): SetMappaContattoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetMappaContattoResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mappa"] = this.mappa ? this.mappa.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISetMappaContattoResponse extends IOkApiResponse {
    mappa?: Mappa | null;
}

export class SetMappaContattoRequest extends LocalizedRequest implements ISetMappaContattoRequest {
    contattoId?: number;
    mappa?: Mappa | null;

    constructor(data?: ISetMappaContattoRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoId = _data["contattoId"] !== undefined ? _data["contattoId"] : null as any;
            this.mappa = _data["mappa"] ? Mappa.fromJS(_data["mappa"]) : null as any;
        }
    }

    static override fromJS(data: any): SetMappaContattoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetMappaContattoRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoId"] = this.contattoId !== undefined ? this.contattoId : null as any;
        data["mappa"] = this.mappa ? this.mappa.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISetMappaContattoRequest extends ILocalizedRequest {
    contattoId?: number;
    mappa?: Mappa | null;
}

export class SetRecapitiContattoRequest extends LocalizedRequest implements ISetRecapitiContattoRequest {
    contattoId?: number;
    dati?: ContattoRecapito[] | null;

    constructor(data?: ISetRecapitiContattoRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoId = _data["contattoId"] !== undefined ? _data["contattoId"] : null as any;
            if (Array.isArray(_data["dati"])) {
                this.dati = [] as any;
                for (let item of _data["dati"])
                    this.dati!.push(ContattoRecapito.fromJS(item));
            }
            else {
                this.dati = null as any;
            }
        }
    }

    static override fromJS(data: any): SetRecapitiContattoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetRecapitiContattoRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoId"] = this.contattoId !== undefined ? this.contattoId : null as any;
        if (Array.isArray(this.dati)) {
            data["dati"] = [];
            for (let item of this.dati)
                data["dati"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetRecapitiContattoRequest extends ILocalizedRequest {
    contattoId?: number;
    dati?: ContattoRecapito[] | null;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class SetRelazioniContattoRequest extends LocalizedRequest implements ISetRelazioniContattoRequest {
    contattoID?: number;
    relazioni?: ContattoRelazione[] | null;

    constructor(data?: ISetRelazioniContattoRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            if (Array.isArray(_data["relazioni"])) {
                this.relazioni = [] as any;
                for (let item of _data["relazioni"])
                    this.relazioni!.push(ContattoRelazione.fromJS(item));
            }
            else {
                this.relazioni = null as any;
            }
        }
    }

    static override fromJS(data: any): SetRelazioniContattoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetRelazioniContattoRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        if (Array.isArray(this.relazioni)) {
            data["relazioni"] = [];
            for (let item of this.relazioni)
                data["relazioni"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface ISetRelazioniContattoRequest extends ILocalizedRequest {
    contattoID?: number;
    relazioni?: ContattoRelazione[] | null;
}

export class UpdateAgencyDataRequest extends LocalizedRequest implements IUpdateAgencyDataRequest {
    profileData!: ProfileData;

    constructor(data?: IUpdateAgencyDataRequest) {
        super(data);
        if (!data) {
            this.profileData = new ProfileData();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.profileData = _data["profileData"] ? ProfileData.fromJS(_data["profileData"]) : new ProfileData();
        }
    }

    static override fromJS(data: any): UpdateAgencyDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAgencyDataRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileData"] = this.profileData ? this.profileData.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateAgencyDataRequest extends ILocalizedRequest {
    profileData: ProfileData;
}

export class UpdateAgencyInvoiceDataRequest extends LocalizedRequest implements IUpdateAgencyInvoiceDataRequest {
    profileInvoiceData!: ProfileInvoiceData;

    constructor(data?: IUpdateAgencyInvoiceDataRequest) {
        super(data);
        if (!data) {
            this.profileInvoiceData = new ProfileInvoiceData();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.profileInvoiceData = _data["profileInvoiceData"] ? ProfileInvoiceData.fromJS(_data["profileInvoiceData"]) : new ProfileInvoiceData();
        }
    }

    static override fromJS(data: any): UpdateAgencyInvoiceDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAgencyInvoiceDataRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileInvoiceData"] = this.profileInvoiceData ? this.profileInvoiceData.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateAgencyInvoiceDataRequest extends ILocalizedRequest {
    profileInvoiceData: ProfileInvoiceData;
}

export class UpdateLogoRequest extends LocalizedRequest implements IUpdateLogoRequest {
    logo?: LogoUpsert | null;

    constructor(data?: IUpdateLogoRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.logo = _data["logo"] ? LogoUpsert.fromJS(_data["logo"]) : null as any;
        }
    }

    static override fromJS(data: any): UpdateLogoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLogoRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logo"] = this.logo ? this.logo.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateLogoRequest extends ILocalizedRequest {
    logo?: LogoUpsert | null;
}

export class UpdateUtenteAgenziaResponse extends OkApiResponse implements IUpdateUtenteAgenziaResponse {
    /** Entità modificata */
    utente?: UtenteRow;

    constructor(data?: IUpdateUtenteAgenziaResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.utente = _data["utente"] ? UtenteRow.fromJS(_data["utente"]) : null as any;
        }
    }

    static override fromJS(data: any): UpdateUtenteAgenziaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUtenteAgenziaResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utente"] = this.utente ? this.utente.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateUtenteAgenziaResponse extends IOkApiResponse {
    /** Entità modificata */
    utente?: UtenteRow;
}

export class UpdateUtenteAgenziaRequest extends SiteRequest implements IUpdateUtenteAgenziaRequest {
    /** ID dell'utente da modificare */
    id!: number;
    /** Indirizzo email dell'utente */
    email!: string;
    /** Nome proprio */
    nome!: string;
    /** Cognome, facoltativo */
    cognome?: string | null;
    /** Numero di telefono dell'utente, facoltativo */
    telefono?: string | null;
    /** Flag di abilitazione */
    abilitato?: boolean;

    constructor(data?: IUpdateUtenteAgenziaRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : null as any;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : null as any;
            this.abilitato = _data["abilitato"] !== undefined ? _data["abilitato"] : null as any;
        }
    }

    static override fromJS(data: any): UpdateUtenteAgenziaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUtenteAgenziaRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["cognome"] = this.cognome !== undefined ? this.cognome : null as any;
        data["telefono"] = this.telefono !== undefined ? this.telefono : null as any;
        data["abilitato"] = this.abilitato !== undefined ? this.abilitato : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateUtenteAgenziaRequest extends ISiteRequest {
    /** ID dell'utente da modificare */
    id: number;
    /** Indirizzo email dell'utente */
    email: string;
    /** Nome proprio */
    nome: string;
    /** Cognome, facoltativo */
    cognome?: string | null;
    /** Numero di telefono dell'utente, facoltativo */
    telefono?: string | null;
    /** Flag di abilitazione */
    abilitato?: boolean;
}

export class UpsertUtenteSecondarioResponse extends CreateUtenteAgenziaResponse implements IUpsertUtenteSecondarioResponse {

    constructor(data?: IUpsertUtenteSecondarioResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UpsertUtenteSecondarioResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertUtenteSecondarioResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertUtenteSecondarioResponse extends ICreateUtenteAgenziaResponse {
}

export class UpsertUtenteSecondarioRequest extends CreateUtenteAgenziaRequest implements IUpsertUtenteSecondarioRequest {
    utenteID?: number;

    constructor(data?: IUpsertUtenteSecondarioRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.utenteID = _data["utenteID"] !== undefined ? _data["utenteID"] : null as any;
        }
    }

    static override fromJS(data: any): UpsertUtenteSecondarioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertUtenteSecondarioRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utenteID"] = this.utenteID !== undefined ? this.utenteID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertUtenteSecondarioRequest extends ICreateUtenteAgenziaRequest {
    utenteID?: number;
}

export class GetDashboardNewsResponse extends OkApiResponse implements IGetDashboardNewsResponse {
    news?: NewsRow[] | null;

    constructor(data?: IGetDashboardNewsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["news"])) {
                this.news = [] as any;
                for (let item of _data["news"])
                    this.news!.push(NewsRow.fromJS(item));
            }
            else {
                this.news = null as any;
            }
        }
    }

    static override fromJS(data: any): GetDashboardNewsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDashboardNewsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.news)) {
            data["news"] = [];
            for (let item of this.news)
                data["news"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetDashboardNewsResponse extends IOkApiResponse {
    news?: NewsRow[] | null;
}

export class NewsRow implements INewsRow {
    id?: number;
    titoloIT?: string | null;
    titoloEN?: string | null;
    testoIT?: string | null;
    testoEN?: string | null;
    allegati?: NewsAttachment[] | null;
    ultimoAggiornamento?: string | null;

    constructor(data?: INewsRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.titoloIT = _data["titoloIT"] !== undefined ? _data["titoloIT"] : null as any;
            this.titoloEN = _data["titoloEN"] !== undefined ? _data["titoloEN"] : null as any;
            this.testoIT = _data["testoIT"] !== undefined ? _data["testoIT"] : null as any;
            this.testoEN = _data["testoEN"] !== undefined ? _data["testoEN"] : null as any;
            if (Array.isArray(_data["allegati"])) {
                this.allegati = [] as any;
                for (let item of _data["allegati"])
                    this.allegati!.push(NewsAttachment.fromJS(item));
            }
            else {
                this.allegati = null as any;
            }
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] !== undefined ? _data["ultimoAggiornamento"] : null as any;
        }
    }

    static fromJS(data: any): NewsRow {
        data = typeof data === 'object' ? data : {};
        let result = new NewsRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["titoloIT"] = this.titoloIT !== undefined ? this.titoloIT : null as any;
        data["titoloEN"] = this.titoloEN !== undefined ? this.titoloEN : null as any;
        data["testoIT"] = this.testoIT !== undefined ? this.testoIT : null as any;
        data["testoEN"] = this.testoEN !== undefined ? this.testoEN : null as any;
        if (Array.isArray(this.allegati)) {
            data["allegati"] = [];
            for (let item of this.allegati)
                data["allegati"].push(item ? item.toJSON() : null as any);
        }
        data["ultimoAggiornamento"] = this.ultimoAggiornamento !== undefined ? this.ultimoAggiornamento : null as any;
        return data;
    }
}

export interface INewsRow {
    id?: number;
    titoloIT?: string | null;
    titoloEN?: string | null;
    testoIT?: string | null;
    testoEN?: string | null;
    allegati?: NewsAttachment[] | null;
    ultimoAggiornamento?: string | null;
}

export class NewsAttachment implements INewsAttachment {
    id?: number;
    descrizione?: string | null;
    fileName?: string | null;

    constructor(data?: INewsAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
        }
    }

    static fromJS(data: any): NewsAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new NewsAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        return data;
    }
}

export interface INewsAttachment {
    id?: number;
    descrizione?: string | null;
    fileName?: string | null;
}

export class DashboardGetConfigResponse extends OkApiResponse implements IDashboardGetConfigResponse {
    userConfig?: IntranetUsersDashboardConfig[] | null;

    constructor(data?: IDashboardGetConfigResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["userConfig"])) {
                this.userConfig = [] as any;
                for (let item of _data["userConfig"])
                    this.userConfig!.push(IntranetUsersDashboardConfig.fromJS(item));
            }
            else {
                this.userConfig = null as any;
            }
        }
    }

    static override fromJS(data: any): DashboardGetConfigResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardGetConfigResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userConfig)) {
            data["userConfig"] = [];
            for (let item of this.userConfig)
                data["userConfig"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDashboardGetConfigResponse extends IOkApiResponse {
    userConfig?: IntranetUsersDashboardConfig[] | null;
}

export class IntranetUsersDashboardConfig implements IIntranetUsersDashboardConfig {
    id?: number;
    userID?: number;
    type?: EDashboardWidgetType;
    row?: number;
    rowSpan?: number;
    col?: number;
    colSpan?: number;
    title?: string | null;
    jsonOptions?: string | null;

    constructor(data?: IIntranetUsersDashboardConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.userID = _data["userID"] !== undefined ? _data["userID"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.row = _data["row"] !== undefined ? _data["row"] : null as any;
            this.rowSpan = _data["rowSpan"] !== undefined ? _data["rowSpan"] : null as any;
            this.col = _data["col"] !== undefined ? _data["col"] : null as any;
            this.colSpan = _data["colSpan"] !== undefined ? _data["colSpan"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.jsonOptions = _data["jsonOptions"] !== undefined ? _data["jsonOptions"] : null as any;
        }
    }

    static fromJS(data: any): IntranetUsersDashboardConfig {
        data = typeof data === 'object' ? data : {};
        let result = new IntranetUsersDashboardConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["userID"] = this.userID !== undefined ? this.userID : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["row"] = this.row !== undefined ? this.row : null as any;
        data["rowSpan"] = this.rowSpan !== undefined ? this.rowSpan : null as any;
        data["col"] = this.col !== undefined ? this.col : null as any;
        data["colSpan"] = this.colSpan !== undefined ? this.colSpan : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["jsonOptions"] = this.jsonOptions !== undefined ? this.jsonOptions : null as any;
        return data;
    }
}

export interface IIntranetUsersDashboardConfig {
    id?: number;
    userID?: number;
    type?: EDashboardWidgetType;
    row?: number;
    rowSpan?: number;
    col?: number;
    colSpan?: number;
    title?: string | null;
    jsonOptions?: string | null;
}

export enum EDashboardWidgetType {
    Statistic = "Statistic",
    Admin = "Admin",
    Basecamp = "Basecamp",
    Translation = "Translation",
    News = "News",
}

export class SetUserConfigRequest extends ApiRequest implements ISetUserConfigRequest {
    userConfig?: IntranetUsersDashboardConfig[] | null;

    constructor(data?: ISetUserConfigRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["userConfig"])) {
                this.userConfig = [] as any;
                for (let item of _data["userConfig"])
                    this.userConfig!.push(IntranetUsersDashboardConfig.fromJS(item));
            }
            else {
                this.userConfig = null as any;
            }
        }
    }

    static override fromJS(data: any): SetUserConfigRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetUserConfigRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userConfig)) {
            data["userConfig"] = [];
            for (let item of this.userConfig)
                data["userConfig"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetUserConfigRequest extends IApiRequest {
    userConfig?: IntranetUsersDashboardConfig[] | null;
}

export class PhraseGetResponse extends OkApiResponse implements IPhraseGetResponse {
    frase?: Frase;
    tagsIds?: number[];

    constructor(data?: IPhraseGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.frase = _data["frase"] ? Frase.fromJS(_data["frase"]) : null as any;
            if (Array.isArray(_data["tagsIds"])) {
                this.tagsIds = [] as any;
                for (let item of _data["tagsIds"])
                    this.tagsIds!.push(item);
            }
            else {
                this.tagsIds = null as any;
            }
        }
    }

    static override fromJS(data: any): PhraseGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PhraseGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["frase"] = this.frase ? this.frase.toJSON() : null as any;
        if (Array.isArray(this.tagsIds)) {
            data["tagsIds"] = [];
            for (let item of this.tagsIds)
                data["tagsIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPhraseGetResponse extends IOkApiResponse {
    frase?: Frase;
    tagsIds?: number[];
}

export class PhraseGetRequest extends LocalizedRequest implements IPhraseGetRequest {
    fraseID?: number;

    constructor(data?: IPhraseGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fraseID = _data["fraseID"] !== undefined ? _data["fraseID"] : null as any;
        }
    }

    static override fromJS(data: any): PhraseGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PhraseGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fraseID"] = this.fraseID !== undefined ? this.fraseID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPhraseGetRequest extends ILocalizedRequest {
    fraseID?: number;
}

export class UpdatePhraseRequest extends PhraseGetRequest implements IUpdatePhraseRequest {
    frase?: Frase | null;
    tagsIds?: number[] | null;

    constructor(data?: IUpdatePhraseRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.frase = _data["frase"] ? Frase.fromJS(_data["frase"]) : null as any;
            if (Array.isArray(_data["tagsIds"])) {
                this.tagsIds = [] as any;
                for (let item of _data["tagsIds"])
                    this.tagsIds!.push(item);
            }
            else {
                this.tagsIds = null as any;
            }
        }
    }

    static override fromJS(data: any): UpdatePhraseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePhraseRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["frase"] = this.frase ? this.frase.toJSON() : null as any;
        if (Array.isArray(this.tagsIds)) {
            data["tagsIds"] = [];
            for (let item of this.tagsIds)
                data["tagsIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdatePhraseRequest extends IPhraseGetRequest {
    frase?: Frase | null;
    tagsIds?: number[] | null;
}

export class PhraseDeleteRequest extends ApiRequest implements IPhraseDeleteRequest {
    fraseID?: number;

    constructor(data?: IPhraseDeleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fraseID = _data["fraseID"] !== undefined ? _data["fraseID"] : null as any;
        }
    }

    static override fromJS(data: any): PhraseDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PhraseDeleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fraseID"] = this.fraseID !== undefined ? this.fraseID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPhraseDeleteRequest extends IApiRequest {
    fraseID?: number;
}

export class NrTableResponseOfPhraseRow extends OkApiResponse implements INrTableResponseOfPhraseRow {
    /** Array delle righe della pagina richiesta */
    rows?: PhraseRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfPhraseRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(PhraseRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfPhraseRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfPhraseRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfPhraseRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: PhraseRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class ListPhrasesResponse extends NrTableResponseOfPhraseRow implements IListPhrasesResponse {

    constructor(data?: IListPhrasesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ListPhrasesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListPhrasesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IListPhrasesResponse extends INrTableResponseOfPhraseRow {
}

export class PhraseRow implements IPhraseRow {
    text?: string;
    title?: string | null;
    frase?: Frase;
    luogo?: string | null;
    paese?: string | null;
    luogoDestinazione?: string | null;
    servizio?: string | null;
    sezione?: string | null;
    contatto?: string | null;
    deleted?: boolean;
    tagsIds?: number[];

    constructor(data?: IPhraseRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.frase = _data["frase"] ? Frase.fromJS(_data["frase"]) : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.paese = _data["paese"] !== undefined ? _data["paese"] : null as any;
            this.luogoDestinazione = _data["luogoDestinazione"] !== undefined ? _data["luogoDestinazione"] : null as any;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : null as any;
            this.sezione = _data["sezione"] !== undefined ? _data["sezione"] : null as any;
            this.contatto = _data["contatto"] !== undefined ? _data["contatto"] : null as any;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : null as any;
            if (Array.isArray(_data["tagsIds"])) {
                this.tagsIds = [] as any;
                for (let item of _data["tagsIds"])
                    this.tagsIds!.push(item);
            }
            else {
                this.tagsIds = null as any;
            }
        }
    }

    static fromJS(data: any): PhraseRow {
        data = typeof data === 'object' ? data : {};
        let result = new PhraseRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text !== undefined ? this.text : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["frase"] = this.frase ? this.frase.toJSON() : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["paese"] = this.paese !== undefined ? this.paese : null as any;
        data["luogoDestinazione"] = this.luogoDestinazione !== undefined ? this.luogoDestinazione : null as any;
        data["servizio"] = this.servizio !== undefined ? this.servizio : null as any;
        data["sezione"] = this.sezione !== undefined ? this.sezione : null as any;
        data["contatto"] = this.contatto !== undefined ? this.contatto : null as any;
        data["deleted"] = this.deleted !== undefined ? this.deleted : null as any;
        if (Array.isArray(this.tagsIds)) {
            data["tagsIds"] = [];
            for (let item of this.tagsIds)
                data["tagsIds"].push(item);
        }
        return data;
    }
}

export interface IPhraseRow {
    text?: string;
    title?: string | null;
    frase?: Frase;
    luogo?: string | null;
    paese?: string | null;
    luogoDestinazione?: string | null;
    servizio?: string | null;
    sezione?: string | null;
    contatto?: string | null;
    deleted?: boolean;
    tagsIds?: number[];
}

export class ListPhrasesRequest extends NrTableRequest implements IListPhrasesRequest {
    /** Termine di ricerca: ID, titolo, parti di testo */
    term?: string | null;
    /** Se true cerca solo frasi non associate a luogo */
    noLuogo?: boolean;
    /** Se true cerca solo frasi non associate a servizio */
    noServizio?: boolean;
    /** Se true cerca solo frasi non associate a contatto */
    noContatto?: boolean;
    /** Se presente cerca solo frasi che hanno almeno uno dei tag con l'id della lista */
    tagIds?: number[] | null;
    /** Modalità di filtraggio degli ID dei tag */
    tagsIdsFilter?: EListPhrasesCollectionFilter;
    /** Filtro sugli ID luogo. Se presente la frase deve appartenere ad uno di questi luoghi */
    luoghiIds?: number[] | null;
    /** Filtroo sugli ID paese; */
    paesiIds?: number[] | null;
    /** Filtro sugli ID servizio. Se presente la frase deve appartenere ad uno di questi servizi */
    serviziIds?: number[] | null;
    /** Filtro sugli ID contatto. Se presente la frase deve appartenere ad uno di questi contatti */
    contattiIds?: number[] | null;
    /** Filtro sull'ID della sezione. Se presente la frase deve appartenere a questa sezione */
    sezioneID?: number | null;
    /** Filters by not deleted when true or only deleted items when false */
    showDeleted?: boolean;
    tipoServizioID?: string | null;
    /** Se true cerca solo le frasi generate da AI, ovvero con almeno una traduzione non confermata (qualsiasi lingua) */
    generatedByAI?: boolean | null;

    constructor(data?: IListPhrasesRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : null as any;
            this.noLuogo = _data["noLuogo"] !== undefined ? _data["noLuogo"] : null as any;
            this.noServizio = _data["noServizio"] !== undefined ? _data["noServizio"] : null as any;
            this.noContatto = _data["noContatto"] !== undefined ? _data["noContatto"] : null as any;
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            else {
                this.tagIds = null as any;
            }
            this.tagsIdsFilter = _data["tagsIdsFilter"] !== undefined ? _data["tagsIdsFilter"] : null as any;
            if (Array.isArray(_data["luoghiIds"])) {
                this.luoghiIds = [] as any;
                for (let item of _data["luoghiIds"])
                    this.luoghiIds!.push(item);
            }
            else {
                this.luoghiIds = null as any;
            }
            if (Array.isArray(_data["paesiIds"])) {
                this.paesiIds = [] as any;
                for (let item of _data["paesiIds"])
                    this.paesiIds!.push(item);
            }
            else {
                this.paesiIds = null as any;
            }
            if (Array.isArray(_data["serviziIds"])) {
                this.serviziIds = [] as any;
                for (let item of _data["serviziIds"])
                    this.serviziIds!.push(item);
            }
            else {
                this.serviziIds = null as any;
            }
            if (Array.isArray(_data["contattiIds"])) {
                this.contattiIds = [] as any;
                for (let item of _data["contattiIds"])
                    this.contattiIds!.push(item);
            }
            else {
                this.contattiIds = null as any;
            }
            this.sezioneID = _data["sezioneID"] !== undefined ? _data["sezioneID"] : null as any;
            this.showDeleted = _data["showDeleted"] !== undefined ? _data["showDeleted"] : null as any;
            this.tipoServizioID = _data["tipoServizioID"] !== undefined ? _data["tipoServizioID"] : null as any;
            this.generatedByAI = _data["generatedByAI"] !== undefined ? _data["generatedByAI"] : null as any;
        }
    }

    static override fromJS(data: any): ListPhrasesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListPhrasesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : null as any;
        data["noLuogo"] = this.noLuogo !== undefined ? this.noLuogo : null as any;
        data["noServizio"] = this.noServizio !== undefined ? this.noServizio : null as any;
        data["noContatto"] = this.noContatto !== undefined ? this.noContatto : null as any;
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        data["tagsIdsFilter"] = this.tagsIdsFilter !== undefined ? this.tagsIdsFilter : null as any;
        if (Array.isArray(this.luoghiIds)) {
            data["luoghiIds"] = [];
            for (let item of this.luoghiIds)
                data["luoghiIds"].push(item);
        }
        if (Array.isArray(this.paesiIds)) {
            data["paesiIds"] = [];
            for (let item of this.paesiIds)
                data["paesiIds"].push(item);
        }
        if (Array.isArray(this.serviziIds)) {
            data["serviziIds"] = [];
            for (let item of this.serviziIds)
                data["serviziIds"].push(item);
        }
        if (Array.isArray(this.contattiIds)) {
            data["contattiIds"] = [];
            for (let item of this.contattiIds)
                data["contattiIds"].push(item);
        }
        data["sezioneID"] = this.sezioneID !== undefined ? this.sezioneID : null as any;
        data["showDeleted"] = this.showDeleted !== undefined ? this.showDeleted : null as any;
        data["tipoServizioID"] = this.tipoServizioID !== undefined ? this.tipoServizioID : null as any;
        data["generatedByAI"] = this.generatedByAI !== undefined ? this.generatedByAI : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IListPhrasesRequest extends INrTableRequest {
    /** Termine di ricerca: ID, titolo, parti di testo */
    term?: string | null;
    /** Se true cerca solo frasi non associate a luogo */
    noLuogo?: boolean;
    /** Se true cerca solo frasi non associate a servizio */
    noServizio?: boolean;
    /** Se true cerca solo frasi non associate a contatto */
    noContatto?: boolean;
    /** Se presente cerca solo frasi che hanno almeno uno dei tag con l'id della lista */
    tagIds?: number[] | null;
    /** Modalità di filtraggio degli ID dei tag */
    tagsIdsFilter?: EListPhrasesCollectionFilter;
    /** Filtro sugli ID luogo. Se presente la frase deve appartenere ad uno di questi luoghi */
    luoghiIds?: number[] | null;
    /** Filtroo sugli ID paese; */
    paesiIds?: number[] | null;
    /** Filtro sugli ID servizio. Se presente la frase deve appartenere ad uno di questi servizi */
    serviziIds?: number[] | null;
    /** Filtro sugli ID contatto. Se presente la frase deve appartenere ad uno di questi contatti */
    contattiIds?: number[] | null;
    /** Filtro sull'ID della sezione. Se presente la frase deve appartenere a questa sezione */
    sezioneID?: number | null;
    /** Filters by not deleted when true or only deleted items when false */
    showDeleted?: boolean;
    tipoServizioID?: string | null;
    /** Se true cerca solo le frasi generate da AI, ovvero con almeno una traduzione non confermata (qualsiasi lingua) */
    generatedByAI?: boolean | null;
}

export enum EListPhrasesCollectionFilter {
    All = "All",
    Any = "Any",
}

export class TranslatePhrasesResponse extends OkApiResponse implements ITranslatePhrasesResponse {
    testoTradotto?: FraseTestoLingua | null;

    constructor(data?: ITranslatePhrasesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.testoTradotto = _data["testoTradotto"] ? FraseTestoLingua.fromJS(_data["testoTradotto"]) : null as any;
        }
    }

    static override fromJS(data: any): TranslatePhrasesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TranslatePhrasesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["testoTradotto"] = this.testoTradotto ? this.testoTradotto.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslatePhrasesResponse extends IOkApiResponse {
    testoTradotto?: FraseTestoLingua | null;
}

export class FraseTestoLingua implements IFraseTestoLingua {
    fraseID?: number;
    lingua?: ELingua;
    titolo?: string | null;
    testo?: string | null;
    confermato?: boolean;

    constructor(data?: IFraseTestoLingua) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fraseID = _data["fraseID"] !== undefined ? _data["fraseID"] : null as any;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : null as any;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : null as any;
            this.confermato = _data["confermato"] !== undefined ? _data["confermato"] : null as any;
        }
    }

    static fromJS(data: any): FraseTestoLingua {
        data = typeof data === 'object' ? data : {};
        let result = new FraseTestoLingua();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fraseID"] = this.fraseID !== undefined ? this.fraseID : null as any;
        data["lingua"] = this.lingua !== undefined ? this.lingua : null as any;
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        data["testo"] = this.testo !== undefined ? this.testo : null as any;
        data["confermato"] = this.confermato !== undefined ? this.confermato : null as any;
        return data;
    }
}

export interface IFraseTestoLingua {
    fraseID?: number;
    lingua?: ELingua;
    titolo?: string | null;
    testo?: string | null;
    confermato?: boolean;
}

export class TranslatePhrasesRequest extends ApiRequest implements ITranslatePhrasesRequest {
    testo?: FraseTestoLingua | null;
    linguaDestinazione?: ELingua;

    constructor(data?: ITranslatePhrasesRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.testo = _data["testo"] ? FraseTestoLingua.fromJS(_data["testo"]) : null as any;
            this.linguaDestinazione = _data["linguaDestinazione"] !== undefined ? _data["linguaDestinazione"] : null as any;
        }
    }

    static override fromJS(data: any): TranslatePhrasesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TranslatePhrasesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["testo"] = this.testo ? this.testo.toJSON() : null as any;
        data["linguaDestinazione"] = this.linguaDestinazione !== undefined ? this.linguaDestinazione : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslatePhrasesRequest extends IApiRequest {
    testo?: FraseTestoLingua | null;
    linguaDestinazione?: ELingua;
}

export class PhraseRestoreRequest extends ApiRequest implements IPhraseRestoreRequest {
    fraseID?: number;

    constructor(data?: IPhraseRestoreRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fraseID = _data["fraseID"] !== undefined ? _data["fraseID"] : null as any;
        }
    }

    static override fromJS(data: any): PhraseRestoreRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PhraseRestoreRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fraseID"] = this.fraseID !== undefined ? this.fraseID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPhraseRestoreRequest extends IApiRequest {
    fraseID?: number;
}

/** Response containing the disabled H2H description. */
export class DisableDescrizioneH2HResponse extends OkApiResponse implements IDisableDescrizioneH2HResponse {
    /** The updated description entity. */
    descrizione?: HHDescrizione;

    constructor(data?: IDisableDescrizioneH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.descrizione = _data["descrizione"] ? HHDescrizione.fromJS(_data["descrizione"]) : null as any;
        }
    }

    static override fromJS(data: any): DisableDescrizioneH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DisableDescrizioneH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descrizione"] = this.descrizione ? this.descrizione.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Response containing the disabled H2H description. */
export interface IDisableDescrizioneH2HResponse extends IOkApiResponse {
    /** The updated description entity. */
    descrizione?: HHDescrizione;
}

export class HHDescrizione implements IHHDescrizione {
    id?: number;
    servizioHHID?: number;
    fornitore?: EFornitore;
    sourceRef?: string | null;
    lingua?: ELingua;
    title?: string | null;
    text!: string;
    html?: boolean;
    sortOrder?: number;
    disabled?: boolean;
    createdAt?: string;
    updatedAt?: string;
    translated?: boolean;

    constructor(data?: IHHDescrizione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.servizioHHID = _data["servizioHHID"] !== undefined ? _data["servizioHHID"] : null as any;
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : null as any;
            this.sourceRef = _data["sourceRef"] !== undefined ? _data["sourceRef"] : null as any;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
            this.html = _data["html"] !== undefined ? _data["html"] : null as any;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null as any;
            this.disabled = _data["disabled"] !== undefined ? _data["disabled"] : null as any;
            this.createdAt = _data["createdAt"] !== undefined ? _data["createdAt"] : null as any;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : null as any;
            this.translated = _data["translated"] !== undefined ? _data["translated"] : null as any;
        }
    }

    static fromJS(data: any): HHDescrizione {
        data = typeof data === 'object' ? data : {};
        let result = new HHDescrizione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["servizioHHID"] = this.servizioHHID !== undefined ? this.servizioHHID : null as any;
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : null as any;
        data["sourceRef"] = this.sourceRef !== undefined ? this.sourceRef : null as any;
        data["lingua"] = this.lingua !== undefined ? this.lingua : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["text"] = this.text !== undefined ? this.text : null as any;
        data["html"] = this.html !== undefined ? this.html : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        data["disabled"] = this.disabled !== undefined ? this.disabled : null as any;
        data["createdAt"] = this.createdAt !== undefined ? this.createdAt : null as any;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : null as any;
        data["translated"] = this.translated !== undefined ? this.translated : null as any;
        return data;
    }
}

export interface IHHDescrizione {
    id?: number;
    servizioHHID?: number;
    fornitore?: EFornitore;
    sourceRef?: string | null;
    lingua?: ELingua;
    title?: string | null;
    text: string;
    html?: boolean;
    sortOrder?: number;
    disabled?: boolean;
    createdAt?: string;
    updatedAt?: string;
    translated?: boolean;
}

/** Request to disable an H2H description (sets Disabled to true). */
export class DisableDescrizioneH2HRequest extends ApiRequest implements IDisableDescrizioneH2HRequest {
    /** Primary key of the description to disable. */
    descrizioneID?: number;

    constructor(data?: IDisableDescrizioneH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.descrizioneID = _data["descrizioneID"] !== undefined ? _data["descrizioneID"] : null as any;
        }
    }

    static override fromJS(data: any): DisableDescrizioneH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DisableDescrizioneH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descrizioneID"] = this.descrizioneID !== undefined ? this.descrizioneID : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Request to disable an H2H description (sets Disabled to true). */
export interface IDisableDescrizioneH2HRequest extends IApiRequest {
    /** Primary key of the description to disable. */
    descrizioneID?: number;
}

/** Response containing the enabled H2H description. */
export class EnableDescrizioneH2HResponse extends OkApiResponse implements IEnableDescrizioneH2HResponse {
    /** The updated description entity. */
    descrizione?: HHDescrizione;

    constructor(data?: IEnableDescrizioneH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.descrizione = _data["descrizione"] ? HHDescrizione.fromJS(_data["descrizione"]) : null as any;
        }
    }

    static override fromJS(data: any): EnableDescrizioneH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnableDescrizioneH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descrizione"] = this.descrizione ? this.descrizione.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Response containing the enabled H2H description. */
export interface IEnableDescrizioneH2HResponse extends IOkApiResponse {
    /** The updated description entity. */
    descrizione?: HHDescrizione;
}

/** Request to enable an H2H description (sets Disabled to false). */
export class EnableDescrizioneH2HRequest extends ApiRequest implements IEnableDescrizioneH2HRequest {
    /** Primary key of the description to enable. */
    descrizioneID?: number;

    constructor(data?: IEnableDescrizioneH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.descrizioneID = _data["descrizioneID"] !== undefined ? _data["descrizioneID"] : null as any;
        }
    }

    static override fromJS(data: any): EnableDescrizioneH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnableDescrizioneH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descrizioneID"] = this.descrizioneID !== undefined ? this.descrizioneID : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Request to enable an H2H description (sets Disabled to false). */
export interface IEnableDescrizioneH2HRequest extends IApiRequest {
    /** Primary key of the description to enable. */
    descrizioneID?: number;
}

/** Response containing a single H2H description row. */
export class GetDescrizioneH2HResponse extends OkApiResponse implements IGetDescrizioneH2HResponse {
    /** The retrieved description row DTO. */
    descrizione?: DescrizioneH2HRow;

    constructor(data?: IGetDescrizioneH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.descrizione = _data["descrizione"] ? DescrizioneH2HRow.fromJS(_data["descrizione"]) : null as any;
        }
    }

    static override fromJS(data: any): GetDescrizioneH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDescrizioneH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descrizione"] = this.descrizione ? this.descrizione.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Response containing a single H2H description row. */
export interface IGetDescrizioneH2HResponse extends IOkApiResponse {
    /** The retrieved description row DTO. */
    descrizione?: DescrizioneH2HRow;
}

/** Row DTO for an H2H description in the list view. */
export class DescrizioneH2HRow implements IDescrizioneH2HRow {
    /** Description primary key. */
    id?: number;
    /** FK to the aggregated H2H service. */
    servizioHHID?: number;
    /** Name of the aggregated service this description belongs to. */
    servizioNome?: string | null;
    /** Supplier name. */
    fornitore?: string;
    /** Language of the description. */
    lingua?: string;
    /** Description title. Max 100 chars. */
    title?: string | null;
    /** Description text content (truncated to 200 chars in list view). */
    text?: string;
    /** Whether the text content is HTML. */
    html?: boolean;
    /** Supplier-assigned display order. */
    sortOrder?: number;
    /** true when the description is enabled (i.e. Disabled = false). */
    enabled?: boolean;
    /** Last update timestamp. */
    updatedAt?: string;
    /** Supplier-provided source reference. Max 50 chars. */
    sourceRef?: string | null;
    /** Whether the description has been translated by Naar. */
    translated?: boolean;

    constructor(data?: IDescrizioneH2HRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.servizioHHID = _data["servizioHHID"] !== undefined ? _data["servizioHHID"] : null as any;
            this.servizioNome = _data["servizioNome"] !== undefined ? _data["servizioNome"] : null as any;
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : null as any;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
            this.html = _data["html"] !== undefined ? _data["html"] : null as any;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null as any;
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : null as any;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : null as any;
            this.sourceRef = _data["sourceRef"] !== undefined ? _data["sourceRef"] : null as any;
            this.translated = _data["translated"] !== undefined ? _data["translated"] : null as any;
        }
    }

    static fromJS(data: any): DescrizioneH2HRow {
        data = typeof data === 'object' ? data : {};
        let result = new DescrizioneH2HRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["servizioHHID"] = this.servizioHHID !== undefined ? this.servizioHHID : null as any;
        data["servizioNome"] = this.servizioNome !== undefined ? this.servizioNome : null as any;
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : null as any;
        data["lingua"] = this.lingua !== undefined ? this.lingua : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["text"] = this.text !== undefined ? this.text : null as any;
        data["html"] = this.html !== undefined ? this.html : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        data["enabled"] = this.enabled !== undefined ? this.enabled : null as any;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : null as any;
        data["sourceRef"] = this.sourceRef !== undefined ? this.sourceRef : null as any;
        data["translated"] = this.translated !== undefined ? this.translated : null as any;
        return data;
    }
}

/** Row DTO for an H2H description in the list view. */
export interface IDescrizioneH2HRow {
    /** Description primary key. */
    id?: number;
    /** FK to the aggregated H2H service. */
    servizioHHID?: number;
    /** Name of the aggregated service this description belongs to. */
    servizioNome?: string | null;
    /** Supplier name. */
    fornitore?: string;
    /** Language of the description. */
    lingua?: string;
    /** Description title. Max 100 chars. */
    title?: string | null;
    /** Description text content (truncated to 200 chars in list view). */
    text?: string;
    /** Whether the text content is HTML. */
    html?: boolean;
    /** Supplier-assigned display order. */
    sortOrder?: number;
    /** true when the description is enabled (i.e. Disabled = false). */
    enabled?: boolean;
    /** Last update timestamp. */
    updatedAt?: string;
    /** Supplier-provided source reference. Max 50 chars. */
    sourceRef?: string | null;
    /** Whether the description has been translated by Naar. */
    translated?: boolean;
}

/** Request to retrieve a single H2H description by its ID. */
export class GetDescrizioneH2HRequest extends LocalizedRequest implements IGetDescrizioneH2HRequest {
    /** Primary key of the description to retrieve. */
    descrizioneID!: number;

    constructor(data?: IGetDescrizioneH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.descrizioneID = _data["descrizioneID"] !== undefined ? _data["descrizioneID"] : null as any;
        }
    }

    static override fromJS(data: any): GetDescrizioneH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDescrizioneH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descrizioneID"] = this.descrizioneID !== undefined ? this.descrizioneID : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Request to retrieve a single H2H description by its ID. */
export interface IGetDescrizioneH2HRequest extends ILocalizedRequest {
    /** Primary key of the description to retrieve. */
    descrizioneID: number;
}

export class NrTableResponseOfDescrizioneH2HRow extends OkApiResponse implements INrTableResponseOfDescrizioneH2HRow {
    /** Array delle righe della pagina richiesta */
    rows?: DescrizioneH2HRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfDescrizioneH2HRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(DescrizioneH2HRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfDescrizioneH2HRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfDescrizioneH2HRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfDescrizioneH2HRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: DescrizioneH2HRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

/** Paginated response containing H2H description rows. */
export class GetDescrizioniH2HResponse extends NrTableResponseOfDescrizioneH2HRow implements IGetDescrizioniH2HResponse {

    constructor(data?: IGetDescrizioniH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetDescrizioniH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDescrizioniH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Paginated response containing H2H description rows. */
export interface IGetDescrizioniH2HResponse extends INrTableResponseOfDescrizioneH2HRow {
}

/** Request for listing H2H descriptions with optional filtering and pagination. */
export class GetDescrizioniH2HRequest extends NrTableRequest implements IGetDescrizioniH2HRequest {
    /** Optional filter by aggregated service ID (ID). */
    servizioHHID?: number | null;
    /** Optional filter by supplier (eFornitore). */
    fornitore?: EFornitore | null;
    /** Optional filter by description language (eLingua).
Named LinguaFiltro to avoid conflict with Lingua.
The explicit JsonPropertyAttribute is required because the global
Error setting fails to resolve
the camelCase mapping for this property without it. */
    linguaFiltro?: ELingua | null;
    /** Optional filter by disabled state.
true returns only disabled descriptions; false returns only enabled ones; null returns all. */
    disabled?: boolean | null;

    constructor(data?: IGetDescrizioniH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHID = _data["servizioHHID"] !== undefined ? _data["servizioHHID"] : null as any;
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : null as any;
            this.linguaFiltro = _data["linguaFiltro"] !== undefined ? _data["linguaFiltro"] : null as any;
            this.disabled = _data["disabled"] !== undefined ? _data["disabled"] : null as any;
        }
    }

    static override fromJS(data: any): GetDescrizioniH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDescrizioniH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHID"] = this.servizioHHID !== undefined ? this.servizioHHID : null as any;
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : null as any;
        data["linguaFiltro"] = this.linguaFiltro !== undefined ? this.linguaFiltro : null as any;
        data["disabled"] = this.disabled !== undefined ? this.disabled : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Request for listing H2H descriptions with optional filtering and pagination. */
export interface IGetDescrizioniH2HRequest extends INrTableRequest {
    /** Optional filter by aggregated service ID (ID). */
    servizioHHID?: number | null;
    /** Optional filter by supplier (eFornitore). */
    fornitore?: EFornitore | null;
    /** Optional filter by description language (eLingua).
Named LinguaFiltro to avoid conflict with Lingua.
The explicit JsonPropertyAttribute is required because the global
Error setting fails to resolve
the camelCase mapping for this property without it. */
    linguaFiltro?: ELingua | null;
    /** Optional filter by disabled state.
true returns only disabled descriptions; false returns only enabled ones; null returns all. */
    disabled?: boolean | null;
}

/** Response containing the updated H2H description. */
export class UpdateDescrizioneH2HResponse extends OkApiResponse implements IUpdateDescrizioneH2HResponse {
    /** The updated description entity. */
    descrizione?: HHDescrizione;

    constructor(data?: IUpdateDescrizioneH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.descrizione = _data["descrizione"] ? HHDescrizione.fromJS(_data["descrizione"]) : null as any;
        }
    }

    static override fromJS(data: any): UpdateDescrizioneH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDescrizioneH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descrizione"] = this.descrizione ? this.descrizione.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Response containing the updated H2H description. */
export interface IUpdateDescrizioneH2HResponse extends IOkApiResponse {
    /** The updated description entity. */
    descrizione?: HHDescrizione;
}

/** Request to update an H2H description. Only Text is persisted. */
export class UpdateDescrizioneH2HRequest extends ApiRequest implements IUpdateDescrizioneH2HRequest {
    /** The description to update. ID must be set. */
    descrizione?: HHDescrizione;

    constructor(data?: IUpdateDescrizioneH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.descrizione = _data["descrizione"] ? HHDescrizione.fromJS(_data["descrizione"]) : null as any;
        }
    }

    static override fromJS(data: any): UpdateDescrizioneH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDescrizioneH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descrizione"] = this.descrizione ? this.descrizione.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Request to update an H2H description. Only Text is persisted. */
export interface IUpdateDescrizioneH2HRequest extends IApiRequest {
    /** The description to update. ID must be set. */
    descrizione?: HHDescrizione;
}

export class ConvertPdfMultiResponse extends OkApiResponse implements IConvertPdfMultiResponse {
    outputTempID?: number;

    constructor(data?: IConvertPdfMultiResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.outputTempID = _data["outputTempID"] !== undefined ? _data["outputTempID"] : null as any;
        }
    }

    static override fromJS(data: any): ConvertPdfMultiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConvertPdfMultiResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outputTempID"] = this.outputTempID !== undefined ? this.outputTempID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IConvertPdfMultiResponse extends IOkApiResponse {
    outputTempID?: number;
}

export class ConvertPdfMultiRequest extends ApiRequest implements IConvertPdfMultiRequest {
    documentiIDs?: number[];
    format?: string;

    constructor(data?: IConvertPdfMultiRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["documentiIDs"])) {
                this.documentiIDs = [] as any;
                for (let item of _data["documentiIDs"])
                    this.documentiIDs!.push(item);
            }
            else {
                this.documentiIDs = null as any;
            }
            this.format = _data["format"] !== undefined ? _data["format"] : null as any;
        }
    }

    static override fromJS(data: any): ConvertPdfMultiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConvertPdfMultiRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documentiIDs)) {
            data["documentiIDs"] = [];
            for (let item of this.documentiIDs)
                data["documentiIDs"].push(item);
        }
        data["format"] = this.format !== undefined ? this.format : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IConvertPdfMultiRequest extends IApiRequest {
    documentiIDs?: number[];
    format?: string;
}

export class TripGetResponse extends OkApiResponse implements ITripGetResponse {
    id?: number;
    header?: TripHeader;
    contattoAgenziaID?: number | null;
    agency?: TripAgency | null;
    status?: TripStatus | null;
    economics?: TripEconomics | null;
    cancelCosts?: TripCancelCosts;
    paxes?: TripPaxes;
    confermata?: boolean;
    /** True se la pratica si gestisce solo in NaarNew (NaarTourOperator/api#1525): il blocco e' in Enforce e la pratica e' confermata, anche se annullata dopo. Il B2B disabilita ogni azione di modifica e mostra un banner; lo decide il server, cosi' il B2B non puo' contraddire l'API. */
    managedInNaarNew?: boolean;
    /** True se la pratica e' confermata e legacy convive con NaarNew senza bloccarla (ngsites#1394): il blocco e' in Audit e il passaggio a NaarNew e' acceso. Il B2B mostra un avviso col link a NaarNew, dove si gestiscono i servizi, ma non disabilita nulla: per questo non e' ManagedInNaarNew. */
    naarNewSideBySide?: boolean;
    /** Indirizzo della pratica nel sito di NaarNew, per il banner (ManagedInNaarNew o NaarNewSideBySide); null senza banner o se l'indirizzo del sito non e' configurato. */
    naarNewTripUrl?: string | null;
    annullata?: boolean;
    warningGlobali?: WarningOfferta[];
    confermabile?: boolean;
    warningVoli?: WarningOfferta[];
    voliPrenotabili?: boolean;
    noteAgenzia?: string[] | null;
    flights?: TripFlights;
    steps?: TripStep[];
    accontoTotale?: number;
    accontoTotaleValuta?: number;
    compensatoTotale?: number;
    compensatoTotaleValuta?: number;
    dataPrimoAcconto?: string | null;
    agreementsCosts?: TripAgreementCost[] | null;
    agreementsByRoomCosts?: TripAgreementCost[] | null;
    invoices?: TripInvoicesListRow[] | null;
    note?: TripNote[] | null;
    abilitaCopiaAgenzia?: boolean;
    /** Se true consente l'inserimento di quote di apertura con impostazione "manuale" che non vengono eliminate in automatico se il viaggio è a tappa singola */
    consentiQuoteManuali?: boolean;
    /** Tutti i servizi accessori non volo, non booking fee e non assicurazione */
    accessories?: TripStep | null;
    /** Assicurazioni per conto loro */
    insurances?: TripStep | null;
    documenti?: TripDocument[] | null;
    corrispondenzaAgenzia?: TripDocument[] | null;
    corrispondenzaFornitori?: TripDocument[] | null;
    documentiViaggio?: TripDocument[] | null;
    vouchers?: TripVoucher[] | null;
    emails?: TripEmail[] | null;
    isNew?: boolean;
    newTripData?: Offerta | null;
    documentiAllegabili?: TripAttachedDocCategory[] | null;
    documentiAgenzia?: TripAgencyDocuments;
    assicurazioni?: EServizioAutomatico[];
    voucherTuristicoID?: number | null;
    /** Percentuale attuale dei diritti di agenzia. Null se non presenti */
    percentualeDirittiAgenzia?: number | null;
    /** True se è possibile attivare il pulsante di sblocco */
    sbloccabile?: boolean;
    /** ID univoci di tutti i luoghi (città, regione, paese) toccati */
    luoghiIds?: number[];
    paxConnectID?: string | null;
    midocoID?: string | null;
    welcomeID?: number | null;
    bosysID?: string | null;
    /** Ultimo stato di sincronizzazione della pratica verso i gestionali esterni;
null se non è mai stata inviata. */
    lastSyncStatus?: TripSyncStatus | null;
    /** Se true è possibile generare l'estratto conto. */
    consentiEstrattoConto?: boolean;
    publicHash?: string;

    constructor(data?: ITripGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.header = _data["header"] ? TripHeader.fromJS(_data["header"]) : null as any;
            this.contattoAgenziaID = _data["contattoAgenziaID"] !== undefined ? _data["contattoAgenziaID"] : null as any;
            this.agency = _data["agency"] ? TripAgency.fromJS(_data["agency"]) : null as any;
            this.status = _data["status"] ? TripStatus.fromJS(_data["status"]) : null as any;
            this.economics = _data["economics"] ? TripEconomics.fromJS(_data["economics"]) : null as any;
            this.cancelCosts = _data["cancelCosts"] ? TripCancelCosts.fromJS(_data["cancelCosts"]) : null as any;
            this.paxes = _data["paxes"] ? TripPaxes.fromJS(_data["paxes"]) : null as any;
            this.confermata = _data["confermata"] !== undefined ? _data["confermata"] : null as any;
            this.managedInNaarNew = _data["managedInNaarNew"] !== undefined ? _data["managedInNaarNew"] : null as any;
            this.naarNewSideBySide = _data["naarNewSideBySide"] !== undefined ? _data["naarNewSideBySide"] : null as any;
            this.naarNewTripUrl = _data["naarNewTripUrl"] !== undefined ? _data["naarNewTripUrl"] : null as any;
            this.annullata = _data["annullata"] !== undefined ? _data["annullata"] : null as any;
            if (Array.isArray(_data["warningGlobali"])) {
                this.warningGlobali = [] as any;
                for (let item of _data["warningGlobali"])
                    this.warningGlobali!.push(WarningOfferta.fromJS(item));
            }
            else {
                this.warningGlobali = null as any;
            }
            this.confermabile = _data["confermabile"] !== undefined ? _data["confermabile"] : null as any;
            if (Array.isArray(_data["warningVoli"])) {
                this.warningVoli = [] as any;
                for (let item of _data["warningVoli"])
                    this.warningVoli!.push(WarningOfferta.fromJS(item));
            }
            else {
                this.warningVoli = null as any;
            }
            this.voliPrenotabili = _data["voliPrenotabili"] !== undefined ? _data["voliPrenotabili"] : null as any;
            if (Array.isArray(_data["noteAgenzia"])) {
                this.noteAgenzia = [] as any;
                for (let item of _data["noteAgenzia"])
                    this.noteAgenzia!.push(item);
            }
            else {
                this.noteAgenzia = null as any;
            }
            this.flights = _data["flights"] ? TripFlights.fromJS(_data["flights"]) : null as any;
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(TripStep.fromJS(item));
            }
            else {
                this.steps = null as any;
            }
            this.accontoTotale = _data["accontoTotale"] !== undefined ? _data["accontoTotale"] : null as any;
            this.accontoTotaleValuta = _data["accontoTotaleValuta"] !== undefined ? _data["accontoTotaleValuta"] : null as any;
            this.compensatoTotale = _data["compensatoTotale"] !== undefined ? _data["compensatoTotale"] : null as any;
            this.compensatoTotaleValuta = _data["compensatoTotaleValuta"] !== undefined ? _data["compensatoTotaleValuta"] : null as any;
            this.dataPrimoAcconto = _data["dataPrimoAcconto"] !== undefined ? _data["dataPrimoAcconto"] : null as any;
            if (Array.isArray(_data["agreementsCosts"])) {
                this.agreementsCosts = [] as any;
                for (let item of _data["agreementsCosts"])
                    this.agreementsCosts!.push(TripAgreementCost.fromJS(item));
            }
            else {
                this.agreementsCosts = null as any;
            }
            if (Array.isArray(_data["agreementsByRoomCosts"])) {
                this.agreementsByRoomCosts = [] as any;
                for (let item of _data["agreementsByRoomCosts"])
                    this.agreementsByRoomCosts!.push(TripAgreementCost.fromJS(item));
            }
            else {
                this.agreementsByRoomCosts = null as any;
            }
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(TripInvoicesListRow.fromJS(item));
            }
            else {
                this.invoices = null as any;
            }
            if (Array.isArray(_data["note"])) {
                this.note = [] as any;
                for (let item of _data["note"])
                    this.note!.push(TripNote.fromJS(item));
            }
            else {
                this.note = null as any;
            }
            this.abilitaCopiaAgenzia = _data["abilitaCopiaAgenzia"] !== undefined ? _data["abilitaCopiaAgenzia"] : null as any;
            this.consentiQuoteManuali = _data["consentiQuoteManuali"] !== undefined ? _data["consentiQuoteManuali"] : null as any;
            this.accessories = _data["accessories"] ? TripStep.fromJS(_data["accessories"]) : null as any;
            this.insurances = _data["insurances"] ? TripStep.fromJS(_data["insurances"]) : null as any;
            if (Array.isArray(_data["documenti"])) {
                this.documenti = [] as any;
                for (let item of _data["documenti"])
                    this.documenti!.push(TripDocument.fromJS(item));
            }
            else {
                this.documenti = null as any;
            }
            if (Array.isArray(_data["corrispondenzaAgenzia"])) {
                this.corrispondenzaAgenzia = [] as any;
                for (let item of _data["corrispondenzaAgenzia"])
                    this.corrispondenzaAgenzia!.push(TripDocument.fromJS(item));
            }
            else {
                this.corrispondenzaAgenzia = null as any;
            }
            if (Array.isArray(_data["corrispondenzaFornitori"])) {
                this.corrispondenzaFornitori = [] as any;
                for (let item of _data["corrispondenzaFornitori"])
                    this.corrispondenzaFornitori!.push(TripDocument.fromJS(item));
            }
            else {
                this.corrispondenzaFornitori = null as any;
            }
            if (Array.isArray(_data["documentiViaggio"])) {
                this.documentiViaggio = [] as any;
                for (let item of _data["documentiViaggio"])
                    this.documentiViaggio!.push(TripDocument.fromJS(item));
            }
            else {
                this.documentiViaggio = null as any;
            }
            if (Array.isArray(_data["vouchers"])) {
                this.vouchers = [] as any;
                for (let item of _data["vouchers"])
                    this.vouchers!.push(TripVoucher.fromJS(item));
            }
            else {
                this.vouchers = null as any;
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(TripEmail.fromJS(item));
            }
            else {
                this.emails = null as any;
            }
            this.isNew = _data["isNew"] !== undefined ? _data["isNew"] : null as any;
            this.newTripData = _data["newTripData"] ? Offerta.fromJS(_data["newTripData"]) : null as any;
            if (Array.isArray(_data["documentiAllegabili"])) {
                this.documentiAllegabili = [] as any;
                for (let item of _data["documentiAllegabili"])
                    this.documentiAllegabili!.push(TripAttachedDocCategory.fromJS(item));
            }
            else {
                this.documentiAllegabili = null as any;
            }
            this.documentiAgenzia = _data["documentiAgenzia"] ? TripAgencyDocuments.fromJS(_data["documentiAgenzia"]) : null as any;
            if (Array.isArray(_data["assicurazioni"])) {
                this.assicurazioni = [] as any;
                for (let item of _data["assicurazioni"])
                    this.assicurazioni!.push(item);
            }
            else {
                this.assicurazioni = null as any;
            }
            this.voucherTuristicoID = _data["voucherTuristicoID"] !== undefined ? _data["voucherTuristicoID"] : null as any;
            this.percentualeDirittiAgenzia = _data["percentualeDirittiAgenzia"] !== undefined ? _data["percentualeDirittiAgenzia"] : null as any;
            this.sbloccabile = _data["sbloccabile"] !== undefined ? _data["sbloccabile"] : null as any;
            if (Array.isArray(_data["luoghiIds"])) {
                this.luoghiIds = [] as any;
                for (let item of _data["luoghiIds"])
                    this.luoghiIds!.push(item);
            }
            else {
                this.luoghiIds = null as any;
            }
            this.paxConnectID = _data["paxConnectID"] !== undefined ? _data["paxConnectID"] : null as any;
            this.midocoID = _data["midocoID"] !== undefined ? _data["midocoID"] : null as any;
            this.welcomeID = _data["welcomeID"] !== undefined ? _data["welcomeID"] : null as any;
            this.bosysID = _data["bosysID"] !== undefined ? _data["bosysID"] : null as any;
            this.lastSyncStatus = _data["lastSyncStatus"] ? TripSyncStatus.fromJS(_data["lastSyncStatus"]) : null as any;
            this.consentiEstrattoConto = _data["consentiEstrattoConto"] !== undefined ? _data["consentiEstrattoConto"] : null as any;
            this.publicHash = _data["publicHash"] !== undefined ? _data["publicHash"] : null as any;
        }
    }

    static override fromJS(data: any): TripGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TripGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["header"] = this.header ? this.header.toJSON() : null as any;
        data["contattoAgenziaID"] = this.contattoAgenziaID !== undefined ? this.contattoAgenziaID : null as any;
        data["agency"] = this.agency ? this.agency.toJSON() : null as any;
        data["status"] = this.status ? this.status.toJSON() : null as any;
        data["economics"] = this.economics ? this.economics.toJSON() : null as any;
        data["cancelCosts"] = this.cancelCosts ? this.cancelCosts.toJSON() : null as any;
        data["paxes"] = this.paxes ? this.paxes.toJSON() : null as any;
        data["confermata"] = this.confermata !== undefined ? this.confermata : null as any;
        data["managedInNaarNew"] = this.managedInNaarNew !== undefined ? this.managedInNaarNew : null as any;
        data["naarNewSideBySide"] = this.naarNewSideBySide !== undefined ? this.naarNewSideBySide : null as any;
        data["naarNewTripUrl"] = this.naarNewTripUrl !== undefined ? this.naarNewTripUrl : null as any;
        data["annullata"] = this.annullata !== undefined ? this.annullata : null as any;
        if (Array.isArray(this.warningGlobali)) {
            data["warningGlobali"] = [];
            for (let item of this.warningGlobali)
                data["warningGlobali"].push(item ? item.toJSON() : null as any);
        }
        data["confermabile"] = this.confermabile !== undefined ? this.confermabile : null as any;
        if (Array.isArray(this.warningVoli)) {
            data["warningVoli"] = [];
            for (let item of this.warningVoli)
                data["warningVoli"].push(item ? item.toJSON() : null as any);
        }
        data["voliPrenotabili"] = this.voliPrenotabili !== undefined ? this.voliPrenotabili : null as any;
        if (Array.isArray(this.noteAgenzia)) {
            data["noteAgenzia"] = [];
            for (let item of this.noteAgenzia)
                data["noteAgenzia"].push(item);
        }
        data["flights"] = this.flights ? this.flights.toJSON() : null as any;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item ? item.toJSON() : null as any);
        }
        data["accontoTotale"] = this.accontoTotale !== undefined ? this.accontoTotale : null as any;
        data["accontoTotaleValuta"] = this.accontoTotaleValuta !== undefined ? this.accontoTotaleValuta : null as any;
        data["compensatoTotale"] = this.compensatoTotale !== undefined ? this.compensatoTotale : null as any;
        data["compensatoTotaleValuta"] = this.compensatoTotaleValuta !== undefined ? this.compensatoTotaleValuta : null as any;
        data["dataPrimoAcconto"] = this.dataPrimoAcconto !== undefined ? this.dataPrimoAcconto : null as any;
        if (Array.isArray(this.agreementsCosts)) {
            data["agreementsCosts"] = [];
            for (let item of this.agreementsCosts)
                data["agreementsCosts"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.agreementsByRoomCosts)) {
            data["agreementsByRoomCosts"] = [];
            for (let item of this.agreementsByRoomCosts)
                data["agreementsByRoomCosts"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.note)) {
            data["note"] = [];
            for (let item of this.note)
                data["note"].push(item ? item.toJSON() : null as any);
        }
        data["abilitaCopiaAgenzia"] = this.abilitaCopiaAgenzia !== undefined ? this.abilitaCopiaAgenzia : null as any;
        data["consentiQuoteManuali"] = this.consentiQuoteManuali !== undefined ? this.consentiQuoteManuali : null as any;
        data["accessories"] = this.accessories ? this.accessories.toJSON() : null as any;
        data["insurances"] = this.insurances ? this.insurances.toJSON() : null as any;
        if (Array.isArray(this.documenti)) {
            data["documenti"] = [];
            for (let item of this.documenti)
                data["documenti"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.corrispondenzaAgenzia)) {
            data["corrispondenzaAgenzia"] = [];
            for (let item of this.corrispondenzaAgenzia)
                data["corrispondenzaAgenzia"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.corrispondenzaFornitori)) {
            data["corrispondenzaFornitori"] = [];
            for (let item of this.corrispondenzaFornitori)
                data["corrispondenzaFornitori"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.documentiViaggio)) {
            data["documentiViaggio"] = [];
            for (let item of this.documentiViaggio)
                data["documentiViaggio"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.vouchers)) {
            data["vouchers"] = [];
            for (let item of this.vouchers)
                data["vouchers"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item ? item.toJSON() : null as any);
        }
        data["isNew"] = this.isNew !== undefined ? this.isNew : null as any;
        data["newTripData"] = this.newTripData ? this.newTripData.toJSON() : null as any;
        if (Array.isArray(this.documentiAllegabili)) {
            data["documentiAllegabili"] = [];
            for (let item of this.documentiAllegabili)
                data["documentiAllegabili"].push(item ? item.toJSON() : null as any);
        }
        data["documentiAgenzia"] = this.documentiAgenzia ? this.documentiAgenzia.toJSON() : null as any;
        if (Array.isArray(this.assicurazioni)) {
            data["assicurazioni"] = [];
            for (let item of this.assicurazioni)
                data["assicurazioni"].push(item);
        }
        data["voucherTuristicoID"] = this.voucherTuristicoID !== undefined ? this.voucherTuristicoID : null as any;
        data["percentualeDirittiAgenzia"] = this.percentualeDirittiAgenzia !== undefined ? this.percentualeDirittiAgenzia : null as any;
        data["sbloccabile"] = this.sbloccabile !== undefined ? this.sbloccabile : null as any;
        if (Array.isArray(this.luoghiIds)) {
            data["luoghiIds"] = [];
            for (let item of this.luoghiIds)
                data["luoghiIds"].push(item);
        }
        data["paxConnectID"] = this.paxConnectID !== undefined ? this.paxConnectID : null as any;
        data["midocoID"] = this.midocoID !== undefined ? this.midocoID : null as any;
        data["welcomeID"] = this.welcomeID !== undefined ? this.welcomeID : null as any;
        data["bosysID"] = this.bosysID !== undefined ? this.bosysID : null as any;
        data["lastSyncStatus"] = this.lastSyncStatus ? this.lastSyncStatus.toJSON() : null as any;
        data["consentiEstrattoConto"] = this.consentiEstrattoConto !== undefined ? this.consentiEstrattoConto : null as any;
        data["publicHash"] = this.publicHash !== undefined ? this.publicHash : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITripGetResponse extends IOkApiResponse {
    id?: number;
    header?: TripHeader;
    contattoAgenziaID?: number | null;
    agency?: TripAgency | null;
    status?: TripStatus | null;
    economics?: TripEconomics | null;
    cancelCosts?: TripCancelCosts;
    paxes?: TripPaxes;
    confermata?: boolean;
    /** True se la pratica si gestisce solo in NaarNew (NaarTourOperator/api#1525): il blocco e' in Enforce e la pratica e' confermata, anche se annullata dopo. Il B2B disabilita ogni azione di modifica e mostra un banner; lo decide il server, cosi' il B2B non puo' contraddire l'API. */
    managedInNaarNew?: boolean;
    /** True se la pratica e' confermata e legacy convive con NaarNew senza bloccarla (ngsites#1394): il blocco e' in Audit e il passaggio a NaarNew e' acceso. Il B2B mostra un avviso col link a NaarNew, dove si gestiscono i servizi, ma non disabilita nulla: per questo non e' ManagedInNaarNew. */
    naarNewSideBySide?: boolean;
    /** Indirizzo della pratica nel sito di NaarNew, per il banner (ManagedInNaarNew o NaarNewSideBySide); null senza banner o se l'indirizzo del sito non e' configurato. */
    naarNewTripUrl?: string | null;
    annullata?: boolean;
    warningGlobali?: WarningOfferta[];
    confermabile?: boolean;
    warningVoli?: WarningOfferta[];
    voliPrenotabili?: boolean;
    noteAgenzia?: string[] | null;
    flights?: TripFlights;
    steps?: TripStep[];
    accontoTotale?: number;
    accontoTotaleValuta?: number;
    compensatoTotale?: number;
    compensatoTotaleValuta?: number;
    dataPrimoAcconto?: string | null;
    agreementsCosts?: TripAgreementCost[] | null;
    agreementsByRoomCosts?: TripAgreementCost[] | null;
    invoices?: TripInvoicesListRow[] | null;
    note?: TripNote[] | null;
    abilitaCopiaAgenzia?: boolean;
    /** Se true consente l'inserimento di quote di apertura con impostazione "manuale" che non vengono eliminate in automatico se il viaggio è a tappa singola */
    consentiQuoteManuali?: boolean;
    /** Tutti i servizi accessori non volo, non booking fee e non assicurazione */
    accessories?: TripStep | null;
    /** Assicurazioni per conto loro */
    insurances?: TripStep | null;
    documenti?: TripDocument[] | null;
    corrispondenzaAgenzia?: TripDocument[] | null;
    corrispondenzaFornitori?: TripDocument[] | null;
    documentiViaggio?: TripDocument[] | null;
    vouchers?: TripVoucher[] | null;
    emails?: TripEmail[] | null;
    isNew?: boolean;
    newTripData?: Offerta | null;
    documentiAllegabili?: TripAttachedDocCategory[] | null;
    documentiAgenzia?: TripAgencyDocuments;
    assicurazioni?: EServizioAutomatico[];
    voucherTuristicoID?: number | null;
    /** Percentuale attuale dei diritti di agenzia. Null se non presenti */
    percentualeDirittiAgenzia?: number | null;
    /** True se è possibile attivare il pulsante di sblocco */
    sbloccabile?: boolean;
    /** ID univoci di tutti i luoghi (città, regione, paese) toccati */
    luoghiIds?: number[];
    paxConnectID?: string | null;
    midocoID?: string | null;
    welcomeID?: number | null;
    bosysID?: string | null;
    /** Ultimo stato di sincronizzazione della pratica verso i gestionali esterni;
null se non è mai stata inviata. */
    lastSyncStatus?: TripSyncStatus | null;
    /** Se true è possibile generare l'estratto conto. */
    consentiEstrattoConto?: boolean;
    publicHash?: string;
}

export class TripHeader implements ITripHeader {
    id?: number;
    descrizione?: string | null;
    /** Titolo interno */
    titoloViaggio?: string | null;
    /** Titolo da usare nei documenti */
    titoloDocumenti?: string | null;
    note?: string | null;
    partenza?: string;
    termine?: string;
    giorni?: number;
    notti?: number;
    numeroPax?: number;
    numeroTappe?: number;
    nozze?: boolean;
    tipo?: ETipoViaggio;
    statoUtente?: EStatoOffertaUtente;
    modalitaQuote?: EModalitaQuote;
    dataCancellazioneTO?: string | null;
    offerta?: Offerta;
    /** Flag che indica che la stampa dell'offerta non richiede verifica prezzi */
    prezziAggiornati?: boolean;
    valutaNonEuro?: boolean;
    codiceValuta?: string;
    cambioValuta?: number;
    totale?: number | null;
    totaleValuta?: number | null;
    destinazione?: string | null;
    totaleCommissioni?: number | null;
    totaleCommissioniValuta?: number | null;
    totaleNetto?: number | null;
    totaleNettoValuta?: number | null;
    ritenutaAcconto?: number | null;
    ritenutaAccontoValuta?: number | null;
    /** Solo intranet */
    utenteCreatore?: string | null;
    anticipiFornitoreAggiornati?: boolean;
    /** Lingua del viaggio */
    lingua?: ELingua;

    constructor(data?: ITripHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.titoloViaggio = _data["titoloViaggio"] !== undefined ? _data["titoloViaggio"] : null as any;
            this.titoloDocumenti = _data["titoloDocumenti"] !== undefined ? _data["titoloDocumenti"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : null as any;
            this.termine = _data["termine"] !== undefined ? _data["termine"] : null as any;
            this.giorni = _data["giorni"] !== undefined ? _data["giorni"] : null as any;
            this.notti = _data["notti"] !== undefined ? _data["notti"] : null as any;
            this.numeroPax = _data["numeroPax"] !== undefined ? _data["numeroPax"] : null as any;
            this.numeroTappe = _data["numeroTappe"] !== undefined ? _data["numeroTappe"] : null as any;
            this.nozze = _data["nozze"] !== undefined ? _data["nozze"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.statoUtente = _data["statoUtente"] !== undefined ? _data["statoUtente"] : null as any;
            this.modalitaQuote = _data["modalitaQuote"] !== undefined ? _data["modalitaQuote"] : null as any;
            this.dataCancellazioneTO = _data["dataCancellazioneTO"] !== undefined ? _data["dataCancellazioneTO"] : null as any;
            this.offerta = _data["offerta"] ? Offerta.fromJS(_data["offerta"]) : null as any;
            this.prezziAggiornati = _data["prezziAggiornati"] !== undefined ? _data["prezziAggiornati"] : null as any;
            this.valutaNonEuro = _data["valutaNonEuro"] !== undefined ? _data["valutaNonEuro"] : null as any;
            this.codiceValuta = _data["codiceValuta"] !== undefined ? _data["codiceValuta"] : null as any;
            this.cambioValuta = _data["cambioValuta"] !== undefined ? _data["cambioValuta"] : null as any;
            this.totale = _data["totale"] !== undefined ? _data["totale"] : null as any;
            this.totaleValuta = _data["totaleValuta"] !== undefined ? _data["totaleValuta"] : null as any;
            this.destinazione = _data["destinazione"] !== undefined ? _data["destinazione"] : null as any;
            this.totaleCommissioni = _data["totaleCommissioni"] !== undefined ? _data["totaleCommissioni"] : null as any;
            this.totaleCommissioniValuta = _data["totaleCommissioniValuta"] !== undefined ? _data["totaleCommissioniValuta"] : null as any;
            this.totaleNetto = _data["totaleNetto"] !== undefined ? _data["totaleNetto"] : null as any;
            this.totaleNettoValuta = _data["totaleNettoValuta"] !== undefined ? _data["totaleNettoValuta"] : null as any;
            this.ritenutaAcconto = _data["ritenutaAcconto"] !== undefined ? _data["ritenutaAcconto"] : null as any;
            this.ritenutaAccontoValuta = _data["ritenutaAccontoValuta"] !== undefined ? _data["ritenutaAccontoValuta"] : null as any;
            this.utenteCreatore = _data["utenteCreatore"] !== undefined ? _data["utenteCreatore"] : null as any;
            this.anticipiFornitoreAggiornati = _data["anticipiFornitoreAggiornati"] !== undefined ? _data["anticipiFornitoreAggiornati"] : null as any;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : null as any;
        }
    }

    static fromJS(data: any): TripHeader {
        data = typeof data === 'object' ? data : {};
        let result = new TripHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["titoloViaggio"] = this.titoloViaggio !== undefined ? this.titoloViaggio : null as any;
        data["titoloDocumenti"] = this.titoloDocumenti !== undefined ? this.titoloDocumenti : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["partenza"] = this.partenza !== undefined ? this.partenza : null as any;
        data["termine"] = this.termine !== undefined ? this.termine : null as any;
        data["giorni"] = this.giorni !== undefined ? this.giorni : null as any;
        data["notti"] = this.notti !== undefined ? this.notti : null as any;
        data["numeroPax"] = this.numeroPax !== undefined ? this.numeroPax : null as any;
        data["numeroTappe"] = this.numeroTappe !== undefined ? this.numeroTappe : null as any;
        data["nozze"] = this.nozze !== undefined ? this.nozze : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["statoUtente"] = this.statoUtente !== undefined ? this.statoUtente : null as any;
        data["modalitaQuote"] = this.modalitaQuote !== undefined ? this.modalitaQuote : null as any;
        data["dataCancellazioneTO"] = this.dataCancellazioneTO !== undefined ? this.dataCancellazioneTO : null as any;
        data["offerta"] = this.offerta ? this.offerta.toJSON() : null as any;
        data["prezziAggiornati"] = this.prezziAggiornati !== undefined ? this.prezziAggiornati : null as any;
        data["valutaNonEuro"] = this.valutaNonEuro !== undefined ? this.valutaNonEuro : null as any;
        data["codiceValuta"] = this.codiceValuta !== undefined ? this.codiceValuta : null as any;
        data["cambioValuta"] = this.cambioValuta !== undefined ? this.cambioValuta : null as any;
        data["totale"] = this.totale !== undefined ? this.totale : null as any;
        data["totaleValuta"] = this.totaleValuta !== undefined ? this.totaleValuta : null as any;
        data["destinazione"] = this.destinazione !== undefined ? this.destinazione : null as any;
        data["totaleCommissioni"] = this.totaleCommissioni !== undefined ? this.totaleCommissioni : null as any;
        data["totaleCommissioniValuta"] = this.totaleCommissioniValuta !== undefined ? this.totaleCommissioniValuta : null as any;
        data["totaleNetto"] = this.totaleNetto !== undefined ? this.totaleNetto : null as any;
        data["totaleNettoValuta"] = this.totaleNettoValuta !== undefined ? this.totaleNettoValuta : null as any;
        data["ritenutaAcconto"] = this.ritenutaAcconto !== undefined ? this.ritenutaAcconto : null as any;
        data["ritenutaAccontoValuta"] = this.ritenutaAccontoValuta !== undefined ? this.ritenutaAccontoValuta : null as any;
        data["utenteCreatore"] = this.utenteCreatore !== undefined ? this.utenteCreatore : null as any;
        data["anticipiFornitoreAggiornati"] = this.anticipiFornitoreAggiornati !== undefined ? this.anticipiFornitoreAggiornati : null as any;
        data["lingua"] = this.lingua !== undefined ? this.lingua : null as any;
        return data;
    }
}

export interface ITripHeader {
    id?: number;
    descrizione?: string | null;
    /** Titolo interno */
    titoloViaggio?: string | null;
    /** Titolo da usare nei documenti */
    titoloDocumenti?: string | null;
    note?: string | null;
    partenza?: string;
    termine?: string;
    giorni?: number;
    notti?: number;
    numeroPax?: number;
    numeroTappe?: number;
    nozze?: boolean;
    tipo?: ETipoViaggio;
    statoUtente?: EStatoOffertaUtente;
    modalitaQuote?: EModalitaQuote;
    dataCancellazioneTO?: string | null;
    offerta?: Offerta;
    /** Flag che indica che la stampa dell'offerta non richiede verifica prezzi */
    prezziAggiornati?: boolean;
    valutaNonEuro?: boolean;
    codiceValuta?: string;
    cambioValuta?: number;
    totale?: number | null;
    totaleValuta?: number | null;
    destinazione?: string | null;
    totaleCommissioni?: number | null;
    totaleCommissioniValuta?: number | null;
    totaleNetto?: number | null;
    totaleNettoValuta?: number | null;
    ritenutaAcconto?: number | null;
    ritenutaAccontoValuta?: number | null;
    /** Solo intranet */
    utenteCreatore?: string | null;
    anticipiFornitoreAggiornati?: boolean;
    /** Lingua del viaggio */
    lingua?: ELingua;
}

export enum ETipoViaggio {
    Indefinito = "Indefinito",
    Vip = "Vip",
    Gruppo = "Gruppo",
    Tci = "Tci",
    Adv = "Adv",
    EasyTop = "EasyTop",
    Pacchetto = "Pacchetto",
}

export enum EStatoOffertaUtente {
    Preventivo = "Preventivo",
    PrenotazioneInCorso = "PrenotazioneInCorso",
    Confermata = "Confermata",
    Annullata = "Annullata",
}

export enum EModalitaQuote {
    Naar = "Naar",
    Online = "Online",
    OnlineUpgrade = "OnlineUpgrade",
}

export class Offerta implements IOfferta {
    offertaID?: number;
    riferimento?: number;
    descrizione?: string | null;
    destinazioneID?: number | null;
    creazione?: string;
    partenza?: string;
    tipo?: ETipoViaggio | null;
    impiegatoUtenteID?: number;
    totale?: number | null;
    totaleCommissione?: number | null;
    totaleCommissioneCee?: number | null;
    totaleCosto?: number | null;
    operatore?: EOperatore;
    codiceAeroportoPartenza?: string | null;
    note?: string | null;
    numeroPax?: number | null;
    versione?: number;
    cookie?: string | null;
    nozze?: boolean;
    templateID?: number | null;
    tipologiaID?: number | null;
    offertaOrigineID?: number | null;
    totaleAssicurato?: number | null;
    anticipiAggiornati?: boolean;
    titoloViaggio?: string | null;
    penaleMassima?: number | null;
    ultimoAggiornamentoPenaleMassima?: string | null;
    ritorno?: string | null;
    servizioID?: number | null;

    constructor(data?: IOfferta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.riferimento = _data["riferimento"] !== undefined ? _data["riferimento"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.destinazioneID = _data["destinazioneID"] !== undefined ? _data["destinazioneID"] : null as any;
            this.creazione = _data["creazione"] !== undefined ? _data["creazione"] : null as any;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.impiegatoUtenteID = _data["impiegatoUtenteID"] !== undefined ? _data["impiegatoUtenteID"] : null as any;
            this.totale = _data["totale"] !== undefined ? _data["totale"] : null as any;
            this.totaleCommissione = _data["totaleCommissione"] !== undefined ? _data["totaleCommissione"] : null as any;
            this.totaleCommissioneCee = _data["totaleCommissioneCee"] !== undefined ? _data["totaleCommissioneCee"] : null as any;
            this.totaleCosto = _data["totaleCosto"] !== undefined ? _data["totaleCosto"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.codiceAeroportoPartenza = _data["codiceAeroportoPartenza"] !== undefined ? _data["codiceAeroportoPartenza"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.numeroPax = _data["numeroPax"] !== undefined ? _data["numeroPax"] : null as any;
            this.versione = _data["versione"] !== undefined ? _data["versione"] : null as any;
            this.cookie = _data["cookie"] !== undefined ? _data["cookie"] : null as any;
            this.nozze = _data["nozze"] !== undefined ? _data["nozze"] : null as any;
            this.templateID = _data["templateID"] !== undefined ? _data["templateID"] : null as any;
            this.tipologiaID = _data["tipologiaID"] !== undefined ? _data["tipologiaID"] : null as any;
            this.offertaOrigineID = _data["offertaOrigineID"] !== undefined ? _data["offertaOrigineID"] : null as any;
            this.totaleAssicurato = _data["totaleAssicurato"] !== undefined ? _data["totaleAssicurato"] : null as any;
            this.anticipiAggiornati = _data["anticipiAggiornati"] !== undefined ? _data["anticipiAggiornati"] : null as any;
            this.titoloViaggio = _data["titoloViaggio"] !== undefined ? _data["titoloViaggio"] : null as any;
            this.penaleMassima = _data["penaleMassima"] !== undefined ? _data["penaleMassima"] : null as any;
            this.ultimoAggiornamentoPenaleMassima = _data["ultimoAggiornamentoPenaleMassima"] !== undefined ? _data["ultimoAggiornamentoPenaleMassima"] : null as any;
            this.ritorno = _data["ritorno"] !== undefined ? _data["ritorno"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
        }
    }

    static fromJS(data: any): Offerta {
        data = typeof data === 'object' ? data : {};
        let result = new Offerta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["riferimento"] = this.riferimento !== undefined ? this.riferimento : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["destinazioneID"] = this.destinazioneID !== undefined ? this.destinazioneID : null as any;
        data["creazione"] = this.creazione !== undefined ? this.creazione : null as any;
        data["partenza"] = this.partenza !== undefined ? this.partenza : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["impiegatoUtenteID"] = this.impiegatoUtenteID !== undefined ? this.impiegatoUtenteID : null as any;
        data["totale"] = this.totale !== undefined ? this.totale : null as any;
        data["totaleCommissione"] = this.totaleCommissione !== undefined ? this.totaleCommissione : null as any;
        data["totaleCommissioneCee"] = this.totaleCommissioneCee !== undefined ? this.totaleCommissioneCee : null as any;
        data["totaleCosto"] = this.totaleCosto !== undefined ? this.totaleCosto : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["codiceAeroportoPartenza"] = this.codiceAeroportoPartenza !== undefined ? this.codiceAeroportoPartenza : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["numeroPax"] = this.numeroPax !== undefined ? this.numeroPax : null as any;
        data["versione"] = this.versione !== undefined ? this.versione : null as any;
        data["cookie"] = this.cookie !== undefined ? this.cookie : null as any;
        data["nozze"] = this.nozze !== undefined ? this.nozze : null as any;
        data["templateID"] = this.templateID !== undefined ? this.templateID : null as any;
        data["tipologiaID"] = this.tipologiaID !== undefined ? this.tipologiaID : null as any;
        data["offertaOrigineID"] = this.offertaOrigineID !== undefined ? this.offertaOrigineID : null as any;
        data["totaleAssicurato"] = this.totaleAssicurato !== undefined ? this.totaleAssicurato : null as any;
        data["anticipiAggiornati"] = this.anticipiAggiornati !== undefined ? this.anticipiAggiornati : null as any;
        data["titoloViaggio"] = this.titoloViaggio !== undefined ? this.titoloViaggio : null as any;
        data["penaleMassima"] = this.penaleMassima !== undefined ? this.penaleMassima : null as any;
        data["ultimoAggiornamentoPenaleMassima"] = this.ultimoAggiornamentoPenaleMassima !== undefined ? this.ultimoAggiornamentoPenaleMassima : null as any;
        data["ritorno"] = this.ritorno !== undefined ? this.ritorno : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        return data;
    }
}

export interface IOfferta {
    offertaID?: number;
    riferimento?: number;
    descrizione?: string | null;
    destinazioneID?: number | null;
    creazione?: string;
    partenza?: string;
    tipo?: ETipoViaggio | null;
    impiegatoUtenteID?: number;
    totale?: number | null;
    totaleCommissione?: number | null;
    totaleCommissioneCee?: number | null;
    totaleCosto?: number | null;
    operatore?: EOperatore;
    codiceAeroportoPartenza?: string | null;
    note?: string | null;
    numeroPax?: number | null;
    versione?: number;
    cookie?: string | null;
    nozze?: boolean;
    templateID?: number | null;
    tipologiaID?: number | null;
    offertaOrigineID?: number | null;
    totaleAssicurato?: number | null;
    anticipiAggiornati?: boolean;
    titoloViaggio?: string | null;
    penaleMassima?: number | null;
    ultimoAggiornamentoPenaleMassima?: string | null;
    ritorno?: string | null;
    servizioID?: number | null;
}

export class TripAgency implements ITripAgency {
    offertaAgenzia?: OffertaAgenzia;
    id?: number;
    contattoID?: number;
    nome?: string | null;
    cognome?: string | null;
    indirizzo?: string | null;
    civico?: string | null;
    cap?: string | null;
    luogo?: string | null;
    provincia?: string | null;
    paese?: string | null;
    telefono?: string | null;
    fax?: string | null;
    partitaIva?: string | null;
    email?: string | null;
    categoria?: string | null;
    pagamentoHtml?: string | null;
    contattoNetworkID?: number | null;
    network?: string | null;
    contattoPromoterID?: number | null;
    promoter?: string | null;
    telefonoPromoter?: string | null;
    acconto?: number | null;
    noAnticipoQuote?: boolean;
    accontoNozze?: number | null;
    noAnticipoBiglietti?: boolean;
    nomeAddetto?: string | null;
    emailAddetto?: string | null;
    addettoID?: number | null;
    username?: string | null;
    riferimentoCliente?: string | null;
    utentePreventivoID?: number | null;
    utentePreventivo?: string | null;
    utenteConfermaID?: number | null;
    utenteConferma?: string | null;
    utenteDocumentiID?: number | null;
    utenteDocumenti?: string | null;
    dataEvasionePrevista?: string | null;
    dataAppuntamentoAgenzia?: string | null;
    dataConferma?: string | null;
    dataConfermaTO?: string | null;
    dataCancellazioneADV?: string | null;
    dataCancellazioneTO?: string | null;
    commissione?: number | null;
    utenteTariffaID?: number | null;
    utenteTariffa?: string | null;
    utenteBiglietteriaID?: number | null;
    utenteBiglietteria?: string | null;
    richiedeAggiornamentoValute?: boolean;
    commissioneAccordo?: number | null;
    logoUrl?: string | null;
    statusPreventivo?: EStatusPreventivo | null;
    tagIDs?: number[];

    constructor(data?: ITripAgency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaAgenzia = _data["offertaAgenzia"] ? OffertaAgenzia.fromJS(_data["offertaAgenzia"]) : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : null as any;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : null as any;
            this.civico = _data["civico"] !== undefined ? _data["civico"] : null as any;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.provincia = _data["provincia"] !== undefined ? _data["provincia"] : null as any;
            this.paese = _data["paese"] !== undefined ? _data["paese"] : null as any;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : null as any;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : null as any;
            this.partitaIva = _data["partitaIva"] !== undefined ? _data["partitaIva"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.categoria = _data["categoria"] !== undefined ? _data["categoria"] : null as any;
            this.pagamentoHtml = _data["pagamentoHtml"] !== undefined ? _data["pagamentoHtml"] : null as any;
            this.contattoNetworkID = _data["contattoNetworkID"] !== undefined ? _data["contattoNetworkID"] : null as any;
            this.network = _data["network"] !== undefined ? _data["network"] : null as any;
            this.contattoPromoterID = _data["contattoPromoterID"] !== undefined ? _data["contattoPromoterID"] : null as any;
            this.promoter = _data["promoter"] !== undefined ? _data["promoter"] : null as any;
            this.telefonoPromoter = _data["telefonoPromoter"] !== undefined ? _data["telefonoPromoter"] : null as any;
            this.acconto = _data["acconto"] !== undefined ? _data["acconto"] : null as any;
            this.noAnticipoQuote = _data["noAnticipoQuote"] !== undefined ? _data["noAnticipoQuote"] : null as any;
            this.accontoNozze = _data["accontoNozze"] !== undefined ? _data["accontoNozze"] : null as any;
            this.noAnticipoBiglietti = _data["noAnticipoBiglietti"] !== undefined ? _data["noAnticipoBiglietti"] : null as any;
            this.nomeAddetto = _data["nomeAddetto"] !== undefined ? _data["nomeAddetto"] : null as any;
            this.emailAddetto = _data["emailAddetto"] !== undefined ? _data["emailAddetto"] : null as any;
            this.addettoID = _data["addettoID"] !== undefined ? _data["addettoID"] : null as any;
            this.username = _data["username"] !== undefined ? _data["username"] : null as any;
            this.riferimentoCliente = _data["riferimentoCliente"] !== undefined ? _data["riferimentoCliente"] : null as any;
            this.utentePreventivoID = _data["utentePreventivoID"] !== undefined ? _data["utentePreventivoID"] : null as any;
            this.utentePreventivo = _data["utentePreventivo"] !== undefined ? _data["utentePreventivo"] : null as any;
            this.utenteConfermaID = _data["utenteConfermaID"] !== undefined ? _data["utenteConfermaID"] : null as any;
            this.utenteConferma = _data["utenteConferma"] !== undefined ? _data["utenteConferma"] : null as any;
            this.utenteDocumentiID = _data["utenteDocumentiID"] !== undefined ? _data["utenteDocumentiID"] : null as any;
            this.utenteDocumenti = _data["utenteDocumenti"] !== undefined ? _data["utenteDocumenti"] : null as any;
            this.dataEvasionePrevista = _data["dataEvasionePrevista"] !== undefined ? _data["dataEvasionePrevista"] : null as any;
            this.dataAppuntamentoAgenzia = _data["dataAppuntamentoAgenzia"] !== undefined ? _data["dataAppuntamentoAgenzia"] : null as any;
            this.dataConferma = _data["dataConferma"] !== undefined ? _data["dataConferma"] : null as any;
            this.dataConfermaTO = _data["dataConfermaTO"] !== undefined ? _data["dataConfermaTO"] : null as any;
            this.dataCancellazioneADV = _data["dataCancellazioneADV"] !== undefined ? _data["dataCancellazioneADV"] : null as any;
            this.dataCancellazioneTO = _data["dataCancellazioneTO"] !== undefined ? _data["dataCancellazioneTO"] : null as any;
            this.commissione = _data["commissione"] !== undefined ? _data["commissione"] : null as any;
            this.utenteTariffaID = _data["utenteTariffaID"] !== undefined ? _data["utenteTariffaID"] : null as any;
            this.utenteTariffa = _data["utenteTariffa"] !== undefined ? _data["utenteTariffa"] : null as any;
            this.utenteBiglietteriaID = _data["utenteBiglietteriaID"] !== undefined ? _data["utenteBiglietteriaID"] : null as any;
            this.utenteBiglietteria = _data["utenteBiglietteria"] !== undefined ? _data["utenteBiglietteria"] : null as any;
            this.richiedeAggiornamentoValute = _data["richiedeAggiornamentoValute"] !== undefined ? _data["richiedeAggiornamentoValute"] : null as any;
            this.commissioneAccordo = _data["commissioneAccordo"] !== undefined ? _data["commissioneAccordo"] : null as any;
            this.logoUrl = _data["logoUrl"] !== undefined ? _data["logoUrl"] : null as any;
            this.statusPreventivo = _data["statusPreventivo"] !== undefined ? _data["statusPreventivo"] : null as any;
            if (Array.isArray(_data["tagIDs"])) {
                this.tagIDs = [] as any;
                for (let item of _data["tagIDs"])
                    this.tagIDs!.push(item);
            }
            else {
                this.tagIDs = null as any;
            }
        }
    }

    static fromJS(data: any): TripAgency {
        data = typeof data === 'object' ? data : {};
        let result = new TripAgency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaAgenzia"] = this.offertaAgenzia ? this.offertaAgenzia.toJSON() : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["cognome"] = this.cognome !== undefined ? this.cognome : null as any;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : null as any;
        data["civico"] = this.civico !== undefined ? this.civico : null as any;
        data["cap"] = this.cap !== undefined ? this.cap : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["provincia"] = this.provincia !== undefined ? this.provincia : null as any;
        data["paese"] = this.paese !== undefined ? this.paese : null as any;
        data["telefono"] = this.telefono !== undefined ? this.telefono : null as any;
        data["fax"] = this.fax !== undefined ? this.fax : null as any;
        data["partitaIva"] = this.partitaIva !== undefined ? this.partitaIva : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["categoria"] = this.categoria !== undefined ? this.categoria : null as any;
        data["pagamentoHtml"] = this.pagamentoHtml !== undefined ? this.pagamentoHtml : null as any;
        data["contattoNetworkID"] = this.contattoNetworkID !== undefined ? this.contattoNetworkID : null as any;
        data["network"] = this.network !== undefined ? this.network : null as any;
        data["contattoPromoterID"] = this.contattoPromoterID !== undefined ? this.contattoPromoterID : null as any;
        data["promoter"] = this.promoter !== undefined ? this.promoter : null as any;
        data["telefonoPromoter"] = this.telefonoPromoter !== undefined ? this.telefonoPromoter : null as any;
        data["acconto"] = this.acconto !== undefined ? this.acconto : null as any;
        data["noAnticipoQuote"] = this.noAnticipoQuote !== undefined ? this.noAnticipoQuote : null as any;
        data["accontoNozze"] = this.accontoNozze !== undefined ? this.accontoNozze : null as any;
        data["noAnticipoBiglietti"] = this.noAnticipoBiglietti !== undefined ? this.noAnticipoBiglietti : null as any;
        data["nomeAddetto"] = this.nomeAddetto !== undefined ? this.nomeAddetto : null as any;
        data["emailAddetto"] = this.emailAddetto !== undefined ? this.emailAddetto : null as any;
        data["addettoID"] = this.addettoID !== undefined ? this.addettoID : null as any;
        data["username"] = this.username !== undefined ? this.username : null as any;
        data["riferimentoCliente"] = this.riferimentoCliente !== undefined ? this.riferimentoCliente : null as any;
        data["utentePreventivoID"] = this.utentePreventivoID !== undefined ? this.utentePreventivoID : null as any;
        data["utentePreventivo"] = this.utentePreventivo !== undefined ? this.utentePreventivo : null as any;
        data["utenteConfermaID"] = this.utenteConfermaID !== undefined ? this.utenteConfermaID : null as any;
        data["utenteConferma"] = this.utenteConferma !== undefined ? this.utenteConferma : null as any;
        data["utenteDocumentiID"] = this.utenteDocumentiID !== undefined ? this.utenteDocumentiID : null as any;
        data["utenteDocumenti"] = this.utenteDocumenti !== undefined ? this.utenteDocumenti : null as any;
        data["dataEvasionePrevista"] = this.dataEvasionePrevista !== undefined ? this.dataEvasionePrevista : null as any;
        data["dataAppuntamentoAgenzia"] = this.dataAppuntamentoAgenzia !== undefined ? this.dataAppuntamentoAgenzia : null as any;
        data["dataConferma"] = this.dataConferma !== undefined ? this.dataConferma : null as any;
        data["dataConfermaTO"] = this.dataConfermaTO !== undefined ? this.dataConfermaTO : null as any;
        data["dataCancellazioneADV"] = this.dataCancellazioneADV !== undefined ? this.dataCancellazioneADV : null as any;
        data["dataCancellazioneTO"] = this.dataCancellazioneTO !== undefined ? this.dataCancellazioneTO : null as any;
        data["commissione"] = this.commissione !== undefined ? this.commissione : null as any;
        data["utenteTariffaID"] = this.utenteTariffaID !== undefined ? this.utenteTariffaID : null as any;
        data["utenteTariffa"] = this.utenteTariffa !== undefined ? this.utenteTariffa : null as any;
        data["utenteBiglietteriaID"] = this.utenteBiglietteriaID !== undefined ? this.utenteBiglietteriaID : null as any;
        data["utenteBiglietteria"] = this.utenteBiglietteria !== undefined ? this.utenteBiglietteria : null as any;
        data["richiedeAggiornamentoValute"] = this.richiedeAggiornamentoValute !== undefined ? this.richiedeAggiornamentoValute : null as any;
        data["commissioneAccordo"] = this.commissioneAccordo !== undefined ? this.commissioneAccordo : null as any;
        data["logoUrl"] = this.logoUrl !== undefined ? this.logoUrl : null as any;
        data["statusPreventivo"] = this.statusPreventivo !== undefined ? this.statusPreventivo : null as any;
        if (Array.isArray(this.tagIDs)) {
            data["tagIDs"] = [];
            for (let item of this.tagIDs)
                data["tagIDs"].push(item);
        }
        return data;
    }
}

export interface ITripAgency {
    offertaAgenzia?: OffertaAgenzia;
    id?: number;
    contattoID?: number;
    nome?: string | null;
    cognome?: string | null;
    indirizzo?: string | null;
    civico?: string | null;
    cap?: string | null;
    luogo?: string | null;
    provincia?: string | null;
    paese?: string | null;
    telefono?: string | null;
    fax?: string | null;
    partitaIva?: string | null;
    email?: string | null;
    categoria?: string | null;
    pagamentoHtml?: string | null;
    contattoNetworkID?: number | null;
    network?: string | null;
    contattoPromoterID?: number | null;
    promoter?: string | null;
    telefonoPromoter?: string | null;
    acconto?: number | null;
    noAnticipoQuote?: boolean;
    accontoNozze?: number | null;
    noAnticipoBiglietti?: boolean;
    nomeAddetto?: string | null;
    emailAddetto?: string | null;
    addettoID?: number | null;
    username?: string | null;
    riferimentoCliente?: string | null;
    utentePreventivoID?: number | null;
    utentePreventivo?: string | null;
    utenteConfermaID?: number | null;
    utenteConferma?: string | null;
    utenteDocumentiID?: number | null;
    utenteDocumenti?: string | null;
    dataEvasionePrevista?: string | null;
    dataAppuntamentoAgenzia?: string | null;
    dataConferma?: string | null;
    dataConfermaTO?: string | null;
    dataCancellazioneADV?: string | null;
    dataCancellazioneTO?: string | null;
    commissione?: number | null;
    utenteTariffaID?: number | null;
    utenteTariffa?: string | null;
    utenteBiglietteriaID?: number | null;
    utenteBiglietteria?: string | null;
    richiedeAggiornamentoValute?: boolean;
    commissioneAccordo?: number | null;
    logoUrl?: string | null;
    statusPreventivo?: EStatusPreventivo | null;
    tagIDs?: number[];
}

export class OffertaAgenzia implements IOffertaAgenzia {
    offertaAgenziaID?: number;
    offertaID?: number;
    utenteID?: number | null;
    contattoAgenziaID?: number | null;
    utentePreventivoID?: number | null;
    utenteConfermaID?: number | null;
    utenteDocumentiID?: number | null;
    utenteTariffaID?: number | null;
    utenteBigliettiAereiID?: number | null;
    contattoClienteDirettoID?: number | null;
    addetto?: string | null;
    emailAddetto?: string | null;
    riferimentoCliente?: string | null;
    commissione?: number | null;
    dataCreazione?: string;
    dataConferma?: string | null;
    dataConfermaTO?: string | null;
    dataCancellazioneTourOperator?: string | null;
    dataCancellazioneConferma?: string | null;
    fatturazioneAlNetto?: boolean;
    aggiornamentoValute?: EModalitaAggiornamentoValute;
    priorita?: string | null;
    cancellata?: number | null;
    teamID?: number | null;
    statusPreventivo?: EStatusPreventivo | null;
    dataAppuntamentoAgenzia?: string | null;
    contattoNetworkID?: number | null;
    contattoPromoterID?: number | null;
    dataInvioPreventivo?: string | null;
    lingua?: ELingua | null;
    valutaID?: number | null;
    cambioValuta?: number | null;

    constructor(data?: IOffertaAgenzia) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaAgenziaID = _data["offertaAgenziaID"] !== undefined ? _data["offertaAgenziaID"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.utenteID = _data["utenteID"] !== undefined ? _data["utenteID"] : null as any;
            this.contattoAgenziaID = _data["contattoAgenziaID"] !== undefined ? _data["contattoAgenziaID"] : null as any;
            this.utentePreventivoID = _data["utentePreventivoID"] !== undefined ? _data["utentePreventivoID"] : null as any;
            this.utenteConfermaID = _data["utenteConfermaID"] !== undefined ? _data["utenteConfermaID"] : null as any;
            this.utenteDocumentiID = _data["utenteDocumentiID"] !== undefined ? _data["utenteDocumentiID"] : null as any;
            this.utenteTariffaID = _data["utenteTariffaID"] !== undefined ? _data["utenteTariffaID"] : null as any;
            this.utenteBigliettiAereiID = _data["utenteBigliettiAereiID"] !== undefined ? _data["utenteBigliettiAereiID"] : null as any;
            this.contattoClienteDirettoID = _data["contattoClienteDirettoID"] !== undefined ? _data["contattoClienteDirettoID"] : null as any;
            this.addetto = _data["addetto"] !== undefined ? _data["addetto"] : null as any;
            this.emailAddetto = _data["emailAddetto"] !== undefined ? _data["emailAddetto"] : null as any;
            this.riferimentoCliente = _data["riferimentoCliente"] !== undefined ? _data["riferimentoCliente"] : null as any;
            this.commissione = _data["commissione"] !== undefined ? _data["commissione"] : null as any;
            this.dataCreazione = _data["dataCreazione"] !== undefined ? _data["dataCreazione"] : null as any;
            this.dataConferma = _data["dataConferma"] !== undefined ? _data["dataConferma"] : null as any;
            this.dataConfermaTO = _data["dataConfermaTO"] !== undefined ? _data["dataConfermaTO"] : null as any;
            this.dataCancellazioneTourOperator = _data["dataCancellazioneTourOperator"] !== undefined ? _data["dataCancellazioneTourOperator"] : null as any;
            this.dataCancellazioneConferma = _data["dataCancellazioneConferma"] !== undefined ? _data["dataCancellazioneConferma"] : null as any;
            this.fatturazioneAlNetto = _data["fatturazioneAlNetto"] !== undefined ? _data["fatturazioneAlNetto"] : null as any;
            this.aggiornamentoValute = _data["aggiornamentoValute"] !== undefined ? _data["aggiornamentoValute"] : null as any;
            this.priorita = _data["priorita"] !== undefined ? _data["priorita"] : null as any;
            this.cancellata = _data["cancellata"] !== undefined ? _data["cancellata"] : null as any;
            this.teamID = _data["teamID"] !== undefined ? _data["teamID"] : null as any;
            this.statusPreventivo = _data["statusPreventivo"] !== undefined ? _data["statusPreventivo"] : null as any;
            this.dataAppuntamentoAgenzia = _data["dataAppuntamentoAgenzia"] !== undefined ? _data["dataAppuntamentoAgenzia"] : null as any;
            this.contattoNetworkID = _data["contattoNetworkID"] !== undefined ? _data["contattoNetworkID"] : null as any;
            this.contattoPromoterID = _data["contattoPromoterID"] !== undefined ? _data["contattoPromoterID"] : null as any;
            this.dataInvioPreventivo = _data["dataInvioPreventivo"] !== undefined ? _data["dataInvioPreventivo"] : null as any;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : null as any;
            this.valutaID = _data["valutaID"] !== undefined ? _data["valutaID"] : null as any;
            this.cambioValuta = _data["cambioValuta"] !== undefined ? _data["cambioValuta"] : null as any;
        }
    }

    static fromJS(data: any): OffertaAgenzia {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaAgenzia();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaAgenziaID"] = this.offertaAgenziaID !== undefined ? this.offertaAgenziaID : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["utenteID"] = this.utenteID !== undefined ? this.utenteID : null as any;
        data["contattoAgenziaID"] = this.contattoAgenziaID !== undefined ? this.contattoAgenziaID : null as any;
        data["utentePreventivoID"] = this.utentePreventivoID !== undefined ? this.utentePreventivoID : null as any;
        data["utenteConfermaID"] = this.utenteConfermaID !== undefined ? this.utenteConfermaID : null as any;
        data["utenteDocumentiID"] = this.utenteDocumentiID !== undefined ? this.utenteDocumentiID : null as any;
        data["utenteTariffaID"] = this.utenteTariffaID !== undefined ? this.utenteTariffaID : null as any;
        data["utenteBigliettiAereiID"] = this.utenteBigliettiAereiID !== undefined ? this.utenteBigliettiAereiID : null as any;
        data["contattoClienteDirettoID"] = this.contattoClienteDirettoID !== undefined ? this.contattoClienteDirettoID : null as any;
        data["addetto"] = this.addetto !== undefined ? this.addetto : null as any;
        data["emailAddetto"] = this.emailAddetto !== undefined ? this.emailAddetto : null as any;
        data["riferimentoCliente"] = this.riferimentoCliente !== undefined ? this.riferimentoCliente : null as any;
        data["commissione"] = this.commissione !== undefined ? this.commissione : null as any;
        data["dataCreazione"] = this.dataCreazione !== undefined ? this.dataCreazione : null as any;
        data["dataConferma"] = this.dataConferma !== undefined ? this.dataConferma : null as any;
        data["dataConfermaTO"] = this.dataConfermaTO !== undefined ? this.dataConfermaTO : null as any;
        data["dataCancellazioneTourOperator"] = this.dataCancellazioneTourOperator !== undefined ? this.dataCancellazioneTourOperator : null as any;
        data["dataCancellazioneConferma"] = this.dataCancellazioneConferma !== undefined ? this.dataCancellazioneConferma : null as any;
        data["fatturazioneAlNetto"] = this.fatturazioneAlNetto !== undefined ? this.fatturazioneAlNetto : null as any;
        data["aggiornamentoValute"] = this.aggiornamentoValute !== undefined ? this.aggiornamentoValute : null as any;
        data["priorita"] = this.priorita !== undefined ? this.priorita : null as any;
        data["cancellata"] = this.cancellata !== undefined ? this.cancellata : null as any;
        data["teamID"] = this.teamID !== undefined ? this.teamID : null as any;
        data["statusPreventivo"] = this.statusPreventivo !== undefined ? this.statusPreventivo : null as any;
        data["dataAppuntamentoAgenzia"] = this.dataAppuntamentoAgenzia !== undefined ? this.dataAppuntamentoAgenzia : null as any;
        data["contattoNetworkID"] = this.contattoNetworkID !== undefined ? this.contattoNetworkID : null as any;
        data["contattoPromoterID"] = this.contattoPromoterID !== undefined ? this.contattoPromoterID : null as any;
        data["dataInvioPreventivo"] = this.dataInvioPreventivo !== undefined ? this.dataInvioPreventivo : null as any;
        data["lingua"] = this.lingua !== undefined ? this.lingua : null as any;
        data["valutaID"] = this.valutaID !== undefined ? this.valutaID : null as any;
        data["cambioValuta"] = this.cambioValuta !== undefined ? this.cambioValuta : null as any;
        return data;
    }
}

export interface IOffertaAgenzia {
    offertaAgenziaID?: number;
    offertaID?: number;
    utenteID?: number | null;
    contattoAgenziaID?: number | null;
    utentePreventivoID?: number | null;
    utenteConfermaID?: number | null;
    utenteDocumentiID?: number | null;
    utenteTariffaID?: number | null;
    utenteBigliettiAereiID?: number | null;
    contattoClienteDirettoID?: number | null;
    addetto?: string | null;
    emailAddetto?: string | null;
    riferimentoCliente?: string | null;
    commissione?: number | null;
    dataCreazione?: string;
    dataConferma?: string | null;
    dataConfermaTO?: string | null;
    dataCancellazioneTourOperator?: string | null;
    dataCancellazioneConferma?: string | null;
    fatturazioneAlNetto?: boolean;
    aggiornamentoValute?: EModalitaAggiornamentoValute;
    priorita?: string | null;
    cancellata?: number | null;
    teamID?: number | null;
    statusPreventivo?: EStatusPreventivo | null;
    dataAppuntamentoAgenzia?: string | null;
    contattoNetworkID?: number | null;
    contattoPromoterID?: number | null;
    dataInvioPreventivo?: string | null;
    lingua?: ELingua | null;
    valutaID?: number | null;
    cambioValuta?: number | null;
}

export enum EModalitaAggiornamentoValute {
    NessunAdeguamento = "NessunAdeguamento",
    AggiornaCambi = "AggiornaCambi",
    CambiAggiornati = "CambiAggiornati",
    VerificaOfferta = "VerificaOfferta",
}

export enum EStatusPreventivo {
    DaVerificare = "DaVerificare",
    DaFare = "DaFare",
    DaModificare = "DaModificare",
    AttesaADV = "AttesaADV",
    Completato = "Completato",
    NonConcretizzato = "NonConcretizzato",
    NonEvaso = "NonEvaso",
    ConfermaDaModificare = "ConfermaDaModificare",
    NonParte = "NonParte",
    VendutoAltroTO = "VendutoAltroTO",
    NonRichiamare = "NonRichiamare",
    SupportPostVendita = "SupportPostVendita",
}

export class TripStatus implements ITripStatus {
    stato?: OffertaAgenziaStato | null;
    terminePagamento?: string | null;
    corriere?: string | null;
    acconto?: number;
    accontoValuta?: number;
    dataAcconto?: string | null;
    compensato?: number;
    compensatoValuta?: number;
    dataCompensazione?: string | null;
    saldo?: number;
    saldoValuta?: number;
    dataSaldo?: string | null;
    incassi?: OffertaIncasso[];
    utenteSblocco?: string | null;
    righeSbloccabiliIDs?: number[];
    modalitaIncassi?: EModalitaIncassi;
    totaleDare?: number | null;
    totaleDareValuta?: number | null;
    totaleAvere?: number | null;
    totaleAvereValuta?: number | null;
    totaleSbilancio?: number | null;
    totaleSbilancioValuta?: number | null;
    totaleAvereScaduto?: number | null;
    totaleAvereScadutoValuta?: number | null;

    constructor(data?: ITripStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stato = _data["stato"] ? OffertaAgenziaStato.fromJS(_data["stato"]) : null as any;
            this.terminePagamento = _data["terminePagamento"] !== undefined ? _data["terminePagamento"] : null as any;
            this.corriere = _data["corriere"] !== undefined ? _data["corriere"] : null as any;
            this.acconto = _data["acconto"] !== undefined ? _data["acconto"] : null as any;
            this.accontoValuta = _data["accontoValuta"] !== undefined ? _data["accontoValuta"] : null as any;
            this.dataAcconto = _data["dataAcconto"] !== undefined ? _data["dataAcconto"] : null as any;
            this.compensato = _data["compensato"] !== undefined ? _data["compensato"] : null as any;
            this.compensatoValuta = _data["compensatoValuta"] !== undefined ? _data["compensatoValuta"] : null as any;
            this.dataCompensazione = _data["dataCompensazione"] !== undefined ? _data["dataCompensazione"] : null as any;
            this.saldo = _data["saldo"] !== undefined ? _data["saldo"] : null as any;
            this.saldoValuta = _data["saldoValuta"] !== undefined ? _data["saldoValuta"] : null as any;
            this.dataSaldo = _data["dataSaldo"] !== undefined ? _data["dataSaldo"] : null as any;
            if (Array.isArray(_data["incassi"])) {
                this.incassi = [] as any;
                for (let item of _data["incassi"])
                    this.incassi!.push(OffertaIncasso.fromJS(item));
            }
            else {
                this.incassi = null as any;
            }
            this.utenteSblocco = _data["utenteSblocco"] !== undefined ? _data["utenteSblocco"] : null as any;
            if (Array.isArray(_data["righeSbloccabiliIDs"])) {
                this.righeSbloccabiliIDs = [] as any;
                for (let item of _data["righeSbloccabiliIDs"])
                    this.righeSbloccabiliIDs!.push(item);
            }
            else {
                this.righeSbloccabiliIDs = null as any;
            }
            this.modalitaIncassi = _data["modalitaIncassi"] !== undefined ? _data["modalitaIncassi"] : null as any;
            this.totaleDare = _data["totaleDare"] !== undefined ? _data["totaleDare"] : null as any;
            this.totaleDareValuta = _data["totaleDareValuta"] !== undefined ? _data["totaleDareValuta"] : null as any;
            this.totaleAvere = _data["totaleAvere"] !== undefined ? _data["totaleAvere"] : null as any;
            this.totaleAvereValuta = _data["totaleAvereValuta"] !== undefined ? _data["totaleAvereValuta"] : null as any;
            this.totaleSbilancio = _data["totaleSbilancio"] !== undefined ? _data["totaleSbilancio"] : null as any;
            this.totaleSbilancioValuta = _data["totaleSbilancioValuta"] !== undefined ? _data["totaleSbilancioValuta"] : null as any;
            this.totaleAvereScaduto = _data["totaleAvereScaduto"] !== undefined ? _data["totaleAvereScaduto"] : null as any;
            this.totaleAvereScadutoValuta = _data["totaleAvereScadutoValuta"] !== undefined ? _data["totaleAvereScadutoValuta"] : null as any;
        }
    }

    static fromJS(data: any): TripStatus {
        data = typeof data === 'object' ? data : {};
        let result = new TripStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stato"] = this.stato ? this.stato.toJSON() : null as any;
        data["terminePagamento"] = this.terminePagamento !== undefined ? this.terminePagamento : null as any;
        data["corriere"] = this.corriere !== undefined ? this.corriere : null as any;
        data["acconto"] = this.acconto !== undefined ? this.acconto : null as any;
        data["accontoValuta"] = this.accontoValuta !== undefined ? this.accontoValuta : null as any;
        data["dataAcconto"] = this.dataAcconto !== undefined ? this.dataAcconto : null as any;
        data["compensato"] = this.compensato !== undefined ? this.compensato : null as any;
        data["compensatoValuta"] = this.compensatoValuta !== undefined ? this.compensatoValuta : null as any;
        data["dataCompensazione"] = this.dataCompensazione !== undefined ? this.dataCompensazione : null as any;
        data["saldo"] = this.saldo !== undefined ? this.saldo : null as any;
        data["saldoValuta"] = this.saldoValuta !== undefined ? this.saldoValuta : null as any;
        data["dataSaldo"] = this.dataSaldo !== undefined ? this.dataSaldo : null as any;
        if (Array.isArray(this.incassi)) {
            data["incassi"] = [];
            for (let item of this.incassi)
                data["incassi"].push(item ? item.toJSON() : null as any);
        }
        data["utenteSblocco"] = this.utenteSblocco !== undefined ? this.utenteSblocco : null as any;
        if (Array.isArray(this.righeSbloccabiliIDs)) {
            data["righeSbloccabiliIDs"] = [];
            for (let item of this.righeSbloccabiliIDs)
                data["righeSbloccabiliIDs"].push(item);
        }
        data["modalitaIncassi"] = this.modalitaIncassi !== undefined ? this.modalitaIncassi : null as any;
        data["totaleDare"] = this.totaleDare !== undefined ? this.totaleDare : null as any;
        data["totaleDareValuta"] = this.totaleDareValuta !== undefined ? this.totaleDareValuta : null as any;
        data["totaleAvere"] = this.totaleAvere !== undefined ? this.totaleAvere : null as any;
        data["totaleAvereValuta"] = this.totaleAvereValuta !== undefined ? this.totaleAvereValuta : null as any;
        data["totaleSbilancio"] = this.totaleSbilancio !== undefined ? this.totaleSbilancio : null as any;
        data["totaleSbilancioValuta"] = this.totaleSbilancioValuta !== undefined ? this.totaleSbilancioValuta : null as any;
        data["totaleAvereScaduto"] = this.totaleAvereScaduto !== undefined ? this.totaleAvereScaduto : null as any;
        data["totaleAvereScadutoValuta"] = this.totaleAvereScadutoValuta !== undefined ? this.totaleAvereScadutoValuta : null as any;
        return data;
    }
}

export interface ITripStatus {
    stato?: OffertaAgenziaStato | null;
    terminePagamento?: string | null;
    corriere?: string | null;
    acconto?: number;
    accontoValuta?: number;
    dataAcconto?: string | null;
    compensato?: number;
    compensatoValuta?: number;
    dataCompensazione?: string | null;
    saldo?: number;
    saldoValuta?: number;
    dataSaldo?: string | null;
    incassi?: OffertaIncasso[];
    utenteSblocco?: string | null;
    righeSbloccabiliIDs?: number[];
    modalitaIncassi?: EModalitaIncassi;
    totaleDare?: number | null;
    totaleDareValuta?: number | null;
    totaleAvere?: number | null;
    totaleAvereValuta?: number | null;
    totaleSbilancio?: number | null;
    totaleSbilancioValuta?: number | null;
    totaleAvereScaduto?: number | null;
    totaleAvereScadutoValuta?: number | null;
}

export class OffertaAgenziaStato implements IOffertaAgenziaStato {
    statusID?: number;
    offertaAgenziaID?: number;
    okAgenzia?: string | null;
    okFornitori?: string | null;
    terminePagamentoID?: number | null;
    acconto?: number | null;
    dataAcconto?: string | null;
    saldo?: number | null;
    dataSaldo?: string | null;
    invioDocumenti?: string | null;
    stampaProgramma?: string | null;
    bigliettiPresiInCarico?: string | null;
    ordinaEmissioneBiglietti?: string | null;
    stampaVoucher?: string | null;
    fattura?: number;
    networkID?: number | null;
    status?: EStatoOfferta | null;
    corriereID?: number | null;
    letteraVettura?: string | null;
    note?: string | null;
    creazioneDocumentiApp?: string | null;
    documentiAppStep1?: string | null;
    documentiAppStep2?: string | null;
    updateDocumentiApp?: string | null;
    invioDocumentiApp?: string | null;
    invioDocumentiMail?: string | null;
    okDocumenti?: string | null;
    bigliettiEmessi?: string | null;
    tipoEmissioneTicket?: ETipoTicketBiglietteria | null;
    importoAcconto?: number | null;
    tipoAccontoBiglietteria?: ETipoTicketBiglietteria | null;
    tipoAccontoServizi?: ETipoAcconto | null;
    okPassaporto?: string | null;
    haRigheConOrdinaBiglietteria?: boolean;
    righeCaricoBiglietteria?: EStatoInsieme;
    righeEmesseBiglietteria?: EStatoInsieme;
    righeOkContabileBiglietteria?: EStatoInsieme;
    okContabileBiglietteria?: string | null;
    autofattura?: number;
    dataSbloccoConferma?: string | null;
    utenteSbloccoConfermaID?: number | null;
    titoloViaggio?: string | null;
    bloccoRicalcolo?: string | null;

    constructor(data?: IOffertaAgenziaStato) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusID = _data["statusID"] !== undefined ? _data["statusID"] : null as any;
            this.offertaAgenziaID = _data["offertaAgenziaID"] !== undefined ? _data["offertaAgenziaID"] : null as any;
            this.okAgenzia = _data["okAgenzia"] !== undefined ? _data["okAgenzia"] : null as any;
            this.okFornitori = _data["okFornitori"] !== undefined ? _data["okFornitori"] : null as any;
            this.terminePagamentoID = _data["terminePagamentoID"] !== undefined ? _data["terminePagamentoID"] : null as any;
            this.acconto = _data["acconto"] !== undefined ? _data["acconto"] : null as any;
            this.dataAcconto = _data["dataAcconto"] !== undefined ? _data["dataAcconto"] : null as any;
            this.saldo = _data["saldo"] !== undefined ? _data["saldo"] : null as any;
            this.dataSaldo = _data["dataSaldo"] !== undefined ? _data["dataSaldo"] : null as any;
            this.invioDocumenti = _data["invioDocumenti"] !== undefined ? _data["invioDocumenti"] : null as any;
            this.stampaProgramma = _data["stampaProgramma"] !== undefined ? _data["stampaProgramma"] : null as any;
            this.bigliettiPresiInCarico = _data["bigliettiPresiInCarico"] !== undefined ? _data["bigliettiPresiInCarico"] : null as any;
            this.ordinaEmissioneBiglietti = _data["ordinaEmissioneBiglietti"] !== undefined ? _data["ordinaEmissioneBiglietti"] : null as any;
            this.stampaVoucher = _data["stampaVoucher"] !== undefined ? _data["stampaVoucher"] : null as any;
            this.fattura = _data["fattura"] !== undefined ? _data["fattura"] : null as any;
            this.networkID = _data["networkID"] !== undefined ? _data["networkID"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.corriereID = _data["corriereID"] !== undefined ? _data["corriereID"] : null as any;
            this.letteraVettura = _data["letteraVettura"] !== undefined ? _data["letteraVettura"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.creazioneDocumentiApp = _data["creazioneDocumentiApp"] !== undefined ? _data["creazioneDocumentiApp"] : null as any;
            this.documentiAppStep1 = _data["documentiAppStep1"] !== undefined ? _data["documentiAppStep1"] : null as any;
            this.documentiAppStep2 = _data["documentiAppStep2"] !== undefined ? _data["documentiAppStep2"] : null as any;
            this.updateDocumentiApp = _data["updateDocumentiApp"] !== undefined ? _data["updateDocumentiApp"] : null as any;
            this.invioDocumentiApp = _data["invioDocumentiApp"] !== undefined ? _data["invioDocumentiApp"] : null as any;
            this.invioDocumentiMail = _data["invioDocumentiMail"] !== undefined ? _data["invioDocumentiMail"] : null as any;
            this.okDocumenti = _data["okDocumenti"] !== undefined ? _data["okDocumenti"] : null as any;
            this.bigliettiEmessi = _data["bigliettiEmessi"] !== undefined ? _data["bigliettiEmessi"] : null as any;
            this.tipoEmissioneTicket = _data["tipoEmissioneTicket"] !== undefined ? _data["tipoEmissioneTicket"] : null as any;
            this.importoAcconto = _data["importoAcconto"] !== undefined ? _data["importoAcconto"] : null as any;
            this.tipoAccontoBiglietteria = _data["tipoAccontoBiglietteria"] !== undefined ? _data["tipoAccontoBiglietteria"] : null as any;
            this.tipoAccontoServizi = _data["tipoAccontoServizi"] !== undefined ? _data["tipoAccontoServizi"] : null as any;
            this.okPassaporto = _data["okPassaporto"] !== undefined ? _data["okPassaporto"] : null as any;
            this.haRigheConOrdinaBiglietteria = _data["haRigheConOrdinaBiglietteria"] !== undefined ? _data["haRigheConOrdinaBiglietteria"] : null as any;
            this.righeCaricoBiglietteria = _data["righeCaricoBiglietteria"] !== undefined ? _data["righeCaricoBiglietteria"] : null as any;
            this.righeEmesseBiglietteria = _data["righeEmesseBiglietteria"] !== undefined ? _data["righeEmesseBiglietteria"] : null as any;
            this.righeOkContabileBiglietteria = _data["righeOkContabileBiglietteria"] !== undefined ? _data["righeOkContabileBiglietteria"] : null as any;
            this.okContabileBiglietteria = _data["okContabileBiglietteria"] !== undefined ? _data["okContabileBiglietteria"] : null as any;
            this.autofattura = _data["autofattura"] !== undefined ? _data["autofattura"] : null as any;
            this.dataSbloccoConferma = _data["dataSbloccoConferma"] !== undefined ? _data["dataSbloccoConferma"] : null as any;
            this.utenteSbloccoConfermaID = _data["utenteSbloccoConfermaID"] !== undefined ? _data["utenteSbloccoConfermaID"] : null as any;
            this.titoloViaggio = _data["titoloViaggio"] !== undefined ? _data["titoloViaggio"] : null as any;
            this.bloccoRicalcolo = _data["bloccoRicalcolo"] !== undefined ? _data["bloccoRicalcolo"] : null as any;
        }
    }

    static fromJS(data: any): OffertaAgenziaStato {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaAgenziaStato();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusID"] = this.statusID !== undefined ? this.statusID : null as any;
        data["offertaAgenziaID"] = this.offertaAgenziaID !== undefined ? this.offertaAgenziaID : null as any;
        data["okAgenzia"] = this.okAgenzia !== undefined ? this.okAgenzia : null as any;
        data["okFornitori"] = this.okFornitori !== undefined ? this.okFornitori : null as any;
        data["terminePagamentoID"] = this.terminePagamentoID !== undefined ? this.terminePagamentoID : null as any;
        data["acconto"] = this.acconto !== undefined ? this.acconto : null as any;
        data["dataAcconto"] = this.dataAcconto !== undefined ? this.dataAcconto : null as any;
        data["saldo"] = this.saldo !== undefined ? this.saldo : null as any;
        data["dataSaldo"] = this.dataSaldo !== undefined ? this.dataSaldo : null as any;
        data["invioDocumenti"] = this.invioDocumenti !== undefined ? this.invioDocumenti : null as any;
        data["stampaProgramma"] = this.stampaProgramma !== undefined ? this.stampaProgramma : null as any;
        data["bigliettiPresiInCarico"] = this.bigliettiPresiInCarico !== undefined ? this.bigliettiPresiInCarico : null as any;
        data["ordinaEmissioneBiglietti"] = this.ordinaEmissioneBiglietti !== undefined ? this.ordinaEmissioneBiglietti : null as any;
        data["stampaVoucher"] = this.stampaVoucher !== undefined ? this.stampaVoucher : null as any;
        data["fattura"] = this.fattura !== undefined ? this.fattura : null as any;
        data["networkID"] = this.networkID !== undefined ? this.networkID : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["corriereID"] = this.corriereID !== undefined ? this.corriereID : null as any;
        data["letteraVettura"] = this.letteraVettura !== undefined ? this.letteraVettura : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["creazioneDocumentiApp"] = this.creazioneDocumentiApp !== undefined ? this.creazioneDocumentiApp : null as any;
        data["documentiAppStep1"] = this.documentiAppStep1 !== undefined ? this.documentiAppStep1 : null as any;
        data["documentiAppStep2"] = this.documentiAppStep2 !== undefined ? this.documentiAppStep2 : null as any;
        data["updateDocumentiApp"] = this.updateDocumentiApp !== undefined ? this.updateDocumentiApp : null as any;
        data["invioDocumentiApp"] = this.invioDocumentiApp !== undefined ? this.invioDocumentiApp : null as any;
        data["invioDocumentiMail"] = this.invioDocumentiMail !== undefined ? this.invioDocumentiMail : null as any;
        data["okDocumenti"] = this.okDocumenti !== undefined ? this.okDocumenti : null as any;
        data["bigliettiEmessi"] = this.bigliettiEmessi !== undefined ? this.bigliettiEmessi : null as any;
        data["tipoEmissioneTicket"] = this.tipoEmissioneTicket !== undefined ? this.tipoEmissioneTicket : null as any;
        data["importoAcconto"] = this.importoAcconto !== undefined ? this.importoAcconto : null as any;
        data["tipoAccontoBiglietteria"] = this.tipoAccontoBiglietteria !== undefined ? this.tipoAccontoBiglietteria : null as any;
        data["tipoAccontoServizi"] = this.tipoAccontoServizi !== undefined ? this.tipoAccontoServizi : null as any;
        data["okPassaporto"] = this.okPassaporto !== undefined ? this.okPassaporto : null as any;
        data["haRigheConOrdinaBiglietteria"] = this.haRigheConOrdinaBiglietteria !== undefined ? this.haRigheConOrdinaBiglietteria : null as any;
        data["righeCaricoBiglietteria"] = this.righeCaricoBiglietteria !== undefined ? this.righeCaricoBiglietteria : null as any;
        data["righeEmesseBiglietteria"] = this.righeEmesseBiglietteria !== undefined ? this.righeEmesseBiglietteria : null as any;
        data["righeOkContabileBiglietteria"] = this.righeOkContabileBiglietteria !== undefined ? this.righeOkContabileBiglietteria : null as any;
        data["okContabileBiglietteria"] = this.okContabileBiglietteria !== undefined ? this.okContabileBiglietteria : null as any;
        data["autofattura"] = this.autofattura !== undefined ? this.autofattura : null as any;
        data["dataSbloccoConferma"] = this.dataSbloccoConferma !== undefined ? this.dataSbloccoConferma : null as any;
        data["utenteSbloccoConfermaID"] = this.utenteSbloccoConfermaID !== undefined ? this.utenteSbloccoConfermaID : null as any;
        data["titoloViaggio"] = this.titoloViaggio !== undefined ? this.titoloViaggio : null as any;
        data["bloccoRicalcolo"] = this.bloccoRicalcolo !== undefined ? this.bloccoRicalcolo : null as any;
        return data;
    }
}

export interface IOffertaAgenziaStato {
    statusID?: number;
    offertaAgenziaID?: number;
    okAgenzia?: string | null;
    okFornitori?: string | null;
    terminePagamentoID?: number | null;
    acconto?: number | null;
    dataAcconto?: string | null;
    saldo?: number | null;
    dataSaldo?: string | null;
    invioDocumenti?: string | null;
    stampaProgramma?: string | null;
    bigliettiPresiInCarico?: string | null;
    ordinaEmissioneBiglietti?: string | null;
    stampaVoucher?: string | null;
    fattura?: number;
    networkID?: number | null;
    status?: EStatoOfferta | null;
    corriereID?: number | null;
    letteraVettura?: string | null;
    note?: string | null;
    creazioneDocumentiApp?: string | null;
    documentiAppStep1?: string | null;
    documentiAppStep2?: string | null;
    updateDocumentiApp?: string | null;
    invioDocumentiApp?: string | null;
    invioDocumentiMail?: string | null;
    okDocumenti?: string | null;
    bigliettiEmessi?: string | null;
    tipoEmissioneTicket?: ETipoTicketBiglietteria | null;
    importoAcconto?: number | null;
    tipoAccontoBiglietteria?: ETipoTicketBiglietteria | null;
    tipoAccontoServizi?: ETipoAcconto | null;
    okPassaporto?: string | null;
    haRigheConOrdinaBiglietteria?: boolean;
    righeCaricoBiglietteria?: EStatoInsieme;
    righeEmesseBiglietteria?: EStatoInsieme;
    righeOkContabileBiglietteria?: EStatoInsieme;
    okContabileBiglietteria?: string | null;
    autofattura?: number;
    dataSbloccoConferma?: string | null;
    utenteSbloccoConfermaID?: number | null;
    titoloViaggio?: string | null;
    bloccoRicalcolo?: string | null;
}

export enum EStatoOfferta {
    Manuale = "Manuale",
    AttesaPagamento = "AttesaPagamento",
    InPrenotazione = "InPrenotazione",
    InEmissioneDoc = "InEmissioneDoc",
    ViaggioPronto = "ViaggioPronto",
    InCancellazione = "InCancellazione",
    Cancellato = "Cancellato",
    ViaggioChiuso = "ViaggioChiuso",
    ViaggioInContenzioso = "ViaggioInContenzioso",
}

export enum EStatoInsieme {
    Nessuno = "Nessuno",
    Parte = "Parte",
    Tutto = "Tutto",
}

export class TripEconomics implements ITripEconomics {
    dataConfermaTO?: string | null;
    margineLordo?: number;
    margineLordoValuta?: number;
    margineLordoPercentuale?: number;
    commissioniAgenzia?: number;
    commissioniAgenziaValuta?: number;
    commissioniAgenziaPercentuale?: number;
    margineNetto?: number;
    margineNettoValuta?: number;
    margineNettoPercentuale?: number;
    /** Percentuale massima delle commissioni d'agenzia sulla biglietteria. */
    maxPercentualeCommissioneAgenziaSuBiglietteria?: number;
    /** Importo massimo della commissione agenzia su biglietteria calcolata su questo viaggio */
    maxImportoCommissioneAgenziaSuBiglietteria?: number;
    /** Percentuale massima dei diritti d'agenzia */
    maxPercentualeDirittiAgenzia?: number;
    /** Importo massimo dei diritti d'agenzia calcolata su questo viaggio */
    maxImportoDirittiAgenzia?: number;
    /** Scadenze pagamenti agenzia (Avere o Previsione) */
    mastrino?: OffertaIncasso[];
    /** Per ricostruire la scaletta */
    tipoImportoAnticipo?: EImportoAnticipoMaggiore | null;
    /** Importo degli anticipi percentuali */
    importoAnticipoPercentuale?: number;
    importoAnticipoPercentualeValuta?: number;
    /** Importo delle somme da anticipare comunque */
    importoSommeDaAnticipare?: number;
    importoSommeDaAnticipareValuta?: number;
    /** Percentuale anticipo contrattuale */
    percentualeAnticipo?: number | null;
    /** Totale dei movimenti Dare */
    totaleIncassi?: number;
    totaleIncassiValuta?: number;
    /** Totale netto - totale incassi */
    residuoDaIncassare?: number;
    residuoDaIncassareValuta?: number;
    /** Residuo da incassare scaduto alla data odierna */
    residuoDaIncassareScaduto?: number;
    residuoDaIncassareScadutoValuta?: number;

    constructor(data?: ITripEconomics) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataConfermaTO = _data["dataConfermaTO"] !== undefined ? _data["dataConfermaTO"] : null as any;
            this.margineLordo = _data["margineLordo"] !== undefined ? _data["margineLordo"] : null as any;
            this.margineLordoValuta = _data["margineLordoValuta"] !== undefined ? _data["margineLordoValuta"] : null as any;
            this.margineLordoPercentuale = _data["margineLordoPercentuale"] !== undefined ? _data["margineLordoPercentuale"] : null as any;
            this.commissioniAgenzia = _data["commissioniAgenzia"] !== undefined ? _data["commissioniAgenzia"] : null as any;
            this.commissioniAgenziaValuta = _data["commissioniAgenziaValuta"] !== undefined ? _data["commissioniAgenziaValuta"] : null as any;
            this.commissioniAgenziaPercentuale = _data["commissioniAgenziaPercentuale"] !== undefined ? _data["commissioniAgenziaPercentuale"] : null as any;
            this.margineNetto = _data["margineNetto"] !== undefined ? _data["margineNetto"] : null as any;
            this.margineNettoValuta = _data["margineNettoValuta"] !== undefined ? _data["margineNettoValuta"] : null as any;
            this.margineNettoPercentuale = _data["margineNettoPercentuale"] !== undefined ? _data["margineNettoPercentuale"] : null as any;
            this.maxPercentualeCommissioneAgenziaSuBiglietteria = _data["maxPercentualeCommissioneAgenziaSuBiglietteria"] !== undefined ? _data["maxPercentualeCommissioneAgenziaSuBiglietteria"] : null as any;
            this.maxImportoCommissioneAgenziaSuBiglietteria = _data["maxImportoCommissioneAgenziaSuBiglietteria"] !== undefined ? _data["maxImportoCommissioneAgenziaSuBiglietteria"] : null as any;
            this.maxPercentualeDirittiAgenzia = _data["maxPercentualeDirittiAgenzia"] !== undefined ? _data["maxPercentualeDirittiAgenzia"] : null as any;
            this.maxImportoDirittiAgenzia = _data["maxImportoDirittiAgenzia"] !== undefined ? _data["maxImportoDirittiAgenzia"] : null as any;
            if (Array.isArray(_data["mastrino"])) {
                this.mastrino = [] as any;
                for (let item of _data["mastrino"])
                    this.mastrino!.push(OffertaIncasso.fromJS(item));
            }
            else {
                this.mastrino = null as any;
            }
            this.tipoImportoAnticipo = _data["tipoImportoAnticipo"] !== undefined ? _data["tipoImportoAnticipo"] : null as any;
            this.importoAnticipoPercentuale = _data["importoAnticipoPercentuale"] !== undefined ? _data["importoAnticipoPercentuale"] : null as any;
            this.importoAnticipoPercentualeValuta = _data["importoAnticipoPercentualeValuta"] !== undefined ? _data["importoAnticipoPercentualeValuta"] : null as any;
            this.importoSommeDaAnticipare = _data["importoSommeDaAnticipare"] !== undefined ? _data["importoSommeDaAnticipare"] : null as any;
            this.importoSommeDaAnticipareValuta = _data["importoSommeDaAnticipareValuta"] !== undefined ? _data["importoSommeDaAnticipareValuta"] : null as any;
            this.percentualeAnticipo = _data["percentualeAnticipo"] !== undefined ? _data["percentualeAnticipo"] : null as any;
            this.totaleIncassi = _data["totaleIncassi"] !== undefined ? _data["totaleIncassi"] : null as any;
            this.totaleIncassiValuta = _data["totaleIncassiValuta"] !== undefined ? _data["totaleIncassiValuta"] : null as any;
            this.residuoDaIncassare = _data["residuoDaIncassare"] !== undefined ? _data["residuoDaIncassare"] : null as any;
            this.residuoDaIncassareValuta = _data["residuoDaIncassareValuta"] !== undefined ? _data["residuoDaIncassareValuta"] : null as any;
            this.residuoDaIncassareScaduto = _data["residuoDaIncassareScaduto"] !== undefined ? _data["residuoDaIncassareScaduto"] : null as any;
            this.residuoDaIncassareScadutoValuta = _data["residuoDaIncassareScadutoValuta"] !== undefined ? _data["residuoDaIncassareScadutoValuta"] : null as any;
        }
    }

    static fromJS(data: any): TripEconomics {
        data = typeof data === 'object' ? data : {};
        let result = new TripEconomics();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataConfermaTO"] = this.dataConfermaTO !== undefined ? this.dataConfermaTO : null as any;
        data["margineLordo"] = this.margineLordo !== undefined ? this.margineLordo : null as any;
        data["margineLordoValuta"] = this.margineLordoValuta !== undefined ? this.margineLordoValuta : null as any;
        data["margineLordoPercentuale"] = this.margineLordoPercentuale !== undefined ? this.margineLordoPercentuale : null as any;
        data["commissioniAgenzia"] = this.commissioniAgenzia !== undefined ? this.commissioniAgenzia : null as any;
        data["commissioniAgenziaValuta"] = this.commissioniAgenziaValuta !== undefined ? this.commissioniAgenziaValuta : null as any;
        data["commissioniAgenziaPercentuale"] = this.commissioniAgenziaPercentuale !== undefined ? this.commissioniAgenziaPercentuale : null as any;
        data["margineNetto"] = this.margineNetto !== undefined ? this.margineNetto : null as any;
        data["margineNettoValuta"] = this.margineNettoValuta !== undefined ? this.margineNettoValuta : null as any;
        data["margineNettoPercentuale"] = this.margineNettoPercentuale !== undefined ? this.margineNettoPercentuale : null as any;
        data["maxPercentualeCommissioneAgenziaSuBiglietteria"] = this.maxPercentualeCommissioneAgenziaSuBiglietteria !== undefined ? this.maxPercentualeCommissioneAgenziaSuBiglietteria : null as any;
        data["maxImportoCommissioneAgenziaSuBiglietteria"] = this.maxImportoCommissioneAgenziaSuBiglietteria !== undefined ? this.maxImportoCommissioneAgenziaSuBiglietteria : null as any;
        data["maxPercentualeDirittiAgenzia"] = this.maxPercentualeDirittiAgenzia !== undefined ? this.maxPercentualeDirittiAgenzia : null as any;
        data["maxImportoDirittiAgenzia"] = this.maxImportoDirittiAgenzia !== undefined ? this.maxImportoDirittiAgenzia : null as any;
        if (Array.isArray(this.mastrino)) {
            data["mastrino"] = [];
            for (let item of this.mastrino)
                data["mastrino"].push(item ? item.toJSON() : null as any);
        }
        data["tipoImportoAnticipo"] = this.tipoImportoAnticipo !== undefined ? this.tipoImportoAnticipo : null as any;
        data["importoAnticipoPercentuale"] = this.importoAnticipoPercentuale !== undefined ? this.importoAnticipoPercentuale : null as any;
        data["importoAnticipoPercentualeValuta"] = this.importoAnticipoPercentualeValuta !== undefined ? this.importoAnticipoPercentualeValuta : null as any;
        data["importoSommeDaAnticipare"] = this.importoSommeDaAnticipare !== undefined ? this.importoSommeDaAnticipare : null as any;
        data["importoSommeDaAnticipareValuta"] = this.importoSommeDaAnticipareValuta !== undefined ? this.importoSommeDaAnticipareValuta : null as any;
        data["percentualeAnticipo"] = this.percentualeAnticipo !== undefined ? this.percentualeAnticipo : null as any;
        data["totaleIncassi"] = this.totaleIncassi !== undefined ? this.totaleIncassi : null as any;
        data["totaleIncassiValuta"] = this.totaleIncassiValuta !== undefined ? this.totaleIncassiValuta : null as any;
        data["residuoDaIncassare"] = this.residuoDaIncassare !== undefined ? this.residuoDaIncassare : null as any;
        data["residuoDaIncassareValuta"] = this.residuoDaIncassareValuta !== undefined ? this.residuoDaIncassareValuta : null as any;
        data["residuoDaIncassareScaduto"] = this.residuoDaIncassareScaduto !== undefined ? this.residuoDaIncassareScaduto : null as any;
        data["residuoDaIncassareScadutoValuta"] = this.residuoDaIncassareScadutoValuta !== undefined ? this.residuoDaIncassareScadutoValuta : null as any;
        return data;
    }
}

export interface ITripEconomics {
    dataConfermaTO?: string | null;
    margineLordo?: number;
    margineLordoValuta?: number;
    margineLordoPercentuale?: number;
    commissioniAgenzia?: number;
    commissioniAgenziaValuta?: number;
    commissioniAgenziaPercentuale?: number;
    margineNetto?: number;
    margineNettoValuta?: number;
    margineNettoPercentuale?: number;
    /** Percentuale massima delle commissioni d'agenzia sulla biglietteria. */
    maxPercentualeCommissioneAgenziaSuBiglietteria?: number;
    /** Importo massimo della commissione agenzia su biglietteria calcolata su questo viaggio */
    maxImportoCommissioneAgenziaSuBiglietteria?: number;
    /** Percentuale massima dei diritti d'agenzia */
    maxPercentualeDirittiAgenzia?: number;
    /** Importo massimo dei diritti d'agenzia calcolata su questo viaggio */
    maxImportoDirittiAgenzia?: number;
    /** Scadenze pagamenti agenzia (Avere o Previsione) */
    mastrino?: OffertaIncasso[];
    /** Per ricostruire la scaletta */
    tipoImportoAnticipo?: EImportoAnticipoMaggiore | null;
    /** Importo degli anticipi percentuali */
    importoAnticipoPercentuale?: number;
    importoAnticipoPercentualeValuta?: number;
    /** Importo delle somme da anticipare comunque */
    importoSommeDaAnticipare?: number;
    importoSommeDaAnticipareValuta?: number;
    /** Percentuale anticipo contrattuale */
    percentualeAnticipo?: number | null;
    /** Totale dei movimenti Dare */
    totaleIncassi?: number;
    totaleIncassiValuta?: number;
    /** Totale netto - totale incassi */
    residuoDaIncassare?: number;
    residuoDaIncassareValuta?: number;
    /** Residuo da incassare scaduto alla data odierna */
    residuoDaIncassareScaduto?: number;
    residuoDaIncassareScadutoValuta?: number;
}

export enum EImportoAnticipoMaggiore {
    AnticipiContrattualiPercentuali = "AnticipiContrattualiPercentuali",
    ServiziDaPagareAllaConferma = "ServiziDaPagareAllaConferma",
}

export class TripCancelCosts implements ITripCancelCosts {
    cancelCosts?: TripCancelCostRow[];
    totalEnsuredCost?: number;

    constructor(data?: ITripCancelCosts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cancelCosts"])) {
                this.cancelCosts = [] as any;
                for (let item of _data["cancelCosts"])
                    this.cancelCosts!.push(TripCancelCostRow.fromJS(item));
            }
            else {
                this.cancelCosts = null as any;
            }
            this.totalEnsuredCost = _data["totalEnsuredCost"] !== undefined ? _data["totalEnsuredCost"] : null as any;
        }
    }

    static fromJS(data: any): TripCancelCosts {
        data = typeof data === 'object' ? data : {};
        let result = new TripCancelCosts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cancelCosts)) {
            data["cancelCosts"] = [];
            for (let item of this.cancelCosts)
                data["cancelCosts"].push(item ? item.toJSON() : null as any);
        }
        data["totalEnsuredCost"] = this.totalEnsuredCost !== undefined ? this.totalEnsuredCost : null as any;
        return data;
    }
}

export interface ITripCancelCosts {
    cancelCosts?: TripCancelCostRow[];
    totalEnsuredCost?: number;
}

export class TripCancelCostRow implements ITripCancelCostRow {
    rowID?: number;
    name?: string;
    notRefundable?: boolean;
    limitDate?: string | null;
    amount?: number | null;

    constructor(data?: ITripCancelCostRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowID = _data["rowID"] !== undefined ? _data["rowID"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.notRefundable = _data["notRefundable"] !== undefined ? _data["notRefundable"] : null as any;
            this.limitDate = _data["limitDate"] !== undefined ? _data["limitDate"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
        }
    }

    static fromJS(data: any): TripCancelCostRow {
        data = typeof data === 'object' ? data : {};
        let result = new TripCancelCostRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowID"] = this.rowID !== undefined ? this.rowID : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["notRefundable"] = this.notRefundable !== undefined ? this.notRefundable : null as any;
        data["limitDate"] = this.limitDate !== undefined ? this.limitDate : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        return data;
    }
}

export interface ITripCancelCostRow {
    rowID?: number;
    name?: string;
    notRefundable?: boolean;
    limitDate?: string | null;
    amount?: number | null;
}

export class TripPaxes implements ITripPaxes {
    paxes?: TripPax[];
    abbinamenti?: TripRoom[];
    adulti?: number;
    bambini?: number;
    dataNascitaDefaultAdulto?: string;
    dataNascitaDefaultBambino?: string;
    camereSemplici?: boolean;

    constructor(data?: ITripPaxes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["paxes"])) {
                this.paxes = [] as any;
                for (let item of _data["paxes"])
                    this.paxes!.push(TripPax.fromJS(item));
            }
            else {
                this.paxes = null as any;
            }
            if (Array.isArray(_data["abbinamenti"])) {
                this.abbinamenti = [] as any;
                for (let item of _data["abbinamenti"])
                    this.abbinamenti!.push(TripRoom.fromJS(item));
            }
            else {
                this.abbinamenti = null as any;
            }
            this.adulti = _data["adulti"] !== undefined ? _data["adulti"] : null as any;
            this.bambini = _data["bambini"] !== undefined ? _data["bambini"] : null as any;
            this.dataNascitaDefaultAdulto = _data["dataNascitaDefaultAdulto"] !== undefined ? _data["dataNascitaDefaultAdulto"] : null as any;
            this.dataNascitaDefaultBambino = _data["dataNascitaDefaultBambino"] !== undefined ? _data["dataNascitaDefaultBambino"] : null as any;
            this.camereSemplici = _data["camereSemplici"] !== undefined ? _data["camereSemplici"] : null as any;
        }
    }

    static fromJS(data: any): TripPaxes {
        data = typeof data === 'object' ? data : {};
        let result = new TripPaxes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.paxes)) {
            data["paxes"] = [];
            for (let item of this.paxes)
                data["paxes"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.abbinamenti)) {
            data["abbinamenti"] = [];
            for (let item of this.abbinamenti)
                data["abbinamenti"].push(item ? item.toJSON() : null as any);
        }
        data["adulti"] = this.adulti !== undefined ? this.adulti : null as any;
        data["bambini"] = this.bambini !== undefined ? this.bambini : null as any;
        data["dataNascitaDefaultAdulto"] = this.dataNascitaDefaultAdulto !== undefined ? this.dataNascitaDefaultAdulto : null as any;
        data["dataNascitaDefaultBambino"] = this.dataNascitaDefaultBambino !== undefined ? this.dataNascitaDefaultBambino : null as any;
        data["camereSemplici"] = this.camereSemplici !== undefined ? this.camereSemplici : null as any;
        return data;
    }
}

export interface ITripPaxes {
    paxes?: TripPax[];
    abbinamenti?: TripRoom[];
    adulti?: number;
    bambini?: number;
    dataNascitaDefaultAdulto?: string;
    dataNascitaDefaultBambino?: string;
    camereSemplici?: boolean;
}

export class TripPax implements ITripPax {
    cliente?: Cliente;
    dati?: ClienteDato | null;
    completo?: boolean;
    camere?: string[];
    servizi?: TripService[];

    constructor(data?: ITripPax) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cliente = _data["cliente"] ? Cliente.fromJS(_data["cliente"]) : null as any;
            this.dati = _data["dati"] ? ClienteDato.fromJS(_data["dati"]) : null as any;
            this.completo = _data["completo"] !== undefined ? _data["completo"] : null as any;
            if (Array.isArray(_data["camere"])) {
                this.camere = [] as any;
                for (let item of _data["camere"])
                    this.camere!.push(item);
            }
            else {
                this.camere = null as any;
            }
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(TripService.fromJS(item));
            }
            else {
                this.servizi = null as any;
            }
        }
    }

    static fromJS(data: any): TripPax {
        data = typeof data === 'object' ? data : {};
        let result = new TripPax();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cliente"] = this.cliente ? this.cliente.toJSON() : null as any;
        data["dati"] = this.dati ? this.dati.toJSON() : null as any;
        data["completo"] = this.completo !== undefined ? this.completo : null as any;
        if (Array.isArray(this.camere)) {
            data["camere"] = [];
            for (let item of this.camere)
                data["camere"].push(item);
        }
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ITripPax {
    cliente?: Cliente;
    dati?: ClienteDato | null;
    completo?: boolean;
    camere?: string[];
    servizi?: TripService[];
}

export class Cliente implements ICliente {
    clienteID?: number;
    clienteIdPrecedente?: number | null;
    offertaAgenziaID?: number | null;
    clienteLeaderID?: number | null;
    abbinamentoID?: number | null;
    titolo?: ETitolo;
    nome?: string | null;
    cognome?: string | null;
    codiceFiscale?: string | null;
    dataNascita?: string | null;
    tesseraTCI?: string | null;
    dataNascitaCorretta?: boolean;

    constructor(data?: ICliente) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clienteID = _data["clienteID"] !== undefined ? _data["clienteID"] : null as any;
            this.clienteIdPrecedente = _data["clienteIdPrecedente"] !== undefined ? _data["clienteIdPrecedente"] : null as any;
            this.offertaAgenziaID = _data["offertaAgenziaID"] !== undefined ? _data["offertaAgenziaID"] : null as any;
            this.clienteLeaderID = _data["clienteLeaderID"] !== undefined ? _data["clienteLeaderID"] : null as any;
            this.abbinamentoID = _data["abbinamentoID"] !== undefined ? _data["abbinamentoID"] : null as any;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : null as any;
            this.codiceFiscale = _data["codiceFiscale"] !== undefined ? _data["codiceFiscale"] : null as any;
            this.dataNascita = _data["dataNascita"] !== undefined ? _data["dataNascita"] : null as any;
            this.tesseraTCI = _data["tesseraTCI"] !== undefined ? _data["tesseraTCI"] : null as any;
            this.dataNascitaCorretta = _data["dataNascitaCorretta"] !== undefined ? _data["dataNascitaCorretta"] : null as any;
        }
    }

    static fromJS(data: any): Cliente {
        data = typeof data === 'object' ? data : {};
        let result = new Cliente();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clienteID"] = this.clienteID !== undefined ? this.clienteID : null as any;
        data["clienteIdPrecedente"] = this.clienteIdPrecedente !== undefined ? this.clienteIdPrecedente : null as any;
        data["offertaAgenziaID"] = this.offertaAgenziaID !== undefined ? this.offertaAgenziaID : null as any;
        data["clienteLeaderID"] = this.clienteLeaderID !== undefined ? this.clienteLeaderID : null as any;
        data["abbinamentoID"] = this.abbinamentoID !== undefined ? this.abbinamentoID : null as any;
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["cognome"] = this.cognome !== undefined ? this.cognome : null as any;
        data["codiceFiscale"] = this.codiceFiscale !== undefined ? this.codiceFiscale : null as any;
        data["dataNascita"] = this.dataNascita !== undefined ? this.dataNascita : null as any;
        data["tesseraTCI"] = this.tesseraTCI !== undefined ? this.tesseraTCI : null as any;
        data["dataNascitaCorretta"] = this.dataNascitaCorretta !== undefined ? this.dataNascitaCorretta : null as any;
        return data;
    }
}

export interface ICliente {
    clienteID?: number;
    clienteIdPrecedente?: number | null;
    offertaAgenziaID?: number | null;
    clienteLeaderID?: number | null;
    abbinamentoID?: number | null;
    titolo?: ETitolo;
    nome?: string | null;
    cognome?: string | null;
    codiceFiscale?: string | null;
    dataNascita?: string | null;
    tesseraTCI?: string | null;
    dataNascitaCorretta?: boolean;
}

export class ClienteDato implements IClienteDato {
    id?: number;
    cellulare?: string | null;
    passaporto?: string | null;
    scadenzaPassaporto?: string | null;
    codiceIstatComune?: string | null;
    luogoNascita?: string | null;
    nazionalita?: string | null;
    paeseRilascioPass?: string | null;
    indirizzo?: string | null;
    cap?: string | null;
    comune?: string | null;
    provincia?: string | null;
    email?: string | null;

    constructor(data?: IClienteDato) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.cellulare = _data["cellulare"] !== undefined ? _data["cellulare"] : null as any;
            this.passaporto = _data["passaporto"] !== undefined ? _data["passaporto"] : null as any;
            this.scadenzaPassaporto = _data["scadenzaPassaporto"] !== undefined ? _data["scadenzaPassaporto"] : null as any;
            this.codiceIstatComune = _data["codiceIstatComune"] !== undefined ? _data["codiceIstatComune"] : null as any;
            this.luogoNascita = _data["luogoNascita"] !== undefined ? _data["luogoNascita"] : null as any;
            this.nazionalita = _data["nazionalita"] !== undefined ? _data["nazionalita"] : null as any;
            this.paeseRilascioPass = _data["paeseRilascioPass"] !== undefined ? _data["paeseRilascioPass"] : null as any;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : null as any;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : null as any;
            this.comune = _data["comune"] !== undefined ? _data["comune"] : null as any;
            this.provincia = _data["provincia"] !== undefined ? _data["provincia"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
        }
    }

    static fromJS(data: any): ClienteDato {
        data = typeof data === 'object' ? data : {};
        let result = new ClienteDato();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["cellulare"] = this.cellulare !== undefined ? this.cellulare : null as any;
        data["passaporto"] = this.passaporto !== undefined ? this.passaporto : null as any;
        data["scadenzaPassaporto"] = this.scadenzaPassaporto !== undefined ? this.scadenzaPassaporto : null as any;
        data["codiceIstatComune"] = this.codiceIstatComune !== undefined ? this.codiceIstatComune : null as any;
        data["luogoNascita"] = this.luogoNascita !== undefined ? this.luogoNascita : null as any;
        data["nazionalita"] = this.nazionalita !== undefined ? this.nazionalita : null as any;
        data["paeseRilascioPass"] = this.paeseRilascioPass !== undefined ? this.paeseRilascioPass : null as any;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : null as any;
        data["cap"] = this.cap !== undefined ? this.cap : null as any;
        data["comune"] = this.comune !== undefined ? this.comune : null as any;
        data["provincia"] = this.provincia !== undefined ? this.provincia : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        return data;
    }
}

export interface IClienteDato {
    id?: number;
    cellulare?: string | null;
    passaporto?: string | null;
    scadenzaPassaporto?: string | null;
    codiceIstatComune?: string | null;
    luogoNascita?: string | null;
    nazionalita?: string | null;
    paeseRilascioPass?: string | null;
    indirizzo?: string | null;
    cap?: string | null;
    comune?: string | null;
    provincia?: string | null;
    email?: string | null;
}

export class TripService implements ITripService {
    id?: number;
    luogo?: string | null;
    luogoFine?: string | null;
    abbinamento?: string | null;
    cliente?: string | null;
    /** Data e ora di checkin / inizio */
    data?: string;
    /** Data e ora di checkout / fine */
    dataCheckout?: string | null;
    notti?: number;
    isHotel?: boolean;
    isVolo?: boolean;
    isNoleggio?: boolean;
    isTrasferimento?: boolean;
    isVisita?: boolean;
    haPaginaDettaglio?: boolean;
    descrizione?: string | null;
    /** Descrizione da usare nel programma di viaggio */
    descrizioneProgramma?: string | null;
    urlPart?: string | null;
    servizioID?: number | null;
    esterno?: boolean;
    disponibilita?: EStatoDisponibilita;
    disponibilitaPrecedente?: EStatoDisponibilita | null;
    daQuotare?: boolean;
    prezzoIndicativo?: boolean;
    status?: EStatoServizioUtente;
    numeroConferma?: string | null;
    accessori?: boolean;
    prezzo?: number;
    prezzoValuta?: number;
    pagamentoAnticipato?: boolean;
    adulti?: number;
    bambini?: number;
    prezzoPrecedente?: number | null;
    prezzoPrecedenteValuta?: number | null;
    dati?: TripServiceData | null;
    penale?: PenaleServizio | null;
    printableAccessori?: boolean;
    eliminabile?: boolean;
    eliminabileAgenzia?: boolean;
    nascostoAgenzia?: boolean;
    /** True se il servizio ha un pagamento fornitore associato che è sbloccabile */
    pagamentoSbloccabile?: boolean;
    /** Elenco delle note associate a questa riga prelevate dagli articoli */
    note?: TripTextHtml[] | null;
    /** Elenco delle offerte speciali / azioni applicate  */
    dettagliPrezzi?: TripServicePriceDetail[];
    /** Elenco delle componenti del prezzo */
    composizionePrezzo?: TripServicePriceDetail[] | null;
    /** Testo dell'articolo penali di cancellazione da visualizzare all'agenzia.
Calcolato in base alla presenza: di una nota custom, di un articolo di penale, dei dati aggiuntivi penale default, della nota fornitore
in questo ordine */
    testoPenali?: TripTextHtml | null;
    /** Indica quale degli eventuali molteplici testi di penale è destinato all'agenzia */
    tipoTestoPenale?: ETestoPenaleAgenzia;
    durata?: ServiceDuration | null;
    tappe?: string | null;
    /** Data di ultimo aggiornamento dei prezzi */
    dataUltimoAggiornamento?: string | null;
    /** Lista da usare per associare le note a piè di pagina sui documenti */
    elencoNotePiePagina?: number[];
    /** Lista da usare per associare le righe dello specchietto anticipi sui documenti. Per ora in teoria max 1 riferimento.
Ma conoscendo i nostri polli... */
    elencoRiferimentiAnticipi?: number[];
    fullContent?: boolean;
    puntoIniziale?: TripServiceLocation | null;
    puntoFinale?: TripServiceLocation | null;

    constructor(data?: ITripService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.luogoFine = _data["luogoFine"] !== undefined ? _data["luogoFine"] : null as any;
            this.abbinamento = _data["abbinamento"] !== undefined ? _data["abbinamento"] : null as any;
            this.cliente = _data["cliente"] !== undefined ? _data["cliente"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
            this.dataCheckout = _data["dataCheckout"] !== undefined ? _data["dataCheckout"] : null as any;
            this.notti = _data["notti"] !== undefined ? _data["notti"] : null as any;
            this.isHotel = _data["isHotel"] !== undefined ? _data["isHotel"] : null as any;
            this.isVolo = _data["isVolo"] !== undefined ? _data["isVolo"] : null as any;
            this.isNoleggio = _data["isNoleggio"] !== undefined ? _data["isNoleggio"] : null as any;
            this.isTrasferimento = _data["isTrasferimento"] !== undefined ? _data["isTrasferimento"] : null as any;
            this.isVisita = _data["isVisita"] !== undefined ? _data["isVisita"] : null as any;
            this.haPaginaDettaglio = _data["haPaginaDettaglio"] !== undefined ? _data["haPaginaDettaglio"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.descrizioneProgramma = _data["descrizioneProgramma"] !== undefined ? _data["descrizioneProgramma"] : null as any;
            this.urlPart = _data["urlPart"] !== undefined ? _data["urlPart"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.esterno = _data["esterno"] !== undefined ? _data["esterno"] : null as any;
            this.disponibilita = _data["disponibilita"] !== undefined ? _data["disponibilita"] : null as any;
            this.disponibilitaPrecedente = _data["disponibilitaPrecedente"] !== undefined ? _data["disponibilitaPrecedente"] : null as any;
            this.daQuotare = _data["daQuotare"] !== undefined ? _data["daQuotare"] : null as any;
            this.prezzoIndicativo = _data["prezzoIndicativo"] !== undefined ? _data["prezzoIndicativo"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.numeroConferma = _data["numeroConferma"] !== undefined ? _data["numeroConferma"] : null as any;
            this.accessori = _data["accessori"] !== undefined ? _data["accessori"] : null as any;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : null as any;
            this.prezzoValuta = _data["prezzoValuta"] !== undefined ? _data["prezzoValuta"] : null as any;
            this.pagamentoAnticipato = _data["pagamentoAnticipato"] !== undefined ? _data["pagamentoAnticipato"] : null as any;
            this.adulti = _data["adulti"] !== undefined ? _data["adulti"] : null as any;
            this.bambini = _data["bambini"] !== undefined ? _data["bambini"] : null as any;
            this.prezzoPrecedente = _data["prezzoPrecedente"] !== undefined ? _data["prezzoPrecedente"] : null as any;
            this.prezzoPrecedenteValuta = _data["prezzoPrecedenteValuta"] !== undefined ? _data["prezzoPrecedenteValuta"] : null as any;
            this.dati = _data["dati"] ? TripServiceData.fromJS(_data["dati"]) : null as any;
            this.penale = _data["penale"] ? PenaleServizio.fromJS(_data["penale"]) : null as any;
            this.printableAccessori = _data["printableAccessori"] !== undefined ? _data["printableAccessori"] : null as any;
            this.eliminabile = _data["eliminabile"] !== undefined ? _data["eliminabile"] : null as any;
            this.eliminabileAgenzia = _data["eliminabileAgenzia"] !== undefined ? _data["eliminabileAgenzia"] : null as any;
            this.nascostoAgenzia = _data["nascostoAgenzia"] !== undefined ? _data["nascostoAgenzia"] : null as any;
            this.pagamentoSbloccabile = _data["pagamentoSbloccabile"] !== undefined ? _data["pagamentoSbloccabile"] : null as any;
            if (Array.isArray(_data["note"])) {
                this.note = [] as any;
                for (let item of _data["note"])
                    this.note!.push(TripTextHtml.fromJS(item));
            }
            else {
                this.note = null as any;
            }
            if (Array.isArray(_data["dettagliPrezzi"])) {
                this.dettagliPrezzi = [] as any;
                for (let item of _data["dettagliPrezzi"])
                    this.dettagliPrezzi!.push(TripServicePriceDetail.fromJS(item));
            }
            else {
                this.dettagliPrezzi = null as any;
            }
            if (Array.isArray(_data["composizionePrezzo"])) {
                this.composizionePrezzo = [] as any;
                for (let item of _data["composizionePrezzo"])
                    this.composizionePrezzo!.push(TripServicePriceDetail.fromJS(item));
            }
            else {
                this.composizionePrezzo = null as any;
            }
            this.testoPenali = _data["testoPenali"] ? TripTextHtml.fromJS(_data["testoPenali"]) : null as any;
            this.tipoTestoPenale = _data["tipoTestoPenale"] !== undefined ? _data["tipoTestoPenale"] : null as any;
            this.durata = _data["durata"] ? ServiceDuration.fromJS(_data["durata"]) : null as any;
            this.tappe = _data["tappe"] !== undefined ? _data["tappe"] : null as any;
            this.dataUltimoAggiornamento = _data["dataUltimoAggiornamento"] !== undefined ? _data["dataUltimoAggiornamento"] : null as any;
            if (Array.isArray(_data["elencoNotePiePagina"])) {
                this.elencoNotePiePagina = [] as any;
                for (let item of _data["elencoNotePiePagina"])
                    this.elencoNotePiePagina!.push(item);
            }
            else {
                this.elencoNotePiePagina = null as any;
            }
            if (Array.isArray(_data["elencoRiferimentiAnticipi"])) {
                this.elencoRiferimentiAnticipi = [] as any;
                for (let item of _data["elencoRiferimentiAnticipi"])
                    this.elencoRiferimentiAnticipi!.push(item);
            }
            else {
                this.elencoRiferimentiAnticipi = null as any;
            }
            this.fullContent = _data["fullContent"] !== undefined ? _data["fullContent"] : null as any;
            this.puntoIniziale = _data["puntoIniziale"] ? TripServiceLocation.fromJS(_data["puntoIniziale"]) : null as any;
            this.puntoFinale = _data["puntoFinale"] ? TripServiceLocation.fromJS(_data["puntoFinale"]) : null as any;
        }
    }

    static fromJS(data: any): TripService {
        data = typeof data === 'object' ? data : {};
        let result = new TripService();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["luogoFine"] = this.luogoFine !== undefined ? this.luogoFine : null as any;
        data["abbinamento"] = this.abbinamento !== undefined ? this.abbinamento : null as any;
        data["cliente"] = this.cliente !== undefined ? this.cliente : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["dataCheckout"] = this.dataCheckout !== undefined ? this.dataCheckout : null as any;
        data["notti"] = this.notti !== undefined ? this.notti : null as any;
        data["isHotel"] = this.isHotel !== undefined ? this.isHotel : null as any;
        data["isVolo"] = this.isVolo !== undefined ? this.isVolo : null as any;
        data["isNoleggio"] = this.isNoleggio !== undefined ? this.isNoleggio : null as any;
        data["isTrasferimento"] = this.isTrasferimento !== undefined ? this.isTrasferimento : null as any;
        data["isVisita"] = this.isVisita !== undefined ? this.isVisita : null as any;
        data["haPaginaDettaglio"] = this.haPaginaDettaglio !== undefined ? this.haPaginaDettaglio : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["descrizioneProgramma"] = this.descrizioneProgramma !== undefined ? this.descrizioneProgramma : null as any;
        data["urlPart"] = this.urlPart !== undefined ? this.urlPart : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["esterno"] = this.esterno !== undefined ? this.esterno : null as any;
        data["disponibilita"] = this.disponibilita !== undefined ? this.disponibilita : null as any;
        data["disponibilitaPrecedente"] = this.disponibilitaPrecedente !== undefined ? this.disponibilitaPrecedente : null as any;
        data["daQuotare"] = this.daQuotare !== undefined ? this.daQuotare : null as any;
        data["prezzoIndicativo"] = this.prezzoIndicativo !== undefined ? this.prezzoIndicativo : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["numeroConferma"] = this.numeroConferma !== undefined ? this.numeroConferma : null as any;
        data["accessori"] = this.accessori !== undefined ? this.accessori : null as any;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : null as any;
        data["prezzoValuta"] = this.prezzoValuta !== undefined ? this.prezzoValuta : null as any;
        data["pagamentoAnticipato"] = this.pagamentoAnticipato !== undefined ? this.pagamentoAnticipato : null as any;
        data["adulti"] = this.adulti !== undefined ? this.adulti : null as any;
        data["bambini"] = this.bambini !== undefined ? this.bambini : null as any;
        data["prezzoPrecedente"] = this.prezzoPrecedente !== undefined ? this.prezzoPrecedente : null as any;
        data["prezzoPrecedenteValuta"] = this.prezzoPrecedenteValuta !== undefined ? this.prezzoPrecedenteValuta : null as any;
        data["dati"] = this.dati ? this.dati.toJSON() : null as any;
        data["penale"] = this.penale ? this.penale.toJSON() : null as any;
        data["printableAccessori"] = this.printableAccessori !== undefined ? this.printableAccessori : null as any;
        data["eliminabile"] = this.eliminabile !== undefined ? this.eliminabile : null as any;
        data["eliminabileAgenzia"] = this.eliminabileAgenzia !== undefined ? this.eliminabileAgenzia : null as any;
        data["nascostoAgenzia"] = this.nascostoAgenzia !== undefined ? this.nascostoAgenzia : null as any;
        data["pagamentoSbloccabile"] = this.pagamentoSbloccabile !== undefined ? this.pagamentoSbloccabile : null as any;
        if (Array.isArray(this.note)) {
            data["note"] = [];
            for (let item of this.note)
                data["note"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.dettagliPrezzi)) {
            data["dettagliPrezzi"] = [];
            for (let item of this.dettagliPrezzi)
                data["dettagliPrezzi"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.composizionePrezzo)) {
            data["composizionePrezzo"] = [];
            for (let item of this.composizionePrezzo)
                data["composizionePrezzo"].push(item ? item.toJSON() : null as any);
        }
        data["testoPenali"] = this.testoPenali ? this.testoPenali.toJSON() : null as any;
        data["tipoTestoPenale"] = this.tipoTestoPenale !== undefined ? this.tipoTestoPenale : null as any;
        data["durata"] = this.durata ? this.durata.toJSON() : null as any;
        data["tappe"] = this.tappe !== undefined ? this.tappe : null as any;
        data["dataUltimoAggiornamento"] = this.dataUltimoAggiornamento !== undefined ? this.dataUltimoAggiornamento : null as any;
        if (Array.isArray(this.elencoNotePiePagina)) {
            data["elencoNotePiePagina"] = [];
            for (let item of this.elencoNotePiePagina)
                data["elencoNotePiePagina"].push(item);
        }
        if (Array.isArray(this.elencoRiferimentiAnticipi)) {
            data["elencoRiferimentiAnticipi"] = [];
            for (let item of this.elencoRiferimentiAnticipi)
                data["elencoRiferimentiAnticipi"].push(item);
        }
        data["fullContent"] = this.fullContent !== undefined ? this.fullContent : null as any;
        data["puntoIniziale"] = this.puntoIniziale ? this.puntoIniziale.toJSON() : null as any;
        data["puntoFinale"] = this.puntoFinale ? this.puntoFinale.toJSON() : null as any;
        return data;
    }
}

export interface ITripService {
    id?: number;
    luogo?: string | null;
    luogoFine?: string | null;
    abbinamento?: string | null;
    cliente?: string | null;
    /** Data e ora di checkin / inizio */
    data?: string;
    /** Data e ora di checkout / fine */
    dataCheckout?: string | null;
    notti?: number;
    isHotel?: boolean;
    isVolo?: boolean;
    isNoleggio?: boolean;
    isTrasferimento?: boolean;
    isVisita?: boolean;
    haPaginaDettaglio?: boolean;
    descrizione?: string | null;
    /** Descrizione da usare nel programma di viaggio */
    descrizioneProgramma?: string | null;
    urlPart?: string | null;
    servizioID?: number | null;
    esterno?: boolean;
    disponibilita?: EStatoDisponibilita;
    disponibilitaPrecedente?: EStatoDisponibilita | null;
    daQuotare?: boolean;
    prezzoIndicativo?: boolean;
    status?: EStatoServizioUtente;
    numeroConferma?: string | null;
    accessori?: boolean;
    prezzo?: number;
    prezzoValuta?: number;
    pagamentoAnticipato?: boolean;
    adulti?: number;
    bambini?: number;
    prezzoPrecedente?: number | null;
    prezzoPrecedenteValuta?: number | null;
    dati?: TripServiceData | null;
    penale?: PenaleServizio | null;
    printableAccessori?: boolean;
    eliminabile?: boolean;
    eliminabileAgenzia?: boolean;
    nascostoAgenzia?: boolean;
    /** True se il servizio ha un pagamento fornitore associato che è sbloccabile */
    pagamentoSbloccabile?: boolean;
    /** Elenco delle note associate a questa riga prelevate dagli articoli */
    note?: TripTextHtml[] | null;
    /** Elenco delle offerte speciali / azioni applicate  */
    dettagliPrezzi?: TripServicePriceDetail[];
    /** Elenco delle componenti del prezzo */
    composizionePrezzo?: TripServicePriceDetail[] | null;
    /** Testo dell'articolo penali di cancellazione da visualizzare all'agenzia.
Calcolato in base alla presenza: di una nota custom, di un articolo di penale, dei dati aggiuntivi penale default, della nota fornitore
in questo ordine */
    testoPenali?: TripTextHtml | null;
    /** Indica quale degli eventuali molteplici testi di penale è destinato all'agenzia */
    tipoTestoPenale?: ETestoPenaleAgenzia;
    durata?: ServiceDuration | null;
    tappe?: string | null;
    /** Data di ultimo aggiornamento dei prezzi */
    dataUltimoAggiornamento?: string | null;
    /** Lista da usare per associare le note a piè di pagina sui documenti */
    elencoNotePiePagina?: number[];
    /** Lista da usare per associare le righe dello specchietto anticipi sui documenti. Per ora in teoria max 1 riferimento.
Ma conoscendo i nostri polli... */
    elencoRiferimentiAnticipi?: number[];
    fullContent?: boolean;
    puntoIniziale?: TripServiceLocation | null;
    puntoFinale?: TripServiceLocation | null;
}

export enum EStatoDisponibilita {
    NonDisponibile = "NonDisponibile",
    SuRichiesta = "SuRichiesta",
    Disponibile = "Disponibile",
    DaVerificare = "DaVerificare",
    DisponibileFreesale = "DisponibileFreesale",
    NonDisponibileNoMatchRegola = "NonDisponibileNoMatchRegola",
    Indeterminato = "Indeterminato",
}

export enum EStatoServizioUtente {
    Nessuno = "Nessuno",
    PrezziDispoVariati = "PrezziDispoVariati",
    InPrenotazione = "InPrenotazione",
    Confermato = "Confermato",
    Annullato = "Annullato",
}

export class TripServiceData implements ITripServiceData {
    offertaDato?: OffertaDato | null;
    stato?: OffertaDatoStato | null;
    datiH2H?: OffertaDatoH2H | null;
    /** Tipologia fornitore associata.
Null se non è un h2h oppure se è una tipologia basata su hashcode */
    tipologiaFornitore?: HHTipologiaFornitore | null;
    /** Nome per esteso ed in lingua della tipologia mappata (nei pochi casi in cui c'è) */
    tipologiaNaarMappata?: string | null;
    /** Servizio del fornitore associato
Null se non è un servizio H2H oppure se è una tipologia basata su hashcode */
    servizioFornitore?: HHServizioFornitore | null;
    /** Luogo del fornitore associato.
Null se non è un servizio H2H oppure se è una tipologia basata su hashcode */
    luogoFornitore?: HHLuogo | null;
    /** Nome per esteso del luogo Naar mappato sul LuogoFornitore se presente e mappato. */
    luogoNaarMappato?: string | null;
    /** Servizio H2H se è tale */
    servizioAggregato?: HHServizio | null;
    /** Nome per esteso del servizio Naar associato al ServizioAggregato se presente e mappato */
    servizioNaarMappato?: string | null;
    /** Descrizione dell'hashcode calcolato */
    hashcodeDescription?: HHAttributoHashcodeDescription | null;
    /** Hashcode originale associato alla tipologia fornitore */
    hashcodeTiplogia?: HHAttributoHashcode | null;
    /** Descrizione dell'hashcode sorgente della tipologia */
    hashcodeTipologiaDescription?: HHAttributoHashcodeDescription | null;
    dettagli?: OffertaDatoDettaglio[] | null;
    supplementi?: TripServiceData[] | null;
    /** Dati per i documenti */
    datiDocumento?: DatiDocumentoRiga | null;
    /** Dati di conferma */
    datiConferma?: DatiConfermaRiga | null;
    /** Note abbinate a questa riga */
    note?: OffertaNota[] | null;
    notaH2H?: string | null;
    data?: string;
    dataCheckout?: string | null;
    dataAcconto?: string | null;
    camera?: string | null;
    nomeServizioFornitore?: string | null;
    nomeServizioNaar?: string | null;
    eliminato?: boolean;
    obsoleto?: boolean;
    servizioH2H?: string | null;
    tipologiaH2H?: string | null;
    nomeAccordo?: string | null;
    costo?: number;
    valutaCosto?: string | null;
    marginePercentule?: number;
    accordoH2H?: boolean;
    totaleDaAnticipare?: number;
    tipoAcconto?: ETipoAcconto;
    statoServizioAlternativo?: EStatoServizioAlternativo;
    /** Eventuale nota H2H del fornitore. Tipicamente il testo è HTML */
    notaFornitore?: TripNote | null;
    /** Testo dell'articolo penali di cancellazione, se c'è. */
    articoloPenali?: TripTextHtml | null;
    /** Nota custom delle penali di cancellazione, se ce n'è una */
    notaPenaliCustom?: TripNote | null;
    /** Testo ricavato dalle penali di default dei dati aggiuntivi */
    testoPenaliDatiAggiuntivi?: string | null;
    /** Dati dell'anticipo al fornitore, se previsti */
    anticipoFornitore?: AnticipoFornitore | null;
    /** Nome della regola di anticipo al fornitore */
    regolaAnticipoFornitore?: string | null;
    /** Elenco degli invii dell'assicurazione, una riga per ogni cliente */
    inviiAssicurazioneFilodiretto?: InvioAssicurazioneFiloDiretto[] | null;
    inviiAssicurazione?: InvioAssicurazione[] | null;
    fullContent?: boolean;

    constructor(data?: ITripServiceData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaDato = _data["offertaDato"] ? OffertaDato.fromJS(_data["offertaDato"]) : null as any;
            this.stato = _data["stato"] ? OffertaDatoStato.fromJS(_data["stato"]) : null as any;
            this.datiH2H = _data["datiH2H"] ? OffertaDatoH2H.fromJS(_data["datiH2H"]) : null as any;
            this.tipologiaFornitore = _data["tipologiaFornitore"] ? HHTipologiaFornitore.fromJS(_data["tipologiaFornitore"]) : null as any;
            this.tipologiaNaarMappata = _data["tipologiaNaarMappata"] !== undefined ? _data["tipologiaNaarMappata"] : null as any;
            this.servizioFornitore = _data["servizioFornitore"] ? HHServizioFornitore.fromJS(_data["servizioFornitore"]) : null as any;
            this.luogoFornitore = _data["luogoFornitore"] ? HHLuogo.fromJS(_data["luogoFornitore"]) : null as any;
            this.luogoNaarMappato = _data["luogoNaarMappato"] !== undefined ? _data["luogoNaarMappato"] : null as any;
            this.servizioAggregato = _data["servizioAggregato"] ? HHServizio.fromJS(_data["servizioAggregato"]) : null as any;
            this.servizioNaarMappato = _data["servizioNaarMappato"] !== undefined ? _data["servizioNaarMappato"] : null as any;
            this.hashcodeDescription = _data["hashcodeDescription"] ? HHAttributoHashcodeDescription.fromJS(_data["hashcodeDescription"]) : null as any;
            this.hashcodeTiplogia = _data["hashcodeTiplogia"] ? HHAttributoHashcode.fromJS(_data["hashcodeTiplogia"]) : null as any;
            this.hashcodeTipologiaDescription = _data["hashcodeTipologiaDescription"] ? HHAttributoHashcodeDescription.fromJS(_data["hashcodeTipologiaDescription"]) : null as any;
            if (Array.isArray(_data["dettagli"])) {
                this.dettagli = [] as any;
                for (let item of _data["dettagli"])
                    this.dettagli!.push(OffertaDatoDettaglio.fromJS(item));
            }
            else {
                this.dettagli = null as any;
            }
            if (Array.isArray(_data["supplementi"])) {
                this.supplementi = [] as any;
                for (let item of _data["supplementi"])
                    this.supplementi!.push(TripServiceData.fromJS(item));
            }
            else {
                this.supplementi = null as any;
            }
            this.datiDocumento = _data["datiDocumento"] ? DatiDocumentoRiga.fromJS(_data["datiDocumento"]) : null as any;
            this.datiConferma = _data["datiConferma"] ? DatiConfermaRiga.fromJS(_data["datiConferma"]) : null as any;
            if (Array.isArray(_data["note"])) {
                this.note = [] as any;
                for (let item of _data["note"])
                    this.note!.push(OffertaNota.fromJS(item));
            }
            else {
                this.note = null as any;
            }
            this.notaH2H = _data["notaH2H"] !== undefined ? _data["notaH2H"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
            this.dataCheckout = _data["dataCheckout"] !== undefined ? _data["dataCheckout"] : null as any;
            this.dataAcconto = _data["dataAcconto"] !== undefined ? _data["dataAcconto"] : null as any;
            this.camera = _data["camera"] !== undefined ? _data["camera"] : null as any;
            this.nomeServizioFornitore = _data["nomeServizioFornitore"] !== undefined ? _data["nomeServizioFornitore"] : null as any;
            this.nomeServizioNaar = _data["nomeServizioNaar"] !== undefined ? _data["nomeServizioNaar"] : null as any;
            this.eliminato = _data["eliminato"] !== undefined ? _data["eliminato"] : null as any;
            this.obsoleto = _data["obsoleto"] !== undefined ? _data["obsoleto"] : null as any;
            this.servizioH2H = _data["servizioH2H"] !== undefined ? _data["servizioH2H"] : null as any;
            this.tipologiaH2H = _data["tipologiaH2H"] !== undefined ? _data["tipologiaH2H"] : null as any;
            this.nomeAccordo = _data["nomeAccordo"] !== undefined ? _data["nomeAccordo"] : null as any;
            this.costo = _data["costo"] !== undefined ? _data["costo"] : null as any;
            this.valutaCosto = _data["valutaCosto"] !== undefined ? _data["valutaCosto"] : null as any;
            this.marginePercentule = _data["marginePercentule"] !== undefined ? _data["marginePercentule"] : null as any;
            this.accordoH2H = _data["accordoH2H"] !== undefined ? _data["accordoH2H"] : null as any;
            this.totaleDaAnticipare = _data["totaleDaAnticipare"] !== undefined ? _data["totaleDaAnticipare"] : null as any;
            this.tipoAcconto = _data["tipoAcconto"] !== undefined ? _data["tipoAcconto"] : null as any;
            this.statoServizioAlternativo = _data["statoServizioAlternativo"] !== undefined ? _data["statoServizioAlternativo"] : null as any;
            this.notaFornitore = _data["notaFornitore"] ? TripNote.fromJS(_data["notaFornitore"]) : null as any;
            this.articoloPenali = _data["articoloPenali"] ? TripTextHtml.fromJS(_data["articoloPenali"]) : null as any;
            this.notaPenaliCustom = _data["notaPenaliCustom"] ? TripNote.fromJS(_data["notaPenaliCustom"]) : null as any;
            this.testoPenaliDatiAggiuntivi = _data["testoPenaliDatiAggiuntivi"] !== undefined ? _data["testoPenaliDatiAggiuntivi"] : null as any;
            this.anticipoFornitore = _data["anticipoFornitore"] ? AnticipoFornitore.fromJS(_data["anticipoFornitore"]) : null as any;
            this.regolaAnticipoFornitore = _data["regolaAnticipoFornitore"] !== undefined ? _data["regolaAnticipoFornitore"] : null as any;
            if (Array.isArray(_data["inviiAssicurazioneFilodiretto"])) {
                this.inviiAssicurazioneFilodiretto = [] as any;
                for (let item of _data["inviiAssicurazioneFilodiretto"])
                    this.inviiAssicurazioneFilodiretto!.push(InvioAssicurazioneFiloDiretto.fromJS(item));
            }
            else {
                this.inviiAssicurazioneFilodiretto = null as any;
            }
            if (Array.isArray(_data["inviiAssicurazione"])) {
                this.inviiAssicurazione = [] as any;
                for (let item of _data["inviiAssicurazione"])
                    this.inviiAssicurazione!.push(InvioAssicurazione.fromJS(item));
            }
            else {
                this.inviiAssicurazione = null as any;
            }
            this.fullContent = _data["fullContent"] !== undefined ? _data["fullContent"] : null as any;
        }
    }

    static fromJS(data: any): TripServiceData {
        data = typeof data === 'object' ? data : {};
        let result = new TripServiceData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaDato"] = this.offertaDato ? this.offertaDato.toJSON() : null as any;
        data["stato"] = this.stato ? this.stato.toJSON() : null as any;
        data["datiH2H"] = this.datiH2H ? this.datiH2H.toJSON() : null as any;
        data["tipologiaFornitore"] = this.tipologiaFornitore ? this.tipologiaFornitore.toJSON() : null as any;
        data["tipologiaNaarMappata"] = this.tipologiaNaarMappata !== undefined ? this.tipologiaNaarMappata : null as any;
        data["servizioFornitore"] = this.servizioFornitore ? this.servizioFornitore.toJSON() : null as any;
        data["luogoFornitore"] = this.luogoFornitore ? this.luogoFornitore.toJSON() : null as any;
        data["luogoNaarMappato"] = this.luogoNaarMappato !== undefined ? this.luogoNaarMappato : null as any;
        data["servizioAggregato"] = this.servizioAggregato ? this.servizioAggregato.toJSON() : null as any;
        data["servizioNaarMappato"] = this.servizioNaarMappato !== undefined ? this.servizioNaarMappato : null as any;
        data["hashcodeDescription"] = this.hashcodeDescription ? this.hashcodeDescription.toJSON() : null as any;
        data["hashcodeTiplogia"] = this.hashcodeTiplogia ? this.hashcodeTiplogia.toJSON() : null as any;
        data["hashcodeTipologiaDescription"] = this.hashcodeTipologiaDescription ? this.hashcodeTipologiaDescription.toJSON() : null as any;
        if (Array.isArray(this.dettagli)) {
            data["dettagli"] = [];
            for (let item of this.dettagli)
                data["dettagli"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.supplementi)) {
            data["supplementi"] = [];
            for (let item of this.supplementi)
                data["supplementi"].push(item ? item.toJSON() : null as any);
        }
        data["datiDocumento"] = this.datiDocumento ? this.datiDocumento.toJSON() : null as any;
        data["datiConferma"] = this.datiConferma ? this.datiConferma.toJSON() : null as any;
        if (Array.isArray(this.note)) {
            data["note"] = [];
            for (let item of this.note)
                data["note"].push(item ? item.toJSON() : null as any);
        }
        data["notaH2H"] = this.notaH2H !== undefined ? this.notaH2H : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["dataCheckout"] = this.dataCheckout !== undefined ? this.dataCheckout : null as any;
        data["dataAcconto"] = this.dataAcconto !== undefined ? this.dataAcconto : null as any;
        data["camera"] = this.camera !== undefined ? this.camera : null as any;
        data["nomeServizioFornitore"] = this.nomeServizioFornitore !== undefined ? this.nomeServizioFornitore : null as any;
        data["nomeServizioNaar"] = this.nomeServizioNaar !== undefined ? this.nomeServizioNaar : null as any;
        data["eliminato"] = this.eliminato !== undefined ? this.eliminato : null as any;
        data["obsoleto"] = this.obsoleto !== undefined ? this.obsoleto : null as any;
        data["servizioH2H"] = this.servizioH2H !== undefined ? this.servizioH2H : null as any;
        data["tipologiaH2H"] = this.tipologiaH2H !== undefined ? this.tipologiaH2H : null as any;
        data["nomeAccordo"] = this.nomeAccordo !== undefined ? this.nomeAccordo : null as any;
        data["costo"] = this.costo !== undefined ? this.costo : null as any;
        data["valutaCosto"] = this.valutaCosto !== undefined ? this.valutaCosto : null as any;
        data["marginePercentule"] = this.marginePercentule !== undefined ? this.marginePercentule : null as any;
        data["accordoH2H"] = this.accordoH2H !== undefined ? this.accordoH2H : null as any;
        data["totaleDaAnticipare"] = this.totaleDaAnticipare !== undefined ? this.totaleDaAnticipare : null as any;
        data["tipoAcconto"] = this.tipoAcconto !== undefined ? this.tipoAcconto : null as any;
        data["statoServizioAlternativo"] = this.statoServizioAlternativo !== undefined ? this.statoServizioAlternativo : null as any;
        data["notaFornitore"] = this.notaFornitore ? this.notaFornitore.toJSON() : null as any;
        data["articoloPenali"] = this.articoloPenali ? this.articoloPenali.toJSON() : null as any;
        data["notaPenaliCustom"] = this.notaPenaliCustom ? this.notaPenaliCustom.toJSON() : null as any;
        data["testoPenaliDatiAggiuntivi"] = this.testoPenaliDatiAggiuntivi !== undefined ? this.testoPenaliDatiAggiuntivi : null as any;
        data["anticipoFornitore"] = this.anticipoFornitore ? this.anticipoFornitore.toJSON() : null as any;
        data["regolaAnticipoFornitore"] = this.regolaAnticipoFornitore !== undefined ? this.regolaAnticipoFornitore : null as any;
        if (Array.isArray(this.inviiAssicurazioneFilodiretto)) {
            data["inviiAssicurazioneFilodiretto"] = [];
            for (let item of this.inviiAssicurazioneFilodiretto)
                data["inviiAssicurazioneFilodiretto"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.inviiAssicurazione)) {
            data["inviiAssicurazione"] = [];
            for (let item of this.inviiAssicurazione)
                data["inviiAssicurazione"].push(item ? item.toJSON() : null as any);
        }
        data["fullContent"] = this.fullContent !== undefined ? this.fullContent : null as any;
        return data;
    }
}

export interface ITripServiceData {
    offertaDato?: OffertaDato | null;
    stato?: OffertaDatoStato | null;
    datiH2H?: OffertaDatoH2H | null;
    /** Tipologia fornitore associata.
Null se non è un h2h oppure se è una tipologia basata su hashcode */
    tipologiaFornitore?: HHTipologiaFornitore | null;
    /** Nome per esteso ed in lingua della tipologia mappata (nei pochi casi in cui c'è) */
    tipologiaNaarMappata?: string | null;
    /** Servizio del fornitore associato
Null se non è un servizio H2H oppure se è una tipologia basata su hashcode */
    servizioFornitore?: HHServizioFornitore | null;
    /** Luogo del fornitore associato.
Null se non è un servizio H2H oppure se è una tipologia basata su hashcode */
    luogoFornitore?: HHLuogo | null;
    /** Nome per esteso del luogo Naar mappato sul LuogoFornitore se presente e mappato. */
    luogoNaarMappato?: string | null;
    /** Servizio H2H se è tale */
    servizioAggregato?: HHServizio | null;
    /** Nome per esteso del servizio Naar associato al ServizioAggregato se presente e mappato */
    servizioNaarMappato?: string | null;
    /** Descrizione dell'hashcode calcolato */
    hashcodeDescription?: HHAttributoHashcodeDescription | null;
    /** Hashcode originale associato alla tipologia fornitore */
    hashcodeTiplogia?: HHAttributoHashcode | null;
    /** Descrizione dell'hashcode sorgente della tipologia */
    hashcodeTipologiaDescription?: HHAttributoHashcodeDescription | null;
    dettagli?: OffertaDatoDettaglio[] | null;
    supplementi?: TripServiceData[] | null;
    /** Dati per i documenti */
    datiDocumento?: DatiDocumentoRiga | null;
    /** Dati di conferma */
    datiConferma?: DatiConfermaRiga | null;
    /** Note abbinate a questa riga */
    note?: OffertaNota[] | null;
    notaH2H?: string | null;
    data?: string;
    dataCheckout?: string | null;
    dataAcconto?: string | null;
    camera?: string | null;
    nomeServizioFornitore?: string | null;
    nomeServizioNaar?: string | null;
    eliminato?: boolean;
    obsoleto?: boolean;
    servizioH2H?: string | null;
    tipologiaH2H?: string | null;
    nomeAccordo?: string | null;
    costo?: number;
    valutaCosto?: string | null;
    marginePercentule?: number;
    accordoH2H?: boolean;
    totaleDaAnticipare?: number;
    tipoAcconto?: ETipoAcconto;
    statoServizioAlternativo?: EStatoServizioAlternativo;
    /** Eventuale nota H2H del fornitore. Tipicamente il testo è HTML */
    notaFornitore?: TripNote | null;
    /** Testo dell'articolo penali di cancellazione, se c'è. */
    articoloPenali?: TripTextHtml | null;
    /** Nota custom delle penali di cancellazione, se ce n'è una */
    notaPenaliCustom?: TripNote | null;
    /** Testo ricavato dalle penali di default dei dati aggiuntivi */
    testoPenaliDatiAggiuntivi?: string | null;
    /** Dati dell'anticipo al fornitore, se previsti */
    anticipoFornitore?: AnticipoFornitore | null;
    /** Nome della regola di anticipo al fornitore */
    regolaAnticipoFornitore?: string | null;
    /** Elenco degli invii dell'assicurazione, una riga per ogni cliente */
    inviiAssicurazioneFilodiretto?: InvioAssicurazioneFiloDiretto[] | null;
    inviiAssicurazione?: InvioAssicurazione[] | null;
    fullContent?: boolean;
}

export class OffertaDato implements IOffertaDato {
    offertaDatoID?: number;
    offertaID?: number;
    itinerarioID?: number;
    abbinamentoID?: number;
    servizioID?: number | null;
    servizioTipologiaID?: number | null;
    trattamentoID?: number | null;
    cancellato?: boolean;
    accordoID?: number | null;
    giorno?: number | null;
    ordine?: number | null;
    quantita?: number | null;
    descrizione?: string | null;
    note?: string | null;
    noteCliente?: string | null;
    prezzoAdulto?: number;
    prezzoAdultoOriginale?: number | null;
    prezzoBambino?: number;
    prezzoBambinoOriginale?: number | null;
    costoAdulto?: number;
    costoAdultoOriginale?: number | null;
    costoBambino?: number;
    costoBambinoOriginale?: number | null;
    valutaID?: number;
    valutaPrezzoID?: number | null;
    cambioValuta?: number;
    contabilizzazione?: EContabilizzazione | null;
    deregolamenta?: boolean | null;
    commissioniAgenzia?: number | null;
    commissionePercentuale?: number;
    costoID?: number | null;
    costoGlobale?: boolean | null;
    sistemazioneID?: number | null;
    numeroAdulti?: number;
    numeroBambini?: number;
    allotment?: number | null;
    allotmentPrecedente?: number | null;
    tabellaAllotmentID?: number | null;
    provider?: number | null;
    codiceTipologiaFornitore?: string | null;
    dataInserimento?: string | null;
    markup?: number | null;
    transactionID?: number | null;
    rigaManuale?: boolean | null;
    tipo?: ETipoRiga | null;
    regolaVenditaID?: number | null;
    codiceServizioH2H?: string | null;
    supplementoRiduzione?: number | null;
    tabellaCostoID?: number | null;
    maxEta?: number | null;
    codicePrenotazione?: string | null;
    penaleID?: number | null;
    articoloPenaleID?: number | null;
    dataAcconto?: string | null;
    inizio?: string | null;
    fine?: string | null;
    ottimizzataIl?: string | null;
    costoOttimizzato?: number | null;
    fornitoreOttimizzato?: number | null;
    descrizioneOttimizzato?: string | null;
    clienteID?: number | null;
    luogoDestinazioneID?: number | null;
    luogoID?: number | null;
    tipoAutocomplete?: EAutocompleteRiga | null;
    prezzoManuale?: boolean;
    periodoManuale?: boolean;
    dataPenale?: string | null;
    importoPenale?: number | null;
    tipoAcconto?: ETipoImportoAcconto | null;
    importoAcconto?: number | null;
    nonRimborsabile?: boolean;
    anticipoFornitoreID?: number | null;
    ultimaVerifica?: string | null;
    disponibilita?: EStatoDisponibilita;
    disponibilitaOriginal?: EStatoDisponibilita;

    constructor(data?: IOffertaDato) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.itinerarioID = _data["itinerarioID"] !== undefined ? _data["itinerarioID"] : null as any;
            this.abbinamentoID = _data["abbinamentoID"] !== undefined ? _data["abbinamentoID"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.servizioTipologiaID = _data["servizioTipologiaID"] !== undefined ? _data["servizioTipologiaID"] : null as any;
            this.trattamentoID = _data["trattamentoID"] !== undefined ? _data["trattamentoID"] : null as any;
            this.cancellato = _data["cancellato"] !== undefined ? _data["cancellato"] : null as any;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.quantita = _data["quantita"] !== undefined ? _data["quantita"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.noteCliente = _data["noteCliente"] !== undefined ? _data["noteCliente"] : null as any;
            this.prezzoAdulto = _data["prezzoAdulto"] !== undefined ? _data["prezzoAdulto"] : null as any;
            this.prezzoAdultoOriginale = _data["prezzoAdultoOriginale"] !== undefined ? _data["prezzoAdultoOriginale"] : null as any;
            this.prezzoBambino = _data["prezzoBambino"] !== undefined ? _data["prezzoBambino"] : null as any;
            this.prezzoBambinoOriginale = _data["prezzoBambinoOriginale"] !== undefined ? _data["prezzoBambinoOriginale"] : null as any;
            this.costoAdulto = _data["costoAdulto"] !== undefined ? _data["costoAdulto"] : null as any;
            this.costoAdultoOriginale = _data["costoAdultoOriginale"] !== undefined ? _data["costoAdultoOriginale"] : null as any;
            this.costoBambino = _data["costoBambino"] !== undefined ? _data["costoBambino"] : null as any;
            this.costoBambinoOriginale = _data["costoBambinoOriginale"] !== undefined ? _data["costoBambinoOriginale"] : null as any;
            this.valutaID = _data["valutaID"] !== undefined ? _data["valutaID"] : null as any;
            this.valutaPrezzoID = _data["valutaPrezzoID"] !== undefined ? _data["valutaPrezzoID"] : null as any;
            this.cambioValuta = _data["cambioValuta"] !== undefined ? _data["cambioValuta"] : null as any;
            this.contabilizzazione = _data["contabilizzazione"] !== undefined ? _data["contabilizzazione"] : null as any;
            this.deregolamenta = _data["deregolamenta"] !== undefined ? _data["deregolamenta"] : null as any;
            this.commissioniAgenzia = _data["commissioniAgenzia"] !== undefined ? _data["commissioniAgenzia"] : null as any;
            this.commissionePercentuale = _data["commissionePercentuale"] !== undefined ? _data["commissionePercentuale"] : null as any;
            this.costoID = _data["costoID"] !== undefined ? _data["costoID"] : null as any;
            this.costoGlobale = _data["costoGlobale"] !== undefined ? _data["costoGlobale"] : null as any;
            this.sistemazioneID = _data["sistemazioneID"] !== undefined ? _data["sistemazioneID"] : null as any;
            this.numeroAdulti = _data["numeroAdulti"] !== undefined ? _data["numeroAdulti"] : null as any;
            this.numeroBambini = _data["numeroBambini"] !== undefined ? _data["numeroBambini"] : null as any;
            this.allotment = _data["allotment"] !== undefined ? _data["allotment"] : null as any;
            this.allotmentPrecedente = _data["allotmentPrecedente"] !== undefined ? _data["allotmentPrecedente"] : null as any;
            this.tabellaAllotmentID = _data["tabellaAllotmentID"] !== undefined ? _data["tabellaAllotmentID"] : null as any;
            this.provider = _data["provider"] !== undefined ? _data["provider"] : null as any;
            this.codiceTipologiaFornitore = _data["codiceTipologiaFornitore"] !== undefined ? _data["codiceTipologiaFornitore"] : null as any;
            this.dataInserimento = _data["dataInserimento"] !== undefined ? _data["dataInserimento"] : null as any;
            this.markup = _data["markup"] !== undefined ? _data["markup"] : null as any;
            this.transactionID = _data["transactionID"] !== undefined ? _data["transactionID"] : null as any;
            this.rigaManuale = _data["rigaManuale"] !== undefined ? _data["rigaManuale"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.regolaVenditaID = _data["regolaVenditaID"] !== undefined ? _data["regolaVenditaID"] : null as any;
            this.codiceServizioH2H = _data["codiceServizioH2H"] !== undefined ? _data["codiceServizioH2H"] : null as any;
            this.supplementoRiduzione = _data["supplementoRiduzione"] !== undefined ? _data["supplementoRiduzione"] : null as any;
            this.tabellaCostoID = _data["tabellaCostoID"] !== undefined ? _data["tabellaCostoID"] : null as any;
            this.maxEta = _data["maxEta"] !== undefined ? _data["maxEta"] : null as any;
            this.codicePrenotazione = _data["codicePrenotazione"] !== undefined ? _data["codicePrenotazione"] : null as any;
            this.penaleID = _data["penaleID"] !== undefined ? _data["penaleID"] : null as any;
            this.articoloPenaleID = _data["articoloPenaleID"] !== undefined ? _data["articoloPenaleID"] : null as any;
            this.dataAcconto = _data["dataAcconto"] !== undefined ? _data["dataAcconto"] : null as any;
            this.inizio = _data["inizio"] !== undefined ? _data["inizio"] : null as any;
            this.fine = _data["fine"] !== undefined ? _data["fine"] : null as any;
            this.ottimizzataIl = _data["ottimizzataIl"] !== undefined ? _data["ottimizzataIl"] : null as any;
            this.costoOttimizzato = _data["costoOttimizzato"] !== undefined ? _data["costoOttimizzato"] : null as any;
            this.fornitoreOttimizzato = _data["fornitoreOttimizzato"] !== undefined ? _data["fornitoreOttimizzato"] : null as any;
            this.descrizioneOttimizzato = _data["descrizioneOttimizzato"] !== undefined ? _data["descrizioneOttimizzato"] : null as any;
            this.clienteID = _data["clienteID"] !== undefined ? _data["clienteID"] : null as any;
            this.luogoDestinazioneID = _data["luogoDestinazioneID"] !== undefined ? _data["luogoDestinazioneID"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.tipoAutocomplete = _data["tipoAutocomplete"] !== undefined ? _data["tipoAutocomplete"] : null as any;
            this.prezzoManuale = _data["prezzoManuale"] !== undefined ? _data["prezzoManuale"] : null as any;
            this.periodoManuale = _data["periodoManuale"] !== undefined ? _data["periodoManuale"] : null as any;
            this.dataPenale = _data["dataPenale"] !== undefined ? _data["dataPenale"] : null as any;
            this.importoPenale = _data["importoPenale"] !== undefined ? _data["importoPenale"] : null as any;
            this.tipoAcconto = _data["tipoAcconto"] !== undefined ? _data["tipoAcconto"] : null as any;
            this.importoAcconto = _data["importoAcconto"] !== undefined ? _data["importoAcconto"] : null as any;
            this.nonRimborsabile = _data["nonRimborsabile"] !== undefined ? _data["nonRimborsabile"] : null as any;
            this.anticipoFornitoreID = _data["anticipoFornitoreID"] !== undefined ? _data["anticipoFornitoreID"] : null as any;
            this.ultimaVerifica = _data["ultimaVerifica"] !== undefined ? _data["ultimaVerifica"] : null as any;
            this.disponibilita = _data["disponibilita"] !== undefined ? _data["disponibilita"] : null as any;
            this.disponibilitaOriginal = _data["disponibilitaOriginal"] !== undefined ? _data["disponibilitaOriginal"] : null as any;
        }
    }

    static fromJS(data: any): OffertaDato {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaDato();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["itinerarioID"] = this.itinerarioID !== undefined ? this.itinerarioID : null as any;
        data["abbinamentoID"] = this.abbinamentoID !== undefined ? this.abbinamentoID : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["servizioTipologiaID"] = this.servizioTipologiaID !== undefined ? this.servizioTipologiaID : null as any;
        data["trattamentoID"] = this.trattamentoID !== undefined ? this.trattamentoID : null as any;
        data["cancellato"] = this.cancellato !== undefined ? this.cancellato : null as any;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["giorno"] = this.giorno !== undefined ? this.giorno : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["quantita"] = this.quantita !== undefined ? this.quantita : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["noteCliente"] = this.noteCliente !== undefined ? this.noteCliente : null as any;
        data["prezzoAdulto"] = this.prezzoAdulto !== undefined ? this.prezzoAdulto : null as any;
        data["prezzoAdultoOriginale"] = this.prezzoAdultoOriginale !== undefined ? this.prezzoAdultoOriginale : null as any;
        data["prezzoBambino"] = this.prezzoBambino !== undefined ? this.prezzoBambino : null as any;
        data["prezzoBambinoOriginale"] = this.prezzoBambinoOriginale !== undefined ? this.prezzoBambinoOriginale : null as any;
        data["costoAdulto"] = this.costoAdulto !== undefined ? this.costoAdulto : null as any;
        data["costoAdultoOriginale"] = this.costoAdultoOriginale !== undefined ? this.costoAdultoOriginale : null as any;
        data["costoBambino"] = this.costoBambino !== undefined ? this.costoBambino : null as any;
        data["costoBambinoOriginale"] = this.costoBambinoOriginale !== undefined ? this.costoBambinoOriginale : null as any;
        data["valutaID"] = this.valutaID !== undefined ? this.valutaID : null as any;
        data["valutaPrezzoID"] = this.valutaPrezzoID !== undefined ? this.valutaPrezzoID : null as any;
        data["cambioValuta"] = this.cambioValuta !== undefined ? this.cambioValuta : null as any;
        data["contabilizzazione"] = this.contabilizzazione !== undefined ? this.contabilizzazione : null as any;
        data["deregolamenta"] = this.deregolamenta !== undefined ? this.deregolamenta : null as any;
        data["commissioniAgenzia"] = this.commissioniAgenzia !== undefined ? this.commissioniAgenzia : null as any;
        data["commissionePercentuale"] = this.commissionePercentuale !== undefined ? this.commissionePercentuale : null as any;
        data["costoID"] = this.costoID !== undefined ? this.costoID : null as any;
        data["costoGlobale"] = this.costoGlobale !== undefined ? this.costoGlobale : null as any;
        data["sistemazioneID"] = this.sistemazioneID !== undefined ? this.sistemazioneID : null as any;
        data["numeroAdulti"] = this.numeroAdulti !== undefined ? this.numeroAdulti : null as any;
        data["numeroBambini"] = this.numeroBambini !== undefined ? this.numeroBambini : null as any;
        data["allotment"] = this.allotment !== undefined ? this.allotment : null as any;
        data["allotmentPrecedente"] = this.allotmentPrecedente !== undefined ? this.allotmentPrecedente : null as any;
        data["tabellaAllotmentID"] = this.tabellaAllotmentID !== undefined ? this.tabellaAllotmentID : null as any;
        data["provider"] = this.provider !== undefined ? this.provider : null as any;
        data["codiceTipologiaFornitore"] = this.codiceTipologiaFornitore !== undefined ? this.codiceTipologiaFornitore : null as any;
        data["dataInserimento"] = this.dataInserimento !== undefined ? this.dataInserimento : null as any;
        data["markup"] = this.markup !== undefined ? this.markup : null as any;
        data["transactionID"] = this.transactionID !== undefined ? this.transactionID : null as any;
        data["rigaManuale"] = this.rigaManuale !== undefined ? this.rigaManuale : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["regolaVenditaID"] = this.regolaVenditaID !== undefined ? this.regolaVenditaID : null as any;
        data["codiceServizioH2H"] = this.codiceServizioH2H !== undefined ? this.codiceServizioH2H : null as any;
        data["supplementoRiduzione"] = this.supplementoRiduzione !== undefined ? this.supplementoRiduzione : null as any;
        data["tabellaCostoID"] = this.tabellaCostoID !== undefined ? this.tabellaCostoID : null as any;
        data["maxEta"] = this.maxEta !== undefined ? this.maxEta : null as any;
        data["codicePrenotazione"] = this.codicePrenotazione !== undefined ? this.codicePrenotazione : null as any;
        data["penaleID"] = this.penaleID !== undefined ? this.penaleID : null as any;
        data["articoloPenaleID"] = this.articoloPenaleID !== undefined ? this.articoloPenaleID : null as any;
        data["dataAcconto"] = this.dataAcconto !== undefined ? this.dataAcconto : null as any;
        data["inizio"] = this.inizio !== undefined ? this.inizio : null as any;
        data["fine"] = this.fine !== undefined ? this.fine : null as any;
        data["ottimizzataIl"] = this.ottimizzataIl !== undefined ? this.ottimizzataIl : null as any;
        data["costoOttimizzato"] = this.costoOttimizzato !== undefined ? this.costoOttimizzato : null as any;
        data["fornitoreOttimizzato"] = this.fornitoreOttimizzato !== undefined ? this.fornitoreOttimizzato : null as any;
        data["descrizioneOttimizzato"] = this.descrizioneOttimizzato !== undefined ? this.descrizioneOttimizzato : null as any;
        data["clienteID"] = this.clienteID !== undefined ? this.clienteID : null as any;
        data["luogoDestinazioneID"] = this.luogoDestinazioneID !== undefined ? this.luogoDestinazioneID : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["tipoAutocomplete"] = this.tipoAutocomplete !== undefined ? this.tipoAutocomplete : null as any;
        data["prezzoManuale"] = this.prezzoManuale !== undefined ? this.prezzoManuale : null as any;
        data["periodoManuale"] = this.periodoManuale !== undefined ? this.periodoManuale : null as any;
        data["dataPenale"] = this.dataPenale !== undefined ? this.dataPenale : null as any;
        data["importoPenale"] = this.importoPenale !== undefined ? this.importoPenale : null as any;
        data["tipoAcconto"] = this.tipoAcconto !== undefined ? this.tipoAcconto : null as any;
        data["importoAcconto"] = this.importoAcconto !== undefined ? this.importoAcconto : null as any;
        data["nonRimborsabile"] = this.nonRimborsabile !== undefined ? this.nonRimborsabile : null as any;
        data["anticipoFornitoreID"] = this.anticipoFornitoreID !== undefined ? this.anticipoFornitoreID : null as any;
        data["ultimaVerifica"] = this.ultimaVerifica !== undefined ? this.ultimaVerifica : null as any;
        data["disponibilita"] = this.disponibilita !== undefined ? this.disponibilita : null as any;
        data["disponibilitaOriginal"] = this.disponibilitaOriginal !== undefined ? this.disponibilitaOriginal : null as any;
        return data;
    }
}

export interface IOffertaDato {
    offertaDatoID?: number;
    offertaID?: number;
    itinerarioID?: number;
    abbinamentoID?: number;
    servizioID?: number | null;
    servizioTipologiaID?: number | null;
    trattamentoID?: number | null;
    cancellato?: boolean;
    accordoID?: number | null;
    giorno?: number | null;
    ordine?: number | null;
    quantita?: number | null;
    descrizione?: string | null;
    note?: string | null;
    noteCliente?: string | null;
    prezzoAdulto?: number;
    prezzoAdultoOriginale?: number | null;
    prezzoBambino?: number;
    prezzoBambinoOriginale?: number | null;
    costoAdulto?: number;
    costoAdultoOriginale?: number | null;
    costoBambino?: number;
    costoBambinoOriginale?: number | null;
    valutaID?: number;
    valutaPrezzoID?: number | null;
    cambioValuta?: number;
    contabilizzazione?: EContabilizzazione | null;
    deregolamenta?: boolean | null;
    commissioniAgenzia?: number | null;
    commissionePercentuale?: number;
    costoID?: number | null;
    costoGlobale?: boolean | null;
    sistemazioneID?: number | null;
    numeroAdulti?: number;
    numeroBambini?: number;
    allotment?: number | null;
    allotmentPrecedente?: number | null;
    tabellaAllotmentID?: number | null;
    provider?: number | null;
    codiceTipologiaFornitore?: string | null;
    dataInserimento?: string | null;
    markup?: number | null;
    transactionID?: number | null;
    rigaManuale?: boolean | null;
    tipo?: ETipoRiga | null;
    regolaVenditaID?: number | null;
    codiceServizioH2H?: string | null;
    supplementoRiduzione?: number | null;
    tabellaCostoID?: number | null;
    maxEta?: number | null;
    codicePrenotazione?: string | null;
    penaleID?: number | null;
    articoloPenaleID?: number | null;
    dataAcconto?: string | null;
    inizio?: string | null;
    fine?: string | null;
    ottimizzataIl?: string | null;
    costoOttimizzato?: number | null;
    fornitoreOttimizzato?: number | null;
    descrizioneOttimizzato?: string | null;
    clienteID?: number | null;
    luogoDestinazioneID?: number | null;
    luogoID?: number | null;
    tipoAutocomplete?: EAutocompleteRiga | null;
    prezzoManuale?: boolean;
    periodoManuale?: boolean;
    dataPenale?: string | null;
    importoPenale?: number | null;
    tipoAcconto?: ETipoImportoAcconto | null;
    importoAcconto?: number | null;
    nonRimborsabile?: boolean;
    anticipoFornitoreID?: number | null;
    ultimaVerifica?: string | null;
    disponibilita?: EStatoDisponibilita;
    disponibilitaOriginal?: EStatoDisponibilita;
}

export enum ETipoRiga {
    Default = "Default",
    Volo = "Volo",
    TasseVolo = "TasseVolo",
    UsoInterno = "UsoInterno",
}

export enum EAutocompleteRiga {
    NonCompletare = "NonCompletare",
    ServizioSpecifico = "ServizioSpecifico",
    ServizioTipologiaSpecifici = "ServizioTipologiaSpecifici",
    ServizioStessoTipo = "ServizioStessoTipo",
}

export enum ETipoImportoAcconto {
    Percentuale = "Percentuale",
    ValoreAssolutoCosto = "ValoreAssolutoCosto",
    ValoreCostoConMarkup = "ValoreCostoConMarkup",
    ValoreAssolutoPrezzo = "ValoreAssolutoPrezzo",
}

export class OffertaDatoStato implements IOffertaDatoStato {
    offertaDatoID?: number;
    numeroPrenotazione?: string | null;
    riferimentoFornitore?: string | null;
    dataPrenotazione?: string | null;
    dataConferma?: string | null;
    dataAnnullamento?: string | null;
    dataCancellazione?: string | null;
    prenotaDal?: string | null;
    stato?: EStatusServizio | null;
    documentoID?: number | null;
    host2Host?: boolean | null;
    pagato?: number | null;
    pagamentoID?: number | null;
    verificato?: boolean | null;
    ordinaBiglietteria?: string | null;
    presaInCaricoBiglietteria?: string | null;
    emessoBiglietteria?: string | null;
    okContabileBiglietteria?: string | null;
    dataEmissioneCustom?: string | null;
    richiestoRimborso?: boolean;
    importoAnticipoFornitore?: number | null;
    valutaAnticipoFornitoreID?: number | null;
    dataAnticipoFornitore?: string | null;
    statoServizioAlternativo?: EStatoServizioAlternativo;
    offertaDatoAlternativaID?: number | null;

    constructor(data?: IOffertaDatoStato) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : null as any;
            this.numeroPrenotazione = _data["numeroPrenotazione"] !== undefined ? _data["numeroPrenotazione"] : null as any;
            this.riferimentoFornitore = _data["riferimentoFornitore"] !== undefined ? _data["riferimentoFornitore"] : null as any;
            this.dataPrenotazione = _data["dataPrenotazione"] !== undefined ? _data["dataPrenotazione"] : null as any;
            this.dataConferma = _data["dataConferma"] !== undefined ? _data["dataConferma"] : null as any;
            this.dataAnnullamento = _data["dataAnnullamento"] !== undefined ? _data["dataAnnullamento"] : null as any;
            this.dataCancellazione = _data["dataCancellazione"] !== undefined ? _data["dataCancellazione"] : null as any;
            this.prenotaDal = _data["prenotaDal"] !== undefined ? _data["prenotaDal"] : null as any;
            this.stato = _data["stato"] !== undefined ? _data["stato"] : null as any;
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : null as any;
            this.host2Host = _data["host2Host"] !== undefined ? _data["host2Host"] : null as any;
            this.pagato = _data["pagato"] !== undefined ? _data["pagato"] : null as any;
            this.pagamentoID = _data["pagamentoID"] !== undefined ? _data["pagamentoID"] : null as any;
            this.verificato = _data["verificato"] !== undefined ? _data["verificato"] : null as any;
            this.ordinaBiglietteria = _data["ordinaBiglietteria"] !== undefined ? _data["ordinaBiglietteria"] : null as any;
            this.presaInCaricoBiglietteria = _data["presaInCaricoBiglietteria"] !== undefined ? _data["presaInCaricoBiglietteria"] : null as any;
            this.emessoBiglietteria = _data["emessoBiglietteria"] !== undefined ? _data["emessoBiglietteria"] : null as any;
            this.okContabileBiglietteria = _data["okContabileBiglietteria"] !== undefined ? _data["okContabileBiglietteria"] : null as any;
            this.dataEmissioneCustom = _data["dataEmissioneCustom"] !== undefined ? _data["dataEmissioneCustom"] : null as any;
            this.richiestoRimborso = _data["richiestoRimborso"] !== undefined ? _data["richiestoRimborso"] : null as any;
            this.importoAnticipoFornitore = _data["importoAnticipoFornitore"] !== undefined ? _data["importoAnticipoFornitore"] : null as any;
            this.valutaAnticipoFornitoreID = _data["valutaAnticipoFornitoreID"] !== undefined ? _data["valutaAnticipoFornitoreID"] : null as any;
            this.dataAnticipoFornitore = _data["dataAnticipoFornitore"] !== undefined ? _data["dataAnticipoFornitore"] : null as any;
            this.statoServizioAlternativo = _data["statoServizioAlternativo"] !== undefined ? _data["statoServizioAlternativo"] : null as any;
            this.offertaDatoAlternativaID = _data["offertaDatoAlternativaID"] !== undefined ? _data["offertaDatoAlternativaID"] : null as any;
        }
    }

    static fromJS(data: any): OffertaDatoStato {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaDatoStato();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : null as any;
        data["numeroPrenotazione"] = this.numeroPrenotazione !== undefined ? this.numeroPrenotazione : null as any;
        data["riferimentoFornitore"] = this.riferimentoFornitore !== undefined ? this.riferimentoFornitore : null as any;
        data["dataPrenotazione"] = this.dataPrenotazione !== undefined ? this.dataPrenotazione : null as any;
        data["dataConferma"] = this.dataConferma !== undefined ? this.dataConferma : null as any;
        data["dataAnnullamento"] = this.dataAnnullamento !== undefined ? this.dataAnnullamento : null as any;
        data["dataCancellazione"] = this.dataCancellazione !== undefined ? this.dataCancellazione : null as any;
        data["prenotaDal"] = this.prenotaDal !== undefined ? this.prenotaDal : null as any;
        data["stato"] = this.stato !== undefined ? this.stato : null as any;
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : null as any;
        data["host2Host"] = this.host2Host !== undefined ? this.host2Host : null as any;
        data["pagato"] = this.pagato !== undefined ? this.pagato : null as any;
        data["pagamentoID"] = this.pagamentoID !== undefined ? this.pagamentoID : null as any;
        data["verificato"] = this.verificato !== undefined ? this.verificato : null as any;
        data["ordinaBiglietteria"] = this.ordinaBiglietteria !== undefined ? this.ordinaBiglietteria : null as any;
        data["presaInCaricoBiglietteria"] = this.presaInCaricoBiglietteria !== undefined ? this.presaInCaricoBiglietteria : null as any;
        data["emessoBiglietteria"] = this.emessoBiglietteria !== undefined ? this.emessoBiglietteria : null as any;
        data["okContabileBiglietteria"] = this.okContabileBiglietteria !== undefined ? this.okContabileBiglietteria : null as any;
        data["dataEmissioneCustom"] = this.dataEmissioneCustom !== undefined ? this.dataEmissioneCustom : null as any;
        data["richiestoRimborso"] = this.richiestoRimborso !== undefined ? this.richiestoRimborso : null as any;
        data["importoAnticipoFornitore"] = this.importoAnticipoFornitore !== undefined ? this.importoAnticipoFornitore : null as any;
        data["valutaAnticipoFornitoreID"] = this.valutaAnticipoFornitoreID !== undefined ? this.valutaAnticipoFornitoreID : null as any;
        data["dataAnticipoFornitore"] = this.dataAnticipoFornitore !== undefined ? this.dataAnticipoFornitore : null as any;
        data["statoServizioAlternativo"] = this.statoServizioAlternativo !== undefined ? this.statoServizioAlternativo : null as any;
        data["offertaDatoAlternativaID"] = this.offertaDatoAlternativaID !== undefined ? this.offertaDatoAlternativaID : null as any;
        return data;
    }
}

export interface IOffertaDatoStato {
    offertaDatoID?: number;
    numeroPrenotazione?: string | null;
    riferimentoFornitore?: string | null;
    dataPrenotazione?: string | null;
    dataConferma?: string | null;
    dataAnnullamento?: string | null;
    dataCancellazione?: string | null;
    prenotaDal?: string | null;
    stato?: EStatusServizio | null;
    documentoID?: number | null;
    host2Host?: boolean | null;
    pagato?: number | null;
    pagamentoID?: number | null;
    verificato?: boolean | null;
    ordinaBiglietteria?: string | null;
    presaInCaricoBiglietteria?: string | null;
    emessoBiglietteria?: string | null;
    okContabileBiglietteria?: string | null;
    dataEmissioneCustom?: string | null;
    richiestoRimborso?: boolean;
    importoAnticipoFornitore?: number | null;
    valutaAnticipoFornitoreID?: number | null;
    dataAnticipoFornitore?: string | null;
    statoServizioAlternativo?: EStatoServizioAlternativo;
    offertaDatoAlternativaID?: number | null;
}

export enum EStatusServizio {
    Manuale = "Manuale",
    DaPrenotare = "DaPrenotare",
    InPrenotazione = "InPrenotazione",
    PrezziVariati = "PrezziVariati",
    Confermato = "Confermato",
    ParzialmenteConfermato = "ParzialmenteConfermato",
    NonConfermato = "NonConfermato",
    DaCancellare = "DaCancellare",
    InCancellazione = "InCancellazione",
    Cancellato = "Cancellato",
    DaVerificareManualmente = "DaVerificareManualmente",
}

export enum EStatoServizioAlternativo {
    Nessuno = "Nessuno",
    AlternativaProposta = "AlternativaProposta",
    AlternativaAccettata = "AlternativaAccettata",
}

export class OffertaDatoH2H implements IOffertaDatoH2H {
    offertaDatoID?: number;
    hhCodiceID?: number | null;
    codicePrenotazione?: string | null;
    codiceServizio?: string | null;
    codiceTipologia?: string | null;
    customData?: string | null;
    bookCustomData?: string | null;
    contattoPickupID?: number | null;
    contattoDropoffID?: number | null;
    puntoIniziale?: string | null;
    puntoFinale?: string | null;
    hashCode?: string | null;
    qualifier?: string | null;
    servizioH2hID?: number | null;
    roomAttributeID?: number | null;
    classAttributeID?: number | null;
    viewAttributeID?: number | null;
    featuresAttributeID?: number | null;
    qualifierTokens?: string[];
    mealsID?: number | null;
    bedsID?: number | null;

    constructor(data?: IOffertaDatoH2H) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : null as any;
            this.hhCodiceID = _data["hhCodiceID"] !== undefined ? _data["hhCodiceID"] : null as any;
            this.codicePrenotazione = _data["codicePrenotazione"] !== undefined ? _data["codicePrenotazione"] : null as any;
            this.codiceServizio = _data["codiceServizio"] !== undefined ? _data["codiceServizio"] : null as any;
            this.codiceTipologia = _data["codiceTipologia"] !== undefined ? _data["codiceTipologia"] : null as any;
            this.customData = _data["customData"] !== undefined ? _data["customData"] : null as any;
            this.bookCustomData = _data["bookCustomData"] !== undefined ? _data["bookCustomData"] : null as any;
            this.contattoPickupID = _data["contattoPickupID"] !== undefined ? _data["contattoPickupID"] : null as any;
            this.contattoDropoffID = _data["contattoDropoffID"] !== undefined ? _data["contattoDropoffID"] : null as any;
            this.puntoIniziale = _data["puntoIniziale"] !== undefined ? _data["puntoIniziale"] : null as any;
            this.puntoFinale = _data["puntoFinale"] !== undefined ? _data["puntoFinale"] : null as any;
            this.hashCode = _data["hashCode"] !== undefined ? _data["hashCode"] : null as any;
            this.qualifier = _data["qualifier"] !== undefined ? _data["qualifier"] : null as any;
            this.servizioH2hID = _data["servizioH2hID"] !== undefined ? _data["servizioH2hID"] : null as any;
            this.roomAttributeID = _data["roomAttributeID"] !== undefined ? _data["roomAttributeID"] : null as any;
            this.classAttributeID = _data["classAttributeID"] !== undefined ? _data["classAttributeID"] : null as any;
            this.viewAttributeID = _data["viewAttributeID"] !== undefined ? _data["viewAttributeID"] : null as any;
            this.featuresAttributeID = _data["featuresAttributeID"] !== undefined ? _data["featuresAttributeID"] : null as any;
            if (Array.isArray(_data["qualifierTokens"])) {
                this.qualifierTokens = [] as any;
                for (let item of _data["qualifierTokens"])
                    this.qualifierTokens!.push(item);
            }
            else {
                this.qualifierTokens = null as any;
            }
            this.mealsID = _data["mealsID"] !== undefined ? _data["mealsID"] : null as any;
            this.bedsID = _data["bedsID"] !== undefined ? _data["bedsID"] : null as any;
        }
    }

    static fromJS(data: any): OffertaDatoH2H {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaDatoH2H();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : null as any;
        data["hhCodiceID"] = this.hhCodiceID !== undefined ? this.hhCodiceID : null as any;
        data["codicePrenotazione"] = this.codicePrenotazione !== undefined ? this.codicePrenotazione : null as any;
        data["codiceServizio"] = this.codiceServizio !== undefined ? this.codiceServizio : null as any;
        data["codiceTipologia"] = this.codiceTipologia !== undefined ? this.codiceTipologia : null as any;
        data["customData"] = this.customData !== undefined ? this.customData : null as any;
        data["bookCustomData"] = this.bookCustomData !== undefined ? this.bookCustomData : null as any;
        data["contattoPickupID"] = this.contattoPickupID !== undefined ? this.contattoPickupID : null as any;
        data["contattoDropoffID"] = this.contattoDropoffID !== undefined ? this.contattoDropoffID : null as any;
        data["puntoIniziale"] = this.puntoIniziale !== undefined ? this.puntoIniziale : null as any;
        data["puntoFinale"] = this.puntoFinale !== undefined ? this.puntoFinale : null as any;
        data["hashCode"] = this.hashCode !== undefined ? this.hashCode : null as any;
        data["qualifier"] = this.qualifier !== undefined ? this.qualifier : null as any;
        data["servizioH2hID"] = this.servizioH2hID !== undefined ? this.servizioH2hID : null as any;
        data["roomAttributeID"] = this.roomAttributeID !== undefined ? this.roomAttributeID : null as any;
        data["classAttributeID"] = this.classAttributeID !== undefined ? this.classAttributeID : null as any;
        data["viewAttributeID"] = this.viewAttributeID !== undefined ? this.viewAttributeID : null as any;
        data["featuresAttributeID"] = this.featuresAttributeID !== undefined ? this.featuresAttributeID : null as any;
        if (Array.isArray(this.qualifierTokens)) {
            data["qualifierTokens"] = [];
            for (let item of this.qualifierTokens)
                data["qualifierTokens"].push(item);
        }
        data["mealsID"] = this.mealsID !== undefined ? this.mealsID : null as any;
        data["bedsID"] = this.bedsID !== undefined ? this.bedsID : null as any;
        return data;
    }
}

export interface IOffertaDatoH2H {
    offertaDatoID?: number;
    hhCodiceID?: number | null;
    codicePrenotazione?: string | null;
    codiceServizio?: string | null;
    codiceTipologia?: string | null;
    customData?: string | null;
    bookCustomData?: string | null;
    contattoPickupID?: number | null;
    contattoDropoffID?: number | null;
    puntoIniziale?: string | null;
    puntoFinale?: string | null;
    hashCode?: string | null;
    qualifier?: string | null;
    servizioH2hID?: number | null;
    roomAttributeID?: number | null;
    classAttributeID?: number | null;
    viewAttributeID?: number | null;
    featuresAttributeID?: number | null;
    qualifierTokens?: string[];
    mealsID?: number | null;
    bedsID?: number | null;
}

export class HHTipologiaFornitore implements IHHTipologiaFornitore {
    id?: number;
    hhServizioID?: number | null;
    nomeTipologia?: string | null;
    codiceTipologia?: string | null;
    servizioTipologiaNaarID?: number | null;
    tipoTipologia?: ETipoTipologiaHH;
    ultimoAggiornamento?: string | null;
    codiceTrattamentoFornitore?: string | null;
    trattamentoID?: number | null;
    nonRimborsabile?: boolean | null;
    pagaSubito?: boolean;
    customData?: string | null;
    servizioRegolaVenditaID?: number | null;
    descrizioneID?: number | null;
    hashCodeID?: number | null;
    servizioFornitore?: HHServizioFornitore | null;
    bedsID?: number | null;
    mealID?: number | null;
    hashCode?: string | null;

    constructor(data?: IHHTipologiaFornitore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.hhServizioID = _data["hhServizioID"] !== undefined ? _data["hhServizioID"] : null as any;
            this.nomeTipologia = _data["nomeTipologia"] !== undefined ? _data["nomeTipologia"] : null as any;
            this.codiceTipologia = _data["codiceTipologia"] !== undefined ? _data["codiceTipologia"] : null as any;
            this.servizioTipologiaNaarID = _data["servizioTipologiaNaarID"] !== undefined ? _data["servizioTipologiaNaarID"] : null as any;
            this.tipoTipologia = _data["tipoTipologia"] !== undefined ? _data["tipoTipologia"] : null as any;
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] !== undefined ? _data["ultimoAggiornamento"] : null as any;
            this.codiceTrattamentoFornitore = _data["codiceTrattamentoFornitore"] !== undefined ? _data["codiceTrattamentoFornitore"] : null as any;
            this.trattamentoID = _data["trattamentoID"] !== undefined ? _data["trattamentoID"] : null as any;
            this.nonRimborsabile = _data["nonRimborsabile"] !== undefined ? _data["nonRimborsabile"] : null as any;
            this.pagaSubito = _data["pagaSubito"] !== undefined ? _data["pagaSubito"] : null as any;
            this.customData = _data["customData"] !== undefined ? _data["customData"] : null as any;
            this.servizioRegolaVenditaID = _data["servizioRegolaVenditaID"] !== undefined ? _data["servizioRegolaVenditaID"] : null as any;
            this.descrizioneID = _data["descrizioneID"] !== undefined ? _data["descrizioneID"] : null as any;
            this.hashCodeID = _data["hashCodeID"] !== undefined ? _data["hashCodeID"] : null as any;
            this.servizioFornitore = _data["servizioFornitore"] ? HHServizioFornitore.fromJS(_data["servizioFornitore"]) : null as any;
            this.bedsID = _data["bedsID"] !== undefined ? _data["bedsID"] : null as any;
            this.mealID = _data["mealID"] !== undefined ? _data["mealID"] : null as any;
            this.hashCode = _data["hashCode"] !== undefined ? _data["hashCode"] : null as any;
        }
    }

    static fromJS(data: any): HHTipologiaFornitore {
        data = typeof data === 'object' ? data : {};
        let result = new HHTipologiaFornitore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["hhServizioID"] = this.hhServizioID !== undefined ? this.hhServizioID : null as any;
        data["nomeTipologia"] = this.nomeTipologia !== undefined ? this.nomeTipologia : null as any;
        data["codiceTipologia"] = this.codiceTipologia !== undefined ? this.codiceTipologia : null as any;
        data["servizioTipologiaNaarID"] = this.servizioTipologiaNaarID !== undefined ? this.servizioTipologiaNaarID : null as any;
        data["tipoTipologia"] = this.tipoTipologia !== undefined ? this.tipoTipologia : null as any;
        data["ultimoAggiornamento"] = this.ultimoAggiornamento !== undefined ? this.ultimoAggiornamento : null as any;
        data["codiceTrattamentoFornitore"] = this.codiceTrattamentoFornitore !== undefined ? this.codiceTrattamentoFornitore : null as any;
        data["trattamentoID"] = this.trattamentoID !== undefined ? this.trattamentoID : null as any;
        data["nonRimborsabile"] = this.nonRimborsabile !== undefined ? this.nonRimborsabile : null as any;
        data["pagaSubito"] = this.pagaSubito !== undefined ? this.pagaSubito : null as any;
        data["customData"] = this.customData !== undefined ? this.customData : null as any;
        data["servizioRegolaVenditaID"] = this.servizioRegolaVenditaID !== undefined ? this.servizioRegolaVenditaID : null as any;
        data["descrizioneID"] = this.descrizioneID !== undefined ? this.descrizioneID : null as any;
        data["hashCodeID"] = this.hashCodeID !== undefined ? this.hashCodeID : null as any;
        data["servizioFornitore"] = this.servizioFornitore ? this.servizioFornitore.toJSON() : null as any;
        data["bedsID"] = this.bedsID !== undefined ? this.bedsID : null as any;
        data["mealID"] = this.mealID !== undefined ? this.mealID : null as any;
        data["hashCode"] = this.hashCode !== undefined ? this.hashCode : null as any;
        return data;
    }
}

export interface IHHTipologiaFornitore {
    id?: number;
    hhServizioID?: number | null;
    nomeTipologia?: string | null;
    codiceTipologia?: string | null;
    servizioTipologiaNaarID?: number | null;
    tipoTipologia?: ETipoTipologiaHH;
    ultimoAggiornamento?: string | null;
    codiceTrattamentoFornitore?: string | null;
    trattamentoID?: number | null;
    nonRimborsabile?: boolean | null;
    pagaSubito?: boolean;
    customData?: string | null;
    servizioRegolaVenditaID?: number | null;
    descrizioneID?: number | null;
    hashCodeID?: number | null;
    servizioFornitore?: HHServizioFornitore | null;
    bedsID?: number | null;
    mealID?: number | null;
    hashCode?: string | null;
}

export enum ETipoTipologiaHH {
    Camera = "Camera",
    Supplemento = "Supplemento",
    Pasto = "Pasto",
}

export class HHServizioFornitore implements IHHServizioFornitore {
    id?: number;
    fornitore?: EFornitore;
    servizioNaarID?: number | null;
    luogoFornitoreID?: number;
    nomeServizio?: string | null;
    codiceServizio!: string;
    ultimoAggiornamento?: string | null;
    customData?: string | null;
    tipo?: ETipoServizio;
    daConfermare?: boolean;
    indirizzo?: string | null;
    telefono?: string | null;
    latitudine?: number | null;
    longitudine?: number | null;
    giataID?: number | null;
    servizioH2HID?: number | null;
    rating?: number | null;
    numeroRecensioni?: number | null;
    punteggioRecensioni?: string | null;
    accordoID?: number | null;
    deleted?: string | null;

    constructor(data?: IHHServizioFornitore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : null as any;
            this.servizioNaarID = _data["servizioNaarID"] !== undefined ? _data["servizioNaarID"] : null as any;
            this.luogoFornitoreID = _data["luogoFornitoreID"] !== undefined ? _data["luogoFornitoreID"] : null as any;
            this.nomeServizio = _data["nomeServizio"] !== undefined ? _data["nomeServizio"] : null as any;
            this.codiceServizio = _data["codiceServizio"] !== undefined ? _data["codiceServizio"] : null as any;
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] !== undefined ? _data["ultimoAggiornamento"] : null as any;
            this.customData = _data["customData"] !== undefined ? _data["customData"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.daConfermare = _data["daConfermare"] !== undefined ? _data["daConfermare"] : null as any;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : null as any;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : null as any;
            this.latitudine = _data["latitudine"] !== undefined ? _data["latitudine"] : null as any;
            this.longitudine = _data["longitudine"] !== undefined ? _data["longitudine"] : null as any;
            this.giataID = _data["giataID"] !== undefined ? _data["giataID"] : null as any;
            this.servizioH2HID = _data["servizioH2HID"] !== undefined ? _data["servizioH2HID"] : null as any;
            this.rating = _data["rating"] !== undefined ? _data["rating"] : null as any;
            this.numeroRecensioni = _data["numeroRecensioni"] !== undefined ? _data["numeroRecensioni"] : null as any;
            this.punteggioRecensioni = _data["punteggioRecensioni"] !== undefined ? _data["punteggioRecensioni"] : null as any;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : null as any;
        }
    }

    static fromJS(data: any): HHServizioFornitore {
        data = typeof data === 'object' ? data : {};
        let result = new HHServizioFornitore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : null as any;
        data["servizioNaarID"] = this.servizioNaarID !== undefined ? this.servizioNaarID : null as any;
        data["luogoFornitoreID"] = this.luogoFornitoreID !== undefined ? this.luogoFornitoreID : null as any;
        data["nomeServizio"] = this.nomeServizio !== undefined ? this.nomeServizio : null as any;
        data["codiceServizio"] = this.codiceServizio !== undefined ? this.codiceServizio : null as any;
        data["ultimoAggiornamento"] = this.ultimoAggiornamento !== undefined ? this.ultimoAggiornamento : null as any;
        data["customData"] = this.customData !== undefined ? this.customData : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["daConfermare"] = this.daConfermare !== undefined ? this.daConfermare : null as any;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : null as any;
        data["telefono"] = this.telefono !== undefined ? this.telefono : null as any;
        data["latitudine"] = this.latitudine !== undefined ? this.latitudine : null as any;
        data["longitudine"] = this.longitudine !== undefined ? this.longitudine : null as any;
        data["giataID"] = this.giataID !== undefined ? this.giataID : null as any;
        data["servizioH2HID"] = this.servizioH2HID !== undefined ? this.servizioH2HID : null as any;
        data["rating"] = this.rating !== undefined ? this.rating : null as any;
        data["numeroRecensioni"] = this.numeroRecensioni !== undefined ? this.numeroRecensioni : null as any;
        data["punteggioRecensioni"] = this.punteggioRecensioni !== undefined ? this.punteggioRecensioni : null as any;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["deleted"] = this.deleted !== undefined ? this.deleted : null as any;
        return data;
    }
}

export interface IHHServizioFornitore {
    id?: number;
    fornitore?: EFornitore;
    servizioNaarID?: number | null;
    luogoFornitoreID?: number;
    nomeServizio?: string | null;
    codiceServizio: string;
    ultimoAggiornamento?: string | null;
    customData?: string | null;
    tipo?: ETipoServizio;
    daConfermare?: boolean;
    indirizzo?: string | null;
    telefono?: string | null;
    latitudine?: number | null;
    longitudine?: number | null;
    giataID?: number | null;
    servizioH2HID?: number | null;
    rating?: number | null;
    numeroRecensioni?: number | null;
    punteggioRecensioni?: string | null;
    accordoID?: number | null;
    deleted?: string | null;
}

export class HHLuogo implements IHHLuogo {
    id?: number;
    codiceLuogo!: string;
    fornitoreID?: number;
    luogoNaarID?: number | null;
    accordoID?: number | null;
    nome!: string;
    codicePaese?: string | null;
    ultimoAggiornamento?: string | null;
    prioritaImmagini?: number | null;
    prioritaArticoli?: number | null;
    prioritaInfo?: number | null;
    disabilitato?: boolean;
    tipoLocation?: EH2HTipoLocation;
    tipoLuogo?: EHHTipoLuogo;
    priorita?: number;
    parentID?: number | null;
    rating?: number | null;
    customData?: string | null;
    deleted?: string | null;
    latitude?: number | null;
    longitude?: number | null;

    constructor(data?: IHHLuogo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.codiceLuogo = _data["codiceLuogo"] !== undefined ? _data["codiceLuogo"] : null as any;
            this.fornitoreID = _data["fornitoreID"] !== undefined ? _data["fornitoreID"] : null as any;
            this.luogoNaarID = _data["luogoNaarID"] !== undefined ? _data["luogoNaarID"] : null as any;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.codicePaese = _data["codicePaese"] !== undefined ? _data["codicePaese"] : null as any;
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] !== undefined ? _data["ultimoAggiornamento"] : null as any;
            this.prioritaImmagini = _data["prioritaImmagini"] !== undefined ? _data["prioritaImmagini"] : null as any;
            this.prioritaArticoli = _data["prioritaArticoli"] !== undefined ? _data["prioritaArticoli"] : null as any;
            this.prioritaInfo = _data["prioritaInfo"] !== undefined ? _data["prioritaInfo"] : null as any;
            this.disabilitato = _data["disabilitato"] !== undefined ? _data["disabilitato"] : null as any;
            this.tipoLocation = _data["tipoLocation"] !== undefined ? _data["tipoLocation"] : null as any;
            this.tipoLuogo = _data["tipoLuogo"] !== undefined ? _data["tipoLuogo"] : null as any;
            this.priorita = _data["priorita"] !== undefined ? _data["priorita"] : null as any;
            this.parentID = _data["parentID"] !== undefined ? _data["parentID"] : null as any;
            this.rating = _data["rating"] !== undefined ? _data["rating"] : null as any;
            this.customData = _data["customData"] !== undefined ? _data["customData"] : null as any;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : null as any;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : null as any;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : null as any;
        }
    }

    static fromJS(data: any): HHLuogo {
        data = typeof data === 'object' ? data : {};
        let result = new HHLuogo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["codiceLuogo"] = this.codiceLuogo !== undefined ? this.codiceLuogo : null as any;
        data["fornitoreID"] = this.fornitoreID !== undefined ? this.fornitoreID : null as any;
        data["luogoNaarID"] = this.luogoNaarID !== undefined ? this.luogoNaarID : null as any;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["codicePaese"] = this.codicePaese !== undefined ? this.codicePaese : null as any;
        data["ultimoAggiornamento"] = this.ultimoAggiornamento !== undefined ? this.ultimoAggiornamento : null as any;
        data["prioritaImmagini"] = this.prioritaImmagini !== undefined ? this.prioritaImmagini : null as any;
        data["prioritaArticoli"] = this.prioritaArticoli !== undefined ? this.prioritaArticoli : null as any;
        data["prioritaInfo"] = this.prioritaInfo !== undefined ? this.prioritaInfo : null as any;
        data["disabilitato"] = this.disabilitato !== undefined ? this.disabilitato : null as any;
        data["tipoLocation"] = this.tipoLocation !== undefined ? this.tipoLocation : null as any;
        data["tipoLuogo"] = this.tipoLuogo !== undefined ? this.tipoLuogo : null as any;
        data["priorita"] = this.priorita !== undefined ? this.priorita : null as any;
        data["parentID"] = this.parentID !== undefined ? this.parentID : null as any;
        data["rating"] = this.rating !== undefined ? this.rating : null as any;
        data["customData"] = this.customData !== undefined ? this.customData : null as any;
        data["deleted"] = this.deleted !== undefined ? this.deleted : null as any;
        data["latitude"] = this.latitude !== undefined ? this.latitude : null as any;
        data["longitude"] = this.longitude !== undefined ? this.longitude : null as any;
        return data;
    }
}

export interface IHHLuogo {
    id?: number;
    codiceLuogo: string;
    fornitoreID?: number;
    luogoNaarID?: number | null;
    accordoID?: number | null;
    nome: string;
    codicePaese?: string | null;
    ultimoAggiornamento?: string | null;
    prioritaImmagini?: number | null;
    prioritaArticoli?: number | null;
    prioritaInfo?: number | null;
    disabilitato?: boolean;
    tipoLocation?: EH2HTipoLocation;
    tipoLuogo?: EHHTipoLuogo;
    priorita?: number;
    parentID?: number | null;
    rating?: number | null;
    customData?: string | null;
    deleted?: string | null;
    latitude?: number | null;
    longitude?: number | null;
}

export enum EH2HTipoLocation {
    Indefinita = "Indefinita",
    Aeroporto = "Aeroporto",
}

export enum EHHTipoLuogo {
    Continente = "Continente",
    Zona = "Zona",
    Paese = "Paese",
    Citta = "Citta",
    Quartiere = "Quartiere",
    Regione = "Regione",
    Stato = "Stato",
    PuntoDiInteresse = "PuntoDiInteresse",
}

export class HHServizio implements IHHServizio {
    id?: number;
    luogoID?: number;
    nome!: string;
    indirizzo?: string | null;
    cap?: string | null;
    telefono?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    zoom?: number | null;
    tipo?: ETipoServizio;
    ultimoAggiornamento?: string;
    servizioID?: number | null;
    disabilitato?: boolean;
    giataID?: number | null;
    thumbUrl?: string | null;
    email?: string | null;
    website?: string | null;
    stelle?: number | null;
    giataUpdate?: string | null;
    codice?: string | null;

    constructor(data?: IHHServizio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : null as any;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : null as any;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : null as any;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : null as any;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : null as any;
            this.zoom = _data["zoom"] !== undefined ? _data["zoom"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] !== undefined ? _data["ultimoAggiornamento"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.disabilitato = _data["disabilitato"] !== undefined ? _data["disabilitato"] : null as any;
            this.giataID = _data["giataID"] !== undefined ? _data["giataID"] : null as any;
            this.thumbUrl = _data["thumbUrl"] !== undefined ? _data["thumbUrl"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.website = _data["website"] !== undefined ? _data["website"] : null as any;
            this.stelle = _data["stelle"] !== undefined ? _data["stelle"] : null as any;
            this.giataUpdate = _data["giataUpdate"] !== undefined ? _data["giataUpdate"] : null as any;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
        }
    }

    static fromJS(data: any): HHServizio {
        data = typeof data === 'object' ? data : {};
        let result = new HHServizio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : null as any;
        data["cap"] = this.cap !== undefined ? this.cap : null as any;
        data["telefono"] = this.telefono !== undefined ? this.telefono : null as any;
        data["latitude"] = this.latitude !== undefined ? this.latitude : null as any;
        data["longitude"] = this.longitude !== undefined ? this.longitude : null as any;
        data["zoom"] = this.zoom !== undefined ? this.zoom : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["ultimoAggiornamento"] = this.ultimoAggiornamento !== undefined ? this.ultimoAggiornamento : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["disabilitato"] = this.disabilitato !== undefined ? this.disabilitato : null as any;
        data["giataID"] = this.giataID !== undefined ? this.giataID : null as any;
        data["thumbUrl"] = this.thumbUrl !== undefined ? this.thumbUrl : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["website"] = this.website !== undefined ? this.website : null as any;
        data["stelle"] = this.stelle !== undefined ? this.stelle : null as any;
        data["giataUpdate"] = this.giataUpdate !== undefined ? this.giataUpdate : null as any;
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        return data;
    }
}

export interface IHHServizio {
    id?: number;
    luogoID?: number;
    nome: string;
    indirizzo?: string | null;
    cap?: string | null;
    telefono?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    zoom?: number | null;
    tipo?: ETipoServizio;
    ultimoAggiornamento?: string;
    servizioID?: number | null;
    disabilitato?: boolean;
    giataID?: number | null;
    thumbUrl?: string | null;
    email?: string | null;
    website?: string | null;
    stelle?: number | null;
    giataUpdate?: string | null;
    codice?: string | null;
}

export class HHAttributoHashcodeDescription implements IHHAttributoHashcodeDescription {
    lingua?: ELingua;
    room?: string | null;
    class?: string | null;
    view?: string | null;
    feature?: string | null;
    meals?: string | null;
    beds?: string | null;
    fullDescription?: string | null;

    constructor(data?: IHHAttributoHashcodeDescription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : null as any;
            this.room = _data["room"] !== undefined ? _data["room"] : null as any;
            this.class = _data["class"] !== undefined ? _data["class"] : null as any;
            this.view = _data["view"] !== undefined ? _data["view"] : null as any;
            this.feature = _data["feature"] !== undefined ? _data["feature"] : null as any;
            this.meals = _data["meals"] !== undefined ? _data["meals"] : null as any;
            this.beds = _data["beds"] !== undefined ? _data["beds"] : null as any;
            this.fullDescription = _data["fullDescription"] !== undefined ? _data["fullDescription"] : null as any;
        }
    }

    static fromJS(data: any): HHAttributoHashcodeDescription {
        data = typeof data === 'object' ? data : {};
        let result = new HHAttributoHashcodeDescription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lingua"] = this.lingua !== undefined ? this.lingua : null as any;
        data["room"] = this.room !== undefined ? this.room : null as any;
        data["class"] = this.class !== undefined ? this.class : null as any;
        data["view"] = this.view !== undefined ? this.view : null as any;
        data["feature"] = this.feature !== undefined ? this.feature : null as any;
        data["meals"] = this.meals !== undefined ? this.meals : null as any;
        data["beds"] = this.beds !== undefined ? this.beds : null as any;
        data["fullDescription"] = this.fullDescription !== undefined ? this.fullDescription : null as any;
        return data;
    }
}

export interface IHHAttributoHashcodeDescription {
    lingua?: ELingua;
    room?: string | null;
    class?: string | null;
    view?: string | null;
    feature?: string | null;
    meals?: string | null;
    beds?: string | null;
    fullDescription?: string | null;
}

export class HHAttributoHashcode implements IHHAttributoHashcode {
    id?: number;
    hashcode!: string;
    name?: string | null;
    roomAttributeID?: number | null;
    classAttributeID?: number | null;
    viewAttributeID?: number | null;
    featuresAttributeID?: number | null;
    deletedAt?: string | null;
    servizioH2HID?: number | null;
    dateUpdated?: string | null;
    supplier?: EFornitore | null;
    isManual?: boolean | null;
    qualifier?: string | null;
    qualifierTokens?: string[];
    isBasic?: boolean;

    constructor(data?: IHHAttributoHashcode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.hashcode = _data["hashcode"] !== undefined ? _data["hashcode"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.roomAttributeID = _data["roomAttributeID"] !== undefined ? _data["roomAttributeID"] : null as any;
            this.classAttributeID = _data["classAttributeID"] !== undefined ? _data["classAttributeID"] : null as any;
            this.viewAttributeID = _data["viewAttributeID"] !== undefined ? _data["viewAttributeID"] : null as any;
            this.featuresAttributeID = _data["featuresAttributeID"] !== undefined ? _data["featuresAttributeID"] : null as any;
            this.deletedAt = _data["deletedAt"] !== undefined ? _data["deletedAt"] : null as any;
            this.servizioH2HID = _data["servizioH2HID"] !== undefined ? _data["servizioH2HID"] : null as any;
            this.dateUpdated = _data["dateUpdated"] !== undefined ? _data["dateUpdated"] : null as any;
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : null as any;
            this.isManual = _data["isManual"] !== undefined ? _data["isManual"] : null as any;
            this.qualifier = _data["qualifier"] !== undefined ? _data["qualifier"] : null as any;
            if (Array.isArray(_data["qualifierTokens"])) {
                this.qualifierTokens = [] as any;
                for (let item of _data["qualifierTokens"])
                    this.qualifierTokens!.push(item);
            }
            else {
                this.qualifierTokens = null as any;
            }
            this.isBasic = _data["isBasic"] !== undefined ? _data["isBasic"] : null as any;
        }
    }

    static fromJS(data: any): HHAttributoHashcode {
        data = typeof data === 'object' ? data : {};
        let result = new HHAttributoHashcode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["hashcode"] = this.hashcode !== undefined ? this.hashcode : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["roomAttributeID"] = this.roomAttributeID !== undefined ? this.roomAttributeID : null as any;
        data["classAttributeID"] = this.classAttributeID !== undefined ? this.classAttributeID : null as any;
        data["viewAttributeID"] = this.viewAttributeID !== undefined ? this.viewAttributeID : null as any;
        data["featuresAttributeID"] = this.featuresAttributeID !== undefined ? this.featuresAttributeID : null as any;
        data["deletedAt"] = this.deletedAt !== undefined ? this.deletedAt : null as any;
        data["servizioH2HID"] = this.servizioH2HID !== undefined ? this.servizioH2HID : null as any;
        data["dateUpdated"] = this.dateUpdated !== undefined ? this.dateUpdated : null as any;
        data["supplier"] = this.supplier !== undefined ? this.supplier : null as any;
        data["isManual"] = this.isManual !== undefined ? this.isManual : null as any;
        data["qualifier"] = this.qualifier !== undefined ? this.qualifier : null as any;
        if (Array.isArray(this.qualifierTokens)) {
            data["qualifierTokens"] = [];
            for (let item of this.qualifierTokens)
                data["qualifierTokens"].push(item);
        }
        data["isBasic"] = this.isBasic !== undefined ? this.isBasic : null as any;
        return data;
    }
}

export interface IHHAttributoHashcode {
    id?: number;
    hashcode: string;
    name?: string | null;
    roomAttributeID?: number | null;
    classAttributeID?: number | null;
    viewAttributeID?: number | null;
    featuresAttributeID?: number | null;
    deletedAt?: string | null;
    servizioH2HID?: number | null;
    dateUpdated?: string | null;
    supplier?: EFornitore | null;
    isManual?: boolean | null;
    qualifier?: string | null;
    qualifierTokens?: string[];
    isBasic?: boolean;
}

export class OffertaDatoDettaglio implements IOffertaDatoDettaglio {
    datoDettaglioID?: number;
    offertaDatoID?: number;
    associazioneID?: number;
    prezzo?: number;
    costo?: number;
    descrizione?: string | null;
    tipoAzione?: ETipoAzioneDettaglio;

    constructor(data?: IOffertaDatoDettaglio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datoDettaglioID = _data["datoDettaglioID"] !== undefined ? _data["datoDettaglioID"] : null as any;
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : null as any;
            this.associazioneID = _data["associazioneID"] !== undefined ? _data["associazioneID"] : null as any;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : null as any;
            this.costo = _data["costo"] !== undefined ? _data["costo"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.tipoAzione = _data["tipoAzione"] !== undefined ? _data["tipoAzione"] : null as any;
        }
    }

    static fromJS(data: any): OffertaDatoDettaglio {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaDatoDettaglio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datoDettaglioID"] = this.datoDettaglioID !== undefined ? this.datoDettaglioID : null as any;
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : null as any;
        data["associazioneID"] = this.associazioneID !== undefined ? this.associazioneID : null as any;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : null as any;
        data["costo"] = this.costo !== undefined ? this.costo : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["tipoAzione"] = this.tipoAzione !== undefined ? this.tipoAzione : null as any;
        return data;
    }
}

export interface IOffertaDatoDettaglio {
    datoDettaglioID?: number;
    offertaDatoID?: number;
    associazioneID?: number;
    prezzo?: number;
    costo?: number;
    descrizione?: string | null;
    tipoAzione?: ETipoAzioneDettaglio;
}

export enum ETipoAzioneDettaglio {
    NessunCambiamento = "NessunCambiamento",
    Allerta = "Allerta",
    BloccoVendita = "BloccoVendita",
    RiduzioneApplicata = "RiduzioneApplicata",
    OffertaApplicata = "OffertaApplicata",
    Nascosto = "Nascosto",
    SupplementoApplicato = "SupplementoApplicato",
    VisualizzaInformazione = "VisualizzaInformazione",
}

export abstract class DatiRiga implements IDatiRiga {
    offertaDatoID?: number;

    constructor(data?: IDatiRiga) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : null as any;
        }
    }

    static fromJS(data: any): DatiRiga {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'DatiRiga' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : null as any;
        return data;
    }
}

export interface IDatiRiga {
    offertaDatoID?: number;
}

export class DatiDocumentoRiga extends DatiRiga implements IDatiDocumentoRiga {
    descrizioneProgrammaDiViaggio?: string | null;
    inizio?: string | null;
    fine?: string | null;
    luogoInizioID?: number | null;
    puntoIniziale?: string | null;
    contattoPickupID?: number | null;
    luogoFineID?: number | null;
    puntoFinale?: string | null;
    contattoDropoffID?: number | null;

    constructor(data?: IDatiDocumentoRiga) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.descrizioneProgrammaDiViaggio = _data["descrizioneProgrammaDiViaggio"] !== undefined ? _data["descrizioneProgrammaDiViaggio"] : null as any;
            this.inizio = _data["inizio"] !== undefined ? _data["inizio"] : null as any;
            this.fine = _data["fine"] !== undefined ? _data["fine"] : null as any;
            this.luogoInizioID = _data["luogoInizioID"] !== undefined ? _data["luogoInizioID"] : null as any;
            this.puntoIniziale = _data["puntoIniziale"] !== undefined ? _data["puntoIniziale"] : null as any;
            this.contattoPickupID = _data["contattoPickupID"] !== undefined ? _data["contattoPickupID"] : null as any;
            this.luogoFineID = _data["luogoFineID"] !== undefined ? _data["luogoFineID"] : null as any;
            this.puntoFinale = _data["puntoFinale"] !== undefined ? _data["puntoFinale"] : null as any;
            this.contattoDropoffID = _data["contattoDropoffID"] !== undefined ? _data["contattoDropoffID"] : null as any;
        }
    }

    static override fromJS(data: any): DatiDocumentoRiga {
        data = typeof data === 'object' ? data : {};
        let result = new DatiDocumentoRiga();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descrizioneProgrammaDiViaggio"] = this.descrizioneProgrammaDiViaggio !== undefined ? this.descrizioneProgrammaDiViaggio : null as any;
        data["inizio"] = this.inizio !== undefined ? this.inizio : null as any;
        data["fine"] = this.fine !== undefined ? this.fine : null as any;
        data["luogoInizioID"] = this.luogoInizioID !== undefined ? this.luogoInizioID : null as any;
        data["puntoIniziale"] = this.puntoIniziale !== undefined ? this.puntoIniziale : null as any;
        data["contattoPickupID"] = this.contattoPickupID !== undefined ? this.contattoPickupID : null as any;
        data["luogoFineID"] = this.luogoFineID !== undefined ? this.luogoFineID : null as any;
        data["puntoFinale"] = this.puntoFinale !== undefined ? this.puntoFinale : null as any;
        data["contattoDropoffID"] = this.contattoDropoffID !== undefined ? this.contattoDropoffID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDatiDocumentoRiga extends IDatiRiga {
    descrizioneProgrammaDiViaggio?: string | null;
    inizio?: string | null;
    fine?: string | null;
    luogoInizioID?: number | null;
    puntoIniziale?: string | null;
    contattoPickupID?: number | null;
    luogoFineID?: number | null;
    puntoFinale?: string | null;
    contattoDropoffID?: number | null;
}

export class DatiConfermaRiga extends DatiRiga implements IDatiConfermaRiga {
    status?: EStatusServizio | null;
    bookingReference?: string | null;

    constructor(data?: IDatiConfermaRiga) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.bookingReference = _data["bookingReference"] !== undefined ? _data["bookingReference"] : null as any;
        }
    }

    static override fromJS(data: any): DatiConfermaRiga {
        data = typeof data === 'object' ? data : {};
        let result = new DatiConfermaRiga();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["bookingReference"] = this.bookingReference !== undefined ? this.bookingReference : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDatiConfermaRiga extends IDatiRiga {
    status?: EStatusServizio | null;
    bookingReference?: string | null;
}

export class OffertaNota implements IOffertaNota {
    offertaNotaID?: number;
    offertaID?: number;
    offertaDatoID?: number | null;
    accordoID?: number | null;
    testo!: string;
    data?: string;
    utenteImpiegatoID?: number | null;
    utentePresaInCaricoID?: number | null;
    fatto?: boolean;
    pubblica?: boolean;
    voucher?: boolean;
    kanban?: boolean;
    sistema?: boolean;
    tipo?: ETipoNota | null;

    constructor(data?: IOffertaNota) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaNotaID = _data["offertaNotaID"] !== undefined ? _data["offertaNotaID"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : null as any;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
            this.utenteImpiegatoID = _data["utenteImpiegatoID"] !== undefined ? _data["utenteImpiegatoID"] : null as any;
            this.utentePresaInCaricoID = _data["utentePresaInCaricoID"] !== undefined ? _data["utentePresaInCaricoID"] : null as any;
            this.fatto = _data["fatto"] !== undefined ? _data["fatto"] : null as any;
            this.pubblica = _data["pubblica"] !== undefined ? _data["pubblica"] : null as any;
            this.voucher = _data["voucher"] !== undefined ? _data["voucher"] : null as any;
            this.kanban = _data["kanban"] !== undefined ? _data["kanban"] : null as any;
            this.sistema = _data["sistema"] !== undefined ? _data["sistema"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
        }
    }

    static fromJS(data: any): OffertaNota {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaNota();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaNotaID"] = this.offertaNotaID !== undefined ? this.offertaNotaID : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : null as any;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["testo"] = this.testo !== undefined ? this.testo : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["utenteImpiegatoID"] = this.utenteImpiegatoID !== undefined ? this.utenteImpiegatoID : null as any;
        data["utentePresaInCaricoID"] = this.utentePresaInCaricoID !== undefined ? this.utentePresaInCaricoID : null as any;
        data["fatto"] = this.fatto !== undefined ? this.fatto : null as any;
        data["pubblica"] = this.pubblica !== undefined ? this.pubblica : null as any;
        data["voucher"] = this.voucher !== undefined ? this.voucher : null as any;
        data["kanban"] = this.kanban !== undefined ? this.kanban : null as any;
        data["sistema"] = this.sistema !== undefined ? this.sistema : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        return data;
    }
}

export interface IOffertaNota {
    offertaNotaID?: number;
    offertaID?: number;
    offertaDatoID?: number | null;
    accordoID?: number | null;
    testo: string;
    data?: string;
    utenteImpiegatoID?: number | null;
    utentePresaInCaricoID?: number | null;
    fatto?: boolean;
    pubblica?: boolean;
    voucher?: boolean;
    kanban?: boolean;
    sistema?: boolean;
    tipo?: ETipoNota | null;
}

export enum ETipoNota {
    Interna = "Interna",
    PreventivoSingola = "PreventivoSingola",
    PreventivoMultipla = "PreventivoMultipla",
    Agenzia = "Agenzia",
    RispostaAgenzia = "RispostaAgenzia",
    Assistenza = "Assistenza",
    Passeggero = "Passeggero",
    Operatore = "Operatore",
    Documento = "Documento",
}

export class TripNote implements ITripNote {
    nota?: OffertaNota;
    utente?: string | null;
    utentePresaInCarico?: string | null;

    constructor(data?: ITripNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nota = _data["nota"] ? OffertaNota.fromJS(_data["nota"]) : null as any;
            this.utente = _data["utente"] !== undefined ? _data["utente"] : null as any;
            this.utentePresaInCarico = _data["utentePresaInCarico"] !== undefined ? _data["utentePresaInCarico"] : null as any;
        }
    }

    static fromJS(data: any): TripNote {
        data = typeof data === 'object' ? data : {};
        let result = new TripNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nota"] = this.nota ? this.nota.toJSON() : null as any;
        data["utente"] = this.utente !== undefined ? this.utente : null as any;
        data["utentePresaInCarico"] = this.utentePresaInCarico !== undefined ? this.utentePresaInCarico : null as any;
        return data;
    }
}

export interface ITripNote {
    nota?: OffertaNota;
    utente?: string | null;
    utentePresaInCarico?: string | null;
}

export class AnticipoFornitore implements IAnticipoFornitore {
    accordoID?: number;
    importo?: number;
    valutaID?: number;
    codiceValuta?: string;
    data?: string | null;

    constructor(data?: IAnticipoFornitore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : null as any;
            this.valutaID = _data["valutaID"] !== undefined ? _data["valutaID"] : null as any;
            this.codiceValuta = _data["codiceValuta"] !== undefined ? _data["codiceValuta"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
        }
    }

    static fromJS(data: any): AnticipoFornitore {
        data = typeof data === 'object' ? data : {};
        let result = new AnticipoFornitore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["importo"] = this.importo !== undefined ? this.importo : null as any;
        data["valutaID"] = this.valutaID !== undefined ? this.valutaID : null as any;
        data["codiceValuta"] = this.codiceValuta !== undefined ? this.codiceValuta : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        return data;
    }
}

export interface IAnticipoFornitore {
    accordoID?: number;
    importo?: number;
    valutaID?: number;
    codiceValuta?: string;
    data?: string | null;
}

export class InvioAssicurazioneFiloDiretto implements IInvioAssicurazioneFiloDiretto {
    id?: number;
    clienteID?: number;
    offertaDatoID?: number;
    dataInvio?: string;
    nome_Polizza?: string | null;
    cognome?: string | null;
    nome?: string | null;
    data_Prenotazione?: string | null;
    data_Partenza?: string | null;
    data_Rientro?: string | null;
    importo_Viaggio?: string | null;
    destinazione?: string | null;
    codice_Area?: string | null;
    bookingID?: string | null;
    tipo_Operazione?: string | null;
    login?: string | null;
    polizza?: string | null;
    capo_Nucleo?: string | null;
    tipo_Assicurato?: string | null;
    impremioAss?: string | null;
    codice_Fiscale?: string | null;

    constructor(data?: IInvioAssicurazioneFiloDiretto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.clienteID = _data["clienteID"] !== undefined ? _data["clienteID"] : null as any;
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : null as any;
            this.dataInvio = _data["dataInvio"] !== undefined ? _data["dataInvio"] : null as any;
            this.nome_Polizza = _data["nome_Polizza"] !== undefined ? _data["nome_Polizza"] : null as any;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.data_Prenotazione = _data["data_Prenotazione"] !== undefined ? _data["data_Prenotazione"] : null as any;
            this.data_Partenza = _data["data_Partenza"] !== undefined ? _data["data_Partenza"] : null as any;
            this.data_Rientro = _data["data_Rientro"] !== undefined ? _data["data_Rientro"] : null as any;
            this.importo_Viaggio = _data["importo_Viaggio"] !== undefined ? _data["importo_Viaggio"] : null as any;
            this.destinazione = _data["destinazione"] !== undefined ? _data["destinazione"] : null as any;
            this.codice_Area = _data["codice_Area"] !== undefined ? _data["codice_Area"] : null as any;
            this.bookingID = _data["bookingID"] !== undefined ? _data["bookingID"] : null as any;
            this.tipo_Operazione = _data["tipo_Operazione"] !== undefined ? _data["tipo_Operazione"] : null as any;
            this.login = _data["login"] !== undefined ? _data["login"] : null as any;
            this.polizza = _data["polizza"] !== undefined ? _data["polizza"] : null as any;
            this.capo_Nucleo = _data["capo_Nucleo"] !== undefined ? _data["capo_Nucleo"] : null as any;
            this.tipo_Assicurato = _data["tipo_Assicurato"] !== undefined ? _data["tipo_Assicurato"] : null as any;
            this.impremioAss = _data["impremioAss"] !== undefined ? _data["impremioAss"] : null as any;
            this.codice_Fiscale = _data["codice_Fiscale"] !== undefined ? _data["codice_Fiscale"] : null as any;
        }
    }

    static fromJS(data: any): InvioAssicurazioneFiloDiretto {
        data = typeof data === 'object' ? data : {};
        let result = new InvioAssicurazioneFiloDiretto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["clienteID"] = this.clienteID !== undefined ? this.clienteID : null as any;
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : null as any;
        data["dataInvio"] = this.dataInvio !== undefined ? this.dataInvio : null as any;
        data["nome_Polizza"] = this.nome_Polizza !== undefined ? this.nome_Polizza : null as any;
        data["cognome"] = this.cognome !== undefined ? this.cognome : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["data_Prenotazione"] = this.data_Prenotazione !== undefined ? this.data_Prenotazione : null as any;
        data["data_Partenza"] = this.data_Partenza !== undefined ? this.data_Partenza : null as any;
        data["data_Rientro"] = this.data_Rientro !== undefined ? this.data_Rientro : null as any;
        data["importo_Viaggio"] = this.importo_Viaggio !== undefined ? this.importo_Viaggio : null as any;
        data["destinazione"] = this.destinazione !== undefined ? this.destinazione : null as any;
        data["codice_Area"] = this.codice_Area !== undefined ? this.codice_Area : null as any;
        data["bookingID"] = this.bookingID !== undefined ? this.bookingID : null as any;
        data["tipo_Operazione"] = this.tipo_Operazione !== undefined ? this.tipo_Operazione : null as any;
        data["login"] = this.login !== undefined ? this.login : null as any;
        data["polizza"] = this.polizza !== undefined ? this.polizza : null as any;
        data["capo_Nucleo"] = this.capo_Nucleo !== undefined ? this.capo_Nucleo : null as any;
        data["tipo_Assicurato"] = this.tipo_Assicurato !== undefined ? this.tipo_Assicurato : null as any;
        data["impremioAss"] = this.impremioAss !== undefined ? this.impremioAss : null as any;
        data["codice_Fiscale"] = this.codice_Fiscale !== undefined ? this.codice_Fiscale : null as any;
        return data;
    }
}

export interface IInvioAssicurazioneFiloDiretto {
    id?: number;
    clienteID?: number;
    offertaDatoID?: number;
    dataInvio?: string;
    nome_Polizza?: string | null;
    cognome?: string | null;
    nome?: string | null;
    data_Prenotazione?: string | null;
    data_Partenza?: string | null;
    data_Rientro?: string | null;
    importo_Viaggio?: string | null;
    destinazione?: string | null;
    codice_Area?: string | null;
    bookingID?: string | null;
    tipo_Operazione?: string | null;
    login?: string | null;
    polizza?: string | null;
    capo_Nucleo?: string | null;
    tipo_Assicurato?: string | null;
    impremioAss?: string | null;
    codice_Fiscale?: string | null;
}

export class InvioAssicurazione implements IInvioAssicurazione {
    id?: number;
    offertaID!: number;
    clienteID!: number;
    offertaDatoID!: number;
    servizioID!: number;
    dataInvio!: string;
    idProdottoEA!: number;
    nomeProdottoEA?: string | null;
    cognome?: string | null;
    nome?: string | null;
    tipoAssicurato?: string | null;
    dataPrenotazione?: string | null;
    dataPartenza?: string | null;
    dataRientro?: string | null;
    importoViaggio?: string | null;
    destinazione?: string | null;
    codiceArea?: string | null;
    couponID?: string | null;
    tipoOperazione?: string | null;
    importoPremioAss?: string | null;
    codiceFiscale?: string | null;
    dataCancellazione?: string | null;
    dataUltimoAggiornamento?: string | null;

    constructor(data?: IInvioAssicurazione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.clienteID = _data["clienteID"] !== undefined ? _data["clienteID"] : null as any;
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.dataInvio = _data["dataInvio"] !== undefined ? _data["dataInvio"] : null as any;
            this.idProdottoEA = _data["idProdottoEA"] !== undefined ? _data["idProdottoEA"] : null as any;
            this.nomeProdottoEA = _data["nomeProdottoEA"] !== undefined ? _data["nomeProdottoEA"] : null as any;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.tipoAssicurato = _data["tipoAssicurato"] !== undefined ? _data["tipoAssicurato"] : null as any;
            this.dataPrenotazione = _data["dataPrenotazione"] !== undefined ? _data["dataPrenotazione"] : null as any;
            this.dataPartenza = _data["dataPartenza"] !== undefined ? _data["dataPartenza"] : null as any;
            this.dataRientro = _data["dataRientro"] !== undefined ? _data["dataRientro"] : null as any;
            this.importoViaggio = _data["importoViaggio"] !== undefined ? _data["importoViaggio"] : null as any;
            this.destinazione = _data["destinazione"] !== undefined ? _data["destinazione"] : null as any;
            this.codiceArea = _data["codiceArea"] !== undefined ? _data["codiceArea"] : null as any;
            this.couponID = _data["couponID"] !== undefined ? _data["couponID"] : null as any;
            this.tipoOperazione = _data["tipoOperazione"] !== undefined ? _data["tipoOperazione"] : null as any;
            this.importoPremioAss = _data["importoPremioAss"] !== undefined ? _data["importoPremioAss"] : null as any;
            this.codiceFiscale = _data["codiceFiscale"] !== undefined ? _data["codiceFiscale"] : null as any;
            this.dataCancellazione = _data["dataCancellazione"] !== undefined ? _data["dataCancellazione"] : null as any;
            this.dataUltimoAggiornamento = _data["dataUltimoAggiornamento"] !== undefined ? _data["dataUltimoAggiornamento"] : null as any;
        }
    }

    static fromJS(data: any): InvioAssicurazione {
        data = typeof data === 'object' ? data : {};
        let result = new InvioAssicurazione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["clienteID"] = this.clienteID !== undefined ? this.clienteID : null as any;
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["dataInvio"] = this.dataInvio !== undefined ? this.dataInvio : null as any;
        data["idProdottoEA"] = this.idProdottoEA !== undefined ? this.idProdottoEA : null as any;
        data["nomeProdottoEA"] = this.nomeProdottoEA !== undefined ? this.nomeProdottoEA : null as any;
        data["cognome"] = this.cognome !== undefined ? this.cognome : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["tipoAssicurato"] = this.tipoAssicurato !== undefined ? this.tipoAssicurato : null as any;
        data["dataPrenotazione"] = this.dataPrenotazione !== undefined ? this.dataPrenotazione : null as any;
        data["dataPartenza"] = this.dataPartenza !== undefined ? this.dataPartenza : null as any;
        data["dataRientro"] = this.dataRientro !== undefined ? this.dataRientro : null as any;
        data["importoViaggio"] = this.importoViaggio !== undefined ? this.importoViaggio : null as any;
        data["destinazione"] = this.destinazione !== undefined ? this.destinazione : null as any;
        data["codiceArea"] = this.codiceArea !== undefined ? this.codiceArea : null as any;
        data["couponID"] = this.couponID !== undefined ? this.couponID : null as any;
        data["tipoOperazione"] = this.tipoOperazione !== undefined ? this.tipoOperazione : null as any;
        data["importoPremioAss"] = this.importoPremioAss !== undefined ? this.importoPremioAss : null as any;
        data["codiceFiscale"] = this.codiceFiscale !== undefined ? this.codiceFiscale : null as any;
        data["dataCancellazione"] = this.dataCancellazione !== undefined ? this.dataCancellazione : null as any;
        data["dataUltimoAggiornamento"] = this.dataUltimoAggiornamento !== undefined ? this.dataUltimoAggiornamento : null as any;
        return data;
    }
}

export interface IInvioAssicurazione {
    id?: number;
    offertaID: number;
    clienteID: number;
    offertaDatoID: number;
    servizioID: number;
    dataInvio: string;
    idProdottoEA: number;
    nomeProdottoEA?: string | null;
    cognome?: string | null;
    nome?: string | null;
    tipoAssicurato?: string | null;
    dataPrenotazione?: string | null;
    dataPartenza?: string | null;
    dataRientro?: string | null;
    importoViaggio?: string | null;
    destinazione?: string | null;
    codiceArea?: string | null;
    couponID?: string | null;
    tipoOperazione?: string | null;
    importoPremioAss?: string | null;
    codiceFiscale?: string | null;
    dataCancellazione?: string | null;
    dataUltimoAggiornamento?: string | null;
}

export class PenaleServizio implements IPenaleServizio {
    nonRimborsabile?: boolean;
    dataLimite?: string | null;
    importo?: number | null;

    constructor(data?: IPenaleServizio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nonRimborsabile = _data["nonRimborsabile"] !== undefined ? _data["nonRimborsabile"] : null as any;
            this.dataLimite = _data["dataLimite"] !== undefined ? _data["dataLimite"] : null as any;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : null as any;
        }
    }

    static fromJS(data: any): PenaleServizio {
        data = typeof data === 'object' ? data : {};
        let result = new PenaleServizio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nonRimborsabile"] = this.nonRimborsabile !== undefined ? this.nonRimborsabile : null as any;
        data["dataLimite"] = this.dataLimite !== undefined ? this.dataLimite : null as any;
        data["importo"] = this.importo !== undefined ? this.importo : null as any;
        return data;
    }
}

export interface IPenaleServizio {
    nonRimborsabile?: boolean;
    dataLimite?: string | null;
    importo?: number | null;
}

export class TripServicePriceDetail implements ITripServicePriceDetail {
    descrizione?: string | null;
    costo?: number;
    prezzo?: number;
    prezzoValuta?: number;
    tipo?: ETipoAzioneDettaglio;

    constructor(data?: ITripServicePriceDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.costo = _data["costo"] !== undefined ? _data["costo"] : null as any;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : null as any;
            this.prezzoValuta = _data["prezzoValuta"] !== undefined ? _data["prezzoValuta"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
        }
    }

    static fromJS(data: any): TripServicePriceDetail {
        data = typeof data === 'object' ? data : {};
        let result = new TripServicePriceDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["costo"] = this.costo !== undefined ? this.costo : null as any;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : null as any;
        data["prezzoValuta"] = this.prezzoValuta !== undefined ? this.prezzoValuta : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        return data;
    }
}

export interface ITripServicePriceDetail {
    descrizione?: string | null;
    costo?: number;
    prezzo?: number;
    prezzoValuta?: number;
    tipo?: ETipoAzioneDettaglio;
}

export enum ETestoPenaleAgenzia {
    Nessuno = "Nessuno",
    NotaFornitore = "NotaFornitore",
    Articolo = "Articolo",
    NotaCustom = "NotaCustom",
    DatiAggiuntivi = "DatiAggiuntivi",
    PenaleH2H = "PenaleH2H",
}

export class TripServiceLocation implements ITripServiceLocation {
    contattoId?: number | null;
    /** Data e ora  */
    date?: string;
    /** Nome del luogo / contatto */
    nome?: string | null;
    /** Indirizzo */
    indirizzo?: string | null;
    /** Numero civico */
    numero?: string | null;
    /** Cap */
    cap?: string | null;
    /** Nome del luogo (in lingua) */
    luogo?: string | null;
    /** Ulteriori dettagli */
    dettagli?: string | null;

    constructor(data?: ITripServiceLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contattoId = _data["contattoId"] !== undefined ? _data["contattoId"] : null as any;
            this.date = _data["date"] !== undefined ? _data["date"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : null as any;
            this.numero = _data["numero"] !== undefined ? _data["numero"] : null as any;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.dettagli = _data["dettagli"] !== undefined ? _data["dettagli"] : null as any;
        }
    }

    static fromJS(data: any): TripServiceLocation {
        data = typeof data === 'object' ? data : {};
        let result = new TripServiceLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoId"] = this.contattoId !== undefined ? this.contattoId : null as any;
        data["date"] = this.date !== undefined ? this.date : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : null as any;
        data["numero"] = this.numero !== undefined ? this.numero : null as any;
        data["cap"] = this.cap !== undefined ? this.cap : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["dettagli"] = this.dettagli !== undefined ? this.dettagli : null as any;
        return data;
    }
}

export interface ITripServiceLocation {
    contattoId?: number | null;
    /** Data e ora  */
    date?: string;
    /** Nome del luogo / contatto */
    nome?: string | null;
    /** Indirizzo */
    indirizzo?: string | null;
    /** Numero civico */
    numero?: string | null;
    /** Cap */
    cap?: string | null;
    /** Nome del luogo (in lingua) */
    luogo?: string | null;
    /** Ulteriori dettagli */
    dettagli?: string | null;
}

export class TripRoom implements ITripRoom {
    abbinamento?: Abbinamento;
    clienti?: Cliente[];
    servizi?: TripService[];
    isTutti?: boolean;

    constructor(data?: ITripRoom) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.abbinamento = _data["abbinamento"] ? Abbinamento.fromJS(_data["abbinamento"]) : null as any;
            if (Array.isArray(_data["clienti"])) {
                this.clienti = [] as any;
                for (let item of _data["clienti"])
                    this.clienti!.push(Cliente.fromJS(item));
            }
            else {
                this.clienti = null as any;
            }
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(TripService.fromJS(item));
            }
            else {
                this.servizi = null as any;
            }
            this.isTutti = _data["isTutti"] !== undefined ? _data["isTutti"] : null as any;
        }
    }

    static fromJS(data: any): TripRoom {
        data = typeof data === 'object' ? data : {};
        let result = new TripRoom();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["abbinamento"] = this.abbinamento ? this.abbinamento.toJSON() : null as any;
        if (Array.isArray(this.clienti)) {
            data["clienti"] = [];
            for (let item of this.clienti)
                data["clienti"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item ? item.toJSON() : null as any);
        }
        data["isTutti"] = this.isTutti !== undefined ? this.isTutti : null as any;
        return data;
    }
}

export interface ITripRoom {
    abbinamento?: Abbinamento;
    clienti?: Cliente[];
    servizi?: TripService[];
    isTutti?: boolean;
}

export class Abbinamento implements IAbbinamento {
    abbinamentoID?: number;
    abbinamentoIdPrecedente?: number | null;
    offertaID?: number | null;
    sistemazioneID?: number | null;
    nome?: string | null;
    nomiClienti?: string | null;
    tutti?: boolean | null;
    cameraDoppia?: boolean;
    voloID?: number | null;

    constructor(data?: IAbbinamento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.abbinamentoID = _data["abbinamentoID"] !== undefined ? _data["abbinamentoID"] : null as any;
            this.abbinamentoIdPrecedente = _data["abbinamentoIdPrecedente"] !== undefined ? _data["abbinamentoIdPrecedente"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.sistemazioneID = _data["sistemazioneID"] !== undefined ? _data["sistemazioneID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nomiClienti = _data["nomiClienti"] !== undefined ? _data["nomiClienti"] : null as any;
            this.tutti = _data["tutti"] !== undefined ? _data["tutti"] : null as any;
            this.cameraDoppia = _data["cameraDoppia"] !== undefined ? _data["cameraDoppia"] : null as any;
            this.voloID = _data["voloID"] !== undefined ? _data["voloID"] : null as any;
        }
    }

    static fromJS(data: any): Abbinamento {
        data = typeof data === 'object' ? data : {};
        let result = new Abbinamento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["abbinamentoID"] = this.abbinamentoID !== undefined ? this.abbinamentoID : null as any;
        data["abbinamentoIdPrecedente"] = this.abbinamentoIdPrecedente !== undefined ? this.abbinamentoIdPrecedente : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["sistemazioneID"] = this.sistemazioneID !== undefined ? this.sistemazioneID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nomiClienti"] = this.nomiClienti !== undefined ? this.nomiClienti : null as any;
        data["tutti"] = this.tutti !== undefined ? this.tutti : null as any;
        data["cameraDoppia"] = this.cameraDoppia !== undefined ? this.cameraDoppia : null as any;
        data["voloID"] = this.voloID !== undefined ? this.voloID : null as any;
        return data;
    }
}

export interface IAbbinamento {
    abbinamentoID?: number;
    abbinamentoIdPrecedente?: number | null;
    offertaID?: number | null;
    sistemazioneID?: number | null;
    nome?: string | null;
    nomiClienti?: string | null;
    tutti?: boolean | null;
    cameraDoppia?: boolean;
    voloID?: number | null;
}

export class WarningOfferta implements IWarningOfferta {
    tipo?: ETipoWarningOfferta;
    impedisceConferma?: boolean;
    oggetto?: string | null;
    oggettoID?: number;
    daData?: string | null;
    aData?: string | null;

    constructor(data?: IWarningOfferta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.impedisceConferma = _data["impedisceConferma"] !== undefined ? _data["impedisceConferma"] : null as any;
            this.oggetto = _data["oggetto"] !== undefined ? _data["oggetto"] : null as any;
            this.oggettoID = _data["oggettoID"] !== undefined ? _data["oggettoID"] : null as any;
            this.daData = _data["daData"] !== undefined ? _data["daData"] : null as any;
            this.aData = _data["aData"] !== undefined ? _data["aData"] : null as any;
        }
    }

    static fromJS(data: any): WarningOfferta {
        data = typeof data === 'object' ? data : {};
        let result = new WarningOfferta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["impedisceConferma"] = this.impedisceConferma !== undefined ? this.impedisceConferma : null as any;
        data["oggetto"] = this.oggetto !== undefined ? this.oggetto : null as any;
        data["oggettoID"] = this.oggettoID !== undefined ? this.oggettoID : null as any;
        data["daData"] = this.daData !== undefined ? this.daData : null as any;
        data["aData"] = this.aData !== undefined ? this.aData : null as any;
        return data;
    }
}

export interface IWarningOfferta {
    tipo?: ETipoWarningOfferta;
    impedisceConferma?: boolean;
    oggetto?: string | null;
    oggettoID?: number;
    daData?: string | null;
    aData?: string | null;
}

export enum ETipoWarningOfferta {
    NessunCliente = "NessunCliente",
    NessunAbbinamento = "NessunAbbinamento",
    NessunItinerario = "NessunItinerario",
    NessunServizio = "NessunServizio",
    ItinerariSovrapposti = "ItinerariSovrapposti",
    ItinerariNonConsecutivi = "ItinerariNonConsecutivi",
    DatiClienteIncompleti = "DatiClienteIncompleti",
    CodiceFiscaleNonValido = "CodiceFiscaleNonValido",
    DataNascitaNonCoerente = "DataNascitaNonCoerente",
    CodiceFiscaleMancante = "CodiceFiscaleMancante",
    DataNascitaNonConfermata = "DataNascitaNonConfermata",
    VoloSenzaPNR = "VoloSenzaPNR",
}

export class TripFlights implements ITripFlights {
    flightPlan?: TripFlightSegment[];
    serviziVolo?: TripFlightService[];
    voli?: TripFlight[] | null;

    constructor(data?: ITripFlights) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["flightPlan"])) {
                this.flightPlan = [] as any;
                for (let item of _data["flightPlan"])
                    this.flightPlan!.push(TripFlightSegment.fromJS(item));
            }
            else {
                this.flightPlan = null as any;
            }
            if (Array.isArray(_data["serviziVolo"])) {
                this.serviziVolo = [] as any;
                for (let item of _data["serviziVolo"])
                    this.serviziVolo!.push(TripFlightService.fromJS(item));
            }
            else {
                this.serviziVolo = null as any;
            }
            if (Array.isArray(_data["voli"])) {
                this.voli = [] as any;
                for (let item of _data["voli"])
                    this.voli!.push(TripFlight.fromJS(item));
            }
            else {
                this.voli = null as any;
            }
        }
    }

    static fromJS(data: any): TripFlights {
        data = typeof data === 'object' ? data : {};
        let result = new TripFlights();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.flightPlan)) {
            data["flightPlan"] = [];
            for (let item of this.flightPlan)
                data["flightPlan"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.serviziVolo)) {
            data["serviziVolo"] = [];
            for (let item of this.serviziVolo)
                data["serviziVolo"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.voli)) {
            data["voli"] = [];
            for (let item of this.voli)
                data["voli"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ITripFlights {
    flightPlan?: TripFlightSegment[];
    serviziVolo?: TripFlightService[];
    voli?: TripFlight[] | null;
}

export class TripFlightSegment implements ITripFlightSegment {
    pnr?: string | null;
    tratta?: VoloTratta;
    soluzione?: string | null;
    arrivoIlGiornoDopo?: boolean;
    compagnia?: string | null;
    aeroportoPartenza?: string | null;
    aeroportoArrivo?: string | null;
    codiceArea?: string | null;
    stato?: StatoVolo | null;
    isPnr?: boolean;
    tariffeTratteRel?: VoloRel[];
    tariffe?: VoloTariffa[];
    codiceOperatedBy?: string | null;
    nomeOperatedBy?: string | null;
    isNdc?: boolean;

    constructor(data?: ITripFlightSegment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pnr = _data["pnr"] !== undefined ? _data["pnr"] : null as any;
            this.tratta = _data["tratta"] ? VoloTratta.fromJS(_data["tratta"]) : null as any;
            this.soluzione = _data["soluzione"] !== undefined ? _data["soluzione"] : null as any;
            this.arrivoIlGiornoDopo = _data["arrivoIlGiornoDopo"] !== undefined ? _data["arrivoIlGiornoDopo"] : null as any;
            this.compagnia = _data["compagnia"] !== undefined ? _data["compagnia"] : null as any;
            this.aeroportoPartenza = _data["aeroportoPartenza"] !== undefined ? _data["aeroportoPartenza"] : null as any;
            this.aeroportoArrivo = _data["aeroportoArrivo"] !== undefined ? _data["aeroportoArrivo"] : null as any;
            this.codiceArea = _data["codiceArea"] !== undefined ? _data["codiceArea"] : null as any;
            this.stato = _data["stato"] ? StatoVolo.fromJS(_data["stato"]) : null as any;
            this.isPnr = _data["isPnr"] !== undefined ? _data["isPnr"] : null as any;
            if (Array.isArray(_data["tariffeTratteRel"])) {
                this.tariffeTratteRel = [] as any;
                for (let item of _data["tariffeTratteRel"])
                    this.tariffeTratteRel!.push(VoloRel.fromJS(item));
            }
            else {
                this.tariffeTratteRel = null as any;
            }
            if (Array.isArray(_data["tariffe"])) {
                this.tariffe = [] as any;
                for (let item of _data["tariffe"])
                    this.tariffe!.push(VoloTariffa.fromJS(item));
            }
            else {
                this.tariffe = null as any;
            }
            this.codiceOperatedBy = _data["codiceOperatedBy"] !== undefined ? _data["codiceOperatedBy"] : null as any;
            this.nomeOperatedBy = _data["nomeOperatedBy"] !== undefined ? _data["nomeOperatedBy"] : null as any;
            this.isNdc = _data["isNdc"] !== undefined ? _data["isNdc"] : null as any;
        }
    }

    static fromJS(data: any): TripFlightSegment {
        data = typeof data === 'object' ? data : {};
        let result = new TripFlightSegment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pnr"] = this.pnr !== undefined ? this.pnr : null as any;
        data["tratta"] = this.tratta ? this.tratta.toJSON() : null as any;
        data["soluzione"] = this.soluzione !== undefined ? this.soluzione : null as any;
        data["arrivoIlGiornoDopo"] = this.arrivoIlGiornoDopo !== undefined ? this.arrivoIlGiornoDopo : null as any;
        data["compagnia"] = this.compagnia !== undefined ? this.compagnia : null as any;
        data["aeroportoPartenza"] = this.aeroportoPartenza !== undefined ? this.aeroportoPartenza : null as any;
        data["aeroportoArrivo"] = this.aeroportoArrivo !== undefined ? this.aeroportoArrivo : null as any;
        data["codiceArea"] = this.codiceArea !== undefined ? this.codiceArea : null as any;
        data["stato"] = this.stato ? this.stato.toJSON() : null as any;
        data["isPnr"] = this.isPnr !== undefined ? this.isPnr : null as any;
        if (Array.isArray(this.tariffeTratteRel)) {
            data["tariffeTratteRel"] = [];
            for (let item of this.tariffeTratteRel)
                data["tariffeTratteRel"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.tariffe)) {
            data["tariffe"] = [];
            for (let item of this.tariffe)
                data["tariffe"].push(item ? item.toJSON() : null as any);
        }
        data["codiceOperatedBy"] = this.codiceOperatedBy !== undefined ? this.codiceOperatedBy : null as any;
        data["nomeOperatedBy"] = this.nomeOperatedBy !== undefined ? this.nomeOperatedBy : null as any;
        data["isNdc"] = this.isNdc !== undefined ? this.isNdc : null as any;
        return data;
    }
}

export interface ITripFlightSegment {
    pnr?: string | null;
    tratta?: VoloTratta;
    soluzione?: string | null;
    arrivoIlGiornoDopo?: boolean;
    compagnia?: string | null;
    aeroportoPartenza?: string | null;
    aeroportoArrivo?: string | null;
    codiceArea?: string | null;
    stato?: StatoVolo | null;
    isPnr?: boolean;
    tariffeTratteRel?: VoloRel[];
    tariffe?: VoloTariffa[];
    codiceOperatedBy?: string | null;
    nomeOperatedBy?: string | null;
    isNdc?: boolean;
}

export class VoloTratta implements IVoloTratta {
    voloTrattaID?: number;
    voloID?: number;
    numeroVolo?: number | null;
    partenza?: string | null;
    arrivo?: string | null;
    daAeroportoCodice?: string | null;
    adAeroportoCodice?: string | null;
    codiceCompagnia?: string | null;
    codiceCompagniaOperating?: string | null;
    codiceStato?: string | null;
    posti?: number | null;
    classe?: string | null;
    durata?: string | null;
    technicalStopsJson?: string | null;
    technicalStops?: TechnicalStop[] | null;

    constructor(data?: IVoloTratta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voloTrattaID = _data["voloTrattaID"] !== undefined ? _data["voloTrattaID"] : null as any;
            this.voloID = _data["voloID"] !== undefined ? _data["voloID"] : null as any;
            this.numeroVolo = _data["numeroVolo"] !== undefined ? _data["numeroVolo"] : null as any;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : null as any;
            this.arrivo = _data["arrivo"] !== undefined ? _data["arrivo"] : null as any;
            this.daAeroportoCodice = _data["daAeroportoCodice"] !== undefined ? _data["daAeroportoCodice"] : null as any;
            this.adAeroportoCodice = _data["adAeroportoCodice"] !== undefined ? _data["adAeroportoCodice"] : null as any;
            this.codiceCompagnia = _data["codiceCompagnia"] !== undefined ? _data["codiceCompagnia"] : null as any;
            this.codiceCompagniaOperating = _data["codiceCompagniaOperating"] !== undefined ? _data["codiceCompagniaOperating"] : null as any;
            this.codiceStato = _data["codiceStato"] !== undefined ? _data["codiceStato"] : null as any;
            this.posti = _data["posti"] !== undefined ? _data["posti"] : null as any;
            this.classe = _data["classe"] !== undefined ? _data["classe"] : null as any;
            this.durata = _data["durata"] !== undefined ? _data["durata"] : null as any;
            this.technicalStopsJson = _data["technicalStopsJson"] !== undefined ? _data["technicalStopsJson"] : null as any;
            if (Array.isArray(_data["technicalStops"])) {
                this.technicalStops = [] as any;
                for (let item of _data["technicalStops"])
                    this.technicalStops!.push(TechnicalStop.fromJS(item));
            }
            else {
                this.technicalStops = null as any;
            }
        }
    }

    static fromJS(data: any): VoloTratta {
        data = typeof data === 'object' ? data : {};
        let result = new VoloTratta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voloTrattaID"] = this.voloTrattaID !== undefined ? this.voloTrattaID : null as any;
        data["voloID"] = this.voloID !== undefined ? this.voloID : null as any;
        data["numeroVolo"] = this.numeroVolo !== undefined ? this.numeroVolo : null as any;
        data["partenza"] = this.partenza !== undefined ? this.partenza : null as any;
        data["arrivo"] = this.arrivo !== undefined ? this.arrivo : null as any;
        data["daAeroportoCodice"] = this.daAeroportoCodice !== undefined ? this.daAeroportoCodice : null as any;
        data["adAeroportoCodice"] = this.adAeroportoCodice !== undefined ? this.adAeroportoCodice : null as any;
        data["codiceCompagnia"] = this.codiceCompagnia !== undefined ? this.codiceCompagnia : null as any;
        data["codiceCompagniaOperating"] = this.codiceCompagniaOperating !== undefined ? this.codiceCompagniaOperating : null as any;
        data["codiceStato"] = this.codiceStato !== undefined ? this.codiceStato : null as any;
        data["posti"] = this.posti !== undefined ? this.posti : null as any;
        data["classe"] = this.classe !== undefined ? this.classe : null as any;
        data["durata"] = this.durata !== undefined ? this.durata : null as any;
        data["technicalStopsJson"] = this.technicalStopsJson !== undefined ? this.technicalStopsJson : null as any;
        if (Array.isArray(this.technicalStops)) {
            data["technicalStops"] = [];
            for (let item of this.technicalStops)
                data["technicalStops"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IVoloTratta {
    voloTrattaID?: number;
    voloID?: number;
    numeroVolo?: number | null;
    partenza?: string | null;
    arrivo?: string | null;
    daAeroportoCodice?: string | null;
    adAeroportoCodice?: string | null;
    codiceCompagnia?: string | null;
    codiceCompagniaOperating?: string | null;
    codiceStato?: string | null;
    posti?: number | null;
    classe?: string | null;
    durata?: string | null;
    technicalStopsJson?: string | null;
    technicalStops?: TechnicalStop[] | null;
}

export class TechnicalStop implements ITechnicalStop {
    iataCode?: string | null;
    airportName?: string | null;
    duration?: string | null;

    constructor(data?: ITechnicalStop) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iataCode = _data["iataCode"] !== undefined ? _data["iataCode"] : null as any;
            this.airportName = _data["airportName"] !== undefined ? _data["airportName"] : null as any;
            this.duration = _data["duration"] !== undefined ? _data["duration"] : null as any;
        }
    }

    static fromJS(data: any): TechnicalStop {
        data = typeof data === 'object' ? data : {};
        let result = new TechnicalStop();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iataCode"] = this.iataCode !== undefined ? this.iataCode : null as any;
        data["airportName"] = this.airportName !== undefined ? this.airportName : null as any;
        data["duration"] = this.duration !== undefined ? this.duration : null as any;
        return data;
    }
}

export interface ITechnicalStop {
    iataCode?: string | null;
    airportName?: string | null;
    duration?: string | null;
}

export class VoloRel implements IVoloRel {
    voloRelID?: number;
    voloID?: number;
    voloTrattaID?: number;
    voloTariffaID?: number;
    fareBasis?: string | null;
    baggageIncluded?: number | null;
    cabin?: ETipoCabin | null;

    constructor(data?: IVoloRel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voloRelID = _data["voloRelID"] !== undefined ? _data["voloRelID"] : null as any;
            this.voloID = _data["voloID"] !== undefined ? _data["voloID"] : null as any;
            this.voloTrattaID = _data["voloTrattaID"] !== undefined ? _data["voloTrattaID"] : null as any;
            this.voloTariffaID = _data["voloTariffaID"] !== undefined ? _data["voloTariffaID"] : null as any;
            this.fareBasis = _data["fareBasis"] !== undefined ? _data["fareBasis"] : null as any;
            this.baggageIncluded = _data["baggageIncluded"] !== undefined ? _data["baggageIncluded"] : null as any;
            this.cabin = _data["cabin"] !== undefined ? _data["cabin"] : null as any;
        }
    }

    static fromJS(data: any): VoloRel {
        data = typeof data === 'object' ? data : {};
        let result = new VoloRel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voloRelID"] = this.voloRelID !== undefined ? this.voloRelID : null as any;
        data["voloID"] = this.voloID !== undefined ? this.voloID : null as any;
        data["voloTrattaID"] = this.voloTrattaID !== undefined ? this.voloTrattaID : null as any;
        data["voloTariffaID"] = this.voloTariffaID !== undefined ? this.voloTariffaID : null as any;
        data["fareBasis"] = this.fareBasis !== undefined ? this.fareBasis : null as any;
        data["baggageIncluded"] = this.baggageIncluded !== undefined ? this.baggageIncluded : null as any;
        data["cabin"] = this.cabin !== undefined ? this.cabin : null as any;
        return data;
    }
}

export interface IVoloRel {
    voloRelID?: number;
    voloID?: number;
    voloTrattaID?: number;
    voloTariffaID?: number;
    fareBasis?: string | null;
    baggageIncluded?: number | null;
    cabin?: ETipoCabin | null;
}

export enum ETipoCabin {
    Economy = "Economy",
    PremiumEconomy = "PremiumEconomy",
    Business = "Business",
    First = "First",
}

export class VoloTariffa implements IVoloTariffa {
    voloTariffaID?: number;
    voloID?: number | null;
    fareBasis?: string | null;
    idTariffaC?: number;
    tipoPaxID?: ETipoPax | null;
    tariffa?: number | null;
    tasse?: number | null;
    numeroPax?: number | null;
    costo?: number | null;
    costoTasse?: number | null;
    tariffaTO?: boolean;
    lastTicketDate?: string | null;
    baggageIncluded?: number | null;
    valutaID?: number | null;

    constructor(data?: IVoloTariffa) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voloTariffaID = _data["voloTariffaID"] !== undefined ? _data["voloTariffaID"] : null as any;
            this.voloID = _data["voloID"] !== undefined ? _data["voloID"] : null as any;
            this.fareBasis = _data["fareBasis"] !== undefined ? _data["fareBasis"] : null as any;
            this.idTariffaC = _data["idTariffaC"] !== undefined ? _data["idTariffaC"] : null as any;
            this.tipoPaxID = _data["tipoPaxID"] !== undefined ? _data["tipoPaxID"] : null as any;
            this.tariffa = _data["tariffa"] !== undefined ? _data["tariffa"] : null as any;
            this.tasse = _data["tasse"] !== undefined ? _data["tasse"] : null as any;
            this.numeroPax = _data["numeroPax"] !== undefined ? _data["numeroPax"] : null as any;
            this.costo = _data["costo"] !== undefined ? _data["costo"] : null as any;
            this.costoTasse = _data["costoTasse"] !== undefined ? _data["costoTasse"] : null as any;
            this.tariffaTO = _data["tariffaTO"] !== undefined ? _data["tariffaTO"] : null as any;
            this.lastTicketDate = _data["lastTicketDate"] !== undefined ? _data["lastTicketDate"] : null as any;
            this.baggageIncluded = _data["baggageIncluded"] !== undefined ? _data["baggageIncluded"] : null as any;
            this.valutaID = _data["valutaID"] !== undefined ? _data["valutaID"] : null as any;
        }
    }

    static fromJS(data: any): VoloTariffa {
        data = typeof data === 'object' ? data : {};
        let result = new VoloTariffa();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voloTariffaID"] = this.voloTariffaID !== undefined ? this.voloTariffaID : null as any;
        data["voloID"] = this.voloID !== undefined ? this.voloID : null as any;
        data["fareBasis"] = this.fareBasis !== undefined ? this.fareBasis : null as any;
        data["idTariffaC"] = this.idTariffaC !== undefined ? this.idTariffaC : null as any;
        data["tipoPaxID"] = this.tipoPaxID !== undefined ? this.tipoPaxID : null as any;
        data["tariffa"] = this.tariffa !== undefined ? this.tariffa : null as any;
        data["tasse"] = this.tasse !== undefined ? this.tasse : null as any;
        data["numeroPax"] = this.numeroPax !== undefined ? this.numeroPax : null as any;
        data["costo"] = this.costo !== undefined ? this.costo : null as any;
        data["costoTasse"] = this.costoTasse !== undefined ? this.costoTasse : null as any;
        data["tariffaTO"] = this.tariffaTO !== undefined ? this.tariffaTO : null as any;
        data["lastTicketDate"] = this.lastTicketDate !== undefined ? this.lastTicketDate : null as any;
        data["baggageIncluded"] = this.baggageIncluded !== undefined ? this.baggageIncluded : null as any;
        data["valutaID"] = this.valutaID !== undefined ? this.valutaID : null as any;
        return data;
    }
}

export interface IVoloTariffa {
    voloTariffaID?: number;
    voloID?: number | null;
    fareBasis?: string | null;
    idTariffaC?: number;
    tipoPaxID?: ETipoPax | null;
    tariffa?: number | null;
    tasse?: number | null;
    numeroPax?: number | null;
    costo?: number | null;
    costoTasse?: number | null;
    tariffaTO?: boolean;
    lastTicketDate?: string | null;
    baggageIncluded?: number | null;
    valutaID?: number | null;
}

export enum ETipoPax {
    Sconosciuto = "Sconosciuto",
    Adulto = "Adulto",
    Child = "Child",
    Infant = "Infant",
}

export class TripFlightService extends TripService implements ITripFlightService {
    nome?: string | null;
    isTasseVolo?: boolean;
    daPrendereInCaricoTkt?: boolean;
    okContabTkt?: boolean;
    inCaricoTkt?: boolean;
    emessoTkt?: boolean;

    constructor(data?: ITripFlightService) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.isTasseVolo = _data["isTasseVolo"] !== undefined ? _data["isTasseVolo"] : null as any;
            this.daPrendereInCaricoTkt = _data["daPrendereInCaricoTkt"] !== undefined ? _data["daPrendereInCaricoTkt"] : null as any;
            this.okContabTkt = _data["okContabTkt"] !== undefined ? _data["okContabTkt"] : null as any;
            this.inCaricoTkt = _data["inCaricoTkt"] !== undefined ? _data["inCaricoTkt"] : null as any;
            this.emessoTkt = _data["emessoTkt"] !== undefined ? _data["emessoTkt"] : null as any;
        }
    }

    static override fromJS(data: any): TripFlightService {
        data = typeof data === 'object' ? data : {};
        let result = new TripFlightService();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["isTasseVolo"] = this.isTasseVolo !== undefined ? this.isTasseVolo : null as any;
        data["daPrendereInCaricoTkt"] = this.daPrendereInCaricoTkt !== undefined ? this.daPrendereInCaricoTkt : null as any;
        data["okContabTkt"] = this.okContabTkt !== undefined ? this.okContabTkt : null as any;
        data["inCaricoTkt"] = this.inCaricoTkt !== undefined ? this.inCaricoTkt : null as any;
        data["emessoTkt"] = this.emessoTkt !== undefined ? this.emessoTkt : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITripFlightService extends ITripService {
    nome?: string | null;
    isTasseVolo?: boolean;
    daPrendereInCaricoTkt?: boolean;
    okContabTkt?: boolean;
    inCaricoTkt?: boolean;
    emessoTkt?: boolean;
}

export class TripFlight implements ITripFlight {
    volo?: Volo;
    fornitore?: string | null;
    tratte?: VoloTratta[];
    tariffe?: TripFlightFare[];
    note?: VoloNota[];
    relazioni?: VoloRel[];
    camera?: string | null;
    isPnr?: boolean;
    /** Se true vanno aggiornati i dati dei pax sul PNR */
    verificaPax?: boolean;

    constructor(data?: ITripFlight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.volo = _data["volo"] ? Volo.fromJS(_data["volo"]) : null as any;
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : null as any;
            if (Array.isArray(_data["tratte"])) {
                this.tratte = [] as any;
                for (let item of _data["tratte"])
                    this.tratte!.push(VoloTratta.fromJS(item));
            }
            else {
                this.tratte = null as any;
            }
            if (Array.isArray(_data["tariffe"])) {
                this.tariffe = [] as any;
                for (let item of _data["tariffe"])
                    this.tariffe!.push(TripFlightFare.fromJS(item));
            }
            else {
                this.tariffe = null as any;
            }
            if (Array.isArray(_data["note"])) {
                this.note = [] as any;
                for (let item of _data["note"])
                    this.note!.push(VoloNota.fromJS(item));
            }
            else {
                this.note = null as any;
            }
            if (Array.isArray(_data["relazioni"])) {
                this.relazioni = [] as any;
                for (let item of _data["relazioni"])
                    this.relazioni!.push(VoloRel.fromJS(item));
            }
            else {
                this.relazioni = null as any;
            }
            this.camera = _data["camera"] !== undefined ? _data["camera"] : null as any;
            this.isPnr = _data["isPnr"] !== undefined ? _data["isPnr"] : null as any;
            this.verificaPax = _data["verificaPax"] !== undefined ? _data["verificaPax"] : null as any;
        }
    }

    static fromJS(data: any): TripFlight {
        data = typeof data === 'object' ? data : {};
        let result = new TripFlight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["volo"] = this.volo ? this.volo.toJSON() : null as any;
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : null as any;
        if (Array.isArray(this.tratte)) {
            data["tratte"] = [];
            for (let item of this.tratte)
                data["tratte"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.tariffe)) {
            data["tariffe"] = [];
            for (let item of this.tariffe)
                data["tariffe"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.note)) {
            data["note"] = [];
            for (let item of this.note)
                data["note"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.relazioni)) {
            data["relazioni"] = [];
            for (let item of this.relazioni)
                data["relazioni"].push(item ? item.toJSON() : null as any);
        }
        data["camera"] = this.camera !== undefined ? this.camera : null as any;
        data["isPnr"] = this.isPnr !== undefined ? this.isPnr : null as any;
        data["verificaPax"] = this.verificaPax !== undefined ? this.verificaPax : null as any;
        return data;
    }
}

export interface ITripFlight {
    volo?: Volo;
    fornitore?: string | null;
    tratte?: VoloTratta[];
    tariffe?: TripFlightFare[];
    note?: VoloNota[];
    relazioni?: VoloRel[];
    camera?: string | null;
    isPnr?: boolean;
    /** Se true vanno aggiornati i dati dei pax sul PNR */
    verificaPax?: boolean;
}

export class Volo implements IVolo {
    voloID?: number;
    offertaID?: number | null;
    utenteID?: number | null;
    abbinamentoID?: number | null;
    offertaDatoID?: number | null;
    riga?: OffertaDato | null;
    pnr?: string | null;
    paxRef?: string | null;
    status?: EStatoVolo | null;
    dataSalvataggio?: string | null;
    dataPartenza?: string | null;
    dataCancellazioneAuto?: string | null;
    supplierID?: number | null;
    verificare?: boolean;

    constructor(data?: IVolo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voloID = _data["voloID"] !== undefined ? _data["voloID"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.utenteID = _data["utenteID"] !== undefined ? _data["utenteID"] : null as any;
            this.abbinamentoID = _data["abbinamentoID"] !== undefined ? _data["abbinamentoID"] : null as any;
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : null as any;
            this.riga = _data["riga"] ? OffertaDato.fromJS(_data["riga"]) : null as any;
            this.pnr = _data["pnr"] !== undefined ? _data["pnr"] : null as any;
            this.paxRef = _data["paxRef"] !== undefined ? _data["paxRef"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.dataSalvataggio = _data["dataSalvataggio"] !== undefined ? _data["dataSalvataggio"] : null as any;
            this.dataPartenza = _data["dataPartenza"] !== undefined ? _data["dataPartenza"] : null as any;
            this.dataCancellazioneAuto = _data["dataCancellazioneAuto"] !== undefined ? _data["dataCancellazioneAuto"] : null as any;
            this.supplierID = _data["supplierID"] !== undefined ? _data["supplierID"] : null as any;
            this.verificare = _data["verificare"] !== undefined ? _data["verificare"] : null as any;
        }
    }

    static fromJS(data: any): Volo {
        data = typeof data === 'object' ? data : {};
        let result = new Volo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voloID"] = this.voloID !== undefined ? this.voloID : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["utenteID"] = this.utenteID !== undefined ? this.utenteID : null as any;
        data["abbinamentoID"] = this.abbinamentoID !== undefined ? this.abbinamentoID : null as any;
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : null as any;
        data["riga"] = this.riga ? this.riga.toJSON() : null as any;
        data["pnr"] = this.pnr !== undefined ? this.pnr : null as any;
        data["paxRef"] = this.paxRef !== undefined ? this.paxRef : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["dataSalvataggio"] = this.dataSalvataggio !== undefined ? this.dataSalvataggio : null as any;
        data["dataPartenza"] = this.dataPartenza !== undefined ? this.dataPartenza : null as any;
        data["dataCancellazioneAuto"] = this.dataCancellazioneAuto !== undefined ? this.dataCancellazioneAuto : null as any;
        data["supplierID"] = this.supplierID !== undefined ? this.supplierID : null as any;
        data["verificare"] = this.verificare !== undefined ? this.verificare : null as any;
        return data;
    }
}

export interface IVolo {
    voloID?: number;
    offertaID?: number | null;
    utenteID?: number | null;
    abbinamentoID?: number | null;
    offertaDatoID?: number | null;
    riga?: OffertaDato | null;
    pnr?: string | null;
    paxRef?: string | null;
    status?: EStatoVolo | null;
    dataSalvataggio?: string | null;
    dataPartenza?: string | null;
    dataCancellazioneAuto?: string | null;
    supplierID?: number | null;
    verificare?: boolean;
}

export enum EStatoVolo {
    Attivo = "Attivo",
    Cancellato = "Cancellato",
    InEmissione = "InEmissione",
    Emesso = "Emesso",
    Monitorato = "Monitorato",
}

export class TripFlightFare implements ITripFlightFare {
    tariffa?: VoloTariffa;
    tratte?: VoloTratta[];
    relazioni?: VoloRel[];

    constructor(data?: ITripFlightFare) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tariffa = _data["tariffa"] ? VoloTariffa.fromJS(_data["tariffa"]) : null as any;
            if (Array.isArray(_data["tratte"])) {
                this.tratte = [] as any;
                for (let item of _data["tratte"])
                    this.tratte!.push(VoloTratta.fromJS(item));
            }
            else {
                this.tratte = null as any;
            }
            if (Array.isArray(_data["relazioni"])) {
                this.relazioni = [] as any;
                for (let item of _data["relazioni"])
                    this.relazioni!.push(VoloRel.fromJS(item));
            }
            else {
                this.relazioni = null as any;
            }
        }
    }

    static fromJS(data: any): TripFlightFare {
        data = typeof data === 'object' ? data : {};
        let result = new TripFlightFare();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tariffa"] = this.tariffa ? this.tariffa.toJSON() : null as any;
        if (Array.isArray(this.tratte)) {
            data["tratte"] = [];
            for (let item of this.tratte)
                data["tratte"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.relazioni)) {
            data["relazioni"] = [];
            for (let item of this.relazioni)
                data["relazioni"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ITripFlightFare {
    tariffa?: VoloTariffa;
    tratte?: VoloTratta[];
    relazioni?: VoloRel[];
}

export class VoloNota implements IVoloNota {
    voloNotaID?: number;
    voloID?: number;
    tipoID?: number | null;
    tipoMemo?: string | null;
    testo?: string | null;
    data?: string | null;

    constructor(data?: IVoloNota) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voloNotaID = _data["voloNotaID"] !== undefined ? _data["voloNotaID"] : null as any;
            this.voloID = _data["voloID"] !== undefined ? _data["voloID"] : null as any;
            this.tipoID = _data["tipoID"] !== undefined ? _data["tipoID"] : null as any;
            this.tipoMemo = _data["tipoMemo"] !== undefined ? _data["tipoMemo"] : null as any;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
        }
    }

    static fromJS(data: any): VoloNota {
        data = typeof data === 'object' ? data : {};
        let result = new VoloNota();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voloNotaID"] = this.voloNotaID !== undefined ? this.voloNotaID : null as any;
        data["voloID"] = this.voloID !== undefined ? this.voloID : null as any;
        data["tipoID"] = this.tipoID !== undefined ? this.tipoID : null as any;
        data["tipoMemo"] = this.tipoMemo !== undefined ? this.tipoMemo : null as any;
        data["testo"] = this.testo !== undefined ? this.testo : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        return data;
    }
}

export interface IVoloNota {
    voloNotaID?: number;
    voloID?: number;
    tipoID?: number | null;
    tipoMemo?: string | null;
    testo?: string | null;
    data?: string | null;
}

export class TripStep implements ITripStep {
    itinerario?: OffertaItinerario;
    luogo?: string | null;
    dal?: string | null;
    al?: string | null;
    servizioCollegato?: string | null;
    tipologiaCollegata?: string | null;
    sovrapposto?: boolean;
    giorniMancantiAlPrecedente?: number;
    hotelStatus?: ETripStepHotelStatus;
    servizi?: TripService[];
    consentiRicercaHotel?: boolean;
    consentiRicercaTour?: boolean;
    consentiRicercaSelfdrive?: boolean;
    consentiRicercaTrasferimenti?: boolean;
    consentiRicercaVisite?: boolean;
    consentiRicercaVoli?: boolean;
    consentiRicercaNoleggi?: boolean;

    constructor(data?: ITripStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itinerario = _data["itinerario"] ? OffertaItinerario.fromJS(_data["itinerario"]) : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.al = _data["al"] !== undefined ? _data["al"] : null as any;
            this.servizioCollegato = _data["servizioCollegato"] !== undefined ? _data["servizioCollegato"] : null as any;
            this.tipologiaCollegata = _data["tipologiaCollegata"] !== undefined ? _data["tipologiaCollegata"] : null as any;
            this.sovrapposto = _data["sovrapposto"] !== undefined ? _data["sovrapposto"] : null as any;
            this.giorniMancantiAlPrecedente = _data["giorniMancantiAlPrecedente"] !== undefined ? _data["giorniMancantiAlPrecedente"] : null as any;
            this.hotelStatus = _data["hotelStatus"] !== undefined ? _data["hotelStatus"] : null as any;
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(TripService.fromJS(item));
            }
            else {
                this.servizi = null as any;
            }
            this.consentiRicercaHotel = _data["consentiRicercaHotel"] !== undefined ? _data["consentiRicercaHotel"] : null as any;
            this.consentiRicercaTour = _data["consentiRicercaTour"] !== undefined ? _data["consentiRicercaTour"] : null as any;
            this.consentiRicercaSelfdrive = _data["consentiRicercaSelfdrive"] !== undefined ? _data["consentiRicercaSelfdrive"] : null as any;
            this.consentiRicercaTrasferimenti = _data["consentiRicercaTrasferimenti"] !== undefined ? _data["consentiRicercaTrasferimenti"] : null as any;
            this.consentiRicercaVisite = _data["consentiRicercaVisite"] !== undefined ? _data["consentiRicercaVisite"] : null as any;
            this.consentiRicercaVoli = _data["consentiRicercaVoli"] !== undefined ? _data["consentiRicercaVoli"] : null as any;
            this.consentiRicercaNoleggi = _data["consentiRicercaNoleggi"] !== undefined ? _data["consentiRicercaNoleggi"] : null as any;
        }
    }

    static fromJS(data: any): TripStep {
        data = typeof data === 'object' ? data : {};
        let result = new TripStep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itinerario"] = this.itinerario ? this.itinerario.toJSON() : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["al"] = this.al !== undefined ? this.al : null as any;
        data["servizioCollegato"] = this.servizioCollegato !== undefined ? this.servizioCollegato : null as any;
        data["tipologiaCollegata"] = this.tipologiaCollegata !== undefined ? this.tipologiaCollegata : null as any;
        data["sovrapposto"] = this.sovrapposto !== undefined ? this.sovrapposto : null as any;
        data["giorniMancantiAlPrecedente"] = this.giorniMancantiAlPrecedente !== undefined ? this.giorniMancantiAlPrecedente : null as any;
        data["hotelStatus"] = this.hotelStatus !== undefined ? this.hotelStatus : null as any;
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item ? item.toJSON() : null as any);
        }
        data["consentiRicercaHotel"] = this.consentiRicercaHotel !== undefined ? this.consentiRicercaHotel : null as any;
        data["consentiRicercaTour"] = this.consentiRicercaTour !== undefined ? this.consentiRicercaTour : null as any;
        data["consentiRicercaSelfdrive"] = this.consentiRicercaSelfdrive !== undefined ? this.consentiRicercaSelfdrive : null as any;
        data["consentiRicercaTrasferimenti"] = this.consentiRicercaTrasferimenti !== undefined ? this.consentiRicercaTrasferimenti : null as any;
        data["consentiRicercaVisite"] = this.consentiRicercaVisite !== undefined ? this.consentiRicercaVisite : null as any;
        data["consentiRicercaVoli"] = this.consentiRicercaVoli !== undefined ? this.consentiRicercaVoli : null as any;
        data["consentiRicercaNoleggi"] = this.consentiRicercaNoleggi !== undefined ? this.consentiRicercaNoleggi : null as any;
        return data;
    }
}

export interface ITripStep {
    itinerario?: OffertaItinerario;
    luogo?: string | null;
    dal?: string | null;
    al?: string | null;
    servizioCollegato?: string | null;
    tipologiaCollegata?: string | null;
    sovrapposto?: boolean;
    giorniMancantiAlPrecedente?: number;
    hotelStatus?: ETripStepHotelStatus;
    servizi?: TripService[];
    consentiRicercaHotel?: boolean;
    consentiRicercaTour?: boolean;
    consentiRicercaSelfdrive?: boolean;
    consentiRicercaTrasferimenti?: boolean;
    consentiRicercaVisite?: boolean;
    consentiRicercaVoli?: boolean;
    consentiRicercaNoleggi?: boolean;
}

export class OffertaItinerario implements IOffertaItinerario {
    itinerarioID?: number;
    offertaID?: number;
    luogoID?: number;
    giorno?: number | null;
    notti?: number | null;
    ordine?: number | null;
    tipo?: ETipoTappa | null;
    servizioTipologiaTourID?: number | null;
    tipoTrasporto?: ETipoTrasporto | null;
    autofillOperation?: EAutofillOperation;
    autofillStrategy?: EAutofillStrategy;
    autofillMinStars?: EAutofillMinStars;
    autofillFlags?: EAutofillFlags;
    airport?: string | null;
    offset?: number;
    servizioHotelID?: number | null;
    airportDeparture?: string | null;

    constructor(data?: IOffertaItinerario) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itinerarioID = _data["itinerarioID"] !== undefined ? _data["itinerarioID"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : null as any;
            this.notti = _data["notti"] !== undefined ? _data["notti"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.servizioTipologiaTourID = _data["servizioTipologiaTourID"] !== undefined ? _data["servizioTipologiaTourID"] : null as any;
            this.tipoTrasporto = _data["tipoTrasporto"] !== undefined ? _data["tipoTrasporto"] : null as any;
            this.autofillOperation = _data["autofillOperation"] !== undefined ? _data["autofillOperation"] : null as any;
            this.autofillStrategy = _data["autofillStrategy"] !== undefined ? _data["autofillStrategy"] : null as any;
            this.autofillMinStars = _data["autofillMinStars"] !== undefined ? _data["autofillMinStars"] : null as any;
            this.autofillFlags = _data["autofillFlags"] !== undefined ? _data["autofillFlags"] : null as any;
            this.airport = _data["airport"] !== undefined ? _data["airport"] : null as any;
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.servizioHotelID = _data["servizioHotelID"] !== undefined ? _data["servizioHotelID"] : null as any;
            this.airportDeparture = _data["airportDeparture"] !== undefined ? _data["airportDeparture"] : null as any;
        }
    }

    static fromJS(data: any): OffertaItinerario {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaItinerario();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itinerarioID"] = this.itinerarioID !== undefined ? this.itinerarioID : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["giorno"] = this.giorno !== undefined ? this.giorno : null as any;
        data["notti"] = this.notti !== undefined ? this.notti : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["servizioTipologiaTourID"] = this.servizioTipologiaTourID !== undefined ? this.servizioTipologiaTourID : null as any;
        data["tipoTrasporto"] = this.tipoTrasporto !== undefined ? this.tipoTrasporto : null as any;
        data["autofillOperation"] = this.autofillOperation !== undefined ? this.autofillOperation : null as any;
        data["autofillStrategy"] = this.autofillStrategy !== undefined ? this.autofillStrategy : null as any;
        data["autofillMinStars"] = this.autofillMinStars !== undefined ? this.autofillMinStars : null as any;
        data["autofillFlags"] = this.autofillFlags !== undefined ? this.autofillFlags : null as any;
        data["airport"] = this.airport !== undefined ? this.airport : null as any;
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["servizioHotelID"] = this.servizioHotelID !== undefined ? this.servizioHotelID : null as any;
        data["airportDeparture"] = this.airportDeparture !== undefined ? this.airportDeparture : null as any;
        return data;
    }
}

export interface IOffertaItinerario {
    itinerarioID?: number;
    offertaID?: number;
    luogoID?: number;
    giorno?: number | null;
    notti?: number | null;
    ordine?: number | null;
    tipo?: ETipoTappa | null;
    servizioTipologiaTourID?: number | null;
    tipoTrasporto?: ETipoTrasporto | null;
    autofillOperation?: EAutofillOperation;
    autofillStrategy?: EAutofillStrategy;
    autofillMinStars?: EAutofillMinStars;
    autofillFlags?: EAutofillFlags;
    airport?: string | null;
    offset?: number;
    servizioHotelID?: number | null;
    airportDeparture?: string | null;
}

export enum ETipoTappa {
    Normale = "Normale",
    Accessori = "Accessori",
    SoggiornoLibero = "SoggiornoLibero",
    InVolo = "InVolo",
    InizioViaggio = "InizioViaggio",
    TermineViaggio = "TermineViaggio",
    ItinerarioTour = "ItinerarioTour",
    ItinerarioSelfdrive = "ItinerarioSelfdrive",
    ItinerarioPacchetto = "ItinerarioPacchetto",
}

export enum EAutofillOperation {
    None = "None",
    Hotel = "Hotel",
    HotelAndPrivateTransfert = "HotelAndPrivateTransfert",
    HotelAndGroupTransfert = "HotelAndGroupTransfert",
    HotelAndPrivateCityViewTransfert = "HotelAndPrivateCityViewTransfert",
    HotelAndGroupCityViewTransfert = "HotelAndGroupCityViewTransfert",
}

export enum EAutofillStrategy {
    MostEconomic = "MostEconomic",
    HightestRating = "HightestRating",
}

export enum EAutofillMinStars {
    None = "None",
    Stars3 = "Stars3",
    Stars4 = "Stars4",
    Stars5 = "Stars5",
    Stars2 = "Stars2",
}

export enum EAutofillFlags {
    None = "None",
    IncludeOnRequestHotels = "IncludeOnRequestHotels",
    IncludeInstantPayHotels = "IncludeInstantPayHotels",
    IncludeNotRefundableHotels = "IncludeNotRefundableHotels",
    IncludeAirportHotels = "IncludeAirportHotels",
    IncludeOnRequestHotelsOrIncludeAirportHotels = "IncludeOnRequestHotelsOrIncludeAirportHotels",
    ExcludeFlightSearch = "ExcludeFlightSearch",
}

export enum ETripStepHotelStatus {
    Mancante = "Mancante",
    Parziale = "Parziale",
    Ok = "Ok",
}

export class TripAgreementCost implements ITripAgreementCost {
    accordoID?: number;
    accordo?: string | null;
    abbinamentoID?: number | null;
    abbinamento?: string | null;
    valuta?: string | null;
    costo?: number;
    prezzo?: number;

    constructor(data?: ITripAgreementCost) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.accordo = _data["accordo"] !== undefined ? _data["accordo"] : null as any;
            this.abbinamentoID = _data["abbinamentoID"] !== undefined ? _data["abbinamentoID"] : null as any;
            this.abbinamento = _data["abbinamento"] !== undefined ? _data["abbinamento"] : null as any;
            this.valuta = _data["valuta"] !== undefined ? _data["valuta"] : null as any;
            this.costo = _data["costo"] !== undefined ? _data["costo"] : null as any;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : null as any;
        }
    }

    static fromJS(data: any): TripAgreementCost {
        data = typeof data === 'object' ? data : {};
        let result = new TripAgreementCost();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["accordo"] = this.accordo !== undefined ? this.accordo : null as any;
        data["abbinamentoID"] = this.abbinamentoID !== undefined ? this.abbinamentoID : null as any;
        data["abbinamento"] = this.abbinamento !== undefined ? this.abbinamento : null as any;
        data["valuta"] = this.valuta !== undefined ? this.valuta : null as any;
        data["costo"] = this.costo !== undefined ? this.costo : null as any;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : null as any;
        return data;
    }
}

export interface ITripAgreementCost {
    accordoID?: number;
    accordo?: string | null;
    abbinamentoID?: number | null;
    abbinamento?: string | null;
    valuta?: string | null;
    costo?: number;
    prezzo?: number;
}

export class TripInvoicesListRow implements ITripInvoicesListRow {
    /** Invoice Id */
    id?: number;
    /** Invoice date */
    date?: string;
    /** Type of invoice */
    type?: ETipoDocumento;
    /** Invoice description */
    description?: string | null;

    constructor(data?: ITripInvoicesListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.date = _data["date"] !== undefined ? _data["date"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
        }
    }

    static fromJS(data: any): TripInvoicesListRow {
        data = typeof data === 'object' ? data : {};
        let result = new TripInvoicesListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["date"] = this.date !== undefined ? this.date : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        return data;
    }
}

export interface ITripInvoicesListRow {
    /** Invoice Id */
    id?: number;
    /** Invoice date */
    date?: string;
    /** Type of invoice */
    type?: ETipoDocumento;
    /** Invoice description */
    description?: string | null;
}

export class TripDocument implements ITripDocument {
    /** ID del documento */
    id?: number;
    /** Entità del documento */
    documento?: Documento;
    /** Per i documenti condivisi è la url PRIVATA del documento.
Per i link Email è la url su Outlook.com */
    urlPrivato?: string | null;
    /** Url per la visualizzazione pubblica */
    urlPubblico?: string | null;
    /** Nome del documento */
    nome?: string | null;
    /** Nome del file collegato */
    nomeAllegato?: string | null;
    /** Nome del contatto */
    nomeContatto?: string | null;
    /** Content type dell'allegato */
    contentType?: string | null;
    /** Dimensione del file allegato */
    dimensioneAllegato?: number | null;
    /** Se true il documento è un link Email */
    isEmailLink?: boolean;
    /** Se true è possiible visualizzare l'anteprima */
    anteprimaVisibile?: boolean;
    /** Se true la stampa è visualizzabile */
    stampaVisibile?: boolean;
    /** Se true il documento può essere cancellato */
    eliminabile?: boolean;
    /** Se true esiste un editor per il documento */
    editabile?: boolean;
    /** Se true può usare l'editor a frasi */
    editabileFrasi?: boolean;
    /** Se true è possibioe duplicare la riga */
    duplicabile?: boolean;
    /** Se true il documento accetta la stampa multipla */
    stampaMulti?: boolean;
    /** Se true il documento può essere usato per la conversione multipla in PDF */
    pdfMulti?: boolean;
    /** True se il documento è convertibile in PDF */
    convertibilePdf?: boolean;
    /** True se il documento è inviabile per mail */
    inviabile?: boolean;
    /** Lista degli ID dei documenti extra (Post) */
    extraDocIDs?: number[];

    constructor(data?: ITripDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.documento = _data["documento"] ? Documento.fromJS(_data["documento"]) : null as any;
            this.urlPrivato = _data["urlPrivato"] !== undefined ? _data["urlPrivato"] : null as any;
            this.urlPubblico = _data["urlPubblico"] !== undefined ? _data["urlPubblico"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nomeAllegato = _data["nomeAllegato"] !== undefined ? _data["nomeAllegato"] : null as any;
            this.nomeContatto = _data["nomeContatto"] !== undefined ? _data["nomeContatto"] : null as any;
            this.contentType = _data["contentType"] !== undefined ? _data["contentType"] : null as any;
            this.dimensioneAllegato = _data["dimensioneAllegato"] !== undefined ? _data["dimensioneAllegato"] : null as any;
            this.isEmailLink = _data["isEmailLink"] !== undefined ? _data["isEmailLink"] : null as any;
            this.anteprimaVisibile = _data["anteprimaVisibile"] !== undefined ? _data["anteprimaVisibile"] : null as any;
            this.stampaVisibile = _data["stampaVisibile"] !== undefined ? _data["stampaVisibile"] : null as any;
            this.eliminabile = _data["eliminabile"] !== undefined ? _data["eliminabile"] : null as any;
            this.editabile = _data["editabile"] !== undefined ? _data["editabile"] : null as any;
            this.editabileFrasi = _data["editabileFrasi"] !== undefined ? _data["editabileFrasi"] : null as any;
            this.duplicabile = _data["duplicabile"] !== undefined ? _data["duplicabile"] : null as any;
            this.stampaMulti = _data["stampaMulti"] !== undefined ? _data["stampaMulti"] : null as any;
            this.pdfMulti = _data["pdfMulti"] !== undefined ? _data["pdfMulti"] : null as any;
            this.convertibilePdf = _data["convertibilePdf"] !== undefined ? _data["convertibilePdf"] : null as any;
            this.inviabile = _data["inviabile"] !== undefined ? _data["inviabile"] : null as any;
            if (Array.isArray(_data["extraDocIDs"])) {
                this.extraDocIDs = [] as any;
                for (let item of _data["extraDocIDs"])
                    this.extraDocIDs!.push(item);
            }
            else {
                this.extraDocIDs = null as any;
            }
        }
    }

    static fromJS(data: any): TripDocument {
        data = typeof data === 'object' ? data : {};
        let result = new TripDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["documento"] = this.documento ? this.documento.toJSON() : null as any;
        data["urlPrivato"] = this.urlPrivato !== undefined ? this.urlPrivato : null as any;
        data["urlPubblico"] = this.urlPubblico !== undefined ? this.urlPubblico : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nomeAllegato"] = this.nomeAllegato !== undefined ? this.nomeAllegato : null as any;
        data["nomeContatto"] = this.nomeContatto !== undefined ? this.nomeContatto : null as any;
        data["contentType"] = this.contentType !== undefined ? this.contentType : null as any;
        data["dimensioneAllegato"] = this.dimensioneAllegato !== undefined ? this.dimensioneAllegato : null as any;
        data["isEmailLink"] = this.isEmailLink !== undefined ? this.isEmailLink : null as any;
        data["anteprimaVisibile"] = this.anteprimaVisibile !== undefined ? this.anteprimaVisibile : null as any;
        data["stampaVisibile"] = this.stampaVisibile !== undefined ? this.stampaVisibile : null as any;
        data["eliminabile"] = this.eliminabile !== undefined ? this.eliminabile : null as any;
        data["editabile"] = this.editabile !== undefined ? this.editabile : null as any;
        data["editabileFrasi"] = this.editabileFrasi !== undefined ? this.editabileFrasi : null as any;
        data["duplicabile"] = this.duplicabile !== undefined ? this.duplicabile : null as any;
        data["stampaMulti"] = this.stampaMulti !== undefined ? this.stampaMulti : null as any;
        data["pdfMulti"] = this.pdfMulti !== undefined ? this.pdfMulti : null as any;
        data["convertibilePdf"] = this.convertibilePdf !== undefined ? this.convertibilePdf : null as any;
        data["inviabile"] = this.inviabile !== undefined ? this.inviabile : null as any;
        if (Array.isArray(this.extraDocIDs)) {
            data["extraDocIDs"] = [];
            for (let item of this.extraDocIDs)
                data["extraDocIDs"].push(item);
        }
        return data;
    }
}

export interface ITripDocument {
    /** ID del documento */
    id?: number;
    /** Entità del documento */
    documento?: Documento;
    /** Per i documenti condivisi è la url PRIVATA del documento.
Per i link Email è la url su Outlook.com */
    urlPrivato?: string | null;
    /** Url per la visualizzazione pubblica */
    urlPubblico?: string | null;
    /** Nome del documento */
    nome?: string | null;
    /** Nome del file collegato */
    nomeAllegato?: string | null;
    /** Nome del contatto */
    nomeContatto?: string | null;
    /** Content type dell'allegato */
    contentType?: string | null;
    /** Dimensione del file allegato */
    dimensioneAllegato?: number | null;
    /** Se true il documento è un link Email */
    isEmailLink?: boolean;
    /** Se true è possiible visualizzare l'anteprima */
    anteprimaVisibile?: boolean;
    /** Se true la stampa è visualizzabile */
    stampaVisibile?: boolean;
    /** Se true il documento può essere cancellato */
    eliminabile?: boolean;
    /** Se true esiste un editor per il documento */
    editabile?: boolean;
    /** Se true può usare l'editor a frasi */
    editabileFrasi?: boolean;
    /** Se true è possibioe duplicare la riga */
    duplicabile?: boolean;
    /** Se true il documento accetta la stampa multipla */
    stampaMulti?: boolean;
    /** Se true il documento può essere usato per la conversione multipla in PDF */
    pdfMulti?: boolean;
    /** True se il documento è convertibile in PDF */
    convertibilePdf?: boolean;
    /** True se il documento è inviabile per mail */
    inviabile?: boolean;
    /** Lista degli ID dei documenti extra (Post) */
    extraDocIDs?: number[];
}

export class Documento implements IDocumento {
    documentoID?: number;
    offertaID?: number;
    contattoID?: number | null;
    tipoDocumento?: ETipoDocumento;
    testata?: string | null;
    corpo?: string | null;
    corpo2?: string | null;
    data?: string | null;
    userID?: number | null;
    spedito?: string | null;
    contatoreSpedizioni?: number | null;
    rootID?: number;
    opzioni?: string | null;
    storage?: EStorage;

    constructor(data?: IDocumento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.tipoDocumento = _data["tipoDocumento"] !== undefined ? _data["tipoDocumento"] : null as any;
            this.testata = _data["testata"] !== undefined ? _data["testata"] : null as any;
            this.corpo = _data["corpo"] !== undefined ? _data["corpo"] : null as any;
            this.corpo2 = _data["corpo2"] !== undefined ? _data["corpo2"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
            this.userID = _data["userID"] !== undefined ? _data["userID"] : null as any;
            this.spedito = _data["spedito"] !== undefined ? _data["spedito"] : null as any;
            this.contatoreSpedizioni = _data["contatoreSpedizioni"] !== undefined ? _data["contatoreSpedizioni"] : null as any;
            this.rootID = _data["rootID"] !== undefined ? _data["rootID"] : null as any;
            this.opzioni = _data["opzioni"] !== undefined ? _data["opzioni"] : null as any;
            this.storage = _data["storage"] !== undefined ? _data["storage"] : null as any;
        }
    }

    static fromJS(data: any): Documento {
        data = typeof data === 'object' ? data : {};
        let result = new Documento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["tipoDocumento"] = this.tipoDocumento !== undefined ? this.tipoDocumento : null as any;
        data["testata"] = this.testata !== undefined ? this.testata : null as any;
        data["corpo"] = this.corpo !== undefined ? this.corpo : null as any;
        data["corpo2"] = this.corpo2 !== undefined ? this.corpo2 : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["userID"] = this.userID !== undefined ? this.userID : null as any;
        data["spedito"] = this.spedito !== undefined ? this.spedito : null as any;
        data["contatoreSpedizioni"] = this.contatoreSpedizioni !== undefined ? this.contatoreSpedizioni : null as any;
        data["rootID"] = this.rootID !== undefined ? this.rootID : null as any;
        data["opzioni"] = this.opzioni !== undefined ? this.opzioni : null as any;
        data["storage"] = this.storage !== undefined ? this.storage : null as any;
        return data;
    }
}

export interface IDocumento {
    documentoID?: number;
    offertaID?: number;
    contattoID?: number | null;
    tipoDocumento?: ETipoDocumento;
    testata?: string | null;
    corpo?: string | null;
    corpo2?: string | null;
    data?: string | null;
    userID?: number | null;
    spedito?: string | null;
    contatoreSpedizioni?: number | null;
    rootID?: number;
    opzioni?: string | null;
    storage?: EStorage;
}

export enum EStorage {
    Unknown = "Unknown",
    SharedFilesystem = "SharedFilesystem",
    AzureMedia = "AzureMedia",
    Database = "Database",
}

export class TripVoucher implements ITripVoucher {
    nr?: string;
    voucher?: Voucher;
    servizio?: string;
    isNozze?: boolean;

    constructor(data?: ITripVoucher) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nr = _data["nr"] !== undefined ? _data["nr"] : null as any;
            this.voucher = _data["voucher"] ? Voucher.fromJS(_data["voucher"]) : null as any;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : null as any;
            this.isNozze = _data["isNozze"] !== undefined ? _data["isNozze"] : null as any;
        }
    }

    static fromJS(data: any): TripVoucher {
        data = typeof data === 'object' ? data : {};
        let result = new TripVoucher();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nr"] = this.nr !== undefined ? this.nr : null as any;
        data["voucher"] = this.voucher ? this.voucher.toJSON() : null as any;
        data["servizio"] = this.servizio !== undefined ? this.servizio : null as any;
        data["isNozze"] = this.isNozze !== undefined ? this.isNozze : null as any;
        return data;
    }
}

export interface ITripVoucher {
    nr?: string;
    voucher?: Voucher;
    servizio?: string;
    isNozze?: boolean;
}

export class Voucher implements IVoucher {
    voucherID?: number;
    offertaID?: number | null;
    ordine?: number | null;
    testata?: string | null;
    bookingRef?: string | null;
    clienti?: string | null;
    descrizioneServizio?: string | null;
    periodo?: string | null;
    dettaglio?: string | null;
    istruzioni?: string | null;
    servizioID?: number | null;
    lingua?: ELingua | null;
    versione?: number;

    constructor(data?: IVoucher) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voucherID = _data["voucherID"] !== undefined ? _data["voucherID"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.testata = _data["testata"] !== undefined ? _data["testata"] : null as any;
            this.bookingRef = _data["bookingRef"] !== undefined ? _data["bookingRef"] : null as any;
            this.clienti = _data["clienti"] !== undefined ? _data["clienti"] : null as any;
            this.descrizioneServizio = _data["descrizioneServizio"] !== undefined ? _data["descrizioneServizio"] : null as any;
            this.periodo = _data["periodo"] !== undefined ? _data["periodo"] : null as any;
            this.dettaglio = _data["dettaglio"] !== undefined ? _data["dettaglio"] : null as any;
            this.istruzioni = _data["istruzioni"] !== undefined ? _data["istruzioni"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : null as any;
            this.versione = _data["versione"] !== undefined ? _data["versione"] : null as any;
        }
    }

    static fromJS(data: any): Voucher {
        data = typeof data === 'object' ? data : {};
        let result = new Voucher();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherID"] = this.voucherID !== undefined ? this.voucherID : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["testata"] = this.testata !== undefined ? this.testata : null as any;
        data["bookingRef"] = this.bookingRef !== undefined ? this.bookingRef : null as any;
        data["clienti"] = this.clienti !== undefined ? this.clienti : null as any;
        data["descrizioneServizio"] = this.descrizioneServizio !== undefined ? this.descrizioneServizio : null as any;
        data["periodo"] = this.periodo !== undefined ? this.periodo : null as any;
        data["dettaglio"] = this.dettaglio !== undefined ? this.dettaglio : null as any;
        data["istruzioni"] = this.istruzioni !== undefined ? this.istruzioni : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["lingua"] = this.lingua !== undefined ? this.lingua : null as any;
        data["versione"] = this.versione !== undefined ? this.versione : null as any;
        return data;
    }
}

export interface IVoucher {
    voucherID?: number;
    offertaID?: number | null;
    ordine?: number | null;
    testata?: string | null;
    bookingRef?: string | null;
    clienti?: string | null;
    descrizioneServizio?: string | null;
    periodo?: string | null;
    dettaglio?: string | null;
    istruzioni?: string | null;
    servizioID?: number | null;
    lingua?: ELingua | null;
    versione?: number;
}

export class TripEmail implements ITripEmail {
    id?: number;
    from?: string;
    to?: string;
    cc?: string;
    bcc?: string;
    attachments?: TripEmailAttachment[];
    email?: EmailQueue;

    constructor(data?: ITripEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.from = _data["from"] !== undefined ? _data["from"] : null as any;
            this.to = _data["to"] !== undefined ? _data["to"] : null as any;
            this.cc = _data["cc"] !== undefined ? _data["cc"] : null as any;
            this.bcc = _data["bcc"] !== undefined ? _data["bcc"] : null as any;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(TripEmailAttachment.fromJS(item));
            }
            else {
                this.attachments = null as any;
            }
            this.email = _data["email"] ? EmailQueue.fromJS(_data["email"]) : null as any;
        }
    }

    static fromJS(data: any): TripEmail {
        data = typeof data === 'object' ? data : {};
        let result = new TripEmail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["from"] = this.from !== undefined ? this.from : null as any;
        data["to"] = this.to !== undefined ? this.to : null as any;
        data["cc"] = this.cc !== undefined ? this.cc : null as any;
        data["bcc"] = this.bcc !== undefined ? this.bcc : null as any;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : null as any);
        }
        data["email"] = this.email ? this.email.toJSON() : null as any;
        return data;
    }
}

export interface ITripEmail {
    id?: number;
    from?: string;
    to?: string;
    cc?: string;
    bcc?: string;
    attachments?: TripEmailAttachment[];
    email?: EmailQueue;
}

export class TripEmailAttachment implements ITripEmailAttachment {
    id?: number;
    name?: string;

    constructor(data?: ITripEmailAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): TripEmailAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new TripEmailAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export interface ITripEmailAttachment {
    id?: number;
    name?: string;
}

export class EmailQueue implements IEmailQueue {
    id?: number;
    category?: EEmailCategory;
    senderUserID?: number | null;
    offertaID?: number | null;
    offertaDatoID?: number | null;
    fromAddress!: string;
    fromName?: string | null;
    subject!: string;
    bodyText!: string;
    isHtmlBoby?: boolean;
    requestNotify?: boolean;
    highPriority?: boolean;
    status?: EEmailStatus;
    statusText?: string | null;
    creationDate?: string;
    requestedSendDate?: string;
    processedDate?: string | null;
    headers?: string | null;

    constructor(data?: IEmailQueue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.senderUserID = _data["senderUserID"] !== undefined ? _data["senderUserID"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : null as any;
            this.fromAddress = _data["fromAddress"] !== undefined ? _data["fromAddress"] : null as any;
            this.fromName = _data["fromName"] !== undefined ? _data["fromName"] : null as any;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : null as any;
            this.bodyText = _data["bodyText"] !== undefined ? _data["bodyText"] : null as any;
            this.isHtmlBoby = _data["isHtmlBoby"] !== undefined ? _data["isHtmlBoby"] : null as any;
            this.requestNotify = _data["requestNotify"] !== undefined ? _data["requestNotify"] : null as any;
            this.highPriority = _data["highPriority"] !== undefined ? _data["highPriority"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.statusText = _data["statusText"] !== undefined ? _data["statusText"] : null as any;
            this.creationDate = _data["creationDate"] !== undefined ? _data["creationDate"] : null as any;
            this.requestedSendDate = _data["requestedSendDate"] !== undefined ? _data["requestedSendDate"] : null as any;
            this.processedDate = _data["processedDate"] !== undefined ? _data["processedDate"] : null as any;
            this.headers = _data["headers"] !== undefined ? _data["headers"] : null as any;
        }
    }

    static fromJS(data: any): EmailQueue {
        data = typeof data === 'object' ? data : {};
        let result = new EmailQueue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["senderUserID"] = this.senderUserID !== undefined ? this.senderUserID : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : null as any;
        data["fromAddress"] = this.fromAddress !== undefined ? this.fromAddress : null as any;
        data["fromName"] = this.fromName !== undefined ? this.fromName : null as any;
        data["subject"] = this.subject !== undefined ? this.subject : null as any;
        data["bodyText"] = this.bodyText !== undefined ? this.bodyText : null as any;
        data["isHtmlBoby"] = this.isHtmlBoby !== undefined ? this.isHtmlBoby : null as any;
        data["requestNotify"] = this.requestNotify !== undefined ? this.requestNotify : null as any;
        data["highPriority"] = this.highPriority !== undefined ? this.highPriority : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["statusText"] = this.statusText !== undefined ? this.statusText : null as any;
        data["creationDate"] = this.creationDate !== undefined ? this.creationDate : null as any;
        data["requestedSendDate"] = this.requestedSendDate !== undefined ? this.requestedSendDate : null as any;
        data["processedDate"] = this.processedDate !== undefined ? this.processedDate : null as any;
        data["headers"] = this.headers !== undefined ? this.headers : null as any;
        return data;
    }
}

export interface IEmailQueue {
    id?: number;
    category?: EEmailCategory;
    senderUserID?: number | null;
    offertaID?: number | null;
    offertaDatoID?: number | null;
    fromAddress: string;
    fromName?: string | null;
    subject: string;
    bodyText: string;
    isHtmlBoby?: boolean;
    requestNotify?: boolean;
    highPriority?: boolean;
    status?: EEmailStatus;
    statusText?: string | null;
    creationDate?: string;
    requestedSendDate?: string;
    processedDate?: string | null;
    headers?: string | null;
}

export enum EEmailCategory {
    Accounting = "Accounting",
    Booking = "Booking",
    Documenti = "Documenti",
    DocumentiContabili = "DocumentiContabili",
    AreaAgenzie = "AreaAgenzie",
    InvioCliente = "InvioCliente",
    Assicurazioni = "Assicurazioni",
    Report = "Report",
}

export enum EEmailStatus {
    Queued = "Queued",
    Sent = "Sent",
    Error = "Error",
    Canceled = "Canceled",
}

export class TripAttachedDocCategory implements ITripAttachedDocCategory {
    nome?: string | null;
    documenti?: TripAttachedDoc[];

    constructor(data?: ITripAttachedDocCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            if (Array.isArray(_data["documenti"])) {
                this.documenti = [] as any;
                for (let item of _data["documenti"])
                    this.documenti!.push(TripAttachedDoc.fromJS(item));
            }
            else {
                this.documenti = null as any;
            }
        }
    }

    static fromJS(data: any): TripAttachedDocCategory {
        data = typeof data === 'object' ? data : {};
        let result = new TripAttachedDocCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        if (Array.isArray(this.documenti)) {
            data["documenti"] = [];
            for (let item of this.documenti)
                data["documenti"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ITripAttachedDocCategory {
    nome?: string | null;
    documenti?: TripAttachedDoc[];
}

export class TripAttachedDoc implements ITripAttachedDoc {
    id?: number;
    nome?: string | null;
    selezionato?: boolean;
    allegato?: string | null;
    dimensioni?: number | null;
    url?: string | null;
    ordine?: number;

    constructor(data?: ITripAttachedDoc) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.selezionato = _data["selezionato"] !== undefined ? _data["selezionato"] : null as any;
            this.allegato = _data["allegato"] !== undefined ? _data["allegato"] : null as any;
            this.dimensioni = _data["dimensioni"] !== undefined ? _data["dimensioni"] : null as any;
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
        }
    }

    static fromJS(data: any): TripAttachedDoc {
        data = typeof data === 'object' ? data : {};
        let result = new TripAttachedDoc();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["selezionato"] = this.selezionato !== undefined ? this.selezionato : null as any;
        data["allegato"] = this.allegato !== undefined ? this.allegato : null as any;
        data["dimensioni"] = this.dimensioni !== undefined ? this.dimensioni : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        return data;
    }
}

export interface ITripAttachedDoc {
    id?: number;
    nome?: string | null;
    selezionato?: boolean;
    allegato?: string | null;
    dimensioni?: number | null;
    url?: string | null;
    ordine?: number;
}

export class TripAgencyDocuments implements ITripAgencyDocuments {
    offerta?: TripDocument | null;
    preventivoCliente?: TripDocument | null;
    preventivoClientePlus?: TripDocument | null;
    conferma?: TripDocument | null;
    estrattoConto?: TripDocument | null;
    programma?: TripDocument | null;
    documentiOnline?: TripDocument[] | null;
    documentiAllegati?: TripDocument[] | null;
    consentiStampaVoucher?: boolean;
    consentiStampaFatture?: boolean;
    confermaProvvisoria?: TripDocument | null;
    confermaCliente?: TripDocument | null;

    constructor(data?: ITripAgencyDocuments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offerta = _data["offerta"] ? TripDocument.fromJS(_data["offerta"]) : null as any;
            this.preventivoCliente = _data["preventivoCliente"] ? TripDocument.fromJS(_data["preventivoCliente"]) : null as any;
            this.preventivoClientePlus = _data["preventivoClientePlus"] ? TripDocument.fromJS(_data["preventivoClientePlus"]) : null as any;
            this.conferma = _data["conferma"] ? TripDocument.fromJS(_data["conferma"]) : null as any;
            this.estrattoConto = _data["estrattoConto"] ? TripDocument.fromJS(_data["estrattoConto"]) : null as any;
            this.programma = _data["programma"] ? TripDocument.fromJS(_data["programma"]) : null as any;
            if (Array.isArray(_data["documentiOnline"])) {
                this.documentiOnline = [] as any;
                for (let item of _data["documentiOnline"])
                    this.documentiOnline!.push(TripDocument.fromJS(item));
            }
            else {
                this.documentiOnline = null as any;
            }
            if (Array.isArray(_data["documentiAllegati"])) {
                this.documentiAllegati = [] as any;
                for (let item of _data["documentiAllegati"])
                    this.documentiAllegati!.push(TripDocument.fromJS(item));
            }
            else {
                this.documentiAllegati = null as any;
            }
            this.consentiStampaVoucher = _data["consentiStampaVoucher"] !== undefined ? _data["consentiStampaVoucher"] : null as any;
            this.consentiStampaFatture = _data["consentiStampaFatture"] !== undefined ? _data["consentiStampaFatture"] : null as any;
            this.confermaProvvisoria = _data["confermaProvvisoria"] ? TripDocument.fromJS(_data["confermaProvvisoria"]) : null as any;
            this.confermaCliente = _data["confermaCliente"] ? TripDocument.fromJS(_data["confermaCliente"]) : null as any;
        }
    }

    static fromJS(data: any): TripAgencyDocuments {
        data = typeof data === 'object' ? data : {};
        let result = new TripAgencyDocuments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offerta"] = this.offerta ? this.offerta.toJSON() : null as any;
        data["preventivoCliente"] = this.preventivoCliente ? this.preventivoCliente.toJSON() : null as any;
        data["preventivoClientePlus"] = this.preventivoClientePlus ? this.preventivoClientePlus.toJSON() : null as any;
        data["conferma"] = this.conferma ? this.conferma.toJSON() : null as any;
        data["estrattoConto"] = this.estrattoConto ? this.estrattoConto.toJSON() : null as any;
        data["programma"] = this.programma ? this.programma.toJSON() : null as any;
        if (Array.isArray(this.documentiOnline)) {
            data["documentiOnline"] = [];
            for (let item of this.documentiOnline)
                data["documentiOnline"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.documentiAllegati)) {
            data["documentiAllegati"] = [];
            for (let item of this.documentiAllegati)
                data["documentiAllegati"].push(item ? item.toJSON() : null as any);
        }
        data["consentiStampaVoucher"] = this.consentiStampaVoucher !== undefined ? this.consentiStampaVoucher : null as any;
        data["consentiStampaFatture"] = this.consentiStampaFatture !== undefined ? this.consentiStampaFatture : null as any;
        data["confermaProvvisoria"] = this.confermaProvvisoria ? this.confermaProvvisoria.toJSON() : null as any;
        data["confermaCliente"] = this.confermaCliente ? this.confermaCliente.toJSON() : null as any;
        return data;
    }
}

export interface ITripAgencyDocuments {
    offerta?: TripDocument | null;
    preventivoCliente?: TripDocument | null;
    preventivoClientePlus?: TripDocument | null;
    conferma?: TripDocument | null;
    estrattoConto?: TripDocument | null;
    programma?: TripDocument | null;
    documentiOnline?: TripDocument[] | null;
    documentiAllegati?: TripDocument[] | null;
    consentiStampaVoucher?: boolean;
    consentiStampaFatture?: boolean;
    confermaProvvisoria?: TripDocument | null;
    confermaCliente?: TripDocument | null;
}

export enum EServizioAutomatico {
    Nessuno = "Nessuno",
    RinunciaWeCareYouSmile = "RinunciaWeCareYouSmile",
    SpeseMediche100K = "SpeseMediche100K",
    SpeseMediche300K = "SpeseMediche300K",
    SpeseMediche500K = "SpeseMediche500K",
    SpeseMediche1M = "SpeseMediche1M",
    WeCareYouSmilePlus = "WeCareYouSmilePlus",
    MedicoBagaglioBase = "MedicoBagaglioBase",
    QuoteNaar = "QuoteNaar",
    QuoteOnline = "QuoteOnline",
    UpgradeQuoteOnline = "UpgradeQuoteOnline",
    RinunciaBloccaPrezzo = "RinunciaBloccaPrezzo",
    DirittiAgenzia = "DirittiAgenzia",
    DirittiAgenziaSuBiglietteria = "DirittiAgenziaSuBiglietteria",
    QuoteOnlineFrance = "QuoteOnlineFrance",
    QuoteNaarFrance = "QuoteNaarFrance",
    PolizzaFr1 = "PolizzaFr1",
    PolizzaFr2 = "PolizzaFr2",
    PolizzaFr3 = "PolizzaFr3",
    CostiCancellazione = "CostiCancellazione",
    QuoteOnlineBenelux = "QuoteOnlineBenelux",
    QuoteNaarBenelux = "QuoteNaarBenelux",
    QuoteOnlineGermany = "QuoteOnlineGermany",
    QuoteNaarGermany = "QuoteNaarGermany",
    QuoteOnlineSalaun = "QuoteOnlineSalaun",
    QuoteNaarSalaun = "QuoteNaarSalaun",
    QuoteOnlineSwiss = "QuoteOnlineSwiss",
    QuoteNaarSwiss = "QuoteNaarSwiss",
    PeaceOfMind = "PeaceOfMind",
    EuropAssistanceOpzionale = "EuropAssistanceOpzionale",
    EuropAssistance300K = "EuropAssistance300K",
    EuropAssistance500K = "EuropAssistance500K",
    EuropAssistanceIllimitato = "EuropAssistanceIllimitato",
    RinunciaPeaceOfMind = "RinunciaPeaceOfMind",
}

/** Ultimo stato di sincronizzazione della pratica verso i gestionali esterni. */
export class TripSyncStatus implements ITripSyncStatus {
    /** Gestionale che ha prodotto questo stato. */
    provider?: ETripSyncProviders;
    /** Istante del tentativo, già convertito nel fuso applicativo (a database è UTC). */
    startedAt?: string;
    /** Esito del tentativo: Success significa allineato. */
    outcome?: ETripSyncOutcome;
    /** Descrizione dell'errore, quando il tentativo non è riuscito. Valorizzata solo per gli utenti
interni: contiene dettagli di configurazione e identificativi tecnici che non vanno esposti alle
agenzie. */
    errorMessage?: string | null;

    constructor(data?: ITripSyncStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.provider = _data["provider"] !== undefined ? _data["provider"] : null as any;
            this.startedAt = _data["startedAt"] !== undefined ? _data["startedAt"] : null as any;
            this.outcome = _data["outcome"] !== undefined ? _data["outcome"] : null as any;
            this.errorMessage = _data["errorMessage"] !== undefined ? _data["errorMessage"] : null as any;
        }
    }

    static fromJS(data: any): TripSyncStatus {
        data = typeof data === 'object' ? data : {};
        let result = new TripSyncStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provider"] = this.provider !== undefined ? this.provider : null as any;
        data["startedAt"] = this.startedAt !== undefined ? this.startedAt : null as any;
        data["outcome"] = this.outcome !== undefined ? this.outcome : null as any;
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : null as any;
        return data;
    }
}

/** Ultimo stato di sincronizzazione della pratica verso i gestionali esterni. */
export interface ITripSyncStatus {
    /** Gestionale che ha prodotto questo stato. */
    provider?: ETripSyncProviders;
    /** Istante del tentativo, già convertito nel fuso applicativo (a database è UTC). */
    startedAt?: string;
    /** Esito del tentativo: Success significa allineato. */
    outcome?: ETripSyncOutcome;
    /** Descrizione dell'errore, quando il tentativo non è riuscito. Valorizzata solo per gli utenti
interni: contiene dettagli di configurazione e identificativi tecnici che non vanno esposti alle
agenzie. */
    errorMessage?: string | null;
}

export enum ETripSyncProviders {
    Bosys = "Bosys",
    Midoco = "Midoco",
    PaxConnect = "PaxConnect",
    Welcome = "Welcome",
}

export enum ETripSyncOutcome {
    Success = "Success",
    HttpError = "HttpError",
    ValidationError = "ValidationError",
    ConfigError = "ConfigError",
    NotChanged = "NotChanged",
}

export class TripGetRequest extends SiteRequest implements ITripGetRequest {
    /** ID dell'offerta di riferimento */
    offertaID!: number;
    resetPriceDispo?: boolean;

    constructor(data?: ITripGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.resetPriceDispo = _data["resetPriceDispo"] !== undefined ? _data["resetPriceDispo"] : null as any;
        }
    }

    static override fromJS(data: any): TripGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TripGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["resetPriceDispo"] = this.resetPriceDispo !== undefined ? this.resetPriceDispo : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITripGetRequest extends ISiteRequest {
    /** ID dell'offerta di riferimento */
    offertaID: number;
    resetPriceDispo?: boolean;
}

export class ConvertTraducibileRequest extends TripGetRequest implements IConvertTraducibileRequest {
    documentoID?: number;

    constructor(data?: IConvertTraducibileRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : null as any;
        }
    }

    static override fromJS(data: any): ConvertTraducibileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConvertTraducibileRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IConvertTraducibileRequest extends ITripGetRequest {
    documentoID?: number;
}

/** Riposta alla stampa: tutta l'offerta + l'id del documento creato */
export class DocumentPrintResponse extends TripGetResponse implements IDocumentPrintResponse {
    /** ID del documento che è stato creato */
    documentoID?: number;

    constructor(data?: IDocumentPrintResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : null as any;
        }
    }

    static override fromJS(data: any): DocumentPrintResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentPrintResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Riposta alla stampa: tutta l'offerta + l'id del documento creato */
export interface IDocumentPrintResponse extends ITripGetResponse {
    /** ID del documento che è stato creato */
    documentoID?: number;
}

/** Richiesta di stampa di un documento per un'offerta */
export class DocumentPrintRequest extends TripGetRequest implements IDocumentPrintRequest {
    /** Tipo di documento da stampare */
    tipoDocumento!: ETipoDocumento;
    /** ID del documento che verrà convertito */
    documentoID?: number | null;
    /** Stringa con le tuple [id_ordine] separate da virgola delle miniguide da usare nel documento */
    extraDocs?: string;

    constructor(data?: IDocumentPrintRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tipoDocumento = _data["tipoDocumento"] !== undefined ? _data["tipoDocumento"] : null as any;
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : null as any;
            this.extraDocs = _data["extraDocs"] !== undefined ? _data["extraDocs"] : null as any;
        }
    }

    static override fromJS(data: any): DocumentPrintRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentPrintRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoDocumento"] = this.tipoDocumento !== undefined ? this.tipoDocumento : null as any;
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : null as any;
        data["extraDocs"] = this.extraDocs !== undefined ? this.extraDocs : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Richiesta di stampa di un documento per un'offerta */
export interface IDocumentPrintRequest extends ITripGetRequest {
    /** Tipo di documento da stampare */
    tipoDocumento: ETipoDocumento;
    /** ID del documento che verrà convertito */
    documentoID?: number | null;
    /** Stringa con le tuple [id_ordine] separate da virgola delle miniguide da usare nel documento */
    extraDocs?: string;
}

export class CreateReservationDocumentResponse extends TripGetResponse implements ICreateReservationDocumentResponse {

    constructor(data?: ICreateReservationDocumentResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CreateReservationDocumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReservationDocumentResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreateReservationDocumentResponse extends ITripGetResponse {
}

export class CreateReservationDocumentRequest extends TripGetRequest implements ICreateReservationDocumentRequest {
    /** Underscore separated string: "contactID_currencyID" */
    contactAndCurrency!: string[];

    constructor(data?: ICreateReservationDocumentRequest) {
        super(data);
        if (!data) {
            this.contactAndCurrency = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["contactAndCurrency"])) {
                this.contactAndCurrency = [] as any;
                for (let item of _data["contactAndCurrency"])
                    this.contactAndCurrency!.push(item);
            }
            else {
                this.contactAndCurrency = null as any;
            }
        }
    }

    static override fromJS(data: any): CreateReservationDocumentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReservationDocumentRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contactAndCurrency)) {
            data["contactAndCurrency"] = [];
            for (let item of this.contactAndCurrency)
                data["contactAndCurrency"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICreateReservationDocumentRequest extends ITripGetRequest {
    /** Underscore separated string: "contactID_currencyID" */
    contactAndCurrency: string[];
}

export class EditDocumentResponse extends OkApiResponse implements IEditDocumentResponse {
    /** Contenuto HTML del documento */
    content?: string;
    /** Link completo del CSS del documento */
    cssUrl?: string | null;
    /** Titolo del documento */
    title?: string | null;
    /** Link alla favicon */
    favIconUrl?: string | null;
    /** Lista dei css "extra" */
    extraCssUrls?: string[] | null;

    constructor(data?: IEditDocumentResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.content = _data["content"] !== undefined ? _data["content"] : null as any;
            this.cssUrl = _data["cssUrl"] !== undefined ? _data["cssUrl"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.favIconUrl = _data["favIconUrl"] !== undefined ? _data["favIconUrl"] : null as any;
            if (Array.isArray(_data["extraCssUrls"])) {
                this.extraCssUrls = [] as any;
                for (let item of _data["extraCssUrls"])
                    this.extraCssUrls!.push(item);
            }
            else {
                this.extraCssUrls = null as any;
            }
        }
    }

    static override fromJS(data: any): EditDocumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditDocumentResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content !== undefined ? this.content : null as any;
        data["cssUrl"] = this.cssUrl !== undefined ? this.cssUrl : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["favIconUrl"] = this.favIconUrl !== undefined ? this.favIconUrl : null as any;
        if (Array.isArray(this.extraCssUrls)) {
            data["extraCssUrls"] = [];
            for (let item of this.extraCssUrls)
                data["extraCssUrls"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IEditDocumentResponse extends IOkApiResponse {
    /** Contenuto HTML del documento */
    content?: string;
    /** Link completo del CSS del documento */
    cssUrl?: string | null;
    /** Titolo del documento */
    title?: string | null;
    /** Link alla favicon */
    favIconUrl?: string | null;
    /** Lista dei css "extra" */
    extraCssUrls?: string[] | null;
}

export class EditDocumentRequest extends LocalizedRequest implements IEditDocumentRequest {
    /** ID del documento da editare */
    documentoID?: number;

    constructor(data?: IEditDocumentRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : null as any;
        }
    }

    static override fromJS(data: any): EditDocumentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditDocumentRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IEditDocumentRequest extends ILocalizedRequest {
    /** ID del documento da editare */
    documentoID?: number;
}

export class GetDocumentoFrasiResponse extends OkApiResponse implements IGetDocumentoFrasiResponse {
    contatti?: IdValore[];
    accordi?: IdValore[];
    servizi?: IdValore[];
    luoghi?: IdValore[];
    sezioni?: SezioneView[];

    constructor(data?: IGetDocumentoFrasiResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["contatti"])) {
                this.contatti = [] as any;
                for (let item of _data["contatti"])
                    this.contatti!.push(IdValore.fromJS(item));
            }
            else {
                this.contatti = null as any;
            }
            if (Array.isArray(_data["accordi"])) {
                this.accordi = [] as any;
                for (let item of _data["accordi"])
                    this.accordi!.push(IdValore.fromJS(item));
            }
            else {
                this.accordi = null as any;
            }
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(IdValore.fromJS(item));
            }
            else {
                this.servizi = null as any;
            }
            if (Array.isArray(_data["luoghi"])) {
                this.luoghi = [] as any;
                for (let item of _data["luoghi"])
                    this.luoghi!.push(IdValore.fromJS(item));
            }
            else {
                this.luoghi = null as any;
            }
            if (Array.isArray(_data["sezioni"])) {
                this.sezioni = [] as any;
                for (let item of _data["sezioni"])
                    this.sezioni!.push(SezioneView.fromJS(item));
            }
            else {
                this.sezioni = null as any;
            }
        }
    }

    static override fromJS(data: any): GetDocumentoFrasiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentoFrasiResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contatti)) {
            data["contatti"] = [];
            for (let item of this.contatti)
                data["contatti"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.accordi)) {
            data["accordi"] = [];
            for (let item of this.accordi)
                data["accordi"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.luoghi)) {
            data["luoghi"] = [];
            for (let item of this.luoghi)
                data["luoghi"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.sezioni)) {
            data["sezioni"] = [];
            for (let item of this.sezioni)
                data["sezioni"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetDocumentoFrasiResponse extends IOkApiResponse {
    contatti?: IdValore[];
    accordi?: IdValore[];
    servizi?: IdValore[];
    luoghi?: IdValore[];
    sezioni?: SezioneView[];
}

export class SezioneView implements ISezioneView {
    id?: number;
    nome?: string;
    editabile?: boolean;
    giorni?: GiornoSezioneView[];

    constructor(data?: ISezioneView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.editabile = _data["editabile"] !== undefined ? _data["editabile"] : null as any;
            if (Array.isArray(_data["giorni"])) {
                this.giorni = [] as any;
                for (let item of _data["giorni"])
                    this.giorni!.push(GiornoSezioneView.fromJS(item));
            }
            else {
                this.giorni = null as any;
            }
        }
    }

    static fromJS(data: any): SezioneView {
        data = typeof data === 'object' ? data : {};
        let result = new SezioneView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["editabile"] = this.editabile !== undefined ? this.editabile : null as any;
        if (Array.isArray(this.giorni)) {
            data["giorni"] = [];
            for (let item of this.giorni)
                data["giorni"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ISezioneView {
    id?: number;
    nome?: string;
    editabile?: boolean;
    giorni?: GiornoSezioneView[];
}

export class GiornoSezioneView implements IGiornoSezioneView {
    giorno?: number | null;
    data?: string | null;
    luoghi?: string | null;
    luoghiIds?: number[] | null;
    serviziIds?: number[] | null;
    contattiIds?: number[] | null;
    sottosezioni?: SottozioneGiornoView[];

    constructor(data?: IGiornoSezioneView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
            this.luoghi = _data["luoghi"] !== undefined ? _data["luoghi"] : null as any;
            if (Array.isArray(_data["luoghiIds"])) {
                this.luoghiIds = [] as any;
                for (let item of _data["luoghiIds"])
                    this.luoghiIds!.push(item);
            }
            else {
                this.luoghiIds = null as any;
            }
            if (Array.isArray(_data["serviziIds"])) {
                this.serviziIds = [] as any;
                for (let item of _data["serviziIds"])
                    this.serviziIds!.push(item);
            }
            else {
                this.serviziIds = null as any;
            }
            if (Array.isArray(_data["contattiIds"])) {
                this.contattiIds = [] as any;
                for (let item of _data["contattiIds"])
                    this.contattiIds!.push(item);
            }
            else {
                this.contattiIds = null as any;
            }
            if (Array.isArray(_data["sottosezioni"])) {
                this.sottosezioni = [] as any;
                for (let item of _data["sottosezioni"])
                    this.sottosezioni!.push(SottozioneGiornoView.fromJS(item));
            }
            else {
                this.sottosezioni = null as any;
            }
        }
    }

    static fromJS(data: any): GiornoSezioneView {
        data = typeof data === 'object' ? data : {};
        let result = new GiornoSezioneView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giorno"] = this.giorno !== undefined ? this.giorno : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["luoghi"] = this.luoghi !== undefined ? this.luoghi : null as any;
        if (Array.isArray(this.luoghiIds)) {
            data["luoghiIds"] = [];
            for (let item of this.luoghiIds)
                data["luoghiIds"].push(item);
        }
        if (Array.isArray(this.serviziIds)) {
            data["serviziIds"] = [];
            for (let item of this.serviziIds)
                data["serviziIds"].push(item);
        }
        if (Array.isArray(this.contattiIds)) {
            data["contattiIds"] = [];
            for (let item of this.contattiIds)
                data["contattiIds"].push(item);
        }
        if (Array.isArray(this.sottosezioni)) {
            data["sottosezioni"] = [];
            for (let item of this.sottosezioni)
                data["sottosezioni"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IGiornoSezioneView {
    giorno?: number | null;
    data?: string | null;
    luoghi?: string | null;
    luoghiIds?: number[] | null;
    serviziIds?: number[] | null;
    contattiIds?: number[] | null;
    sottosezioni?: SottozioneGiornoView[];
}

export class SottozioneGiornoView implements ISottozioneGiornoView {
    id?: number | null;
    nome?: string | null;
    frasi?: FraseSottosezione[];

    constructor(data?: ISottozioneGiornoView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            if (Array.isArray(_data["frasi"])) {
                this.frasi = [] as any;
                for (let item of _data["frasi"])
                    this.frasi!.push(FraseSottosezione.fromJS(item));
            }
            else {
                this.frasi = null as any;
            }
        }
    }

    static fromJS(data: any): SottozioneGiornoView {
        data = typeof data === 'object' ? data : {};
        let result = new SottozioneGiornoView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        if (Array.isArray(this.frasi)) {
            data["frasi"] = [];
            for (let item of this.frasi)
                data["frasi"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ISottozioneGiornoView {
    id?: number | null;
    nome?: string | null;
    frasi?: FraseSottosezione[];
}

export class FraseSottosezione implements IFraseSottosezione {
    id?: number;
    /** ID dell'articolo associato. Se presente il testo deriva da un articolo */
    articoloID?: number | null;
    /** ID della frase. Se presente il testo deriva da una frase */
    fraseID?: number | null;
    /** ID del contatto associato, opzionale */
    contattoID?: number | null;
    /** ID dell'accordo associato, opzionale */
    accordoID?: number | null;
    /** ID del servizio associato, opzionale */
    servizioID?: number | null;
    /** ID della riga di offerta associata, opzionale */
    rigaID?: number | null;
    /** ID del luogo associato, opzionale */
    luogoID?: number | null;
    /** Terminatore da utilizzare */
    terminatore?: EFraseTerminatore;
    /** Testo non formattato */
    testo?: string;
    /** Dizionario delle variabili e rispettivi valori */
    variabili?: { [key: string]: VariabileValore; } | null;
    frase?: Frase | null;

    constructor(data?: IFraseSottosezione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.articoloID = _data["articoloID"] !== undefined ? _data["articoloID"] : null as any;
            this.fraseID = _data["fraseID"] !== undefined ? _data["fraseID"] : null as any;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.rigaID = _data["rigaID"] !== undefined ? _data["rigaID"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.terminatore = _data["terminatore"] !== undefined ? _data["terminatore"] : null as any;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : null as any;
            if (_data["variabili"]) {
                this.variabili = {} as any;
                for (let key in _data["variabili"]) {
                    if (_data["variabili"].hasOwnProperty(key))
                        (this.variabili as any)![key] = _data["variabili"][key] ? VariabileValore.fromJS(_data["variabili"][key]) : new VariabileValore();
                }
            }
            else {
                this.variabili = null as any;
            }
            this.frase = _data["frase"] ? Frase.fromJS(_data["frase"]) : null as any;
        }
    }

    static fromJS(data: any): FraseSottosezione {
        data = typeof data === 'object' ? data : {};
        let result = new FraseSottosezione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["articoloID"] = this.articoloID !== undefined ? this.articoloID : null as any;
        data["fraseID"] = this.fraseID !== undefined ? this.fraseID : null as any;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["rigaID"] = this.rigaID !== undefined ? this.rigaID : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["terminatore"] = this.terminatore !== undefined ? this.terminatore : null as any;
        data["testo"] = this.testo !== undefined ? this.testo : null as any;
        if (this.variabili) {
            data["variabili"] = {};
            for (let key in this.variabili) {
                if (this.variabili.hasOwnProperty(key))
                    (data["variabili"] as any)[key] = this.variabili[key] ? this.variabili[key].toJSON() : null as any;
            }
        }
        data["frase"] = this.frase ? this.frase.toJSON() : null as any;
        return data;
    }
}

export interface IFraseSottosezione {
    id?: number;
    /** ID dell'articolo associato. Se presente il testo deriva da un articolo */
    articoloID?: number | null;
    /** ID della frase. Se presente il testo deriva da una frase */
    fraseID?: number | null;
    /** ID del contatto associato, opzionale */
    contattoID?: number | null;
    /** ID dell'accordo associato, opzionale */
    accordoID?: number | null;
    /** ID del servizio associato, opzionale */
    servizioID?: number | null;
    /** ID della riga di offerta associata, opzionale */
    rigaID?: number | null;
    /** ID del luogo associato, opzionale */
    luogoID?: number | null;
    /** Terminatore da utilizzare */
    terminatore?: EFraseTerminatore;
    /** Testo non formattato */
    testo?: string;
    /** Dizionario delle variabili e rispettivi valori */
    variabili?: { [key: string]: VariabileValore; } | null;
    frase?: Frase | null;
}

export class GetDocumentoFrasiRequest extends LocalizedRequest implements IGetDocumentoFrasiRequest {
    documentoID?: number;

    constructor(data?: IGetDocumentoFrasiRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : null as any;
        }
    }

    static override fromJS(data: any): GetDocumentoFrasiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentoFrasiRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetDocumentoFrasiRequest extends ILocalizedRequest {
    documentoID?: number;
}

export class UpdateDocumentRequest extends LocalizedRequest implements IUpdateDocumentRequest {
    /** ID del documento */
    documentoID?: number;
    /** Contenuto HTML del documento */
    content!: string;
    /** Link completo del CSS del documento */
    cssUrl?: string | null;
    /** Titolo del documento */
    title?: string | null;
    /** Link alla favicon */
    favIconUrl?: string | null;
    /** Lista dei css "extra" */
    extraCssUrls?: string[] | null;

    constructor(data?: IUpdateDocumentRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : null as any;
            this.content = _data["content"] !== undefined ? _data["content"] : null as any;
            this.cssUrl = _data["cssUrl"] !== undefined ? _data["cssUrl"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.favIconUrl = _data["favIconUrl"] !== undefined ? _data["favIconUrl"] : null as any;
            if (Array.isArray(_data["extraCssUrls"])) {
                this.extraCssUrls = [] as any;
                for (let item of _data["extraCssUrls"])
                    this.extraCssUrls!.push(item);
            }
            else {
                this.extraCssUrls = null as any;
            }
        }
    }

    static override fromJS(data: any): UpdateDocumentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : null as any;
        data["content"] = this.content !== undefined ? this.content : null as any;
        data["cssUrl"] = this.cssUrl !== undefined ? this.cssUrl : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["favIconUrl"] = this.favIconUrl !== undefined ? this.favIconUrl : null as any;
        if (Array.isArray(this.extraCssUrls)) {
            data["extraCssUrls"] = [];
            for (let item of this.extraCssUrls)
                data["extraCssUrls"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateDocumentRequest extends ILocalizedRequest {
    /** ID del documento */
    documentoID?: number;
    /** Contenuto HTML del documento */
    content: string;
    /** Link completo del CSS del documento */
    cssUrl?: string | null;
    /** Titolo del documento */
    title?: string | null;
    /** Link alla favicon */
    favIconUrl?: string | null;
    /** Lista dei css "extra" */
    extraCssUrls?: string[] | null;
}

export class UpdateDocumentPhrasesResponse extends GetDocumentoFrasiResponse implements IUpdateDocumentPhrasesResponse {

    constructor(data?: IUpdateDocumentPhrasesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UpdateDocumentPhrasesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentPhrasesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateDocumentPhrasesResponse extends IGetDocumentoFrasiResponse {
}

export class UpdateDocumentPhrasesRequest extends GetDocumentoFrasiRequest implements IUpdateDocumentPhrasesRequest {
    sezioni!: SezioneView[];

    constructor(data?: IUpdateDocumentPhrasesRequest) {
        super(data);
        if (!data) {
            this.sezioni = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["sezioni"])) {
                this.sezioni = [] as any;
                for (let item of _data["sezioni"])
                    this.sezioni!.push(SezioneView.fromJS(item));
            }
            else {
                this.sezioni = null as any;
            }
        }
    }

    static override fromJS(data: any): UpdateDocumentPhrasesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentPhrasesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sezioni)) {
            data["sezioni"] = [];
            for (let item of this.sezioni)
                data["sezioni"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateDocumentPhrasesRequest extends IGetDocumentoFrasiRequest {
    sezioni: SezioneView[];
}

export class UpdateExtraDocsRequest extends TripGetRequest implements IUpdateExtraDocsRequest {
    /** ID del documento */
    documentoID?: number;
    /** Stringa degli extra docs formato ID_Ordine,... */
    extraDocsString!: string;

    constructor(data?: IUpdateExtraDocsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : null as any;
            this.extraDocsString = _data["extraDocsString"] !== undefined ? _data["extraDocsString"] : null as any;
        }
    }

    static override fromJS(data: any): UpdateExtraDocsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExtraDocsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : null as any;
        data["extraDocsString"] = this.extraDocsString !== undefined ? this.extraDocsString : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateExtraDocsRequest extends ITripGetRequest {
    /** ID del documento */
    documentoID?: number;
    /** Stringa degli extra docs formato ID_Ordine,... */
    extraDocsString: string;
}

export class GetEmailResponse extends OkApiResponse implements IGetEmailResponse {
    email?: EmailQueue | null;
    toRecipients?: string | null;
    ccRecipients?: string | null;
    bccRecipients?: string | null;
    attachments?: EmailAttachmentInfo[] | null;

    constructor(data?: IGetEmailResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.email = _data["email"] ? EmailQueue.fromJS(_data["email"]) : null as any;
            this.toRecipients = _data["toRecipients"] !== undefined ? _data["toRecipients"] : null as any;
            this.ccRecipients = _data["ccRecipients"] !== undefined ? _data["ccRecipients"] : null as any;
            this.bccRecipients = _data["bccRecipients"] !== undefined ? _data["bccRecipients"] : null as any;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(EmailAttachmentInfo.fromJS(item));
            }
            else {
                this.attachments = null as any;
            }
        }
    }

    static override fromJS(data: any): GetEmailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmailResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email ? this.email.toJSON() : null as any;
        data["toRecipients"] = this.toRecipients !== undefined ? this.toRecipients : null as any;
        data["ccRecipients"] = this.ccRecipients !== undefined ? this.ccRecipients : null as any;
        data["bccRecipients"] = this.bccRecipients !== undefined ? this.bccRecipients : null as any;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetEmailResponse extends IOkApiResponse {
    email?: EmailQueue | null;
    toRecipients?: string | null;
    ccRecipients?: string | null;
    bccRecipients?: string | null;
    attachments?: EmailAttachmentInfo[] | null;
}

export class EmailAttachmentInfo implements IEmailAttachmentInfo {
    id?: number;
    attachment?: EmailQueueAttachment | null;

    constructor(data?: IEmailAttachmentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.attachment = _data["attachment"] ? EmailQueueAttachment.fromJS(_data["attachment"]) : null as any;
        }
    }

    static fromJS(data: any): EmailAttachmentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new EmailAttachmentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["attachment"] = this.attachment ? this.attachment.toJSON() : null as any;
        return data;
    }
}

export interface IEmailAttachmentInfo {
    id?: number;
    attachment?: EmailQueueAttachment | null;
}

export class EmailQueueAttachment implements IEmailQueueAttachment {
    id?: number;
    emailID?: number;
    attachmentType?: EEmailAttachmentType;
    entityID?: number | null;
    mimeType!: string;
    convertToPdf?: boolean;
    attachmentFileName!: string;

    constructor(data?: IEmailQueueAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.emailID = _data["emailID"] !== undefined ? _data["emailID"] : null as any;
            this.attachmentType = _data["attachmentType"] !== undefined ? _data["attachmentType"] : null as any;
            this.entityID = _data["entityID"] !== undefined ? _data["entityID"] : null as any;
            this.mimeType = _data["mimeType"] !== undefined ? _data["mimeType"] : null as any;
            this.convertToPdf = _data["convertToPdf"] !== undefined ? _data["convertToPdf"] : null as any;
            this.attachmentFileName = _data["attachmentFileName"] !== undefined ? _data["attachmentFileName"] : null as any;
        }
    }

    static fromJS(data: any): EmailQueueAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new EmailQueueAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["emailID"] = this.emailID !== undefined ? this.emailID : null as any;
        data["attachmentType"] = this.attachmentType !== undefined ? this.attachmentType : null as any;
        data["entityID"] = this.entityID !== undefined ? this.entityID : null as any;
        data["mimeType"] = this.mimeType !== undefined ? this.mimeType : null as any;
        data["convertToPdf"] = this.convertToPdf !== undefined ? this.convertToPdf : null as any;
        data["attachmentFileName"] = this.attachmentFileName !== undefined ? this.attachmentFileName : null as any;
        return data;
    }
}

export interface IEmailQueueAttachment {
    id?: number;
    emailID?: number;
    attachmentType?: EEmailAttachmentType;
    entityID?: number | null;
    mimeType: string;
    convertToPdf?: boolean;
    attachmentFileName: string;
}

export enum EEmailAttachmentType {
    Custom = "Custom",
    DocumentoOfferta = "DocumentoOfferta",
    DocumentoContabile = "DocumentoContabile",
    Voucher = "Voucher",
}

export class GetEmailRequest extends LocalizedRequest implements IGetEmailRequest {
    emailID?: number;

    constructor(data?: IGetEmailRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.emailID = _data["emailID"] !== undefined ? _data["emailID"] : null as any;
        }
    }

    static override fromJS(data: any): GetEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmailRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailID"] = this.emailID !== undefined ? this.emailID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetEmailRequest extends ILocalizedRequest {
    emailID?: number;
}

export class CreateErrorRequest extends ApiRequest implements ICreateErrorRequest {
    /** In che controller */
    controller?: string | null;
    /** Dove è avvenuto l'errore */
    action?: string | null;
    /** Con quali parametri */
    request?: string | null;
    /** Che messaggio è stato visualizzato */
    message?: string | null;
    /** Informazioni aggiuntive sintetiche */
    info?: string | null;
    /** Se l'errore è stato gestito dall'applicazione */
    isApplicationHandled?: boolean;

    constructor(data?: ICreateErrorRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.controller = _data["controller"] !== undefined ? _data["controller"] : null as any;
            this.action = _data["action"] !== undefined ? _data["action"] : null as any;
            this.request = _data["request"] !== undefined ? _data["request"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
            this.info = _data["info"] !== undefined ? _data["info"] : null as any;
            this.isApplicationHandled = _data["isApplicationHandled"] !== undefined ? _data["isApplicationHandled"] : null as any;
        }
    }

    static override fromJS(data: any): CreateErrorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateErrorRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["controller"] = this.controller !== undefined ? this.controller : null as any;
        data["action"] = this.action !== undefined ? this.action : null as any;
        data["request"] = this.request !== undefined ? this.request : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        data["info"] = this.info !== undefined ? this.info : null as any;
        data["isApplicationHandled"] = this.isApplicationHandled !== undefined ? this.isApplicationHandled : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateErrorRequest extends IApiRequest {
    /** In che controller */
    controller?: string | null;
    /** Dove è avvenuto l'errore */
    action?: string | null;
    /** Con quali parametri */
    request?: string | null;
    /** Che messaggio è stato visualizzato */
    message?: string | null;
    /** Informazioni aggiuntive sintetiche */
    info?: string | null;
    /** Se l'errore è stato gestito dall'applicazione */
    isApplicationHandled?: boolean;
}

export class DeleteErrorRequest extends ApiRequest implements IDeleteErrorRequest {
    errorID!: number;

    constructor(data?: IDeleteErrorRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.errorID = _data["errorID"] !== undefined ? _data["errorID"] : null as any;
        }
    }

    static override fromJS(data: any): DeleteErrorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteErrorRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorID"] = this.errorID !== undefined ? this.errorID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteErrorRequest extends IApiRequest {
    errorID: number;
}

export class DeleteErrorMultiRequest extends ApiRequest implements IDeleteErrorMultiRequest {
    errorIDs!: number[];

    constructor(data?: IDeleteErrorMultiRequest) {
        super(data);
        if (!data) {
            this.errorIDs = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["errorIDs"])) {
                this.errorIDs = [] as any;
                for (let item of _data["errorIDs"])
                    this.errorIDs!.push(item);
            }
            else {
                this.errorIDs = null as any;
            }
        }
    }

    static override fromJS(data: any): DeleteErrorMultiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteErrorMultiRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorIDs)) {
            data["errorIDs"] = [];
            for (let item of this.errorIDs)
                data["errorIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteErrorMultiRequest extends IApiRequest {
    errorIDs: number[];
}

export class NrTableResponseOfErrorRow extends OkApiResponse implements INrTableResponseOfErrorRow {
    /** Array delle righe della pagina richiesta */
    rows?: ErrorRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfErrorRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ErrorRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfErrorRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfErrorRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfErrorRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: ErrorRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class ErrorRow implements IErrorRow {
    errore?: Errore | null;
    utente?: string | null;

    constructor(data?: IErrorRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errore = _data["errore"] ? Errore.fromJS(_data["errore"]) : null as any;
            this.utente = _data["utente"] !== undefined ? _data["utente"] : null as any;
        }
    }

    static fromJS(data: any): ErrorRow {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errore"] = this.errore ? this.errore.toJSON() : null as any;
        data["utente"] = this.utente !== undefined ? this.utente : null as any;
        return data;
    }
}

export interface IErrorRow {
    errore?: Errore | null;
    utente?: string | null;
}

export class Errore implements IErrore {
    id?: number;
    date?: string;
    userID?: number | null;
    ip?: string | null;
    controller?: string;
    action?: string;
    routeData?: string | null;
    request?: string | null;
    referrer?: string | null;
    message?: string;
    info?: string | null;
    stackTrace?: string | null;
    isDebug?: boolean;
    isApplicationHandled?: boolean;

    constructor(data?: IErrore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.date = _data["date"] !== undefined ? _data["date"] : null as any;
            this.userID = _data["userID"] !== undefined ? _data["userID"] : null as any;
            this.ip = _data["ip"] !== undefined ? _data["ip"] : null as any;
            this.controller = _data["controller"] !== undefined ? _data["controller"] : null as any;
            this.action = _data["action"] !== undefined ? _data["action"] : null as any;
            this.routeData = _data["routeData"] !== undefined ? _data["routeData"] : null as any;
            this.request = _data["request"] !== undefined ? _data["request"] : null as any;
            this.referrer = _data["referrer"] !== undefined ? _data["referrer"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
            this.info = _data["info"] !== undefined ? _data["info"] : null as any;
            this.stackTrace = _data["stackTrace"] !== undefined ? _data["stackTrace"] : null as any;
            this.isDebug = _data["isDebug"] !== undefined ? _data["isDebug"] : null as any;
            this.isApplicationHandled = _data["isApplicationHandled"] !== undefined ? _data["isApplicationHandled"] : null as any;
        }
    }

    static fromJS(data: any): Errore {
        data = typeof data === 'object' ? data : {};
        let result = new Errore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["date"] = this.date !== undefined ? this.date : null as any;
        data["userID"] = this.userID !== undefined ? this.userID : null as any;
        data["ip"] = this.ip !== undefined ? this.ip : null as any;
        data["controller"] = this.controller !== undefined ? this.controller : null as any;
        data["action"] = this.action !== undefined ? this.action : null as any;
        data["routeData"] = this.routeData !== undefined ? this.routeData : null as any;
        data["request"] = this.request !== undefined ? this.request : null as any;
        data["referrer"] = this.referrer !== undefined ? this.referrer : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        data["info"] = this.info !== undefined ? this.info : null as any;
        data["stackTrace"] = this.stackTrace !== undefined ? this.stackTrace : null as any;
        data["isDebug"] = this.isDebug !== undefined ? this.isDebug : null as any;
        data["isApplicationHandled"] = this.isApplicationHandled !== undefined ? this.isApplicationHandled : null as any;
        return data;
    }
}

export interface IErrore {
    id?: number;
    date?: string;
    userID?: number | null;
    ip?: string | null;
    controller?: string;
    action?: string;
    routeData?: string | null;
    request?: string | null;
    referrer?: string | null;
    message?: string;
    info?: string | null;
    stackTrace?: string | null;
    isDebug?: boolean;
    isApplicationHandled?: boolean;
}

export class ErrorsListRequest extends NrTableRequest implements IErrorsListRequest {
    userID?: number | null;
    errorsFilter?: DebugErrorsFilter;
    handledFilter?: ApplicationHandledFilter;
    dateFromFilter?: string | null;
    dateToFilter?: string | null;
    controllerFilter?: string | null;
    actionFilter?: string | null;
    messageFilter?: string | null;

    constructor(data?: IErrorsListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userID = _data["userID"] !== undefined ? _data["userID"] : null as any;
            this.errorsFilter = _data["errorsFilter"] !== undefined ? _data["errorsFilter"] : null as any;
            this.handledFilter = _data["handledFilter"] !== undefined ? _data["handledFilter"] : null as any;
            this.dateFromFilter = _data["dateFromFilter"] !== undefined ? _data["dateFromFilter"] : null as any;
            this.dateToFilter = _data["dateToFilter"] !== undefined ? _data["dateToFilter"] : null as any;
            this.controllerFilter = _data["controllerFilter"] !== undefined ? _data["controllerFilter"] : null as any;
            this.actionFilter = _data["actionFilter"] !== undefined ? _data["actionFilter"] : null as any;
            this.messageFilter = _data["messageFilter"] !== undefined ? _data["messageFilter"] : null as any;
        }
    }

    static override fromJS(data: any): ErrorsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorsListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID !== undefined ? this.userID : null as any;
        data["errorsFilter"] = this.errorsFilter !== undefined ? this.errorsFilter : null as any;
        data["handledFilter"] = this.handledFilter !== undefined ? this.handledFilter : null as any;
        data["dateFromFilter"] = this.dateFromFilter !== undefined ? this.dateFromFilter : null as any;
        data["dateToFilter"] = this.dateToFilter !== undefined ? this.dateToFilter : null as any;
        data["controllerFilter"] = this.controllerFilter !== undefined ? this.controllerFilter : null as any;
        data["actionFilter"] = this.actionFilter !== undefined ? this.actionFilter : null as any;
        data["messageFilter"] = this.messageFilter !== undefined ? this.messageFilter : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IErrorsListRequest extends INrTableRequest {
    userID?: number | null;
    errorsFilter?: DebugErrorsFilter;
    handledFilter?: ApplicationHandledFilter;
    dateFromFilter?: string | null;
    dateToFilter?: string | null;
    controllerFilter?: string | null;
    actionFilter?: string | null;
    messageFilter?: string | null;
}

export enum DebugErrorsFilter {
    None = "None",
    DebugOnly = "DebugOnly",
    ProdOnly = "ProdOnly",
}

export enum ApplicationHandledFilter {
    None = "None",
    Handled = "Handled",
    Unhandled = "Unhandled",
}

export class NrTableResponseOfEstrattoContoReportRow extends OkApiResponse implements INrTableResponseOfEstrattoContoReportRow {
    /** Array delle righe della pagina richiesta */
    rows?: EstrattoContoReportRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfEstrattoContoReportRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(EstrattoContoReportRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfEstrattoContoReportRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfEstrattoContoReportRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfEstrattoContoReportRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: EstrattoContoReportRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class GetEstrattoContoReportResponse extends NrTableResponseOfEstrattoContoReportRow implements IGetEstrattoContoReportResponse {
    totale?: number | null;
    totaleNetto?: number | null;
    totaleVersato?: number | null;
    totaleDaPagare?: number | null;
    totaleCommissione?: number | null;

    constructor(data?: IGetEstrattoContoReportResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totale = _data["totale"] !== undefined ? _data["totale"] : null as any;
            this.totaleNetto = _data["totaleNetto"] !== undefined ? _data["totaleNetto"] : null as any;
            this.totaleVersato = _data["totaleVersato"] !== undefined ? _data["totaleVersato"] : null as any;
            this.totaleDaPagare = _data["totaleDaPagare"] !== undefined ? _data["totaleDaPagare"] : null as any;
            this.totaleCommissione = _data["totaleCommissione"] !== undefined ? _data["totaleCommissione"] : null as any;
        }
    }

    static override fromJS(data: any): GetEstrattoContoReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEstrattoContoReportResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totale"] = this.totale !== undefined ? this.totale : null as any;
        data["totaleNetto"] = this.totaleNetto !== undefined ? this.totaleNetto : null as any;
        data["totaleVersato"] = this.totaleVersato !== undefined ? this.totaleVersato : null as any;
        data["totaleDaPagare"] = this.totaleDaPagare !== undefined ? this.totaleDaPagare : null as any;
        data["totaleCommissione"] = this.totaleCommissione !== undefined ? this.totaleCommissione : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetEstrattoContoReportResponse extends INrTableResponseOfEstrattoContoReportRow {
    totale?: number | null;
    totaleNetto?: number | null;
    totaleVersato?: number | null;
    totaleDaPagare?: number | null;
    totaleCommissione?: number | null;
}

export class EstrattoContoReportRow implements IEstrattoContoReportRow {
    offertaID?: number;
    agenziaID?: number | null;
    agenzia?: string | null;
    luogoAgenzia?: string | null;
    network?: string | null;
    pagamento?: string | null;
    pagamentoID?: number | null;
    descrizione?: string | null;
    partenza?: string;
    totale?: number | null;
    commissione?: number | null;
    netto?: number;
    versato?: number;
    daPagare?: number;

    constructor(data?: IEstrattoContoReportRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.agenziaID = _data["agenziaID"] !== undefined ? _data["agenziaID"] : null as any;
            this.agenzia = _data["agenzia"] !== undefined ? _data["agenzia"] : null as any;
            this.luogoAgenzia = _data["luogoAgenzia"] !== undefined ? _data["luogoAgenzia"] : null as any;
            this.network = _data["network"] !== undefined ? _data["network"] : null as any;
            this.pagamento = _data["pagamento"] !== undefined ? _data["pagamento"] : null as any;
            this.pagamentoID = _data["pagamentoID"] !== undefined ? _data["pagamentoID"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : null as any;
            this.totale = _data["totale"] !== undefined ? _data["totale"] : null as any;
            this.commissione = _data["commissione"] !== undefined ? _data["commissione"] : null as any;
            this.netto = _data["netto"] !== undefined ? _data["netto"] : null as any;
            this.versato = _data["versato"] !== undefined ? _data["versato"] : null as any;
            this.daPagare = _data["daPagare"] !== undefined ? _data["daPagare"] : null as any;
        }
    }

    static fromJS(data: any): EstrattoContoReportRow {
        data = typeof data === 'object' ? data : {};
        let result = new EstrattoContoReportRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["agenziaID"] = this.agenziaID !== undefined ? this.agenziaID : null as any;
        data["agenzia"] = this.agenzia !== undefined ? this.agenzia : null as any;
        data["luogoAgenzia"] = this.luogoAgenzia !== undefined ? this.luogoAgenzia : null as any;
        data["network"] = this.network !== undefined ? this.network : null as any;
        data["pagamento"] = this.pagamento !== undefined ? this.pagamento : null as any;
        data["pagamentoID"] = this.pagamentoID !== undefined ? this.pagamentoID : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["partenza"] = this.partenza !== undefined ? this.partenza : null as any;
        data["totale"] = this.totale !== undefined ? this.totale : null as any;
        data["commissione"] = this.commissione !== undefined ? this.commissione : null as any;
        data["netto"] = this.netto !== undefined ? this.netto : null as any;
        data["versato"] = this.versato !== undefined ? this.versato : null as any;
        data["daPagare"] = this.daPagare !== undefined ? this.daPagare : null as any;
        return data;
    }
}

export interface IEstrattoContoReportRow {
    offertaID?: number;
    agenziaID?: number | null;
    agenzia?: string | null;
    luogoAgenzia?: string | null;
    network?: string | null;
    pagamento?: string | null;
    pagamentoID?: number | null;
    descrizione?: string | null;
    partenza?: string;
    totale?: number | null;
    commissione?: number | null;
    netto?: number;
    versato?: number;
    daPagare?: number;
}

export class GetEstrattoContoReportRequest extends NrTableRequest implements IGetEstrattoContoReportRequest {
    contattoID?: number | null;
    partitaIVA?: string | null;
    partenzaDa?: string | null;
    partenzaA?: string | null;
    pagamentoID?: number | null;
    opening?: boolean;

    constructor(data?: IGetEstrattoContoReportRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.partitaIVA = _data["partitaIVA"] !== undefined ? _data["partitaIVA"] : null as any;
            this.partenzaDa = _data["partenzaDa"] !== undefined ? _data["partenzaDa"] : null as any;
            this.partenzaA = _data["partenzaA"] !== undefined ? _data["partenzaA"] : null as any;
            this.pagamentoID = _data["pagamentoID"] !== undefined ? _data["pagamentoID"] : null as any;
            this.opening = _data["opening"] !== undefined ? _data["opening"] : null as any;
        }
    }

    static override fromJS(data: any): GetEstrattoContoReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetEstrattoContoReportRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["partitaIVA"] = this.partitaIVA !== undefined ? this.partitaIVA : null as any;
        data["partenzaDa"] = this.partenzaDa !== undefined ? this.partenzaDa : null as any;
        data["partenzaA"] = this.partenzaA !== undefined ? this.partenzaA : null as any;
        data["pagamentoID"] = this.pagamentoID !== undefined ? this.pagamentoID : null as any;
        data["opening"] = this.opening !== undefined ? this.opening : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetEstrattoContoReportRequest extends INrTableRequest {
    contattoID?: number | null;
    partitaIVA?: string | null;
    partenzaDa?: string | null;
    partenzaA?: string | null;
    pagamentoID?: number | null;
    opening?: boolean;
}

export class NrTableResponseOfEstrattoContoRow extends OkApiResponse implements INrTableResponseOfEstrattoContoRow {
    /** Array delle righe della pagina richiesta */
    rows?: EstrattoContoRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfEstrattoContoRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(EstrattoContoRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfEstrattoContoRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfEstrattoContoRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfEstrattoContoRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: EstrattoContoRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class EstrattoContoRow implements IEstrattoContoRow {
    id?: number;
    contattoID?: number;
    nome?: string | null;
    data?: string;
    tipo?: ETipoEstrattoConto;
    invio?: string | null;

    constructor(data?: IEstrattoContoRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.invio = _data["invio"] !== undefined ? _data["invio"] : null as any;
        }
    }

    static fromJS(data: any): EstrattoContoRow {
        data = typeof data === 'object' ? data : {};
        let result = new EstrattoContoRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["invio"] = this.invio !== undefined ? this.invio : null as any;
        return data;
    }
}

export interface IEstrattoContoRow {
    id?: number;
    contattoID?: number;
    nome?: string | null;
    data?: string;
    tipo?: ETipoEstrattoConto;
    invio?: string | null;
}

export enum ETipoEstrattoConto {
    FineMese = "FineMese",
    Travelfactoring = "Travelfactoring",
}

export class EstrattiContoSearchRequest extends NrTableRequest implements IEstrattiContoSearchRequest {
    operatore?: EOperatore;
    contattoID?: number | null;
    partitaIVA?: string | null;
    dal?: string | null;
    al?: string | null;

    constructor(data?: IEstrattiContoSearchRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.partitaIVA = _data["partitaIVA"] !== undefined ? _data["partitaIVA"] : null as any;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.al = _data["al"] !== undefined ? _data["al"] : null as any;
        }
    }

    static override fromJS(data: any): EstrattiContoSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EstrattiContoSearchRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["partitaIVA"] = this.partitaIVA !== undefined ? this.partitaIVA : null as any;
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["al"] = this.al !== undefined ? this.al : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IEstrattiContoSearchRequest extends INrTableRequest {
    operatore?: EOperatore;
    contattoID?: number | null;
    partitaIVA?: string | null;
    dal?: string | null;
    al?: string | null;
}

export class EstrattoContoReadResponse extends OkApiResponse implements IEstrattoContoReadResponse {
    estrattoConto?: EstrattoConto | null;
    incassi?: IncassoRow[] | null;
    contatto?: string | null;
    email?: string | null;
    pagamento?: string | null;
    scadenza?: string;

    constructor(data?: IEstrattoContoReadResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.estrattoConto = _data["estrattoConto"] ? EstrattoConto.fromJS(_data["estrattoConto"]) : null as any;
            if (Array.isArray(_data["incassi"])) {
                this.incassi = [] as any;
                for (let item of _data["incassi"])
                    this.incassi!.push(IncassoRow.fromJS(item));
            }
            else {
                this.incassi = null as any;
            }
            this.contatto = _data["contatto"] !== undefined ? _data["contatto"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.pagamento = _data["pagamento"] !== undefined ? _data["pagamento"] : null as any;
            this.scadenza = _data["scadenza"] !== undefined ? _data["scadenza"] : null as any;
        }
    }

    static override fromJS(data: any): EstrattoContoReadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EstrattoContoReadResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estrattoConto"] = this.estrattoConto ? this.estrattoConto.toJSON() : null as any;
        if (Array.isArray(this.incassi)) {
            data["incassi"] = [];
            for (let item of this.incassi)
                data["incassi"].push(item ? item.toJSON() : null as any);
        }
        data["contatto"] = this.contatto !== undefined ? this.contatto : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["pagamento"] = this.pagamento !== undefined ? this.pagamento : null as any;
        data["scadenza"] = this.scadenza !== undefined ? this.scadenza : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IEstrattoContoReadResponse extends IOkApiResponse {
    estrattoConto?: EstrattoConto | null;
    incassi?: IncassoRow[] | null;
    contatto?: string | null;
    email?: string | null;
    pagamento?: string | null;
    scadenza?: string;
}

export class EstrattoConto implements IEstrattoConto {
    id?: number;
    operatore?: EOperatore;
    tipo?: ETipoEstrattoConto;
    contattoID?: number;
    data?: string;
    invio?: string | null;
    note?: string | null;
    bancaID?: number | null;

    constructor(data?: IEstrattoConto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
            this.invio = _data["invio"] !== undefined ? _data["invio"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.bancaID = _data["bancaID"] !== undefined ? _data["bancaID"] : null as any;
        }
    }

    static fromJS(data: any): EstrattoConto {
        data = typeof data === 'object' ? data : {};
        let result = new EstrattoConto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["invio"] = this.invio !== undefined ? this.invio : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["bancaID"] = this.bancaID !== undefined ? this.bancaID : null as any;
        return data;
    }
}

export interface IEstrattoConto {
    id?: number;
    operatore?: EOperatore;
    tipo?: ETipoEstrattoConto;
    contattoID?: number;
    data?: string;
    invio?: string | null;
    note?: string | null;
    bancaID?: number | null;
}

export class IncassoRow implements IIncassoRow {
    incassoID?: number;
    offertaID?: number;
    offerta?: string | null;
    dataScadenza?: string | null;
    dataCessione?: string | null;
    dataPagamento?: string | null;
    descrizione?: string | null;
    importo?: number | null;
    banca?: string | null;
    tipoOperazione?: string | null;
    tipoBiglietteria?: string | null;
    tipoPrepagamento?: string | null;

    constructor(data?: IIncassoRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incassoID = _data["incassoID"] !== undefined ? _data["incassoID"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.offerta = _data["offerta"] !== undefined ? _data["offerta"] : null as any;
            this.dataScadenza = _data["dataScadenza"] !== undefined ? _data["dataScadenza"] : null as any;
            this.dataCessione = _data["dataCessione"] !== undefined ? _data["dataCessione"] : null as any;
            this.dataPagamento = _data["dataPagamento"] !== undefined ? _data["dataPagamento"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : null as any;
            this.banca = _data["banca"] !== undefined ? _data["banca"] : null as any;
            this.tipoOperazione = _data["tipoOperazione"] !== undefined ? _data["tipoOperazione"] : null as any;
            this.tipoBiglietteria = _data["tipoBiglietteria"] !== undefined ? _data["tipoBiglietteria"] : null as any;
            this.tipoPrepagamento = _data["tipoPrepagamento"] !== undefined ? _data["tipoPrepagamento"] : null as any;
        }
    }

    static fromJS(data: any): IncassoRow {
        data = typeof data === 'object' ? data : {};
        let result = new IncassoRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incassoID"] = this.incassoID !== undefined ? this.incassoID : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["offerta"] = this.offerta !== undefined ? this.offerta : null as any;
        data["dataScadenza"] = this.dataScadenza !== undefined ? this.dataScadenza : null as any;
        data["dataCessione"] = this.dataCessione !== undefined ? this.dataCessione : null as any;
        data["dataPagamento"] = this.dataPagamento !== undefined ? this.dataPagamento : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["importo"] = this.importo !== undefined ? this.importo : null as any;
        data["banca"] = this.banca !== undefined ? this.banca : null as any;
        data["tipoOperazione"] = this.tipoOperazione !== undefined ? this.tipoOperazione : null as any;
        data["tipoBiglietteria"] = this.tipoBiglietteria !== undefined ? this.tipoBiglietteria : null as any;
        data["tipoPrepagamento"] = this.tipoPrepagamento !== undefined ? this.tipoPrepagamento : null as any;
        return data;
    }
}

export interface IIncassoRow {
    incassoID?: number;
    offertaID?: number;
    offerta?: string | null;
    dataScadenza?: string | null;
    dataCessione?: string | null;
    dataPagamento?: string | null;
    descrizione?: string | null;
    importo?: number | null;
    banca?: string | null;
    tipoOperazione?: string | null;
    tipoBiglietteria?: string | null;
    tipoPrepagamento?: string | null;
}

export class EstrattoContoReadRequest extends ApiRequest implements IEstrattoContoReadRequest {
    estrattoContoID?: number;

    constructor(data?: IEstrattoContoReadRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.estrattoContoID = _data["estrattoContoID"] !== undefined ? _data["estrattoContoID"] : null as any;
        }
    }

    static override fromJS(data: any): EstrattoContoReadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EstrattoContoReadRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estrattoContoID"] = this.estrattoContoID !== undefined ? this.estrattoContoID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IEstrattoContoReadRequest extends IApiRequest {
    estrattoContoID?: number;
}

export class EstrattoContoCreateResponse extends OkApiResponse implements IEstrattoContoCreateResponse {
    estrattoConto?: EstrattoConto | null;
    contatto?: string | null;

    constructor(data?: IEstrattoContoCreateResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.estrattoConto = _data["estrattoConto"] ? EstrattoConto.fromJS(_data["estrattoConto"]) : null as any;
            this.contatto = _data["contatto"] !== undefined ? _data["contatto"] : null as any;
        }
    }

    static override fromJS(data: any): EstrattoContoCreateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EstrattoContoCreateResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estrattoConto"] = this.estrattoConto ? this.estrattoConto.toJSON() : null as any;
        data["contatto"] = this.contatto !== undefined ? this.contatto : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IEstrattoContoCreateResponse extends IOkApiResponse {
    estrattoConto?: EstrattoConto | null;
    contatto?: string | null;
}

export class EstrattoContoCreateRequest extends ApiRequest implements IEstrattoContoCreateRequest {
    estrattoConto?: EstrattoConto | null;
    dal?: string;
    al?: string;

    constructor(data?: IEstrattoContoCreateRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.estrattoConto = _data["estrattoConto"] ? EstrattoConto.fromJS(_data["estrattoConto"]) : null as any;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.al = _data["al"] !== undefined ? _data["al"] : null as any;
        }
    }

    static override fromJS(data: any): EstrattoContoCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EstrattoContoCreateRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estrattoConto"] = this.estrattoConto ? this.estrattoConto.toJSON() : null as any;
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["al"] = this.al !== undefined ? this.al : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IEstrattoContoCreateRequest extends IApiRequest {
    estrattoConto?: EstrattoConto | null;
    dal?: string;
    al?: string;
}

export class EstrattoContoDeleteRequest extends ApiRequest implements IEstrattoContoDeleteRequest {
    estrattoContoID?: number;

    constructor(data?: IEstrattoContoDeleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.estrattoContoID = _data["estrattoContoID"] !== undefined ? _data["estrattoContoID"] : null as any;
        }
    }

    static override fromJS(data: any): EstrattoContoDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EstrattoContoDeleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estrattoContoID"] = this.estrattoContoID !== undefined ? this.estrattoContoID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IEstrattoContoDeleteRequest extends IApiRequest {
    estrattoContoID?: number;
}

export class PreviewEstrattoContoResponse extends OkApiResponse implements IPreviewEstrattoContoResponse {
    incassi?: PreviewEstrattoContoRow[] | null;

    constructor(data?: IPreviewEstrattoContoResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["incassi"])) {
                this.incassi = [] as any;
                for (let item of _data["incassi"])
                    this.incassi!.push(PreviewEstrattoContoRow.fromJS(item));
            }
            else {
                this.incassi = null as any;
            }
        }
    }

    static override fromJS(data: any): PreviewEstrattoContoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewEstrattoContoResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.incassi)) {
            data["incassi"] = [];
            for (let item of this.incassi)
                data["incassi"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPreviewEstrattoContoResponse extends IOkApiResponse {
    incassi?: PreviewEstrattoContoRow[] | null;
}

export class PreviewEstrattoContoRow implements IPreviewEstrattoContoRow {
    offertaID?: number;
    offerta?: string | null;
    dataScadenza?: string | null;
    descrizione?: string | null;
    importo?: number | null;
    tipoOperazione?: string | null;
    tipoBiglietteria?: string | null;
    tipoPrepagamento?: string | null;

    constructor(data?: IPreviewEstrattoContoRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.offerta = _data["offerta"] !== undefined ? _data["offerta"] : null as any;
            this.dataScadenza = _data["dataScadenza"] !== undefined ? _data["dataScadenza"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : null as any;
            this.tipoOperazione = _data["tipoOperazione"] !== undefined ? _data["tipoOperazione"] : null as any;
            this.tipoBiglietteria = _data["tipoBiglietteria"] !== undefined ? _data["tipoBiglietteria"] : null as any;
            this.tipoPrepagamento = _data["tipoPrepagamento"] !== undefined ? _data["tipoPrepagamento"] : null as any;
        }
    }

    static fromJS(data: any): PreviewEstrattoContoRow {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewEstrattoContoRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["offerta"] = this.offerta !== undefined ? this.offerta : null as any;
        data["dataScadenza"] = this.dataScadenza !== undefined ? this.dataScadenza : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["importo"] = this.importo !== undefined ? this.importo : null as any;
        data["tipoOperazione"] = this.tipoOperazione !== undefined ? this.tipoOperazione : null as any;
        data["tipoBiglietteria"] = this.tipoBiglietteria !== undefined ? this.tipoBiglietteria : null as any;
        data["tipoPrepagamento"] = this.tipoPrepagamento !== undefined ? this.tipoPrepagamento : null as any;
        return data;
    }
}

export interface IPreviewEstrattoContoRow {
    offertaID?: number;
    offerta?: string | null;
    dataScadenza?: string | null;
    descrizione?: string | null;
    importo?: number | null;
    tipoOperazione?: string | null;
    tipoBiglietteria?: string | null;
    tipoPrepagamento?: string | null;
}

export class PreviewEstrattoContoRequest extends ApiRequest implements IPreviewEstrattoContoRequest {
    estrattoConto?: EstrattoConto | null;
    dal?: string;
    al?: string;

    constructor(data?: IPreviewEstrattoContoRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.estrattoConto = _data["estrattoConto"] ? EstrattoConto.fromJS(_data["estrattoConto"]) : null as any;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.al = _data["al"] !== undefined ? _data["al"] : null as any;
        }
    }

    static override fromJS(data: any): PreviewEstrattoContoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewEstrattoContoRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estrattoConto"] = this.estrattoConto ? this.estrattoConto.toJSON() : null as any;
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["al"] = this.al !== undefined ? this.al : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPreviewEstrattoContoRequest extends IApiRequest {
    estrattoConto?: EstrattoConto | null;
    dal?: string;
    al?: string;
}

export class PreviewExcelRequest extends ApiRequest implements IPreviewExcelRequest {
    rows?: IncassoSendRow[] | null;

    constructor(data?: IPreviewExcelRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(IncassoSendRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
        }
    }

    static override fromJS(data: any): PreviewExcelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewExcelRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPreviewExcelRequest extends IApiRequest {
    rows?: IncassoSendRow[] | null;
}

export class IncassoSendRow implements IIncassoSendRow {
    offertaID?: number | null;
    offerta?: string | null;
    descrizione?: string | null;
    importo?: number | null;
    tipoOperazione?: string | null;
    tipoPrepagamento?: string | null;
    tipoBiglietteria?: string | null;
    subtotale?: number | null;

    constructor(data?: IIncassoSendRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.offerta = _data["offerta"] !== undefined ? _data["offerta"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : null as any;
            this.tipoOperazione = _data["tipoOperazione"] !== undefined ? _data["tipoOperazione"] : null as any;
            this.tipoPrepagamento = _data["tipoPrepagamento"] !== undefined ? _data["tipoPrepagamento"] : null as any;
            this.tipoBiglietteria = _data["tipoBiglietteria"] !== undefined ? _data["tipoBiglietteria"] : null as any;
            this.subtotale = _data["subtotale"] !== undefined ? _data["subtotale"] : null as any;
        }
    }

    static fromJS(data: any): IncassoSendRow {
        data = typeof data === 'object' ? data : {};
        let result = new IncassoSendRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["offerta"] = this.offerta !== undefined ? this.offerta : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["importo"] = this.importo !== undefined ? this.importo : null as any;
        data["tipoOperazione"] = this.tipoOperazione !== undefined ? this.tipoOperazione : null as any;
        data["tipoPrepagamento"] = this.tipoPrepagamento !== undefined ? this.tipoPrepagamento : null as any;
        data["tipoBiglietteria"] = this.tipoBiglietteria !== undefined ? this.tipoBiglietteria : null as any;
        data["subtotale"] = this.subtotale !== undefined ? this.subtotale : null as any;
        return data;
    }
}

export interface IIncassoSendRow {
    offertaID?: number | null;
    offerta?: string | null;
    descrizione?: string | null;
    importo?: number | null;
    tipoOperazione?: string | null;
    tipoPrepagamento?: string | null;
    tipoBiglietteria?: string | null;
    subtotale?: number | null;
}

export abstract class BaseRQ implements IBaseRQ {
    pid?: string | null;
    connectorsEnvironment?: ConnectorEnvironment[] | null;

    constructor(data?: IBaseRQ) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pid = _data["Pid"] !== undefined ? _data["Pid"] : null as any;
            if (Array.isArray(_data["ConnectorsEnvironment"])) {
                this.connectorsEnvironment = [] as any;
                for (let item of _data["ConnectorsEnvironment"])
                    this.connectorsEnvironment!.push(ConnectorEnvironment.fromJS(item));
            }
            else {
                this.connectorsEnvironment = null as any;
            }
        }
    }

    static fromJS(data: any): BaseRQ {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseRQ' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Pid"] = this.pid !== undefined ? this.pid : null as any;
        if (Array.isArray(this.connectorsEnvironment)) {
            data["ConnectorsEnvironment"] = [];
            for (let item of this.connectorsEnvironment)
                data["ConnectorsEnvironment"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IBaseRQ {
    pid?: string | null;
    connectorsEnvironment?: ConnectorEnvironment[] | null;
}

export abstract class BaseCacheableRQ extends BaseRQ implements IBaseCacheableRQ {
    forceNotCachedResponse?: boolean | null;

    constructor(data?: IBaseCacheableRQ) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.forceNotCachedResponse = _data["ForceNotCachedResponse"] !== undefined ? _data["ForceNotCachedResponse"] : null as any;
        }
    }

    static override fromJS(data: any): BaseCacheableRQ {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCacheableRQ' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ForceNotCachedResponse"] = this.forceNotCachedResponse !== undefined ? this.forceNotCachedResponse : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IBaseCacheableRQ extends IBaseRQ {
    forceNotCachedResponse?: boolean | null;
}

export class JupiterFlightAvailabilityRQ extends BaseCacheableRQ implements IJupiterFlightAvailabilityRQ {
    request?: JupiterFlightAvailabilityInput | null;

    constructor(data?: IJupiterFlightAvailabilityRQ) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.request = _data["Request"] ? JupiterFlightAvailabilityInput.fromJS(_data["Request"]) : null as any;
        }
    }

    static override fromJS(data: any): JupiterFlightAvailabilityRQ {
        data = typeof data === 'object' ? data : {};
        let result = new JupiterFlightAvailabilityRQ();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Request"] = this.request ? this.request.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IJupiterFlightAvailabilityRQ extends IBaseCacheableRQ {
    request?: JupiterFlightAvailabilityInput | null;
}

export abstract class BaseInput implements IBaseInput {
    connectorsDebug?: EH2HConnectorCode[] | null;

    constructor(data?: IBaseInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ConnectorsDebug"])) {
                this.connectorsDebug = [] as any;
                for (let item of _data["ConnectorsDebug"])
                    this.connectorsDebug!.push(item);
            }
            else {
                this.connectorsDebug = null as any;
            }
        }
    }

    static fromJS(data: any): BaseInput {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseInput' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.connectorsDebug)) {
            data["ConnectorsDebug"] = [];
            for (let item of this.connectorsDebug)
                data["ConnectorsDebug"].push(item);
        }
        return data;
    }
}

export interface IBaseInput {
    connectorsDebug?: EH2HConnectorCode[] | null;
}

export class JupiterFlightAvailabilityInput extends BaseInput implements IJupiterFlightAvailabilityInput {
    connectorsSearch!: EH2HConnectorCode[];
    flightSteps!: FlightStepRequest[];
    adultCount!: number;
    childCount!: number;
    infantCount!: number;
    preferredCurrency?: string | null;
    mergeConnectorResults?: boolean | null;
    connectorCustomData?: FlightAvailabilityInputCustomData[] | null;
    customerCustomData?: CustomerCustomDataOfJupiterFlightAvailabilityInput | null;

    constructor(data?: IJupiterFlightAvailabilityInput) {
        super(data);
        if (!data) {
            this.connectorsSearch = [];
            this.flightSteps = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["ConnectorsSearch"])) {
                this.connectorsSearch = [] as any;
                for (let item of _data["ConnectorsSearch"])
                    this.connectorsSearch!.push(item);
            }
            else {
                this.connectorsSearch = null as any;
            }
            if (Array.isArray(_data["FlightSteps"])) {
                this.flightSteps = [] as any;
                for (let item of _data["FlightSteps"])
                    this.flightSteps!.push(FlightStepRequest.fromJS(item));
            }
            else {
                this.flightSteps = null as any;
            }
            this.adultCount = _data["AdultCount"] !== undefined ? _data["AdultCount"] : null as any;
            this.childCount = _data["ChildCount"] !== undefined ? _data["ChildCount"] : null as any;
            this.infantCount = _data["InfantCount"] !== undefined ? _data["InfantCount"] : null as any;
            this.preferredCurrency = _data["PreferredCurrency"] !== undefined ? _data["PreferredCurrency"] : null as any;
            this.mergeConnectorResults = _data["MergeConnectorResults"] !== undefined ? _data["MergeConnectorResults"] : null as any;
            if (Array.isArray(_data["ConnectorCustomData"])) {
                this.connectorCustomData = [] as any;
                for (let item of _data["ConnectorCustomData"])
                    this.connectorCustomData!.push(FlightAvailabilityInputCustomData.fromJS(item));
            }
            else {
                this.connectorCustomData = null as any;
            }
            this.customerCustomData = _data["CustomerCustomData"] ? CustomerCustomDataOfJupiterFlightAvailabilityInput.fromJS(_data["CustomerCustomData"]) : null as any;
        }
    }

    static override fromJS(data: any): JupiterFlightAvailabilityInput {
        data = typeof data === 'object' ? data : {};
        let result = new JupiterFlightAvailabilityInput();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.connectorsSearch)) {
            data["ConnectorsSearch"] = [];
            for (let item of this.connectorsSearch)
                data["ConnectorsSearch"].push(item);
        }
        if (Array.isArray(this.flightSteps)) {
            data["FlightSteps"] = [];
            for (let item of this.flightSteps)
                data["FlightSteps"].push(item ? item.toJSON() : null as any);
        }
        data["AdultCount"] = this.adultCount !== undefined ? this.adultCount : null as any;
        data["ChildCount"] = this.childCount !== undefined ? this.childCount : null as any;
        data["InfantCount"] = this.infantCount !== undefined ? this.infantCount : null as any;
        data["PreferredCurrency"] = this.preferredCurrency !== undefined ? this.preferredCurrency : null as any;
        data["MergeConnectorResults"] = this.mergeConnectorResults !== undefined ? this.mergeConnectorResults : null as any;
        if (Array.isArray(this.connectorCustomData)) {
            data["ConnectorCustomData"] = [];
            for (let item of this.connectorCustomData)
                data["ConnectorCustomData"].push(item ? item.toJSON() : null as any);
        }
        data["CustomerCustomData"] = this.customerCustomData ? this.customerCustomData.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IJupiterFlightAvailabilityInput extends IBaseInput {
    connectorsSearch: EH2HConnectorCode[];
    flightSteps: FlightStepRequest[];
    adultCount: number;
    childCount: number;
    infantCount: number;
    preferredCurrency?: string | null;
    mergeConnectorResults?: boolean | null;
    connectorCustomData?: FlightAvailabilityInputCustomData[] | null;
    customerCustomData?: CustomerCustomDataOfJupiterFlightAvailabilityInput | null;
}

export enum EH2HConnectorCode {
    UNKNOWN = "UNKNOWN",
    BOOKING_DOT_COM = "BOOKING_DOT_COM",
    SABRE_SYNXIS = "SABRE_SYNXIS",
    AMADEUS = "AMADEUS",
    SABRE = "SABRE",
    SABRE_CSL = "SABRE_CSL",
    CREOLE = "CREOLE",
    SANDALS = "SANDALS",
    TRAVELFUSION = "TRAVELFUSION",
    IHG_GRS = "IHG_GRS",
    OKKAMI = "OKKAMI",
    HOTELBEDS = "HOTELBEDS",
    EMINDS = "EMINDS",
    EXPEDIA = "EXPEDIA",
    TEKURA = "TEKURA",
    AIC = "AIC",
    ALLIED = "ALLIED",
    JTB = "JTB",
    HERTZ = "HERTZ",
    AMERICA_4_YOU = "AMERICA_4_YOU",
    TEAM_AMERICA = "TEAM_AMERICA",
    ARABIAN = "ARABIAN",
    JONVIEW = "JONVIEW",
    MECA = "MECA",
    ATI = "ATI",
    OLYMPIA = "OLYMPIA",
    PACIFIC_DESTINATIONS = "PACIFIC_DESTINATIONS",
    ROSIE = "ROSIE",
    RMH_TOURS = "RMH_TOURS",
    GO_WEST = "GO_WEST",
    AOT = "AOT",
    RESTEL = "RESTEL",
    TOURMAPPERS = "TOURMAPPERS",
    TRAVALCO = "TRAVALCO",
    WTS = "WTS",
    BONOTEL = "BONOTEL",
    ALAMO = "ALAMO",
    MSC = "MSC",
    BOOK_ME = "BOOK_ME",
    MAGIC_TRAVELS = "MAGIC_TRAVELS",
    CLUBMED = "CLUBMED",
    RIU = "RIU",
    KOEDIA = "KOEDIA",
    NTA = "NTA",
    RATE_HAWK = "RATE_HAWK",
    TRAVELGATE = "TRAVELGATE",
    PAN_PACIFIC = "PAN_PACIFIC",
    NET_STORMING = "NET_STORMING",
    HOTEL_TRADER = "HOTEL_TRADER",
    WONDERMILES = "WONDERMILES",
    TRAVELPORT = "TRAVELPORT",
    EXPEDIA_RAPID = "EXPEDIA_RAPID",
    WEBBEDS = "WEBBEDS",
    GO_WAY = "GO_WAY",
    GO_GLOBAL = "GO_GLOBAL",
    HDR = "HDR",
    HYPER_GUEST = "HYPER_GUEST",
    A_SAMPLE = "A_SAMPLE",
}

export class FlightStepRequest implements IFlightStepRequest {
    departureDate!: string;
    departureTime?: string | null;
    departureTimeWindow?: number | null;
    cabin?: EFlightCabin | null;
    enableJumpCabin?: boolean | null;
    departureAirport!: string;
    arrivalAirport!: string;
    excludedCarriers?: string[] | null;
    includedCarriers?: string[] | null;
    onlyDirectFlights?: boolean | null;
    baggageIncluded?: boolean | null;
    connectorCustomData?: FlightStepRequestCustomData[] | null;

    constructor(data?: IFlightStepRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departureDate = _data["DepartureDate"] !== undefined ? _data["DepartureDate"] : null as any;
            this.departureTime = _data["DepartureTime"] !== undefined ? _data["DepartureTime"] : null as any;
            this.departureTimeWindow = _data["DepartureTimeWindow"] !== undefined ? _data["DepartureTimeWindow"] : null as any;
            this.cabin = _data["Cabin"] !== undefined ? _data["Cabin"] : null as any;
            this.enableJumpCabin = _data["EnableJumpCabin"] !== undefined ? _data["EnableJumpCabin"] : null as any;
            this.departureAirport = _data["DepartureAirport"] !== undefined ? _data["DepartureAirport"] : null as any;
            this.arrivalAirport = _data["ArrivalAirport"] !== undefined ? _data["ArrivalAirport"] : null as any;
            if (Array.isArray(_data["ExcludedCarriers"])) {
                this.excludedCarriers = [] as any;
                for (let item of _data["ExcludedCarriers"])
                    this.excludedCarriers!.push(item);
            }
            else {
                this.excludedCarriers = null as any;
            }
            if (Array.isArray(_data["IncludedCarriers"])) {
                this.includedCarriers = [] as any;
                for (let item of _data["IncludedCarriers"])
                    this.includedCarriers!.push(item);
            }
            else {
                this.includedCarriers = null as any;
            }
            this.onlyDirectFlights = _data["OnlyDirectFlights"] !== undefined ? _data["OnlyDirectFlights"] : null as any;
            this.baggageIncluded = _data["BaggageIncluded"] !== undefined ? _data["BaggageIncluded"] : null as any;
            if (Array.isArray(_data["ConnectorCustomData"])) {
                this.connectorCustomData = [] as any;
                for (let item of _data["ConnectorCustomData"])
                    this.connectorCustomData!.push(FlightStepRequestCustomData.fromJS(item));
            }
            else {
                this.connectorCustomData = null as any;
            }
        }
    }

    static fromJS(data: any): FlightStepRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FlightStepRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DepartureDate"] = this.departureDate !== undefined ? this.departureDate : null as any;
        data["DepartureTime"] = this.departureTime !== undefined ? this.departureTime : null as any;
        data["DepartureTimeWindow"] = this.departureTimeWindow !== undefined ? this.departureTimeWindow : null as any;
        data["Cabin"] = this.cabin !== undefined ? this.cabin : null as any;
        data["EnableJumpCabin"] = this.enableJumpCabin !== undefined ? this.enableJumpCabin : null as any;
        data["DepartureAirport"] = this.departureAirport !== undefined ? this.departureAirport : null as any;
        data["ArrivalAirport"] = this.arrivalAirport !== undefined ? this.arrivalAirport : null as any;
        if (Array.isArray(this.excludedCarriers)) {
            data["ExcludedCarriers"] = [];
            for (let item of this.excludedCarriers)
                data["ExcludedCarriers"].push(item);
        }
        if (Array.isArray(this.includedCarriers)) {
            data["IncludedCarriers"] = [];
            for (let item of this.includedCarriers)
                data["IncludedCarriers"].push(item);
        }
        data["OnlyDirectFlights"] = this.onlyDirectFlights !== undefined ? this.onlyDirectFlights : null as any;
        data["BaggageIncluded"] = this.baggageIncluded !== undefined ? this.baggageIncluded : null as any;
        if (Array.isArray(this.connectorCustomData)) {
            data["ConnectorCustomData"] = [];
            for (let item of this.connectorCustomData)
                data["ConnectorCustomData"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IFlightStepRequest {
    departureDate: string;
    departureTime?: string | null;
    departureTimeWindow?: number | null;
    cabin?: EFlightCabin | null;
    enableJumpCabin?: boolean | null;
    departureAirport: string;
    arrivalAirport: string;
    excludedCarriers?: string[] | null;
    includedCarriers?: string[] | null;
    onlyDirectFlights?: boolean | null;
    baggageIncluded?: boolean | null;
    connectorCustomData?: FlightStepRequestCustomData[] | null;
}

export enum EFlightCabin {
    ECONOMY = "ECONOMY",
    PREMIUM_ECONOMY = "PREMIUM_ECONOMY",
    BUSINESS = "BUSINESS",
    PREMIUM_BUSINESS = "PREMIUM_BUSINESS",
    FIRST = "FIRST",
    PREMIUM_FIRST = "PREMIUM_FIRST",
}

export abstract class FlightStepRequestCustomData implements IFlightStepRequestCustomData {

    protected _discriminator: string;

    constructor(data?: IFlightStepRequestCustomData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "FlightStepRequestCustomData";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): FlightStepRequestCustomData {
        data = typeof data === 'object' ? data : {};
        if (data["CustomDataConnectorCode"] === "AMADEUS") {
            let result = new AmadeusFlightStepRequestCustomData();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'FlightStepRequestCustomData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomDataConnectorCode"] = this._discriminator;
        return data;
    }
}

export interface IFlightStepRequestCustomData {
}

export class AmadeusFlightStepRequestCustomData extends FlightStepRequestCustomData implements IAmadeusFlightStepRequestCustomData {
    maxStopsQuantity?: number | null;

    constructor(data?: IAmadeusFlightStepRequestCustomData) {
        super(data);
        this._discriminator = "AMADEUS";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.maxStopsQuantity = _data["MaxStopsQuantity"] !== undefined ? _data["MaxStopsQuantity"] : null as any;
        }
    }

    static override fromJS(data: any): AmadeusFlightStepRequestCustomData {
        data = typeof data === 'object' ? data : {};
        let result = new AmadeusFlightStepRequestCustomData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MaxStopsQuantity"] = this.maxStopsQuantity !== undefined ? this.maxStopsQuantity : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAmadeusFlightStepRequestCustomData extends IFlightStepRequestCustomData {
    maxStopsQuantity?: number | null;
}

export abstract class FlightAvailabilityInputCustomData implements IFlightAvailabilityInputCustomData {
    accountCodes?: string[] | null;

    protected _discriminator: string;

    constructor(data?: IFlightAvailabilityInputCustomData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "FlightAvailabilityInputCustomData";
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["AccountCodes"])) {
                this.accountCodes = [] as any;
                for (let item of _data["AccountCodes"])
                    this.accountCodes!.push(item);
            }
            else {
                this.accountCodes = null as any;
            }
        }
    }

    static fromJS(data: any): FlightAvailabilityInputCustomData {
        data = typeof data === 'object' ? data : {};
        if (data["CustomDataConnectorCode"] === "AMADEUS") {
            let result = new AmadeusFlightAvailabilityInputCustomData();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'FlightAvailabilityInputCustomData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomDataConnectorCode"] = this._discriminator;
        if (Array.isArray(this.accountCodes)) {
            data["AccountCodes"] = [];
            for (let item of this.accountCodes)
                data["AccountCodes"].push(item);
        }
        return data;
    }
}

export interface IFlightAvailabilityInputCustomData {
    accountCodes?: string[] | null;
}

export class AmadeusFlightAvailabilityInputCustomData extends FlightAvailabilityInputCustomData implements IAmadeusFlightAvailabilityInputCustomData {
    amadeusSession?: AmadeusGdsSessionCustomData | null;
    isExpertSearch?: boolean | null;
    enableFareFamilies?: boolean | null;
    enableMiniRule?: boolean | null;
    onlyNdc?: boolean | null;
    includeNdc?: boolean | null;
    refundableFares?: boolean | null;
    exchangeableFares?: boolean | null;
    noAdvancedPurchaseFares?: boolean | null;
    noRestrictionFares?: boolean | null;
    includedAlliances?: string[] | null;
    excludedAlliances?: string[] | null;
    maxConnectionMinutes?: number | null;
    minimumConnectionMinutes?: number | null;
    getPureSolutions?: boolean | null;
    priceTypeList?: string[] | null;
    recommendationNumberOfUnits?: number | null;

    constructor(data?: IAmadeusFlightAvailabilityInputCustomData) {
        super(data);
        this._discriminator = "AMADEUS";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.amadeusSession = _data["AmadeusSession"] ? AmadeusGdsSessionCustomData.fromJS(_data["AmadeusSession"]) : null as any;
            this.isExpertSearch = _data["IsExpertSearch"] !== undefined ? _data["IsExpertSearch"] : null as any;
            this.enableFareFamilies = _data["EnableFareFamilies"] !== undefined ? _data["EnableFareFamilies"] : null as any;
            this.enableMiniRule = _data["EnableMiniRule"] !== undefined ? _data["EnableMiniRule"] : null as any;
            this.onlyNdc = _data["OnlyNdc"] !== undefined ? _data["OnlyNdc"] : null as any;
            this.includeNdc = _data["IncludeNdc"] !== undefined ? _data["IncludeNdc"] : null as any;
            this.refundableFares = _data["RefundableFares"] !== undefined ? _data["RefundableFares"] : null as any;
            this.exchangeableFares = _data["ExchangeableFares"] !== undefined ? _data["ExchangeableFares"] : null as any;
            this.noAdvancedPurchaseFares = _data["NoAdvancedPurchaseFares"] !== undefined ? _data["NoAdvancedPurchaseFares"] : null as any;
            this.noRestrictionFares = _data["NoRestrictionFares"] !== undefined ? _data["NoRestrictionFares"] : null as any;
            if (Array.isArray(_data["IncludedAlliances"])) {
                this.includedAlliances = [] as any;
                for (let item of _data["IncludedAlliances"])
                    this.includedAlliances!.push(item);
            }
            else {
                this.includedAlliances = null as any;
            }
            if (Array.isArray(_data["ExcludedAlliances"])) {
                this.excludedAlliances = [] as any;
                for (let item of _data["ExcludedAlliances"])
                    this.excludedAlliances!.push(item);
            }
            else {
                this.excludedAlliances = null as any;
            }
            this.maxConnectionMinutes = _data["MaxConnectionMinutes"] !== undefined ? _data["MaxConnectionMinutes"] : null as any;
            this.minimumConnectionMinutes = _data["MinimumConnectionMinutes"] !== undefined ? _data["MinimumConnectionMinutes"] : null as any;
            this.getPureSolutions = _data["GetPureSolutions"] !== undefined ? _data["GetPureSolutions"] : null as any;
            if (Array.isArray(_data["PriceTypeList"])) {
                this.priceTypeList = [] as any;
                for (let item of _data["PriceTypeList"])
                    this.priceTypeList!.push(item);
            }
            else {
                this.priceTypeList = null as any;
            }
            this.recommendationNumberOfUnits = _data["RecommendationNumberOfUnits"] !== undefined ? _data["RecommendationNumberOfUnits"] : null as any;
        }
    }

    static override fromJS(data: any): AmadeusFlightAvailabilityInputCustomData {
        data = typeof data === 'object' ? data : {};
        let result = new AmadeusFlightAvailabilityInputCustomData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AmadeusSession"] = this.amadeusSession ? this.amadeusSession.toJSON() : null as any;
        data["IsExpertSearch"] = this.isExpertSearch !== undefined ? this.isExpertSearch : null as any;
        data["EnableFareFamilies"] = this.enableFareFamilies !== undefined ? this.enableFareFamilies : null as any;
        data["EnableMiniRule"] = this.enableMiniRule !== undefined ? this.enableMiniRule : null as any;
        data["OnlyNdc"] = this.onlyNdc !== undefined ? this.onlyNdc : null as any;
        data["IncludeNdc"] = this.includeNdc !== undefined ? this.includeNdc : null as any;
        data["RefundableFares"] = this.refundableFares !== undefined ? this.refundableFares : null as any;
        data["ExchangeableFares"] = this.exchangeableFares !== undefined ? this.exchangeableFares : null as any;
        data["NoAdvancedPurchaseFares"] = this.noAdvancedPurchaseFares !== undefined ? this.noAdvancedPurchaseFares : null as any;
        data["NoRestrictionFares"] = this.noRestrictionFares !== undefined ? this.noRestrictionFares : null as any;
        if (Array.isArray(this.includedAlliances)) {
            data["IncludedAlliances"] = [];
            for (let item of this.includedAlliances)
                data["IncludedAlliances"].push(item);
        }
        if (Array.isArray(this.excludedAlliances)) {
            data["ExcludedAlliances"] = [];
            for (let item of this.excludedAlliances)
                data["ExcludedAlliances"].push(item);
        }
        data["MaxConnectionMinutes"] = this.maxConnectionMinutes !== undefined ? this.maxConnectionMinutes : null as any;
        data["MinimumConnectionMinutes"] = this.minimumConnectionMinutes !== undefined ? this.minimumConnectionMinutes : null as any;
        data["GetPureSolutions"] = this.getPureSolutions !== undefined ? this.getPureSolutions : null as any;
        if (Array.isArray(this.priceTypeList)) {
            data["PriceTypeList"] = [];
            for (let item of this.priceTypeList)
                data["PriceTypeList"].push(item);
        }
        data["RecommendationNumberOfUnits"] = this.recommendationNumberOfUnits !== undefined ? this.recommendationNumberOfUnits : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAmadeusFlightAvailabilityInputCustomData extends IFlightAvailabilityInputCustomData {
    amadeusSession?: AmadeusGdsSessionCustomData | null;
    isExpertSearch?: boolean | null;
    enableFareFamilies?: boolean | null;
    enableMiniRule?: boolean | null;
    onlyNdc?: boolean | null;
    includeNdc?: boolean | null;
    refundableFares?: boolean | null;
    exchangeableFares?: boolean | null;
    noAdvancedPurchaseFares?: boolean | null;
    noRestrictionFares?: boolean | null;
    includedAlliances?: string[] | null;
    excludedAlliances?: string[] | null;
    maxConnectionMinutes?: number | null;
    minimumConnectionMinutes?: number | null;
    getPureSolutions?: boolean | null;
    priceTypeList?: string[] | null;
    recommendationNumberOfUnits?: number | null;
}

export abstract class GdsSessionCustomData implements IGdsSessionCustomData {

    protected _discriminator: string;

    constructor(data?: IGdsSessionCustomData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "GdsSessionCustomData";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GdsSessionCustomData {
        data = typeof data === 'object' ? data : {};
        if (data["CustomDataConnectorCode"] === "AMADEUS") {
            let result = new AmadeusGdsSessionCustomData();
            result.init(data);
            return result;
        }
        if (data["CustomDataConnectorCode"] === "SABRE") {
            let result = new SabreGdsSessionCustomData();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'GdsSessionCustomData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomDataConnectorCode"] = this._discriminator;
        return data;
    }
}

export interface IGdsSessionCustomData {
}

export class AmadeusGdsSessionCustomData extends GdsSessionCustomData implements IAmadeusGdsSessionCustomData {
    sessionId?: string | null;
    sessionStatus?: EAmadeusSessionStatus | null;
    sequenceNumber?: number | null;
    securityToken?: string | null;

    constructor(data?: IAmadeusGdsSessionCustomData) {
        super(data);
        this._discriminator = "AMADEUS";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sessionId = _data["SessionId"] !== undefined ? _data["SessionId"] : null as any;
            this.sessionStatus = _data["SessionStatus"] !== undefined ? _data["SessionStatus"] : null as any;
            this.sequenceNumber = _data["SequenceNumber"] !== undefined ? _data["SequenceNumber"] : null as any;
            this.securityToken = _data["SecurityToken"] !== undefined ? _data["SecurityToken"] : null as any;
        }
    }

    static override fromJS(data: any): AmadeusGdsSessionCustomData {
        data = typeof data === 'object' ? data : {};
        let result = new AmadeusGdsSessionCustomData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SessionId"] = this.sessionId !== undefined ? this.sessionId : null as any;
        data["SessionStatus"] = this.sessionStatus !== undefined ? this.sessionStatus : null as any;
        data["SequenceNumber"] = this.sequenceNumber !== undefined ? this.sequenceNumber : null as any;
        data["SecurityToken"] = this.securityToken !== undefined ? this.securityToken : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAmadeusGdsSessionCustomData extends IGdsSessionCustomData {
    sessionId?: string | null;
    sessionStatus?: EAmadeusSessionStatus | null;
    sequenceNumber?: number | null;
    securityToken?: string | null;
}

export enum EAmadeusSessionStatus {
    START = "START",
    END = "END",
    IN_SERIES = "IN_SERIES",
}

export class SabreGdsSessionCustomData extends GdsSessionCustomData implements ISabreGdsSessionCustomData {
    id?: string | null;
    type?: ESabreSessionType | null;
    environment?: string | null;
    status?: ESabreSessionStatus | null;
    lastCallUtc?: string | null;
    binarySecurityToken?: string | null;
    conversationId?: string | null;
    processId?: string | null;

    constructor(data?: ISabreGdsSessionCustomData) {
        super(data);
        this._discriminator = "SABRE";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"] !== undefined ? _data["Id"] : null as any;
            this.type = _data["Type"] !== undefined ? _data["Type"] : null as any;
            this.environment = _data["Environment"] !== undefined ? _data["Environment"] : null as any;
            this.status = _data["Status"] !== undefined ? _data["Status"] : null as any;
            this.lastCallUtc = _data["LastCallUtc"] !== undefined ? _data["LastCallUtc"] : null as any;
            this.binarySecurityToken = _data["BinarySecurityToken"] !== undefined ? _data["BinarySecurityToken"] : null as any;
            this.conversationId = _data["ConversationId"] !== undefined ? _data["ConversationId"] : null as any;
            this.processId = _data["ProcessId"] !== undefined ? _data["ProcessId"] : null as any;
        }
    }

    static override fromJS(data: any): SabreGdsSessionCustomData {
        data = typeof data === 'object' ? data : {};
        let result = new SabreGdsSessionCustomData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id !== undefined ? this.id : null as any;
        data["Type"] = this.type !== undefined ? this.type : null as any;
        data["Environment"] = this.environment !== undefined ? this.environment : null as any;
        data["Status"] = this.status !== undefined ? this.status : null as any;
        data["LastCallUtc"] = this.lastCallUtc !== undefined ? this.lastCallUtc : null as any;
        data["BinarySecurityToken"] = this.binarySecurityToken !== undefined ? this.binarySecurityToken : null as any;
        data["ConversationId"] = this.conversationId !== undefined ? this.conversationId : null as any;
        data["ProcessId"] = this.processId !== undefined ? this.processId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISabreGdsSessionCustomData extends IGdsSessionCustomData {
    id?: string | null;
    type?: ESabreSessionType | null;
    environment?: string | null;
    status?: ESabreSessionStatus | null;
    lastCallUtc?: string | null;
    binarySecurityToken?: string | null;
    conversationId?: string | null;
    processId?: string | null;
}

export enum ESabreSessionType {
    SESSION = "SESSION",
    TOKEN = "TOKEN",
}

export enum ESabreSessionStatus {
    AVAILABLE = "AVAILABLE",
    BUSY = "BUSY",
    CLOSED = "CLOSED",
}

export abstract class CustomerCustomDataOfJupiterFlightAvailabilityInput implements ICustomerCustomDataOfJupiterFlightAvailabilityInput {

    protected _discriminator: string;

    constructor(data?: ICustomerCustomDataOfJupiterFlightAvailabilityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "CustomerCustomDataOfJupiterFlightAvailabilityInput";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CustomerCustomDataOfJupiterFlightAvailabilityInput {
        data = typeof data === 'object' ? data : {};
        if (data["CustomDataCode"] === "FlightAvailNaarData") {
            let result = new FlightAvailNaarData();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'CustomerCustomDataOfJupiterFlightAvailabilityInput' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomDataCode"] = this._discriminator;
        return data;
    }
}

export interface ICustomerCustomDataOfJupiterFlightAvailabilityInput {
}

export class FlightAvailNaarData extends CustomerCustomDataOfJupiterFlightAvailabilityInput implements IFlightAvailNaarData {
    markupData?: MarkupData | null;

    constructor(data?: IFlightAvailNaarData) {
        super(data);
        this._discriminator = "FlightAvailNaarData";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.markupData = _data["MarkupData"] ? MarkupData.fromJS(_data["MarkupData"]) : null as any;
        }
    }

    static override fromJS(data: any): FlightAvailNaarData {
        data = typeof data === 'object' ? data : {};
        let result = new FlightAvailNaarData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MarkupData"] = this.markupData ? this.markupData.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IFlightAvailNaarData extends ICustomerCustomDataOfJupiterFlightAvailabilityInput {
    markupData?: MarkupData | null;
}

export class MarkupData implements IMarkupData {
    markupFlightFareIT?: number | null;
    markupFlightFareIP?: number | null;
    markupFlightTax?: number | null;

    constructor(data?: IMarkupData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.markupFlightFareIT = _data["MarkupFlightFareIT"] !== undefined ? _data["MarkupFlightFareIT"] : null as any;
            this.markupFlightFareIP = _data["MarkupFlightFareIP"] !== undefined ? _data["MarkupFlightFareIP"] : null as any;
            this.markupFlightTax = _data["MarkupFlightTax"] !== undefined ? _data["MarkupFlightTax"] : null as any;
        }
    }

    static fromJS(data: any): MarkupData {
        data = typeof data === 'object' ? data : {};
        let result = new MarkupData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MarkupFlightFareIT"] = this.markupFlightFareIT !== undefined ? this.markupFlightFareIT : null as any;
        data["MarkupFlightFareIP"] = this.markupFlightFareIP !== undefined ? this.markupFlightFareIP : null as any;
        data["MarkupFlightTax"] = this.markupFlightTax !== undefined ? this.markupFlightTax : null as any;
        return data;
    }
}

export interface IMarkupData {
    markupFlightFareIT?: number | null;
    markupFlightFareIP?: number | null;
    markupFlightTax?: number | null;
}

export class ConnectorEnvironment implements IConnectorEnvironment {
    connectorCode?: EH2HConnectorCode | null;
    environment?: string | null;

    constructor(data?: IConnectorEnvironment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectorCode = _data["ConnectorCode"] !== undefined ? _data["ConnectorCode"] : null as any;
            this.environment = _data["Environment"] !== undefined ? _data["Environment"] : null as any;
        }
    }

    static fromJS(data: any): ConnectorEnvironment {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectorEnvironment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ConnectorCode"] = this.connectorCode !== undefined ? this.connectorCode : null as any;
        data["Environment"] = this.environment !== undefined ? this.environment : null as any;
        return data;
    }
}

export interface IConnectorEnvironment {
    connectorCode?: EH2HConnectorCode | null;
    environment?: string | null;
}

export abstract class BaseRS implements IBaseRS {
    pid?: string | null;
    status?: EOperationStatus | null;
    messages?: Message[] | null;
    connectorsResponseDetails?: ConnectorResponseDetails[] | null;

    constructor(data?: IBaseRS) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pid = _data["Pid"] !== undefined ? _data["Pid"] : null as any;
            this.status = _data["Status"] !== undefined ? _data["Status"] : null as any;
            if (Array.isArray(_data["Messages"])) {
                this.messages = [] as any;
                for (let item of _data["Messages"])
                    this.messages!.push(Message.fromJS(item));
            }
            else {
                this.messages = null as any;
            }
            if (Array.isArray(_data["ConnectorsResponseDetails"])) {
                this.connectorsResponseDetails = [] as any;
                for (let item of _data["ConnectorsResponseDetails"])
                    this.connectorsResponseDetails!.push(ConnectorResponseDetails.fromJS(item));
            }
            else {
                this.connectorsResponseDetails = null as any;
            }
        }
    }

    static fromJS(data: any): BaseRS {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseRS' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Pid"] = this.pid !== undefined ? this.pid : null as any;
        data["Status"] = this.status !== undefined ? this.status : null as any;
        if (Array.isArray(this.messages)) {
            data["Messages"] = [];
            for (let item of this.messages)
                data["Messages"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.connectorsResponseDetails)) {
            data["ConnectorsResponseDetails"] = [];
            for (let item of this.connectorsResponseDetails)
                data["ConnectorsResponseDetails"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IBaseRS {
    pid?: string | null;
    status?: EOperationStatus | null;
    messages?: Message[] | null;
    connectorsResponseDetails?: ConnectorResponseDetails[] | null;
}

export abstract class BaseCacheableRS extends BaseRS implements IBaseCacheableRS {
    cacheResponseInfo?: CacheResponseInfo | null;

    constructor(data?: IBaseCacheableRS) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cacheResponseInfo = _data["CacheResponseInfo"] ? CacheResponseInfo.fromJS(_data["CacheResponseInfo"]) : null as any;
        }
    }

    static override fromJS(data: any): BaseCacheableRS {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCacheableRS' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CacheResponseInfo"] = this.cacheResponseInfo ? this.cacheResponseInfo.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IBaseCacheableRS extends IBaseRS {
    cacheResponseInfo?: CacheResponseInfo | null;
}

export class JupiterFlightAvailabilityRS extends BaseCacheableRS implements IJupiterFlightAvailabilityRS {
    response?: JupiterFlightAvailabilityOutput | null;

    constructor(data?: IJupiterFlightAvailabilityRS) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.response = _data["Response"] ? JupiterFlightAvailabilityOutput.fromJS(_data["Response"]) : null as any;
        }
    }

    static override fromJS(data: any): JupiterFlightAvailabilityRS {
        data = typeof data === 'object' ? data : {};
        let result = new JupiterFlightAvailabilityRS();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Response"] = this.response ? this.response.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IJupiterFlightAvailabilityRS extends IBaseCacheableRS {
    response?: JupiterFlightAvailabilityOutput | null;
}

export abstract class BaseOutput implements IBaseOutput {

    constructor(data?: IBaseOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): BaseOutput {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseOutput' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IBaseOutput {
}

export class JupiterFlightAvailabilityOutput extends BaseOutput implements IJupiterFlightAvailabilityOutput {
    flightResults?: SingleFlightAvailResult[] | null;
    connectorCustomData?: FlightAvailabilityOutputCustomData[] | null;

    constructor(data?: IJupiterFlightAvailabilityOutput) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["FlightResults"])) {
                this.flightResults = [] as any;
                for (let item of _data["FlightResults"])
                    this.flightResults!.push(SingleFlightAvailResult.fromJS(item));
            }
            else {
                this.flightResults = null as any;
            }
            if (Array.isArray(_data["ConnectorCustomData"])) {
                this.connectorCustomData = [] as any;
                for (let item of _data["ConnectorCustomData"])
                    this.connectorCustomData!.push(FlightAvailabilityOutputCustomData.fromJS(item));
            }
            else {
                this.connectorCustomData = null as any;
            }
        }
    }

    static override fromJS(data: any): JupiterFlightAvailabilityOutput {
        data = typeof data === 'object' ? data : {};
        let result = new JupiterFlightAvailabilityOutput();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.flightResults)) {
            data["FlightResults"] = [];
            for (let item of this.flightResults)
                data["FlightResults"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.connectorCustomData)) {
            data["ConnectorCustomData"] = [];
            for (let item of this.connectorCustomData)
                data["ConnectorCustomData"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IJupiterFlightAvailabilityOutput extends IBaseOutput {
    flightResults?: SingleFlightAvailResult[] | null;
    connectorCustomData?: FlightAvailabilityOutputCustomData[] | null;
}

export class SingleFlightAvailResult implements ISingleFlightAvailResult {
    id?: string | null;
    resultKey?: string | null;
    routingKey?: string | null;
    isPure?: boolean | null;
    codeShareKey?: string | null;
    flightSegments?: FlightSegmentResult[] | null;
    totalDuration?: string | null;
    fareList?: FlightFareGroupResult[] | null;

    constructor(data?: ISingleFlightAvailResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"] !== undefined ? _data["Id"] : null as any;
            this.resultKey = _data["ResultKey"] !== undefined ? _data["ResultKey"] : null as any;
            this.routingKey = _data["RoutingKey"] !== undefined ? _data["RoutingKey"] : null as any;
            this.isPure = _data["IsPure"] !== undefined ? _data["IsPure"] : null as any;
            this.codeShareKey = _data["CodeShareKey"] !== undefined ? _data["CodeShareKey"] : null as any;
            if (Array.isArray(_data["FlightSegments"])) {
                this.flightSegments = [] as any;
                for (let item of _data["FlightSegments"])
                    this.flightSegments!.push(FlightSegmentResult.fromJS(item));
            }
            else {
                this.flightSegments = null as any;
            }
            this.totalDuration = _data["TotalDuration"] !== undefined ? _data["TotalDuration"] : null as any;
            if (Array.isArray(_data["FareList"])) {
                this.fareList = [] as any;
                for (let item of _data["FareList"])
                    this.fareList!.push(FlightFareGroupResult.fromJS(item));
            }
            else {
                this.fareList = null as any;
            }
        }
    }

    static fromJS(data: any): SingleFlightAvailResult {
        data = typeof data === 'object' ? data : {};
        let result = new SingleFlightAvailResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id !== undefined ? this.id : null as any;
        data["ResultKey"] = this.resultKey !== undefined ? this.resultKey : null as any;
        data["RoutingKey"] = this.routingKey !== undefined ? this.routingKey : null as any;
        data["IsPure"] = this.isPure !== undefined ? this.isPure : null as any;
        data["CodeShareKey"] = this.codeShareKey !== undefined ? this.codeShareKey : null as any;
        if (Array.isArray(this.flightSegments)) {
            data["FlightSegments"] = [];
            for (let item of this.flightSegments)
                data["FlightSegments"].push(item ? item.toJSON() : null as any);
        }
        data["TotalDuration"] = this.totalDuration !== undefined ? this.totalDuration : null as any;
        if (Array.isArray(this.fareList)) {
            data["FareList"] = [];
            for (let item of this.fareList)
                data["FareList"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ISingleFlightAvailResult {
    id?: string | null;
    resultKey?: string | null;
    routingKey?: string | null;
    isPure?: boolean | null;
    codeShareKey?: string | null;
    flightSegments?: FlightSegmentResult[] | null;
    totalDuration?: string | null;
    fareList?: FlightFareGroupResult[] | null;
}

export class FlightSegment implements IFlightSegment {
    id?: string | null;
    segmentKey?: string | null;
    segmentRoutingKey?: string | null;
    isPure?: boolean | null;
    stepGroupId?: string | null;
    connectionTime?: string | null;
    departureDate?: string | null;
    departureAirport?: AirportTerminal | null;
    arrivalDate?: string | null;
    arrivalAirport?: AirportTerminal | null;
    duration?: string | null;
    marketingCarrier?: FlightCarrier | null;
    operatingCarrier?: FlightCarrier | null;
    aircraft?: Aircraft | null;
    technicalStops?: FlightStop[] | null;

    constructor(data?: IFlightSegment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"] !== undefined ? _data["Id"] : null as any;
            this.segmentKey = _data["SegmentKey"] !== undefined ? _data["SegmentKey"] : null as any;
            this.segmentRoutingKey = _data["SegmentRoutingKey"] !== undefined ? _data["SegmentRoutingKey"] : null as any;
            this.isPure = _data["IsPure"] !== undefined ? _data["IsPure"] : null as any;
            this.stepGroupId = _data["StepGroupId"] !== undefined ? _data["StepGroupId"] : null as any;
            this.connectionTime = _data["ConnectionTime"] !== undefined ? _data["ConnectionTime"] : null as any;
            this.departureDate = _data["DepartureDate"] !== undefined ? _data["DepartureDate"] : null as any;
            this.departureAirport = _data["DepartureAirport"] ? AirportTerminal.fromJS(_data["DepartureAirport"]) : null as any;
            this.arrivalDate = _data["ArrivalDate"] !== undefined ? _data["ArrivalDate"] : null as any;
            this.arrivalAirport = _data["ArrivalAirport"] ? AirportTerminal.fromJS(_data["ArrivalAirport"]) : null as any;
            this.duration = _data["Duration"] !== undefined ? _data["Duration"] : null as any;
            this.marketingCarrier = _data["MarketingCarrier"] ? FlightCarrier.fromJS(_data["MarketingCarrier"]) : null as any;
            this.operatingCarrier = _data["OperatingCarrier"] ? FlightCarrier.fromJS(_data["OperatingCarrier"]) : null as any;
            this.aircraft = _data["Aircraft"] ? Aircraft.fromJS(_data["Aircraft"]) : null as any;
            if (Array.isArray(_data["TechnicalStops"])) {
                this.technicalStops = [] as any;
                for (let item of _data["TechnicalStops"])
                    this.technicalStops!.push(FlightStop.fromJS(item));
            }
            else {
                this.technicalStops = null as any;
            }
        }
    }

    static fromJS(data: any): FlightSegment {
        data = typeof data === 'object' ? data : {};
        let result = new FlightSegment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id !== undefined ? this.id : null as any;
        data["SegmentKey"] = this.segmentKey !== undefined ? this.segmentKey : null as any;
        data["SegmentRoutingKey"] = this.segmentRoutingKey !== undefined ? this.segmentRoutingKey : null as any;
        data["IsPure"] = this.isPure !== undefined ? this.isPure : null as any;
        data["StepGroupId"] = this.stepGroupId !== undefined ? this.stepGroupId : null as any;
        data["ConnectionTime"] = this.connectionTime !== undefined ? this.connectionTime : null as any;
        data["DepartureDate"] = this.departureDate !== undefined ? this.departureDate : null as any;
        data["DepartureAirport"] = this.departureAirport ? this.departureAirport.toJSON() : null as any;
        data["ArrivalDate"] = this.arrivalDate !== undefined ? this.arrivalDate : null as any;
        data["ArrivalAirport"] = this.arrivalAirport ? this.arrivalAirport.toJSON() : null as any;
        data["Duration"] = this.duration !== undefined ? this.duration : null as any;
        data["MarketingCarrier"] = this.marketingCarrier ? this.marketingCarrier.toJSON() : null as any;
        data["OperatingCarrier"] = this.operatingCarrier ? this.operatingCarrier.toJSON() : null as any;
        data["Aircraft"] = this.aircraft ? this.aircraft.toJSON() : null as any;
        if (Array.isArray(this.technicalStops)) {
            data["TechnicalStops"] = [];
            for (let item of this.technicalStops)
                data["TechnicalStops"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IFlightSegment {
    id?: string | null;
    segmentKey?: string | null;
    segmentRoutingKey?: string | null;
    isPure?: boolean | null;
    stepGroupId?: string | null;
    connectionTime?: string | null;
    departureDate?: string | null;
    departureAirport?: AirportTerminal | null;
    arrivalDate?: string | null;
    arrivalAirport?: AirportTerminal | null;
    duration?: string | null;
    marketingCarrier?: FlightCarrier | null;
    operatingCarrier?: FlightCarrier | null;
    aircraft?: Aircraft | null;
    technicalStops?: FlightStop[] | null;
}

export class FlightSegmentResult extends FlightSegment implements IFlightSegmentResult {
    connectorCustomData?: FlightSegmentResultCustomData[] | null;

    constructor(data?: IFlightSegmentResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["ConnectorCustomData"])) {
                this.connectorCustomData = [] as any;
                for (let item of _data["ConnectorCustomData"])
                    this.connectorCustomData!.push(FlightSegmentResultCustomData.fromJS(item));
            }
            else {
                this.connectorCustomData = null as any;
            }
        }
    }

    static override fromJS(data: any): FlightSegmentResult {
        data = typeof data === 'object' ? data : {};
        let result = new FlightSegmentResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.connectorCustomData)) {
            data["ConnectorCustomData"] = [];
            for (let item of this.connectorCustomData)
                data["ConnectorCustomData"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFlightSegmentResult extends IFlightSegment {
    connectorCustomData?: FlightSegmentResultCustomData[] | null;
}

export abstract class FlightSegmentResultCustomData implements IFlightSegmentResultCustomData {

    protected _discriminator: string;

    constructor(data?: IFlightSegmentResultCustomData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "FlightSegmentResultCustomData";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): FlightSegmentResultCustomData {
        data = typeof data === 'object' ? data : {};
        if (data["CustomDataConnectorCode"] === "SABRE") {
            let result = new SabreFlightSegmentResultCustomData();
            result.init(data);
            return result;
        }
        if (data["CustomDataConnectorCode"] === "AMADEUS") {
            let result = new AmadeusFlightSegmentResultCustomData();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'FlightSegmentResultCustomData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomDataConnectorCode"] = this._discriminator;
        return data;
    }
}

export interface IFlightSegmentResultCustomData {
}

export class SabreFlightSegmentResultCustomData extends FlightSegmentResultCustomData implements ISabreFlightSegmentResultCustomData {
    marriageGrp?: string | null;

    constructor(data?: ISabreFlightSegmentResultCustomData) {
        super(data);
        this._discriminator = "SABRE";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.marriageGrp = _data["MarriageGrp"] !== undefined ? _data["MarriageGrp"] : null as any;
        }
    }

    static override fromJS(data: any): SabreFlightSegmentResultCustomData {
        data = typeof data === 'object' ? data : {};
        let result = new SabreFlightSegmentResultCustomData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MarriageGrp"] = this.marriageGrp !== undefined ? this.marriageGrp : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISabreFlightSegmentResultCustomData extends IFlightSegmentResultCustomData {
    marriageGrp?: string | null;
}

export class AmadeusFlightSegmentResultCustomData extends FlightSegmentResultCustomData implements IAmadeusFlightSegmentResultCustomData {
    flightProposalRef?: string | null;
    flightIndex?: string | null;

    constructor(data?: IAmadeusFlightSegmentResultCustomData) {
        super(data);
        this._discriminator = "AMADEUS";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.flightProposalRef = _data["FlightProposalRef"] !== undefined ? _data["FlightProposalRef"] : null as any;
            this.flightIndex = _data["FlightIndex"] !== undefined ? _data["FlightIndex"] : null as any;
        }
    }

    static override fromJS(data: any): AmadeusFlightSegmentResultCustomData {
        data = typeof data === 'object' ? data : {};
        let result = new AmadeusFlightSegmentResultCustomData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FlightProposalRef"] = this.flightProposalRef !== undefined ? this.flightProposalRef : null as any;
        data["FlightIndex"] = this.flightIndex !== undefined ? this.flightIndex : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAmadeusFlightSegmentResultCustomData extends IFlightSegmentResultCustomData {
    flightProposalRef?: string | null;
    flightIndex?: string | null;
}

export class Airport implements IAirport {
    iataCode?: string | null;
    name?: string | null;
    cityName?: string | null;
    countryCode?: string | null;
    countryName?: string | null;
    location?: LatLng | null;

    constructor(data?: IAirport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iataCode = _data["IataCode"] !== undefined ? _data["IataCode"] : null as any;
            this.name = _data["Name"] !== undefined ? _data["Name"] : null as any;
            this.cityName = _data["CityName"] !== undefined ? _data["CityName"] : null as any;
            this.countryCode = _data["CountryCode"] !== undefined ? _data["CountryCode"] : null as any;
            this.countryName = _data["CountryName"] !== undefined ? _data["CountryName"] : null as any;
            this.location = _data["Location"] ? LatLng.fromJS(_data["Location"]) : null as any;
        }
    }

    static fromJS(data: any): Airport {
        data = typeof data === 'object' ? data : {};
        let result = new Airport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IataCode"] = this.iataCode !== undefined ? this.iataCode : null as any;
        data["Name"] = this.name !== undefined ? this.name : null as any;
        data["CityName"] = this.cityName !== undefined ? this.cityName : null as any;
        data["CountryCode"] = this.countryCode !== undefined ? this.countryCode : null as any;
        data["CountryName"] = this.countryName !== undefined ? this.countryName : null as any;
        data["Location"] = this.location ? this.location.toJSON() : null as any;
        return data;
    }
}

export interface IAirport {
    iataCode?: string | null;
    name?: string | null;
    cityName?: string | null;
    countryCode?: string | null;
    countryName?: string | null;
    location?: LatLng | null;
}

export class AirportTerminal extends Airport implements IAirportTerminal {
    terminalCode?: string | null;
    terminalText?: string | null;

    constructor(data?: IAirportTerminal) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.terminalCode = _data["TerminalCode"] !== undefined ? _data["TerminalCode"] : null as any;
            this.terminalText = _data["TerminalText"] !== undefined ? _data["TerminalText"] : null as any;
        }
    }

    static override fromJS(data: any): AirportTerminal {
        data = typeof data === 'object' ? data : {};
        let result = new AirportTerminal();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TerminalCode"] = this.terminalCode !== undefined ? this.terminalCode : null as any;
        data["TerminalText"] = this.terminalText !== undefined ? this.terminalText : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAirportTerminal extends IAirport {
    terminalCode?: string | null;
    terminalText?: string | null;
}

export class LatLng implements ILatLng {
    lat?: number | null;
    lng?: number | null;

    constructor(data?: ILatLng) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lat = _data["Lat"] !== undefined ? _data["Lat"] : null as any;
            this.lng = _data["Lng"] !== undefined ? _data["Lng"] : null as any;
        }
    }

    static fromJS(data: any): LatLng {
        data = typeof data === 'object' ? data : {};
        let result = new LatLng();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Lat"] = this.lat !== undefined ? this.lat : null as any;
        data["Lng"] = this.lng !== undefined ? this.lng : null as any;
        return data;
    }
}

export interface ILatLng {
    lat?: number | null;
    lng?: number | null;
}

export class Carrier implements ICarrier {
    iataCode?: string | null;
    name?: string | null;

    constructor(data?: ICarrier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iataCode = _data["IataCode"] !== undefined ? _data["IataCode"] : null as any;
            this.name = _data["Name"] !== undefined ? _data["Name"] : null as any;
        }
    }

    static fromJS(data: any): Carrier {
        data = typeof data === 'object' ? data : {};
        let result = new Carrier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IataCode"] = this.iataCode !== undefined ? this.iataCode : null as any;
        data["Name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export interface ICarrier {
    iataCode?: string | null;
    name?: string | null;
}

export class FlightCarrier extends Carrier implements IFlightCarrier {
    flightNumber?: string | null;
    flightCarrierDescription?: string | null;

    constructor(data?: IFlightCarrier) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.flightNumber = _data["FlightNumber"] !== undefined ? _data["FlightNumber"] : null as any;
            this.flightCarrierDescription = _data["FlightCarrierDescription"] !== undefined ? _data["FlightCarrierDescription"] : null as any;
        }
    }

    static override fromJS(data: any): FlightCarrier {
        data = typeof data === 'object' ? data : {};
        let result = new FlightCarrier();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FlightNumber"] = this.flightNumber !== undefined ? this.flightNumber : null as any;
        data["FlightCarrierDescription"] = this.flightCarrierDescription !== undefined ? this.flightCarrierDescription : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IFlightCarrier extends ICarrier {
    flightNumber?: string | null;
    flightCarrierDescription?: string | null;
}

export class Aircraft implements IAircraft {
    code?: string | null;
    text?: string | null;

    constructor(data?: IAircraft) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"] !== undefined ? _data["Code"] : null as any;
            this.text = _data["Text"] !== undefined ? _data["Text"] : null as any;
        }
    }

    static fromJS(data: any): Aircraft {
        data = typeof data === 'object' ? data : {};
        let result = new Aircraft();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code !== undefined ? this.code : null as any;
        data["Text"] = this.text !== undefined ? this.text : null as any;
        return data;
    }
}

export interface IAircraft {
    code?: string | null;
    text?: string | null;
}

export class FlightStop implements IFlightStop {
    airport?: Airport | null;
    arrivalDate?: string | null;
    departureDate?: string | null;
    duration?: string | null;

    constructor(data?: IFlightStop) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.airport = _data["Airport"] ? Airport.fromJS(_data["Airport"]) : null as any;
            this.arrivalDate = _data["ArrivalDate"] !== undefined ? _data["ArrivalDate"] : null as any;
            this.departureDate = _data["DepartureDate"] !== undefined ? _data["DepartureDate"] : null as any;
            this.duration = _data["Duration"] !== undefined ? _data["Duration"] : null as any;
        }
    }

    static fromJS(data: any): FlightStop {
        data = typeof data === 'object' ? data : {};
        let result = new FlightStop();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Airport"] = this.airport ? this.airport.toJSON() : null as any;
        data["ArrivalDate"] = this.arrivalDate !== undefined ? this.arrivalDate : null as any;
        data["DepartureDate"] = this.departureDate !== undefined ? this.departureDate : null as any;
        data["Duration"] = this.duration !== undefined ? this.duration : null as any;
        return data;
    }
}

export interface IFlightStop {
    airport?: Airport | null;
    arrivalDate?: string | null;
    departureDate?: string | null;
    duration?: string | null;
}

export class FlightFare implements IFlightFare {
    fareRules?: FareRule[] | null;
    id?: string | null;
    connectorCode?: EH2HConnectorCode | null;
    description?: string | null;
    paxFareList?: FlightPaxFare[] | null;
    feeList?: Tax[] | null;
    amount?: Total | null;
    isNdc?: boolean | null;
    isFullRefundable?: boolean | null;
    isPartialRefundable?: boolean | null;
    isFullExchangeable?: boolean | null;
    isPartialExchangeable?: boolean | null;
    fareKey?: string | null;
    fareGroupingKey?: string | null;

    constructor(data?: IFlightFare) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["FareRules"])) {
                this.fareRules = [] as any;
                for (let item of _data["FareRules"])
                    this.fareRules!.push(FareRule.fromJS(item));
            }
            else {
                this.fareRules = null as any;
            }
            this.id = _data["Id"] !== undefined ? _data["Id"] : null as any;
            this.connectorCode = _data["ConnectorCode"] !== undefined ? _data["ConnectorCode"] : null as any;
            this.description = _data["Description"] !== undefined ? _data["Description"] : null as any;
            if (Array.isArray(_data["PaxFareList"])) {
                this.paxFareList = [] as any;
                for (let item of _data["PaxFareList"])
                    this.paxFareList!.push(FlightPaxFare.fromJS(item));
            }
            else {
                this.paxFareList = null as any;
            }
            if (Array.isArray(_data["FeeList"])) {
                this.feeList = [] as any;
                for (let item of _data["FeeList"])
                    this.feeList!.push(Tax.fromJS(item));
            }
            else {
                this.feeList = null as any;
            }
            this.amount = _data["Amount"] ? Total.fromJS(_data["Amount"]) : null as any;
            this.isNdc = _data["IsNdc"] !== undefined ? _data["IsNdc"] : null as any;
            this.isFullRefundable = _data["IsFullRefundable"] !== undefined ? _data["IsFullRefundable"] : null as any;
            this.isPartialRefundable = _data["IsPartialRefundable"] !== undefined ? _data["IsPartialRefundable"] : null as any;
            this.isFullExchangeable = _data["IsFullExchangeable"] !== undefined ? _data["IsFullExchangeable"] : null as any;
            this.isPartialExchangeable = _data["IsPartialExchangeable"] !== undefined ? _data["IsPartialExchangeable"] : null as any;
            this.fareKey = _data["FareKey"] !== undefined ? _data["FareKey"] : null as any;
            this.fareGroupingKey = _data["FareGroupingKey"] !== undefined ? _data["FareGroupingKey"] : null as any;
        }
    }

    static fromJS(data: any): FlightFare {
        data = typeof data === 'object' ? data : {};
        let result = new FlightFare();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fareRules)) {
            data["FareRules"] = [];
            for (let item of this.fareRules)
                data["FareRules"].push(item ? item.toJSON() : null as any);
        }
        data["Id"] = this.id !== undefined ? this.id : null as any;
        data["ConnectorCode"] = this.connectorCode !== undefined ? this.connectorCode : null as any;
        data["Description"] = this.description !== undefined ? this.description : null as any;
        if (Array.isArray(this.paxFareList)) {
            data["PaxFareList"] = [];
            for (let item of this.paxFareList)
                data["PaxFareList"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.feeList)) {
            data["FeeList"] = [];
            for (let item of this.feeList)
                data["FeeList"].push(item ? item.toJSON() : null as any);
        }
        data["Amount"] = this.amount ? this.amount.toJSON() : null as any;
        data["IsNdc"] = this.isNdc !== undefined ? this.isNdc : null as any;
        data["IsFullRefundable"] = this.isFullRefundable !== undefined ? this.isFullRefundable : null as any;
        data["IsPartialRefundable"] = this.isPartialRefundable !== undefined ? this.isPartialRefundable : null as any;
        data["IsFullExchangeable"] = this.isFullExchangeable !== undefined ? this.isFullExchangeable : null as any;
        data["IsPartialExchangeable"] = this.isPartialExchangeable !== undefined ? this.isPartialExchangeable : null as any;
        data["FareKey"] = this.fareKey !== undefined ? this.fareKey : null as any;
        data["FareGroupingKey"] = this.fareGroupingKey !== undefined ? this.fareGroupingKey : null as any;
        return data;
    }
}

export interface IFlightFare {
    fareRules?: FareRule[] | null;
    id?: string | null;
    connectorCode?: EH2HConnectorCode | null;
    description?: string | null;
    paxFareList?: FlightPaxFare[] | null;
    feeList?: Tax[] | null;
    amount?: Total | null;
    isNdc?: boolean | null;
    isFullRefundable?: boolean | null;
    isPartialRefundable?: boolean | null;
    isFullExchangeable?: boolean | null;
    isPartialExchangeable?: boolean | null;
    fareKey?: string | null;
    fareGroupingKey?: string | null;
}

export class FlightFareGroupResult extends FlightFare implements IFlightFareGroupResult {
    fullReferenceId?: string | null;
    customerCustomData?: CustomerCustomDataOfFlightFareGroupResult | null;

    constructor(data?: IFlightFareGroupResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fullReferenceId = _data["FullReferenceId"] !== undefined ? _data["FullReferenceId"] : null as any;
            this.customerCustomData = _data["CustomerCustomData"] ? CustomerCustomDataOfFlightFareGroupResult.fromJS(_data["CustomerCustomData"]) : null as any;
        }
    }

    static override fromJS(data: any): FlightFareGroupResult {
        data = typeof data === 'object' ? data : {};
        let result = new FlightFareGroupResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FullReferenceId"] = this.fullReferenceId !== undefined ? this.fullReferenceId : null as any;
        data["CustomerCustomData"] = this.customerCustomData ? this.customerCustomData.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IFlightFareGroupResult extends IFlightFare {
    fullReferenceId?: string | null;
    customerCustomData?: CustomerCustomDataOfFlightFareGroupResult | null;
}

export abstract class CustomerCustomDataOfFlightFareGroupResult implements ICustomerCustomDataOfFlightFareGroupResult {

    protected _discriminator: string;

    constructor(data?: ICustomerCustomDataOfFlightFareGroupResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "CustomerCustomDataOfFlightFareGroupResult";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CustomerCustomDataOfFlightFareGroupResult {
        data = typeof data === 'object' ? data : {};
        if (data["CustomDataCode"] === "FlightFareNaarData") {
            let result = new FlightFareNaarData();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'CustomerCustomDataOfFlightFareGroupResult' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomDataCode"] = this._discriminator;
        return data;
    }
}

export interface ICustomerCustomDataOfFlightFareGroupResult {
}

export class FlightFareNaarData extends CustomerCustomDataOfFlightFareGroupResult implements IFlightFareNaarData {
    isToFare?: boolean | null;
    totalAmountWithoutTaxWithMarkup?: CurrencyAmount | null;
    totalAmountWithMarkup?: CurrencyAmount | null;
    totalTaxWithMarkup?: CurrencyAmount | null;
    perPaxAmountWithMarkup?: CurrencyAmount | null;

    constructor(data?: IFlightFareNaarData) {
        super(data);
        this._discriminator = "FlightFareNaarData";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isToFare = _data["isToFare"] !== undefined ? _data["isToFare"] : null as any;
            this.totalAmountWithoutTaxWithMarkup = _data["TotalAmountWithoutTaxWithMarkup"] ? CurrencyAmount.fromJS(_data["TotalAmountWithoutTaxWithMarkup"]) : null as any;
            this.totalAmountWithMarkup = _data["TotalAmountWithMarkup"] ? CurrencyAmount.fromJS(_data["TotalAmountWithMarkup"]) : null as any;
            this.totalTaxWithMarkup = _data["TotalTaxWithMarkup"] ? CurrencyAmount.fromJS(_data["TotalTaxWithMarkup"]) : null as any;
            this.perPaxAmountWithMarkup = _data["PerPaxAmountWithMarkup"] ? CurrencyAmount.fromJS(_data["PerPaxAmountWithMarkup"]) : null as any;
        }
    }

    static override fromJS(data: any): FlightFareNaarData {
        data = typeof data === 'object' ? data : {};
        let result = new FlightFareNaarData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isToFare"] = this.isToFare !== undefined ? this.isToFare : null as any;
        data["TotalAmountWithoutTaxWithMarkup"] = this.totalAmountWithoutTaxWithMarkup ? this.totalAmountWithoutTaxWithMarkup.toJSON() : null as any;
        data["TotalAmountWithMarkup"] = this.totalAmountWithMarkup ? this.totalAmountWithMarkup.toJSON() : null as any;
        data["TotalTaxWithMarkup"] = this.totalTaxWithMarkup ? this.totalTaxWithMarkup.toJSON() : null as any;
        data["PerPaxAmountWithMarkup"] = this.perPaxAmountWithMarkup ? this.perPaxAmountWithMarkup.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IFlightFareNaarData extends ICustomerCustomDataOfFlightFareGroupResult {
    isToFare?: boolean | null;
    totalAmountWithoutTaxWithMarkup?: CurrencyAmount | null;
    totalAmountWithMarkup?: CurrencyAmount | null;
    totalTaxWithMarkup?: CurrencyAmount | null;
    perPaxAmountWithMarkup?: CurrencyAmount | null;
}

export class CurrencyAmount implements ICurrencyAmount {
    currency?: string | null;
    amount?: number | null;

    constructor(data?: ICurrencyAmount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currency = _data["Currency"] !== undefined ? _data["Currency"] : null as any;
            this.amount = _data["Amount"] !== undefined ? _data["Amount"] : null as any;
        }
    }

    static fromJS(data: any): CurrencyAmount {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyAmount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Currency"] = this.currency !== undefined ? this.currency : null as any;
        data["Amount"] = this.amount !== undefined ? this.amount : null as any;
        return data;
    }
}

export interface ICurrencyAmount {
    currency?: string | null;
    amount?: number | null;
}

export class FareRule implements IFareRule {
    title?: string | null;
    application?: string | null;
    description?: string | null;

    constructor(data?: IFareRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["Title"] !== undefined ? _data["Title"] : null as any;
            this.application = _data["Application"] !== undefined ? _data["Application"] : null as any;
            this.description = _data["Description"] !== undefined ? _data["Description"] : null as any;
        }
    }

    static fromJS(data: any): FareRule {
        data = typeof data === 'object' ? data : {};
        let result = new FareRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Title"] = this.title !== undefined ? this.title : null as any;
        data["Application"] = this.application !== undefined ? this.application : null as any;
        data["Description"] = this.description !== undefined ? this.description : null as any;
        return data;
    }
}

export interface IFareRule {
    title?: string | null;
    application?: string | null;
    description?: string | null;
}

export class FlightPaxFare implements IFlightPaxFare {
    id?: string | null;
    paxType?: EPaxType | null;
    paxTypeCode?: string | null;
    paxCount?: number | null;
    flightSegmentDetails?: FareSegmentDetail[] | null;
    farePenalties?: FarePenalties | null;
    refundable?: boolean | null;
    lastTicketDate?: string | null;
    amount?: Total | null;
    connectorCustomData?: FlightPaxFareCustomData | null;
    customerCustomData?: CustomerCustomDataOfFlightPaxFare | null;

    constructor(data?: IFlightPaxFare) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"] !== undefined ? _data["Id"] : null as any;
            this.paxType = _data["PaxType"] !== undefined ? _data["PaxType"] : null as any;
            this.paxTypeCode = _data["PaxTypeCode"] !== undefined ? _data["PaxTypeCode"] : null as any;
            this.paxCount = _data["PaxCount"] !== undefined ? _data["PaxCount"] : null as any;
            if (Array.isArray(_data["FlightSegmentDetails"])) {
                this.flightSegmentDetails = [] as any;
                for (let item of _data["FlightSegmentDetails"])
                    this.flightSegmentDetails!.push(FareSegmentDetail.fromJS(item));
            }
            else {
                this.flightSegmentDetails = null as any;
            }
            this.farePenalties = _data["FarePenalties"] ? FarePenalties.fromJS(_data["FarePenalties"]) : null as any;
            this.refundable = _data["Refundable"] !== undefined ? _data["Refundable"] : null as any;
            this.lastTicketDate = _data["LastTicketDate"] !== undefined ? _data["LastTicketDate"] : null as any;
            this.amount = _data["Amount"] ? Total.fromJS(_data["Amount"]) : null as any;
            this.connectorCustomData = _data["ConnectorCustomData"] ? FlightPaxFareCustomData.fromJS(_data["ConnectorCustomData"]) : null as any;
            this.customerCustomData = _data["CustomerCustomData"] ? CustomerCustomDataOfFlightPaxFare.fromJS(_data["CustomerCustomData"]) : null as any;
        }
    }

    static fromJS(data: any): FlightPaxFare {
        data = typeof data === 'object' ? data : {};
        let result = new FlightPaxFare();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id !== undefined ? this.id : null as any;
        data["PaxType"] = this.paxType !== undefined ? this.paxType : null as any;
        data["PaxTypeCode"] = this.paxTypeCode !== undefined ? this.paxTypeCode : null as any;
        data["PaxCount"] = this.paxCount !== undefined ? this.paxCount : null as any;
        if (Array.isArray(this.flightSegmentDetails)) {
            data["FlightSegmentDetails"] = [];
            for (let item of this.flightSegmentDetails)
                data["FlightSegmentDetails"].push(item ? item.toJSON() : null as any);
        }
        data["FarePenalties"] = this.farePenalties ? this.farePenalties.toJSON() : null as any;
        data["Refundable"] = this.refundable !== undefined ? this.refundable : null as any;
        data["LastTicketDate"] = this.lastTicketDate !== undefined ? this.lastTicketDate : null as any;
        data["Amount"] = this.amount ? this.amount.toJSON() : null as any;
        data["ConnectorCustomData"] = this.connectorCustomData ? this.connectorCustomData.toJSON() : null as any;
        data["CustomerCustomData"] = this.customerCustomData ? this.customerCustomData.toJSON() : null as any;
        return data;
    }
}

export interface IFlightPaxFare {
    id?: string | null;
    paxType?: EPaxType | null;
    paxTypeCode?: string | null;
    paxCount?: number | null;
    flightSegmentDetails?: FareSegmentDetail[] | null;
    farePenalties?: FarePenalties | null;
    refundable?: boolean | null;
    lastTicketDate?: string | null;
    amount?: Total | null;
    connectorCustomData?: FlightPaxFareCustomData | null;
    customerCustomData?: CustomerCustomDataOfFlightPaxFare | null;
}

export enum EPaxType {
    INFANT = "INFANT",
    CHILD = "CHILD",
    ADULT = "ADULT",
}

export class FareSegmentDetail implements IFareSegmentDetail {
    flightSegmentRefId?: string | null;
    fareType?: EFareType | null;
    fareTypeCode?: string | null;
    cabin?: EFlightCabin | null;
    cabinCode?: string | null;
    class?: string | null;
    classAvail?: string | null;
    fareBasis?: string | null;
    matchedAccountCode?: string | null;
    meal?: FlightMeal | null;
    baggageDetails?: FlightBaggageDetails | null;
    brandedFare?: string | null;
    brandedFareCode?: string | null;
    fareDescription?: string | null;
    hostToken?: string | null;
    providerCode?: string | null;

    constructor(data?: IFareSegmentDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flightSegmentRefId = _data["FlightSegmentRefId"] !== undefined ? _data["FlightSegmentRefId"] : null as any;
            this.fareType = _data["FareType"] !== undefined ? _data["FareType"] : null as any;
            this.fareTypeCode = _data["FareTypeCode"] !== undefined ? _data["FareTypeCode"] : null as any;
            this.cabin = _data["Cabin"] !== undefined ? _data["Cabin"] : null as any;
            this.cabinCode = _data["CabinCode"] !== undefined ? _data["CabinCode"] : null as any;
            this.class = _data["Class"] !== undefined ? _data["Class"] : null as any;
            this.classAvail = _data["ClassAvail"] !== undefined ? _data["ClassAvail"] : null as any;
            this.fareBasis = _data["FareBasis"] !== undefined ? _data["FareBasis"] : null as any;
            this.matchedAccountCode = _data["MatchedAccountCode"] !== undefined ? _data["MatchedAccountCode"] : null as any;
            this.meal = _data["Meal"] ? FlightMeal.fromJS(_data["Meal"]) : null as any;
            this.baggageDetails = _data["BaggageDetails"] ? FlightBaggageDetails.fromJS(_data["BaggageDetails"]) : null as any;
            this.brandedFare = _data["BrandedFare"] !== undefined ? _data["BrandedFare"] : null as any;
            this.brandedFareCode = _data["BrandedFareCode"] !== undefined ? _data["BrandedFareCode"] : null as any;
            this.fareDescription = _data["FareDescription"] !== undefined ? _data["FareDescription"] : null as any;
            this.hostToken = _data["HostToken"] !== undefined ? _data["HostToken"] : null as any;
            this.providerCode = _data["ProviderCode"] !== undefined ? _data["ProviderCode"] : null as any;
        }
    }

    static fromJS(data: any): FareSegmentDetail {
        data = typeof data === 'object' ? data : {};
        let result = new FareSegmentDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FlightSegmentRefId"] = this.flightSegmentRefId !== undefined ? this.flightSegmentRefId : null as any;
        data["FareType"] = this.fareType !== undefined ? this.fareType : null as any;
        data["FareTypeCode"] = this.fareTypeCode !== undefined ? this.fareTypeCode : null as any;
        data["Cabin"] = this.cabin !== undefined ? this.cabin : null as any;
        data["CabinCode"] = this.cabinCode !== undefined ? this.cabinCode : null as any;
        data["Class"] = this.class !== undefined ? this.class : null as any;
        data["ClassAvail"] = this.classAvail !== undefined ? this.classAvail : null as any;
        data["FareBasis"] = this.fareBasis !== undefined ? this.fareBasis : null as any;
        data["MatchedAccountCode"] = this.matchedAccountCode !== undefined ? this.matchedAccountCode : null as any;
        data["Meal"] = this.meal ? this.meal.toJSON() : null as any;
        data["BaggageDetails"] = this.baggageDetails ? this.baggageDetails.toJSON() : null as any;
        data["BrandedFare"] = this.brandedFare !== undefined ? this.brandedFare : null as any;
        data["BrandedFareCode"] = this.brandedFareCode !== undefined ? this.brandedFareCode : null as any;
        data["FareDescription"] = this.fareDescription !== undefined ? this.fareDescription : null as any;
        data["HostToken"] = this.hostToken !== undefined ? this.hostToken : null as any;
        data["ProviderCode"] = this.providerCode !== undefined ? this.providerCode : null as any;
        return data;
    }
}

export interface IFareSegmentDetail {
    flightSegmentRefId?: string | null;
    fareType?: EFareType | null;
    fareTypeCode?: string | null;
    cabin?: EFlightCabin | null;
    cabinCode?: string | null;
    class?: string | null;
    classAvail?: string | null;
    fareBasis?: string | null;
    matchedAccountCode?: string | null;
    meal?: FlightMeal | null;
    baggageDetails?: FlightBaggageDetails | null;
    brandedFare?: string | null;
    brandedFareCode?: string | null;
    fareDescription?: string | null;
    hostToken?: string | null;
    providerCode?: string | null;
}

export enum EFareType {
    PUBLIC = "PUBLIC",
    PRIVATE = "PRIVATE",
    TO = "TO",
}

export class FlightMeal implements IFlightMeal {
    code?: string | null;
    text?: string | null;

    constructor(data?: IFlightMeal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"] !== undefined ? _data["Code"] : null as any;
            this.text = _data["Text"] !== undefined ? _data["Text"] : null as any;
        }
    }

    static fromJS(data: any): FlightMeal {
        data = typeof data === 'object' ? data : {};
        let result = new FlightMeal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code !== undefined ? this.code : null as any;
        data["Text"] = this.text !== undefined ? this.text : null as any;
        return data;
    }
}

export interface IFlightMeal {
    code?: string | null;
    text?: string | null;
}

export class FlightBaggageDetails implements IFlightBaggageDetails {
    baggageCount?: number | null;
    code?: string | null;
    text?: string | null;
    baggageTypeDetails?: BaggageTypeDetail[] | null;

    constructor(data?: IFlightBaggageDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baggageCount = _data["BaggageCount"] !== undefined ? _data["BaggageCount"] : null as any;
            this.code = _data["Code"] !== undefined ? _data["Code"] : null as any;
            this.text = _data["Text"] !== undefined ? _data["Text"] : null as any;
            if (Array.isArray(_data["BaggageTypeDetails"])) {
                this.baggageTypeDetails = [] as any;
                for (let item of _data["BaggageTypeDetails"])
                    this.baggageTypeDetails!.push(BaggageTypeDetail.fromJS(item));
            }
            else {
                this.baggageTypeDetails = null as any;
            }
        }
    }

    static fromJS(data: any): FlightBaggageDetails {
        data = typeof data === 'object' ? data : {};
        let result = new FlightBaggageDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["BaggageCount"] = this.baggageCount !== undefined ? this.baggageCount : null as any;
        data["Code"] = this.code !== undefined ? this.code : null as any;
        data["Text"] = this.text !== undefined ? this.text : null as any;
        if (Array.isArray(this.baggageTypeDetails)) {
            data["BaggageTypeDetails"] = [];
            for (let item of this.baggageTypeDetails)
                data["BaggageTypeDetails"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IFlightBaggageDetails {
    baggageCount?: number | null;
    code?: string | null;
    text?: string | null;
    baggageTypeDetails?: BaggageTypeDetail[] | null;
}

export class BaggageTypeDetail implements IBaggageTypeDetail {
    count?: number | null;
    type?: EBaggageType | null;
    code?: string | null;
    text?: string | null;
    descriptions?: string[] | null;

    constructor(data?: IBaggageTypeDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["Count"] !== undefined ? _data["Count"] : null as any;
            this.type = _data["Type"] !== undefined ? _data["Type"] : null as any;
            this.code = _data["Code"] !== undefined ? _data["Code"] : null as any;
            this.text = _data["Text"] !== undefined ? _data["Text"] : null as any;
            if (Array.isArray(_data["Descriptions"])) {
                this.descriptions = [] as any;
                for (let item of _data["Descriptions"])
                    this.descriptions!.push(item);
            }
            else {
                this.descriptions = null as any;
            }
        }
    }

    static fromJS(data: any): BaggageTypeDetail {
        data = typeof data === 'object' ? data : {};
        let result = new BaggageTypeDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Count"] = this.count !== undefined ? this.count : null as any;
        data["Type"] = this.type !== undefined ? this.type : null as any;
        data["Code"] = this.code !== undefined ? this.code : null as any;
        data["Text"] = this.text !== undefined ? this.text : null as any;
        if (Array.isArray(this.descriptions)) {
            data["Descriptions"] = [];
            for (let item of this.descriptions)
                data["Descriptions"].push(item);
        }
        return data;
    }
}

export interface IBaggageTypeDetail {
    count?: number | null;
    type?: EBaggageType | null;
    code?: string | null;
    text?: string | null;
    descriptions?: string[] | null;
}

export enum EBaggageType {
    CARRY_ON = "CARRY_ON",
    CHECKED = "CHECKED",
    SPECIAL = "SPECIAL",
}

export class FarePenalties implements IFarePenalties {
    exchangeBefore?: FarePenalty | null;
    exchangeAfter?: FarePenalty | null;
    refundBefore?: FarePenalty | null;
    refundAfter?: FarePenalty | null;

    constructor(data?: IFarePenalties) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exchangeBefore = _data["ExchangeBefore"] ? FarePenalty.fromJS(_data["ExchangeBefore"]) : null as any;
            this.exchangeAfter = _data["ExchangeAfter"] ? FarePenalty.fromJS(_data["ExchangeAfter"]) : null as any;
            this.refundBefore = _data["RefundBefore"] ? FarePenalty.fromJS(_data["RefundBefore"]) : null as any;
            this.refundAfter = _data["RefundAfter"] ? FarePenalty.fromJS(_data["RefundAfter"]) : null as any;
        }
    }

    static fromJS(data: any): FarePenalties {
        data = typeof data === 'object' ? data : {};
        let result = new FarePenalties();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ExchangeBefore"] = this.exchangeBefore ? this.exchangeBefore.toJSON() : null as any;
        data["ExchangeAfter"] = this.exchangeAfter ? this.exchangeAfter.toJSON() : null as any;
        data["RefundBefore"] = this.refundBefore ? this.refundBefore.toJSON() : null as any;
        data["RefundAfter"] = this.refundAfter ? this.refundAfter.toJSON() : null as any;
        return data;
    }
}

export interface IFarePenalties {
    exchangeBefore?: FarePenalty | null;
    exchangeAfter?: FarePenalty | null;
    refundBefore?: FarePenalty | null;
    refundAfter?: FarePenalty | null;
}

export class FarePenalty implements IFarePenalty {
    isApplicable?: boolean | null;
    penaltyConditions?: string[] | null;
    penaltyAmount?: CurrencyAmount | null;
    penaltyAmountNoShow?: CurrencyAmount | null;

    constructor(data?: IFarePenalty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isApplicable = _data["IsApplicable"] !== undefined ? _data["IsApplicable"] : null as any;
            if (Array.isArray(_data["PenaltyConditions"])) {
                this.penaltyConditions = [] as any;
                for (let item of _data["PenaltyConditions"])
                    this.penaltyConditions!.push(item);
            }
            else {
                this.penaltyConditions = null as any;
            }
            this.penaltyAmount = _data["PenaltyAmount"] ? CurrencyAmount.fromJS(_data["PenaltyAmount"]) : null as any;
            this.penaltyAmountNoShow = _data["PenaltyAmountNoShow"] ? CurrencyAmount.fromJS(_data["PenaltyAmountNoShow"]) : null as any;
        }
    }

    static fromJS(data: any): FarePenalty {
        data = typeof data === 'object' ? data : {};
        let result = new FarePenalty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsApplicable"] = this.isApplicable !== undefined ? this.isApplicable : null as any;
        if (Array.isArray(this.penaltyConditions)) {
            data["PenaltyConditions"] = [];
            for (let item of this.penaltyConditions)
                data["PenaltyConditions"].push(item);
        }
        data["PenaltyAmount"] = this.penaltyAmount ? this.penaltyAmount.toJSON() : null as any;
        data["PenaltyAmountNoShow"] = this.penaltyAmountNoShow ? this.penaltyAmountNoShow.toJSON() : null as any;
        return data;
    }
}

export interface IFarePenalty {
    isApplicable?: boolean | null;
    penaltyConditions?: string[] | null;
    penaltyAmount?: CurrencyAmount | null;
    penaltyAmountNoShow?: CurrencyAmount | null;
}

export class Total extends CurrencyAmount implements ITotal {
    amountWithoutTax?: number | null;
    taxes?: Taxes | null;

    constructor(data?: ITotal) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.amountWithoutTax = _data["AmountWithoutTax"] !== undefined ? _data["AmountWithoutTax"] : null as any;
            this.taxes = _data["Taxes"] ? Taxes.fromJS(_data["Taxes"]) : null as any;
        }
    }

    static override fromJS(data: any): Total {
        data = typeof data === 'object' ? data : {};
        let result = new Total();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AmountWithoutTax"] = this.amountWithoutTax !== undefined ? this.amountWithoutTax : null as any;
        data["Taxes"] = this.taxes ? this.taxes.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITotal extends ICurrencyAmount {
    amountWithoutTax?: number | null;
    taxes?: Taxes | null;
}

export class Taxes extends CurrencyAmount implements ITaxes {
    taxList?: Tax[] | null;

    constructor(data?: ITaxes) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["TaxList"])) {
                this.taxList = [] as any;
                for (let item of _data["TaxList"])
                    this.taxList!.push(Tax.fromJS(item));
            }
            else {
                this.taxList = null as any;
            }
        }
    }

    static override fromJS(data: any): Taxes {
        data = typeof data === 'object' ? data : {};
        let result = new Taxes();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.taxList)) {
            data["TaxList"] = [];
            for (let item of this.taxList)
                data["TaxList"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITaxes extends ICurrencyAmount {
    taxList?: Tax[] | null;
}

export class Tax extends CurrencyAmount implements ITax {
    code?: string | null;
    name?: string | null;
    description?: string | null;

    constructor(data?: ITax) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["Code"] !== undefined ? _data["Code"] : null as any;
            this.name = _data["Name"] !== undefined ? _data["Name"] : null as any;
            this.description = _data["Description"] !== undefined ? _data["Description"] : null as any;
        }
    }

    static override fromJS(data: any): Tax {
        data = typeof data === 'object' ? data : {};
        let result = new Tax();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code !== undefined ? this.code : null as any;
        data["Name"] = this.name !== undefined ? this.name : null as any;
        data["Description"] = this.description !== undefined ? this.description : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITax extends ICurrencyAmount {
    code?: string | null;
    name?: string | null;
    description?: string | null;
}

export abstract class FlightPaxFareCustomData implements IFlightPaxFareCustomData {

    protected _discriminator: string;

    constructor(data?: IFlightPaxFareCustomData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "FlightPaxFareCustomData";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): FlightPaxFareCustomData {
        data = typeof data === 'object' ? data : {};
        if (data["CustomDataConnectorCode"] === "AMADEUS") {
            let result = new AmadeusFlightPaxFareCustomData();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'FlightPaxFareCustomData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomDataConnectorCode"] = this._discriminator;
        return data;
    }
}

export interface IFlightPaxFareCustomData {
}

export class AmadeusFlightPaxFareCustomData extends FlightPaxFareCustomData implements IAmadeusFlightPaxFareCustomData {
    pnrFlightPaxFareId?: string | null;
    paxType?: EPaxType | null;
    shoppingResponseId?: string | null;
    offerId?: string | null;
    offerItemId?: string | null;
    dateAndTimeNdcLimits?: DateTimeNdcLimit[] | null;
    creationDate?: string | null;
    lastModificationDate?: string | null;
    tstIndicator?: string | null;
    orderId?: string | null;
    orderItemId?: string | null;
    ownerCode?: string | null;
    ownerItemCode?: string | null;

    constructor(data?: IAmadeusFlightPaxFareCustomData) {
        super(data);
        this._discriminator = "AMADEUS";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pnrFlightPaxFareId = _data["PnrFlightPaxFareId"] !== undefined ? _data["PnrFlightPaxFareId"] : null as any;
            this.paxType = _data["PaxType"] !== undefined ? _data["PaxType"] : null as any;
            this.shoppingResponseId = _data["ShoppingResponseId"] !== undefined ? _data["ShoppingResponseId"] : null as any;
            this.offerId = _data["OfferId"] !== undefined ? _data["OfferId"] : null as any;
            this.offerItemId = _data["OfferItemId"] !== undefined ? _data["OfferItemId"] : null as any;
            if (Array.isArray(_data["DateAndTimeNdcLimits"])) {
                this.dateAndTimeNdcLimits = [] as any;
                for (let item of _data["DateAndTimeNdcLimits"])
                    this.dateAndTimeNdcLimits!.push(DateTimeNdcLimit.fromJS(item));
            }
            else {
                this.dateAndTimeNdcLimits = null as any;
            }
            this.creationDate = _data["CreationDate"] !== undefined ? _data["CreationDate"] : null as any;
            this.lastModificationDate = _data["LastModificationDate"] !== undefined ? _data["LastModificationDate"] : null as any;
            this.tstIndicator = _data["TstIndicator"] !== undefined ? _data["TstIndicator"] : null as any;
            this.orderId = _data["OrderId"] !== undefined ? _data["OrderId"] : null as any;
            this.orderItemId = _data["OrderItemId"] !== undefined ? _data["OrderItemId"] : null as any;
            this.ownerCode = _data["OwnerCode"] !== undefined ? _data["OwnerCode"] : null as any;
            this.ownerItemCode = _data["OwnerItemCode"] !== undefined ? _data["OwnerItemCode"] : null as any;
        }
    }

    static override fromJS(data: any): AmadeusFlightPaxFareCustomData {
        data = typeof data === 'object' ? data : {};
        let result = new AmadeusFlightPaxFareCustomData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PnrFlightPaxFareId"] = this.pnrFlightPaxFareId !== undefined ? this.pnrFlightPaxFareId : null as any;
        data["PaxType"] = this.paxType !== undefined ? this.paxType : null as any;
        data["ShoppingResponseId"] = this.shoppingResponseId !== undefined ? this.shoppingResponseId : null as any;
        data["OfferId"] = this.offerId !== undefined ? this.offerId : null as any;
        data["OfferItemId"] = this.offerItemId !== undefined ? this.offerItemId : null as any;
        if (Array.isArray(this.dateAndTimeNdcLimits)) {
            data["DateAndTimeNdcLimits"] = [];
            for (let item of this.dateAndTimeNdcLimits)
                data["DateAndTimeNdcLimits"].push(item ? item.toJSON() : null as any);
        }
        data["CreationDate"] = this.creationDate !== undefined ? this.creationDate : null as any;
        data["LastModificationDate"] = this.lastModificationDate !== undefined ? this.lastModificationDate : null as any;
        data["TstIndicator"] = this.tstIndicator !== undefined ? this.tstIndicator : null as any;
        data["OrderId"] = this.orderId !== undefined ? this.orderId : null as any;
        data["OrderItemId"] = this.orderItemId !== undefined ? this.orderItemId : null as any;
        data["OwnerCode"] = this.ownerCode !== undefined ? this.ownerCode : null as any;
        data["OwnerItemCode"] = this.ownerItemCode !== undefined ? this.ownerItemCode : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAmadeusFlightPaxFareCustomData extends IFlightPaxFareCustomData {
    pnrFlightPaxFareId?: string | null;
    paxType?: EPaxType | null;
    shoppingResponseId?: string | null;
    offerId?: string | null;
    offerItemId?: string | null;
    dateAndTimeNdcLimits?: DateTimeNdcLimit[] | null;
    creationDate?: string | null;
    lastModificationDate?: string | null;
    tstIndicator?: string | null;
    orderId?: string | null;
    orderItemId?: string | null;
    ownerCode?: string | null;
    ownerItemCode?: string | null;
}

export class DateTimeNdcLimit implements IDateTimeNdcLimit {
    code?: string | null;
    expirationDateTimeUtc?: string | null;

    constructor(data?: IDateTimeNdcLimit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"] !== undefined ? _data["Code"] : null as any;
            this.expirationDateTimeUtc = _data["ExpirationDateTimeUtc"] !== undefined ? _data["ExpirationDateTimeUtc"] : null as any;
        }
    }

    static fromJS(data: any): DateTimeNdcLimit {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeNdcLimit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code !== undefined ? this.code : null as any;
        data["ExpirationDateTimeUtc"] = this.expirationDateTimeUtc !== undefined ? this.expirationDateTimeUtc : null as any;
        return data;
    }
}

export interface IDateTimeNdcLimit {
    code?: string | null;
    expirationDateTimeUtc?: string | null;
}

export abstract class CustomerCustomDataOfFlightPaxFare implements ICustomerCustomDataOfFlightPaxFare {

    protected _discriminator: string;

    constructor(data?: ICustomerCustomDataOfFlightPaxFare) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "CustomerCustomDataOfFlightPaxFare";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CustomerCustomDataOfFlightPaxFare {
        data = typeof data === 'object' ? data : {};
        if (data["CustomDataCode"] === "FlightPnrFlightPaxFareNaarData") {
            let result = new FlightPnrFlightPaxFareNaarData();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'CustomerCustomDataOfFlightPaxFare' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomDataCode"] = this._discriminator;
        return data;
    }
}

export interface ICustomerCustomDataOfFlightPaxFare {
}

export class FlightPnrFlightPaxFareNaarData extends CustomerCustomDataOfFlightPaxFare implements IFlightPnrFlightPaxFareNaarData {
    isToFare?: boolean | null;
    totalAmountWithoutTaxWithMarkup?: CurrencyAmount | null;
    totalAmountWithMarkup?: CurrencyAmount | null;
    totalTaxWithMarkup?: CurrencyAmount | null;
    perPaxAmountWithMarkup?: CurrencyAmount | null;

    constructor(data?: IFlightPnrFlightPaxFareNaarData) {
        super(data);
        this._discriminator = "FlightPnrFlightPaxFareNaarData";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isToFare = _data["isToFare"] !== undefined ? _data["isToFare"] : null as any;
            this.totalAmountWithoutTaxWithMarkup = _data["TotalAmountWithoutTaxWithMarkup"] ? CurrencyAmount.fromJS(_data["TotalAmountWithoutTaxWithMarkup"]) : null as any;
            this.totalAmountWithMarkup = _data["TotalAmountWithMarkup"] ? CurrencyAmount.fromJS(_data["TotalAmountWithMarkup"]) : null as any;
            this.totalTaxWithMarkup = _data["TotalTaxWithMarkup"] ? CurrencyAmount.fromJS(_data["TotalTaxWithMarkup"]) : null as any;
            this.perPaxAmountWithMarkup = _data["PerPaxAmountWithMarkup"] ? CurrencyAmount.fromJS(_data["PerPaxAmountWithMarkup"]) : null as any;
        }
    }

    static override fromJS(data: any): FlightPnrFlightPaxFareNaarData {
        data = typeof data === 'object' ? data : {};
        let result = new FlightPnrFlightPaxFareNaarData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isToFare"] = this.isToFare !== undefined ? this.isToFare : null as any;
        data["TotalAmountWithoutTaxWithMarkup"] = this.totalAmountWithoutTaxWithMarkup ? this.totalAmountWithoutTaxWithMarkup.toJSON() : null as any;
        data["TotalAmountWithMarkup"] = this.totalAmountWithMarkup ? this.totalAmountWithMarkup.toJSON() : null as any;
        data["TotalTaxWithMarkup"] = this.totalTaxWithMarkup ? this.totalTaxWithMarkup.toJSON() : null as any;
        data["PerPaxAmountWithMarkup"] = this.perPaxAmountWithMarkup ? this.perPaxAmountWithMarkup.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IFlightPnrFlightPaxFareNaarData extends ICustomerCustomDataOfFlightPaxFare {
    isToFare?: boolean | null;
    totalAmountWithoutTaxWithMarkup?: CurrencyAmount | null;
    totalAmountWithMarkup?: CurrencyAmount | null;
    totalTaxWithMarkup?: CurrencyAmount | null;
    perPaxAmountWithMarkup?: CurrencyAmount | null;
}

export abstract class FlightAvailabilityOutputCustomData implements IFlightAvailabilityOutputCustomData {

    protected _discriminator: string;

    constructor(data?: IFlightAvailabilityOutputCustomData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "FlightAvailabilityOutputCustomData";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): FlightAvailabilityOutputCustomData {
        data = typeof data === 'object' ? data : {};
        if (data["CustomDataConnectorCode"] === "AMADEUS") {
            let result = new AmadeusFlightAvailabilityOutputCustomData();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'FlightAvailabilityOutputCustomData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomDataConnectorCode"] = this._discriminator;
        return data;
    }
}

export interface IFlightAvailabilityOutputCustomData {
}

export class AmadeusFlightAvailabilityOutputCustomData extends FlightAvailabilityOutputCustomData implements IAmadeusFlightAvailabilityOutputCustomData {
    amadeusSession?: AmadeusGdsSessionCustomData | null;

    constructor(data?: IAmadeusFlightAvailabilityOutputCustomData) {
        super(data);
        this._discriminator = "AMADEUS";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.amadeusSession = _data["AmadeusSession"] ? AmadeusGdsSessionCustomData.fromJS(_data["AmadeusSession"]) : null as any;
        }
    }

    static override fromJS(data: any): AmadeusFlightAvailabilityOutputCustomData {
        data = typeof data === 'object' ? data : {};
        let result = new AmadeusFlightAvailabilityOutputCustomData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AmadeusSession"] = this.amadeusSession ? this.amadeusSession.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAmadeusFlightAvailabilityOutputCustomData extends IFlightAvailabilityOutputCustomData {
    amadeusSession?: AmadeusGdsSessionCustomData | null;
}

export class CacheResponseInfo implements ICacheResponseInfo {
    isCachedResponse?: boolean | null;
    cachedItemKey?: string | null;
    cachedDateTimeUtc?: string | null;
    expirationTimeSpan?: string | null;

    constructor(data?: ICacheResponseInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isCachedResponse = _data["IsCachedResponse"] !== undefined ? _data["IsCachedResponse"] : null as any;
            this.cachedItemKey = _data["CachedItemKey"] !== undefined ? _data["CachedItemKey"] : null as any;
            this.cachedDateTimeUtc = _data["CachedDateTimeUtc"] !== undefined ? _data["CachedDateTimeUtc"] : null as any;
            this.expirationTimeSpan = _data["ExpirationTimeSpan"] !== undefined ? _data["ExpirationTimeSpan"] : null as any;
        }
    }

    static fromJS(data: any): CacheResponseInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CacheResponseInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsCachedResponse"] = this.isCachedResponse !== undefined ? this.isCachedResponse : null as any;
        data["CachedItemKey"] = this.cachedItemKey !== undefined ? this.cachedItemKey : null as any;
        data["CachedDateTimeUtc"] = this.cachedDateTimeUtc !== undefined ? this.cachedDateTimeUtc : null as any;
        data["ExpirationTimeSpan"] = this.expirationTimeSpan !== undefined ? this.expirationTimeSpan : null as any;
        return data;
    }
}

export interface ICacheResponseInfo {
    isCachedResponse?: boolean | null;
    cachedItemKey?: string | null;
    cachedDateTimeUtc?: string | null;
    expirationTimeSpan?: string | null;
}

export enum EOperationStatus {
    SUCCESS = "SUCCESS",
    WARNING = "WARNING",
    ERROR = "ERROR",
}

export class Message implements IMessage {
    connectorCode?: EH2HConnectorCode | null;
    type?: EMessageType | null;
    code?: EMessageCode | null;
    text?: string | null;

    constructor(data?: IMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectorCode = _data["ConnectorCode"] !== undefined ? _data["ConnectorCode"] : null as any;
            this.type = _data["Type"] !== undefined ? _data["Type"] : null as any;
            this.code = _data["Code"] !== undefined ? _data["Code"] : null as any;
            this.text = _data["Text"] !== undefined ? _data["Text"] : null as any;
        }
    }

    static fromJS(data: any): Message {
        data = typeof data === 'object' ? data : {};
        let result = new Message();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ConnectorCode"] = this.connectorCode !== undefined ? this.connectorCode : null as any;
        data["Type"] = this.type !== undefined ? this.type : null as any;
        data["Code"] = this.code !== undefined ? this.code : null as any;
        data["Text"] = this.text !== undefined ? this.text : null as any;
        return data;
    }
}

export interface IMessage {
    connectorCode?: EH2HConnectorCode | null;
    type?: EMessageType | null;
    code?: EMessageCode | null;
    text?: string | null;
}

export enum EMessageType {
    INFO = "INFO",
    WARNING = "WARNING",
    ERROR = "ERROR",
}

export enum EMessageCode {
    UNKNOWN = "UNKNOWN",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    NOT_ENABLED_CONNECTOR = "NOT_ENABLED_CONNECTOR",
    NOT_ENABLED_OPERATION = "NOT_ENABLED_OPERATION",
    CONNECTOR_ERROR = "CONNECTOR_ERROR",
    NO_AVAIL = "NO_AVAIL",
    NO_FARE_OR_RATE = "NO_FARE_OR_RATE",
    WRONG_CC = "WRONG_CC",
    IMPOSSIBLE_TO_CANCEL = "IMPOSSIBLE_TO_CANCEL",
    BOOK_NOT_FOUND = "BOOK_NOT_FOUND",
    WRONG_INPUTS = "WRONG_INPUTS",
    PRICE_CHANGED = "PRICE_CHANGED",
    NO_RESULTS = "NO_RESULTS",
    FULL_RESPONSE = "FULL_RESPONSE",
    CACHE_EXPIRED = "CACHE_EXPIRED",
}

export class ConnectorResponseDetails implements IConnectorResponseDetails {
    connectorCode?: EH2HConnectorCode | null;
    environment?: string | null;
    status?: EH2HOperationStatus | null;
    executionTime?: number | null;
    messages?: Message[] | null;
    messageCodes?: EMessageCode[] | null;
    connectorDebugData?: ConnectorDebugData | null;

    constructor(data?: IConnectorResponseDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectorCode = _data["ConnectorCode"] !== undefined ? _data["ConnectorCode"] : null as any;
            this.environment = _data["Environment"] !== undefined ? _data["Environment"] : null as any;
            this.status = _data["Status"] !== undefined ? _data["Status"] : null as any;
            this.executionTime = _data["ExecutionTime"] !== undefined ? _data["ExecutionTime"] : null as any;
            if (Array.isArray(_data["Messages"])) {
                this.messages = [] as any;
                for (let item of _data["Messages"])
                    this.messages!.push(Message.fromJS(item));
            }
            else {
                this.messages = null as any;
            }
            if (Array.isArray(_data["MessageCodes"])) {
                this.messageCodes = [] as any;
                for (let item of _data["MessageCodes"])
                    this.messageCodes!.push(item);
            }
            else {
                this.messageCodes = null as any;
            }
            this.connectorDebugData = _data["ConnectorDebugData"] ? ConnectorDebugData.fromJS(_data["ConnectorDebugData"]) : null as any;
        }
    }

    static fromJS(data: any): ConnectorResponseDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectorResponseDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ConnectorCode"] = this.connectorCode !== undefined ? this.connectorCode : null as any;
        data["Environment"] = this.environment !== undefined ? this.environment : null as any;
        data["Status"] = this.status !== undefined ? this.status : null as any;
        data["ExecutionTime"] = this.executionTime !== undefined ? this.executionTime : null as any;
        if (Array.isArray(this.messages)) {
            data["Messages"] = [];
            for (let item of this.messages)
                data["Messages"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.messageCodes)) {
            data["MessageCodes"] = [];
            for (let item of this.messageCodes)
                data["MessageCodes"].push(item);
        }
        data["ConnectorDebugData"] = this.connectorDebugData ? this.connectorDebugData.toJSON() : null as any;
        return data;
    }
}

export interface IConnectorResponseDetails {
    connectorCode?: EH2HConnectorCode | null;
    environment?: string | null;
    status?: EH2HOperationStatus | null;
    executionTime?: number | null;
    messages?: Message[] | null;
    messageCodes?: EMessageCode[] | null;
    connectorDebugData?: ConnectorDebugData | null;
}

export enum EH2HOperationStatus {
    START = "START",
    PENDING = "PENDING",
    SUCCESS = "SUCCESS",
    WARNING = "WARNING",
    ERROR = "ERROR",
}

export class ConnectorDebugData implements IConnectorDebugData {
    request?: string | null;
    response?: string | null;

    constructor(data?: IConnectorDebugData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.request = _data["Request"] !== undefined ? _data["Request"] : null as any;
            this.response = _data["Response"] !== undefined ? _data["Response"] : null as any;
        }
    }

    static fromJS(data: any): ConnectorDebugData {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectorDebugData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Request"] = this.request !== undefined ? this.request : null as any;
        data["Response"] = this.response !== undefined ? this.response : null as any;
        return data;
    }
}

export interface IConnectorDebugData {
    request?: string | null;
    response?: string | null;
}

export class JupiterCrypticRS extends BaseRS implements IJupiterCrypticRS {
    response?: JupiterCrypticOutput | null;

    constructor(data?: IJupiterCrypticRS) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.response = _data["Response"] ? JupiterCrypticOutput.fromJS(_data["Response"]) : null as any;
        }
    }

    static override fromJS(data: any): JupiterCrypticRS {
        data = typeof data === 'object' ? data : {};
        let result = new JupiterCrypticRS();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Response"] = this.response ? this.response.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IJupiterCrypticRS extends IBaseRS {
    response?: JupiterCrypticOutput | null;
}

export abstract class BaseJupiterSessionOutput extends BaseOutput implements IBaseJupiterSessionOutput {
    connectorCode?: EH2HConnectorCode | null;
    sessionConnectorCustomData?: GdsSessionCustomData | null;

    constructor(data?: IBaseJupiterSessionOutput) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.connectorCode = _data["ConnectorCode"] !== undefined ? _data["ConnectorCode"] : null as any;
            this.sessionConnectorCustomData = _data["SessionConnectorCustomData"] ? GdsSessionCustomData.fromJS(_data["SessionConnectorCustomData"]) : null as any;
        }
    }

    static override fromJS(data: any): BaseJupiterSessionOutput {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseJupiterSessionOutput' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ConnectorCode"] = this.connectorCode !== undefined ? this.connectorCode : null as any;
        data["SessionConnectorCustomData"] = this.sessionConnectorCustomData ? this.sessionConnectorCustomData.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IBaseJupiterSessionOutput extends IBaseOutput {
    connectorCode?: EH2HConnectorCode | null;
    sessionConnectorCustomData?: GdsSessionCustomData | null;
}

export class JupiterCrypticOutput extends BaseJupiterSessionOutput implements IJupiterCrypticOutput {
    crypticResponse?: string | null;

    constructor(data?: IJupiterCrypticOutput) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.crypticResponse = _data["CrypticResponse"] !== undefined ? _data["CrypticResponse"] : null as any;
        }
    }

    static override fromJS(data: any): JupiterCrypticOutput {
        data = typeof data === 'object' ? data : {};
        let result = new JupiterCrypticOutput();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CrypticResponse"] = this.crypticResponse !== undefined ? this.crypticResponse : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IJupiterCrypticOutput extends IBaseJupiterSessionOutput {
    crypticResponse?: string | null;
}

export class JupiterCrypticRQ extends BaseRQ implements IJupiterCrypticRQ {
    request?: JupiterCrypticInput | null;

    constructor(data?: IJupiterCrypticRQ) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.request = _data["Request"] ? JupiterCrypticInput.fromJS(_data["Request"]) : null as any;
        }
    }

    static override fromJS(data: any): JupiterCrypticRQ {
        data = typeof data === 'object' ? data : {};
        let result = new JupiterCrypticRQ();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Request"] = this.request ? this.request.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IJupiterCrypticRQ extends IBaseRQ {
    request?: JupiterCrypticInput | null;
}

export abstract class BaseJupiterSessionInput extends BaseInput implements IBaseJupiterSessionInput {
    connectorCode?: EH2HConnectorCode | null;
    sessionConnectorCustomData?: GdsSessionCustomData | null;

    constructor(data?: IBaseJupiterSessionInput) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.connectorCode = _data["ConnectorCode"] !== undefined ? _data["ConnectorCode"] : null as any;
            this.sessionConnectorCustomData = _data["SessionConnectorCustomData"] ? GdsSessionCustomData.fromJS(_data["SessionConnectorCustomData"]) : null as any;
        }
    }

    static override fromJS(data: any): BaseJupiterSessionInput {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseJupiterSessionInput' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ConnectorCode"] = this.connectorCode !== undefined ? this.connectorCode : null as any;
        data["SessionConnectorCustomData"] = this.sessionConnectorCustomData ? this.sessionConnectorCustomData.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IBaseJupiterSessionInput extends IBaseInput {
    connectorCode?: EH2HConnectorCode | null;
    sessionConnectorCustomData?: GdsSessionCustomData | null;
}

export class JupiterCrypticInput extends BaseJupiterSessionInput implements IJupiterCrypticInput {
    crypticRequest?: string | null;

    constructor(data?: IJupiterCrypticInput) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.crypticRequest = _data["CrypticRequest"] !== undefined ? _data["CrypticRequest"] : null as any;
        }
    }

    static override fromJS(data: any): JupiterCrypticInput {
        data = typeof data === 'object' ? data : {};
        let result = new JupiterCrypticInput();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CrypticRequest"] = this.crypticRequest !== undefined ? this.crypticRequest : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IJupiterCrypticInput extends IBaseJupiterSessionInput {
    crypticRequest?: string | null;
}

export class JupiterFlightPnrRetrieveRS extends BaseRS implements IJupiterFlightPnrRetrieveRS {
    response?: JupiterFlightPnrRetrieveOutput | null;

    constructor(data?: IJupiterFlightPnrRetrieveRS) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.response = _data["Response"] ? JupiterFlightPnrRetrieveOutput.fromJS(_data["Response"]) : null as any;
        }
    }

    static override fromJS(data: any): JupiterFlightPnrRetrieveRS {
        data = typeof data === 'object' ? data : {};
        let result = new JupiterFlightPnrRetrieveRS();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Response"] = this.response ? this.response.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IJupiterFlightPnrRetrieveRS extends IBaseRS {
    response?: JupiterFlightPnrRetrieveOutput | null;
}

export class JupiterFlightPnrRetrieveOutput extends BaseOutput implements IJupiterFlightPnrRetrieveOutput {
    pnr?: BaseOperationPnr | null;

    constructor(data?: IJupiterFlightPnrRetrieveOutput) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pnr = _data["Pnr"] ? BaseOperationPnr.fromJS(_data["Pnr"]) : null as any;
        }
    }

    static override fromJS(data: any): JupiterFlightPnrRetrieveOutput {
        data = typeof data === 'object' ? data : {};
        let result = new JupiterFlightPnrRetrieveOutput();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Pnr"] = this.pnr ? this.pnr.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IJupiterFlightPnrRetrieveOutput extends IBaseOutput {
    pnr?: BaseOperationPnr | null;
}

export class BaseOperationPnr implements IBaseOperationPnr {
    fullReferenceId?: string | null;
    resultKey?: string | null;
    routingKey?: string | null;
    isPure?: boolean | null;
    codeShareKey?: string | null;
    connectorCode!: EH2HConnectorCode;
    closePnr?: boolean | null;
    bookingStatus?: EBookingStatus | null;
    pnrNumber?: string | null;
    pseudoCityCode?: string | null;
    pnrDate?: string | null;
    cancelDate?: string | null;
    lastTicketDate?: string | null;
    flightSegments?: PnrFlightSegment[] | null;
    fare?: PnrFlightFare | null;
    alternativeFares?: PnrFlightFare[] | null;
    ancillaries?: PnrBookedFlightAncillary[] | null;
    additionalAncillaries?: PnrFlightAdditionalAncillary[] | null;
    paxes?: PnrPaxDetails[] | null;
    creditCardPayment?: CreditCardInfo | null;
    travelCompany?: PnrTravelCompany | null;
    remarks?: PnrRemarks[] | null;
    osiSsr?: PnrOsiSsr[] | null;
    cO2Emissions?: CO2Emissions | null;
    connectorCustomData?: PnrCustomData | null;

    constructor(data?: IBaseOperationPnr) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullReferenceId = _data["FullReferenceId"] !== undefined ? _data["FullReferenceId"] : null as any;
            this.resultKey = _data["ResultKey"] !== undefined ? _data["ResultKey"] : null as any;
            this.routingKey = _data["RoutingKey"] !== undefined ? _data["RoutingKey"] : null as any;
            this.isPure = _data["IsPure"] !== undefined ? _data["IsPure"] : null as any;
            this.codeShareKey = _data["CodeShareKey"] !== undefined ? _data["CodeShareKey"] : null as any;
            this.connectorCode = _data["ConnectorCode"] !== undefined ? _data["ConnectorCode"] : null as any;
            this.closePnr = _data["ClosePnr"] !== undefined ? _data["ClosePnr"] : null as any;
            this.bookingStatus = _data["BookingStatus"] !== undefined ? _data["BookingStatus"] : null as any;
            this.pnrNumber = _data["PnrNumber"] !== undefined ? _data["PnrNumber"] : null as any;
            this.pseudoCityCode = _data["PseudoCityCode"] !== undefined ? _data["PseudoCityCode"] : null as any;
            this.pnrDate = _data["PnrDate"] !== undefined ? _data["PnrDate"] : null as any;
            this.cancelDate = _data["CancelDate"] !== undefined ? _data["CancelDate"] : null as any;
            this.lastTicketDate = _data["LastTicketDate"] !== undefined ? _data["LastTicketDate"] : null as any;
            if (Array.isArray(_data["FlightSegments"])) {
                this.flightSegments = [] as any;
                for (let item of _data["FlightSegments"])
                    this.flightSegments!.push(PnrFlightSegment.fromJS(item));
            }
            else {
                this.flightSegments = null as any;
            }
            this.fare = _data["Fare"] ? PnrFlightFare.fromJS(_data["Fare"]) : null as any;
            if (Array.isArray(_data["AlternativeFares"])) {
                this.alternativeFares = [] as any;
                for (let item of _data["AlternativeFares"])
                    this.alternativeFares!.push(PnrFlightFare.fromJS(item));
            }
            else {
                this.alternativeFares = null as any;
            }
            if (Array.isArray(_data["Ancillaries"])) {
                this.ancillaries = [] as any;
                for (let item of _data["Ancillaries"])
                    this.ancillaries!.push(PnrBookedFlightAncillary.fromJS(item));
            }
            else {
                this.ancillaries = null as any;
            }
            if (Array.isArray(_data["AdditionalAncillaries"])) {
                this.additionalAncillaries = [] as any;
                for (let item of _data["AdditionalAncillaries"])
                    this.additionalAncillaries!.push(PnrFlightAdditionalAncillary.fromJS(item));
            }
            else {
                this.additionalAncillaries = null as any;
            }
            if (Array.isArray(_data["Paxes"])) {
                this.paxes = [] as any;
                for (let item of _data["Paxes"])
                    this.paxes!.push(PnrPaxDetails.fromJS(item));
            }
            else {
                this.paxes = null as any;
            }
            this.creditCardPayment = _data["CreditCardPayment"] ? CreditCardInfo.fromJS(_data["CreditCardPayment"]) : null as any;
            this.travelCompany = _data["TravelCompany"] ? PnrTravelCompany.fromJS(_data["TravelCompany"]) : null as any;
            if (Array.isArray(_data["Remarks"])) {
                this.remarks = [] as any;
                for (let item of _data["Remarks"])
                    this.remarks!.push(PnrRemarks.fromJS(item));
            }
            else {
                this.remarks = null as any;
            }
            if (Array.isArray(_data["OsiSsr"])) {
                this.osiSsr = [] as any;
                for (let item of _data["OsiSsr"])
                    this.osiSsr!.push(PnrOsiSsr.fromJS(item));
            }
            else {
                this.osiSsr = null as any;
            }
            this.cO2Emissions = _data["CO2Emissions"] ? CO2Emissions.fromJS(_data["CO2Emissions"]) : null as any;
            this.connectorCustomData = _data["ConnectorCustomData"] ? PnrCustomData.fromJS(_data["ConnectorCustomData"]) : null as any;
        }
    }

    static fromJS(data: any): BaseOperationPnr {
        data = typeof data === 'object' ? data : {};
        let result = new BaseOperationPnr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FullReferenceId"] = this.fullReferenceId !== undefined ? this.fullReferenceId : null as any;
        data["ResultKey"] = this.resultKey !== undefined ? this.resultKey : null as any;
        data["RoutingKey"] = this.routingKey !== undefined ? this.routingKey : null as any;
        data["IsPure"] = this.isPure !== undefined ? this.isPure : null as any;
        data["CodeShareKey"] = this.codeShareKey !== undefined ? this.codeShareKey : null as any;
        data["ConnectorCode"] = this.connectorCode !== undefined ? this.connectorCode : null as any;
        data["ClosePnr"] = this.closePnr !== undefined ? this.closePnr : null as any;
        data["BookingStatus"] = this.bookingStatus !== undefined ? this.bookingStatus : null as any;
        data["PnrNumber"] = this.pnrNumber !== undefined ? this.pnrNumber : null as any;
        data["PseudoCityCode"] = this.pseudoCityCode !== undefined ? this.pseudoCityCode : null as any;
        data["PnrDate"] = this.pnrDate !== undefined ? this.pnrDate : null as any;
        data["CancelDate"] = this.cancelDate !== undefined ? this.cancelDate : null as any;
        data["LastTicketDate"] = this.lastTicketDate !== undefined ? this.lastTicketDate : null as any;
        if (Array.isArray(this.flightSegments)) {
            data["FlightSegments"] = [];
            for (let item of this.flightSegments)
                data["FlightSegments"].push(item ? item.toJSON() : null as any);
        }
        data["Fare"] = this.fare ? this.fare.toJSON() : null as any;
        if (Array.isArray(this.alternativeFares)) {
            data["AlternativeFares"] = [];
            for (let item of this.alternativeFares)
                data["AlternativeFares"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.ancillaries)) {
            data["Ancillaries"] = [];
            for (let item of this.ancillaries)
                data["Ancillaries"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.additionalAncillaries)) {
            data["AdditionalAncillaries"] = [];
            for (let item of this.additionalAncillaries)
                data["AdditionalAncillaries"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.paxes)) {
            data["Paxes"] = [];
            for (let item of this.paxes)
                data["Paxes"].push(item ? item.toJSON() : null as any);
        }
        data["CreditCardPayment"] = this.creditCardPayment ? this.creditCardPayment.toJSON() : null as any;
        data["TravelCompany"] = this.travelCompany ? this.travelCompany.toJSON() : null as any;
        if (Array.isArray(this.remarks)) {
            data["Remarks"] = [];
            for (let item of this.remarks)
                data["Remarks"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.osiSsr)) {
            data["OsiSsr"] = [];
            for (let item of this.osiSsr)
                data["OsiSsr"].push(item ? item.toJSON() : null as any);
        }
        data["CO2Emissions"] = this.cO2Emissions ? this.cO2Emissions.toJSON() : null as any;
        data["ConnectorCustomData"] = this.connectorCustomData ? this.connectorCustomData.toJSON() : null as any;
        return data;
    }
}

export interface IBaseOperationPnr {
    fullReferenceId?: string | null;
    resultKey?: string | null;
    routingKey?: string | null;
    isPure?: boolean | null;
    codeShareKey?: string | null;
    connectorCode: EH2HConnectorCode;
    closePnr?: boolean | null;
    bookingStatus?: EBookingStatus | null;
    pnrNumber?: string | null;
    pseudoCityCode?: string | null;
    pnrDate?: string | null;
    cancelDate?: string | null;
    lastTicketDate?: string | null;
    flightSegments?: PnrFlightSegment[] | null;
    fare?: PnrFlightFare | null;
    alternativeFares?: PnrFlightFare[] | null;
    ancillaries?: PnrBookedFlightAncillary[] | null;
    additionalAncillaries?: PnrFlightAdditionalAncillary[] | null;
    paxes?: PnrPaxDetails[] | null;
    creditCardPayment?: CreditCardInfo | null;
    travelCompany?: PnrTravelCompany | null;
    remarks?: PnrRemarks[] | null;
    osiSsr?: PnrOsiSsr[] | null;
    cO2Emissions?: CO2Emissions | null;
    connectorCustomData?: PnrCustomData | null;
}

export enum EBookingStatus {
    PENDING = "PENDING",
    BOOKED = "BOOKED",
    DELETED = "DELETED",
    ERROR = "ERROR",
    MODIFIED = "MODIFIED",
}

export class PnrFlightSegment extends FlightSegment implements IPnrFlightSegment {
    flightStatus?: EFlightStatus | null;
    connectorCustomData?: PnrFlightSegmentCustomData | null;

    constructor(data?: IPnrFlightSegment) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.flightStatus = _data["FlightStatus"] !== undefined ? _data["FlightStatus"] : null as any;
            this.connectorCustomData = _data["ConnectorCustomData"] ? PnrFlightSegmentCustomData.fromJS(_data["ConnectorCustomData"]) : null as any;
        }
    }

    static override fromJS(data: any): PnrFlightSegment {
        data = typeof data === 'object' ? data : {};
        let result = new PnrFlightSegment();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FlightStatus"] = this.flightStatus !== undefined ? this.flightStatus : null as any;
        data["ConnectorCustomData"] = this.connectorCustomData ? this.connectorCustomData.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPnrFlightSegment extends IFlightSegment {
    flightStatus?: EFlightStatus | null;
    connectorCustomData?: PnrFlightSegmentCustomData | null;
}

export enum EFlightStatus {
    HK_CONFIRMED = "HK_CONFIRMED",
    WL_WAITLISTED = "WL_WAITLISTED",
    RQ_ON_REQUEST = "RQ_ON_REQUEST",
    X_CANCELLED = "X_CANCELLED",
    UC_IMPOSSIBLE = "UC_IMPOSSIBLE",
    SC_SCHEDULE_CHANGE = "SC_SCHEDULE_CHANGE",
    UNKNOWN = "UNKNOWN",
}

export abstract class PnrFlightSegmentCustomData implements IPnrFlightSegmentCustomData {

    protected _discriminator: string;

    constructor(data?: IPnrFlightSegmentCustomData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "PnrFlightSegmentCustomData";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): PnrFlightSegmentCustomData {
        data = typeof data === 'object' ? data : {};
        if (data["CustomDataConnectorCode"] === "SABRE") {
            let result = new SabrePnrFlightSegmentCustomData();
            result.init(data);
            return result;
        }
        if (data["CustomDataConnectorCode"] === "AMADEUS") {
            let result = new AmadeusPnrFlightSegmentCustomData();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'PnrFlightSegmentCustomData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomDataConnectorCode"] = this._discriminator;
        return data;
    }
}

export interface IPnrFlightSegmentCustomData {
}

export class SabrePnrFlightSegmentCustomData extends PnrFlightSegmentCustomData implements ISabrePnrFlightSegmentCustomData {
    marriageGrp?: string | null;
    statusCode?: string | null;

    constructor(data?: ISabrePnrFlightSegmentCustomData) {
        super(data);
        this._discriminator = "SABRE";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.marriageGrp = _data["MarriageGrp"] !== undefined ? _data["MarriageGrp"] : null as any;
            this.statusCode = _data["StatusCode"] !== undefined ? _data["StatusCode"] : null as any;
        }
    }

    static override fromJS(data: any): SabrePnrFlightSegmentCustomData {
        data = typeof data === 'object' ? data : {};
        let result = new SabrePnrFlightSegmentCustomData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MarriageGrp"] = this.marriageGrp !== undefined ? this.marriageGrp : null as any;
        data["StatusCode"] = this.statusCode !== undefined ? this.statusCode : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISabrePnrFlightSegmentCustomData extends IPnrFlightSegmentCustomData {
    marriageGrp?: string | null;
    statusCode?: string | null;
}

export class AmadeusPnrFlightSegmentCustomData extends PnrFlightSegmentCustomData implements IAmadeusPnrFlightSegmentCustomData {
    referenceNumber?: string | null;
    lineNumber?: string | null;
    classCode?: string | null;
    status?: string | null;
    eTicket?: boolean | null;
    quantity?: number | null;
    numOfStops?: string | null;
    operatedByText?: string | null;
    cabinDetails?: string | null;

    constructor(data?: IAmadeusPnrFlightSegmentCustomData) {
        super(data);
        this._discriminator = "AMADEUS";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.referenceNumber = _data["ReferenceNumber"] !== undefined ? _data["ReferenceNumber"] : null as any;
            this.lineNumber = _data["LineNumber"] !== undefined ? _data["LineNumber"] : null as any;
            this.classCode = _data["ClassCode"] !== undefined ? _data["ClassCode"] : null as any;
            this.status = _data["Status"] !== undefined ? _data["Status"] : null as any;
            this.eTicket = _data["ETicket"] !== undefined ? _data["ETicket"] : null as any;
            this.quantity = _data["Quantity"] !== undefined ? _data["Quantity"] : null as any;
            this.numOfStops = _data["NumOfStops"] !== undefined ? _data["NumOfStops"] : null as any;
            this.operatedByText = _data["OperatedByText"] !== undefined ? _data["OperatedByText"] : null as any;
            this.cabinDetails = _data["CabinDetails"] !== undefined ? _data["CabinDetails"] : null as any;
        }
    }

    static override fromJS(data: any): AmadeusPnrFlightSegmentCustomData {
        data = typeof data === 'object' ? data : {};
        let result = new AmadeusPnrFlightSegmentCustomData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ReferenceNumber"] = this.referenceNumber !== undefined ? this.referenceNumber : null as any;
        data["LineNumber"] = this.lineNumber !== undefined ? this.lineNumber : null as any;
        data["ClassCode"] = this.classCode !== undefined ? this.classCode : null as any;
        data["Status"] = this.status !== undefined ? this.status : null as any;
        data["ETicket"] = this.eTicket !== undefined ? this.eTicket : null as any;
        data["Quantity"] = this.quantity !== undefined ? this.quantity : null as any;
        data["NumOfStops"] = this.numOfStops !== undefined ? this.numOfStops : null as any;
        data["OperatedByText"] = this.operatedByText !== undefined ? this.operatedByText : null as any;
        data["CabinDetails"] = this.cabinDetails !== undefined ? this.cabinDetails : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAmadeusPnrFlightSegmentCustomData extends IPnrFlightSegmentCustomData {
    referenceNumber?: string | null;
    lineNumber?: string | null;
    classCode?: string | null;
    status?: string | null;
    eTicket?: boolean | null;
    quantity?: number | null;
    numOfStops?: string | null;
    operatedByText?: string | null;
    cabinDetails?: string | null;
}

export class PnrFlightFare extends FlightFare implements IPnrFlightFare {
    customerCustomData?: CustomerCustomDataOfPnrFlightFare | null;

    constructor(data?: IPnrFlightFare) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customerCustomData = _data["CustomerCustomData"] ? CustomerCustomDataOfPnrFlightFare.fromJS(_data["CustomerCustomData"]) : null as any;
        }
    }

    static override fromJS(data: any): PnrFlightFare {
        data = typeof data === 'object' ? data : {};
        let result = new PnrFlightFare();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomerCustomData"] = this.customerCustomData ? this.customerCustomData.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPnrFlightFare extends IFlightFare {
    customerCustomData?: CustomerCustomDataOfPnrFlightFare | null;
}

export abstract class CustomerCustomDataOfPnrFlightFare implements ICustomerCustomDataOfPnrFlightFare {

    protected _discriminator: string;

    constructor(data?: ICustomerCustomDataOfPnrFlightFare) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "CustomerCustomDataOfPnrFlightFare";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CustomerCustomDataOfPnrFlightFare {
        data = typeof data === 'object' ? data : {};
        if (data["CustomDataCode"] === "FlightPnrFareNaarData") {
            let result = new FlightPnrFareNaarData();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'CustomerCustomDataOfPnrFlightFare' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomDataCode"] = this._discriminator;
        return data;
    }
}

export interface ICustomerCustomDataOfPnrFlightFare {
}

export class FlightPnrFareNaarData extends CustomerCustomDataOfPnrFlightFare implements IFlightPnrFareNaarData {
    isToFare?: boolean | null;
    totalAmountWithoutTaxWithMarkup?: CurrencyAmount | null;
    totalAmountWithMarkup?: CurrencyAmount | null;
    totalTaxWithMarkup?: CurrencyAmount | null;
    perPaxAmountWithMarkup?: CurrencyAmount | null;

    constructor(data?: IFlightPnrFareNaarData) {
        super(data);
        this._discriminator = "FlightPnrFareNaarData";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isToFare = _data["isToFare"] !== undefined ? _data["isToFare"] : null as any;
            this.totalAmountWithoutTaxWithMarkup = _data["TotalAmountWithoutTaxWithMarkup"] ? CurrencyAmount.fromJS(_data["TotalAmountWithoutTaxWithMarkup"]) : null as any;
            this.totalAmountWithMarkup = _data["TotalAmountWithMarkup"] ? CurrencyAmount.fromJS(_data["TotalAmountWithMarkup"]) : null as any;
            this.totalTaxWithMarkup = _data["TotalTaxWithMarkup"] ? CurrencyAmount.fromJS(_data["TotalTaxWithMarkup"]) : null as any;
            this.perPaxAmountWithMarkup = _data["PerPaxAmountWithMarkup"] ? CurrencyAmount.fromJS(_data["PerPaxAmountWithMarkup"]) : null as any;
        }
    }

    static override fromJS(data: any): FlightPnrFareNaarData {
        data = typeof data === 'object' ? data : {};
        let result = new FlightPnrFareNaarData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isToFare"] = this.isToFare !== undefined ? this.isToFare : null as any;
        data["TotalAmountWithoutTaxWithMarkup"] = this.totalAmountWithoutTaxWithMarkup ? this.totalAmountWithoutTaxWithMarkup.toJSON() : null as any;
        data["TotalAmountWithMarkup"] = this.totalAmountWithMarkup ? this.totalAmountWithMarkup.toJSON() : null as any;
        data["TotalTaxWithMarkup"] = this.totalTaxWithMarkup ? this.totalTaxWithMarkup.toJSON() : null as any;
        data["PerPaxAmountWithMarkup"] = this.perPaxAmountWithMarkup ? this.perPaxAmountWithMarkup.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IFlightPnrFareNaarData extends ICustomerCustomDataOfPnrFlightFare {
    isToFare?: boolean | null;
    totalAmountWithoutTaxWithMarkup?: CurrencyAmount | null;
    totalAmountWithMarkup?: CurrencyAmount | null;
    totalTaxWithMarkup?: CurrencyAmount | null;
    perPaxAmountWithMarkup?: CurrencyAmount | null;
}

export abstract class BaseFlightAncillary implements IBaseFlightAncillary {
    id?: string | null;
    type?: EAncillaryType | null;
    code?: string | null;
    description?: string | null;

    constructor(data?: IBaseFlightAncillary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"] !== undefined ? _data["Id"] : null as any;
            this.type = _data["Type"] !== undefined ? _data["Type"] : null as any;
            this.code = _data["Code"] !== undefined ? _data["Code"] : null as any;
            this.description = _data["Description"] !== undefined ? _data["Description"] : null as any;
        }
    }

    static fromJS(data: any): BaseFlightAncillary {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseFlightAncillary' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id !== undefined ? this.id : null as any;
        data["Type"] = this.type !== undefined ? this.type : null as any;
        data["Code"] = this.code !== undefined ? this.code : null as any;
        data["Description"] = this.description !== undefined ? this.description : null as any;
        return data;
    }
}

export interface IBaseFlightAncillary {
    id?: string | null;
    type?: EAncillaryType | null;
    code?: string | null;
    description?: string | null;
}

export class BookedFlightAncillary extends BaseFlightAncillary implements IBookedFlightAncillary {
    paxRefId?: string | null;
    flightSegmentRefIds?: string[] | null;
    chargeMode?: EAncillaryChargeMode | null;
    baseAmount?: CurrencyAmount | null;
    selectedOptionIdOrValue?: string | null;
    selectedOptionDescription?: string | null;
    totalAmount?: CurrencyAmount | null;

    constructor(data?: IBookedFlightAncillary) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.paxRefId = _data["PaxRefId"] !== undefined ? _data["PaxRefId"] : null as any;
            if (Array.isArray(_data["FlightSegmentRefIds"])) {
                this.flightSegmentRefIds = [] as any;
                for (let item of _data["FlightSegmentRefIds"])
                    this.flightSegmentRefIds!.push(item);
            }
            else {
                this.flightSegmentRefIds = null as any;
            }
            this.chargeMode = _data["ChargeMode"] !== undefined ? _data["ChargeMode"] : null as any;
            this.baseAmount = _data["BaseAmount"] ? CurrencyAmount.fromJS(_data["BaseAmount"]) : null as any;
            this.selectedOptionIdOrValue = _data["SelectedOptionIdOrValue"] !== undefined ? _data["SelectedOptionIdOrValue"] : null as any;
            this.selectedOptionDescription = _data["SelectedOptionDescription"] !== undefined ? _data["SelectedOptionDescription"] : null as any;
            this.totalAmount = _data["TotalAmount"] ? CurrencyAmount.fromJS(_data["TotalAmount"]) : null as any;
        }
    }

    static override fromJS(data: any): BookedFlightAncillary {
        data = typeof data === 'object' ? data : {};
        let result = new BookedFlightAncillary();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PaxRefId"] = this.paxRefId !== undefined ? this.paxRefId : null as any;
        if (Array.isArray(this.flightSegmentRefIds)) {
            data["FlightSegmentRefIds"] = [];
            for (let item of this.flightSegmentRefIds)
                data["FlightSegmentRefIds"].push(item);
        }
        data["ChargeMode"] = this.chargeMode !== undefined ? this.chargeMode : null as any;
        data["BaseAmount"] = this.baseAmount ? this.baseAmount.toJSON() : null as any;
        data["SelectedOptionIdOrValue"] = this.selectedOptionIdOrValue !== undefined ? this.selectedOptionIdOrValue : null as any;
        data["SelectedOptionDescription"] = this.selectedOptionDescription !== undefined ? this.selectedOptionDescription : null as any;
        data["TotalAmount"] = this.totalAmount ? this.totalAmount.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IBookedFlightAncillary extends IBaseFlightAncillary {
    paxRefId?: string | null;
    flightSegmentRefIds?: string[] | null;
    chargeMode?: EAncillaryChargeMode | null;
    baseAmount?: CurrencyAmount | null;
    selectedOptionIdOrValue?: string | null;
    selectedOptionDescription?: string | null;
    totalAmount?: CurrencyAmount | null;
}

export class PnrBookedFlightAncillary extends BookedFlightAncillary implements IPnrBookedFlightAncillary {

    constructor(data?: IPnrBookedFlightAncillary) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PnrBookedFlightAncillary {
        data = typeof data === 'object' ? data : {};
        let result = new PnrBookedFlightAncillary();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPnrBookedFlightAncillary extends IBookedFlightAncillary {
}

export enum EAncillaryChargeMode {
    PER_PERSON = "PER_PERSON",
    PER_SEGMENT = "PER_SEGMENT",
    PER_PERSON_PER_SEGMENT = "PER_PERSON_PER_SEGMENT",
    TOTAL = "TOTAL",
}

export enum EAncillaryType {
    BAGGAGE = "BAGGAGE",
    OUTWARD_BAGGAGE = "OUTWARD_BAGGAGE",
    RETURN_BAGGAGE = "RETURN_BAGGAGE",
    HAND_BAGGAGE = "HAND_BAGGAGE",
    HAND_OUTWARD_BAGGAGE = "HAND_OUTWARD_BAGGAGE",
    HAND_RETURN_BAGGAGE = "HAND_RETURN_BAGGAGE",
    MEAL = "MEAL",
    INSURANCE = "INSURANCE",
    SPEEDY_BOARDING = "SPEEDY_BOARDING",
    ONLINE_CHECKIN = "ONLINE_CHECKIN",
    AIRPORT_CHECKIN = "AIRPORT_CHECKIN",
    SEAT_ASSIGNMENT = "SEAT_ASSIGNMENT",
    CARD_CHARGE = "CARD_CHARGE",
    EQUIPMENT = "EQUIPMENT",
    OTHER = "OTHER",
}

export class FlightAdditionalAncillary extends BaseFlightAncillary implements IFlightAdditionalAncillary {
    options?: FlightAncillaryOption[] | null;
    selectedPaxRefId?: string | null;
    selectedFlightSegmentRefIds?: string[] | null;
    selectedOptionIdOrValue?: string | null;

    constructor(data?: IFlightAdditionalAncillary) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["Options"])) {
                this.options = [] as any;
                for (let item of _data["Options"])
                    this.options!.push(FlightAncillaryOption.fromJS(item));
            }
            else {
                this.options = null as any;
            }
            this.selectedPaxRefId = _data["SelectedPaxRefId"] !== undefined ? _data["SelectedPaxRefId"] : null as any;
            if (Array.isArray(_data["SelectedFlightSegmentRefIds"])) {
                this.selectedFlightSegmentRefIds = [] as any;
                for (let item of _data["SelectedFlightSegmentRefIds"])
                    this.selectedFlightSegmentRefIds!.push(item);
            }
            else {
                this.selectedFlightSegmentRefIds = null as any;
            }
            this.selectedOptionIdOrValue = _data["SelectedOptionIdOrValue"] !== undefined ? _data["SelectedOptionIdOrValue"] : null as any;
        }
    }

    static override fromJS(data: any): FlightAdditionalAncillary {
        data = typeof data === 'object' ? data : {};
        let result = new FlightAdditionalAncillary();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.options)) {
            data["Options"] = [];
            for (let item of this.options)
                data["Options"].push(item ? item.toJSON() : null as any);
        }
        data["SelectedPaxRefId"] = this.selectedPaxRefId !== undefined ? this.selectedPaxRefId : null as any;
        if (Array.isArray(this.selectedFlightSegmentRefIds)) {
            data["SelectedFlightSegmentRefIds"] = [];
            for (let item of this.selectedFlightSegmentRefIds)
                data["SelectedFlightSegmentRefIds"].push(item);
        }
        data["SelectedOptionIdOrValue"] = this.selectedOptionIdOrValue !== undefined ? this.selectedOptionIdOrValue : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IFlightAdditionalAncillary extends IBaseFlightAncillary {
    options?: FlightAncillaryOption[] | null;
    selectedPaxRefId?: string | null;
    selectedFlightSegmentRefIds?: string[] | null;
    selectedOptionIdOrValue?: string | null;
}

export class PnrFlightAdditionalAncillary extends FlightAdditionalAncillary implements IPnrFlightAdditionalAncillary {

    constructor(data?: IPnrFlightAdditionalAncillary) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PnrFlightAdditionalAncillary {
        data = typeof data === 'object' ? data : {};
        let result = new PnrFlightAdditionalAncillary();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPnrFlightAdditionalAncillary extends IFlightAdditionalAncillary {
}

export class FlightAncillaryOption implements IFlightAncillaryOption {
    id!: string;
    description?: string | null;
    paxType?: EPaxType | null;
    chargeMode?: EAncillaryChargeMode | null;
    baseAmount!: CurrencyAmount;
    seatMapInfo?: SeatMap | null;
    baggageInfo?: BaggageInfo | null;

    constructor(data?: IFlightAncillaryOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.baseAmount = new CurrencyAmount();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"] !== undefined ? _data["Id"] : null as any;
            this.description = _data["Description"] !== undefined ? _data["Description"] : null as any;
            this.paxType = _data["PaxType"] !== undefined ? _data["PaxType"] : null as any;
            this.chargeMode = _data["ChargeMode"] !== undefined ? _data["ChargeMode"] : null as any;
            this.baseAmount = _data["BaseAmount"] ? CurrencyAmount.fromJS(_data["BaseAmount"]) : new CurrencyAmount();
            this.seatMapInfo = _data["SeatMapInfo"] ? SeatMap.fromJS(_data["SeatMapInfo"]) : null as any;
            this.baggageInfo = _data["BaggageInfo"] ? BaggageInfo.fromJS(_data["BaggageInfo"]) : null as any;
        }
    }

    static fromJS(data: any): FlightAncillaryOption {
        data = typeof data === 'object' ? data : {};
        let result = new FlightAncillaryOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id !== undefined ? this.id : null as any;
        data["Description"] = this.description !== undefined ? this.description : null as any;
        data["PaxType"] = this.paxType !== undefined ? this.paxType : null as any;
        data["ChargeMode"] = this.chargeMode !== undefined ? this.chargeMode : null as any;
        data["BaseAmount"] = this.baseAmount ? this.baseAmount.toJSON() : null as any;
        data["SeatMapInfo"] = this.seatMapInfo ? this.seatMapInfo.toJSON() : null as any;
        data["BaggageInfo"] = this.baggageInfo ? this.baggageInfo.toJSON() : null as any;
        return data;
    }
}

export interface IFlightAncillaryOption {
    id: string;
    description?: string | null;
    paxType?: EPaxType | null;
    chargeMode?: EAncillaryChargeMode | null;
    baseAmount: CurrencyAmount;
    seatMapInfo?: SeatMap | null;
    baggageInfo?: BaggageInfo | null;
}

export class SeatMap implements ISeatMap {
    rowNumber?: number | null;
    rowPosition?: ESeatMapRowPosition | null;
    column?: string | null;
    columnPosition?: ESeatMapColumnPosition | null;
    seatAvailability?: ESeatMapAvailability | null;
    rowLevel?: ESeatMapRowLevel | null;
    seatCharacteristics?: string[] | null;
    extraLeg?: boolean | null;
    exitRow?: boolean | null;
    hasPaxTypeRestriction?: boolean | null;
    hasRestriction?: boolean | null;
    isFacility?: boolean | null;

    constructor(data?: ISeatMap) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowNumber = _data["RowNumber"] !== undefined ? _data["RowNumber"] : null as any;
            this.rowPosition = _data["RowPosition"] !== undefined ? _data["RowPosition"] : null as any;
            this.column = _data["Column"] !== undefined ? _data["Column"] : null as any;
            this.columnPosition = _data["ColumnPosition"] !== undefined ? _data["ColumnPosition"] : null as any;
            this.seatAvailability = _data["SeatAvailability"] !== undefined ? _data["SeatAvailability"] : null as any;
            this.rowLevel = _data["RowLevel"] !== undefined ? _data["RowLevel"] : null as any;
            if (Array.isArray(_data["SeatCharacteristics"])) {
                this.seatCharacteristics = [] as any;
                for (let item of _data["SeatCharacteristics"])
                    this.seatCharacteristics!.push(item);
            }
            else {
                this.seatCharacteristics = null as any;
            }
            this.extraLeg = _data["ExtraLeg"] !== undefined ? _data["ExtraLeg"] : null as any;
            this.exitRow = _data["ExitRow"] !== undefined ? _data["ExitRow"] : null as any;
            this.hasPaxTypeRestriction = _data["HasPaxTypeRestriction"] !== undefined ? _data["HasPaxTypeRestriction"] : null as any;
            this.hasRestriction = _data["HasRestriction"] !== undefined ? _data["HasRestriction"] : null as any;
            this.isFacility = _data["IsFacility"] !== undefined ? _data["IsFacility"] : null as any;
        }
    }

    static fromJS(data: any): SeatMap {
        data = typeof data === 'object' ? data : {};
        let result = new SeatMap();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RowNumber"] = this.rowNumber !== undefined ? this.rowNumber : null as any;
        data["RowPosition"] = this.rowPosition !== undefined ? this.rowPosition : null as any;
        data["Column"] = this.column !== undefined ? this.column : null as any;
        data["ColumnPosition"] = this.columnPosition !== undefined ? this.columnPosition : null as any;
        data["SeatAvailability"] = this.seatAvailability !== undefined ? this.seatAvailability : null as any;
        data["RowLevel"] = this.rowLevel !== undefined ? this.rowLevel : null as any;
        if (Array.isArray(this.seatCharacteristics)) {
            data["SeatCharacteristics"] = [];
            for (let item of this.seatCharacteristics)
                data["SeatCharacteristics"].push(item);
        }
        data["ExtraLeg"] = this.extraLeg !== undefined ? this.extraLeg : null as any;
        data["ExitRow"] = this.exitRow !== undefined ? this.exitRow : null as any;
        data["HasPaxTypeRestriction"] = this.hasPaxTypeRestriction !== undefined ? this.hasPaxTypeRestriction : null as any;
        data["HasRestriction"] = this.hasRestriction !== undefined ? this.hasRestriction : null as any;
        data["IsFacility"] = this.isFacility !== undefined ? this.isFacility : null as any;
        return data;
    }
}

export interface ISeatMap {
    rowNumber?: number | null;
    rowPosition?: ESeatMapRowPosition | null;
    column?: string | null;
    columnPosition?: ESeatMapColumnPosition | null;
    seatAvailability?: ESeatMapAvailability | null;
    rowLevel?: ESeatMapRowLevel | null;
    seatCharacteristics?: string[] | null;
    extraLeg?: boolean | null;
    exitRow?: boolean | null;
    hasPaxTypeRestriction?: boolean | null;
    hasRestriction?: boolean | null;
    isFacility?: boolean | null;
}

export enum ESeatMapRowPosition {
    BEFORE_WINGS = "BEFORE_WINGS",
    AFTER_WINGS = "AFTER_WINGS",
    ON_WINGS = "ON_WINGS",
}

export enum ESeatMapColumnPosition {
    CENTER_SEAT = "CENTER_SEAT",
    AISLE_SEAT = "AISLE_SEAT",
    WINDOW_SEAT = "WINDOW_SEAT",
}

export enum ESeatMapAvailability {
    UNKOWN = "UNKOWN",
    AVAILABLE = "AVAILABLE",
    OCCUPIED = "OCCUPIED",
    UNAVAILABLE = "UNAVAILABLE",
}

export enum ESeatMapRowLevel {
    LOWER_DECK = "LOWER_DECK",
    MAIN_DECK = "MAIN_DECK",
    UPPER_DECK = "UPPER_DECK",
}

export class BaggageInfo implements IBaggageInfo {
    parentId?: string | null;
    baggageInfoCode?: string | null;
    baggageCostType?: EBaggageCostType | null;
    baggageBookingCode?: string | null;
    freeBaggageData?: FreeBaggageData[] | null;

    constructor(data?: IBaggageInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["ParentId"] !== undefined ? _data["ParentId"] : null as any;
            this.baggageInfoCode = _data["BaggageInfoCode"] !== undefined ? _data["BaggageInfoCode"] : null as any;
            this.baggageCostType = _data["BaggageCostType"] !== undefined ? _data["BaggageCostType"] : null as any;
            this.baggageBookingCode = _data["BaggageBookingCode"] !== undefined ? _data["BaggageBookingCode"] : null as any;
            if (Array.isArray(_data["FreeBaggageData"])) {
                this.freeBaggageData = [] as any;
                for (let item of _data["FreeBaggageData"])
                    this.freeBaggageData!.push(FreeBaggageData.fromJS(item));
            }
            else {
                this.freeBaggageData = null as any;
            }
        }
    }

    static fromJS(data: any): BaggageInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BaggageInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ParentId"] = this.parentId !== undefined ? this.parentId : null as any;
        data["BaggageInfoCode"] = this.baggageInfoCode !== undefined ? this.baggageInfoCode : null as any;
        data["BaggageCostType"] = this.baggageCostType !== undefined ? this.baggageCostType : null as any;
        data["BaggageBookingCode"] = this.baggageBookingCode !== undefined ? this.baggageBookingCode : null as any;
        if (Array.isArray(this.freeBaggageData)) {
            data["FreeBaggageData"] = [];
            for (let item of this.freeBaggageData)
                data["FreeBaggageData"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IBaggageInfo {
    parentId?: string | null;
    baggageInfoCode?: string | null;
    baggageCostType?: EBaggageCostType | null;
    baggageBookingCode?: string | null;
    freeBaggageData?: FreeBaggageData[] | null;
}

export enum EBaggageCostType {
    PRICE_PER_PIECE = "PRICE_PER_PIECE",
    PRICE_PER_WEIGHT = "PRICE_PER_WEIGHT",
    PRICE_PER_RANGE_OF_WEIGHT = "PRICE_PER_RANGE_OF_WEIGHT",
}

export class FreeBaggageData implements IFreeBaggageData {
    fbaMinWeight?: number | null;
    fbaMaxWeight?: number | null;
    weightUnitValue?: string | null;
    fbaQuantity?: number | null;
    isWeightBased?: boolean | null;
    flightSegmentRefIds?: string[] | null;

    constructor(data?: IFreeBaggageData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fbaMinWeight = _data["FbaMinWeight"] !== undefined ? _data["FbaMinWeight"] : null as any;
            this.fbaMaxWeight = _data["FbaMaxWeight"] !== undefined ? _data["FbaMaxWeight"] : null as any;
            this.weightUnitValue = _data["WeightUnitValue"] !== undefined ? _data["WeightUnitValue"] : null as any;
            this.fbaQuantity = _data["FbaQuantity"] !== undefined ? _data["FbaQuantity"] : null as any;
            this.isWeightBased = _data["IsWeightBased"] !== undefined ? _data["IsWeightBased"] : null as any;
            if (Array.isArray(_data["FlightSegmentRefIds"])) {
                this.flightSegmentRefIds = [] as any;
                for (let item of _data["FlightSegmentRefIds"])
                    this.flightSegmentRefIds!.push(item);
            }
            else {
                this.flightSegmentRefIds = null as any;
            }
        }
    }

    static fromJS(data: any): FreeBaggageData {
        data = typeof data === 'object' ? data : {};
        let result = new FreeBaggageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FbaMinWeight"] = this.fbaMinWeight !== undefined ? this.fbaMinWeight : null as any;
        data["FbaMaxWeight"] = this.fbaMaxWeight !== undefined ? this.fbaMaxWeight : null as any;
        data["WeightUnitValue"] = this.weightUnitValue !== undefined ? this.weightUnitValue : null as any;
        data["FbaQuantity"] = this.fbaQuantity !== undefined ? this.fbaQuantity : null as any;
        data["IsWeightBased"] = this.isWeightBased !== undefined ? this.isWeightBased : null as any;
        if (Array.isArray(this.flightSegmentRefIds)) {
            data["FlightSegmentRefIds"] = [];
            for (let item of this.flightSegmentRefIds)
                data["FlightSegmentRefIds"].push(item);
        }
        return data;
    }
}

export interface IFreeBaggageData {
    fbaMinWeight?: number | null;
    fbaMaxWeight?: number | null;
    weightUnitValue?: string | null;
    fbaQuantity?: number | null;
    isWeightBased?: boolean | null;
    flightSegmentRefIds?: string[] | null;
}

export class PaxDetails implements IPaxDetails {
    paxTitle?: string | null;
    gender?: EPaxGender | null;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    emails?: Email[] | null;
    phoneNumbers?: Phone[] | null;
    documents?: PaxDocument[] | null;
    loyaltyCards?: PaxLoyaltyCard[] | null;
    company?: BusinessCompany | null;
    address?: Address | null;
    birthDate!: string;

    constructor(data?: IPaxDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paxTitle = _data["PaxTitle"] !== undefined ? _data["PaxTitle"] : null as any;
            this.gender = _data["Gender"] !== undefined ? _data["Gender"] : null as any;
            this.firstName = _data["FirstName"] !== undefined ? _data["FirstName"] : null as any;
            this.middleName = _data["MiddleName"] !== undefined ? _data["MiddleName"] : null as any;
            this.lastName = _data["LastName"] !== undefined ? _data["LastName"] : null as any;
            if (Array.isArray(_data["Emails"])) {
                this.emails = [] as any;
                for (let item of _data["Emails"])
                    this.emails!.push(Email.fromJS(item));
            }
            else {
                this.emails = null as any;
            }
            if (Array.isArray(_data["PhoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["PhoneNumbers"])
                    this.phoneNumbers!.push(Phone.fromJS(item));
            }
            else {
                this.phoneNumbers = null as any;
            }
            if (Array.isArray(_data["Documents"])) {
                this.documents = [] as any;
                for (let item of _data["Documents"])
                    this.documents!.push(PaxDocument.fromJS(item));
            }
            else {
                this.documents = null as any;
            }
            if (Array.isArray(_data["LoyaltyCards"])) {
                this.loyaltyCards = [] as any;
                for (let item of _data["LoyaltyCards"])
                    this.loyaltyCards!.push(PaxLoyaltyCard.fromJS(item));
            }
            else {
                this.loyaltyCards = null as any;
            }
            this.company = _data["Company"] ? BusinessCompany.fromJS(_data["Company"]) : null as any;
            this.address = _data["Address"] ? Address.fromJS(_data["Address"]) : null as any;
            this.birthDate = _data["BirthDate"] !== undefined ? _data["BirthDate"] : null as any;
        }
    }

    static fromJS(data: any): PaxDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PaxDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PaxTitle"] = this.paxTitle !== undefined ? this.paxTitle : null as any;
        data["Gender"] = this.gender !== undefined ? this.gender : null as any;
        data["FirstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["MiddleName"] = this.middleName !== undefined ? this.middleName : null as any;
        data["LastName"] = this.lastName !== undefined ? this.lastName : null as any;
        if (Array.isArray(this.emails)) {
            data["Emails"] = [];
            for (let item of this.emails)
                data["Emails"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.phoneNumbers)) {
            data["PhoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["PhoneNumbers"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.documents)) {
            data["Documents"] = [];
            for (let item of this.documents)
                data["Documents"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.loyaltyCards)) {
            data["LoyaltyCards"] = [];
            for (let item of this.loyaltyCards)
                data["LoyaltyCards"].push(item ? item.toJSON() : null as any);
        }
        data["Company"] = this.company ? this.company.toJSON() : null as any;
        data["Address"] = this.address ? this.address.toJSON() : null as any;
        data["BirthDate"] = this.birthDate !== undefined ? this.birthDate : null as any;
        return data;
    }
}

export interface IPaxDetails {
    paxTitle?: string | null;
    gender?: EPaxGender | null;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    emails?: Email[] | null;
    phoneNumbers?: Phone[] | null;
    documents?: PaxDocument[] | null;
    loyaltyCards?: PaxLoyaltyCard[] | null;
    company?: BusinessCompany | null;
    address?: Address | null;
    birthDate: string;
}

export class PnrPaxDetails extends PaxDetails implements IPnrPaxDetails {
    id?: string | null;
    connectorCustomData?: PnrPaxDetailsCustomData | null;

    constructor(data?: IPnrPaxDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"] !== undefined ? _data["Id"] : null as any;
            this.connectorCustomData = _data["ConnectorCustomData"] ? PnrPaxDetailsCustomData.fromJS(_data["ConnectorCustomData"]) : null as any;
        }
    }

    static override fromJS(data: any): PnrPaxDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PnrPaxDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id !== undefined ? this.id : null as any;
        data["ConnectorCustomData"] = this.connectorCustomData ? this.connectorCustomData.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPnrPaxDetails extends IPaxDetails {
    id?: string | null;
    connectorCustomData?: PnrPaxDetailsCustomData | null;
}

export abstract class PnrPaxDetailsCustomData implements IPnrPaxDetailsCustomData {

    protected _discriminator: string;

    constructor(data?: IPnrPaxDetailsCustomData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "PnrPaxDetailsCustomData";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): PnrPaxDetailsCustomData {
        data = typeof data === 'object' ? data : {};
        if (data["CustomDataConnectorCode"] === "AMADEUS") {
            let result = new AmadeusPnrPaxDetailsCustomData();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'PnrPaxDetailsCustomData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomDataConnectorCode"] = this._discriminator;
        return data;
    }
}

export interface IPnrPaxDetailsCustomData {
}

export class AmadeusPnrPaxDetailsCustomData extends PnrPaxDetailsCustomData implements IAmadeusPnrPaxDetailsCustomData {
    lineNumber?: string | null;
    paxType?: string | null;
    quantity?: string | null;
    infantIndicator?: string | null;

    constructor(data?: IAmadeusPnrPaxDetailsCustomData) {
        super(data);
        this._discriminator = "AMADEUS";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.lineNumber = _data["LineNumber"] !== undefined ? _data["LineNumber"] : null as any;
            this.paxType = _data["PaxType"] !== undefined ? _data["PaxType"] : null as any;
            this.quantity = _data["Quantity"] !== undefined ? _data["Quantity"] : null as any;
            this.infantIndicator = _data["InfantIndicator"] !== undefined ? _data["InfantIndicator"] : null as any;
        }
    }

    static override fromJS(data: any): AmadeusPnrPaxDetailsCustomData {
        data = typeof data === 'object' ? data : {};
        let result = new AmadeusPnrPaxDetailsCustomData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LineNumber"] = this.lineNumber !== undefined ? this.lineNumber : null as any;
        data["PaxType"] = this.paxType !== undefined ? this.paxType : null as any;
        data["Quantity"] = this.quantity !== undefined ? this.quantity : null as any;
        data["InfantIndicator"] = this.infantIndicator !== undefined ? this.infantIndicator : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAmadeusPnrPaxDetailsCustomData extends IPnrPaxDetailsCustomData {
    lineNumber?: string | null;
    paxType?: string | null;
    quantity?: string | null;
    infantIndicator?: string | null;
}

export enum EPaxGender {
    UNKNOWN = "UNKNOWN",
    MALE = "MALE",
    FEMALE = "FEMALE",
}

export class Email implements IEmail {
    title?: string | null;
    value?: string | null;

    constructor(data?: IEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["Title"] !== undefined ? _data["Title"] : null as any;
            this.value = _data["Value"] !== undefined ? _data["Value"] : null as any;
        }
    }

    static fromJS(data: any): Email {
        data = typeof data === 'object' ? data : {};
        let result = new Email();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Title"] = this.title !== undefined ? this.title : null as any;
        data["Value"] = this.value !== undefined ? this.value : null as any;
        return data;
    }
}

export interface IEmail {
    title?: string | null;
    value?: string | null;
}

export class Phone implements IPhone {
    title?: string | null;
    value?: string | null;

    constructor(data?: IPhone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["Title"] !== undefined ? _data["Title"] : null as any;
            this.value = _data["Value"] !== undefined ? _data["Value"] : null as any;
        }
    }

    static fromJS(data: any): Phone {
        data = typeof data === 'object' ? data : {};
        let result = new Phone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Title"] = this.title !== undefined ? this.title : null as any;
        data["Value"] = this.value !== undefined ? this.value : null as any;
        return data;
    }
}

export interface IPhone {
    title?: string | null;
    value?: string | null;
}

export class PaxDocument implements IPaxDocument {
    type?: EDocumentType | null;
    firstName?: string | null;
    lastName?: string | null;
    number?: string | null;
    issueIsoCode?: string | null;
    nationalityIsoCode?: string | null;
    expirationDate?: string | null;

    constructor(data?: IPaxDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["Type"] !== undefined ? _data["Type"] : null as any;
            this.firstName = _data["FirstName"] !== undefined ? _data["FirstName"] : null as any;
            this.lastName = _data["LastName"] !== undefined ? _data["LastName"] : null as any;
            this.number = _data["Number"] !== undefined ? _data["Number"] : null as any;
            this.issueIsoCode = _data["IssueIsoCode"] !== undefined ? _data["IssueIsoCode"] : null as any;
            this.nationalityIsoCode = _data["NationalityIsoCode"] !== undefined ? _data["NationalityIsoCode"] : null as any;
            this.expirationDate = _data["ExpirationDate"] !== undefined ? _data["ExpirationDate"] : null as any;
        }
    }

    static fromJS(data: any): PaxDocument {
        data = typeof data === 'object' ? data : {};
        let result = new PaxDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Type"] = this.type !== undefined ? this.type : null as any;
        data["FirstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["LastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["Number"] = this.number !== undefined ? this.number : null as any;
        data["IssueIsoCode"] = this.issueIsoCode !== undefined ? this.issueIsoCode : null as any;
        data["NationalityIsoCode"] = this.nationalityIsoCode !== undefined ? this.nationalityIsoCode : null as any;
        data["ExpirationDate"] = this.expirationDate !== undefined ? this.expirationDate : null as any;
        return data;
    }
}

export interface IPaxDocument {
    type?: EDocumentType | null;
    firstName?: string | null;
    lastName?: string | null;
    number?: string | null;
    issueIsoCode?: string | null;
    nationalityIsoCode?: string | null;
    expirationDate?: string | null;
}

export enum EDocumentType {
    ID = "ID",
    PASSPORT = "PASSPORT",
    FISCAL_CODE = "FISCAL_CODE",
}

export class PaxLoyaltyCard implements IPaxLoyaltyCard {
    membershipId?: string | null;
    programId?: string | null;
    iataCode?: string | null;
    cardExpirationDate?: string | null;

    constructor(data?: IPaxLoyaltyCard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.membershipId = _data["MembershipId"] !== undefined ? _data["MembershipId"] : null as any;
            this.programId = _data["ProgramId"] !== undefined ? _data["ProgramId"] : null as any;
            this.iataCode = _data["IataCode"] !== undefined ? _data["IataCode"] : null as any;
            this.cardExpirationDate = _data["CardExpirationDate"] !== undefined ? _data["CardExpirationDate"] : null as any;
        }
    }

    static fromJS(data: any): PaxLoyaltyCard {
        data = typeof data === 'object' ? data : {};
        let result = new PaxLoyaltyCard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MembershipId"] = this.membershipId !== undefined ? this.membershipId : null as any;
        data["ProgramId"] = this.programId !== undefined ? this.programId : null as any;
        data["IataCode"] = this.iataCode !== undefined ? this.iataCode : null as any;
        data["CardExpirationDate"] = this.cardExpirationDate !== undefined ? this.cardExpirationDate : null as any;
        return data;
    }
}

export interface IPaxLoyaltyCard {
    membershipId?: string | null;
    programId?: string | null;
    iataCode?: string | null;
    cardExpirationDate?: string | null;
}

export class BaseCompany implements IBaseCompany {
    name?: string | null;
    addresses?: Address[] | null;
    vatNumber?: string | null;
    phoneNumbers?: Phone[] | null;
    emails?: Email[] | null;

    constructor(data?: IBaseCompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"] !== undefined ? _data["Name"] : null as any;
            if (Array.isArray(_data["Addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["Addresses"])
                    this.addresses!.push(Address.fromJS(item));
            }
            else {
                this.addresses = null as any;
            }
            this.vatNumber = _data["VatNumber"] !== undefined ? _data["VatNumber"] : null as any;
            if (Array.isArray(_data["PhoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["PhoneNumbers"])
                    this.phoneNumbers!.push(Phone.fromJS(item));
            }
            else {
                this.phoneNumbers = null as any;
            }
            if (Array.isArray(_data["Emails"])) {
                this.emails = [] as any;
                for (let item of _data["Emails"])
                    this.emails!.push(Email.fromJS(item));
            }
            else {
                this.emails = null as any;
            }
        }
    }

    static fromJS(data: any): BaseCompany {
        data = typeof data === 'object' ? data : {};
        let result = new BaseCompany();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name !== undefined ? this.name : null as any;
        if (Array.isArray(this.addresses)) {
            data["Addresses"] = [];
            for (let item of this.addresses)
                data["Addresses"].push(item ? item.toJSON() : null as any);
        }
        data["VatNumber"] = this.vatNumber !== undefined ? this.vatNumber : null as any;
        if (Array.isArray(this.phoneNumbers)) {
            data["PhoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["PhoneNumbers"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.emails)) {
            data["Emails"] = [];
            for (let item of this.emails)
                data["Emails"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IBaseCompany {
    name?: string | null;
    addresses?: Address[] | null;
    vatNumber?: string | null;
    phoneNumbers?: Phone[] | null;
    emails?: Email[] | null;
}

export class BusinessCompany extends BaseCompany implements IBusinessCompany {

    constructor(data?: IBusinessCompany) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): BusinessCompany {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessCompany();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IBusinessCompany extends IBaseCompany {
}

export class Address implements IAddress {
    type?: string | null;
    street?: string | null;
    zip?: string | null;
    city?: string | null;
    country?: string | null;
    countryCode?: string | null;
    state?: string | null;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["Type"] !== undefined ? _data["Type"] : null as any;
            this.street = _data["Street"] !== undefined ? _data["Street"] : null as any;
            this.zip = _data["Zip"] !== undefined ? _data["Zip"] : null as any;
            this.city = _data["City"] !== undefined ? _data["City"] : null as any;
            this.country = _data["Country"] !== undefined ? _data["Country"] : null as any;
            this.countryCode = _data["CountryCode"] !== undefined ? _data["CountryCode"] : null as any;
            this.state = _data["State"] !== undefined ? _data["State"] : null as any;
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Type"] = this.type !== undefined ? this.type : null as any;
        data["Street"] = this.street !== undefined ? this.street : null as any;
        data["Zip"] = this.zip !== undefined ? this.zip : null as any;
        data["City"] = this.city !== undefined ? this.city : null as any;
        data["Country"] = this.country !== undefined ? this.country : null as any;
        data["CountryCode"] = this.countryCode !== undefined ? this.countryCode : null as any;
        data["State"] = this.state !== undefined ? this.state : null as any;
        return data;
    }
}

export interface IAddress {
    type?: string | null;
    street?: string | null;
    zip?: string | null;
    city?: string | null;
    country?: string | null;
    countryCode?: string | null;
    state?: string | null;
}

export class CreditCardInfo implements ICreditCardInfo {
    cardHolderName?: string | null;
    cardHolderFirstName?: string | null;
    cardHolderLastName?: string | null;
    creditCardType?: ECreditCardType | null;
    creditCardNumber?: string | null;
    creditCardCvv?: string | null;
    expireDate?: string | null;
    startDate?: string | null;
    issueNumber?: string | null;

    constructor(data?: ICreditCardInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardHolderName = _data["CardHolderName"] !== undefined ? _data["CardHolderName"] : null as any;
            this.cardHolderFirstName = _data["CardHolderFirstName"] !== undefined ? _data["CardHolderFirstName"] : null as any;
            this.cardHolderLastName = _data["CardHolderLastName"] !== undefined ? _data["CardHolderLastName"] : null as any;
            this.creditCardType = _data["CreditCardType"] !== undefined ? _data["CreditCardType"] : null as any;
            this.creditCardNumber = _data["CreditCardNumber"] !== undefined ? _data["CreditCardNumber"] : null as any;
            this.creditCardCvv = _data["CreditCardCvv"] !== undefined ? _data["CreditCardCvv"] : null as any;
            this.expireDate = _data["ExpireDate"] !== undefined ? _data["ExpireDate"] : null as any;
            this.startDate = _data["StartDate"] !== undefined ? _data["StartDate"] : null as any;
            this.issueNumber = _data["IssueNumber"] !== undefined ? _data["IssueNumber"] : null as any;
        }
    }

    static fromJS(data: any): CreditCardInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CreditCardInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CardHolderName"] = this.cardHolderName !== undefined ? this.cardHolderName : null as any;
        data["CardHolderFirstName"] = this.cardHolderFirstName !== undefined ? this.cardHolderFirstName : null as any;
        data["CardHolderLastName"] = this.cardHolderLastName !== undefined ? this.cardHolderLastName : null as any;
        data["CreditCardType"] = this.creditCardType !== undefined ? this.creditCardType : null as any;
        data["CreditCardNumber"] = this.creditCardNumber !== undefined ? this.creditCardNumber : null as any;
        data["CreditCardCvv"] = this.creditCardCvv !== undefined ? this.creditCardCvv : null as any;
        data["ExpireDate"] = this.expireDate !== undefined ? this.expireDate : null as any;
        data["StartDate"] = this.startDate !== undefined ? this.startDate : null as any;
        data["IssueNumber"] = this.issueNumber !== undefined ? this.issueNumber : null as any;
        return data;
    }
}

export interface ICreditCardInfo {
    cardHolderName?: string | null;
    cardHolderFirstName?: string | null;
    cardHolderLastName?: string | null;
    creditCardType?: ECreditCardType | null;
    creditCardNumber?: string | null;
    creditCardCvv?: string | null;
    expireDate?: string | null;
    startDate?: string | null;
    issueNumber?: string | null;
}

export enum ECreditCardType {
    MASTERCARD = "MASTERCARD",
    VISA = "VISA",
    AMERICAN_EXPRESS = "AMERICAN_EXPRESS",
    JCB_INTERNATIONAL = "JCB_INTERNATIONAL",
    CARTE_BLANCHE = "CARTE_BLANCHE",
    CHINA_UNION_PAY_EXPEDIA = "CHINA_UNION_PAY_EXPEDIA",
    CHINA_UNION_PAY = "CHINA_UNION_PAY",
    DINERS_CLUB = "DINERS_CLUB",
    DISCOVER_CARD = "DISCOVER_CARD",
    EURO_CARD = "EURO_CARD",
    FORBRUGSFORENINGSKORT = "FORBRUGSFORENINGSKORT",
    MAESTRO = "MAESTRO",
    AIR_PLUS = "AIR_PLUS",
    UATP = "UATP",
    BUSINESS_CARD = "BUSINESS_CARD",
    NEXI_MASTERCARD = "NEXI_MASTERCARD",
    NEXI_VISA = "NEXI_VISA",
}

export class TravelCompany extends BaseCompany implements ITravelCompany {

    constructor(data?: ITravelCompany) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): TravelCompany {
        data = typeof data === 'object' ? data : {};
        let result = new TravelCompany();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITravelCompany extends IBaseCompany {
}

export class PnrTravelCompany extends TravelCompany implements IPnrTravelCompany {

    constructor(data?: IPnrTravelCompany) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PnrTravelCompany {
        data = typeof data === 'object' ? data : {};
        let result = new PnrTravelCompany();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPnrTravelCompany extends ITravelCompany {
}

export class PnrRemarks implements IPnrRemarks {
    lineNumber?: string | null;
    id?: string | null;
    code?: string | null;
    type?: string | null;
    text?: string | null;
    flightSegmentRefId?: string | null;
    paxRefId?: string | null;

    constructor(data?: IPnrRemarks) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineNumber = _data["LineNumber"] !== undefined ? _data["LineNumber"] : null as any;
            this.id = _data["Id"] !== undefined ? _data["Id"] : null as any;
            this.code = _data["Code"] !== undefined ? _data["Code"] : null as any;
            this.type = _data["Type"] !== undefined ? _data["Type"] : null as any;
            this.text = _data["Text"] !== undefined ? _data["Text"] : null as any;
            this.flightSegmentRefId = _data["FlightSegmentRefId"] !== undefined ? _data["FlightSegmentRefId"] : null as any;
            this.paxRefId = _data["PaxRefId"] !== undefined ? _data["PaxRefId"] : null as any;
        }
    }

    static fromJS(data: any): PnrRemarks {
        data = typeof data === 'object' ? data : {};
        let result = new PnrRemarks();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LineNumber"] = this.lineNumber !== undefined ? this.lineNumber : null as any;
        data["Id"] = this.id !== undefined ? this.id : null as any;
        data["Code"] = this.code !== undefined ? this.code : null as any;
        data["Type"] = this.type !== undefined ? this.type : null as any;
        data["Text"] = this.text !== undefined ? this.text : null as any;
        data["FlightSegmentRefId"] = this.flightSegmentRefId !== undefined ? this.flightSegmentRefId : null as any;
        data["PaxRefId"] = this.paxRefId !== undefined ? this.paxRefId : null as any;
        return data;
    }
}

export interface IPnrRemarks {
    lineNumber?: string | null;
    id?: string | null;
    code?: string | null;
    type?: string | null;
    text?: string | null;
    flightSegmentRefId?: string | null;
    paxRefId?: string | null;
}

export class PnrOsiSsr implements IPnrOsiSsr {
    lineNumber?: string | null;
    id?: string | null;
    code?: string | null;
    type?: string | null;
    date?: string | null;
    text?: string | null;
    flightSegmentRefId?: string | null;
    airlineIataCode?: string | null;
    paxRefId?: string | null;

    constructor(data?: IPnrOsiSsr) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineNumber = _data["LineNumber"] !== undefined ? _data["LineNumber"] : null as any;
            this.id = _data["Id"] !== undefined ? _data["Id"] : null as any;
            this.code = _data["Code"] !== undefined ? _data["Code"] : null as any;
            this.type = _data["Type"] !== undefined ? _data["Type"] : null as any;
            this.date = _data["Date"] !== undefined ? _data["Date"] : null as any;
            this.text = _data["Text"] !== undefined ? _data["Text"] : null as any;
            this.flightSegmentRefId = _data["FlightSegmentRefId"] !== undefined ? _data["FlightSegmentRefId"] : null as any;
            this.airlineIataCode = _data["AirlineIataCode"] !== undefined ? _data["AirlineIataCode"] : null as any;
            this.paxRefId = _data["PaxRefId"] !== undefined ? _data["PaxRefId"] : null as any;
        }
    }

    static fromJS(data: any): PnrOsiSsr {
        data = typeof data === 'object' ? data : {};
        let result = new PnrOsiSsr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LineNumber"] = this.lineNumber !== undefined ? this.lineNumber : null as any;
        data["Id"] = this.id !== undefined ? this.id : null as any;
        data["Code"] = this.code !== undefined ? this.code : null as any;
        data["Type"] = this.type !== undefined ? this.type : null as any;
        data["Date"] = this.date !== undefined ? this.date : null as any;
        data["Text"] = this.text !== undefined ? this.text : null as any;
        data["FlightSegmentRefId"] = this.flightSegmentRefId !== undefined ? this.flightSegmentRefId : null as any;
        data["AirlineIataCode"] = this.airlineIataCode !== undefined ? this.airlineIataCode : null as any;
        data["PaxRefId"] = this.paxRefId !== undefined ? this.paxRefId : null as any;
        return data;
    }
}

export interface IPnrOsiSsr {
    lineNumber?: string | null;
    id?: string | null;
    code?: string | null;
    type?: string | null;
    date?: string | null;
    text?: string | null;
    flightSegmentRefId?: string | null;
    airlineIataCode?: string | null;
    paxRefId?: string | null;
}

export class CO2Emissions implements ICO2Emissions {
    perSegment?: number | null;
    perPassenger?: number | null;
    perMile?: number | null;
    perKm?: number | null;
    distanceInMiles?: number | null;
    distanceInKm?: number | null;
    unit?: string | null;

    constructor(data?: ICO2Emissions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.perSegment = _data["PerSegment"] !== undefined ? _data["PerSegment"] : null as any;
            this.perPassenger = _data["PerPassenger"] !== undefined ? _data["PerPassenger"] : null as any;
            this.perMile = _data["PerMile"] !== undefined ? _data["PerMile"] : null as any;
            this.perKm = _data["PerKm"] !== undefined ? _data["PerKm"] : null as any;
            this.distanceInMiles = _data["DistanceInMiles"] !== undefined ? _data["DistanceInMiles"] : null as any;
            this.distanceInKm = _data["DistanceInKm"] !== undefined ? _data["DistanceInKm"] : null as any;
            this.unit = _data["Unit"] !== undefined ? _data["Unit"] : null as any;
        }
    }

    static fromJS(data: any): CO2Emissions {
        data = typeof data === 'object' ? data : {};
        let result = new CO2Emissions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PerSegment"] = this.perSegment !== undefined ? this.perSegment : null as any;
        data["PerPassenger"] = this.perPassenger !== undefined ? this.perPassenger : null as any;
        data["PerMile"] = this.perMile !== undefined ? this.perMile : null as any;
        data["PerKm"] = this.perKm !== undefined ? this.perKm : null as any;
        data["DistanceInMiles"] = this.distanceInMiles !== undefined ? this.distanceInMiles : null as any;
        data["DistanceInKm"] = this.distanceInKm !== undefined ? this.distanceInKm : null as any;
        data["Unit"] = this.unit !== undefined ? this.unit : null as any;
        return data;
    }
}

export interface ICO2Emissions {
    perSegment?: number | null;
    perPassenger?: number | null;
    perMile?: number | null;
    perKm?: number | null;
    distanceInMiles?: number | null;
    distanceInKm?: number | null;
    unit?: string | null;
}

export abstract class PnrCustomData implements IPnrCustomData {

    protected _discriminator: string;

    constructor(data?: IPnrCustomData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "PnrCustomData";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): PnrCustomData {
        data = typeof data === 'object' ? data : {};
        if (data["CustomDataConnectorCode"] === "AMADEUS") {
            let result = new AmadeusPnrCustomData();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'PnrCustomData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomDataConnectorCode"] = this._discriminator;
        return data;
    }
}

export interface IPnrCustomData {
}

export class AmadeusPnrCustomData extends PnrCustomData implements IAmadeusPnrCustomData {
    pnrCustomData?: AmadeusFlightPnrCustomData | null;

    constructor(data?: IAmadeusPnrCustomData) {
        super(data);
        this._discriminator = "AMADEUS";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pnrCustomData = _data["PnrCustomData"] ? AmadeusFlightPnrCustomData.fromJS(_data["PnrCustomData"]) : null as any;
        }
    }

    static override fromJS(data: any): AmadeusPnrCustomData {
        data = typeof data === 'object' ? data : {};
        let result = new AmadeusPnrCustomData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PnrCustomData"] = this.pnrCustomData ? this.pnrCustomData.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAmadeusPnrCustomData extends IPnrCustomData {
    pnrCustomData?: AmadeusFlightPnrCustomData | null;
}

export class AmadeusFlightPnrCustomData implements IAmadeusFlightPnrCustomData {
    receivedFrom?: string | null;
    tkXlAutoDeleteDate?: string | null;
    tkTlTimeLimitDate?: string | null;
    amadeusPnrRetrieveXmlRs?: string | null;
    ndcOrderId?: string | null;
    ndcOwnerCode?: string | null;
    ndcTicketNumbers?: string[] | null;

    constructor(data?: IAmadeusFlightPnrCustomData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receivedFrom = _data["ReceivedFrom"] !== undefined ? _data["ReceivedFrom"] : null as any;
            this.tkXlAutoDeleteDate = _data["TkXlAutoDeleteDate"] !== undefined ? _data["TkXlAutoDeleteDate"] : null as any;
            this.tkTlTimeLimitDate = _data["TkTlTimeLimitDate"] !== undefined ? _data["TkTlTimeLimitDate"] : null as any;
            this.amadeusPnrRetrieveXmlRs = _data["AmadeusPnrRetrieveXmlRs"] !== undefined ? _data["AmadeusPnrRetrieveXmlRs"] : null as any;
            this.ndcOrderId = _data["NdcOrderId"] !== undefined ? _data["NdcOrderId"] : null as any;
            this.ndcOwnerCode = _data["NdcOwnerCode"] !== undefined ? _data["NdcOwnerCode"] : null as any;
            if (Array.isArray(_data["NdcTicketNumbers"])) {
                this.ndcTicketNumbers = [] as any;
                for (let item of _data["NdcTicketNumbers"])
                    this.ndcTicketNumbers!.push(item);
            }
            else {
                this.ndcTicketNumbers = null as any;
            }
        }
    }

    static fromJS(data: any): AmadeusFlightPnrCustomData {
        data = typeof data === 'object' ? data : {};
        let result = new AmadeusFlightPnrCustomData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ReceivedFrom"] = this.receivedFrom !== undefined ? this.receivedFrom : null as any;
        data["TkXlAutoDeleteDate"] = this.tkXlAutoDeleteDate !== undefined ? this.tkXlAutoDeleteDate : null as any;
        data["TkTlTimeLimitDate"] = this.tkTlTimeLimitDate !== undefined ? this.tkTlTimeLimitDate : null as any;
        data["AmadeusPnrRetrieveXmlRs"] = this.amadeusPnrRetrieveXmlRs !== undefined ? this.amadeusPnrRetrieveXmlRs : null as any;
        data["NdcOrderId"] = this.ndcOrderId !== undefined ? this.ndcOrderId : null as any;
        data["NdcOwnerCode"] = this.ndcOwnerCode !== undefined ? this.ndcOwnerCode : null as any;
        if (Array.isArray(this.ndcTicketNumbers)) {
            data["NdcTicketNumbers"] = [];
            for (let item of this.ndcTicketNumbers)
                data["NdcTicketNumbers"].push(item);
        }
        return data;
    }
}

export interface IAmadeusFlightPnrCustomData {
    receivedFrom?: string | null;
    tkXlAutoDeleteDate?: string | null;
    tkTlTimeLimitDate?: string | null;
    amadeusPnrRetrieveXmlRs?: string | null;
    ndcOrderId?: string | null;
    ndcOwnerCode?: string | null;
    ndcTicketNumbers?: string[] | null;
}

export class JupiterFlightPnrRetrieveRQ extends BaseRQ implements IJupiterFlightPnrRetrieveRQ {
    request?: JupiterFlightPnrRetrieveInput | null;

    constructor(data?: IJupiterFlightPnrRetrieveRQ) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.request = _data["Request"] ? JupiterFlightPnrRetrieveInput.fromJS(_data["Request"]) : null as any;
        }
    }

    static override fromJS(data: any): JupiterFlightPnrRetrieveRQ {
        data = typeof data === 'object' ? data : {};
        let result = new JupiterFlightPnrRetrieveRQ();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Request"] = this.request ? this.request.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IJupiterFlightPnrRetrieveRQ extends IBaseRQ {
    request?: JupiterFlightPnrRetrieveInput | null;
}

export class JupiterFlightPnrRetrieveInput extends BaseInput implements IJupiterFlightPnrRetrieveInput {
    connectorCode!: EH2HConnectorCode;
    pnrNumber?: string | null;
    connectorCustomData?: FlightPnrRetrieveInputCustomData | null;
    sessionConnectorCustomData?: GdsSessionCustomData | null;
    customerCustomData?: CustomerCustomDataOfJupiterFlightPnrRetrieveInput | null;

    constructor(data?: IJupiterFlightPnrRetrieveInput) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.connectorCode = _data["ConnectorCode"] !== undefined ? _data["ConnectorCode"] : null as any;
            this.pnrNumber = _data["PnrNumber"] !== undefined ? _data["PnrNumber"] : null as any;
            this.connectorCustomData = _data["ConnectorCustomData"] ? FlightPnrRetrieveInputCustomData.fromJS(_data["ConnectorCustomData"]) : null as any;
            this.sessionConnectorCustomData = _data["SessionConnectorCustomData"] ? GdsSessionCustomData.fromJS(_data["SessionConnectorCustomData"]) : null as any;
            this.customerCustomData = _data["CustomerCustomData"] ? CustomerCustomDataOfJupiterFlightPnrRetrieveInput.fromJS(_data["CustomerCustomData"]) : null as any;
        }
    }

    static override fromJS(data: any): JupiterFlightPnrRetrieveInput {
        data = typeof data === 'object' ? data : {};
        let result = new JupiterFlightPnrRetrieveInput();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ConnectorCode"] = this.connectorCode !== undefined ? this.connectorCode : null as any;
        data["PnrNumber"] = this.pnrNumber !== undefined ? this.pnrNumber : null as any;
        data["ConnectorCustomData"] = this.connectorCustomData ? this.connectorCustomData.toJSON() : null as any;
        data["SessionConnectorCustomData"] = this.sessionConnectorCustomData ? this.sessionConnectorCustomData.toJSON() : null as any;
        data["CustomerCustomData"] = this.customerCustomData ? this.customerCustomData.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IJupiterFlightPnrRetrieveInput extends IBaseInput {
    connectorCode: EH2HConnectorCode;
    pnrNumber?: string | null;
    connectorCustomData?: FlightPnrRetrieveInputCustomData | null;
    sessionConnectorCustomData?: GdsSessionCustomData | null;
    customerCustomData?: CustomerCustomDataOfJupiterFlightPnrRetrieveInput | null;
}

export abstract class FlightPnrRetrieveInputCustomData implements IFlightPnrRetrieveInputCustomData {

    protected _discriminator: string;

    constructor(data?: IFlightPnrRetrieveInputCustomData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "FlightPnrRetrieveInputCustomData";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): FlightPnrRetrieveInputCustomData {
        data = typeof data === 'object' ? data : {};
        if (data["CustomDataConnectorCode"] === "AMADEUS") {
            let result = new AmadeusFlightPnrRetrieveInputCustomData();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'FlightPnrRetrieveInputCustomData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomDataConnectorCode"] = this._discriminator;
        return data;
    }
}

export interface IFlightPnrRetrieveInputCustomData {
}

export class AmadeusFlightPnrRetrieveInputCustomData extends FlightPnrRetrieveInputCustomData implements IAmadeusFlightPnrRetrieveInputCustomData {
    ndcOrderId?: string | null;
    ndcOwnerCode?: string | null;

    constructor(data?: IAmadeusFlightPnrRetrieveInputCustomData) {
        super(data);
        this._discriminator = "AMADEUS";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ndcOrderId = _data["NdcOrderId"] !== undefined ? _data["NdcOrderId"] : null as any;
            this.ndcOwnerCode = _data["NdcOwnerCode"] !== undefined ? _data["NdcOwnerCode"] : null as any;
        }
    }

    static override fromJS(data: any): AmadeusFlightPnrRetrieveInputCustomData {
        data = typeof data === 'object' ? data : {};
        let result = new AmadeusFlightPnrRetrieveInputCustomData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["NdcOrderId"] = this.ndcOrderId !== undefined ? this.ndcOrderId : null as any;
        data["NdcOwnerCode"] = this.ndcOwnerCode !== undefined ? this.ndcOwnerCode : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAmadeusFlightPnrRetrieveInputCustomData extends IFlightPnrRetrieveInputCustomData {
    ndcOrderId?: string | null;
    ndcOwnerCode?: string | null;
}

export abstract class CustomerCustomDataOfJupiterFlightPnrRetrieveInput implements ICustomerCustomDataOfJupiterFlightPnrRetrieveInput {

    protected _discriminator: string;

    constructor(data?: ICustomerCustomDataOfJupiterFlightPnrRetrieveInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "CustomerCustomDataOfJupiterFlightPnrRetrieveInput";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CustomerCustomDataOfJupiterFlightPnrRetrieveInput {
        data = typeof data === 'object' ? data : {};
        if (data["CustomDataCode"] === "FlightPnrRetrieveNaarData") {
            let result = new FlightPnrRetrieveNaarData();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'CustomerCustomDataOfJupiterFlightPnrRetrieveInput' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomDataCode"] = this._discriminator;
        return data;
    }
}

export interface ICustomerCustomDataOfJupiterFlightPnrRetrieveInput {
}

export class FlightPnrRetrieveNaarData extends CustomerCustomDataOfJupiterFlightPnrRetrieveInput implements IFlightPnrRetrieveNaarData {
    markupData?: MarkupData | null;

    constructor(data?: IFlightPnrRetrieveNaarData) {
        super(data);
        this._discriminator = "FlightPnrRetrieveNaarData";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.markupData = _data["MarkupData"] ? MarkupData.fromJS(_data["MarkupData"]) : null as any;
        }
    }

    static override fromJS(data: any): FlightPnrRetrieveNaarData {
        data = typeof data === 'object' ? data : {};
        let result = new FlightPnrRetrieveNaarData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MarkupData"] = this.markupData ? this.markupData.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IFlightPnrRetrieveNaarData extends ICustomerCustomDataOfJupiterFlightPnrRetrieveInput {
    markupData?: MarkupData | null;
}

export class ImportPnrApiRequest extends ApiRequest implements IImportPnrApiRequest {
    /** Offerta ID */
    tripID?: number;
    /** Pnr Number */
    pnr?: string | null;
    /** Supplier ID -> 14 Amadeus */
    supplierID?: number;
    /** Abbinamento ID -> Camera */
    abbinamentoID?: number;
    /** Boolean indicating import services rows */
    importServiceRows?: boolean;
    /** Boolean indicating import fares */
    importFares?: boolean;

    constructor(data?: IImportPnrApiRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : null as any;
            this.pnr = _data["pnr"] !== undefined ? _data["pnr"] : null as any;
            this.supplierID = _data["supplierID"] !== undefined ? _data["supplierID"] : null as any;
            this.abbinamentoID = _data["abbinamentoID"] !== undefined ? _data["abbinamentoID"] : null as any;
            this.importServiceRows = _data["importServiceRows"] !== undefined ? _data["importServiceRows"] : null as any;
            this.importFares = _data["importFares"] !== undefined ? _data["importFares"] : null as any;
        }
    }

    static override fromJS(data: any): ImportPnrApiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportPnrApiRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripID"] = this.tripID !== undefined ? this.tripID : null as any;
        data["pnr"] = this.pnr !== undefined ? this.pnr : null as any;
        data["supplierID"] = this.supplierID !== undefined ? this.supplierID : null as any;
        data["abbinamentoID"] = this.abbinamentoID !== undefined ? this.abbinamentoID : null as any;
        data["importServiceRows"] = this.importServiceRows !== undefined ? this.importServiceRows : null as any;
        data["importFares"] = this.importFares !== undefined ? this.importFares : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IImportPnrApiRequest extends IApiRequest {
    /** Offerta ID */
    tripID?: number;
    /** Pnr Number */
    pnr?: string | null;
    /** Supplier ID -> 14 Amadeus */
    supplierID?: number;
    /** Abbinamento ID -> Camera */
    abbinamentoID?: number;
    /** Boolean indicating import services rows */
    importServiceRows?: boolean;
    /** Boolean indicating import fares */
    importFares?: boolean;
}

export class ImportCrypticPnrApiRequest extends ApiRequest implements IImportCrypticPnrApiRequest {
    /** Session Custom Data */
    sessionConnectorCustomData?: GdsSessionCustomData | null;
    /** Offerta ID */
    tripID?: number;
    /** Supplier ID -> 14 Amadeus */
    supplierID?: number | null;
    /** Abbinamento ID -> Camera */
    abbinamentoID?: number | null;
    /** Boolean indicating import services rows */
    importServiceRows?: boolean;
    /** Boolean indicating import fares */
    importFares?: boolean;
    /** Boolean indicating if replace existing Rows and PNRs
It work only if the PNR associated to the rows is the same PNR */
    replaceRows?: boolean;

    constructor(data?: IImportCrypticPnrApiRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sessionConnectorCustomData = _data["sessionConnectorCustomData"] ? GdsSessionCustomData.fromJS(_data["sessionConnectorCustomData"]) : null as any;
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : null as any;
            this.supplierID = _data["supplierID"] !== undefined ? _data["supplierID"] : null as any;
            this.abbinamentoID = _data["abbinamentoID"] !== undefined ? _data["abbinamentoID"] : null as any;
            this.importServiceRows = _data["importServiceRows"] !== undefined ? _data["importServiceRows"] : null as any;
            this.importFares = _data["importFares"] !== undefined ? _data["importFares"] : null as any;
            this.replaceRows = _data["replaceRows"] !== undefined ? _data["replaceRows"] : null as any;
        }
    }

    static override fromJS(data: any): ImportCrypticPnrApiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportCrypticPnrApiRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionConnectorCustomData"] = this.sessionConnectorCustomData ? this.sessionConnectorCustomData.toJSON() : null as any;
        data["tripID"] = this.tripID !== undefined ? this.tripID : null as any;
        data["supplierID"] = this.supplierID !== undefined ? this.supplierID : null as any;
        data["abbinamentoID"] = this.abbinamentoID !== undefined ? this.abbinamentoID : null as any;
        data["importServiceRows"] = this.importServiceRows !== undefined ? this.importServiceRows : null as any;
        data["importFares"] = this.importFares !== undefined ? this.importFares : null as any;
        data["replaceRows"] = this.replaceRows !== undefined ? this.replaceRows : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IImportCrypticPnrApiRequest extends IApiRequest {
    /** Session Custom Data */
    sessionConnectorCustomData?: GdsSessionCustomData | null;
    /** Offerta ID */
    tripID?: number;
    /** Supplier ID -> 14 Amadeus */
    supplierID?: number | null;
    /** Abbinamento ID -> Camera */
    abbinamentoID?: number | null;
    /** Boolean indicating import services rows */
    importServiceRows?: boolean;
    /** Boolean indicating import fares */
    importFares?: boolean;
    /** Boolean indicating if replace existing Rows and PNRs
It work only if the PNR associated to the rows is the same PNR */
    replaceRows?: boolean;
}

export class ClosePnrApiRequest extends ApiRequest implements IClosePnrApiRequest {
    /** Offerta ID */
    tripID?: number;
    /** Abbinamento ID -> Camera */
    abbinamentoID?: number;

    constructor(data?: IClosePnrApiRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : null as any;
            this.abbinamentoID = _data["abbinamentoID"] !== undefined ? _data["abbinamentoID"] : null as any;
        }
    }

    static override fromJS(data: any): ClosePnrApiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ClosePnrApiRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripID"] = this.tripID !== undefined ? this.tripID : null as any;
        data["abbinamentoID"] = this.abbinamentoID !== undefined ? this.abbinamentoID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IClosePnrApiRequest extends IApiRequest {
    /** Offerta ID */
    tripID?: number;
    /** Abbinamento ID -> Camera */
    abbinamentoID?: number;
}

export class AddFlightFromSearchRequest extends ApiRequest implements IAddFlightFromSearchRequest {
    /** Offerta ID */
    tripID?: number;
    /** Availability Request */
    availabilityInput?: JupiterFlightAvailabilityInput | null;
    /** Selected Result */
    selectedResult?: SingleFlightAvailResult | null;

    constructor(data?: IAddFlightFromSearchRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : null as any;
            this.availabilityInput = _data["availabilityInput"] ? JupiterFlightAvailabilityInput.fromJS(_data["availabilityInput"]) : null as any;
            this.selectedResult = _data["selectedResult"] ? SingleFlightAvailResult.fromJS(_data["selectedResult"]) : null as any;
        }
    }

    static override fromJS(data: any): AddFlightFromSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddFlightFromSearchRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripID"] = this.tripID !== undefined ? this.tripID : null as any;
        data["availabilityInput"] = this.availabilityInput ? this.availabilityInput.toJSON() : null as any;
        data["selectedResult"] = this.selectedResult ? this.selectedResult.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAddFlightFromSearchRequest extends IApiRequest {
    /** Offerta ID */
    tripID?: number;
    /** Availability Request */
    availabilityInput?: JupiterFlightAvailabilityInput | null;
    /** Selected Result */
    selectedResult?: SingleFlightAvailResult | null;
}

export class CreateTripFromSearchRequest extends ApiRequest implements ICreateTripFromSearchRequest {
    /** Availability Request */
    availabilityInput?: JupiterFlightAvailabilityInput | null;
    /** Selected Result */
    selectedResult?: SingleFlightAvailResult | null;
    /** Trip Paxes */
    tripPaxes?: ClienteDatoUpdate[] | null;

    constructor(data?: ICreateTripFromSearchRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.availabilityInput = _data["availabilityInput"] ? JupiterFlightAvailabilityInput.fromJS(_data["availabilityInput"]) : null as any;
            this.selectedResult = _data["selectedResult"] ? SingleFlightAvailResult.fromJS(_data["selectedResult"]) : null as any;
            if (Array.isArray(_data["tripPaxes"])) {
                this.tripPaxes = [] as any;
                for (let item of _data["tripPaxes"])
                    this.tripPaxes!.push(ClienteDatoUpdate.fromJS(item));
            }
            else {
                this.tripPaxes = null as any;
            }
        }
    }

    static override fromJS(data: any): CreateTripFromSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTripFromSearchRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["availabilityInput"] = this.availabilityInput ? this.availabilityInput.toJSON() : null as any;
        data["selectedResult"] = this.selectedResult ? this.selectedResult.toJSON() : null as any;
        if (Array.isArray(this.tripPaxes)) {
            data["tripPaxes"] = [];
            for (let item of this.tripPaxes)
                data["tripPaxes"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICreateTripFromSearchRequest extends IApiRequest {
    /** Availability Request */
    availabilityInput?: JupiterFlightAvailabilityInput | null;
    /** Selected Result */
    selectedResult?: SingleFlightAvailResult | null;
    /** Trip Paxes */
    tripPaxes?: ClienteDatoUpdate[] | null;
}

export class ClienteDatoUpdate implements IClienteDatoUpdate {
    cliente?: Cliente | null;
    clienteDato?: ClienteDato | null;
    abbinamentoID?: number | null;
    nomeNuovoAbbinamento?: string | null;

    constructor(data?: IClienteDatoUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cliente = _data["cliente"] ? Cliente.fromJS(_data["cliente"]) : null as any;
            this.clienteDato = _data["clienteDato"] ? ClienteDato.fromJS(_data["clienteDato"]) : null as any;
            this.abbinamentoID = _data["abbinamentoID"] !== undefined ? _data["abbinamentoID"] : null as any;
            this.nomeNuovoAbbinamento = _data["nomeNuovoAbbinamento"] !== undefined ? _data["nomeNuovoAbbinamento"] : null as any;
        }
    }

    static fromJS(data: any): ClienteDatoUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new ClienteDatoUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cliente"] = this.cliente ? this.cliente.toJSON() : null as any;
        data["clienteDato"] = this.clienteDato ? this.clienteDato.toJSON() : null as any;
        data["abbinamentoID"] = this.abbinamentoID !== undefined ? this.abbinamentoID : null as any;
        data["nomeNuovoAbbinamento"] = this.nomeNuovoAbbinamento !== undefined ? this.nomeNuovoAbbinamento : null as any;
        return data;
    }
}

export interface IClienteDatoUpdate {
    cliente?: Cliente | null;
    clienteDato?: ClienteDato | null;
    abbinamentoID?: number | null;
    nomeNuovoAbbinamento?: string | null;
}

export class GetAllSuppliersResponse extends OkApiResponse implements IGetAllSuppliersResponse {
    rows?: SupplierRow[] | null;

    constructor(data?: IGetAllSuppliersResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(SupplierRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
        }
    }

    static override fromJS(data: any): GetAllSuppliersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSuppliersResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetAllSuppliersResponse extends IOkApiResponse {
    rows?: SupplierRow[] | null;
}

export class SupplierRow implements ISupplierRow {
    id?: number;
    code?: string | null;
    name?: string | null;
    attivo?: boolean;
    ricercaHotel?: boolean;
    bookingHotel?: boolean;
    ricercaVoli?: boolean;
    bookingVoli?: boolean;
    ricercaVisite?: boolean;
    bookingVisite?: boolean;
    ricercaNoleggi?: boolean;
    bookingNoleggi?: boolean;
    ricercaCrociere?: boolean;
    bookingCrociere?: boolean;
    ultimaRicerca?: string | null;
    ultimaRicercaFault?: string | null;
    durataRicerche?: number | null;
    durataRicercheFault?: number | null;
    ricercheAttive?: number;
    ricercheAttiveFault?: number;
    accordoObbligatorio?: boolean;
    dirty?: boolean;

    constructor(data?: ISupplierRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.attivo = _data["attivo"] !== undefined ? _data["attivo"] : null as any;
            this.ricercaHotel = _data["ricercaHotel"] !== undefined ? _data["ricercaHotel"] : null as any;
            this.bookingHotel = _data["bookingHotel"] !== undefined ? _data["bookingHotel"] : null as any;
            this.ricercaVoli = _data["ricercaVoli"] !== undefined ? _data["ricercaVoli"] : null as any;
            this.bookingVoli = _data["bookingVoli"] !== undefined ? _data["bookingVoli"] : null as any;
            this.ricercaVisite = _data["ricercaVisite"] !== undefined ? _data["ricercaVisite"] : null as any;
            this.bookingVisite = _data["bookingVisite"] !== undefined ? _data["bookingVisite"] : null as any;
            this.ricercaNoleggi = _data["ricercaNoleggi"] !== undefined ? _data["ricercaNoleggi"] : null as any;
            this.bookingNoleggi = _data["bookingNoleggi"] !== undefined ? _data["bookingNoleggi"] : null as any;
            this.ricercaCrociere = _data["ricercaCrociere"] !== undefined ? _data["ricercaCrociere"] : null as any;
            this.bookingCrociere = _data["bookingCrociere"] !== undefined ? _data["bookingCrociere"] : null as any;
            this.ultimaRicerca = _data["ultimaRicerca"] !== undefined ? _data["ultimaRicerca"] : null as any;
            this.ultimaRicercaFault = _data["ultimaRicercaFault"] !== undefined ? _data["ultimaRicercaFault"] : null as any;
            this.durataRicerche = _data["durataRicerche"] !== undefined ? _data["durataRicerche"] : null as any;
            this.durataRicercheFault = _data["durataRicercheFault"] !== undefined ? _data["durataRicercheFault"] : null as any;
            this.ricercheAttive = _data["ricercheAttive"] !== undefined ? _data["ricercheAttive"] : null as any;
            this.ricercheAttiveFault = _data["ricercheAttiveFault"] !== undefined ? _data["ricercheAttiveFault"] : null as any;
            this.accordoObbligatorio = _data["accordoObbligatorio"] !== undefined ? _data["accordoObbligatorio"] : null as any;
            this.dirty = _data["dirty"] !== undefined ? _data["dirty"] : null as any;
        }
    }

    static fromJS(data: any): SupplierRow {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["attivo"] = this.attivo !== undefined ? this.attivo : null as any;
        data["ricercaHotel"] = this.ricercaHotel !== undefined ? this.ricercaHotel : null as any;
        data["bookingHotel"] = this.bookingHotel !== undefined ? this.bookingHotel : null as any;
        data["ricercaVoli"] = this.ricercaVoli !== undefined ? this.ricercaVoli : null as any;
        data["bookingVoli"] = this.bookingVoli !== undefined ? this.bookingVoli : null as any;
        data["ricercaVisite"] = this.ricercaVisite !== undefined ? this.ricercaVisite : null as any;
        data["bookingVisite"] = this.bookingVisite !== undefined ? this.bookingVisite : null as any;
        data["ricercaNoleggi"] = this.ricercaNoleggi !== undefined ? this.ricercaNoleggi : null as any;
        data["bookingNoleggi"] = this.bookingNoleggi !== undefined ? this.bookingNoleggi : null as any;
        data["ricercaCrociere"] = this.ricercaCrociere !== undefined ? this.ricercaCrociere : null as any;
        data["bookingCrociere"] = this.bookingCrociere !== undefined ? this.bookingCrociere : null as any;
        data["ultimaRicerca"] = this.ultimaRicerca !== undefined ? this.ultimaRicerca : null as any;
        data["ultimaRicercaFault"] = this.ultimaRicercaFault !== undefined ? this.ultimaRicercaFault : null as any;
        data["durataRicerche"] = this.durataRicerche !== undefined ? this.durataRicerche : null as any;
        data["durataRicercheFault"] = this.durataRicercheFault !== undefined ? this.durataRicercheFault : null as any;
        data["ricercheAttive"] = this.ricercheAttive !== undefined ? this.ricercheAttive : null as any;
        data["ricercheAttiveFault"] = this.ricercheAttiveFault !== undefined ? this.ricercheAttiveFault : null as any;
        data["accordoObbligatorio"] = this.accordoObbligatorio !== undefined ? this.accordoObbligatorio : null as any;
        data["dirty"] = this.dirty !== undefined ? this.dirty : null as any;
        return data;
    }
}

export interface ISupplierRow {
    id?: number;
    code?: string | null;
    name?: string | null;
    attivo?: boolean;
    ricercaHotel?: boolean;
    bookingHotel?: boolean;
    ricercaVoli?: boolean;
    bookingVoli?: boolean;
    ricercaVisite?: boolean;
    bookingVisite?: boolean;
    ricercaNoleggi?: boolean;
    bookingNoleggi?: boolean;
    ricercaCrociere?: boolean;
    bookingCrociere?: boolean;
    ultimaRicerca?: string | null;
    ultimaRicercaFault?: string | null;
    durataRicerche?: number | null;
    durataRicercheFault?: number | null;
    ricercheAttive?: number;
    ricercheAttiveFault?: number;
    accordoObbligatorio?: boolean;
    dirty?: boolean;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class GetAllSuppliersRequest extends ApiRequest implements IGetAllSuppliersRequest {

    constructor(data?: IGetAllSuppliersRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetAllSuppliersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSuppliersRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IGetAllSuppliersRequest extends IApiRequest {
}

export class H2HSupplierAdditionalDataGetResponse extends OkApiResponse implements IH2HSupplierAdditionalDataGetResponse {
    data?: H2hSupplierAdditionalData | null;

    constructor(data?: IH2HSupplierAdditionalDataGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? H2hSupplierAdditionalData.fromJS(_data["data"]) : null as any;
        }
    }

    static override fromJS(data: any): H2HSupplierAdditionalDataGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new H2HSupplierAdditionalDataGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IH2HSupplierAdditionalDataGetResponse extends IOkApiResponse {
    data?: H2hSupplierAdditionalData | null;
}

export class H2hSupplierAdditionalData implements IH2hSupplierAdditionalData {
    id?: number;
    nome?: string | null;
    data?: AdditionalData[] | null;

    constructor(data?: IH2hSupplierAdditionalData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AdditionalData.fromJS(item));
            }
            else {
                this.data = null as any;
            }
        }
    }

    static fromJS(data: any): H2hSupplierAdditionalData {
        data = typeof data === 'object' ? data : {};
        let result = new H2hSupplierAdditionalData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IH2hSupplierAdditionalData {
    id?: number;
    nome?: string | null;
    data?: AdditionalData[] | null;
}

export class AdditionalData implements IAdditionalData {
    id?: number;
    description?: string | null;
    updatedAt?: string;
    idDato?: number | null;

    constructor(data?: IAdditionalData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : null as any;
            this.idDato = _data["idDato"] !== undefined ? _data["idDato"] : null as any;
        }
    }

    static fromJS(data: any): AdditionalData {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : null as any;
        data["idDato"] = this.idDato !== undefined ? this.idDato : null as any;
        return data;
    }
}

export interface IAdditionalData {
    id?: number;
    description?: string | null;
    updatedAt?: string;
    idDato?: number | null;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class H2hSupplierAdditionalDataGetRequest extends ApiRequest implements IH2hSupplierAdditionalDataGetRequest {
    fornitoreId?: number;

    constructor(data?: IH2hSupplierAdditionalDataGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fornitoreId = _data["fornitoreId"] !== undefined ? _data["fornitoreId"] : null as any;
        }
    }

    static override fromJS(data: any): H2hSupplierAdditionalDataGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new H2hSupplierAdditionalDataGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fornitoreId"] = this.fornitoreId !== undefined ? this.fornitoreId : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IH2hSupplierAdditionalDataGetRequest extends IApiRequest {
    fornitoreId?: number;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class SaveSuppliersRequest extends ApiRequest implements ISaveSuppliersRequest {
    suppliers?: SupplierItem[] | null;

    constructor(data?: ISaveSuppliersRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [] as any;
                for (let item of _data["suppliers"])
                    this.suppliers!.push(SupplierItem.fromJS(item));
            }
            else {
                this.suppliers = null as any;
            }
        }
    }

    static override fromJS(data: any): SaveSuppliersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveSuppliersRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface ISaveSuppliersRequest extends IApiRequest {
    suppliers?: SupplierItem[] | null;
}

export class SupplierItem implements ISupplierItem {
    id?: number;
    attivo?: boolean;
    ricercaHotel?: boolean;
    bookingHotel?: boolean;
    ricercaVoli?: boolean;
    bookingVoli?: boolean;
    ricercaVisite?: boolean;
    bookingVisite?: boolean;
    ricercaNoleggi?: boolean;
    bookingNoleggi?: boolean;
    dirty?: boolean;

    constructor(data?: ISupplierItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.attivo = _data["attivo"] !== undefined ? _data["attivo"] : null as any;
            this.ricercaHotel = _data["ricercaHotel"] !== undefined ? _data["ricercaHotel"] : null as any;
            this.bookingHotel = _data["bookingHotel"] !== undefined ? _data["bookingHotel"] : null as any;
            this.ricercaVoli = _data["ricercaVoli"] !== undefined ? _data["ricercaVoli"] : null as any;
            this.bookingVoli = _data["bookingVoli"] !== undefined ? _data["bookingVoli"] : null as any;
            this.ricercaVisite = _data["ricercaVisite"] !== undefined ? _data["ricercaVisite"] : null as any;
            this.bookingVisite = _data["bookingVisite"] !== undefined ? _data["bookingVisite"] : null as any;
            this.ricercaNoleggi = _data["ricercaNoleggi"] !== undefined ? _data["ricercaNoleggi"] : null as any;
            this.bookingNoleggi = _data["bookingNoleggi"] !== undefined ? _data["bookingNoleggi"] : null as any;
            this.dirty = _data["dirty"] !== undefined ? _data["dirty"] : null as any;
        }
    }

    static fromJS(data: any): SupplierItem {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["attivo"] = this.attivo !== undefined ? this.attivo : null as any;
        data["ricercaHotel"] = this.ricercaHotel !== undefined ? this.ricercaHotel : null as any;
        data["bookingHotel"] = this.bookingHotel !== undefined ? this.bookingHotel : null as any;
        data["ricercaVoli"] = this.ricercaVoli !== undefined ? this.ricercaVoli : null as any;
        data["bookingVoli"] = this.bookingVoli !== undefined ? this.bookingVoli : null as any;
        data["ricercaVisite"] = this.ricercaVisite !== undefined ? this.ricercaVisite : null as any;
        data["bookingVisite"] = this.bookingVisite !== undefined ? this.bookingVisite : null as any;
        data["ricercaNoleggi"] = this.ricercaNoleggi !== undefined ? this.ricercaNoleggi : null as any;
        data["bookingNoleggi"] = this.bookingNoleggi !== undefined ? this.bookingNoleggi : null as any;
        data["dirty"] = this.dirty !== undefined ? this.dirty : null as any;
        return data;
    }
}

export interface ISupplierItem {
    id?: number;
    attivo?: boolean;
    ricercaHotel?: boolean;
    bookingHotel?: boolean;
    ricercaVoli?: boolean;
    bookingVoli?: boolean;
    ricercaVisite?: boolean;
    bookingVisite?: boolean;
    ricercaNoleggi?: boolean;
    bookingNoleggi?: boolean;
    dirty?: boolean;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class SetSupplierAdditionalDataMappingRequest extends ApiRequest implements ISetSupplierAdditionalDataMappingRequest {
    fornitoreId?: number;
    datoAggiuntivoId?: number | null;
    datoAggiuntivoFornitoreId?: number;

    constructor(data?: ISetSupplierAdditionalDataMappingRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fornitoreId = _data["fornitoreId"] !== undefined ? _data["fornitoreId"] : null as any;
            this.datoAggiuntivoId = _data["datoAggiuntivoId"] !== undefined ? _data["datoAggiuntivoId"] : null as any;
            this.datoAggiuntivoFornitoreId = _data["datoAggiuntivoFornitoreId"] !== undefined ? _data["datoAggiuntivoFornitoreId"] : null as any;
        }
    }

    static override fromJS(data: any): SetSupplierAdditionalDataMappingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetSupplierAdditionalDataMappingRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fornitoreId"] = this.fornitoreId !== undefined ? this.fornitoreId : null as any;
        data["datoAggiuntivoId"] = this.datoAggiuntivoId !== undefined ? this.datoAggiuntivoId : null as any;
        data["datoAggiuntivoFornitoreId"] = this.datoAggiuntivoFornitoreId !== undefined ? this.datoAggiuntivoFornitoreId : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface ISetSupplierAdditionalDataMappingRequest extends IApiRequest {
    fornitoreId?: number;
    datoAggiuntivoId?: number | null;
    datoAggiuntivoFornitoreId?: number;
}

export class GetCoverImageResponse implements IGetCoverImageResponse {
    url?: string;

    constructor(data?: IGetCoverImageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
        }
    }

    static fromJS(data: any): GetCoverImageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCoverImageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url !== undefined ? this.url : null as any;
        return data;
    }
}

export interface IGetCoverImageResponse {
    url?: string;
}

export enum EImageCoverType {
    Service = "Service",
    Place = "Place",
}

/** Enumeratore dei tipi di marker */
export enum EPriceMarkerType {
    Available = "Available",
    OnRequest = "OnRequest",
    Current = "Current",
}

/** Response containing the disabled H2H image. */
export class DisableImmagineH2HResponse extends OkApiResponse implements IDisableImmagineH2HResponse {
    /** The updated image entity. */
    image?: HHImmagine;

    constructor(data?: IDisableImmagineH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.image = _data["image"] ? HHImmagine.fromJS(_data["image"]) : null as any;
        }
    }

    static override fromJS(data: any): DisableImmagineH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DisableImmagineH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image ? this.image.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Response containing the disabled H2H image. */
export interface IDisableImmagineH2HResponse extends IOkApiResponse {
    /** The updated image entity. */
    image?: HHImmagine;
}

export class HHImmagine implements IHHImmagine {
    id?: number;
    servizioHHID?: number;
    fornitore?: EFornitore;
    sourceRef?: string | null;
    imageUrl!: string;
    thumbUrl?: string | null;
    sortOrder?: number;
    disabled?: boolean;
    createdAt?: string;
    updatedAt?: string;
    ordineNaar?: number | null;

    constructor(data?: IHHImmagine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.servizioHHID = _data["servizioHHID"] !== undefined ? _data["servizioHHID"] : null as any;
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : null as any;
            this.sourceRef = _data["sourceRef"] !== undefined ? _data["sourceRef"] : null as any;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : null as any;
            this.thumbUrl = _data["thumbUrl"] !== undefined ? _data["thumbUrl"] : null as any;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null as any;
            this.disabled = _data["disabled"] !== undefined ? _data["disabled"] : null as any;
            this.createdAt = _data["createdAt"] !== undefined ? _data["createdAt"] : null as any;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : null as any;
            this.ordineNaar = _data["ordineNaar"] !== undefined ? _data["ordineNaar"] : null as any;
        }
    }

    static fromJS(data: any): HHImmagine {
        data = typeof data === 'object' ? data : {};
        let result = new HHImmagine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["servizioHHID"] = this.servizioHHID !== undefined ? this.servizioHHID : null as any;
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : null as any;
        data["sourceRef"] = this.sourceRef !== undefined ? this.sourceRef : null as any;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : null as any;
        data["thumbUrl"] = this.thumbUrl !== undefined ? this.thumbUrl : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        data["disabled"] = this.disabled !== undefined ? this.disabled : null as any;
        data["createdAt"] = this.createdAt !== undefined ? this.createdAt : null as any;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : null as any;
        data["ordineNaar"] = this.ordineNaar !== undefined ? this.ordineNaar : null as any;
        return data;
    }
}

export interface IHHImmagine {
    id?: number;
    servizioHHID?: number;
    fornitore?: EFornitore;
    sourceRef?: string | null;
    imageUrl: string;
    thumbUrl?: string | null;
    sortOrder?: number;
    disabled?: boolean;
    createdAt?: string;
    updatedAt?: string;
    ordineNaar?: number | null;
}

/** Request to disable an H2H image (sets Disabled to true). */
export class DisableImmagineH2HRequest extends ApiRequest implements IDisableImmagineH2HRequest {
    /** Primary key of the image to disable. */
    imageID?: number;

    constructor(data?: IDisableImmagineH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.imageID = _data["imageID"] !== undefined ? _data["imageID"] : null as any;
        }
    }

    static override fromJS(data: any): DisableImmagineH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DisableImmagineH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageID"] = this.imageID !== undefined ? this.imageID : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Request to disable an H2H image (sets Disabled to true). */
export interface IDisableImmagineH2HRequest extends IApiRequest {
    /** Primary key of the image to disable. */
    imageID?: number;
}

/** Response containing the enabled H2H image. */
export class EnableImmagineH2HResponse extends OkApiResponse implements IEnableImmagineH2HResponse {
    /** The updated image entity. */
    image?: HHImmagine;

    constructor(data?: IEnableImmagineH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.image = _data["image"] ? HHImmagine.fromJS(_data["image"]) : null as any;
        }
    }

    static override fromJS(data: any): EnableImmagineH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnableImmagineH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image ? this.image.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Response containing the enabled H2H image. */
export interface IEnableImmagineH2HResponse extends IOkApiResponse {
    /** The updated image entity. */
    image?: HHImmagine;
}

/** Request to enable an H2H image (sets Disabled to false). */
export class EnableImmagineH2HRequest extends ApiRequest implements IEnableImmagineH2HRequest {
    /** Primary key of the image to enable. */
    imageID?: number;

    constructor(data?: IEnableImmagineH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.imageID = _data["imageID"] !== undefined ? _data["imageID"] : null as any;
        }
    }

    static override fromJS(data: any): EnableImmagineH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnableImmagineH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageID"] = this.imageID !== undefined ? this.imageID : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Request to enable an H2H image (sets Disabled to false). */
export interface IEnableImmagineH2HRequest extends IApiRequest {
    /** Primary key of the image to enable. */
    imageID?: number;
}

/** Response containing a single H2H image row with its descriptions. */
export class GetImmagineH2HResponse extends OkApiResponse implements IGetImmagineH2HResponse {
    /** The retrieved image row DTO. */
    image?: ImmagineH2HRow;

    constructor(data?: IGetImmagineH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.image = _data["image"] ? ImmagineH2HRow.fromJS(_data["image"]) : null as any;
        }
    }

    static override fromJS(data: any): GetImmagineH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetImmagineH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image ? this.image.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Response containing a single H2H image row with its descriptions. */
export interface IGetImmagineH2HResponse extends IOkApiResponse {
    /** The retrieved image row DTO. */
    image?: ImmagineH2HRow;
}

/** Row DTO for an H2H image in the list view. */
export class ImmagineH2HRow implements IImmagineH2HRow {
    /** Image primary key. */
    id?: number;
    /** FK to the aggregated H2H service. */
    servizioHHID?: number;
    /** Name of the aggregated service this image belongs to. */
    servizioNome?: string | null;
    /** Supplier name. */
    fornitore?: string;
    /** Full-resolution image URL. Max 500 chars. */
    imageUrl?: string;
    /** Thumbnail URL. Max 500 chars. */
    thumbUrl?: string | null;
    /** Supplier-assigned display order. */
    sortOrder?: number;
    /** Naar-assigned display order. Range: 1–255.
null means no Naar order has been assigned. */
    ordineNaar?: number | null;
    /** true when the image is enabled (i.e. Disabled = false). */
    enabled?: boolean;
    /** Last update timestamp. */
    updatedAt?: string;
    /** Supplier-provided source reference. Max 50 chars. */
    sourceRef?: string | null;
    /** Language descriptions for this image. Empty when not explicitly loaded. */
    descrizioni?: DescrizioneImmagineH2HRow[];

    constructor(data?: IImmagineH2HRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.servizioHHID = _data["servizioHHID"] !== undefined ? _data["servizioHHID"] : null as any;
            this.servizioNome = _data["servizioNome"] !== undefined ? _data["servizioNome"] : null as any;
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : null as any;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : null as any;
            this.thumbUrl = _data["thumbUrl"] !== undefined ? _data["thumbUrl"] : null as any;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null as any;
            this.ordineNaar = _data["ordineNaar"] !== undefined ? _data["ordineNaar"] : null as any;
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : null as any;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : null as any;
            this.sourceRef = _data["sourceRef"] !== undefined ? _data["sourceRef"] : null as any;
            if (Array.isArray(_data["descrizioni"])) {
                this.descrizioni = [] as any;
                for (let item of _data["descrizioni"])
                    this.descrizioni!.push(DescrizioneImmagineH2HRow.fromJS(item));
            }
            else {
                this.descrizioni = null as any;
            }
        }
    }

    static fromJS(data: any): ImmagineH2HRow {
        data = typeof data === 'object' ? data : {};
        let result = new ImmagineH2HRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["servizioHHID"] = this.servizioHHID !== undefined ? this.servizioHHID : null as any;
        data["servizioNome"] = this.servizioNome !== undefined ? this.servizioNome : null as any;
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : null as any;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : null as any;
        data["thumbUrl"] = this.thumbUrl !== undefined ? this.thumbUrl : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        data["ordineNaar"] = this.ordineNaar !== undefined ? this.ordineNaar : null as any;
        data["enabled"] = this.enabled !== undefined ? this.enabled : null as any;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : null as any;
        data["sourceRef"] = this.sourceRef !== undefined ? this.sourceRef : null as any;
        if (Array.isArray(this.descrizioni)) {
            data["descrizioni"] = [];
            for (let item of this.descrizioni)
                data["descrizioni"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** Row DTO for an H2H image in the list view. */
export interface IImmagineH2HRow {
    /** Image primary key. */
    id?: number;
    /** FK to the aggregated H2H service. */
    servizioHHID?: number;
    /** Name of the aggregated service this image belongs to. */
    servizioNome?: string | null;
    /** Supplier name. */
    fornitore?: string;
    /** Full-resolution image URL. Max 500 chars. */
    imageUrl?: string;
    /** Thumbnail URL. Max 500 chars. */
    thumbUrl?: string | null;
    /** Supplier-assigned display order. */
    sortOrder?: number;
    /** Naar-assigned display order. Range: 1–255.
null means no Naar order has been assigned. */
    ordineNaar?: number | null;
    /** true when the image is enabled (i.e. Disabled = false). */
    enabled?: boolean;
    /** Last update timestamp. */
    updatedAt?: string;
    /** Supplier-provided source reference. Max 50 chars. */
    sourceRef?: string | null;
    /** Language descriptions for this image. Empty when not explicitly loaded. */
    descrizioni?: DescrizioneImmagineH2HRow[];
}

/** Row DTO for a single language description of an H2H image. */
export class DescrizioneImmagineH2HRow implements IDescrizioneImmagineH2HRow {
    /** Description primary key. */
    id?: number;
    /** Language of this description. */
    lingua?: ELingua;
    /** Description text. Max 200 chars. */
    descrizione?: string;

    constructor(data?: IDescrizioneImmagineH2HRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
        }
    }

    static fromJS(data: any): DescrizioneImmagineH2HRow {
        data = typeof data === 'object' ? data : {};
        let result = new DescrizioneImmagineH2HRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["lingua"] = this.lingua !== undefined ? this.lingua : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        return data;
    }
}

/** Row DTO for a single language description of an H2H image. */
export interface IDescrizioneImmagineH2HRow {
    /** Description primary key. */
    id?: number;
    /** Language of this description. */
    lingua?: ELingua;
    /** Description text. Max 200 chars. */
    descrizione?: string;
}

/** Request to retrieve a single H2H image by its ID. */
export class GetImmagineH2HRequest extends LocalizedRequest implements IGetImmagineH2HRequest {
    /** Primary key of the image to retrieve. */
    imageID!: number;

    constructor(data?: IGetImmagineH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.imageID = _data["imageID"] !== undefined ? _data["imageID"] : null as any;
        }
    }

    static override fromJS(data: any): GetImmagineH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetImmagineH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageID"] = this.imageID !== undefined ? this.imageID : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Request to retrieve a single H2H image by its ID. */
export interface IGetImmagineH2HRequest extends ILocalizedRequest {
    /** Primary key of the image to retrieve. */
    imageID: number;
}

export class NrTableResponseOfImmagineH2HRow extends OkApiResponse implements INrTableResponseOfImmagineH2HRow {
    /** Array delle righe della pagina richiesta */
    rows?: ImmagineH2HRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfImmagineH2HRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ImmagineH2HRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfImmagineH2HRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfImmagineH2HRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfImmagineH2HRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: ImmagineH2HRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

/** Paginated response containing H2H image rows. */
export class GetImmaginiH2HResponse extends NrTableResponseOfImmagineH2HRow implements IGetImmaginiH2HResponse {

    constructor(data?: IGetImmaginiH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetImmaginiH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetImmaginiH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Paginated response containing H2H image rows. */
export interface IGetImmaginiH2HResponse extends INrTableResponseOfImmagineH2HRow {
}

/** Request for listing H2H images with optional filtering and pagination. */
export class GetImmaginiH2HRequest extends NrTableRequest implements IGetImmaginiH2HRequest {
    /** Optional filter by aggregated service ID (ID). */
    servizioHHID?: number | null;
    /** Optional filter by supplier (eFornitore). */
    fornitore?: EFornitore | null;
    /** Optional filter by disabled state.
true returns only disabled images; false returns only enabled ones; null returns all. */
    disabled?: boolean | null;

    constructor(data?: IGetImmaginiH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHID = _data["servizioHHID"] !== undefined ? _data["servizioHHID"] : null as any;
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : null as any;
            this.disabled = _data["disabled"] !== undefined ? _data["disabled"] : null as any;
        }
    }

    static override fromJS(data: any): GetImmaginiH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetImmaginiH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHID"] = this.servizioHHID !== undefined ? this.servizioHHID : null as any;
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : null as any;
        data["disabled"] = this.disabled !== undefined ? this.disabled : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Request for listing H2H images with optional filtering and pagination. */
export interface IGetImmaginiH2HRequest extends INrTableRequest {
    /** Optional filter by aggregated service ID (ID). */
    servizioHHID?: number | null;
    /** Optional filter by supplier (eFornitore). */
    fornitore?: EFornitore | null;
    /** Optional filter by disabled state.
true returns only disabled images; false returns only enabled ones; null returns all. */
    disabled?: boolean | null;
}

/** Response containing the saved descriptions with their generated IDs. */
export class SaveDescriptionsImmagineH2HResponse extends OkApiResponse implements ISaveDescriptionsImmagineH2HResponse {
    /** The saved descriptions. */
    descrizioni?: DescrizioneImmagineH2HRow[];

    constructor(data?: ISaveDescriptionsImmagineH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["descrizioni"])) {
                this.descrizioni = [] as any;
                for (let item of _data["descrizioni"])
                    this.descrizioni!.push(DescrizioneImmagineH2HRow.fromJS(item));
            }
            else {
                this.descrizioni = null as any;
            }
        }
    }

    static override fromJS(data: any): SaveDescriptionsImmagineH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveDescriptionsImmagineH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.descrizioni)) {
            data["descrizioni"] = [];
            for (let item of this.descrizioni)
                data["descrizioni"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Response containing the saved descriptions with their generated IDs. */
export interface ISaveDescriptionsImmagineH2HResponse extends IOkApiResponse {
    /** The saved descriptions. */
    descrizioni?: DescrizioneImmagineH2HRow[];
}

/** Request to replace all descriptions of an H2H image. */
export class SaveDescriptionsImmagineH2HRequest extends ApiRequest implements ISaveDescriptionsImmagineH2HRequest {
    /** Primary key of the target image. */
    imageID?: number;
    /** Full replacement list of descriptions. May be empty to remove all. */
    descrizioni?: DescrizioneImmagineH2HInput[];

    constructor(data?: ISaveDescriptionsImmagineH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.imageID = _data["imageID"] !== undefined ? _data["imageID"] : null as any;
            if (Array.isArray(_data["descrizioni"])) {
                this.descrizioni = [] as any;
                for (let item of _data["descrizioni"])
                    this.descrizioni!.push(DescrizioneImmagineH2HInput.fromJS(item));
            }
            else {
                this.descrizioni = null as any;
            }
        }
    }

    static override fromJS(data: any): SaveDescriptionsImmagineH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveDescriptionsImmagineH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageID"] = this.imageID !== undefined ? this.imageID : null as any;
        if (Array.isArray(this.descrizioni)) {
            data["descrizioni"] = [];
            for (let item of this.descrizioni)
                data["descrizioni"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Request to replace all descriptions of an H2H image. */
export interface ISaveDescriptionsImmagineH2HRequest extends IApiRequest {
    /** Primary key of the target image. */
    imageID?: number;
    /** Full replacement list of descriptions. May be empty to remove all. */
    descrizioni?: DescrizioneImmagineH2HInput[];
}

/** Input DTO for a single image description sent from the client. */
export class DescrizioneImmagineH2HInput implements IDescrizioneImmagineH2HInput {
    /** Language of the description. */
    lingua?: ELingua;
    /** Description text. Max 200 chars. */
    descrizione?: string;

    constructor(data?: IDescrizioneImmagineH2HInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
        }
    }

    static fromJS(data: any): DescrizioneImmagineH2HInput {
        data = typeof data === 'object' ? data : {};
        let result = new DescrizioneImmagineH2HInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lingua"] = this.lingua !== undefined ? this.lingua : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        return data;
    }
}

/** Input DTO for a single image description sent from the client. */
export interface IDescrizioneImmagineH2HInput {
    /** Language of the description. */
    lingua?: ELingua;
    /** Description text. Max 200 chars. */
    descrizione?: string;
}

/** Response containing the updated H2H image. */
export class UpdateImmagineH2HResponse extends OkApiResponse implements IUpdateImmagineH2HResponse {
    /** The updated image entity. */
    image?: HHImmagine;

    constructor(data?: IUpdateImmagineH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.image = _data["image"] ? HHImmagine.fromJS(_data["image"]) : null as any;
        }
    }

    static override fromJS(data: any): UpdateImmagineH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateImmagineH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image ? this.image.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Response containing the updated H2H image. */
export interface IUpdateImmagineH2HResponse extends IOkApiResponse {
    /** The updated image entity. */
    image?: HHImmagine;
}

/** Request to update an H2H image. Only OrdineNaar is persisted. */
export class UpdateImmagineH2HRequest extends ApiRequest implements IUpdateImmagineH2HRequest {
    /** The image to update. ID must be set. */
    image?: HHImmagine;

    constructor(data?: IUpdateImmagineH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.image = _data["image"] ? HHImmagine.fromJS(_data["image"]) : null as any;
        }
    }

    static override fromJS(data: any): UpdateImmagineH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateImmagineH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image ? this.image.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Request to update an H2H image. Only OrdineNaar is persisted. */
export interface IUpdateImmagineH2HRequest extends IApiRequest {
    /** The image to update. ID must be set. */
    image?: HHImmagine;
}

export class CancelOfferEACouponRequest extends ApiRequest implements ICancelOfferEACouponRequest {
    offerId?: number;
    sentInsuranceId?: number;

    constructor(data?: ICancelOfferEACouponRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offerId = _data["offerId"] !== undefined ? _data["offerId"] : null as any;
            this.sentInsuranceId = _data["sentInsuranceId"] !== undefined ? _data["sentInsuranceId"] : null as any;
        }
    }

    static override fromJS(data: any): CancelOfferEACouponRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CancelOfferEACouponRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offerId"] = this.offerId !== undefined ? this.offerId : null as any;
        data["sentInsuranceId"] = this.sentInsuranceId !== undefined ? this.sentInsuranceId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICancelOfferEACouponRequest extends IApiRequest {
    offerId?: number;
    sentInsuranceId?: number;
}

export class InsuranceGetResponse extends OkApiResponse implements IInsuranceGetResponse {
    insurance?: Assicurazione | null;

    constructor(data?: IInsuranceGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.insurance = _data["insurance"] ? Assicurazione.fromJS(_data["insurance"]) : null as any;
        }
    }

    static override fromJS(data: any): InsuranceGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["insurance"] = this.insurance ? this.insurance.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IInsuranceGetResponse extends IOkApiResponse {
    insurance?: Assicurazione | null;
}

export class Assicurazione implements IAssicurazione {
    id?: number;
    codice!: string;
    codiceTemplateEmail?: string | null;
    nome!: string;
    query?: string | null;
    abilitata?: boolean;
    orarioInvio!: string;
    modalitaCalendario?: EModalitaCalendarioAssicurazione;
    tipoOperazioneDB?: ETipoOperazioneDbAssicurazione | null;
    oraInvio?: number;
    minutoInvio?: number;
    servizioID?: number | null;

    constructor(data?: IAssicurazione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
            this.codiceTemplateEmail = _data["codiceTemplateEmail"] !== undefined ? _data["codiceTemplateEmail"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.query = _data["query"] !== undefined ? _data["query"] : null as any;
            this.abilitata = _data["abilitata"] !== undefined ? _data["abilitata"] : null as any;
            this.orarioInvio = _data["orarioInvio"] !== undefined ? _data["orarioInvio"] : null as any;
            this.modalitaCalendario = _data["modalitaCalendario"] !== undefined ? _data["modalitaCalendario"] : null as any;
            this.tipoOperazioneDB = _data["tipoOperazioneDB"] !== undefined ? _data["tipoOperazioneDB"] : null as any;
            this.oraInvio = _data["oraInvio"] !== undefined ? _data["oraInvio"] : null as any;
            this.minutoInvio = _data["minutoInvio"] !== undefined ? _data["minutoInvio"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
        }
    }

    static fromJS(data: any): Assicurazione {
        data = typeof data === 'object' ? data : {};
        let result = new Assicurazione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        data["codiceTemplateEmail"] = this.codiceTemplateEmail !== undefined ? this.codiceTemplateEmail : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["query"] = this.query !== undefined ? this.query : null as any;
        data["abilitata"] = this.abilitata !== undefined ? this.abilitata : null as any;
        data["orarioInvio"] = this.orarioInvio !== undefined ? this.orarioInvio : null as any;
        data["modalitaCalendario"] = this.modalitaCalendario !== undefined ? this.modalitaCalendario : null as any;
        data["tipoOperazioneDB"] = this.tipoOperazioneDB !== undefined ? this.tipoOperazioneDB : null as any;
        data["oraInvio"] = this.oraInvio !== undefined ? this.oraInvio : null as any;
        data["minutoInvio"] = this.minutoInvio !== undefined ? this.minutoInvio : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        return data;
    }
}

export interface IAssicurazione {
    id?: number;
    codice: string;
    codiceTemplateEmail?: string | null;
    nome: string;
    query?: string | null;
    abilitata?: boolean;
    orarioInvio: string;
    modalitaCalendario?: EModalitaCalendarioAssicurazione;
    tipoOperazioneDB?: ETipoOperazioneDbAssicurazione | null;
    oraInvio?: number;
    minutoInvio?: number;
    servizioID?: number | null;
}

export enum EModalitaCalendarioAssicurazione {
    Quotidiano = "Quotidiano",
    Feriali = "Feriali",
    Mensile = "Mensile",
    Filodiretto = "Filodiretto",
}

export enum ETipoOperazioneDbAssicurazione {
    Nessuna = "Nessuna",
    RischioZeroInsert = "RischioZeroInsert",
    FiloDirettoInsert = "FiloDirettoInsert",
    FiloDirettoUpdate = "FiloDirettoUpdate",
}

export class InsuranceGetRequest extends LocalizedRequest implements IInsuranceGetRequest {
    insuranceID?: number;

    constructor(data?: IInsuranceGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.insuranceID = _data["insuranceID"] !== undefined ? _data["insuranceID"] : null as any;
        }
    }

    static override fromJS(data: any): InsuranceGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["insuranceID"] = this.insuranceID !== undefined ? this.insuranceID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IInsuranceGetRequest extends ILocalizedRequest {
    insuranceID?: number;
}

export class GetOfferEAInsurancesResponse extends OkApiResponse implements IGetOfferEAInsurancesResponse {
    paxes?: InsuranceCustomerCoupons[];

    constructor(data?: IGetOfferEAInsurancesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["paxes"])) {
                this.paxes = [] as any;
                for (let item of _data["paxes"])
                    this.paxes!.push(InsuranceCustomerCoupons.fromJS(item));
            }
            else {
                this.paxes = null as any;
            }
        }
    }

    static override fromJS(data: any): GetOfferEAInsurancesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOfferEAInsurancesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.paxes)) {
            data["paxes"] = [];
            for (let item of this.paxes)
                data["paxes"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetOfferEAInsurancesResponse extends IOkApiResponse {
    paxes?: InsuranceCustomerCoupons[];
}

export class InsuranceCustomerCoupons implements IInsuranceCustomerCoupons {
    id?: number;
    name?: string;
    surname?: string;
    coupons?: InsuranceCouponDetail[];

    constructor(data?: IInsuranceCustomerCoupons) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.surname = _data["surname"] !== undefined ? _data["surname"] : null as any;
            if (Array.isArray(_data["coupons"])) {
                this.coupons = [] as any;
                for (let item of _data["coupons"])
                    this.coupons!.push(InsuranceCouponDetail.fromJS(item));
            }
            else {
                this.coupons = null as any;
            }
        }
    }

    static fromJS(data: any): InsuranceCustomerCoupons {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceCustomerCoupons();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["surname"] = this.surname !== undefined ? this.surname : null as any;
        if (Array.isArray(this.coupons)) {
            data["coupons"] = [];
            for (let item of this.coupons)
                data["coupons"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IInsuranceCustomerCoupons {
    id?: number;
    name?: string;
    surname?: string;
    coupons?: InsuranceCouponDetail[];
}

export class InsuranceCouponDetail implements IInsuranceCouponDetail {
    offerDataId?: number;
    serviceId?: number;
    serviceName?: string;
    travelDestination?: string | null;
    sentInsuranceId?: number;
    code?: string;
    cancelDate?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    resolutionDate?: string | null;
    insertDate?: string | null;
    bookingDate?: string | null;
    lastUpdateDate?: string | null;
    originalStartDate?: string | null;
    status?: EACouponStatus;

    constructor(data?: IInsuranceCouponDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offerDataId = _data["offerDataId"] !== undefined ? _data["offerDataId"] : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.serviceName = _data["serviceName"] !== undefined ? _data["serviceName"] : null as any;
            this.travelDestination = _data["travelDestination"] !== undefined ? _data["travelDestination"] : null as any;
            this.sentInsuranceId = _data["sentInsuranceId"] !== undefined ? _data["sentInsuranceId"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.cancelDate = _data["cancelDate"] !== undefined ? _data["cancelDate"] : null as any;
            this.startDate = _data["startDate"] !== undefined ? _data["startDate"] : null as any;
            this.endDate = _data["endDate"] !== undefined ? _data["endDate"] : null as any;
            this.resolutionDate = _data["resolutionDate"] !== undefined ? _data["resolutionDate"] : null as any;
            this.insertDate = _data["insertDate"] !== undefined ? _data["insertDate"] : null as any;
            this.bookingDate = _data["bookingDate"] !== undefined ? _data["bookingDate"] : null as any;
            this.lastUpdateDate = _data["lastUpdateDate"] !== undefined ? _data["lastUpdateDate"] : null as any;
            this.originalStartDate = _data["originalStartDate"] !== undefined ? _data["originalStartDate"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
        }
    }

    static fromJS(data: any): InsuranceCouponDetail {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceCouponDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offerDataId"] = this.offerDataId !== undefined ? this.offerDataId : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["serviceName"] = this.serviceName !== undefined ? this.serviceName : null as any;
        data["travelDestination"] = this.travelDestination !== undefined ? this.travelDestination : null as any;
        data["sentInsuranceId"] = this.sentInsuranceId !== undefined ? this.sentInsuranceId : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["cancelDate"] = this.cancelDate !== undefined ? this.cancelDate : null as any;
        data["startDate"] = this.startDate !== undefined ? this.startDate : null as any;
        data["endDate"] = this.endDate !== undefined ? this.endDate : null as any;
        data["resolutionDate"] = this.resolutionDate !== undefined ? this.resolutionDate : null as any;
        data["insertDate"] = this.insertDate !== undefined ? this.insertDate : null as any;
        data["bookingDate"] = this.bookingDate !== undefined ? this.bookingDate : null as any;
        data["lastUpdateDate"] = this.lastUpdateDate !== undefined ? this.lastUpdateDate : null as any;
        data["originalStartDate"] = this.originalStartDate !== undefined ? this.originalStartDate : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        return data;
    }
}

export interface IInsuranceCouponDetail {
    offerDataId?: number;
    serviceId?: number;
    serviceName?: string;
    travelDestination?: string | null;
    sentInsuranceId?: number;
    code?: string;
    cancelDate?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    resolutionDate?: string | null;
    insertDate?: string | null;
    bookingDate?: string | null;
    lastUpdateDate?: string | null;
    originalStartDate?: string | null;
    status?: EACouponStatus;
}

export enum EACouponStatus {
    Active = "Active",
    Deleted = "Deleted",
    Expired = "Expired",
}

export class GetOfferEAInsurancesRequest extends ApiRequest implements IGetOfferEAInsurancesRequest {
    offerId?: number;

    constructor(data?: IGetOfferEAInsurancesRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offerId = _data["offerId"] !== undefined ? _data["offerId"] : null as any;
        }
    }

    static override fromJS(data: any): GetOfferEAInsurancesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetOfferEAInsurancesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offerId"] = this.offerId !== undefined ? this.offerId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetOfferEAInsurancesRequest extends IApiRequest {
    offerId?: number;
}

export class NrTableResponseOfInsuranceRow extends OkApiResponse implements INrTableResponseOfInsuranceRow {
    /** Array delle righe della pagina richiesta */
    rows?: InsuranceRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfInsuranceRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(InsuranceRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfInsuranceRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfInsuranceRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfInsuranceRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: InsuranceRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class InsuranceListResponse extends NrTableResponseOfInsuranceRow implements IInsuranceListResponse {

    constructor(data?: IInsuranceListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): InsuranceListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IInsuranceListResponse extends INrTableResponseOfInsuranceRow {
}

export class InsuranceRow implements IInsuranceRow {
    id?: number;
    insurance?: Assicurazione | null;
    lastSend?: AssicurazioneInvio | null;

    constructor(data?: IInsuranceRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.insurance = _data["insurance"] ? Assicurazione.fromJS(_data["insurance"]) : null as any;
            this.lastSend = _data["lastSend"] ? AssicurazioneInvio.fromJS(_data["lastSend"]) : null as any;
        }
    }

    static fromJS(data: any): InsuranceRow {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["insurance"] = this.insurance ? this.insurance.toJSON() : null as any;
        data["lastSend"] = this.lastSend ? this.lastSend.toJSON() : null as any;
        return data;
    }
}

export interface IInsuranceRow {
    id?: number;
    insurance?: Assicurazione | null;
    lastSend?: AssicurazioneInvio | null;
}

export class AssicurazioneInvio implements IAssicurazioneInvio {
    id?: number;
    assicurazioneID?: number;
    data?: string;
    rowCount?: number;
    esito?: EEsitoInvioAssicurazione;
    jsonData?: string | null;
    messaggio?: string | null;

    constructor(data?: IAssicurazioneInvio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.assicurazioneID = _data["assicurazioneID"] !== undefined ? _data["assicurazioneID"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
            this.rowCount = _data["rowCount"] !== undefined ? _data["rowCount"] : null as any;
            this.esito = _data["esito"] !== undefined ? _data["esito"] : null as any;
            this.jsonData = _data["jsonData"] !== undefined ? _data["jsonData"] : null as any;
            this.messaggio = _data["messaggio"] !== undefined ? _data["messaggio"] : null as any;
        }
    }

    static fromJS(data: any): AssicurazioneInvio {
        data = typeof data === 'object' ? data : {};
        let result = new AssicurazioneInvio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["assicurazioneID"] = this.assicurazioneID !== undefined ? this.assicurazioneID : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : null as any;
        data["esito"] = this.esito !== undefined ? this.esito : null as any;
        data["jsonData"] = this.jsonData !== undefined ? this.jsonData : null as any;
        data["messaggio"] = this.messaggio !== undefined ? this.messaggio : null as any;
        return data;
    }
}

export interface IAssicurazioneInvio {
    id?: number;
    assicurazioneID?: number;
    data?: string;
    rowCount?: number;
    esito?: EEsitoInvioAssicurazione;
    jsonData?: string | null;
    messaggio?: string | null;
}

export enum EEsitoInvioAssicurazione {
    Ok = "Ok",
    Errore = "Errore",
}

export class InsuranceListRequest extends NrTableRequest implements IInsuranceListRequest {

    constructor(data?: IInsuranceListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): InsuranceListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IInsuranceListRequest extends INrTableRequest {
}

export class NrTableResponseOfAssicurazioneInvio extends OkApiResponse implements INrTableResponseOfAssicurazioneInvio {
    /** Array delle righe della pagina richiesta */
    rows?: AssicurazioneInvio[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfAssicurazioneInvio) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AssicurazioneInvio.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfAssicurazioneInvio {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfAssicurazioneInvio();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfAssicurazioneInvio extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: AssicurazioneInvio[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class InsuranceSendsListResponse extends NrTableResponseOfAssicurazioneInvio implements IInsuranceSendsListResponse {

    constructor(data?: IInsuranceSendsListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): InsuranceSendsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceSendsListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IInsuranceSendsListResponse extends INrTableResponseOfAssicurazioneInvio {
}

export class InsuranceSendsListRequest extends NrTableRequest implements IInsuranceSendsListRequest {
    insuranceID?: number;

    constructor(data?: IInsuranceSendsListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.insuranceID = _data["insuranceID"] !== undefined ? _data["insuranceID"] : null as any;
        }
    }

    static override fromJS(data: any): InsuranceSendsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceSendsListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["insuranceID"] = this.insuranceID !== undefined ? this.insuranceID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IInsuranceSendsListRequest extends INrTableRequest {
    insuranceID?: number;
}

export class CancelOfferEAInsuranceRequest extends ApiRequest implements ICancelOfferEAInsuranceRequest {
    offerId?: number;
    sentInsuranceId?: number;

    constructor(data?: ICancelOfferEAInsuranceRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offerId = _data["offerId"] !== undefined ? _data["offerId"] : null as any;
            this.sentInsuranceId = _data["sentInsuranceId"] !== undefined ? _data["sentInsuranceId"] : null as any;
        }
    }

    static override fromJS(data: any): CancelOfferEAInsuranceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CancelOfferEAInsuranceRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offerId"] = this.offerId !== undefined ? this.offerId : null as any;
        data["sentInsuranceId"] = this.sentInsuranceId !== undefined ? this.sentInsuranceId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICancelOfferEAInsuranceRequest extends IApiRequest {
    offerId?: number;
    sentInsuranceId?: number;
}

export class NrTableResponseOfLinkRow extends OkApiResponse implements INrTableResponseOfLinkRow {
    /** Array delle righe della pagina richiesta */
    rows?: LinkRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfLinkRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(LinkRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfLinkRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfLinkRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfLinkRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: LinkRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class LinkRow implements ILinkRow {
    id?: number;
    nome?: string | null;
    ordine?: number;
    servizioID?: number | null;
    servizio?: string | null;
    luogoID?: number | null;
    luogo?: string | null;
    tipo?: ETipoLink;
    posizione?: EPosizioneLink;

    constructor(data?: ILinkRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.posizione = _data["posizione"] !== undefined ? _data["posizione"] : null as any;
        }
    }

    static fromJS(data: any): LinkRow {
        data = typeof data === 'object' ? data : {};
        let result = new LinkRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["servizio"] = this.servizio !== undefined ? this.servizio : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["posizione"] = this.posizione !== undefined ? this.posizione : null as any;
        return data;
    }
}

export interface ILinkRow {
    id?: number;
    nome?: string | null;
    ordine?: number;
    servizioID?: number | null;
    servizio?: string | null;
    luogoID?: number | null;
    luogo?: string | null;
    tipo?: ETipoLink;
    posizione?: EPosizioneLink;
}

export class GetLinksListRequest extends NrTableRequest implements IGetLinksListRequest {
    nome?: string | null;
    tipoLink?: ETipoLink | null;
    tipoLuogo?: ETipoLuogo | null;
    luogoID?: number | null;

    constructor(data?: IGetLinksListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.tipoLink = _data["tipoLink"] !== undefined ? _data["tipoLink"] : null as any;
            this.tipoLuogo = _data["tipoLuogo"] !== undefined ? _data["tipoLuogo"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
        }
    }

    static override fromJS(data: any): GetLinksListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetLinksListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["tipoLink"] = this.tipoLink !== undefined ? this.tipoLink : null as any;
        data["tipoLuogo"] = this.tipoLuogo !== undefined ? this.tipoLuogo : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetLinksListRequest extends INrTableRequest {
    nome?: string | null;
    tipoLink?: ETipoLink | null;
    tipoLuogo?: ETipoLuogo | null;
    luogoID?: number | null;
}

export enum ETipoLuogo {
    Aeroporto = "Aeroporto",
    SubzonaAerea = "SubzonaAerea",
    Paese = "Paese",
    Regione = "Regione",
    Citta = "Citta",
    Area = "Area",
    GruppiDiCitta = "GruppiDiCitta",
    PuntoNoleggio = "PuntoNoleggio",
    PaginaWeb = "PaginaWeb",
    PaginaTci = "PaginaTci",
    Destinazione = "Destinazione",
    IdeeDiViaggio = "IdeeDiViaggio",
}

export class CheckServiziResponse extends OkApiResponse implements ICheckServiziResponse {
    rows?: CheckServiziRow[] | null;

    constructor(data?: ICheckServiziResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(CheckServiziRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
        }
    }

    static override fromJS(data: any): CheckServiziResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CheckServiziResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICheckServiziResponse extends IOkApiResponse {
    rows?: CheckServiziRow[] | null;
}

export class CheckServiziRow implements ICheckServiziRow {
    luogo?: string | null;
    tipo?: string | null;
    servizio?: string | null;
    idServizio?: number | null;
    web?: number | null;
    preferito?: boolean | null;
    contatto?: string | null;
    idContatto?: number | null;
    articleDate?: string | null;
    totDati?: number | null;
    images?: number | null;
    part?: string | null;
    lastPrice?: string | null;
    h2HSuppliers?: number | null;
    allot?: string | null;
    latitude?: number | null;
    longitude?: number | null;

    constructor(data?: ICheckServiziRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : null as any;
            this.idServizio = _data["idServizio"] !== undefined ? _data["idServizio"] : null as any;
            this.web = _data["web"] !== undefined ? _data["web"] : null as any;
            this.preferito = _data["preferito"] !== undefined ? _data["preferito"] : null as any;
            this.contatto = _data["contatto"] !== undefined ? _data["contatto"] : null as any;
            this.idContatto = _data["idContatto"] !== undefined ? _data["idContatto"] : null as any;
            this.articleDate = _data["articleDate"] !== undefined ? _data["articleDate"] : null as any;
            this.totDati = _data["totDati"] !== undefined ? _data["totDati"] : null as any;
            this.images = _data["images"] !== undefined ? _data["images"] : null as any;
            this.part = _data["part"] !== undefined ? _data["part"] : null as any;
            this.lastPrice = _data["lastPrice"] !== undefined ? _data["lastPrice"] : null as any;
            this.h2HSuppliers = _data["h2HSuppliers"] !== undefined ? _data["h2HSuppliers"] : null as any;
            this.allot = _data["allot"] !== undefined ? _data["allot"] : null as any;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : null as any;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : null as any;
        }
    }

    static fromJS(data: any): CheckServiziRow {
        data = typeof data === 'object' ? data : {};
        let result = new CheckServiziRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["servizio"] = this.servizio !== undefined ? this.servizio : null as any;
        data["idServizio"] = this.idServizio !== undefined ? this.idServizio : null as any;
        data["web"] = this.web !== undefined ? this.web : null as any;
        data["preferito"] = this.preferito !== undefined ? this.preferito : null as any;
        data["contatto"] = this.contatto !== undefined ? this.contatto : null as any;
        data["idContatto"] = this.idContatto !== undefined ? this.idContatto : null as any;
        data["articleDate"] = this.articleDate !== undefined ? this.articleDate : null as any;
        data["totDati"] = this.totDati !== undefined ? this.totDati : null as any;
        data["images"] = this.images !== undefined ? this.images : null as any;
        data["part"] = this.part !== undefined ? this.part : null as any;
        data["lastPrice"] = this.lastPrice !== undefined ? this.lastPrice : null as any;
        data["h2HSuppliers"] = this.h2HSuppliers !== undefined ? this.h2HSuppliers : null as any;
        data["allot"] = this.allot !== undefined ? this.allot : null as any;
        data["latitude"] = this.latitude !== undefined ? this.latitude : null as any;
        data["longitude"] = this.longitude !== undefined ? this.longitude : null as any;
        return data;
    }
}

export interface ICheckServiziRow {
    luogo?: string | null;
    tipo?: string | null;
    servizio?: string | null;
    idServizio?: number | null;
    web?: number | null;
    preferito?: boolean | null;
    contatto?: string | null;
    idContatto?: number | null;
    articleDate?: string | null;
    totDati?: number | null;
    images?: number | null;
    part?: string | null;
    lastPrice?: string | null;
    h2HSuppliers?: number | null;
    allot?: string | null;
    latitude?: number | null;
    longitude?: number | null;
}

export class CheckServiziRequest extends LocalizedRequest implements ICheckServiziRequest {
    luogoId?: number;
    export?: boolean;

    constructor(data?: ICheckServiziRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogoId = _data["luogoId"] !== undefined ? _data["luogoId"] : null as any;
            this.export = _data["export"] !== undefined ? _data["export"] : null as any;
        }
    }

    static override fromJS(data: any): CheckServiziRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckServiziRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoId"] = this.luogoId !== undefined ? this.luogoId : null as any;
        data["export"] = this.export !== undefined ? this.export : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICheckServiziRequest extends ILocalizedRequest {
    luogoId?: number;
    export?: boolean;
}

export class LocationDetail extends OkApiResponse implements ILocationDetail {
    luogo?: Luogo;
    mappa?: Mappa;

    constructor(data?: ILocationDetail) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogo = _data["luogo"] ? Luogo.fromJS(_data["luogo"]) : null as any;
            this.mappa = _data["mappa"] ? Mappa.fromJS(_data["mappa"]) : null as any;
        }
    }

    static override fromJS(data: any): LocationDetail {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDetail();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogo"] = this.luogo ? this.luogo.toJSON() : null as any;
        data["mappa"] = this.mappa ? this.mappa.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ILocationDetail extends IOkApiResponse {
    luogo?: Luogo;
    mappa?: Mappa;
}

export class Luogo implements ILuogo {
    luogoID?: number;
    nome!: string;
    pubblicazione1?: EStatoPubblicazioneLuogo | null;
    pubblicazione2?: EStatoPubblicazioneLuogo | null;
    pubblicazione3?: EStatoPubblicazioneLuogo | null;
    pubblicazione4?: EStatoPubblicazioneLuogo | null;
    tipo?: ETipoLuogo;
    cee?: boolean | null;
    iata?: string | null;
    tipoRicerca?: ETipoRicercaLuogo | null;
    autoFillFlags?: EAutofillFlags;
    provincia?: string | null;
    capoluogoProvincia?: boolean;
    giataCodeType?: ETipoLuogoGiata | null;
    giataCode?: string | null;
    modoNonMappati?: EModalitaNonMappati;
    popolarita?: number | null;
    nome_en?: string | null;
    traduzioni?: LocationTranslation[] | null;
    pubblicazioni?: LocationPublish[] | null;
    nascondiNrf?: boolean;
    eliminato?: string | null;
    cacheBypass?: boolean;
    codice?: string | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean | null;
    confirmed_en?: boolean | null;
    astoiID?: number | null;
    isExpertDestination?: boolean | null;
    range?: number | null;

    constructor(data?: ILuogo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.pubblicazione1 = _data["pubblicazione1"] !== undefined ? _data["pubblicazione1"] : null as any;
            this.pubblicazione2 = _data["pubblicazione2"] !== undefined ? _data["pubblicazione2"] : null as any;
            this.pubblicazione3 = _data["pubblicazione3"] !== undefined ? _data["pubblicazione3"] : null as any;
            this.pubblicazione4 = _data["pubblicazione4"] !== undefined ? _data["pubblicazione4"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.cee = _data["cee"] !== undefined ? _data["cee"] : null as any;
            this.iata = _data["iata"] !== undefined ? _data["iata"] : null as any;
            this.tipoRicerca = _data["tipoRicerca"] !== undefined ? _data["tipoRicerca"] : null as any;
            this.autoFillFlags = _data["autoFillFlags"] !== undefined ? _data["autoFillFlags"] : null as any;
            this.provincia = _data["provincia"] !== undefined ? _data["provincia"] : null as any;
            this.capoluogoProvincia = _data["capoluogoProvincia"] !== undefined ? _data["capoluogoProvincia"] : null as any;
            this.giataCodeType = _data["giataCodeType"] !== undefined ? _data["giataCodeType"] : null as any;
            this.giataCode = _data["giataCode"] !== undefined ? _data["giataCode"] : null as any;
            this.modoNonMappati = _data["modoNonMappati"] !== undefined ? _data["modoNonMappati"] : null as any;
            this.popolarita = _data["popolarita"] !== undefined ? _data["popolarita"] : null as any;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : null as any;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(LocationTranslation.fromJS(item));
            }
            else {
                this.traduzioni = null as any;
            }
            if (Array.isArray(_data["pubblicazioni"])) {
                this.pubblicazioni = [] as any;
                for (let item of _data["pubblicazioni"])
                    this.pubblicazioni!.push(LocationPublish.fromJS(item));
            }
            else {
                this.pubblicazioni = null as any;
            }
            this.nascondiNrf = _data["nascondiNrf"] !== undefined ? _data["nascondiNrf"] : null as any;
            this.eliminato = _data["eliminato"] !== undefined ? _data["eliminato"] : null as any;
            this.cacheBypass = _data["cacheBypass"] !== undefined ? _data["cacheBypass"] : null as any;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : null as any;
            this.lastUpdate_en = _data["lastUpdate_en"] !== undefined ? _data["lastUpdate_en"] : null as any;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : null as any;
            this.confirmed_en = _data["confirmed_en"] !== undefined ? _data["confirmed_en"] : null as any;
            this.astoiID = _data["astoiID"] !== undefined ? _data["astoiID"] : null as any;
            this.isExpertDestination = _data["isExpertDestination"] !== undefined ? _data["isExpertDestination"] : null as any;
            this.range = _data["range"] !== undefined ? _data["range"] : null as any;
        }
    }

    static fromJS(data: any): Luogo {
        data = typeof data === 'object' ? data : {};
        let result = new Luogo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["pubblicazione1"] = this.pubblicazione1 !== undefined ? this.pubblicazione1 : null as any;
        data["pubblicazione2"] = this.pubblicazione2 !== undefined ? this.pubblicazione2 : null as any;
        data["pubblicazione3"] = this.pubblicazione3 !== undefined ? this.pubblicazione3 : null as any;
        data["pubblicazione4"] = this.pubblicazione4 !== undefined ? this.pubblicazione4 : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["cee"] = this.cee !== undefined ? this.cee : null as any;
        data["iata"] = this.iata !== undefined ? this.iata : null as any;
        data["tipoRicerca"] = this.tipoRicerca !== undefined ? this.tipoRicerca : null as any;
        data["autoFillFlags"] = this.autoFillFlags !== undefined ? this.autoFillFlags : null as any;
        data["provincia"] = this.provincia !== undefined ? this.provincia : null as any;
        data["capoluogoProvincia"] = this.capoluogoProvincia !== undefined ? this.capoluogoProvincia : null as any;
        data["giataCodeType"] = this.giataCodeType !== undefined ? this.giataCodeType : null as any;
        data["giataCode"] = this.giataCode !== undefined ? this.giataCode : null as any;
        data["modoNonMappati"] = this.modoNonMappati !== undefined ? this.modoNonMappati : null as any;
        data["popolarita"] = this.popolarita !== undefined ? this.popolarita : null as any;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : null as any;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.pubblicazioni)) {
            data["pubblicazioni"] = [];
            for (let item of this.pubblicazioni)
                data["pubblicazioni"].push(item ? item.toJSON() : null as any);
        }
        data["nascondiNrf"] = this.nascondiNrf !== undefined ? this.nascondiNrf : null as any;
        data["eliminato"] = this.eliminato !== undefined ? this.eliminato : null as any;
        data["cacheBypass"] = this.cacheBypass !== undefined ? this.cacheBypass : null as any;
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : null as any;
        data["lastUpdate_en"] = this.lastUpdate_en !== undefined ? this.lastUpdate_en : null as any;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : null as any;
        data["confirmed_en"] = this.confirmed_en !== undefined ? this.confirmed_en : null as any;
        data["astoiID"] = this.astoiID !== undefined ? this.astoiID : null as any;
        data["isExpertDestination"] = this.isExpertDestination !== undefined ? this.isExpertDestination : null as any;
        data["range"] = this.range !== undefined ? this.range : null as any;
        return data;
    }
}

export interface ILuogo {
    luogoID?: number;
    nome: string;
    pubblicazione1?: EStatoPubblicazioneLuogo | null;
    pubblicazione2?: EStatoPubblicazioneLuogo | null;
    pubblicazione3?: EStatoPubblicazioneLuogo | null;
    pubblicazione4?: EStatoPubblicazioneLuogo | null;
    tipo?: ETipoLuogo;
    cee?: boolean | null;
    iata?: string | null;
    tipoRicerca?: ETipoRicercaLuogo | null;
    autoFillFlags?: EAutofillFlags;
    provincia?: string | null;
    capoluogoProvincia?: boolean;
    giataCodeType?: ETipoLuogoGiata | null;
    giataCode?: string | null;
    modoNonMappati?: EModalitaNonMappati;
    popolarita?: number | null;
    nome_en?: string | null;
    traduzioni?: LocationTranslation[] | null;
    pubblicazioni?: LocationPublish[] | null;
    nascondiNrf?: boolean;
    eliminato?: string | null;
    cacheBypass?: boolean;
    codice?: string | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean | null;
    confirmed_en?: boolean | null;
    astoiID?: number | null;
    isExpertDestination?: boolean | null;
    range?: number | null;
}

export enum EStatoPubblicazioneLuogo {
    NonPubblicato = "NonPubblicato",
    PubblicaWeb = "PubblicaWeb",
    PubblicaIntranet = "PubblicaIntranet",
    PubblicaWebPreferito = "PubblicaWebPreferito",
}

export enum ETipoRicercaLuogo {
    NoRicerca = "NoRicerca",
    Tutto = "Tutto",
    TuttoSalvoHotel = "TuttoSalvoHotel",
    SoloTour = "SoloTour",
}

export enum ETipoLuogoGiata {
    Paese = "Paese",
    Destinazione = "Destinazione",
    Citta = "Citta",
}

export enum EModalitaNonMappati {
    NonAttivi = "NonAttivi",
    SuRichiesta = "SuRichiesta",
    Sempre = "Sempre",
}

export class LocationTranslation extends WebTranslation implements ILocationTranslation {

    constructor(data?: ILocationTranslation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): LocationTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new LocationTranslation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ILocationTranslation extends IWebTranslation {
}

export class LocationPublish extends WebsitePublish implements ILocationPublish {
    statoPubblicazione?: EStatoPubblicazioneLuogo;

    constructor(data?: ILocationPublish) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.statoPubblicazione = _data["statoPubblicazione"] !== undefined ? _data["statoPubblicazione"] : null as any;
        }
    }

    static override fromJS(data: any): LocationPublish {
        data = typeof data === 'object' ? data : {};
        let result = new LocationPublish();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statoPubblicazione"] = this.statoPubblicazione !== undefined ? this.statoPubblicazione : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ILocationPublish extends IWebsitePublish {
    statoPubblicazione?: EStatoPubblicazioneLuogo;
}

export class CreateLocationRequest extends LocalizedRequest implements ICreateLocationRequest {
    luogo?: Luogo | null;

    constructor(data?: ICreateLocationRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogo = _data["luogo"] ? Luogo.fromJS(_data["luogo"]) : null as any;
        }
    }

    static override fromJS(data: any): CreateLocationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLocationRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogo"] = this.luogo ? this.luogo.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateLocationRequest extends ILocalizedRequest {
    luogo?: Luogo | null;
}

export class DeleteLocationRequest extends LocalizedRequest implements IDeleteLocationRequest {
    luogoId?: number;

    constructor(data?: IDeleteLocationRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogoId = _data["luogoId"] !== undefined ? _data["luogoId"] : null as any;
        }
    }

    static override fromJS(data: any): DeleteLocationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteLocationRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoId"] = this.luogoId !== undefined ? this.luogoId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteLocationRequest extends ILocalizedRequest {
    luogoId?: number;
}

export class DeleteMappaRequest extends LocalizedRequest implements IDeleteMappaRequest {
    luogoId?: number;

    constructor(data?: IDeleteMappaRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogoId = _data["luogoId"] !== undefined ? _data["luogoId"] : null as any;
        }
    }

    static override fromJS(data: any): DeleteMappaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMappaRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoId"] = this.luogoId !== undefined ? this.luogoId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteMappaRequest extends ILocalizedRequest {
    luogoId?: number;
}

export class GetLocationRequest extends LocalizedRequest implements IGetLocationRequest {
    luogoId!: number;

    constructor(data?: IGetLocationRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogoId = _data["luogoId"] !== undefined ? _data["luogoId"] : null as any;
        }
    }

    static override fromJS(data: any): GetLocationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoId"] = this.luogoId !== undefined ? this.luogoId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetLocationRequest extends ILocalizedRequest {
    luogoId: number;
}

export class LuogoRelazioneResponse extends OkApiResponse implements ILuogoRelazioneResponse {
    rows?: LuogoRelazioneRow[] | null;

    constructor(data?: ILuogoRelazioneResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(LuogoRelazioneRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
        }
    }

    static override fromJS(data: any): LuogoRelazioneResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LuogoRelazioneResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ILuogoRelazioneResponse extends IOkApiResponse {
    rows?: LuogoRelazioneRow[] | null;
}

export class LuogoRelazioneRow implements ILuogoRelazioneRow {
    luogoID?: number;
    luogoPadreId?: number;
    relazioneId?: number;

    constructor(data?: ILuogoRelazioneRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.luogoPadreId = _data["luogoPadreId"] !== undefined ? _data["luogoPadreId"] : null as any;
            this.relazioneId = _data["relazioneId"] !== undefined ? _data["relazioneId"] : null as any;
        }
    }

    static fromJS(data: any): LuogoRelazioneRow {
        data = typeof data === 'object' ? data : {};
        let result = new LuogoRelazioneRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["luogoPadreId"] = this.luogoPadreId !== undefined ? this.luogoPadreId : null as any;
        data["relazioneId"] = this.relazioneId !== undefined ? this.relazioneId : null as any;
        return data;
    }
}

export interface ILuogoRelazioneRow {
    luogoID?: number;
    luogoPadreId?: number;
    relazioneId?: number;
}

export class GetLuogoDistanzeRequest extends LocalizedRequest implements IGetLuogoDistanzeRequest {
    luogoId?: number;

    constructor(data?: IGetLuogoDistanzeRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogoId = _data["luogoId"] !== undefined ? _data["luogoId"] : null as any;
        }
    }

    static override fromJS(data: any): GetLuogoDistanzeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetLuogoDistanzeRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoId"] = this.luogoId !== undefined ? this.luogoId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetLuogoDistanzeRequest extends ILocalizedRequest {
    luogoId?: number;
}

export class GetLuoghiRelazioniRequest extends LocalizedRequest implements IGetLuoghiRelazioniRequest {
    luogoId?: number;

    constructor(data?: IGetLuoghiRelazioniRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogoId = _data["luogoId"] !== undefined ? _data["luogoId"] : null as any;
        }
    }

    static override fromJS(data: any): GetLuoghiRelazioniRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetLuoghiRelazioniRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoId"] = this.luogoId !== undefined ? this.luogoId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetLuoghiRelazioniRequest extends ILocalizedRequest {
    luogoId?: number;
}

export class LuoghiViciniResponse extends OkApiResponse implements ILuoghiViciniResponse {
    luoghiViciniIDs?: number[] | null;

    constructor(data?: ILuoghiViciniResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["luoghiViciniIDs"])) {
                this.luoghiViciniIDs = [] as any;
                for (let item of _data["luoghiViciniIDs"])
                    this.luoghiViciniIDs!.push(item);
            }
            else {
                this.luoghiViciniIDs = null as any;
            }
        }
    }

    static override fromJS(data: any): LuoghiViciniResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LuoghiViciniResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.luoghiViciniIDs)) {
            data["luoghiViciniIDs"] = [];
            for (let item of this.luoghiViciniIDs)
                data["luoghiViciniIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ILuoghiViciniResponse extends IOkApiResponse {
    luoghiViciniIDs?: number[] | null;
}

export class GetLuoghiViciniRequest extends LocalizedRequest implements IGetLuoghiViciniRequest {
    luogoId?: number;

    constructor(data?: IGetLuoghiViciniRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogoId = _data["luogoId"] !== undefined ? _data["luogoId"] : null as any;
        }
    }

    static override fromJS(data: any): GetLuoghiViciniRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetLuoghiViciniRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoId"] = this.luogoId !== undefined ? this.luogoId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetLuoghiViciniRequest extends ILocalizedRequest {
    luogoId?: number;
}

export class NrTableResponseOfLocationListRow extends OkApiResponse implements INrTableResponseOfLocationListRow {
    /** Array delle righe della pagina richiesta */
    rows?: LocationListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfLocationListRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(LocationListRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfLocationListRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfLocationListRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfLocationListRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: LocationListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

/** Classe che rappresenta la risposta ad una richiesta di elenco contatti */
export class LocationsListResponse extends NrTableResponseOfLocationListRow implements ILocationsListResponse {

    constructor(data?: ILocationsListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): LocationsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LocationsListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta la risposta ad una richiesta di elenco contatti */
export interface ILocationsListResponse extends INrTableResponseOfLocationListRow {
}

export class LocationListRow implements ILocationListRow {
    id?: number;
    codice?: string | null;
    nome?: string | null;
    tipo?: ETipoLuogo;
    regione?: string | null;
    paese?: string | null;
    locationPublishes?: LocationPublish[] | null;
    pubblicazioneSito1?: EStatoPubblicazioneLuogo;

    constructor(data?: ILocationListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.regione = _data["regione"] !== undefined ? _data["regione"] : null as any;
            this.paese = _data["paese"] !== undefined ? _data["paese"] : null as any;
            if (Array.isArray(_data["locationPublishes"])) {
                this.locationPublishes = [] as any;
                for (let item of _data["locationPublishes"])
                    this.locationPublishes!.push(LocationPublish.fromJS(item));
            }
            else {
                this.locationPublishes = null as any;
            }
            this.pubblicazioneSito1 = _data["pubblicazioneSito1"] !== undefined ? _data["pubblicazioneSito1"] : null as any;
        }
    }

    static fromJS(data: any): LocationListRow {
        data = typeof data === 'object' ? data : {};
        let result = new LocationListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["regione"] = this.regione !== undefined ? this.regione : null as any;
        data["paese"] = this.paese !== undefined ? this.paese : null as any;
        if (Array.isArray(this.locationPublishes)) {
            data["locationPublishes"] = [];
            for (let item of this.locationPublishes)
                data["locationPublishes"].push(item ? item.toJSON() : null as any);
        }
        data["pubblicazioneSito1"] = this.pubblicazioneSito1 !== undefined ? this.pubblicazioneSito1 : null as any;
        return data;
    }
}

export interface ILocationListRow {
    id?: number;
    codice?: string | null;
    nome?: string | null;
    tipo?: ETipoLuogo;
    regione?: string | null;
    paese?: string | null;
    locationPublishes?: LocationPublish[] | null;
    pubblicazioneSito1?: EStatoPubblicazioneLuogo;
}

export class ListLocationsRequest extends NrTableRequest implements IListLocationsRequest {
    term?: string | null;
    tipo?: ETipoLuogo | null;
    codice?: string | null;
    luogoPaeseID?: number | null;
    luogoRegioneID?: number | null;
    statoPubblicatione?: EStatoPubblicazioneLuogo | null;
    sitoPubblicazione?: number | null;

    constructor(data?: IListLocationsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
            this.luogoPaeseID = _data["luogoPaeseID"] !== undefined ? _data["luogoPaeseID"] : null as any;
            this.luogoRegioneID = _data["luogoRegioneID"] !== undefined ? _data["luogoRegioneID"] : null as any;
            this.statoPubblicatione = _data["statoPubblicatione"] !== undefined ? _data["statoPubblicatione"] : null as any;
            this.sitoPubblicazione = _data["sitoPubblicazione"] !== undefined ? _data["sitoPubblicazione"] : null as any;
        }
    }

    static override fromJS(data: any): ListLocationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListLocationsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        data["luogoPaeseID"] = this.luogoPaeseID !== undefined ? this.luogoPaeseID : null as any;
        data["luogoRegioneID"] = this.luogoRegioneID !== undefined ? this.luogoRegioneID : null as any;
        data["statoPubblicatione"] = this.statoPubblicatione !== undefined ? this.statoPubblicatione : null as any;
        data["sitoPubblicazione"] = this.sitoPubblicazione !== undefined ? this.sitoPubblicazione : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IListLocationsRequest extends INrTableRequest {
    term?: string | null;
    tipo?: ETipoLuogo | null;
    codice?: string | null;
    luogoPaeseID?: number | null;
    luogoRegioneID?: number | null;
    statoPubblicatione?: EStatoPubblicazioneLuogo | null;
    sitoPubblicazione?: number | null;
}

export class SetDistanzeRequest extends LocalizedRequest implements ISetDistanzeRequest {
    luogoId?: number;
    luoghiDistanze?: LuogoDistanza[] | null;

    constructor(data?: ISetDistanzeRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogoId = _data["luogoId"] !== undefined ? _data["luogoId"] : null as any;
            if (Array.isArray(_data["luoghiDistanze"])) {
                this.luoghiDistanze = [] as any;
                for (let item of _data["luoghiDistanze"])
                    this.luoghiDistanze!.push(LuogoDistanza.fromJS(item));
            }
            else {
                this.luoghiDistanze = null as any;
            }
        }
    }

    static override fromJS(data: any): SetDistanzeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetDistanzeRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoId"] = this.luogoId !== undefined ? this.luogoId : null as any;
        if (Array.isArray(this.luoghiDistanze)) {
            data["luoghiDistanze"] = [];
            for (let item of this.luoghiDistanze)
                data["luoghiDistanze"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetDistanzeRequest extends ILocalizedRequest {
    luogoId?: number;
    luoghiDistanze?: LuogoDistanza[] | null;
}

export class LuogoDistanza implements ILuogoDistanza {
    luogoDistanzaID?: number;
    luogoID?: number;
    luogoID2?: number;
    distanzaAuto?: number | null;
    durataAuto?: number | null;

    constructor(data?: ILuogoDistanza) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.luogoDistanzaID = _data["luogoDistanzaID"] !== undefined ? _data["luogoDistanzaID"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.luogoID2 = _data["luogoID2"] !== undefined ? _data["luogoID2"] : null as any;
            this.distanzaAuto = _data["distanzaAuto"] !== undefined ? _data["distanzaAuto"] : null as any;
            this.durataAuto = _data["durataAuto"] !== undefined ? _data["durataAuto"] : null as any;
        }
    }

    static fromJS(data: any): LuogoDistanza {
        data = typeof data === 'object' ? data : {};
        let result = new LuogoDistanza();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoDistanzaID"] = this.luogoDistanzaID !== undefined ? this.luogoDistanzaID : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["luogoID2"] = this.luogoID2 !== undefined ? this.luogoID2 : null as any;
        data["distanzaAuto"] = this.distanzaAuto !== undefined ? this.distanzaAuto : null as any;
        data["durataAuto"] = this.durataAuto !== undefined ? this.durataAuto : null as any;
        return data;
    }
}

export interface ILuogoDistanza {
    luogoDistanzaID?: number;
    luogoID?: number;
    luogoID2?: number;
    distanzaAuto?: number | null;
    durataAuto?: number | null;
}

export class SetMappaResponse extends OkApiResponse implements ISetMappaResponse {
    mappa?: Mappa | null;

    constructor(data?: ISetMappaResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.mappa = _data["mappa"] ? Mappa.fromJS(_data["mappa"]) : null as any;
        }
    }

    static override fromJS(data: any): SetMappaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetMappaResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mappa"] = this.mappa ? this.mappa.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISetMappaResponse extends IOkApiResponse {
    mappa?: Mappa | null;
}

export class SetMappaRequest extends LocalizedRequest implements ISetMappaRequest {
    luogoId?: number;
    mappa?: Mappa | null;

    constructor(data?: ISetMappaRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogoId = _data["luogoId"] !== undefined ? _data["luogoId"] : null as any;
            this.mappa = _data["mappa"] ? Mappa.fromJS(_data["mappa"]) : null as any;
        }
    }

    static override fromJS(data: any): SetMappaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetMappaRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoId"] = this.luogoId !== undefined ? this.luogoId : null as any;
        data["mappa"] = this.mappa ? this.mappa.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISetMappaRequest extends ILocalizedRequest {
    luogoId?: number;
    mappa?: Mappa | null;
}

export class SetRelazioniRequest extends LocalizedRequest implements ISetRelazioniRequest {
    luogoId?: number;
    luoghiRelazioni?: LuogoRelazione[] | null;

    constructor(data?: ISetRelazioniRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogoId = _data["luogoId"] !== undefined ? _data["luogoId"] : null as any;
            if (Array.isArray(_data["luoghiRelazioni"])) {
                this.luoghiRelazioni = [] as any;
                for (let item of _data["luoghiRelazioni"])
                    this.luoghiRelazioni!.push(LuogoRelazione.fromJS(item));
            }
            else {
                this.luoghiRelazioni = null as any;
            }
        }
    }

    static override fromJS(data: any): SetRelazioniRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetRelazioniRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoId"] = this.luogoId !== undefined ? this.luogoId : null as any;
        if (Array.isArray(this.luoghiRelazioni)) {
            data["luoghiRelazioni"] = [];
            for (let item of this.luoghiRelazioni)
                data["luoghiRelazioni"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetRelazioniRequest extends ILocalizedRequest {
    luogoId?: number;
    luoghiRelazioni?: LuogoRelazione[] | null;
}

export class LuogoRelazione implements ILuogoRelazione {
    relazioneID?: number;
    luogoID?: number;
    luogoPadreID?: number;

    constructor(data?: ILuogoRelazione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.relazioneID = _data["relazioneID"] !== undefined ? _data["relazioneID"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.luogoPadreID = _data["luogoPadreID"] !== undefined ? _data["luogoPadreID"] : null as any;
        }
    }

    static fromJS(data: any): LuogoRelazione {
        data = typeof data === 'object' ? data : {};
        let result = new LuogoRelazione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["relazioneID"] = this.relazioneID !== undefined ? this.relazioneID : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["luogoPadreID"] = this.luogoPadreID !== undefined ? this.luogoPadreID : null as any;
        return data;
    }
}

export interface ILuogoRelazione {
    relazioneID?: number;
    luogoID?: number;
    luogoPadreID?: number;
}

export class SetViciniRequest extends LocalizedRequest implements ISetViciniRequest {
    luogoId?: number;
    luoghiViciniIds?: number[] | null;

    constructor(data?: ISetViciniRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogoId = _data["luogoId"] !== undefined ? _data["luogoId"] : null as any;
            if (Array.isArray(_data["luoghiViciniIds"])) {
                this.luoghiViciniIds = [] as any;
                for (let item of _data["luoghiViciniIds"])
                    this.luoghiViciniIds!.push(item);
            }
            else {
                this.luoghiViciniIds = null as any;
            }
        }
    }

    static override fromJS(data: any): SetViciniRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetViciniRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoId"] = this.luogoId !== undefined ? this.luogoId : null as any;
        if (Array.isArray(this.luoghiViciniIds)) {
            data["luoghiViciniIds"] = [];
            for (let item of this.luoghiViciniIds)
                data["luoghiViciniIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetViciniRequest extends ILocalizedRequest {
    luogoId?: number;
    luoghiViciniIds?: number[] | null;
}

export class UpdateLocationRequest extends LocalizedRequest implements IUpdateLocationRequest {
    luogo?: Luogo | null;

    constructor(data?: IUpdateLocationRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogo = _data["luogo"] ? Luogo.fromJS(_data["luogo"]) : null as any;
        }
    }

    static override fromJS(data: any): UpdateLocationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLocationRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogo"] = this.luogo ? this.luogo.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateLocationRequest extends ILocalizedRequest {
    luogo?: Luogo | null;
}

export class UpdateLocationPublishingRequest extends ApiRequest implements IUpdateLocationPublishingRequest {
    locationId?: number;
    siteId?: number;
    status?: EStatoPubblicazioneLuogo;

    constructor(data?: IUpdateLocationPublishingRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : null as any;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
        }
    }

    static override fromJS(data: any): UpdateLocationPublishingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLocationPublishingRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId !== undefined ? this.locationId : null as any;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateLocationPublishingRequest extends IApiRequest {
    locationId?: number;
    siteId?: number;
    status?: EStatoPubblicazioneLuogo;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class ConfirmLuogoH2HRequest extends ApiRequest implements IConfirmLuogoH2HRequest {
    id?: number;

    constructor(data?: IConfirmLuogoH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): ConfirmLuogoH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmLuogoH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IConfirmLuogoH2HRequest extends IApiRequest {
    id?: number;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class DeleteLuogoH2HRequest extends ApiRequest implements IDeleteLuogoH2HRequest {
    id?: number;

    constructor(data?: IDeleteLuogoH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): DeleteLuogoH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteLuogoH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IDeleteLuogoH2HRequest extends IApiRequest {
    id?: number;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class DiscardLuogoH2HRequest extends ApiRequest implements IDiscardLuogoH2HRequest {
    id?: number;

    constructor(data?: IDiscardLuogoH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): DiscardLuogoH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DiscardLuogoH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IDiscardLuogoH2HRequest extends IApiRequest {
    id?: number;
}

export class LuogoH2HGetResponse extends OkApiResponse implements ILuogoH2HGetResponse {
    luogo?: LuogoH2HRow;

    constructor(data?: ILuogoH2HGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogo = _data["luogo"] ? LuogoH2HRow.fromJS(_data["luogo"]) : null as any;
        }
    }

    static override fromJS(data: any): LuogoH2HGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LuogoH2HGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogo"] = this.luogo ? this.luogo.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ILuogoH2HGetResponse extends IOkApiResponse {
    luogo?: LuogoH2HRow;
}

export class LuogoH2HRow implements ILuogoH2HRow {
    id?: number;
    paese?: string | null;
    tipo?: EHHTipoLuogo;
    hhLuogo?: HHLuogo | null;
    nome?: string | null;
    codice?: string | null;
    fornitore?: string | null;
    fornitoreID?: number;
    luogoNaar?: string | null;
    disabilitato?: boolean;
    ultimoAggiornamento?: string | null;
    accordo?: string | null;
    accordoMancante?: boolean;
    deleted?: string | null;
    latitude?: number | null;
    longitude?: number | null;

    constructor(data?: ILuogoH2HRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.paese = _data["paese"] !== undefined ? _data["paese"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.hhLuogo = _data["hhLuogo"] ? HHLuogo.fromJS(_data["hhLuogo"]) : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : null as any;
            this.fornitoreID = _data["fornitoreID"] !== undefined ? _data["fornitoreID"] : null as any;
            this.luogoNaar = _data["luogoNaar"] !== undefined ? _data["luogoNaar"] : null as any;
            this.disabilitato = _data["disabilitato"] !== undefined ? _data["disabilitato"] : null as any;
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] !== undefined ? _data["ultimoAggiornamento"] : null as any;
            this.accordo = _data["accordo"] !== undefined ? _data["accordo"] : null as any;
            this.accordoMancante = _data["accordoMancante"] !== undefined ? _data["accordoMancante"] : null as any;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : null as any;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : null as any;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : null as any;
        }
    }

    static fromJS(data: any): LuogoH2HRow {
        data = typeof data === 'object' ? data : {};
        let result = new LuogoH2HRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["paese"] = this.paese !== undefined ? this.paese : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["hhLuogo"] = this.hhLuogo ? this.hhLuogo.toJSON() : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : null as any;
        data["fornitoreID"] = this.fornitoreID !== undefined ? this.fornitoreID : null as any;
        data["luogoNaar"] = this.luogoNaar !== undefined ? this.luogoNaar : null as any;
        data["disabilitato"] = this.disabilitato !== undefined ? this.disabilitato : null as any;
        data["ultimoAggiornamento"] = this.ultimoAggiornamento !== undefined ? this.ultimoAggiornamento : null as any;
        data["accordo"] = this.accordo !== undefined ? this.accordo : null as any;
        data["accordoMancante"] = this.accordoMancante !== undefined ? this.accordoMancante : null as any;
        data["deleted"] = this.deleted !== undefined ? this.deleted : null as any;
        data["latitude"] = this.latitude !== undefined ? this.latitude : null as any;
        data["longitude"] = this.longitude !== undefined ? this.longitude : null as any;
        return data;
    }
}

export interface ILuogoH2HRow {
    id?: number;
    paese?: string | null;
    tipo?: EHHTipoLuogo;
    hhLuogo?: HHLuogo | null;
    nome?: string | null;
    codice?: string | null;
    fornitore?: string | null;
    fornitoreID?: number;
    luogoNaar?: string | null;
    disabilitato?: boolean;
    ultimoAggiornamento?: string | null;
    accordo?: string | null;
    accordoMancante?: boolean;
    deleted?: string | null;
    latitude?: number | null;
    longitude?: number | null;
}

export class LuogoH2HGetRequest extends LocalizedRequest implements ILuogoH2HGetRequest {
    luogoH2HID!: number;

    constructor(data?: ILuogoH2HGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogoH2HID = _data["luogoH2HID"] !== undefined ? _data["luogoH2HID"] : null as any;
        }
    }

    static override fromJS(data: any): LuogoH2HGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LuogoH2HGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoH2HID"] = this.luogoH2HID !== undefined ? this.luogoH2HID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ILuogoH2HGetRequest extends ILocalizedRequest {
    luogoH2HID: number;
}

export class NrTableResponseOfLuogoH2HRow extends OkApiResponse implements INrTableResponseOfLuogoH2HRow {
    /** Array delle righe della pagina richiesta */
    rows?: LuogoH2HRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfLuogoH2HRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(LuogoH2HRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfLuogoH2HRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfLuogoH2HRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfLuogoH2HRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: LuogoH2HRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class GetLuoghiH2HResponse extends NrTableResponseOfLuogoH2HRow implements IGetLuoghiH2HResponse {

    constructor(data?: IGetLuoghiH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetLuoghiH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLuoghiH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetLuoghiH2HResponse extends INrTableResponseOfLuogoH2HRow {
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class GetLuoghiH2HRequest extends NrTableRequest implements IGetLuoghiH2HRequest {
    supplier?: number | null;
    luogoNaarID?: number | null;
    mapped?: boolean | null;
    disabled?: boolean | null;
    confirmed?: boolean | null;
    nomeLuogoFornitore?: string | null;
    codicePaese?: string | null;
    missingAc?: boolean;
    showDeleted?: boolean;

    constructor(data?: IGetLuoghiH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : null as any;
            this.luogoNaarID = _data["luogoNaarID"] !== undefined ? _data["luogoNaarID"] : null as any;
            this.mapped = _data["mapped"] !== undefined ? _data["mapped"] : null as any;
            this.disabled = _data["disabled"] !== undefined ? _data["disabled"] : null as any;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : null as any;
            this.nomeLuogoFornitore = _data["nomeLuogoFornitore"] !== undefined ? _data["nomeLuogoFornitore"] : null as any;
            this.codicePaese = _data["codicePaese"] !== undefined ? _data["codicePaese"] : null as any;
            this.missingAc = _data["missingAc"] !== undefined ? _data["missingAc"] : null as any;
            this.showDeleted = _data["showDeleted"] !== undefined ? _data["showDeleted"] : null as any;
        }
    }

    static override fromJS(data: any): GetLuoghiH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetLuoghiH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplier"] = this.supplier !== undefined ? this.supplier : null as any;
        data["luogoNaarID"] = this.luogoNaarID !== undefined ? this.luogoNaarID : null as any;
        data["mapped"] = this.mapped !== undefined ? this.mapped : null as any;
        data["disabled"] = this.disabled !== undefined ? this.disabled : null as any;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : null as any;
        data["nomeLuogoFornitore"] = this.nomeLuogoFornitore !== undefined ? this.nomeLuogoFornitore : null as any;
        data["codicePaese"] = this.codicePaese !== undefined ? this.codicePaese : null as any;
        data["missingAc"] = this.missingAc !== undefined ? this.missingAc : null as any;
        data["showDeleted"] = this.showDeleted !== undefined ? this.showDeleted : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IGetLuoghiH2HRequest extends INrTableRequest {
    supplier?: number | null;
    luogoNaarID?: number | null;
    mapped?: boolean | null;
    disabled?: boolean | null;
    confirmed?: boolean | null;
    nomeLuogoFornitore?: string | null;
    codicePaese?: string | null;
    missingAc?: boolean;
    showDeleted?: boolean;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class RestoreLuogoH2HRequest extends ApiRequest implements IRestoreLuogoH2HRequest {
    id?: number;

    constructor(data?: IRestoreLuogoH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): RestoreLuogoH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreLuogoH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IRestoreLuogoH2HRequest extends IApiRequest {
    id?: number;
}

export class UpdateLuogoH2HResponse extends OkApiResponse implements IUpdateLuogoH2HResponse {
    luogo?: HHLuogo | null;

    constructor(data?: IUpdateLuogoH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogo = _data["luogo"] ? HHLuogo.fromJS(_data["luogo"]) : null as any;
        }
    }

    static override fromJS(data: any): UpdateLuogoH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLuogoH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogo"] = this.luogo ? this.luogo.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateLuogoH2HResponse extends IOkApiResponse {
    luogo?: HHLuogo | null;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class UpdateLuogoH2HRequest extends ApiRequest implements IUpdateLuogoH2HRequest {
    luogo?: HHLuogo | null;

    constructor(data?: IUpdateLuogoH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogo = _data["luogo"] ? HHLuogo.fromJS(_data["luogo"]) : null as any;
        }
    }

    static override fromJS(data: any): UpdateLuogoH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLuogoH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogo"] = this.luogo ? this.luogo.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IUpdateLuogoH2HRequest extends IApiRequest {
    luogo?: HHLuogo | null;
}

export class GetAgencyDataResponse extends OkApiResponse implements IGetAgencyDataResponse {
    /** ID del contatto agenzia */
    contattoID!: number;
    /** Nome del contatto / Ragione sociale semplice */
    nome!: string;
    /** Cognome del contatto / Ragione sociale estesa (incluso tipo società) */
    cognome?: string | null;
    /** Indirizzo del contatto. Dovrebbe essere solo la parte col nome della via */
    indirizzo?: string | null;
    /** Numero civico, qualora non incluso in Indirizzo */
    civico?: string | null;
    /** CAP dell'indirizzo del contatto */
    cap?: string | null;
    /** Città della sede del contatto */
    luogo?: string | null;
    /** Sigla della provincia della sede del contatto (solo contatti italiani) */
    provincia?: string | null;
    /** Numero di telefono. Campo libero, potrebbe contenenre più numeri e/o brevi note */
    telefono?: string | null;
    /** Numero di fax */
    fax?: string | null;
    /** Indirizzo email principale del contatto */
    email?: string | null;
    /** Nome della categoria dell'agenzia */
    categoria?: string | null;
    /** Codice della categoria dell'agenzia */
    codiceCategoria?: string | null;
    /** Descrizione della modalità di pagamento associata all'accordo corrente per l'operatore dell'offerta. Può contenere tag html */
    pagamentoHtml?: string | null;
    /** ID del contatto di tipo network agenzie (se appartenente a network) */
    contattoNetworkID?: number | null;
    /** Nome del network di agenzie (se appartenente a network) */
    network?: string | null;
    /** ID del contatto di tipo produttore/promoter se associato */
    contattoPromoterID?: number | null;
    /** Nome del produttore/promoter se associato */
    promoter?: string | null;
    /** Numero di telefono del produttore/promoter se associato. Campo libero, potrebbe contenenre più numeri e/o brevi note */
    telefonoPromoter?: string | null;
    /** Percentuale di acconto richiesta per viaggi standard */
    acconto?: number | null;
    /** Se true l'agenzia non paga anticipi sulle quote di apertura pratica */
    noAnticipoQuote?: boolean;
    /** Percentuale di acconto richiesta per viaggi di tipo nozze */
    accontoNozze?: number | null;
    /** Se true l'agenzia non paga anticipi sulla biglietteria aerea */
    noAnticipoBiglietti?: boolean;
    /** Nome dell'addetto in agenzia responsabile per questa pratica */
    nomeAddetto?: string | null;
    /** Email dell'addetto in agenzia responsabile per questa pratica */
    emailAddetto?: string | null;
    /** Nome esteso dell'utente dell'agenzia proprietario della pratica */
    username?: string | null;
    /** Elenco delle note commerciali per l'agenzia */
    noteAgenzia?: string[] | null;

    constructor(data?: IGetAgencyDataResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : null as any;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : null as any;
            this.civico = _data["civico"] !== undefined ? _data["civico"] : null as any;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.provincia = _data["provincia"] !== undefined ? _data["provincia"] : null as any;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : null as any;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.categoria = _data["categoria"] !== undefined ? _data["categoria"] : null as any;
            this.codiceCategoria = _data["codiceCategoria"] !== undefined ? _data["codiceCategoria"] : null as any;
            this.pagamentoHtml = _data["pagamentoHtml"] !== undefined ? _data["pagamentoHtml"] : null as any;
            this.contattoNetworkID = _data["contattoNetworkID"] !== undefined ? _data["contattoNetworkID"] : null as any;
            this.network = _data["network"] !== undefined ? _data["network"] : null as any;
            this.contattoPromoterID = _data["contattoPromoterID"] !== undefined ? _data["contattoPromoterID"] : null as any;
            this.promoter = _data["promoter"] !== undefined ? _data["promoter"] : null as any;
            this.telefonoPromoter = _data["telefonoPromoter"] !== undefined ? _data["telefonoPromoter"] : null as any;
            this.acconto = _data["acconto"] !== undefined ? _data["acconto"] : null as any;
            this.noAnticipoQuote = _data["noAnticipoQuote"] !== undefined ? _data["noAnticipoQuote"] : null as any;
            this.accontoNozze = _data["accontoNozze"] !== undefined ? _data["accontoNozze"] : null as any;
            this.noAnticipoBiglietti = _data["noAnticipoBiglietti"] !== undefined ? _data["noAnticipoBiglietti"] : null as any;
            this.nomeAddetto = _data["nomeAddetto"] !== undefined ? _data["nomeAddetto"] : null as any;
            this.emailAddetto = _data["emailAddetto"] !== undefined ? _data["emailAddetto"] : null as any;
            this.username = _data["username"] !== undefined ? _data["username"] : null as any;
            if (Array.isArray(_data["noteAgenzia"])) {
                this.noteAgenzia = [] as any;
                for (let item of _data["noteAgenzia"])
                    this.noteAgenzia!.push(item);
            }
            else {
                this.noteAgenzia = null as any;
            }
        }
    }

    static override fromJS(data: any): GetAgencyDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAgencyDataResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["cognome"] = this.cognome !== undefined ? this.cognome : null as any;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : null as any;
        data["civico"] = this.civico !== undefined ? this.civico : null as any;
        data["cap"] = this.cap !== undefined ? this.cap : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["provincia"] = this.provincia !== undefined ? this.provincia : null as any;
        data["telefono"] = this.telefono !== undefined ? this.telefono : null as any;
        data["fax"] = this.fax !== undefined ? this.fax : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["categoria"] = this.categoria !== undefined ? this.categoria : null as any;
        data["codiceCategoria"] = this.codiceCategoria !== undefined ? this.codiceCategoria : null as any;
        data["pagamentoHtml"] = this.pagamentoHtml !== undefined ? this.pagamentoHtml : null as any;
        data["contattoNetworkID"] = this.contattoNetworkID !== undefined ? this.contattoNetworkID : null as any;
        data["network"] = this.network !== undefined ? this.network : null as any;
        data["contattoPromoterID"] = this.contattoPromoterID !== undefined ? this.contattoPromoterID : null as any;
        data["promoter"] = this.promoter !== undefined ? this.promoter : null as any;
        data["telefonoPromoter"] = this.telefonoPromoter !== undefined ? this.telefonoPromoter : null as any;
        data["acconto"] = this.acconto !== undefined ? this.acconto : null as any;
        data["noAnticipoQuote"] = this.noAnticipoQuote !== undefined ? this.noAnticipoQuote : null as any;
        data["accontoNozze"] = this.accontoNozze !== undefined ? this.accontoNozze : null as any;
        data["noAnticipoBiglietti"] = this.noAnticipoBiglietti !== undefined ? this.noAnticipoBiglietti : null as any;
        data["nomeAddetto"] = this.nomeAddetto !== undefined ? this.nomeAddetto : null as any;
        data["emailAddetto"] = this.emailAddetto !== undefined ? this.emailAddetto : null as any;
        data["username"] = this.username !== undefined ? this.username : null as any;
        if (Array.isArray(this.noteAgenzia)) {
            data["noteAgenzia"] = [];
            for (let item of this.noteAgenzia)
                data["noteAgenzia"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetAgencyDataResponse extends IOkApiResponse {
    /** ID del contatto agenzia */
    contattoID: number;
    /** Nome del contatto / Ragione sociale semplice */
    nome: string;
    /** Cognome del contatto / Ragione sociale estesa (incluso tipo società) */
    cognome?: string | null;
    /** Indirizzo del contatto. Dovrebbe essere solo la parte col nome della via */
    indirizzo?: string | null;
    /** Numero civico, qualora non incluso in Indirizzo */
    civico?: string | null;
    /** CAP dell'indirizzo del contatto */
    cap?: string | null;
    /** Città della sede del contatto */
    luogo?: string | null;
    /** Sigla della provincia della sede del contatto (solo contatti italiani) */
    provincia?: string | null;
    /** Numero di telefono. Campo libero, potrebbe contenenre più numeri e/o brevi note */
    telefono?: string | null;
    /** Numero di fax */
    fax?: string | null;
    /** Indirizzo email principale del contatto */
    email?: string | null;
    /** Nome della categoria dell'agenzia */
    categoria?: string | null;
    /** Codice della categoria dell'agenzia */
    codiceCategoria?: string | null;
    /** Descrizione della modalità di pagamento associata all'accordo corrente per l'operatore dell'offerta. Può contenere tag html */
    pagamentoHtml?: string | null;
    /** ID del contatto di tipo network agenzie (se appartenente a network) */
    contattoNetworkID?: number | null;
    /** Nome del network di agenzie (se appartenente a network) */
    network?: string | null;
    /** ID del contatto di tipo produttore/promoter se associato */
    contattoPromoterID?: number | null;
    /** Nome del produttore/promoter se associato */
    promoter?: string | null;
    /** Numero di telefono del produttore/promoter se associato. Campo libero, potrebbe contenenre più numeri e/o brevi note */
    telefonoPromoter?: string | null;
    /** Percentuale di acconto richiesta per viaggi standard */
    acconto?: number | null;
    /** Se true l'agenzia non paga anticipi sulle quote di apertura pratica */
    noAnticipoQuote?: boolean;
    /** Percentuale di acconto richiesta per viaggi di tipo nozze */
    accontoNozze?: number | null;
    /** Se true l'agenzia non paga anticipi sulla biglietteria aerea */
    noAnticipoBiglietti?: boolean;
    /** Nome dell'addetto in agenzia responsabile per questa pratica */
    nomeAddetto?: string | null;
    /** Email dell'addetto in agenzia responsabile per questa pratica */
    emailAddetto?: string | null;
    /** Nome esteso dell'utente dell'agenzia proprietario della pratica */
    username?: string | null;
    /** Elenco delle note commerciali per l'agenzia */
    noteAgenzia?: string[] | null;
}

export class M2MRequest extends ApiRequest implements IM2MRequest {
    /** Token di autorizzazione */
    authToken!: string;

    constructor(data?: IM2MRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.authToken = _data["authToken"] !== undefined ? _data["authToken"] : null as any;
        }
    }

    static override fromJS(data: any): M2MRequest {
        data = typeof data === 'object' ? data : {};
        let result = new M2MRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authToken"] = this.authToken !== undefined ? this.authToken : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IM2MRequest extends IApiRequest {
    /** Token di autorizzazione */
    authToken: string;
}

export class GetAgencyDataRequest extends M2MRequest implements IGetAgencyDataRequest {
    /** ID dell'offerta da cui estrarre i dati agenzia */
    offertaID!: number;

    constructor(data?: IGetAgencyDataRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
        }
    }

    static override fromJS(data: any): GetAgencyDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAgencyDataRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetAgencyDataRequest extends IM2MRequest {
    /** ID dell'offerta da cui estrarre i dati agenzia */
    offertaID: number;
}

export class GetContabilityDocumentDataResponse extends OkApiResponse implements IGetContabilityDocumentDataResponse {
    listRow?: InvoicePrint;

    constructor(data?: IGetContabilityDocumentDataResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.listRow = _data["listRow"] ? InvoicePrint.fromJS(_data["listRow"]) : null as any;
        }
    }

    static override fromJS(data: any): GetContabilityDocumentDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetContabilityDocumentDataResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listRow"] = this.listRow ? this.listRow.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetContabilityDocumentDataResponse extends IOkApiResponse {
    listRow?: InvoicePrint;
}

export class InvoicePrint implements IInvoicePrint {
    invoiceDocument?: InvoiceDocument;
    fatturaEmitter?: InvoiceEmitter;
    economics?: TripEconomics | null;
    numOfPages?: number;
    /** Righe raggruppate per maxNumOfPages */
    groupedRighe?: InvoicesListRowDetail[][];

    constructor(data?: IInvoicePrint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceDocument = _data["invoiceDocument"] ? InvoiceDocument.fromJS(_data["invoiceDocument"]) : null as any;
            this.fatturaEmitter = _data["fatturaEmitter"] ? InvoiceEmitter.fromJS(_data["fatturaEmitter"]) : null as any;
            this.economics = _data["economics"] ? TripEconomics.fromJS(_data["economics"]) : null as any;
            this.numOfPages = _data["numOfPages"] !== undefined ? _data["numOfPages"] : null as any;
            if (Array.isArray(_data["groupedRighe"])) {
                this.groupedRighe = [] as any;
                for (let item of _data["groupedRighe"])
                    this.groupedRighe!.push(item);
            }
            else {
                this.groupedRighe = null as any;
            }
        }
    }

    static fromJS(data: any): InvoicePrint {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicePrint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceDocument"] = this.invoiceDocument ? this.invoiceDocument.toJSON() : null as any;
        data["fatturaEmitter"] = this.fatturaEmitter ? this.fatturaEmitter.toJSON() : null as any;
        data["economics"] = this.economics ? this.economics.toJSON() : null as any;
        data["numOfPages"] = this.numOfPages !== undefined ? this.numOfPages : null as any;
        if (Array.isArray(this.groupedRighe)) {
            data["groupedRighe"] = [];
            for (let item of this.groupedRighe)
                data["groupedRighe"].push(item);
        }
        return data;
    }
}

export interface IInvoicePrint {
    invoiceDocument?: InvoiceDocument;
    fatturaEmitter?: InvoiceEmitter;
    economics?: TripEconomics | null;
    numOfPages?: number;
    /** Righe raggruppate per maxNumOfPages */
    groupedRighe?: InvoicesListRowDetail[][];
}

export class InvoiceDocument implements IInvoiceDocument {
    id?: number;
    tipo?: ETipoDocumento;
    numero?: number;
    data?: string;
    contattoID?: number | null;
    contatto?: string | null;
    ragioneSociale?: string | null;
    indirizzoFatt?: string | null;
    numeroCivico?: string | null;
    cap?: string | null;
    comune?: string | null;
    cliente?: string | null;
    indirizzo?: string | null;
    importo?: number;
    totaleIva?: number;
    /** Importo converted into the offer currency, as the sum of the converted
row amounts. The currency itself is exposed by CodiceValuta. */
    importoValuta?: number;
    /** TotaleIva converted into the offer currency, as the sum of the converted
row VAT amounts. */
    totaleIvaValuta?: number;
    luogo?: string;
    partitaIva?: string | null;
    note?: string | null;
    nomeDocumento?: string | null;

    constructor(data?: IInvoiceDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.numero = _data["numero"] !== undefined ? _data["numero"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.contatto = _data["contatto"] !== undefined ? _data["contatto"] : null as any;
            this.ragioneSociale = _data["ragioneSociale"] !== undefined ? _data["ragioneSociale"] : null as any;
            this.indirizzoFatt = _data["indirizzoFatt"] !== undefined ? _data["indirizzoFatt"] : null as any;
            this.numeroCivico = _data["numeroCivico"] !== undefined ? _data["numeroCivico"] : null as any;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : null as any;
            this.comune = _data["comune"] !== undefined ? _data["comune"] : null as any;
            this.cliente = _data["cliente"] !== undefined ? _data["cliente"] : null as any;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : null as any;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : null as any;
            this.totaleIva = _data["totaleIva"] !== undefined ? _data["totaleIva"] : null as any;
            this.importoValuta = _data["importoValuta"] !== undefined ? _data["importoValuta"] : null as any;
            this.totaleIvaValuta = _data["totaleIvaValuta"] !== undefined ? _data["totaleIvaValuta"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.partitaIva = _data["partitaIva"] !== undefined ? _data["partitaIva"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.nomeDocumento = _data["nomeDocumento"] !== undefined ? _data["nomeDocumento"] : null as any;
        }
    }

    static fromJS(data: any): InvoiceDocument {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["numero"] = this.numero !== undefined ? this.numero : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["contatto"] = this.contatto !== undefined ? this.contatto : null as any;
        data["ragioneSociale"] = this.ragioneSociale !== undefined ? this.ragioneSociale : null as any;
        data["indirizzoFatt"] = this.indirizzoFatt !== undefined ? this.indirizzoFatt : null as any;
        data["numeroCivico"] = this.numeroCivico !== undefined ? this.numeroCivico : null as any;
        data["cap"] = this.cap !== undefined ? this.cap : null as any;
        data["comune"] = this.comune !== undefined ? this.comune : null as any;
        data["cliente"] = this.cliente !== undefined ? this.cliente : null as any;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : null as any;
        data["importo"] = this.importo !== undefined ? this.importo : null as any;
        data["totaleIva"] = this.totaleIva !== undefined ? this.totaleIva : null as any;
        data["importoValuta"] = this.importoValuta !== undefined ? this.importoValuta : null as any;
        data["totaleIvaValuta"] = this.totaleIvaValuta !== undefined ? this.totaleIvaValuta : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["partitaIva"] = this.partitaIva !== undefined ? this.partitaIva : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["nomeDocumento"] = this.nomeDocumento !== undefined ? this.nomeDocumento : null as any;
        return data;
    }
}

export interface IInvoiceDocument {
    id?: number;
    tipo?: ETipoDocumento;
    numero?: number;
    data?: string;
    contattoID?: number | null;
    contatto?: string | null;
    ragioneSociale?: string | null;
    indirizzoFatt?: string | null;
    numeroCivico?: string | null;
    cap?: string | null;
    comune?: string | null;
    cliente?: string | null;
    indirizzo?: string | null;
    importo?: number;
    totaleIva?: number;
    /** Importo converted into the offer currency, as the sum of the converted
row amounts. The currency itself is exposed by CodiceValuta. */
    importoValuta?: number;
    /** TotaleIva converted into the offer currency, as the sum of the converted
row VAT amounts. */
    totaleIvaValuta?: number;
    luogo?: string;
    partitaIva?: string | null;
    note?: string | null;
    nomeDocumento?: string | null;
}

export class InvoiceEmitter implements IInvoiceEmitter {
    id?: number;
    ragioneSociale?: string;
    indirizzo?: string;
    cap?: string;
    citta?: string;
    pIva?: string;
    fax?: string;
    tel?: string;
    lang?: ELingua;
    logoUrl?: string;
    valutaNonEuro?: boolean;
    codiceValuta?: string;
    cambioValuta?: number;
    operatore?: EOperatore;

    constructor(data?: IInvoiceEmitter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.ragioneSociale = _data["ragioneSociale"] !== undefined ? _data["ragioneSociale"] : null as any;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : null as any;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : null as any;
            this.citta = _data["citta"] !== undefined ? _data["citta"] : null as any;
            this.pIva = _data["pIva"] !== undefined ? _data["pIva"] : null as any;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : null as any;
            this.tel = _data["tel"] !== undefined ? _data["tel"] : null as any;
            this.lang = _data["lang"] !== undefined ? _data["lang"] : null as any;
            this.logoUrl = _data["logoUrl"] !== undefined ? _data["logoUrl"] : null as any;
            this.valutaNonEuro = _data["valutaNonEuro"] !== undefined ? _data["valutaNonEuro"] : null as any;
            this.codiceValuta = _data["codiceValuta"] !== undefined ? _data["codiceValuta"] : null as any;
            this.cambioValuta = _data["cambioValuta"] !== undefined ? _data["cambioValuta"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
        }
    }

    static fromJS(data: any): InvoiceEmitter {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceEmitter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["ragioneSociale"] = this.ragioneSociale !== undefined ? this.ragioneSociale : null as any;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : null as any;
        data["cap"] = this.cap !== undefined ? this.cap : null as any;
        data["citta"] = this.citta !== undefined ? this.citta : null as any;
        data["pIva"] = this.pIva !== undefined ? this.pIva : null as any;
        data["fax"] = this.fax !== undefined ? this.fax : null as any;
        data["tel"] = this.tel !== undefined ? this.tel : null as any;
        data["lang"] = this.lang !== undefined ? this.lang : null as any;
        data["logoUrl"] = this.logoUrl !== undefined ? this.logoUrl : null as any;
        data["valutaNonEuro"] = this.valutaNonEuro !== undefined ? this.valutaNonEuro : null as any;
        data["codiceValuta"] = this.codiceValuta !== undefined ? this.codiceValuta : null as any;
        data["cambioValuta"] = this.cambioValuta !== undefined ? this.cambioValuta : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        return data;
    }
}

export interface IInvoiceEmitter {
    id?: number;
    ragioneSociale?: string;
    indirizzo?: string;
    cap?: string;
    citta?: string;
    pIva?: string;
    fax?: string;
    tel?: string;
    lang?: ELingua;
    logoUrl?: string;
    valutaNonEuro?: boolean;
    codiceValuta?: string;
    cambioValuta?: number;
    operatore?: EOperatore;
}

export class GetContabilityDocumentDataRequest extends SiteRequest implements IGetContabilityDocumentDataRequest {
    documentoID!: number;
    maxNumOfRowsPerPage?: number;

    constructor(data?: IGetContabilityDocumentDataRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : null as any;
            this.maxNumOfRowsPerPage = _data["maxNumOfRowsPerPage"] !== undefined ? _data["maxNumOfRowsPerPage"] : null as any;
        }
    }

    static override fromJS(data: any): GetContabilityDocumentDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetContabilityDocumentDataRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : null as any;
        data["maxNumOfRowsPerPage"] = this.maxNumOfRowsPerPage !== undefined ? this.maxNumOfRowsPerPage : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetContabilityDocumentDataRequest extends ISiteRequest {
    documentoID: number;
    maxNumOfRowsPerPage?: number;
}

export class GetKanbanDocumentDataResponse extends OkApiResponse implements IGetKanbanDocumentDataResponse {
    kanban?: KanbanRaw | null;

    constructor(data?: IGetKanbanDocumentDataResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.kanban = _data["kanban"] ? KanbanRaw.fromJS(_data["kanban"]) : null as any;
        }
    }

    static override fromJS(data: any): GetKanbanDocumentDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetKanbanDocumentDataResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kanban"] = this.kanban ? this.kanban.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetKanbanDocumentDataResponse extends IOkApiResponse {
    kanban?: KanbanRaw | null;
}

export class KanbanRaw implements IKanbanRaw {
    id?: number;
    confermata?: boolean | null;
    descrizione?: string | null;
    creazione?: string | null;
    dataConferma?: string | null;
    partenza?: string | null;
    priorita?: string | null;
    destinazione?: string | null;
    nomeVisualizzato?: string | null;
    tipoViaggio?: ETipoViaggio;
    clienti?: string[] | null;
    riferimentoCliente?: string | null;
    addetto?: string | null;
    contattoAgenzia?: KanbanContattoRaw | null;
    categoria?: string | null;
    contattoNetwork?: KanbanContattoRaw | null;
    contattoPromoter?: KanbanContattoRaw | null;
    terminePagamentoAgenzia?: string | null;
    datiAgenzia?: KanbanDatiagenzia | null;
    statistiche?: KanbanStatisticsRaw | null;
    elencoNote?: KanbanNota[] | null;

    constructor(data?: IKanbanRaw) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.confermata = _data["confermata"] !== undefined ? _data["confermata"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.creazione = _data["creazione"] !== undefined ? _data["creazione"] : null as any;
            this.dataConferma = _data["dataConferma"] !== undefined ? _data["dataConferma"] : null as any;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : null as any;
            this.priorita = _data["priorita"] !== undefined ? _data["priorita"] : null as any;
            this.destinazione = _data["destinazione"] !== undefined ? _data["destinazione"] : null as any;
            this.nomeVisualizzato = _data["nomeVisualizzato"] !== undefined ? _data["nomeVisualizzato"] : null as any;
            this.tipoViaggio = _data["tipoViaggio"] !== undefined ? _data["tipoViaggio"] : null as any;
            if (Array.isArray(_data["clienti"])) {
                this.clienti = [] as any;
                for (let item of _data["clienti"])
                    this.clienti!.push(item);
            }
            else {
                this.clienti = null as any;
            }
            this.riferimentoCliente = _data["riferimentoCliente"] !== undefined ? _data["riferimentoCliente"] : null as any;
            this.addetto = _data["addetto"] !== undefined ? _data["addetto"] : null as any;
            this.contattoAgenzia = _data["contattoAgenzia"] ? KanbanContattoRaw.fromJS(_data["contattoAgenzia"]) : null as any;
            this.categoria = _data["categoria"] !== undefined ? _data["categoria"] : null as any;
            this.contattoNetwork = _data["contattoNetwork"] ? KanbanContattoRaw.fromJS(_data["contattoNetwork"]) : null as any;
            this.contattoPromoter = _data["contattoPromoter"] ? KanbanContattoRaw.fromJS(_data["contattoPromoter"]) : null as any;
            this.terminePagamentoAgenzia = _data["terminePagamentoAgenzia"] !== undefined ? _data["terminePagamentoAgenzia"] : null as any;
            this.datiAgenzia = _data["datiAgenzia"] ? KanbanDatiagenzia.fromJS(_data["datiAgenzia"]) : null as any;
            this.statistiche = _data["statistiche"] ? KanbanStatisticsRaw.fromJS(_data["statistiche"]) : null as any;
            if (Array.isArray(_data["elencoNote"])) {
                this.elencoNote = [] as any;
                for (let item of _data["elencoNote"])
                    this.elencoNote!.push(KanbanNota.fromJS(item));
            }
            else {
                this.elencoNote = null as any;
            }
        }
    }

    static fromJS(data: any): KanbanRaw {
        data = typeof data === 'object' ? data : {};
        let result = new KanbanRaw();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["confermata"] = this.confermata !== undefined ? this.confermata : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["creazione"] = this.creazione !== undefined ? this.creazione : null as any;
        data["dataConferma"] = this.dataConferma !== undefined ? this.dataConferma : null as any;
        data["partenza"] = this.partenza !== undefined ? this.partenza : null as any;
        data["priorita"] = this.priorita !== undefined ? this.priorita : null as any;
        data["destinazione"] = this.destinazione !== undefined ? this.destinazione : null as any;
        data["nomeVisualizzato"] = this.nomeVisualizzato !== undefined ? this.nomeVisualizzato : null as any;
        data["tipoViaggio"] = this.tipoViaggio !== undefined ? this.tipoViaggio : null as any;
        if (Array.isArray(this.clienti)) {
            data["clienti"] = [];
            for (let item of this.clienti)
                data["clienti"].push(item);
        }
        data["riferimentoCliente"] = this.riferimentoCliente !== undefined ? this.riferimentoCliente : null as any;
        data["addetto"] = this.addetto !== undefined ? this.addetto : null as any;
        data["contattoAgenzia"] = this.contattoAgenzia ? this.contattoAgenzia.toJSON() : null as any;
        data["categoria"] = this.categoria !== undefined ? this.categoria : null as any;
        data["contattoNetwork"] = this.contattoNetwork ? this.contattoNetwork.toJSON() : null as any;
        data["contattoPromoter"] = this.contattoPromoter ? this.contattoPromoter.toJSON() : null as any;
        data["terminePagamentoAgenzia"] = this.terminePagamentoAgenzia !== undefined ? this.terminePagamentoAgenzia : null as any;
        data["datiAgenzia"] = this.datiAgenzia ? this.datiAgenzia.toJSON() : null as any;
        data["statistiche"] = this.statistiche ? this.statistiche.toJSON() : null as any;
        if (Array.isArray(this.elencoNote)) {
            data["elencoNote"] = [];
            for (let item of this.elencoNote)
                data["elencoNote"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IKanbanRaw {
    id?: number;
    confermata?: boolean | null;
    descrizione?: string | null;
    creazione?: string | null;
    dataConferma?: string | null;
    partenza?: string | null;
    priorita?: string | null;
    destinazione?: string | null;
    nomeVisualizzato?: string | null;
    tipoViaggio?: ETipoViaggio;
    clienti?: string[] | null;
    riferimentoCliente?: string | null;
    addetto?: string | null;
    contattoAgenzia?: KanbanContattoRaw | null;
    categoria?: string | null;
    contattoNetwork?: KanbanContattoRaw | null;
    contattoPromoter?: KanbanContattoRaw | null;
    terminePagamentoAgenzia?: string | null;
    datiAgenzia?: KanbanDatiagenzia | null;
    statistiche?: KanbanStatisticsRaw | null;
    elencoNote?: KanbanNota[] | null;
}

export class KanbanContattoRaw implements IKanbanContattoRaw {
    nome?: string | null;
    telefono?: string | null;
    fax?: string | null;
    email?: string | null;

    constructor(data?: IKanbanContattoRaw) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : null as any;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
        }
    }

    static fromJS(data: any): KanbanContattoRaw {
        data = typeof data === 'object' ? data : {};
        let result = new KanbanContattoRaw();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["telefono"] = this.telefono !== undefined ? this.telefono : null as any;
        data["fax"] = this.fax !== undefined ? this.fax : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        return data;
    }
}

export interface IKanbanContattoRaw {
    nome?: string | null;
    telefono?: string | null;
    fax?: string | null;
    email?: string | null;
}

export class KanbanDatiagenzia implements IKanbanDatiagenzia {
    telefono?: string | null;
    fax?: string | null;
    email?: string | null;
    categoria?: string | null;
    pagamento?: string | null;
    network?: string | null;
    promoter?: string | null;
    promoterTelefono?: string | null;

    constructor(data?: IKanbanDatiagenzia) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : null as any;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.categoria = _data["categoria"] !== undefined ? _data["categoria"] : null as any;
            this.pagamento = _data["pagamento"] !== undefined ? _data["pagamento"] : null as any;
            this.network = _data["network"] !== undefined ? _data["network"] : null as any;
            this.promoter = _data["promoter"] !== undefined ? _data["promoter"] : null as any;
            this.promoterTelefono = _data["promoterTelefono"] !== undefined ? _data["promoterTelefono"] : null as any;
        }
    }

    static fromJS(data: any): KanbanDatiagenzia {
        data = typeof data === 'object' ? data : {};
        let result = new KanbanDatiagenzia();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["telefono"] = this.telefono !== undefined ? this.telefono : null as any;
        data["fax"] = this.fax !== undefined ? this.fax : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["categoria"] = this.categoria !== undefined ? this.categoria : null as any;
        data["pagamento"] = this.pagamento !== undefined ? this.pagamento : null as any;
        data["network"] = this.network !== undefined ? this.network : null as any;
        data["promoter"] = this.promoter !== undefined ? this.promoter : null as any;
        data["promoterTelefono"] = this.promoterTelefono !== undefined ? this.promoterTelefono : null as any;
        return data;
    }
}

export interface IKanbanDatiagenzia {
    telefono?: string | null;
    fax?: string | null;
    email?: string | null;
    categoria?: string | null;
    pagamento?: string | null;
    network?: string | null;
    promoter?: string | null;
    promoterTelefono?: string | null;
}

export class KanbanStatisticsRaw implements IKanbanStatisticsRaw {
    priorita?: string | null;
    fatturato?: number;
    percentualeConferme?: number | null;
    confermePassate?: number | null;
    preventiviBkgPassati?: number | null;
    preventiviPassati?: number | null;
    confermeFuture?: number | null;
    preventiviBkgFuturi?: number | null;

    constructor(data?: IKanbanStatisticsRaw) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.priorita = _data["priorita"] !== undefined ? _data["priorita"] : null as any;
            this.fatturato = _data["fatturato"] !== undefined ? _data["fatturato"] : null as any;
            this.percentualeConferme = _data["percentualeConferme"] !== undefined ? _data["percentualeConferme"] : null as any;
            this.confermePassate = _data["confermePassate"] !== undefined ? _data["confermePassate"] : null as any;
            this.preventiviBkgPassati = _data["preventiviBkgPassati"] !== undefined ? _data["preventiviBkgPassati"] : null as any;
            this.preventiviPassati = _data["preventiviPassati"] !== undefined ? _data["preventiviPassati"] : null as any;
            this.confermeFuture = _data["confermeFuture"] !== undefined ? _data["confermeFuture"] : null as any;
            this.preventiviBkgFuturi = _data["preventiviBkgFuturi"] !== undefined ? _data["preventiviBkgFuturi"] : null as any;
        }
    }

    static fromJS(data: any): KanbanStatisticsRaw {
        data = typeof data === 'object' ? data : {};
        let result = new KanbanStatisticsRaw();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priorita"] = this.priorita !== undefined ? this.priorita : null as any;
        data["fatturato"] = this.fatturato !== undefined ? this.fatturato : null as any;
        data["percentualeConferme"] = this.percentualeConferme !== undefined ? this.percentualeConferme : null as any;
        data["confermePassate"] = this.confermePassate !== undefined ? this.confermePassate : null as any;
        data["preventiviBkgPassati"] = this.preventiviBkgPassati !== undefined ? this.preventiviBkgPassati : null as any;
        data["preventiviPassati"] = this.preventiviPassati !== undefined ? this.preventiviPassati : null as any;
        data["confermeFuture"] = this.confermeFuture !== undefined ? this.confermeFuture : null as any;
        data["preventiviBkgFuturi"] = this.preventiviBkgFuturi !== undefined ? this.preventiviBkgFuturi : null as any;
        return data;
    }
}

export interface IKanbanStatisticsRaw {
    priorita?: string | null;
    fatturato?: number;
    percentualeConferme?: number | null;
    confermePassate?: number | null;
    preventiviBkgPassati?: number | null;
    preventiviPassati?: number | null;
    confermeFuture?: number | null;
    preventiviBkgFuturi?: number | null;
}

export class KanbanNota implements IKanbanNota {
    data?: string;
    testo?: string | null;
    isAdv?: boolean | null;
    noAcc?: boolean | null;

    constructor(data?: IKanbanNota) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : null as any;
            this.isAdv = _data["isAdv"] !== undefined ? _data["isAdv"] : null as any;
            this.noAcc = _data["noAcc"] !== undefined ? _data["noAcc"] : null as any;
        }
    }

    static fromJS(data: any): KanbanNota {
        data = typeof data === 'object' ? data : {};
        let result = new KanbanNota();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["testo"] = this.testo !== undefined ? this.testo : null as any;
        data["isAdv"] = this.isAdv !== undefined ? this.isAdv : null as any;
        data["noAcc"] = this.noAcc !== undefined ? this.noAcc : null as any;
        return data;
    }
}

export interface IKanbanNota {
    data?: string;
    testo?: string | null;
    isAdv?: boolean | null;
    noAcc?: boolean | null;
}

export class GetKanbanDocumentDataRequest extends SiteRequest implements IGetKanbanDocumentDataRequest {
    userID?: string;
    offertaID?: number;

    constructor(data?: IGetKanbanDocumentDataRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userID = _data["userID"] !== undefined ? _data["userID"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
        }
    }

    static override fromJS(data: any): GetKanbanDocumentDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetKanbanDocumentDataRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID !== undefined ? this.userID : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetKanbanDocumentDataRequest extends ISiteRequest {
    userID?: string;
    offertaID?: number;
}

export class GetTripDocumentDataResponse extends OkApiResponse implements IGetTripDocumentDataResponse {
    tipoDocumento?: ETipoDocumento;
    /** Data e ora della stampa */
    printDate?: string;
    /** Dati del tour operator associato all'offerta */
    tourOperator?: TourOperator;
    /** Intestazione dell'offerta */
    header?: TripHeader;
    /** Dati finanziari dell'offerta */
    economics?: TripEconomics;
    paymentNameHtml?: string;
    totaleCommissionabile?: number;
    totaleCommissioni?: number;
    importoNettoDovutoDaAdv?: number;
    totaleDare?: number | null;
    totaleAvere?: number | null;
    totaleSbilancio?: number | null;
    /** Specchietto delle commissioni agenzia */
    agencyFees?: AgencyFee[];
    /** Dati dell'agenzia */
    agency?: TripAgency;
    /** Prezzi per pax */
    paxPrices?: PaxPrice[];
    /** Elenco tappe e servizi */
    steps?: TripStep[];
    /** Elenco servizi accessori, senza i voli */
    accessories?: TripService[];
    /** Elenco servizi accessori, senza i voli */
    insurances?: TripService[];
    /** Elenco servizi volo, separato dagli accessori */
    flights?: TripService[];
    /** Valori dei cambi */
    currencies?: CurrencyValue[];
    /** Lista delle penali cumulative per data */
    penaltiesByDate?: ImportoData[];
    /** Elenco dei PNR dell'offerta */
    pnrs?: FlightPnr[];
    /** Note a fine documento */
    footerNotes?: TripTextHtml[];
    /** Descrive l'itinerario completo giorno per giorno */
    daybyday?: DayByDay;
    /** Note a piè pagina dei servizi con ters organizzati con la legenda */
    servicesFooterNotes?: { [key: string]: TripTextHtml; };
    /** Sperimentale, il vecchio blocco testi */
    sections?: DocSections | null;
    estremiBancari?: EstremiBancari | null;
    elencoNote?: NoteDocumento[] | null;
    elencoMiniguide?: Miniguida[] | null;
    destinationInformation?: PassolutionAllInfo[] | null;

    constructor(data?: IGetTripDocumentDataResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tipoDocumento = _data["tipoDocumento"] !== undefined ? _data["tipoDocumento"] : null as any;
            this.printDate = _data["printDate"] !== undefined ? _data["printDate"] : null as any;
            this.tourOperator = _data["tourOperator"] ? TourOperator.fromJS(_data["tourOperator"]) : null as any;
            this.header = _data["header"] ? TripHeader.fromJS(_data["header"]) : null as any;
            this.economics = _data["economics"] ? TripEconomics.fromJS(_data["economics"]) : null as any;
            this.paymentNameHtml = _data["paymentNameHtml"] !== undefined ? _data["paymentNameHtml"] : null as any;
            this.totaleCommissionabile = _data["totaleCommissionabile"] !== undefined ? _data["totaleCommissionabile"] : null as any;
            this.totaleCommissioni = _data["totaleCommissioni"] !== undefined ? _data["totaleCommissioni"] : null as any;
            this.importoNettoDovutoDaAdv = _data["importoNettoDovutoDaAdv"] !== undefined ? _data["importoNettoDovutoDaAdv"] : null as any;
            this.totaleDare = _data["totaleDare"] !== undefined ? _data["totaleDare"] : null as any;
            this.totaleAvere = _data["totaleAvere"] !== undefined ? _data["totaleAvere"] : null as any;
            this.totaleSbilancio = _data["totaleSbilancio"] !== undefined ? _data["totaleSbilancio"] : null as any;
            if (Array.isArray(_data["agencyFees"])) {
                this.agencyFees = [] as any;
                for (let item of _data["agencyFees"])
                    this.agencyFees!.push(AgencyFee.fromJS(item));
            }
            else {
                this.agencyFees = null as any;
            }
            this.agency = _data["agency"] ? TripAgency.fromJS(_data["agency"]) : null as any;
            if (Array.isArray(_data["paxPrices"])) {
                this.paxPrices = [] as any;
                for (let item of _data["paxPrices"])
                    this.paxPrices!.push(PaxPrice.fromJS(item));
            }
            else {
                this.paxPrices = null as any;
            }
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(TripStep.fromJS(item));
            }
            else {
                this.steps = null as any;
            }
            if (Array.isArray(_data["accessories"])) {
                this.accessories = [] as any;
                for (let item of _data["accessories"])
                    this.accessories!.push(TripService.fromJS(item));
            }
            else {
                this.accessories = null as any;
            }
            if (Array.isArray(_data["insurances"])) {
                this.insurances = [] as any;
                for (let item of _data["insurances"])
                    this.insurances!.push(TripService.fromJS(item));
            }
            else {
                this.insurances = null as any;
            }
            if (Array.isArray(_data["flights"])) {
                this.flights = [] as any;
                for (let item of _data["flights"])
                    this.flights!.push(TripService.fromJS(item));
            }
            else {
                this.flights = null as any;
            }
            if (Array.isArray(_data["currencies"])) {
                this.currencies = [] as any;
                for (let item of _data["currencies"])
                    this.currencies!.push(CurrencyValue.fromJS(item));
            }
            else {
                this.currencies = null as any;
            }
            if (Array.isArray(_data["penaltiesByDate"])) {
                this.penaltiesByDate = [] as any;
                for (let item of _data["penaltiesByDate"])
                    this.penaltiesByDate!.push(ImportoData.fromJS(item));
            }
            else {
                this.penaltiesByDate = null as any;
            }
            if (Array.isArray(_data["pnrs"])) {
                this.pnrs = [] as any;
                for (let item of _data["pnrs"])
                    this.pnrs!.push(FlightPnr.fromJS(item));
            }
            else {
                this.pnrs = null as any;
            }
            if (Array.isArray(_data["footerNotes"])) {
                this.footerNotes = [] as any;
                for (let item of _data["footerNotes"])
                    this.footerNotes!.push(TripTextHtml.fromJS(item));
            }
            else {
                this.footerNotes = null as any;
            }
            this.daybyday = _data["daybyday"] ? DayByDay.fromJS(_data["daybyday"]) : null as any;
            if (_data["servicesFooterNotes"]) {
                this.servicesFooterNotes = {} as any;
                for (let key in _data["servicesFooterNotes"]) {
                    if (_data["servicesFooterNotes"].hasOwnProperty(key))
                        (this.servicesFooterNotes as any)![key] = _data["servicesFooterNotes"][key] ? TripTextHtml.fromJS(_data["servicesFooterNotes"][key]) : new TripTextHtml();
                }
            }
            else {
                this.servicesFooterNotes = null as any;
            }
            this.sections = _data["sections"] ? DocSections.fromJS(_data["sections"]) : null as any;
            this.estremiBancari = _data["estremiBancari"] ? EstremiBancari.fromJS(_data["estremiBancari"]) : null as any;
            if (Array.isArray(_data["elencoNote"])) {
                this.elencoNote = [] as any;
                for (let item of _data["elencoNote"])
                    this.elencoNote!.push(NoteDocumento.fromJS(item));
            }
            else {
                this.elencoNote = null as any;
            }
            if (Array.isArray(_data["elencoMiniguide"])) {
                this.elencoMiniguide = [] as any;
                for (let item of _data["elencoMiniguide"])
                    this.elencoMiniguide!.push(Miniguida.fromJS(item));
            }
            else {
                this.elencoMiniguide = null as any;
            }
            if (Array.isArray(_data["destinationInformation"])) {
                this.destinationInformation = [] as any;
                for (let item of _data["destinationInformation"])
                    this.destinationInformation!.push(PassolutionAllInfo.fromJS(item));
            }
            else {
                this.destinationInformation = null as any;
            }
        }
    }

    static override fromJS(data: any): GetTripDocumentDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripDocumentDataResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoDocumento"] = this.tipoDocumento !== undefined ? this.tipoDocumento : null as any;
        data["printDate"] = this.printDate !== undefined ? this.printDate : null as any;
        data["tourOperator"] = this.tourOperator ? this.tourOperator.toJSON() : null as any;
        data["header"] = this.header ? this.header.toJSON() : null as any;
        data["economics"] = this.economics ? this.economics.toJSON() : null as any;
        data["paymentNameHtml"] = this.paymentNameHtml !== undefined ? this.paymentNameHtml : null as any;
        data["totaleCommissionabile"] = this.totaleCommissionabile !== undefined ? this.totaleCommissionabile : null as any;
        data["totaleCommissioni"] = this.totaleCommissioni !== undefined ? this.totaleCommissioni : null as any;
        data["importoNettoDovutoDaAdv"] = this.importoNettoDovutoDaAdv !== undefined ? this.importoNettoDovutoDaAdv : null as any;
        data["totaleDare"] = this.totaleDare !== undefined ? this.totaleDare : null as any;
        data["totaleAvere"] = this.totaleAvere !== undefined ? this.totaleAvere : null as any;
        data["totaleSbilancio"] = this.totaleSbilancio !== undefined ? this.totaleSbilancio : null as any;
        if (Array.isArray(this.agencyFees)) {
            data["agencyFees"] = [];
            for (let item of this.agencyFees)
                data["agencyFees"].push(item ? item.toJSON() : null as any);
        }
        data["agency"] = this.agency ? this.agency.toJSON() : null as any;
        if (Array.isArray(this.paxPrices)) {
            data["paxPrices"] = [];
            for (let item of this.paxPrices)
                data["paxPrices"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.accessories)) {
            data["accessories"] = [];
            for (let item of this.accessories)
                data["accessories"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.insurances)) {
            data["insurances"] = [];
            for (let item of this.insurances)
                data["insurances"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.flights)) {
            data["flights"] = [];
            for (let item of this.flights)
                data["flights"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.currencies)) {
            data["currencies"] = [];
            for (let item of this.currencies)
                data["currencies"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.penaltiesByDate)) {
            data["penaltiesByDate"] = [];
            for (let item of this.penaltiesByDate)
                data["penaltiesByDate"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.pnrs)) {
            data["pnrs"] = [];
            for (let item of this.pnrs)
                data["pnrs"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.footerNotes)) {
            data["footerNotes"] = [];
            for (let item of this.footerNotes)
                data["footerNotes"].push(item ? item.toJSON() : null as any);
        }
        data["daybyday"] = this.daybyday ? this.daybyday.toJSON() : null as any;
        if (this.servicesFooterNotes) {
            data["servicesFooterNotes"] = {};
            for (let key in this.servicesFooterNotes) {
                if (this.servicesFooterNotes.hasOwnProperty(key))
                    (data["servicesFooterNotes"] as any)[key] = this.servicesFooterNotes[key] ? this.servicesFooterNotes[key].toJSON() : null as any;
            }
        }
        data["sections"] = this.sections ? this.sections.toJSON() : null as any;
        data["estremiBancari"] = this.estremiBancari ? this.estremiBancari.toJSON() : null as any;
        if (Array.isArray(this.elencoNote)) {
            data["elencoNote"] = [];
            for (let item of this.elencoNote)
                data["elencoNote"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.elencoMiniguide)) {
            data["elencoMiniguide"] = [];
            for (let item of this.elencoMiniguide)
                data["elencoMiniguide"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.destinationInformation)) {
            data["destinationInformation"] = [];
            for (let item of this.destinationInformation)
                data["destinationInformation"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetTripDocumentDataResponse extends IOkApiResponse {
    tipoDocumento?: ETipoDocumento;
    /** Data e ora della stampa */
    printDate?: string;
    /** Dati del tour operator associato all'offerta */
    tourOperator?: TourOperator;
    /** Intestazione dell'offerta */
    header?: TripHeader;
    /** Dati finanziari dell'offerta */
    economics?: TripEconomics;
    paymentNameHtml?: string;
    totaleCommissionabile?: number;
    totaleCommissioni?: number;
    importoNettoDovutoDaAdv?: number;
    totaleDare?: number | null;
    totaleAvere?: number | null;
    totaleSbilancio?: number | null;
    /** Specchietto delle commissioni agenzia */
    agencyFees?: AgencyFee[];
    /** Dati dell'agenzia */
    agency?: TripAgency;
    /** Prezzi per pax */
    paxPrices?: PaxPrice[];
    /** Elenco tappe e servizi */
    steps?: TripStep[];
    /** Elenco servizi accessori, senza i voli */
    accessories?: TripService[];
    /** Elenco servizi accessori, senza i voli */
    insurances?: TripService[];
    /** Elenco servizi volo, separato dagli accessori */
    flights?: TripService[];
    /** Valori dei cambi */
    currencies?: CurrencyValue[];
    /** Lista delle penali cumulative per data */
    penaltiesByDate?: ImportoData[];
    /** Elenco dei PNR dell'offerta */
    pnrs?: FlightPnr[];
    /** Note a fine documento */
    footerNotes?: TripTextHtml[];
    /** Descrive l'itinerario completo giorno per giorno */
    daybyday?: DayByDay;
    /** Note a piè pagina dei servizi con ters organizzati con la legenda */
    servicesFooterNotes?: { [key: string]: TripTextHtml; };
    /** Sperimentale, il vecchio blocco testi */
    sections?: DocSections | null;
    estremiBancari?: EstremiBancari | null;
    elencoNote?: NoteDocumento[] | null;
    elencoMiniguide?: Miniguida[] | null;
    destinationInformation?: PassolutionAllInfo[] | null;
}

/** Dati del tour operator ricavati dal contatto associato */
export class TourOperator implements ITourOperator {
    ragioneSociale?: string;
    indirizzo?: string;
    civico?: string;
    cap?: string;
    luogo?: string;
    telefono?: string;
    fax?: string;
    email?: string;
    partitaIVA?: string;
    codiceSDI?: string;
    websiteUrl?: string;
    logoUrl?: string;

    constructor(data?: ITourOperator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ragioneSociale = _data["ragioneSociale"] !== undefined ? _data["ragioneSociale"] : null as any;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : null as any;
            this.civico = _data["civico"] !== undefined ? _data["civico"] : null as any;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : null as any;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.partitaIVA = _data["partitaIVA"] !== undefined ? _data["partitaIVA"] : null as any;
            this.codiceSDI = _data["codiceSDI"] !== undefined ? _data["codiceSDI"] : null as any;
            this.websiteUrl = _data["websiteUrl"] !== undefined ? _data["websiteUrl"] : null as any;
            this.logoUrl = _data["logoUrl"] !== undefined ? _data["logoUrl"] : null as any;
        }
    }

    static fromJS(data: any): TourOperator {
        data = typeof data === 'object' ? data : {};
        let result = new TourOperator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ragioneSociale"] = this.ragioneSociale !== undefined ? this.ragioneSociale : null as any;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : null as any;
        data["civico"] = this.civico !== undefined ? this.civico : null as any;
        data["cap"] = this.cap !== undefined ? this.cap : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["telefono"] = this.telefono !== undefined ? this.telefono : null as any;
        data["fax"] = this.fax !== undefined ? this.fax : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["partitaIVA"] = this.partitaIVA !== undefined ? this.partitaIVA : null as any;
        data["codiceSDI"] = this.codiceSDI !== undefined ? this.codiceSDI : null as any;
        data["websiteUrl"] = this.websiteUrl !== undefined ? this.websiteUrl : null as any;
        data["logoUrl"] = this.logoUrl !== undefined ? this.logoUrl : null as any;
        return data;
    }
}

/** Dati del tour operator ricavati dal contatto associato */
export interface ITourOperator {
    ragioneSociale?: string;
    indirizzo?: string;
    civico?: string;
    cap?: string;
    luogo?: string;
    telefono?: string;
    fax?: string;
    email?: string;
    partitaIVA?: string;
    codiceSDI?: string;
    websiteUrl?: string;
    logoUrl?: string;
}

/** Riga di commissione agenzia */
export class AgencyFee implements IAgencyFee {
    nettoIva?: boolean;
    percentuale?: number;
    totalePrezzo?: number;
    totaleCommissione?: number;

    constructor(data?: IAgencyFee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nettoIva = _data["nettoIva"] !== undefined ? _data["nettoIva"] : null as any;
            this.percentuale = _data["percentuale"] !== undefined ? _data["percentuale"] : null as any;
            this.totalePrezzo = _data["totalePrezzo"] !== undefined ? _data["totalePrezzo"] : null as any;
            this.totaleCommissione = _data["totaleCommissione"] !== undefined ? _data["totaleCommissione"] : null as any;
        }
    }

    static fromJS(data: any): AgencyFee {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyFee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nettoIva"] = this.nettoIva !== undefined ? this.nettoIva : null as any;
        data["percentuale"] = this.percentuale !== undefined ? this.percentuale : null as any;
        data["totalePrezzo"] = this.totalePrezzo !== undefined ? this.totalePrezzo : null as any;
        data["totaleCommissione"] = this.totaleCommissione !== undefined ? this.totaleCommissione : null as any;
        return data;
    }
}

/** Riga di commissione agenzia */
export interface IAgencyFee {
    nettoIva?: boolean;
    percentuale?: number;
    totalePrezzo?: number;
    totaleCommissione?: number;
}

/** Prezzi per passeggero */
export class PaxPrice implements IPaxPrice {
    titolo?: ETitolo;
    nomeVisualizzato?: string;
    codiceFiscale?: string;
    prezzo?: number;
    dataNascita?: string | null;

    constructor(data?: IPaxPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            this.nomeVisualizzato = _data["nomeVisualizzato"] !== undefined ? _data["nomeVisualizzato"] : null as any;
            this.codiceFiscale = _data["codiceFiscale"] !== undefined ? _data["codiceFiscale"] : null as any;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : null as any;
            this.dataNascita = _data["dataNascita"] !== undefined ? _data["dataNascita"] : null as any;
        }
    }

    static fromJS(data: any): PaxPrice {
        data = typeof data === 'object' ? data : {};
        let result = new PaxPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        data["nomeVisualizzato"] = this.nomeVisualizzato !== undefined ? this.nomeVisualizzato : null as any;
        data["codiceFiscale"] = this.codiceFiscale !== undefined ? this.codiceFiscale : null as any;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : null as any;
        data["dataNascita"] = this.dataNascita !== undefined ? this.dataNascita : null as any;
        return data;
    }
}

/** Prezzi per passeggero */
export interface IPaxPrice {
    titolo?: ETitolo;
    nomeVisualizzato?: string;
    codiceFiscale?: string;
    prezzo?: number;
    dataNascita?: string | null;
}

/** Valore applicato nei cambi delle monete */
export class CurrencyValue implements ICurrencyValue {
    nome?: string;
    valore?: number;

    constructor(data?: ICurrencyValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.valore = _data["valore"] !== undefined ? _data["valore"] : null as any;
        }
    }

    static fromJS(data: any): CurrencyValue {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["valore"] = this.valore !== undefined ? this.valore : null as any;
        return data;
    }
}

/** Valore applicato nei cambi delle monete */
export interface ICurrencyValue {
    nome?: string;
    valore?: number;
}

/** Tupla che abbina una data ad un importo */
export class ImportoData implements IImportoData {
    /** Importo */
    amount?: number;
    /** Data */
    date?: string;

    constructor(data?: IImportoData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.date = _data["date"] !== undefined ? _data["date"] : null as any;
        }
    }

    static fromJS(data: any): ImportoData {
        data = typeof data === 'object' ? data : {};
        let result = new ImportoData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["date"] = this.date !== undefined ? this.date : null as any;
        return data;
    }
}

/** Tupla che abbina una data ad un importo */
export interface IImportoData {
    /** Importo */
    amount?: number;
    /** Data */
    date?: string;
}

/** Dati di un singolo PNR */
export class FlightPnr implements IFlightPnr {
    pnr?: string;
    abbinamento?: string | null;
    segmenti?: FlightSegment2[];
    compagnie?: FlightAirline[];
    noteCompagnie?: TripTextHtml[];

    constructor(data?: IFlightPnr) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pnr = _data["pnr"] !== undefined ? _data["pnr"] : null as any;
            this.abbinamento = _data["abbinamento"] !== undefined ? _data["abbinamento"] : null as any;
            if (Array.isArray(_data["segmenti"])) {
                this.segmenti = [] as any;
                for (let item of _data["segmenti"])
                    this.segmenti!.push(FlightSegment2.fromJS(item));
            }
            else {
                this.segmenti = null as any;
            }
            if (Array.isArray(_data["compagnie"])) {
                this.compagnie = [] as any;
                for (let item of _data["compagnie"])
                    this.compagnie!.push(FlightAirline.fromJS(item));
            }
            else {
                this.compagnie = null as any;
            }
            if (Array.isArray(_data["noteCompagnie"])) {
                this.noteCompagnie = [] as any;
                for (let item of _data["noteCompagnie"])
                    this.noteCompagnie!.push(TripTextHtml.fromJS(item));
            }
            else {
                this.noteCompagnie = null as any;
            }
        }
    }

    static fromJS(data: any): FlightPnr {
        data = typeof data === 'object' ? data : {};
        let result = new FlightPnr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pnr"] = this.pnr !== undefined ? this.pnr : null as any;
        data["abbinamento"] = this.abbinamento !== undefined ? this.abbinamento : null as any;
        if (Array.isArray(this.segmenti)) {
            data["segmenti"] = [];
            for (let item of this.segmenti)
                data["segmenti"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.compagnie)) {
            data["compagnie"] = [];
            for (let item of this.compagnie)
                data["compagnie"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.noteCompagnie)) {
            data["noteCompagnie"] = [];
            for (let item of this.noteCompagnie)
                data["noteCompagnie"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** Dati di un singolo PNR */
export interface IFlightPnr {
    pnr?: string;
    abbinamento?: string | null;
    segmenti?: FlightSegment2[];
    compagnie?: FlightAirline[];
    noteCompagnie?: TripTextHtml[];
}

/** Dati di un singolo segmento volo */
export class FlightSegment2 implements IFlightSegment2 {
    partenza?: string;
    arrivo?: string;
    arrivoGiornoDopo?: boolean;
    codiceCompagnia?: string | null;
    nomeCompagnia?: string | null;
    volo?: number;
    da?: string;
    daCodice?: string | null;
    a?: string;
    aCodice?: string | null;
    status?: string | null;
    codiceOperatedBy?: string | null;
    nomeOperatedBy?: string | null;
    details?: FlightSegmentDetail[];

    constructor(data?: IFlightSegment2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : null as any;
            this.arrivo = _data["arrivo"] !== undefined ? _data["arrivo"] : null as any;
            this.arrivoGiornoDopo = _data["arrivoGiornoDopo"] !== undefined ? _data["arrivoGiornoDopo"] : null as any;
            this.codiceCompagnia = _data["codiceCompagnia"] !== undefined ? _data["codiceCompagnia"] : null as any;
            this.nomeCompagnia = _data["nomeCompagnia"] !== undefined ? _data["nomeCompagnia"] : null as any;
            this.volo = _data["volo"] !== undefined ? _data["volo"] : null as any;
            this.da = _data["da"] !== undefined ? _data["da"] : null as any;
            this.daCodice = _data["daCodice"] !== undefined ? _data["daCodice"] : null as any;
            this.a = _data["a"] !== undefined ? _data["a"] : null as any;
            this.aCodice = _data["aCodice"] !== undefined ? _data["aCodice"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.codiceOperatedBy = _data["codiceOperatedBy"] !== undefined ? _data["codiceOperatedBy"] : null as any;
            this.nomeOperatedBy = _data["nomeOperatedBy"] !== undefined ? _data["nomeOperatedBy"] : null as any;
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(FlightSegmentDetail.fromJS(item));
            }
            else {
                this.details = null as any;
            }
        }
    }

    static fromJS(data: any): FlightSegment2 {
        data = typeof data === 'object' ? data : {};
        let result = new FlightSegment2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partenza"] = this.partenza !== undefined ? this.partenza : null as any;
        data["arrivo"] = this.arrivo !== undefined ? this.arrivo : null as any;
        data["arrivoGiornoDopo"] = this.arrivoGiornoDopo !== undefined ? this.arrivoGiornoDopo : null as any;
        data["codiceCompagnia"] = this.codiceCompagnia !== undefined ? this.codiceCompagnia : null as any;
        data["nomeCompagnia"] = this.nomeCompagnia !== undefined ? this.nomeCompagnia : null as any;
        data["volo"] = this.volo !== undefined ? this.volo : null as any;
        data["da"] = this.da !== undefined ? this.da : null as any;
        data["daCodice"] = this.daCodice !== undefined ? this.daCodice : null as any;
        data["a"] = this.a !== undefined ? this.a : null as any;
        data["aCodice"] = this.aCodice !== undefined ? this.aCodice : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["codiceOperatedBy"] = this.codiceOperatedBy !== undefined ? this.codiceOperatedBy : null as any;
        data["nomeOperatedBy"] = this.nomeOperatedBy !== undefined ? this.nomeOperatedBy : null as any;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** Dati di un singolo segmento volo */
export interface IFlightSegment2 {
    partenza?: string;
    arrivo?: string;
    arrivoGiornoDopo?: boolean;
    codiceCompagnia?: string | null;
    nomeCompagnia?: string | null;
    volo?: number;
    da?: string;
    daCodice?: string | null;
    a?: string;
    aCodice?: string | null;
    status?: string | null;
    codiceOperatedBy?: string | null;
    nomeOperatedBy?: string | null;
    details?: FlightSegmentDetail[];
}

export class FlightSegmentDetail implements IFlightSegmentDetail {
    tipoPaxID?: ETipoPax | null;
    numeroPax?: number | null;
    baggageIncluded?: number | null;

    constructor(data?: IFlightSegmentDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoPaxID = _data["tipoPaxID"] !== undefined ? _data["tipoPaxID"] : null as any;
            this.numeroPax = _data["numeroPax"] !== undefined ? _data["numeroPax"] : null as any;
            this.baggageIncluded = _data["baggageIncluded"] !== undefined ? _data["baggageIncluded"] : null as any;
        }
    }

    static fromJS(data: any): FlightSegmentDetail {
        data = typeof data === 'object' ? data : {};
        let result = new FlightSegmentDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoPaxID"] = this.tipoPaxID !== undefined ? this.tipoPaxID : null as any;
        data["numeroPax"] = this.numeroPax !== undefined ? this.numeroPax : null as any;
        data["baggageIncluded"] = this.baggageIncluded !== undefined ? this.baggageIncluded : null as any;
        return data;
    }
}

export interface IFlightSegmentDetail {
    tipoPaxID?: ETipoPax | null;
    numeroPax?: number | null;
    baggageIncluded?: number | null;
}

/** Descrittore compagia aerea */
export class FlightAirline implements IFlightAirline {
    codice?: string;
    nome?: string;

    constructor(data?: IFlightAirline) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
        }
    }

    static fromJS(data: any): FlightAirline {
        data = typeof data === 'object' ? data : {};
        let result = new FlightAirline();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        return data;
    }
}

/** Descrittore compagia aerea */
export interface IFlightAirline {
    codice?: string;
    nome?: string;
}

/** Elenco dei giorni del Viaggio */
export class DayByDay implements IDayByDay {
    days?: Day[];
    notes?: TextSeed[];

    constructor(data?: IDayByDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(Day.fromJS(item));
            }
            else {
                this.days = null as any;
            }
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(TextSeed.fromJS(item));
            }
            else {
                this.notes = null as any;
            }
        }
    }

    static fromJS(data: any): DayByDay {
        data = typeof data === 'object' ? data : {};
        let result = new DayByDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** Elenco dei giorni del Viaggio */
export interface IDayByDay {
    days?: Day[];
    notes?: TextSeed[];
}

export class Day implements IDay {
    date?: string | null;
    locations?: string;
    steps?: Step[];

    constructor(data?: IDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] !== undefined ? _data["date"] : null as any;
            this.locations = _data["locations"] !== undefined ? _data["locations"] : null as any;
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(Step.fromJS(item));
            }
            else {
                this.steps = null as any;
            }
        }
    }

    static fromJS(data: any): Day {
        data = typeof data === 'object' ? data : {};
        let result = new Day();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date !== undefined ? this.date : null as any;
        data["locations"] = this.locations !== undefined ? this.locations : null as any;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IDay {
    date?: string | null;
    locations?: string;
    steps?: Step[];
}

/** Indica ogni passo della giornata di un viaggio completo di testi, immagini, dettagli servizi, dettagli voli */
export class Step implements IStep {
    idx?: number;
    luogo?: string | null;
    description?: TextSeed | null;
    imgUrl?: string | null;
    dateFrom?: string;
    dateTo?: string;
    servizi?: SvcDetail[] | null;
    voli?: FlightSegment2[] | null;
    images?: ImageSeed[] | null;

    constructor(data?: IStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idx = _data["idx"] !== undefined ? _data["idx"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.description = _data["description"] ? TextSeed.fromJS(_data["description"]) : null as any;
            this.imgUrl = _data["imgUrl"] !== undefined ? _data["imgUrl"] : null as any;
            this.dateFrom = _data["dateFrom"] !== undefined ? _data["dateFrom"] : null as any;
            this.dateTo = _data["dateTo"] !== undefined ? _data["dateTo"] : null as any;
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(SvcDetail.fromJS(item));
            }
            else {
                this.servizi = null as any;
            }
            if (Array.isArray(_data["voli"])) {
                this.voli = [] as any;
                for (let item of _data["voli"])
                    this.voli!.push(FlightSegment2.fromJS(item));
            }
            else {
                this.voli = null as any;
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageSeed.fromJS(item));
            }
            else {
                this.images = null as any;
            }
        }
    }

    static fromJS(data: any): Step {
        data = typeof data === 'object' ? data : {};
        let result = new Step();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idx"] = this.idx !== undefined ? this.idx : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["description"] = this.description ? this.description.toJSON() : null as any;
        data["imgUrl"] = this.imgUrl !== undefined ? this.imgUrl : null as any;
        data["dateFrom"] = this.dateFrom !== undefined ? this.dateFrom : null as any;
        data["dateTo"] = this.dateTo !== undefined ? this.dateTo : null as any;
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.voli)) {
            data["voli"] = [];
            for (let item of this.voli)
                data["voli"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** Indica ogni passo della giornata di un viaggio completo di testi, immagini, dettagli servizi, dettagli voli */
export interface IStep {
    idx?: number;
    luogo?: string | null;
    description?: TextSeed | null;
    imgUrl?: string | null;
    dateFrom?: string;
    dateTo?: string;
    servizi?: SvcDetail[] | null;
    voli?: FlightSegment2[] | null;
    images?: ImageSeed[] | null;
}

export class TextSeed implements ITextSeed {
    title?: string;
    text?: string;

    constructor(data?: ITextSeed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
        }
    }

    static fromJS(data: any): TextSeed {
        data = typeof data === 'object' ? data : {};
        let result = new TextSeed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["text"] = this.text !== undefined ? this.text : null as any;
        return data;
    }
}

export interface ITextSeed {
    title?: string;
    text?: string;
}

export class SvcDetail implements ISvcDetail {
    id?: number;
    name?: string | null;
    imgUrl?: string | null;
    texts?: TextSeed[] | null;
    tipoServizio?: ETipoServizio;

    constructor(data?: ISvcDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.imgUrl = _data["imgUrl"] !== undefined ? _data["imgUrl"] : null as any;
            if (Array.isArray(_data["texts"])) {
                this.texts = [] as any;
                for (let item of _data["texts"])
                    this.texts!.push(TextSeed.fromJS(item));
            }
            else {
                this.texts = null as any;
            }
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
        }
    }

    static fromJS(data: any): SvcDetail {
        data = typeof data === 'object' ? data : {};
        let result = new SvcDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["imgUrl"] = this.imgUrl !== undefined ? this.imgUrl : null as any;
        if (Array.isArray(this.texts)) {
            data["texts"] = [];
            for (let item of this.texts)
                data["texts"].push(item ? item.toJSON() : null as any);
        }
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        return data;
    }
}

export interface ISvcDetail {
    id?: number;
    name?: string | null;
    imgUrl?: string | null;
    texts?: TextSeed[] | null;
    tipoServizio?: ETipoServizio;
}

/** Usata per generare le sezioni del PreventivoClientePlus */
export class DocSections implements IDocSections {
    sectionServizi?: SectionServizi;
    sectionUffici?: SectionUffici;
    sectionInfoHotel?: SectionInfoHotel;
    sectionNote?: SectionNote;
    sectionPDV?: SectionProgrammaDiViaggio;
    sectionAssistenza?: SectionAssistenza;
    sectionAssicurazione?: SectionAssicurazione;
    sectionElencoVoucher?: SectionElencoVoucher;
    sectionMiniguide?: SectionMiniguide;
    sectionTicketsVoli?: SectionTicketsVoli;

    constructor(data?: IDocSections) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sectionServizi = _data["sectionServizi"] ? SectionServizi.fromJS(_data["sectionServizi"]) : null as any;
            this.sectionUffici = _data["sectionUffici"] ? SectionUffici.fromJS(_data["sectionUffici"]) : null as any;
            this.sectionInfoHotel = _data["sectionInfoHotel"] ? SectionInfoHotel.fromJS(_data["sectionInfoHotel"]) : null as any;
            this.sectionNote = _data["sectionNote"] ? SectionNote.fromJS(_data["sectionNote"]) : null as any;
            this.sectionPDV = _data["sectionPDV"] ? SectionProgrammaDiViaggio.fromJS(_data["sectionPDV"]) : null as any;
            this.sectionAssistenza = _data["sectionAssistenza"] ? SectionAssistenza.fromJS(_data["sectionAssistenza"]) : null as any;
            this.sectionAssicurazione = _data["sectionAssicurazione"] ? SectionAssicurazione.fromJS(_data["sectionAssicurazione"]) : null as any;
            this.sectionElencoVoucher = _data["sectionElencoVoucher"] ? SectionElencoVoucher.fromJS(_data["sectionElencoVoucher"]) : null as any;
            this.sectionMiniguide = _data["sectionMiniguide"] ? SectionMiniguide.fromJS(_data["sectionMiniguide"]) : null as any;
            this.sectionTicketsVoli = _data["sectionTicketsVoli"] ? SectionTicketsVoli.fromJS(_data["sectionTicketsVoli"]) : null as any;
        }
    }

    static fromJS(data: any): DocSections {
        data = typeof data === 'object' ? data : {};
        let result = new DocSections();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionServizi"] = this.sectionServizi ? this.sectionServizi.toJSON() : null as any;
        data["sectionUffici"] = this.sectionUffici ? this.sectionUffici.toJSON() : null as any;
        data["sectionInfoHotel"] = this.sectionInfoHotel ? this.sectionInfoHotel.toJSON() : null as any;
        data["sectionNote"] = this.sectionNote ? this.sectionNote.toJSON() : null as any;
        data["sectionPDV"] = this.sectionPDV ? this.sectionPDV.toJSON() : null as any;
        data["sectionAssistenza"] = this.sectionAssistenza ? this.sectionAssistenza.toJSON() : null as any;
        data["sectionAssicurazione"] = this.sectionAssicurazione ? this.sectionAssicurazione.toJSON() : null as any;
        data["sectionElencoVoucher"] = this.sectionElencoVoucher ? this.sectionElencoVoucher.toJSON() : null as any;
        data["sectionMiniguide"] = this.sectionMiniguide ? this.sectionMiniguide.toJSON() : null as any;
        data["sectionTicketsVoli"] = this.sectionTicketsVoli ? this.sectionTicketsVoli.toJSON() : null as any;
        return data;
    }
}

/** Usata per generare le sezioni del PreventivoClientePlus */
export interface IDocSections {
    sectionServizi?: SectionServizi;
    sectionUffici?: SectionUffici;
    sectionInfoHotel?: SectionInfoHotel;
    sectionNote?: SectionNote;
    sectionPDV?: SectionProgrammaDiViaggio;
    sectionAssistenza?: SectionAssistenza;
    sectionAssicurazione?: SectionAssicurazione;
    sectionElencoVoucher?: SectionElencoVoucher;
    sectionMiniguide?: SectionMiniguide;
    sectionTicketsVoli?: SectionTicketsVoli;
}

export class ExportableSection implements IExportableSection {

    constructor(data?: IExportableSection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ExportableSection {
        data = typeof data === 'object' ? data : {};
        let result = new ExportableSection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IExportableSection {
}

export class SectionServizi extends ExportableSection implements ISectionServizi {
    servizi?: RigaServizio[] | null;

    constructor(data?: ISectionServizi) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(RigaServizio.fromJS(item));
            }
            else {
                this.servizi = null as any;
            }
        }
    }

    static override fromJS(data: any): SectionServizi {
        data = typeof data === 'object' ? data : {};
        let result = new SectionServizi();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISectionServizi extends IExportableSection {
    servizi?: RigaServizio[] | null;
}

export class RigaServizio implements IRigaServizio {
    idServizio?: number;
    tipo?: string | null;
    nome?: string | null;
    indirizzo?: string | null;
    telefono?: string | null;
    luogo?: string | null;
    descrizioniRighe?: string[] | null;
    isHotel?: boolean;
    abbinamentiDate?: AbbinamentoData[] | null;
    isFullContent?: boolean;
    fullContentInfo?: string | null;

    constructor(data?: IRigaServizio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idServizio = _data["idServizio"] !== undefined ? _data["idServizio"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : null as any;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            if (Array.isArray(_data["descrizioniRighe"])) {
                this.descrizioniRighe = [] as any;
                for (let item of _data["descrizioniRighe"])
                    this.descrizioniRighe!.push(item);
            }
            else {
                this.descrizioniRighe = null as any;
            }
            this.isHotel = _data["isHotel"] !== undefined ? _data["isHotel"] : null as any;
            if (Array.isArray(_data["abbinamentiDate"])) {
                this.abbinamentiDate = [] as any;
                for (let item of _data["abbinamentiDate"])
                    this.abbinamentiDate!.push(AbbinamentoData.fromJS(item));
            }
            else {
                this.abbinamentiDate = null as any;
            }
            this.isFullContent = _data["isFullContent"] !== undefined ? _data["isFullContent"] : null as any;
            this.fullContentInfo = _data["fullContentInfo"] !== undefined ? _data["fullContentInfo"] : null as any;
        }
    }

    static fromJS(data: any): RigaServizio {
        data = typeof data === 'object' ? data : {};
        let result = new RigaServizio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idServizio"] = this.idServizio !== undefined ? this.idServizio : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : null as any;
        data["telefono"] = this.telefono !== undefined ? this.telefono : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        if (Array.isArray(this.descrizioniRighe)) {
            data["descrizioniRighe"] = [];
            for (let item of this.descrizioniRighe)
                data["descrizioniRighe"].push(item);
        }
        data["isHotel"] = this.isHotel !== undefined ? this.isHotel : null as any;
        if (Array.isArray(this.abbinamentiDate)) {
            data["abbinamentiDate"] = [];
            for (let item of this.abbinamentiDate)
                data["abbinamentiDate"].push(item ? item.toJSON() : null as any);
        }
        data["isFullContent"] = this.isFullContent !== undefined ? this.isFullContent : null as any;
        data["fullContentInfo"] = this.fullContentInfo !== undefined ? this.fullContentInfo : null as any;
        return data;
    }
}

export interface IRigaServizio {
    idServizio?: number;
    tipo?: string | null;
    nome?: string | null;
    indirizzo?: string | null;
    telefono?: string | null;
    luogo?: string | null;
    descrizioniRighe?: string[] | null;
    isHotel?: boolean;
    abbinamentiDate?: AbbinamentoData[] | null;
    isFullContent?: boolean;
    fullContentInfo?: string | null;
}

export class AbbinamentoData implements IAbbinamentoData {
    dal?: string;
    al?: string;
    notti?: number;
    abbinamenti?: AbbinamentoInfo[] | null;
    isTutti?: boolean;
    overrideDalAl?: string | null;
    chiaveAbbinamenti?: string | null;

    constructor(data?: IAbbinamentoData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.al = _data["al"] !== undefined ? _data["al"] : null as any;
            this.notti = _data["notti"] !== undefined ? _data["notti"] : null as any;
            if (Array.isArray(_data["abbinamenti"])) {
                this.abbinamenti = [] as any;
                for (let item of _data["abbinamenti"])
                    this.abbinamenti!.push(AbbinamentoInfo.fromJS(item));
            }
            else {
                this.abbinamenti = null as any;
            }
            this.isTutti = _data["isTutti"] !== undefined ? _data["isTutti"] : null as any;
            this.overrideDalAl = _data["overrideDalAl"] !== undefined ? _data["overrideDalAl"] : null as any;
            this.chiaveAbbinamenti = _data["chiaveAbbinamenti"] !== undefined ? _data["chiaveAbbinamenti"] : null as any;
        }
    }

    static fromJS(data: any): AbbinamentoData {
        data = typeof data === 'object' ? data : {};
        let result = new AbbinamentoData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["al"] = this.al !== undefined ? this.al : null as any;
        data["notti"] = this.notti !== undefined ? this.notti : null as any;
        if (Array.isArray(this.abbinamenti)) {
            data["abbinamenti"] = [];
            for (let item of this.abbinamenti)
                data["abbinamenti"].push(item ? item.toJSON() : null as any);
        }
        data["isTutti"] = this.isTutti !== undefined ? this.isTutti : null as any;
        data["overrideDalAl"] = this.overrideDalAl !== undefined ? this.overrideDalAl : null as any;
        data["chiaveAbbinamenti"] = this.chiaveAbbinamenti !== undefined ? this.chiaveAbbinamenti : null as any;
        return data;
    }
}

export interface IAbbinamentoData {
    dal?: string;
    al?: string;
    notti?: number;
    abbinamenti?: AbbinamentoInfo[] | null;
    isTutti?: boolean;
    overrideDalAl?: string | null;
    chiaveAbbinamenti?: string | null;
}

export class AbbinamentoInfo implements IAbbinamentoInfo {
    id?: number;
    abbinamento?: Abbinamento | null;
    clientiID?: AbbinamentoCliente[] | null;
    clienti?: ClienteInfo[] | null;
    righe?: OffertaDatoInfo[] | null;
    clientiIdHash?: string | null;
    isTutti?: boolean;
    isVolo?: boolean;

    constructor(data?: IAbbinamentoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.abbinamento = _data["abbinamento"] ? Abbinamento.fromJS(_data["abbinamento"]) : null as any;
            if (Array.isArray(_data["clientiID"])) {
                this.clientiID = [] as any;
                for (let item of _data["clientiID"])
                    this.clientiID!.push(AbbinamentoCliente.fromJS(item));
            }
            else {
                this.clientiID = null as any;
            }
            if (Array.isArray(_data["clienti"])) {
                this.clienti = [] as any;
                for (let item of _data["clienti"])
                    this.clienti!.push(ClienteInfo.fromJS(item));
            }
            else {
                this.clienti = null as any;
            }
            if (Array.isArray(_data["righe"])) {
                this.righe = [] as any;
                for (let item of _data["righe"])
                    this.righe!.push(OffertaDatoInfo.fromJS(item));
            }
            else {
                this.righe = null as any;
            }
            this.clientiIdHash = _data["clientiIdHash"] !== undefined ? _data["clientiIdHash"] : null as any;
            this.isTutti = _data["isTutti"] !== undefined ? _data["isTutti"] : null as any;
            this.isVolo = _data["isVolo"] !== undefined ? _data["isVolo"] : null as any;
        }
    }

    static fromJS(data: any): AbbinamentoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AbbinamentoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["abbinamento"] = this.abbinamento ? this.abbinamento.toJSON() : null as any;
        if (Array.isArray(this.clientiID)) {
            data["clientiID"] = [];
            for (let item of this.clientiID)
                data["clientiID"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.clienti)) {
            data["clienti"] = [];
            for (let item of this.clienti)
                data["clienti"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.righe)) {
            data["righe"] = [];
            for (let item of this.righe)
                data["righe"].push(item ? item.toJSON() : null as any);
        }
        data["clientiIdHash"] = this.clientiIdHash !== undefined ? this.clientiIdHash : null as any;
        data["isTutti"] = this.isTutti !== undefined ? this.isTutti : null as any;
        data["isVolo"] = this.isVolo !== undefined ? this.isVolo : null as any;
        return data;
    }
}

export interface IAbbinamentoInfo {
    id?: number;
    abbinamento?: Abbinamento | null;
    clientiID?: AbbinamentoCliente[] | null;
    clienti?: ClienteInfo[] | null;
    righe?: OffertaDatoInfo[] | null;
    clientiIdHash?: string | null;
    isTutti?: boolean;
    isVolo?: boolean;
}

export class AbbinamentoCliente implements IAbbinamentoCliente {
    abbinamentoID?: number;
    clienteID?: number;

    constructor(data?: IAbbinamentoCliente) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.abbinamentoID = _data["abbinamentoID"] !== undefined ? _data["abbinamentoID"] : null as any;
            this.clienteID = _data["clienteID"] !== undefined ? _data["clienteID"] : null as any;
        }
    }

    static fromJS(data: any): AbbinamentoCliente {
        data = typeof data === 'object' ? data : {};
        let result = new AbbinamentoCliente();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["abbinamentoID"] = this.abbinamentoID !== undefined ? this.abbinamentoID : null as any;
        data["clienteID"] = this.clienteID !== undefined ? this.clienteID : null as any;
        return data;
    }
}

export interface IAbbinamentoCliente {
    abbinamentoID?: number;
    clienteID?: number;
}

export class ClienteInfo implements IClienteInfo {
    id?: number;
    cliente?: Cliente | null;
    dati?: ClienteDato | null;
    offerta?: OffertaInfo | null;
    abbinamenti?: AbbinamentoInfo[] | null;
    dataNascitaDefault?: string;
    nomeVisualizzato?: string | null;
    nomeAbbreviato?: string | null;
    datiCompleti?: boolean;
    datiCompletiVolo?: boolean;
    isChild?: boolean;
    dataNascitaNormalizzata?: string;
    prezzo?: number;
    codiceFiscaleOk?: boolean;

    constructor(data?: IClienteInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.cliente = _data["cliente"] ? Cliente.fromJS(_data["cliente"]) : null as any;
            this.dati = _data["dati"] ? ClienteDato.fromJS(_data["dati"]) : null as any;
            this.offerta = _data["offerta"] ? OffertaInfo.fromJS(_data["offerta"]) : null as any;
            if (Array.isArray(_data["abbinamenti"])) {
                this.abbinamenti = [] as any;
                for (let item of _data["abbinamenti"])
                    this.abbinamenti!.push(AbbinamentoInfo.fromJS(item));
            }
            else {
                this.abbinamenti = null as any;
            }
            this.dataNascitaDefault = _data["dataNascitaDefault"] !== undefined ? _data["dataNascitaDefault"] : null as any;
            this.nomeVisualizzato = _data["nomeVisualizzato"] !== undefined ? _data["nomeVisualizzato"] : null as any;
            this.nomeAbbreviato = _data["nomeAbbreviato"] !== undefined ? _data["nomeAbbreviato"] : null as any;
            this.datiCompleti = _data["datiCompleti"] !== undefined ? _data["datiCompleti"] : null as any;
            this.datiCompletiVolo = _data["datiCompletiVolo"] !== undefined ? _data["datiCompletiVolo"] : null as any;
            this.isChild = _data["isChild"] !== undefined ? _data["isChild"] : null as any;
            this.dataNascitaNormalizzata = _data["dataNascitaNormalizzata"] !== undefined ? _data["dataNascitaNormalizzata"] : null as any;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : null as any;
            this.codiceFiscaleOk = _data["codiceFiscaleOk"] !== undefined ? _data["codiceFiscaleOk"] : null as any;
        }
    }

    static fromJS(data: any): ClienteInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ClienteInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["cliente"] = this.cliente ? this.cliente.toJSON() : null as any;
        data["dati"] = this.dati ? this.dati.toJSON() : null as any;
        data["offerta"] = this.offerta ? this.offerta.toJSON() : null as any;
        if (Array.isArray(this.abbinamenti)) {
            data["abbinamenti"] = [];
            for (let item of this.abbinamenti)
                data["abbinamenti"].push(item ? item.toJSON() : null as any);
        }
        data["dataNascitaDefault"] = this.dataNascitaDefault !== undefined ? this.dataNascitaDefault : null as any;
        data["nomeVisualizzato"] = this.nomeVisualizzato !== undefined ? this.nomeVisualizzato : null as any;
        data["nomeAbbreviato"] = this.nomeAbbreviato !== undefined ? this.nomeAbbreviato : null as any;
        data["datiCompleti"] = this.datiCompleti !== undefined ? this.datiCompleti : null as any;
        data["datiCompletiVolo"] = this.datiCompletiVolo !== undefined ? this.datiCompletiVolo : null as any;
        data["isChild"] = this.isChild !== undefined ? this.isChild : null as any;
        data["dataNascitaNormalizzata"] = this.dataNascitaNormalizzata !== undefined ? this.dataNascitaNormalizzata : null as any;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : null as any;
        data["codiceFiscaleOk"] = this.codiceFiscaleOk !== undefined ? this.codiceFiscaleOk : null as any;
        return data;
    }
}

export interface IClienteInfo {
    id?: number;
    cliente?: Cliente | null;
    dati?: ClienteDato | null;
    offerta?: OffertaInfo | null;
    abbinamenti?: AbbinamentoInfo[] | null;
    dataNascitaDefault?: string;
    nomeVisualizzato?: string | null;
    nomeAbbreviato?: string | null;
    datiCompleti?: boolean;
    datiCompletiVolo?: boolean;
    isChild?: boolean;
    dataNascitaNormalizzata?: string;
    prezzo?: number;
    codiceFiscaleOk?: boolean;
}

export class OffertaInfo implements IOffertaInfo {
    id?: number;
    offerta?: Offerta | null;
    offertaAgenzia?: OffertaAgenzia | null;
    stato?: OffertaAgenziaStato | null;
    tipoViaggio?: ETipoViaggio;
    modalitaQuote?: EModalitaQuote;
    operatore?: OperatoreInfo | null;
    contattoAgenzia?: ContattoInfo | null;
    noteOffertaAgenzia?: string[] | null;
    contattoNetwork?: ContattoInfo | null;
    accordoOperatore?: AccordoContattoInfo | null;
    terminePagamentoAgenzia?: TerminePagamentoInfo | null;
    servizioAssociato?: ServizioInfo | null;
    tipologiaAssociata?: ServizioTipologiaInfo | null;
    pricing?: PricingInfo | null;
    pricingRules?: PricingRule[] | null;
    valutaOfferta?: ValutaInfo | null;
    valutaNonEuro?: boolean;
    cambioValutaOfferta?: number;
    quotaVoliNettoTasse?: number;
    commissioneBiglietteriaMassima?: number;
    dirittiAgenziaMassimi?: number;
    percentualeDirittiAgenzia?: number | null;
    tags?: TagOffertaInfo[] | null;
    isNozze?: boolean;
    percentualeAcconto?: number | null;
    percentualeAccontoNozze?: number | null;
    percentualeAccontoAgenzia?: number | null;
    noAnticipoBiglietti?: boolean;
    noAnticipoQuote?: boolean;
    clienti?: ClienteInfo[] | null;
    leader?: ClienteInfo | null;
    utenteCreatore?: UtenteInfo | null;
    utenteAgenzia?: UtenteInfo | null;
    emailAddetto?: string | null;
    utentePreventivo?: UtenteInfo | null;
    utenteConferma?: UtenteInfo | null;
    utenteDocumenti?: UtenteInfo | null;
    utenteTariffa?: UtenteInfo | null;
    utenteBigliettiAerei?: UtenteInfo | null;
    contattoClienteDiretto?: ContattoInfo | null;
    contattoPromoter?: ContattoInfo | null;
    contattoCorriere?: ContattoInfo | null;
    statoUtente?: EStatoOffertaUtente;
    allServiziIds?: number[] | null;
    allContattiIds?: number[] | null;
    allLuoghiIds?: number[] | null;
    itinerarioAccessori?: ItinerarioOffertaInfo | null;
    itinerariByID?: { [key: string]: ItinerarioOffertaInfo; } | null;
    itinerari?: ItinerarioOffertaInfo[] | null;
    itinerarioServizio?: ServizioItinerarioInfo | null;
    itinerariPackage?: ItinerarioOffertaInfo[] | null;
    isPackage?: boolean;
    itinerariVoli?: ItinerarioVoloInfo[] | null;
    documenti?: DocumentoInfo[] | null;
    nomeCorriere?: string | null;
    email?: EmailInfo[] | null;
    abbinamentoTutti?: AbbinamentoInfo | null;
    abbinamenti?: AbbinamentoInfo[] | null;
    dataNascitaDefaultAdulto?: string;
    dataNascitaDefaultBambino?: string;
    righeDict?: { [key: string]: OffertaDatoInfo; } | null;
    righe?: OffertaDatoInfo[] | null;
    note?: OffertaNotaInfo[] | null;
    haVoli?: boolean;
    voli?: VoloInfo[] | null;
    voliTickets?: VoloTicketsInfo[] | null;
    destinazione?: LuogoInfo | null;
    aeroportoPartenza?: Aeroporto | null;
    aeroportoArrivo?: Aeroporto | null;
    voucher?: VoucherInfo[] | null;
    dataMinimaTappa?: string | null;
    dataMassimaTappa?: string | null;
    luoghiOfferta?: LuogoInfo[] | null;
    invoices?: DocumentoContabileTestata[] | null;
    incassi?: OffertaIncasso[] | null;
    saldata?: boolean;
    compensato?: number;
    dataCompensazione?: string | null;
    acconto?: number;
    dataAcconto?: string | null;
    saldo?: number;
    dataSaldo?: string | null;
    totaleLordo?: number;
    totaleNetto?: number;
    totaleCostoNetto?: number;
    totaleCommissioni?: number;
    giorni?: number;
    notti?: number;
    warnings?: WarningOfferta[] | null;
    confermabile?: boolean;
    confermabileAgenzia?: boolean;
    confermata?: boolean;
    annullata?: boolean;
    annullataADV?: boolean;
    annullataTO?: boolean;
    sbloccata?: boolean;
    utenteSblocco?: UtenteInfo | null;
    warningsVoli?: WarningOfferta[] | null;
    voliPrenotabili?: boolean;
    voucherTuristico?: OffertaDatoInfo | null;
    descrizioni?: OffertaTesto[] | null;
    luogoPartenza?: LuogoInfo | null;
    luogoArrivo?: LuogoInfo | null;
    dataRitorno?: string;
    ultimoGiorno?: number;

    constructor(data?: IOffertaInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.offerta = _data["offerta"] ? Offerta.fromJS(_data["offerta"]) : null as any;
            this.offertaAgenzia = _data["offertaAgenzia"] ? OffertaAgenzia.fromJS(_data["offertaAgenzia"]) : null as any;
            this.stato = _data["stato"] ? OffertaAgenziaStato.fromJS(_data["stato"]) : null as any;
            this.tipoViaggio = _data["tipoViaggio"] !== undefined ? _data["tipoViaggio"] : null as any;
            this.modalitaQuote = _data["modalitaQuote"] !== undefined ? _data["modalitaQuote"] : null as any;
            this.operatore = _data["operatore"] ? OperatoreInfo.fromJS(_data["operatore"]) : null as any;
            this.contattoAgenzia = _data["contattoAgenzia"] ? ContattoInfo.fromJS(_data["contattoAgenzia"]) : null as any;
            if (Array.isArray(_data["noteOffertaAgenzia"])) {
                this.noteOffertaAgenzia = [] as any;
                for (let item of _data["noteOffertaAgenzia"])
                    this.noteOffertaAgenzia!.push(item);
            }
            else {
                this.noteOffertaAgenzia = null as any;
            }
            this.contattoNetwork = _data["contattoNetwork"] ? ContattoInfo.fromJS(_data["contattoNetwork"]) : null as any;
            this.accordoOperatore = _data["accordoOperatore"] ? AccordoContattoInfo.fromJS(_data["accordoOperatore"]) : null as any;
            this.terminePagamentoAgenzia = _data["terminePagamentoAgenzia"] ? TerminePagamentoInfo.fromJS(_data["terminePagamentoAgenzia"]) : null as any;
            this.servizioAssociato = _data["servizioAssociato"] ? ServizioInfo.fromJS(_data["servizioAssociato"]) : null as any;
            this.tipologiaAssociata = _data["tipologiaAssociata"] ? ServizioTipologiaInfo.fromJS(_data["tipologiaAssociata"]) : null as any;
            this.pricing = _data["pricing"] ? PricingInfo.fromJS(_data["pricing"]) : null as any;
            if (Array.isArray(_data["pricingRules"])) {
                this.pricingRules = [] as any;
                for (let item of _data["pricingRules"])
                    this.pricingRules!.push(PricingRule.fromJS(item));
            }
            else {
                this.pricingRules = null as any;
            }
            this.valutaOfferta = _data["valutaOfferta"] ? ValutaInfo.fromJS(_data["valutaOfferta"]) : null as any;
            this.valutaNonEuro = _data["valutaNonEuro"] !== undefined ? _data["valutaNonEuro"] : null as any;
            this.cambioValutaOfferta = _data["cambioValutaOfferta"] !== undefined ? _data["cambioValutaOfferta"] : null as any;
            this.quotaVoliNettoTasse = _data["quotaVoliNettoTasse"] !== undefined ? _data["quotaVoliNettoTasse"] : null as any;
            this.commissioneBiglietteriaMassima = _data["commissioneBiglietteriaMassima"] !== undefined ? _data["commissioneBiglietteriaMassima"] : null as any;
            this.dirittiAgenziaMassimi = _data["dirittiAgenziaMassimi"] !== undefined ? _data["dirittiAgenziaMassimi"] : null as any;
            this.percentualeDirittiAgenzia = _data["percentualeDirittiAgenzia"] !== undefined ? _data["percentualeDirittiAgenzia"] : null as any;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagOffertaInfo.fromJS(item));
            }
            else {
                this.tags = null as any;
            }
            this.isNozze = _data["isNozze"] !== undefined ? _data["isNozze"] : null as any;
            this.percentualeAcconto = _data["percentualeAcconto"] !== undefined ? _data["percentualeAcconto"] : null as any;
            this.percentualeAccontoNozze = _data["percentualeAccontoNozze"] !== undefined ? _data["percentualeAccontoNozze"] : null as any;
            this.percentualeAccontoAgenzia = _data["percentualeAccontoAgenzia"] !== undefined ? _data["percentualeAccontoAgenzia"] : null as any;
            this.noAnticipoBiglietti = _data["noAnticipoBiglietti"] !== undefined ? _data["noAnticipoBiglietti"] : null as any;
            this.noAnticipoQuote = _data["noAnticipoQuote"] !== undefined ? _data["noAnticipoQuote"] : null as any;
            if (Array.isArray(_data["clienti"])) {
                this.clienti = [] as any;
                for (let item of _data["clienti"])
                    this.clienti!.push(ClienteInfo.fromJS(item));
            }
            else {
                this.clienti = null as any;
            }
            this.leader = _data["leader"] ? ClienteInfo.fromJS(_data["leader"]) : null as any;
            this.utenteCreatore = _data["utenteCreatore"] ? UtenteInfo.fromJS(_data["utenteCreatore"]) : null as any;
            this.utenteAgenzia = _data["utenteAgenzia"] ? UtenteInfo.fromJS(_data["utenteAgenzia"]) : null as any;
            this.emailAddetto = _data["emailAddetto"] !== undefined ? _data["emailAddetto"] : null as any;
            this.utentePreventivo = _data["utentePreventivo"] ? UtenteInfo.fromJS(_data["utentePreventivo"]) : null as any;
            this.utenteConferma = _data["utenteConferma"] ? UtenteInfo.fromJS(_data["utenteConferma"]) : null as any;
            this.utenteDocumenti = _data["utenteDocumenti"] ? UtenteInfo.fromJS(_data["utenteDocumenti"]) : null as any;
            this.utenteTariffa = _data["utenteTariffa"] ? UtenteInfo.fromJS(_data["utenteTariffa"]) : null as any;
            this.utenteBigliettiAerei = _data["utenteBigliettiAerei"] ? UtenteInfo.fromJS(_data["utenteBigliettiAerei"]) : null as any;
            this.contattoClienteDiretto = _data["contattoClienteDiretto"] ? ContattoInfo.fromJS(_data["contattoClienteDiretto"]) : null as any;
            this.contattoPromoter = _data["contattoPromoter"] ? ContattoInfo.fromJS(_data["contattoPromoter"]) : null as any;
            this.contattoCorriere = _data["contattoCorriere"] ? ContattoInfo.fromJS(_data["contattoCorriere"]) : null as any;
            this.statoUtente = _data["statoUtente"] !== undefined ? _data["statoUtente"] : null as any;
            if (Array.isArray(_data["allServiziIds"])) {
                this.allServiziIds = [] as any;
                for (let item of _data["allServiziIds"])
                    this.allServiziIds!.push(item);
            }
            else {
                this.allServiziIds = null as any;
            }
            if (Array.isArray(_data["allContattiIds"])) {
                this.allContattiIds = [] as any;
                for (let item of _data["allContattiIds"])
                    this.allContattiIds!.push(item);
            }
            else {
                this.allContattiIds = null as any;
            }
            if (Array.isArray(_data["allLuoghiIds"])) {
                this.allLuoghiIds = [] as any;
                for (let item of _data["allLuoghiIds"])
                    this.allLuoghiIds!.push(item);
            }
            else {
                this.allLuoghiIds = null as any;
            }
            this.itinerarioAccessori = _data["itinerarioAccessori"] ? ItinerarioOffertaInfo.fromJS(_data["itinerarioAccessori"]) : null as any;
            if (_data["itinerariByID"]) {
                this.itinerariByID = {} as any;
                for (let key in _data["itinerariByID"]) {
                    if (_data["itinerariByID"].hasOwnProperty(key))
                        (this.itinerariByID as any)![key] = _data["itinerariByID"][key] ? ItinerarioOffertaInfo.fromJS(_data["itinerariByID"][key]) : new ItinerarioOffertaInfo();
                }
            }
            else {
                this.itinerariByID = null as any;
            }
            if (Array.isArray(_data["itinerari"])) {
                this.itinerari = [] as any;
                for (let item of _data["itinerari"])
                    this.itinerari!.push(ItinerarioOffertaInfo.fromJS(item));
            }
            else {
                this.itinerari = null as any;
            }
            this.itinerarioServizio = _data["itinerarioServizio"] ? ServizioItinerarioInfo.fromJS(_data["itinerarioServizio"]) : null as any;
            if (Array.isArray(_data["itinerariPackage"])) {
                this.itinerariPackage = [] as any;
                for (let item of _data["itinerariPackage"])
                    this.itinerariPackage!.push(ItinerarioOffertaInfo.fromJS(item));
            }
            else {
                this.itinerariPackage = null as any;
            }
            this.isPackage = _data["isPackage"] !== undefined ? _data["isPackage"] : null as any;
            if (Array.isArray(_data["itinerariVoli"])) {
                this.itinerariVoli = [] as any;
                for (let item of _data["itinerariVoli"])
                    this.itinerariVoli!.push(ItinerarioVoloInfo.fromJS(item));
            }
            else {
                this.itinerariVoli = null as any;
            }
            if (Array.isArray(_data["documenti"])) {
                this.documenti = [] as any;
                for (let item of _data["documenti"])
                    this.documenti!.push(DocumentoInfo.fromJS(item));
            }
            else {
                this.documenti = null as any;
            }
            this.nomeCorriere = _data["nomeCorriere"] !== undefined ? _data["nomeCorriere"] : null as any;
            if (Array.isArray(_data["email"])) {
                this.email = [] as any;
                for (let item of _data["email"])
                    this.email!.push(EmailInfo.fromJS(item));
            }
            else {
                this.email = null as any;
            }
            this.abbinamentoTutti = _data["abbinamentoTutti"] ? AbbinamentoInfo.fromJS(_data["abbinamentoTutti"]) : null as any;
            if (Array.isArray(_data["abbinamenti"])) {
                this.abbinamenti = [] as any;
                for (let item of _data["abbinamenti"])
                    this.abbinamenti!.push(AbbinamentoInfo.fromJS(item));
            }
            else {
                this.abbinamenti = null as any;
            }
            this.dataNascitaDefaultAdulto = _data["dataNascitaDefaultAdulto"] !== undefined ? _data["dataNascitaDefaultAdulto"] : null as any;
            this.dataNascitaDefaultBambino = _data["dataNascitaDefaultBambino"] !== undefined ? _data["dataNascitaDefaultBambino"] : null as any;
            if (_data["righeDict"]) {
                this.righeDict = {} as any;
                for (let key in _data["righeDict"]) {
                    if (_data["righeDict"].hasOwnProperty(key))
                        (this.righeDict as any)![key] = _data["righeDict"][key] ? OffertaDatoInfo.fromJS(_data["righeDict"][key]) : new OffertaDatoInfo();
                }
            }
            else {
                this.righeDict = null as any;
            }
            if (Array.isArray(_data["righe"])) {
                this.righe = [] as any;
                for (let item of _data["righe"])
                    this.righe!.push(OffertaDatoInfo.fromJS(item));
            }
            else {
                this.righe = null as any;
            }
            if (Array.isArray(_data["note"])) {
                this.note = [] as any;
                for (let item of _data["note"])
                    this.note!.push(OffertaNotaInfo.fromJS(item));
            }
            else {
                this.note = null as any;
            }
            this.haVoli = _data["haVoli"] !== undefined ? _data["haVoli"] : null as any;
            if (Array.isArray(_data["voli"])) {
                this.voli = [] as any;
                for (let item of _data["voli"])
                    this.voli!.push(VoloInfo.fromJS(item));
            }
            else {
                this.voli = null as any;
            }
            if (Array.isArray(_data["voliTickets"])) {
                this.voliTickets = [] as any;
                for (let item of _data["voliTickets"])
                    this.voliTickets!.push(VoloTicketsInfo.fromJS(item));
            }
            else {
                this.voliTickets = null as any;
            }
            this.destinazione = _data["destinazione"] ? LuogoInfo.fromJS(_data["destinazione"]) : null as any;
            this.aeroportoPartenza = _data["aeroportoPartenza"] ? Aeroporto.fromJS(_data["aeroportoPartenza"]) : null as any;
            this.aeroportoArrivo = _data["aeroportoArrivo"] ? Aeroporto.fromJS(_data["aeroportoArrivo"]) : null as any;
            if (Array.isArray(_data["voucher"])) {
                this.voucher = [] as any;
                for (let item of _data["voucher"])
                    this.voucher!.push(VoucherInfo.fromJS(item));
            }
            else {
                this.voucher = null as any;
            }
            this.dataMinimaTappa = _data["dataMinimaTappa"] !== undefined ? _data["dataMinimaTappa"] : null as any;
            this.dataMassimaTappa = _data["dataMassimaTappa"] !== undefined ? _data["dataMassimaTappa"] : null as any;
            if (Array.isArray(_data["luoghiOfferta"])) {
                this.luoghiOfferta = [] as any;
                for (let item of _data["luoghiOfferta"])
                    this.luoghiOfferta!.push(LuogoInfo.fromJS(item));
            }
            else {
                this.luoghiOfferta = null as any;
            }
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(DocumentoContabileTestata.fromJS(item));
            }
            else {
                this.invoices = null as any;
            }
            if (Array.isArray(_data["incassi"])) {
                this.incassi = [] as any;
                for (let item of _data["incassi"])
                    this.incassi!.push(OffertaIncasso.fromJS(item));
            }
            else {
                this.incassi = null as any;
            }
            this.saldata = _data["saldata"] !== undefined ? _data["saldata"] : null as any;
            this.compensato = _data["compensato"] !== undefined ? _data["compensato"] : null as any;
            this.dataCompensazione = _data["dataCompensazione"] !== undefined ? _data["dataCompensazione"] : null as any;
            this.acconto = _data["acconto"] !== undefined ? _data["acconto"] : null as any;
            this.dataAcconto = _data["dataAcconto"] !== undefined ? _data["dataAcconto"] : null as any;
            this.saldo = _data["saldo"] !== undefined ? _data["saldo"] : null as any;
            this.dataSaldo = _data["dataSaldo"] !== undefined ? _data["dataSaldo"] : null as any;
            this.totaleLordo = _data["totaleLordo"] !== undefined ? _data["totaleLordo"] : null as any;
            this.totaleNetto = _data["totaleNetto"] !== undefined ? _data["totaleNetto"] : null as any;
            this.totaleCostoNetto = _data["totaleCostoNetto"] !== undefined ? _data["totaleCostoNetto"] : null as any;
            this.totaleCommissioni = _data["totaleCommissioni"] !== undefined ? _data["totaleCommissioni"] : null as any;
            this.giorni = _data["giorni"] !== undefined ? _data["giorni"] : null as any;
            this.notti = _data["notti"] !== undefined ? _data["notti"] : null as any;
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(WarningOfferta.fromJS(item));
            }
            else {
                this.warnings = null as any;
            }
            this.confermabile = _data["confermabile"] !== undefined ? _data["confermabile"] : null as any;
            this.confermabileAgenzia = _data["confermabileAgenzia"] !== undefined ? _data["confermabileAgenzia"] : null as any;
            this.confermata = _data["confermata"] !== undefined ? _data["confermata"] : null as any;
            this.annullata = _data["annullata"] !== undefined ? _data["annullata"] : null as any;
            this.annullataADV = _data["annullataADV"] !== undefined ? _data["annullataADV"] : null as any;
            this.annullataTO = _data["annullataTO"] !== undefined ? _data["annullataTO"] : null as any;
            this.sbloccata = _data["sbloccata"] !== undefined ? _data["sbloccata"] : null as any;
            this.utenteSblocco = _data["utenteSblocco"] ? UtenteInfo.fromJS(_data["utenteSblocco"]) : null as any;
            if (Array.isArray(_data["warningsVoli"])) {
                this.warningsVoli = [] as any;
                for (let item of _data["warningsVoli"])
                    this.warningsVoli!.push(WarningOfferta.fromJS(item));
            }
            else {
                this.warningsVoli = null as any;
            }
            this.voliPrenotabili = _data["voliPrenotabili"] !== undefined ? _data["voliPrenotabili"] : null as any;
            this.voucherTuristico = _data["voucherTuristico"] ? OffertaDatoInfo.fromJS(_data["voucherTuristico"]) : null as any;
            if (Array.isArray(_data["descrizioni"])) {
                this.descrizioni = [] as any;
                for (let item of _data["descrizioni"])
                    this.descrizioni!.push(OffertaTesto.fromJS(item));
            }
            else {
                this.descrizioni = null as any;
            }
            this.luogoPartenza = _data["luogoPartenza"] ? LuogoInfo.fromJS(_data["luogoPartenza"]) : null as any;
            this.luogoArrivo = _data["luogoArrivo"] ? LuogoInfo.fromJS(_data["luogoArrivo"]) : null as any;
            this.dataRitorno = _data["dataRitorno"] !== undefined ? _data["dataRitorno"] : null as any;
            this.ultimoGiorno = _data["ultimoGiorno"] !== undefined ? _data["ultimoGiorno"] : null as any;
        }
    }

    static fromJS(data: any): OffertaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["offerta"] = this.offerta ? this.offerta.toJSON() : null as any;
        data["offertaAgenzia"] = this.offertaAgenzia ? this.offertaAgenzia.toJSON() : null as any;
        data["stato"] = this.stato ? this.stato.toJSON() : null as any;
        data["tipoViaggio"] = this.tipoViaggio !== undefined ? this.tipoViaggio : null as any;
        data["modalitaQuote"] = this.modalitaQuote !== undefined ? this.modalitaQuote : null as any;
        data["operatore"] = this.operatore ? this.operatore.toJSON() : null as any;
        data["contattoAgenzia"] = this.contattoAgenzia ? this.contattoAgenzia.toJSON() : null as any;
        if (Array.isArray(this.noteOffertaAgenzia)) {
            data["noteOffertaAgenzia"] = [];
            for (let item of this.noteOffertaAgenzia)
                data["noteOffertaAgenzia"].push(item);
        }
        data["contattoNetwork"] = this.contattoNetwork ? this.contattoNetwork.toJSON() : null as any;
        data["accordoOperatore"] = this.accordoOperatore ? this.accordoOperatore.toJSON() : null as any;
        data["terminePagamentoAgenzia"] = this.terminePagamentoAgenzia ? this.terminePagamentoAgenzia.toJSON() : null as any;
        data["servizioAssociato"] = this.servizioAssociato ? this.servizioAssociato.toJSON() : null as any;
        data["tipologiaAssociata"] = this.tipologiaAssociata ? this.tipologiaAssociata.toJSON() : null as any;
        data["pricing"] = this.pricing ? this.pricing.toJSON() : null as any;
        if (Array.isArray(this.pricingRules)) {
            data["pricingRules"] = [];
            for (let item of this.pricingRules)
                data["pricingRules"].push(item ? item.toJSON() : null as any);
        }
        data["valutaOfferta"] = this.valutaOfferta ? this.valutaOfferta.toJSON() : null as any;
        data["valutaNonEuro"] = this.valutaNonEuro !== undefined ? this.valutaNonEuro : null as any;
        data["cambioValutaOfferta"] = this.cambioValutaOfferta !== undefined ? this.cambioValutaOfferta : null as any;
        data["quotaVoliNettoTasse"] = this.quotaVoliNettoTasse !== undefined ? this.quotaVoliNettoTasse : null as any;
        data["commissioneBiglietteriaMassima"] = this.commissioneBiglietteriaMassima !== undefined ? this.commissioneBiglietteriaMassima : null as any;
        data["dirittiAgenziaMassimi"] = this.dirittiAgenziaMassimi !== undefined ? this.dirittiAgenziaMassimi : null as any;
        data["percentualeDirittiAgenzia"] = this.percentualeDirittiAgenzia !== undefined ? this.percentualeDirittiAgenzia : null as any;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : null as any);
        }
        data["isNozze"] = this.isNozze !== undefined ? this.isNozze : null as any;
        data["percentualeAcconto"] = this.percentualeAcconto !== undefined ? this.percentualeAcconto : null as any;
        data["percentualeAccontoNozze"] = this.percentualeAccontoNozze !== undefined ? this.percentualeAccontoNozze : null as any;
        data["percentualeAccontoAgenzia"] = this.percentualeAccontoAgenzia !== undefined ? this.percentualeAccontoAgenzia : null as any;
        data["noAnticipoBiglietti"] = this.noAnticipoBiglietti !== undefined ? this.noAnticipoBiglietti : null as any;
        data["noAnticipoQuote"] = this.noAnticipoQuote !== undefined ? this.noAnticipoQuote : null as any;
        if (Array.isArray(this.clienti)) {
            data["clienti"] = [];
            for (let item of this.clienti)
                data["clienti"].push(item ? item.toJSON() : null as any);
        }
        data["leader"] = this.leader ? this.leader.toJSON() : null as any;
        data["utenteCreatore"] = this.utenteCreatore ? this.utenteCreatore.toJSON() : null as any;
        data["utenteAgenzia"] = this.utenteAgenzia ? this.utenteAgenzia.toJSON() : null as any;
        data["emailAddetto"] = this.emailAddetto !== undefined ? this.emailAddetto : null as any;
        data["utentePreventivo"] = this.utentePreventivo ? this.utentePreventivo.toJSON() : null as any;
        data["utenteConferma"] = this.utenteConferma ? this.utenteConferma.toJSON() : null as any;
        data["utenteDocumenti"] = this.utenteDocumenti ? this.utenteDocumenti.toJSON() : null as any;
        data["utenteTariffa"] = this.utenteTariffa ? this.utenteTariffa.toJSON() : null as any;
        data["utenteBigliettiAerei"] = this.utenteBigliettiAerei ? this.utenteBigliettiAerei.toJSON() : null as any;
        data["contattoClienteDiretto"] = this.contattoClienteDiretto ? this.contattoClienteDiretto.toJSON() : null as any;
        data["contattoPromoter"] = this.contattoPromoter ? this.contattoPromoter.toJSON() : null as any;
        data["contattoCorriere"] = this.contattoCorriere ? this.contattoCorriere.toJSON() : null as any;
        data["statoUtente"] = this.statoUtente !== undefined ? this.statoUtente : null as any;
        if (Array.isArray(this.allServiziIds)) {
            data["allServiziIds"] = [];
            for (let item of this.allServiziIds)
                data["allServiziIds"].push(item);
        }
        if (Array.isArray(this.allContattiIds)) {
            data["allContattiIds"] = [];
            for (let item of this.allContattiIds)
                data["allContattiIds"].push(item);
        }
        if (Array.isArray(this.allLuoghiIds)) {
            data["allLuoghiIds"] = [];
            for (let item of this.allLuoghiIds)
                data["allLuoghiIds"].push(item);
        }
        data["itinerarioAccessori"] = this.itinerarioAccessori ? this.itinerarioAccessori.toJSON() : null as any;
        if (this.itinerariByID) {
            data["itinerariByID"] = {};
            for (let key in this.itinerariByID) {
                if (this.itinerariByID.hasOwnProperty(key))
                    (data["itinerariByID"] as any)[key] = this.itinerariByID[key] ? this.itinerariByID[key].toJSON() : null as any;
            }
        }
        if (Array.isArray(this.itinerari)) {
            data["itinerari"] = [];
            for (let item of this.itinerari)
                data["itinerari"].push(item ? item.toJSON() : null as any);
        }
        data["itinerarioServizio"] = this.itinerarioServizio ? this.itinerarioServizio.toJSON() : null as any;
        if (Array.isArray(this.itinerariPackage)) {
            data["itinerariPackage"] = [];
            for (let item of this.itinerariPackage)
                data["itinerariPackage"].push(item ? item.toJSON() : null as any);
        }
        data["isPackage"] = this.isPackage !== undefined ? this.isPackage : null as any;
        if (Array.isArray(this.itinerariVoli)) {
            data["itinerariVoli"] = [];
            for (let item of this.itinerariVoli)
                data["itinerariVoli"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.documenti)) {
            data["documenti"] = [];
            for (let item of this.documenti)
                data["documenti"].push(item ? item.toJSON() : null as any);
        }
        data["nomeCorriere"] = this.nomeCorriere !== undefined ? this.nomeCorriere : null as any;
        if (Array.isArray(this.email)) {
            data["email"] = [];
            for (let item of this.email)
                data["email"].push(item ? item.toJSON() : null as any);
        }
        data["abbinamentoTutti"] = this.abbinamentoTutti ? this.abbinamentoTutti.toJSON() : null as any;
        if (Array.isArray(this.abbinamenti)) {
            data["abbinamenti"] = [];
            for (let item of this.abbinamenti)
                data["abbinamenti"].push(item ? item.toJSON() : null as any);
        }
        data["dataNascitaDefaultAdulto"] = this.dataNascitaDefaultAdulto !== undefined ? this.dataNascitaDefaultAdulto : null as any;
        data["dataNascitaDefaultBambino"] = this.dataNascitaDefaultBambino !== undefined ? this.dataNascitaDefaultBambino : null as any;
        if (this.righeDict) {
            data["righeDict"] = {};
            for (let key in this.righeDict) {
                if (this.righeDict.hasOwnProperty(key))
                    (data["righeDict"] as any)[key] = this.righeDict[key] ? this.righeDict[key].toJSON() : null as any;
            }
        }
        if (Array.isArray(this.righe)) {
            data["righe"] = [];
            for (let item of this.righe)
                data["righe"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.note)) {
            data["note"] = [];
            for (let item of this.note)
                data["note"].push(item ? item.toJSON() : null as any);
        }
        data["haVoli"] = this.haVoli !== undefined ? this.haVoli : null as any;
        if (Array.isArray(this.voli)) {
            data["voli"] = [];
            for (let item of this.voli)
                data["voli"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.voliTickets)) {
            data["voliTickets"] = [];
            for (let item of this.voliTickets)
                data["voliTickets"].push(item ? item.toJSON() : null as any);
        }
        data["destinazione"] = this.destinazione ? this.destinazione.toJSON() : null as any;
        data["aeroportoPartenza"] = this.aeroportoPartenza ? this.aeroportoPartenza.toJSON() : null as any;
        data["aeroportoArrivo"] = this.aeroportoArrivo ? this.aeroportoArrivo.toJSON() : null as any;
        if (Array.isArray(this.voucher)) {
            data["voucher"] = [];
            for (let item of this.voucher)
                data["voucher"].push(item ? item.toJSON() : null as any);
        }
        data["dataMinimaTappa"] = this.dataMinimaTappa !== undefined ? this.dataMinimaTappa : null as any;
        data["dataMassimaTappa"] = this.dataMassimaTappa !== undefined ? this.dataMassimaTappa : null as any;
        if (Array.isArray(this.luoghiOfferta)) {
            data["luoghiOfferta"] = [];
            for (let item of this.luoghiOfferta)
                data["luoghiOfferta"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.incassi)) {
            data["incassi"] = [];
            for (let item of this.incassi)
                data["incassi"].push(item ? item.toJSON() : null as any);
        }
        data["saldata"] = this.saldata !== undefined ? this.saldata : null as any;
        data["compensato"] = this.compensato !== undefined ? this.compensato : null as any;
        data["dataCompensazione"] = this.dataCompensazione !== undefined ? this.dataCompensazione : null as any;
        data["acconto"] = this.acconto !== undefined ? this.acconto : null as any;
        data["dataAcconto"] = this.dataAcconto !== undefined ? this.dataAcconto : null as any;
        data["saldo"] = this.saldo !== undefined ? this.saldo : null as any;
        data["dataSaldo"] = this.dataSaldo !== undefined ? this.dataSaldo : null as any;
        data["totaleLordo"] = this.totaleLordo !== undefined ? this.totaleLordo : null as any;
        data["totaleNetto"] = this.totaleNetto !== undefined ? this.totaleNetto : null as any;
        data["totaleCostoNetto"] = this.totaleCostoNetto !== undefined ? this.totaleCostoNetto : null as any;
        data["totaleCommissioni"] = this.totaleCommissioni !== undefined ? this.totaleCommissioni : null as any;
        data["giorni"] = this.giorni !== undefined ? this.giorni : null as any;
        data["notti"] = this.notti !== undefined ? this.notti : null as any;
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item ? item.toJSON() : null as any);
        }
        data["confermabile"] = this.confermabile !== undefined ? this.confermabile : null as any;
        data["confermabileAgenzia"] = this.confermabileAgenzia !== undefined ? this.confermabileAgenzia : null as any;
        data["confermata"] = this.confermata !== undefined ? this.confermata : null as any;
        data["annullata"] = this.annullata !== undefined ? this.annullata : null as any;
        data["annullataADV"] = this.annullataADV !== undefined ? this.annullataADV : null as any;
        data["annullataTO"] = this.annullataTO !== undefined ? this.annullataTO : null as any;
        data["sbloccata"] = this.sbloccata !== undefined ? this.sbloccata : null as any;
        data["utenteSblocco"] = this.utenteSblocco ? this.utenteSblocco.toJSON() : null as any;
        if (Array.isArray(this.warningsVoli)) {
            data["warningsVoli"] = [];
            for (let item of this.warningsVoli)
                data["warningsVoli"].push(item ? item.toJSON() : null as any);
        }
        data["voliPrenotabili"] = this.voliPrenotabili !== undefined ? this.voliPrenotabili : null as any;
        data["voucherTuristico"] = this.voucherTuristico ? this.voucherTuristico.toJSON() : null as any;
        if (Array.isArray(this.descrizioni)) {
            data["descrizioni"] = [];
            for (let item of this.descrizioni)
                data["descrizioni"].push(item ? item.toJSON() : null as any);
        }
        data["luogoPartenza"] = this.luogoPartenza ? this.luogoPartenza.toJSON() : null as any;
        data["luogoArrivo"] = this.luogoArrivo ? this.luogoArrivo.toJSON() : null as any;
        data["dataRitorno"] = this.dataRitorno !== undefined ? this.dataRitorno : null as any;
        data["ultimoGiorno"] = this.ultimoGiorno !== undefined ? this.ultimoGiorno : null as any;
        return data;
    }
}

export interface IOffertaInfo {
    id?: number;
    offerta?: Offerta | null;
    offertaAgenzia?: OffertaAgenzia | null;
    stato?: OffertaAgenziaStato | null;
    tipoViaggio?: ETipoViaggio;
    modalitaQuote?: EModalitaQuote;
    operatore?: OperatoreInfo | null;
    contattoAgenzia?: ContattoInfo | null;
    noteOffertaAgenzia?: string[] | null;
    contattoNetwork?: ContattoInfo | null;
    accordoOperatore?: AccordoContattoInfo | null;
    terminePagamentoAgenzia?: TerminePagamentoInfo | null;
    servizioAssociato?: ServizioInfo | null;
    tipologiaAssociata?: ServizioTipologiaInfo | null;
    pricing?: PricingInfo | null;
    pricingRules?: PricingRule[] | null;
    valutaOfferta?: ValutaInfo | null;
    valutaNonEuro?: boolean;
    cambioValutaOfferta?: number;
    quotaVoliNettoTasse?: number;
    commissioneBiglietteriaMassima?: number;
    dirittiAgenziaMassimi?: number;
    percentualeDirittiAgenzia?: number | null;
    tags?: TagOffertaInfo[] | null;
    isNozze?: boolean;
    percentualeAcconto?: number | null;
    percentualeAccontoNozze?: number | null;
    percentualeAccontoAgenzia?: number | null;
    noAnticipoBiglietti?: boolean;
    noAnticipoQuote?: boolean;
    clienti?: ClienteInfo[] | null;
    leader?: ClienteInfo | null;
    utenteCreatore?: UtenteInfo | null;
    utenteAgenzia?: UtenteInfo | null;
    emailAddetto?: string | null;
    utentePreventivo?: UtenteInfo | null;
    utenteConferma?: UtenteInfo | null;
    utenteDocumenti?: UtenteInfo | null;
    utenteTariffa?: UtenteInfo | null;
    utenteBigliettiAerei?: UtenteInfo | null;
    contattoClienteDiretto?: ContattoInfo | null;
    contattoPromoter?: ContattoInfo | null;
    contattoCorriere?: ContattoInfo | null;
    statoUtente?: EStatoOffertaUtente;
    allServiziIds?: number[] | null;
    allContattiIds?: number[] | null;
    allLuoghiIds?: number[] | null;
    itinerarioAccessori?: ItinerarioOffertaInfo | null;
    itinerariByID?: { [key: string]: ItinerarioOffertaInfo; } | null;
    itinerari?: ItinerarioOffertaInfo[] | null;
    itinerarioServizio?: ServizioItinerarioInfo | null;
    itinerariPackage?: ItinerarioOffertaInfo[] | null;
    isPackage?: boolean;
    itinerariVoli?: ItinerarioVoloInfo[] | null;
    documenti?: DocumentoInfo[] | null;
    nomeCorriere?: string | null;
    email?: EmailInfo[] | null;
    abbinamentoTutti?: AbbinamentoInfo | null;
    abbinamenti?: AbbinamentoInfo[] | null;
    dataNascitaDefaultAdulto?: string;
    dataNascitaDefaultBambino?: string;
    righeDict?: { [key: string]: OffertaDatoInfo; } | null;
    righe?: OffertaDatoInfo[] | null;
    note?: OffertaNotaInfo[] | null;
    haVoli?: boolean;
    voli?: VoloInfo[] | null;
    voliTickets?: VoloTicketsInfo[] | null;
    destinazione?: LuogoInfo | null;
    aeroportoPartenza?: Aeroporto | null;
    aeroportoArrivo?: Aeroporto | null;
    voucher?: VoucherInfo[] | null;
    dataMinimaTappa?: string | null;
    dataMassimaTappa?: string | null;
    luoghiOfferta?: LuogoInfo[] | null;
    invoices?: DocumentoContabileTestata[] | null;
    incassi?: OffertaIncasso[] | null;
    saldata?: boolean;
    compensato?: number;
    dataCompensazione?: string | null;
    acconto?: number;
    dataAcconto?: string | null;
    saldo?: number;
    dataSaldo?: string | null;
    totaleLordo?: number;
    totaleNetto?: number;
    totaleCostoNetto?: number;
    totaleCommissioni?: number;
    giorni?: number;
    notti?: number;
    warnings?: WarningOfferta[] | null;
    confermabile?: boolean;
    confermabileAgenzia?: boolean;
    confermata?: boolean;
    annullata?: boolean;
    annullataADV?: boolean;
    annullataTO?: boolean;
    sbloccata?: boolean;
    utenteSblocco?: UtenteInfo | null;
    warningsVoli?: WarningOfferta[] | null;
    voliPrenotabili?: boolean;
    voucherTuristico?: OffertaDatoInfo | null;
    descrizioni?: OffertaTesto[] | null;
    luogoPartenza?: LuogoInfo | null;
    luogoArrivo?: LuogoInfo | null;
    dataRitorno?: string;
    ultimoGiorno?: number;
}

export class OperatoreInfo implements IOperatoreInfo {
    _EOperatore?: EOperatore | null;
    id?: number;
    operatore?: OperatoreView;
    eOperatore?: EOperatore;
    searchTerms?: string;
    amadeusParams?: CrypticMarket | null;
    defaultWebsiteID?: number | null;
    websites?: WebsiteInfo[];
    contatto?: ContattoInfo;
    valuta?: ValutaInfo;

    constructor(data?: IOperatoreInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._EOperatore = _data["_EOperatore"] !== undefined ? _data["_EOperatore"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.operatore = _data["operatore"] ? OperatoreView.fromJS(_data["operatore"]) : null as any;
            this.eOperatore = _data["eOperatore"] !== undefined ? _data["eOperatore"] : null as any;
            this.searchTerms = _data["searchTerms"] !== undefined ? _data["searchTerms"] : null as any;
            this.amadeusParams = _data["amadeusParams"] ? CrypticMarket.fromJS(_data["amadeusParams"]) : null as any;
            this.defaultWebsiteID = _data["defaultWebsiteID"] !== undefined ? _data["defaultWebsiteID"] : null as any;
            if (Array.isArray(_data["websites"])) {
                this.websites = [] as any;
                for (let item of _data["websites"])
                    this.websites!.push(WebsiteInfo.fromJS(item));
            }
            else {
                this.websites = null as any;
            }
            this.contatto = _data["contatto"] ? ContattoInfo.fromJS(_data["contatto"]) : null as any;
            this.valuta = _data["valuta"] ? ValutaInfo.fromJS(_data["valuta"]) : null as any;
        }
    }

    static fromJS(data: any): OperatoreInfo {
        data = typeof data === 'object' ? data : {};
        let result = new OperatoreInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_EOperatore"] = this._EOperatore !== undefined ? this._EOperatore : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["operatore"] = this.operatore ? this.operatore.toJSON() : null as any;
        data["eOperatore"] = this.eOperatore !== undefined ? this.eOperatore : null as any;
        data["searchTerms"] = this.searchTerms !== undefined ? this.searchTerms : null as any;
        data["amadeusParams"] = this.amadeusParams ? this.amadeusParams.toJSON() : null as any;
        data["defaultWebsiteID"] = this.defaultWebsiteID !== undefined ? this.defaultWebsiteID : null as any;
        if (Array.isArray(this.websites)) {
            data["websites"] = [];
            for (let item of this.websites)
                data["websites"].push(item ? item.toJSON() : null as any);
        }
        data["contatto"] = this.contatto ? this.contatto.toJSON() : null as any;
        data["valuta"] = this.valuta ? this.valuta.toJSON() : null as any;
        return data;
    }
}

export interface IOperatoreInfo {
    _EOperatore?: EOperatore | null;
    id?: number;
    operatore?: OperatoreView;
    eOperatore?: EOperatore;
    searchTerms?: string;
    amadeusParams?: CrypticMarket | null;
    defaultWebsiteID?: number | null;
    websites?: WebsiteInfo[];
    contatto?: ContattoInfo;
    valuta?: ValutaInfo;
}

export abstract class OperatoreView implements IOperatoreView {
    operatoreID?: number;
    contattoID?: number;
    nome?: string;
    nomeVisualizzato?: string | null;
    valutaID?: number;
    visibile?: boolean;
    includeTaxesInFlightCommissions?: boolean;
    advHomeConf?: ActionBoxConfig[] | null;
    cambio?: number;

    constructor(data?: IOperatoreView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operatoreID = _data["operatoreID"] !== undefined ? _data["operatoreID"] : null as any;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nomeVisualizzato = _data["nomeVisualizzato"] !== undefined ? _data["nomeVisualizzato"] : null as any;
            this.valutaID = _data["valutaID"] !== undefined ? _data["valutaID"] : null as any;
            this.visibile = _data["visibile"] !== undefined ? _data["visibile"] : null as any;
            this.includeTaxesInFlightCommissions = _data["includeTaxesInFlightCommissions"] !== undefined ? _data["includeTaxesInFlightCommissions"] : null as any;
            if (Array.isArray(_data["advHomeConf"])) {
                this.advHomeConf = [] as any;
                for (let item of _data["advHomeConf"])
                    this.advHomeConf!.push(ActionBoxConfig.fromJS(item));
            }
            else {
                this.advHomeConf = null as any;
            }
            this.cambio = _data["cambio"] !== undefined ? _data["cambio"] : null as any;
        }
    }

    static fromJS(data: any): OperatoreView {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'OperatoreView' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operatoreID"] = this.operatoreID !== undefined ? this.operatoreID : null as any;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nomeVisualizzato"] = this.nomeVisualizzato !== undefined ? this.nomeVisualizzato : null as any;
        data["valutaID"] = this.valutaID !== undefined ? this.valutaID : null as any;
        data["visibile"] = this.visibile !== undefined ? this.visibile : null as any;
        data["includeTaxesInFlightCommissions"] = this.includeTaxesInFlightCommissions !== undefined ? this.includeTaxesInFlightCommissions : null as any;
        if (Array.isArray(this.advHomeConf)) {
            data["advHomeConf"] = [];
            for (let item of this.advHomeConf)
                data["advHomeConf"].push(item ? item.toJSON() : null as any);
        }
        data["cambio"] = this.cambio !== undefined ? this.cambio : null as any;
        return data;
    }
}

export interface IOperatoreView {
    operatoreID?: number;
    contattoID?: number;
    nome?: string;
    nomeVisualizzato?: string | null;
    valutaID?: number;
    visibile?: boolean;
    includeTaxesInFlightCommissions?: boolean;
    advHomeConf?: ActionBoxConfig[] | null;
    cambio?: number;
}

export class CrypticMarket implements ICrypticMarket {
    name?: string;
    market?: string;
    jupiterEnv?: string;
    offices?: CrypticKeyValues[];
    selectedOffice?: string;
    companyCodes?: CrypticKeyValues[];
    selectedCompanyCode?: string;
    quotePrivateCodes?: CrypticKeyValues[];
    selectedQuotePrivateCode?: string;
    queueCodes?: CrypticKeyValues[];
    selectedQueueCode?: string;
    statuses?: CrypticKeyValues[];
    selectedStatus?: string;

    constructor(data?: ICrypticMarket) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.market = _data["market"] !== undefined ? _data["market"] : null as any;
            this.jupiterEnv = _data["jupiterEnv"] !== undefined ? _data["jupiterEnv"] : null as any;
            if (Array.isArray(_data["offices"])) {
                this.offices = [] as any;
                for (let item of _data["offices"])
                    this.offices!.push(CrypticKeyValues.fromJS(item));
            }
            else {
                this.offices = null as any;
            }
            this.selectedOffice = _data["selectedOffice"] !== undefined ? _data["selectedOffice"] : null as any;
            if (Array.isArray(_data["companyCodes"])) {
                this.companyCodes = [] as any;
                for (let item of _data["companyCodes"])
                    this.companyCodes!.push(CrypticKeyValues.fromJS(item));
            }
            else {
                this.companyCodes = null as any;
            }
            this.selectedCompanyCode = _data["selectedCompanyCode"] !== undefined ? _data["selectedCompanyCode"] : null as any;
            if (Array.isArray(_data["quotePrivateCodes"])) {
                this.quotePrivateCodes = [] as any;
                for (let item of _data["quotePrivateCodes"])
                    this.quotePrivateCodes!.push(CrypticKeyValues.fromJS(item));
            }
            else {
                this.quotePrivateCodes = null as any;
            }
            this.selectedQuotePrivateCode = _data["selectedQuotePrivateCode"] !== undefined ? _data["selectedQuotePrivateCode"] : null as any;
            if (Array.isArray(_data["queueCodes"])) {
                this.queueCodes = [] as any;
                for (let item of _data["queueCodes"])
                    this.queueCodes!.push(CrypticKeyValues.fromJS(item));
            }
            else {
                this.queueCodes = null as any;
            }
            this.selectedQueueCode = _data["selectedQueueCode"] !== undefined ? _data["selectedQueueCode"] : null as any;
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(CrypticKeyValues.fromJS(item));
            }
            else {
                this.statuses = null as any;
            }
            this.selectedStatus = _data["selectedStatus"] !== undefined ? _data["selectedStatus"] : null as any;
        }
    }

    static fromJS(data: any): CrypticMarket {
        data = typeof data === 'object' ? data : {};
        let result = new CrypticMarket();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["market"] = this.market !== undefined ? this.market : null as any;
        data["jupiterEnv"] = this.jupiterEnv !== undefined ? this.jupiterEnv : null as any;
        if (Array.isArray(this.offices)) {
            data["offices"] = [];
            for (let item of this.offices)
                data["offices"].push(item ? item.toJSON() : null as any);
        }
        data["selectedOffice"] = this.selectedOffice !== undefined ? this.selectedOffice : null as any;
        if (Array.isArray(this.companyCodes)) {
            data["companyCodes"] = [];
            for (let item of this.companyCodes)
                data["companyCodes"].push(item ? item.toJSON() : null as any);
        }
        data["selectedCompanyCode"] = this.selectedCompanyCode !== undefined ? this.selectedCompanyCode : null as any;
        if (Array.isArray(this.quotePrivateCodes)) {
            data["quotePrivateCodes"] = [];
            for (let item of this.quotePrivateCodes)
                data["quotePrivateCodes"].push(item ? item.toJSON() : null as any);
        }
        data["selectedQuotePrivateCode"] = this.selectedQuotePrivateCode !== undefined ? this.selectedQuotePrivateCode : null as any;
        if (Array.isArray(this.queueCodes)) {
            data["queueCodes"] = [];
            for (let item of this.queueCodes)
                data["queueCodes"].push(item ? item.toJSON() : null as any);
        }
        data["selectedQueueCode"] = this.selectedQueueCode !== undefined ? this.selectedQueueCode : null as any;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item ? item.toJSON() : null as any);
        }
        data["selectedStatus"] = this.selectedStatus !== undefined ? this.selectedStatus : null as any;
        return data;
    }
}

export interface ICrypticMarket {
    name?: string;
    market?: string;
    jupiterEnv?: string;
    offices?: CrypticKeyValues[];
    selectedOffice?: string;
    companyCodes?: CrypticKeyValues[];
    selectedCompanyCode?: string;
    quotePrivateCodes?: CrypticKeyValues[];
    selectedQuotePrivateCode?: string;
    queueCodes?: CrypticKeyValues[];
    selectedQueueCode?: string;
    statuses?: CrypticKeyValues[];
    selectedStatus?: string;
}

export class CrypticKeyValues implements ICrypticKeyValues {
    name?: string;
    value?: string;

    constructor(data?: ICrypticKeyValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
        }
    }

    static fromJS(data: any): CrypticKeyValues {
        data = typeof data === 'object' ? data : {};
        let result = new CrypticKeyValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        return data;
    }
}

export interface ICrypticKeyValues {
    name?: string;
    value?: string;
}

export class WebsiteInfo implements IWebsiteInfo {
    id?: number;
    website?: Website;
    hosts?: string[];
    linguaDefault?: Lingua;
    availableLanguages?: WebsiteLanguage[];
    operatore?: OperatoreInfo;
    accordo?: AccordoInfo;
    defaultLangCode?: string;

    constructor(data?: IWebsiteInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.website = _data["website"] ? Website.fromJS(_data["website"]) : null as any;
            if (Array.isArray(_data["hosts"])) {
                this.hosts = [] as any;
                for (let item of _data["hosts"])
                    this.hosts!.push(item);
            }
            else {
                this.hosts = null as any;
            }
            this.linguaDefault = _data["linguaDefault"] ? Lingua.fromJS(_data["linguaDefault"]) : null as any;
            if (Array.isArray(_data["availableLanguages"])) {
                this.availableLanguages = [] as any;
                for (let item of _data["availableLanguages"])
                    this.availableLanguages!.push(WebsiteLanguage.fromJS(item));
            }
            else {
                this.availableLanguages = null as any;
            }
            this.operatore = _data["operatore"] ? OperatoreInfo.fromJS(_data["operatore"]) : null as any;
            this.accordo = _data["accordo"] ? AccordoInfo.fromJS(_data["accordo"]) : null as any;
            this.defaultLangCode = _data["defaultLangCode"] !== undefined ? _data["defaultLangCode"] : null as any;
        }
    }

    static fromJS(data: any): WebsiteInfo {
        data = typeof data === 'object' ? data : {};
        let result = new WebsiteInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["website"] = this.website ? this.website.toJSON() : null as any;
        if (Array.isArray(this.hosts)) {
            data["hosts"] = [];
            for (let item of this.hosts)
                data["hosts"].push(item);
        }
        data["linguaDefault"] = this.linguaDefault ? this.linguaDefault.toJSON() : null as any;
        if (Array.isArray(this.availableLanguages)) {
            data["availableLanguages"] = [];
            for (let item of this.availableLanguages)
                data["availableLanguages"].push(item ? item.toJSON() : null as any);
        }
        data["operatore"] = this.operatore ? this.operatore.toJSON() : null as any;
        data["accordo"] = this.accordo ? this.accordo.toJSON() : null as any;
        data["defaultLangCode"] = this.defaultLangCode !== undefined ? this.defaultLangCode : null as any;
        return data;
    }
}

export interface IWebsiteInfo {
    id?: number;
    website?: Website;
    hosts?: string[];
    linguaDefault?: Lingua;
    availableLanguages?: WebsiteLanguage[];
    operatore?: OperatoreInfo;
    accordo?: AccordoInfo;
    defaultLangCode?: string;
}

export class Website implements IWebsite {
    id?: number;
    nome!: string;
    hosts!: string;
    operatore?: EOperatore;
    linguaDefaultID?: ELingua;
    accordoID?: number;
    lingueDisponibili?: string | null;

    constructor(data?: IWebsite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.hosts = _data["hosts"] !== undefined ? _data["hosts"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.linguaDefaultID = _data["linguaDefaultID"] !== undefined ? _data["linguaDefaultID"] : null as any;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.lingueDisponibili = _data["lingueDisponibili"] !== undefined ? _data["lingueDisponibili"] : null as any;
        }
    }

    static fromJS(data: any): Website {
        data = typeof data === 'object' ? data : {};
        let result = new Website();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["hosts"] = this.hosts !== undefined ? this.hosts : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["linguaDefaultID"] = this.linguaDefaultID !== undefined ? this.linguaDefaultID : null as any;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["lingueDisponibili"] = this.lingueDisponibili !== undefined ? this.lingueDisponibili : null as any;
        return data;
    }
}

export interface IWebsite {
    id?: number;
    nome: string;
    hosts: string;
    operatore?: EOperatore;
    linguaDefaultID?: ELingua;
    accordoID?: number;
    lingueDisponibili?: string | null;
}

export class Lingua implements ILingua {
    linguaID?: ELingua;
    nome?: string | null;
    codice!: string;

    constructor(data?: ILingua) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linguaID = _data["linguaID"] !== undefined ? _data["linguaID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
        }
    }

    static fromJS(data: any): Lingua {
        data = typeof data === 'object' ? data : {};
        let result = new Lingua();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linguaID"] = this.linguaID !== undefined ? this.linguaID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        return data;
    }
}

export interface ILingua {
    linguaID?: ELingua;
    nome?: string | null;
    codice: string;
}

export class WebsiteLanguage implements IWebsiteLanguage {
    linguaID?: ELingua;
    nome?: string | null;
    codice?: string | null;

    constructor(data?: IWebsiteLanguage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linguaID = _data["linguaID"] !== undefined ? _data["linguaID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
        }
    }

    static fromJS(data: any): WebsiteLanguage {
        data = typeof data === 'object' ? data : {};
        let result = new WebsiteLanguage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linguaID"] = this.linguaID !== undefined ? this.linguaID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        return data;
    }
}

export interface IWebsiteLanguage {
    linguaID?: ELingua;
    nome?: string | null;
    codice?: string | null;
}

export class AccordoInfo implements IAccordoInfo {
    id?: number;
    accordo?: Accordo;
    searchTerms?: string;
    srtNome?: string;
    contatto?: ContattoInfo | null;
    srtContattoNome?: string | null;
    srtContattoLuogo_it?: string | null;
    srtContattoLuogo_en?: string | null;
    srtContattoLuogo_fr?: string | null;
    srtContattoLuogo_de?: string | null;
    articoliAccordo?: ArticoloInfo[];
    valuta?: ValutaInfo | null;
    host2Host?: boolean;
    tabellaCostiCommissioniDefault?: TabellaCostiCommissioniInfo | null;
    tabelleCostiCommissioni?: TabellaCostiCommissioniInfo[];
    tabelleCostiCommissioniByID?: { [key: string]: TabellaCostiCommissioniInfo; };
    datiAggiuntivi?: AccordoDatoAggiuntivo[];
    contraenti?: AccordoContatto[];
    fornitore?: EFornitore;
    isValid?: boolean;
    isDeleted?: boolean;
    reservationsFroms?: string[];

    constructor(data?: IAccordoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.accordo = _data["accordo"] ? Accordo.fromJS(_data["accordo"]) : null as any;
            this.searchTerms = _data["searchTerms"] !== undefined ? _data["searchTerms"] : null as any;
            this.srtNome = _data["srtNome"] !== undefined ? _data["srtNome"] : null as any;
            this.contatto = _data["contatto"] ? ContattoInfo.fromJS(_data["contatto"]) : null as any;
            this.srtContattoNome = _data["srtContattoNome"] !== undefined ? _data["srtContattoNome"] : null as any;
            this.srtContattoLuogo_it = _data["srtContattoLuogo_it"] !== undefined ? _data["srtContattoLuogo_it"] : null as any;
            this.srtContattoLuogo_en = _data["srtContattoLuogo_en"] !== undefined ? _data["srtContattoLuogo_en"] : null as any;
            this.srtContattoLuogo_fr = _data["srtContattoLuogo_fr"] !== undefined ? _data["srtContattoLuogo_fr"] : null as any;
            this.srtContattoLuogo_de = _data["srtContattoLuogo_de"] !== undefined ? _data["srtContattoLuogo_de"] : null as any;
            if (Array.isArray(_data["articoliAccordo"])) {
                this.articoliAccordo = [] as any;
                for (let item of _data["articoliAccordo"])
                    this.articoliAccordo!.push(ArticoloInfo.fromJS(item));
            }
            else {
                this.articoliAccordo = null as any;
            }
            this.valuta = _data["valuta"] ? ValutaInfo.fromJS(_data["valuta"]) : null as any;
            this.host2Host = _data["host2Host"] !== undefined ? _data["host2Host"] : null as any;
            this.tabellaCostiCommissioniDefault = _data["tabellaCostiCommissioniDefault"] ? TabellaCostiCommissioniInfo.fromJS(_data["tabellaCostiCommissioniDefault"]) : null as any;
            if (Array.isArray(_data["tabelleCostiCommissioni"])) {
                this.tabelleCostiCommissioni = [] as any;
                for (let item of _data["tabelleCostiCommissioni"])
                    this.tabelleCostiCommissioni!.push(TabellaCostiCommissioniInfo.fromJS(item));
            }
            else {
                this.tabelleCostiCommissioni = null as any;
            }
            if (_data["tabelleCostiCommissioniByID"]) {
                this.tabelleCostiCommissioniByID = {} as any;
                for (let key in _data["tabelleCostiCommissioniByID"]) {
                    if (_data["tabelleCostiCommissioniByID"].hasOwnProperty(key))
                        (this.tabelleCostiCommissioniByID as any)![key] = _data["tabelleCostiCommissioniByID"][key] ? TabellaCostiCommissioniInfo.fromJS(_data["tabelleCostiCommissioniByID"][key]) : new TabellaCostiCommissioniInfo();
                }
            }
            else {
                this.tabelleCostiCommissioniByID = null as any;
            }
            if (Array.isArray(_data["datiAggiuntivi"])) {
                this.datiAggiuntivi = [] as any;
                for (let item of _data["datiAggiuntivi"])
                    this.datiAggiuntivi!.push(AccordoDatoAggiuntivo.fromJS(item));
            }
            else {
                this.datiAggiuntivi = null as any;
            }
            if (Array.isArray(_data["contraenti"])) {
                this.contraenti = [] as any;
                for (let item of _data["contraenti"])
                    this.contraenti!.push(AccordoContatto.fromJS(item));
            }
            else {
                this.contraenti = null as any;
            }
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : null as any;
            this.isValid = _data["isValid"] !== undefined ? _data["isValid"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            if (Array.isArray(_data["reservationsFroms"])) {
                this.reservationsFroms = [] as any;
                for (let item of _data["reservationsFroms"])
                    this.reservationsFroms!.push(item);
            }
            else {
                this.reservationsFroms = null as any;
            }
        }
    }

    static fromJS(data: any): AccordoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AccordoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["accordo"] = this.accordo ? this.accordo.toJSON() : null as any;
        data["searchTerms"] = this.searchTerms !== undefined ? this.searchTerms : null as any;
        data["srtNome"] = this.srtNome !== undefined ? this.srtNome : null as any;
        data["contatto"] = this.contatto ? this.contatto.toJSON() : null as any;
        data["srtContattoNome"] = this.srtContattoNome !== undefined ? this.srtContattoNome : null as any;
        data["srtContattoLuogo_it"] = this.srtContattoLuogo_it !== undefined ? this.srtContattoLuogo_it : null as any;
        data["srtContattoLuogo_en"] = this.srtContattoLuogo_en !== undefined ? this.srtContattoLuogo_en : null as any;
        data["srtContattoLuogo_fr"] = this.srtContattoLuogo_fr !== undefined ? this.srtContattoLuogo_fr : null as any;
        data["srtContattoLuogo_de"] = this.srtContattoLuogo_de !== undefined ? this.srtContattoLuogo_de : null as any;
        if (Array.isArray(this.articoliAccordo)) {
            data["articoliAccordo"] = [];
            for (let item of this.articoliAccordo)
                data["articoliAccordo"].push(item ? item.toJSON() : null as any);
        }
        data["valuta"] = this.valuta ? this.valuta.toJSON() : null as any;
        data["host2Host"] = this.host2Host !== undefined ? this.host2Host : null as any;
        data["tabellaCostiCommissioniDefault"] = this.tabellaCostiCommissioniDefault ? this.tabellaCostiCommissioniDefault.toJSON() : null as any;
        if (Array.isArray(this.tabelleCostiCommissioni)) {
            data["tabelleCostiCommissioni"] = [];
            for (let item of this.tabelleCostiCommissioni)
                data["tabelleCostiCommissioni"].push(item ? item.toJSON() : null as any);
        }
        if (this.tabelleCostiCommissioniByID) {
            data["tabelleCostiCommissioniByID"] = {};
            for (let key in this.tabelleCostiCommissioniByID) {
                if (this.tabelleCostiCommissioniByID.hasOwnProperty(key))
                    (data["tabelleCostiCommissioniByID"] as any)[key] = this.tabelleCostiCommissioniByID[key] ? this.tabelleCostiCommissioniByID[key].toJSON() : null as any;
            }
        }
        if (Array.isArray(this.datiAggiuntivi)) {
            data["datiAggiuntivi"] = [];
            for (let item of this.datiAggiuntivi)
                data["datiAggiuntivi"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.contraenti)) {
            data["contraenti"] = [];
            for (let item of this.contraenti)
                data["contraenti"].push(item ? item.toJSON() : null as any);
        }
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : null as any;
        data["isValid"] = this.isValid !== undefined ? this.isValid : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        if (Array.isArray(this.reservationsFroms)) {
            data["reservationsFroms"] = [];
            for (let item of this.reservationsFroms)
                data["reservationsFroms"].push(item);
        }
        return data;
    }
}

export interface IAccordoInfo {
    id?: number;
    accordo?: Accordo;
    searchTerms?: string;
    srtNome?: string;
    contatto?: ContattoInfo | null;
    srtContattoNome?: string | null;
    srtContattoLuogo_it?: string | null;
    srtContattoLuogo_en?: string | null;
    srtContattoLuogo_fr?: string | null;
    srtContattoLuogo_de?: string | null;
    articoliAccordo?: ArticoloInfo[];
    valuta?: ValutaInfo | null;
    host2Host?: boolean;
    tabellaCostiCommissioniDefault?: TabellaCostiCommissioniInfo | null;
    tabelleCostiCommissioni?: TabellaCostiCommissioniInfo[];
    tabelleCostiCommissioniByID?: { [key: string]: TabellaCostiCommissioniInfo; };
    datiAggiuntivi?: AccordoDatoAggiuntivo[];
    contraenti?: AccordoContatto[];
    fornitore?: EFornitore;
    isValid?: boolean;
    isDeleted?: boolean;
    reservationsFroms?: string[];
}

export class ContattoInfo implements IContattoInfo {
    id?: number;
    uniqueID?: string | null;
    contatto?: Contatto | null;
    isFake?: boolean;
    nomeVisualizzato?: string | null;
    nomeAbbreviato?: string | null;
    ragioneSociale?: string | null;
    email?: string | null;
    descrizione?: string | null;
    relazioni?: ContattoRelazione[] | null;
    relazioniParent?: ContattoRelazione[] | null;
    contattoPromoter?: ContattoInfo | null;
    srtPromoter?: string | null;
    contattoNetwork?: ContattoInfo | null;
    srtNetwork?: string | null;
    recapiti?: ContattoRecapito[] | null;
    luogoContatto?: LuogoInfo | null;
    srtNomeLuogo_it?: string | null;
    srtNomeLuogo_fr?: string | null;
    srtNomeLuogo_de?: string | null;
    srtNomeLuogo_en?: string | null;
    srtNomeRegione_it?: string | null;
    srtNomeRegione_fr?: string | null;
    srtNomeRegione_de?: string | null;
    srtNomeRegione_en?: string | null;
    luogoFatturazione?: LuogoInfo | null;
    categoria?: CategoriaContatto | null;
    srtCategoria?: string | null;
    accordi?: AccordoContattoInfo[] | null;
    accordiOperatore?: { [key in keyof typeof EOperatore]?: AccordoContattoInfo; } | null;
    accordoNaar?: AccordoContattoInfo | null;
    srtAccordoNaar?: string | null;
    srtPagamentoAccordoNaar_it?: string | null;
    srtPagamentoAccordoNaar_fr?: string | null;
    srtPagamentoAccordoNaar_de?: string | null;
    srtPagamentoAccordoNaar_en?: string | null;
    srtPagamentoBiglietteriaNaar_it?: string | null;
    srtPagamentoBiglietteriaNaar_fr?: string | null;
    srtPagamentoBiglietteriaNaar_de?: string | null;
    srtPagamentoBiglietteriaNaar_en?: string | null;
    mappa?: Mappa | null;
    loghi?: ContattoLogo[] | null;
    logoADV?: LogoInfo | null;
    datiAggiuntivi?: ContattoDato[] | null;
    statistiche?: ContattoStatistica[] | null;
    indirizzoCompleto?: string | null;
    luogoFattura?: LuogoInfo | null;
    codiceNazioneFattura?: string | null;
    indirizzoFattura?: string | null;
    numeroCivicoFattura?: string | null;
    capFattura?: string | null;
    partitaIva?: string | null;
    searchTerms?: string | null;
    srtNome?: string | null;
    srtCognome?: string | null;
    emailDocumentiContabili?: string | null;
    codiceUnivocoAgenziaFE?: string | null;
    indirizzoPecAgenziaFE?: string | null;
    datiHotelCompleti?: boolean;
    haMappa?: boolean;
    haServizio?: boolean;
    websiteUrl?: string | null;
    logoUrl?: string | null;
    lingua?: ELingua | null;

    constructor(data?: IContattoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.uniqueID = _data["uniqueID"] !== undefined ? _data["uniqueID"] : null as any;
            this.contatto = _data["contatto"] ? Contatto.fromJS(_data["contatto"]) : null as any;
            this.isFake = _data["isFake"] !== undefined ? _data["isFake"] : null as any;
            this.nomeVisualizzato = _data["nomeVisualizzato"] !== undefined ? _data["nomeVisualizzato"] : null as any;
            this.nomeAbbreviato = _data["nomeAbbreviato"] !== undefined ? _data["nomeAbbreviato"] : null as any;
            this.ragioneSociale = _data["ragioneSociale"] !== undefined ? _data["ragioneSociale"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            if (Array.isArray(_data["relazioni"])) {
                this.relazioni = [] as any;
                for (let item of _data["relazioni"])
                    this.relazioni!.push(ContattoRelazione.fromJS(item));
            }
            else {
                this.relazioni = null as any;
            }
            if (Array.isArray(_data["relazioniParent"])) {
                this.relazioniParent = [] as any;
                for (let item of _data["relazioniParent"])
                    this.relazioniParent!.push(ContattoRelazione.fromJS(item));
            }
            else {
                this.relazioniParent = null as any;
            }
            this.contattoPromoter = _data["contattoPromoter"] ? ContattoInfo.fromJS(_data["contattoPromoter"]) : null as any;
            this.srtPromoter = _data["srtPromoter"] !== undefined ? _data["srtPromoter"] : null as any;
            this.contattoNetwork = _data["contattoNetwork"] ? ContattoInfo.fromJS(_data["contattoNetwork"]) : null as any;
            this.srtNetwork = _data["srtNetwork"] !== undefined ? _data["srtNetwork"] : null as any;
            if (Array.isArray(_data["recapiti"])) {
                this.recapiti = [] as any;
                for (let item of _data["recapiti"])
                    this.recapiti!.push(ContattoRecapito.fromJS(item));
            }
            else {
                this.recapiti = null as any;
            }
            this.luogoContatto = _data["luogoContatto"] ? LuogoInfo.fromJS(_data["luogoContatto"]) : null as any;
            this.srtNomeLuogo_it = _data["srtNomeLuogo_it"] !== undefined ? _data["srtNomeLuogo_it"] : null as any;
            this.srtNomeLuogo_fr = _data["srtNomeLuogo_fr"] !== undefined ? _data["srtNomeLuogo_fr"] : null as any;
            this.srtNomeLuogo_de = _data["srtNomeLuogo_de"] !== undefined ? _data["srtNomeLuogo_de"] : null as any;
            this.srtNomeLuogo_en = _data["srtNomeLuogo_en"] !== undefined ? _data["srtNomeLuogo_en"] : null as any;
            this.srtNomeRegione_it = _data["srtNomeRegione_it"] !== undefined ? _data["srtNomeRegione_it"] : null as any;
            this.srtNomeRegione_fr = _data["srtNomeRegione_fr"] !== undefined ? _data["srtNomeRegione_fr"] : null as any;
            this.srtNomeRegione_de = _data["srtNomeRegione_de"] !== undefined ? _data["srtNomeRegione_de"] : null as any;
            this.srtNomeRegione_en = _data["srtNomeRegione_en"] !== undefined ? _data["srtNomeRegione_en"] : null as any;
            this.luogoFatturazione = _data["luogoFatturazione"] ? LuogoInfo.fromJS(_data["luogoFatturazione"]) : null as any;
            this.categoria = _data["categoria"] ? CategoriaContatto.fromJS(_data["categoria"]) : null as any;
            this.srtCategoria = _data["srtCategoria"] !== undefined ? _data["srtCategoria"] : null as any;
            if (Array.isArray(_data["accordi"])) {
                this.accordi = [] as any;
                for (let item of _data["accordi"])
                    this.accordi!.push(AccordoContattoInfo.fromJS(item));
            }
            else {
                this.accordi = null as any;
            }
            if (_data["accordiOperatore"]) {
                this.accordiOperatore = {} as any;
                for (let key in _data["accordiOperatore"]) {
                    if (_data["accordiOperatore"].hasOwnProperty(key))
                        (this.accordiOperatore as any)![key] = _data["accordiOperatore"][key] ? AccordoContattoInfo.fromJS(_data["accordiOperatore"][key]) : new AccordoContattoInfo();
                }
            }
            else {
                this.accordiOperatore = null as any;
            }
            this.accordoNaar = _data["accordoNaar"] ? AccordoContattoInfo.fromJS(_data["accordoNaar"]) : null as any;
            this.srtAccordoNaar = _data["srtAccordoNaar"] !== undefined ? _data["srtAccordoNaar"] : null as any;
            this.srtPagamentoAccordoNaar_it = _data["srtPagamentoAccordoNaar_it"] !== undefined ? _data["srtPagamentoAccordoNaar_it"] : null as any;
            this.srtPagamentoAccordoNaar_fr = _data["srtPagamentoAccordoNaar_fr"] !== undefined ? _data["srtPagamentoAccordoNaar_fr"] : null as any;
            this.srtPagamentoAccordoNaar_de = _data["srtPagamentoAccordoNaar_de"] !== undefined ? _data["srtPagamentoAccordoNaar_de"] : null as any;
            this.srtPagamentoAccordoNaar_en = _data["srtPagamentoAccordoNaar_en"] !== undefined ? _data["srtPagamentoAccordoNaar_en"] : null as any;
            this.srtPagamentoBiglietteriaNaar_it = _data["srtPagamentoBiglietteriaNaar_it"] !== undefined ? _data["srtPagamentoBiglietteriaNaar_it"] : null as any;
            this.srtPagamentoBiglietteriaNaar_fr = _data["srtPagamentoBiglietteriaNaar_fr"] !== undefined ? _data["srtPagamentoBiglietteriaNaar_fr"] : null as any;
            this.srtPagamentoBiglietteriaNaar_de = _data["srtPagamentoBiglietteriaNaar_de"] !== undefined ? _data["srtPagamentoBiglietteriaNaar_de"] : null as any;
            this.srtPagamentoBiglietteriaNaar_en = _data["srtPagamentoBiglietteriaNaar_en"] !== undefined ? _data["srtPagamentoBiglietteriaNaar_en"] : null as any;
            this.mappa = _data["mappa"] ? Mappa.fromJS(_data["mappa"]) : null as any;
            if (Array.isArray(_data["loghi"])) {
                this.loghi = [] as any;
                for (let item of _data["loghi"])
                    this.loghi!.push(ContattoLogo.fromJS(item));
            }
            else {
                this.loghi = null as any;
            }
            this.logoADV = _data["logoADV"] ? LogoInfo.fromJS(_data["logoADV"]) : null as any;
            if (Array.isArray(_data["datiAggiuntivi"])) {
                this.datiAggiuntivi = [] as any;
                for (let item of _data["datiAggiuntivi"])
                    this.datiAggiuntivi!.push(ContattoDato.fromJS(item));
            }
            else {
                this.datiAggiuntivi = null as any;
            }
            if (Array.isArray(_data["statistiche"])) {
                this.statistiche = [] as any;
                for (let item of _data["statistiche"])
                    this.statistiche!.push(ContattoStatistica.fromJS(item));
            }
            else {
                this.statistiche = null as any;
            }
            this.indirizzoCompleto = _data["indirizzoCompleto"] !== undefined ? _data["indirizzoCompleto"] : null as any;
            this.luogoFattura = _data["luogoFattura"] ? LuogoInfo.fromJS(_data["luogoFattura"]) : null as any;
            this.codiceNazioneFattura = _data["codiceNazioneFattura"] !== undefined ? _data["codiceNazioneFattura"] : null as any;
            this.indirizzoFattura = _data["indirizzoFattura"] !== undefined ? _data["indirizzoFattura"] : null as any;
            this.numeroCivicoFattura = _data["numeroCivicoFattura"] !== undefined ? _data["numeroCivicoFattura"] : null as any;
            this.capFattura = _data["capFattura"] !== undefined ? _data["capFattura"] : null as any;
            this.partitaIva = _data["partitaIva"] !== undefined ? _data["partitaIva"] : null as any;
            this.searchTerms = _data["searchTerms"] !== undefined ? _data["searchTerms"] : null as any;
            this.srtNome = _data["srtNome"] !== undefined ? _data["srtNome"] : null as any;
            this.srtCognome = _data["srtCognome"] !== undefined ? _data["srtCognome"] : null as any;
            this.emailDocumentiContabili = _data["emailDocumentiContabili"] !== undefined ? _data["emailDocumentiContabili"] : null as any;
            this.codiceUnivocoAgenziaFE = _data["codiceUnivocoAgenziaFE"] !== undefined ? _data["codiceUnivocoAgenziaFE"] : null as any;
            this.indirizzoPecAgenziaFE = _data["indirizzoPecAgenziaFE"] !== undefined ? _data["indirizzoPecAgenziaFE"] : null as any;
            this.datiHotelCompleti = _data["datiHotelCompleti"] !== undefined ? _data["datiHotelCompleti"] : null as any;
            this.haMappa = _data["haMappa"] !== undefined ? _data["haMappa"] : null as any;
            this.haServizio = _data["haServizio"] !== undefined ? _data["haServizio"] : null as any;
            this.websiteUrl = _data["websiteUrl"] !== undefined ? _data["websiteUrl"] : null as any;
            this.logoUrl = _data["logoUrl"] !== undefined ? _data["logoUrl"] : null as any;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : null as any;
        }
    }

    static fromJS(data: any): ContattoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ContattoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["uniqueID"] = this.uniqueID !== undefined ? this.uniqueID : null as any;
        data["contatto"] = this.contatto ? this.contatto.toJSON() : null as any;
        data["isFake"] = this.isFake !== undefined ? this.isFake : null as any;
        data["nomeVisualizzato"] = this.nomeVisualizzato !== undefined ? this.nomeVisualizzato : null as any;
        data["nomeAbbreviato"] = this.nomeAbbreviato !== undefined ? this.nomeAbbreviato : null as any;
        data["ragioneSociale"] = this.ragioneSociale !== undefined ? this.ragioneSociale : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        if (Array.isArray(this.relazioni)) {
            data["relazioni"] = [];
            for (let item of this.relazioni)
                data["relazioni"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.relazioniParent)) {
            data["relazioniParent"] = [];
            for (let item of this.relazioniParent)
                data["relazioniParent"].push(item ? item.toJSON() : null as any);
        }
        data["contattoPromoter"] = this.contattoPromoter ? this.contattoPromoter.toJSON() : null as any;
        data["srtPromoter"] = this.srtPromoter !== undefined ? this.srtPromoter : null as any;
        data["contattoNetwork"] = this.contattoNetwork ? this.contattoNetwork.toJSON() : null as any;
        data["srtNetwork"] = this.srtNetwork !== undefined ? this.srtNetwork : null as any;
        if (Array.isArray(this.recapiti)) {
            data["recapiti"] = [];
            for (let item of this.recapiti)
                data["recapiti"].push(item ? item.toJSON() : null as any);
        }
        data["luogoContatto"] = this.luogoContatto ? this.luogoContatto.toJSON() : null as any;
        data["srtNomeLuogo_it"] = this.srtNomeLuogo_it !== undefined ? this.srtNomeLuogo_it : null as any;
        data["srtNomeLuogo_fr"] = this.srtNomeLuogo_fr !== undefined ? this.srtNomeLuogo_fr : null as any;
        data["srtNomeLuogo_de"] = this.srtNomeLuogo_de !== undefined ? this.srtNomeLuogo_de : null as any;
        data["srtNomeLuogo_en"] = this.srtNomeLuogo_en !== undefined ? this.srtNomeLuogo_en : null as any;
        data["srtNomeRegione_it"] = this.srtNomeRegione_it !== undefined ? this.srtNomeRegione_it : null as any;
        data["srtNomeRegione_fr"] = this.srtNomeRegione_fr !== undefined ? this.srtNomeRegione_fr : null as any;
        data["srtNomeRegione_de"] = this.srtNomeRegione_de !== undefined ? this.srtNomeRegione_de : null as any;
        data["srtNomeRegione_en"] = this.srtNomeRegione_en !== undefined ? this.srtNomeRegione_en : null as any;
        data["luogoFatturazione"] = this.luogoFatturazione ? this.luogoFatturazione.toJSON() : null as any;
        data["categoria"] = this.categoria ? this.categoria.toJSON() : null as any;
        data["srtCategoria"] = this.srtCategoria !== undefined ? this.srtCategoria : null as any;
        if (Array.isArray(this.accordi)) {
            data["accordi"] = [];
            for (let item of this.accordi)
                data["accordi"].push(item ? item.toJSON() : null as any);
        }
        if (this.accordiOperatore) {
            data["accordiOperatore"] = {};
            for (let key in this.accordiOperatore) {
                if (this.accordiOperatore.hasOwnProperty(key))
                    (data["accordiOperatore"] as any)[key] = this.accordiOperatore[key] ? this.accordiOperatore[key].toJSON() : null as any;
            }
        }
        data["accordoNaar"] = this.accordoNaar ? this.accordoNaar.toJSON() : null as any;
        data["srtAccordoNaar"] = this.srtAccordoNaar !== undefined ? this.srtAccordoNaar : null as any;
        data["srtPagamentoAccordoNaar_it"] = this.srtPagamentoAccordoNaar_it !== undefined ? this.srtPagamentoAccordoNaar_it : null as any;
        data["srtPagamentoAccordoNaar_fr"] = this.srtPagamentoAccordoNaar_fr !== undefined ? this.srtPagamentoAccordoNaar_fr : null as any;
        data["srtPagamentoAccordoNaar_de"] = this.srtPagamentoAccordoNaar_de !== undefined ? this.srtPagamentoAccordoNaar_de : null as any;
        data["srtPagamentoAccordoNaar_en"] = this.srtPagamentoAccordoNaar_en !== undefined ? this.srtPagamentoAccordoNaar_en : null as any;
        data["srtPagamentoBiglietteriaNaar_it"] = this.srtPagamentoBiglietteriaNaar_it !== undefined ? this.srtPagamentoBiglietteriaNaar_it : null as any;
        data["srtPagamentoBiglietteriaNaar_fr"] = this.srtPagamentoBiglietteriaNaar_fr !== undefined ? this.srtPagamentoBiglietteriaNaar_fr : null as any;
        data["srtPagamentoBiglietteriaNaar_de"] = this.srtPagamentoBiglietteriaNaar_de !== undefined ? this.srtPagamentoBiglietteriaNaar_de : null as any;
        data["srtPagamentoBiglietteriaNaar_en"] = this.srtPagamentoBiglietteriaNaar_en !== undefined ? this.srtPagamentoBiglietteriaNaar_en : null as any;
        data["mappa"] = this.mappa ? this.mappa.toJSON() : null as any;
        if (Array.isArray(this.loghi)) {
            data["loghi"] = [];
            for (let item of this.loghi)
                data["loghi"].push(item ? item.toJSON() : null as any);
        }
        data["logoADV"] = this.logoADV ? this.logoADV.toJSON() : null as any;
        if (Array.isArray(this.datiAggiuntivi)) {
            data["datiAggiuntivi"] = [];
            for (let item of this.datiAggiuntivi)
                data["datiAggiuntivi"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.statistiche)) {
            data["statistiche"] = [];
            for (let item of this.statistiche)
                data["statistiche"].push(item ? item.toJSON() : null as any);
        }
        data["indirizzoCompleto"] = this.indirizzoCompleto !== undefined ? this.indirizzoCompleto : null as any;
        data["luogoFattura"] = this.luogoFattura ? this.luogoFattura.toJSON() : null as any;
        data["codiceNazioneFattura"] = this.codiceNazioneFattura !== undefined ? this.codiceNazioneFattura : null as any;
        data["indirizzoFattura"] = this.indirizzoFattura !== undefined ? this.indirizzoFattura : null as any;
        data["numeroCivicoFattura"] = this.numeroCivicoFattura !== undefined ? this.numeroCivicoFattura : null as any;
        data["capFattura"] = this.capFattura !== undefined ? this.capFattura : null as any;
        data["partitaIva"] = this.partitaIva !== undefined ? this.partitaIva : null as any;
        data["searchTerms"] = this.searchTerms !== undefined ? this.searchTerms : null as any;
        data["srtNome"] = this.srtNome !== undefined ? this.srtNome : null as any;
        data["srtCognome"] = this.srtCognome !== undefined ? this.srtCognome : null as any;
        data["emailDocumentiContabili"] = this.emailDocumentiContabili !== undefined ? this.emailDocumentiContabili : null as any;
        data["codiceUnivocoAgenziaFE"] = this.codiceUnivocoAgenziaFE !== undefined ? this.codiceUnivocoAgenziaFE : null as any;
        data["indirizzoPecAgenziaFE"] = this.indirizzoPecAgenziaFE !== undefined ? this.indirizzoPecAgenziaFE : null as any;
        data["datiHotelCompleti"] = this.datiHotelCompleti !== undefined ? this.datiHotelCompleti : null as any;
        data["haMappa"] = this.haMappa !== undefined ? this.haMappa : null as any;
        data["haServizio"] = this.haServizio !== undefined ? this.haServizio : null as any;
        data["websiteUrl"] = this.websiteUrl !== undefined ? this.websiteUrl : null as any;
        data["logoUrl"] = this.logoUrl !== undefined ? this.logoUrl : null as any;
        data["lingua"] = this.lingua !== undefined ? this.lingua : null as any;
        return data;
    }
}

export interface IContattoInfo {
    id?: number;
    uniqueID?: string | null;
    contatto?: Contatto | null;
    isFake?: boolean;
    nomeVisualizzato?: string | null;
    nomeAbbreviato?: string | null;
    ragioneSociale?: string | null;
    email?: string | null;
    descrizione?: string | null;
    relazioni?: ContattoRelazione[] | null;
    relazioniParent?: ContattoRelazione[] | null;
    contattoPromoter?: ContattoInfo | null;
    srtPromoter?: string | null;
    contattoNetwork?: ContattoInfo | null;
    srtNetwork?: string | null;
    recapiti?: ContattoRecapito[] | null;
    luogoContatto?: LuogoInfo | null;
    srtNomeLuogo_it?: string | null;
    srtNomeLuogo_fr?: string | null;
    srtNomeLuogo_de?: string | null;
    srtNomeLuogo_en?: string | null;
    srtNomeRegione_it?: string | null;
    srtNomeRegione_fr?: string | null;
    srtNomeRegione_de?: string | null;
    srtNomeRegione_en?: string | null;
    luogoFatturazione?: LuogoInfo | null;
    categoria?: CategoriaContatto | null;
    srtCategoria?: string | null;
    accordi?: AccordoContattoInfo[] | null;
    accordiOperatore?: { [key in keyof typeof EOperatore]?: AccordoContattoInfo; } | null;
    accordoNaar?: AccordoContattoInfo | null;
    srtAccordoNaar?: string | null;
    srtPagamentoAccordoNaar_it?: string | null;
    srtPagamentoAccordoNaar_fr?: string | null;
    srtPagamentoAccordoNaar_de?: string | null;
    srtPagamentoAccordoNaar_en?: string | null;
    srtPagamentoBiglietteriaNaar_it?: string | null;
    srtPagamentoBiglietteriaNaar_fr?: string | null;
    srtPagamentoBiglietteriaNaar_de?: string | null;
    srtPagamentoBiglietteriaNaar_en?: string | null;
    mappa?: Mappa | null;
    loghi?: ContattoLogo[] | null;
    logoADV?: LogoInfo | null;
    datiAggiuntivi?: ContattoDato[] | null;
    statistiche?: ContattoStatistica[] | null;
    indirizzoCompleto?: string | null;
    luogoFattura?: LuogoInfo | null;
    codiceNazioneFattura?: string | null;
    indirizzoFattura?: string | null;
    numeroCivicoFattura?: string | null;
    capFattura?: string | null;
    partitaIva?: string | null;
    searchTerms?: string | null;
    srtNome?: string | null;
    srtCognome?: string | null;
    emailDocumentiContabili?: string | null;
    codiceUnivocoAgenziaFE?: string | null;
    indirizzoPecAgenziaFE?: string | null;
    datiHotelCompleti?: boolean;
    haMappa?: boolean;
    haServizio?: boolean;
    websiteUrl?: string | null;
    logoUrl?: string | null;
    lingua?: ELingua | null;
}

export class LuogoInfo implements ILuogoInfo {
    id?: number;
    table?: string | null;
    luogo?: Luogo | null;
    eliminato?: boolean;
    provincia?: string | null;
    prioritaParent?: number;
    isCity?: boolean;
    hasMap?: boolean;
    isPlaceholder?: boolean;
    codice?: string | null;
    mappa?: Mappa | null;
    regione?: LuogoInfo | null;
    paese?: LuogoInfo | null;
    destinazione?: LuogoInfo | null;
    subzonaAerea?: LuogoInfo | null;
    relazioni?: LuogoRelazione[] | null;
    distanze?: LuogoDistanza[] | null;
    isItalia?: boolean;
    isEuropa?: boolean;
    isCee?: boolean;
    isNordAmerica?: boolean;
    aeroporto?: Aeroporto | null;
    padre?: LuogoInfo | null;
    luoghiPadre?: LuogoInfo[] | null;
    luoghiVicini?: LuogoInfo[] | null;
    articoli?: ArticoloInfo[] | null;
    medias?: MediaInfo[] | null;
    sortedMedias?: MediaInfo[] | null;
    srtNome_it?: string | null;
    srtNome_en?: string | null;
    srtNome_fr?: string | null;
    srtNome_de?: string | null;
    srtNome_be?: string | null;
    nome?: string | null;
    nome_en?: string | null;
    traduzioni?: IWebTranslationEntity[] | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean;
    confirmed_en?: boolean;

    constructor(data?: ILuogoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.table = _data["table"] !== undefined ? _data["table"] : null as any;
            this.luogo = _data["luogo"] ? Luogo.fromJS(_data["luogo"]) : null as any;
            this.eliminato = _data["eliminato"] !== undefined ? _data["eliminato"] : null as any;
            this.provincia = _data["provincia"] !== undefined ? _data["provincia"] : null as any;
            this.prioritaParent = _data["prioritaParent"] !== undefined ? _data["prioritaParent"] : null as any;
            this.isCity = _data["isCity"] !== undefined ? _data["isCity"] : null as any;
            this.hasMap = _data["hasMap"] !== undefined ? _data["hasMap"] : null as any;
            this.isPlaceholder = _data["isPlaceholder"] !== undefined ? _data["isPlaceholder"] : null as any;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
            this.mappa = _data["mappa"] ? Mappa.fromJS(_data["mappa"]) : null as any;
            this.regione = _data["regione"] ? LuogoInfo.fromJS(_data["regione"]) : null as any;
            this.paese = _data["paese"] ? LuogoInfo.fromJS(_data["paese"]) : null as any;
            this.destinazione = _data["destinazione"] ? LuogoInfo.fromJS(_data["destinazione"]) : null as any;
            this.subzonaAerea = _data["subzonaAerea"] ? LuogoInfo.fromJS(_data["subzonaAerea"]) : null as any;
            if (Array.isArray(_data["relazioni"])) {
                this.relazioni = [] as any;
                for (let item of _data["relazioni"])
                    this.relazioni!.push(LuogoRelazione.fromJS(item));
            }
            else {
                this.relazioni = null as any;
            }
            if (Array.isArray(_data["distanze"])) {
                this.distanze = [] as any;
                for (let item of _data["distanze"])
                    this.distanze!.push(LuogoDistanza.fromJS(item));
            }
            else {
                this.distanze = null as any;
            }
            this.isItalia = _data["isItalia"] !== undefined ? _data["isItalia"] : null as any;
            this.isEuropa = _data["isEuropa"] !== undefined ? _data["isEuropa"] : null as any;
            this.isCee = _data["isCee"] !== undefined ? _data["isCee"] : null as any;
            this.isNordAmerica = _data["isNordAmerica"] !== undefined ? _data["isNordAmerica"] : null as any;
            this.aeroporto = _data["aeroporto"] ? Aeroporto.fromJS(_data["aeroporto"]) : null as any;
            this.padre = _data["padre"] ? LuogoInfo.fromJS(_data["padre"]) : null as any;
            if (Array.isArray(_data["luoghiPadre"])) {
                this.luoghiPadre = [] as any;
                for (let item of _data["luoghiPadre"])
                    this.luoghiPadre!.push(LuogoInfo.fromJS(item));
            }
            else {
                this.luoghiPadre = null as any;
            }
            if (Array.isArray(_data["luoghiVicini"])) {
                this.luoghiVicini = [] as any;
                for (let item of _data["luoghiVicini"])
                    this.luoghiVicini!.push(LuogoInfo.fromJS(item));
            }
            else {
                this.luoghiVicini = null as any;
            }
            if (Array.isArray(_data["articoli"])) {
                this.articoli = [] as any;
                for (let item of _data["articoli"])
                    this.articoli!.push(ArticoloInfo.fromJS(item));
            }
            else {
                this.articoli = null as any;
            }
            if (Array.isArray(_data["medias"])) {
                this.medias = [] as any;
                for (let item of _data["medias"])
                    this.medias!.push(MediaInfo.fromJS(item));
            }
            else {
                this.medias = null as any;
            }
            if (Array.isArray(_data["sortedMedias"])) {
                this.sortedMedias = [] as any;
                for (let item of _data["sortedMedias"])
                    this.sortedMedias!.push(MediaInfo.fromJS(item));
            }
            else {
                this.sortedMedias = null as any;
            }
            this.srtNome_it = _data["srtNome_it"] !== undefined ? _data["srtNome_it"] : null as any;
            this.srtNome_en = _data["srtNome_en"] !== undefined ? _data["srtNome_en"] : null as any;
            this.srtNome_fr = _data["srtNome_fr"] !== undefined ? _data["srtNome_fr"] : null as any;
            this.srtNome_de = _data["srtNome_de"] !== undefined ? _data["srtNome_de"] : null as any;
            this.srtNome_be = _data["srtNome_be"] !== undefined ? _data["srtNome_be"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : null as any;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(IWebTranslationEntity.fromJS(item));
            }
            else {
                this.traduzioni = null as any;
            }
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : null as any;
            this.lastUpdate_en = _data["lastUpdate_en"] !== undefined ? _data["lastUpdate_en"] : null as any;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : null as any;
            this.confirmed_en = _data["confirmed_en"] !== undefined ? _data["confirmed_en"] : null as any;
        }
    }

    static fromJS(data: any): LuogoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new LuogoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["table"] = this.table !== undefined ? this.table : null as any;
        data["luogo"] = this.luogo ? this.luogo.toJSON() : null as any;
        data["eliminato"] = this.eliminato !== undefined ? this.eliminato : null as any;
        data["provincia"] = this.provincia !== undefined ? this.provincia : null as any;
        data["prioritaParent"] = this.prioritaParent !== undefined ? this.prioritaParent : null as any;
        data["isCity"] = this.isCity !== undefined ? this.isCity : null as any;
        data["hasMap"] = this.hasMap !== undefined ? this.hasMap : null as any;
        data["isPlaceholder"] = this.isPlaceholder !== undefined ? this.isPlaceholder : null as any;
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        data["mappa"] = this.mappa ? this.mappa.toJSON() : null as any;
        data["regione"] = this.regione ? this.regione.toJSON() : null as any;
        data["paese"] = this.paese ? this.paese.toJSON() : null as any;
        data["destinazione"] = this.destinazione ? this.destinazione.toJSON() : null as any;
        data["subzonaAerea"] = this.subzonaAerea ? this.subzonaAerea.toJSON() : null as any;
        if (Array.isArray(this.relazioni)) {
            data["relazioni"] = [];
            for (let item of this.relazioni)
                data["relazioni"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.distanze)) {
            data["distanze"] = [];
            for (let item of this.distanze)
                data["distanze"].push(item ? item.toJSON() : null as any);
        }
        data["isItalia"] = this.isItalia !== undefined ? this.isItalia : null as any;
        data["isEuropa"] = this.isEuropa !== undefined ? this.isEuropa : null as any;
        data["isCee"] = this.isCee !== undefined ? this.isCee : null as any;
        data["isNordAmerica"] = this.isNordAmerica !== undefined ? this.isNordAmerica : null as any;
        data["aeroporto"] = this.aeroporto ? this.aeroporto.toJSON() : null as any;
        data["padre"] = this.padre ? this.padre.toJSON() : null as any;
        if (Array.isArray(this.luoghiPadre)) {
            data["luoghiPadre"] = [];
            for (let item of this.luoghiPadre)
                data["luoghiPadre"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.luoghiVicini)) {
            data["luoghiVicini"] = [];
            for (let item of this.luoghiVicini)
                data["luoghiVicini"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.articoli)) {
            data["articoli"] = [];
            for (let item of this.articoli)
                data["articoli"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.medias)) {
            data["medias"] = [];
            for (let item of this.medias)
                data["medias"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.sortedMedias)) {
            data["sortedMedias"] = [];
            for (let item of this.sortedMedias)
                data["sortedMedias"].push(item ? item.toJSON() : null as any);
        }
        data["srtNome_it"] = this.srtNome_it !== undefined ? this.srtNome_it : null as any;
        data["srtNome_en"] = this.srtNome_en !== undefined ? this.srtNome_en : null as any;
        data["srtNome_fr"] = this.srtNome_fr !== undefined ? this.srtNome_fr : null as any;
        data["srtNome_de"] = this.srtNome_de !== undefined ? this.srtNome_de : null as any;
        data["srtNome_be"] = this.srtNome_be !== undefined ? this.srtNome_be : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : null as any;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item ? item.toJSON() : null as any);
        }
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : null as any;
        data["lastUpdate_en"] = this.lastUpdate_en !== undefined ? this.lastUpdate_en : null as any;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : null as any;
        data["confirmed_en"] = this.confirmed_en !== undefined ? this.confirmed_en : null as any;
        return data;
    }
}

export interface ILuogoInfo {
    id?: number;
    table?: string | null;
    luogo?: Luogo | null;
    eliminato?: boolean;
    provincia?: string | null;
    prioritaParent?: number;
    isCity?: boolean;
    hasMap?: boolean;
    isPlaceholder?: boolean;
    codice?: string | null;
    mappa?: Mappa | null;
    regione?: LuogoInfo | null;
    paese?: LuogoInfo | null;
    destinazione?: LuogoInfo | null;
    subzonaAerea?: LuogoInfo | null;
    relazioni?: LuogoRelazione[] | null;
    distanze?: LuogoDistanza[] | null;
    isItalia?: boolean;
    isEuropa?: boolean;
    isCee?: boolean;
    isNordAmerica?: boolean;
    aeroporto?: Aeroporto | null;
    padre?: LuogoInfo | null;
    luoghiPadre?: LuogoInfo[] | null;
    luoghiVicini?: LuogoInfo[] | null;
    articoli?: ArticoloInfo[] | null;
    medias?: MediaInfo[] | null;
    sortedMedias?: MediaInfo[] | null;
    srtNome_it?: string | null;
    srtNome_en?: string | null;
    srtNome_fr?: string | null;
    srtNome_de?: string | null;
    srtNome_be?: string | null;
    nome?: string | null;
    nome_en?: string | null;
    traduzioni?: IWebTranslationEntity[] | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean;
    confirmed_en?: boolean;
}

export class ArticoloInfo implements IArticoloInfo {
    id?: number;
    articolo?: Articolo;
    pubblicato?: boolean;
    titolo?: string;
    srtLuogo_it?: string | null;
    srtLuogo_en?: string | null;
    srtLuogo_fr?: string | null;
    srtLuogo_de?: string | null;
    srtServizio_it?: string | null;
    srtServizio_en?: string | null;
    srtServizio_fr?: string | null;
    srtServizio_de?: string | null;
    srtCompagnia?: string | null;
    srtAccordo?: string | null;
    srtOrdine?: string;
    intestazione?: ArticoloTestata | null;
    luogo?: LuogoInfo | null;
    servizio?: ServizioInfo | null;
    accordo?: AccordoInfo | null;
    link?: PageLinkInfo | null;
    compagnia?: CompagniaAerea | null;
    searchTerms?: string;
    attachments?: ArticoloAttachmentInfo[];
    giorno?: number;
    ordine?: number;
    gruppoTestata?: number | null;
    ordineTestata?: number | null;
    isGiorno?: boolean;
    isNota?: boolean;
    isNews?: boolean;
    isPenaliCancellazioneRiga?: boolean;
    isPenaliCancellazioneEstese?: boolean;
    isNoteServizioRiga?: boolean;
    isNoteServizioEstese?: boolean;
    traduzioni?: ArticoloTraduzione[];
    lastUpdate?: string | null;
    srtTitolo_it?: string | null;
    srtTitolo_en?: string | null;
    srtTitolo_fr?: string | null;
    srtTitolo_de?: string | null;
    operatore?: EOperatore | null;

    constructor(data?: IArticoloInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.articolo = _data["articolo"] ? Articolo.fromJS(_data["articolo"]) : null as any;
            this.pubblicato = _data["pubblicato"] !== undefined ? _data["pubblicato"] : null as any;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            this.srtLuogo_it = _data["srtLuogo_it"] !== undefined ? _data["srtLuogo_it"] : null as any;
            this.srtLuogo_en = _data["srtLuogo_en"] !== undefined ? _data["srtLuogo_en"] : null as any;
            this.srtLuogo_fr = _data["srtLuogo_fr"] !== undefined ? _data["srtLuogo_fr"] : null as any;
            this.srtLuogo_de = _data["srtLuogo_de"] !== undefined ? _data["srtLuogo_de"] : null as any;
            this.srtServizio_it = _data["srtServizio_it"] !== undefined ? _data["srtServizio_it"] : null as any;
            this.srtServizio_en = _data["srtServizio_en"] !== undefined ? _data["srtServizio_en"] : null as any;
            this.srtServizio_fr = _data["srtServizio_fr"] !== undefined ? _data["srtServizio_fr"] : null as any;
            this.srtServizio_de = _data["srtServizio_de"] !== undefined ? _data["srtServizio_de"] : null as any;
            this.srtCompagnia = _data["srtCompagnia"] !== undefined ? _data["srtCompagnia"] : null as any;
            this.srtAccordo = _data["srtAccordo"] !== undefined ? _data["srtAccordo"] : null as any;
            this.srtOrdine = _data["srtOrdine"] !== undefined ? _data["srtOrdine"] : null as any;
            this.intestazione = _data["intestazione"] ? ArticoloTestata.fromJS(_data["intestazione"]) : null as any;
            this.luogo = _data["luogo"] ? LuogoInfo.fromJS(_data["luogo"]) : null as any;
            this.servizio = _data["servizio"] ? ServizioInfo.fromJS(_data["servizio"]) : null as any;
            this.accordo = _data["accordo"] ? AccordoInfo.fromJS(_data["accordo"]) : null as any;
            this.link = _data["link"] ? PageLinkInfo.fromJS(_data["link"]) : null as any;
            this.compagnia = _data["compagnia"] ? CompagniaAerea.fromJS(_data["compagnia"]) : null as any;
            this.searchTerms = _data["searchTerms"] !== undefined ? _data["searchTerms"] : null as any;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(ArticoloAttachmentInfo.fromJS(item));
            }
            else {
                this.attachments = null as any;
            }
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.gruppoTestata = _data["gruppoTestata"] !== undefined ? _data["gruppoTestata"] : null as any;
            this.ordineTestata = _data["ordineTestata"] !== undefined ? _data["ordineTestata"] : null as any;
            this.isGiorno = _data["isGiorno"] !== undefined ? _data["isGiorno"] : null as any;
            this.isNota = _data["isNota"] !== undefined ? _data["isNota"] : null as any;
            this.isNews = _data["isNews"] !== undefined ? _data["isNews"] : null as any;
            this.isPenaliCancellazioneRiga = _data["isPenaliCancellazioneRiga"] !== undefined ? _data["isPenaliCancellazioneRiga"] : null as any;
            this.isPenaliCancellazioneEstese = _data["isPenaliCancellazioneEstese"] !== undefined ? _data["isPenaliCancellazioneEstese"] : null as any;
            this.isNoteServizioRiga = _data["isNoteServizioRiga"] !== undefined ? _data["isNoteServizioRiga"] : null as any;
            this.isNoteServizioEstese = _data["isNoteServizioEstese"] !== undefined ? _data["isNoteServizioEstese"] : null as any;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(ArticoloTraduzione.fromJS(item));
            }
            else {
                this.traduzioni = null as any;
            }
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : null as any;
            this.srtTitolo_it = _data["srtTitolo_it"] !== undefined ? _data["srtTitolo_it"] : null as any;
            this.srtTitolo_en = _data["srtTitolo_en"] !== undefined ? _data["srtTitolo_en"] : null as any;
            this.srtTitolo_fr = _data["srtTitolo_fr"] !== undefined ? _data["srtTitolo_fr"] : null as any;
            this.srtTitolo_de = _data["srtTitolo_de"] !== undefined ? _data["srtTitolo_de"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
        }
    }

    static fromJS(data: any): ArticoloInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["articolo"] = this.articolo ? this.articolo.toJSON() : null as any;
        data["pubblicato"] = this.pubblicato !== undefined ? this.pubblicato : null as any;
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        data["srtLuogo_it"] = this.srtLuogo_it !== undefined ? this.srtLuogo_it : null as any;
        data["srtLuogo_en"] = this.srtLuogo_en !== undefined ? this.srtLuogo_en : null as any;
        data["srtLuogo_fr"] = this.srtLuogo_fr !== undefined ? this.srtLuogo_fr : null as any;
        data["srtLuogo_de"] = this.srtLuogo_de !== undefined ? this.srtLuogo_de : null as any;
        data["srtServizio_it"] = this.srtServizio_it !== undefined ? this.srtServizio_it : null as any;
        data["srtServizio_en"] = this.srtServizio_en !== undefined ? this.srtServizio_en : null as any;
        data["srtServizio_fr"] = this.srtServizio_fr !== undefined ? this.srtServizio_fr : null as any;
        data["srtServizio_de"] = this.srtServizio_de !== undefined ? this.srtServizio_de : null as any;
        data["srtCompagnia"] = this.srtCompagnia !== undefined ? this.srtCompagnia : null as any;
        data["srtAccordo"] = this.srtAccordo !== undefined ? this.srtAccordo : null as any;
        data["srtOrdine"] = this.srtOrdine !== undefined ? this.srtOrdine : null as any;
        data["intestazione"] = this.intestazione ? this.intestazione.toJSON() : null as any;
        data["luogo"] = this.luogo ? this.luogo.toJSON() : null as any;
        data["servizio"] = this.servizio ? this.servizio.toJSON() : null as any;
        data["accordo"] = this.accordo ? this.accordo.toJSON() : null as any;
        data["link"] = this.link ? this.link.toJSON() : null as any;
        data["compagnia"] = this.compagnia ? this.compagnia.toJSON() : null as any;
        data["searchTerms"] = this.searchTerms !== undefined ? this.searchTerms : null as any;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : null as any);
        }
        data["giorno"] = this.giorno !== undefined ? this.giorno : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["gruppoTestata"] = this.gruppoTestata !== undefined ? this.gruppoTestata : null as any;
        data["ordineTestata"] = this.ordineTestata !== undefined ? this.ordineTestata : null as any;
        data["isGiorno"] = this.isGiorno !== undefined ? this.isGiorno : null as any;
        data["isNota"] = this.isNota !== undefined ? this.isNota : null as any;
        data["isNews"] = this.isNews !== undefined ? this.isNews : null as any;
        data["isPenaliCancellazioneRiga"] = this.isPenaliCancellazioneRiga !== undefined ? this.isPenaliCancellazioneRiga : null as any;
        data["isPenaliCancellazioneEstese"] = this.isPenaliCancellazioneEstese !== undefined ? this.isPenaliCancellazioneEstese : null as any;
        data["isNoteServizioRiga"] = this.isNoteServizioRiga !== undefined ? this.isNoteServizioRiga : null as any;
        data["isNoteServizioEstese"] = this.isNoteServizioEstese !== undefined ? this.isNoteServizioEstese : null as any;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item ? item.toJSON() : null as any);
        }
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : null as any;
        data["srtTitolo_it"] = this.srtTitolo_it !== undefined ? this.srtTitolo_it : null as any;
        data["srtTitolo_en"] = this.srtTitolo_en !== undefined ? this.srtTitolo_en : null as any;
        data["srtTitolo_fr"] = this.srtTitolo_fr !== undefined ? this.srtTitolo_fr : null as any;
        data["srtTitolo_de"] = this.srtTitolo_de !== undefined ? this.srtTitolo_de : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        return data;
    }
}

export interface IArticoloInfo {
    id?: number;
    articolo?: Articolo;
    pubblicato?: boolean;
    titolo?: string;
    srtLuogo_it?: string | null;
    srtLuogo_en?: string | null;
    srtLuogo_fr?: string | null;
    srtLuogo_de?: string | null;
    srtServizio_it?: string | null;
    srtServizio_en?: string | null;
    srtServizio_fr?: string | null;
    srtServizio_de?: string | null;
    srtCompagnia?: string | null;
    srtAccordo?: string | null;
    srtOrdine?: string;
    intestazione?: ArticoloTestata | null;
    luogo?: LuogoInfo | null;
    servizio?: ServizioInfo | null;
    accordo?: AccordoInfo | null;
    link?: PageLinkInfo | null;
    compagnia?: CompagniaAerea | null;
    searchTerms?: string;
    attachments?: ArticoloAttachmentInfo[];
    giorno?: number;
    ordine?: number;
    gruppoTestata?: number | null;
    ordineTestata?: number | null;
    isGiorno?: boolean;
    isNota?: boolean;
    isNews?: boolean;
    isPenaliCancellazioneRiga?: boolean;
    isPenaliCancellazioneEstese?: boolean;
    isNoteServizioRiga?: boolean;
    isNoteServizioEstese?: boolean;
    traduzioni?: ArticoloTraduzione[];
    lastUpdate?: string | null;
    srtTitolo_it?: string | null;
    srtTitolo_en?: string | null;
    srtTitolo_fr?: string | null;
    srtTitolo_de?: string | null;
    operatore?: EOperatore | null;
}

export class ArticoloTestata implements IArticoloTestata {
    articoloTestataID?: number;
    nome!: string;
    ordine?: number | null;
    gruppo?: number | null;
    nome_en?: string | null;

    constructor(data?: IArticoloTestata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articoloTestataID = _data["articoloTestataID"] !== undefined ? _data["articoloTestataID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.gruppo = _data["gruppo"] !== undefined ? _data["gruppo"] : null as any;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : null as any;
        }
    }

    static fromJS(data: any): ArticoloTestata {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloTestata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articoloTestataID"] = this.articoloTestataID !== undefined ? this.articoloTestataID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["gruppo"] = this.gruppo !== undefined ? this.gruppo : null as any;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : null as any;
        return data;
    }
}

export interface IArticoloTestata {
    articoloTestataID?: number;
    nome: string;
    ordine?: number | null;
    gruppo?: number | null;
    nome_en?: string | null;
}

export abstract class ServizioInfoBase implements IServizioInfoBase {
    luogo?: LuogoInfo | null;

    constructor(data?: IServizioInfoBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.luogo = _data["luogo"] ? LuogoInfo.fromJS(_data["luogo"]) : null as any;
        }
    }

    static fromJS(data: any): ServizioInfoBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ServizioInfoBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogo"] = this.luogo ? this.luogo.toJSON() : null as any;
        return data;
    }
}

export interface IServizioInfoBase {
    luogo?: LuogoInfo | null;
}

export class ServizioInfo extends ServizioInfoBase implements IServizioInfo {
    _Prezzi?: PrezzoOfferta[] | null;
    id?: number;
    table?: string | null;
    uniqueID?: string | null;
    servizio?: Servizio | null;
    eliminato?: boolean;
    luogoID?: number;
    contattoFornitore?: ContattoInfo | null;
    nomeFornitore?: string | null;
    srtNomeFornitore?: string | null;
    regoleScontoPacchetto?: ServizioRegolaScontoPacchetto[] | null;
    deltaMargine?: number;
    medias?: MediaInfo[] | null;
    sortedMedias?: MediaInfo[] | null;
    coverImage?: string | null;
    isObsoleto?: boolean;
    isVolo?: boolean;
    isBookingFeeBiglietteria?: boolean;
    isNonMappato?: boolean;
    tipologie?: ServizioTipologiaInfo[] | null;
    hasMandatorySupplements?: boolean;
    tipologieDict?: { [key: string]: ServizioTipologiaInfo; } | null;
    ordine?: number;
    itinerari?: ServizioItinerario[] | null;
    itinerariTour?: ServizioItinerarioInfo[] | null;
    isAssicurazione?: boolean;
    isAssicurazioneSanitariaFacoltativa?: boolean;
    isVariazione?: boolean;
    isTasseVolo?: boolean;
    isCamper?: boolean;
    isMoto?: boolean;
    isTrasferimento?: boolean;
    isVisita?: boolean;
    isCrociera?: boolean;
    isQuoteApertura?: boolean;
    isBloccaPrezzo?: boolean;
    isCommissioneAgenziaSuBiglietteria?: boolean;
    isDirittiAgenzia?: boolean;
    tipoServizio?: ETipoServizioFlags;
    moltiplicatoreServizio?: number;
    accordi?: ServizioAccordoInfo[] | null;
    validita?: Validita[] | null;
    regoleServizio?: ServizioRegola[] | null;
    regoleServizioDict?: { [key: string]: ServizioRegola; } | null;
    regoleVendita?: ServizioRegolaVendita[] | null;
    regoleVenditaDict?: { [key: string]: ServizioRegolaVendita; } | null;
    costi?: CostoInfo[] | null;
    partenzeDict?: { [key: string]: Partenza; } | null;
    partenze?: Partenza[] | null;
    luoghi?: ServizioLuogo[] | null;
    associazioni?: ServizioAssociazioneInfo[] | null;
    associazioniOfferteComponibili?: ServizioAssociazioneInfo[] | null;
    giornaliero?: boolean;
    stelle?: number | null;
    escludiDaAutofill?: boolean;
    vicinoAeroporto?: boolean;
    haAttributiTestata?: boolean;
    haAttributiNoleggio?: boolean;
    attributiNoleggio?: ServizioDatoAggiuntivoInfo[] | null;
    haCategoria?: boolean;
    haNuovo?: boolean;
    haVantaggi?: boolean;
    haServizi?: boolean;
    datoAggiuntivoPenale?: ServizioDatoAggiuntivoInfo | null;
    aPartireDa?: number | null;
    isViaggiDelClub?: boolean;
    offerDestination?: DatoAggiuntivo | null;
    offerteDestinationCodice?: string | null;
    offerteDestinationNome?: string | null;
    offertaAPartireDa?: string | null;
    isOffertaViaggio?: boolean;
    datiAggiuntiviAutomazionePacchettiIDs?: number[] | null;
    datiAggiuntiviAutomazionePacchetti?: ServizioDatoAggiuntivoInfo[] | null;
    servDatiAggiuntivi?: ServizioDatoAggiuntivoInfo[] | null;
    datiAggiuntiviPenaleDefault?: ServizioDatoAggiuntivoInfo[] | null;
    prezzi?: PrezzoOfferta[] | null;
    isSpecialOffert?: boolean;
    rangeValiditaCosti?: ServizioValiditaCosti | null;
    mappa?: Mappa | null;
    sunto?: ArticoloInfo | null;
    articoli?: ArticoloInfo[] | null;
    articoliGiorni?: ArticoloInfo[] | null;
    srtNome_it?: string | null;
    srtNome_en?: string | null;
    srtNome_fr?: string | null;
    srtNome_de?: string | null;
    traduzioni?: IWebTranslationEntity[] | null;
    nome?: string | null;
    nome_en?: string | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean;
    confirmed_en?: boolean;

    constructor(data?: IServizioInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["_Prezzi"])) {
                this._Prezzi = [] as any;
                for (let item of _data["_Prezzi"])
                    this._Prezzi!.push(PrezzoOfferta.fromJS(item));
            }
            else {
                this._Prezzi = null as any;
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.table = _data["table"] !== undefined ? _data["table"] : null as any;
            this.uniqueID = _data["uniqueID"] !== undefined ? _data["uniqueID"] : null as any;
            this.servizio = _data["servizio"] ? Servizio.fromJS(_data["servizio"]) : null as any;
            this.eliminato = _data["eliminato"] !== undefined ? _data["eliminato"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.contattoFornitore = _data["contattoFornitore"] ? ContattoInfo.fromJS(_data["contattoFornitore"]) : null as any;
            this.nomeFornitore = _data["nomeFornitore"] !== undefined ? _data["nomeFornitore"] : null as any;
            this.srtNomeFornitore = _data["srtNomeFornitore"] !== undefined ? _data["srtNomeFornitore"] : null as any;
            if (Array.isArray(_data["regoleScontoPacchetto"])) {
                this.regoleScontoPacchetto = [] as any;
                for (let item of _data["regoleScontoPacchetto"])
                    this.regoleScontoPacchetto!.push(ServizioRegolaScontoPacchetto.fromJS(item));
            }
            else {
                this.regoleScontoPacchetto = null as any;
            }
            this.deltaMargine = _data["deltaMargine"] !== undefined ? _data["deltaMargine"] : null as any;
            if (Array.isArray(_data["medias"])) {
                this.medias = [] as any;
                for (let item of _data["medias"])
                    this.medias!.push(MediaInfo.fromJS(item));
            }
            else {
                this.medias = null as any;
            }
            if (Array.isArray(_data["sortedMedias"])) {
                this.sortedMedias = [] as any;
                for (let item of _data["sortedMedias"])
                    this.sortedMedias!.push(MediaInfo.fromJS(item));
            }
            else {
                this.sortedMedias = null as any;
            }
            this.coverImage = _data["coverImage"] !== undefined ? _data["coverImage"] : null as any;
            this.isObsoleto = _data["isObsoleto"] !== undefined ? _data["isObsoleto"] : null as any;
            this.isVolo = _data["isVolo"] !== undefined ? _data["isVolo"] : null as any;
            this.isBookingFeeBiglietteria = _data["isBookingFeeBiglietteria"] !== undefined ? _data["isBookingFeeBiglietteria"] : null as any;
            this.isNonMappato = _data["isNonMappato"] !== undefined ? _data["isNonMappato"] : null as any;
            if (Array.isArray(_data["tipologie"])) {
                this.tipologie = [] as any;
                for (let item of _data["tipologie"])
                    this.tipologie!.push(ServizioTipologiaInfo.fromJS(item));
            }
            else {
                this.tipologie = null as any;
            }
            this.hasMandatorySupplements = _data["hasMandatorySupplements"] !== undefined ? _data["hasMandatorySupplements"] : null as any;
            if (_data["tipologieDict"]) {
                this.tipologieDict = {} as any;
                for (let key in _data["tipologieDict"]) {
                    if (_data["tipologieDict"].hasOwnProperty(key))
                        (this.tipologieDict as any)![key] = _data["tipologieDict"][key] ? ServizioTipologiaInfo.fromJS(_data["tipologieDict"][key]) : new ServizioTipologiaInfo();
                }
            }
            else {
                this.tipologieDict = null as any;
            }
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            if (Array.isArray(_data["itinerari"])) {
                this.itinerari = [] as any;
                for (let item of _data["itinerari"])
                    this.itinerari!.push(ServizioItinerario.fromJS(item));
            }
            else {
                this.itinerari = null as any;
            }
            if (Array.isArray(_data["itinerariTour"])) {
                this.itinerariTour = [] as any;
                for (let item of _data["itinerariTour"])
                    this.itinerariTour!.push(ServizioItinerarioInfo.fromJS(item));
            }
            else {
                this.itinerariTour = null as any;
            }
            this.isAssicurazione = _data["isAssicurazione"] !== undefined ? _data["isAssicurazione"] : null as any;
            this.isAssicurazioneSanitariaFacoltativa = _data["isAssicurazioneSanitariaFacoltativa"] !== undefined ? _data["isAssicurazioneSanitariaFacoltativa"] : null as any;
            this.isVariazione = _data["isVariazione"] !== undefined ? _data["isVariazione"] : null as any;
            this.isTasseVolo = _data["isTasseVolo"] !== undefined ? _data["isTasseVolo"] : null as any;
            this.isCamper = _data["isCamper"] !== undefined ? _data["isCamper"] : null as any;
            this.isMoto = _data["isMoto"] !== undefined ? _data["isMoto"] : null as any;
            this.isTrasferimento = _data["isTrasferimento"] !== undefined ? _data["isTrasferimento"] : null as any;
            this.isVisita = _data["isVisita"] !== undefined ? _data["isVisita"] : null as any;
            this.isCrociera = _data["isCrociera"] !== undefined ? _data["isCrociera"] : null as any;
            this.isQuoteApertura = _data["isQuoteApertura"] !== undefined ? _data["isQuoteApertura"] : null as any;
            this.isBloccaPrezzo = _data["isBloccaPrezzo"] !== undefined ? _data["isBloccaPrezzo"] : null as any;
            this.isCommissioneAgenziaSuBiglietteria = _data["isCommissioneAgenziaSuBiglietteria"] !== undefined ? _data["isCommissioneAgenziaSuBiglietteria"] : null as any;
            this.isDirittiAgenzia = _data["isDirittiAgenzia"] !== undefined ? _data["isDirittiAgenzia"] : null as any;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
            this.moltiplicatoreServizio = _data["moltiplicatoreServizio"] !== undefined ? _data["moltiplicatoreServizio"] : null as any;
            if (Array.isArray(_data["accordi"])) {
                this.accordi = [] as any;
                for (let item of _data["accordi"])
                    this.accordi!.push(ServizioAccordoInfo.fromJS(item));
            }
            else {
                this.accordi = null as any;
            }
            if (Array.isArray(_data["validita"])) {
                this.validita = [] as any;
                for (let item of _data["validita"])
                    this.validita!.push(Validita.fromJS(item));
            }
            else {
                this.validita = null as any;
            }
            if (Array.isArray(_data["regoleServizio"])) {
                this.regoleServizio = [] as any;
                for (let item of _data["regoleServizio"])
                    this.regoleServizio!.push(ServizioRegola.fromJS(item));
            }
            else {
                this.regoleServizio = null as any;
            }
            if (_data["regoleServizioDict"]) {
                this.regoleServizioDict = {} as any;
                for (let key in _data["regoleServizioDict"]) {
                    if (_data["regoleServizioDict"].hasOwnProperty(key))
                        (this.regoleServizioDict as any)![key] = _data["regoleServizioDict"][key] ? ServizioRegola.fromJS(_data["regoleServizioDict"][key]) : new ServizioRegola();
                }
            }
            else {
                this.regoleServizioDict = null as any;
            }
            if (Array.isArray(_data["regoleVendita"])) {
                this.regoleVendita = [] as any;
                for (let item of _data["regoleVendita"])
                    this.regoleVendita!.push(ServizioRegolaVendita.fromJS(item));
            }
            else {
                this.regoleVendita = null as any;
            }
            if (_data["regoleVenditaDict"]) {
                this.regoleVenditaDict = {} as any;
                for (let key in _data["regoleVenditaDict"]) {
                    if (_data["regoleVenditaDict"].hasOwnProperty(key))
                        (this.regoleVenditaDict as any)![key] = _data["regoleVenditaDict"][key] ? ServizioRegolaVendita.fromJS(_data["regoleVenditaDict"][key]) : new ServizioRegolaVendita();
                }
            }
            else {
                this.regoleVenditaDict = null as any;
            }
            if (Array.isArray(_data["costi"])) {
                this.costi = [] as any;
                for (let item of _data["costi"])
                    this.costi!.push(CostoInfo.fromJS(item));
            }
            else {
                this.costi = null as any;
            }
            if (_data["partenzeDict"]) {
                this.partenzeDict = {} as any;
                for (let key in _data["partenzeDict"]) {
                    if (_data["partenzeDict"].hasOwnProperty(key))
                        (this.partenzeDict as any)![key] = _data["partenzeDict"][key] ? Partenza.fromJS(_data["partenzeDict"][key]) : new Partenza();
                }
            }
            else {
                this.partenzeDict = null as any;
            }
            if (Array.isArray(_data["partenze"])) {
                this.partenze = [] as any;
                for (let item of _data["partenze"])
                    this.partenze!.push(Partenza.fromJS(item));
            }
            else {
                this.partenze = null as any;
            }
            if (Array.isArray(_data["luoghi"])) {
                this.luoghi = [] as any;
                for (let item of _data["luoghi"])
                    this.luoghi!.push(ServizioLuogo.fromJS(item));
            }
            else {
                this.luoghi = null as any;
            }
            if (Array.isArray(_data["associazioni"])) {
                this.associazioni = [] as any;
                for (let item of _data["associazioni"])
                    this.associazioni!.push(ServizioAssociazioneInfo.fromJS(item));
            }
            else {
                this.associazioni = null as any;
            }
            if (Array.isArray(_data["associazioniOfferteComponibili"])) {
                this.associazioniOfferteComponibili = [] as any;
                for (let item of _data["associazioniOfferteComponibili"])
                    this.associazioniOfferteComponibili!.push(ServizioAssociazioneInfo.fromJS(item));
            }
            else {
                this.associazioniOfferteComponibili = null as any;
            }
            this.giornaliero = _data["giornaliero"] !== undefined ? _data["giornaliero"] : null as any;
            this.stelle = _data["stelle"] !== undefined ? _data["stelle"] : null as any;
            this.escludiDaAutofill = _data["escludiDaAutofill"] !== undefined ? _data["escludiDaAutofill"] : null as any;
            this.vicinoAeroporto = _data["vicinoAeroporto"] !== undefined ? _data["vicinoAeroporto"] : null as any;
            this.haAttributiTestata = _data["haAttributiTestata"] !== undefined ? _data["haAttributiTestata"] : null as any;
            this.haAttributiNoleggio = _data["haAttributiNoleggio"] !== undefined ? _data["haAttributiNoleggio"] : null as any;
            if (Array.isArray(_data["attributiNoleggio"])) {
                this.attributiNoleggio = [] as any;
                for (let item of _data["attributiNoleggio"])
                    this.attributiNoleggio!.push(ServizioDatoAggiuntivoInfo.fromJS(item));
            }
            else {
                this.attributiNoleggio = null as any;
            }
            this.haCategoria = _data["haCategoria"] !== undefined ? _data["haCategoria"] : null as any;
            this.haNuovo = _data["haNuovo"] !== undefined ? _data["haNuovo"] : null as any;
            this.haVantaggi = _data["haVantaggi"] !== undefined ? _data["haVantaggi"] : null as any;
            this.haServizi = _data["haServizi"] !== undefined ? _data["haServizi"] : null as any;
            this.datoAggiuntivoPenale = _data["datoAggiuntivoPenale"] ? ServizioDatoAggiuntivoInfo.fromJS(_data["datoAggiuntivoPenale"]) : null as any;
            this.aPartireDa = _data["aPartireDa"] !== undefined ? _data["aPartireDa"] : null as any;
            this.isViaggiDelClub = _data["isViaggiDelClub"] !== undefined ? _data["isViaggiDelClub"] : null as any;
            this.offerDestination = _data["offerDestination"] ? DatoAggiuntivo.fromJS(_data["offerDestination"]) : null as any;
            this.offerteDestinationCodice = _data["offerteDestinationCodice"] !== undefined ? _data["offerteDestinationCodice"] : null as any;
            this.offerteDestinationNome = _data["offerteDestinationNome"] !== undefined ? _data["offerteDestinationNome"] : null as any;
            this.offertaAPartireDa = _data["offertaAPartireDa"] !== undefined ? _data["offertaAPartireDa"] : null as any;
            this.isOffertaViaggio = _data["isOffertaViaggio"] !== undefined ? _data["isOffertaViaggio"] : null as any;
            if (Array.isArray(_data["datiAggiuntiviAutomazionePacchettiIDs"])) {
                this.datiAggiuntiviAutomazionePacchettiIDs = [] as any;
                for (let item of _data["datiAggiuntiviAutomazionePacchettiIDs"])
                    this.datiAggiuntiviAutomazionePacchettiIDs!.push(item);
            }
            else {
                this.datiAggiuntiviAutomazionePacchettiIDs = null as any;
            }
            if (Array.isArray(_data["datiAggiuntiviAutomazionePacchetti"])) {
                this.datiAggiuntiviAutomazionePacchetti = [] as any;
                for (let item of _data["datiAggiuntiviAutomazionePacchetti"])
                    this.datiAggiuntiviAutomazionePacchetti!.push(ServizioDatoAggiuntivoInfo.fromJS(item));
            }
            else {
                this.datiAggiuntiviAutomazionePacchetti = null as any;
            }
            if (Array.isArray(_data["servDatiAggiuntivi"])) {
                this.servDatiAggiuntivi = [] as any;
                for (let item of _data["servDatiAggiuntivi"])
                    this.servDatiAggiuntivi!.push(ServizioDatoAggiuntivoInfo.fromJS(item));
            }
            else {
                this.servDatiAggiuntivi = null as any;
            }
            if (Array.isArray(_data["datiAggiuntiviPenaleDefault"])) {
                this.datiAggiuntiviPenaleDefault = [] as any;
                for (let item of _data["datiAggiuntiviPenaleDefault"])
                    this.datiAggiuntiviPenaleDefault!.push(ServizioDatoAggiuntivoInfo.fromJS(item));
            }
            else {
                this.datiAggiuntiviPenaleDefault = null as any;
            }
            if (Array.isArray(_data["prezzi"])) {
                this.prezzi = [] as any;
                for (let item of _data["prezzi"])
                    this.prezzi!.push(PrezzoOfferta.fromJS(item));
            }
            else {
                this.prezzi = null as any;
            }
            this.isSpecialOffert = _data["isSpecialOffert"] !== undefined ? _data["isSpecialOffert"] : null as any;
            this.rangeValiditaCosti = _data["rangeValiditaCosti"] ? ServizioValiditaCosti.fromJS(_data["rangeValiditaCosti"]) : null as any;
            this.mappa = _data["mappa"] ? Mappa.fromJS(_data["mappa"]) : null as any;
            this.sunto = _data["sunto"] ? ArticoloInfo.fromJS(_data["sunto"]) : null as any;
            if (Array.isArray(_data["articoli"])) {
                this.articoli = [] as any;
                for (let item of _data["articoli"])
                    this.articoli!.push(ArticoloInfo.fromJS(item));
            }
            else {
                this.articoli = null as any;
            }
            if (Array.isArray(_data["articoliGiorni"])) {
                this.articoliGiorni = [] as any;
                for (let item of _data["articoliGiorni"])
                    this.articoliGiorni!.push(ArticoloInfo.fromJS(item));
            }
            else {
                this.articoliGiorni = null as any;
            }
            this.srtNome_it = _data["srtNome_it"] !== undefined ? _data["srtNome_it"] : null as any;
            this.srtNome_en = _data["srtNome_en"] !== undefined ? _data["srtNome_en"] : null as any;
            this.srtNome_fr = _data["srtNome_fr"] !== undefined ? _data["srtNome_fr"] : null as any;
            this.srtNome_de = _data["srtNome_de"] !== undefined ? _data["srtNome_de"] : null as any;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(IWebTranslationEntity.fromJS(item));
            }
            else {
                this.traduzioni = null as any;
            }
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : null as any;
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : null as any;
            this.lastUpdate_en = _data["lastUpdate_en"] !== undefined ? _data["lastUpdate_en"] : null as any;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : null as any;
            this.confirmed_en = _data["confirmed_en"] !== undefined ? _data["confirmed_en"] : null as any;
        }
    }

    static override fromJS(data: any): ServizioInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this._Prezzi)) {
            data["_Prezzi"] = [];
            for (let item of this._Prezzi)
                data["_Prezzi"].push(item ? item.toJSON() : null as any);
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["table"] = this.table !== undefined ? this.table : null as any;
        data["uniqueID"] = this.uniqueID !== undefined ? this.uniqueID : null as any;
        data["servizio"] = this.servizio ? this.servizio.toJSON() : null as any;
        data["eliminato"] = this.eliminato !== undefined ? this.eliminato : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["contattoFornitore"] = this.contattoFornitore ? this.contattoFornitore.toJSON() : null as any;
        data["nomeFornitore"] = this.nomeFornitore !== undefined ? this.nomeFornitore : null as any;
        data["srtNomeFornitore"] = this.srtNomeFornitore !== undefined ? this.srtNomeFornitore : null as any;
        if (Array.isArray(this.regoleScontoPacchetto)) {
            data["regoleScontoPacchetto"] = [];
            for (let item of this.regoleScontoPacchetto)
                data["regoleScontoPacchetto"].push(item ? item.toJSON() : null as any);
        }
        data["deltaMargine"] = this.deltaMargine !== undefined ? this.deltaMargine : null as any;
        if (Array.isArray(this.medias)) {
            data["medias"] = [];
            for (let item of this.medias)
                data["medias"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.sortedMedias)) {
            data["sortedMedias"] = [];
            for (let item of this.sortedMedias)
                data["sortedMedias"].push(item ? item.toJSON() : null as any);
        }
        data["coverImage"] = this.coverImage !== undefined ? this.coverImage : null as any;
        data["isObsoleto"] = this.isObsoleto !== undefined ? this.isObsoleto : null as any;
        data["isVolo"] = this.isVolo !== undefined ? this.isVolo : null as any;
        data["isBookingFeeBiglietteria"] = this.isBookingFeeBiglietteria !== undefined ? this.isBookingFeeBiglietteria : null as any;
        data["isNonMappato"] = this.isNonMappato !== undefined ? this.isNonMappato : null as any;
        if (Array.isArray(this.tipologie)) {
            data["tipologie"] = [];
            for (let item of this.tipologie)
                data["tipologie"].push(item ? item.toJSON() : null as any);
        }
        data["hasMandatorySupplements"] = this.hasMandatorySupplements !== undefined ? this.hasMandatorySupplements : null as any;
        if (this.tipologieDict) {
            data["tipologieDict"] = {};
            for (let key in this.tipologieDict) {
                if (this.tipologieDict.hasOwnProperty(key))
                    (data["tipologieDict"] as any)[key] = this.tipologieDict[key] ? this.tipologieDict[key].toJSON() : null as any;
            }
        }
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        if (Array.isArray(this.itinerari)) {
            data["itinerari"] = [];
            for (let item of this.itinerari)
                data["itinerari"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.itinerariTour)) {
            data["itinerariTour"] = [];
            for (let item of this.itinerariTour)
                data["itinerariTour"].push(item ? item.toJSON() : null as any);
        }
        data["isAssicurazione"] = this.isAssicurazione !== undefined ? this.isAssicurazione : null as any;
        data["isAssicurazioneSanitariaFacoltativa"] = this.isAssicurazioneSanitariaFacoltativa !== undefined ? this.isAssicurazioneSanitariaFacoltativa : null as any;
        data["isVariazione"] = this.isVariazione !== undefined ? this.isVariazione : null as any;
        data["isTasseVolo"] = this.isTasseVolo !== undefined ? this.isTasseVolo : null as any;
        data["isCamper"] = this.isCamper !== undefined ? this.isCamper : null as any;
        data["isMoto"] = this.isMoto !== undefined ? this.isMoto : null as any;
        data["isTrasferimento"] = this.isTrasferimento !== undefined ? this.isTrasferimento : null as any;
        data["isVisita"] = this.isVisita !== undefined ? this.isVisita : null as any;
        data["isCrociera"] = this.isCrociera !== undefined ? this.isCrociera : null as any;
        data["isQuoteApertura"] = this.isQuoteApertura !== undefined ? this.isQuoteApertura : null as any;
        data["isBloccaPrezzo"] = this.isBloccaPrezzo !== undefined ? this.isBloccaPrezzo : null as any;
        data["isCommissioneAgenziaSuBiglietteria"] = this.isCommissioneAgenziaSuBiglietteria !== undefined ? this.isCommissioneAgenziaSuBiglietteria : null as any;
        data["isDirittiAgenzia"] = this.isDirittiAgenzia !== undefined ? this.isDirittiAgenzia : null as any;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        data["moltiplicatoreServizio"] = this.moltiplicatoreServizio !== undefined ? this.moltiplicatoreServizio : null as any;
        if (Array.isArray(this.accordi)) {
            data["accordi"] = [];
            for (let item of this.accordi)
                data["accordi"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.validita)) {
            data["validita"] = [];
            for (let item of this.validita)
                data["validita"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.regoleServizio)) {
            data["regoleServizio"] = [];
            for (let item of this.regoleServizio)
                data["regoleServizio"].push(item ? item.toJSON() : null as any);
        }
        if (this.regoleServizioDict) {
            data["regoleServizioDict"] = {};
            for (let key in this.regoleServizioDict) {
                if (this.regoleServizioDict.hasOwnProperty(key))
                    (data["regoleServizioDict"] as any)[key] = this.regoleServizioDict[key] ? this.regoleServizioDict[key].toJSON() : null as any;
            }
        }
        if (Array.isArray(this.regoleVendita)) {
            data["regoleVendita"] = [];
            for (let item of this.regoleVendita)
                data["regoleVendita"].push(item ? item.toJSON() : null as any);
        }
        if (this.regoleVenditaDict) {
            data["regoleVenditaDict"] = {};
            for (let key in this.regoleVenditaDict) {
                if (this.regoleVenditaDict.hasOwnProperty(key))
                    (data["regoleVenditaDict"] as any)[key] = this.regoleVenditaDict[key] ? this.regoleVenditaDict[key].toJSON() : null as any;
            }
        }
        if (Array.isArray(this.costi)) {
            data["costi"] = [];
            for (let item of this.costi)
                data["costi"].push(item ? item.toJSON() : null as any);
        }
        if (this.partenzeDict) {
            data["partenzeDict"] = {};
            for (let key in this.partenzeDict) {
                if (this.partenzeDict.hasOwnProperty(key))
                    (data["partenzeDict"] as any)[key] = this.partenzeDict[key] ? this.partenzeDict[key].toJSON() : null as any;
            }
        }
        if (Array.isArray(this.partenze)) {
            data["partenze"] = [];
            for (let item of this.partenze)
                data["partenze"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.luoghi)) {
            data["luoghi"] = [];
            for (let item of this.luoghi)
                data["luoghi"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.associazioni)) {
            data["associazioni"] = [];
            for (let item of this.associazioni)
                data["associazioni"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.associazioniOfferteComponibili)) {
            data["associazioniOfferteComponibili"] = [];
            for (let item of this.associazioniOfferteComponibili)
                data["associazioniOfferteComponibili"].push(item ? item.toJSON() : null as any);
        }
        data["giornaliero"] = this.giornaliero !== undefined ? this.giornaliero : null as any;
        data["stelle"] = this.stelle !== undefined ? this.stelle : null as any;
        data["escludiDaAutofill"] = this.escludiDaAutofill !== undefined ? this.escludiDaAutofill : null as any;
        data["vicinoAeroporto"] = this.vicinoAeroporto !== undefined ? this.vicinoAeroporto : null as any;
        data["haAttributiTestata"] = this.haAttributiTestata !== undefined ? this.haAttributiTestata : null as any;
        data["haAttributiNoleggio"] = this.haAttributiNoleggio !== undefined ? this.haAttributiNoleggio : null as any;
        if (Array.isArray(this.attributiNoleggio)) {
            data["attributiNoleggio"] = [];
            for (let item of this.attributiNoleggio)
                data["attributiNoleggio"].push(item ? item.toJSON() : null as any);
        }
        data["haCategoria"] = this.haCategoria !== undefined ? this.haCategoria : null as any;
        data["haNuovo"] = this.haNuovo !== undefined ? this.haNuovo : null as any;
        data["haVantaggi"] = this.haVantaggi !== undefined ? this.haVantaggi : null as any;
        data["haServizi"] = this.haServizi !== undefined ? this.haServizi : null as any;
        data["datoAggiuntivoPenale"] = this.datoAggiuntivoPenale ? this.datoAggiuntivoPenale.toJSON() : null as any;
        data["aPartireDa"] = this.aPartireDa !== undefined ? this.aPartireDa : null as any;
        data["isViaggiDelClub"] = this.isViaggiDelClub !== undefined ? this.isViaggiDelClub : null as any;
        data["offerDestination"] = this.offerDestination ? this.offerDestination.toJSON() : null as any;
        data["offerteDestinationCodice"] = this.offerteDestinationCodice !== undefined ? this.offerteDestinationCodice : null as any;
        data["offerteDestinationNome"] = this.offerteDestinationNome !== undefined ? this.offerteDestinationNome : null as any;
        data["offertaAPartireDa"] = this.offertaAPartireDa !== undefined ? this.offertaAPartireDa : null as any;
        data["isOffertaViaggio"] = this.isOffertaViaggio !== undefined ? this.isOffertaViaggio : null as any;
        if (Array.isArray(this.datiAggiuntiviAutomazionePacchettiIDs)) {
            data["datiAggiuntiviAutomazionePacchettiIDs"] = [];
            for (let item of this.datiAggiuntiviAutomazionePacchettiIDs)
                data["datiAggiuntiviAutomazionePacchettiIDs"].push(item);
        }
        if (Array.isArray(this.datiAggiuntiviAutomazionePacchetti)) {
            data["datiAggiuntiviAutomazionePacchetti"] = [];
            for (let item of this.datiAggiuntiviAutomazionePacchetti)
                data["datiAggiuntiviAutomazionePacchetti"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.servDatiAggiuntivi)) {
            data["servDatiAggiuntivi"] = [];
            for (let item of this.servDatiAggiuntivi)
                data["servDatiAggiuntivi"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.datiAggiuntiviPenaleDefault)) {
            data["datiAggiuntiviPenaleDefault"] = [];
            for (let item of this.datiAggiuntiviPenaleDefault)
                data["datiAggiuntiviPenaleDefault"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.prezzi)) {
            data["prezzi"] = [];
            for (let item of this.prezzi)
                data["prezzi"].push(item ? item.toJSON() : null as any);
        }
        data["isSpecialOffert"] = this.isSpecialOffert !== undefined ? this.isSpecialOffert : null as any;
        data["rangeValiditaCosti"] = this.rangeValiditaCosti ? this.rangeValiditaCosti.toJSON() : null as any;
        data["mappa"] = this.mappa ? this.mappa.toJSON() : null as any;
        data["sunto"] = this.sunto ? this.sunto.toJSON() : null as any;
        if (Array.isArray(this.articoli)) {
            data["articoli"] = [];
            for (let item of this.articoli)
                data["articoli"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.articoliGiorni)) {
            data["articoliGiorni"] = [];
            for (let item of this.articoliGiorni)
                data["articoliGiorni"].push(item ? item.toJSON() : null as any);
        }
        data["srtNome_it"] = this.srtNome_it !== undefined ? this.srtNome_it : null as any;
        data["srtNome_en"] = this.srtNome_en !== undefined ? this.srtNome_en : null as any;
        data["srtNome_fr"] = this.srtNome_fr !== undefined ? this.srtNome_fr : null as any;
        data["srtNome_de"] = this.srtNome_de !== undefined ? this.srtNome_de : null as any;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item ? item.toJSON() : null as any);
        }
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : null as any;
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : null as any;
        data["lastUpdate_en"] = this.lastUpdate_en !== undefined ? this.lastUpdate_en : null as any;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : null as any;
        data["confirmed_en"] = this.confirmed_en !== undefined ? this.confirmed_en : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IServizioInfo extends IServizioInfoBase {
    _Prezzi?: PrezzoOfferta[] | null;
    id?: number;
    table?: string | null;
    uniqueID?: string | null;
    servizio?: Servizio | null;
    eliminato?: boolean;
    luogoID?: number;
    contattoFornitore?: ContattoInfo | null;
    nomeFornitore?: string | null;
    srtNomeFornitore?: string | null;
    regoleScontoPacchetto?: ServizioRegolaScontoPacchetto[] | null;
    deltaMargine?: number;
    medias?: MediaInfo[] | null;
    sortedMedias?: MediaInfo[] | null;
    coverImage?: string | null;
    isObsoleto?: boolean;
    isVolo?: boolean;
    isBookingFeeBiglietteria?: boolean;
    isNonMappato?: boolean;
    tipologie?: ServizioTipologiaInfo[] | null;
    hasMandatorySupplements?: boolean;
    tipologieDict?: { [key: string]: ServizioTipologiaInfo; } | null;
    ordine?: number;
    itinerari?: ServizioItinerario[] | null;
    itinerariTour?: ServizioItinerarioInfo[] | null;
    isAssicurazione?: boolean;
    isAssicurazioneSanitariaFacoltativa?: boolean;
    isVariazione?: boolean;
    isTasseVolo?: boolean;
    isCamper?: boolean;
    isMoto?: boolean;
    isTrasferimento?: boolean;
    isVisita?: boolean;
    isCrociera?: boolean;
    isQuoteApertura?: boolean;
    isBloccaPrezzo?: boolean;
    isCommissioneAgenziaSuBiglietteria?: boolean;
    isDirittiAgenzia?: boolean;
    tipoServizio?: ETipoServizioFlags;
    moltiplicatoreServizio?: number;
    accordi?: ServizioAccordoInfo[] | null;
    validita?: Validita[] | null;
    regoleServizio?: ServizioRegola[] | null;
    regoleServizioDict?: { [key: string]: ServizioRegola; } | null;
    regoleVendita?: ServizioRegolaVendita[] | null;
    regoleVenditaDict?: { [key: string]: ServizioRegolaVendita; } | null;
    costi?: CostoInfo[] | null;
    partenzeDict?: { [key: string]: Partenza; } | null;
    partenze?: Partenza[] | null;
    luoghi?: ServizioLuogo[] | null;
    associazioni?: ServizioAssociazioneInfo[] | null;
    associazioniOfferteComponibili?: ServizioAssociazioneInfo[] | null;
    giornaliero?: boolean;
    stelle?: number | null;
    escludiDaAutofill?: boolean;
    vicinoAeroporto?: boolean;
    haAttributiTestata?: boolean;
    haAttributiNoleggio?: boolean;
    attributiNoleggio?: ServizioDatoAggiuntivoInfo[] | null;
    haCategoria?: boolean;
    haNuovo?: boolean;
    haVantaggi?: boolean;
    haServizi?: boolean;
    datoAggiuntivoPenale?: ServizioDatoAggiuntivoInfo | null;
    aPartireDa?: number | null;
    isViaggiDelClub?: boolean;
    offerDestination?: DatoAggiuntivo | null;
    offerteDestinationCodice?: string | null;
    offerteDestinationNome?: string | null;
    offertaAPartireDa?: string | null;
    isOffertaViaggio?: boolean;
    datiAggiuntiviAutomazionePacchettiIDs?: number[] | null;
    datiAggiuntiviAutomazionePacchetti?: ServizioDatoAggiuntivoInfo[] | null;
    servDatiAggiuntivi?: ServizioDatoAggiuntivoInfo[] | null;
    datiAggiuntiviPenaleDefault?: ServizioDatoAggiuntivoInfo[] | null;
    prezzi?: PrezzoOfferta[] | null;
    isSpecialOffert?: boolean;
    rangeValiditaCosti?: ServizioValiditaCosti | null;
    mappa?: Mappa | null;
    sunto?: ArticoloInfo | null;
    articoli?: ArticoloInfo[] | null;
    articoliGiorni?: ArticoloInfo[] | null;
    srtNome_it?: string | null;
    srtNome_en?: string | null;
    srtNome_fr?: string | null;
    srtNome_de?: string | null;
    traduzioni?: IWebTranslationEntity[] | null;
    nome?: string | null;
    nome_en?: string | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean;
    confirmed_en?: boolean;
}

export class PrezzoOfferta implements IPrezzoOfferta {
    id?: number;
    offertaID?: number;
    data?: string;
    modalitaData?: EModalitaDataPrezzo;
    prezzoPersonaLand?: number;
    prezzoPersonaVoli?: number;
    aggiornato?: string | null;
    frequenzaAggiornamentoGiorni?: number | null;
    manuale?: boolean;
    prossimoCheck?: string | null;
    errore?: boolean;
    includiVoli?: boolean;

    constructor(data?: IPrezzoOfferta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
            this.modalitaData = _data["modalitaData"] !== undefined ? _data["modalitaData"] : null as any;
            this.prezzoPersonaLand = _data["prezzoPersonaLand"] !== undefined ? _data["prezzoPersonaLand"] : null as any;
            this.prezzoPersonaVoli = _data["prezzoPersonaVoli"] !== undefined ? _data["prezzoPersonaVoli"] : null as any;
            this.aggiornato = _data["aggiornato"] !== undefined ? _data["aggiornato"] : null as any;
            this.frequenzaAggiornamentoGiorni = _data["frequenzaAggiornamentoGiorni"] !== undefined ? _data["frequenzaAggiornamentoGiorni"] : null as any;
            this.manuale = _data["manuale"] !== undefined ? _data["manuale"] : null as any;
            this.prossimoCheck = _data["prossimoCheck"] !== undefined ? _data["prossimoCheck"] : null as any;
            this.errore = _data["errore"] !== undefined ? _data["errore"] : null as any;
            this.includiVoli = _data["includiVoli"] !== undefined ? _data["includiVoli"] : null as any;
        }
    }

    static fromJS(data: any): PrezzoOfferta {
        data = typeof data === 'object' ? data : {};
        let result = new PrezzoOfferta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["modalitaData"] = this.modalitaData !== undefined ? this.modalitaData : null as any;
        data["prezzoPersonaLand"] = this.prezzoPersonaLand !== undefined ? this.prezzoPersonaLand : null as any;
        data["prezzoPersonaVoli"] = this.prezzoPersonaVoli !== undefined ? this.prezzoPersonaVoli : null as any;
        data["aggiornato"] = this.aggiornato !== undefined ? this.aggiornato : null as any;
        data["frequenzaAggiornamentoGiorni"] = this.frequenzaAggiornamentoGiorni !== undefined ? this.frequenzaAggiornamentoGiorni : null as any;
        data["manuale"] = this.manuale !== undefined ? this.manuale : null as any;
        data["prossimoCheck"] = this.prossimoCheck !== undefined ? this.prossimoCheck : null as any;
        data["errore"] = this.errore !== undefined ? this.errore : null as any;
        data["includiVoli"] = this.includiVoli !== undefined ? this.includiVoli : null as any;
        return data;
    }
}

export interface IPrezzoOfferta {
    id?: number;
    offertaID?: number;
    data?: string;
    modalitaData?: EModalitaDataPrezzo;
    prezzoPersonaLand?: number;
    prezzoPersonaVoli?: number;
    aggiornato?: string | null;
    frequenzaAggiornamentoGiorni?: number | null;
    manuale?: boolean;
    prossimoCheck?: string | null;
    errore?: boolean;
    includiVoli?: boolean;
}

export enum EModalitaDataPrezzo {
    DataEsatta = "DataEsatta",
    Mese = "Mese",
}

export class ServizioRegolaScontoPacchetto implements IServizioRegolaScontoPacchetto {
    id?: number;
    servizioID?: number;
    itinerarioID?: number | null;
    servizioScontoID?: number | null;
    prenotaDal?: string | null;
    prenotaAl?: string | null;
    partenzaDal?: string | null;
    partenzaAl?: string | null;
    scontoServiziTerra?: number;
    scontoQuote?: number;
    scontoBloccaPrezzo?: number;
    nome?: string | null;
    ordine?: number;

    constructor(data?: IServizioRegolaScontoPacchetto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.itinerarioID = _data["itinerarioID"] !== undefined ? _data["itinerarioID"] : null as any;
            this.servizioScontoID = _data["servizioScontoID"] !== undefined ? _data["servizioScontoID"] : null as any;
            this.prenotaDal = _data["prenotaDal"] !== undefined ? _data["prenotaDal"] : null as any;
            this.prenotaAl = _data["prenotaAl"] !== undefined ? _data["prenotaAl"] : null as any;
            this.partenzaDal = _data["partenzaDal"] !== undefined ? _data["partenzaDal"] : null as any;
            this.partenzaAl = _data["partenzaAl"] !== undefined ? _data["partenzaAl"] : null as any;
            this.scontoServiziTerra = _data["scontoServiziTerra"] !== undefined ? _data["scontoServiziTerra"] : null as any;
            this.scontoQuote = _data["scontoQuote"] !== undefined ? _data["scontoQuote"] : null as any;
            this.scontoBloccaPrezzo = _data["scontoBloccaPrezzo"] !== undefined ? _data["scontoBloccaPrezzo"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
        }
    }

    static fromJS(data: any): ServizioRegolaScontoPacchetto {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioRegolaScontoPacchetto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["itinerarioID"] = this.itinerarioID !== undefined ? this.itinerarioID : null as any;
        data["servizioScontoID"] = this.servizioScontoID !== undefined ? this.servizioScontoID : null as any;
        data["prenotaDal"] = this.prenotaDal !== undefined ? this.prenotaDal : null as any;
        data["prenotaAl"] = this.prenotaAl !== undefined ? this.prenotaAl : null as any;
        data["partenzaDal"] = this.partenzaDal !== undefined ? this.partenzaDal : null as any;
        data["partenzaAl"] = this.partenzaAl !== undefined ? this.partenzaAl : null as any;
        data["scontoServiziTerra"] = this.scontoServiziTerra !== undefined ? this.scontoServiziTerra : null as any;
        data["scontoQuote"] = this.scontoQuote !== undefined ? this.scontoQuote : null as any;
        data["scontoBloccaPrezzo"] = this.scontoBloccaPrezzo !== undefined ? this.scontoBloccaPrezzo : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        return data;
    }
}

export interface IServizioRegolaScontoPacchetto {
    id?: number;
    servizioID?: number;
    itinerarioID?: number | null;
    servizioScontoID?: number | null;
    prenotaDal?: string | null;
    prenotaAl?: string | null;
    partenzaDal?: string | null;
    partenzaAl?: string | null;
    scontoServiziTerra?: number;
    scontoQuote?: number;
    scontoBloccaPrezzo?: number;
    nome?: string | null;
    ordine?: number;
}

export class MediaInfo implements IMediaInfo {
    media?: Media;
    id?: number;
    label?: MediaLabel;
    thumbnails?: MediaThumb[];
    locationLinks?: LocationMediaLinkInfo[];
    serviceLinks?: ServiceMediaLinkInfo[];
    allLinks?: MediaLinkInfo[];
    hasValidLabel?: boolean;
    linkedFile?: AzureBlobFileInfo;
    url?: string;

    constructor(data?: IMediaInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.media = _data["media"] ? Media.fromJS(_data["media"]) : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.label = _data["label"] ? MediaLabel.fromJS(_data["label"]) : null as any;
            if (Array.isArray(_data["thumbnails"])) {
                this.thumbnails = [] as any;
                for (let item of _data["thumbnails"])
                    this.thumbnails!.push(MediaThumb.fromJS(item));
            }
            else {
                this.thumbnails = null as any;
            }
            if (Array.isArray(_data["locationLinks"])) {
                this.locationLinks = [] as any;
                for (let item of _data["locationLinks"])
                    this.locationLinks!.push(LocationMediaLinkInfo.fromJS(item));
            }
            else {
                this.locationLinks = null as any;
            }
            if (Array.isArray(_data["serviceLinks"])) {
                this.serviceLinks = [] as any;
                for (let item of _data["serviceLinks"])
                    this.serviceLinks!.push(ServiceMediaLinkInfo.fromJS(item));
            }
            else {
                this.serviceLinks = null as any;
            }
            if (Array.isArray(_data["allLinks"])) {
                this.allLinks = [] as any;
                for (let item of _data["allLinks"])
                    this.allLinks!.push(MediaLinkInfo.fromJS(item));
            }
            else {
                this.allLinks = null as any;
            }
            this.hasValidLabel = _data["hasValidLabel"] !== undefined ? _data["hasValidLabel"] : null as any;
            this.linkedFile = _data["linkedFile"] ? AzureBlobFileInfo.fromJS(_data["linkedFile"]) : null as any;
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
        }
    }

    static fromJS(data: any): MediaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MediaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["media"] = this.media ? this.media.toJSON() : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["label"] = this.label ? this.label.toJSON() : null as any;
        if (Array.isArray(this.thumbnails)) {
            data["thumbnails"] = [];
            for (let item of this.thumbnails)
                data["thumbnails"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.locationLinks)) {
            data["locationLinks"] = [];
            for (let item of this.locationLinks)
                data["locationLinks"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.serviceLinks)) {
            data["serviceLinks"] = [];
            for (let item of this.serviceLinks)
                data["serviceLinks"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.allLinks)) {
            data["allLinks"] = [];
            for (let item of this.allLinks)
                data["allLinks"].push(item ? item.toJSON() : null as any);
        }
        data["hasValidLabel"] = this.hasValidLabel !== undefined ? this.hasValidLabel : null as any;
        data["linkedFile"] = this.linkedFile ? this.linkedFile.toJSON() : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        return data;
    }
}

export interface IMediaInfo {
    media?: Media;
    id?: number;
    label?: MediaLabel;
    thumbnails?: MediaThumb[];
    locationLinks?: LocationMediaLinkInfo[];
    serviceLinks?: ServiceMediaLinkInfo[];
    allLinks?: MediaLinkInfo[];
    hasValidLabel?: boolean;
    linkedFile?: AzureBlobFileInfo;
    url?: string;
}

export class Media implements IMedia {
    id?: number;
    labelId?: number | null;
    type?: EMediaType;
    path?: string | null;
    hash?: string | null;
    updatedAt?: string;
    deleted?: boolean;

    constructor(data?: IMedia) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.labelId = _data["labelId"] !== undefined ? _data["labelId"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.path = _data["path"] !== undefined ? _data["path"] : null as any;
            this.hash = _data["hash"] !== undefined ? _data["hash"] : null as any;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : null as any;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : null as any;
        }
    }

    static fromJS(data: any): Media {
        data = typeof data === 'object' ? data : {};
        let result = new Media();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["labelId"] = this.labelId !== undefined ? this.labelId : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["path"] = this.path !== undefined ? this.path : null as any;
        data["hash"] = this.hash !== undefined ? this.hash : null as any;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : null as any;
        data["deleted"] = this.deleted !== undefined ? this.deleted : null as any;
        return data;
    }
}

export interface IMedia {
    id?: number;
    labelId?: number | null;
    type?: EMediaType;
    path?: string | null;
    hash?: string | null;
    updatedAt?: string;
    deleted?: boolean;
}

export enum EMediaType {
    Photo = "Photo",
}

export class MediaThumb implements IMediaThumb {
    id?: number;
    mediaId?: number;
    width?: number;
    height?: number;
    path?: string | null;
    deleted?: boolean;

    constructor(data?: IMediaThumb) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.mediaId = _data["mediaId"] !== undefined ? _data["mediaId"] : null as any;
            this.width = _data["width"] !== undefined ? _data["width"] : null as any;
            this.height = _data["height"] !== undefined ? _data["height"] : null as any;
            this.path = _data["path"] !== undefined ? _data["path"] : null as any;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : null as any;
        }
    }

    static fromJS(data: any): MediaThumb {
        data = typeof data === 'object' ? data : {};
        let result = new MediaThumb();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["mediaId"] = this.mediaId !== undefined ? this.mediaId : null as any;
        data["width"] = this.width !== undefined ? this.width : null as any;
        data["height"] = this.height !== undefined ? this.height : null as any;
        data["path"] = this.path !== undefined ? this.path : null as any;
        data["deleted"] = this.deleted !== undefined ? this.deleted : null as any;
        return data;
    }
}

export interface IMediaThumb {
    id?: number;
    mediaId?: number;
    width?: number;
    height?: number;
    path?: string | null;
    deleted?: boolean;
}

export class MediaLink implements IMediaLink {
    id?: number;
    mediaId?: number;
    tableName?: string | null;
    entityId?: number;
    sortOrder?: number | null;

    constructor(data?: IMediaLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.mediaId = _data["mediaId"] !== undefined ? _data["mediaId"] : null as any;
            this.tableName = _data["tableName"] !== undefined ? _data["tableName"] : null as any;
            this.entityId = _data["entityId"] !== undefined ? _data["entityId"] : null as any;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null as any;
        }
    }

    static fromJS(data: any): MediaLink {
        data = typeof data === 'object' ? data : {};
        let result = new MediaLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["mediaId"] = this.mediaId !== undefined ? this.mediaId : null as any;
        data["tableName"] = this.tableName !== undefined ? this.tableName : null as any;
        data["entityId"] = this.entityId !== undefined ? this.entityId : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        return data;
    }
}

export interface IMediaLink {
    id?: number;
    mediaId?: number;
    tableName?: string | null;
    entityId?: number;
    sortOrder?: number | null;
}

export abstract class MediaLinkInfo extends MediaLink implements IMediaLinkInfo {

    constructor(data?: IMediaLinkInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MediaLinkInfo {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MediaLinkInfo' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMediaLinkInfo extends IMediaLink {
}

export class LocationMediaLinkInfo extends MediaLinkInfo implements ILocationMediaLinkInfo {
    luogo?: LuogoInfo | null;

    constructor(data?: ILocationMediaLinkInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogo = _data["luogo"] ? LuogoInfo.fromJS(_data["luogo"]) : null as any;
        }
    }

    static override fromJS(data: any): LocationMediaLinkInfo {
        data = typeof data === 'object' ? data : {};
        let result = new LocationMediaLinkInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogo"] = this.luogo ? this.luogo.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ILocationMediaLinkInfo extends IMediaLinkInfo {
    luogo?: LuogoInfo | null;
}

export class ServiceMediaLinkInfo extends MediaLinkInfo implements IServiceMediaLinkInfo {
    servizio?: ServizioInfo | null;

    constructor(data?: IServiceMediaLinkInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizio = _data["servizio"] ? ServizioInfo.fromJS(_data["servizio"]) : null as any;
        }
    }

    static override fromJS(data: any): ServiceMediaLinkInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceMediaLinkInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio ? this.servizio.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IServiceMediaLinkInfo extends IMediaLinkInfo {
    servizio?: ServizioInfo | null;
}

export abstract class FileInfoBase implements IFileInfoBase {
    extension?: string;
    contentType?: string;
    isPdf?: boolean;
    canGetAsPdf?: boolean;

    constructor(data?: IFileInfoBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.extension = _data["extension"] !== undefined ? _data["extension"] : null as any;
            this.contentType = _data["contentType"] !== undefined ? _data["contentType"] : null as any;
            this.isPdf = _data["isPdf"] !== undefined ? _data["isPdf"] : null as any;
            this.canGetAsPdf = _data["canGetAsPdf"] !== undefined ? _data["canGetAsPdf"] : null as any;
        }
    }

    static fromJS(data: any): FileInfoBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'FileInfoBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extension"] = this.extension !== undefined ? this.extension : null as any;
        data["contentType"] = this.contentType !== undefined ? this.contentType : null as any;
        data["isPdf"] = this.isPdf !== undefined ? this.isPdf : null as any;
        data["canGetAsPdf"] = this.canGetAsPdf !== undefined ? this.canGetAsPdf : null as any;
        return data;
    }
}

export interface IFileInfoBase {
    extension?: string;
    contentType?: string;
    isPdf?: boolean;
    canGetAsPdf?: boolean;
}

export class AzureBlobFileInfo extends FileInfoBase implements IAzureBlobFileInfo {
    remotePath?: string;
    exists?: boolean;
    publicUrl?: string | null;
    privateUrl?: string | null;
    name?: string;
    size?: number;
    fileType?: EFileType;

    constructor(data?: IAzureBlobFileInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.remotePath = _data["remotePath"] !== undefined ? _data["remotePath"] : null as any;
            this.exists = _data["exists"] !== undefined ? _data["exists"] : null as any;
            this.publicUrl = _data["publicUrl"] !== undefined ? _data["publicUrl"] : null as any;
            this.privateUrl = _data["privateUrl"] !== undefined ? _data["privateUrl"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.size = _data["size"] !== undefined ? _data["size"] : null as any;
            this.fileType = _data["fileType"] !== undefined ? _data["fileType"] : null as any;
        }
    }

    static override fromJS(data: any): AzureBlobFileInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AzureBlobFileInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["remotePath"] = this.remotePath !== undefined ? this.remotePath : null as any;
        data["exists"] = this.exists !== undefined ? this.exists : null as any;
        data["publicUrl"] = this.publicUrl !== undefined ? this.publicUrl : null as any;
        data["privateUrl"] = this.privateUrl !== undefined ? this.privateUrl : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["size"] = this.size !== undefined ? this.size : null as any;
        data["fileType"] = this.fileType !== undefined ? this.fileType : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAzureBlobFileInfo extends IFileInfoBase {
    remotePath?: string;
    exists?: boolean;
    publicUrl?: string | null;
    privateUrl?: string | null;
    name?: string;
    size?: number;
    fileType?: EFileType;
}

export enum EFileType {
    Document = "Document",
    Attachment = "Attachment",
    SharedDoc = "SharedDoc",
    Logo = "Logo",
    Media = "Media",
    Guide = "Guide",
    Temporary = "Temporary",
    TaskLogFileAttachment = "TaskLogFileAttachment",
    NaarGoAttachment = "NaarGoAttachment",
    AIChatAttachment = "AIChatAttachment",
}

export class ServizioTipologiaInfo implements IServizioTipologiaInfo {
    id?: number;
    tipologia?: ServizioTipologia | null;
    isSupplemento?: boolean;
    isObbligatorio?: boolean;
    prezzoMinimo?: number | null;
    aPartireDa?: PrezzoMin[] | null;
    nomeNormalized?: string | null;
    tipologiaStandard?: ServizioTipologiaStandardInfo | null;
    itinerario?: ServizioItinerarioInfo | null;
    richiedeCreazioneItinerario?: boolean;
    supplementoRiduzione?: ESupplementoRiduzione;
    orarioInizio?: OreMinuti | null;
    orarioFine?: OreMinuti | null;

    constructor(data?: IServizioTipologiaInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.tipologia = _data["tipologia"] ? ServizioTipologia.fromJS(_data["tipologia"]) : null as any;
            this.isSupplemento = _data["isSupplemento"] !== undefined ? _data["isSupplemento"] : null as any;
            this.isObbligatorio = _data["isObbligatorio"] !== undefined ? _data["isObbligatorio"] : null as any;
            this.prezzoMinimo = _data["prezzoMinimo"] !== undefined ? _data["prezzoMinimo"] : null as any;
            if (Array.isArray(_data["aPartireDa"])) {
                this.aPartireDa = [] as any;
                for (let item of _data["aPartireDa"])
                    this.aPartireDa!.push(PrezzoMin.fromJS(item));
            }
            else {
                this.aPartireDa = null as any;
            }
            this.nomeNormalized = _data["nomeNormalized"] !== undefined ? _data["nomeNormalized"] : null as any;
            this.tipologiaStandard = _data["tipologiaStandard"] ? ServizioTipologiaStandardInfo.fromJS(_data["tipologiaStandard"]) : null as any;
            this.itinerario = _data["itinerario"] ? ServizioItinerarioInfo.fromJS(_data["itinerario"]) : null as any;
            this.richiedeCreazioneItinerario = _data["richiedeCreazioneItinerario"] !== undefined ? _data["richiedeCreazioneItinerario"] : null as any;
            this.supplementoRiduzione = _data["supplementoRiduzione"] !== undefined ? _data["supplementoRiduzione"] : null as any;
            this.orarioInizio = _data["orarioInizio"] ? OreMinuti.fromJS(_data["orarioInizio"]) : null as any;
            this.orarioFine = _data["orarioFine"] ? OreMinuti.fromJS(_data["orarioFine"]) : null as any;
        }
    }

    static fromJS(data: any): ServizioTipologiaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioTipologiaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["tipologia"] = this.tipologia ? this.tipologia.toJSON() : null as any;
        data["isSupplemento"] = this.isSupplemento !== undefined ? this.isSupplemento : null as any;
        data["isObbligatorio"] = this.isObbligatorio !== undefined ? this.isObbligatorio : null as any;
        data["prezzoMinimo"] = this.prezzoMinimo !== undefined ? this.prezzoMinimo : null as any;
        if (Array.isArray(this.aPartireDa)) {
            data["aPartireDa"] = [];
            for (let item of this.aPartireDa)
                data["aPartireDa"].push(item ? item.toJSON() : null as any);
        }
        data["nomeNormalized"] = this.nomeNormalized !== undefined ? this.nomeNormalized : null as any;
        data["tipologiaStandard"] = this.tipologiaStandard ? this.tipologiaStandard.toJSON() : null as any;
        data["itinerario"] = this.itinerario ? this.itinerario.toJSON() : null as any;
        data["richiedeCreazioneItinerario"] = this.richiedeCreazioneItinerario !== undefined ? this.richiedeCreazioneItinerario : null as any;
        data["supplementoRiduzione"] = this.supplementoRiduzione !== undefined ? this.supplementoRiduzione : null as any;
        data["orarioInizio"] = this.orarioInizio ? this.orarioInizio.toJSON() : null as any;
        data["orarioFine"] = this.orarioFine ? this.orarioFine.toJSON() : null as any;
        return data;
    }
}

export interface IServizioTipologiaInfo {
    id?: number;
    tipologia?: ServizioTipologia | null;
    isSupplemento?: boolean;
    isObbligatorio?: boolean;
    prezzoMinimo?: number | null;
    aPartireDa?: PrezzoMin[] | null;
    nomeNormalized?: string | null;
    tipologiaStandard?: ServizioTipologiaStandardInfo | null;
    itinerario?: ServizioItinerarioInfo | null;
    richiedeCreazioneItinerario?: boolean;
    supplementoRiduzione?: ESupplementoRiduzione;
    orarioInizio?: OreMinuti | null;
    orarioFine?: OreMinuti | null;
}

export abstract class ServizioTipologiaBase implements IServizioTipologiaBase {
    servizioTipologiaID?: number;
    servizioID?: number;
    tipologiaStandardID?: number | null;
    paramsJson?: string | null;
    orarioInizio?: string | null;
    puntoInizio?: string | null;
    orarioFine?: string | null;
    puntoFine?: string | null;
    tipoSupplemento?: ETipoSupplemento | null;
    supplementoRiduzione?: ESupplementoRiduzione | null;

    constructor(data?: IServizioTipologiaBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servizioTipologiaID = _data["servizioTipologiaID"] !== undefined ? _data["servizioTipologiaID"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.tipologiaStandardID = _data["tipologiaStandardID"] !== undefined ? _data["tipologiaStandardID"] : null as any;
            this.paramsJson = _data["paramsJson"] !== undefined ? _data["paramsJson"] : null as any;
            this.orarioInizio = _data["orarioInizio"] !== undefined ? _data["orarioInizio"] : null as any;
            this.puntoInizio = _data["puntoInizio"] !== undefined ? _data["puntoInizio"] : null as any;
            this.orarioFine = _data["orarioFine"] !== undefined ? _data["orarioFine"] : null as any;
            this.puntoFine = _data["puntoFine"] !== undefined ? _data["puntoFine"] : null as any;
            this.tipoSupplemento = _data["tipoSupplemento"] !== undefined ? _data["tipoSupplemento"] : null as any;
            this.supplementoRiduzione = _data["supplementoRiduzione"] !== undefined ? _data["supplementoRiduzione"] : null as any;
        }
    }

    static fromJS(data: any): ServizioTipologiaBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ServizioTipologiaBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioTipologiaID"] = this.servizioTipologiaID !== undefined ? this.servizioTipologiaID : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["tipologiaStandardID"] = this.tipologiaStandardID !== undefined ? this.tipologiaStandardID : null as any;
        data["paramsJson"] = this.paramsJson !== undefined ? this.paramsJson : null as any;
        data["orarioInizio"] = this.orarioInizio !== undefined ? this.orarioInizio : null as any;
        data["puntoInizio"] = this.puntoInizio !== undefined ? this.puntoInizio : null as any;
        data["orarioFine"] = this.orarioFine !== undefined ? this.orarioFine : null as any;
        data["puntoFine"] = this.puntoFine !== undefined ? this.puntoFine : null as any;
        data["tipoSupplemento"] = this.tipoSupplemento !== undefined ? this.tipoSupplemento : null as any;
        data["supplementoRiduzione"] = this.supplementoRiduzione !== undefined ? this.supplementoRiduzione : null as any;
        return data;
    }
}

export interface IServizioTipologiaBase {
    servizioTipologiaID?: number;
    servizioID?: number;
    tipologiaStandardID?: number | null;
    paramsJson?: string | null;
    orarioInizio?: string | null;
    puntoInizio?: string | null;
    orarioFine?: string | null;
    puntoFine?: string | null;
    tipoSupplemento?: ETipoSupplemento | null;
    supplementoRiduzione?: ESupplementoRiduzione | null;
}

export class ServizioTipologia extends ServizioTipologiaBase implements IServizioTipologia {
    contattoVoucherID?: number | null;
    nome?: string | null;
    nomeVoucher?: string | null;
    nomeSecondario?: string | null;
    nomeSecondarioVoucher?: string | null;
    verificaPartenze?: boolean;
    supplementoPercentuale?: boolean | null;
    itinerarioID?: number | null;
    ordine?: number | null;
    obbligatorio?: EObbligatorieta | null;
    alternativa?: number | null;
    interno?: boolean | null;
    costoPerPersona?: boolean;
    costoPerGiorno?: boolean | null;
    supplementoSuRichiesta?: boolean | null;
    selezionePax?: boolean | null;
    condividi?: boolean | null;
    memo?: string | null;
    contattoInizioID?: number | null;
    contattoInizio?: Contatto | null;
    contattoFineID?: number | null;
    contattoFine?: Contatto | null;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    deleted?: string | null;
    regolaPacchettoID?: number | null;
    languages?: ELingua[] | null;
    tipoTipologia?: ETipoSupplemento;

    constructor(data?: IServizioTipologia) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoVoucherID = _data["contattoVoucherID"] !== undefined ? _data["contattoVoucherID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nomeVoucher = _data["nomeVoucher"] !== undefined ? _data["nomeVoucher"] : null as any;
            this.nomeSecondario = _data["nomeSecondario"] !== undefined ? _data["nomeSecondario"] : null as any;
            this.nomeSecondarioVoucher = _data["nomeSecondarioVoucher"] !== undefined ? _data["nomeSecondarioVoucher"] : null as any;
            this.verificaPartenze = _data["verificaPartenze"] !== undefined ? _data["verificaPartenze"] : null as any;
            this.supplementoPercentuale = _data["supplementoPercentuale"] !== undefined ? _data["supplementoPercentuale"] : null as any;
            this.itinerarioID = _data["itinerarioID"] !== undefined ? _data["itinerarioID"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.obbligatorio = _data["obbligatorio"] !== undefined ? _data["obbligatorio"] : null as any;
            this.alternativa = _data["alternativa"] !== undefined ? _data["alternativa"] : null as any;
            this.interno = _data["interno"] !== undefined ? _data["interno"] : null as any;
            this.costoPerPersona = _data["costoPerPersona"] !== undefined ? _data["costoPerPersona"] : null as any;
            this.costoPerGiorno = _data["costoPerGiorno"] !== undefined ? _data["costoPerGiorno"] : null as any;
            this.supplementoSuRichiesta = _data["supplementoSuRichiesta"] !== undefined ? _data["supplementoSuRichiesta"] : null as any;
            this.selezionePax = _data["selezionePax"] !== undefined ? _data["selezionePax"] : null as any;
            this.condividi = _data["condividi"] !== undefined ? _data["condividi"] : null as any;
            this.memo = _data["memo"] !== undefined ? _data["memo"] : null as any;
            this.contattoInizioID = _data["contattoInizioID"] !== undefined ? _data["contattoInizioID"] : null as any;
            this.contattoInizio = _data["contattoInizio"] ? Contatto.fromJS(_data["contattoInizio"]) : null as any;
            this.contattoFineID = _data["contattoFineID"] !== undefined ? _data["contattoFineID"] : null as any;
            this.contattoFine = _data["contattoFine"] ? Contatto.fromJS(_data["contattoFine"]) : null as any;
            this.nome_fr = _data["nome_fr"] !== undefined ? _data["nome_fr"] : null as any;
            this.nome_de = _data["nome_de"] !== undefined ? _data["nome_de"] : null as any;
            this.nome_es = _data["nome_es"] !== undefined ? _data["nome_es"] : null as any;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : null as any;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : null as any;
            this.regolaPacchettoID = _data["regolaPacchettoID"] !== undefined ? _data["regolaPacchettoID"] : null as any;
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(item);
            }
            else {
                this.languages = null as any;
            }
            this.tipoTipologia = _data["tipoTipologia"] !== undefined ? _data["tipoTipologia"] : null as any;
        }
    }

    static override fromJS(data: any): ServizioTipologia {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioTipologia();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoVoucherID"] = this.contattoVoucherID !== undefined ? this.contattoVoucherID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nomeVoucher"] = this.nomeVoucher !== undefined ? this.nomeVoucher : null as any;
        data["nomeSecondario"] = this.nomeSecondario !== undefined ? this.nomeSecondario : null as any;
        data["nomeSecondarioVoucher"] = this.nomeSecondarioVoucher !== undefined ? this.nomeSecondarioVoucher : null as any;
        data["verificaPartenze"] = this.verificaPartenze !== undefined ? this.verificaPartenze : null as any;
        data["supplementoPercentuale"] = this.supplementoPercentuale !== undefined ? this.supplementoPercentuale : null as any;
        data["itinerarioID"] = this.itinerarioID !== undefined ? this.itinerarioID : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["obbligatorio"] = this.obbligatorio !== undefined ? this.obbligatorio : null as any;
        data["alternativa"] = this.alternativa !== undefined ? this.alternativa : null as any;
        data["interno"] = this.interno !== undefined ? this.interno : null as any;
        data["costoPerPersona"] = this.costoPerPersona !== undefined ? this.costoPerPersona : null as any;
        data["costoPerGiorno"] = this.costoPerGiorno !== undefined ? this.costoPerGiorno : null as any;
        data["supplementoSuRichiesta"] = this.supplementoSuRichiesta !== undefined ? this.supplementoSuRichiesta : null as any;
        data["selezionePax"] = this.selezionePax !== undefined ? this.selezionePax : null as any;
        data["condividi"] = this.condividi !== undefined ? this.condividi : null as any;
        data["memo"] = this.memo !== undefined ? this.memo : null as any;
        data["contattoInizioID"] = this.contattoInizioID !== undefined ? this.contattoInizioID : null as any;
        data["contattoInizio"] = this.contattoInizio ? this.contattoInizio.toJSON() : null as any;
        data["contattoFineID"] = this.contattoFineID !== undefined ? this.contattoFineID : null as any;
        data["contattoFine"] = this.contattoFine ? this.contattoFine.toJSON() : null as any;
        data["nome_fr"] = this.nome_fr !== undefined ? this.nome_fr : null as any;
        data["nome_de"] = this.nome_de !== undefined ? this.nome_de : null as any;
        data["nome_es"] = this.nome_es !== undefined ? this.nome_es : null as any;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : null as any;
        data["deleted"] = this.deleted !== undefined ? this.deleted : null as any;
        data["regolaPacchettoID"] = this.regolaPacchettoID !== undefined ? this.regolaPacchettoID : null as any;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item);
        }
        data["tipoTipologia"] = this.tipoTipologia !== undefined ? this.tipoTipologia : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IServizioTipologia extends IServizioTipologiaBase {
    contattoVoucherID?: number | null;
    nome?: string | null;
    nomeVoucher?: string | null;
    nomeSecondario?: string | null;
    nomeSecondarioVoucher?: string | null;
    verificaPartenze?: boolean;
    supplementoPercentuale?: boolean | null;
    itinerarioID?: number | null;
    ordine?: number | null;
    obbligatorio?: EObbligatorieta | null;
    alternativa?: number | null;
    interno?: boolean | null;
    costoPerPersona?: boolean;
    costoPerGiorno?: boolean | null;
    supplementoSuRichiesta?: boolean | null;
    selezionePax?: boolean | null;
    condividi?: boolean | null;
    memo?: string | null;
    contattoInizioID?: number | null;
    contattoInizio?: Contatto | null;
    contattoFineID?: number | null;
    contattoFine?: Contatto | null;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    deleted?: string | null;
    regolaPacchettoID?: number | null;
    languages?: ELingua[] | null;
    tipoTipologia?: ETipoSupplemento;
}

export enum EObbligatorieta {
    Facoltativo = "Facoltativo",
    Obbligatorio = "Obbligatorio",
}

export enum ETipoSupplemento {
    Nessuno = "Nessuno",
    Ignoto = "Ignoto",
    OfferteRid = "OfferteRid",
    Pasti = "Pasti",
    Camera = "Camera",
    Trasferimenti = "Trasferimenti",
    Visite = "Visite",
    Appartamento = "Appartamento",
    LettoAggiunto = "LettoAggiunto",
    Supplemento = "Supplemento",
}

export enum ESupplementoRiduzione {
    Nessuno = "Nessuno",
    Supplemento = "Supplemento",
    Riduzione = "Riduzione",
    DaPagareInLoco = "DaPagareInLoco",
    GratisDaPrenotare = "GratisDaPrenotare",
}

export class PrezzoMin implements IPrezzoMin {
    servizioID?: number;
    servizioTipologiaID?: number;
    trattamentoID?: number | null;
    prezzoMinimo?: number;

    constructor(data?: IPrezzoMin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.servizioTipologiaID = _data["servizioTipologiaID"] !== undefined ? _data["servizioTipologiaID"] : null as any;
            this.trattamentoID = _data["trattamentoID"] !== undefined ? _data["trattamentoID"] : null as any;
            this.prezzoMinimo = _data["prezzoMinimo"] !== undefined ? _data["prezzoMinimo"] : null as any;
        }
    }

    static fromJS(data: any): PrezzoMin {
        data = typeof data === 'object' ? data : {};
        let result = new PrezzoMin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["servizioTipologiaID"] = this.servizioTipologiaID !== undefined ? this.servizioTipologiaID : null as any;
        data["trattamentoID"] = this.trattamentoID !== undefined ? this.trattamentoID : null as any;
        data["prezzoMinimo"] = this.prezzoMinimo !== undefined ? this.prezzoMinimo : null as any;
        return data;
    }
}

export interface IPrezzoMin {
    servizioID?: number;
    servizioTipologiaID?: number;
    trattamentoID?: number | null;
    prezzoMinimo?: number;
}

export class ServizioTipologiaStandardInfo implements IServizioTipologiaStandardInfo {
    id?: number;
    tipologiaStandard?: ServizioTipologiaStandard | null;
    traduzioni?: IWebTranslationEntity[] | null;
    nome?: string | null;
    nome_en?: string | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean;
    confirmed_en?: boolean;
    table?: string | null;

    constructor(data?: IServizioTipologiaStandardInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.tipologiaStandard = _data["tipologiaStandard"] ? ServizioTipologiaStandard.fromJS(_data["tipologiaStandard"]) : null as any;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(IWebTranslationEntity.fromJS(item));
            }
            else {
                this.traduzioni = null as any;
            }
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : null as any;
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : null as any;
            this.lastUpdate_en = _data["lastUpdate_en"] !== undefined ? _data["lastUpdate_en"] : null as any;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : null as any;
            this.confirmed_en = _data["confirmed_en"] !== undefined ? _data["confirmed_en"] : null as any;
            this.table = _data["table"] !== undefined ? _data["table"] : null as any;
        }
    }

    static fromJS(data: any): ServizioTipologiaStandardInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioTipologiaStandardInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["tipologiaStandard"] = this.tipologiaStandard ? this.tipologiaStandard.toJSON() : null as any;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item ? item.toJSON() : null as any);
        }
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : null as any;
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : null as any;
        data["lastUpdate_en"] = this.lastUpdate_en !== undefined ? this.lastUpdate_en : null as any;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : null as any;
        data["confirmed_en"] = this.confirmed_en !== undefined ? this.confirmed_en : null as any;
        data["table"] = this.table !== undefined ? this.table : null as any;
        return data;
    }
}

export interface IServizioTipologiaStandardInfo {
    id?: number;
    tipologiaStandard?: ServizioTipologiaStandard | null;
    traduzioni?: IWebTranslationEntity[] | null;
    nome?: string | null;
    nome_en?: string | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean;
    confirmed_en?: boolean;
    table?: string | null;
}

export abstract class IWebTranslationEntity implements IIWebTranslationEntity {
    id?: number;
    table?: string;
    entityID?: number;
    lang?: ELingua;
    culture?: string | null;
    translation?: string;
    lastUpdate?: string | null;
    confirmed?: boolean | null;

    constructor(data?: IIWebTranslationEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.table = _data["table"] !== undefined ? _data["table"] : null as any;
            this.entityID = _data["entityID"] !== undefined ? _data["entityID"] : null as any;
            this.lang = _data["lang"] !== undefined ? _data["lang"] : null as any;
            this.culture = _data["culture"] !== undefined ? _data["culture"] : null as any;
            this.translation = _data["translation"] !== undefined ? _data["translation"] : null as any;
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : null as any;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : null as any;
        }
    }

    static fromJS(data: any): IWebTranslationEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IWebTranslationEntity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["table"] = this.table !== undefined ? this.table : null as any;
        data["entityID"] = this.entityID !== undefined ? this.entityID : null as any;
        data["lang"] = this.lang !== undefined ? this.lang : null as any;
        data["culture"] = this.culture !== undefined ? this.culture : null as any;
        data["translation"] = this.translation !== undefined ? this.translation : null as any;
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : null as any;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : null as any;
        return data;
    }
}

export interface IIWebTranslationEntity {
    id?: number;
    table?: string;
    entityID?: number;
    lang?: ELingua;
    culture?: string | null;
    translation?: string;
    lastUpdate?: string | null;
    confirmed?: boolean | null;
}

export class ServizioItinerarioInfo implements IServizioItinerarioInfo {
    id?: number;
    servizioItinerario?: ServizioItinerario | null;
    numeroGiorni?: number;
    numeroNotti?: number;
    giorni?: ServizioItinerarioGiornoInfo[] | null;
    departureAirports?: string[] | null;
    destinazione?: string | null;
    airlines?: string[] | null;

    constructor(data?: IServizioItinerarioInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.servizioItinerario = _data["servizioItinerario"] ? ServizioItinerario.fromJS(_data["servizioItinerario"]) : null as any;
            this.numeroGiorni = _data["numeroGiorni"] !== undefined ? _data["numeroGiorni"] : null as any;
            this.numeroNotti = _data["numeroNotti"] !== undefined ? _data["numeroNotti"] : null as any;
            if (Array.isArray(_data["giorni"])) {
                this.giorni = [] as any;
                for (let item of _data["giorni"])
                    this.giorni!.push(ServizioItinerarioGiornoInfo.fromJS(item));
            }
            else {
                this.giorni = null as any;
            }
            if (Array.isArray(_data["departureAirports"])) {
                this.departureAirports = [] as any;
                for (let item of _data["departureAirports"])
                    this.departureAirports!.push(item);
            }
            else {
                this.departureAirports = null as any;
            }
            this.destinazione = _data["destinazione"] !== undefined ? _data["destinazione"] : null as any;
            if (Array.isArray(_data["airlines"])) {
                this.airlines = [] as any;
                for (let item of _data["airlines"])
                    this.airlines!.push(item);
            }
            else {
                this.airlines = null as any;
            }
        }
    }

    static fromJS(data: any): ServizioItinerarioInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioItinerarioInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["servizioItinerario"] = this.servizioItinerario ? this.servizioItinerario.toJSON() : null as any;
        data["numeroGiorni"] = this.numeroGiorni !== undefined ? this.numeroGiorni : null as any;
        data["numeroNotti"] = this.numeroNotti !== undefined ? this.numeroNotti : null as any;
        if (Array.isArray(this.giorni)) {
            data["giorni"] = [];
            for (let item of this.giorni)
                data["giorni"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.departureAirports)) {
            data["departureAirports"] = [];
            for (let item of this.departureAirports)
                data["departureAirports"].push(item);
        }
        data["destinazione"] = this.destinazione !== undefined ? this.destinazione : null as any;
        if (Array.isArray(this.airlines)) {
            data["airlines"] = [];
            for (let item of this.airlines)
                data["airlines"].push(item);
        }
        return data;
    }
}

export interface IServizioItinerarioInfo {
    id?: number;
    servizioItinerario?: ServizioItinerario | null;
    numeroGiorni?: number;
    numeroNotti?: number;
    giorni?: ServizioItinerarioGiornoInfo[] | null;
    departureAirports?: string[] | null;
    destinazione?: string | null;
    airlines?: string[] | null;
}

export class ServizioItinerario implements IServizioItinerario {
    itinerarioID?: number;
    servizioID?: number;
    nome!: string;
    memo?: string | null;
    departureAirports?: string[] | null;
    destinazione?: string | null;
    airlines?: string[] | null;

    constructor(data?: IServizioItinerario) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itinerarioID = _data["itinerarioID"] !== undefined ? _data["itinerarioID"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.memo = _data["memo"] !== undefined ? _data["memo"] : null as any;
            if (Array.isArray(_data["departureAirports"])) {
                this.departureAirports = [] as any;
                for (let item of _data["departureAirports"])
                    this.departureAirports!.push(item);
            }
            else {
                this.departureAirports = null as any;
            }
            this.destinazione = _data["destinazione"] !== undefined ? _data["destinazione"] : null as any;
            if (Array.isArray(_data["airlines"])) {
                this.airlines = [] as any;
                for (let item of _data["airlines"])
                    this.airlines!.push(item);
            }
            else {
                this.airlines = null as any;
            }
        }
    }

    static fromJS(data: any): ServizioItinerario {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioItinerario();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itinerarioID"] = this.itinerarioID !== undefined ? this.itinerarioID : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["memo"] = this.memo !== undefined ? this.memo : null as any;
        if (Array.isArray(this.departureAirports)) {
            data["departureAirports"] = [];
            for (let item of this.departureAirports)
                data["departureAirports"].push(item);
        }
        data["destinazione"] = this.destinazione !== undefined ? this.destinazione : null as any;
        if (Array.isArray(this.airlines)) {
            data["airlines"] = [];
            for (let item of this.airlines)
                data["airlines"].push(item);
        }
        return data;
    }
}

export interface IServizioItinerario {
    itinerarioID?: number;
    servizioID?: number;
    nome: string;
    memo?: string | null;
    departureAirports?: string[] | null;
    destinazione?: string | null;
    airlines?: string[] | null;
}

export class ServizioItinerarioGiornoInfo implements IServizioItinerarioGiornoInfo {
    id?: number;
    itinerarioGiorno?: ServizioItinerarioGiorno | null;
    luogo?: LuogoInfo | null;
    contattoHotel?: ContattoInfo | null;
    servizioHotel?: ServizioInfo | null;
    servizi?: ServizioItinerarioGiornoServizioInfo[] | null;
    compagniaAerea?: string | null;
    classe?: string | null;
    compagniaAerea2?: string | null;
    classe2?: string | null;
    cambioHotel?: boolean;

    constructor(data?: IServizioItinerarioGiornoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.itinerarioGiorno = _data["itinerarioGiorno"] ? ServizioItinerarioGiorno.fromJS(_data["itinerarioGiorno"]) : null as any;
            this.luogo = _data["luogo"] ? LuogoInfo.fromJS(_data["luogo"]) : null as any;
            this.contattoHotel = _data["contattoHotel"] ? ContattoInfo.fromJS(_data["contattoHotel"]) : null as any;
            this.servizioHotel = _data["servizioHotel"] ? ServizioInfo.fromJS(_data["servizioHotel"]) : null as any;
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(ServizioItinerarioGiornoServizioInfo.fromJS(item));
            }
            else {
                this.servizi = null as any;
            }
            this.compagniaAerea = _data["compagniaAerea"] !== undefined ? _data["compagniaAerea"] : null as any;
            this.classe = _data["classe"] !== undefined ? _data["classe"] : null as any;
            this.compagniaAerea2 = _data["compagniaAerea2"] !== undefined ? _data["compagniaAerea2"] : null as any;
            this.classe2 = _data["classe2"] !== undefined ? _data["classe2"] : null as any;
            this.cambioHotel = _data["cambioHotel"] !== undefined ? _data["cambioHotel"] : null as any;
        }
    }

    static fromJS(data: any): ServizioItinerarioGiornoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioItinerarioGiornoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["itinerarioGiorno"] = this.itinerarioGiorno ? this.itinerarioGiorno.toJSON() : null as any;
        data["luogo"] = this.luogo ? this.luogo.toJSON() : null as any;
        data["contattoHotel"] = this.contattoHotel ? this.contattoHotel.toJSON() : null as any;
        data["servizioHotel"] = this.servizioHotel ? this.servizioHotel.toJSON() : null as any;
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item ? item.toJSON() : null as any);
        }
        data["compagniaAerea"] = this.compagniaAerea !== undefined ? this.compagniaAerea : null as any;
        data["classe"] = this.classe !== undefined ? this.classe : null as any;
        data["compagniaAerea2"] = this.compagniaAerea2 !== undefined ? this.compagniaAerea2 : null as any;
        data["classe2"] = this.classe2 !== undefined ? this.classe2 : null as any;
        data["cambioHotel"] = this.cambioHotel !== undefined ? this.cambioHotel : null as any;
        return data;
    }
}

export interface IServizioItinerarioGiornoInfo {
    id?: number;
    itinerarioGiorno?: ServizioItinerarioGiorno | null;
    luogo?: LuogoInfo | null;
    contattoHotel?: ContattoInfo | null;
    servizioHotel?: ServizioInfo | null;
    servizi?: ServizioItinerarioGiornoServizioInfo[] | null;
    compagniaAerea?: string | null;
    classe?: string | null;
    compagniaAerea2?: string | null;
    classe2?: string | null;
    cambioHotel?: boolean;
}

export class ServizioItinerarioGiorno implements IServizioItinerarioGiorno {
    giornoID?: number;
    itinerarioID?: number;
    luogoID?: number;
    giorno?: number;
    ordine?: number | null;
    contattoHotelID?: number | null;
    durata?: number | null;
    trasporto?: ETipoTrasporto | null;
    noRicercaVoli?: boolean;
    compagniaAerea?: string | null;
    classe?: string | null;
    compagniaAerea2?: string | null;
    classe2?: string | null;
    cambioHotel?: boolean | null;

    constructor(data?: IServizioItinerarioGiorno) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.giornoID = _data["giornoID"] !== undefined ? _data["giornoID"] : null as any;
            this.itinerarioID = _data["itinerarioID"] !== undefined ? _data["itinerarioID"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.contattoHotelID = _data["contattoHotelID"] !== undefined ? _data["contattoHotelID"] : null as any;
            this.durata = _data["durata"] !== undefined ? _data["durata"] : null as any;
            this.trasporto = _data["trasporto"] !== undefined ? _data["trasporto"] : null as any;
            this.noRicercaVoli = _data["noRicercaVoli"] !== undefined ? _data["noRicercaVoli"] : null as any;
            this.compagniaAerea = _data["compagniaAerea"] !== undefined ? _data["compagniaAerea"] : null as any;
            this.classe = _data["classe"] !== undefined ? _data["classe"] : null as any;
            this.compagniaAerea2 = _data["compagniaAerea2"] !== undefined ? _data["compagniaAerea2"] : null as any;
            this.classe2 = _data["classe2"] !== undefined ? _data["classe2"] : null as any;
            this.cambioHotel = _data["cambioHotel"] !== undefined ? _data["cambioHotel"] : null as any;
        }
    }

    static fromJS(data: any): ServizioItinerarioGiorno {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioItinerarioGiorno();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giornoID"] = this.giornoID !== undefined ? this.giornoID : null as any;
        data["itinerarioID"] = this.itinerarioID !== undefined ? this.itinerarioID : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["giorno"] = this.giorno !== undefined ? this.giorno : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["contattoHotelID"] = this.contattoHotelID !== undefined ? this.contattoHotelID : null as any;
        data["durata"] = this.durata !== undefined ? this.durata : null as any;
        data["trasporto"] = this.trasporto !== undefined ? this.trasporto : null as any;
        data["noRicercaVoli"] = this.noRicercaVoli !== undefined ? this.noRicercaVoli : null as any;
        data["compagniaAerea"] = this.compagniaAerea !== undefined ? this.compagniaAerea : null as any;
        data["classe"] = this.classe !== undefined ? this.classe : null as any;
        data["compagniaAerea2"] = this.compagniaAerea2 !== undefined ? this.compagniaAerea2 : null as any;
        data["classe2"] = this.classe2 !== undefined ? this.classe2 : null as any;
        data["cambioHotel"] = this.cambioHotel !== undefined ? this.cambioHotel : null as any;
        return data;
    }
}

export interface IServizioItinerarioGiorno {
    giornoID?: number;
    itinerarioID?: number;
    luogoID?: number;
    giorno?: number;
    ordine?: number | null;
    contattoHotelID?: number | null;
    durata?: number | null;
    trasporto?: ETipoTrasporto | null;
    noRicercaVoli?: boolean;
    compagniaAerea?: string | null;
    classe?: string | null;
    compagniaAerea2?: string | null;
    classe2?: string | null;
    cambioHotel?: boolean | null;
}

export class ServizioItinerarioGiornoServizioInfo implements IServizioItinerarioGiornoServizioInfo {
    id?: number;
    servizioItinerarioGiornoServizio?: ServizioItinerarioGiornoServizio | null;
    tipologiaBase?: ServizioTipologiaInfo | null;
    servizio?: ServizioInfo | null;
    tipologia?: ServizioTipologiaInfo | null;
    servizioGiorno?: ServizioInfo | null;
    tipologiaGiorno?: ServizioTipologiaInfo | null;
    posizioneServizio?: EPosizioneDefaultServizioGiorno;
    ordine?: number;

    constructor(data?: IServizioItinerarioGiornoServizioInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.servizioItinerarioGiornoServizio = _data["servizioItinerarioGiornoServizio"] ? ServizioItinerarioGiornoServizio.fromJS(_data["servizioItinerarioGiornoServizio"]) : null as any;
            this.tipologiaBase = _data["tipologiaBase"] ? ServizioTipologiaInfo.fromJS(_data["tipologiaBase"]) : null as any;
            this.servizio = _data["servizio"] ? ServizioInfo.fromJS(_data["servizio"]) : null as any;
            this.tipologia = _data["tipologia"] ? ServizioTipologiaInfo.fromJS(_data["tipologia"]) : null as any;
            this.servizioGiorno = _data["servizioGiorno"] ? ServizioInfo.fromJS(_data["servizioGiorno"]) : null as any;
            this.tipologiaGiorno = _data["tipologiaGiorno"] ? ServizioTipologiaInfo.fromJS(_data["tipologiaGiorno"]) : null as any;
            this.posizioneServizio = _data["posizioneServizio"] !== undefined ? _data["posizioneServizio"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
        }
    }

    static fromJS(data: any): ServizioItinerarioGiornoServizioInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioItinerarioGiornoServizioInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["servizioItinerarioGiornoServizio"] = this.servizioItinerarioGiornoServizio ? this.servizioItinerarioGiornoServizio.toJSON() : null as any;
        data["tipologiaBase"] = this.tipologiaBase ? this.tipologiaBase.toJSON() : null as any;
        data["servizio"] = this.servizio ? this.servizio.toJSON() : null as any;
        data["tipologia"] = this.tipologia ? this.tipologia.toJSON() : null as any;
        data["servizioGiorno"] = this.servizioGiorno ? this.servizioGiorno.toJSON() : null as any;
        data["tipologiaGiorno"] = this.tipologiaGiorno ? this.tipologiaGiorno.toJSON() : null as any;
        data["posizioneServizio"] = this.posizioneServizio !== undefined ? this.posizioneServizio : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        return data;
    }
}

export interface IServizioItinerarioGiornoServizioInfo {
    id?: number;
    servizioItinerarioGiornoServizio?: ServizioItinerarioGiornoServizio | null;
    tipologiaBase?: ServizioTipologiaInfo | null;
    servizio?: ServizioInfo | null;
    tipologia?: ServizioTipologiaInfo | null;
    servizioGiorno?: ServizioInfo | null;
    tipologiaGiorno?: ServizioTipologiaInfo | null;
    posizioneServizio?: EPosizioneDefaultServizioGiorno;
    ordine?: number;
}

export class ServizioItinerarioGiornoServizio implements IServizioItinerarioGiornoServizio {
    id?: number;
    servizioItinerarioGiornoID?: number;
    tipologiaBaseID?: number | null;
    servizioID?: number | null;
    tipologiaID?: number | null;
    giorno?: number;
    durata?: number;
    alternativa?: number | null;
    trattamentoID?: number | null;

    constructor(data?: IServizioItinerarioGiornoServizio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.servizioItinerarioGiornoID = _data["servizioItinerarioGiornoID"] !== undefined ? _data["servizioItinerarioGiornoID"] : null as any;
            this.tipologiaBaseID = _data["tipologiaBaseID"] !== undefined ? _data["tipologiaBaseID"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.tipologiaID = _data["tipologiaID"] !== undefined ? _data["tipologiaID"] : null as any;
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : null as any;
            this.durata = _data["durata"] !== undefined ? _data["durata"] : null as any;
            this.alternativa = _data["alternativa"] !== undefined ? _data["alternativa"] : null as any;
            this.trattamentoID = _data["trattamentoID"] !== undefined ? _data["trattamentoID"] : null as any;
        }
    }

    static fromJS(data: any): ServizioItinerarioGiornoServizio {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioItinerarioGiornoServizio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["servizioItinerarioGiornoID"] = this.servizioItinerarioGiornoID !== undefined ? this.servizioItinerarioGiornoID : null as any;
        data["tipologiaBaseID"] = this.tipologiaBaseID !== undefined ? this.tipologiaBaseID : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["tipologiaID"] = this.tipologiaID !== undefined ? this.tipologiaID : null as any;
        data["giorno"] = this.giorno !== undefined ? this.giorno : null as any;
        data["durata"] = this.durata !== undefined ? this.durata : null as any;
        data["alternativa"] = this.alternativa !== undefined ? this.alternativa : null as any;
        data["trattamentoID"] = this.trattamentoID !== undefined ? this.trattamentoID : null as any;
        return data;
    }
}

export interface IServizioItinerarioGiornoServizio {
    id?: number;
    servizioItinerarioGiornoID?: number;
    tipologiaBaseID?: number | null;
    servizioID?: number | null;
    tipologiaID?: number | null;
    giorno?: number;
    durata?: number;
    alternativa?: number | null;
    trattamentoID?: number | null;
}

export enum EPosizioneDefaultServizioGiorno {
    InizioTappa = "InizioTappa",
    FineTappa = "FineTappa",
    GiornoIndicato = "GiornoIndicato",
}

export class OreMinuti implements IOreMinuti {
    ore?: number;
    minuti?: number;

    constructor(data?: IOreMinuti) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ore = _data["ore"] !== undefined ? _data["ore"] : null as any;
            this.minuti = _data["minuti"] !== undefined ? _data["minuti"] : null as any;
        }
    }

    static fromJS(data: any): OreMinuti {
        data = typeof data === 'object' ? data : {};
        let result = new OreMinuti();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ore"] = this.ore !== undefined ? this.ore : null as any;
        data["minuti"] = this.minuti !== undefined ? this.minuti : null as any;
        return data;
    }
}

export interface IOreMinuti {
    ore?: number;
    minuti?: number;
}

export class ServizioAccordoInfo implements IServizioAccordoInfo {
    id?: number;
    servizioAccordo?: ServizioAccordo;
    accordo?: AccordoInfo | null;

    constructor(data?: IServizioAccordoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.servizioAccordo = _data["servizioAccordo"] ? ServizioAccordo.fromJS(_data["servizioAccordo"]) : null as any;
            this.accordo = _data["accordo"] ? AccordoInfo.fromJS(_data["accordo"]) : null as any;
        }
    }

    static fromJS(data: any): ServizioAccordoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioAccordoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["servizioAccordo"] = this.servizioAccordo ? this.servizioAccordo.toJSON() : null as any;
        data["accordo"] = this.accordo ? this.accordo.toJSON() : null as any;
        return data;
    }
}

export interface IServizioAccordoInfo {
    id?: number;
    servizioAccordo?: ServizioAccordo;
    accordo?: AccordoInfo | null;
}

export class ServizioAccordo implements IServizioAccordo {
    servizioAccordoID?: number;
    servizioID?: number | null;
    accordoID?: number | null;

    constructor(data?: IServizioAccordo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servizioAccordoID = _data["servizioAccordoID"] !== undefined ? _data["servizioAccordoID"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
        }
    }

    static fromJS(data: any): ServizioAccordo {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioAccordo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioAccordoID"] = this.servizioAccordoID !== undefined ? this.servizioAccordoID : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        return data;
    }
}

export interface IServizioAccordo {
    servizioAccordoID?: number;
    servizioID?: number | null;
    accordoID?: number | null;
}

export class Validita implements IValidita {
    validitaID?: number;
    servizioID?: number;
    dal?: string;
    al?: string;
    giorni?: string | null;
    overAdv?: number | null;
    note?: string | null;
    prezziIndicativi?: boolean;

    constructor(data?: IValidita) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validitaID = _data["validitaID"] !== undefined ? _data["validitaID"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.al = _data["al"] !== undefined ? _data["al"] : null as any;
            this.giorni = _data["giorni"] !== undefined ? _data["giorni"] : null as any;
            this.overAdv = _data["overAdv"] !== undefined ? _data["overAdv"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.prezziIndicativi = _data["prezziIndicativi"] !== undefined ? _data["prezziIndicativi"] : null as any;
        }
    }

    static fromJS(data: any): Validita {
        data = typeof data === 'object' ? data : {};
        let result = new Validita();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validitaID"] = this.validitaID !== undefined ? this.validitaID : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["al"] = this.al !== undefined ? this.al : null as any;
        data["giorni"] = this.giorni !== undefined ? this.giorni : null as any;
        data["overAdv"] = this.overAdv !== undefined ? this.overAdv : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["prezziIndicativi"] = this.prezziIndicativi !== undefined ? this.prezziIndicativi : null as any;
        return data;
    }
}

export interface IValidita {
    validitaID?: number;
    servizioID?: number;
    dal?: string;
    al?: string;
    giorni?: string | null;
    overAdv?: number | null;
    note?: string | null;
    prezziIndicativi?: boolean;
}

export class ServizioRegola implements IServizioRegola {
    regolaServizioID?: number;
    servizioID?: number;
    nome?: string | null;
    costoPerGiorno?: boolean;
    costoPerPersona?: boolean;
    minPax?: number;
    maxPax?: number;
    maxPaxCamera?: number | null;
    maxAdulti?: number | null;
    maxChild?: number | null;
    etaInfant?: number | null;
    etaChildFree?: number | null;
    freeSale?: number | null;
    maxLettiAggiungibili?: number | null;

    constructor(data?: IServizioRegola) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.regolaServizioID = _data["regolaServizioID"] !== undefined ? _data["regolaServizioID"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.costoPerGiorno = _data["costoPerGiorno"] !== undefined ? _data["costoPerGiorno"] : null as any;
            this.costoPerPersona = _data["costoPerPersona"] !== undefined ? _data["costoPerPersona"] : null as any;
            this.minPax = _data["minPax"] !== undefined ? _data["minPax"] : null as any;
            this.maxPax = _data["maxPax"] !== undefined ? _data["maxPax"] : null as any;
            this.maxPaxCamera = _data["maxPaxCamera"] !== undefined ? _data["maxPaxCamera"] : null as any;
            this.maxAdulti = _data["maxAdulti"] !== undefined ? _data["maxAdulti"] : null as any;
            this.maxChild = _data["maxChild"] !== undefined ? _data["maxChild"] : null as any;
            this.etaInfant = _data["etaInfant"] !== undefined ? _data["etaInfant"] : null as any;
            this.etaChildFree = _data["etaChildFree"] !== undefined ? _data["etaChildFree"] : null as any;
            this.freeSale = _data["freeSale"] !== undefined ? _data["freeSale"] : null as any;
            this.maxLettiAggiungibili = _data["maxLettiAggiungibili"] !== undefined ? _data["maxLettiAggiungibili"] : null as any;
        }
    }

    static fromJS(data: any): ServizioRegola {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioRegola();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regolaServizioID"] = this.regolaServizioID !== undefined ? this.regolaServizioID : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["costoPerGiorno"] = this.costoPerGiorno !== undefined ? this.costoPerGiorno : null as any;
        data["costoPerPersona"] = this.costoPerPersona !== undefined ? this.costoPerPersona : null as any;
        data["minPax"] = this.minPax !== undefined ? this.minPax : null as any;
        data["maxPax"] = this.maxPax !== undefined ? this.maxPax : null as any;
        data["maxPaxCamera"] = this.maxPaxCamera !== undefined ? this.maxPaxCamera : null as any;
        data["maxAdulti"] = this.maxAdulti !== undefined ? this.maxAdulti : null as any;
        data["maxChild"] = this.maxChild !== undefined ? this.maxChild : null as any;
        data["etaInfant"] = this.etaInfant !== undefined ? this.etaInfant : null as any;
        data["etaChildFree"] = this.etaChildFree !== undefined ? this.etaChildFree : null as any;
        data["freeSale"] = this.freeSale !== undefined ? this.freeSale : null as any;
        data["maxLettiAggiungibili"] = this.maxLettiAggiungibili !== undefined ? this.maxLettiAggiungibili : null as any;
        return data;
    }
}

export interface IServizioRegola {
    regolaServizioID?: number;
    servizioID?: number;
    nome?: string | null;
    costoPerGiorno?: boolean;
    costoPerPersona?: boolean;
    minPax?: number;
    maxPax?: number;
    maxPaxCamera?: number | null;
    maxAdulti?: number | null;
    maxChild?: number | null;
    etaInfant?: number | null;
    etaChildFree?: number | null;
    freeSale?: number | null;
    maxLettiAggiungibili?: number | null;
}

export abstract class ServizioRegolaVenditaBase implements IServizioRegolaVenditaBase {
    id?: number;
    servizioID?: number;
    penaleID?: number | null;
    giorniPenale?: number | null;
    percentualePenale?: number | null;
    articoloID?: number | null;

    constructor(data?: IServizioRegolaVenditaBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.penaleID = _data["penaleID"] !== undefined ? _data["penaleID"] : null as any;
            this.giorniPenale = _data["giorniPenale"] !== undefined ? _data["giorniPenale"] : null as any;
            this.percentualePenale = _data["percentualePenale"] !== undefined ? _data["percentualePenale"] : null as any;
            this.articoloID = _data["articoloID"] !== undefined ? _data["articoloID"] : null as any;
        }
    }

    static fromJS(data: any): ServizioRegolaVenditaBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ServizioRegolaVenditaBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["penaleID"] = this.penaleID !== undefined ? this.penaleID : null as any;
        data["giorniPenale"] = this.giorniPenale !== undefined ? this.giorniPenale : null as any;
        data["percentualePenale"] = this.percentualePenale !== undefined ? this.percentualePenale : null as any;
        data["articoloID"] = this.articoloID !== undefined ? this.articoloID : null as any;
        return data;
    }
}

export interface IServizioRegolaVenditaBase {
    id?: number;
    servizioID?: number;
    penaleID?: number | null;
    giorniPenale?: number | null;
    percentualePenale?: number | null;
    articoloID?: number | null;
}

export class ServizioRegolaVendita extends ServizioRegolaVenditaBase implements IServizioRegolaVendita {
    nome?: string | null;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    numeroGiorni?: number | null;
    minimoGiorni?: number | null;
    massimoGiorni?: number | null;
    etaMinima?: number | null;
    etaMassima?: number | null;
    dal?: string | null;
    al?: string | null;
    commissioniAgenzia?: number | null;
    commissioniTourOperator?: number | null;
    minimoNottiPeriodo?: number | null;
    giorniEntrata?: string | null;
    giorniUscita?: string | null;
    prenotaEntroData?: string | null;
    prenotaEntroGiorni?: number | null;
    deregolamentaSuRichiesta?: boolean | null;
    articolo?: Articolo | null;

    constructor(data?: IServizioRegolaVendita) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nome_fr = _data["nome_fr"] !== undefined ? _data["nome_fr"] : null as any;
            this.nome_de = _data["nome_de"] !== undefined ? _data["nome_de"] : null as any;
            this.nome_es = _data["nome_es"] !== undefined ? _data["nome_es"] : null as any;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : null as any;
            this.numeroGiorni = _data["numeroGiorni"] !== undefined ? _data["numeroGiorni"] : null as any;
            this.minimoGiorni = _data["minimoGiorni"] !== undefined ? _data["minimoGiorni"] : null as any;
            this.massimoGiorni = _data["massimoGiorni"] !== undefined ? _data["massimoGiorni"] : null as any;
            this.etaMinima = _data["etaMinima"] !== undefined ? _data["etaMinima"] : null as any;
            this.etaMassima = _data["etaMassima"] !== undefined ? _data["etaMassima"] : null as any;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.al = _data["al"] !== undefined ? _data["al"] : null as any;
            this.commissioniAgenzia = _data["commissioniAgenzia"] !== undefined ? _data["commissioniAgenzia"] : null as any;
            this.commissioniTourOperator = _data["commissioniTourOperator"] !== undefined ? _data["commissioniTourOperator"] : null as any;
            this.minimoNottiPeriodo = _data["minimoNottiPeriodo"] !== undefined ? _data["minimoNottiPeriodo"] : null as any;
            this.giorniEntrata = _data["giorniEntrata"] !== undefined ? _data["giorniEntrata"] : null as any;
            this.giorniUscita = _data["giorniUscita"] !== undefined ? _data["giorniUscita"] : null as any;
            this.prenotaEntroData = _data["prenotaEntroData"] !== undefined ? _data["prenotaEntroData"] : null as any;
            this.prenotaEntroGiorni = _data["prenotaEntroGiorni"] !== undefined ? _data["prenotaEntroGiorni"] : null as any;
            this.deregolamentaSuRichiesta = _data["deregolamentaSuRichiesta"] !== undefined ? _data["deregolamentaSuRichiesta"] : null as any;
            this.articolo = _data["articolo"] ? Articolo.fromJS(_data["articolo"]) : null as any;
        }
    }

    static override fromJS(data: any): ServizioRegolaVendita {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioRegolaVendita();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nome_fr"] = this.nome_fr !== undefined ? this.nome_fr : null as any;
        data["nome_de"] = this.nome_de !== undefined ? this.nome_de : null as any;
        data["nome_es"] = this.nome_es !== undefined ? this.nome_es : null as any;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : null as any;
        data["numeroGiorni"] = this.numeroGiorni !== undefined ? this.numeroGiorni : null as any;
        data["minimoGiorni"] = this.minimoGiorni !== undefined ? this.minimoGiorni : null as any;
        data["massimoGiorni"] = this.massimoGiorni !== undefined ? this.massimoGiorni : null as any;
        data["etaMinima"] = this.etaMinima !== undefined ? this.etaMinima : null as any;
        data["etaMassima"] = this.etaMassima !== undefined ? this.etaMassima : null as any;
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["al"] = this.al !== undefined ? this.al : null as any;
        data["commissioniAgenzia"] = this.commissioniAgenzia !== undefined ? this.commissioniAgenzia : null as any;
        data["commissioniTourOperator"] = this.commissioniTourOperator !== undefined ? this.commissioniTourOperator : null as any;
        data["minimoNottiPeriodo"] = this.minimoNottiPeriodo !== undefined ? this.minimoNottiPeriodo : null as any;
        data["giorniEntrata"] = this.giorniEntrata !== undefined ? this.giorniEntrata : null as any;
        data["giorniUscita"] = this.giorniUscita !== undefined ? this.giorniUscita : null as any;
        data["prenotaEntroData"] = this.prenotaEntroData !== undefined ? this.prenotaEntroData : null as any;
        data["prenotaEntroGiorni"] = this.prenotaEntroGiorni !== undefined ? this.prenotaEntroGiorni : null as any;
        data["deregolamentaSuRichiesta"] = this.deregolamentaSuRichiesta !== undefined ? this.deregolamentaSuRichiesta : null as any;
        data["articolo"] = this.articolo ? this.articolo.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IServizioRegolaVendita extends IServizioRegolaVenditaBase {
    nome?: string | null;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    numeroGiorni?: number | null;
    minimoGiorni?: number | null;
    massimoGiorni?: number | null;
    etaMinima?: number | null;
    etaMassima?: number | null;
    dal?: string | null;
    al?: string | null;
    commissioniAgenzia?: number | null;
    commissioniTourOperator?: number | null;
    minimoNottiPeriodo?: number | null;
    giorniEntrata?: string | null;
    giorniUscita?: string | null;
    prenotaEntroData?: string | null;
    prenotaEntroGiorni?: number | null;
    deregolamentaSuRichiesta?: boolean | null;
    articolo?: Articolo | null;
}

export class CostoInfo implements ICostoInfo {
    id?: number;
    costo?: Costo | null;
    tabellaCostiCommissioni?: TabellaCostiCommissioniInfo | null;
    tipologia?: ServizioTipologiaInfo | null;
    regolaServizio?: ServizioRegola | null;
    regolaVendita?: ServizioRegolaVendita | null;
    validita?: Validita | null;
    trattamento?: TrattamentoInfo | null;
    sistemazione?: SistemazioneInfo | null;

    constructor(data?: ICostoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.costo = _data["costo"] ? Costo.fromJS(_data["costo"]) : null as any;
            this.tabellaCostiCommissioni = _data["tabellaCostiCommissioni"] ? TabellaCostiCommissioniInfo.fromJS(_data["tabellaCostiCommissioni"]) : null as any;
            this.tipologia = _data["tipologia"] ? ServizioTipologiaInfo.fromJS(_data["tipologia"]) : null as any;
            this.regolaServizio = _data["regolaServizio"] ? ServizioRegola.fromJS(_data["regolaServizio"]) : null as any;
            this.regolaVendita = _data["regolaVendita"] ? ServizioRegolaVendita.fromJS(_data["regolaVendita"]) : null as any;
            this.validita = _data["validita"] ? Validita.fromJS(_data["validita"]) : null as any;
            this.trattamento = _data["trattamento"] ? TrattamentoInfo.fromJS(_data["trattamento"]) : null as any;
            this.sistemazione = _data["sistemazione"] ? SistemazioneInfo.fromJS(_data["sistemazione"]) : null as any;
        }
    }

    static fromJS(data: any): CostoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CostoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["costo"] = this.costo ? this.costo.toJSON() : null as any;
        data["tabellaCostiCommissioni"] = this.tabellaCostiCommissioni ? this.tabellaCostiCommissioni.toJSON() : null as any;
        data["tipologia"] = this.tipologia ? this.tipologia.toJSON() : null as any;
        data["regolaServizio"] = this.regolaServizio ? this.regolaServizio.toJSON() : null as any;
        data["regolaVendita"] = this.regolaVendita ? this.regolaVendita.toJSON() : null as any;
        data["validita"] = this.validita ? this.validita.toJSON() : null as any;
        data["trattamento"] = this.trattamento ? this.trattamento.toJSON() : null as any;
        data["sistemazione"] = this.sistemazione ? this.sistemazione.toJSON() : null as any;
        return data;
    }
}

export interface ICostoInfo {
    id?: number;
    costo?: Costo | null;
    tabellaCostiCommissioni?: TabellaCostiCommissioniInfo | null;
    tipologia?: ServizioTipologiaInfo | null;
    regolaServizio?: ServizioRegola | null;
    regolaVendita?: ServizioRegolaVendita | null;
    validita?: Validita | null;
    trattamento?: TrattamentoInfo | null;
    sistemazione?: SistemazioneInfo | null;
}

export class Costo implements ICosto {
    costoID?: number;
    servizioTipologiaID?: number;
    tabellaCostiCommissioniID?: number;
    trattamentoID?: number | null;
    regolaServizioID?: number | null;
    regolaVenditaID?: number | null;
    validitaID?: number;
    sistemazioneID?: number | null;
    codicePrenotazione?: string | null;
    cost?: number;
    prezzo?: number | null;
    margine?: number | null;
    etaMassima?: number | null;
    regolaCostiBambino?: ERegolaCostiBambino | null;
    _ScontoBambinoPercentuale?: boolean | null;

    constructor(data?: ICosto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.costoID = _data["costoID"] !== undefined ? _data["costoID"] : null as any;
            this.servizioTipologiaID = _data["servizioTipologiaID"] !== undefined ? _data["servizioTipologiaID"] : null as any;
            this.tabellaCostiCommissioniID = _data["tabellaCostiCommissioniID"] !== undefined ? _data["tabellaCostiCommissioniID"] : null as any;
            this.trattamentoID = _data["trattamentoID"] !== undefined ? _data["trattamentoID"] : null as any;
            this.regolaServizioID = _data["regolaServizioID"] !== undefined ? _data["regolaServizioID"] : null as any;
            this.regolaVenditaID = _data["regolaVenditaID"] !== undefined ? _data["regolaVenditaID"] : null as any;
            this.validitaID = _data["validitaID"] !== undefined ? _data["validitaID"] : null as any;
            this.sistemazioneID = _data["sistemazioneID"] !== undefined ? _data["sistemazioneID"] : null as any;
            this.codicePrenotazione = _data["codicePrenotazione"] !== undefined ? _data["codicePrenotazione"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : null as any;
            this.margine = _data["margine"] !== undefined ? _data["margine"] : null as any;
            this.etaMassima = _data["etaMassima"] !== undefined ? _data["etaMassima"] : null as any;
            this.regolaCostiBambino = _data["regolaCostiBambino"] !== undefined ? _data["regolaCostiBambino"] : null as any;
            this._ScontoBambinoPercentuale = _data["_ScontoBambinoPercentuale"] !== undefined ? _data["_ScontoBambinoPercentuale"] : null as any;
        }
    }

    static fromJS(data: any): Costo {
        data = typeof data === 'object' ? data : {};
        let result = new Costo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["costoID"] = this.costoID !== undefined ? this.costoID : null as any;
        data["servizioTipologiaID"] = this.servizioTipologiaID !== undefined ? this.servizioTipologiaID : null as any;
        data["tabellaCostiCommissioniID"] = this.tabellaCostiCommissioniID !== undefined ? this.tabellaCostiCommissioniID : null as any;
        data["trattamentoID"] = this.trattamentoID !== undefined ? this.trattamentoID : null as any;
        data["regolaServizioID"] = this.regolaServizioID !== undefined ? this.regolaServizioID : null as any;
        data["regolaVenditaID"] = this.regolaVenditaID !== undefined ? this.regolaVenditaID : null as any;
        data["validitaID"] = this.validitaID !== undefined ? this.validitaID : null as any;
        data["sistemazioneID"] = this.sistemazioneID !== undefined ? this.sistemazioneID : null as any;
        data["codicePrenotazione"] = this.codicePrenotazione !== undefined ? this.codicePrenotazione : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : null as any;
        data["margine"] = this.margine !== undefined ? this.margine : null as any;
        data["etaMassima"] = this.etaMassima !== undefined ? this.etaMassima : null as any;
        data["regolaCostiBambino"] = this.regolaCostiBambino !== undefined ? this.regolaCostiBambino : null as any;
        data["_ScontoBambinoPercentuale"] = this._ScontoBambinoPercentuale !== undefined ? this._ScontoBambinoPercentuale : null as any;
        return data;
    }
}

export interface ICosto {
    costoID?: number;
    servizioTipologiaID?: number;
    tabellaCostiCommissioniID?: number;
    trattamentoID?: number | null;
    regolaServizioID?: number | null;
    regolaVenditaID?: number | null;
    validitaID?: number;
    sistemazioneID?: number | null;
    codicePrenotazione?: string | null;
    cost?: number;
    prezzo?: number | null;
    margine?: number | null;
    etaMassima?: number | null;
    regolaCostiBambino?: ERegolaCostiBambino | null;
    _ScontoBambinoPercentuale?: boolean | null;
}

export enum ERegolaCostiBambino {
    Nessuna = "Nessuna",
    Fino1Bambino = "Fino1Bambino",
    Fino2Bambini = "Fino2Bambini",
    Fino3Bambini = "Fino3Bambini",
    Fino1Infant = "Fino1Infant",
    Fino2Infant = "Fino2Infant",
    PrimoBambino = "PrimoBambino",
    SecondoBambino = "SecondoBambino",
    TerzoBambino = "TerzoBambino",
    QuartoBambino = "QuartoBambino",
    Fino4Bambini = "Fino4Bambini",
    Fino5Bambini = "Fino5Bambini",
    QuintoBambino = "QuintoBambino",
}

export class TabellaCostiCommissioniInfo implements ITabellaCostiCommissioniInfo {
    id?: number;
    tabellaCostiCommissioni?: TabellaCostiCommissioni;
    accordo?: AccordoInfo | null;
    esclusioni?: TabellaCostiCommissioniEsclusione[];
    eccezioni?: TabellaCostiCommissioniEccezione[];
    isValid?: boolean;
    wasValidLastYear?: boolean;

    constructor(data?: ITabellaCostiCommissioniInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.tabellaCostiCommissioni = _data["tabellaCostiCommissioni"] ? TabellaCostiCommissioni.fromJS(_data["tabellaCostiCommissioni"]) : null as any;
            this.accordo = _data["accordo"] ? AccordoInfo.fromJS(_data["accordo"]) : null as any;
            if (Array.isArray(_data["esclusioni"])) {
                this.esclusioni = [] as any;
                for (let item of _data["esclusioni"])
                    this.esclusioni!.push(TabellaCostiCommissioniEsclusione.fromJS(item));
            }
            else {
                this.esclusioni = null as any;
            }
            if (Array.isArray(_data["eccezioni"])) {
                this.eccezioni = [] as any;
                for (let item of _data["eccezioni"])
                    this.eccezioni!.push(TabellaCostiCommissioniEccezione.fromJS(item));
            }
            else {
                this.eccezioni = null as any;
            }
            this.isValid = _data["isValid"] !== undefined ? _data["isValid"] : null as any;
            this.wasValidLastYear = _data["wasValidLastYear"] !== undefined ? _data["wasValidLastYear"] : null as any;
        }
    }

    static fromJS(data: any): TabellaCostiCommissioniInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TabellaCostiCommissioniInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["tabellaCostiCommissioni"] = this.tabellaCostiCommissioni ? this.tabellaCostiCommissioni.toJSON() : null as any;
        data["accordo"] = this.accordo ? this.accordo.toJSON() : null as any;
        if (Array.isArray(this.esclusioni)) {
            data["esclusioni"] = [];
            for (let item of this.esclusioni)
                data["esclusioni"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.eccezioni)) {
            data["eccezioni"] = [];
            for (let item of this.eccezioni)
                data["eccezioni"].push(item ? item.toJSON() : null as any);
        }
        data["isValid"] = this.isValid !== undefined ? this.isValid : null as any;
        data["wasValidLastYear"] = this.wasValidLastYear !== undefined ? this.wasValidLastYear : null as any;
        return data;
    }
}

export interface ITabellaCostiCommissioniInfo {
    id?: number;
    tabellaCostiCommissioni?: TabellaCostiCommissioni;
    accordo?: AccordoInfo | null;
    esclusioni?: TabellaCostiCommissioniEsclusione[];
    eccezioni?: TabellaCostiCommissioniEccezione[];
    isValid?: boolean;
    wasValidLastYear?: boolean;
}

export class TabellaCostiCommissioniEsclusione implements ITabellaCostiCommissioniEsclusione {
    tabellaCostiCommissioniEsclusioneID?: number;
    tabellaCostiCommissioniID?: number;
    dal?: string;
    al?: string;

    constructor(data?: ITabellaCostiCommissioniEsclusione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tabellaCostiCommissioniEsclusioneID = _data["tabellaCostiCommissioniEsclusioneID"] !== undefined ? _data["tabellaCostiCommissioniEsclusioneID"] : null as any;
            this.tabellaCostiCommissioniID = _data["tabellaCostiCommissioniID"] !== undefined ? _data["tabellaCostiCommissioniID"] : null as any;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.al = _data["al"] !== undefined ? _data["al"] : null as any;
        }
    }

    static fromJS(data: any): TabellaCostiCommissioniEsclusione {
        data = typeof data === 'object' ? data : {};
        let result = new TabellaCostiCommissioniEsclusione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tabellaCostiCommissioniEsclusioneID"] = this.tabellaCostiCommissioniEsclusioneID !== undefined ? this.tabellaCostiCommissioniEsclusioneID : null as any;
        data["tabellaCostiCommissioniID"] = this.tabellaCostiCommissioniID !== undefined ? this.tabellaCostiCommissioniID : null as any;
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["al"] = this.al !== undefined ? this.al : null as any;
        return data;
    }
}

export interface ITabellaCostiCommissioniEsclusione {
    tabellaCostiCommissioniEsclusioneID?: number;
    tabellaCostiCommissioniID?: number;
    dal?: string;
    al?: string;
}

export class TabellaCostiCommissioniEccezione implements ITabellaCostiCommissioniEccezione {
    id?: number;
    tabellaCostoCommissioniID?: number;
    dal?: string;
    al?: string;
    percentuale?: number;
    percentuale2?: number | null;
    differenzaCommissioneAdv?: number | null;

    constructor(data?: ITabellaCostiCommissioniEccezione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.tabellaCostoCommissioniID = _data["tabellaCostoCommissioniID"] !== undefined ? _data["tabellaCostoCommissioniID"] : null as any;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.al = _data["al"] !== undefined ? _data["al"] : null as any;
            this.percentuale = _data["percentuale"] !== undefined ? _data["percentuale"] : null as any;
            this.percentuale2 = _data["percentuale2"] !== undefined ? _data["percentuale2"] : null as any;
            this.differenzaCommissioneAdv = _data["differenzaCommissioneAdv"] !== undefined ? _data["differenzaCommissioneAdv"] : null as any;
        }
    }

    static fromJS(data: any): TabellaCostiCommissioniEccezione {
        data = typeof data === 'object' ? data : {};
        let result = new TabellaCostiCommissioniEccezione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["tabellaCostoCommissioniID"] = this.tabellaCostoCommissioniID !== undefined ? this.tabellaCostoCommissioniID : null as any;
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["al"] = this.al !== undefined ? this.al : null as any;
        data["percentuale"] = this.percentuale !== undefined ? this.percentuale : null as any;
        data["percentuale2"] = this.percentuale2 !== undefined ? this.percentuale2 : null as any;
        data["differenzaCommissioneAdv"] = this.differenzaCommissioneAdv !== undefined ? this.differenzaCommissioneAdv : null as any;
        return data;
    }
}

export interface ITabellaCostiCommissioniEccezione {
    id?: number;
    tabellaCostoCommissioniID?: number;
    dal?: string;
    al?: string;
    percentuale?: number;
    percentuale2?: number | null;
    differenzaCommissioneAdv?: number | null;
}

export class TrattamentoInfo implements ITrattamentoInfo {
    id?: number;
    trattamento?: Trattamento;
    traduzioni?: IWebTranslationEntity[];
    nome?: string;
    nome_en?: string;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean;
    confirmed_en?: boolean;
    table?: string;

    constructor(data?: ITrattamentoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.trattamento = _data["trattamento"] ? Trattamento.fromJS(_data["trattamento"]) : null as any;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(IWebTranslationEntity.fromJS(item));
            }
            else {
                this.traduzioni = null as any;
            }
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : null as any;
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : null as any;
            this.lastUpdate_en = _data["lastUpdate_en"] !== undefined ? _data["lastUpdate_en"] : null as any;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : null as any;
            this.confirmed_en = _data["confirmed_en"] !== undefined ? _data["confirmed_en"] : null as any;
            this.table = _data["table"] !== undefined ? _data["table"] : null as any;
        }
    }

    static fromJS(data: any): TrattamentoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TrattamentoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["trattamento"] = this.trattamento ? this.trattamento.toJSON() : null as any;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item ? item.toJSON() : null as any);
        }
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : null as any;
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : null as any;
        data["lastUpdate_en"] = this.lastUpdate_en !== undefined ? this.lastUpdate_en : null as any;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : null as any;
        data["confirmed_en"] = this.confirmed_en !== undefined ? this.confirmed_en : null as any;
        data["table"] = this.table !== undefined ? this.table : null as any;
        return data;
    }
}

export interface ITrattamentoInfo {
    id?: number;
    trattamento?: Trattamento;
    traduzioni?: IWebTranslationEntity[];
    nome?: string;
    nome_en?: string;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean;
    confirmed_en?: boolean;
    table?: string;
}

export class SistemazioneInfo implements ISistemazioneInfo {
    _Nomi?: { [key in keyof typeof ELingua]?: string; } | null;
    id?: number;
    sistemazione?: Sistemazione | null;
    isBase?: boolean;
    nomi?: { [key in keyof typeof ELingua]?: string; } | null;

    constructor(data?: ISistemazioneInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["_Nomi"]) {
                this._Nomi = {} as any;
                for (let key in _data["_Nomi"]) {
                    if (_data["_Nomi"].hasOwnProperty(key))
                        (this._Nomi as any)![key] = _data["_Nomi"][key] !== undefined ? _data["_Nomi"][key] : null as any;
                }
            }
            else {
                this._Nomi = null as any;
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.sistemazione = _data["sistemazione"] ? Sistemazione.fromJS(_data["sistemazione"]) : null as any;
            this.isBase = _data["isBase"] !== undefined ? _data["isBase"] : null as any;
            if (_data["nomi"]) {
                this.nomi = {} as any;
                for (let key in _data["nomi"]) {
                    if (_data["nomi"].hasOwnProperty(key))
                        (this.nomi as any)![key] = _data["nomi"][key] !== undefined ? _data["nomi"][key] : null as any;
                }
            }
            else {
                this.nomi = null as any;
            }
        }
    }

    static fromJS(data: any): SistemazioneInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SistemazioneInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this._Nomi) {
            data["_Nomi"] = {};
            for (let key in this._Nomi) {
                if (this._Nomi.hasOwnProperty(key))
                    (data["_Nomi"] as any)[key] = this._Nomi[key] !== undefined ? this._Nomi[key] : null as any;
            }
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["sistemazione"] = this.sistemazione ? this.sistemazione.toJSON() : null as any;
        data["isBase"] = this.isBase !== undefined ? this.isBase : null as any;
        if (this.nomi) {
            data["nomi"] = {};
            for (let key in this.nomi) {
                if (this.nomi.hasOwnProperty(key))
                    (data["nomi"] as any)[key] = this.nomi[key] !== undefined ? this.nomi[key] : null as any;
            }
        }
        return data;
    }
}

export interface ISistemazioneInfo {
    _Nomi?: { [key in keyof typeof ELingua]?: string; } | null;
    id?: number;
    sistemazione?: Sistemazione | null;
    isBase?: boolean;
    nomi?: { [key in keyof typeof ELingua]?: string; } | null;
}

export class Sistemazione implements ISistemazione {
    sistemazioneID?: number;
    sistemazioneBaseID?: number | null;
    nome!: string;
    nomeInglese?: string | null;
    memo?: string | null;
    nomeVoucher?: string | null;
    maxAdulti?: number;
    maxChildren?: number;
    nome_en?: string | null;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_nl?: string | null;
    visibile?: boolean | null;

    constructor(data?: ISistemazione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sistemazioneID = _data["sistemazioneID"] !== undefined ? _data["sistemazioneID"] : null as any;
            this.sistemazioneBaseID = _data["sistemazioneBaseID"] !== undefined ? _data["sistemazioneBaseID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nomeInglese = _data["nomeInglese"] !== undefined ? _data["nomeInglese"] : null as any;
            this.memo = _data["memo"] !== undefined ? _data["memo"] : null as any;
            this.nomeVoucher = _data["nomeVoucher"] !== undefined ? _data["nomeVoucher"] : null as any;
            this.maxAdulti = _data["maxAdulti"] !== undefined ? _data["maxAdulti"] : null as any;
            this.maxChildren = _data["maxChildren"] !== undefined ? _data["maxChildren"] : null as any;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : null as any;
            this.nome_fr = _data["nome_fr"] !== undefined ? _data["nome_fr"] : null as any;
            this.nome_de = _data["nome_de"] !== undefined ? _data["nome_de"] : null as any;
            this.nome_es = _data["nome_es"] !== undefined ? _data["nome_es"] : null as any;
            this.nome_nl = _data["nome_nl"] !== undefined ? _data["nome_nl"] : null as any;
            this.visibile = _data["visibile"] !== undefined ? _data["visibile"] : null as any;
        }
    }

    static fromJS(data: any): Sistemazione {
        data = typeof data === 'object' ? data : {};
        let result = new Sistemazione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sistemazioneID"] = this.sistemazioneID !== undefined ? this.sistemazioneID : null as any;
        data["sistemazioneBaseID"] = this.sistemazioneBaseID !== undefined ? this.sistemazioneBaseID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nomeInglese"] = this.nomeInglese !== undefined ? this.nomeInglese : null as any;
        data["memo"] = this.memo !== undefined ? this.memo : null as any;
        data["nomeVoucher"] = this.nomeVoucher !== undefined ? this.nomeVoucher : null as any;
        data["maxAdulti"] = this.maxAdulti !== undefined ? this.maxAdulti : null as any;
        data["maxChildren"] = this.maxChildren !== undefined ? this.maxChildren : null as any;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : null as any;
        data["nome_fr"] = this.nome_fr !== undefined ? this.nome_fr : null as any;
        data["nome_de"] = this.nome_de !== undefined ? this.nome_de : null as any;
        data["nome_es"] = this.nome_es !== undefined ? this.nome_es : null as any;
        data["nome_nl"] = this.nome_nl !== undefined ? this.nome_nl : null as any;
        data["visibile"] = this.visibile !== undefined ? this.visibile : null as any;
        return data;
    }
}

export interface ISistemazione {
    sistemazioneID?: number;
    sistemazioneBaseID?: number | null;
    nome: string;
    nomeInglese?: string | null;
    memo?: string | null;
    nomeVoucher?: string | null;
    maxAdulti?: number;
    maxChildren?: number;
    nome_en?: string | null;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_nl?: string | null;
    visibile?: boolean | null;
}

export abstract class PartenzaBase implements IPartenzaBase {
    partenzaID?: number;
    servizioID?: number;
    data?: string | null;
    flags?: EPartenzaFlags;

    constructor(data?: IPartenzaBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partenzaID = _data["partenzaID"] !== undefined ? _data["partenzaID"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
            this.flags = _data["flags"] !== undefined ? _data["flags"] : null as any;
        }
    }

    static fromJS(data: any): PartenzaBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'PartenzaBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partenzaID"] = this.partenzaID !== undefined ? this.partenzaID : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["flags"] = this.flags !== undefined ? this.flags : null as any;
        return data;
    }
}

export interface IPartenzaBase {
    partenzaID?: number;
    servizioID?: number;
    data?: string | null;
    flags?: EPartenzaFlags;
}

export class Partenza extends PartenzaBase implements IPartenza {

    constructor(data?: IPartenza) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): Partenza {
        data = typeof data === 'object' ? data : {};
        let result = new Partenza();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPartenza extends IPartenzaBase {
}

export enum EPartenzaFlags {
    Nessuno = "Nessuno",
    Garantita = "Garantita",
    InItaliano = "InItaliano",
    SuRichiesta = "SuRichiesta",
    InInglese = "InInglese",
    InTedesco = "InTedesco",
    InFrancese = "InFrancese",
    InSpagnolo = "InSpagnolo",
    InOlandese = "InOlandese",
}

export class ServizioLuogo implements IServizioLuogo {
    servizioLuogoID?: number;
    servizioID?: number;
    luogoID?: number;

    constructor(data?: IServizioLuogo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servizioLuogoID = _data["servizioLuogoID"] !== undefined ? _data["servizioLuogoID"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
        }
    }

    static fromJS(data: any): ServizioLuogo {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioLuogo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioLuogoID"] = this.servizioLuogoID !== undefined ? this.servizioLuogoID : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        return data;
    }
}

export interface IServizioLuogo {
    servizioLuogoID?: number;
    servizioID?: number;
    luogoID?: number;
}

export class ServizioAssociazioneInfo implements IServizioAssociazioneInfo {
    id?: number;
    associazione?: ServizioAssociazione;
    configurazioneOfferta?: OffertaComponibile | null;
    labelOfferta?: string | null;
    disabilitata?: boolean;
    esclusioni?: string | null;
    codice?: string | null;
    priorita?: number | null;
    cumulabilita?: string | null;
    tipologiaParent?: ServizioTipologiaInfo | null;
    tipologiaSupplemento?: ServizioTipologiaInfo | null;
    regolaVendita?: ServizioRegolaVendita | null;
    tabellaCosti?: TabellaCostiCommissioniInfo | null;
    sistemazione?: SistemazioneInfo | null;
    trattamento?: TrattamentoInfo | null;
    isOffertaComponibile?: boolean;
    isOffertaComponibilePerTipologia?: boolean;
    isPerTipologia?: boolean;

    constructor(data?: IServizioAssociazioneInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.associazione = _data["associazione"] ? ServizioAssociazione.fromJS(_data["associazione"]) : null as any;
            this.configurazioneOfferta = _data["configurazioneOfferta"] ? OffertaComponibile.fromJS(_data["configurazioneOfferta"]) : null as any;
            this.labelOfferta = _data["labelOfferta"] !== undefined ? _data["labelOfferta"] : null as any;
            this.disabilitata = _data["disabilitata"] !== undefined ? _data["disabilitata"] : null as any;
            this.esclusioni = _data["esclusioni"] !== undefined ? _data["esclusioni"] : null as any;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
            this.priorita = _data["priorita"] !== undefined ? _data["priorita"] : null as any;
            this.cumulabilita = _data["cumulabilita"] !== undefined ? _data["cumulabilita"] : null as any;
            this.tipologiaParent = _data["tipologiaParent"] ? ServizioTipologiaInfo.fromJS(_data["tipologiaParent"]) : null as any;
            this.tipologiaSupplemento = _data["tipologiaSupplemento"] ? ServizioTipologiaInfo.fromJS(_data["tipologiaSupplemento"]) : null as any;
            this.regolaVendita = _data["regolaVendita"] ? ServizioRegolaVendita.fromJS(_data["regolaVendita"]) : null as any;
            this.tabellaCosti = _data["tabellaCosti"] ? TabellaCostiCommissioniInfo.fromJS(_data["tabellaCosti"]) : null as any;
            this.sistemazione = _data["sistemazione"] ? SistemazioneInfo.fromJS(_data["sistemazione"]) : null as any;
            this.trattamento = _data["trattamento"] ? TrattamentoInfo.fromJS(_data["trattamento"]) : null as any;
            this.isOffertaComponibile = _data["isOffertaComponibile"] !== undefined ? _data["isOffertaComponibile"] : null as any;
            this.isOffertaComponibilePerTipologia = _data["isOffertaComponibilePerTipologia"] !== undefined ? _data["isOffertaComponibilePerTipologia"] : null as any;
            this.isPerTipologia = _data["isPerTipologia"] !== undefined ? _data["isPerTipologia"] : null as any;
        }
    }

    static fromJS(data: any): ServizioAssociazioneInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioAssociazioneInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["associazione"] = this.associazione ? this.associazione.toJSON() : null as any;
        data["configurazioneOfferta"] = this.configurazioneOfferta ? this.configurazioneOfferta.toJSON() : null as any;
        data["labelOfferta"] = this.labelOfferta !== undefined ? this.labelOfferta : null as any;
        data["disabilitata"] = this.disabilitata !== undefined ? this.disabilitata : null as any;
        data["esclusioni"] = this.esclusioni !== undefined ? this.esclusioni : null as any;
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        data["priorita"] = this.priorita !== undefined ? this.priorita : null as any;
        data["cumulabilita"] = this.cumulabilita !== undefined ? this.cumulabilita : null as any;
        data["tipologiaParent"] = this.tipologiaParent ? this.tipologiaParent.toJSON() : null as any;
        data["tipologiaSupplemento"] = this.tipologiaSupplemento ? this.tipologiaSupplemento.toJSON() : null as any;
        data["regolaVendita"] = this.regolaVendita ? this.regolaVendita.toJSON() : null as any;
        data["tabellaCosti"] = this.tabellaCosti ? this.tabellaCosti.toJSON() : null as any;
        data["sistemazione"] = this.sistemazione ? this.sistemazione.toJSON() : null as any;
        data["trattamento"] = this.trattamento ? this.trattamento.toJSON() : null as any;
        data["isOffertaComponibile"] = this.isOffertaComponibile !== undefined ? this.isOffertaComponibile : null as any;
        data["isOffertaComponibilePerTipologia"] = this.isOffertaComponibilePerTipologia !== undefined ? this.isOffertaComponibilePerTipologia : null as any;
        data["isPerTipologia"] = this.isPerTipologia !== undefined ? this.isPerTipologia : null as any;
        return data;
    }
}

export interface IServizioAssociazioneInfo {
    id?: number;
    associazione?: ServizioAssociazione;
    configurazioneOfferta?: OffertaComponibile | null;
    labelOfferta?: string | null;
    disabilitata?: boolean;
    esclusioni?: string | null;
    codice?: string | null;
    priorita?: number | null;
    cumulabilita?: string | null;
    tipologiaParent?: ServizioTipologiaInfo | null;
    tipologiaSupplemento?: ServizioTipologiaInfo | null;
    regolaVendita?: ServizioRegolaVendita | null;
    tabellaCosti?: TabellaCostiCommissioniInfo | null;
    sistemazione?: SistemazioneInfo | null;
    trattamento?: TrattamentoInfo | null;
    isOffertaComponibile?: boolean;
    isOffertaComponibilePerTipologia?: boolean;
    isPerTipologia?: boolean;
}

export class ServizioAssociazioneBase implements IServizioAssociazioneBase {
    id?: number;
    servizioID?: number;
    tipologiaSupplementoID?: number | null;
    tipologiaParentID?: number | null;
    tabellaCostoID?: number | null;
    sistemazioneID?: number | null;
    ordine?: number | null;
    macroTipologia?: EMacrotipologia | null;
    tipoSupplemento?: ETipoSupplemento | null;
    regolaVenditaID?: number | null;
    dal?: string | null;
    al?: string | null;
    parametriOfferta?: string | null;
    cumulabilita?: string | null;
    trattamentoID?: number | null;
    tipoAssociazione?: ETipoAssociazione | null;
    tipoOffertaID?: number | null;

    constructor(data?: IServizioAssociazioneBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.tipologiaSupplementoID = _data["tipologiaSupplementoID"] !== undefined ? _data["tipologiaSupplementoID"] : null as any;
            this.tipologiaParentID = _data["tipologiaParentID"] !== undefined ? _data["tipologiaParentID"] : null as any;
            this.tabellaCostoID = _data["tabellaCostoID"] !== undefined ? _data["tabellaCostoID"] : null as any;
            this.sistemazioneID = _data["sistemazioneID"] !== undefined ? _data["sistemazioneID"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.macroTipologia = _data["macroTipologia"] !== undefined ? _data["macroTipologia"] : null as any;
            this.tipoSupplemento = _data["tipoSupplemento"] !== undefined ? _data["tipoSupplemento"] : null as any;
            this.regolaVenditaID = _data["regolaVenditaID"] !== undefined ? _data["regolaVenditaID"] : null as any;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.al = _data["al"] !== undefined ? _data["al"] : null as any;
            this.parametriOfferta = _data["parametriOfferta"] !== undefined ? _data["parametriOfferta"] : null as any;
            this.cumulabilita = _data["cumulabilita"] !== undefined ? _data["cumulabilita"] : null as any;
            this.trattamentoID = _data["trattamentoID"] !== undefined ? _data["trattamentoID"] : null as any;
            this.tipoAssociazione = _data["tipoAssociazione"] !== undefined ? _data["tipoAssociazione"] : null as any;
            this.tipoOffertaID = _data["tipoOffertaID"] !== undefined ? _data["tipoOffertaID"] : null as any;
        }
    }

    static fromJS(data: any): ServizioAssociazioneBase {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioAssociazioneBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["tipologiaSupplementoID"] = this.tipologiaSupplementoID !== undefined ? this.tipologiaSupplementoID : null as any;
        data["tipologiaParentID"] = this.tipologiaParentID !== undefined ? this.tipologiaParentID : null as any;
        data["tabellaCostoID"] = this.tabellaCostoID !== undefined ? this.tabellaCostoID : null as any;
        data["sistemazioneID"] = this.sistemazioneID !== undefined ? this.sistemazioneID : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["macroTipologia"] = this.macroTipologia !== undefined ? this.macroTipologia : null as any;
        data["tipoSupplemento"] = this.tipoSupplemento !== undefined ? this.tipoSupplemento : null as any;
        data["regolaVenditaID"] = this.regolaVenditaID !== undefined ? this.regolaVenditaID : null as any;
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["al"] = this.al !== undefined ? this.al : null as any;
        data["parametriOfferta"] = this.parametriOfferta !== undefined ? this.parametriOfferta : null as any;
        data["cumulabilita"] = this.cumulabilita !== undefined ? this.cumulabilita : null as any;
        data["trattamentoID"] = this.trattamentoID !== undefined ? this.trattamentoID : null as any;
        data["tipoAssociazione"] = this.tipoAssociazione !== undefined ? this.tipoAssociazione : null as any;
        data["tipoOffertaID"] = this.tipoOffertaID !== undefined ? this.tipoOffertaID : null as any;
        return data;
    }
}

export interface IServizioAssociazioneBase {
    id?: number;
    servizioID?: number;
    tipologiaSupplementoID?: number | null;
    tipologiaParentID?: number | null;
    tabellaCostoID?: number | null;
    sistemazioneID?: number | null;
    ordine?: number | null;
    macroTipologia?: EMacrotipologia | null;
    tipoSupplemento?: ETipoSupplemento | null;
    regolaVenditaID?: number | null;
    dal?: string | null;
    al?: string | null;
    parametriOfferta?: string | null;
    cumulabilita?: string | null;
    trattamentoID?: number | null;
    tipoAssociazione?: ETipoAssociazione | null;
    tipoOffertaID?: number | null;
}

export class ServizioAssociazione extends ServizioAssociazioneBase implements IServizioAssociazione {
    tipologiaEsternaID?: number | null;
    descrizioneWeb?: string | null;
    descrizioneVoucher?: string | null;

    constructor(data?: IServizioAssociazione) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tipologiaEsternaID = _data["tipologiaEsternaID"] !== undefined ? _data["tipologiaEsternaID"] : null as any;
            this.descrizioneWeb = _data["descrizioneWeb"] !== undefined ? _data["descrizioneWeb"] : null as any;
            this.descrizioneVoucher = _data["descrizioneVoucher"] !== undefined ? _data["descrizioneVoucher"] : null as any;
        }
    }

    static override fromJS(data: any): ServizioAssociazione {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioAssociazione();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipologiaEsternaID"] = this.tipologiaEsternaID !== undefined ? this.tipologiaEsternaID : null as any;
        data["descrizioneWeb"] = this.descrizioneWeb !== undefined ? this.descrizioneWeb : null as any;
        data["descrizioneVoucher"] = this.descrizioneVoucher !== undefined ? this.descrizioneVoucher : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IServizioAssociazione extends IServizioAssociazioneBase {
    tipologiaEsternaID?: number | null;
    descrizioneWeb?: string | null;
    descrizioneVoucher?: string | null;
}

export enum EMacrotipologia {
    TuttoTranneSupplementi = "TuttoTranneSupplementi",
    SoloSupplementi = "SoloSupplementi",
}

export enum ETipoAssociazione {
    TipologiaSupplemento = "TipologiaSupplemento",
    RegolaVenditaAggiuntiva = "RegolaVenditaAggiuntiva",
    OffertaComponibile = "OffertaComponibile",
    PenaliCancellazione = "PenaliCancellazione",
}

export class OffertaComponibile implements IOffertaComponibile {
    codice?: string;
    label?: string;
    priorita?: number;
    cumulabilita?: string | null;
    periodiEsclusione?: string | null;
    tipoApplicazione?: ETipoApplicazione;
    disabilitata?: boolean;
    noteInterne?: string | null;
    configurazionePrecondizioni?: EccezioneConfig[] | null;
    configurazioneAlgoritmo?: EccezioneConfig | null;

    constructor(data?: IOffertaComponibile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
            this.label = _data["label"] !== undefined ? _data["label"] : null as any;
            this.priorita = _data["priorita"] !== undefined ? _data["priorita"] : null as any;
            this.cumulabilita = _data["cumulabilita"] !== undefined ? _data["cumulabilita"] : null as any;
            this.periodiEsclusione = _data["periodiEsclusione"] !== undefined ? _data["periodiEsclusione"] : null as any;
            this.tipoApplicazione = _data["tipoApplicazione"] !== undefined ? _data["tipoApplicazione"] : null as any;
            this.disabilitata = _data["disabilitata"] !== undefined ? _data["disabilitata"] : null as any;
            this.noteInterne = _data["noteInterne"] !== undefined ? _data["noteInterne"] : null as any;
            if (Array.isArray(_data["configurazionePrecondizioni"])) {
                this.configurazionePrecondizioni = [] as any;
                for (let item of _data["configurazionePrecondizioni"])
                    this.configurazionePrecondizioni!.push(EccezioneConfig.fromJS(item));
            }
            else {
                this.configurazionePrecondizioni = null as any;
            }
            this.configurazioneAlgoritmo = _data["configurazioneAlgoritmo"] ? EccezioneConfig.fromJS(_data["configurazioneAlgoritmo"]) : null as any;
        }
    }

    static fromJS(data: any): OffertaComponibile {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaComponibile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        data["label"] = this.label !== undefined ? this.label : null as any;
        data["priorita"] = this.priorita !== undefined ? this.priorita : null as any;
        data["cumulabilita"] = this.cumulabilita !== undefined ? this.cumulabilita : null as any;
        data["periodiEsclusione"] = this.periodiEsclusione !== undefined ? this.periodiEsclusione : null as any;
        data["tipoApplicazione"] = this.tipoApplicazione !== undefined ? this.tipoApplicazione : null as any;
        data["disabilitata"] = this.disabilitata !== undefined ? this.disabilitata : null as any;
        data["noteInterne"] = this.noteInterne !== undefined ? this.noteInterne : null as any;
        if (Array.isArray(this.configurazionePrecondizioni)) {
            data["configurazionePrecondizioni"] = [];
            for (let item of this.configurazionePrecondizioni)
                data["configurazionePrecondizioni"].push(item ? item.toJSON() : null as any);
        }
        data["configurazioneAlgoritmo"] = this.configurazioneAlgoritmo ? this.configurazioneAlgoritmo.toJSON() : null as any;
        return data;
    }
}

export interface IOffertaComponibile {
    codice?: string;
    label?: string;
    priorita?: number;
    cumulabilita?: string | null;
    periodiEsclusione?: string | null;
    tipoApplicazione?: ETipoApplicazione;
    disabilitata?: boolean;
    noteInterne?: string | null;
    configurazionePrecondizioni?: EccezioneConfig[] | null;
    configurazioneAlgoritmo?: EccezioneConfig | null;
}

export enum ETipoApplicazione {
    Normale = "Normale",
    ApplicaENascondiPrezzo = "ApplicaENascondiPrezzo",
    ModificaQuoteBase = "ModificaQuoteBase",
    VisualizzaLabel = "VisualizzaLabel",
    BloccaVendita = "BloccaVendita",
    VisualizzaLabelAnonima = "VisualizzaLabelAnonima",
    VisualizzaLabelSupplemento = "VisualizzaLabelSupplemento",
    ForzaSuRichiesta = "ForzaSuRichiesta",
}

export class EccezioneConfig implements IEccezioneConfig {
    codice?: string;
    config?: any | null;

    constructor(data?: IEccezioneConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
            this.config = _data["config"] !== undefined ? _data["config"] : null as any;
        }
    }

    static fromJS(data: any): EccezioneConfig {
        data = typeof data === 'object' ? data : {};
        let result = new EccezioneConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        data["config"] = this.config !== undefined ? this.config : null as any;
        return data;
    }
}

export interface IEccezioneConfig {
    codice?: string;
    config?: any | null;
}

export class ServizioDatoAggiuntivoInfo implements IServizioDatoAggiuntivoInfo {
    tipoInfo?: DatoAggiuntivoTipoInfo;
    datoAggiuntivoInfo?: DatoAggiuntivoInfo;
    datoAggiuntivo?: DatoAggiuntivo;
    valore?: ServizioDatoAggiuntivo;

    constructor(data?: IServizioDatoAggiuntivoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoInfo = _data["tipoInfo"] ? DatoAggiuntivoTipoInfo.fromJS(_data["tipoInfo"]) : null as any;
            this.datoAggiuntivoInfo = _data["datoAggiuntivoInfo"] ? DatoAggiuntivoInfo.fromJS(_data["datoAggiuntivoInfo"]) : null as any;
            this.datoAggiuntivo = _data["datoAggiuntivo"] ? DatoAggiuntivo.fromJS(_data["datoAggiuntivo"]) : null as any;
            this.valore = _data["valore"] ? ServizioDatoAggiuntivo.fromJS(_data["valore"]) : null as any;
        }
    }

    static fromJS(data: any): ServizioDatoAggiuntivoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioDatoAggiuntivoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoInfo"] = this.tipoInfo ? this.tipoInfo.toJSON() : null as any;
        data["datoAggiuntivoInfo"] = this.datoAggiuntivoInfo ? this.datoAggiuntivoInfo.toJSON() : null as any;
        data["datoAggiuntivo"] = this.datoAggiuntivo ? this.datoAggiuntivo.toJSON() : null as any;
        data["valore"] = this.valore ? this.valore.toJSON() : null as any;
        return data;
    }
}

export interface IServizioDatoAggiuntivoInfo {
    tipoInfo?: DatoAggiuntivoTipoInfo;
    datoAggiuntivoInfo?: DatoAggiuntivoInfo;
    datoAggiuntivo?: DatoAggiuntivo;
    valore?: ServizioDatoAggiuntivo;
}

export class DatoAggiuntivoTipoInfo implements IDatoAggiuntivoTipoInfo {
    id?: number;
    tipo?: DatoAggiuntivoTipo;
    traduzioni?: IWebTranslationEntity[];
    nome?: string;
    nome_en?: string;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean;
    confirmed_en?: boolean;
    table?: string;

    constructor(data?: IDatoAggiuntivoTipoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.tipo = _data["tipo"] ? DatoAggiuntivoTipo.fromJS(_data["tipo"]) : null as any;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(IWebTranslationEntity.fromJS(item));
            }
            else {
                this.traduzioni = null as any;
            }
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : null as any;
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : null as any;
            this.lastUpdate_en = _data["lastUpdate_en"] !== undefined ? _data["lastUpdate_en"] : null as any;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : null as any;
            this.confirmed_en = _data["confirmed_en"] !== undefined ? _data["confirmed_en"] : null as any;
            this.table = _data["table"] !== undefined ? _data["table"] : null as any;
        }
    }

    static fromJS(data: any): DatoAggiuntivoTipoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DatoAggiuntivoTipoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["tipo"] = this.tipo ? this.tipo.toJSON() : null as any;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item ? item.toJSON() : null as any);
        }
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : null as any;
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : null as any;
        data["lastUpdate_en"] = this.lastUpdate_en !== undefined ? this.lastUpdate_en : null as any;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : null as any;
        data["confirmed_en"] = this.confirmed_en !== undefined ? this.confirmed_en : null as any;
        data["table"] = this.table !== undefined ? this.table : null as any;
        return data;
    }
}

export interface IDatoAggiuntivoTipoInfo {
    id?: number;
    tipo?: DatoAggiuntivoTipo;
    traduzioni?: IWebTranslationEntity[];
    nome?: string;
    nome_en?: string;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean;
    confirmed_en?: boolean;
    table?: string;
}

export class DatoAggiuntivoInfo implements IDatoAggiuntivoInfo {
    id?: number;
    dato?: DatoAggiuntivo;
    tipo?: DatoAggiuntivoTipoInfo;
    srtTipo?: string;
    tipoServizio?: ETipoServizio | null;
    srtLuogo?: string;
    luogo?: LuogoInfo | null;
    traduzioni?: IWebTranslationEntity[];
    nome?: string;
    nome_en?: string;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean;
    confirmed_en?: boolean;
    table?: string;

    constructor(data?: IDatoAggiuntivoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.dato = _data["dato"] ? DatoAggiuntivo.fromJS(_data["dato"]) : null as any;
            this.tipo = _data["tipo"] ? DatoAggiuntivoTipoInfo.fromJS(_data["tipo"]) : null as any;
            this.srtTipo = _data["srtTipo"] !== undefined ? _data["srtTipo"] : null as any;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
            this.srtLuogo = _data["srtLuogo"] !== undefined ? _data["srtLuogo"] : null as any;
            this.luogo = _data["luogo"] ? LuogoInfo.fromJS(_data["luogo"]) : null as any;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(IWebTranslationEntity.fromJS(item));
            }
            else {
                this.traduzioni = null as any;
            }
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : null as any;
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : null as any;
            this.lastUpdate_en = _data["lastUpdate_en"] !== undefined ? _data["lastUpdate_en"] : null as any;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : null as any;
            this.confirmed_en = _data["confirmed_en"] !== undefined ? _data["confirmed_en"] : null as any;
            this.table = _data["table"] !== undefined ? _data["table"] : null as any;
        }
    }

    static fromJS(data: any): DatoAggiuntivoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DatoAggiuntivoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["dato"] = this.dato ? this.dato.toJSON() : null as any;
        data["tipo"] = this.tipo ? this.tipo.toJSON() : null as any;
        data["srtTipo"] = this.srtTipo !== undefined ? this.srtTipo : null as any;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        data["srtLuogo"] = this.srtLuogo !== undefined ? this.srtLuogo : null as any;
        data["luogo"] = this.luogo ? this.luogo.toJSON() : null as any;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item ? item.toJSON() : null as any);
        }
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : null as any;
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : null as any;
        data["lastUpdate_en"] = this.lastUpdate_en !== undefined ? this.lastUpdate_en : null as any;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : null as any;
        data["confirmed_en"] = this.confirmed_en !== undefined ? this.confirmed_en : null as any;
        data["table"] = this.table !== undefined ? this.table : null as any;
        return data;
    }
}

export interface IDatoAggiuntivoInfo {
    id?: number;
    dato?: DatoAggiuntivo;
    tipo?: DatoAggiuntivoTipoInfo;
    srtTipo?: string;
    tipoServizio?: ETipoServizio | null;
    srtLuogo?: string;
    luogo?: LuogoInfo | null;
    traduzioni?: IWebTranslationEntity[];
    nome?: string;
    nome_en?: string;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean;
    confirmed_en?: boolean;
    table?: string;
}

export class ServizioDatoAggiuntivo implements IServizioDatoAggiuntivo {
    id?: number;
    servizioID?: number;
    datoAggiuntivoID?: number;
    tipoServizio?: ETipoServizio | null;
    valore?: string | null;
    dal?: string | null;
    al?: string | null;
    valore_fr?: string | null;
    valore_de?: string | null;
    valore_es?: string | null;
    valore_en?: string | null;

    constructor(data?: IServizioDatoAggiuntivo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.datoAggiuntivoID = _data["datoAggiuntivoID"] !== undefined ? _data["datoAggiuntivoID"] : null as any;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
            this.valore = _data["valore"] !== undefined ? _data["valore"] : null as any;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.al = _data["al"] !== undefined ? _data["al"] : null as any;
            this.valore_fr = _data["valore_fr"] !== undefined ? _data["valore_fr"] : null as any;
            this.valore_de = _data["valore_de"] !== undefined ? _data["valore_de"] : null as any;
            this.valore_es = _data["valore_es"] !== undefined ? _data["valore_es"] : null as any;
            this.valore_en = _data["valore_en"] !== undefined ? _data["valore_en"] : null as any;
        }
    }

    static fromJS(data: any): ServizioDatoAggiuntivo {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioDatoAggiuntivo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["datoAggiuntivoID"] = this.datoAggiuntivoID !== undefined ? this.datoAggiuntivoID : null as any;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        data["valore"] = this.valore !== undefined ? this.valore : null as any;
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["al"] = this.al !== undefined ? this.al : null as any;
        data["valore_fr"] = this.valore_fr !== undefined ? this.valore_fr : null as any;
        data["valore_de"] = this.valore_de !== undefined ? this.valore_de : null as any;
        data["valore_es"] = this.valore_es !== undefined ? this.valore_es : null as any;
        data["valore_en"] = this.valore_en !== undefined ? this.valore_en : null as any;
        return data;
    }
}

export interface IServizioDatoAggiuntivo {
    id?: number;
    servizioID?: number;
    datoAggiuntivoID?: number;
    tipoServizio?: ETipoServizio | null;
    valore?: string | null;
    dal?: string | null;
    al?: string | null;
    valore_fr?: string | null;
    valore_de?: string | null;
    valore_es?: string | null;
    valore_en?: string | null;
}

export class ServizioValiditaCosti implements IServizioValiditaCosti {
    servizioID?: number;
    dal?: string;
    al?: string;

    constructor(data?: IServizioValiditaCosti) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.al = _data["al"] !== undefined ? _data["al"] : null as any;
        }
    }

    static fromJS(data: any): ServizioValiditaCosti {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioValiditaCosti();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["al"] = this.al !== undefined ? this.al : null as any;
        return data;
    }
}

export interface IServizioValiditaCosti {
    servizioID?: number;
    dal?: string;
    al?: string;
}

export class PageLinkInfo implements IPageLinkInfo {
    id?: number;
    pageLink?: PageLink | null;
    luogo?: LuogoInfo | null;
    servizio?: ServizioInfo | null;
    contenuti?: PageLinkContentInfo[] | null;
    pubblicato?: boolean;

    constructor(data?: IPageLinkInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.pageLink = _data["pageLink"] ? PageLink.fromJS(_data["pageLink"]) : null as any;
            this.luogo = _data["luogo"] ? LuogoInfo.fromJS(_data["luogo"]) : null as any;
            this.servizio = _data["servizio"] ? ServizioInfo.fromJS(_data["servizio"]) : null as any;
            if (Array.isArray(_data["contenuti"])) {
                this.contenuti = [] as any;
                for (let item of _data["contenuti"])
                    this.contenuti!.push(PageLinkContentInfo.fromJS(item));
            }
            else {
                this.contenuti = null as any;
            }
            this.pubblicato = _data["pubblicato"] !== undefined ? _data["pubblicato"] : null as any;
        }
    }

    static fromJS(data: any): PageLinkInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PageLinkInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["pageLink"] = this.pageLink ? this.pageLink.toJSON() : null as any;
        data["luogo"] = this.luogo ? this.luogo.toJSON() : null as any;
        data["servizio"] = this.servizio ? this.servizio.toJSON() : null as any;
        if (Array.isArray(this.contenuti)) {
            data["contenuti"] = [];
            for (let item of this.contenuti)
                data["contenuti"].push(item ? item.toJSON() : null as any);
        }
        data["pubblicato"] = this.pubblicato !== undefined ? this.pubblicato : null as any;
        return data;
    }
}

export interface IPageLinkInfo {
    id?: number;
    pageLink?: PageLink | null;
    luogo?: LuogoInfo | null;
    servizio?: ServizioInfo | null;
    contenuti?: PageLinkContentInfo[] | null;
    pubblicato?: boolean;
}

export class PageLinkContentInfo implements IPageLinkContentInfo {
    id?: number;
    pageLinkContent?: PageLinkContent | null;
    articolo?: ArticoloInfo | null;
    isValid?: boolean;

    constructor(data?: IPageLinkContentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.pageLinkContent = _data["pageLinkContent"] ? PageLinkContent.fromJS(_data["pageLinkContent"]) : null as any;
            this.articolo = _data["articolo"] ? ArticoloInfo.fromJS(_data["articolo"]) : null as any;
            this.isValid = _data["isValid"] !== undefined ? _data["isValid"] : null as any;
        }
    }

    static fromJS(data: any): PageLinkContentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PageLinkContentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["pageLinkContent"] = this.pageLinkContent ? this.pageLinkContent.toJSON() : null as any;
        data["articolo"] = this.articolo ? this.articolo.toJSON() : null as any;
        data["isValid"] = this.isValid !== undefined ? this.isValid : null as any;
        return data;
    }
}

export interface IPageLinkContentInfo {
    id?: number;
    pageLinkContent?: PageLinkContent | null;
    articolo?: ArticoloInfo | null;
    isValid?: boolean;
}

export class ArticoloAttachmentInfo implements IArticoloAttachmentInfo {
    id?: number;
    articoloAttachment?: ArticoloAttachment;
    linkedFile?: FileInfoBase;

    constructor(data?: IArticoloAttachmentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.articoloAttachment = _data["articoloAttachment"] ? ArticoloAttachment.fromJS(_data["articoloAttachment"]) : null as any;
            this.linkedFile = _data["linkedFile"] ? FileInfoBase.fromJS(_data["linkedFile"]) : null as any;
        }
    }

    static fromJS(data: any): ArticoloAttachmentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloAttachmentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["articoloAttachment"] = this.articoloAttachment ? this.articoloAttachment.toJSON() : null as any;
        data["linkedFile"] = this.linkedFile ? this.linkedFile.toJSON() : null as any;
        return data;
    }
}

export interface IArticoloAttachmentInfo {
    id?: number;
    articoloAttachment?: ArticoloAttachment;
    linkedFile?: FileInfoBase;
}

export class ArticoloTraduzione implements IArticoloTraduzione {
    articoloID?: number;
    lingua?: ELingua;
    titolo?: string | null;
    sunto?: string | null;
    confermata?: boolean;
    ultimoAggiornamento?: string | null;

    constructor(data?: IArticoloTraduzione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articoloID = _data["articoloID"] !== undefined ? _data["articoloID"] : null as any;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : null as any;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            this.sunto = _data["sunto"] !== undefined ? _data["sunto"] : null as any;
            this.confermata = _data["confermata"] !== undefined ? _data["confermata"] : null as any;
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] !== undefined ? _data["ultimoAggiornamento"] : null as any;
        }
    }

    static fromJS(data: any): ArticoloTraduzione {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloTraduzione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articoloID"] = this.articoloID !== undefined ? this.articoloID : null as any;
        data["lingua"] = this.lingua !== undefined ? this.lingua : null as any;
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        data["sunto"] = this.sunto !== undefined ? this.sunto : null as any;
        data["confermata"] = this.confermata !== undefined ? this.confermata : null as any;
        data["ultimoAggiornamento"] = this.ultimoAggiornamento !== undefined ? this.ultimoAggiornamento : null as any;
        return data;
    }
}

export interface IArticoloTraduzione {
    articoloID?: number;
    lingua?: ELingua;
    titolo?: string | null;
    sunto?: string | null;
    confermata?: boolean;
    ultimoAggiornamento?: string | null;
}

export class AccordoContattoInfo implements IAccordoContattoInfo {
    id?: number;
    accordoContatto?: AccordoContatto;
    accordo?: AccordoInfo | null;
    terminePagamento?: TerminePagamentoInfo | null;
    terminePagamentoBiglietteria?: TerminePagamentoInfo | null;

    constructor(data?: IAccordoContattoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.accordoContatto = _data["accordoContatto"] ? AccordoContatto.fromJS(_data["accordoContatto"]) : null as any;
            this.accordo = _data["accordo"] ? AccordoInfo.fromJS(_data["accordo"]) : null as any;
            this.terminePagamento = _data["terminePagamento"] ? TerminePagamentoInfo.fromJS(_data["terminePagamento"]) : null as any;
            this.terminePagamentoBiglietteria = _data["terminePagamentoBiglietteria"] ? TerminePagamentoInfo.fromJS(_data["terminePagamentoBiglietteria"]) : null as any;
        }
    }

    static fromJS(data: any): AccordoContattoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AccordoContattoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["accordoContatto"] = this.accordoContatto ? this.accordoContatto.toJSON() : null as any;
        data["accordo"] = this.accordo ? this.accordo.toJSON() : null as any;
        data["terminePagamento"] = this.terminePagamento ? this.terminePagamento.toJSON() : null as any;
        data["terminePagamentoBiglietteria"] = this.terminePagamentoBiglietteria ? this.terminePagamentoBiglietteria.toJSON() : null as any;
        return data;
    }
}

export interface IAccordoContattoInfo {
    id?: number;
    accordoContatto?: AccordoContatto;
    accordo?: AccordoInfo | null;
    terminePagamento?: TerminePagamentoInfo | null;
    terminePagamentoBiglietteria?: TerminePagamentoInfo | null;
}

export class TerminePagamentoInfo implements ITerminePagamentoInfo {
    _Nomi?: { [key in keyof typeof ELingua]?: string; } | null;
    id?: number;
    terminePagamento?: TerminePagamento | null;
    isFactoring?: boolean;
    isAnticipato?: boolean;
    nomi?: { [key in keyof typeof ELingua]?: string; } | null;
    srtNome_it?: string | null;
    srtNome_en?: string | null;
    srtNome_fr?: string | null;
    srtNome_de?: string | null;
    srtNome_nl?: string | null;

    constructor(data?: ITerminePagamentoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["_Nomi"]) {
                this._Nomi = {} as any;
                for (let key in _data["_Nomi"]) {
                    if (_data["_Nomi"].hasOwnProperty(key))
                        (this._Nomi as any)![key] = _data["_Nomi"][key] !== undefined ? _data["_Nomi"][key] : null as any;
                }
            }
            else {
                this._Nomi = null as any;
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.terminePagamento = _data["terminePagamento"] ? TerminePagamento.fromJS(_data["terminePagamento"]) : null as any;
            this.isFactoring = _data["isFactoring"] !== undefined ? _data["isFactoring"] : null as any;
            this.isAnticipato = _data["isAnticipato"] !== undefined ? _data["isAnticipato"] : null as any;
            if (_data["nomi"]) {
                this.nomi = {} as any;
                for (let key in _data["nomi"]) {
                    if (_data["nomi"].hasOwnProperty(key))
                        (this.nomi as any)![key] = _data["nomi"][key] !== undefined ? _data["nomi"][key] : null as any;
                }
            }
            else {
                this.nomi = null as any;
            }
            this.srtNome_it = _data["srtNome_it"] !== undefined ? _data["srtNome_it"] : null as any;
            this.srtNome_en = _data["srtNome_en"] !== undefined ? _data["srtNome_en"] : null as any;
            this.srtNome_fr = _data["srtNome_fr"] !== undefined ? _data["srtNome_fr"] : null as any;
            this.srtNome_de = _data["srtNome_de"] !== undefined ? _data["srtNome_de"] : null as any;
            this.srtNome_nl = _data["srtNome_nl"] !== undefined ? _data["srtNome_nl"] : null as any;
        }
    }

    static fromJS(data: any): TerminePagamentoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TerminePagamentoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this._Nomi) {
            data["_Nomi"] = {};
            for (let key in this._Nomi) {
                if (this._Nomi.hasOwnProperty(key))
                    (data["_Nomi"] as any)[key] = this._Nomi[key] !== undefined ? this._Nomi[key] : null as any;
            }
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["terminePagamento"] = this.terminePagamento ? this.terminePagamento.toJSON() : null as any;
        data["isFactoring"] = this.isFactoring !== undefined ? this.isFactoring : null as any;
        data["isAnticipato"] = this.isAnticipato !== undefined ? this.isAnticipato : null as any;
        if (this.nomi) {
            data["nomi"] = {};
            for (let key in this.nomi) {
                if (this.nomi.hasOwnProperty(key))
                    (data["nomi"] as any)[key] = this.nomi[key] !== undefined ? this.nomi[key] : null as any;
            }
        }
        data["srtNome_it"] = this.srtNome_it !== undefined ? this.srtNome_it : null as any;
        data["srtNome_en"] = this.srtNome_en !== undefined ? this.srtNome_en : null as any;
        data["srtNome_fr"] = this.srtNome_fr !== undefined ? this.srtNome_fr : null as any;
        data["srtNome_de"] = this.srtNome_de !== undefined ? this.srtNome_de : null as any;
        data["srtNome_nl"] = this.srtNome_nl !== undefined ? this.srtNome_nl : null as any;
        return data;
    }
}

export interface ITerminePagamentoInfo {
    _Nomi?: { [key in keyof typeof ELingua]?: string; } | null;
    id?: number;
    terminePagamento?: TerminePagamento | null;
    isFactoring?: boolean;
    isAnticipato?: boolean;
    nomi?: { [key in keyof typeof ELingua]?: string; } | null;
    srtNome_it?: string | null;
    srtNome_en?: string | null;
    srtNome_fr?: string | null;
    srtNome_de?: string | null;
    srtNome_nl?: string | null;
}

export class TerminePagamento implements ITerminePagamento {
    pagamentoID?: number;
    nome!: string;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    nome_nl?: string | null;
    memo?: string | null;
    visibile?: boolean | null;
    eliminato?: string | null;
    searchTerms?: string | null;

    constructor(data?: ITerminePagamento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pagamentoID = _data["pagamentoID"] !== undefined ? _data["pagamentoID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nome_fr = _data["nome_fr"] !== undefined ? _data["nome_fr"] : null as any;
            this.nome_de = _data["nome_de"] !== undefined ? _data["nome_de"] : null as any;
            this.nome_es = _data["nome_es"] !== undefined ? _data["nome_es"] : null as any;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : null as any;
            this.nome_nl = _data["nome_nl"] !== undefined ? _data["nome_nl"] : null as any;
            this.memo = _data["memo"] !== undefined ? _data["memo"] : null as any;
            this.visibile = _data["visibile"] !== undefined ? _data["visibile"] : null as any;
            this.eliminato = _data["eliminato"] !== undefined ? _data["eliminato"] : null as any;
            this.searchTerms = _data["searchTerms"] !== undefined ? _data["searchTerms"] : null as any;
        }
    }

    static fromJS(data: any): TerminePagamento {
        data = typeof data === 'object' ? data : {};
        let result = new TerminePagamento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pagamentoID"] = this.pagamentoID !== undefined ? this.pagamentoID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nome_fr"] = this.nome_fr !== undefined ? this.nome_fr : null as any;
        data["nome_de"] = this.nome_de !== undefined ? this.nome_de : null as any;
        data["nome_es"] = this.nome_es !== undefined ? this.nome_es : null as any;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : null as any;
        data["nome_nl"] = this.nome_nl !== undefined ? this.nome_nl : null as any;
        data["memo"] = this.memo !== undefined ? this.memo : null as any;
        data["visibile"] = this.visibile !== undefined ? this.visibile : null as any;
        data["eliminato"] = this.eliminato !== undefined ? this.eliminato : null as any;
        data["searchTerms"] = this.searchTerms !== undefined ? this.searchTerms : null as any;
        return data;
    }
}

export interface ITerminePagamento {
    pagamentoID?: number;
    nome: string;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    nome_nl?: string | null;
    memo?: string | null;
    visibile?: boolean | null;
    eliminato?: string | null;
    searchTerms?: string | null;
}

export class ContattoStatistica implements IContattoStatistica {
    contattoID?: number;
    operatore?: EOperatore;
    preventiviPassati?: number | null;
    preventiviBkgPassati?: number | null;
    confermePassate?: number | null;
    fatturatoPassato?: number | null;
    preventiviFuturi?: number | null;
    preventiviBkgFuturi?: number | null;
    confermeFuture?: number | null;
    fatturatoFuturo?: number | null;
    percentualeConfermePassate?: number | null;
    note?: string | null;

    constructor(data?: IContattoStatistica) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.preventiviPassati = _data["preventiviPassati"] !== undefined ? _data["preventiviPassati"] : null as any;
            this.preventiviBkgPassati = _data["preventiviBkgPassati"] !== undefined ? _data["preventiviBkgPassati"] : null as any;
            this.confermePassate = _data["confermePassate"] !== undefined ? _data["confermePassate"] : null as any;
            this.fatturatoPassato = _data["fatturatoPassato"] !== undefined ? _data["fatturatoPassato"] : null as any;
            this.preventiviFuturi = _data["preventiviFuturi"] !== undefined ? _data["preventiviFuturi"] : null as any;
            this.preventiviBkgFuturi = _data["preventiviBkgFuturi"] !== undefined ? _data["preventiviBkgFuturi"] : null as any;
            this.confermeFuture = _data["confermeFuture"] !== undefined ? _data["confermeFuture"] : null as any;
            this.fatturatoFuturo = _data["fatturatoFuturo"] !== undefined ? _data["fatturatoFuturo"] : null as any;
            this.percentualeConfermePassate = _data["percentualeConfermePassate"] !== undefined ? _data["percentualeConfermePassate"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
        }
    }

    static fromJS(data: any): ContattoStatistica {
        data = typeof data === 'object' ? data : {};
        let result = new ContattoStatistica();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["preventiviPassati"] = this.preventiviPassati !== undefined ? this.preventiviPassati : null as any;
        data["preventiviBkgPassati"] = this.preventiviBkgPassati !== undefined ? this.preventiviBkgPassati : null as any;
        data["confermePassate"] = this.confermePassate !== undefined ? this.confermePassate : null as any;
        data["fatturatoPassato"] = this.fatturatoPassato !== undefined ? this.fatturatoPassato : null as any;
        data["preventiviFuturi"] = this.preventiviFuturi !== undefined ? this.preventiviFuturi : null as any;
        data["preventiviBkgFuturi"] = this.preventiviBkgFuturi !== undefined ? this.preventiviBkgFuturi : null as any;
        data["confermeFuture"] = this.confermeFuture !== undefined ? this.confermeFuture : null as any;
        data["fatturatoFuturo"] = this.fatturatoFuturo !== undefined ? this.fatturatoFuturo : null as any;
        data["percentualeConfermePassate"] = this.percentualeConfermePassate !== undefined ? this.percentualeConfermePassate : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        return data;
    }
}

export interface IContattoStatistica {
    contattoID?: number;
    operatore?: EOperatore;
    preventiviPassati?: number | null;
    preventiviBkgPassati?: number | null;
    confermePassate?: number | null;
    fatturatoPassato?: number | null;
    preventiviFuturi?: number | null;
    preventiviBkgFuturi?: number | null;
    confermeFuture?: number | null;
    fatturatoFuturo?: number | null;
    percentualeConfermePassate?: number | null;
    note?: string | null;
}

export class ValutaInfo implements IValutaInfo {
    id?: number;
    valuta?: Valuta;
    valoreCorrente?: ValutaValore | null;
    euroExchangeRate?: number;

    constructor(data?: IValutaInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.valuta = _data["valuta"] ? Valuta.fromJS(_data["valuta"]) : null as any;
            this.valoreCorrente = _data["valoreCorrente"] ? ValutaValore.fromJS(_data["valoreCorrente"]) : null as any;
            this.euroExchangeRate = _data["euroExchangeRate"] !== undefined ? _data["euroExchangeRate"] : null as any;
        }
    }

    static fromJS(data: any): ValutaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ValutaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["valuta"] = this.valuta ? this.valuta.toJSON() : null as any;
        data["valoreCorrente"] = this.valoreCorrente ? this.valoreCorrente.toJSON() : null as any;
        data["euroExchangeRate"] = this.euroExchangeRate !== undefined ? this.euroExchangeRate : null as any;
        return data;
    }
}

export interface IValutaInfo {
    id?: number;
    valuta?: Valuta;
    valoreCorrente?: ValutaValore | null;
    euroExchangeRate?: number;
}

export class Valuta implements IValuta {
    valutaID?: number;
    codice!: string;
    nome!: string;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    arrotondamento?: number | null;

    constructor(data?: IValuta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valutaID = _data["valutaID"] !== undefined ? _data["valutaID"] : null as any;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nome_fr = _data["nome_fr"] !== undefined ? _data["nome_fr"] : null as any;
            this.nome_de = _data["nome_de"] !== undefined ? _data["nome_de"] : null as any;
            this.nome_es = _data["nome_es"] !== undefined ? _data["nome_es"] : null as any;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : null as any;
            this.arrotondamento = _data["arrotondamento"] !== undefined ? _data["arrotondamento"] : null as any;
        }
    }

    static fromJS(data: any): Valuta {
        data = typeof data === 'object' ? data : {};
        let result = new Valuta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valutaID"] = this.valutaID !== undefined ? this.valutaID : null as any;
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nome_fr"] = this.nome_fr !== undefined ? this.nome_fr : null as any;
        data["nome_de"] = this.nome_de !== undefined ? this.nome_de : null as any;
        data["nome_es"] = this.nome_es !== undefined ? this.nome_es : null as any;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : null as any;
        data["arrotondamento"] = this.arrotondamento !== undefined ? this.arrotondamento : null as any;
        return data;
    }
}

export interface IValuta {
    valutaID?: number;
    codice: string;
    nome: string;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    arrotondamento?: number | null;
}

export class PricingInfo implements IPricingInfo {
    id?: number;
    pricing?: Pricing;
    rules?: PricingRule[];
    operator?: OperatoreInfo | null;
    searchTerms?: string;

    constructor(data?: IPricingInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.pricing = _data["pricing"] ? Pricing.fromJS(_data["pricing"]) : null as any;
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(PricingRule.fromJS(item));
            }
            else {
                this.rules = null as any;
            }
            this.operator = _data["operator"] ? OperatoreInfo.fromJS(_data["operator"]) : null as any;
            this.searchTerms = _data["searchTerms"] !== undefined ? _data["searchTerms"] : null as any;
        }
    }

    static fromJS(data: any): PricingInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PricingInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["pricing"] = this.pricing ? this.pricing.toJSON() : null as any;
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item ? item.toJSON() : null as any);
        }
        data["operator"] = this.operator ? this.operator.toJSON() : null as any;
        data["searchTerms"] = this.searchTerms !== undefined ? this.searchTerms : null as any;
        return data;
    }
}

export interface IPricingInfo {
    id?: number;
    pricing?: Pricing;
    rules?: PricingRule[];
    operator?: OperatoreInfo | null;
    searchTerms?: string;
}

export class PricingRule implements IPricingRule {
    id?: number;
    pricingID?: number;
    pricing?: Pricing | null;
    tripCreationFrom?: string | null;
    tripCreationTo?: string | null;
    tripDepartureFrom?: string | null;
    tripDepartureTo?: string | null;
    serviceType?: ETipoServizio | null;
    tripType?: EPriceRuleTripType;
    locationID?: number | null;
    deltaMargin?: number;
    priority?: number;

    constructor(data?: IPricingRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.pricingID = _data["pricingID"] !== undefined ? _data["pricingID"] : null as any;
            this.pricing = _data["pricing"] ? Pricing.fromJS(_data["pricing"]) : null as any;
            this.tripCreationFrom = _data["tripCreationFrom"] !== undefined ? _data["tripCreationFrom"] : null as any;
            this.tripCreationTo = _data["tripCreationTo"] !== undefined ? _data["tripCreationTo"] : null as any;
            this.tripDepartureFrom = _data["tripDepartureFrom"] !== undefined ? _data["tripDepartureFrom"] : null as any;
            this.tripDepartureTo = _data["tripDepartureTo"] !== undefined ? _data["tripDepartureTo"] : null as any;
            this.serviceType = _data["serviceType"] !== undefined ? _data["serviceType"] : null as any;
            this.tripType = _data["tripType"] !== undefined ? _data["tripType"] : null as any;
            this.locationID = _data["locationID"] !== undefined ? _data["locationID"] : null as any;
            this.deltaMargin = _data["deltaMargin"] !== undefined ? _data["deltaMargin"] : null as any;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : null as any;
        }
    }

    static fromJS(data: any): PricingRule {
        data = typeof data === 'object' ? data : {};
        let result = new PricingRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["pricingID"] = this.pricingID !== undefined ? this.pricingID : null as any;
        data["pricing"] = this.pricing ? this.pricing.toJSON() : null as any;
        data["tripCreationFrom"] = this.tripCreationFrom !== undefined ? this.tripCreationFrom : null as any;
        data["tripCreationTo"] = this.tripCreationTo !== undefined ? this.tripCreationTo : null as any;
        data["tripDepartureFrom"] = this.tripDepartureFrom !== undefined ? this.tripDepartureFrom : null as any;
        data["tripDepartureTo"] = this.tripDepartureTo !== undefined ? this.tripDepartureTo : null as any;
        data["serviceType"] = this.serviceType !== undefined ? this.serviceType : null as any;
        data["tripType"] = this.tripType !== undefined ? this.tripType : null as any;
        data["locationID"] = this.locationID !== undefined ? this.locationID : null as any;
        data["deltaMargin"] = this.deltaMargin !== undefined ? this.deltaMargin : null as any;
        data["priority"] = this.priority !== undefined ? this.priority : null as any;
        return data;
    }
}

export interface IPricingRule {
    id?: number;
    pricingID?: number;
    pricing?: Pricing | null;
    tripCreationFrom?: string | null;
    tripCreationTo?: string | null;
    tripDepartureFrom?: string | null;
    tripDepartureTo?: string | null;
    serviceType?: ETipoServizio | null;
    tripType?: EPriceRuleTripType;
    locationID?: number | null;
    deltaMargin?: number;
    priority?: number;
}

export enum EPriceRuleTripType {
    All = "All",
    TailorMade = "TailorMade",
    Packages = "Packages",
}

export class TagOffertaInfo implements ITagOffertaInfo {
    id?: number;
    tag?: TagOfferta;
    eliminato?: boolean;
    sortName_it?: string;
    sortName_en?: string;
    sortName_fr?: string;
    sortName_de?: string;

    constructor(data?: ITagOffertaInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.tag = _data["tag"] ? TagOfferta.fromJS(_data["tag"]) : null as any;
            this.eliminato = _data["eliminato"] !== undefined ? _data["eliminato"] : null as any;
            this.sortName_it = _data["sortName_it"] !== undefined ? _data["sortName_it"] : null as any;
            this.sortName_en = _data["sortName_en"] !== undefined ? _data["sortName_en"] : null as any;
            this.sortName_fr = _data["sortName_fr"] !== undefined ? _data["sortName_fr"] : null as any;
            this.sortName_de = _data["sortName_de"] !== undefined ? _data["sortName_de"] : null as any;
        }
    }

    static fromJS(data: any): TagOffertaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TagOffertaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["tag"] = this.tag ? this.tag.toJSON() : null as any;
        data["eliminato"] = this.eliminato !== undefined ? this.eliminato : null as any;
        data["sortName_it"] = this.sortName_it !== undefined ? this.sortName_it : null as any;
        data["sortName_en"] = this.sortName_en !== undefined ? this.sortName_en : null as any;
        data["sortName_fr"] = this.sortName_fr !== undefined ? this.sortName_fr : null as any;
        data["sortName_de"] = this.sortName_de !== undefined ? this.sortName_de : null as any;
        return data;
    }
}

export interface ITagOffertaInfo {
    id?: number;
    tag?: TagOfferta;
    eliminato?: boolean;
    sortName_it?: string;
    sortName_en?: string;
    sortName_fr?: string;
    sortName_de?: string;
}

export class TagOfferta implements ITagOfferta {
    id?: number;
    tag!: string;
    tag_en?: string | null;
    tag_fr?: string | null;
    tag_de?: string | null;
    tag_nl?: string | null;
    tag_es?: string | null;
    sistema?: boolean;
    uiOptions?: string | null;
    creato?: string;
    aggiornato?: string;
    eliminato?: string | null;

    constructor(data?: ITagOfferta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.tag = _data["tag"] !== undefined ? _data["tag"] : null as any;
            this.tag_en = _data["tag_en"] !== undefined ? _data["tag_en"] : null as any;
            this.tag_fr = _data["tag_fr"] !== undefined ? _data["tag_fr"] : null as any;
            this.tag_de = _data["tag_de"] !== undefined ? _data["tag_de"] : null as any;
            this.tag_nl = _data["tag_nl"] !== undefined ? _data["tag_nl"] : null as any;
            this.tag_es = _data["tag_es"] !== undefined ? _data["tag_es"] : null as any;
            this.sistema = _data["sistema"] !== undefined ? _data["sistema"] : null as any;
            this.uiOptions = _data["uiOptions"] !== undefined ? _data["uiOptions"] : null as any;
            this.creato = _data["creato"] !== undefined ? _data["creato"] : null as any;
            this.aggiornato = _data["aggiornato"] !== undefined ? _data["aggiornato"] : null as any;
            this.eliminato = _data["eliminato"] !== undefined ? _data["eliminato"] : null as any;
        }
    }

    static fromJS(data: any): TagOfferta {
        data = typeof data === 'object' ? data : {};
        let result = new TagOfferta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["tag"] = this.tag !== undefined ? this.tag : null as any;
        data["tag_en"] = this.tag_en !== undefined ? this.tag_en : null as any;
        data["tag_fr"] = this.tag_fr !== undefined ? this.tag_fr : null as any;
        data["tag_de"] = this.tag_de !== undefined ? this.tag_de : null as any;
        data["tag_nl"] = this.tag_nl !== undefined ? this.tag_nl : null as any;
        data["tag_es"] = this.tag_es !== undefined ? this.tag_es : null as any;
        data["sistema"] = this.sistema !== undefined ? this.sistema : null as any;
        data["uiOptions"] = this.uiOptions !== undefined ? this.uiOptions : null as any;
        data["creato"] = this.creato !== undefined ? this.creato : null as any;
        data["aggiornato"] = this.aggiornato !== undefined ? this.aggiornato : null as any;
        data["eliminato"] = this.eliminato !== undefined ? this.eliminato : null as any;
        return data;
    }
}

export interface ITagOfferta {
    id?: number;
    tag: string;
    tag_en?: string | null;
    tag_fr?: string | null;
    tag_de?: string | null;
    tag_nl?: string | null;
    tag_es?: string | null;
    sistema?: boolean;
    uiOptions?: string | null;
    creato?: string;
    aggiornato?: string;
    eliminato?: string | null;
}

export class UtenteInfo implements IUtenteInfo {
    id?: number;
    utente?: Utente;
    tipoUtente?: ETipoUtente;
    ultimaRichiesta?: string;
    username?: string;
    email?: string | null;
    nomeVisualizzato?: string;
    srtContattoAgenzia?: string | null;
    contattoUtente?: ContattoInfo;
    contattoAgenzia?: ContattoInfo | null;
    categoria?: CategoriaContatto | null;
    ruoli?: RuoloUtente[];
    isIntranet?: boolean;
    isDev?: boolean;
    isProduttore?: boolean;
    canBookFlights?: boolean;
    searchTerms?: string;
    permessi?: Permesso[];
    permessiCodici?: string[];
    uiOptions?: any;
    team?: TeamInfo | null;
    lingua?: ELingua | null;
    commissioneWebAgenzia?: number;

    constructor(data?: IUtenteInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.utente = _data["utente"] ? Utente.fromJS(_data["utente"]) : null as any;
            this.tipoUtente = _data["tipoUtente"] !== undefined ? _data["tipoUtente"] : null as any;
            this.ultimaRichiesta = _data["ultimaRichiesta"] !== undefined ? _data["ultimaRichiesta"] : null as any;
            this.username = _data["username"] !== undefined ? _data["username"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.nomeVisualizzato = _data["nomeVisualizzato"] !== undefined ? _data["nomeVisualizzato"] : null as any;
            this.srtContattoAgenzia = _data["srtContattoAgenzia"] !== undefined ? _data["srtContattoAgenzia"] : null as any;
            this.contattoUtente = _data["contattoUtente"] ? ContattoInfo.fromJS(_data["contattoUtente"]) : null as any;
            this.contattoAgenzia = _data["contattoAgenzia"] ? ContattoInfo.fromJS(_data["contattoAgenzia"]) : null as any;
            this.categoria = _data["categoria"] ? CategoriaContatto.fromJS(_data["categoria"]) : null as any;
            if (Array.isArray(_data["ruoli"])) {
                this.ruoli = [] as any;
                for (let item of _data["ruoli"])
                    this.ruoli!.push(RuoloUtente.fromJS(item));
            }
            else {
                this.ruoli = null as any;
            }
            this.isIntranet = _data["isIntranet"] !== undefined ? _data["isIntranet"] : null as any;
            this.isDev = _data["isDev"] !== undefined ? _data["isDev"] : null as any;
            this.isProduttore = _data["isProduttore"] !== undefined ? _data["isProduttore"] : null as any;
            this.canBookFlights = _data["canBookFlights"] !== undefined ? _data["canBookFlights"] : null as any;
            this.searchTerms = _data["searchTerms"] !== undefined ? _data["searchTerms"] : null as any;
            if (Array.isArray(_data["permessi"])) {
                this.permessi = [] as any;
                for (let item of _data["permessi"])
                    this.permessi!.push(Permesso.fromJS(item));
            }
            else {
                this.permessi = null as any;
            }
            if (Array.isArray(_data["permessiCodici"])) {
                this.permessiCodici = [] as any;
                for (let item of _data["permessiCodici"])
                    this.permessiCodici!.push(item);
            }
            else {
                this.permessiCodici = null as any;
            }
            this.uiOptions = _data["uiOptions"] !== undefined ? _data["uiOptions"] : null as any;
            this.team = _data["team"] ? TeamInfo.fromJS(_data["team"]) : null as any;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : null as any;
            this.commissioneWebAgenzia = _data["commissioneWebAgenzia"] !== undefined ? _data["commissioneWebAgenzia"] : null as any;
        }
    }

    static fromJS(data: any): UtenteInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UtenteInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["utente"] = this.utente ? this.utente.toJSON() : null as any;
        data["tipoUtente"] = this.tipoUtente !== undefined ? this.tipoUtente : null as any;
        data["ultimaRichiesta"] = this.ultimaRichiesta !== undefined ? this.ultimaRichiesta : null as any;
        data["username"] = this.username !== undefined ? this.username : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["nomeVisualizzato"] = this.nomeVisualizzato !== undefined ? this.nomeVisualizzato : null as any;
        data["srtContattoAgenzia"] = this.srtContattoAgenzia !== undefined ? this.srtContattoAgenzia : null as any;
        data["contattoUtente"] = this.contattoUtente ? this.contattoUtente.toJSON() : null as any;
        data["contattoAgenzia"] = this.contattoAgenzia ? this.contattoAgenzia.toJSON() : null as any;
        data["categoria"] = this.categoria ? this.categoria.toJSON() : null as any;
        if (Array.isArray(this.ruoli)) {
            data["ruoli"] = [];
            for (let item of this.ruoli)
                data["ruoli"].push(item ? item.toJSON() : null as any);
        }
        data["isIntranet"] = this.isIntranet !== undefined ? this.isIntranet : null as any;
        data["isDev"] = this.isDev !== undefined ? this.isDev : null as any;
        data["isProduttore"] = this.isProduttore !== undefined ? this.isProduttore : null as any;
        data["canBookFlights"] = this.canBookFlights !== undefined ? this.canBookFlights : null as any;
        data["searchTerms"] = this.searchTerms !== undefined ? this.searchTerms : null as any;
        if (Array.isArray(this.permessi)) {
            data["permessi"] = [];
            for (let item of this.permessi)
                data["permessi"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.permessiCodici)) {
            data["permessiCodici"] = [];
            for (let item of this.permessiCodici)
                data["permessiCodici"].push(item);
        }
        data["uiOptions"] = this.uiOptions !== undefined ? this.uiOptions : null as any;
        data["team"] = this.team ? this.team.toJSON() : null as any;
        data["lingua"] = this.lingua !== undefined ? this.lingua : null as any;
        data["commissioneWebAgenzia"] = this.commissioneWebAgenzia !== undefined ? this.commissioneWebAgenzia : null as any;
        return data;
    }
}

export interface IUtenteInfo {
    id?: number;
    utente?: Utente;
    tipoUtente?: ETipoUtente;
    ultimaRichiesta?: string;
    username?: string;
    email?: string | null;
    nomeVisualizzato?: string;
    srtContattoAgenzia?: string | null;
    contattoUtente?: ContattoInfo;
    contattoAgenzia?: ContattoInfo | null;
    categoria?: CategoriaContatto | null;
    ruoli?: RuoloUtente[];
    isIntranet?: boolean;
    isDev?: boolean;
    isProduttore?: boolean;
    canBookFlights?: boolean;
    searchTerms?: string;
    permessi?: Permesso[];
    permessiCodici?: string[];
    uiOptions?: any;
    team?: TeamInfo | null;
    lingua?: ELingua | null;
    commissioneWebAgenzia?: number;
}

export class RuoloUtente implements IRuoloUtente {
    id?: number;
    utenteID?: number;
    ruoloID?: number;

    constructor(data?: IRuoloUtente) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.utenteID = _data["utenteID"] !== undefined ? _data["utenteID"] : null as any;
            this.ruoloID = _data["ruoloID"] !== undefined ? _data["ruoloID"] : null as any;
        }
    }

    static fromJS(data: any): RuoloUtente {
        data = typeof data === 'object' ? data : {};
        let result = new RuoloUtente();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["utenteID"] = this.utenteID !== undefined ? this.utenteID : null as any;
        data["ruoloID"] = this.ruoloID !== undefined ? this.ruoloID : null as any;
        return data;
    }
}

export interface IRuoloUtente {
    id?: number;
    utenteID?: number;
    ruoloID?: number;
}

export class Permesso implements IPermesso {
    id?: number;
    categoriaID?: number;
    descrizione!: string;
    codice!: string;

    constructor(data?: IPermesso) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.categoriaID = _data["categoriaID"] !== undefined ? _data["categoriaID"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
        }
    }

    static fromJS(data: any): Permesso {
        data = typeof data === 'object' ? data : {};
        let result = new Permesso();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["categoriaID"] = this.categoriaID !== undefined ? this.categoriaID : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        return data;
    }
}

export interface IPermesso {
    id?: number;
    categoriaID?: number;
    descrizione: string;
    codice: string;
}

export class TeamInfo implements ITeamInfo {
    id?: string;
    team?: Team;

    constructor(data?: ITeamInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.team = _data["team"] ? Team.fromJS(_data["team"]) : null as any;
        }
    }

    static fromJS(data: any): TeamInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TeamInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["team"] = this.team ? this.team.toJSON() : null as any;
        return data;
    }
}

export interface ITeamInfo {
    id?: string;
    team?: Team;
}

export class Team implements ITeam {
    teamID!: string;
    nome!: string;
    email?: string | null;
    idTeam?: number;
    visibilita?: EVisibilitaTeam;
    operatore?: EOperatore;

    constructor(data?: ITeam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamID = _data["teamID"] !== undefined ? _data["teamID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.idTeam = _data["idTeam"] !== undefined ? _data["idTeam"] : null as any;
            this.visibilita = _data["visibilita"] !== undefined ? _data["visibilita"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
        }
    }

    static fromJS(data: any): Team {
        data = typeof data === 'object' ? data : {};
        let result = new Team();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamID"] = this.teamID !== undefined ? this.teamID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["idTeam"] = this.idTeam !== undefined ? this.idTeam : null as any;
        data["visibilita"] = this.visibilita !== undefined ? this.visibilita : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        return data;
    }
}

export interface ITeam {
    teamID: string;
    nome: string;
    email?: string | null;
    idTeam?: number;
    visibilita?: EVisibilitaTeam;
    operatore?: EOperatore;
}

export class ItinerarioOffertaInfo implements IItinerarioOffertaInfo {
    id?: number;
    itinerario?: OffertaItinerario;
    offerta?: OffertaInfo;
    itinerarioPackage?: ServizioItinerarioGiornoInfo | null;
    ordine?: number;
    dal?: string | null;
    localDal?: string | null;
    al?: string | null;
    localAl?: string | null;
    itinerarioAccessori?: boolean;
    luogo?: LuogoInfo;
    aeroporto?: Aeroporto | null;
    aeroportoPartenza?: Aeroporto | null;
    righe?: OffertaDatoInfo[];
    servizioCollegato?: ServizioInfo | null;
    servizioHotelCollegato?: ServizioInfo | null;
    tipologiaCollegata?: ServizioTipologia | null;
    itinerariSovrapposti?: ItinerarioOffertaInfo[];
    giorniMancantiPrima?: number;
    modificabile?: boolean;
    eliminabile?: boolean;
    haHotel?: boolean;
    haHotelTuttiIGiorni?: boolean;

    constructor(data?: IItinerarioOffertaInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.itinerario = _data["itinerario"] ? OffertaItinerario.fromJS(_data["itinerario"]) : null as any;
            this.offerta = _data["offerta"] ? OffertaInfo.fromJS(_data["offerta"]) : null as any;
            this.itinerarioPackage = _data["itinerarioPackage"] ? ServizioItinerarioGiornoInfo.fromJS(_data["itinerarioPackage"]) : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.localDal = _data["localDal"] !== undefined ? _data["localDal"] : null as any;
            this.al = _data["al"] !== undefined ? _data["al"] : null as any;
            this.localAl = _data["localAl"] !== undefined ? _data["localAl"] : null as any;
            this.itinerarioAccessori = _data["itinerarioAccessori"] !== undefined ? _data["itinerarioAccessori"] : null as any;
            this.luogo = _data["luogo"] ? LuogoInfo.fromJS(_data["luogo"]) : null as any;
            this.aeroporto = _data["aeroporto"] ? Aeroporto.fromJS(_data["aeroporto"]) : null as any;
            this.aeroportoPartenza = _data["aeroportoPartenza"] ? Aeroporto.fromJS(_data["aeroportoPartenza"]) : null as any;
            if (Array.isArray(_data["righe"])) {
                this.righe = [] as any;
                for (let item of _data["righe"])
                    this.righe!.push(OffertaDatoInfo.fromJS(item));
            }
            else {
                this.righe = null as any;
            }
            this.servizioCollegato = _data["servizioCollegato"] ? ServizioInfo.fromJS(_data["servizioCollegato"]) : null as any;
            this.servizioHotelCollegato = _data["servizioHotelCollegato"] ? ServizioInfo.fromJS(_data["servizioHotelCollegato"]) : null as any;
            this.tipologiaCollegata = _data["tipologiaCollegata"] ? ServizioTipologia.fromJS(_data["tipologiaCollegata"]) : null as any;
            if (Array.isArray(_data["itinerariSovrapposti"])) {
                this.itinerariSovrapposti = [] as any;
                for (let item of _data["itinerariSovrapposti"])
                    this.itinerariSovrapposti!.push(ItinerarioOffertaInfo.fromJS(item));
            }
            else {
                this.itinerariSovrapposti = null as any;
            }
            this.giorniMancantiPrima = _data["giorniMancantiPrima"] !== undefined ? _data["giorniMancantiPrima"] : null as any;
            this.modificabile = _data["modificabile"] !== undefined ? _data["modificabile"] : null as any;
            this.eliminabile = _data["eliminabile"] !== undefined ? _data["eliminabile"] : null as any;
            this.haHotel = _data["haHotel"] !== undefined ? _data["haHotel"] : null as any;
            this.haHotelTuttiIGiorni = _data["haHotelTuttiIGiorni"] !== undefined ? _data["haHotelTuttiIGiorni"] : null as any;
        }
    }

    static fromJS(data: any): ItinerarioOffertaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ItinerarioOffertaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["itinerario"] = this.itinerario ? this.itinerario.toJSON() : null as any;
        data["offerta"] = this.offerta ? this.offerta.toJSON() : null as any;
        data["itinerarioPackage"] = this.itinerarioPackage ? this.itinerarioPackage.toJSON() : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["localDal"] = this.localDal !== undefined ? this.localDal : null as any;
        data["al"] = this.al !== undefined ? this.al : null as any;
        data["localAl"] = this.localAl !== undefined ? this.localAl : null as any;
        data["itinerarioAccessori"] = this.itinerarioAccessori !== undefined ? this.itinerarioAccessori : null as any;
        data["luogo"] = this.luogo ? this.luogo.toJSON() : null as any;
        data["aeroporto"] = this.aeroporto ? this.aeroporto.toJSON() : null as any;
        data["aeroportoPartenza"] = this.aeroportoPartenza ? this.aeroportoPartenza.toJSON() : null as any;
        if (Array.isArray(this.righe)) {
            data["righe"] = [];
            for (let item of this.righe)
                data["righe"].push(item ? item.toJSON() : null as any);
        }
        data["servizioCollegato"] = this.servizioCollegato ? this.servizioCollegato.toJSON() : null as any;
        data["servizioHotelCollegato"] = this.servizioHotelCollegato ? this.servizioHotelCollegato.toJSON() : null as any;
        data["tipologiaCollegata"] = this.tipologiaCollegata ? this.tipologiaCollegata.toJSON() : null as any;
        if (Array.isArray(this.itinerariSovrapposti)) {
            data["itinerariSovrapposti"] = [];
            for (let item of this.itinerariSovrapposti)
                data["itinerariSovrapposti"].push(item ? item.toJSON() : null as any);
        }
        data["giorniMancantiPrima"] = this.giorniMancantiPrima !== undefined ? this.giorniMancantiPrima : null as any;
        data["modificabile"] = this.modificabile !== undefined ? this.modificabile : null as any;
        data["eliminabile"] = this.eliminabile !== undefined ? this.eliminabile : null as any;
        data["haHotel"] = this.haHotel !== undefined ? this.haHotel : null as any;
        data["haHotelTuttiIGiorni"] = this.haHotelTuttiIGiorni !== undefined ? this.haHotelTuttiIGiorni : null as any;
        return data;
    }
}

export interface IItinerarioOffertaInfo {
    id?: number;
    itinerario?: OffertaItinerario;
    offerta?: OffertaInfo;
    itinerarioPackage?: ServizioItinerarioGiornoInfo | null;
    ordine?: number;
    dal?: string | null;
    localDal?: string | null;
    al?: string | null;
    localAl?: string | null;
    itinerarioAccessori?: boolean;
    luogo?: LuogoInfo;
    aeroporto?: Aeroporto | null;
    aeroportoPartenza?: Aeroporto | null;
    righe?: OffertaDatoInfo[];
    servizioCollegato?: ServizioInfo | null;
    servizioHotelCollegato?: ServizioInfo | null;
    tipologiaCollegata?: ServizioTipologia | null;
    itinerariSovrapposti?: ItinerarioOffertaInfo[];
    giorniMancantiPrima?: number;
    modificabile?: boolean;
    eliminabile?: boolean;
    haHotel?: boolean;
    haHotelTuttiIGiorni?: boolean;
}

export class OffertaDatoInfo implements IOffertaDatoInfo {
    id?: number;
    rigaParentID?: number | null;
    offertaDato?: OffertaDato | null;
    stato?: OffertaDatoStato | null;
    offerta?: OffertaInfo | null;
    totaleCommissione?: number;
    inviiAssicurazioneFilodiretto?: InvioAssicurazioneFiloDiretto[] | null;
    inviiAssicurazione?: InvioAssicurazione[] | null;
    tipoRiga?: ETipoRiga;
    statoUtente?: EStatoServizioUtente;
    disponibilita?: EStatoDisponibilita;
    disponibilitaPrecedente?: EStatoDisponibilita;
    servizioIdUnivoco?: string | null;
    pagamentoAnticipato?: boolean;
    score?: number;
    datiDocumento?: DatiDocumentoRiga | null;
    datiConferma?: DatiConfermaRiga | null;
    regolaAnticipoFornitore?: ServizioAnticipoFornitoreInfo | null;
    anticipoFornitore?: AnticipoFornitore | null;
    prezziDisponibilitaVariati?: boolean;
    dettagli?: OffertaDatoDettaglio[] | null;
    servizioNonMappato?: boolean;
    righeSupplemento?: OffertaDatoInfo[] | null;
    noteAssociate?: OffertaNotaInfo[] | null;
    notaPenaleFornitore?: OffertaNotaInfo | null;
    notaPenaleCustom?: OffertaNotaInfo | null;
    accordo?: AccordoInfo | null;
    contattoServizioAggregato?: ContattoInfo | null;
    tabellaCostiCommissioni?: TabellaCostiCommissioniInfo | null;
    valuta?: ValutaInfo | null;
    servizio?: ServizioInfo | null;
    tipologia?: ServizioTipologia | null;
    tipologiaInfo?: ServizioTipologiaInfo | null;
    cliente?: ClienteInfo | null;
    costo?: Costo | null;
    prezzoIndicativo?: boolean;
    tipoPenale?: PenaleInfo | null;
    penale?: PenaleServizio | null;
    articoloPenale?: ArticoloInfo | null;
    codicePrenotazione?: string | null;
    sistemazione?: SistemazioneInfo | null;
    trattamento?: TrattamentoInfo | null;
    nomeServizioVoucher?: string | null;
    descrizioneServizioVoucher?: string | null;
    nomeSistemazioneVoucher?: string | null;
    nomeCameraVoucher?: string | null;
    ordineServizio?: number;
    hhCodiceID?: number | null;
    hashcode?: string | null;
    tipologiaH2H?: HHTipologiaFornitore | null;
    servizioH2H?: HHServizio | null;
    codiceServizioH2H?: string | null;
    codiceTipologiaH2H?: string | null;
    outputCustomData?: string | null;
    isVolo?: boolean;
    isVoloIP?: boolean;
    isVoloTO?: boolean;
    isSupplemento?: boolean;
    isRinunciaPeaceOfMind?: boolean;
    isPriceAdjustmentOrAgencyFee?: boolean;
    isPeaceOfMind?: boolean;
    itinerario?: ItinerarioOffertaInfo | null;
    itinerarioTour?: ServizioItinerarioInfo | null;
    luogoInizio?: LuogoInfo | null;
    luogoFine?: LuogoInfo | null;
    abbinamento?: AbbinamentoInfo | null;
    data?: string;
    dataCheckout?: string | null;
    notti?: number | null;
    prezzoPrecedente?: number;
    prezzoTotale?: number;
    prezzoTotaleNetto?: number;
    costoTotale?: number;
    costoTotaleEuro?: number;
    costoTotaleNetto?: number;
    tipoAcconto?: ETipoAcconto;
    tipoImportoAcconto?: ETipoImportoAcconto | null;
    dataAcconto?: string | null;
    totaleDaAnticipare?: number;
    marginePercentuale?: number;
    commissionePercentuale?: number;
    nettoIva?: boolean;
    nonVisibileADV?: boolean;
    totaleCommissioneTO?: number;

    constructor(data?: IOffertaDatoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.rigaParentID = _data["rigaParentID"] !== undefined ? _data["rigaParentID"] : null as any;
            this.offertaDato = _data["offertaDato"] ? OffertaDato.fromJS(_data["offertaDato"]) : null as any;
            this.stato = _data["stato"] ? OffertaDatoStato.fromJS(_data["stato"]) : null as any;
            this.offerta = _data["offerta"] ? OffertaInfo.fromJS(_data["offerta"]) : null as any;
            this.totaleCommissione = _data["totaleCommissione"] !== undefined ? _data["totaleCommissione"] : null as any;
            if (Array.isArray(_data["inviiAssicurazioneFilodiretto"])) {
                this.inviiAssicurazioneFilodiretto = [] as any;
                for (let item of _data["inviiAssicurazioneFilodiretto"])
                    this.inviiAssicurazioneFilodiretto!.push(InvioAssicurazioneFiloDiretto.fromJS(item));
            }
            else {
                this.inviiAssicurazioneFilodiretto = null as any;
            }
            if (Array.isArray(_data["inviiAssicurazione"])) {
                this.inviiAssicurazione = [] as any;
                for (let item of _data["inviiAssicurazione"])
                    this.inviiAssicurazione!.push(InvioAssicurazione.fromJS(item));
            }
            else {
                this.inviiAssicurazione = null as any;
            }
            this.tipoRiga = _data["tipoRiga"] !== undefined ? _data["tipoRiga"] : null as any;
            this.statoUtente = _data["statoUtente"] !== undefined ? _data["statoUtente"] : null as any;
            this.disponibilita = _data["disponibilita"] !== undefined ? _data["disponibilita"] : null as any;
            this.disponibilitaPrecedente = _data["disponibilitaPrecedente"] !== undefined ? _data["disponibilitaPrecedente"] : null as any;
            this.servizioIdUnivoco = _data["servizioIdUnivoco"] !== undefined ? _data["servizioIdUnivoco"] : null as any;
            this.pagamentoAnticipato = _data["pagamentoAnticipato"] !== undefined ? _data["pagamentoAnticipato"] : null as any;
            this.score = _data["score"] !== undefined ? _data["score"] : null as any;
            this.datiDocumento = _data["datiDocumento"] ? DatiDocumentoRiga.fromJS(_data["datiDocumento"]) : null as any;
            this.datiConferma = _data["datiConferma"] ? DatiConfermaRiga.fromJS(_data["datiConferma"]) : null as any;
            this.regolaAnticipoFornitore = _data["regolaAnticipoFornitore"] ? ServizioAnticipoFornitoreInfo.fromJS(_data["regolaAnticipoFornitore"]) : null as any;
            this.anticipoFornitore = _data["anticipoFornitore"] ? AnticipoFornitore.fromJS(_data["anticipoFornitore"]) : null as any;
            this.prezziDisponibilitaVariati = _data["prezziDisponibilitaVariati"] !== undefined ? _data["prezziDisponibilitaVariati"] : null as any;
            if (Array.isArray(_data["dettagli"])) {
                this.dettagli = [] as any;
                for (let item of _data["dettagli"])
                    this.dettagli!.push(OffertaDatoDettaglio.fromJS(item));
            }
            else {
                this.dettagli = null as any;
            }
            this.servizioNonMappato = _data["servizioNonMappato"] !== undefined ? _data["servizioNonMappato"] : null as any;
            if (Array.isArray(_data["righeSupplemento"])) {
                this.righeSupplemento = [] as any;
                for (let item of _data["righeSupplemento"])
                    this.righeSupplemento!.push(OffertaDatoInfo.fromJS(item));
            }
            else {
                this.righeSupplemento = null as any;
            }
            if (Array.isArray(_data["noteAssociate"])) {
                this.noteAssociate = [] as any;
                for (let item of _data["noteAssociate"])
                    this.noteAssociate!.push(OffertaNotaInfo.fromJS(item));
            }
            else {
                this.noteAssociate = null as any;
            }
            this.notaPenaleFornitore = _data["notaPenaleFornitore"] ? OffertaNotaInfo.fromJS(_data["notaPenaleFornitore"]) : null as any;
            this.notaPenaleCustom = _data["notaPenaleCustom"] ? OffertaNotaInfo.fromJS(_data["notaPenaleCustom"]) : null as any;
            this.accordo = _data["accordo"] ? AccordoInfo.fromJS(_data["accordo"]) : null as any;
            this.contattoServizioAggregato = _data["contattoServizioAggregato"] ? ContattoInfo.fromJS(_data["contattoServizioAggregato"]) : null as any;
            this.tabellaCostiCommissioni = _data["tabellaCostiCommissioni"] ? TabellaCostiCommissioniInfo.fromJS(_data["tabellaCostiCommissioni"]) : null as any;
            this.valuta = _data["valuta"] ? ValutaInfo.fromJS(_data["valuta"]) : null as any;
            this.servizio = _data["servizio"] ? ServizioInfo.fromJS(_data["servizio"]) : null as any;
            this.tipologia = _data["tipologia"] ? ServizioTipologia.fromJS(_data["tipologia"]) : null as any;
            this.tipologiaInfo = _data["tipologiaInfo"] ? ServizioTipologiaInfo.fromJS(_data["tipologiaInfo"]) : null as any;
            this.cliente = _data["cliente"] ? ClienteInfo.fromJS(_data["cliente"]) : null as any;
            this.costo = _data["costo"] ? Costo.fromJS(_data["costo"]) : null as any;
            this.prezzoIndicativo = _data["prezzoIndicativo"] !== undefined ? _data["prezzoIndicativo"] : null as any;
            this.tipoPenale = _data["tipoPenale"] ? PenaleInfo.fromJS(_data["tipoPenale"]) : null as any;
            this.penale = _data["penale"] ? PenaleServizio.fromJS(_data["penale"]) : null as any;
            this.articoloPenale = _data["articoloPenale"] ? ArticoloInfo.fromJS(_data["articoloPenale"]) : null as any;
            this.codicePrenotazione = _data["codicePrenotazione"] !== undefined ? _data["codicePrenotazione"] : null as any;
            this.sistemazione = _data["sistemazione"] ? SistemazioneInfo.fromJS(_data["sistemazione"]) : null as any;
            this.trattamento = _data["trattamento"] ? TrattamentoInfo.fromJS(_data["trattamento"]) : null as any;
            this.nomeServizioVoucher = _data["nomeServizioVoucher"] !== undefined ? _data["nomeServizioVoucher"] : null as any;
            this.descrizioneServizioVoucher = _data["descrizioneServizioVoucher"] !== undefined ? _data["descrizioneServizioVoucher"] : null as any;
            this.nomeSistemazioneVoucher = _data["nomeSistemazioneVoucher"] !== undefined ? _data["nomeSistemazioneVoucher"] : null as any;
            this.nomeCameraVoucher = _data["nomeCameraVoucher"] !== undefined ? _data["nomeCameraVoucher"] : null as any;
            this.ordineServizio = _data["ordineServizio"] !== undefined ? _data["ordineServizio"] : null as any;
            this.hhCodiceID = _data["hhCodiceID"] !== undefined ? _data["hhCodiceID"] : null as any;
            this.hashcode = _data["hashcode"] !== undefined ? _data["hashcode"] : null as any;
            this.tipologiaH2H = _data["tipologiaH2H"] ? HHTipologiaFornitore.fromJS(_data["tipologiaH2H"]) : null as any;
            this.servizioH2H = _data["servizioH2H"] ? HHServizio.fromJS(_data["servizioH2H"]) : null as any;
            this.codiceServizioH2H = _data["codiceServizioH2H"] !== undefined ? _data["codiceServizioH2H"] : null as any;
            this.codiceTipologiaH2H = _data["codiceTipologiaH2H"] !== undefined ? _data["codiceTipologiaH2H"] : null as any;
            this.outputCustomData = _data["outputCustomData"] !== undefined ? _data["outputCustomData"] : null as any;
            this.isVolo = _data["isVolo"] !== undefined ? _data["isVolo"] : null as any;
            this.isVoloIP = _data["isVoloIP"] !== undefined ? _data["isVoloIP"] : null as any;
            this.isVoloTO = _data["isVoloTO"] !== undefined ? _data["isVoloTO"] : null as any;
            this.isSupplemento = _data["isSupplemento"] !== undefined ? _data["isSupplemento"] : null as any;
            this.isRinunciaPeaceOfMind = _data["isRinunciaPeaceOfMind"] !== undefined ? _data["isRinunciaPeaceOfMind"] : null as any;
            this.isPriceAdjustmentOrAgencyFee = _data["isPriceAdjustmentOrAgencyFee"] !== undefined ? _data["isPriceAdjustmentOrAgencyFee"] : null as any;
            this.isPeaceOfMind = _data["isPeaceOfMind"] !== undefined ? _data["isPeaceOfMind"] : null as any;
            this.itinerario = _data["itinerario"] ? ItinerarioOffertaInfo.fromJS(_data["itinerario"]) : null as any;
            this.itinerarioTour = _data["itinerarioTour"] ? ServizioItinerarioInfo.fromJS(_data["itinerarioTour"]) : null as any;
            this.luogoInizio = _data["luogoInizio"] ? LuogoInfo.fromJS(_data["luogoInizio"]) : null as any;
            this.luogoFine = _data["luogoFine"] ? LuogoInfo.fromJS(_data["luogoFine"]) : null as any;
            this.abbinamento = _data["abbinamento"] ? AbbinamentoInfo.fromJS(_data["abbinamento"]) : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
            this.dataCheckout = _data["dataCheckout"] !== undefined ? _data["dataCheckout"] : null as any;
            this.notti = _data["notti"] !== undefined ? _data["notti"] : null as any;
            this.prezzoPrecedente = _data["prezzoPrecedente"] !== undefined ? _data["prezzoPrecedente"] : null as any;
            this.prezzoTotale = _data["prezzoTotale"] !== undefined ? _data["prezzoTotale"] : null as any;
            this.prezzoTotaleNetto = _data["prezzoTotaleNetto"] !== undefined ? _data["prezzoTotaleNetto"] : null as any;
            this.costoTotale = _data["costoTotale"] !== undefined ? _data["costoTotale"] : null as any;
            this.costoTotaleEuro = _data["costoTotaleEuro"] !== undefined ? _data["costoTotaleEuro"] : null as any;
            this.costoTotaleNetto = _data["costoTotaleNetto"] !== undefined ? _data["costoTotaleNetto"] : null as any;
            this.tipoAcconto = _data["tipoAcconto"] !== undefined ? _data["tipoAcconto"] : null as any;
            this.tipoImportoAcconto = _data["tipoImportoAcconto"] !== undefined ? _data["tipoImportoAcconto"] : null as any;
            this.dataAcconto = _data["dataAcconto"] !== undefined ? _data["dataAcconto"] : null as any;
            this.totaleDaAnticipare = _data["totaleDaAnticipare"] !== undefined ? _data["totaleDaAnticipare"] : null as any;
            this.marginePercentuale = _data["marginePercentuale"] !== undefined ? _data["marginePercentuale"] : null as any;
            this.commissionePercentuale = _data["commissionePercentuale"] !== undefined ? _data["commissionePercentuale"] : null as any;
            this.nettoIva = _data["nettoIva"] !== undefined ? _data["nettoIva"] : null as any;
            this.nonVisibileADV = _data["nonVisibileADV"] !== undefined ? _data["nonVisibileADV"] : null as any;
            this.totaleCommissioneTO = _data["totaleCommissioneTO"] !== undefined ? _data["totaleCommissioneTO"] : null as any;
        }
    }

    static fromJS(data: any): OffertaDatoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaDatoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["rigaParentID"] = this.rigaParentID !== undefined ? this.rigaParentID : null as any;
        data["offertaDato"] = this.offertaDato ? this.offertaDato.toJSON() : null as any;
        data["stato"] = this.stato ? this.stato.toJSON() : null as any;
        data["offerta"] = this.offerta ? this.offerta.toJSON() : null as any;
        data["totaleCommissione"] = this.totaleCommissione !== undefined ? this.totaleCommissione : null as any;
        if (Array.isArray(this.inviiAssicurazioneFilodiretto)) {
            data["inviiAssicurazioneFilodiretto"] = [];
            for (let item of this.inviiAssicurazioneFilodiretto)
                data["inviiAssicurazioneFilodiretto"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.inviiAssicurazione)) {
            data["inviiAssicurazione"] = [];
            for (let item of this.inviiAssicurazione)
                data["inviiAssicurazione"].push(item ? item.toJSON() : null as any);
        }
        data["tipoRiga"] = this.tipoRiga !== undefined ? this.tipoRiga : null as any;
        data["statoUtente"] = this.statoUtente !== undefined ? this.statoUtente : null as any;
        data["disponibilita"] = this.disponibilita !== undefined ? this.disponibilita : null as any;
        data["disponibilitaPrecedente"] = this.disponibilitaPrecedente !== undefined ? this.disponibilitaPrecedente : null as any;
        data["servizioIdUnivoco"] = this.servizioIdUnivoco !== undefined ? this.servizioIdUnivoco : null as any;
        data["pagamentoAnticipato"] = this.pagamentoAnticipato !== undefined ? this.pagamentoAnticipato : null as any;
        data["score"] = this.score !== undefined ? this.score : null as any;
        data["datiDocumento"] = this.datiDocumento ? this.datiDocumento.toJSON() : null as any;
        data["datiConferma"] = this.datiConferma ? this.datiConferma.toJSON() : null as any;
        data["regolaAnticipoFornitore"] = this.regolaAnticipoFornitore ? this.regolaAnticipoFornitore.toJSON() : null as any;
        data["anticipoFornitore"] = this.anticipoFornitore ? this.anticipoFornitore.toJSON() : null as any;
        data["prezziDisponibilitaVariati"] = this.prezziDisponibilitaVariati !== undefined ? this.prezziDisponibilitaVariati : null as any;
        if (Array.isArray(this.dettagli)) {
            data["dettagli"] = [];
            for (let item of this.dettagli)
                data["dettagli"].push(item ? item.toJSON() : null as any);
        }
        data["servizioNonMappato"] = this.servizioNonMappato !== undefined ? this.servizioNonMappato : null as any;
        if (Array.isArray(this.righeSupplemento)) {
            data["righeSupplemento"] = [];
            for (let item of this.righeSupplemento)
                data["righeSupplemento"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.noteAssociate)) {
            data["noteAssociate"] = [];
            for (let item of this.noteAssociate)
                data["noteAssociate"].push(item ? item.toJSON() : null as any);
        }
        data["notaPenaleFornitore"] = this.notaPenaleFornitore ? this.notaPenaleFornitore.toJSON() : null as any;
        data["notaPenaleCustom"] = this.notaPenaleCustom ? this.notaPenaleCustom.toJSON() : null as any;
        data["accordo"] = this.accordo ? this.accordo.toJSON() : null as any;
        data["contattoServizioAggregato"] = this.contattoServizioAggregato ? this.contattoServizioAggregato.toJSON() : null as any;
        data["tabellaCostiCommissioni"] = this.tabellaCostiCommissioni ? this.tabellaCostiCommissioni.toJSON() : null as any;
        data["valuta"] = this.valuta ? this.valuta.toJSON() : null as any;
        data["servizio"] = this.servizio ? this.servizio.toJSON() : null as any;
        data["tipologia"] = this.tipologia ? this.tipologia.toJSON() : null as any;
        data["tipologiaInfo"] = this.tipologiaInfo ? this.tipologiaInfo.toJSON() : null as any;
        data["cliente"] = this.cliente ? this.cliente.toJSON() : null as any;
        data["costo"] = this.costo ? this.costo.toJSON() : null as any;
        data["prezzoIndicativo"] = this.prezzoIndicativo !== undefined ? this.prezzoIndicativo : null as any;
        data["tipoPenale"] = this.tipoPenale ? this.tipoPenale.toJSON() : null as any;
        data["penale"] = this.penale ? this.penale.toJSON() : null as any;
        data["articoloPenale"] = this.articoloPenale ? this.articoloPenale.toJSON() : null as any;
        data["codicePrenotazione"] = this.codicePrenotazione !== undefined ? this.codicePrenotazione : null as any;
        data["sistemazione"] = this.sistemazione ? this.sistemazione.toJSON() : null as any;
        data["trattamento"] = this.trattamento ? this.trattamento.toJSON() : null as any;
        data["nomeServizioVoucher"] = this.nomeServizioVoucher !== undefined ? this.nomeServizioVoucher : null as any;
        data["descrizioneServizioVoucher"] = this.descrizioneServizioVoucher !== undefined ? this.descrizioneServizioVoucher : null as any;
        data["nomeSistemazioneVoucher"] = this.nomeSistemazioneVoucher !== undefined ? this.nomeSistemazioneVoucher : null as any;
        data["nomeCameraVoucher"] = this.nomeCameraVoucher !== undefined ? this.nomeCameraVoucher : null as any;
        data["ordineServizio"] = this.ordineServizio !== undefined ? this.ordineServizio : null as any;
        data["hhCodiceID"] = this.hhCodiceID !== undefined ? this.hhCodiceID : null as any;
        data["hashcode"] = this.hashcode !== undefined ? this.hashcode : null as any;
        data["tipologiaH2H"] = this.tipologiaH2H ? this.tipologiaH2H.toJSON() : null as any;
        data["servizioH2H"] = this.servizioH2H ? this.servizioH2H.toJSON() : null as any;
        data["codiceServizioH2H"] = this.codiceServizioH2H !== undefined ? this.codiceServizioH2H : null as any;
        data["codiceTipologiaH2H"] = this.codiceTipologiaH2H !== undefined ? this.codiceTipologiaH2H : null as any;
        data["outputCustomData"] = this.outputCustomData !== undefined ? this.outputCustomData : null as any;
        data["isVolo"] = this.isVolo !== undefined ? this.isVolo : null as any;
        data["isVoloIP"] = this.isVoloIP !== undefined ? this.isVoloIP : null as any;
        data["isVoloTO"] = this.isVoloTO !== undefined ? this.isVoloTO : null as any;
        data["isSupplemento"] = this.isSupplemento !== undefined ? this.isSupplemento : null as any;
        data["isRinunciaPeaceOfMind"] = this.isRinunciaPeaceOfMind !== undefined ? this.isRinunciaPeaceOfMind : null as any;
        data["isPriceAdjustmentOrAgencyFee"] = this.isPriceAdjustmentOrAgencyFee !== undefined ? this.isPriceAdjustmentOrAgencyFee : null as any;
        data["isPeaceOfMind"] = this.isPeaceOfMind !== undefined ? this.isPeaceOfMind : null as any;
        data["itinerario"] = this.itinerario ? this.itinerario.toJSON() : null as any;
        data["itinerarioTour"] = this.itinerarioTour ? this.itinerarioTour.toJSON() : null as any;
        data["luogoInizio"] = this.luogoInizio ? this.luogoInizio.toJSON() : null as any;
        data["luogoFine"] = this.luogoFine ? this.luogoFine.toJSON() : null as any;
        data["abbinamento"] = this.abbinamento ? this.abbinamento.toJSON() : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["dataCheckout"] = this.dataCheckout !== undefined ? this.dataCheckout : null as any;
        data["notti"] = this.notti !== undefined ? this.notti : null as any;
        data["prezzoPrecedente"] = this.prezzoPrecedente !== undefined ? this.prezzoPrecedente : null as any;
        data["prezzoTotale"] = this.prezzoTotale !== undefined ? this.prezzoTotale : null as any;
        data["prezzoTotaleNetto"] = this.prezzoTotaleNetto !== undefined ? this.prezzoTotaleNetto : null as any;
        data["costoTotale"] = this.costoTotale !== undefined ? this.costoTotale : null as any;
        data["costoTotaleEuro"] = this.costoTotaleEuro !== undefined ? this.costoTotaleEuro : null as any;
        data["costoTotaleNetto"] = this.costoTotaleNetto !== undefined ? this.costoTotaleNetto : null as any;
        data["tipoAcconto"] = this.tipoAcconto !== undefined ? this.tipoAcconto : null as any;
        data["tipoImportoAcconto"] = this.tipoImportoAcconto !== undefined ? this.tipoImportoAcconto : null as any;
        data["dataAcconto"] = this.dataAcconto !== undefined ? this.dataAcconto : null as any;
        data["totaleDaAnticipare"] = this.totaleDaAnticipare !== undefined ? this.totaleDaAnticipare : null as any;
        data["marginePercentuale"] = this.marginePercentuale !== undefined ? this.marginePercentuale : null as any;
        data["commissionePercentuale"] = this.commissionePercentuale !== undefined ? this.commissionePercentuale : null as any;
        data["nettoIva"] = this.nettoIva !== undefined ? this.nettoIva : null as any;
        data["nonVisibileADV"] = this.nonVisibileADV !== undefined ? this.nonVisibileADV : null as any;
        data["totaleCommissioneTO"] = this.totaleCommissioneTO !== undefined ? this.totaleCommissioneTO : null as any;
        return data;
    }
}

export interface IOffertaDatoInfo {
    id?: number;
    rigaParentID?: number | null;
    offertaDato?: OffertaDato | null;
    stato?: OffertaDatoStato | null;
    offerta?: OffertaInfo | null;
    totaleCommissione?: number;
    inviiAssicurazioneFilodiretto?: InvioAssicurazioneFiloDiretto[] | null;
    inviiAssicurazione?: InvioAssicurazione[] | null;
    tipoRiga?: ETipoRiga;
    statoUtente?: EStatoServizioUtente;
    disponibilita?: EStatoDisponibilita;
    disponibilitaPrecedente?: EStatoDisponibilita;
    servizioIdUnivoco?: string | null;
    pagamentoAnticipato?: boolean;
    score?: number;
    datiDocumento?: DatiDocumentoRiga | null;
    datiConferma?: DatiConfermaRiga | null;
    regolaAnticipoFornitore?: ServizioAnticipoFornitoreInfo | null;
    anticipoFornitore?: AnticipoFornitore | null;
    prezziDisponibilitaVariati?: boolean;
    dettagli?: OffertaDatoDettaglio[] | null;
    servizioNonMappato?: boolean;
    righeSupplemento?: OffertaDatoInfo[] | null;
    noteAssociate?: OffertaNotaInfo[] | null;
    notaPenaleFornitore?: OffertaNotaInfo | null;
    notaPenaleCustom?: OffertaNotaInfo | null;
    accordo?: AccordoInfo | null;
    contattoServizioAggregato?: ContattoInfo | null;
    tabellaCostiCommissioni?: TabellaCostiCommissioniInfo | null;
    valuta?: ValutaInfo | null;
    servizio?: ServizioInfo | null;
    tipologia?: ServizioTipologia | null;
    tipologiaInfo?: ServizioTipologiaInfo | null;
    cliente?: ClienteInfo | null;
    costo?: Costo | null;
    prezzoIndicativo?: boolean;
    tipoPenale?: PenaleInfo | null;
    penale?: PenaleServizio | null;
    articoloPenale?: ArticoloInfo | null;
    codicePrenotazione?: string | null;
    sistemazione?: SistemazioneInfo | null;
    trattamento?: TrattamentoInfo | null;
    nomeServizioVoucher?: string | null;
    descrizioneServizioVoucher?: string | null;
    nomeSistemazioneVoucher?: string | null;
    nomeCameraVoucher?: string | null;
    ordineServizio?: number;
    hhCodiceID?: number | null;
    hashcode?: string | null;
    tipologiaH2H?: HHTipologiaFornitore | null;
    servizioH2H?: HHServizio | null;
    codiceServizioH2H?: string | null;
    codiceTipologiaH2H?: string | null;
    outputCustomData?: string | null;
    isVolo?: boolean;
    isVoloIP?: boolean;
    isVoloTO?: boolean;
    isSupplemento?: boolean;
    isRinunciaPeaceOfMind?: boolean;
    isPriceAdjustmentOrAgencyFee?: boolean;
    isPeaceOfMind?: boolean;
    itinerario?: ItinerarioOffertaInfo | null;
    itinerarioTour?: ServizioItinerarioInfo | null;
    luogoInizio?: LuogoInfo | null;
    luogoFine?: LuogoInfo | null;
    abbinamento?: AbbinamentoInfo | null;
    data?: string;
    dataCheckout?: string | null;
    notti?: number | null;
    prezzoPrecedente?: number;
    prezzoTotale?: number;
    prezzoTotaleNetto?: number;
    costoTotale?: number;
    costoTotaleEuro?: number;
    costoTotaleNetto?: number;
    tipoAcconto?: ETipoAcconto;
    tipoImportoAcconto?: ETipoImportoAcconto | null;
    dataAcconto?: string | null;
    totaleDaAnticipare?: number;
    marginePercentuale?: number;
    commissionePercentuale?: number;
    nettoIva?: boolean;
    nonVisibileADV?: boolean;
    totaleCommissioneTO?: number;
}

export class ServizioAnticipoFornitoreInfo implements IServizioAnticipoFornitoreInfo {
    id?: number;
    servizioAnticipoFornitore?: ServizioAnticipoFornitore;
    srtNome?: string;
    accordo?: AccordoInfo | null;
    srtAccordo?: string | null;
    servizio?: ServizioInfo | null;
    srtServizio_it?: string | null;
    srtServizio_en?: string | null;
    srtServizio_fr?: string | null;
    srtServizio_de?: string | null;
    luogo?: LuogoInfo | null;
    srtLuogo_it?: string | null;
    srtLuogo_en?: string | null;
    srtLuogo_fr?: string | null;
    srtLuogo_de?: string | null;
    terms?: string;

    constructor(data?: IServizioAnticipoFornitoreInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.servizioAnticipoFornitore = _data["servizioAnticipoFornitore"] ? ServizioAnticipoFornitore.fromJS(_data["servizioAnticipoFornitore"]) : null as any;
            this.srtNome = _data["srtNome"] !== undefined ? _data["srtNome"] : null as any;
            this.accordo = _data["accordo"] ? AccordoInfo.fromJS(_data["accordo"]) : null as any;
            this.srtAccordo = _data["srtAccordo"] !== undefined ? _data["srtAccordo"] : null as any;
            this.servizio = _data["servizio"] ? ServizioInfo.fromJS(_data["servizio"]) : null as any;
            this.srtServizio_it = _data["srtServizio_it"] !== undefined ? _data["srtServizio_it"] : null as any;
            this.srtServizio_en = _data["srtServizio_en"] !== undefined ? _data["srtServizio_en"] : null as any;
            this.srtServizio_fr = _data["srtServizio_fr"] !== undefined ? _data["srtServizio_fr"] : null as any;
            this.srtServizio_de = _data["srtServizio_de"] !== undefined ? _data["srtServizio_de"] : null as any;
            this.luogo = _data["luogo"] ? LuogoInfo.fromJS(_data["luogo"]) : null as any;
            this.srtLuogo_it = _data["srtLuogo_it"] !== undefined ? _data["srtLuogo_it"] : null as any;
            this.srtLuogo_en = _data["srtLuogo_en"] !== undefined ? _data["srtLuogo_en"] : null as any;
            this.srtLuogo_fr = _data["srtLuogo_fr"] !== undefined ? _data["srtLuogo_fr"] : null as any;
            this.srtLuogo_de = _data["srtLuogo_de"] !== undefined ? _data["srtLuogo_de"] : null as any;
            this.terms = _data["terms"] !== undefined ? _data["terms"] : null as any;
        }
    }

    static fromJS(data: any): ServizioAnticipoFornitoreInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioAnticipoFornitoreInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["servizioAnticipoFornitore"] = this.servizioAnticipoFornitore ? this.servizioAnticipoFornitore.toJSON() : null as any;
        data["srtNome"] = this.srtNome !== undefined ? this.srtNome : null as any;
        data["accordo"] = this.accordo ? this.accordo.toJSON() : null as any;
        data["srtAccordo"] = this.srtAccordo !== undefined ? this.srtAccordo : null as any;
        data["servizio"] = this.servizio ? this.servizio.toJSON() : null as any;
        data["srtServizio_it"] = this.srtServizio_it !== undefined ? this.srtServizio_it : null as any;
        data["srtServizio_en"] = this.srtServizio_en !== undefined ? this.srtServizio_en : null as any;
        data["srtServizio_fr"] = this.srtServizio_fr !== undefined ? this.srtServizio_fr : null as any;
        data["srtServizio_de"] = this.srtServizio_de !== undefined ? this.srtServizio_de : null as any;
        data["luogo"] = this.luogo ? this.luogo.toJSON() : null as any;
        data["srtLuogo_it"] = this.srtLuogo_it !== undefined ? this.srtLuogo_it : null as any;
        data["srtLuogo_en"] = this.srtLuogo_en !== undefined ? this.srtLuogo_en : null as any;
        data["srtLuogo_fr"] = this.srtLuogo_fr !== undefined ? this.srtLuogo_fr : null as any;
        data["srtLuogo_de"] = this.srtLuogo_de !== undefined ? this.srtLuogo_de : null as any;
        data["terms"] = this.terms !== undefined ? this.terms : null as any;
        return data;
    }
}

export interface IServizioAnticipoFornitoreInfo {
    id?: number;
    servizioAnticipoFornitore?: ServizioAnticipoFornitore;
    srtNome?: string;
    accordo?: AccordoInfo | null;
    srtAccordo?: string | null;
    servizio?: ServizioInfo | null;
    srtServizio_it?: string | null;
    srtServizio_en?: string | null;
    srtServizio_fr?: string | null;
    srtServizio_de?: string | null;
    luogo?: LuogoInfo | null;
    srtLuogo_it?: string | null;
    srtLuogo_en?: string | null;
    srtLuogo_fr?: string | null;
    srtLuogo_de?: string | null;
    terms?: string;
}

export class OffertaNotaInfo implements IOffertaNotaInfo {
    id?: number;
    nota?: OffertaNota | null;
    utente?: UtenteInfo | null;
    utentePresaInCarico?: UtenteInfo | null;
    accordo?: AccordoInfo | null;
    testoSemplice?: string | null;

    constructor(data?: IOffertaNotaInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nota = _data["nota"] ? OffertaNota.fromJS(_data["nota"]) : null as any;
            this.utente = _data["utente"] ? UtenteInfo.fromJS(_data["utente"]) : null as any;
            this.utentePresaInCarico = _data["utentePresaInCarico"] ? UtenteInfo.fromJS(_data["utentePresaInCarico"]) : null as any;
            this.accordo = _data["accordo"] ? AccordoInfo.fromJS(_data["accordo"]) : null as any;
            this.testoSemplice = _data["testoSemplice"] !== undefined ? _data["testoSemplice"] : null as any;
        }
    }

    static fromJS(data: any): OffertaNotaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaNotaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nota"] = this.nota ? this.nota.toJSON() : null as any;
        data["utente"] = this.utente ? this.utente.toJSON() : null as any;
        data["utentePresaInCarico"] = this.utentePresaInCarico ? this.utentePresaInCarico.toJSON() : null as any;
        data["accordo"] = this.accordo ? this.accordo.toJSON() : null as any;
        data["testoSemplice"] = this.testoSemplice !== undefined ? this.testoSemplice : null as any;
        return data;
    }
}

export interface IOffertaNotaInfo {
    id?: number;
    nota?: OffertaNota | null;
    utente?: UtenteInfo | null;
    utentePresaInCarico?: UtenteInfo | null;
    accordo?: AccordoInfo | null;
    testoSemplice?: string | null;
}

export abstract class PenaleInfo implements IPenaleInfo {
    penale?: Penale;

    constructor(data?: IPenaleInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.penale = _data["penale"] ? Penale.fromJS(_data["penale"]) : null as any;
        }
    }

    static fromJS(data: any): PenaleInfo {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'PenaleInfo' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["penale"] = this.penale ? this.penale.toJSON() : null as any;
        return data;
    }
}

export interface IPenaleInfo {
    penale?: Penale;
}

export class Penale implements IPenale {
    id?: number;
    nome!: string;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    giorni?: number | null;
    valore?: number | null;

    constructor(data?: IPenale) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nome_fr = _data["nome_fr"] !== undefined ? _data["nome_fr"] : null as any;
            this.nome_de = _data["nome_de"] !== undefined ? _data["nome_de"] : null as any;
            this.nome_es = _data["nome_es"] !== undefined ? _data["nome_es"] : null as any;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : null as any;
            this.giorni = _data["giorni"] !== undefined ? _data["giorni"] : null as any;
            this.valore = _data["valore"] !== undefined ? _data["valore"] : null as any;
        }
    }

    static fromJS(data: any): Penale {
        data = typeof data === 'object' ? data : {};
        let result = new Penale();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nome_fr"] = this.nome_fr !== undefined ? this.nome_fr : null as any;
        data["nome_de"] = this.nome_de !== undefined ? this.nome_de : null as any;
        data["nome_es"] = this.nome_es !== undefined ? this.nome_es : null as any;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : null as any;
        data["giorni"] = this.giorni !== undefined ? this.giorni : null as any;
        data["valore"] = this.valore !== undefined ? this.valore : null as any;
        return data;
    }
}

export interface IPenale {
    id?: number;
    nome: string;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    giorni?: number | null;
    valore?: number | null;
}

export class ItinerarioVoloInfo implements IItinerarioVoloInfo {
    offerta?: OffertaInfo | null;
    tappaFrom?: ItinerarioOffertaInfo | null;
    tappaTo?: ItinerarioOffertaInfo | null;
    aeroportoPartenza?: Aeroporto | null;
    aeroportoArrivo?: Aeroporto | null;
    dataVolo?: string;
    carrier?: string | null;

    constructor(data?: IItinerarioVoloInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offerta = _data["offerta"] ? OffertaInfo.fromJS(_data["offerta"]) : null as any;
            this.tappaFrom = _data["tappaFrom"] ? ItinerarioOffertaInfo.fromJS(_data["tappaFrom"]) : null as any;
            this.tappaTo = _data["tappaTo"] ? ItinerarioOffertaInfo.fromJS(_data["tappaTo"]) : null as any;
            this.aeroportoPartenza = _data["aeroportoPartenza"] ? Aeroporto.fromJS(_data["aeroportoPartenza"]) : null as any;
            this.aeroportoArrivo = _data["aeroportoArrivo"] ? Aeroporto.fromJS(_data["aeroportoArrivo"]) : null as any;
            this.dataVolo = _data["dataVolo"] !== undefined ? _data["dataVolo"] : null as any;
            this.carrier = _data["carrier"] !== undefined ? _data["carrier"] : null as any;
        }
    }

    static fromJS(data: any): ItinerarioVoloInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ItinerarioVoloInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offerta"] = this.offerta ? this.offerta.toJSON() : null as any;
        data["tappaFrom"] = this.tappaFrom ? this.tappaFrom.toJSON() : null as any;
        data["tappaTo"] = this.tappaTo ? this.tappaTo.toJSON() : null as any;
        data["aeroportoPartenza"] = this.aeroportoPartenza ? this.aeroportoPartenza.toJSON() : null as any;
        data["aeroportoArrivo"] = this.aeroportoArrivo ? this.aeroportoArrivo.toJSON() : null as any;
        data["dataVolo"] = this.dataVolo !== undefined ? this.dataVolo : null as any;
        data["carrier"] = this.carrier !== undefined ? this.carrier : null as any;
        return data;
    }
}

export interface IItinerarioVoloInfo {
    offerta?: OffertaInfo | null;
    tappaFrom?: ItinerarioOffertaInfo | null;
    tappaTo?: ItinerarioOffertaInfo | null;
    aeroportoPartenza?: Aeroporto | null;
    aeroportoArrivo?: Aeroporto | null;
    dataVolo?: string;
    carrier?: string | null;
}

export class DocumentoInfo implements IDocumentoInfo {
    id?: number;
    documento?: Documento | null;
    contatto?: ContattoInfo | null;
    allegato?: DocumentoCondivisoInfo | null;
    pathDocumento?: string | null;
    offerta?: OffertaInfo | null;
    frasi?: DocumentoFrase[] | null;
    extraDocsIDs?: number[] | null;
    extraDocsString?: string | null;
    overrideServizi?: { [key: string]: number; } | null;
    isEmailLink?: boolean;
    emailUrl?: string | null;
    linkedFile?: FileInfoBase | null;
    programmaDiViaggioValido?: boolean;

    constructor(data?: IDocumentoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.documento = _data["documento"] ? Documento.fromJS(_data["documento"]) : null as any;
            this.contatto = _data["contatto"] ? ContattoInfo.fromJS(_data["contatto"]) : null as any;
            this.allegato = _data["allegato"] ? DocumentoCondivisoInfo.fromJS(_data["allegato"]) : null as any;
            this.pathDocumento = _data["pathDocumento"] !== undefined ? _data["pathDocumento"] : null as any;
            this.offerta = _data["offerta"] ? OffertaInfo.fromJS(_data["offerta"]) : null as any;
            if (Array.isArray(_data["frasi"])) {
                this.frasi = [] as any;
                for (let item of _data["frasi"])
                    this.frasi!.push(DocumentoFrase.fromJS(item));
            }
            else {
                this.frasi = null as any;
            }
            if (Array.isArray(_data["extraDocsIDs"])) {
                this.extraDocsIDs = [] as any;
                for (let item of _data["extraDocsIDs"])
                    this.extraDocsIDs!.push(item);
            }
            else {
                this.extraDocsIDs = null as any;
            }
            this.extraDocsString = _data["extraDocsString"] !== undefined ? _data["extraDocsString"] : null as any;
            if (_data["overrideServizi"]) {
                this.overrideServizi = {} as any;
                for (let key in _data["overrideServizi"]) {
                    if (_data["overrideServizi"].hasOwnProperty(key))
                        (this.overrideServizi as any)![key] = _data["overrideServizi"][key] !== undefined ? _data["overrideServizi"][key] : null as any;
                }
            }
            else {
                this.overrideServizi = null as any;
            }
            this.isEmailLink = _data["isEmailLink"] !== undefined ? _data["isEmailLink"] : null as any;
            this.emailUrl = _data["emailUrl"] !== undefined ? _data["emailUrl"] : null as any;
            this.linkedFile = _data["linkedFile"] ? FileInfoBase.fromJS(_data["linkedFile"]) : null as any;
            this.programmaDiViaggioValido = _data["programmaDiViaggioValido"] !== undefined ? _data["programmaDiViaggioValido"] : null as any;
        }
    }

    static fromJS(data: any): DocumentoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["documento"] = this.documento ? this.documento.toJSON() : null as any;
        data["contatto"] = this.contatto ? this.contatto.toJSON() : null as any;
        data["allegato"] = this.allegato ? this.allegato.toJSON() : null as any;
        data["pathDocumento"] = this.pathDocumento !== undefined ? this.pathDocumento : null as any;
        data["offerta"] = this.offerta ? this.offerta.toJSON() : null as any;
        if (Array.isArray(this.frasi)) {
            data["frasi"] = [];
            for (let item of this.frasi)
                data["frasi"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.extraDocsIDs)) {
            data["extraDocsIDs"] = [];
            for (let item of this.extraDocsIDs)
                data["extraDocsIDs"].push(item);
        }
        data["extraDocsString"] = this.extraDocsString !== undefined ? this.extraDocsString : null as any;
        if (this.overrideServizi) {
            data["overrideServizi"] = {};
            for (let key in this.overrideServizi) {
                if (this.overrideServizi.hasOwnProperty(key))
                    (data["overrideServizi"] as any)[key] = this.overrideServizi[key] !== undefined ? this.overrideServizi[key] : null as any;
            }
        }
        data["isEmailLink"] = this.isEmailLink !== undefined ? this.isEmailLink : null as any;
        data["emailUrl"] = this.emailUrl !== undefined ? this.emailUrl : null as any;
        data["linkedFile"] = this.linkedFile ? this.linkedFile.toJSON() : null as any;
        data["programmaDiViaggioValido"] = this.programmaDiViaggioValido !== undefined ? this.programmaDiViaggioValido : null as any;
        return data;
    }
}

export interface IDocumentoInfo {
    id?: number;
    documento?: Documento | null;
    contatto?: ContattoInfo | null;
    allegato?: DocumentoCondivisoInfo | null;
    pathDocumento?: string | null;
    offerta?: OffertaInfo | null;
    frasi?: DocumentoFrase[] | null;
    extraDocsIDs?: number[] | null;
    extraDocsString?: string | null;
    overrideServizi?: { [key: string]: number; } | null;
    isEmailLink?: boolean;
    emailUrl?: string | null;
    linkedFile?: FileInfoBase | null;
    programmaDiViaggioValido?: boolean;
}

export class DocumentoCondivisoInfo implements IDocumentoCondivisoInfo {
    id?: number;
    documentoCondiviso?: DocumentoCondiviso;
    eliminato?: boolean;
    luogo?: LuogoInfo | null;
    luogoDestinazione?: LuogoInfo | null;
    servizio?: ServizioInfo | null;
    accordo?: AccordoInfo | null;
    contatto?: ContattoInfo | null;
    creatoDa?: UtenteInfo;
    aggiornatoDa?: UtenteInfo;
    eliminatoDa?: UtenteInfo | null;
    srtNome_It?: string;
    srtNome_En?: string;
    srtNome_Fr?: string;
    srtNome_De?: string;
    srtCategoria_It?: string | null;
    srtCategoria_En?: string | null;
    srtCategoria_Fr?: string | null;
    srtCategoria_De?: string | null;
    linkedFile?: FileInfoBase;
    qualsiasiLingua?: boolean;
    lingue?: ELingua[];
    categoria?: DocumentoCondivisoCategoriaInfo | null;

    constructor(data?: IDocumentoCondivisoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.documentoCondiviso = _data["documentoCondiviso"] ? DocumentoCondiviso.fromJS(_data["documentoCondiviso"]) : null as any;
            this.eliminato = _data["eliminato"] !== undefined ? _data["eliminato"] : null as any;
            this.luogo = _data["luogo"] ? LuogoInfo.fromJS(_data["luogo"]) : null as any;
            this.luogoDestinazione = _data["luogoDestinazione"] ? LuogoInfo.fromJS(_data["luogoDestinazione"]) : null as any;
            this.servizio = _data["servizio"] ? ServizioInfo.fromJS(_data["servizio"]) : null as any;
            this.accordo = _data["accordo"] ? AccordoInfo.fromJS(_data["accordo"]) : null as any;
            this.contatto = _data["contatto"] ? ContattoInfo.fromJS(_data["contatto"]) : null as any;
            this.creatoDa = _data["creatoDa"] ? UtenteInfo.fromJS(_data["creatoDa"]) : null as any;
            this.aggiornatoDa = _data["aggiornatoDa"] ? UtenteInfo.fromJS(_data["aggiornatoDa"]) : null as any;
            this.eliminatoDa = _data["eliminatoDa"] ? UtenteInfo.fromJS(_data["eliminatoDa"]) : null as any;
            this.srtNome_It = _data["srtNome_It"] !== undefined ? _data["srtNome_It"] : null as any;
            this.srtNome_En = _data["srtNome_En"] !== undefined ? _data["srtNome_En"] : null as any;
            this.srtNome_Fr = _data["srtNome_Fr"] !== undefined ? _data["srtNome_Fr"] : null as any;
            this.srtNome_De = _data["srtNome_De"] !== undefined ? _data["srtNome_De"] : null as any;
            this.srtCategoria_It = _data["srtCategoria_It"] !== undefined ? _data["srtCategoria_It"] : null as any;
            this.srtCategoria_En = _data["srtCategoria_En"] !== undefined ? _data["srtCategoria_En"] : null as any;
            this.srtCategoria_Fr = _data["srtCategoria_Fr"] !== undefined ? _data["srtCategoria_Fr"] : null as any;
            this.srtCategoria_De = _data["srtCategoria_De"] !== undefined ? _data["srtCategoria_De"] : null as any;
            this.linkedFile = _data["linkedFile"] ? FileInfoBase.fromJS(_data["linkedFile"]) : null as any;
            this.qualsiasiLingua = _data["qualsiasiLingua"] !== undefined ? _data["qualsiasiLingua"] : null as any;
            if (Array.isArray(_data["lingue"])) {
                this.lingue = [] as any;
                for (let item of _data["lingue"])
                    this.lingue!.push(item);
            }
            else {
                this.lingue = null as any;
            }
            this.categoria = _data["categoria"] ? DocumentoCondivisoCategoriaInfo.fromJS(_data["categoria"]) : null as any;
        }
    }

    static fromJS(data: any): DocumentoCondivisoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentoCondivisoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["documentoCondiviso"] = this.documentoCondiviso ? this.documentoCondiviso.toJSON() : null as any;
        data["eliminato"] = this.eliminato !== undefined ? this.eliminato : null as any;
        data["luogo"] = this.luogo ? this.luogo.toJSON() : null as any;
        data["luogoDestinazione"] = this.luogoDestinazione ? this.luogoDestinazione.toJSON() : null as any;
        data["servizio"] = this.servizio ? this.servizio.toJSON() : null as any;
        data["accordo"] = this.accordo ? this.accordo.toJSON() : null as any;
        data["contatto"] = this.contatto ? this.contatto.toJSON() : null as any;
        data["creatoDa"] = this.creatoDa ? this.creatoDa.toJSON() : null as any;
        data["aggiornatoDa"] = this.aggiornatoDa ? this.aggiornatoDa.toJSON() : null as any;
        data["eliminatoDa"] = this.eliminatoDa ? this.eliminatoDa.toJSON() : null as any;
        data["srtNome_It"] = this.srtNome_It !== undefined ? this.srtNome_It : null as any;
        data["srtNome_En"] = this.srtNome_En !== undefined ? this.srtNome_En : null as any;
        data["srtNome_Fr"] = this.srtNome_Fr !== undefined ? this.srtNome_Fr : null as any;
        data["srtNome_De"] = this.srtNome_De !== undefined ? this.srtNome_De : null as any;
        data["srtCategoria_It"] = this.srtCategoria_It !== undefined ? this.srtCategoria_It : null as any;
        data["srtCategoria_En"] = this.srtCategoria_En !== undefined ? this.srtCategoria_En : null as any;
        data["srtCategoria_Fr"] = this.srtCategoria_Fr !== undefined ? this.srtCategoria_Fr : null as any;
        data["srtCategoria_De"] = this.srtCategoria_De !== undefined ? this.srtCategoria_De : null as any;
        data["linkedFile"] = this.linkedFile ? this.linkedFile.toJSON() : null as any;
        data["qualsiasiLingua"] = this.qualsiasiLingua !== undefined ? this.qualsiasiLingua : null as any;
        if (Array.isArray(this.lingue)) {
            data["lingue"] = [];
            for (let item of this.lingue)
                data["lingue"].push(item);
        }
        data["categoria"] = this.categoria ? this.categoria.toJSON() : null as any;
        return data;
    }
}

export interface IDocumentoCondivisoInfo {
    id?: number;
    documentoCondiviso?: DocumentoCondiviso;
    eliminato?: boolean;
    luogo?: LuogoInfo | null;
    luogoDestinazione?: LuogoInfo | null;
    servizio?: ServizioInfo | null;
    accordo?: AccordoInfo | null;
    contatto?: ContattoInfo | null;
    creatoDa?: UtenteInfo;
    aggiornatoDa?: UtenteInfo;
    eliminatoDa?: UtenteInfo | null;
    srtNome_It?: string;
    srtNome_En?: string;
    srtNome_Fr?: string;
    srtNome_De?: string;
    srtCategoria_It?: string | null;
    srtCategoria_En?: string | null;
    srtCategoria_Fr?: string | null;
    srtCategoria_De?: string | null;
    linkedFile?: FileInfoBase;
    qualsiasiLingua?: boolean;
    lingue?: ELingua[];
    categoria?: DocumentoCondivisoCategoriaInfo | null;
}

export class DocumentoCondiviso implements IDocumentoCondiviso {
    id?: number;
    categoriaID?: number;
    nome!: string;
    nomeInglese?: string | null;
    nomeFrancese?: string | null;
    nomeTedesco?: string | null;
    nomeSpagnolo?: string | null;
    noteInterne?: string | null;
    path?: string | null;
    tipoPath?: ETipoPath;
    nomeFile?: string | null;
    dimensioneFile?: number | null;
    tipoContenuto?: ETipoDocumentoAllegato;
    luogoID?: number | null;
    luogoDestinazioneID?: number | null;
    servizioID?: number | null;
    accordoID?: number | null;
    contattoID?: number | null;
    tipoPubblicazione?: ETipoPubblicazioneAllegato;
    pubblicatoDal?: string | null;
    pubblicatoAl?: string | null;
    partenzeDal?: string | null;
    partenzeAl?: string | null;
    inserisciDefault?: boolean;
    ordine?: number;
    lingue?: string | null;
    creatoIl?: string;
    creatoDaUtenteID?: number;
    aggiornatoIl?: string;
    aggiornatoDaUtenteID?: number;
    eliminatoIl?: string | null;
    eliminatoDaUtenteID?: number | null;
    operatore?: EOperatore | null;

    constructor(data?: IDocumentoCondiviso) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.categoriaID = _data["categoriaID"] !== undefined ? _data["categoriaID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nomeInglese = _data["nomeInglese"] !== undefined ? _data["nomeInglese"] : null as any;
            this.nomeFrancese = _data["nomeFrancese"] !== undefined ? _data["nomeFrancese"] : null as any;
            this.nomeTedesco = _data["nomeTedesco"] !== undefined ? _data["nomeTedesco"] : null as any;
            this.nomeSpagnolo = _data["nomeSpagnolo"] !== undefined ? _data["nomeSpagnolo"] : null as any;
            this.noteInterne = _data["noteInterne"] !== undefined ? _data["noteInterne"] : null as any;
            this.path = _data["path"] !== undefined ? _data["path"] : null as any;
            this.tipoPath = _data["tipoPath"] !== undefined ? _data["tipoPath"] : null as any;
            this.nomeFile = _data["nomeFile"] !== undefined ? _data["nomeFile"] : null as any;
            this.dimensioneFile = _data["dimensioneFile"] !== undefined ? _data["dimensioneFile"] : null as any;
            this.tipoContenuto = _data["tipoContenuto"] !== undefined ? _data["tipoContenuto"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.luogoDestinazioneID = _data["luogoDestinazioneID"] !== undefined ? _data["luogoDestinazioneID"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.tipoPubblicazione = _data["tipoPubblicazione"] !== undefined ? _data["tipoPubblicazione"] : null as any;
            this.pubblicatoDal = _data["pubblicatoDal"] !== undefined ? _data["pubblicatoDal"] : null as any;
            this.pubblicatoAl = _data["pubblicatoAl"] !== undefined ? _data["pubblicatoAl"] : null as any;
            this.partenzeDal = _data["partenzeDal"] !== undefined ? _data["partenzeDal"] : null as any;
            this.partenzeAl = _data["partenzeAl"] !== undefined ? _data["partenzeAl"] : null as any;
            this.inserisciDefault = _data["inserisciDefault"] !== undefined ? _data["inserisciDefault"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.lingue = _data["lingue"] !== undefined ? _data["lingue"] : null as any;
            this.creatoIl = _data["creatoIl"] !== undefined ? _data["creatoIl"] : null as any;
            this.creatoDaUtenteID = _data["creatoDaUtenteID"] !== undefined ? _data["creatoDaUtenteID"] : null as any;
            this.aggiornatoIl = _data["aggiornatoIl"] !== undefined ? _data["aggiornatoIl"] : null as any;
            this.aggiornatoDaUtenteID = _data["aggiornatoDaUtenteID"] !== undefined ? _data["aggiornatoDaUtenteID"] : null as any;
            this.eliminatoIl = _data["eliminatoIl"] !== undefined ? _data["eliminatoIl"] : null as any;
            this.eliminatoDaUtenteID = _data["eliminatoDaUtenteID"] !== undefined ? _data["eliminatoDaUtenteID"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
        }
    }

    static fromJS(data: any): DocumentoCondiviso {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentoCondiviso();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["categoriaID"] = this.categoriaID !== undefined ? this.categoriaID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nomeInglese"] = this.nomeInglese !== undefined ? this.nomeInglese : null as any;
        data["nomeFrancese"] = this.nomeFrancese !== undefined ? this.nomeFrancese : null as any;
        data["nomeTedesco"] = this.nomeTedesco !== undefined ? this.nomeTedesco : null as any;
        data["nomeSpagnolo"] = this.nomeSpagnolo !== undefined ? this.nomeSpagnolo : null as any;
        data["noteInterne"] = this.noteInterne !== undefined ? this.noteInterne : null as any;
        data["path"] = this.path !== undefined ? this.path : null as any;
        data["tipoPath"] = this.tipoPath !== undefined ? this.tipoPath : null as any;
        data["nomeFile"] = this.nomeFile !== undefined ? this.nomeFile : null as any;
        data["dimensioneFile"] = this.dimensioneFile !== undefined ? this.dimensioneFile : null as any;
        data["tipoContenuto"] = this.tipoContenuto !== undefined ? this.tipoContenuto : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["luogoDestinazioneID"] = this.luogoDestinazioneID !== undefined ? this.luogoDestinazioneID : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["tipoPubblicazione"] = this.tipoPubblicazione !== undefined ? this.tipoPubblicazione : null as any;
        data["pubblicatoDal"] = this.pubblicatoDal !== undefined ? this.pubblicatoDal : null as any;
        data["pubblicatoAl"] = this.pubblicatoAl !== undefined ? this.pubblicatoAl : null as any;
        data["partenzeDal"] = this.partenzeDal !== undefined ? this.partenzeDal : null as any;
        data["partenzeAl"] = this.partenzeAl !== undefined ? this.partenzeAl : null as any;
        data["inserisciDefault"] = this.inserisciDefault !== undefined ? this.inserisciDefault : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["lingue"] = this.lingue !== undefined ? this.lingue : null as any;
        data["creatoIl"] = this.creatoIl !== undefined ? this.creatoIl : null as any;
        data["creatoDaUtenteID"] = this.creatoDaUtenteID !== undefined ? this.creatoDaUtenteID : null as any;
        data["aggiornatoIl"] = this.aggiornatoIl !== undefined ? this.aggiornatoIl : null as any;
        data["aggiornatoDaUtenteID"] = this.aggiornatoDaUtenteID !== undefined ? this.aggiornatoDaUtenteID : null as any;
        data["eliminatoIl"] = this.eliminatoIl !== undefined ? this.eliminatoIl : null as any;
        data["eliminatoDaUtenteID"] = this.eliminatoDaUtenteID !== undefined ? this.eliminatoDaUtenteID : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        return data;
    }
}

export interface IDocumentoCondiviso {
    id?: number;
    categoriaID?: number;
    nome: string;
    nomeInglese?: string | null;
    nomeFrancese?: string | null;
    nomeTedesco?: string | null;
    nomeSpagnolo?: string | null;
    noteInterne?: string | null;
    path?: string | null;
    tipoPath?: ETipoPath;
    nomeFile?: string | null;
    dimensioneFile?: number | null;
    tipoContenuto?: ETipoDocumentoAllegato;
    luogoID?: number | null;
    luogoDestinazioneID?: number | null;
    servizioID?: number | null;
    accordoID?: number | null;
    contattoID?: number | null;
    tipoPubblicazione?: ETipoPubblicazioneAllegato;
    pubblicatoDal?: string | null;
    pubblicatoAl?: string | null;
    partenzeDal?: string | null;
    partenzeAl?: string | null;
    inserisciDefault?: boolean;
    ordine?: number;
    lingue?: string | null;
    creatoIl?: string;
    creatoDaUtenteID?: number;
    aggiornatoIl?: string;
    aggiornatoDaUtenteID?: number;
    eliminatoIl?: string | null;
    eliminatoDaUtenteID?: number | null;
    operatore?: EOperatore | null;
}

export enum ETipoPath {
    PathAssoluto = "PathAssoluto",
    PathRelativo = "PathRelativo",
    UrlAssoluta = "UrlAssoluta",
    UrlRelativa = "UrlRelativa",
}

export enum ETipoDocumentoAllegato {
    Html = "Html",
    Pdf = "Pdf",
    Text = "Text",
    Immagine = "Immagine",
}

export enum ETipoPubblicazioneAllegato {
    Bozza = "Bozza",
    Pubblicato = "Pubblicato",
    PubblicatoIntranet = "PubblicatoIntranet",
    Obsoleto = "Obsoleto",
}

export class DocumentoCondivisoCategoriaInfo implements IDocumentoCondivisoCategoriaInfo {
    id?: number;
    documentoCondivisoCategoria?: DocumentoCondivisoCategoria;
    eliminata?: boolean;
    srtNome_It?: string;
    srtNome_En?: string;
    srtNome_Fr?: string;
    srtNome_De?: string;

    constructor(data?: IDocumentoCondivisoCategoriaInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.documentoCondivisoCategoria = _data["documentoCondivisoCategoria"] ? DocumentoCondivisoCategoria.fromJS(_data["documentoCondivisoCategoria"]) : null as any;
            this.eliminata = _data["eliminata"] !== undefined ? _data["eliminata"] : null as any;
            this.srtNome_It = _data["srtNome_It"] !== undefined ? _data["srtNome_It"] : null as any;
            this.srtNome_En = _data["srtNome_En"] !== undefined ? _data["srtNome_En"] : null as any;
            this.srtNome_Fr = _data["srtNome_Fr"] !== undefined ? _data["srtNome_Fr"] : null as any;
            this.srtNome_De = _data["srtNome_De"] !== undefined ? _data["srtNome_De"] : null as any;
        }
    }

    static fromJS(data: any): DocumentoCondivisoCategoriaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentoCondivisoCategoriaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["documentoCondivisoCategoria"] = this.documentoCondivisoCategoria ? this.documentoCondivisoCategoria.toJSON() : null as any;
        data["eliminata"] = this.eliminata !== undefined ? this.eliminata : null as any;
        data["srtNome_It"] = this.srtNome_It !== undefined ? this.srtNome_It : null as any;
        data["srtNome_En"] = this.srtNome_En !== undefined ? this.srtNome_En : null as any;
        data["srtNome_Fr"] = this.srtNome_Fr !== undefined ? this.srtNome_Fr : null as any;
        data["srtNome_De"] = this.srtNome_De !== undefined ? this.srtNome_De : null as any;
        return data;
    }
}

export interface IDocumentoCondivisoCategoriaInfo {
    id?: number;
    documentoCondivisoCategoria?: DocumentoCondivisoCategoria;
    eliminata?: boolean;
    srtNome_It?: string;
    srtNome_En?: string;
    srtNome_Fr?: string;
    srtNome_De?: string;
}

export class DocumentoCondivisoCategoria implements IDocumentoCondivisoCategoria {
    id?: number;
    nome!: string;
    nomeENG?: string | null;
    nomeFRA?: string | null;
    nomeDEU?: string | null;
    nomeESP?: string | null;
    eliminata?: boolean;

    constructor(data?: IDocumentoCondivisoCategoria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nomeENG = _data["nomeENG"] !== undefined ? _data["nomeENG"] : null as any;
            this.nomeFRA = _data["nomeFRA"] !== undefined ? _data["nomeFRA"] : null as any;
            this.nomeDEU = _data["nomeDEU"] !== undefined ? _data["nomeDEU"] : null as any;
            this.nomeESP = _data["nomeESP"] !== undefined ? _data["nomeESP"] : null as any;
            this.eliminata = _data["eliminata"] !== undefined ? _data["eliminata"] : null as any;
        }
    }

    static fromJS(data: any): DocumentoCondivisoCategoria {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentoCondivisoCategoria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nomeENG"] = this.nomeENG !== undefined ? this.nomeENG : null as any;
        data["nomeFRA"] = this.nomeFRA !== undefined ? this.nomeFRA : null as any;
        data["nomeDEU"] = this.nomeDEU !== undefined ? this.nomeDEU : null as any;
        data["nomeESP"] = this.nomeESP !== undefined ? this.nomeESP : null as any;
        data["eliminata"] = this.eliminata !== undefined ? this.eliminata : null as any;
        return data;
    }
}

export interface IDocumentoCondivisoCategoria {
    id?: number;
    nome: string;
    nomeENG?: string | null;
    nomeFRA?: string | null;
    nomeDEU?: string | null;
    nomeESP?: string | null;
    eliminata?: boolean;
}

export class DocumentoFrase implements IDocumentoFrase {
    id?: number;
    documentoID?: number;
    sezioneID?: number;
    sottoSezioneID?: number | null;
    articoloID?: number | null;
    fraseID?: number | null;
    giorno?: number | null;
    servizioID?: number | null;
    rigaID?: number | null;
    contattoID?: number | null;
    accordoID?: number | null;
    luogoID?: number | null;
    ordine?: number;
    terminatore?: EFraseTerminatore;
    parametri?: string | null;
    valoreInt?: number | null;

    constructor(data?: IDocumentoFrase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : null as any;
            this.sezioneID = _data["sezioneID"] !== undefined ? _data["sezioneID"] : null as any;
            this.sottoSezioneID = _data["sottoSezioneID"] !== undefined ? _data["sottoSezioneID"] : null as any;
            this.articoloID = _data["articoloID"] !== undefined ? _data["articoloID"] : null as any;
            this.fraseID = _data["fraseID"] !== undefined ? _data["fraseID"] : null as any;
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.rigaID = _data["rigaID"] !== undefined ? _data["rigaID"] : null as any;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.terminatore = _data["terminatore"] !== undefined ? _data["terminatore"] : null as any;
            this.parametri = _data["parametri"] !== undefined ? _data["parametri"] : null as any;
            this.valoreInt = _data["valoreInt"] !== undefined ? _data["valoreInt"] : null as any;
        }
    }

    static fromJS(data: any): DocumentoFrase {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentoFrase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : null as any;
        data["sezioneID"] = this.sezioneID !== undefined ? this.sezioneID : null as any;
        data["sottoSezioneID"] = this.sottoSezioneID !== undefined ? this.sottoSezioneID : null as any;
        data["articoloID"] = this.articoloID !== undefined ? this.articoloID : null as any;
        data["fraseID"] = this.fraseID !== undefined ? this.fraseID : null as any;
        data["giorno"] = this.giorno !== undefined ? this.giorno : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["rigaID"] = this.rigaID !== undefined ? this.rigaID : null as any;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["terminatore"] = this.terminatore !== undefined ? this.terminatore : null as any;
        data["parametri"] = this.parametri !== undefined ? this.parametri : null as any;
        data["valoreInt"] = this.valoreInt !== undefined ? this.valoreInt : null as any;
        return data;
    }
}

export interface IDocumentoFrase {
    id?: number;
    documentoID?: number;
    sezioneID?: number;
    sottoSezioneID?: number | null;
    articoloID?: number | null;
    fraseID?: number | null;
    giorno?: number | null;
    servizioID?: number | null;
    rigaID?: number | null;
    contattoID?: number | null;
    accordoID?: number | null;
    luogoID?: number | null;
    ordine?: number;
    terminatore?: EFraseTerminatore;
    parametri?: string | null;
    valoreInt?: number | null;
}

export class EmailInfo implements IEmailInfo {
    id?: number;
    email?: EmailQueue;
    recipients?: EmailQueueRecipient[];
    toRecipients?: string;
    ccRecipients?: string;
    bccRecipients?: string;
    attachments?: EmailAttachmentInfo[];

    constructor(data?: IEmailInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.email = _data["email"] ? EmailQueue.fromJS(_data["email"]) : null as any;
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(EmailQueueRecipient.fromJS(item));
            }
            else {
                this.recipients = null as any;
            }
            this.toRecipients = _data["toRecipients"] !== undefined ? _data["toRecipients"] : null as any;
            this.ccRecipients = _data["ccRecipients"] !== undefined ? _data["ccRecipients"] : null as any;
            this.bccRecipients = _data["bccRecipients"] !== undefined ? _data["bccRecipients"] : null as any;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(EmailAttachmentInfo.fromJS(item));
            }
            else {
                this.attachments = null as any;
            }
        }
    }

    static fromJS(data: any): EmailInfo {
        data = typeof data === 'object' ? data : {};
        let result = new EmailInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["email"] = this.email ? this.email.toJSON() : null as any;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item ? item.toJSON() : null as any);
        }
        data["toRecipients"] = this.toRecipients !== undefined ? this.toRecipients : null as any;
        data["ccRecipients"] = this.ccRecipients !== undefined ? this.ccRecipients : null as any;
        data["bccRecipients"] = this.bccRecipients !== undefined ? this.bccRecipients : null as any;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IEmailInfo {
    id?: number;
    email?: EmailQueue;
    recipients?: EmailQueueRecipient[];
    toRecipients?: string;
    ccRecipients?: string;
    bccRecipients?: string;
    attachments?: EmailAttachmentInfo[];
}

export class EmailQueueRecipient implements IEmailQueueRecipient {
    id?: number;
    emailID?: number;
    addressType?: EEmailAddressType;
    recipientAddress!: string;
    recipientName?: string | null;

    constructor(data?: IEmailQueueRecipient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.emailID = _data["emailID"] !== undefined ? _data["emailID"] : null as any;
            this.addressType = _data["addressType"] !== undefined ? _data["addressType"] : null as any;
            this.recipientAddress = _data["recipientAddress"] !== undefined ? _data["recipientAddress"] : null as any;
            this.recipientName = _data["recipientName"] !== undefined ? _data["recipientName"] : null as any;
        }
    }

    static fromJS(data: any): EmailQueueRecipient {
        data = typeof data === 'object' ? data : {};
        let result = new EmailQueueRecipient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["emailID"] = this.emailID !== undefined ? this.emailID : null as any;
        data["addressType"] = this.addressType !== undefined ? this.addressType : null as any;
        data["recipientAddress"] = this.recipientAddress !== undefined ? this.recipientAddress : null as any;
        data["recipientName"] = this.recipientName !== undefined ? this.recipientName : null as any;
        return data;
    }
}

export interface IEmailQueueRecipient {
    id?: number;
    emailID?: number;
    addressType?: EEmailAddressType;
    recipientAddress: string;
    recipientName?: string | null;
}

export class VoloInfo implements IVoloInfo {
    id?: number;
    volo?: Volo | null;
    offerta?: OffertaInfo | null;
    righe?: OffertaDatoInfo[] | null;
    haOrdinaBiglietteria?: boolean;
    soluzione?: string | null;
    nome?: string | null;
    isPnr?: boolean;
    isNdc?: boolean;
    abbinamento?: AbbinamentoInfo | null;
    fornitore?: FornitoreInfo | null;
    tratte?: VoloTrattaInfo[] | null;
    tariffe?: VoloTariffa[] | null;
    note?: VoloNota[] | null;
    relazioni?: VoloRel[] | null;

    constructor(data?: IVoloInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.volo = _data["volo"] ? Volo.fromJS(_data["volo"]) : null as any;
            this.offerta = _data["offerta"] ? OffertaInfo.fromJS(_data["offerta"]) : null as any;
            if (Array.isArray(_data["righe"])) {
                this.righe = [] as any;
                for (let item of _data["righe"])
                    this.righe!.push(OffertaDatoInfo.fromJS(item));
            }
            else {
                this.righe = null as any;
            }
            this.haOrdinaBiglietteria = _data["haOrdinaBiglietteria"] !== undefined ? _data["haOrdinaBiglietteria"] : null as any;
            this.soluzione = _data["soluzione"] !== undefined ? _data["soluzione"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.isPnr = _data["isPnr"] !== undefined ? _data["isPnr"] : null as any;
            this.isNdc = _data["isNdc"] !== undefined ? _data["isNdc"] : null as any;
            this.abbinamento = _data["abbinamento"] ? AbbinamentoInfo.fromJS(_data["abbinamento"]) : null as any;
            this.fornitore = _data["fornitore"] ? FornitoreInfo.fromJS(_data["fornitore"]) : null as any;
            if (Array.isArray(_data["tratte"])) {
                this.tratte = [] as any;
                for (let item of _data["tratte"])
                    this.tratte!.push(VoloTrattaInfo.fromJS(item));
            }
            else {
                this.tratte = null as any;
            }
            if (Array.isArray(_data["tariffe"])) {
                this.tariffe = [] as any;
                for (let item of _data["tariffe"])
                    this.tariffe!.push(VoloTariffa.fromJS(item));
            }
            else {
                this.tariffe = null as any;
            }
            if (Array.isArray(_data["note"])) {
                this.note = [] as any;
                for (let item of _data["note"])
                    this.note!.push(VoloNota.fromJS(item));
            }
            else {
                this.note = null as any;
            }
            if (Array.isArray(_data["relazioni"])) {
                this.relazioni = [] as any;
                for (let item of _data["relazioni"])
                    this.relazioni!.push(VoloRel.fromJS(item));
            }
            else {
                this.relazioni = null as any;
            }
        }
    }

    static fromJS(data: any): VoloInfo {
        data = typeof data === 'object' ? data : {};
        let result = new VoloInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["volo"] = this.volo ? this.volo.toJSON() : null as any;
        data["offerta"] = this.offerta ? this.offerta.toJSON() : null as any;
        if (Array.isArray(this.righe)) {
            data["righe"] = [];
            for (let item of this.righe)
                data["righe"].push(item ? item.toJSON() : null as any);
        }
        data["haOrdinaBiglietteria"] = this.haOrdinaBiglietteria !== undefined ? this.haOrdinaBiglietteria : null as any;
        data["soluzione"] = this.soluzione !== undefined ? this.soluzione : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["isPnr"] = this.isPnr !== undefined ? this.isPnr : null as any;
        data["isNdc"] = this.isNdc !== undefined ? this.isNdc : null as any;
        data["abbinamento"] = this.abbinamento ? this.abbinamento.toJSON() : null as any;
        data["fornitore"] = this.fornitore ? this.fornitore.toJSON() : null as any;
        if (Array.isArray(this.tratte)) {
            data["tratte"] = [];
            for (let item of this.tratte)
                data["tratte"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.tariffe)) {
            data["tariffe"] = [];
            for (let item of this.tariffe)
                data["tariffe"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.note)) {
            data["note"] = [];
            for (let item of this.note)
                data["note"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.relazioni)) {
            data["relazioni"] = [];
            for (let item of this.relazioni)
                data["relazioni"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IVoloInfo {
    id?: number;
    volo?: Volo | null;
    offerta?: OffertaInfo | null;
    righe?: OffertaDatoInfo[] | null;
    haOrdinaBiglietteria?: boolean;
    soluzione?: string | null;
    nome?: string | null;
    isPnr?: boolean;
    isNdc?: boolean;
    abbinamento?: AbbinamentoInfo | null;
    fornitore?: FornitoreInfo | null;
    tratte?: VoloTrattaInfo[] | null;
    tariffe?: VoloTariffa[] | null;
    note?: VoloNota[] | null;
    relazioni?: VoloRel[] | null;
}

export class FornitoreInfo implements IFornitoreInfo {
    id?: number;
    eFornitore?: EFornitore;
    fornitore?: HHFornitore;
    usaDescrizioniFornitoreSuTipologieMappate?: boolean;
    luoghiMappati?: { [key: string]: HHLuogo[]; };
    luoghiFornitore?: HHLuogo[];
    settings?: HHFornitoreSetting[];
    accordi?: AccordoInfo[];

    constructor(data?: IFornitoreInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.eFornitore = _data["eFornitore"] !== undefined ? _data["eFornitore"] : null as any;
            this.fornitore = _data["fornitore"] ? HHFornitore.fromJS(_data["fornitore"]) : null as any;
            this.usaDescrizioniFornitoreSuTipologieMappate = _data["usaDescrizioniFornitoreSuTipologieMappate"] !== undefined ? _data["usaDescrizioniFornitoreSuTipologieMappate"] : null as any;
            if (_data["luoghiMappati"]) {
                this.luoghiMappati = {} as any;
                for (let key in _data["luoghiMappati"]) {
                    if (_data["luoghiMappati"].hasOwnProperty(key))
                        (this.luoghiMappati as any)![key] = _data["luoghiMappati"][key] ? _data["luoghiMappati"][key].map((i: any) => HHLuogo.fromJS(i)) : [];
                }
            }
            else {
                this.luoghiMappati = null as any;
            }
            if (Array.isArray(_data["luoghiFornitore"])) {
                this.luoghiFornitore = [] as any;
                for (let item of _data["luoghiFornitore"])
                    this.luoghiFornitore!.push(HHLuogo.fromJS(item));
            }
            else {
                this.luoghiFornitore = null as any;
            }
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings!.push(HHFornitoreSetting.fromJS(item));
            }
            else {
                this.settings = null as any;
            }
            if (Array.isArray(_data["accordi"])) {
                this.accordi = [] as any;
                for (let item of _data["accordi"])
                    this.accordi!.push(AccordoInfo.fromJS(item));
            }
            else {
                this.accordi = null as any;
            }
        }
    }

    static fromJS(data: any): FornitoreInfo {
        data = typeof data === 'object' ? data : {};
        let result = new FornitoreInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["eFornitore"] = this.eFornitore !== undefined ? this.eFornitore : null as any;
        data["fornitore"] = this.fornitore ? this.fornitore.toJSON() : null as any;
        data["usaDescrizioniFornitoreSuTipologieMappate"] = this.usaDescrizioniFornitoreSuTipologieMappate !== undefined ? this.usaDescrizioniFornitoreSuTipologieMappate : null as any;
        if (this.luoghiMappati) {
            data["luoghiMappati"] = {};
            for (let key in this.luoghiMappati) {
                if (this.luoghiMappati.hasOwnProperty(key))
                    (data["luoghiMappati"] as any)[key] = this.luoghiMappati[key] !== undefined ? this.luoghiMappati[key] : null as any;
            }
        }
        if (Array.isArray(this.luoghiFornitore)) {
            data["luoghiFornitore"] = [];
            for (let item of this.luoghiFornitore)
                data["luoghiFornitore"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.accordi)) {
            data["accordi"] = [];
            for (let item of this.accordi)
                data["accordi"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IFornitoreInfo {
    id?: number;
    eFornitore?: EFornitore;
    fornitore?: HHFornitore;
    usaDescrizioniFornitoreSuTipologieMappate?: boolean;
    luoghiMappati?: { [key: string]: HHLuogo[]; };
    luoghiFornitore?: HHLuogo[];
    settings?: HHFornitoreSetting[];
    accordi?: AccordoInfo[];
}

export class HHFornitore implements IHHFornitore {
    id?: number;
    nome!: string;
    attivo?: boolean;
    trattamentoDaXml?: boolean;
    instantPurchaseDaXml?: boolean;
    notRefoundableDaXml?: boolean;
    bookingUsaDateNascitaChild?: boolean;
    bookingUsaDateNascitaAdulti?: boolean;
    bookingUsaGenere?: boolean;
    bookingUsaNomiPax?: boolean;
    serviziAttiviRicerca?: EH2HServiceType;
    serviziAttiviBooking?: EH2HServiceType;
    ultimaRicerca?: string | null;
    ultimaRicercaFault?: string | null;
    durataRicercheSec?: number | null;
    durataRicercheFaultSec?: number | null;
    conteggioRicercheAttive?: number;
    conteggioRicercheAttiveFault?: number;
    ricercaUsaDisponibilitaReale?: boolean;
    codiceGiata?: string | null;
    tipoGestioneSupplementi?: ETipoGestioneSupplementi;
    modalitaPrenotazione?: EModalitaPrenotazione;
    accordoObbligatorio?: boolean;
    forzaIpSuNrf?: boolean;
    policiesCall?: boolean;
    dynamicSupplements?: boolean;
    affidabilita?: number;
    searchByService?: boolean;

    constructor(data?: IHHFornitore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.attivo = _data["attivo"] !== undefined ? _data["attivo"] : null as any;
            this.trattamentoDaXml = _data["trattamentoDaXml"] !== undefined ? _data["trattamentoDaXml"] : null as any;
            this.instantPurchaseDaXml = _data["instantPurchaseDaXml"] !== undefined ? _data["instantPurchaseDaXml"] : null as any;
            this.notRefoundableDaXml = _data["notRefoundableDaXml"] !== undefined ? _data["notRefoundableDaXml"] : null as any;
            this.bookingUsaDateNascitaChild = _data["bookingUsaDateNascitaChild"] !== undefined ? _data["bookingUsaDateNascitaChild"] : null as any;
            this.bookingUsaDateNascitaAdulti = _data["bookingUsaDateNascitaAdulti"] !== undefined ? _data["bookingUsaDateNascitaAdulti"] : null as any;
            this.bookingUsaGenere = _data["bookingUsaGenere"] !== undefined ? _data["bookingUsaGenere"] : null as any;
            this.bookingUsaNomiPax = _data["bookingUsaNomiPax"] !== undefined ? _data["bookingUsaNomiPax"] : null as any;
            this.serviziAttiviRicerca = _data["serviziAttiviRicerca"] !== undefined ? _data["serviziAttiviRicerca"] : null as any;
            this.serviziAttiviBooking = _data["serviziAttiviBooking"] !== undefined ? _data["serviziAttiviBooking"] : null as any;
            this.ultimaRicerca = _data["ultimaRicerca"] !== undefined ? _data["ultimaRicerca"] : null as any;
            this.ultimaRicercaFault = _data["ultimaRicercaFault"] !== undefined ? _data["ultimaRicercaFault"] : null as any;
            this.durataRicercheSec = _data["durataRicercheSec"] !== undefined ? _data["durataRicercheSec"] : null as any;
            this.durataRicercheFaultSec = _data["durataRicercheFaultSec"] !== undefined ? _data["durataRicercheFaultSec"] : null as any;
            this.conteggioRicercheAttive = _data["conteggioRicercheAttive"] !== undefined ? _data["conteggioRicercheAttive"] : null as any;
            this.conteggioRicercheAttiveFault = _data["conteggioRicercheAttiveFault"] !== undefined ? _data["conteggioRicercheAttiveFault"] : null as any;
            this.ricercaUsaDisponibilitaReale = _data["ricercaUsaDisponibilitaReale"] !== undefined ? _data["ricercaUsaDisponibilitaReale"] : null as any;
            this.codiceGiata = _data["codiceGiata"] !== undefined ? _data["codiceGiata"] : null as any;
            this.tipoGestioneSupplementi = _data["tipoGestioneSupplementi"] !== undefined ? _data["tipoGestioneSupplementi"] : null as any;
            this.modalitaPrenotazione = _data["modalitaPrenotazione"] !== undefined ? _data["modalitaPrenotazione"] : null as any;
            this.accordoObbligatorio = _data["accordoObbligatorio"] !== undefined ? _data["accordoObbligatorio"] : null as any;
            this.forzaIpSuNrf = _data["forzaIpSuNrf"] !== undefined ? _data["forzaIpSuNrf"] : null as any;
            this.policiesCall = _data["policiesCall"] !== undefined ? _data["policiesCall"] : null as any;
            this.dynamicSupplements = _data["dynamicSupplements"] !== undefined ? _data["dynamicSupplements"] : null as any;
            this.affidabilita = _data["affidabilita"] !== undefined ? _data["affidabilita"] : null as any;
            this.searchByService = _data["searchByService"] !== undefined ? _data["searchByService"] : null as any;
        }
    }

    static fromJS(data: any): HHFornitore {
        data = typeof data === 'object' ? data : {};
        let result = new HHFornitore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["attivo"] = this.attivo !== undefined ? this.attivo : null as any;
        data["trattamentoDaXml"] = this.trattamentoDaXml !== undefined ? this.trattamentoDaXml : null as any;
        data["instantPurchaseDaXml"] = this.instantPurchaseDaXml !== undefined ? this.instantPurchaseDaXml : null as any;
        data["notRefoundableDaXml"] = this.notRefoundableDaXml !== undefined ? this.notRefoundableDaXml : null as any;
        data["bookingUsaDateNascitaChild"] = this.bookingUsaDateNascitaChild !== undefined ? this.bookingUsaDateNascitaChild : null as any;
        data["bookingUsaDateNascitaAdulti"] = this.bookingUsaDateNascitaAdulti !== undefined ? this.bookingUsaDateNascitaAdulti : null as any;
        data["bookingUsaGenere"] = this.bookingUsaGenere !== undefined ? this.bookingUsaGenere : null as any;
        data["bookingUsaNomiPax"] = this.bookingUsaNomiPax !== undefined ? this.bookingUsaNomiPax : null as any;
        data["serviziAttiviRicerca"] = this.serviziAttiviRicerca !== undefined ? this.serviziAttiviRicerca : null as any;
        data["serviziAttiviBooking"] = this.serviziAttiviBooking !== undefined ? this.serviziAttiviBooking : null as any;
        data["ultimaRicerca"] = this.ultimaRicerca !== undefined ? this.ultimaRicerca : null as any;
        data["ultimaRicercaFault"] = this.ultimaRicercaFault !== undefined ? this.ultimaRicercaFault : null as any;
        data["durataRicercheSec"] = this.durataRicercheSec !== undefined ? this.durataRicercheSec : null as any;
        data["durataRicercheFaultSec"] = this.durataRicercheFaultSec !== undefined ? this.durataRicercheFaultSec : null as any;
        data["conteggioRicercheAttive"] = this.conteggioRicercheAttive !== undefined ? this.conteggioRicercheAttive : null as any;
        data["conteggioRicercheAttiveFault"] = this.conteggioRicercheAttiveFault !== undefined ? this.conteggioRicercheAttiveFault : null as any;
        data["ricercaUsaDisponibilitaReale"] = this.ricercaUsaDisponibilitaReale !== undefined ? this.ricercaUsaDisponibilitaReale : null as any;
        data["codiceGiata"] = this.codiceGiata !== undefined ? this.codiceGiata : null as any;
        data["tipoGestioneSupplementi"] = this.tipoGestioneSupplementi !== undefined ? this.tipoGestioneSupplementi : null as any;
        data["modalitaPrenotazione"] = this.modalitaPrenotazione !== undefined ? this.modalitaPrenotazione : null as any;
        data["accordoObbligatorio"] = this.accordoObbligatorio !== undefined ? this.accordoObbligatorio : null as any;
        data["forzaIpSuNrf"] = this.forzaIpSuNrf !== undefined ? this.forzaIpSuNrf : null as any;
        data["policiesCall"] = this.policiesCall !== undefined ? this.policiesCall : null as any;
        data["dynamicSupplements"] = this.dynamicSupplements !== undefined ? this.dynamicSupplements : null as any;
        data["affidabilita"] = this.affidabilita !== undefined ? this.affidabilita : null as any;
        data["searchByService"] = this.searchByService !== undefined ? this.searchByService : null as any;
        return data;
    }
}

export interface IHHFornitore {
    id?: number;
    nome: string;
    attivo?: boolean;
    trattamentoDaXml?: boolean;
    instantPurchaseDaXml?: boolean;
    notRefoundableDaXml?: boolean;
    bookingUsaDateNascitaChild?: boolean;
    bookingUsaDateNascitaAdulti?: boolean;
    bookingUsaGenere?: boolean;
    bookingUsaNomiPax?: boolean;
    serviziAttiviRicerca?: EH2HServiceType;
    serviziAttiviBooking?: EH2HServiceType;
    ultimaRicerca?: string | null;
    ultimaRicercaFault?: string | null;
    durataRicercheSec?: number | null;
    durataRicercheFaultSec?: number | null;
    conteggioRicercheAttive?: number;
    conteggioRicercheAttiveFault?: number;
    ricercaUsaDisponibilitaReale?: boolean;
    codiceGiata?: string | null;
    tipoGestioneSupplementi?: ETipoGestioneSupplementi;
    modalitaPrenotazione?: EModalitaPrenotazione;
    accordoObbligatorio?: boolean;
    forzaIpSuNrf?: boolean;
    policiesCall?: boolean;
    dynamicSupplements?: boolean;
    affidabilita?: number;
    searchByService?: boolean;
}

export enum EH2HServiceType {
    Nessuno = "Nessuno",
    Hotels = "Hotels",
    Flights = "Flights",
    Cars = "Cars",
    Ferries = "Ferries",
    Cruises = "Cruises",
    Visit = "Visit",
    Tours = "Tours",
    Selfdrive = "Selfdrive",
}

export enum ETipoGestioneSupplementi {
    NonGestiti = "NonGestiti",
    ComeServiziDistinti = "ComeServiziDistinti",
    AbbinatiAlServizioPrincipale = "AbbinatiAlServizioPrincipale",
}

export enum EModalitaPrenotazione {
    UnaPrenotazionePerRiga = "UnaPrenotazionePerRiga",
    UnaPrenotazionePerOfferta = "UnaPrenotazionePerOfferta",
}

export class HHFornitoreSetting implements IHHFornitoreSetting {
    id?: number;
    supplierID?: number;
    environment!: string;
    settings!: string;
    isDefault?: boolean;

    constructor(data?: IHHFornitoreSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.supplierID = _data["supplierID"] !== undefined ? _data["supplierID"] : null as any;
            this.environment = _data["environment"] !== undefined ? _data["environment"] : null as any;
            this.settings = _data["settings"] !== undefined ? _data["settings"] : null as any;
            this.isDefault = _data["isDefault"] !== undefined ? _data["isDefault"] : null as any;
        }
    }

    static fromJS(data: any): HHFornitoreSetting {
        data = typeof data === 'object' ? data : {};
        let result = new HHFornitoreSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["supplierID"] = this.supplierID !== undefined ? this.supplierID : null as any;
        data["environment"] = this.environment !== undefined ? this.environment : null as any;
        data["settings"] = this.settings !== undefined ? this.settings : null as any;
        data["isDefault"] = this.isDefault !== undefined ? this.isDefault : null as any;
        return data;
    }
}

export interface IHHFornitoreSetting {
    id?: number;
    supplierID?: number;
    environment: string;
    settings: string;
    isDefault?: boolean;
}

export class VoloTrattaInfo implements IVoloTrattaInfo {
    _MinutiCheckinPartenza?: number | null;
    id?: number;
    voloTratta?: VoloTratta | null;
    compagnia?: CompagniaAerea | null;
    compagniaOperated?: CompagniaAerea | null;
    daAeroporto?: Aeroporto | null;
    adAeroporto?: Aeroporto | null;
    arrivoIlGiornoDopo?: boolean;
    stato?: StatoVolo | null;
    voloInternazionale?: boolean;
    minutiCheckinPartenza?: number;

    constructor(data?: IVoloTrattaInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._MinutiCheckinPartenza = _data["_MinutiCheckinPartenza"] !== undefined ? _data["_MinutiCheckinPartenza"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.voloTratta = _data["voloTratta"] ? VoloTratta.fromJS(_data["voloTratta"]) : null as any;
            this.compagnia = _data["compagnia"] ? CompagniaAerea.fromJS(_data["compagnia"]) : null as any;
            this.compagniaOperated = _data["compagniaOperated"] ? CompagniaAerea.fromJS(_data["compagniaOperated"]) : null as any;
            this.daAeroporto = _data["daAeroporto"] ? Aeroporto.fromJS(_data["daAeroporto"]) : null as any;
            this.adAeroporto = _data["adAeroporto"] ? Aeroporto.fromJS(_data["adAeroporto"]) : null as any;
            this.arrivoIlGiornoDopo = _data["arrivoIlGiornoDopo"] !== undefined ? _data["arrivoIlGiornoDopo"] : null as any;
            this.stato = _data["stato"] ? StatoVolo.fromJS(_data["stato"]) : null as any;
            this.voloInternazionale = _data["voloInternazionale"] !== undefined ? _data["voloInternazionale"] : null as any;
            this.minutiCheckinPartenza = _data["minutiCheckinPartenza"] !== undefined ? _data["minutiCheckinPartenza"] : null as any;
        }
    }

    static fromJS(data: any): VoloTrattaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new VoloTrattaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_MinutiCheckinPartenza"] = this._MinutiCheckinPartenza !== undefined ? this._MinutiCheckinPartenza : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["voloTratta"] = this.voloTratta ? this.voloTratta.toJSON() : null as any;
        data["compagnia"] = this.compagnia ? this.compagnia.toJSON() : null as any;
        data["compagniaOperated"] = this.compagniaOperated ? this.compagniaOperated.toJSON() : null as any;
        data["daAeroporto"] = this.daAeroporto ? this.daAeroporto.toJSON() : null as any;
        data["adAeroporto"] = this.adAeroporto ? this.adAeroporto.toJSON() : null as any;
        data["arrivoIlGiornoDopo"] = this.arrivoIlGiornoDopo !== undefined ? this.arrivoIlGiornoDopo : null as any;
        data["stato"] = this.stato ? this.stato.toJSON() : null as any;
        data["voloInternazionale"] = this.voloInternazionale !== undefined ? this.voloInternazionale : null as any;
        data["minutiCheckinPartenza"] = this.minutiCheckinPartenza !== undefined ? this.minutiCheckinPartenza : null as any;
        return data;
    }
}

export interface IVoloTrattaInfo {
    _MinutiCheckinPartenza?: number | null;
    id?: number;
    voloTratta?: VoloTratta | null;
    compagnia?: CompagniaAerea | null;
    compagniaOperated?: CompagniaAerea | null;
    daAeroporto?: Aeroporto | null;
    adAeroporto?: Aeroporto | null;
    arrivoIlGiornoDopo?: boolean;
    stato?: StatoVolo | null;
    voloInternazionale?: boolean;
    minutiCheckinPartenza?: number;
}

export class VoloTicketsInfo implements IVoloTicketsInfo {
    id?: number;
    voloTickets?: VoloTickets;
    isValid?: boolean;
    offertaID?: number;
    volo?: Volo | null;
    voloID?: number | null;
    ordine?: number;
    cliente?: Cliente | null;

    constructor(data?: IVoloTicketsInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.voloTickets = _data["voloTickets"] ? VoloTickets.fromJS(_data["voloTickets"]) : null as any;
            this.isValid = _data["isValid"] !== undefined ? _data["isValid"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.volo = _data["volo"] ? Volo.fromJS(_data["volo"]) : null as any;
            this.voloID = _data["voloID"] !== undefined ? _data["voloID"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.cliente = _data["cliente"] ? Cliente.fromJS(_data["cliente"]) : null as any;
        }
    }

    static fromJS(data: any): VoloTicketsInfo {
        data = typeof data === 'object' ? data : {};
        let result = new VoloTicketsInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["voloTickets"] = this.voloTickets ? this.voloTickets.toJSON() : null as any;
        data["isValid"] = this.isValid !== undefined ? this.isValid : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["volo"] = this.volo ? this.volo.toJSON() : null as any;
        data["voloID"] = this.voloID !== undefined ? this.voloID : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["cliente"] = this.cliente ? this.cliente.toJSON() : null as any;
        return data;
    }
}

export interface IVoloTicketsInfo {
    id?: number;
    voloTickets?: VoloTickets;
    isValid?: boolean;
    offertaID?: number;
    volo?: Volo | null;
    voloID?: number | null;
    ordine?: number;
    cliente?: Cliente | null;
}

export class VoloTickets implements IVoloTickets {
    id?: number;
    offertaID?: number;
    voloID?: number | null;
    clienteID?: number | null;
    testoTicket?: string | null;
    ordine?: number;

    constructor(data?: IVoloTickets) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.voloID = _data["voloID"] !== undefined ? _data["voloID"] : null as any;
            this.clienteID = _data["clienteID"] !== undefined ? _data["clienteID"] : null as any;
            this.testoTicket = _data["testoTicket"] !== undefined ? _data["testoTicket"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
        }
    }

    static fromJS(data: any): VoloTickets {
        data = typeof data === 'object' ? data : {};
        let result = new VoloTickets();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["voloID"] = this.voloID !== undefined ? this.voloID : null as any;
        data["clienteID"] = this.clienteID !== undefined ? this.clienteID : null as any;
        data["testoTicket"] = this.testoTicket !== undefined ? this.testoTicket : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        return data;
    }
}

export interface IVoloTickets {
    id?: number;
    offertaID?: number;
    voloID?: number | null;
    clienteID?: number | null;
    testoTicket?: string | null;
    ordine?: number;
}

export class VoucherInfo implements IVoucherInfo {
    offerta?: OffertaInfo | null;
    isPreview?: boolean;
    id?: number;
    voucher?: Voucher | null;
    nr?: string | null;
    idStr?: string | null;
    testata?: string | null;
    prenotazione?: string | null;
    clienti?: string | null;
    clientiText?: string | null;
    servizio?: string | null;
    periodo?: string | null;
    istruzioni?: string | null;

    constructor(data?: IVoucherInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offerta = _data["offerta"] ? OffertaInfo.fromJS(_data["offerta"]) : null as any;
            this.isPreview = _data["isPreview"] !== undefined ? _data["isPreview"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.voucher = _data["voucher"] ? Voucher.fromJS(_data["voucher"]) : null as any;
            this.nr = _data["nr"] !== undefined ? _data["nr"] : null as any;
            this.idStr = _data["idStr"] !== undefined ? _data["idStr"] : null as any;
            this.testata = _data["testata"] !== undefined ? _data["testata"] : null as any;
            this.prenotazione = _data["prenotazione"] !== undefined ? _data["prenotazione"] : null as any;
            this.clienti = _data["clienti"] !== undefined ? _data["clienti"] : null as any;
            this.clientiText = _data["clientiText"] !== undefined ? _data["clientiText"] : null as any;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : null as any;
            this.periodo = _data["periodo"] !== undefined ? _data["periodo"] : null as any;
            this.istruzioni = _data["istruzioni"] !== undefined ? _data["istruzioni"] : null as any;
        }
    }

    static fromJS(data: any): VoucherInfo {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offerta"] = this.offerta ? this.offerta.toJSON() : null as any;
        data["isPreview"] = this.isPreview !== undefined ? this.isPreview : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["voucher"] = this.voucher ? this.voucher.toJSON() : null as any;
        data["nr"] = this.nr !== undefined ? this.nr : null as any;
        data["idStr"] = this.idStr !== undefined ? this.idStr : null as any;
        data["testata"] = this.testata !== undefined ? this.testata : null as any;
        data["prenotazione"] = this.prenotazione !== undefined ? this.prenotazione : null as any;
        data["clienti"] = this.clienti !== undefined ? this.clienti : null as any;
        data["clientiText"] = this.clientiText !== undefined ? this.clientiText : null as any;
        data["servizio"] = this.servizio !== undefined ? this.servizio : null as any;
        data["periodo"] = this.periodo !== undefined ? this.periodo : null as any;
        data["istruzioni"] = this.istruzioni !== undefined ? this.istruzioni : null as any;
        return data;
    }
}

export interface IVoucherInfo {
    offerta?: OffertaInfo | null;
    isPreview?: boolean;
    id?: number;
    voucher?: Voucher | null;
    nr?: string | null;
    idStr?: string | null;
    testata?: string | null;
    prenotazione?: string | null;
    clienti?: string | null;
    clientiText?: string | null;
    servizio?: string | null;
    periodo?: string | null;
    istruzioni?: string | null;
}

export class OffertaTesto implements IOffertaTesto {
    id?: number;
    offertaID?: number;
    tappaID?: number;
    giornoTappa?: number;
    editAgenzia?: number;
    ordine?: number;
    testo?: string | null;

    constructor(data?: IOffertaTesto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.tappaID = _data["tappaID"] !== undefined ? _data["tappaID"] : null as any;
            this.giornoTappa = _data["giornoTappa"] !== undefined ? _data["giornoTappa"] : null as any;
            this.editAgenzia = _data["editAgenzia"] !== undefined ? _data["editAgenzia"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : null as any;
        }
    }

    static fromJS(data: any): OffertaTesto {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaTesto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["tappaID"] = this.tappaID !== undefined ? this.tappaID : null as any;
        data["giornoTappa"] = this.giornoTappa !== undefined ? this.giornoTappa : null as any;
        data["editAgenzia"] = this.editAgenzia !== undefined ? this.editAgenzia : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["testo"] = this.testo !== undefined ? this.testo : null as any;
        return data;
    }
}

export interface IOffertaTesto {
    id?: number;
    offertaID?: number;
    tappaID?: number;
    giornoTappa?: number;
    editAgenzia?: number;
    ordine?: number;
    testo?: string | null;
}

export class SectionUffici extends ExportableSection implements ISectionUffici {
    uffici?: RigaUfficio[] | null;

    constructor(data?: ISectionUffici) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["uffici"])) {
                this.uffici = [] as any;
                for (let item of _data["uffici"])
                    this.uffici!.push(RigaUfficio.fromJS(item));
            }
            else {
                this.uffici = null as any;
            }
        }
    }

    static override fromJS(data: any): SectionUffici {
        data = typeof data === 'object' ? data : {};
        let result = new SectionUffici();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.uffici)) {
            data["uffici"] = [];
            for (let item of this.uffici)
                data["uffici"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISectionUffici extends IExportableSection {
    uffici?: RigaUfficio[] | null;
}

export class RigaUfficio implements IRigaUfficio {
    nome?: string | null;
    telefono?: string | null;
    testo?: string | null;
    servizi?: ServizioUfficio[] | null;

    constructor(data?: IRigaUfficio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : null as any;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : null as any;
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(ServizioUfficio.fromJS(item));
            }
            else {
                this.servizi = null as any;
            }
        }
    }

    static fromJS(data: any): RigaUfficio {
        data = typeof data === 'object' ? data : {};
        let result = new RigaUfficio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["telefono"] = this.telefono !== undefined ? this.telefono : null as any;
        data["testo"] = this.testo !== undefined ? this.testo : null as any;
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IRigaUfficio {
    nome?: string | null;
    telefono?: string | null;
    testo?: string | null;
    servizi?: ServizioUfficio[] | null;
}

export class ServizioUfficio implements IServizioUfficio {
    tipo?: ETipoServizio;
    luogo?: string | null;
    nome?: string | null;
    date?: string | null;

    constructor(data?: IServizioUfficio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.date = _data["date"] !== undefined ? _data["date"] : null as any;
        }
    }

    static fromJS(data: any): ServizioUfficio {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioUfficio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["date"] = this.date !== undefined ? this.date : null as any;
        return data;
    }
}

export interface IServizioUfficio {
    tipo?: ETipoServizio;
    luogo?: string | null;
    nome?: string | null;
    date?: string | null;
}

export class SectionInfoHotel extends ExportableSection implements ISectionInfoHotel {
    elencoHotel?: HotelDescrizione[] | null;

    constructor(data?: ISectionInfoHotel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["elencoHotel"])) {
                this.elencoHotel = [] as any;
                for (let item of _data["elencoHotel"])
                    this.elencoHotel!.push(HotelDescrizione.fromJS(item));
            }
            else {
                this.elencoHotel = null as any;
            }
        }
    }

    static override fromJS(data: any): SectionInfoHotel {
        data = typeof data === 'object' ? data : {};
        let result = new SectionInfoHotel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elencoHotel)) {
            data["elencoHotel"] = [];
            for (let item of this.elencoHotel)
                data["elencoHotel"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISectionInfoHotel extends IExportableSection {
    elencoHotel?: HotelDescrizione[] | null;
}

export class HotelDescrizione implements IHotelDescrizione {
    inizio?: string;
    fine?: string;
    notti?: number;
    servizioID?: number | null;
    lat?: number | null;
    lon?: number | null;
    zoom?: number | null;
    descrizione?: string | null;
    contattoId?: number;
    contattoNome?: string | null;
    contattoLuogo?: string | null;
    contattoIndirizzo?: string | null;
    contattoTelefono?: string | null;
    imagesUrl?: string[] | null;
    vouchers?: ReservationVoucher[] | null;
    coverImageUrl?: string | null;
    mapGoogleUrl?: string | null;

    constructor(data?: IHotelDescrizione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inizio = _data["inizio"] !== undefined ? _data["inizio"] : null as any;
            this.fine = _data["fine"] !== undefined ? _data["fine"] : null as any;
            this.notti = _data["notti"] !== undefined ? _data["notti"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.lat = _data["lat"] !== undefined ? _data["lat"] : null as any;
            this.lon = _data["lon"] !== undefined ? _data["lon"] : null as any;
            this.zoom = _data["zoom"] !== undefined ? _data["zoom"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.contattoId = _data["contattoId"] !== undefined ? _data["contattoId"] : null as any;
            this.contattoNome = _data["contattoNome"] !== undefined ? _data["contattoNome"] : null as any;
            this.contattoLuogo = _data["contattoLuogo"] !== undefined ? _data["contattoLuogo"] : null as any;
            this.contattoIndirizzo = _data["contattoIndirizzo"] !== undefined ? _data["contattoIndirizzo"] : null as any;
            this.contattoTelefono = _data["contattoTelefono"] !== undefined ? _data["contattoTelefono"] : null as any;
            if (Array.isArray(_data["imagesUrl"])) {
                this.imagesUrl = [] as any;
                for (let item of _data["imagesUrl"])
                    this.imagesUrl!.push(item);
            }
            else {
                this.imagesUrl = null as any;
            }
            if (Array.isArray(_data["vouchers"])) {
                this.vouchers = [] as any;
                for (let item of _data["vouchers"])
                    this.vouchers!.push(ReservationVoucher.fromJS(item));
            }
            else {
                this.vouchers = null as any;
            }
            this.coverImageUrl = _data["coverImageUrl"] !== undefined ? _data["coverImageUrl"] : null as any;
            this.mapGoogleUrl = _data["mapGoogleUrl"] !== undefined ? _data["mapGoogleUrl"] : null as any;
        }
    }

    static fromJS(data: any): HotelDescrizione {
        data = typeof data === 'object' ? data : {};
        let result = new HotelDescrizione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inizio"] = this.inizio !== undefined ? this.inizio : null as any;
        data["fine"] = this.fine !== undefined ? this.fine : null as any;
        data["notti"] = this.notti !== undefined ? this.notti : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["lat"] = this.lat !== undefined ? this.lat : null as any;
        data["lon"] = this.lon !== undefined ? this.lon : null as any;
        data["zoom"] = this.zoom !== undefined ? this.zoom : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["contattoId"] = this.contattoId !== undefined ? this.contattoId : null as any;
        data["contattoNome"] = this.contattoNome !== undefined ? this.contattoNome : null as any;
        data["contattoLuogo"] = this.contattoLuogo !== undefined ? this.contattoLuogo : null as any;
        data["contattoIndirizzo"] = this.contattoIndirizzo !== undefined ? this.contattoIndirizzo : null as any;
        data["contattoTelefono"] = this.contattoTelefono !== undefined ? this.contattoTelefono : null as any;
        if (Array.isArray(this.imagesUrl)) {
            data["imagesUrl"] = [];
            for (let item of this.imagesUrl)
                data["imagesUrl"].push(item);
        }
        if (Array.isArray(this.vouchers)) {
            data["vouchers"] = [];
            for (let item of this.vouchers)
                data["vouchers"].push(item ? item.toJSON() : null as any);
        }
        data["coverImageUrl"] = this.coverImageUrl !== undefined ? this.coverImageUrl : null as any;
        data["mapGoogleUrl"] = this.mapGoogleUrl !== undefined ? this.mapGoogleUrl : null as any;
        return data;
    }
}

export interface IHotelDescrizione {
    inizio?: string;
    fine?: string;
    notti?: number;
    servizioID?: number | null;
    lat?: number | null;
    lon?: number | null;
    zoom?: number | null;
    descrizione?: string | null;
    contattoId?: number;
    contattoNome?: string | null;
    contattoLuogo?: string | null;
    contattoIndirizzo?: string | null;
    contattoTelefono?: string | null;
    imagesUrl?: string[] | null;
    vouchers?: ReservationVoucher[] | null;
    coverImageUrl?: string | null;
    mapGoogleUrl?: string | null;
}

export class ReservationVoucher implements IReservationVoucher {
    nr?: string | null;
    voucherID?: number;
    offertaID?: number | null;
    ordine?: number | null;
    testata?: string | null;
    bookingRef?: string | null;
    clienti?: string | null;
    descrizioneServizio?: string | null;
    periodo?: string | null;
    dettaglio?: string | null;
    istruzioni?: string | null;
    servizioID?: number | null;
    lingua?: ELingua | null;
    versione?: number;
    paxList?: string[] | null;

    constructor(data?: IReservationVoucher) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nr = _data["nr"] !== undefined ? _data["nr"] : null as any;
            this.voucherID = _data["voucherID"] !== undefined ? _data["voucherID"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.testata = _data["testata"] !== undefined ? _data["testata"] : null as any;
            this.bookingRef = _data["bookingRef"] !== undefined ? _data["bookingRef"] : null as any;
            this.clienti = _data["clienti"] !== undefined ? _data["clienti"] : null as any;
            this.descrizioneServizio = _data["descrizioneServizio"] !== undefined ? _data["descrizioneServizio"] : null as any;
            this.periodo = _data["periodo"] !== undefined ? _data["periodo"] : null as any;
            this.dettaglio = _data["dettaglio"] !== undefined ? _data["dettaglio"] : null as any;
            this.istruzioni = _data["istruzioni"] !== undefined ? _data["istruzioni"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : null as any;
            this.versione = _data["versione"] !== undefined ? _data["versione"] : null as any;
            if (Array.isArray(_data["paxList"])) {
                this.paxList = [] as any;
                for (let item of _data["paxList"])
                    this.paxList!.push(item);
            }
            else {
                this.paxList = null as any;
            }
        }
    }

    static fromJS(data: any): ReservationVoucher {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationVoucher();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nr"] = this.nr !== undefined ? this.nr : null as any;
        data["voucherID"] = this.voucherID !== undefined ? this.voucherID : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["testata"] = this.testata !== undefined ? this.testata : null as any;
        data["bookingRef"] = this.bookingRef !== undefined ? this.bookingRef : null as any;
        data["clienti"] = this.clienti !== undefined ? this.clienti : null as any;
        data["descrizioneServizio"] = this.descrizioneServizio !== undefined ? this.descrizioneServizio : null as any;
        data["periodo"] = this.periodo !== undefined ? this.periodo : null as any;
        data["dettaglio"] = this.dettaglio !== undefined ? this.dettaglio : null as any;
        data["istruzioni"] = this.istruzioni !== undefined ? this.istruzioni : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["lingua"] = this.lingua !== undefined ? this.lingua : null as any;
        data["versione"] = this.versione !== undefined ? this.versione : null as any;
        if (Array.isArray(this.paxList)) {
            data["paxList"] = [];
            for (let item of this.paxList)
                data["paxList"].push(item);
        }
        return data;
    }
}

export interface IReservationVoucher {
    nr?: string | null;
    voucherID?: number;
    offertaID?: number | null;
    ordine?: number | null;
    testata?: string | null;
    bookingRef?: string | null;
    clienti?: string | null;
    descrizioneServizio?: string | null;
    periodo?: string | null;
    dettaglio?: string | null;
    istruzioni?: string | null;
    servizioID?: number | null;
    lingua?: ELingua | null;
    versione?: number;
    paxList?: string[] | null;
}

export class SectionNote extends ExportableSection implements ISectionNote {
    note?: string | null;

    constructor(data?: ISectionNote) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
        }
    }

    static override fromJS(data: any): SectionNote {
        data = typeof data === 'object' ? data : {};
        let result = new SectionNote();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note !== undefined ? this.note : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISectionNote extends IExportableSection {
    note?: string | null;
}

export class SectionProgrammaDiViaggio extends ExportableSection implements ISectionProgrammaDiViaggio {
    days?: PdvDay[] | null;

    constructor(data?: ISectionProgrammaDiViaggio) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(PdvDay.fromJS(item));
            }
            else {
                this.days = null as any;
            }
        }
    }

    static override fromJS(data: any): SectionProgrammaDiViaggio {
        data = typeof data === 'object' ? data : {};
        let result = new SectionProgrammaDiViaggio();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISectionProgrammaDiViaggio extends IExportableSection {
    days?: PdvDay[] | null;
}

export class PdvDay implements IPdvDay {
    orePrima?: number;
    minutiPrima?: number;
    giorno?: number;
    inizio?: string;
    fine?: string | null;
    locations?: string | null;
    headerDate?: string | null;
    testo?: string | null;
    voli?: PdvVolo[] | null;
    immagini?: PdvImage[] | null;
    elencoServizi?: PdvServizio[] | null;
    cityMap?: PdvImage | null;
    distanze?: Distanze[] | null;

    constructor(data?: IPdvDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orePrima = _data["orePrima"] !== undefined ? _data["orePrima"] : null as any;
            this.minutiPrima = _data["minutiPrima"] !== undefined ? _data["minutiPrima"] : null as any;
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : null as any;
            this.inizio = _data["inizio"] !== undefined ? _data["inizio"] : null as any;
            this.fine = _data["fine"] !== undefined ? _data["fine"] : null as any;
            this.locations = _data["locations"] !== undefined ? _data["locations"] : null as any;
            this.headerDate = _data["headerDate"] !== undefined ? _data["headerDate"] : null as any;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : null as any;
            if (Array.isArray(_data["voli"])) {
                this.voli = [] as any;
                for (let item of _data["voli"])
                    this.voli!.push(PdvVolo.fromJS(item));
            }
            else {
                this.voli = null as any;
            }
            if (Array.isArray(_data["immagini"])) {
                this.immagini = [] as any;
                for (let item of _data["immagini"])
                    this.immagini!.push(PdvImage.fromJS(item));
            }
            else {
                this.immagini = null as any;
            }
            if (Array.isArray(_data["elencoServizi"])) {
                this.elencoServizi = [] as any;
                for (let item of _data["elencoServizi"])
                    this.elencoServizi!.push(PdvServizio.fromJS(item));
            }
            else {
                this.elencoServizi = null as any;
            }
            this.cityMap = _data["cityMap"] ? PdvImage.fromJS(_data["cityMap"]) : null as any;
            if (Array.isArray(_data["distanze"])) {
                this.distanze = [] as any;
                for (let item of _data["distanze"])
                    this.distanze!.push(Distanze.fromJS(item));
            }
            else {
                this.distanze = null as any;
            }
        }
    }

    static fromJS(data: any): PdvDay {
        data = typeof data === 'object' ? data : {};
        let result = new PdvDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orePrima"] = this.orePrima !== undefined ? this.orePrima : null as any;
        data["minutiPrima"] = this.minutiPrima !== undefined ? this.minutiPrima : null as any;
        data["giorno"] = this.giorno !== undefined ? this.giorno : null as any;
        data["inizio"] = this.inizio !== undefined ? this.inizio : null as any;
        data["fine"] = this.fine !== undefined ? this.fine : null as any;
        data["locations"] = this.locations !== undefined ? this.locations : null as any;
        data["headerDate"] = this.headerDate !== undefined ? this.headerDate : null as any;
        data["testo"] = this.testo !== undefined ? this.testo : null as any;
        if (Array.isArray(this.voli)) {
            data["voli"] = [];
            for (let item of this.voli)
                data["voli"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.immagini)) {
            data["immagini"] = [];
            for (let item of this.immagini)
                data["immagini"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.elencoServizi)) {
            data["elencoServizi"] = [];
            for (let item of this.elencoServizi)
                data["elencoServizi"].push(item ? item.toJSON() : null as any);
        }
        data["cityMap"] = this.cityMap ? this.cityMap.toJSON() : null as any;
        if (Array.isArray(this.distanze)) {
            data["distanze"] = [];
            for (let item of this.distanze)
                data["distanze"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPdvDay {
    orePrima?: number;
    minutiPrima?: number;
    giorno?: number;
    inizio?: string;
    fine?: string | null;
    locations?: string | null;
    headerDate?: string | null;
    testo?: string | null;
    voli?: PdvVolo[] | null;
    immagini?: PdvImage[] | null;
    elencoServizi?: PdvServizio[] | null;
    cityMap?: PdvImage | null;
    distanze?: Distanze[] | null;
}

export class PdvVolo implements IPdvVolo {
    compagniaNome?: string | null;
    compagniaCodice?: string | null;
    numeroVolo?: number;
    partenza?: string | null;
    partenzaAeroporto?: string | null;
    arrivo?: string | null;
    arrivoAeroporto?: string | null;
    arrivoIlGiornoDopo?: boolean;

    constructor(data?: IPdvVolo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.compagniaNome = _data["compagniaNome"] !== undefined ? _data["compagniaNome"] : null as any;
            this.compagniaCodice = _data["compagniaCodice"] !== undefined ? _data["compagniaCodice"] : null as any;
            this.numeroVolo = _data["numeroVolo"] !== undefined ? _data["numeroVolo"] : null as any;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : null as any;
            this.partenzaAeroporto = _data["partenzaAeroporto"] !== undefined ? _data["partenzaAeroporto"] : null as any;
            this.arrivo = _data["arrivo"] !== undefined ? _data["arrivo"] : null as any;
            this.arrivoAeroporto = _data["arrivoAeroporto"] !== undefined ? _data["arrivoAeroporto"] : null as any;
            this.arrivoIlGiornoDopo = _data["arrivoIlGiornoDopo"] !== undefined ? _data["arrivoIlGiornoDopo"] : null as any;
        }
    }

    static fromJS(data: any): PdvVolo {
        data = typeof data === 'object' ? data : {};
        let result = new PdvVolo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["compagniaNome"] = this.compagniaNome !== undefined ? this.compagniaNome : null as any;
        data["compagniaCodice"] = this.compagniaCodice !== undefined ? this.compagniaCodice : null as any;
        data["numeroVolo"] = this.numeroVolo !== undefined ? this.numeroVolo : null as any;
        data["partenza"] = this.partenza !== undefined ? this.partenza : null as any;
        data["partenzaAeroporto"] = this.partenzaAeroporto !== undefined ? this.partenzaAeroporto : null as any;
        data["arrivo"] = this.arrivo !== undefined ? this.arrivo : null as any;
        data["arrivoAeroporto"] = this.arrivoAeroporto !== undefined ? this.arrivoAeroporto : null as any;
        data["arrivoIlGiornoDopo"] = this.arrivoIlGiornoDopo !== undefined ? this.arrivoIlGiornoDopo : null as any;
        return data;
    }
}

export interface IPdvVolo {
    compagniaNome?: string | null;
    compagniaCodice?: string | null;
    numeroVolo?: number;
    partenza?: string | null;
    partenzaAeroporto?: string | null;
    arrivo?: string | null;
    arrivoAeroporto?: string | null;
    arrivoIlGiornoDopo?: boolean;
}

export class PdvImage implements IPdvImage {
    id?: number;
    url?: string | null;
    caption?: string | null;

    constructor(data?: IPdvImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
            this.caption = _data["caption"] !== undefined ? _data["caption"] : null as any;
        }
    }

    static fromJS(data: any): PdvImage {
        data = typeof data === 'object' ? data : {};
        let result = new PdvImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        data["caption"] = this.caption !== undefined ? this.caption : null as any;
        return data;
    }
}

export interface IPdvImage {
    id?: number;
    url?: string | null;
    caption?: string | null;
}

export class PdvServizio implements IPdvServizio {
    nome?: string | null;
    descrizione?: string | null;
    durata?: number;
    data?: string | null;
    tipoServizio?: ETipoServizio;
    imageUrl?: string | null;
    idServizio?: number;
    texts?: TextSeed[] | null;
    puntoIniziale?: TripServiceLocation | null;
    puntoFinale?: TripServiceLocation | null;

    constructor(data?: IPdvServizio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.durata = _data["durata"] !== undefined ? _data["durata"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : null as any;
            this.idServizio = _data["idServizio"] !== undefined ? _data["idServizio"] : null as any;
            if (Array.isArray(_data["texts"])) {
                this.texts = [] as any;
                for (let item of _data["texts"])
                    this.texts!.push(TextSeed.fromJS(item));
            }
            else {
                this.texts = null as any;
            }
            this.puntoIniziale = _data["puntoIniziale"] ? TripServiceLocation.fromJS(_data["puntoIniziale"]) : null as any;
            this.puntoFinale = _data["puntoFinale"] ? TripServiceLocation.fromJS(_data["puntoFinale"]) : null as any;
        }
    }

    static fromJS(data: any): PdvServizio {
        data = typeof data === 'object' ? data : {};
        let result = new PdvServizio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["durata"] = this.durata !== undefined ? this.durata : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : null as any;
        data["idServizio"] = this.idServizio !== undefined ? this.idServizio : null as any;
        if (Array.isArray(this.texts)) {
            data["texts"] = [];
            for (let item of this.texts)
                data["texts"].push(item ? item.toJSON() : null as any);
        }
        data["puntoIniziale"] = this.puntoIniziale ? this.puntoIniziale.toJSON() : null as any;
        data["puntoFinale"] = this.puntoFinale ? this.puntoFinale.toJSON() : null as any;
        return data;
    }
}

export interface IPdvServizio {
    nome?: string | null;
    descrizione?: string | null;
    durata?: number;
    data?: string | null;
    tipoServizio?: ETipoServizio;
    imageUrl?: string | null;
    idServizio?: number;
    texts?: TextSeed[] | null;
    puntoIniziale?: TripServiceLocation | null;
    puntoFinale?: TripServiceLocation | null;
}

export class Distanze implements IDistanze {
    idLuogo1?: number;
    idLuogo2?: number;
    distanza?: number;
    nomeLuogo1?: string | null;
    nomeLuogo2?: string | null;

    constructor(data?: IDistanze) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idLuogo1 = _data["idLuogo1"] !== undefined ? _data["idLuogo1"] : null as any;
            this.idLuogo2 = _data["idLuogo2"] !== undefined ? _data["idLuogo2"] : null as any;
            this.distanza = _data["distanza"] !== undefined ? _data["distanza"] : null as any;
            this.nomeLuogo1 = _data["nomeLuogo1"] !== undefined ? _data["nomeLuogo1"] : null as any;
            this.nomeLuogo2 = _data["nomeLuogo2"] !== undefined ? _data["nomeLuogo2"] : null as any;
        }
    }

    static fromJS(data: any): Distanze {
        data = typeof data === 'object' ? data : {};
        let result = new Distanze();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLuogo1"] = this.idLuogo1 !== undefined ? this.idLuogo1 : null as any;
        data["idLuogo2"] = this.idLuogo2 !== undefined ? this.idLuogo2 : null as any;
        data["distanza"] = this.distanza !== undefined ? this.distanza : null as any;
        data["nomeLuogo1"] = this.nomeLuogo1 !== undefined ? this.nomeLuogo1 : null as any;
        data["nomeLuogo2"] = this.nomeLuogo2 !== undefined ? this.nomeLuogo2 : null as any;
        return data;
    }
}

export interface IDistanze {
    idLuogo1?: number;
    idLuogo2?: number;
    distanza?: number;
    nomeLuogo1?: string | null;
    nomeLuogo2?: string | null;
}

export class SectionAssistenza implements ISectionAssistenza {
    titolo?: string | null;
    testo?: string | null;

    constructor(data?: ISectionAssistenza) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : null as any;
        }
    }

    static fromJS(data: any): SectionAssistenza {
        data = typeof data === 'object' ? data : {};
        let result = new SectionAssistenza();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        data["testo"] = this.testo !== undefined ? this.testo : null as any;
        return data;
    }
}

export interface ISectionAssistenza {
    titolo?: string | null;
    testo?: string | null;
}

export class SectionAssicurazione implements ISectionAssicurazione {
    insurancesList?: AssicurazioneItem[] | null;

    constructor(data?: ISectionAssicurazione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insurancesList"])) {
                this.insurancesList = [] as any;
                for (let item of _data["insurancesList"])
                    this.insurancesList!.push(AssicurazioneItem.fromJS(item));
            }
            else {
                this.insurancesList = null as any;
            }
        }
    }

    static fromJS(data: any): SectionAssicurazione {
        data = typeof data === 'object' ? data : {};
        let result = new SectionAssicurazione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insurancesList)) {
            data["insurancesList"] = [];
            for (let item of this.insurancesList)
                data["insurancesList"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ISectionAssicurazione {
    insurancesList?: AssicurazioneItem[] | null;
}

export class AssicurazioneItem implements IAssicurazioneItem {
    titolo?: string | null;
    testo?: string | null;
    qrCodeUrl?: string | null;
    idServizio?: number;

    constructor(data?: IAssicurazioneItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : null as any;
            this.qrCodeUrl = _data["qrCodeUrl"] !== undefined ? _data["qrCodeUrl"] : null as any;
            this.idServizio = _data["idServizio"] !== undefined ? _data["idServizio"] : null as any;
        }
    }

    static fromJS(data: any): AssicurazioneItem {
        data = typeof data === 'object' ? data : {};
        let result = new AssicurazioneItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        data["testo"] = this.testo !== undefined ? this.testo : null as any;
        data["qrCodeUrl"] = this.qrCodeUrl !== undefined ? this.qrCodeUrl : null as any;
        data["idServizio"] = this.idServizio !== undefined ? this.idServizio : null as any;
        return data;
    }
}

export interface IAssicurazioneItem {
    titolo?: string | null;
    testo?: string | null;
    qrCodeUrl?: string | null;
    idServizio?: number;
}

export class SectionElencoVoucher extends ExportableSection implements ISectionElencoVoucher {
    elencoServizi?: ServizioVoucher[] | null;

    constructor(data?: ISectionElencoVoucher) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["elencoServizi"])) {
                this.elencoServizi = [] as any;
                for (let item of _data["elencoServizi"])
                    this.elencoServizi!.push(ServizioVoucher.fromJS(item));
            }
            else {
                this.elencoServizi = null as any;
            }
        }
    }

    static override fromJS(data: any): SectionElencoVoucher {
        data = typeof data === 'object' ? data : {};
        let result = new SectionElencoVoucher();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elencoServizi)) {
            data["elencoServizi"] = [];
            for (let item of this.elencoServizi)
                data["elencoServizi"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISectionElencoVoucher extends IExportableSection {
    elencoServizi?: ServizioVoucher[] | null;
}

/** Si carica i dati del servizio necessari al voucher */
export class ServizioVoucher extends HotelDescrizione implements IServizioVoucher {
    descrizioniRighe?: string[] | null;
    tipoServizio?: ETipoServizio;
    nome?: string | null;
    stelle?: number | null;
    /** Dati del punto iniziale */
    puntoIniziale?: TripServiceLocation | null;
    /** Dati del punto finale */
    puntoFinale?: TripServiceLocation | null;
    offertaId?: number;
    bookingRef?: string | null;
    paxList?: VoucherPax[] | null;
    lingua?: ELingua;
    dettaglio?: string | null;
    note?: string[] | null;
    datiaggiuntivi?: string[] | null;
    statusServizio?: EStatusServizio | null;
    isFullContent?: boolean;
    fullContentInfo?: string | null;

    constructor(data?: IServizioVoucher) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["descrizioniRighe"])) {
                this.descrizioniRighe = [] as any;
                for (let item of _data["descrizioniRighe"])
                    this.descrizioniRighe!.push(item);
            }
            else {
                this.descrizioniRighe = null as any;
            }
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.stelle = _data["stelle"] !== undefined ? _data["stelle"] : null as any;
            this.puntoIniziale = _data["puntoIniziale"] ? TripServiceLocation.fromJS(_data["puntoIniziale"]) : null as any;
            this.puntoFinale = _data["puntoFinale"] ? TripServiceLocation.fromJS(_data["puntoFinale"]) : null as any;
            this.offertaId = _data["offertaId"] !== undefined ? _data["offertaId"] : null as any;
            this.bookingRef = _data["bookingRef"] !== undefined ? _data["bookingRef"] : null as any;
            if (Array.isArray(_data["paxList"])) {
                this.paxList = [] as any;
                for (let item of _data["paxList"])
                    this.paxList!.push(VoucherPax.fromJS(item));
            }
            else {
                this.paxList = null as any;
            }
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : null as any;
            this.dettaglio = _data["dettaglio"] !== undefined ? _data["dettaglio"] : null as any;
            if (Array.isArray(_data["note"])) {
                this.note = [] as any;
                for (let item of _data["note"])
                    this.note!.push(item);
            }
            else {
                this.note = null as any;
            }
            if (Array.isArray(_data["datiaggiuntivi"])) {
                this.datiaggiuntivi = [] as any;
                for (let item of _data["datiaggiuntivi"])
                    this.datiaggiuntivi!.push(item);
            }
            else {
                this.datiaggiuntivi = null as any;
            }
            this.statusServizio = _data["statusServizio"] !== undefined ? _data["statusServizio"] : null as any;
            this.isFullContent = _data["isFullContent"] !== undefined ? _data["isFullContent"] : null as any;
            this.fullContentInfo = _data["fullContentInfo"] !== undefined ? _data["fullContentInfo"] : null as any;
        }
    }

    static override fromJS(data: any): ServizioVoucher {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioVoucher();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.descrizioniRighe)) {
            data["descrizioniRighe"] = [];
            for (let item of this.descrizioniRighe)
                data["descrizioniRighe"].push(item);
        }
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["stelle"] = this.stelle !== undefined ? this.stelle : null as any;
        data["puntoIniziale"] = this.puntoIniziale ? this.puntoIniziale.toJSON() : null as any;
        data["puntoFinale"] = this.puntoFinale ? this.puntoFinale.toJSON() : null as any;
        data["offertaId"] = this.offertaId !== undefined ? this.offertaId : null as any;
        data["bookingRef"] = this.bookingRef !== undefined ? this.bookingRef : null as any;
        if (Array.isArray(this.paxList)) {
            data["paxList"] = [];
            for (let item of this.paxList)
                data["paxList"].push(item ? item.toJSON() : null as any);
        }
        data["lingua"] = this.lingua !== undefined ? this.lingua : null as any;
        data["dettaglio"] = this.dettaglio !== undefined ? this.dettaglio : null as any;
        if (Array.isArray(this.note)) {
            data["note"] = [];
            for (let item of this.note)
                data["note"].push(item);
        }
        if (Array.isArray(this.datiaggiuntivi)) {
            data["datiaggiuntivi"] = [];
            for (let item of this.datiaggiuntivi)
                data["datiaggiuntivi"].push(item);
        }
        data["statusServizio"] = this.statusServizio !== undefined ? this.statusServizio : null as any;
        data["isFullContent"] = this.isFullContent !== undefined ? this.isFullContent : null as any;
        data["fullContentInfo"] = this.fullContentInfo !== undefined ? this.fullContentInfo : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Si carica i dati del servizio necessari al voucher */
export interface IServizioVoucher extends IHotelDescrizione {
    descrizioniRighe?: string[] | null;
    tipoServizio?: ETipoServizio;
    nome?: string | null;
    stelle?: number | null;
    /** Dati del punto iniziale */
    puntoIniziale?: TripServiceLocation | null;
    /** Dati del punto finale */
    puntoFinale?: TripServiceLocation | null;
    offertaId?: number;
    bookingRef?: string | null;
    paxList?: VoucherPax[] | null;
    lingua?: ELingua;
    dettaglio?: string | null;
    note?: string[] | null;
    datiaggiuntivi?: string[] | null;
    statusServizio?: EStatusServizio | null;
    isFullContent?: boolean;
    fullContentInfo?: string | null;
}

/** Ritaglio dei dati utente necessari per i voucher */
export class VoucherPax implements IVoucherPax {
    titolo?: ETitolo;
    nome?: string | null;
    cognome?: string | null;
    isChild?: boolean;

    constructor(data?: IVoucherPax) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : null as any;
            this.isChild = _data["isChild"] !== undefined ? _data["isChild"] : null as any;
        }
    }

    static fromJS(data: any): VoucherPax {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherPax();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["cognome"] = this.cognome !== undefined ? this.cognome : null as any;
        data["isChild"] = this.isChild !== undefined ? this.isChild : null as any;
        return data;
    }
}

/** Ritaglio dei dati utente necessari per i voucher */
export interface IVoucherPax {
    titolo?: ETitolo;
    nome?: string | null;
    cognome?: string | null;
    isChild?: boolean;
}

export class SectionMiniguide implements ISectionMiniguide {
    elencoMiniguide?: Miniguida[] | null;

    constructor(data?: ISectionMiniguide) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elencoMiniguide"])) {
                this.elencoMiniguide = [] as any;
                for (let item of _data["elencoMiniguide"])
                    this.elencoMiniguide!.push(Miniguida.fromJS(item));
            }
            else {
                this.elencoMiniguide = null as any;
            }
        }
    }

    static fromJS(data: any): SectionMiniguide {
        data = typeof data === 'object' ? data : {};
        let result = new SectionMiniguide();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elencoMiniguide)) {
            data["elencoMiniguide"] = [];
            for (let item of this.elencoMiniguide)
                data["elencoMiniguide"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ISectionMiniguide {
    elencoMiniguide?: Miniguida[] | null;
}

export class Miniguida extends MiniguidaHeader implements IMiniguida {
    giorno?: number;
    priorita?: number;
    text?: string | null;
    numImmagini?: number;

    constructor(data?: IMiniguida) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : null as any;
            this.priorita = _data["priorita"] !== undefined ? _data["priorita"] : null as any;
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
            this.numImmagini = _data["numImmagini"] !== undefined ? _data["numImmagini"] : null as any;
        }
    }

    static override fromJS(data: any): Miniguida {
        data = typeof data === 'object' ? data : {};
        let result = new Miniguida();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giorno"] = this.giorno !== undefined ? this.giorno : null as any;
        data["priorita"] = this.priorita !== undefined ? this.priorita : null as any;
        data["text"] = this.text !== undefined ? this.text : null as any;
        data["numImmagini"] = this.numImmagini !== undefined ? this.numImmagini : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IMiniguida extends IMiniguidaHeader {
    giorno?: number;
    priorita?: number;
    text?: string | null;
    numImmagini?: number;
}

export class SectionTicketsVoli implements ISectionTicketsVoli {
    elencoTicketsVoli?: VoloTicketsInfo[] | null;

    constructor(data?: ISectionTicketsVoli) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elencoTicketsVoli"])) {
                this.elencoTicketsVoli = [] as any;
                for (let item of _data["elencoTicketsVoli"])
                    this.elencoTicketsVoli!.push(VoloTicketsInfo.fromJS(item));
            }
            else {
                this.elencoTicketsVoli = null as any;
            }
        }
    }

    static fromJS(data: any): SectionTicketsVoli {
        data = typeof data === 'object' ? data : {};
        let result = new SectionTicketsVoli();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elencoTicketsVoli)) {
            data["elencoTicketsVoli"] = [];
            for (let item of this.elencoTicketsVoli)
                data["elencoTicketsVoli"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ISectionTicketsVoli {
    elencoTicketsVoli?: VoloTicketsInfo[] | null;
}

export class EstremiBancari implements IEstremiBancari {
    estremi?: EstremoBancario[];
    note?: string[];

    constructor(data?: IEstremiBancari) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["estremi"])) {
                this.estremi = [] as any;
                for (let item of _data["estremi"])
                    this.estremi!.push(EstremoBancario.fromJS(item));
            }
            else {
                this.estremi = null as any;
            }
            if (Array.isArray(_data["note"])) {
                this.note = [] as any;
                for (let item of _data["note"])
                    this.note!.push(item);
            }
            else {
                this.note = null as any;
            }
        }
    }

    static fromJS(data: any): EstremiBancari {
        data = typeof data === 'object' ? data : {};
        let result = new EstremiBancari();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.estremi)) {
            data["estremi"] = [];
            for (let item of this.estremi)
                data["estremi"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.note)) {
            data["note"] = [];
            for (let item of this.note)
                data["note"].push(item);
        }
        return data;
    }
}

export interface IEstremiBancari {
    estremi?: EstremoBancario[];
    note?: string[];
}

export class EstremoBancario implements IEstremoBancario {
    nome?: string;
    iban?: string;
    swift?: string;

    constructor(data?: IEstremoBancario) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.iban = _data["iban"] !== undefined ? _data["iban"] : null as any;
            this.swift = _data["swift"] !== undefined ? _data["swift"] : null as any;
        }
    }

    static fromJS(data: any): EstremoBancario {
        data = typeof data === 'object' ? data : {};
        let result = new EstremoBancario();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["iban"] = this.iban !== undefined ? this.iban : null as any;
        data["swift"] = this.swift !== undefined ? this.swift : null as any;
        return data;
    }
}

export interface IEstremoBancario {
    nome?: string;
    iban?: string;
    swift?: string;
}

export class NoteDocumento implements INoteDocumento {
    tipo?: ETipoNota;
    testo?: string | null;
    data?: string;

    constructor(data?: INoteDocumento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
        }
    }

    static fromJS(data: any): NoteDocumento {
        data = typeof data === 'object' ? data : {};
        let result = new NoteDocumento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["testo"] = this.testo !== undefined ? this.testo : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        return data;
    }
}

export interface INoteDocumento {
    tipo?: ETipoNota;
    testo?: string | null;
    data?: string;
}

export class PassolutionAllInfo implements IPassolutionAllInfo {
    destination?: string;
    nationality?: string;
    covid_status?: string;
    title?: string;
    corona?: PassolutionCoronaInfo;
    entry?: PassolutionEntryInfo;
    visa?: PassolutionVisaInfo;
    transit_visa?: PassolutionTransitVisaInfo;
    health?: PassolutionHealthInfo;
    final_provisions?: PassolutionBaseContentResponse;

    constructor(data?: IPassolutionAllInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.destination = _data["destination"] !== undefined ? _data["destination"] : null as any;
            this.nationality = _data["nationality"] !== undefined ? _data["nationality"] : null as any;
            this.covid_status = _data["covid_status"] !== undefined ? _data["covid_status"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.corona = _data["corona"] ? PassolutionCoronaInfo.fromJS(_data["corona"]) : null as any;
            this.entry = _data["entry"] ? PassolutionEntryInfo.fromJS(_data["entry"]) : null as any;
            this.visa = _data["visa"] ? PassolutionVisaInfo.fromJS(_data["visa"]) : null as any;
            this.transit_visa = _data["transit_visa"] ? PassolutionTransitVisaInfo.fromJS(_data["transit_visa"]) : null as any;
            this.health = _data["health"] ? PassolutionHealthInfo.fromJS(_data["health"]) : null as any;
            this.final_provisions = _data["final_provisions"] ? PassolutionBaseContentResponse.fromJS(_data["final_provisions"]) : null as any;
        }
    }

    static fromJS(data: any): PassolutionAllInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PassolutionAllInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["destination"] = this.destination !== undefined ? this.destination : null as any;
        data["nationality"] = this.nationality !== undefined ? this.nationality : null as any;
        data["covid_status"] = this.covid_status !== undefined ? this.covid_status : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["corona"] = this.corona ? this.corona.toJSON() : null as any;
        data["entry"] = this.entry ? this.entry.toJSON() : null as any;
        data["visa"] = this.visa ? this.visa.toJSON() : null as any;
        data["transit_visa"] = this.transit_visa ? this.transit_visa.toJSON() : null as any;
        data["health"] = this.health ? this.health.toJSON() : null as any;
        data["final_provisions"] = this.final_provisions ? this.final_provisions.toJSON() : null as any;
        return data;
    }
}

export interface IPassolutionAllInfo {
    destination?: string;
    nationality?: string;
    covid_status?: string;
    title?: string;
    corona?: PassolutionCoronaInfo;
    entry?: PassolutionEntryInfo;
    visa?: PassolutionVisaInfo;
    transit_visa?: PassolutionTransitVisaInfo;
    health?: PassolutionHealthInfo;
    final_provisions?: PassolutionBaseContentResponse;
}

export class PassolutionBaseContentResponse implements IPassolutionBaseContentResponse {
    title?: string | null;
    content?: string | null;
    updated_at?: string | null;
    destination?: string | null;
    nationality?: string | null;
    language?: string | null;
    has_important_changes?: boolean | null;

    constructor(data?: IPassolutionBaseContentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.content = _data["content"] !== undefined ? _data["content"] : null as any;
            this.updated_at = _data["updated_at"] !== undefined ? _data["updated_at"] : null as any;
            this.destination = _data["destination"] !== undefined ? _data["destination"] : null as any;
            this.nationality = _data["nationality"] !== undefined ? _data["nationality"] : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
            this.has_important_changes = _data["has_important_changes"] !== undefined ? _data["has_important_changes"] : null as any;
        }
    }

    static fromJS(data: any): PassolutionBaseContentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PassolutionBaseContentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["content"] = this.content !== undefined ? this.content : null as any;
        data["updated_at"] = this.updated_at !== undefined ? this.updated_at : null as any;
        data["destination"] = this.destination !== undefined ? this.destination : null as any;
        data["nationality"] = this.nationality !== undefined ? this.nationality : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        data["has_important_changes"] = this.has_important_changes !== undefined ? this.has_important_changes : null as any;
        return data;
    }
}

export interface IPassolutionBaseContentResponse {
    title?: string | null;
    content?: string | null;
    updated_at?: string | null;
    destination?: string | null;
    nationality?: string | null;
    language?: string | null;
    has_important_changes?: boolean | null;
}

export class PassolutionCoronaInfo extends PassolutionBaseContentResponse implements IPassolutionCoronaInfo {

    constructor(data?: IPassolutionCoronaInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PassolutionCoronaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PassolutionCoronaInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPassolutionCoronaInfo extends IPassolutionBaseContentResponse {
}

export class PassolutionEntryInfo extends PassolutionBaseContentResponse implements IPassolutionEntryInfo {

    constructor(data?: IPassolutionEntryInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PassolutionEntryInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PassolutionEntryInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPassolutionEntryInfo extends IPassolutionBaseContentResponse {
}

export class PassolutionVisaInfo extends PassolutionBaseContentResponse implements IPassolutionVisaInfo {

    constructor(data?: IPassolutionVisaInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PassolutionVisaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PassolutionVisaInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPassolutionVisaInfo extends IPassolutionBaseContentResponse {
}

export class PassolutionTransitVisaInfo extends PassolutionBaseContentResponse implements IPassolutionTransitVisaInfo {

    constructor(data?: IPassolutionTransitVisaInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PassolutionTransitVisaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PassolutionTransitVisaInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPassolutionTransitVisaInfo extends IPassolutionBaseContentResponse {
}

export class PassolutionHealthInfo extends PassolutionBaseContentResponse implements IPassolutionHealthInfo {

    constructor(data?: IPassolutionHealthInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PassolutionHealthInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PassolutionHealthInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPassolutionHealthInfo extends IPassolutionBaseContentResponse {
}

/** Richiesta dei dati per formattare un documento */
export class GetTripDocumentDataRequest extends SiteRequest implements IGetTripDocumentDataRequest {
    /** ID utente (ad uso delle anteprime di stampa) */
    userID?: string;
    /** ID dell'offerta */
    offertaID?: number;
    /** ID facoltativo di un documento a frasi di cui visualizzare l'anteprima */
    documentoID?: number | null;
    /** Tipo di documento */
    tipoDocumento?: ETipoDocumento;
    /** Stringa con le tuple [id_ordine] separate da virgola delle miniguide da usare nel documento */
    extraDocs?: string;

    constructor(data?: IGetTripDocumentDataRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userID = _data["userID"] !== undefined ? _data["userID"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : null as any;
            this.tipoDocumento = _data["tipoDocumento"] !== undefined ? _data["tipoDocumento"] : null as any;
            this.extraDocs = _data["extraDocs"] !== undefined ? _data["extraDocs"] : null as any;
        }
    }

    static override fromJS(data: any): GetTripDocumentDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripDocumentDataRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID !== undefined ? this.userID : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : null as any;
        data["tipoDocumento"] = this.tipoDocumento !== undefined ? this.tipoDocumento : null as any;
        data["extraDocs"] = this.extraDocs !== undefined ? this.extraDocs : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Richiesta dei dati per formattare un documento */
export interface IGetTripDocumentDataRequest extends ISiteRequest {
    /** ID utente (ad uso delle anteprime di stampa) */
    userID?: string;
    /** ID dell'offerta */
    offertaID?: number;
    /** ID facoltativo di un documento a frasi di cui visualizzare l'anteprima */
    documentoID?: number | null;
    /** Tipo di documento */
    tipoDocumento?: ETipoDocumento;
    /** Stringa con le tuple [id_ordine] separate da virgola delle miniguide da usare nel documento */
    extraDocs?: string;
}

export class GetTripReservationDocDataResponse extends OkApiResponse implements IGetTripReservationDocDataResponse {
    prenotazioni?: TripReservation[];
    reservationEmitter?: InvoiceEmitter | null;

    constructor(data?: IGetTripReservationDocDataResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["prenotazioni"])) {
                this.prenotazioni = [] as any;
                for (let item of _data["prenotazioni"])
                    this.prenotazioni!.push(TripReservation.fromJS(item));
            }
            else {
                this.prenotazioni = null as any;
            }
            this.reservationEmitter = _data["reservationEmitter"] ? InvoiceEmitter.fromJS(_data["reservationEmitter"]) : null as any;
        }
    }

    static override fromJS(data: any): GetTripReservationDocDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripReservationDocDataResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.prenotazioni)) {
            data["prenotazioni"] = [];
            for (let item of this.prenotazioni)
                data["prenotazioni"].push(item ? item.toJSON() : null as any);
        }
        data["reservationEmitter"] = this.reservationEmitter ? this.reservationEmitter.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTripReservationDocDataResponse extends IOkApiResponse {
    prenotazioni?: TripReservation[];
    reservationEmitter?: InvoiceEmitter | null;
}

export class TripReservation implements ITripReservation {
    offertaID?: number;
    isNozze?: boolean;
    contattoID?: number;
    accordo?: string;
    elencoAbbinamenti?: TripReservationAbbinamento[];
    elencoVoli?: TripReservationFlight[];
    hotelsInformation?: TripReservationHotel[];

    constructor(data?: ITripReservation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.isNozze = _data["isNozze"] !== undefined ? _data["isNozze"] : null as any;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.accordo = _data["accordo"] !== undefined ? _data["accordo"] : null as any;
            if (Array.isArray(_data["elencoAbbinamenti"])) {
                this.elencoAbbinamenti = [] as any;
                for (let item of _data["elencoAbbinamenti"])
                    this.elencoAbbinamenti!.push(TripReservationAbbinamento.fromJS(item));
            }
            else {
                this.elencoAbbinamenti = null as any;
            }
            if (Array.isArray(_data["elencoVoli"])) {
                this.elencoVoli = [] as any;
                for (let item of _data["elencoVoli"])
                    this.elencoVoli!.push(TripReservationFlight.fromJS(item));
            }
            else {
                this.elencoVoli = null as any;
            }
            if (Array.isArray(_data["hotelsInformation"])) {
                this.hotelsInformation = [] as any;
                for (let item of _data["hotelsInformation"])
                    this.hotelsInformation!.push(TripReservationHotel.fromJS(item));
            }
            else {
                this.hotelsInformation = null as any;
            }
        }
    }

    static fromJS(data: any): TripReservation {
        data = typeof data === 'object' ? data : {};
        let result = new TripReservation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["isNozze"] = this.isNozze !== undefined ? this.isNozze : null as any;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["accordo"] = this.accordo !== undefined ? this.accordo : null as any;
        if (Array.isArray(this.elencoAbbinamenti)) {
            data["elencoAbbinamenti"] = [];
            for (let item of this.elencoAbbinamenti)
                data["elencoAbbinamenti"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.elencoVoli)) {
            data["elencoVoli"] = [];
            for (let item of this.elencoVoli)
                data["elencoVoli"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.hotelsInformation)) {
            data["hotelsInformation"] = [];
            for (let item of this.hotelsInformation)
                data["hotelsInformation"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ITripReservation {
    offertaID?: number;
    isNozze?: boolean;
    contattoID?: number;
    accordo?: string;
    elencoAbbinamenti?: TripReservationAbbinamento[];
    elencoVoli?: TripReservationFlight[];
    hotelsInformation?: TripReservationHotel[];
}

export class TripReservationAbbinamento implements ITripReservationAbbinamento {
    nome?: string;
    pax?: TripReservationPax[];
    clienti?: string;
    elencoServizi?: TripReservationService[];
    totale?: TripReservationServiceTotal;

    constructor(data?: ITripReservationAbbinamento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            if (Array.isArray(_data["pax"])) {
                this.pax = [] as any;
                for (let item of _data["pax"])
                    this.pax!.push(TripReservationPax.fromJS(item));
            }
            else {
                this.pax = null as any;
            }
            this.clienti = _data["clienti"] !== undefined ? _data["clienti"] : null as any;
            if (Array.isArray(_data["elencoServizi"])) {
                this.elencoServizi = [] as any;
                for (let item of _data["elencoServizi"])
                    this.elencoServizi!.push(TripReservationService.fromJS(item));
            }
            else {
                this.elencoServizi = null as any;
            }
            this.totale = _data["totale"] ? TripReservationServiceTotal.fromJS(_data["totale"]) : null as any;
        }
    }

    static fromJS(data: any): TripReservationAbbinamento {
        data = typeof data === 'object' ? data : {};
        let result = new TripReservationAbbinamento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        if (Array.isArray(this.pax)) {
            data["pax"] = [];
            for (let item of this.pax)
                data["pax"].push(item ? item.toJSON() : null as any);
        }
        data["clienti"] = this.clienti !== undefined ? this.clienti : null as any;
        if (Array.isArray(this.elencoServizi)) {
            data["elencoServizi"] = [];
            for (let item of this.elencoServizi)
                data["elencoServizi"].push(item ? item.toJSON() : null as any);
        }
        data["totale"] = this.totale ? this.totale.toJSON() : null as any;
        return data;
    }
}

export interface ITripReservationAbbinamento {
    nome?: string;
    pax?: TripReservationPax[];
    clienti?: string;
    elencoServizi?: TripReservationService[];
    totale?: TripReservationServiceTotal;
}

export class TripReservationPax implements ITripReservationPax {
    nome?: string;
    cognome?: string;
    titolo?: ETitolo;
    dataDiNascita?: string | null;
    isChild?: boolean;

    constructor(data?: ITripReservationPax) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : null as any;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            this.dataDiNascita = _data["dataDiNascita"] !== undefined ? _data["dataDiNascita"] : null as any;
            this.isChild = _data["isChild"] !== undefined ? _data["isChild"] : null as any;
        }
    }

    static fromJS(data: any): TripReservationPax {
        data = typeof data === 'object' ? data : {};
        let result = new TripReservationPax();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["cognome"] = this.cognome !== undefined ? this.cognome : null as any;
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        data["dataDiNascita"] = this.dataDiNascita !== undefined ? this.dataDiNascita : null as any;
        data["isChild"] = this.isChild !== undefined ? this.isChild : null as any;
        return data;
    }
}

export interface ITripReservationPax {
    nome?: string;
    cognome?: string;
    titolo?: ETitolo;
    dataDiNascita?: string | null;
    isChild?: boolean;
}

export class TripReservationService implements ITripReservationService {
    numeroPrenotazione?: string | null;
    stato?: string | null;
    tipoServizio?: string | null;
    nomeServizio?: string | null;
    luogo?: string | null;
    data?: string | null;
    dataDal?: string | null;
    dataAl?: string | null;
    notti?: number;
    sistemazione?: string | null;
    tipologia?: string | null;
    tipologiaAddData?: string | null;
    trattamento?: string | null;
    totalePrenotazione?: TripReservationServiceTotal | null;
    note?: string | null;
    statusFlag?: number;

    constructor(data?: ITripReservationService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroPrenotazione = _data["numeroPrenotazione"] !== undefined ? _data["numeroPrenotazione"] : null as any;
            this.stato = _data["stato"] !== undefined ? _data["stato"] : null as any;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
            this.nomeServizio = _data["nomeServizio"] !== undefined ? _data["nomeServizio"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
            this.dataDal = _data["dataDal"] !== undefined ? _data["dataDal"] : null as any;
            this.dataAl = _data["dataAl"] !== undefined ? _data["dataAl"] : null as any;
            this.notti = _data["notti"] !== undefined ? _data["notti"] : null as any;
            this.sistemazione = _data["sistemazione"] !== undefined ? _data["sistemazione"] : null as any;
            this.tipologia = _data["tipologia"] !== undefined ? _data["tipologia"] : null as any;
            this.tipologiaAddData = _data["tipologiaAddData"] !== undefined ? _data["tipologiaAddData"] : null as any;
            this.trattamento = _data["trattamento"] !== undefined ? _data["trattamento"] : null as any;
            this.totalePrenotazione = _data["totalePrenotazione"] ? TripReservationServiceTotal.fromJS(_data["totalePrenotazione"]) : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.statusFlag = _data["statusFlag"] !== undefined ? _data["statusFlag"] : null as any;
        }
    }

    static fromJS(data: any): TripReservationService {
        data = typeof data === 'object' ? data : {};
        let result = new TripReservationService();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroPrenotazione"] = this.numeroPrenotazione !== undefined ? this.numeroPrenotazione : null as any;
        data["stato"] = this.stato !== undefined ? this.stato : null as any;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        data["nomeServizio"] = this.nomeServizio !== undefined ? this.nomeServizio : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["dataDal"] = this.dataDal !== undefined ? this.dataDal : null as any;
        data["dataAl"] = this.dataAl !== undefined ? this.dataAl : null as any;
        data["notti"] = this.notti !== undefined ? this.notti : null as any;
        data["sistemazione"] = this.sistemazione !== undefined ? this.sistemazione : null as any;
        data["tipologia"] = this.tipologia !== undefined ? this.tipologia : null as any;
        data["tipologiaAddData"] = this.tipologiaAddData !== undefined ? this.tipologiaAddData : null as any;
        data["trattamento"] = this.trattamento !== undefined ? this.trattamento : null as any;
        data["totalePrenotazione"] = this.totalePrenotazione ? this.totalePrenotazione.toJSON() : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["statusFlag"] = this.statusFlag !== undefined ? this.statusFlag : null as any;
        return data;
    }
}

export interface ITripReservationService {
    numeroPrenotazione?: string | null;
    stato?: string | null;
    tipoServizio?: string | null;
    nomeServizio?: string | null;
    luogo?: string | null;
    data?: string | null;
    dataDal?: string | null;
    dataAl?: string | null;
    notti?: number;
    sistemazione?: string | null;
    tipologia?: string | null;
    tipologiaAddData?: string | null;
    trattamento?: string | null;
    totalePrenotazione?: TripReservationServiceTotal | null;
    note?: string | null;
    statusFlag?: number;
}

export class TripReservationServiceTotal implements ITripReservationServiceTotal {
    valuta?: string | null;
    totale?: number;

    constructor(data?: ITripReservationServiceTotal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valuta = _data["valuta"] !== undefined ? _data["valuta"] : null as any;
            this.totale = _data["totale"] !== undefined ? _data["totale"] : null as any;
        }
    }

    static fromJS(data: any): TripReservationServiceTotal {
        data = typeof data === 'object' ? data : {};
        let result = new TripReservationServiceTotal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valuta"] = this.valuta !== undefined ? this.valuta : null as any;
        data["totale"] = this.totale !== undefined ? this.totale : null as any;
        return data;
    }
}

export interface ITripReservationServiceTotal {
    valuta?: string | null;
    totale?: number;
}

export class TripReservationFlight implements ITripReservationFlight {
    abbinamento?: string;
    pnr?: string;
    elencoTratte?: TripReservationFlightRoute[];
    elencoCompagnie?: TripReservationFlightCompany[];

    constructor(data?: ITripReservationFlight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.abbinamento = _data["abbinamento"] !== undefined ? _data["abbinamento"] : null as any;
            this.pnr = _data["pnr"] !== undefined ? _data["pnr"] : null as any;
            if (Array.isArray(_data["elencoTratte"])) {
                this.elencoTratte = [] as any;
                for (let item of _data["elencoTratte"])
                    this.elencoTratte!.push(TripReservationFlightRoute.fromJS(item));
            }
            else {
                this.elencoTratte = null as any;
            }
            if (Array.isArray(_data["elencoCompagnie"])) {
                this.elencoCompagnie = [] as any;
                for (let item of _data["elencoCompagnie"])
                    this.elencoCompagnie!.push(TripReservationFlightCompany.fromJS(item));
            }
            else {
                this.elencoCompagnie = null as any;
            }
        }
    }

    static fromJS(data: any): TripReservationFlight {
        data = typeof data === 'object' ? data : {};
        let result = new TripReservationFlight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["abbinamento"] = this.abbinamento !== undefined ? this.abbinamento : null as any;
        data["pnr"] = this.pnr !== undefined ? this.pnr : null as any;
        if (Array.isArray(this.elencoTratte)) {
            data["elencoTratte"] = [];
            for (let item of this.elencoTratte)
                data["elencoTratte"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.elencoCompagnie)) {
            data["elencoCompagnie"] = [];
            for (let item of this.elencoCompagnie)
                data["elencoCompagnie"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ITripReservationFlight {
    abbinamento?: string;
    pnr?: string;
    elencoTratte?: TripReservationFlightRoute[];
    elencoCompagnie?: TripReservationFlightCompany[];
}

export class TripReservationFlightRoute implements ITripReservationFlightRoute {
    codiceCompagnia?: string | null;
    numeroVolo?: string | null;
    partenza?: string | null;
    daAeroporto?: string | null;
    daNomeItaliano?: string | null;
    status?: string | null;
    arrivoIlGiornoDopo?: boolean;
    arrivo?: string | null;
    adAeroporto?: string | null;
    aaNomeItaliano?: string | null;

    constructor(data?: ITripReservationFlightRoute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codiceCompagnia = _data["codiceCompagnia"] !== undefined ? _data["codiceCompagnia"] : null as any;
            this.numeroVolo = _data["numeroVolo"] !== undefined ? _data["numeroVolo"] : null as any;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : null as any;
            this.daAeroporto = _data["daAeroporto"] !== undefined ? _data["daAeroporto"] : null as any;
            this.daNomeItaliano = _data["daNomeItaliano"] !== undefined ? _data["daNomeItaliano"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.arrivoIlGiornoDopo = _data["arrivoIlGiornoDopo"] !== undefined ? _data["arrivoIlGiornoDopo"] : null as any;
            this.arrivo = _data["arrivo"] !== undefined ? _data["arrivo"] : null as any;
            this.adAeroporto = _data["adAeroporto"] !== undefined ? _data["adAeroporto"] : null as any;
            this.aaNomeItaliano = _data["aaNomeItaliano"] !== undefined ? _data["aaNomeItaliano"] : null as any;
        }
    }

    static fromJS(data: any): TripReservationFlightRoute {
        data = typeof data === 'object' ? data : {};
        let result = new TripReservationFlightRoute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codiceCompagnia"] = this.codiceCompagnia !== undefined ? this.codiceCompagnia : null as any;
        data["numeroVolo"] = this.numeroVolo !== undefined ? this.numeroVolo : null as any;
        data["partenza"] = this.partenza !== undefined ? this.partenza : null as any;
        data["daAeroporto"] = this.daAeroporto !== undefined ? this.daAeroporto : null as any;
        data["daNomeItaliano"] = this.daNomeItaliano !== undefined ? this.daNomeItaliano : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["arrivoIlGiornoDopo"] = this.arrivoIlGiornoDopo !== undefined ? this.arrivoIlGiornoDopo : null as any;
        data["arrivo"] = this.arrivo !== undefined ? this.arrivo : null as any;
        data["adAeroporto"] = this.adAeroporto !== undefined ? this.adAeroporto : null as any;
        data["aaNomeItaliano"] = this.aaNomeItaliano !== undefined ? this.aaNomeItaliano : null as any;
        return data;
    }
}

export interface ITripReservationFlightRoute {
    codiceCompagnia?: string | null;
    numeroVolo?: string | null;
    partenza?: string | null;
    daAeroporto?: string | null;
    daNomeItaliano?: string | null;
    status?: string | null;
    arrivoIlGiornoDopo?: boolean;
    arrivo?: string | null;
    adAeroporto?: string | null;
    aaNomeItaliano?: string | null;
}

export class TripReservationFlightCompany implements ITripReservationFlightCompany {
    codice?: string;
    nome?: string;

    constructor(data?: ITripReservationFlightCompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
        }
    }

    static fromJS(data: any): TripReservationFlightCompany {
        data = typeof data === 'object' ? data : {};
        let result = new TripReservationFlightCompany();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        return data;
    }
}

export interface ITripReservationFlightCompany {
    codice?: string;
    nome?: string;
}

export class TripReservationHotel implements ITripReservationHotel {
    nome?: string | null;
    luogo?: string | null;
    indirizzo?: string | null;
    telefono?: string | null;
    fax?: string | null;
    reservations?: TripReservationHotelReservationInformation[];

    constructor(data?: ITripReservationHotel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : null as any;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : null as any;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : null as any;
            if (Array.isArray(_data["reservations"])) {
                this.reservations = [] as any;
                for (let item of _data["reservations"])
                    this.reservations!.push(TripReservationHotelReservationInformation.fromJS(item));
            }
            else {
                this.reservations = null as any;
            }
        }
    }

    static fromJS(data: any): TripReservationHotel {
        data = typeof data === 'object' ? data : {};
        let result = new TripReservationHotel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : null as any;
        data["telefono"] = this.telefono !== undefined ? this.telefono : null as any;
        data["fax"] = this.fax !== undefined ? this.fax : null as any;
        if (Array.isArray(this.reservations)) {
            data["reservations"] = [];
            for (let item of this.reservations)
                data["reservations"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ITripReservationHotel {
    nome?: string | null;
    luogo?: string | null;
    indirizzo?: string | null;
    telefono?: string | null;
    fax?: string | null;
    reservations?: TripReservationHotelReservationInformation[];
}

export class TripReservationHotelReservationInformation implements ITripReservationHotelReservationInformation {
    dataDa?: string;
    dataA?: string;
    notti?: number;

    constructor(data?: ITripReservationHotelReservationInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataDa = _data["dataDa"] !== undefined ? _data["dataDa"] : null as any;
            this.dataA = _data["dataA"] !== undefined ? _data["dataA"] : null as any;
            this.notti = _data["notti"] !== undefined ? _data["notti"] : null as any;
        }
    }

    static fromJS(data: any): TripReservationHotelReservationInformation {
        data = typeof data === 'object' ? data : {};
        let result = new TripReservationHotelReservationInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataDa"] = this.dataDa !== undefined ? this.dataDa : null as any;
        data["dataA"] = this.dataA !== undefined ? this.dataA : null as any;
        data["notti"] = this.notti !== undefined ? this.notti : null as any;
        return data;
    }
}

export interface ITripReservationHotelReservationInformation {
    dataDa?: string;
    dataA?: string;
    notti?: number;
}

export class GetTripReservationDocDataRequest extends LocalizedRequest implements IGetTripReservationDocDataRequest {
    offertaID!: number;
    /** Underscore separated string: "contactID_currencyID" */
    contactAndCurrency!: string[];

    constructor(data?: IGetTripReservationDocDataRequest) {
        super(data);
        if (!data) {
            this.contactAndCurrency = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            if (Array.isArray(_data["contactAndCurrency"])) {
                this.contactAndCurrency = [] as any;
                for (let item of _data["contactAndCurrency"])
                    this.contactAndCurrency!.push(item);
            }
            else {
                this.contactAndCurrency = null as any;
            }
        }
    }

    static override fromJS(data: any): GetTripReservationDocDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripReservationDocDataRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        if (Array.isArray(this.contactAndCurrency)) {
            data["contactAndCurrency"] = [];
            for (let item of this.contactAndCurrency)
                data["contactAndCurrency"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetTripReservationDocDataRequest extends ILocalizedRequest {
    offertaID: number;
    /** Underscore separated string: "contactID_currencyID" */
    contactAndCurrency: string[];
}

export class GetTripVoucherDataResponse extends OkApiResponse implements IGetTripVoucherDataResponse {
    /** Elenco dei voucher selezionati passato attraverso il campo ExtraDocs */
    selectedVoucher?: number[];
    elencoVouchers?: VoucherRaw[];
    voucherEmitter?: InvoiceEmitter;

    constructor(data?: IGetTripVoucherDataResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["selectedVoucher"])) {
                this.selectedVoucher = [] as any;
                for (let item of _data["selectedVoucher"])
                    this.selectedVoucher!.push(item);
            }
            else {
                this.selectedVoucher = null as any;
            }
            if (Array.isArray(_data["elencoVouchers"])) {
                this.elencoVouchers = [] as any;
                for (let item of _data["elencoVouchers"])
                    this.elencoVouchers!.push(VoucherRaw.fromJS(item));
            }
            else {
                this.elencoVouchers = null as any;
            }
            this.voucherEmitter = _data["voucherEmitter"] ? InvoiceEmitter.fromJS(_data["voucherEmitter"]) : null as any;
        }
    }

    static override fromJS(data: any): GetTripVoucherDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripVoucherDataResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectedVoucher)) {
            data["selectedVoucher"] = [];
            for (let item of this.selectedVoucher)
                data["selectedVoucher"].push(item);
        }
        if (Array.isArray(this.elencoVouchers)) {
            data["elencoVouchers"] = [];
            for (let item of this.elencoVouchers)
                data["elencoVouchers"].push(item ? item.toJSON() : null as any);
        }
        data["voucherEmitter"] = this.voucherEmitter ? this.voucherEmitter.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTripVoucherDataResponse extends IOkApiResponse {
    /** Elenco dei voucher selezionati passato attraverso il campo ExtraDocs */
    selectedVoucher?: number[];
    elencoVouchers?: VoucherRaw[];
    voucherEmitter?: InvoiceEmitter;
}

export class VoucherRaw implements IVoucherRaw {
    dataVoucher?: TripVoucher;

    constructor(data?: IVoucherRaw) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataVoucher = _data["dataVoucher"] ? TripVoucher.fromJS(_data["dataVoucher"]) : null as any;
        }
    }

    static fromJS(data: any): VoucherRaw {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherRaw();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataVoucher"] = this.dataVoucher ? this.dataVoucher.toJSON() : null as any;
        return data;
    }
}

export interface IVoucherRaw {
    dataVoucher?: TripVoucher;
}

export class GetTripVoucherDataRequest extends SiteRequest implements IGetTripVoucherDataRequest {
    offertaID?: number;
    maxNumOfVouchersPerPage?: number;
    /** Stringa con le tuple [id_ordine] separate da virgola dei voucher da usare nel documento */
    extraDocs?: string;
    preview?: boolean;

    constructor(data?: IGetTripVoucherDataRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.maxNumOfVouchersPerPage = _data["maxNumOfVouchersPerPage"] !== undefined ? _data["maxNumOfVouchersPerPage"] : null as any;
            this.extraDocs = _data["extraDocs"] !== undefined ? _data["extraDocs"] : null as any;
            this.preview = _data["preview"] !== undefined ? _data["preview"] : null as any;
        }
    }

    static override fromJS(data: any): GetTripVoucherDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripVoucherDataRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["maxNumOfVouchersPerPage"] = this.maxNumOfVouchersPerPage !== undefined ? this.maxNumOfVouchersPerPage : null as any;
        data["extraDocs"] = this.extraDocs !== undefined ? this.extraDocs : null as any;
        data["preview"] = this.preview !== undefined ? this.preview : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTripVoucherDataRequest extends ISiteRequest {
    offertaID?: number;
    maxNumOfVouchersPerPage?: number;
    /** Stringa con le tuple [id_ordine] separate da virgola dei voucher da usare nel documento */
    extraDocs?: string;
    preview?: boolean;
}

export class GetMaintenanceResponse extends OkApiResponse implements IGetMaintenanceResponse {
    maintenance?: Maintenance | null;

    constructor(data?: IGetMaintenanceResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.maintenance = _data["maintenance"] ? Maintenance.fromJS(_data["maintenance"]) : null as any;
        }
    }

    static override fromJS(data: any): GetMaintenanceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMaintenanceResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maintenance"] = this.maintenance ? this.maintenance.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetMaintenanceResponse extends IOkApiResponse {
    maintenance?: Maintenance | null;
}

export class Maintenance implements IMaintenance {
    id?: number;
    start!: string;
    ending?: string | null;

    constructor(data?: IMaintenance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.start = _data["start"] !== undefined ? _data["start"] : null as any;
            this.ending = _data["ending"] !== undefined ? _data["ending"] : null as any;
        }
    }

    static fromJS(data: any): Maintenance {
        data = typeof data === 'object' ? data : {};
        let result = new Maintenance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["start"] = this.start !== undefined ? this.start : null as any;
        data["ending"] = this.ending !== undefined ? this.ending : null as any;
        return data;
    }
}

export interface IMaintenance {
    id?: number;
    start: string;
    ending?: string | null;
}

export class SetMaintenanceRequest extends ApiRequest implements ISetMaintenanceRequest {
    start?: string;

    constructor(data?: ISetMaintenanceRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.start = _data["start"] !== undefined ? _data["start"] : null as any;
        }
    }

    static override fromJS(data: any): SetMaintenanceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetMaintenanceRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start !== undefined ? this.start : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISetMaintenanceRequest extends IApiRequest {
    start?: string;
}

export class GetNearbyPlacesResponse extends OkApiResponse implements IGetNearbyPlacesResponse {
    luoghiVicini?: LuogoVicino[] | null;

    constructor(data?: IGetNearbyPlacesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["luoghiVicini"])) {
                this.luoghiVicini = [] as any;
                for (let item of _data["luoghiVicini"])
                    this.luoghiVicini!.push(LuogoVicino.fromJS(item));
            }
            else {
                this.luoghiVicini = null as any;
            }
        }
    }

    static override fromJS(data: any): GetNearbyPlacesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetNearbyPlacesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.luoghiVicini)) {
            data["luoghiVicini"] = [];
            for (let item of this.luoghiVicini)
                data["luoghiVicini"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetNearbyPlacesResponse extends IOkApiResponse {
    luoghiVicini?: LuogoVicino[] | null;
}

export class LuogoVicino implements ILuogoVicino {
    id?: number;
    nome?: string | null;
    latitudine?: number;
    longitudine?: number;
    distanzaKm?: number;
    tempoPercorrenza?: number | null;
    consentePernottamento?: boolean;
    distanzaReale?: boolean;

    constructor(data?: ILuogoVicino) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.latitudine = _data["latitudine"] !== undefined ? _data["latitudine"] : null as any;
            this.longitudine = _data["longitudine"] !== undefined ? _data["longitudine"] : null as any;
            this.distanzaKm = _data["distanzaKm"] !== undefined ? _data["distanzaKm"] : null as any;
            this.tempoPercorrenza = _data["tempoPercorrenza"] !== undefined ? _data["tempoPercorrenza"] : null as any;
            this.consentePernottamento = _data["consentePernottamento"] !== undefined ? _data["consentePernottamento"] : null as any;
            this.distanzaReale = _data["distanzaReale"] !== undefined ? _data["distanzaReale"] : null as any;
        }
    }

    static fromJS(data: any): LuogoVicino {
        data = typeof data === 'object' ? data : {};
        let result = new LuogoVicino();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["latitudine"] = this.latitudine !== undefined ? this.latitudine : null as any;
        data["longitudine"] = this.longitudine !== undefined ? this.longitudine : null as any;
        data["distanzaKm"] = this.distanzaKm !== undefined ? this.distanzaKm : null as any;
        data["tempoPercorrenza"] = this.tempoPercorrenza !== undefined ? this.tempoPercorrenza : null as any;
        data["consentePernottamento"] = this.consentePernottamento !== undefined ? this.consentePernottamento : null as any;
        data["distanzaReale"] = this.distanzaReale !== undefined ? this.distanzaReale : null as any;
        return data;
    }
}

export interface ILuogoVicino {
    id?: number;
    nome?: string | null;
    latitudine?: number;
    longitudine?: number;
    distanzaKm?: number;
    tempoPercorrenza?: number | null;
    consentePernottamento?: boolean;
    distanzaReale?: boolean;
}

export class GetNearbyPlacesRequest extends SiteRequest implements IGetNearbyPlacesRequest {
    luogoID?: number;
    maxDistanzaKm?: number;

    constructor(data?: IGetNearbyPlacesRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.maxDistanzaKm = _data["maxDistanzaKm"] !== undefined ? _data["maxDistanzaKm"] : null as any;
        }
    }

    static override fromJS(data: any): GetNearbyPlacesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetNearbyPlacesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["maxDistanzaKm"] = this.maxDistanzaKm !== undefined ? this.maxDistanzaKm : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetNearbyPlacesRequest extends ISiteRequest {
    luogoID?: number;
    maxDistanzaKm?: number;
}

export class GetPlannerMapResponse extends OkApiResponse implements IGetPlannerMapResponse {
    punti?: MapPinPoint[] | null;
    flightPaths?: MapPath[] | null;
    carPaths?: MapPath[] | null;
    carDirections?: CarPath[] | null;
    trainPaths?: MapPath[] | null;
    trainDirections?: TrainPath[] | null;
    otherPaths?: MapPath[] | null;

    constructor(data?: IGetPlannerMapResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["punti"])) {
                this.punti = [] as any;
                for (let item of _data["punti"])
                    this.punti!.push(MapPinPoint.fromJS(item));
            }
            else {
                this.punti = null as any;
            }
            if (Array.isArray(_data["flightPaths"])) {
                this.flightPaths = [] as any;
                for (let item of _data["flightPaths"])
                    this.flightPaths!.push(MapPath.fromJS(item));
            }
            else {
                this.flightPaths = null as any;
            }
            if (Array.isArray(_data["carPaths"])) {
                this.carPaths = [] as any;
                for (let item of _data["carPaths"])
                    this.carPaths!.push(MapPath.fromJS(item));
            }
            else {
                this.carPaths = null as any;
            }
            if (Array.isArray(_data["carDirections"])) {
                this.carDirections = [] as any;
                for (let item of _data["carDirections"])
                    this.carDirections!.push(CarPath.fromJS(item));
            }
            else {
                this.carDirections = null as any;
            }
            if (Array.isArray(_data["trainPaths"])) {
                this.trainPaths = [] as any;
                for (let item of _data["trainPaths"])
                    this.trainPaths!.push(MapPath.fromJS(item));
            }
            else {
                this.trainPaths = null as any;
            }
            if (Array.isArray(_data["trainDirections"])) {
                this.trainDirections = [] as any;
                for (let item of _data["trainDirections"])
                    this.trainDirections!.push(TrainPath.fromJS(item));
            }
            else {
                this.trainDirections = null as any;
            }
            if (Array.isArray(_data["otherPaths"])) {
                this.otherPaths = [] as any;
                for (let item of _data["otherPaths"])
                    this.otherPaths!.push(MapPath.fromJS(item));
            }
            else {
                this.otherPaths = null as any;
            }
        }
    }

    static override fromJS(data: any): GetPlannerMapResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlannerMapResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.punti)) {
            data["punti"] = [];
            for (let item of this.punti)
                data["punti"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.flightPaths)) {
            data["flightPaths"] = [];
            for (let item of this.flightPaths)
                data["flightPaths"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.carPaths)) {
            data["carPaths"] = [];
            for (let item of this.carPaths)
                data["carPaths"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.carDirections)) {
            data["carDirections"] = [];
            for (let item of this.carDirections)
                data["carDirections"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.trainPaths)) {
            data["trainPaths"] = [];
            for (let item of this.trainPaths)
                data["trainPaths"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.trainDirections)) {
            data["trainDirections"] = [];
            for (let item of this.trainDirections)
                data["trainDirections"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.otherPaths)) {
            data["otherPaths"] = [];
            for (let item of this.otherPaths)
                data["otherPaths"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPlannerMapResponse extends IOkApiResponse {
    punti?: MapPinPoint[] | null;
    flightPaths?: MapPath[] | null;
    carPaths?: MapPath[] | null;
    carDirections?: CarPath[] | null;
    trainPaths?: MapPath[] | null;
    trainDirections?: TrainPath[] | null;
    otherPaths?: MapPath[] | null;
}

export class MapPinPoint implements IMapPinPoint {
    tipoTappa?: ETipoTappa;
    tipoTrasporto?: ETipoTrasporto;
    latitudine?: number;
    longitudine?: number;
    nome?: string | null;
    luogoID?: number;
    itinerarioId?: number;

    constructor(data?: IMapPinPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoTappa = _data["tipoTappa"] !== undefined ? _data["tipoTappa"] : null as any;
            this.tipoTrasporto = _data["tipoTrasporto"] !== undefined ? _data["tipoTrasporto"] : null as any;
            this.latitudine = _data["latitudine"] !== undefined ? _data["latitudine"] : null as any;
            this.longitudine = _data["longitudine"] !== undefined ? _data["longitudine"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.itinerarioId = _data["itinerarioId"] !== undefined ? _data["itinerarioId"] : null as any;
        }
    }

    static fromJS(data: any): MapPinPoint {
        data = typeof data === 'object' ? data : {};
        let result = new MapPinPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoTappa"] = this.tipoTappa !== undefined ? this.tipoTappa : null as any;
        data["tipoTrasporto"] = this.tipoTrasporto !== undefined ? this.tipoTrasporto : null as any;
        data["latitudine"] = this.latitudine !== undefined ? this.latitudine : null as any;
        data["longitudine"] = this.longitudine !== undefined ? this.longitudine : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["itinerarioId"] = this.itinerarioId !== undefined ? this.itinerarioId : null as any;
        return data;
    }
}

export interface IMapPinPoint {
    tipoTappa?: ETipoTappa;
    tipoTrasporto?: ETipoTrasporto;
    latitudine?: number;
    longitudine?: number;
    nome?: string | null;
    luogoID?: number;
    itinerarioId?: number;
}

export class MapPath implements IMapPath {
    punti?: MapPinPoint[] | null;

    constructor(data?: IMapPath) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["punti"])) {
                this.punti = [] as any;
                for (let item of _data["punti"])
                    this.punti!.push(MapPinPoint.fromJS(item));
            }
            else {
                this.punti = null as any;
            }
        }
    }

    static fromJS(data: any): MapPath {
        data = typeof data === 'object' ? data : {};
        let result = new MapPath();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.punti)) {
            data["punti"] = [];
            for (let item of this.punti)
                data["punti"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IMapPath {
    punti?: MapPinPoint[] | null;
}

export class CarPath implements ICarPath {
    origin?: GMapPoint | null;
    destination?: GMapPoint | null;
    waypoints?: GMapWayPoint[] | null;

    constructor(data?: ICarPath) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.origin = _data["origin"] ? GMapPoint.fromJS(_data["origin"]) : null as any;
            this.destination = _data["destination"] ? GMapPoint.fromJS(_data["destination"]) : null as any;
            if (Array.isArray(_data["waypoints"])) {
                this.waypoints = [] as any;
                for (let item of _data["waypoints"])
                    this.waypoints!.push(GMapWayPoint.fromJS(item));
            }
            else {
                this.waypoints = null as any;
            }
        }
    }

    static fromJS(data: any): CarPath {
        data = typeof data === 'object' ? data : {};
        let result = new CarPath();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["origin"] = this.origin ? this.origin.toJSON() : null as any;
        data["destination"] = this.destination ? this.destination.toJSON() : null as any;
        if (Array.isArray(this.waypoints)) {
            data["waypoints"] = [];
            for (let item of this.waypoints)
                data["waypoints"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ICarPath {
    origin?: GMapPoint | null;
    destination?: GMapPoint | null;
    waypoints?: GMapWayPoint[] | null;
}

export class GMapPoint implements IGMapPoint {
    lat?: number;
    lng?: number;
    name?: string | null;

    constructor(data?: IGMapPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lat = _data["lat"] !== undefined ? _data["lat"] : null as any;
            this.lng = _data["lng"] !== undefined ? _data["lng"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): GMapPoint {
        data = typeof data === 'object' ? data : {};
        let result = new GMapPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lat"] = this.lat !== undefined ? this.lat : null as any;
        data["lng"] = this.lng !== undefined ? this.lng : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export interface IGMapPoint {
    lat?: number;
    lng?: number;
    name?: string | null;
}

export class GMapWayPoint implements IGMapWayPoint {
    location?: GMapPoint | null;
    stopover?: boolean;

    constructor(data?: IGMapWayPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"] ? GMapPoint.fromJS(_data["location"]) : null as any;
            this.stopover = _data["stopover"] !== undefined ? _data["stopover"] : null as any;
        }
    }

    static fromJS(data: any): GMapWayPoint {
        data = typeof data === 'object' ? data : {};
        let result = new GMapWayPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location ? this.location.toJSON() : null as any;
        data["stopover"] = this.stopover !== undefined ? this.stopover : null as any;
        return data;
    }
}

export interface IGMapWayPoint {
    location?: GMapPoint | null;
    stopover?: boolean;
}

export class TrainPath implements ITrainPath {
    origin?: GMapPoint | null;
    destination?: GMapPoint | null;

    constructor(data?: ITrainPath) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.origin = _data["origin"] ? GMapPoint.fromJS(_data["origin"]) : null as any;
            this.destination = _data["destination"] ? GMapPoint.fromJS(_data["destination"]) : null as any;
        }
    }

    static fromJS(data: any): TrainPath {
        data = typeof data === 'object' ? data : {};
        let result = new TrainPath();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["origin"] = this.origin ? this.origin.toJSON() : null as any;
        data["destination"] = this.destination ? this.destination.toJSON() : null as any;
        return data;
    }
}

export interface ITrainPath {
    origin?: GMapPoint | null;
    destination?: GMapPoint | null;
}

export class GetPlannerMapRequest extends SiteRequest implements IGetPlannerMapRequest {
    itinerario?: OffertaItinerario[] | null;

    constructor(data?: IGetPlannerMapRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["itinerario"])) {
                this.itinerario = [] as any;
                for (let item of _data["itinerario"])
                    this.itinerario!.push(OffertaItinerario.fromJS(item));
            }
            else {
                this.itinerario = null as any;
            }
        }
    }

    static override fromJS(data: any): GetPlannerMapRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlannerMapRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.itinerario)) {
            data["itinerario"] = [];
            for (let item of this.itinerario)
                data["itinerario"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPlannerMapRequest extends ISiteRequest {
    itinerario?: OffertaItinerario[] | null;
}

export class MarginGetRequest extends LocalizedRequest implements IMarginGetRequest {
    /** ID dell'entità da recuperare */
    id?: number;

    constructor(data?: IMarginGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): MarginGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarginGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IMarginGetRequest extends ILocalizedRequest {
    /** ID dell'entità da recuperare */
    id?: number;
}

export class MarginGetResponse extends OkApiResponse implements IMarginGetResponse {
    /** Entità letta */
    servizioMargine?: ServizioMargine;

    constructor(data?: IMarginGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioMargine = _data["servizioMargine"] ? ServizioMargine.fromJS(_data["servizioMargine"]) : null as any;
        }
    }

    static override fromJS(data: any): MarginGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MarginGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioMargine"] = this.servizioMargine ? this.servizioMargine.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IMarginGetResponse extends IOkApiResponse {
    /** Entità letta */
    servizioMargine?: ServizioMargine;
}

export class ServizioMargine implements IServizioMargine {
    id?: number;
    dal?: string | null;
    al?: string | null;
    servizioDal?: string | null;
    servizioAl?: string | null;
    accordoID?: number | null;
    luogoID?: number | null;
    servizioID?: number | null;
    tipoServizio?: ETipoServizio | null;
    deltaMarkup?: number;
    proporzionale?: boolean;
    ordine?: number;
    note?: string | null;

    constructor(data?: IServizioMargine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.al = _data["al"] !== undefined ? _data["al"] : null as any;
            this.servizioDal = _data["servizioDal"] !== undefined ? _data["servizioDal"] : null as any;
            this.servizioAl = _data["servizioAl"] !== undefined ? _data["servizioAl"] : null as any;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
            this.deltaMarkup = _data["deltaMarkup"] !== undefined ? _data["deltaMarkup"] : null as any;
            this.proporzionale = _data["proporzionale"] !== undefined ? _data["proporzionale"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
        }
    }

    static fromJS(data: any): ServizioMargine {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioMargine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["al"] = this.al !== undefined ? this.al : null as any;
        data["servizioDal"] = this.servizioDal !== undefined ? this.servizioDal : null as any;
        data["servizioAl"] = this.servizioAl !== undefined ? this.servizioAl : null as any;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        data["deltaMarkup"] = this.deltaMarkup !== undefined ? this.deltaMarkup : null as any;
        data["proporzionale"] = this.proporzionale !== undefined ? this.proporzionale : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        return data;
    }
}

export interface IServizioMargine {
    id?: number;
    dal?: string | null;
    al?: string | null;
    servizioDal?: string | null;
    servizioAl?: string | null;
    accordoID?: number | null;
    luogoID?: number | null;
    servizioID?: number | null;
    tipoServizio?: ETipoServizio | null;
    deltaMarkup?: number;
    proporzionale?: boolean;
    ordine?: number;
    note?: string | null;
}

export class NrTableResponseOfMarginRow extends OkApiResponse implements INrTableResponseOfMarginRow {
    /** Array delle righe della pagina richiesta */
    rows?: MarginRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfMarginRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(MarginRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfMarginRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfMarginRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfMarginRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: MarginRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class MarginsList extends NrTableResponseOfMarginRow implements IMarginsList {

    constructor(data?: IMarginsList) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MarginsList {
        data = typeof data === 'object' ? data : {};
        let result = new MarginsList();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMarginsList extends INrTableResponseOfMarginRow {
}

export class MarginRow implements IMarginRow {
    /** ID dell'entità */
    id?: number;
    /** Entità */
    servizioMargine?: ServizioMargine;
    /** Nome in lingua del servizio (se c'è) */
    servizio?: string | null;
    /** True se il servizio è obsoleto */
    servizioObsoleto?: boolean;
    /** True se il servizio è eliminato */
    servizioEliminato?: boolean;
    /** Nome dell'accordo (se c'è) */
    accordo?: string | null;
    /** Nome in lingua del luogo (se c'è) */
    luogo?: string | null;
    luogoEliminato?: boolean;

    constructor(data?: IMarginRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.servizioMargine = _data["servizioMargine"] ? ServizioMargine.fromJS(_data["servizioMargine"]) : null as any;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : null as any;
            this.servizioObsoleto = _data["servizioObsoleto"] !== undefined ? _data["servizioObsoleto"] : null as any;
            this.servizioEliminato = _data["servizioEliminato"] !== undefined ? _data["servizioEliminato"] : null as any;
            this.accordo = _data["accordo"] !== undefined ? _data["accordo"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.luogoEliminato = _data["luogoEliminato"] !== undefined ? _data["luogoEliminato"] : null as any;
        }
    }

    static fromJS(data: any): MarginRow {
        data = typeof data === 'object' ? data : {};
        let result = new MarginRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["servizioMargine"] = this.servizioMargine ? this.servizioMargine.toJSON() : null as any;
        data["servizio"] = this.servizio !== undefined ? this.servizio : null as any;
        data["servizioObsoleto"] = this.servizioObsoleto !== undefined ? this.servizioObsoleto : null as any;
        data["servizioEliminato"] = this.servizioEliminato !== undefined ? this.servizioEliminato : null as any;
        data["accordo"] = this.accordo !== undefined ? this.accordo : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["luogoEliminato"] = this.luogoEliminato !== undefined ? this.luogoEliminato : null as any;
        return data;
    }
}

export interface IMarginRow {
    /** ID dell'entità */
    id?: number;
    /** Entità */
    servizioMargine?: ServizioMargine;
    /** Nome in lingua del servizio (se c'è) */
    servizio?: string | null;
    /** True se il servizio è obsoleto */
    servizioObsoleto?: boolean;
    /** True se il servizio è eliminato */
    servizioEliminato?: boolean;
    /** Nome dell'accordo (se c'è) */
    accordo?: string | null;
    /** Nome in lingua del luogo (se c'è) */
    luogo?: string | null;
    luogoEliminato?: boolean;
}

export class MarginsListRequest extends NrTableRequest implements IMarginsListRequest {
    /** ID o qualcosa che gli somiglia */
    term?: string | null;
    /** Accordo associato */
    accordoID?: number | null;
    /** Solo non associati ad accordo */
    noAccordo?: boolean;
    /** Tipo di servizio associato */
    tipoServizio?: ETipoServizio | null;
    /** Sono non associati a tipo servizio */
    noTipoServizio?: boolean;
    /** Servizio associato */
    servizioID?: number | null;
    /** Solo non associati a servizio */
    noServizio?: boolean;
    /** Luogo associato */
    luogoID?: number | null;
    /** Solo non associati a luogo */
    noLuogo?: boolean;

    constructor(data?: IMarginsListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : null as any;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.noAccordo = _data["noAccordo"] !== undefined ? _data["noAccordo"] : null as any;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
            this.noTipoServizio = _data["noTipoServizio"] !== undefined ? _data["noTipoServizio"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.noServizio = _data["noServizio"] !== undefined ? _data["noServizio"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.noLuogo = _data["noLuogo"] !== undefined ? _data["noLuogo"] : null as any;
        }
    }

    static override fromJS(data: any): MarginsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarginsListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : null as any;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["noAccordo"] = this.noAccordo !== undefined ? this.noAccordo : null as any;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        data["noTipoServizio"] = this.noTipoServizio !== undefined ? this.noTipoServizio : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["noServizio"] = this.noServizio !== undefined ? this.noServizio : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["noLuogo"] = this.noLuogo !== undefined ? this.noLuogo : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IMarginsListRequest extends INrTableRequest {
    /** ID o qualcosa che gli somiglia */
    term?: string | null;
    /** Accordo associato */
    accordoID?: number | null;
    /** Solo non associati ad accordo */
    noAccordo?: boolean;
    /** Tipo di servizio associato */
    tipoServizio?: ETipoServizio | null;
    /** Sono non associati a tipo servizio */
    noTipoServizio?: boolean;
    /** Servizio associato */
    servizioID?: number | null;
    /** Solo non associati a servizio */
    noServizio?: boolean;
    /** Luogo associato */
    luogoID?: number | null;
    /** Solo non associati a luogo */
    noLuogo?: boolean;
}

export class MarginUpsertRequest extends LocalizedRequest implements IMarginUpsertRequest {
    /** Entità da persistere (nuova o modificata) */
    servizioMargine?: ServizioMargineBase;

    constructor(data?: IMarginUpsertRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioMargine = _data["servizioMargine"] ? ServizioMargineBase.fromJS(_data["servizioMargine"]) : null as any;
        }
    }

    static override fromJS(data: any): MarginUpsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarginUpsertRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioMargine"] = this.servizioMargine ? this.servizioMargine.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IMarginUpsertRequest extends ILocalizedRequest {
    /** Entità da persistere (nuova o modificata) */
    servizioMargine?: ServizioMargineBase;
}

export abstract class ServizioMargineBase implements IServizioMargineBase {
    id?: number;
    dal?: string | null;
    al?: string | null;
    servizioDal?: string | null;
    servizioAl?: string | null;
    accordoID?: number | null;
    luogoID?: number | null;
    servizioID?: number | null;
    tipoServizio?: ETipoServizio | null;
    deltaMarkup?: number;
    proporzionale?: boolean;
    ordine?: number;
    note?: string | null;

    constructor(data?: IServizioMargineBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.al = _data["al"] !== undefined ? _data["al"] : null as any;
            this.servizioDal = _data["servizioDal"] !== undefined ? _data["servizioDal"] : null as any;
            this.servizioAl = _data["servizioAl"] !== undefined ? _data["servizioAl"] : null as any;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
            this.deltaMarkup = _data["deltaMarkup"] !== undefined ? _data["deltaMarkup"] : null as any;
            this.proporzionale = _data["proporzionale"] !== undefined ? _data["proporzionale"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
        }
    }

    static fromJS(data: any): ServizioMargineBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ServizioMargineBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["al"] = this.al !== undefined ? this.al : null as any;
        data["servizioDal"] = this.servizioDal !== undefined ? this.servizioDal : null as any;
        data["servizioAl"] = this.servizioAl !== undefined ? this.servizioAl : null as any;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        data["deltaMarkup"] = this.deltaMarkup !== undefined ? this.deltaMarkup : null as any;
        data["proporzionale"] = this.proporzionale !== undefined ? this.proporzionale : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        return data;
    }
}

export interface IServizioMargineBase {
    id?: number;
    dal?: string | null;
    al?: string | null;
    servizioDal?: string | null;
    servizioAl?: string | null;
    accordoID?: number | null;
    luogoID?: number | null;
    servizioID?: number | null;
    tipoServizio?: ETipoServizio | null;
    deltaMarkup?: number;
    proporzionale?: boolean;
    ordine?: number;
    note?: string | null;
}

export class DeleteMediaRequest extends ApiRequest implements IDeleteMediaRequest {
    ids?: number[] | null;

    constructor(data?: IDeleteMediaRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            else {
                this.ids = null as any;
            }
        }
    }

    static override fromJS(data: any): DeleteMediaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMediaRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteMediaRequest extends IApiRequest {
    ids?: number[] | null;
}

export class GetMediaResponse extends OkApiResponse implements IGetMediaResponse {
    media?: MediaRow | null;

    constructor(data?: IGetMediaResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.media = _data["media"] ? MediaRow.fromJS(_data["media"]) : null as any;
        }
    }

    static override fromJS(data: any): GetMediaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMediaResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["media"] = this.media ? this.media.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetMediaResponse extends IOkApiResponse {
    media?: MediaRow | null;
}

export class MediaRow implements IMediaRow {
    id?: number;
    url?: string | null;
    updatedAt?: string;
    deleted?: boolean;
    labelId?: number | null;
    label?: MediaLabel | null;
    thumbnails?: MediaThumbRow[] | null;
    locationLinks?: MediaLinkRow[] | null;
    serviceLinks?: MediaLinkRow[] | null;

    constructor(data?: IMediaRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : null as any;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : null as any;
            this.labelId = _data["labelId"] !== undefined ? _data["labelId"] : null as any;
            this.label = _data["label"] ? MediaLabel.fromJS(_data["label"]) : null as any;
            if (Array.isArray(_data["thumbnails"])) {
                this.thumbnails = [] as any;
                for (let item of _data["thumbnails"])
                    this.thumbnails!.push(MediaThumbRow.fromJS(item));
            }
            else {
                this.thumbnails = null as any;
            }
            if (Array.isArray(_data["locationLinks"])) {
                this.locationLinks = [] as any;
                for (let item of _data["locationLinks"])
                    this.locationLinks!.push(MediaLinkRow.fromJS(item));
            }
            else {
                this.locationLinks = null as any;
            }
            if (Array.isArray(_data["serviceLinks"])) {
                this.serviceLinks = [] as any;
                for (let item of _data["serviceLinks"])
                    this.serviceLinks!.push(MediaLinkRow.fromJS(item));
            }
            else {
                this.serviceLinks = null as any;
            }
        }
    }

    static fromJS(data: any): MediaRow {
        data = typeof data === 'object' ? data : {};
        let result = new MediaRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : null as any;
        data["deleted"] = this.deleted !== undefined ? this.deleted : null as any;
        data["labelId"] = this.labelId !== undefined ? this.labelId : null as any;
        data["label"] = this.label ? this.label.toJSON() : null as any;
        if (Array.isArray(this.thumbnails)) {
            data["thumbnails"] = [];
            for (let item of this.thumbnails)
                data["thumbnails"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.locationLinks)) {
            data["locationLinks"] = [];
            for (let item of this.locationLinks)
                data["locationLinks"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.serviceLinks)) {
            data["serviceLinks"] = [];
            for (let item of this.serviceLinks)
                data["serviceLinks"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IMediaRow {
    id?: number;
    url?: string | null;
    updatedAt?: string;
    deleted?: boolean;
    labelId?: number | null;
    label?: MediaLabel | null;
    thumbnails?: MediaThumbRow[] | null;
    locationLinks?: MediaLinkRow[] | null;
    serviceLinks?: MediaLinkRow[] | null;
}

export class MediaThumbRow implements IMediaThumbRow {
    width?: number;
    height?: number;
    url?: string | null;

    constructor(data?: IMediaThumbRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.width = _data["width"] !== undefined ? _data["width"] : null as any;
            this.height = _data["height"] !== undefined ? _data["height"] : null as any;
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
        }
    }

    static fromJS(data: any): MediaThumbRow {
        data = typeof data === 'object' ? data : {};
        let result = new MediaThumbRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["width"] = this.width !== undefined ? this.width : null as any;
        data["height"] = this.height !== undefined ? this.height : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        return data;
    }
}

export interface IMediaThumbRow {
    width?: number;
    height?: number;
    url?: string | null;
}

export class MediaLinkRow extends MediaLink implements IMediaLinkRow {
    name?: string;

    constructor(data?: IMediaLinkRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static override fromJS(data: any): MediaLinkRow {
        data = typeof data === 'object' ? data : {};
        let result = new MediaLinkRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IMediaLinkRow extends IMediaLink {
    name?: string;
}

export class GetMediaRequest extends LocalizedRequest implements IGetMediaRequest {
    id?: number;

    constructor(data?: IGetMediaRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): GetMediaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMediaRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetMediaRequest extends ILocalizedRequest {
    id?: number;
}

export class MediaLinkDeleteRequest extends ApiRequest implements IMediaLinkDeleteRequest {
    mediaId?: number;
    linkId?: number;

    constructor(data?: IMediaLinkDeleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.mediaId = _data["mediaId"] !== undefined ? _data["mediaId"] : null as any;
            this.linkId = _data["linkId"] !== undefined ? _data["linkId"] : null as any;
        }
    }

    static override fromJS(data: any): MediaLinkDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MediaLinkDeleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mediaId"] = this.mediaId !== undefined ? this.mediaId : null as any;
        data["linkId"] = this.linkId !== undefined ? this.linkId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IMediaLinkDeleteRequest extends IApiRequest {
    mediaId?: number;
    linkId?: number;
}

export class NrTableResponseOfMediaLinkByEntityRow extends OkApiResponse implements INrTableResponseOfMediaLinkByEntityRow {
    /** Array delle righe della pagina richiesta */
    rows?: MediaLinkByEntityRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfMediaLinkByEntityRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(MediaLinkByEntityRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfMediaLinkByEntityRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfMediaLinkByEntityRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfMediaLinkByEntityRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: MediaLinkByEntityRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class MediaLinkByEntityRow implements IMediaLinkByEntityRow {
    id?: number;
    mediaId?: number;
    url?: string | null;
    name?: string | null;
    sortOrder?: number | null;
    updatedAt?: string;

    constructor(data?: IMediaLinkByEntityRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.mediaId = _data["mediaId"] !== undefined ? _data["mediaId"] : null as any;
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null as any;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : null as any;
        }
    }

    static fromJS(data: any): MediaLinkByEntityRow {
        data = typeof data === 'object' ? data : {};
        let result = new MediaLinkByEntityRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["mediaId"] = this.mediaId !== undefined ? this.mediaId : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : null as any;
        return data;
    }
}

export interface IMediaLinkByEntityRow {
    id?: number;
    mediaId?: number;
    url?: string | null;
    name?: string | null;
    sortOrder?: number | null;
    updatedAt?: string;
}

export class MediasLinksByEntityRequest extends NrTableRequest implements IMediasLinksByEntityRequest {
    entityId?: number;
    entityType?: string | null;

    constructor(data?: IMediasLinksByEntityRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.entityId = _data["entityId"] !== undefined ? _data["entityId"] : null as any;
            this.entityType = _data["entityType"] !== undefined ? _data["entityType"] : null as any;
        }
    }

    static override fromJS(data: any): MediasLinksByEntityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MediasLinksByEntityRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId !== undefined ? this.entityId : null as any;
        data["entityType"] = this.entityType !== undefined ? this.entityType : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IMediasLinksByEntityRequest extends INrTableRequest {
    entityId?: number;
    entityType?: string | null;
}

export class MediaLinkUpsertRequest extends ApiRequest implements IMediaLinkUpsertRequest {
    link?: MediaLink | null;

    constructor(data?: IMediaLinkUpsertRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.link = _data["link"] ? MediaLink.fromJS(_data["link"]) : null as any;
        }
    }

    static override fromJS(data: any): MediaLinkUpsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MediaLinkUpsertRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["link"] = this.link ? this.link.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IMediaLinkUpsertRequest extends IApiRequest {
    link?: MediaLink | null;
}

export class NrTableResponseOfMediaRow extends OkApiResponse implements INrTableResponseOfMediaRow {
    /** Array delle righe della pagina richiesta */
    rows?: MediaRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfMediaRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(MediaRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfMediaRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfMediaRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfMediaRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: MediaRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class MediasListRequest extends NrTableRequest implements IMediasListRequest {
    mediaId?: number | null;
    type?: EMediaType | null;
    labelId?: number | null;
    locationId?: number | null;
    excludedLocationId?: number | null;
    serviceId?: number | null;
    excludedServiceId?: number | null;
    showDeleted?: boolean;

    constructor(data?: IMediasListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.mediaId = _data["mediaId"] !== undefined ? _data["mediaId"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.labelId = _data["labelId"] !== undefined ? _data["labelId"] : null as any;
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : null as any;
            this.excludedLocationId = _data["excludedLocationId"] !== undefined ? _data["excludedLocationId"] : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.excludedServiceId = _data["excludedServiceId"] !== undefined ? _data["excludedServiceId"] : null as any;
            this.showDeleted = _data["showDeleted"] !== undefined ? _data["showDeleted"] : null as any;
        }
    }

    static override fromJS(data: any): MediasListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MediasListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mediaId"] = this.mediaId !== undefined ? this.mediaId : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["labelId"] = this.labelId !== undefined ? this.labelId : null as any;
        data["locationId"] = this.locationId !== undefined ? this.locationId : null as any;
        data["excludedLocationId"] = this.excludedLocationId !== undefined ? this.excludedLocationId : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["excludedServiceId"] = this.excludedServiceId !== undefined ? this.excludedServiceId : null as any;
        data["showDeleted"] = this.showDeleted !== undefined ? this.showDeleted : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IMediasListRequest extends INrTableRequest {
    mediaId?: number | null;
    type?: EMediaType | null;
    labelId?: number | null;
    locationId?: number | null;
    excludedLocationId?: number | null;
    serviceId?: number | null;
    excludedServiceId?: number | null;
    showDeleted?: boolean;
}

export class MediasListByIdsResponse extends OkApiResponse implements IMediasListByIdsResponse {
    mediaUrls?: { [key: string]: string; } | null;
    imgUrls?: { [key: string]: string; } | null;

    constructor(data?: IMediasListByIdsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["mediaUrls"]) {
                this.mediaUrls = {} as any;
                for (let key in _data["mediaUrls"]) {
                    if (_data["mediaUrls"].hasOwnProperty(key))
                        (this.mediaUrls as any)![key] = _data["mediaUrls"][key] !== undefined ? _data["mediaUrls"][key] : null as any;
                }
            }
            else {
                this.mediaUrls = null as any;
            }
            if (_data["imgUrls"]) {
                this.imgUrls = {} as any;
                for (let key in _data["imgUrls"]) {
                    if (_data["imgUrls"].hasOwnProperty(key))
                        (this.imgUrls as any)![key] = _data["imgUrls"][key] !== undefined ? _data["imgUrls"][key] : null as any;
                }
            }
            else {
                this.imgUrls = null as any;
            }
        }
    }

    static override fromJS(data: any): MediasListByIdsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MediasListByIdsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.mediaUrls) {
            data["mediaUrls"] = {};
            for (let key in this.mediaUrls) {
                if (this.mediaUrls.hasOwnProperty(key))
                    (data["mediaUrls"] as any)[key] = this.mediaUrls[key] !== undefined ? this.mediaUrls[key] : null as any;
            }
        }
        if (this.imgUrls) {
            data["imgUrls"] = {};
            for (let key in this.imgUrls) {
                if (this.imgUrls.hasOwnProperty(key))
                    (data["imgUrls"] as any)[key] = this.imgUrls[key] !== undefined ? this.imgUrls[key] : null as any;
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IMediasListByIdsResponse extends IOkApiResponse {
    mediaUrls?: { [key: string]: string; } | null;
    imgUrls?: { [key: string]: string; } | null;
}

export class MediasListByIdsRequest extends ApiRequest implements IMediasListByIdsRequest {
    mediaIds?: number[] | null;
    imgIds?: number[] | null;

    constructor(data?: IMediasListByIdsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["mediaIds"])) {
                this.mediaIds = [] as any;
                for (let item of _data["mediaIds"])
                    this.mediaIds!.push(item);
            }
            else {
                this.mediaIds = null as any;
            }
            if (Array.isArray(_data["imgIds"])) {
                this.imgIds = [] as any;
                for (let item of _data["imgIds"])
                    this.imgIds!.push(item);
            }
            else {
                this.imgIds = null as any;
            }
        }
    }

    static override fromJS(data: any): MediasListByIdsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MediasListByIdsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mediaIds)) {
            data["mediaIds"] = [];
            for (let item of this.mediaIds)
                data["mediaIds"].push(item);
        }
        if (Array.isArray(this.imgIds)) {
            data["imgIds"] = [];
            for (let item of this.imgIds)
                data["imgIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IMediasListByIdsRequest extends IApiRequest {
    mediaIds?: number[] | null;
    imgIds?: number[] | null;
}

export class PixabayImportRequest extends LocalizedRequest implements IPixabayImportRequest {
    id?: string | null;
    labelId?: number | null;
    /** Lingua per i metadati */
    importLang?: ELingua;

    constructor(data?: IPixabayImportRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.labelId = _data["labelId"] !== undefined ? _data["labelId"] : null as any;
            this.importLang = _data["importLang"] !== undefined ? _data["importLang"] : null as any;
        }
    }

    static override fromJS(data: any): PixabayImportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PixabayImportRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["labelId"] = this.labelId !== undefined ? this.labelId : null as any;
        data["importLang"] = this.importLang !== undefined ? this.importLang : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPixabayImportRequest extends ILocalizedRequest {
    id?: string | null;
    labelId?: number | null;
    /** Lingua per i metadati */
    importLang?: ELingua;
}

export class NrTableResponseOfPixabayImageData extends OkApiResponse implements INrTableResponseOfPixabayImageData {
    /** Array delle righe della pagina richiesta */
    rows?: PixabayImageData[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfPixabayImageData) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(PixabayImageData.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfPixabayImageData {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfPixabayImageData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfPixabayImageData extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: PixabayImageData[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class PixabayImageData implements IPixabayImageData {
    id?: string | null;
    type?: string | null;
    pageURL?: string | null;
    tags?: string | null;
    previewURL?: string | null;
    previewWidth?: number;
    previewHeight?: number;
    imageWidth?: number;
    imageHeight?: number;
    imageSize?: number;
    largeImageURL?: string | null;

    constructor(data?: IPixabayImageData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.pageURL = _data["pageURL"] !== undefined ? _data["pageURL"] : null as any;
            this.tags = _data["tags"] !== undefined ? _data["tags"] : null as any;
            this.previewURL = _data["previewURL"] !== undefined ? _data["previewURL"] : null as any;
            this.previewWidth = _data["previewWidth"] !== undefined ? _data["previewWidth"] : null as any;
            this.previewHeight = _data["previewHeight"] !== undefined ? _data["previewHeight"] : null as any;
            this.imageWidth = _data["imageWidth"] !== undefined ? _data["imageWidth"] : null as any;
            this.imageHeight = _data["imageHeight"] !== undefined ? _data["imageHeight"] : null as any;
            this.imageSize = _data["imageSize"] !== undefined ? _data["imageSize"] : null as any;
            this.largeImageURL = _data["largeImageURL"] !== undefined ? _data["largeImageURL"] : null as any;
        }
    }

    static fromJS(data: any): PixabayImageData {
        data = typeof data === 'object' ? data : {};
        let result = new PixabayImageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["pageURL"] = this.pageURL !== undefined ? this.pageURL : null as any;
        data["tags"] = this.tags !== undefined ? this.tags : null as any;
        data["previewURL"] = this.previewURL !== undefined ? this.previewURL : null as any;
        data["previewWidth"] = this.previewWidth !== undefined ? this.previewWidth : null as any;
        data["previewHeight"] = this.previewHeight !== undefined ? this.previewHeight : null as any;
        data["imageWidth"] = this.imageWidth !== undefined ? this.imageWidth : null as any;
        data["imageHeight"] = this.imageHeight !== undefined ? this.imageHeight : null as any;
        data["imageSize"] = this.imageSize !== undefined ? this.imageSize : null as any;
        data["largeImageURL"] = this.largeImageURL !== undefined ? this.largeImageURL : null as any;
        return data;
    }
}

export interface IPixabayImageData {
    id?: string | null;
    type?: string | null;
    pageURL?: string | null;
    tags?: string | null;
    previewURL?: string | null;
    previewWidth?: number;
    previewHeight?: number;
    imageWidth?: number;
    imageHeight?: number;
    imageSize?: number;
    largeImageURL?: string | null;
}

export class PixabaySearchRequest extends NrTableRequest implements IPixabaySearchRequest {
    query?: PixabayQuery | null;

    constructor(data?: IPixabaySearchRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.query = _data["query"] ? PixabayQuery.fromJS(_data["query"]) : null as any;
        }
    }

    static override fromJS(data: any): PixabaySearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PixabaySearchRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query ? this.query.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPixabaySearchRequest extends INrTableRequest {
    query?: PixabayQuery | null;
}

export class PixabayQuery implements IPixabayQuery {
    query!: string;
    id?: string | null;
    lingua?: ELingua;
    imageType?: EImageType;
    orientation?: EImageOrientation;
    category?: EImageCategory | null;
    minWidth?: number;
    minHeight?: number;
    editorsChoiche?: boolean;
    safeSearch?: boolean;
    sortOrder?: ESortOrder;
    pageNr?: number;
    perPage?: number;

    constructor(data?: IPixabayQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"] !== undefined ? _data["query"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : null as any;
            this.imageType = _data["imageType"] !== undefined ? _data["imageType"] : null as any;
            this.orientation = _data["orientation"] !== undefined ? _data["orientation"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.minWidth = _data["minWidth"] !== undefined ? _data["minWidth"] : null as any;
            this.minHeight = _data["minHeight"] !== undefined ? _data["minHeight"] : null as any;
            this.editorsChoiche = _data["editorsChoiche"] !== undefined ? _data["editorsChoiche"] : null as any;
            this.safeSearch = _data["safeSearch"] !== undefined ? _data["safeSearch"] : null as any;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null as any;
            this.pageNr = _data["pageNr"] !== undefined ? _data["pageNr"] : null as any;
            this.perPage = _data["perPage"] !== undefined ? _data["perPage"] : null as any;
        }
    }

    static fromJS(data: any): PixabayQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PixabayQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query !== undefined ? this.query : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["lingua"] = this.lingua !== undefined ? this.lingua : null as any;
        data["imageType"] = this.imageType !== undefined ? this.imageType : null as any;
        data["orientation"] = this.orientation !== undefined ? this.orientation : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["minWidth"] = this.minWidth !== undefined ? this.minWidth : null as any;
        data["minHeight"] = this.minHeight !== undefined ? this.minHeight : null as any;
        data["editorsChoiche"] = this.editorsChoiche !== undefined ? this.editorsChoiche : null as any;
        data["safeSearch"] = this.safeSearch !== undefined ? this.safeSearch : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        data["pageNr"] = this.pageNr !== undefined ? this.pageNr : null as any;
        data["perPage"] = this.perPage !== undefined ? this.perPage : null as any;
        return data;
    }
}

export interface IPixabayQuery {
    query: string;
    id?: string | null;
    lingua?: ELingua;
    imageType?: EImageType;
    orientation?: EImageOrientation;
    category?: EImageCategory | null;
    minWidth?: number;
    minHeight?: number;
    editorsChoiche?: boolean;
    safeSearch?: boolean;
    sortOrder?: ESortOrder;
    pageNr?: number;
    perPage?: number;
}

export enum EImageType {
    All = "all",
    Photo = "photo",
    Illustration = "illustration",
    Vector = "vector",
}

export enum EImageOrientation {
    All = "all",
    Horizontal = "horizontal",
    Vertical = "vertical",
}

export enum EImageCategory {
    Backgrounds = "backgrounds",
    Fashion = "fashion",
    Nature = "nature",
    Science = "science",
    Education = "education",
    Feelings = "feelings",
    Health = "health",
    People = "people",
    Religion = "religion",
    Places = "places",
    Animals = "animals",
    Industry = "industry",
    Computer = "computer",
    Food = "food",
    Sports = "sports",
    Transportation = "transportation",
    Travel = "travel",
    Buildings = "buildings",
    Business = "business",
    Music = "music",
}

export enum ESortOrder {
    Popular = "popular",
    Latest = "latest",
}

export class RestoreMediaRequest extends ApiRequest implements IRestoreMediaRequest {
    id?: number;

    constructor(data?: IRestoreMediaRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): RestoreMediaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreMediaRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IRestoreMediaRequest extends IApiRequest {
    id?: number;
}

export class UpdateMediaRequest extends GetMediaRequest implements IUpdateMediaRequest {
    labelId?: number | null;
    links?: MediaLink[] | null;

    constructor(data?: IUpdateMediaRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.labelId = _data["labelId"] !== undefined ? _data["labelId"] : null as any;
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(MediaLink.fromJS(item));
            }
            else {
                this.links = null as any;
            }
        }
    }

    static override fromJS(data: any): UpdateMediaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMediaRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labelId"] = this.labelId !== undefined ? this.labelId : null as any;
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateMediaRequest extends IGetMediaRequest {
    labelId?: number | null;
    links?: MediaLink[] | null;
}

export class LocationMediaLink extends MediaLink implements ILocationMediaLink {

    constructor(data?: ILocationMediaLink) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): LocationMediaLink {
        data = typeof data === 'object' ? data : {};
        let result = new LocationMediaLink();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ILocationMediaLink extends IMediaLink {
}

export class ServiceMediaLink extends MediaLink implements IServiceMediaLink {

    constructor(data?: IServiceMediaLink) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ServiceMediaLink {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceMediaLink();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IServiceMediaLink extends IMediaLink {
}

export class NaarCrypticExecuteResponse extends OkApiResponse implements INaarCrypticExecuteResponse {
    /** Se true il comando è stato eseguito con successo */
    success?: boolean;
    /** Stringa di risposta */
    responseString?: string;
    /** Se true è richiesto l'update del viaggio ID=TripID */
    tripRefreshRequired?: boolean;
    /** Eventuale ID di viaggio (corrente o creato) */
    tripID?: number | null;
    /** Eventuale lista degli warning */
    warnings?: string[];

    constructor(data?: INaarCrypticExecuteResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.success = _data["success"] !== undefined ? _data["success"] : null as any;
            this.responseString = _data["responseString"] !== undefined ? _data["responseString"] : null as any;
            this.tripRefreshRequired = _data["tripRefreshRequired"] !== undefined ? _data["tripRefreshRequired"] : null as any;
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : null as any;
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(item);
            }
            else {
                this.warnings = null as any;
            }
        }
    }

    static override fromJS(data: any): NaarCrypticExecuteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarCrypticExecuteResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : null as any;
        data["responseString"] = this.responseString !== undefined ? this.responseString : null as any;
        data["tripRefreshRequired"] = this.tripRefreshRequired !== undefined ? this.tripRefreshRequired : null as any;
        data["tripID"] = this.tripID !== undefined ? this.tripID : null as any;
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface INaarCrypticExecuteResponse extends IOkApiResponse {
    /** Se true il comando è stato eseguito con successo */
    success?: boolean;
    /** Stringa di risposta */
    responseString?: string;
    /** Se true è richiesto l'update del viaggio ID=TripID */
    tripRefreshRequired?: boolean;
    /** Eventuale ID di viaggio (corrente o creato) */
    tripID?: number | null;
    /** Eventuale lista degli warning */
    warnings?: string[];
}

export class NaarCrypticExecuteRequest extends LocalizedRequest implements INaarCrypticExecuteRequest {
    /** ID del viaggio corrente, per comandi in contesto di viaggio */
    tripID?: number | null;
    /** Comando da eseguire */
    command?: string;
    /** Argomenti */
    args?: string | null;

    constructor(data?: INaarCrypticExecuteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : null as any;
            this.command = _data["command"] !== undefined ? _data["command"] : null as any;
            this.args = _data["args"] !== undefined ? _data["args"] : null as any;
        }
    }

    static override fromJS(data: any): NaarCrypticExecuteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarCrypticExecuteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripID"] = this.tripID !== undefined ? this.tripID : null as any;
        data["command"] = this.command !== undefined ? this.command : null as any;
        data["args"] = this.args !== undefined ? this.args : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarCrypticExecuteRequest extends ILocalizedRequest {
    /** ID del viaggio corrente, per comandi in contesto di viaggio */
    tripID?: number | null;
    /** Comando da eseguire */
    command?: string;
    /** Argomenti */
    args?: string | null;
}

export class GetAgreementsResponse extends OkApiResponse implements IGetAgreementsResponse {
    defaultAgreement?: number;
    agreements?: AgreementItem[] | null;

    constructor(data?: IGetAgreementsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.defaultAgreement = _data["defaultAgreement"] !== undefined ? _data["defaultAgreement"] : null as any;
            if (Array.isArray(_data["agreements"])) {
                this.agreements = [] as any;
                for (let item of _data["agreements"])
                    this.agreements!.push(AgreementItem.fromJS(item));
            }
            else {
                this.agreements = null as any;
            }
        }
    }

    static override fromJS(data: any): GetAgreementsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAgreementsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultAgreement"] = this.defaultAgreement !== undefined ? this.defaultAgreement : null as any;
        if (Array.isArray(this.agreements)) {
            data["agreements"] = [];
            for (let item of this.agreements)
                data["agreements"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetAgreementsResponse extends IOkApiResponse {
    defaultAgreement?: number;
    agreements?: AgreementItem[] | null;
}

export class AgreementItem implements IAgreementItem {
    id?: number;
    name?: string | null;

    constructor(data?: IAgreementItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): AgreementItem {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export interface IAgreementItem {
    id?: number;
    name?: string | null;
}

export class GetAmadeusMarketsResponse extends OkApiResponse implements IGetAmadeusMarketsResponse {
    markets?: CrypticMarket[] | null;

    constructor(data?: IGetAmadeusMarketsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["markets"])) {
                this.markets = [] as any;
                for (let item of _data["markets"])
                    this.markets!.push(CrypticMarket.fromJS(item));
            }
            else {
                this.markets = null as any;
            }
        }
    }

    static override fromJS(data: any): GetAmadeusMarketsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAmadeusMarketsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.markets)) {
            data["markets"] = [];
            for (let item of this.markets)
                data["markets"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetAmadeusMarketsResponse extends IOkApiResponse {
    markets?: CrypticMarket[] | null;
}

export class GetAmadeusMarketsRequest extends ApiRequest implements IGetAmadeusMarketsRequest {
    operator?: EOperatore | null;

    constructor(data?: IGetAmadeusMarketsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operator = _data["operator"] !== undefined ? _data["operator"] : null as any;
        }
    }

    static override fromJS(data: any): GetAmadeusMarketsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAmadeusMarketsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operator"] = this.operator !== undefined ? this.operator : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetAmadeusMarketsRequest extends IApiRequest {
    operator?: EOperatore | null;
}

export class GetPaymentTermsResponse extends OkApiResponse implements IGetPaymentTermsResponse {
    defaultPaymentTerm?: number;
    paymentTerms?: PaymentTermItem[] | null;

    constructor(data?: IGetPaymentTermsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.defaultPaymentTerm = _data["defaultPaymentTerm"] !== undefined ? _data["defaultPaymentTerm"] : null as any;
            if (Array.isArray(_data["paymentTerms"])) {
                this.paymentTerms = [] as any;
                for (let item of _data["paymentTerms"])
                    this.paymentTerms!.push(PaymentTermItem.fromJS(item));
            }
            else {
                this.paymentTerms = null as any;
            }
        }
    }

    static override fromJS(data: any): GetPaymentTermsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentTermsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultPaymentTerm"] = this.defaultPaymentTerm !== undefined ? this.defaultPaymentTerm : null as any;
        if (Array.isArray(this.paymentTerms)) {
            data["paymentTerms"] = [];
            for (let item of this.paymentTerms)
                data["paymentTerms"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPaymentTermsResponse extends IOkApiResponse {
    defaultPaymentTerm?: number;
    paymentTerms?: PaymentTermItem[] | null;
}

export class PaymentTermItem implements IPaymentTermItem {
    id?: number;
    name?: string | null;

    constructor(data?: IPaymentTermItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): PaymentTermItem {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTermItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export interface IPaymentTermItem {
    id?: number;
    name?: string | null;
}

export class NaarGoChatSummarizeResponse extends OkApiResponse implements INaarGoChatSummarizeResponse {
    summary?: string | null;

    constructor(data?: INaarGoChatSummarizeResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.summary = _data["summary"] !== undefined ? _data["summary"] : null as any;
        }
    }

    static override fromJS(data: any): NaarGoChatSummarizeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoChatSummarizeResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary !== undefined ? this.summary : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoChatSummarizeResponse extends IOkApiResponse {
    summary?: string | null;
}

export class NaarGoChatSummarizeRequest extends LocalizedRequest implements INaarGoChatSummarizeRequest {
    previousSummary?: string | null;
    messages?: NaarAIChatMessage[] | null;

    constructor(data?: INaarGoChatSummarizeRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.previousSummary = _data["previousSummary"] !== undefined ? _data["previousSummary"] : null as any;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(NaarAIChatMessage.fromJS(item));
            }
            else {
                this.messages = null as any;
            }
        }
    }

    static override fromJS(data: any): NaarGoChatSummarizeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoChatSummarizeRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["previousSummary"] = this.previousSummary !== undefined ? this.previousSummary : null as any;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoChatSummarizeRequest extends ILocalizedRequest {
    previousSummary?: string | null;
    messages?: NaarAIChatMessage[] | null;
}

export class NaarAIChatMessage implements INaarAIChatMessage {
    author?: string | null;
    message?: string | null;

    constructor(data?: INaarAIChatMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.author = _data["author"] !== undefined ? _data["author"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
        }
    }

    static fromJS(data: any): NaarAIChatMessage {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAIChatMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["author"] = this.author !== undefined ? this.author : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        return data;
    }
}

export interface INaarAIChatMessage {
    author?: string | null;
    message?: string | null;
}

export class NaarGoFileUploadResponse extends OkApiResponse implements INaarGoFileUploadResponse {
    guid?: string | null;

    constructor(data?: INaarGoFileUploadResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
        }
    }

    static override fromJS(data: any): NaarGoFileUploadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoFileUploadResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoFileUploadResponse extends IOkApiResponse {
    guid?: string | null;
}

export class NaarGoFileDownloadResponse extends OkApiResponse implements INaarGoFileDownloadResponse {
    bytes?: string | null;

    constructor(data?: INaarGoFileDownloadResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.bytes = _data["bytes"] !== undefined ? _data["bytes"] : null as any;
        }
    }

    static override fromJS(data: any): NaarGoFileDownloadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoFileDownloadResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bytes"] = this.bytes !== undefined ? this.bytes : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoFileDownloadResponse extends IOkApiResponse {
    bytes?: string | null;
}

export class NaarGoFileDownloadRequest extends ApiRequest implements INaarGoFileDownloadRequest {
    threadId?: string | null;
    guid?: string | null;
    getPreview?: boolean;

    constructor(data?: INaarGoFileDownloadRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.threadId = _data["threadId"] !== undefined ? _data["threadId"] : null as any;
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.getPreview = _data["getPreview"] !== undefined ? _data["getPreview"] : null as any;
        }
    }

    static override fromJS(data: any): NaarGoFileDownloadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoFileDownloadRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["threadId"] = this.threadId !== undefined ? this.threadId : null as any;
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["getPreview"] = this.getPreview !== undefined ? this.getPreview : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoFileDownloadRequest extends IApiRequest {
    threadId?: string | null;
    guid?: string | null;
    getPreview?: boolean;
}

export class NaarGoGetSystemResponse extends OkApiResponse implements INaarGoGetSystemResponse {
    system?: NaarGoUserRow | null;

    constructor(data?: INaarGoGetSystemResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.system = _data["system"] ? NaarGoUserRow.fromJS(_data["system"]) : null as any;
        }
    }

    static override fromJS(data: any): NaarGoGetSystemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoGetSystemResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["system"] = this.system ? this.system.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoGetSystemResponse extends IOkApiResponse {
    system?: NaarGoUserRow | null;
}

export class NaarGoUserRowLite implements INaarGoUserRowLite {
    id?: number;
    azureCSIdentity?: string | null;
    role?: EUserRole;

    constructor(data?: INaarGoUserRowLite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.azureCSIdentity = _data["azureCSIdentity"] !== undefined ? _data["azureCSIdentity"] : null as any;
            this.role = _data["role"] !== undefined ? _data["role"] : null as any;
        }
    }

    static fromJS(data: any): NaarGoUserRowLite {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoUserRowLite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["azureCSIdentity"] = this.azureCSIdentity !== undefined ? this.azureCSIdentity : null as any;
        data["role"] = this.role !== undefined ? this.role : null as any;
        return data;
    }
}

export interface INaarGoUserRowLite {
    id?: number;
    azureCSIdentity?: string | null;
    role?: EUserRole;
}

export class NaarGoUserRow extends NaarGoUserRowLite implements INaarGoUserRow {
    emailAddress?: string | null;
    name?: string | null;
    lastname?: string | null;
    azureCSToken?: string | null;
    authToken?: string | null;
    language?: ELingua;
    intranetUserID?: number | null;
    lastAccess?: string | null;
    deletedDate?: string | null;

    constructor(data?: INaarGoUserRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.lastname = _data["lastname"] !== undefined ? _data["lastname"] : null as any;
            this.azureCSToken = _data["azureCSToken"] !== undefined ? _data["azureCSToken"] : null as any;
            this.authToken = _data["authToken"] !== undefined ? _data["authToken"] : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
            this.intranetUserID = _data["intranetUserID"] !== undefined ? _data["intranetUserID"] : null as any;
            this.lastAccess = _data["lastAccess"] !== undefined ? _data["lastAccess"] : null as any;
            this.deletedDate = _data["deletedDate"] !== undefined ? _data["deletedDate"] : null as any;
        }
    }

    static override fromJS(data: any): NaarGoUserRow {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoUserRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["lastname"] = this.lastname !== undefined ? this.lastname : null as any;
        data["azureCSToken"] = this.azureCSToken !== undefined ? this.azureCSToken : null as any;
        data["authToken"] = this.authToken !== undefined ? this.authToken : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        data["intranetUserID"] = this.intranetUserID !== undefined ? this.intranetUserID : null as any;
        data["lastAccess"] = this.lastAccess !== undefined ? this.lastAccess : null as any;
        data["deletedDate"] = this.deletedDate !== undefined ? this.deletedDate : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoUserRow extends INaarGoUserRowLite {
    emailAddress?: string | null;
    name?: string | null;
    lastname?: string | null;
    azureCSToken?: string | null;
    authToken?: string | null;
    language?: ELingua;
    intranetUserID?: number | null;
    lastAccess?: string | null;
    deletedDate?: string | null;
}

export enum EUserRole {
    User = "User",
    Admin = "Admin",
    System = "System",
}

export class NaarGoGetAdminsResponse extends OkApiResponse implements INaarGoGetAdminsResponse {
    admins?: NaarGoUserRow[] | null;

    constructor(data?: INaarGoGetAdminsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["admins"])) {
                this.admins = [] as any;
                for (let item of _data["admins"])
                    this.admins!.push(NaarGoUserRow.fromJS(item));
            }
            else {
                this.admins = null as any;
            }
        }
    }

    static override fromJS(data: any): NaarGoGetAdminsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoGetAdminsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.admins)) {
            data["admins"] = [];
            for (let item of this.admins)
                data["admins"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoGetAdminsResponse extends IOkApiResponse {
    admins?: NaarGoUserRow[] | null;
}

export class NaarGoGetUserResponse extends OkApiResponse implements INaarGoGetUserResponse {
    user?: NaarGoUserRow | null;

    constructor(data?: INaarGoGetUserResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.user = _data["user"] ? NaarGoUserRow.fromJS(_data["user"]) : null as any;
        }
    }

    static override fromJS(data: any): NaarGoGetUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoGetUserResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoGetUserResponse extends IOkApiResponse {
    user?: NaarGoUserRow | null;
}

export class NaarGoNotificationSubscribeRequest extends ApiRequest implements INaarGoNotificationSubscribeRequest {
    userId?: number;
    subscription?: PushSubscription | null;

    constructor(data?: INaarGoNotificationSubscribeRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.subscription = _data["subscription"] ? PushSubscription.fromJS(_data["subscription"]) : null as any;
        }
    }

    static override fromJS(data: any): NaarGoNotificationSubscribeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoNotificationSubscribeRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["subscription"] = this.subscription ? this.subscription.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoNotificationSubscribeRequest extends IApiRequest {
    userId?: number;
    subscription?: PushSubscription | null;
}

export class PushSubscription implements IPushSubscription {
    endpoint?: string | null;
    p256DH?: string | null;
    auth?: string | null;

    constructor(data?: IPushSubscription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.endpoint = _data["endpoint"] !== undefined ? _data["endpoint"] : null as any;
            this.p256DH = _data["p256DH"] !== undefined ? _data["p256DH"] : null as any;
            this.auth = _data["auth"] !== undefined ? _data["auth"] : null as any;
        }
    }

    static fromJS(data: any): PushSubscription {
        data = typeof data === 'object' ? data : {};
        let result = new PushSubscription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endpoint"] = this.endpoint !== undefined ? this.endpoint : null as any;
        data["p256DH"] = this.p256DH !== undefined ? this.p256DH : null as any;
        data["auth"] = this.auth !== undefined ? this.auth : null as any;
        return data;
    }
}

export interface IPushSubscription {
    endpoint?: string | null;
    p256DH?: string | null;
    auth?: string | null;
}

export class NaarGoNotificationUnsubscribeRequest extends ApiRequest implements INaarGoNotificationUnsubscribeRequest {
    userId?: number;

    constructor(data?: INaarGoNotificationUnsubscribeRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
        }
    }

    static override fromJS(data: any): NaarGoNotificationUnsubscribeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoNotificationUnsubscribeRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoNotificationUnsubscribeRequest extends IApiRequest {
    userId?: number;
}

export class NrTableResponseOfOperatoreListRow extends OkApiResponse implements INrTableResponseOfOperatoreListRow {
    /** Array delle righe della pagina richiesta */
    rows?: OperatoreListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfOperatoreListRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(OperatoreListRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfOperatoreListRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfOperatoreListRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfOperatoreListRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: OperatoreListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class OperatoriListResponse extends NrTableResponseOfOperatoreListRow implements IOperatoriListResponse {

    constructor(data?: IOperatoriListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OperatoriListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OperatoriListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOperatoriListResponse extends INrTableResponseOfOperatoreListRow {
}

export class OperatoreListRow implements IOperatoreListRow {
    /** ID dell'operatore */
    id?: number;
    /** Nome interno */
    nome?: string;
    /** Nome visualizzato */
    nomeVisualizzato?: string | null;
    /** Contatto di riferimento */
    contatto?: string;
    /** Valuta utilizzata */
    valuta?: string;

    constructor(data?: IOperatoreListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nomeVisualizzato = _data["nomeVisualizzato"] !== undefined ? _data["nomeVisualizzato"] : null as any;
            this.contatto = _data["contatto"] !== undefined ? _data["contatto"] : null as any;
            this.valuta = _data["valuta"] !== undefined ? _data["valuta"] : null as any;
        }
    }

    static fromJS(data: any): OperatoreListRow {
        data = typeof data === 'object' ? data : {};
        let result = new OperatoreListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nomeVisualizzato"] = this.nomeVisualizzato !== undefined ? this.nomeVisualizzato : null as any;
        data["contatto"] = this.contatto !== undefined ? this.contatto : null as any;
        data["valuta"] = this.valuta !== undefined ? this.valuta : null as any;
        return data;
    }
}

export interface IOperatoreListRow {
    /** ID dell'operatore */
    id?: number;
    /** Nome interno */
    nome?: string;
    /** Nome visualizzato */
    nomeVisualizzato?: string | null;
    /** Contatto di riferimento */
    contatto?: string;
    /** Valuta utilizzata */
    valuta?: string;
}

export class OperatoriListRequest extends NrTableRequest implements IOperatoriListRequest {
    /** Termine di ricerca oppure ID */
    term?: string | null;

    constructor(data?: IOperatoriListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : null as any;
        }
    }

    static override fromJS(data: any): OperatoriListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OperatoriListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IOperatoriListRequest extends INrTableRequest {
    /** Termine di ricerca oppure ID */
    term?: string | null;
}

export class OptimizeRequest extends ApiRequest implements IOptimizeRequest {
    /** Offerta singola, tutto */
    offertaID?: number | null;
    /** Solo righe appartenenti ad itinerario nel luogo scelto */
    luogoID?: number | null;
    /** Solo partenze dopo la data indicata (inclusa). In ogni caso dopo oggi */
    partenzaDal?: string | null;
    /** Solo partenze prima della data indicata (inclusa) */
    partenzaAl?: string | null;
    /** ID del contatto fornitore associato all'accordo */
    contattoFornitoreID?: number | null;
    /** Aolo se offerte confermate */
    soloConferme?: boolean;
    /** Se true aggiunge le ottimizzazioni a quelle eventualmente già presenti */
    appendToExisting?: boolean;
    /** Dati di testata */
    job?: OffertaDatoAlternativaJob | null;

    constructor(data?: IOptimizeRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.partenzaDal = _data["partenzaDal"] !== undefined ? _data["partenzaDal"] : null as any;
            this.partenzaAl = _data["partenzaAl"] !== undefined ? _data["partenzaAl"] : null as any;
            this.contattoFornitoreID = _data["contattoFornitoreID"] !== undefined ? _data["contattoFornitoreID"] : null as any;
            this.soloConferme = _data["soloConferme"] !== undefined ? _data["soloConferme"] : null as any;
            this.appendToExisting = _data["appendToExisting"] !== undefined ? _data["appendToExisting"] : null as any;
            this.job = _data["job"] ? OffertaDatoAlternativaJob.fromJS(_data["job"]) : null as any;
        }
    }

    static override fromJS(data: any): OptimizeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OptimizeRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["partenzaDal"] = this.partenzaDal !== undefined ? this.partenzaDal : null as any;
        data["partenzaAl"] = this.partenzaAl !== undefined ? this.partenzaAl : null as any;
        data["contattoFornitoreID"] = this.contattoFornitoreID !== undefined ? this.contattoFornitoreID : null as any;
        data["soloConferme"] = this.soloConferme !== undefined ? this.soloConferme : null as any;
        data["appendToExisting"] = this.appendToExisting !== undefined ? this.appendToExisting : null as any;
        data["job"] = this.job ? this.job.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IOptimizeRequest extends IApiRequest {
    /** Offerta singola, tutto */
    offertaID?: number | null;
    /** Solo righe appartenenti ad itinerario nel luogo scelto */
    luogoID?: number | null;
    /** Solo partenze dopo la data indicata (inclusa). In ogni caso dopo oggi */
    partenzaDal?: string | null;
    /** Solo partenze prima della data indicata (inclusa) */
    partenzaAl?: string | null;
    /** ID del contatto fornitore associato all'accordo */
    contattoFornitoreID?: number | null;
    /** Aolo se offerte confermate */
    soloConferme?: boolean;
    /** Se true aggiunge le ottimizzazioni a quelle eventualmente già presenti */
    appendToExisting?: boolean;
    /** Dati di testata */
    job?: OffertaDatoAlternativaJob | null;
}

export class OffertaDatoAlternativaJob implements IOffertaDatoAlternativaJob {
    id?: number;
    alternativaID?: number;
    noFornitoreOriginale?: boolean;
    delta?: number;
    tipoDelta?: ETipoDeltaAlternativa;
    creato?: string;
    emailNotifica?: string | null;

    constructor(data?: IOffertaDatoAlternativaJob) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.alternativaID = _data["alternativaID"] !== undefined ? _data["alternativaID"] : null as any;
            this.noFornitoreOriginale = _data["noFornitoreOriginale"] !== undefined ? _data["noFornitoreOriginale"] : null as any;
            this.delta = _data["delta"] !== undefined ? _data["delta"] : null as any;
            this.tipoDelta = _data["tipoDelta"] !== undefined ? _data["tipoDelta"] : null as any;
            this.creato = _data["creato"] !== undefined ? _data["creato"] : null as any;
            this.emailNotifica = _data["emailNotifica"] !== undefined ? _data["emailNotifica"] : null as any;
        }
    }

    static fromJS(data: any): OffertaDatoAlternativaJob {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaDatoAlternativaJob();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["alternativaID"] = this.alternativaID !== undefined ? this.alternativaID : null as any;
        data["noFornitoreOriginale"] = this.noFornitoreOriginale !== undefined ? this.noFornitoreOriginale : null as any;
        data["delta"] = this.delta !== undefined ? this.delta : null as any;
        data["tipoDelta"] = this.tipoDelta !== undefined ? this.tipoDelta : null as any;
        data["creato"] = this.creato !== undefined ? this.creato : null as any;
        data["emailNotifica"] = this.emailNotifica !== undefined ? this.emailNotifica : null as any;
        return data;
    }
}

export interface IOffertaDatoAlternativaJob {
    id?: number;
    alternativaID?: number;
    noFornitoreOriginale?: boolean;
    delta?: number;
    tipoDelta?: ETipoDeltaAlternativa;
    creato?: string;
    emailNotifica?: string | null;
}

export enum ETipoDeltaAlternativa {
    PercentualePrezzo = "PercentualePrezzo",
    PercentualeCosto = "PercentualeCosto",
    PrezzoAssoluto = "PrezzoAssoluto",
    CostoAssoluto = "CostoAssoluto",
}

export class OptimizeDeleteMultiRequest extends ApiRequest implements IOptimizeDeleteMultiRequest {
    ids!: number[];

    constructor(data?: IOptimizeDeleteMultiRequest) {
        super(data);
        if (!data) {
            this.ids = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            else {
                this.ids = null as any;
            }
        }
    }

    static override fromJS(data: any): OptimizeDeleteMultiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OptimizeDeleteMultiRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IOptimizeDeleteMultiRequest extends IApiRequest {
    ids: number[];
}

export class OptimizePreviewResponse extends OkApiResponse implements IOptimizePreviewResponse {
    righeTotali?: number;

    constructor(data?: IOptimizePreviewResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.righeTotali = _data["righeTotali"] !== undefined ? _data["righeTotali"] : null as any;
        }
    }

    static override fromJS(data: any): OptimizePreviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OptimizePreviewResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["righeTotali"] = this.righeTotali !== undefined ? this.righeTotali : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IOptimizePreviewResponse extends IOkApiResponse {
    righeTotali?: number;
}

export class OptimizationsQueryResponse extends OkApiResponse implements IOptimizationsQueryResponse {
    hasWork?: boolean;
    done?: number;
    total?: number;

    constructor(data?: IOptimizationsQueryResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hasWork = _data["hasWork"] !== undefined ? _data["hasWork"] : null as any;
            this.done = _data["done"] !== undefined ? _data["done"] : null as any;
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): OptimizationsQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OptimizationsQueryResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasWork"] = this.hasWork !== undefined ? this.hasWork : null as any;
        data["done"] = this.done !== undefined ? this.done : null as any;
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IOptimizationsQueryResponse extends IOkApiResponse {
    hasWork?: boolean;
    done?: number;
    total?: number;
}

export class SearchOrdersResponse extends OkApiResponse implements ISearchOrdersResponse {
    trips?: OrderListRow[];

    constructor(data?: ISearchOrdersResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["trips"])) {
                this.trips = [] as any;
                for (let item of _data["trips"])
                    this.trips!.push(OrderListRow.fromJS(item));
            }
            else {
                this.trips = null as any;
            }
        }
    }

    static override fromJS(data: any): SearchOrdersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchOrdersResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.trips)) {
            data["trips"] = [];
            for (let item of this.trips)
                data["trips"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISearchOrdersResponse extends IOkApiResponse {
    trips?: OrderListRow[];
}

export class OrderListRow implements IOrderListRow {
    offertaID?: number;
    descrizione?: string | null;
    clienti?: string | null;
    destinazione?: string | null;
    creazione?: string;
    partenza?: string;
    conferma?: string | null;
    totale?: number;
    totaleValuta?: number;
    agenzia?: string | null;
    telefono?: string | null;
    email?: string | null;
    categoriaAgenzia?: string | null;
    impiegato?: string | null;
    utentePreventivo?: string | null;
    utenteConferma?: string | null;
    annullataTO?: boolean;
    annullataADV?: boolean;
    sales?: string | null;
    pagamento?: string | null;
    saldato?: number;
    saldatoValuta?: number;
    compensato?: number;
    compensatoValuta?: number;
    saldare?: number;
    saldareValuta?: number;
    duplicabileAgenzia?: boolean;
    coverUrl?: string | null;
    valutaNonEuro?: boolean;
    idValuta?: number;
    codiceValuta?: string;
    conversioneValuta?: number;

    constructor(data?: IOrderListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.clienti = _data["clienti"] !== undefined ? _data["clienti"] : null as any;
            this.destinazione = _data["destinazione"] !== undefined ? _data["destinazione"] : null as any;
            this.creazione = _data["creazione"] !== undefined ? _data["creazione"] : null as any;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : null as any;
            this.conferma = _data["conferma"] !== undefined ? _data["conferma"] : null as any;
            this.totale = _data["totale"] !== undefined ? _data["totale"] : null as any;
            this.totaleValuta = _data["totaleValuta"] !== undefined ? _data["totaleValuta"] : null as any;
            this.agenzia = _data["agenzia"] !== undefined ? _data["agenzia"] : null as any;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.categoriaAgenzia = _data["categoriaAgenzia"] !== undefined ? _data["categoriaAgenzia"] : null as any;
            this.impiegato = _data["impiegato"] !== undefined ? _data["impiegato"] : null as any;
            this.utentePreventivo = _data["utentePreventivo"] !== undefined ? _data["utentePreventivo"] : null as any;
            this.utenteConferma = _data["utenteConferma"] !== undefined ? _data["utenteConferma"] : null as any;
            this.annullataTO = _data["annullataTO"] !== undefined ? _data["annullataTO"] : null as any;
            this.annullataADV = _data["annullataADV"] !== undefined ? _data["annullataADV"] : null as any;
            this.sales = _data["sales"] !== undefined ? _data["sales"] : null as any;
            this.pagamento = _data["pagamento"] !== undefined ? _data["pagamento"] : null as any;
            this.saldato = _data["saldato"] !== undefined ? _data["saldato"] : null as any;
            this.saldatoValuta = _data["saldatoValuta"] !== undefined ? _data["saldatoValuta"] : null as any;
            this.compensato = _data["compensato"] !== undefined ? _data["compensato"] : null as any;
            this.compensatoValuta = _data["compensatoValuta"] !== undefined ? _data["compensatoValuta"] : null as any;
            this.saldare = _data["saldare"] !== undefined ? _data["saldare"] : null as any;
            this.saldareValuta = _data["saldareValuta"] !== undefined ? _data["saldareValuta"] : null as any;
            this.duplicabileAgenzia = _data["duplicabileAgenzia"] !== undefined ? _data["duplicabileAgenzia"] : null as any;
            this.coverUrl = _data["coverUrl"] !== undefined ? _data["coverUrl"] : null as any;
            this.valutaNonEuro = _data["valutaNonEuro"] !== undefined ? _data["valutaNonEuro"] : null as any;
            this.idValuta = _data["idValuta"] !== undefined ? _data["idValuta"] : null as any;
            this.codiceValuta = _data["codiceValuta"] !== undefined ? _data["codiceValuta"] : null as any;
            this.conversioneValuta = _data["conversioneValuta"] !== undefined ? _data["conversioneValuta"] : null as any;
        }
    }

    static fromJS(data: any): OrderListRow {
        data = typeof data === 'object' ? data : {};
        let result = new OrderListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["clienti"] = this.clienti !== undefined ? this.clienti : null as any;
        data["destinazione"] = this.destinazione !== undefined ? this.destinazione : null as any;
        data["creazione"] = this.creazione !== undefined ? this.creazione : null as any;
        data["partenza"] = this.partenza !== undefined ? this.partenza : null as any;
        data["conferma"] = this.conferma !== undefined ? this.conferma : null as any;
        data["totale"] = this.totale !== undefined ? this.totale : null as any;
        data["totaleValuta"] = this.totaleValuta !== undefined ? this.totaleValuta : null as any;
        data["agenzia"] = this.agenzia !== undefined ? this.agenzia : null as any;
        data["telefono"] = this.telefono !== undefined ? this.telefono : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["categoriaAgenzia"] = this.categoriaAgenzia !== undefined ? this.categoriaAgenzia : null as any;
        data["impiegato"] = this.impiegato !== undefined ? this.impiegato : null as any;
        data["utentePreventivo"] = this.utentePreventivo !== undefined ? this.utentePreventivo : null as any;
        data["utenteConferma"] = this.utenteConferma !== undefined ? this.utenteConferma : null as any;
        data["annullataTO"] = this.annullataTO !== undefined ? this.annullataTO : null as any;
        data["annullataADV"] = this.annullataADV !== undefined ? this.annullataADV : null as any;
        data["sales"] = this.sales !== undefined ? this.sales : null as any;
        data["pagamento"] = this.pagamento !== undefined ? this.pagamento : null as any;
        data["saldato"] = this.saldato !== undefined ? this.saldato : null as any;
        data["saldatoValuta"] = this.saldatoValuta !== undefined ? this.saldatoValuta : null as any;
        data["compensato"] = this.compensato !== undefined ? this.compensato : null as any;
        data["compensatoValuta"] = this.compensatoValuta !== undefined ? this.compensatoValuta : null as any;
        data["saldare"] = this.saldare !== undefined ? this.saldare : null as any;
        data["saldareValuta"] = this.saldareValuta !== undefined ? this.saldareValuta : null as any;
        data["duplicabileAgenzia"] = this.duplicabileAgenzia !== undefined ? this.duplicabileAgenzia : null as any;
        data["coverUrl"] = this.coverUrl !== undefined ? this.coverUrl : null as any;
        data["valutaNonEuro"] = this.valutaNonEuro !== undefined ? this.valutaNonEuro : null as any;
        data["idValuta"] = this.idValuta !== undefined ? this.idValuta : null as any;
        data["codiceValuta"] = this.codiceValuta !== undefined ? this.codiceValuta : null as any;
        data["conversioneValuta"] = this.conversioneValuta !== undefined ? this.conversioneValuta : null as any;
        return data;
    }
}

export interface IOrderListRow {
    offertaID?: number;
    descrizione?: string | null;
    clienti?: string | null;
    destinazione?: string | null;
    creazione?: string;
    partenza?: string;
    conferma?: string | null;
    totale?: number;
    totaleValuta?: number;
    agenzia?: string | null;
    telefono?: string | null;
    email?: string | null;
    categoriaAgenzia?: string | null;
    impiegato?: string | null;
    utentePreventivo?: string | null;
    utenteConferma?: string | null;
    annullataTO?: boolean;
    annullataADV?: boolean;
    sales?: string | null;
    pagamento?: string | null;
    saldato?: number;
    saldatoValuta?: number;
    compensato?: number;
    compensatoValuta?: number;
    saldare?: number;
    saldareValuta?: number;
    duplicabileAgenzia?: boolean;
    coverUrl?: string | null;
    valutaNonEuro?: boolean;
    idValuta?: number;
    codiceValuta?: string;
    conversioneValuta?: number;
}

export class SearchOrdersRequest extends SiteRequest implements ISearchOrdersRequest {
    offertaID?: number | null;
    agenziaID?: number | null;
    impiegatoID?: number | null;
    soloUtente?: boolean;
    soloConfermate?: boolean;
    soloIncomplete?: boolean;
    soloAnnullate?: boolean;
    dataCreazione?: string | null;
    operatore?: EOperatore | null;
    partenzaDal?: string | null;
    partenzaAl?: string | null;
    confermaDal?: string | null;
    confermaAl?: string | null;
    descrizione?: string | null;
    nomePax?: string | null;
    servizioID?: number | null;
    partitaIva?: string | null;

    constructor(data?: ISearchOrdersRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.agenziaID = _data["agenziaID"] !== undefined ? _data["agenziaID"] : null as any;
            this.impiegatoID = _data["impiegatoID"] !== undefined ? _data["impiegatoID"] : null as any;
            this.soloUtente = _data["soloUtente"] !== undefined ? _data["soloUtente"] : null as any;
            this.soloConfermate = _data["soloConfermate"] !== undefined ? _data["soloConfermate"] : null as any;
            this.soloIncomplete = _data["soloIncomplete"] !== undefined ? _data["soloIncomplete"] : null as any;
            this.soloAnnullate = _data["soloAnnullate"] !== undefined ? _data["soloAnnullate"] : null as any;
            this.dataCreazione = _data["dataCreazione"] !== undefined ? _data["dataCreazione"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.partenzaDal = _data["partenzaDal"] !== undefined ? _data["partenzaDal"] : null as any;
            this.partenzaAl = _data["partenzaAl"] !== undefined ? _data["partenzaAl"] : null as any;
            this.confermaDal = _data["confermaDal"] !== undefined ? _data["confermaDal"] : null as any;
            this.confermaAl = _data["confermaAl"] !== undefined ? _data["confermaAl"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.nomePax = _data["nomePax"] !== undefined ? _data["nomePax"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.partitaIva = _data["partitaIva"] !== undefined ? _data["partitaIva"] : null as any;
        }
    }

    static override fromJS(data: any): SearchOrdersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchOrdersRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["agenziaID"] = this.agenziaID !== undefined ? this.agenziaID : null as any;
        data["impiegatoID"] = this.impiegatoID !== undefined ? this.impiegatoID : null as any;
        data["soloUtente"] = this.soloUtente !== undefined ? this.soloUtente : null as any;
        data["soloConfermate"] = this.soloConfermate !== undefined ? this.soloConfermate : null as any;
        data["soloIncomplete"] = this.soloIncomplete !== undefined ? this.soloIncomplete : null as any;
        data["soloAnnullate"] = this.soloAnnullate !== undefined ? this.soloAnnullate : null as any;
        data["dataCreazione"] = this.dataCreazione !== undefined ? this.dataCreazione : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["partenzaDal"] = this.partenzaDal !== undefined ? this.partenzaDal : null as any;
        data["partenzaAl"] = this.partenzaAl !== undefined ? this.partenzaAl : null as any;
        data["confermaDal"] = this.confermaDal !== undefined ? this.confermaDal : null as any;
        data["confermaAl"] = this.confermaAl !== undefined ? this.confermaAl : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["nomePax"] = this.nomePax !== undefined ? this.nomePax : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["partitaIva"] = this.partitaIva !== undefined ? this.partitaIva : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchOrdersRequest extends ISiteRequest {
    offertaID?: number | null;
    agenziaID?: number | null;
    impiegatoID?: number | null;
    soloUtente?: boolean;
    soloConfermate?: boolean;
    soloIncomplete?: boolean;
    soloAnnullate?: boolean;
    dataCreazione?: string | null;
    operatore?: EOperatore | null;
    partenzaDal?: string | null;
    partenzaAl?: string | null;
    confermaDal?: string | null;
    confermaAl?: string | null;
    descrizione?: string | null;
    nomePax?: string | null;
    servizioID?: number | null;
    partitaIva?: string | null;
}

export class NrTableResponseOfConfirmSearchResponseRow extends OkApiResponse implements INrTableResponseOfConfirmSearchResponseRow {
    /** Array delle righe della pagina richiesta */
    rows?: ConfirmSearchResponseRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfConfirmSearchResponseRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ConfirmSearchResponseRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfConfirmSearchResponseRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfConfirmSearchResponseRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfConfirmSearchResponseRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: ConfirmSearchResponseRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class ConfirmSearchResponseRow implements IConfirmSearchResponseRow {
    offertaID?: number;
    offertaDatoID?: number;
    partenza?: string;
    conferma?: string | null;
    fornitore?: string | null;
    tipo?: ETipoServizio | null;
    servizio?: string | null;
    disponibilita?: EStatoDisponibilitaConferma;
    prenotazione?: string | null;
    confermaTO?: string | null;
    ottimizzataIl?: string | null;
    costoOttimizzato?: number | null;
    deltaOttimizzato?: number | null;
    deltaPositivo?: boolean;
    costoCorrente?: number;
    codiceValuta?: string | null;
    fornitoreOttimizzato?: string | null;
    descrizioneOttimizzato?: string | null;
    luogoID?: number | null;
    luogo?: string | null;
    abbinamentoID?: number;
    abbinamento?: string | null;
    luogoUrl?: string | null;
    stepID?: number;
    servizioID?: number | null;
    dal?: string;
    al?: string;
    canReplace?: boolean;
    numeroConfermaFornitore?: string | null;
    numeroConfermaNaar?: string | null;
    status?: EStatusServizio | null;

    constructor(data?: IConfirmSearchResponseRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : null as any;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : null as any;
            this.conferma = _data["conferma"] !== undefined ? _data["conferma"] : null as any;
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : null as any;
            this.disponibilita = _data["disponibilita"] !== undefined ? _data["disponibilita"] : null as any;
            this.prenotazione = _data["prenotazione"] !== undefined ? _data["prenotazione"] : null as any;
            this.confermaTO = _data["confermaTO"] !== undefined ? _data["confermaTO"] : null as any;
            this.ottimizzataIl = _data["ottimizzataIl"] !== undefined ? _data["ottimizzataIl"] : null as any;
            this.costoOttimizzato = _data["costoOttimizzato"] !== undefined ? _data["costoOttimizzato"] : null as any;
            this.deltaOttimizzato = _data["deltaOttimizzato"] !== undefined ? _data["deltaOttimizzato"] : null as any;
            this.deltaPositivo = _data["deltaPositivo"] !== undefined ? _data["deltaPositivo"] : null as any;
            this.costoCorrente = _data["costoCorrente"] !== undefined ? _data["costoCorrente"] : null as any;
            this.codiceValuta = _data["codiceValuta"] !== undefined ? _data["codiceValuta"] : null as any;
            this.fornitoreOttimizzato = _data["fornitoreOttimizzato"] !== undefined ? _data["fornitoreOttimizzato"] : null as any;
            this.descrizioneOttimizzato = _data["descrizioneOttimizzato"] !== undefined ? _data["descrizioneOttimizzato"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.abbinamentoID = _data["abbinamentoID"] !== undefined ? _data["abbinamentoID"] : null as any;
            this.abbinamento = _data["abbinamento"] !== undefined ? _data["abbinamento"] : null as any;
            this.luogoUrl = _data["luogoUrl"] !== undefined ? _data["luogoUrl"] : null as any;
            this.stepID = _data["stepID"] !== undefined ? _data["stepID"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.al = _data["al"] !== undefined ? _data["al"] : null as any;
            this.canReplace = _data["canReplace"] !== undefined ? _data["canReplace"] : null as any;
            this.numeroConfermaFornitore = _data["numeroConfermaFornitore"] !== undefined ? _data["numeroConfermaFornitore"] : null as any;
            this.numeroConfermaNaar = _data["numeroConfermaNaar"] !== undefined ? _data["numeroConfermaNaar"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
        }
    }

    static fromJS(data: any): ConfirmSearchResponseRow {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmSearchResponseRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : null as any;
        data["partenza"] = this.partenza !== undefined ? this.partenza : null as any;
        data["conferma"] = this.conferma !== undefined ? this.conferma : null as any;
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["servizio"] = this.servizio !== undefined ? this.servizio : null as any;
        data["disponibilita"] = this.disponibilita !== undefined ? this.disponibilita : null as any;
        data["prenotazione"] = this.prenotazione !== undefined ? this.prenotazione : null as any;
        data["confermaTO"] = this.confermaTO !== undefined ? this.confermaTO : null as any;
        data["ottimizzataIl"] = this.ottimizzataIl !== undefined ? this.ottimizzataIl : null as any;
        data["costoOttimizzato"] = this.costoOttimizzato !== undefined ? this.costoOttimizzato : null as any;
        data["deltaOttimizzato"] = this.deltaOttimizzato !== undefined ? this.deltaOttimizzato : null as any;
        data["deltaPositivo"] = this.deltaPositivo !== undefined ? this.deltaPositivo : null as any;
        data["costoCorrente"] = this.costoCorrente !== undefined ? this.costoCorrente : null as any;
        data["codiceValuta"] = this.codiceValuta !== undefined ? this.codiceValuta : null as any;
        data["fornitoreOttimizzato"] = this.fornitoreOttimizzato !== undefined ? this.fornitoreOttimizzato : null as any;
        data["descrizioneOttimizzato"] = this.descrizioneOttimizzato !== undefined ? this.descrizioneOttimizzato : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["abbinamentoID"] = this.abbinamentoID !== undefined ? this.abbinamentoID : null as any;
        data["abbinamento"] = this.abbinamento !== undefined ? this.abbinamento : null as any;
        data["luogoUrl"] = this.luogoUrl !== undefined ? this.luogoUrl : null as any;
        data["stepID"] = this.stepID !== undefined ? this.stepID : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["al"] = this.al !== undefined ? this.al : null as any;
        data["canReplace"] = this.canReplace !== undefined ? this.canReplace : null as any;
        data["numeroConfermaFornitore"] = this.numeroConfermaFornitore !== undefined ? this.numeroConfermaFornitore : null as any;
        data["numeroConfermaNaar"] = this.numeroConfermaNaar !== undefined ? this.numeroConfermaNaar : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        return data;
    }
}

export interface IConfirmSearchResponseRow {
    offertaID?: number;
    offertaDatoID?: number;
    partenza?: string;
    conferma?: string | null;
    fornitore?: string | null;
    tipo?: ETipoServizio | null;
    servizio?: string | null;
    disponibilita?: EStatoDisponibilitaConferma;
    prenotazione?: string | null;
    confermaTO?: string | null;
    ottimizzataIl?: string | null;
    costoOttimizzato?: number | null;
    deltaOttimizzato?: number | null;
    deltaPositivo?: boolean;
    costoCorrente?: number;
    codiceValuta?: string | null;
    fornitoreOttimizzato?: string | null;
    descrizioneOttimizzato?: string | null;
    luogoID?: number | null;
    luogo?: string | null;
    abbinamentoID?: number;
    abbinamento?: string | null;
    luogoUrl?: string | null;
    stepID?: number;
    servizioID?: number | null;
    dal?: string;
    al?: string;
    canReplace?: boolean;
    numeroConfermaFornitore?: string | null;
    numeroConfermaNaar?: string | null;
    status?: EStatusServizio | null;
}

export enum EStatoDisponibilitaConferma {
    NonDisponibile = "NonDisponibile",
    Cancellata = "Cancellata",
    Ok = "Ok",
    OkAllotment = "OkAllotment",
    OnRequestReg = "OnRequestReg",
    OnRequest = "OnRequest",
}

export class SearchConfirmsRequest extends NrTableRequest implements ISearchConfirmsRequest {
    operatore?: EOperatore;
    confermaDal?: string | null;
    confermaAl?: string | null;
    partenzaDal?: string | null;
    partenzaAl?: string | null;
    contattoFornitoreID?: number | null;
    status?: ConfirmSearchStatus | null;
    tipoServizio?: ETipoServizio | null;
    numeroConferma?: string | null;
    nascondiSeriviziAccessori?: boolean | null;

    constructor(data?: ISearchConfirmsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.confermaDal = _data["confermaDal"] !== undefined ? _data["confermaDal"] : null as any;
            this.confermaAl = _data["confermaAl"] !== undefined ? _data["confermaAl"] : null as any;
            this.partenzaDal = _data["partenzaDal"] !== undefined ? _data["partenzaDal"] : null as any;
            this.partenzaAl = _data["partenzaAl"] !== undefined ? _data["partenzaAl"] : null as any;
            this.contattoFornitoreID = _data["contattoFornitoreID"] !== undefined ? _data["contattoFornitoreID"] : null as any;
            this.status = _data["status"] ? ConfirmSearchStatus.fromJS(_data["status"]) : null as any;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
            this.numeroConferma = _data["numeroConferma"] !== undefined ? _data["numeroConferma"] : null as any;
            this.nascondiSeriviziAccessori = _data["nascondiSeriviziAccessori"] !== undefined ? _data["nascondiSeriviziAccessori"] : null as any;
        }
    }

    static override fromJS(data: any): SearchConfirmsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchConfirmsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["confermaDal"] = this.confermaDal !== undefined ? this.confermaDal : null as any;
        data["confermaAl"] = this.confermaAl !== undefined ? this.confermaAl : null as any;
        data["partenzaDal"] = this.partenzaDal !== undefined ? this.partenzaDal : null as any;
        data["partenzaAl"] = this.partenzaAl !== undefined ? this.partenzaAl : null as any;
        data["contattoFornitoreID"] = this.contattoFornitoreID !== undefined ? this.contattoFornitoreID : null as any;
        data["status"] = this.status ? this.status.toJSON() : null as any;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        data["numeroConferma"] = this.numeroConferma !== undefined ? this.numeroConferma : null as any;
        data["nascondiSeriviziAccessori"] = this.nascondiSeriviziAccessori !== undefined ? this.nascondiSeriviziAccessori : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchConfirmsRequest extends INrTableRequest {
    operatore?: EOperatore;
    confermaDal?: string | null;
    confermaAl?: string | null;
    partenzaDal?: string | null;
    partenzaAl?: string | null;
    contattoFornitoreID?: number | null;
    status?: ConfirmSearchStatus | null;
    tipoServizio?: ETipoServizio | null;
    numeroConferma?: string | null;
    nascondiSeriviziAccessori?: boolean | null;
}

export class ConfirmSearchStatus implements IConfirmSearchStatus {
    man?: boolean;
    pren?: boolean;
    inPren?: boolean;
    conf?: boolean;
    nonConf?: boolean;
    daCanc?: boolean;
    inCanc?: boolean;
    canc?: boolean;
    hasValue?: boolean;

    constructor(data?: IConfirmSearchStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.man = _data["man"] !== undefined ? _data["man"] : null as any;
            this.pren = _data["pren"] !== undefined ? _data["pren"] : null as any;
            this.inPren = _data["inPren"] !== undefined ? _data["inPren"] : null as any;
            this.conf = _data["conf"] !== undefined ? _data["conf"] : null as any;
            this.nonConf = _data["nonConf"] !== undefined ? _data["nonConf"] : null as any;
            this.daCanc = _data["daCanc"] !== undefined ? _data["daCanc"] : null as any;
            this.inCanc = _data["inCanc"] !== undefined ? _data["inCanc"] : null as any;
            this.canc = _data["canc"] !== undefined ? _data["canc"] : null as any;
            this.hasValue = _data["hasValue"] !== undefined ? _data["hasValue"] : null as any;
        }
    }

    static fromJS(data: any): ConfirmSearchStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmSearchStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["man"] = this.man !== undefined ? this.man : null as any;
        data["pren"] = this.pren !== undefined ? this.pren : null as any;
        data["inPren"] = this.inPren !== undefined ? this.inPren : null as any;
        data["conf"] = this.conf !== undefined ? this.conf : null as any;
        data["nonConf"] = this.nonConf !== undefined ? this.nonConf : null as any;
        data["daCanc"] = this.daCanc !== undefined ? this.daCanc : null as any;
        data["inCanc"] = this.inCanc !== undefined ? this.inCanc : null as any;
        data["canc"] = this.canc !== undefined ? this.canc : null as any;
        data["hasValue"] = this.hasValue !== undefined ? this.hasValue : null as any;
        return data;
    }
}

export interface IConfirmSearchStatus {
    man?: boolean;
    pren?: boolean;
    inPren?: boolean;
    conf?: boolean;
    nonConf?: boolean;
    daCanc?: boolean;
    inCanc?: boolean;
    canc?: boolean;
    hasValue?: boolean;
}

export class NrTableResponseOfSearchDocumentsResponseRow extends OkApiResponse implements INrTableResponseOfSearchDocumentsResponseRow {
    /** Array delle righe della pagina richiesta */
    rows?: SearchDocumentsResponseRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfSearchDocumentsResponseRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(SearchDocumentsResponseRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfSearchDocumentsResponseRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfSearchDocumentsResponseRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfSearchDocumentsResponseRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: SearchDocumentsResponseRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class SearchDocumentsResponseRow implements ISearchDocumentsResponseRow {
    offertaID?: number;
    operatore?: string | null;
    team?: string | null;
    adv?: string | null;
    dataPartenza?: string;
    dataConferma?: string | null;
    dataRientro?: string | null;
    dataRilascioDoc?: string | null;
    dest?: string | null;
    preventivo?: string | null;
    conferma?: string | null;
    documenti?: string | null;
    tipoQI?: string | null;
    pagamento?: string | null;
    statusDoc?: string | null;
    creaApp?: string | null;
    spedizione?: string | null;
    totNetto?: number | null;
    acconto?: number | null;
    dataAcconto?: string | null;
    saldo?: number | null;
    dataSaldo?: string | null;
    totale?: number | null;
    pax?: number | null;

    constructor(data?: ISearchDocumentsResponseRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.team = _data["team"] !== undefined ? _data["team"] : null as any;
            this.adv = _data["adv"] !== undefined ? _data["adv"] : null as any;
            this.dataPartenza = _data["dataPartenza"] !== undefined ? _data["dataPartenza"] : null as any;
            this.dataConferma = _data["dataConferma"] !== undefined ? _data["dataConferma"] : null as any;
            this.dataRientro = _data["dataRientro"] !== undefined ? _data["dataRientro"] : null as any;
            this.dataRilascioDoc = _data["dataRilascioDoc"] !== undefined ? _data["dataRilascioDoc"] : null as any;
            this.dest = _data["dest"] !== undefined ? _data["dest"] : null as any;
            this.preventivo = _data["preventivo"] !== undefined ? _data["preventivo"] : null as any;
            this.conferma = _data["conferma"] !== undefined ? _data["conferma"] : null as any;
            this.documenti = _data["documenti"] !== undefined ? _data["documenti"] : null as any;
            this.tipoQI = _data["tipoQI"] !== undefined ? _data["tipoQI"] : null as any;
            this.pagamento = _data["pagamento"] !== undefined ? _data["pagamento"] : null as any;
            this.statusDoc = _data["statusDoc"] !== undefined ? _data["statusDoc"] : null as any;
            this.creaApp = _data["creaApp"] !== undefined ? _data["creaApp"] : null as any;
            this.spedizione = _data["spedizione"] !== undefined ? _data["spedizione"] : null as any;
            this.totNetto = _data["totNetto"] !== undefined ? _data["totNetto"] : null as any;
            this.acconto = _data["acconto"] !== undefined ? _data["acconto"] : null as any;
            this.dataAcconto = _data["dataAcconto"] !== undefined ? _data["dataAcconto"] : null as any;
            this.saldo = _data["saldo"] !== undefined ? _data["saldo"] : null as any;
            this.dataSaldo = _data["dataSaldo"] !== undefined ? _data["dataSaldo"] : null as any;
            this.totale = _data["totale"] !== undefined ? _data["totale"] : null as any;
            this.pax = _data["pax"] !== undefined ? _data["pax"] : null as any;
        }
    }

    static fromJS(data: any): SearchDocumentsResponseRow {
        data = typeof data === 'object' ? data : {};
        let result = new SearchDocumentsResponseRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["team"] = this.team !== undefined ? this.team : null as any;
        data["adv"] = this.adv !== undefined ? this.adv : null as any;
        data["dataPartenza"] = this.dataPartenza !== undefined ? this.dataPartenza : null as any;
        data["dataConferma"] = this.dataConferma !== undefined ? this.dataConferma : null as any;
        data["dataRientro"] = this.dataRientro !== undefined ? this.dataRientro : null as any;
        data["dataRilascioDoc"] = this.dataRilascioDoc !== undefined ? this.dataRilascioDoc : null as any;
        data["dest"] = this.dest !== undefined ? this.dest : null as any;
        data["preventivo"] = this.preventivo !== undefined ? this.preventivo : null as any;
        data["conferma"] = this.conferma !== undefined ? this.conferma : null as any;
        data["documenti"] = this.documenti !== undefined ? this.documenti : null as any;
        data["tipoQI"] = this.tipoQI !== undefined ? this.tipoQI : null as any;
        data["pagamento"] = this.pagamento !== undefined ? this.pagamento : null as any;
        data["statusDoc"] = this.statusDoc !== undefined ? this.statusDoc : null as any;
        data["creaApp"] = this.creaApp !== undefined ? this.creaApp : null as any;
        data["spedizione"] = this.spedizione !== undefined ? this.spedizione : null as any;
        data["totNetto"] = this.totNetto !== undefined ? this.totNetto : null as any;
        data["acconto"] = this.acconto !== undefined ? this.acconto : null as any;
        data["dataAcconto"] = this.dataAcconto !== undefined ? this.dataAcconto : null as any;
        data["saldo"] = this.saldo !== undefined ? this.saldo : null as any;
        data["dataSaldo"] = this.dataSaldo !== undefined ? this.dataSaldo : null as any;
        data["totale"] = this.totale !== undefined ? this.totale : null as any;
        data["pax"] = this.pax !== undefined ? this.pax : null as any;
        return data;
    }
}

export interface ISearchDocumentsResponseRow {
    offertaID?: number;
    operatore?: string | null;
    team?: string | null;
    adv?: string | null;
    dataPartenza?: string;
    dataConferma?: string | null;
    dataRientro?: string | null;
    dataRilascioDoc?: string | null;
    dest?: string | null;
    preventivo?: string | null;
    conferma?: string | null;
    documenti?: string | null;
    tipoQI?: string | null;
    pagamento?: string | null;
    statusDoc?: string | null;
    creaApp?: string | null;
    spedizione?: string | null;
    totNetto?: number | null;
    acconto?: number | null;
    dataAcconto?: string | null;
    saldo?: number | null;
    dataSaldo?: string | null;
    totale?: number | null;
    pax?: number | null;
}

export class SearchDocumentsRequest extends NrTableRequest implements ISearchDocumentsRequest {
    luoghi?: SearchDocumentsLuoghi | null;
    confermaDal?: string;
    confermaAl?: string;

    constructor(data?: ISearchDocumentsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luoghi = _data["luoghi"] ? SearchDocumentsLuoghi.fromJS(_data["luoghi"]) : null as any;
            this.confermaDal = _data["confermaDal"] !== undefined ? _data["confermaDal"] : null as any;
            this.confermaAl = _data["confermaAl"] !== undefined ? _data["confermaAl"] : null as any;
        }
    }

    static override fromJS(data: any): SearchDocumentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchDocumentsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luoghi"] = this.luoghi ? this.luoghi.toJSON() : null as any;
        data["confermaDal"] = this.confermaDal !== undefined ? this.confermaDal : null as any;
        data["confermaAl"] = this.confermaAl !== undefined ? this.confermaAl : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchDocumentsRequest extends INrTableRequest {
    luoghi?: SearchDocumentsLuoghi | null;
    confermaDal?: string;
    confermaAl?: string;
}

export class SearchDocumentsLuoghi implements ISearchDocumentsLuoghi {
    americhe?: boolean;
    caraibi?: boolean;
    sudPacifico?: boolean;
    ocIndiano?: boolean;
    australia?: boolean;
    oriente?: boolean;
    africa?: boolean;
    sE_Asia?: boolean;
    hasValue?: boolean;

    constructor(data?: ISearchDocumentsLuoghi) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.americhe = _data["americhe"] !== undefined ? _data["americhe"] : null as any;
            this.caraibi = _data["caraibi"] !== undefined ? _data["caraibi"] : null as any;
            this.sudPacifico = _data["sudPacifico"] !== undefined ? _data["sudPacifico"] : null as any;
            this.ocIndiano = _data["ocIndiano"] !== undefined ? _data["ocIndiano"] : null as any;
            this.australia = _data["australia"] !== undefined ? _data["australia"] : null as any;
            this.oriente = _data["oriente"] !== undefined ? _data["oriente"] : null as any;
            this.africa = _data["africa"] !== undefined ? _data["africa"] : null as any;
            this.sE_Asia = _data["sE_Asia"] !== undefined ? _data["sE_Asia"] : null as any;
            this.hasValue = _data["hasValue"] !== undefined ? _data["hasValue"] : null as any;
        }
    }

    static fromJS(data: any): SearchDocumentsLuoghi {
        data = typeof data === 'object' ? data : {};
        let result = new SearchDocumentsLuoghi();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["americhe"] = this.americhe !== undefined ? this.americhe : null as any;
        data["caraibi"] = this.caraibi !== undefined ? this.caraibi : null as any;
        data["sudPacifico"] = this.sudPacifico !== undefined ? this.sudPacifico : null as any;
        data["ocIndiano"] = this.ocIndiano !== undefined ? this.ocIndiano : null as any;
        data["australia"] = this.australia !== undefined ? this.australia : null as any;
        data["oriente"] = this.oriente !== undefined ? this.oriente : null as any;
        data["africa"] = this.africa !== undefined ? this.africa : null as any;
        data["sE_Asia"] = this.sE_Asia !== undefined ? this.sE_Asia : null as any;
        data["hasValue"] = this.hasValue !== undefined ? this.hasValue : null as any;
        return data;
    }
}

export interface ISearchDocumentsLuoghi {
    americhe?: boolean;
    caraibi?: boolean;
    sudPacifico?: boolean;
    ocIndiano?: boolean;
    australia?: boolean;
    oriente?: boolean;
    africa?: boolean;
    sE_Asia?: boolean;
    hasValue?: boolean;
}

export class NrTableResponseOfSearchEmailsResponseRow extends OkApiResponse implements INrTableResponseOfSearchEmailsResponseRow {
    /** Array delle righe della pagina richiesta */
    rows?: SearchEmailsResponseRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfSearchEmailsResponseRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(SearchEmailsResponseRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfSearchEmailsResponseRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfSearchEmailsResponseRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfSearchEmailsResponseRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: SearchEmailsResponseRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class SearchEmailsResponseRow implements ISearchEmailsResponseRow {
    documentoID?: number;
    offertaID?: number;
    data?: string;
    testata?: string | null;
    corpo?: string | null;
    corpo2?: string | null;
    isEmailLink?: boolean;
    emailUrl?: string | null;
    urlAllegato?: string | null;
    nome?: string | null;
    nomeAllegato?: string | null;
    nomeContatto?: string | null;
    dimensioneAllegato?: number | null;
    spedito?: string | null;
    contatoreSpedizioni?: number | null;

    constructor(data?: ISearchEmailsResponseRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
            this.testata = _data["testata"] !== undefined ? _data["testata"] : null as any;
            this.corpo = _data["corpo"] !== undefined ? _data["corpo"] : null as any;
            this.corpo2 = _data["corpo2"] !== undefined ? _data["corpo2"] : null as any;
            this.isEmailLink = _data["isEmailLink"] !== undefined ? _data["isEmailLink"] : null as any;
            this.emailUrl = _data["emailUrl"] !== undefined ? _data["emailUrl"] : null as any;
            this.urlAllegato = _data["urlAllegato"] !== undefined ? _data["urlAllegato"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nomeAllegato = _data["nomeAllegato"] !== undefined ? _data["nomeAllegato"] : null as any;
            this.nomeContatto = _data["nomeContatto"] !== undefined ? _data["nomeContatto"] : null as any;
            this.dimensioneAllegato = _data["dimensioneAllegato"] !== undefined ? _data["dimensioneAllegato"] : null as any;
            this.spedito = _data["spedito"] !== undefined ? _data["spedito"] : null as any;
            this.contatoreSpedizioni = _data["contatoreSpedizioni"] !== undefined ? _data["contatoreSpedizioni"] : null as any;
        }
    }

    static fromJS(data: any): SearchEmailsResponseRow {
        data = typeof data === 'object' ? data : {};
        let result = new SearchEmailsResponseRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["testata"] = this.testata !== undefined ? this.testata : null as any;
        data["corpo"] = this.corpo !== undefined ? this.corpo : null as any;
        data["corpo2"] = this.corpo2 !== undefined ? this.corpo2 : null as any;
        data["isEmailLink"] = this.isEmailLink !== undefined ? this.isEmailLink : null as any;
        data["emailUrl"] = this.emailUrl !== undefined ? this.emailUrl : null as any;
        data["urlAllegato"] = this.urlAllegato !== undefined ? this.urlAllegato : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nomeAllegato"] = this.nomeAllegato !== undefined ? this.nomeAllegato : null as any;
        data["nomeContatto"] = this.nomeContatto !== undefined ? this.nomeContatto : null as any;
        data["dimensioneAllegato"] = this.dimensioneAllegato !== undefined ? this.dimensioneAllegato : null as any;
        data["spedito"] = this.spedito !== undefined ? this.spedito : null as any;
        data["contatoreSpedizioni"] = this.contatoreSpedizioni !== undefined ? this.contatoreSpedizioni : null as any;
        return data;
    }
}

export interface ISearchEmailsResponseRow {
    documentoID?: number;
    offertaID?: number;
    data?: string;
    testata?: string | null;
    corpo?: string | null;
    corpo2?: string | null;
    isEmailLink?: boolean;
    emailUrl?: string | null;
    urlAllegato?: string | null;
    nome?: string | null;
    nomeAllegato?: string | null;
    nomeContatto?: string | null;
    dimensioneAllegato?: number | null;
    spedito?: string | null;
    contatoreSpedizioni?: number | null;
}

export class SearchEmailsRequest extends NrTableRequest implements ISearchEmailsRequest {
    agenziaID?: number | null;
    impiegatoID?: number | null;
    operatore?: EOperatore;
    confermaDal?: string | null;
    confermaAl?: string | null;
    partenzaDal?: string | null;
    partenzaAl?: string | null;
    inserimentoDal?: string | null;
    inserimentoAl?: string | null;

    constructor(data?: ISearchEmailsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agenziaID = _data["agenziaID"] !== undefined ? _data["agenziaID"] : null as any;
            this.impiegatoID = _data["impiegatoID"] !== undefined ? _data["impiegatoID"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.confermaDal = _data["confermaDal"] !== undefined ? _data["confermaDal"] : null as any;
            this.confermaAl = _data["confermaAl"] !== undefined ? _data["confermaAl"] : null as any;
            this.partenzaDal = _data["partenzaDal"] !== undefined ? _data["partenzaDal"] : null as any;
            this.partenzaAl = _data["partenzaAl"] !== undefined ? _data["partenzaAl"] : null as any;
            this.inserimentoDal = _data["inserimentoDal"] !== undefined ? _data["inserimentoDal"] : null as any;
            this.inserimentoAl = _data["inserimentoAl"] !== undefined ? _data["inserimentoAl"] : null as any;
        }
    }

    static override fromJS(data: any): SearchEmailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchEmailsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agenziaID"] = this.agenziaID !== undefined ? this.agenziaID : null as any;
        data["impiegatoID"] = this.impiegatoID !== undefined ? this.impiegatoID : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["confermaDal"] = this.confermaDal !== undefined ? this.confermaDal : null as any;
        data["confermaAl"] = this.confermaAl !== undefined ? this.confermaAl : null as any;
        data["partenzaDal"] = this.partenzaDal !== undefined ? this.partenzaDal : null as any;
        data["partenzaAl"] = this.partenzaAl !== undefined ? this.partenzaAl : null as any;
        data["inserimentoDal"] = this.inserimentoDal !== undefined ? this.inserimentoDal : null as any;
        data["inserimentoAl"] = this.inserimentoAl !== undefined ? this.inserimentoAl : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchEmailsRequest extends INrTableRequest {
    agenziaID?: number | null;
    impiegatoID?: number | null;
    operatore?: EOperatore;
    confermaDal?: string | null;
    confermaAl?: string | null;
    partenzaDal?: string | null;
    partenzaAl?: string | null;
    inserimentoDal?: string | null;
    inserimentoAl?: string | null;
}

export class NrTableResponseOfSearchNoteResponseRow extends OkApiResponse implements INrTableResponseOfSearchNoteResponseRow {
    /** Array delle righe della pagina richiesta */
    rows?: SearchNoteResponseRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfSearchNoteResponseRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(SearchNoteResponseRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfSearchNoteResponseRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfSearchNoteResponseRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfSearchNoteResponseRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: SearchNoteResponseRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class SearchNoteResponseRow implements ISearchNoteResponseRow {
    offertaNotaID?: number;
    offertaID?: number;
    offertaDatoID?: number | null;
    accordoID?: number | null;
    testo?: string | null;
    data?: string;
    fatto?: boolean;
    pubblica?: boolean;
    voucher?: boolean;
    kanban?: boolean;
    sistema?: boolean;
    tipo?: ETipoNota | null;
    utente?: string | null;
    utentePresaInCarico?: string | null;

    constructor(data?: ISearchNoteResponseRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaNotaID = _data["offertaNotaID"] !== undefined ? _data["offertaNotaID"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : null as any;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
            this.fatto = _data["fatto"] !== undefined ? _data["fatto"] : null as any;
            this.pubblica = _data["pubblica"] !== undefined ? _data["pubblica"] : null as any;
            this.voucher = _data["voucher"] !== undefined ? _data["voucher"] : null as any;
            this.kanban = _data["kanban"] !== undefined ? _data["kanban"] : null as any;
            this.sistema = _data["sistema"] !== undefined ? _data["sistema"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.utente = _data["utente"] !== undefined ? _data["utente"] : null as any;
            this.utentePresaInCarico = _data["utentePresaInCarico"] !== undefined ? _data["utentePresaInCarico"] : null as any;
        }
    }

    static fromJS(data: any): SearchNoteResponseRow {
        data = typeof data === 'object' ? data : {};
        let result = new SearchNoteResponseRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaNotaID"] = this.offertaNotaID !== undefined ? this.offertaNotaID : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : null as any;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["testo"] = this.testo !== undefined ? this.testo : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["fatto"] = this.fatto !== undefined ? this.fatto : null as any;
        data["pubblica"] = this.pubblica !== undefined ? this.pubblica : null as any;
        data["voucher"] = this.voucher !== undefined ? this.voucher : null as any;
        data["kanban"] = this.kanban !== undefined ? this.kanban : null as any;
        data["sistema"] = this.sistema !== undefined ? this.sistema : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["utente"] = this.utente !== undefined ? this.utente : null as any;
        data["utentePresaInCarico"] = this.utentePresaInCarico !== undefined ? this.utentePresaInCarico : null as any;
        return data;
    }
}

export interface ISearchNoteResponseRow {
    offertaNotaID?: number;
    offertaID?: number;
    offertaDatoID?: number | null;
    accordoID?: number | null;
    testo?: string | null;
    data?: string;
    fatto?: boolean;
    pubblica?: boolean;
    voucher?: boolean;
    kanban?: boolean;
    sistema?: boolean;
    tipo?: ETipoNota | null;
    utente?: string | null;
    utentePresaInCarico?: string | null;
}

export class SearchNoteRequest extends NrTableRequest implements ISearchNoteRequest {
    agenziaID?: number | null;
    impiegatoID?: number | null;
    impiegatoPresaInCaricoID?: number | null;
    operatore?: EOperatore;
    confermaDal?: string | null;
    confermaAl?: string | null;
    partenzaDal?: string | null;
    partenzaAl?: string | null;
    inserimentoDal?: string | null;
    inserimentoAl?: string | null;
    tipologieNota?: NoteTypeSearch | null;

    constructor(data?: ISearchNoteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agenziaID = _data["agenziaID"] !== undefined ? _data["agenziaID"] : null as any;
            this.impiegatoID = _data["impiegatoID"] !== undefined ? _data["impiegatoID"] : null as any;
            this.impiegatoPresaInCaricoID = _data["impiegatoPresaInCaricoID"] !== undefined ? _data["impiegatoPresaInCaricoID"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.confermaDal = _data["confermaDal"] !== undefined ? _data["confermaDal"] : null as any;
            this.confermaAl = _data["confermaAl"] !== undefined ? _data["confermaAl"] : null as any;
            this.partenzaDal = _data["partenzaDal"] !== undefined ? _data["partenzaDal"] : null as any;
            this.partenzaAl = _data["partenzaAl"] !== undefined ? _data["partenzaAl"] : null as any;
            this.inserimentoDal = _data["inserimentoDal"] !== undefined ? _data["inserimentoDal"] : null as any;
            this.inserimentoAl = _data["inserimentoAl"] !== undefined ? _data["inserimentoAl"] : null as any;
            this.tipologieNota = _data["tipologieNota"] ? NoteTypeSearch.fromJS(_data["tipologieNota"]) : null as any;
        }
    }

    static override fromJS(data: any): SearchNoteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchNoteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agenziaID"] = this.agenziaID !== undefined ? this.agenziaID : null as any;
        data["impiegatoID"] = this.impiegatoID !== undefined ? this.impiegatoID : null as any;
        data["impiegatoPresaInCaricoID"] = this.impiegatoPresaInCaricoID !== undefined ? this.impiegatoPresaInCaricoID : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["confermaDal"] = this.confermaDal !== undefined ? this.confermaDal : null as any;
        data["confermaAl"] = this.confermaAl !== undefined ? this.confermaAl : null as any;
        data["partenzaDal"] = this.partenzaDal !== undefined ? this.partenzaDal : null as any;
        data["partenzaAl"] = this.partenzaAl !== undefined ? this.partenzaAl : null as any;
        data["inserimentoDal"] = this.inserimentoDal !== undefined ? this.inserimentoDal : null as any;
        data["inserimentoAl"] = this.inserimentoAl !== undefined ? this.inserimentoAl : null as any;
        data["tipologieNota"] = this.tipologieNota ? this.tipologieNota.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchNoteRequest extends INrTableRequest {
    agenziaID?: number | null;
    impiegatoID?: number | null;
    impiegatoPresaInCaricoID?: number | null;
    operatore?: EOperatore;
    confermaDal?: string | null;
    confermaAl?: string | null;
    partenzaDal?: string | null;
    partenzaAl?: string | null;
    inserimentoDal?: string | null;
    inserimentoAl?: string | null;
    tipologieNota?: NoteTypeSearch | null;
}

export class NoteTypeSearch implements INoteTypeSearch {
    int?: boolean;
    prSin?: boolean;
    prMul?: boolean;
    ag?: boolean;
    rAg?: boolean;
    as?: boolean;
    pas?: boolean;
    op?: boolean;
    hasValue?: boolean;
    tipiNota?: ETipoNota[] | null;

    constructor(data?: INoteTypeSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.int = _data["int"] !== undefined ? _data["int"] : null as any;
            this.prSin = _data["prSin"] !== undefined ? _data["prSin"] : null as any;
            this.prMul = _data["prMul"] !== undefined ? _data["prMul"] : null as any;
            this.ag = _data["ag"] !== undefined ? _data["ag"] : null as any;
            this.rAg = _data["rAg"] !== undefined ? _data["rAg"] : null as any;
            this.as = _data["as"] !== undefined ? _data["as"] : null as any;
            this.pas = _data["pas"] !== undefined ? _data["pas"] : null as any;
            this.op = _data["op"] !== undefined ? _data["op"] : null as any;
            this.hasValue = _data["hasValue"] !== undefined ? _data["hasValue"] : null as any;
            if (Array.isArray(_data["tipiNota"])) {
                this.tipiNota = [] as any;
                for (let item of _data["tipiNota"])
                    this.tipiNota!.push(item);
            }
            else {
                this.tipiNota = null as any;
            }
        }
    }

    static fromJS(data: any): NoteTypeSearch {
        data = typeof data === 'object' ? data : {};
        let result = new NoteTypeSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["int"] = this.int !== undefined ? this.int : null as any;
        data["prSin"] = this.prSin !== undefined ? this.prSin : null as any;
        data["prMul"] = this.prMul !== undefined ? this.prMul : null as any;
        data["ag"] = this.ag !== undefined ? this.ag : null as any;
        data["rAg"] = this.rAg !== undefined ? this.rAg : null as any;
        data["as"] = this.as !== undefined ? this.as : null as any;
        data["pas"] = this.pas !== undefined ? this.pas : null as any;
        data["op"] = this.op !== undefined ? this.op : null as any;
        data["hasValue"] = this.hasValue !== undefined ? this.hasValue : null as any;
        if (Array.isArray(this.tipiNota)) {
            data["tipiNota"] = [];
            for (let item of this.tipiNota)
                data["tipiNota"].push(item);
        }
        return data;
    }
}

export interface INoteTypeSearch {
    int?: boolean;
    prSin?: boolean;
    prMul?: boolean;
    ag?: boolean;
    rAg?: boolean;
    as?: boolean;
    pas?: boolean;
    op?: boolean;
    hasValue?: boolean;
    tipiNota?: ETipoNota[] | null;
}

export class NrTableResponseOfOptimizationRow extends OkApiResponse implements INrTableResponseOfOptimizationRow {
    /** Array delle righe della pagina richiesta */
    rows?: OptimizationRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfOptimizationRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(OptimizationRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfOptimizationRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfOptimizationRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfOptimizationRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: OptimizationRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class SearchOptimizationsResponse extends NrTableResponseOfOptimizationRow implements ISearchOptimizationsResponse {

    constructor(data?: ISearchOptimizationsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SearchOptimizationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchOptimizationsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISearchOptimizationsResponse extends INrTableResponseOfOptimizationRow {
}

export class OptimizationRow implements IOptimizationRow {
    id?: number;
    offerta?: Offerta;
    riga?: OffertaDato;
    alternativa?: OffertaDatoAlternativa;
    job?: OffertaDatoAlternativaJob;
    luogo?: string | null;
    dal?: string;
    fornitoreOriginale?: EFornitore | null;
    valutaCostoOriginale?: string | null;
    valutaCostoAlternativa?: string | null;

    constructor(data?: IOptimizationRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.offerta = _data["offerta"] ? Offerta.fromJS(_data["offerta"]) : null as any;
            this.riga = _data["riga"] ? OffertaDato.fromJS(_data["riga"]) : null as any;
            this.alternativa = _data["alternativa"] ? OffertaDatoAlternativa.fromJS(_data["alternativa"]) : null as any;
            this.job = _data["job"] ? OffertaDatoAlternativaJob.fromJS(_data["job"]) : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.fornitoreOriginale = _data["fornitoreOriginale"] !== undefined ? _data["fornitoreOriginale"] : null as any;
            this.valutaCostoOriginale = _data["valutaCostoOriginale"] !== undefined ? _data["valutaCostoOriginale"] : null as any;
            this.valutaCostoAlternativa = _data["valutaCostoAlternativa"] !== undefined ? _data["valutaCostoAlternativa"] : null as any;
        }
    }

    static fromJS(data: any): OptimizationRow {
        data = typeof data === 'object' ? data : {};
        let result = new OptimizationRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["offerta"] = this.offerta ? this.offerta.toJSON() : null as any;
        data["riga"] = this.riga ? this.riga.toJSON() : null as any;
        data["alternativa"] = this.alternativa ? this.alternativa.toJSON() : null as any;
        data["job"] = this.job ? this.job.toJSON() : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["fornitoreOriginale"] = this.fornitoreOriginale !== undefined ? this.fornitoreOriginale : null as any;
        data["valutaCostoOriginale"] = this.valutaCostoOriginale !== undefined ? this.valutaCostoOriginale : null as any;
        data["valutaCostoAlternativa"] = this.valutaCostoAlternativa !== undefined ? this.valutaCostoAlternativa : null as any;
        return data;
    }
}

export interface IOptimizationRow {
    id?: number;
    offerta?: Offerta;
    riga?: OffertaDato;
    alternativa?: OffertaDatoAlternativa;
    job?: OffertaDatoAlternativaJob;
    luogo?: string | null;
    dal?: string;
    fornitoreOriginale?: EFornitore | null;
    valutaCostoOriginale?: string | null;
    valutaCostoAlternativa?: string | null;
}

export class OffertaDatoAlternativa implements IOffertaDatoAlternativa {
    id?: number;
    rigaID?: number;
    jobID?: number;
    status?: EStatusAlternativa;
    creato?: string;
    aggiornato?: string;
    descrizione?: string | null;
    note?: string | null;
    costo?: number | null;
    valutaCostoID?: number | null;
    prezzo?: number | null;
    fornitore?: EFornitore | null;
    searchData?: string | null;

    constructor(data?: IOffertaDatoAlternativa) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.rigaID = _data["rigaID"] !== undefined ? _data["rigaID"] : null as any;
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.creato = _data["creato"] !== undefined ? _data["creato"] : null as any;
            this.aggiornato = _data["aggiornato"] !== undefined ? _data["aggiornato"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.costo = _data["costo"] !== undefined ? _data["costo"] : null as any;
            this.valutaCostoID = _data["valutaCostoID"] !== undefined ? _data["valutaCostoID"] : null as any;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : null as any;
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : null as any;
            this.searchData = _data["searchData"] !== undefined ? _data["searchData"] : null as any;
        }
    }

    static fromJS(data: any): OffertaDatoAlternativa {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaDatoAlternativa();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["rigaID"] = this.rigaID !== undefined ? this.rigaID : null as any;
        data["jobID"] = this.jobID !== undefined ? this.jobID : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["creato"] = this.creato !== undefined ? this.creato : null as any;
        data["aggiornato"] = this.aggiornato !== undefined ? this.aggiornato : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["costo"] = this.costo !== undefined ? this.costo : null as any;
        data["valutaCostoID"] = this.valutaCostoID !== undefined ? this.valutaCostoID : null as any;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : null as any;
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : null as any;
        data["searchData"] = this.searchData !== undefined ? this.searchData : null as any;
        return data;
    }
}

export interface IOffertaDatoAlternativa {
    id?: number;
    rigaID?: number;
    jobID?: number;
    status?: EStatusAlternativa;
    creato?: string;
    aggiornato?: string;
    descrizione?: string | null;
    note?: string | null;
    costo?: number | null;
    valutaCostoID?: number | null;
    prezzo?: number | null;
    fornitore?: EFornitore | null;
    searchData?: string | null;
}

export enum EStatusAlternativa {
    Pronto = "Pronto",
    InCorso = "InCorso",
    EseguitoSuccesso = "EseguitoSuccesso",
    EseguitoNoRisultati = "EseguitoNoRisultati",
    Errore = "Errore",
    Annullato = "Annullato",
}

export class SearchOptimizationsRequest extends NrTableRequest implements ISearchOptimizationsRequest {
    partenzaDal?: string | null;
    partenzaAl?: string | null;

    constructor(data?: ISearchOptimizationsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.partenzaDal = _data["partenzaDal"] !== undefined ? _data["partenzaDal"] : null as any;
            this.partenzaAl = _data["partenzaAl"] !== undefined ? _data["partenzaAl"] : null as any;
        }
    }

    static override fromJS(data: any): SearchOptimizationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchOptimizationsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partenzaDal"] = this.partenzaDal !== undefined ? this.partenzaDal : null as any;
        data["partenzaAl"] = this.partenzaAl !== undefined ? this.partenzaAl : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchOptimizationsRequest extends INrTableRequest {
    partenzaDal?: string | null;
    partenzaAl?: string | null;
}

export class NrTableResponseOfPreventivoListRow extends OkApiResponse implements INrTableResponseOfPreventivoListRow {
    /** Array delle righe della pagina richiesta */
    rows?: PreventivoListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfPreventivoListRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(PreventivoListRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfPreventivoListRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfPreventivoListRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfPreventivoListRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: PreventivoListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class SearchPreventiviResponse extends NrTableResponseOfPreventivoListRow implements ISearchPreventiviResponse {
    ordersWorkLoad?: OrdersWorkLoad | null;

    constructor(data?: ISearchPreventiviResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ordersWorkLoad = _data["ordersWorkLoad"] ? OrdersWorkLoad.fromJS(_data["ordersWorkLoad"]) : null as any;
        }
    }

    static override fromJS(data: any): SearchPreventiviResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchPreventiviResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordersWorkLoad"] = this.ordersWorkLoad ? this.ordersWorkLoad.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchPreventiviResponse extends INrTableResponseOfPreventivoListRow {
    ordersWorkLoad?: OrdersWorkLoad | null;
}

export class OrdersWorkLoad implements IOrdersWorkLoad {
    teamsLoad?: OrdersTeamWorkLoad[] | null;
    totalOrders?: number;

    constructor(data?: IOrdersWorkLoad) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["teamsLoad"])) {
                this.teamsLoad = [] as any;
                for (let item of _data["teamsLoad"])
                    this.teamsLoad!.push(OrdersTeamWorkLoad.fromJS(item));
            }
            else {
                this.teamsLoad = null as any;
            }
            this.totalOrders = _data["totalOrders"] !== undefined ? _data["totalOrders"] : null as any;
        }
    }

    static fromJS(data: any): OrdersWorkLoad {
        data = typeof data === 'object' ? data : {};
        let result = new OrdersWorkLoad();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.teamsLoad)) {
            data["teamsLoad"] = [];
            for (let item of this.teamsLoad)
                data["teamsLoad"].push(item ? item.toJSON() : null as any);
        }
        data["totalOrders"] = this.totalOrders !== undefined ? this.totalOrders : null as any;
        return data;
    }
}

export interface IOrdersWorkLoad {
    teamsLoad?: OrdersTeamWorkLoad[] | null;
    totalOrders?: number;
}

export class OrdersTeamWorkLoad implements IOrdersTeamWorkLoad {
    teamID?: number;
    teamName?: string | null;
    totalOrders?: number;
    users?: OrdersUserWorkLoad[] | null;

    constructor(data?: IOrdersTeamWorkLoad) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamID = _data["teamID"] !== undefined ? _data["teamID"] : null as any;
            this.teamName = _data["teamName"] !== undefined ? _data["teamName"] : null as any;
            this.totalOrders = _data["totalOrders"] !== undefined ? _data["totalOrders"] : null as any;
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(OrdersUserWorkLoad.fromJS(item));
            }
            else {
                this.users = null as any;
            }
        }
    }

    static fromJS(data: any): OrdersTeamWorkLoad {
        data = typeof data === 'object' ? data : {};
        let result = new OrdersTeamWorkLoad();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamID"] = this.teamID !== undefined ? this.teamID : null as any;
        data["teamName"] = this.teamName !== undefined ? this.teamName : null as any;
        data["totalOrders"] = this.totalOrders !== undefined ? this.totalOrders : null as any;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IOrdersTeamWorkLoad {
    teamID?: number;
    teamName?: string | null;
    totalOrders?: number;
    users?: OrdersUserWorkLoad[] | null;
}

export class OrdersUserWorkLoad implements IOrdersUserWorkLoad {
    userID?: number;
    userName?: string | null;
    totalOrders?: number;
    orders?: OrdersOrderDetails[] | null;

    constructor(data?: IOrdersUserWorkLoad) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userID = _data["userID"] !== undefined ? _data["userID"] : null as any;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
            this.totalOrders = _data["totalOrders"] !== undefined ? _data["totalOrders"] : null as any;
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(OrdersOrderDetails.fromJS(item));
            }
            else {
                this.orders = null as any;
            }
        }
    }

    static fromJS(data: any): OrdersUserWorkLoad {
        data = typeof data === 'object' ? data : {};
        let result = new OrdersUserWorkLoad();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID !== undefined ? this.userID : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        data["totalOrders"] = this.totalOrders !== undefined ? this.totalOrders : null as any;
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IOrdersUserWorkLoad {
    userID?: number;
    userName?: string | null;
    totalOrders?: number;
    orders?: OrdersOrderDetails[] | null;
}

export class OrdersOrderDetails implements IOrdersOrderDetails {
    offertaID?: number;
    title?: string | null;
    description?: string | null;
    orderStatus?: EStatusPreventivo | null;

    constructor(data?: IOrdersOrderDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.orderStatus = _data["orderStatus"] !== undefined ? _data["orderStatus"] : null as any;
        }
    }

    static fromJS(data: any): OrdersOrderDetails {
        data = typeof data === 'object' ? data : {};
        let result = new OrdersOrderDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["orderStatus"] = this.orderStatus !== undefined ? this.orderStatus : null as any;
        return data;
    }
}

export interface IOrdersOrderDetails {
    offertaID?: number;
    title?: string | null;
    description?: string | null;
    orderStatus?: EStatusPreventivo | null;
}

export class PreventivoListRow implements IPreventivoListRow {
    offertaID?: number;
    descrizione?: string | null;
    clienti?: string;
    destinazione?: string | null;
    creazione?: string;
    partenza?: string;
    priorita?: string | null;
    dataAppuntamentoADV?: string | null;
    totale?: number;
    agenzia?: string | null;
    telefono?: string | null;
    email?: string | null;
    categoriaAgenzia?: string | null;
    categoriaUtente?: string | null;
    impiegato?: string | null;
    utentePreventivo?: string | null;
    utenteConferma?: string | null;
    sales?: string | null;
    pagamento?: string | null;
    duplicabileAgenzia?: boolean;
    teamId?: number | null;
    teamName?: string | null;
    statusPreventivo?: EStatusPreventivo | null;
    tagIds?: number[];
    numOfPax?: number;
    emails?: TripEmail[] | null;
    coverUrl?: string | null;

    constructor(data?: IPreventivoListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.clienti = _data["clienti"] !== undefined ? _data["clienti"] : null as any;
            this.destinazione = _data["destinazione"] !== undefined ? _data["destinazione"] : null as any;
            this.creazione = _data["creazione"] !== undefined ? _data["creazione"] : null as any;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : null as any;
            this.priorita = _data["priorita"] !== undefined ? _data["priorita"] : null as any;
            this.dataAppuntamentoADV = _data["dataAppuntamentoADV"] !== undefined ? _data["dataAppuntamentoADV"] : null as any;
            this.totale = _data["totale"] !== undefined ? _data["totale"] : null as any;
            this.agenzia = _data["agenzia"] !== undefined ? _data["agenzia"] : null as any;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.categoriaAgenzia = _data["categoriaAgenzia"] !== undefined ? _data["categoriaAgenzia"] : null as any;
            this.categoriaUtente = _data["categoriaUtente"] !== undefined ? _data["categoriaUtente"] : null as any;
            this.impiegato = _data["impiegato"] !== undefined ? _data["impiegato"] : null as any;
            this.utentePreventivo = _data["utentePreventivo"] !== undefined ? _data["utentePreventivo"] : null as any;
            this.utenteConferma = _data["utenteConferma"] !== undefined ? _data["utenteConferma"] : null as any;
            this.sales = _data["sales"] !== undefined ? _data["sales"] : null as any;
            this.pagamento = _data["pagamento"] !== undefined ? _data["pagamento"] : null as any;
            this.duplicabileAgenzia = _data["duplicabileAgenzia"] !== undefined ? _data["duplicabileAgenzia"] : null as any;
            this.teamId = _data["teamId"] !== undefined ? _data["teamId"] : null as any;
            this.teamName = _data["teamName"] !== undefined ? _data["teamName"] : null as any;
            this.statusPreventivo = _data["statusPreventivo"] !== undefined ? _data["statusPreventivo"] : null as any;
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            else {
                this.tagIds = null as any;
            }
            this.numOfPax = _data["numOfPax"] !== undefined ? _data["numOfPax"] : null as any;
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(TripEmail.fromJS(item));
            }
            else {
                this.emails = null as any;
            }
            this.coverUrl = _data["coverUrl"] !== undefined ? _data["coverUrl"] : null as any;
        }
    }

    static fromJS(data: any): PreventivoListRow {
        data = typeof data === 'object' ? data : {};
        let result = new PreventivoListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["clienti"] = this.clienti !== undefined ? this.clienti : null as any;
        data["destinazione"] = this.destinazione !== undefined ? this.destinazione : null as any;
        data["creazione"] = this.creazione !== undefined ? this.creazione : null as any;
        data["partenza"] = this.partenza !== undefined ? this.partenza : null as any;
        data["priorita"] = this.priorita !== undefined ? this.priorita : null as any;
        data["dataAppuntamentoADV"] = this.dataAppuntamentoADV !== undefined ? this.dataAppuntamentoADV : null as any;
        data["totale"] = this.totale !== undefined ? this.totale : null as any;
        data["agenzia"] = this.agenzia !== undefined ? this.agenzia : null as any;
        data["telefono"] = this.telefono !== undefined ? this.telefono : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["categoriaAgenzia"] = this.categoriaAgenzia !== undefined ? this.categoriaAgenzia : null as any;
        data["categoriaUtente"] = this.categoriaUtente !== undefined ? this.categoriaUtente : null as any;
        data["impiegato"] = this.impiegato !== undefined ? this.impiegato : null as any;
        data["utentePreventivo"] = this.utentePreventivo !== undefined ? this.utentePreventivo : null as any;
        data["utenteConferma"] = this.utenteConferma !== undefined ? this.utenteConferma : null as any;
        data["sales"] = this.sales !== undefined ? this.sales : null as any;
        data["pagamento"] = this.pagamento !== undefined ? this.pagamento : null as any;
        data["duplicabileAgenzia"] = this.duplicabileAgenzia !== undefined ? this.duplicabileAgenzia : null as any;
        data["teamId"] = this.teamId !== undefined ? this.teamId : null as any;
        data["teamName"] = this.teamName !== undefined ? this.teamName : null as any;
        data["statusPreventivo"] = this.statusPreventivo !== undefined ? this.statusPreventivo : null as any;
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        data["numOfPax"] = this.numOfPax !== undefined ? this.numOfPax : null as any;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item ? item.toJSON() : null as any);
        }
        data["coverUrl"] = this.coverUrl !== undefined ? this.coverUrl : null as any;
        return data;
    }
}

export interface IPreventivoListRow {
    offertaID?: number;
    descrizione?: string | null;
    clienti?: string;
    destinazione?: string | null;
    creazione?: string;
    partenza?: string;
    priorita?: string | null;
    dataAppuntamentoADV?: string | null;
    totale?: number;
    agenzia?: string | null;
    telefono?: string | null;
    email?: string | null;
    categoriaAgenzia?: string | null;
    categoriaUtente?: string | null;
    impiegato?: string | null;
    utentePreventivo?: string | null;
    utenteConferma?: string | null;
    sales?: string | null;
    pagamento?: string | null;
    duplicabileAgenzia?: boolean;
    teamId?: number | null;
    teamName?: string | null;
    statusPreventivo?: EStatusPreventivo | null;
    tagIds?: number[];
    numOfPax?: number;
    emails?: TripEmail[] | null;
    coverUrl?: string | null;
}

export class SearchPreventiviRequest extends NrTableRequest implements ISearchPreventiviRequest {
    offertaID?: number | null;
    agenziaID?: number | null;
    categorieContattoIDs?: (number | null)[] | null;
    impiegatoID?: number | null;
    promotoreID?: number | null;
    luogoDestinazioneID?: number | null;
    operatore?: EOperatore | null;
    partenzaDal?: string | null;
    partenzaAl?: string | null;
    scadenzaDal?: string | null;
    scadenzaAl?: string | null;
    creazioneDal?: string | null;
    creazioneAl?: string | null;
    appuntamentoAgenziaDal?: string | null;
    appuntamentoAgenziaAl?: string | null;
    teamIds?: number[] | null;
    statusPreventivo?: EStatusPreventivo[] | null;
    tagIds?: number[] | null;
    tagFilterMode?: EFilterMode | null;

    constructor(data?: ISearchPreventiviRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.agenziaID = _data["agenziaID"] !== undefined ? _data["agenziaID"] : null as any;
            if (Array.isArray(_data["categorieContattoIDs"])) {
                this.categorieContattoIDs = [] as any;
                for (let item of _data["categorieContattoIDs"])
                    this.categorieContattoIDs!.push(item);
            }
            else {
                this.categorieContattoIDs = null as any;
            }
            this.impiegatoID = _data["impiegatoID"] !== undefined ? _data["impiegatoID"] : null as any;
            this.promotoreID = _data["promotoreID"] !== undefined ? _data["promotoreID"] : null as any;
            this.luogoDestinazioneID = _data["luogoDestinazioneID"] !== undefined ? _data["luogoDestinazioneID"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.partenzaDal = _data["partenzaDal"] !== undefined ? _data["partenzaDal"] : null as any;
            this.partenzaAl = _data["partenzaAl"] !== undefined ? _data["partenzaAl"] : null as any;
            this.scadenzaDal = _data["scadenzaDal"] !== undefined ? _data["scadenzaDal"] : null as any;
            this.scadenzaAl = _data["scadenzaAl"] !== undefined ? _data["scadenzaAl"] : null as any;
            this.creazioneDal = _data["creazioneDal"] !== undefined ? _data["creazioneDal"] : null as any;
            this.creazioneAl = _data["creazioneAl"] !== undefined ? _data["creazioneAl"] : null as any;
            this.appuntamentoAgenziaDal = _data["appuntamentoAgenziaDal"] !== undefined ? _data["appuntamentoAgenziaDal"] : null as any;
            this.appuntamentoAgenziaAl = _data["appuntamentoAgenziaAl"] !== undefined ? _data["appuntamentoAgenziaAl"] : null as any;
            if (Array.isArray(_data["teamIds"])) {
                this.teamIds = [] as any;
                for (let item of _data["teamIds"])
                    this.teamIds!.push(item);
            }
            else {
                this.teamIds = null as any;
            }
            if (Array.isArray(_data["statusPreventivo"])) {
                this.statusPreventivo = [] as any;
                for (let item of _data["statusPreventivo"])
                    this.statusPreventivo!.push(item);
            }
            else {
                this.statusPreventivo = null as any;
            }
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            else {
                this.tagIds = null as any;
            }
            this.tagFilterMode = _data["tagFilterMode"] !== undefined ? _data["tagFilterMode"] : null as any;
        }
    }

    static override fromJS(data: any): SearchPreventiviRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchPreventiviRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["agenziaID"] = this.agenziaID !== undefined ? this.agenziaID : null as any;
        if (Array.isArray(this.categorieContattoIDs)) {
            data["categorieContattoIDs"] = [];
            for (let item of this.categorieContattoIDs)
                data["categorieContattoIDs"].push(item);
        }
        data["impiegatoID"] = this.impiegatoID !== undefined ? this.impiegatoID : null as any;
        data["promotoreID"] = this.promotoreID !== undefined ? this.promotoreID : null as any;
        data["luogoDestinazioneID"] = this.luogoDestinazioneID !== undefined ? this.luogoDestinazioneID : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["partenzaDal"] = this.partenzaDal !== undefined ? this.partenzaDal : null as any;
        data["partenzaAl"] = this.partenzaAl !== undefined ? this.partenzaAl : null as any;
        data["scadenzaDal"] = this.scadenzaDal !== undefined ? this.scadenzaDal : null as any;
        data["scadenzaAl"] = this.scadenzaAl !== undefined ? this.scadenzaAl : null as any;
        data["creazioneDal"] = this.creazioneDal !== undefined ? this.creazioneDal : null as any;
        data["creazioneAl"] = this.creazioneAl !== undefined ? this.creazioneAl : null as any;
        data["appuntamentoAgenziaDal"] = this.appuntamentoAgenziaDal !== undefined ? this.appuntamentoAgenziaDal : null as any;
        data["appuntamentoAgenziaAl"] = this.appuntamentoAgenziaAl !== undefined ? this.appuntamentoAgenziaAl : null as any;
        if (Array.isArray(this.teamIds)) {
            data["teamIds"] = [];
            for (let item of this.teamIds)
                data["teamIds"].push(item);
        }
        if (Array.isArray(this.statusPreventivo)) {
            data["statusPreventivo"] = [];
            for (let item of this.statusPreventivo)
                data["statusPreventivo"].push(item);
        }
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        data["tagFilterMode"] = this.tagFilterMode !== undefined ? this.tagFilterMode : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchPreventiviRequest extends INrTableRequest {
    offertaID?: number | null;
    agenziaID?: number | null;
    categorieContattoIDs?: (number | null)[] | null;
    impiegatoID?: number | null;
    promotoreID?: number | null;
    luogoDestinazioneID?: number | null;
    operatore?: EOperatore | null;
    partenzaDal?: string | null;
    partenzaAl?: string | null;
    scadenzaDal?: string | null;
    scadenzaAl?: string | null;
    creazioneDal?: string | null;
    creazioneAl?: string | null;
    appuntamentoAgenziaDal?: string | null;
    appuntamentoAgenziaAl?: string | null;
    teamIds?: number[] | null;
    statusPreventivo?: EStatusPreventivo[] | null;
    tagIds?: number[] | null;
    tagFilterMode?: EFilterMode | null;
}

export enum EFilterMode {
    AND = "AND",
    OR = "OR",
}

export class UpdateOrdersStatusMultiRequest extends ApiRequest implements IUpdateOrdersStatusMultiRequest {
    /** Lista degli ID da modificare */
    iDs!: number[];
    /** Se presente è la nuova data del campo priorità da impostare */
    newPriorita?: string | null;
    /** Se presente è il valore in giorni +/- da impostare sulla data di priorità. Se c'è la data questo viene ignorato */
    offsetPriorita?: number | null;
    /** Se presente è il nuovo ID del team da assegnare */
    newTeamID?: number | null;
    /** Se presente è il nuovo status da assegnare */
    newStatusPreventivo?: EStatusPreventivo | null;
    /** Se presente è il nuovo id utente preventivo */
    newUtenteID?: number | null;
    /** Elenco degli id dei tag da assegnare */
    tagsIDs?: number[] | null;

    constructor(data?: IUpdateOrdersStatusMultiRequest) {
        super(data);
        if (!data) {
            this.iDs = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["iDs"])) {
                this.iDs = [] as any;
                for (let item of _data["iDs"])
                    this.iDs!.push(item);
            }
            else {
                this.iDs = null as any;
            }
            this.newPriorita = _data["newPriorita"] !== undefined ? _data["newPriorita"] : null as any;
            this.offsetPriorita = _data["offsetPriorita"] !== undefined ? _data["offsetPriorita"] : null as any;
            this.newTeamID = _data["newTeamID"] !== undefined ? _data["newTeamID"] : null as any;
            this.newStatusPreventivo = _data["newStatusPreventivo"] !== undefined ? _data["newStatusPreventivo"] : null as any;
            this.newUtenteID = _data["newUtenteID"] !== undefined ? _data["newUtenteID"] : null as any;
            if (Array.isArray(_data["tagsIDs"])) {
                this.tagsIDs = [] as any;
                for (let item of _data["tagsIDs"])
                    this.tagsIDs!.push(item);
            }
            else {
                this.tagsIDs = null as any;
            }
        }
    }

    static override fromJS(data: any): UpdateOrdersStatusMultiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrdersStatusMultiRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.iDs)) {
            data["iDs"] = [];
            for (let item of this.iDs)
                data["iDs"].push(item);
        }
        data["newPriorita"] = this.newPriorita !== undefined ? this.newPriorita : null as any;
        data["offsetPriorita"] = this.offsetPriorita !== undefined ? this.offsetPriorita : null as any;
        data["newTeamID"] = this.newTeamID !== undefined ? this.newTeamID : null as any;
        data["newStatusPreventivo"] = this.newStatusPreventivo !== undefined ? this.newStatusPreventivo : null as any;
        data["newUtenteID"] = this.newUtenteID !== undefined ? this.newUtenteID : null as any;
        if (Array.isArray(this.tagsIDs)) {
            data["tagsIDs"] = [];
            for (let item of this.tagsIDs)
                data["tagsIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateOrdersStatusMultiRequest extends IApiRequest {
    /** Lista degli ID da modificare */
    iDs: number[];
    /** Se presente è la nuova data del campo priorità da impostare */
    newPriorita?: string | null;
    /** Se presente è il valore in giorni +/- da impostare sulla data di priorità. Se c'è la data questo viene ignorato */
    offsetPriorita?: number | null;
    /** Se presente è il nuovo ID del team da assegnare */
    newTeamID?: number | null;
    /** Se presente è il nuovo status da assegnare */
    newStatusPreventivo?: EStatusPreventivo | null;
    /** Se presente è il nuovo id utente preventivo */
    newUtenteID?: number | null;
    /** Elenco degli id dei tag da assegnare */
    tagsIDs?: number[] | null;
}

export class PaymentTermsGetResponse extends OkApiResponse implements IPaymentTermsGetResponse {
    paymentTerm?: TerminePagamento | null;

    constructor(data?: IPaymentTermsGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.paymentTerm = _data["paymentTerm"] ? TerminePagamento.fromJS(_data["paymentTerm"]) : null as any;
        }
    }

    static override fromJS(data: any): PaymentTermsGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTermsGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentTerm"] = this.paymentTerm ? this.paymentTerm.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPaymentTermsGetResponse extends IOkApiResponse {
    paymentTerm?: TerminePagamento | null;
}

export class PaymentTermUpsertResponse extends PaymentTermsGetResponse implements IPaymentTermUpsertResponse {

    constructor(data?: IPaymentTermUpsertResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PaymentTermUpsertResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTermUpsertResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPaymentTermUpsertResponse extends IPaymentTermsGetResponse {
}

export class PaymentTermsUpsertRequest extends ApiRequest implements IPaymentTermsUpsertRequest {
    paymentTerm?: TerminePagamento | null;

    constructor(data?: IPaymentTermsUpsertRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.paymentTerm = _data["paymentTerm"] ? TerminePagamento.fromJS(_data["paymentTerm"]) : null as any;
        }
    }

    static override fromJS(data: any): PaymentTermsUpsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTermsUpsertRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentTerm"] = this.paymentTerm ? this.paymentTerm.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPaymentTermsUpsertRequest extends IApiRequest {
    paymentTerm?: TerminePagamento | null;
}

export class PaymentTermsDeleteRequest extends ApiRequest implements IPaymentTermsDeleteRequest {
    id?: number;

    constructor(data?: IPaymentTermsDeleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): PaymentTermsDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTermsDeleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPaymentTermsDeleteRequest extends IApiRequest {
    id?: number;
}

export class PaymentTermsGetRequest extends ApiRequest implements IPaymentTermsGetRequest {
    termID?: number;

    constructor(data?: IPaymentTermsGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.termID = _data["termID"] !== undefined ? _data["termID"] : null as any;
        }
    }

    static override fromJS(data: any): PaymentTermsGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTermsGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termID"] = this.termID !== undefined ? this.termID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPaymentTermsGetRequest extends IApiRequest {
    termID?: number;
}

export class NrTableResponseOfTerminePagamento extends OkApiResponse implements INrTableResponseOfTerminePagamento {
    /** Array delle righe della pagina richiesta */
    rows?: TerminePagamento[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfTerminePagamento) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TerminePagamento.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfTerminePagamento {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfTerminePagamento();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfTerminePagamento extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: TerminePagamento[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class PaymentTermsListRequest extends NrTableRequest implements IPaymentTermsListRequest {
    term?: string | null;
    showDeleted?: boolean;

    constructor(data?: IPaymentTermsListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : null as any;
            this.showDeleted = _data["showDeleted"] !== undefined ? _data["showDeleted"] : null as any;
        }
    }

    static override fromJS(data: any): PaymentTermsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTermsListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : null as any;
        data["showDeleted"] = this.showDeleted !== undefined ? this.showDeleted : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPaymentTermsListRequest extends INrTableRequest {
    term?: string | null;
    showDeleted?: boolean;
}

export class PaymentTermsRestoreRequest extends ApiRequest implements IPaymentTermsRestoreRequest {
    id?: number;

    constructor(data?: IPaymentTermsRestoreRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): PaymentTermsRestoreRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTermsRestoreRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPaymentTermsRestoreRequest extends IApiRequest {
    id?: number;
}

export class GetCacheIndexResponse extends OkApiResponse implements IGetCacheIndexResponse {
    /** Indice della cache */
    indice?: CostsIndex;

    constructor(data?: IGetCacheIndexResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.indice = _data["indice"] ? CostsIndex.fromJS(_data["indice"]) : null as any;
        }
    }

    static override fromJS(data: any): GetCacheIndexResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCacheIndexResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["indice"] = this.indice ? this.indice.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetCacheIndexResponse extends IOkApiResponse {
    /** Indice della cache */
    indice?: CostsIndex;
}

export class CostsIndex implements ICostsIndex {
    key?: string;
    input?: CacheDisponibilitaInput;
    deleteAt?: string;
    createdAt?: string;
    lastHitDate?: string | null;
    updatedAt?: string;
    hits?: number;
    uniqueID?: string | null;
    locationID?: number | null;
    date?: string | null;
    nights?: number | null;
    serviceType?: ETipoServizioSearch | null;
    costi?: { [key: string]: SupplierCostsPointer; };
    generation?: number;
    isFinal?: boolean;
    doneCount?: number;
    okCount?: number;
    searchesCount?: number;
    now?: string;
    hasResults?: boolean;
    status?: EStatusCostiFornitore;

    constructor(data?: ICostsIndex) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
            this.input = _data["input"] ? CacheDisponibilitaInput.fromJS(_data["input"]) : null as any;
            this.deleteAt = _data["deleteAt"] !== undefined ? _data["deleteAt"] : null as any;
            this.createdAt = _data["createdAt"] !== undefined ? _data["createdAt"] : null as any;
            this.lastHitDate = _data["lastHitDate"] !== undefined ? _data["lastHitDate"] : null as any;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : null as any;
            this.hits = _data["hits"] !== undefined ? _data["hits"] : null as any;
            this.uniqueID = _data["uniqueID"] !== undefined ? _data["uniqueID"] : null as any;
            this.locationID = _data["locationID"] !== undefined ? _data["locationID"] : null as any;
            this.date = _data["date"] !== undefined ? _data["date"] : null as any;
            this.nights = _data["nights"] !== undefined ? _data["nights"] : null as any;
            this.serviceType = _data["serviceType"] !== undefined ? _data["serviceType"] : null as any;
            if (_data["costi"]) {
                this.costi = {} as any;
                for (let key in _data["costi"]) {
                    if (_data["costi"].hasOwnProperty(key))
                        (this.costi as any)![key] = _data["costi"][key] ? SupplierCostsPointer.fromJS(_data["costi"][key]) : new SupplierCostsPointer();
                }
            }
            else {
                this.costi = null as any;
            }
            this.generation = _data["generation"] !== undefined ? _data["generation"] : null as any;
            this.isFinal = _data["isFinal"] !== undefined ? _data["isFinal"] : null as any;
            this.doneCount = _data["doneCount"] !== undefined ? _data["doneCount"] : null as any;
            this.okCount = _data["okCount"] !== undefined ? _data["okCount"] : null as any;
            this.searchesCount = _data["searchesCount"] !== undefined ? _data["searchesCount"] : null as any;
            this.now = _data["now"] !== undefined ? _data["now"] : null as any;
            this.hasResults = _data["hasResults"] !== undefined ? _data["hasResults"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
        }
    }

    static fromJS(data: any): CostsIndex {
        data = typeof data === 'object' ? data : {};
        let result = new CostsIndex();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["input"] = this.input ? this.input.toJSON() : null as any;
        data["deleteAt"] = this.deleteAt !== undefined ? this.deleteAt : null as any;
        data["createdAt"] = this.createdAt !== undefined ? this.createdAt : null as any;
        data["lastHitDate"] = this.lastHitDate !== undefined ? this.lastHitDate : null as any;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : null as any;
        data["hits"] = this.hits !== undefined ? this.hits : null as any;
        data["uniqueID"] = this.uniqueID !== undefined ? this.uniqueID : null as any;
        data["locationID"] = this.locationID !== undefined ? this.locationID : null as any;
        data["date"] = this.date !== undefined ? this.date : null as any;
        data["nights"] = this.nights !== undefined ? this.nights : null as any;
        data["serviceType"] = this.serviceType !== undefined ? this.serviceType : null as any;
        if (this.costi) {
            data["costi"] = {};
            for (let key in this.costi) {
                if (this.costi.hasOwnProperty(key))
                    (data["costi"] as any)[key] = this.costi[key] ? this.costi[key].toJSON() : null as any;
            }
        }
        data["generation"] = this.generation !== undefined ? this.generation : null as any;
        data["isFinal"] = this.isFinal !== undefined ? this.isFinal : null as any;
        data["doneCount"] = this.doneCount !== undefined ? this.doneCount : null as any;
        data["okCount"] = this.okCount !== undefined ? this.okCount : null as any;
        data["searchesCount"] = this.searchesCount !== undefined ? this.searchesCount : null as any;
        data["now"] = this.now !== undefined ? this.now : null as any;
        data["hasResults"] = this.hasResults !== undefined ? this.hasResults : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        return data;
    }
}

export interface ICostsIndex {
    key?: string;
    input?: CacheDisponibilitaInput;
    deleteAt?: string;
    createdAt?: string;
    lastHitDate?: string | null;
    updatedAt?: string;
    hits?: number;
    uniqueID?: string | null;
    locationID?: number | null;
    date?: string | null;
    nights?: number | null;
    serviceType?: ETipoServizioSearch | null;
    costi?: { [key: string]: SupplierCostsPointer; };
    generation?: number;
    isFinal?: boolean;
    doneCount?: number;
    okCount?: number;
    searchesCount?: number;
    now?: string;
    hasResults?: boolean;
    status?: EStatusCostiFornitore;
}

export abstract class H2HRequestInputBase implements IH2HRequestInputBase {
    supplier?: EFornitore | null;
    contesto?: EContestoRicerca;
    tipoServizio?: ETipoServizioSearch;
    siteID?: EH2HClient;
    taskLogID?: number | null;

    constructor(data?: IH2HRequestInputBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : null as any;
            this.contesto = _data["contesto"] !== undefined ? _data["contesto"] : null as any;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
            this.siteID = _data["siteID"] !== undefined ? _data["siteID"] : null as any;
            this.taskLogID = _data["taskLogID"] !== undefined ? _data["taskLogID"] : null as any;
        }
    }

    static fromJS(data: any): H2HRequestInputBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'H2HRequestInputBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplier"] = this.supplier !== undefined ? this.supplier : null as any;
        data["contesto"] = this.contesto !== undefined ? this.contesto : null as any;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        data["siteID"] = this.siteID !== undefined ? this.siteID : null as any;
        data["taskLogID"] = this.taskLogID !== undefined ? this.taskLogID : null as any;
        return data;
    }
}

export interface IH2HRequestInputBase {
    supplier?: EFornitore | null;
    contesto?: EContestoRicerca;
    tipoServizio?: ETipoServizioSearch;
    siteID?: EH2HClient;
    taskLogID?: number | null;
}

export class DisponibilitaInput extends H2HRequestInputBase implements IDisponibilitaInput {
    jobID?: string;
    operatore?: EOperatore;
    userID?: number;
    dataDal?: string;
    oraDal?: number | null;
    dataAl?: string;
    oraAl?: number | null;
    gruppi?: DisponibilitaGruppo[];
    usaPrezziNetti?: boolean;
    moltiplicatoreMarkupAdv?: number;
    listino?: EListinoPrezzi;
    nozze?: boolean;
    lingua?: ELingua;
    tripID?: number | null;
    tripDetailID?: number | null;

    constructor(data?: IDisponibilitaInput) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.userID = _data["userID"] !== undefined ? _data["userID"] : null as any;
            this.dataDal = _data["dataDal"] !== undefined ? _data["dataDal"] : null as any;
            this.oraDal = _data["oraDal"] !== undefined ? _data["oraDal"] : null as any;
            this.dataAl = _data["dataAl"] !== undefined ? _data["dataAl"] : null as any;
            this.oraAl = _data["oraAl"] !== undefined ? _data["oraAl"] : null as any;
            if (Array.isArray(_data["gruppi"])) {
                this.gruppi = [] as any;
                for (let item of _data["gruppi"])
                    this.gruppi!.push(DisponibilitaGruppo.fromJS(item));
            }
            else {
                this.gruppi = null as any;
            }
            this.usaPrezziNetti = _data["usaPrezziNetti"] !== undefined ? _data["usaPrezziNetti"] : null as any;
            this.moltiplicatoreMarkupAdv = _data["moltiplicatoreMarkupAdv"] !== undefined ? _data["moltiplicatoreMarkupAdv"] : null as any;
            this.listino = _data["listino"] !== undefined ? _data["listino"] : null as any;
            this.nozze = _data["nozze"] !== undefined ? _data["nozze"] : null as any;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : null as any;
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : null as any;
            this.tripDetailID = _data["tripDetailID"] !== undefined ? _data["tripDetailID"] : null as any;
        }
    }

    static override fromJS(data: any): DisponibilitaInput {
        data = typeof data === 'object' ? data : {};
        let result = new DisponibilitaInput();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobID"] = this.jobID !== undefined ? this.jobID : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["userID"] = this.userID !== undefined ? this.userID : null as any;
        data["dataDal"] = this.dataDal !== undefined ? this.dataDal : null as any;
        data["oraDal"] = this.oraDal !== undefined ? this.oraDal : null as any;
        data["dataAl"] = this.dataAl !== undefined ? this.dataAl : null as any;
        data["oraAl"] = this.oraAl !== undefined ? this.oraAl : null as any;
        if (Array.isArray(this.gruppi)) {
            data["gruppi"] = [];
            for (let item of this.gruppi)
                data["gruppi"].push(item ? item.toJSON() : null as any);
        }
        data["usaPrezziNetti"] = this.usaPrezziNetti !== undefined ? this.usaPrezziNetti : null as any;
        data["moltiplicatoreMarkupAdv"] = this.moltiplicatoreMarkupAdv !== undefined ? this.moltiplicatoreMarkupAdv : null as any;
        data["listino"] = this.listino !== undefined ? this.listino : null as any;
        data["nozze"] = this.nozze !== undefined ? this.nozze : null as any;
        data["lingua"] = this.lingua !== undefined ? this.lingua : null as any;
        data["tripID"] = this.tripID !== undefined ? this.tripID : null as any;
        data["tripDetailID"] = this.tripDetailID !== undefined ? this.tripDetailID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDisponibilitaInput extends IH2HRequestInputBase {
    jobID?: string;
    operatore?: EOperatore;
    userID?: number;
    dataDal?: string;
    oraDal?: number | null;
    dataAl?: string;
    oraAl?: number | null;
    gruppi?: DisponibilitaGruppo[];
    usaPrezziNetti?: boolean;
    moltiplicatoreMarkupAdv?: number;
    listino?: EListinoPrezzi;
    nozze?: boolean;
    lingua?: ELingua;
    tripID?: number | null;
    tripDetailID?: number | null;
}

export class CacheDisponibilitaInput extends DisponibilitaInput implements ICacheDisponibilitaInput {
    luogoID?: number;
    luogoDestinazioneID?: number | null;
    bypassCache?: boolean;
    servizioID?: number | null;
    hasDelta?: boolean;

    constructor(data?: ICacheDisponibilitaInput) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.luogoDestinazioneID = _data["luogoDestinazioneID"] !== undefined ? _data["luogoDestinazioneID"] : null as any;
            this.bypassCache = _data["bypassCache"] !== undefined ? _data["bypassCache"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.hasDelta = _data["hasDelta"] !== undefined ? _data["hasDelta"] : null as any;
        }
    }

    static override fromJS(data: any): CacheDisponibilitaInput {
        data = typeof data === 'object' ? data : {};
        let result = new CacheDisponibilitaInput();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["luogoDestinazioneID"] = this.luogoDestinazioneID !== undefined ? this.luogoDestinazioneID : null as any;
        data["bypassCache"] = this.bypassCache !== undefined ? this.bypassCache : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["hasDelta"] = this.hasDelta !== undefined ? this.hasDelta : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICacheDisponibilitaInput extends IDisponibilitaInput {
    luogoID?: number;
    luogoDestinazioneID?: number | null;
    bypassCache?: boolean;
    servizioID?: number | null;
    hasDelta?: boolean;
}

export class DisponibilitaGruppo implements IDisponibilitaGruppo {
    id?: number;
    nome?: string | null;
    partecipanti?: DisponibilitaPartecipante[];
    prezzoBase?: number;
    ordine?: number;
    adulti?: number;
    children?: number;
    infants?: number;

    constructor(data?: IDisponibilitaGruppo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            if (Array.isArray(_data["partecipanti"])) {
                this.partecipanti = [] as any;
                for (let item of _data["partecipanti"])
                    this.partecipanti!.push(DisponibilitaPartecipante.fromJS(item));
            }
            else {
                this.partecipanti = null as any;
            }
            this.prezzoBase = _data["prezzoBase"] !== undefined ? _data["prezzoBase"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.adulti = _data["adulti"] !== undefined ? _data["adulti"] : null as any;
            this.children = _data["children"] !== undefined ? _data["children"] : null as any;
            this.infants = _data["infants"] !== undefined ? _data["infants"] : null as any;
        }
    }

    static fromJS(data: any): DisponibilitaGruppo {
        data = typeof data === 'object' ? data : {};
        let result = new DisponibilitaGruppo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        if (Array.isArray(this.partecipanti)) {
            data["partecipanti"] = [];
            for (let item of this.partecipanti)
                data["partecipanti"].push(item ? item.toJSON() : null as any);
        }
        data["prezzoBase"] = this.prezzoBase !== undefined ? this.prezzoBase : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["adulti"] = this.adulti !== undefined ? this.adulti : null as any;
        data["children"] = this.children !== undefined ? this.children : null as any;
        data["infants"] = this.infants !== undefined ? this.infants : null as any;
        return data;
    }
}

export interface IDisponibilitaGruppo {
    id?: number;
    nome?: string | null;
    partecipanti?: DisponibilitaPartecipante[];
    prezzoBase?: number;
    ordine?: number;
    adulti?: number;
    children?: number;
    infants?: number;
}

export class DisponibilitaPartecipante implements IDisponibilitaPartecipante {
    id?: number;
    nome?: string | null;
    cognome?: string;
    dataDiNascita?: string;
    titoloPaxID?: number;

    constructor(data?: IDisponibilitaPartecipante) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : null as any;
            this.dataDiNascita = _data["dataDiNascita"] !== undefined ? _data["dataDiNascita"] : null as any;
            this.titoloPaxID = _data["titoloPaxID"] !== undefined ? _data["titoloPaxID"] : null as any;
        }
    }

    static fromJS(data: any): DisponibilitaPartecipante {
        data = typeof data === 'object' ? data : {};
        let result = new DisponibilitaPartecipante();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["cognome"] = this.cognome !== undefined ? this.cognome : null as any;
        data["dataDiNascita"] = this.dataDiNascita !== undefined ? this.dataDiNascita : null as any;
        data["titoloPaxID"] = this.titoloPaxID !== undefined ? this.titoloPaxID : null as any;
        return data;
    }
}

export interface IDisponibilitaPartecipante {
    id?: number;
    nome?: string | null;
    cognome?: string;
    dataDiNascita?: string;
    titoloPaxID?: number;
}

export enum EListinoPrezzi {
    Default = "Default",
    PrezziNetti = "PrezziNetti",
    Pacchetto = "Pacchetto",
}

export enum EContestoRicerca {
    Ricerca = "Ricerca",
    VerificaPrezzi = "VerificaPrezzi",
    Booking = "Booking",
    RicercaCache = "RicercaCache",
    Autofill = "Autofill",
    CacheFill = "CacheFill",
}

export enum ETipoServizioSearch {
    Hotel = "Hotel",
    Visite = "Visite",
    Noleggi = "Noleggi",
    SelfDrive = "SelfDrive",
    Tour = "Tour",
    Unknown = "Unknown",
    Pacchetti = "Pacchetti",
    Voli = "Voli",
    ItinerariConsigliati = "ItinerariConsigliati",
    Traghetti = "Traghetti",
}

export enum EH2HClient {
    NAAR = "NAAR",
    NAAR_FRANCE = "NAAR_FRANCE",
}

export class SupplierCostsPointer implements ISupplierCostsPointer {
    supplierId?: number;
    supplier?: EFornitore;
    key?: string;
    searchStatus?: EStatusCostiFornitore;
    luoghiFornitoreIDs?: number[];
    objectId?: string | null;
    resultsCount?: number | null;
    searchTimeSeconds?: number | null;
    startedAt?: string | null;
    resultsDate?: string | null;
    expireDate?: string;
    timeoutDate?: string;
    resultsStatus?: EStatusCostiFornitore;
    isFinal?: boolean;
    elapsed?: number | null;

    constructor(data?: ISupplierCostsPointer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierId = _data["supplierId"] !== undefined ? _data["supplierId"] : null as any;
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : null as any;
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
            this.searchStatus = _data["searchStatus"] !== undefined ? _data["searchStatus"] : null as any;
            if (Array.isArray(_data["luoghiFornitoreIDs"])) {
                this.luoghiFornitoreIDs = [] as any;
                for (let item of _data["luoghiFornitoreIDs"])
                    this.luoghiFornitoreIDs!.push(item);
            }
            else {
                this.luoghiFornitoreIDs = null as any;
            }
            this.objectId = _data["objectId"] !== undefined ? _data["objectId"] : null as any;
            this.resultsCount = _data["resultsCount"] !== undefined ? _data["resultsCount"] : null as any;
            this.searchTimeSeconds = _data["searchTimeSeconds"] !== undefined ? _data["searchTimeSeconds"] : null as any;
            this.startedAt = _data["startedAt"] !== undefined ? _data["startedAt"] : null as any;
            this.resultsDate = _data["resultsDate"] !== undefined ? _data["resultsDate"] : null as any;
            this.expireDate = _data["expireDate"] !== undefined ? _data["expireDate"] : null as any;
            this.timeoutDate = _data["timeoutDate"] !== undefined ? _data["timeoutDate"] : null as any;
            this.resultsStatus = _data["resultsStatus"] !== undefined ? _data["resultsStatus"] : null as any;
            this.isFinal = _data["isFinal"] !== undefined ? _data["isFinal"] : null as any;
            this.elapsed = _data["elapsed"] !== undefined ? _data["elapsed"] : null as any;
        }
    }

    static fromJS(data: any): SupplierCostsPointer {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierCostsPointer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierId"] = this.supplierId !== undefined ? this.supplierId : null as any;
        data["supplier"] = this.supplier !== undefined ? this.supplier : null as any;
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["searchStatus"] = this.searchStatus !== undefined ? this.searchStatus : null as any;
        if (Array.isArray(this.luoghiFornitoreIDs)) {
            data["luoghiFornitoreIDs"] = [];
            for (let item of this.luoghiFornitoreIDs)
                data["luoghiFornitoreIDs"].push(item);
        }
        data["objectId"] = this.objectId !== undefined ? this.objectId : null as any;
        data["resultsCount"] = this.resultsCount !== undefined ? this.resultsCount : null as any;
        data["searchTimeSeconds"] = this.searchTimeSeconds !== undefined ? this.searchTimeSeconds : null as any;
        data["startedAt"] = this.startedAt !== undefined ? this.startedAt : null as any;
        data["resultsDate"] = this.resultsDate !== undefined ? this.resultsDate : null as any;
        data["expireDate"] = this.expireDate !== undefined ? this.expireDate : null as any;
        data["timeoutDate"] = this.timeoutDate !== undefined ? this.timeoutDate : null as any;
        data["resultsStatus"] = this.resultsStatus !== undefined ? this.resultsStatus : null as any;
        data["isFinal"] = this.isFinal !== undefined ? this.isFinal : null as any;
        data["elapsed"] = this.elapsed !== undefined ? this.elapsed : null as any;
        return data;
    }
}

export interface ISupplierCostsPointer {
    supplierId?: number;
    supplier?: EFornitore;
    key?: string;
    searchStatus?: EStatusCostiFornitore;
    luoghiFornitoreIDs?: number[];
    objectId?: string | null;
    resultsCount?: number | null;
    searchTimeSeconds?: number | null;
    startedAt?: string | null;
    resultsDate?: string | null;
    expireDate?: string;
    timeoutDate?: string;
    resultsStatus?: EStatusCostiFornitore;
    isFinal?: boolean;
    elapsed?: number | null;
}

export enum EStatusCostiFornitore {
    Ready = "Ready",
    Running = "Running",
    Done = "Done",
    Error = "Error",
    Expired = "Expired",
    Empty = "Empty",
}

export class GetCacheIndexRequest extends SiteRequest implements IGetCacheIndexRequest {
    /** Chiave da cercare */
    key?: string;

    constructor(data?: IGetCacheIndexRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
        }
    }

    static override fromJS(data: any): GetCacheIndexRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetCacheIndexRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetCacheIndexRequest extends ISiteRequest {
    /** Chiave da cercare */
    key?: string;
}

export class ExpireCacheRequest extends GetCacheIndexRequest implements IExpireCacheRequest {
    fornitore?: EFornitore | null;

    constructor(data?: IExpireCacheRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : null as any;
        }
    }

    static override fromJS(data: any): ExpireCacheRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExpireCacheRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IExpireCacheRequest extends IGetCacheIndexRequest {
    fornitore?: EFornitore | null;
}

export class GetFullContentInfoResponse extends OkApiResponse implements IGetFullContentInfoResponse {
    notFound?: boolean;
    providerCustomDataJson?: string | null;

    constructor(data?: IGetFullContentInfoResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.notFound = _data["notFound"] !== undefined ? _data["notFound"] : null as any;
            this.providerCustomDataJson = _data["providerCustomDataJson"] !== undefined ? _data["providerCustomDataJson"] : null as any;
        }
    }

    static override fromJS(data: any): GetFullContentInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFullContentInfoResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notFound"] = this.notFound !== undefined ? this.notFound : null as any;
        data["providerCustomDataJson"] = this.providerCustomDataJson !== undefined ? this.providerCustomDataJson : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetFullContentInfoResponse extends IOkApiResponse {
    notFound?: boolean;
    providerCustomDataJson?: string | null;
}

export class GetFullContentInfoRequest extends SiteRequest implements IGetFullContentInfoRequest {
    jobID!: string;
    resultID!: string;
    serviceID!: number;
    typeID!: number;
    departureID?: number | null;
    optionID?: number | null;
    optionItemID?: number | null;

    constructor(data?: IGetFullContentInfoRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : null as any;
            this.resultID = _data["resultID"] !== undefined ? _data["resultID"] : null as any;
            this.serviceID = _data["serviceID"] !== undefined ? _data["serviceID"] : null as any;
            this.typeID = _data["typeID"] !== undefined ? _data["typeID"] : null as any;
            this.departureID = _data["departureID"] !== undefined ? _data["departureID"] : null as any;
            this.optionID = _data["optionID"] !== undefined ? _data["optionID"] : null as any;
            this.optionItemID = _data["optionItemID"] !== undefined ? _data["optionItemID"] : null as any;
        }
    }

    static override fromJS(data: any): GetFullContentInfoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFullContentInfoRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobID"] = this.jobID !== undefined ? this.jobID : null as any;
        data["resultID"] = this.resultID !== undefined ? this.resultID : null as any;
        data["serviceID"] = this.serviceID !== undefined ? this.serviceID : null as any;
        data["typeID"] = this.typeID !== undefined ? this.typeID : null as any;
        data["departureID"] = this.departureID !== undefined ? this.departureID : null as any;
        data["optionID"] = this.optionID !== undefined ? this.optionID : null as any;
        data["optionItemID"] = this.optionItemID !== undefined ? this.optionItemID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetFullContentInfoRequest extends ISiteRequest {
    jobID: string;
    resultID: string;
    serviceID: number;
    typeID: number;
    departureID?: number | null;
    optionID?: number | null;
    optionItemID?: number | null;
}

export class GetPoliciesResponse extends OkApiResponse implements IGetPoliciesResponse {
    notFound?: boolean;
    nota?: string | null;
    nonRimborsabile?: boolean;
    pagamentoImmediato?: boolean;
    dataPenale?: string | null;
    importoPenale?: number | null;
    offerte?: DisponibilitaTipologiaOfferta[] | null;
    supplementi?: Supplemento[] | null;
    /** Testi delle penali descrittive. Se c'è un articolo in arrivo dall'H2H usa quello. Altrimenti cerca le penali di riga
negli articoli */
    penaliDescrittive?: TripTextHtml[] | null;

    constructor(data?: IGetPoliciesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.notFound = _data["notFound"] !== undefined ? _data["notFound"] : null as any;
            this.nota = _data["nota"] !== undefined ? _data["nota"] : null as any;
            this.nonRimborsabile = _data["nonRimborsabile"] !== undefined ? _data["nonRimborsabile"] : null as any;
            this.pagamentoImmediato = _data["pagamentoImmediato"] !== undefined ? _data["pagamentoImmediato"] : null as any;
            this.dataPenale = _data["dataPenale"] !== undefined ? _data["dataPenale"] : null as any;
            this.importoPenale = _data["importoPenale"] !== undefined ? _data["importoPenale"] : null as any;
            if (Array.isArray(_data["offerte"])) {
                this.offerte = [] as any;
                for (let item of _data["offerte"])
                    this.offerte!.push(DisponibilitaTipologiaOfferta.fromJS(item));
            }
            else {
                this.offerte = null as any;
            }
            if (Array.isArray(_data["supplementi"])) {
                this.supplementi = [] as any;
                for (let item of _data["supplementi"])
                    this.supplementi!.push(Supplemento.fromJS(item));
            }
            else {
                this.supplementi = null as any;
            }
            if (Array.isArray(_data["penaliDescrittive"])) {
                this.penaliDescrittive = [] as any;
                for (let item of _data["penaliDescrittive"])
                    this.penaliDescrittive!.push(TripTextHtml.fromJS(item));
            }
            else {
                this.penaliDescrittive = null as any;
            }
        }
    }

    static override fromJS(data: any): GetPoliciesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPoliciesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notFound"] = this.notFound !== undefined ? this.notFound : null as any;
        data["nota"] = this.nota !== undefined ? this.nota : null as any;
        data["nonRimborsabile"] = this.nonRimborsabile !== undefined ? this.nonRimborsabile : null as any;
        data["pagamentoImmediato"] = this.pagamentoImmediato !== undefined ? this.pagamentoImmediato : null as any;
        data["dataPenale"] = this.dataPenale !== undefined ? this.dataPenale : null as any;
        data["importoPenale"] = this.importoPenale !== undefined ? this.importoPenale : null as any;
        if (Array.isArray(this.offerte)) {
            data["offerte"] = [];
            for (let item of this.offerte)
                data["offerte"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.supplementi)) {
            data["supplementi"] = [];
            for (let item of this.supplementi)
                data["supplementi"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.penaliDescrittive)) {
            data["penaliDescrittive"] = [];
            for (let item of this.penaliDescrittive)
                data["penaliDescrittive"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPoliciesResponse extends IOkApiResponse {
    notFound?: boolean;
    nota?: string | null;
    nonRimborsabile?: boolean;
    pagamentoImmediato?: boolean;
    dataPenale?: string | null;
    importoPenale?: number | null;
    offerte?: DisponibilitaTipologiaOfferta[] | null;
    supplementi?: Supplemento[] | null;
    /** Testi delle penali descrittive. Se c'è un articolo in arrivo dall'H2H usa quello. Altrimenti cerca le penali di riga
negli articoli */
    penaliDescrittive?: TripTextHtml[] | null;
}

export class DisponibilitaTipologiaOfferta implements IDisponibilitaTipologiaOfferta {
    prezzo?: number;
    costo?: number;
    label?: string | null;
    idserv_sup?: number;
    tipo?: ETipoAzioneDettaglio;

    constructor(data?: IDisponibilitaTipologiaOfferta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : null as any;
            this.costo = _data["costo"] !== undefined ? _data["costo"] : null as any;
            this.label = _data["label"] !== undefined ? _data["label"] : null as any;
            this.idserv_sup = _data["idserv_sup"] !== undefined ? _data["idserv_sup"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
        }
    }

    static fromJS(data: any): DisponibilitaTipologiaOfferta {
        data = typeof data === 'object' ? data : {};
        let result = new DisponibilitaTipologiaOfferta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : null as any;
        data["costo"] = this.costo !== undefined ? this.costo : null as any;
        data["label"] = this.label !== undefined ? this.label : null as any;
        data["idserv_sup"] = this.idserv_sup !== undefined ? this.idserv_sup : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        return data;
    }
}

export interface IDisponibilitaTipologiaOfferta {
    prezzo?: number;
    costo?: number;
    label?: string | null;
    idserv_sup?: number;
    tipo?: ETipoAzioneDettaglio;
}

export class Supplemento implements ISupplemento {
    id?: number;
    obbligatorio?: boolean;
    percentuale?: boolean;
    alternative?: SupplementoAlternativa[] | null;

    constructor(data?: ISupplemento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.obbligatorio = _data["obbligatorio"] !== undefined ? _data["obbligatorio"] : null as any;
            this.percentuale = _data["percentuale"] !== undefined ? _data["percentuale"] : null as any;
            if (Array.isArray(_data["alternative"])) {
                this.alternative = [] as any;
                for (let item of _data["alternative"])
                    this.alternative!.push(SupplementoAlternativa.fromJS(item));
            }
            else {
                this.alternative = null as any;
            }
        }
    }

    static fromJS(data: any): Supplemento {
        data = typeof data === 'object' ? data : {};
        let result = new Supplemento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["obbligatorio"] = this.obbligatorio !== undefined ? this.obbligatorio : null as any;
        data["percentuale"] = this.percentuale !== undefined ? this.percentuale : null as any;
        if (Array.isArray(this.alternative)) {
            data["alternative"] = [];
            for (let item of this.alternative)
                data["alternative"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ISupplemento {
    id?: number;
    obbligatorio?: boolean;
    percentuale?: boolean;
    alternative?: SupplementoAlternativa[] | null;
}

export class SupplementoAlternativa implements ISupplementoAlternativa {
    id?: number;
    nome?: string;
    prezzoPieno?: number | null;
    prezzoPienoValuta?: number | null;
    prezzo?: number;
    prezzoValuta?: number | null;
    prezzoIndicativo?: boolean;

    constructor(data?: ISupplementoAlternativa) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.prezzoPieno = _data["prezzoPieno"] !== undefined ? _data["prezzoPieno"] : null as any;
            this.prezzoPienoValuta = _data["prezzoPienoValuta"] !== undefined ? _data["prezzoPienoValuta"] : null as any;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : null as any;
            this.prezzoValuta = _data["prezzoValuta"] !== undefined ? _data["prezzoValuta"] : null as any;
            this.prezzoIndicativo = _data["prezzoIndicativo"] !== undefined ? _data["prezzoIndicativo"] : null as any;
        }
    }

    static fromJS(data: any): SupplementoAlternativa {
        data = typeof data === 'object' ? data : {};
        let result = new SupplementoAlternativa();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["prezzoPieno"] = this.prezzoPieno !== undefined ? this.prezzoPieno : null as any;
        data["prezzoPienoValuta"] = this.prezzoPienoValuta !== undefined ? this.prezzoPienoValuta : null as any;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : null as any;
        data["prezzoValuta"] = this.prezzoValuta !== undefined ? this.prezzoValuta : null as any;
        data["prezzoIndicativo"] = this.prezzoIndicativo !== undefined ? this.prezzoIndicativo : null as any;
        return data;
    }
}

export interface ISupplementoAlternativa {
    id?: number;
    nome?: string;
    prezzoPieno?: number | null;
    prezzoPienoValuta?: number | null;
    prezzo?: number;
    prezzoValuta?: number | null;
    prezzoIndicativo?: boolean;
}

export class GetPoliciesRequest extends SiteRequest implements IGetPoliciesRequest {
    jobID!: string;
    resultID!: string;
    serviceID!: number;
    typeID!: number;
    departureID?: number | null;
    optionID?: number | null;
    optionItemID?: number | null;

    constructor(data?: IGetPoliciesRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : null as any;
            this.resultID = _data["resultID"] !== undefined ? _data["resultID"] : null as any;
            this.serviceID = _data["serviceID"] !== undefined ? _data["serviceID"] : null as any;
            this.typeID = _data["typeID"] !== undefined ? _data["typeID"] : null as any;
            this.departureID = _data["departureID"] !== undefined ? _data["departureID"] : null as any;
            this.optionID = _data["optionID"] !== undefined ? _data["optionID"] : null as any;
            this.optionItemID = _data["optionItemID"] !== undefined ? _data["optionItemID"] : null as any;
        }
    }

    static override fromJS(data: any): GetPoliciesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPoliciesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobID"] = this.jobID !== undefined ? this.jobID : null as any;
        data["resultID"] = this.resultID !== undefined ? this.resultID : null as any;
        data["serviceID"] = this.serviceID !== undefined ? this.serviceID : null as any;
        data["typeID"] = this.typeID !== undefined ? this.typeID : null as any;
        data["departureID"] = this.departureID !== undefined ? this.departureID : null as any;
        data["optionID"] = this.optionID !== undefined ? this.optionID : null as any;
        data["optionItemID"] = this.optionItemID !== undefined ? this.optionItemID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPoliciesRequest extends ISiteRequest {
    jobID: string;
    resultID: string;
    serviceID: number;
    typeID: number;
    departureID?: number | null;
    optionID?: number | null;
    optionItemID?: number | null;
}

export class GetQueuesResponse extends OkApiResponse implements IGetQueuesResponse {
    cacheSummary?: QueueStats | null;
    cacheStats?: CacheHitStat[] | null;
    lastSarches?: SearchItem[] | null;
    suppliersStatus?: SupplierSearchStats[] | null;
    suppliersSearchStatsTotals?: SuppliersSearchStatsTotals | null;
    searchesByTime?: QueueChartData[] | null;

    constructor(data?: IGetQueuesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cacheSummary = _data["cacheSummary"] ? QueueStats.fromJS(_data["cacheSummary"]) : null as any;
            if (Array.isArray(_data["cacheStats"])) {
                this.cacheStats = [] as any;
                for (let item of _data["cacheStats"])
                    this.cacheStats!.push(CacheHitStat.fromJS(item));
            }
            else {
                this.cacheStats = null as any;
            }
            if (Array.isArray(_data["lastSarches"])) {
                this.lastSarches = [] as any;
                for (let item of _data["lastSarches"])
                    this.lastSarches!.push(SearchItem.fromJS(item));
            }
            else {
                this.lastSarches = null as any;
            }
            if (Array.isArray(_data["suppliersStatus"])) {
                this.suppliersStatus = [] as any;
                for (let item of _data["suppliersStatus"])
                    this.suppliersStatus!.push(SupplierSearchStats.fromJS(item));
            }
            else {
                this.suppliersStatus = null as any;
            }
            this.suppliersSearchStatsTotals = _data["suppliersSearchStatsTotals"] ? SuppliersSearchStatsTotals.fromJS(_data["suppliersSearchStatsTotals"]) : null as any;
            if (Array.isArray(_data["searchesByTime"])) {
                this.searchesByTime = [] as any;
                for (let item of _data["searchesByTime"])
                    this.searchesByTime!.push(QueueChartData.fromJS(item));
            }
            else {
                this.searchesByTime = null as any;
            }
        }
    }

    static override fromJS(data: any): GetQueuesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetQueuesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cacheSummary"] = this.cacheSummary ? this.cacheSummary.toJSON() : null as any;
        if (Array.isArray(this.cacheStats)) {
            data["cacheStats"] = [];
            for (let item of this.cacheStats)
                data["cacheStats"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.lastSarches)) {
            data["lastSarches"] = [];
            for (let item of this.lastSarches)
                data["lastSarches"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.suppliersStatus)) {
            data["suppliersStatus"] = [];
            for (let item of this.suppliersStatus)
                data["suppliersStatus"].push(item ? item.toJSON() : null as any);
        }
        data["suppliersSearchStatsTotals"] = this.suppliersSearchStatsTotals ? this.suppliersSearchStatsTotals.toJSON() : null as any;
        if (Array.isArray(this.searchesByTime)) {
            data["searchesByTime"] = [];
            for (let item of this.searchesByTime)
                data["searchesByTime"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetQueuesResponse extends IOkApiResponse {
    cacheSummary?: QueueStats | null;
    cacheStats?: CacheHitStat[] | null;
    lastSarches?: SearchItem[] | null;
    suppliersStatus?: SupplierSearchStats[] | null;
    suppliersSearchStatsTotals?: SuppliersSearchStatsTotals | null;
    searchesByTime?: QueueChartData[] | null;
}

export class QueueStats implements IQueueStats {
    items?: number;
    size?: number;
    avgSize?: number | null;
    storageSize?: number;

    constructor(data?: IQueueStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.items = _data["items"] !== undefined ? _data["items"] : null as any;
            this.size = _data["size"] !== undefined ? _data["size"] : null as any;
            this.avgSize = _data["avgSize"] !== undefined ? _data["avgSize"] : null as any;
            this.storageSize = _data["storageSize"] !== undefined ? _data["storageSize"] : null as any;
        }
    }

    static fromJS(data: any): QueueStats {
        data = typeof data === 'object' ? data : {};
        let result = new QueueStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["items"] = this.items !== undefined ? this.items : null as any;
        data["size"] = this.size !== undefined ? this.size : null as any;
        data["avgSize"] = this.avgSize !== undefined ? this.avgSize : null as any;
        data["storageSize"] = this.storageSize !== undefined ? this.storageSize : null as any;
        return data;
    }
}

export interface IQueueStats {
    items?: number;
    size?: number;
    avgSize?: number | null;
    storageSize?: number;
}

export class CacheHitStat implements ICacheHitStat {
    hits?: number;
    count?: number;

    constructor(data?: ICacheHitStat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hits = _data["hits"] !== undefined ? _data["hits"] : null as any;
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
        }
    }

    static fromJS(data: any): CacheHitStat {
        data = typeof data === 'object' ? data : {};
        let result = new CacheHitStat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hits"] = this.hits !== undefined ? this.hits : null as any;
        data["count"] = this.count !== undefined ? this.count : null as any;
        return data;
    }
}

export interface ICacheHitStat {
    hits?: number;
    count?: number;
}

export class SearchItem implements ISearchItem {
    data?: string;
    tipo?: ETipoServizioSearch;
    luogo?: string | null;
    dal?: string;
    al?: string;
    abbinamenti?: number;
    adulti?: number;
    bambini?: number;
    infant?: number;
    stato?: EStatusCostiFornitore;
    statoID?: number;
    utente?: string | null;
    supplierCompleti?: number;
    supplierTotali?: number;

    constructor(data?: ISearchItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.al = _data["al"] !== undefined ? _data["al"] : null as any;
            this.abbinamenti = _data["abbinamenti"] !== undefined ? _data["abbinamenti"] : null as any;
            this.adulti = _data["adulti"] !== undefined ? _data["adulti"] : null as any;
            this.bambini = _data["bambini"] !== undefined ? _data["bambini"] : null as any;
            this.infant = _data["infant"] !== undefined ? _data["infant"] : null as any;
            this.stato = _data["stato"] !== undefined ? _data["stato"] : null as any;
            this.statoID = _data["statoID"] !== undefined ? _data["statoID"] : null as any;
            this.utente = _data["utente"] !== undefined ? _data["utente"] : null as any;
            this.supplierCompleti = _data["supplierCompleti"] !== undefined ? _data["supplierCompleti"] : null as any;
            this.supplierTotali = _data["supplierTotali"] !== undefined ? _data["supplierTotali"] : null as any;
        }
    }

    static fromJS(data: any): SearchItem {
        data = typeof data === 'object' ? data : {};
        let result = new SearchItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["al"] = this.al !== undefined ? this.al : null as any;
        data["abbinamenti"] = this.abbinamenti !== undefined ? this.abbinamenti : null as any;
        data["adulti"] = this.adulti !== undefined ? this.adulti : null as any;
        data["bambini"] = this.bambini !== undefined ? this.bambini : null as any;
        data["infant"] = this.infant !== undefined ? this.infant : null as any;
        data["stato"] = this.stato !== undefined ? this.stato : null as any;
        data["statoID"] = this.statoID !== undefined ? this.statoID : null as any;
        data["utente"] = this.utente !== undefined ? this.utente : null as any;
        data["supplierCompleti"] = this.supplierCompleti !== undefined ? this.supplierCompleti : null as any;
        data["supplierTotali"] = this.supplierTotali !== undefined ? this.supplierTotali : null as any;
        return data;
    }
}

export interface ISearchItem {
    data?: string;
    tipo?: ETipoServizioSearch;
    luogo?: string | null;
    dal?: string;
    al?: string;
    abbinamenti?: number;
    adulti?: number;
    bambini?: number;
    infant?: number;
    stato?: EStatusCostiFornitore;
    statoID?: number;
    utente?: string | null;
    supplierCompleti?: number;
    supplierTotali?: number;
}

export class SupplierSearchStats implements ISupplierSearchStats {
    supplier?: string | null;
    lastRunTime?: string | null;
    running?: number;
    total?: number;
    complete?: number;
    minSearchTimeSec?: number | null;
    maxSearchTimeSec?: number | null;
    avgSearchTimeSec?: number | null;

    constructor(data?: ISupplierSearchStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : null as any;
            this.lastRunTime = _data["lastRunTime"] !== undefined ? _data["lastRunTime"] : null as any;
            this.running = _data["running"] !== undefined ? _data["running"] : null as any;
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
            this.complete = _data["complete"] !== undefined ? _data["complete"] : null as any;
            this.minSearchTimeSec = _data["minSearchTimeSec"] !== undefined ? _data["minSearchTimeSec"] : null as any;
            this.maxSearchTimeSec = _data["maxSearchTimeSec"] !== undefined ? _data["maxSearchTimeSec"] : null as any;
            this.avgSearchTimeSec = _data["avgSearchTimeSec"] !== undefined ? _data["avgSearchTimeSec"] : null as any;
        }
    }

    static fromJS(data: any): SupplierSearchStats {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierSearchStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplier"] = this.supplier !== undefined ? this.supplier : null as any;
        data["lastRunTime"] = this.lastRunTime !== undefined ? this.lastRunTime : null as any;
        data["running"] = this.running !== undefined ? this.running : null as any;
        data["total"] = this.total !== undefined ? this.total : null as any;
        data["complete"] = this.complete !== undefined ? this.complete : null as any;
        data["minSearchTimeSec"] = this.minSearchTimeSec !== undefined ? this.minSearchTimeSec : null as any;
        data["maxSearchTimeSec"] = this.maxSearchTimeSec !== undefined ? this.maxSearchTimeSec : null as any;
        data["avgSearchTimeSec"] = this.avgSearchTimeSec !== undefined ? this.avgSearchTimeSec : null as any;
        return data;
    }
}

export interface ISupplierSearchStats {
    supplier?: string | null;
    lastRunTime?: string | null;
    running?: number;
    total?: number;
    complete?: number;
    minSearchTimeSec?: number | null;
    maxSearchTimeSec?: number | null;
    avgSearchTimeSec?: number | null;
}

export class SuppliersSearchStatsTotals implements ISuppliersSearchStatsTotals {
    searches?: number;
    searchesNaar?: number;
    searchesH2H?: number;
    done?: number;
    running?: number;
    faulted?: number;

    constructor(data?: ISuppliersSearchStatsTotals) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searches = _data["searches"] !== undefined ? _data["searches"] : null as any;
            this.searchesNaar = _data["searchesNaar"] !== undefined ? _data["searchesNaar"] : null as any;
            this.searchesH2H = _data["searchesH2H"] !== undefined ? _data["searchesH2H"] : null as any;
            this.done = _data["done"] !== undefined ? _data["done"] : null as any;
            this.running = _data["running"] !== undefined ? _data["running"] : null as any;
            this.faulted = _data["faulted"] !== undefined ? _data["faulted"] : null as any;
        }
    }

    static fromJS(data: any): SuppliersSearchStatsTotals {
        data = typeof data === 'object' ? data : {};
        let result = new SuppliersSearchStatsTotals();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searches"] = this.searches !== undefined ? this.searches : null as any;
        data["searchesNaar"] = this.searchesNaar !== undefined ? this.searchesNaar : null as any;
        data["searchesH2H"] = this.searchesH2H !== undefined ? this.searchesH2H : null as any;
        data["done"] = this.done !== undefined ? this.done : null as any;
        data["running"] = this.running !== undefined ? this.running : null as any;
        data["faulted"] = this.faulted !== undefined ? this.faulted : null as any;
        return data;
    }
}

export interface ISuppliersSearchStatsTotals {
    searches?: number;
    searchesNaar?: number;
    searchesH2H?: number;
    done?: number;
    running?: number;
    faulted?: number;
}

export class QueueChartData implements IQueueChartData {
    label?: string | null;
    date?: string;
    done?: number;
    faulted?: number;
    running?: number;
    duration?: number | null;
    avg?: number | null;

    constructor(data?: IQueueChartData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"] !== undefined ? _data["label"] : null as any;
            this.date = _data["date"] !== undefined ? _data["date"] : null as any;
            this.done = _data["done"] !== undefined ? _data["done"] : null as any;
            this.faulted = _data["faulted"] !== undefined ? _data["faulted"] : null as any;
            this.running = _data["running"] !== undefined ? _data["running"] : null as any;
            this.duration = _data["duration"] !== undefined ? _data["duration"] : null as any;
            this.avg = _data["avg"] !== undefined ? _data["avg"] : null as any;
        }
    }

    static fromJS(data: any): QueueChartData {
        data = typeof data === 'object' ? data : {};
        let result = new QueueChartData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label !== undefined ? this.label : null as any;
        data["date"] = this.date !== undefined ? this.date : null as any;
        data["done"] = this.done !== undefined ? this.done : null as any;
        data["faulted"] = this.faulted !== undefined ? this.faulted : null as any;
        data["running"] = this.running !== undefined ? this.running : null as any;
        data["duration"] = this.duration !== undefined ? this.duration : null as any;
        data["avg"] = this.avg !== undefined ? this.avg : null as any;
        return data;
    }
}

export interface IQueueChartData {
    label?: string | null;
    date?: string;
    done?: number;
    faulted?: number;
    running?: number;
    duration?: number | null;
    avg?: number | null;
}

export class GetSupplierPricesResponse extends OkApiResponse implements IGetSupplierPricesResponse {
    jobID?: string;
    servizi?: ServicePrice[];
    logs?: H2HLog[];
    contracts?: ContractCurrency[];

    constructor(data?: IGetSupplierPricesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : null as any;
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(ServicePrice.fromJS(item));
            }
            else {
                this.servizi = null as any;
            }
            if (Array.isArray(_data["logs"])) {
                this.logs = [] as any;
                for (let item of _data["logs"])
                    this.logs!.push(H2HLog.fromJS(item));
            }
            else {
                this.logs = null as any;
            }
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(ContractCurrency.fromJS(item));
            }
            else {
                this.contracts = null as any;
            }
        }
    }

    static override fromJS(data: any): GetSupplierPricesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSupplierPricesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobID"] = this.jobID !== undefined ? this.jobID : null as any;
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetSupplierPricesResponse extends IOkApiResponse {
    jobID?: string;
    servizi?: ServicePrice[];
    logs?: H2HLog[];
    contracts?: ContractCurrency[];
}

export class GetRawPricesResponse extends GetSupplierPricesResponse implements IGetRawPricesResponse {
    mappedRequest?: GetSupplierPricesRequest;

    constructor(data?: IGetRawPricesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.mappedRequest = _data["mappedRequest"] ? GetSupplierPricesRequest.fromJS(_data["mappedRequest"]) : null as any;
        }
    }

    static override fromJS(data: any): GetRawPricesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRawPricesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mappedRequest"] = this.mappedRequest ? this.mappedRequest.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetRawPricesResponse extends IGetSupplierPricesResponse {
    mappedRequest?: GetSupplierPricesRequest;
}

export class GetSupplierPricesRequest extends LocalizedRequest implements IGetSupplierPricesRequest {
    fornitore!: EFornitore;
    tipoLuogoRicercaPrezzi!: ETipoLuogoRicercaPrezzi;
    luogoID?: number;
    luogoDestinazioneID?: number | null;
    data?: string;
    notti?: number;
    tipoServizio!: ETipoServizio;
    camere!: SupplierPricesRoom[];
    listinoPrezzi!: EListinoPrezzi;
    utenteRicercaID?: number | null;
    oraPickup?: number | null;
    oraDropoff?: number | null;
    /** ID di servizio singolo */
    servizioID?: number | null;

    constructor(data?: IGetSupplierPricesRequest) {
        super(data);
        if (!data) {
            this.camere = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : null as any;
            this.tipoLuogoRicercaPrezzi = _data["tipoLuogoRicercaPrezzi"] !== undefined ? _data["tipoLuogoRicercaPrezzi"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.luogoDestinazioneID = _data["luogoDestinazioneID"] !== undefined ? _data["luogoDestinazioneID"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
            this.notti = _data["notti"] !== undefined ? _data["notti"] : null as any;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
            if (Array.isArray(_data["camere"])) {
                this.camere = [] as any;
                for (let item of _data["camere"])
                    this.camere!.push(SupplierPricesRoom.fromJS(item));
            }
            else {
                this.camere = null as any;
            }
            this.listinoPrezzi = _data["listinoPrezzi"] !== undefined ? _data["listinoPrezzi"] : null as any;
            this.utenteRicercaID = _data["utenteRicercaID"] !== undefined ? _data["utenteRicercaID"] : null as any;
            this.oraPickup = _data["oraPickup"] !== undefined ? _data["oraPickup"] : null as any;
            this.oraDropoff = _data["oraDropoff"] !== undefined ? _data["oraDropoff"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
        }
    }

    static override fromJS(data: any): GetSupplierPricesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSupplierPricesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : null as any;
        data["tipoLuogoRicercaPrezzi"] = this.tipoLuogoRicercaPrezzi !== undefined ? this.tipoLuogoRicercaPrezzi : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["luogoDestinazioneID"] = this.luogoDestinazioneID !== undefined ? this.luogoDestinazioneID : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["notti"] = this.notti !== undefined ? this.notti : null as any;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        if (Array.isArray(this.camere)) {
            data["camere"] = [];
            for (let item of this.camere)
                data["camere"].push(item ? item.toJSON() : null as any);
        }
        data["listinoPrezzi"] = this.listinoPrezzi !== undefined ? this.listinoPrezzi : null as any;
        data["utenteRicercaID"] = this.utenteRicercaID !== undefined ? this.utenteRicercaID : null as any;
        data["oraPickup"] = this.oraPickup !== undefined ? this.oraPickup : null as any;
        data["oraDropoff"] = this.oraDropoff !== undefined ? this.oraDropoff : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetSupplierPricesRequest extends ILocalizedRequest {
    fornitore: EFornitore;
    tipoLuogoRicercaPrezzi: ETipoLuogoRicercaPrezzi;
    luogoID?: number;
    luogoDestinazioneID?: number | null;
    data?: string;
    notti?: number;
    tipoServizio: ETipoServizio;
    camere: SupplierPricesRoom[];
    listinoPrezzi: EListinoPrezzi;
    utenteRicercaID?: number | null;
    oraPickup?: number | null;
    oraDropoff?: number | null;
    /** ID di servizio singolo */
    servizioID?: number | null;
}

export enum ETipoLuogoRicercaPrezzi {
    LuogoNaar = "LuogoNaar",
    LuogoFornitore = "LuogoFornitore",
}

export class SupplierPricesRoom implements ISupplierPricesRoom {
    adulti?: number;
    senior?: number;
    bambini?: SupplierPricesChild[] | null;

    constructor(data?: ISupplierPricesRoom) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adulti = _data["adulti"] !== undefined ? _data["adulti"] : null as any;
            this.senior = _data["senior"] !== undefined ? _data["senior"] : null as any;
            if (Array.isArray(_data["bambini"])) {
                this.bambini = [] as any;
                for (let item of _data["bambini"])
                    this.bambini!.push(SupplierPricesChild.fromJS(item));
            }
            else {
                this.bambini = null as any;
            }
        }
    }

    static fromJS(data: any): SupplierPricesRoom {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierPricesRoom();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adulti"] = this.adulti !== undefined ? this.adulti : null as any;
        data["senior"] = this.senior !== undefined ? this.senior : null as any;
        if (Array.isArray(this.bambini)) {
            data["bambini"] = [];
            for (let item of this.bambini)
                data["bambini"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ISupplierPricesRoom {
    adulti?: number;
    senior?: number;
    bambini?: SupplierPricesChild[] | null;
}

export class SupplierPricesChild implements ISupplierPricesChild {
    eta?: number;

    constructor(data?: ISupplierPricesChild) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eta = _data["eta"] !== undefined ? _data["eta"] : null as any;
        }
    }

    static fromJS(data: any): SupplierPricesChild {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierPricesChild();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eta"] = this.eta !== undefined ? this.eta : null as any;
        return data;
    }
}

export interface ISupplierPricesChild {
    eta?: number;
}

export class ServicePrice implements IServicePrice {
    id?: number;
    uniqueID?: string;
    unmapped?: boolean;
    nome?: string;
    codice?: string;
    details?: boolean;
    roomsCount?: number;
    minPrice?: number;
    results?: DisponibilitaServizio[];

    constructor(data?: IServicePrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.uniqueID = _data["uniqueID"] !== undefined ? _data["uniqueID"] : null as any;
            this.unmapped = _data["unmapped"] !== undefined ? _data["unmapped"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
            this.details = _data["details"] !== undefined ? _data["details"] : null as any;
            this.roomsCount = _data["roomsCount"] !== undefined ? _data["roomsCount"] : null as any;
            this.minPrice = _data["minPrice"] !== undefined ? _data["minPrice"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DisponibilitaServizio.fromJS(item));
            }
            else {
                this.results = null as any;
            }
        }
    }

    static fromJS(data: any): ServicePrice {
        data = typeof data === 'object' ? data : {};
        let result = new ServicePrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["uniqueID"] = this.uniqueID !== undefined ? this.uniqueID : null as any;
        data["unmapped"] = this.unmapped !== undefined ? this.unmapped : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        data["details"] = this.details !== undefined ? this.details : null as any;
        data["roomsCount"] = this.roomsCount !== undefined ? this.roomsCount : null as any;
        data["minPrice"] = this.minPrice !== undefined ? this.minPrice : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IServicePrice {
    id?: number;
    uniqueID?: string;
    unmapped?: boolean;
    nome?: string;
    codice?: string;
    details?: boolean;
    roomsCount?: number;
    minPrice?: number;
    results?: DisponibilitaServizio[];
}

export class DisponibilitaServizio implements IDisponibilitaServizio {
    servizioID?: number;
    codServizio?: string | null;
    tipologie?: DisponibilitaTipologia[] | null;
    providerCustomData?: string | null;
    nonMappato?: boolean;
    resultID?: number;
    datiCosto?: DisponibilitaDatiCosto | null;
    servizioH2HID?: number | null;
    tipologieByID?: { [key: string]: DisponibilitaTipologia; } | null;

    constructor(data?: IDisponibilitaServizio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.codServizio = _data["codServizio"] !== undefined ? _data["codServizio"] : null as any;
            if (Array.isArray(_data["tipologie"])) {
                this.tipologie = [] as any;
                for (let item of _data["tipologie"])
                    this.tipologie!.push(DisponibilitaTipologia.fromJS(item));
            }
            else {
                this.tipologie = null as any;
            }
            this.providerCustomData = _data["providerCustomData"] !== undefined ? _data["providerCustomData"] : null as any;
            this.nonMappato = _data["nonMappato"] !== undefined ? _data["nonMappato"] : null as any;
            this.resultID = _data["resultID"] !== undefined ? _data["resultID"] : null as any;
            this.datiCosto = _data["datiCosto"] ? DisponibilitaDatiCosto.fromJS(_data["datiCosto"]) : null as any;
            this.servizioH2HID = _data["servizioH2HID"] !== undefined ? _data["servizioH2HID"] : null as any;
            if (_data["tipologieByID"]) {
                this.tipologieByID = {} as any;
                for (let key in _data["tipologieByID"]) {
                    if (_data["tipologieByID"].hasOwnProperty(key))
                        (this.tipologieByID as any)![key] = _data["tipologieByID"][key] ? DisponibilitaTipologia.fromJS(_data["tipologieByID"][key]) : new DisponibilitaTipologia();
                }
            }
            else {
                this.tipologieByID = null as any;
            }
        }
    }

    static fromJS(data: any): DisponibilitaServizio {
        data = typeof data === 'object' ? data : {};
        let result = new DisponibilitaServizio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["codServizio"] = this.codServizio !== undefined ? this.codServizio : null as any;
        if (Array.isArray(this.tipologie)) {
            data["tipologie"] = [];
            for (let item of this.tipologie)
                data["tipologie"].push(item ? item.toJSON() : null as any);
        }
        data["providerCustomData"] = this.providerCustomData !== undefined ? this.providerCustomData : null as any;
        data["nonMappato"] = this.nonMappato !== undefined ? this.nonMappato : null as any;
        data["resultID"] = this.resultID !== undefined ? this.resultID : null as any;
        data["datiCosto"] = this.datiCosto ? this.datiCosto.toJSON() : null as any;
        data["servizioH2HID"] = this.servizioH2HID !== undefined ? this.servizioH2HID : null as any;
        if (this.tipologieByID) {
            data["tipologieByID"] = {};
            for (let key in this.tipologieByID) {
                if (this.tipologieByID.hasOwnProperty(key))
                    (data["tipologieByID"] as any)[key] = this.tipologieByID[key] ? this.tipologieByID[key].toJSON() : null as any;
            }
        }
        return data;
    }
}

export interface IDisponibilitaServizio {
    servizioID?: number;
    codServizio?: string | null;
    tipologie?: DisponibilitaTipologia[] | null;
    providerCustomData?: string | null;
    nonMappato?: boolean;
    resultID?: number;
    datiCosto?: DisponibilitaDatiCosto | null;
    servizioH2HID?: number | null;
    tipologieByID?: { [key: string]: DisponibilitaTipologia; } | null;
}

export class DisponibilitaTipologia implements IDisponibilitaTipologia {
    id?: number;
    prenotabile?: boolean;
    messaggioPrenotabile?: string | null;
    resultItemID?: number;
    accordoID?: number;
    servizioFornitoreID?: number;
    gruppoID?: number;
    servizioTipologiaID?: number | null;
    trattamentoID?: number | null;
    codTipologiaServizio?: string | null;
    codPrenotazione?: string | null;
    descrizione?: string | null;
    descrizioneTipologia?: string | null;
    statoDisponibilita?: EStatoDisponibilita;
    tabAllotmentID?: number | null;
    costi?: DisponibilitaTipologiaCosto[] | null;
    supplementi?: DisponibilitaSupplemento[] | null;
    partenze?: DisponibilitaPartenza[] | null;
    penaleID?: number;
    providerCustomData?: string | null;
    descrizioneFornitore?: string | null;
    codiceMappingGenerico?: string | null;
    notRefundable?: boolean;
    instantPurchase?: boolean;
    weddingRate?: boolean;
    tabellaCostoID?: number;
    descrizioneTabellaCosto?: string | null;
    resultID?: number;
    offerte?: DisponibilitaTipologiaOfferta[] | null;
    nota?: string | null;
    prezzoAdulti?: number;
    prezzoBambini?: number;
    descrizioneID?: number | null;
    dataPenale?: string | null;
    importoPenale?: number | null;
    articoloPenaleID?: number | null;
    tariffeMezzaDoppia?: TariffaMezzaDoppia[] | null;
    prezziGiorniPax?: PrezzoGiornoPax[] | null;
    beddignCalcolatoID?: number | null;
    regolaVenditaPenaleID?: number | null;
    hashcodeID?: number | null;
    bedsID?: number | null;
    mealID?: number | null;
    regolaVenditaID?: number | null;
    descrizioneTariffa?: string | null;
    fullContent?: boolean;
    nomeAccordo?: string | null;
    accordoFisso?: boolean;
    prezzoTotaleDebug?: number;
    costoTotale?: number;
    markup?: number | null;
    trattamento?: string | null;

    constructor(data?: IDisponibilitaTipologia) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.prenotabile = _data["prenotabile"] !== undefined ? _data["prenotabile"] : null as any;
            this.messaggioPrenotabile = _data["messaggioPrenotabile"] !== undefined ? _data["messaggioPrenotabile"] : null as any;
            this.resultItemID = _data["resultItemID"] !== undefined ? _data["resultItemID"] : null as any;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.servizioFornitoreID = _data["servizioFornitoreID"] !== undefined ? _data["servizioFornitoreID"] : null as any;
            this.gruppoID = _data["gruppoID"] !== undefined ? _data["gruppoID"] : null as any;
            this.servizioTipologiaID = _data["servizioTipologiaID"] !== undefined ? _data["servizioTipologiaID"] : null as any;
            this.trattamentoID = _data["trattamentoID"] !== undefined ? _data["trattamentoID"] : null as any;
            this.codTipologiaServizio = _data["codTipologiaServizio"] !== undefined ? _data["codTipologiaServizio"] : null as any;
            this.codPrenotazione = _data["codPrenotazione"] !== undefined ? _data["codPrenotazione"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.descrizioneTipologia = _data["descrizioneTipologia"] !== undefined ? _data["descrizioneTipologia"] : null as any;
            this.statoDisponibilita = _data["statoDisponibilita"] !== undefined ? _data["statoDisponibilita"] : null as any;
            this.tabAllotmentID = _data["tabAllotmentID"] !== undefined ? _data["tabAllotmentID"] : null as any;
            if (Array.isArray(_data["costi"])) {
                this.costi = [] as any;
                for (let item of _data["costi"])
                    this.costi!.push(DisponibilitaTipologiaCosto.fromJS(item));
            }
            else {
                this.costi = null as any;
            }
            if (Array.isArray(_data["supplementi"])) {
                this.supplementi = [] as any;
                for (let item of _data["supplementi"])
                    this.supplementi!.push(DisponibilitaSupplemento.fromJS(item));
            }
            else {
                this.supplementi = null as any;
            }
            if (Array.isArray(_data["partenze"])) {
                this.partenze = [] as any;
                for (let item of _data["partenze"])
                    this.partenze!.push(DisponibilitaPartenza.fromJS(item));
            }
            else {
                this.partenze = null as any;
            }
            this.penaleID = _data["penaleID"] !== undefined ? _data["penaleID"] : null as any;
            this.providerCustomData = _data["providerCustomData"] !== undefined ? _data["providerCustomData"] : null as any;
            this.descrizioneFornitore = _data["descrizioneFornitore"] !== undefined ? _data["descrizioneFornitore"] : null as any;
            this.codiceMappingGenerico = _data["codiceMappingGenerico"] !== undefined ? _data["codiceMappingGenerico"] : null as any;
            this.notRefundable = _data["notRefundable"] !== undefined ? _data["notRefundable"] : null as any;
            this.instantPurchase = _data["instantPurchase"] !== undefined ? _data["instantPurchase"] : null as any;
            this.weddingRate = _data["weddingRate"] !== undefined ? _data["weddingRate"] : null as any;
            this.tabellaCostoID = _data["tabellaCostoID"] !== undefined ? _data["tabellaCostoID"] : null as any;
            this.descrizioneTabellaCosto = _data["descrizioneTabellaCosto"] !== undefined ? _data["descrizioneTabellaCosto"] : null as any;
            this.resultID = _data["resultID"] !== undefined ? _data["resultID"] : null as any;
            if (Array.isArray(_data["offerte"])) {
                this.offerte = [] as any;
                for (let item of _data["offerte"])
                    this.offerte!.push(DisponibilitaTipologiaOfferta.fromJS(item));
            }
            else {
                this.offerte = null as any;
            }
            this.nota = _data["nota"] !== undefined ? _data["nota"] : null as any;
            this.prezzoAdulti = _data["prezzoAdulti"] !== undefined ? _data["prezzoAdulti"] : null as any;
            this.prezzoBambini = _data["prezzoBambini"] !== undefined ? _data["prezzoBambini"] : null as any;
            this.descrizioneID = _data["descrizioneID"] !== undefined ? _data["descrizioneID"] : null as any;
            this.dataPenale = _data["dataPenale"] !== undefined ? _data["dataPenale"] : null as any;
            this.importoPenale = _data["importoPenale"] !== undefined ? _data["importoPenale"] : null as any;
            this.articoloPenaleID = _data["articoloPenaleID"] !== undefined ? _data["articoloPenaleID"] : null as any;
            if (Array.isArray(_data["tariffeMezzaDoppia"])) {
                this.tariffeMezzaDoppia = [] as any;
                for (let item of _data["tariffeMezzaDoppia"])
                    this.tariffeMezzaDoppia!.push(TariffaMezzaDoppia.fromJS(item));
            }
            else {
                this.tariffeMezzaDoppia = null as any;
            }
            if (Array.isArray(_data["prezziGiorniPax"])) {
                this.prezziGiorniPax = [] as any;
                for (let item of _data["prezziGiorniPax"])
                    this.prezziGiorniPax!.push(PrezzoGiornoPax.fromJS(item));
            }
            else {
                this.prezziGiorniPax = null as any;
            }
            this.beddignCalcolatoID = _data["beddignCalcolatoID"] !== undefined ? _data["beddignCalcolatoID"] : null as any;
            this.regolaVenditaPenaleID = _data["regolaVenditaPenaleID"] !== undefined ? _data["regolaVenditaPenaleID"] : null as any;
            this.hashcodeID = _data["hashcodeID"] !== undefined ? _data["hashcodeID"] : null as any;
            this.bedsID = _data["bedsID"] !== undefined ? _data["bedsID"] : null as any;
            this.mealID = _data["mealID"] !== undefined ? _data["mealID"] : null as any;
            this.regolaVenditaID = _data["regolaVenditaID"] !== undefined ? _data["regolaVenditaID"] : null as any;
            this.descrizioneTariffa = _data["descrizioneTariffa"] !== undefined ? _data["descrizioneTariffa"] : null as any;
            this.fullContent = _data["fullContent"] !== undefined ? _data["fullContent"] : null as any;
            this.nomeAccordo = _data["nomeAccordo"] !== undefined ? _data["nomeAccordo"] : null as any;
            this.accordoFisso = _data["accordoFisso"] !== undefined ? _data["accordoFisso"] : null as any;
            this.prezzoTotaleDebug = _data["prezzoTotaleDebug"] !== undefined ? _data["prezzoTotaleDebug"] : null as any;
            this.costoTotale = _data["costoTotale"] !== undefined ? _data["costoTotale"] : null as any;
            this.markup = _data["markup"] !== undefined ? _data["markup"] : null as any;
            this.trattamento = _data["trattamento"] !== undefined ? _data["trattamento"] : null as any;
        }
    }

    static fromJS(data: any): DisponibilitaTipologia {
        data = typeof data === 'object' ? data : {};
        let result = new DisponibilitaTipologia();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["prenotabile"] = this.prenotabile !== undefined ? this.prenotabile : null as any;
        data["messaggioPrenotabile"] = this.messaggioPrenotabile !== undefined ? this.messaggioPrenotabile : null as any;
        data["resultItemID"] = this.resultItemID !== undefined ? this.resultItemID : null as any;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["servizioFornitoreID"] = this.servizioFornitoreID !== undefined ? this.servizioFornitoreID : null as any;
        data["gruppoID"] = this.gruppoID !== undefined ? this.gruppoID : null as any;
        data["servizioTipologiaID"] = this.servizioTipologiaID !== undefined ? this.servizioTipologiaID : null as any;
        data["trattamentoID"] = this.trattamentoID !== undefined ? this.trattamentoID : null as any;
        data["codTipologiaServizio"] = this.codTipologiaServizio !== undefined ? this.codTipologiaServizio : null as any;
        data["codPrenotazione"] = this.codPrenotazione !== undefined ? this.codPrenotazione : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["descrizioneTipologia"] = this.descrizioneTipologia !== undefined ? this.descrizioneTipologia : null as any;
        data["statoDisponibilita"] = this.statoDisponibilita !== undefined ? this.statoDisponibilita : null as any;
        data["tabAllotmentID"] = this.tabAllotmentID !== undefined ? this.tabAllotmentID : null as any;
        if (Array.isArray(this.costi)) {
            data["costi"] = [];
            for (let item of this.costi)
                data["costi"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.supplementi)) {
            data["supplementi"] = [];
            for (let item of this.supplementi)
                data["supplementi"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.partenze)) {
            data["partenze"] = [];
            for (let item of this.partenze)
                data["partenze"].push(item ? item.toJSON() : null as any);
        }
        data["penaleID"] = this.penaleID !== undefined ? this.penaleID : null as any;
        data["providerCustomData"] = this.providerCustomData !== undefined ? this.providerCustomData : null as any;
        data["descrizioneFornitore"] = this.descrizioneFornitore !== undefined ? this.descrizioneFornitore : null as any;
        data["codiceMappingGenerico"] = this.codiceMappingGenerico !== undefined ? this.codiceMappingGenerico : null as any;
        data["notRefundable"] = this.notRefundable !== undefined ? this.notRefundable : null as any;
        data["instantPurchase"] = this.instantPurchase !== undefined ? this.instantPurchase : null as any;
        data["weddingRate"] = this.weddingRate !== undefined ? this.weddingRate : null as any;
        data["tabellaCostoID"] = this.tabellaCostoID !== undefined ? this.tabellaCostoID : null as any;
        data["descrizioneTabellaCosto"] = this.descrizioneTabellaCosto !== undefined ? this.descrizioneTabellaCosto : null as any;
        data["resultID"] = this.resultID !== undefined ? this.resultID : null as any;
        if (Array.isArray(this.offerte)) {
            data["offerte"] = [];
            for (let item of this.offerte)
                data["offerte"].push(item ? item.toJSON() : null as any);
        }
        data["nota"] = this.nota !== undefined ? this.nota : null as any;
        data["prezzoAdulti"] = this.prezzoAdulti !== undefined ? this.prezzoAdulti : null as any;
        data["prezzoBambini"] = this.prezzoBambini !== undefined ? this.prezzoBambini : null as any;
        data["descrizioneID"] = this.descrizioneID !== undefined ? this.descrizioneID : null as any;
        data["dataPenale"] = this.dataPenale !== undefined ? this.dataPenale : null as any;
        data["importoPenale"] = this.importoPenale !== undefined ? this.importoPenale : null as any;
        data["articoloPenaleID"] = this.articoloPenaleID !== undefined ? this.articoloPenaleID : null as any;
        if (Array.isArray(this.tariffeMezzaDoppia)) {
            data["tariffeMezzaDoppia"] = [];
            for (let item of this.tariffeMezzaDoppia)
                data["tariffeMezzaDoppia"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.prezziGiorniPax)) {
            data["prezziGiorniPax"] = [];
            for (let item of this.prezziGiorniPax)
                data["prezziGiorniPax"].push(item ? item.toJSON() : null as any);
        }
        data["beddignCalcolatoID"] = this.beddignCalcolatoID !== undefined ? this.beddignCalcolatoID : null as any;
        data["regolaVenditaPenaleID"] = this.regolaVenditaPenaleID !== undefined ? this.regolaVenditaPenaleID : null as any;
        data["hashcodeID"] = this.hashcodeID !== undefined ? this.hashcodeID : null as any;
        data["bedsID"] = this.bedsID !== undefined ? this.bedsID : null as any;
        data["mealID"] = this.mealID !== undefined ? this.mealID : null as any;
        data["regolaVenditaID"] = this.regolaVenditaID !== undefined ? this.regolaVenditaID : null as any;
        data["descrizioneTariffa"] = this.descrizioneTariffa !== undefined ? this.descrizioneTariffa : null as any;
        data["fullContent"] = this.fullContent !== undefined ? this.fullContent : null as any;
        data["nomeAccordo"] = this.nomeAccordo !== undefined ? this.nomeAccordo : null as any;
        data["accordoFisso"] = this.accordoFisso !== undefined ? this.accordoFisso : null as any;
        data["prezzoTotaleDebug"] = this.prezzoTotaleDebug !== undefined ? this.prezzoTotaleDebug : null as any;
        data["costoTotale"] = this.costoTotale !== undefined ? this.costoTotale : null as any;
        data["markup"] = this.markup !== undefined ? this.markup : null as any;
        data["trattamento"] = this.trattamento !== undefined ? this.trattamento : null as any;
        return data;
    }
}

export interface IDisponibilitaTipologia {
    id?: number;
    prenotabile?: boolean;
    messaggioPrenotabile?: string | null;
    resultItemID?: number;
    accordoID?: number;
    servizioFornitoreID?: number;
    gruppoID?: number;
    servizioTipologiaID?: number | null;
    trattamentoID?: number | null;
    codTipologiaServizio?: string | null;
    codPrenotazione?: string | null;
    descrizione?: string | null;
    descrizioneTipologia?: string | null;
    statoDisponibilita?: EStatoDisponibilita;
    tabAllotmentID?: number | null;
    costi?: DisponibilitaTipologiaCosto[] | null;
    supplementi?: DisponibilitaSupplemento[] | null;
    partenze?: DisponibilitaPartenza[] | null;
    penaleID?: number;
    providerCustomData?: string | null;
    descrizioneFornitore?: string | null;
    codiceMappingGenerico?: string | null;
    notRefundable?: boolean;
    instantPurchase?: boolean;
    weddingRate?: boolean;
    tabellaCostoID?: number;
    descrizioneTabellaCosto?: string | null;
    resultID?: number;
    offerte?: DisponibilitaTipologiaOfferta[] | null;
    nota?: string | null;
    prezzoAdulti?: number;
    prezzoBambini?: number;
    descrizioneID?: number | null;
    dataPenale?: string | null;
    importoPenale?: number | null;
    articoloPenaleID?: number | null;
    tariffeMezzaDoppia?: TariffaMezzaDoppia[] | null;
    prezziGiorniPax?: PrezzoGiornoPax[] | null;
    beddignCalcolatoID?: number | null;
    regolaVenditaPenaleID?: number | null;
    hashcodeID?: number | null;
    bedsID?: number | null;
    mealID?: number | null;
    regolaVenditaID?: number | null;
    descrizioneTariffa?: string | null;
    fullContent?: boolean;
    nomeAccordo?: string | null;
    accordoFisso?: boolean;
    prezzoTotaleDebug?: number;
    costoTotale?: number;
    markup?: number | null;
    trattamento?: string | null;
}

export class DisponibilitaTipologiaCosto implements IDisponibilitaTipologiaCosto {
    viaggiatoreID?: number;
    name?: string | null;
    prezzo?: number | null;
    costo?: number;
    costoID?: number;
    numPersone?: number;
    maxEta?: number;
    tipoPax?: ETipoPax;

    constructor(data?: IDisponibilitaTipologiaCosto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.viaggiatoreID = _data["viaggiatoreID"] !== undefined ? _data["viaggiatoreID"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : null as any;
            this.costo = _data["costo"] !== undefined ? _data["costo"] : null as any;
            this.costoID = _data["costoID"] !== undefined ? _data["costoID"] : null as any;
            this.numPersone = _data["numPersone"] !== undefined ? _data["numPersone"] : null as any;
            this.maxEta = _data["maxEta"] !== undefined ? _data["maxEta"] : null as any;
            this.tipoPax = _data["tipoPax"] !== undefined ? _data["tipoPax"] : null as any;
        }
    }

    static fromJS(data: any): DisponibilitaTipologiaCosto {
        data = typeof data === 'object' ? data : {};
        let result = new DisponibilitaTipologiaCosto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["viaggiatoreID"] = this.viaggiatoreID !== undefined ? this.viaggiatoreID : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : null as any;
        data["costo"] = this.costo !== undefined ? this.costo : null as any;
        data["costoID"] = this.costoID !== undefined ? this.costoID : null as any;
        data["numPersone"] = this.numPersone !== undefined ? this.numPersone : null as any;
        data["maxEta"] = this.maxEta !== undefined ? this.maxEta : null as any;
        data["tipoPax"] = this.tipoPax !== undefined ? this.tipoPax : null as any;
        return data;
    }
}

export interface IDisponibilitaTipologiaCosto {
    viaggiatoreID?: number;
    name?: string | null;
    prezzo?: number | null;
    costo?: number;
    costoID?: number;
    numPersone?: number;
    maxEta?: number;
    tipoPax?: ETipoPax;
}

export class DisponibilitaSupplemento implements IDisponibilitaSupplemento {
    isObbligatorio?: boolean;
    percentuale?: boolean;
    alternative?: DisponibilitaTipologia[] | null;

    constructor(data?: IDisponibilitaSupplemento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isObbligatorio = _data["isObbligatorio"] !== undefined ? _data["isObbligatorio"] : null as any;
            this.percentuale = _data["percentuale"] !== undefined ? _data["percentuale"] : null as any;
            if (Array.isArray(_data["alternative"])) {
                this.alternative = [] as any;
                for (let item of _data["alternative"])
                    this.alternative!.push(DisponibilitaTipologia.fromJS(item));
            }
            else {
                this.alternative = null as any;
            }
        }
    }

    static fromJS(data: any): DisponibilitaSupplemento {
        data = typeof data === 'object' ? data : {};
        let result = new DisponibilitaSupplemento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isObbligatorio"] = this.isObbligatorio !== undefined ? this.isObbligatorio : null as any;
        data["percentuale"] = this.percentuale !== undefined ? this.percentuale : null as any;
        if (Array.isArray(this.alternative)) {
            data["alternative"] = [];
            for (let item of this.alternative)
                data["alternative"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IDisponibilitaSupplemento {
    isObbligatorio?: boolean;
    percentuale?: boolean;
    alternative?: DisponibilitaTipologia[] | null;
}

export class DisponibilitaPartenza implements IDisponibilitaPartenza {
    referenceID?: number;
    partenza?: string;
    costi?: DisponibilitaTipologiaCosto[] | null;
    prezzoAdulti?: number;
    prezzoBambini?: number;
    statoDisponibilita?: EStatoDisponibilita;
    offerte?: DisponibilitaTipologiaOfferta[] | null;
    supplementi?: DisponibilitaSupplemento[] | null;
    penaleID?: number | null;
    dataPenale?: string | null;
    importoPenale?: number | null;
    articoloPenaleID?: number | null;
    tariffeMezzaDoppia?: TariffaMezzaDoppia[] | null;
    prezziGiorniPax?: PrezzoGiornoPax[] | null;
    beddignCalcolatoID?: number | null;
    regolaVenditaPenaleID?: number | null;

    constructor(data?: IDisponibilitaPartenza) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceID = _data["referenceID"] !== undefined ? _data["referenceID"] : null as any;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : null as any;
            if (Array.isArray(_data["costi"])) {
                this.costi = [] as any;
                for (let item of _data["costi"])
                    this.costi!.push(DisponibilitaTipologiaCosto.fromJS(item));
            }
            else {
                this.costi = null as any;
            }
            this.prezzoAdulti = _data["prezzoAdulti"] !== undefined ? _data["prezzoAdulti"] : null as any;
            this.prezzoBambini = _data["prezzoBambini"] !== undefined ? _data["prezzoBambini"] : null as any;
            this.statoDisponibilita = _data["statoDisponibilita"] !== undefined ? _data["statoDisponibilita"] : null as any;
            if (Array.isArray(_data["offerte"])) {
                this.offerte = [] as any;
                for (let item of _data["offerte"])
                    this.offerte!.push(DisponibilitaTipologiaOfferta.fromJS(item));
            }
            else {
                this.offerte = null as any;
            }
            if (Array.isArray(_data["supplementi"])) {
                this.supplementi = [] as any;
                for (let item of _data["supplementi"])
                    this.supplementi!.push(DisponibilitaSupplemento.fromJS(item));
            }
            else {
                this.supplementi = null as any;
            }
            this.penaleID = _data["penaleID"] !== undefined ? _data["penaleID"] : null as any;
            this.dataPenale = _data["dataPenale"] !== undefined ? _data["dataPenale"] : null as any;
            this.importoPenale = _data["importoPenale"] !== undefined ? _data["importoPenale"] : null as any;
            this.articoloPenaleID = _data["articoloPenaleID"] !== undefined ? _data["articoloPenaleID"] : null as any;
            if (Array.isArray(_data["tariffeMezzaDoppia"])) {
                this.tariffeMezzaDoppia = [] as any;
                for (let item of _data["tariffeMezzaDoppia"])
                    this.tariffeMezzaDoppia!.push(TariffaMezzaDoppia.fromJS(item));
            }
            else {
                this.tariffeMezzaDoppia = null as any;
            }
            if (Array.isArray(_data["prezziGiorniPax"])) {
                this.prezziGiorniPax = [] as any;
                for (let item of _data["prezziGiorniPax"])
                    this.prezziGiorniPax!.push(PrezzoGiornoPax.fromJS(item));
            }
            else {
                this.prezziGiorniPax = null as any;
            }
            this.beddignCalcolatoID = _data["beddignCalcolatoID"] !== undefined ? _data["beddignCalcolatoID"] : null as any;
            this.regolaVenditaPenaleID = _data["regolaVenditaPenaleID"] !== undefined ? _data["regolaVenditaPenaleID"] : null as any;
        }
    }

    static fromJS(data: any): DisponibilitaPartenza {
        data = typeof data === 'object' ? data : {};
        let result = new DisponibilitaPartenza();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceID"] = this.referenceID !== undefined ? this.referenceID : null as any;
        data["partenza"] = this.partenza !== undefined ? this.partenza : null as any;
        if (Array.isArray(this.costi)) {
            data["costi"] = [];
            for (let item of this.costi)
                data["costi"].push(item ? item.toJSON() : null as any);
        }
        data["prezzoAdulti"] = this.prezzoAdulti !== undefined ? this.prezzoAdulti : null as any;
        data["prezzoBambini"] = this.prezzoBambini !== undefined ? this.prezzoBambini : null as any;
        data["statoDisponibilita"] = this.statoDisponibilita !== undefined ? this.statoDisponibilita : null as any;
        if (Array.isArray(this.offerte)) {
            data["offerte"] = [];
            for (let item of this.offerte)
                data["offerte"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.supplementi)) {
            data["supplementi"] = [];
            for (let item of this.supplementi)
                data["supplementi"].push(item ? item.toJSON() : null as any);
        }
        data["penaleID"] = this.penaleID !== undefined ? this.penaleID : null as any;
        data["dataPenale"] = this.dataPenale !== undefined ? this.dataPenale : null as any;
        data["importoPenale"] = this.importoPenale !== undefined ? this.importoPenale : null as any;
        data["articoloPenaleID"] = this.articoloPenaleID !== undefined ? this.articoloPenaleID : null as any;
        if (Array.isArray(this.tariffeMezzaDoppia)) {
            data["tariffeMezzaDoppia"] = [];
            for (let item of this.tariffeMezzaDoppia)
                data["tariffeMezzaDoppia"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.prezziGiorniPax)) {
            data["prezziGiorniPax"] = [];
            for (let item of this.prezziGiorniPax)
                data["prezziGiorniPax"].push(item ? item.toJSON() : null as any);
        }
        data["beddignCalcolatoID"] = this.beddignCalcolatoID !== undefined ? this.beddignCalcolatoID : null as any;
        data["regolaVenditaPenaleID"] = this.regolaVenditaPenaleID !== undefined ? this.regolaVenditaPenaleID : null as any;
        return data;
    }
}

export interface IDisponibilitaPartenza {
    referenceID?: number;
    partenza?: string;
    costi?: DisponibilitaTipologiaCosto[] | null;
    prezzoAdulti?: number;
    prezzoBambini?: number;
    statoDisponibilita?: EStatoDisponibilita;
    offerte?: DisponibilitaTipologiaOfferta[] | null;
    supplementi?: DisponibilitaSupplemento[] | null;
    penaleID?: number | null;
    dataPenale?: string | null;
    importoPenale?: number | null;
    articoloPenaleID?: number | null;
    tariffeMezzaDoppia?: TariffaMezzaDoppia[] | null;
    prezziGiorniPax?: PrezzoGiornoPax[] | null;
    beddignCalcolatoID?: number | null;
    regolaVenditaPenaleID?: number | null;
}

export class TariffaMezzaDoppia implements ITariffaMezzaDoppia {
    prezzo?: number;
    costo?: number;
    data?: string;

    constructor(data?: ITariffaMezzaDoppia) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : null as any;
            this.costo = _data["costo"] !== undefined ? _data["costo"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
        }
    }

    static fromJS(data: any): TariffaMezzaDoppia {
        data = typeof data === 'object' ? data : {};
        let result = new TariffaMezzaDoppia();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : null as any;
        data["costo"] = this.costo !== undefined ? this.costo : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        return data;
    }
}

export interface ITariffaMezzaDoppia {
    prezzo?: number;
    costo?: number;
    data?: string;
}

export class PrezzoGiornoPax implements IPrezzoGiornoPax {
    paxID?: number;
    data?: string;
    prezzo?: number;
    costo?: number;
    regolaVenditaApplicata?: number | null;
    prezzoChild?: boolean;
    costoID?: number;

    constructor(data?: IPrezzoGiornoPax) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paxID = _data["paxID"] !== undefined ? _data["paxID"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : null as any;
            this.costo = _data["costo"] !== undefined ? _data["costo"] : null as any;
            this.regolaVenditaApplicata = _data["regolaVenditaApplicata"] !== undefined ? _data["regolaVenditaApplicata"] : null as any;
            this.prezzoChild = _data["prezzoChild"] !== undefined ? _data["prezzoChild"] : null as any;
            this.costoID = _data["costoID"] !== undefined ? _data["costoID"] : null as any;
        }
    }

    static fromJS(data: any): PrezzoGiornoPax {
        data = typeof data === 'object' ? data : {};
        let result = new PrezzoGiornoPax();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paxID"] = this.paxID !== undefined ? this.paxID : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : null as any;
        data["costo"] = this.costo !== undefined ? this.costo : null as any;
        data["regolaVenditaApplicata"] = this.regolaVenditaApplicata !== undefined ? this.regolaVenditaApplicata : null as any;
        data["prezzoChild"] = this.prezzoChild !== undefined ? this.prezzoChild : null as any;
        data["costoID"] = this.costoID !== undefined ? this.costoID : null as any;
        return data;
    }
}

export interface IPrezzoGiornoPax {
    paxID?: number;
    data?: string;
    prezzo?: number;
    costo?: number;
    regolaVenditaApplicata?: number | null;
    prezzoChild?: boolean;
    costoID?: number;
}

export class DisponibilitaDatiCosto implements IDisponibilitaDatiCosto {
    costiConPrezzoIndicativoIDs?: number[];
    costiConMarkupPersonalizzato?: { [key: string]: number; };

    constructor(data?: IDisponibilitaDatiCosto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["costiConPrezzoIndicativoIDs"])) {
                this.costiConPrezzoIndicativoIDs = [] as any;
                for (let item of _data["costiConPrezzoIndicativoIDs"])
                    this.costiConPrezzoIndicativoIDs!.push(item);
            }
            else {
                this.costiConPrezzoIndicativoIDs = null as any;
            }
            if (_data["costiConMarkupPersonalizzato"]) {
                this.costiConMarkupPersonalizzato = {} as any;
                for (let key in _data["costiConMarkupPersonalizzato"]) {
                    if (_data["costiConMarkupPersonalizzato"].hasOwnProperty(key))
                        (this.costiConMarkupPersonalizzato as any)![key] = _data["costiConMarkupPersonalizzato"][key] !== undefined ? _data["costiConMarkupPersonalizzato"][key] : null as any;
                }
            }
            else {
                this.costiConMarkupPersonalizzato = null as any;
            }
        }
    }

    static fromJS(data: any): DisponibilitaDatiCosto {
        data = typeof data === 'object' ? data : {};
        let result = new DisponibilitaDatiCosto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.costiConPrezzoIndicativoIDs)) {
            data["costiConPrezzoIndicativoIDs"] = [];
            for (let item of this.costiConPrezzoIndicativoIDs)
                data["costiConPrezzoIndicativoIDs"].push(item);
        }
        if (this.costiConMarkupPersonalizzato) {
            data["costiConMarkupPersonalizzato"] = {};
            for (let key in this.costiConMarkupPersonalizzato) {
                if (this.costiConMarkupPersonalizzato.hasOwnProperty(key))
                    (data["costiConMarkupPersonalizzato"] as any)[key] = this.costiConMarkupPersonalizzato[key] !== undefined ? this.costiConMarkupPersonalizzato[key] : null as any;
            }
        }
        return data;
    }
}

export interface IDisponibilitaDatiCosto {
    costiConPrezzoIndicativoIDs?: number[];
    costiConMarkupPersonalizzato?: { [key: string]: number; };
}

export class H2HLog implements IH2HLog {
    id?: string;
    supplier?: EFornitore;
    jobID?: string;
    itemNr?: number;
    requestData?: string;
    requestSize?: number;
    requestDataType?: ELogDataType;
    responseData?: string;
    responseSize?: number;
    responseDataType?: ELogDataType;
    date?: string;

    constructor(data?: IH2HLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : null as any;
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : null as any;
            this.itemNr = _data["itemNr"] !== undefined ? _data["itemNr"] : null as any;
            this.requestData = _data["requestData"] !== undefined ? _data["requestData"] : null as any;
            this.requestSize = _data["requestSize"] !== undefined ? _data["requestSize"] : null as any;
            this.requestDataType = _data["requestDataType"] !== undefined ? _data["requestDataType"] : null as any;
            this.responseData = _data["responseData"] !== undefined ? _data["responseData"] : null as any;
            this.responseSize = _data["responseSize"] !== undefined ? _data["responseSize"] : null as any;
            this.responseDataType = _data["responseDataType"] !== undefined ? _data["responseDataType"] : null as any;
            this.date = _data["date"] !== undefined ? _data["date"] : null as any;
        }
    }

    static fromJS(data: any): H2HLog {
        data = typeof data === 'object' ? data : {};
        let result = new H2HLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["supplier"] = this.supplier !== undefined ? this.supplier : null as any;
        data["jobID"] = this.jobID !== undefined ? this.jobID : null as any;
        data["itemNr"] = this.itemNr !== undefined ? this.itemNr : null as any;
        data["requestData"] = this.requestData !== undefined ? this.requestData : null as any;
        data["requestSize"] = this.requestSize !== undefined ? this.requestSize : null as any;
        data["requestDataType"] = this.requestDataType !== undefined ? this.requestDataType : null as any;
        data["responseData"] = this.responseData !== undefined ? this.responseData : null as any;
        data["responseSize"] = this.responseSize !== undefined ? this.responseSize : null as any;
        data["responseDataType"] = this.responseDataType !== undefined ? this.responseDataType : null as any;
        data["date"] = this.date !== undefined ? this.date : null as any;
        return data;
    }
}

export interface IH2HLog {
    id?: string;
    supplier?: EFornitore;
    jobID?: string;
    itemNr?: number;
    requestData?: string;
    requestSize?: number;
    requestDataType?: ELogDataType;
    responseData?: string;
    responseSize?: number;
    responseDataType?: ELogDataType;
    date?: string;
}

export enum ELogDataType {
    Text = "Text",
    Xml = "Xml",
    Json = "Json",
}

export class ContractCurrency implements IContractCurrency {
    accordoID?: number;
    codiceValuta?: string;

    constructor(data?: IContractCurrency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.codiceValuta = _data["codiceValuta"] !== undefined ? _data["codiceValuta"] : null as any;
        }
    }

    static fromJS(data: any): ContractCurrency {
        data = typeof data === 'object' ? data : {};
        let result = new ContractCurrency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["codiceValuta"] = this.codiceValuta !== undefined ? this.codiceValuta : null as any;
        return data;
    }
}

export interface IContractCurrency {
    accordoID?: number;
    codiceValuta?: string;
}

export class GetRawPricesRequest extends LocalizedRequest implements IGetRawPricesRequest {
    jobID!: string;
    resultID!: string;

    constructor(data?: IGetRawPricesRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : null as any;
            this.resultID = _data["resultID"] !== undefined ? _data["resultID"] : null as any;
        }
    }

    static override fromJS(data: any): GetRawPricesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetRawPricesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobID"] = this.jobID !== undefined ? this.jobID : null as any;
        data["resultID"] = this.resultID !== undefined ? this.resultID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetRawPricesRequest extends ILocalizedRequest {
    jobID: string;
    resultID: string;
}

export class GetResultsResponse extends OkApiResponse implements IGetResultsResponse {
    dati?: RicercaDati;
    idsByPrice?: string[];

    constructor(data?: IGetResultsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dati = _data["dati"] ? RicercaDati.fromJS(_data["dati"]) : null as any;
            if (Array.isArray(_data["idsByPrice"])) {
                this.idsByPrice = [] as any;
                for (let item of _data["idsByPrice"])
                    this.idsByPrice!.push(item);
            }
            else {
                this.idsByPrice = null as any;
            }
        }
    }

    static override fromJS(data: any): GetResultsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetResultsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dati"] = this.dati ? this.dati.toJSON() : null as any;
        if (Array.isArray(this.idsByPrice)) {
            data["idsByPrice"] = [];
            for (let item of this.idsByPrice)
                data["idsByPrice"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetResultsResponse extends IOkApiResponse {
    dati?: RicercaDati;
    idsByPrice?: string[];
}

export class RicercaDati implements IRicercaDati {
    jobID?: string;
    generationID?: number;
    servizi?: ServizioSearch[];
    minPrice?: number | null;
    minPriceValuta?: number | null;
    maxPrice?: number | null;
    maxPriceValuta?: number | null;
    cacheResult?: boolean;
    descriptions?: string[] | null;
    sourceResults?: SourceResultPointer[];
    hasExpiredCosts?: boolean;
    codiceValuta?: string | null;
    valutaNonEuro?: boolean;

    constructor(data?: IRicercaDati) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : null as any;
            this.generationID = _data["generationID"] !== undefined ? _data["generationID"] : null as any;
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(ServizioSearch.fromJS(item));
            }
            else {
                this.servizi = null as any;
            }
            this.minPrice = _data["minPrice"] !== undefined ? _data["minPrice"] : null as any;
            this.minPriceValuta = _data["minPriceValuta"] !== undefined ? _data["minPriceValuta"] : null as any;
            this.maxPrice = _data["maxPrice"] !== undefined ? _data["maxPrice"] : null as any;
            this.maxPriceValuta = _data["maxPriceValuta"] !== undefined ? _data["maxPriceValuta"] : null as any;
            this.cacheResult = _data["cacheResult"] !== undefined ? _data["cacheResult"] : null as any;
            if (Array.isArray(_data["descriptions"])) {
                this.descriptions = [] as any;
                for (let item of _data["descriptions"])
                    this.descriptions!.push(item);
            }
            else {
                this.descriptions = null as any;
            }
            if (Array.isArray(_data["sourceResults"])) {
                this.sourceResults = [] as any;
                for (let item of _data["sourceResults"])
                    this.sourceResults!.push(SourceResultPointer.fromJS(item));
            }
            else {
                this.sourceResults = null as any;
            }
            this.hasExpiredCosts = _data["hasExpiredCosts"] !== undefined ? _data["hasExpiredCosts"] : null as any;
            this.codiceValuta = _data["codiceValuta"] !== undefined ? _data["codiceValuta"] : null as any;
            this.valutaNonEuro = _data["valutaNonEuro"] !== undefined ? _data["valutaNonEuro"] : null as any;
        }
    }

    static fromJS(data: any): RicercaDati {
        data = typeof data === 'object' ? data : {};
        let result = new RicercaDati();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobID"] = this.jobID !== undefined ? this.jobID : null as any;
        data["generationID"] = this.generationID !== undefined ? this.generationID : null as any;
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item ? item.toJSON() : null as any);
        }
        data["minPrice"] = this.minPrice !== undefined ? this.minPrice : null as any;
        data["minPriceValuta"] = this.minPriceValuta !== undefined ? this.minPriceValuta : null as any;
        data["maxPrice"] = this.maxPrice !== undefined ? this.maxPrice : null as any;
        data["maxPriceValuta"] = this.maxPriceValuta !== undefined ? this.maxPriceValuta : null as any;
        data["cacheResult"] = this.cacheResult !== undefined ? this.cacheResult : null as any;
        if (Array.isArray(this.descriptions)) {
            data["descriptions"] = [];
            for (let item of this.descriptions)
                data["descriptions"].push(item);
        }
        if (Array.isArray(this.sourceResults)) {
            data["sourceResults"] = [];
            for (let item of this.sourceResults)
                data["sourceResults"].push(item ? item.toJSON() : null as any);
        }
        data["hasExpiredCosts"] = this.hasExpiredCosts !== undefined ? this.hasExpiredCosts : null as any;
        data["codiceValuta"] = this.codiceValuta !== undefined ? this.codiceValuta : null as any;
        data["valutaNonEuro"] = this.valutaNonEuro !== undefined ? this.valutaNonEuro : null as any;
        return data;
    }
}

export interface IRicercaDati {
    jobID?: string;
    generationID?: number;
    servizi?: ServizioSearch[];
    minPrice?: number | null;
    minPriceValuta?: number | null;
    maxPrice?: number | null;
    maxPriceValuta?: number | null;
    cacheResult?: boolean;
    descriptions?: string[] | null;
    sourceResults?: SourceResultPointer[];
    hasExpiredCosts?: boolean;
    codiceValuta?: string | null;
    valutaNonEuro?: boolean;
}

export class ServizioSearch implements IServizioSearch {
    id?: string | null;
    codice?: string | null;
    nonMappato?: boolean;
    servizioID?: number;
    prezzoPieno?: number | null;
    prezzoPienoValuta?: number | null;
    prezzo?: number;
    prezzoValuta?: number | null;
    disponibilitaPrezzoMinimo?: EStatoDisponibilita;
    abbinamentiTipologie?: AbbinamentoTipologie[] | null;
    hasAvailable?: boolean;
    isOpen?: boolean;
    drilledDown?: boolean;
    bests?: Best[] | null;
    hasExpired?: boolean;
    suppliers?: number[] | null;

    constructor(data?: IServizioSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
            this.nonMappato = _data["nonMappato"] !== undefined ? _data["nonMappato"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.prezzoPieno = _data["prezzoPieno"] !== undefined ? _data["prezzoPieno"] : null as any;
            this.prezzoPienoValuta = _data["prezzoPienoValuta"] !== undefined ? _data["prezzoPienoValuta"] : null as any;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : null as any;
            this.prezzoValuta = _data["prezzoValuta"] !== undefined ? _data["prezzoValuta"] : null as any;
            this.disponibilitaPrezzoMinimo = _data["disponibilitaPrezzoMinimo"] !== undefined ? _data["disponibilitaPrezzoMinimo"] : null as any;
            if (Array.isArray(_data["abbinamentiTipologie"])) {
                this.abbinamentiTipologie = [] as any;
                for (let item of _data["abbinamentiTipologie"])
                    this.abbinamentiTipologie!.push(AbbinamentoTipologie.fromJS(item));
            }
            else {
                this.abbinamentiTipologie = null as any;
            }
            this.hasAvailable = _data["hasAvailable"] !== undefined ? _data["hasAvailable"] : null as any;
            this.isOpen = _data["isOpen"] !== undefined ? _data["isOpen"] : null as any;
            this.drilledDown = _data["drilledDown"] !== undefined ? _data["drilledDown"] : null as any;
            if (Array.isArray(_data["bests"])) {
                this.bests = [] as any;
                for (let item of _data["bests"])
                    this.bests!.push(Best.fromJS(item));
            }
            else {
                this.bests = null as any;
            }
            this.hasExpired = _data["hasExpired"] !== undefined ? _data["hasExpired"] : null as any;
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [] as any;
                for (let item of _data["suppliers"])
                    this.suppliers!.push(item);
            }
            else {
                this.suppliers = null as any;
            }
        }
    }

    static fromJS(data: any): ServizioSearch {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        data["nonMappato"] = this.nonMappato !== undefined ? this.nonMappato : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["prezzoPieno"] = this.prezzoPieno !== undefined ? this.prezzoPieno : null as any;
        data["prezzoPienoValuta"] = this.prezzoPienoValuta !== undefined ? this.prezzoPienoValuta : null as any;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : null as any;
        data["prezzoValuta"] = this.prezzoValuta !== undefined ? this.prezzoValuta : null as any;
        data["disponibilitaPrezzoMinimo"] = this.disponibilitaPrezzoMinimo !== undefined ? this.disponibilitaPrezzoMinimo : null as any;
        if (Array.isArray(this.abbinamentiTipologie)) {
            data["abbinamentiTipologie"] = [];
            for (let item of this.abbinamentiTipologie)
                data["abbinamentiTipologie"].push(item ? item.toJSON() : null as any);
        }
        data["hasAvailable"] = this.hasAvailable !== undefined ? this.hasAvailable : null as any;
        data["isOpen"] = this.isOpen !== undefined ? this.isOpen : null as any;
        data["drilledDown"] = this.drilledDown !== undefined ? this.drilledDown : null as any;
        if (Array.isArray(this.bests)) {
            data["bests"] = [];
            for (let item of this.bests)
                data["bests"].push(item ? item.toJSON() : null as any);
        }
        data["hasExpired"] = this.hasExpired !== undefined ? this.hasExpired : null as any;
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item);
        }
        return data;
    }
}

export interface IServizioSearch {
    id?: string | null;
    codice?: string | null;
    nonMappato?: boolean;
    servizioID?: number;
    prezzoPieno?: number | null;
    prezzoPienoValuta?: number | null;
    prezzo?: number;
    prezzoValuta?: number | null;
    disponibilitaPrezzoMinimo?: EStatoDisponibilita;
    abbinamentiTipologie?: AbbinamentoTipologie[] | null;
    hasAvailable?: boolean;
    isOpen?: boolean;
    drilledDown?: boolean;
    bests?: Best[] | null;
    hasExpired?: boolean;
    suppliers?: number[] | null;
}

export class AbbinamentoTipologie implements IAbbinamentoTipologie {
    gruppoID?: number;
    nomeGruppo?: string;
    nomiPax?: string;
    macroTipologie?: GruppoMacroTipologie[];

    constructor(data?: IAbbinamentoTipologie) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gruppoID = _data["gruppoID"] !== undefined ? _data["gruppoID"] : null as any;
            this.nomeGruppo = _data["nomeGruppo"] !== undefined ? _data["nomeGruppo"] : null as any;
            this.nomiPax = _data["nomiPax"] !== undefined ? _data["nomiPax"] : null as any;
            if (Array.isArray(_data["macroTipologie"])) {
                this.macroTipologie = [] as any;
                for (let item of _data["macroTipologie"])
                    this.macroTipologie!.push(GruppoMacroTipologie.fromJS(item));
            }
            else {
                this.macroTipologie = null as any;
            }
        }
    }

    static fromJS(data: any): AbbinamentoTipologie {
        data = typeof data === 'object' ? data : {};
        let result = new AbbinamentoTipologie();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gruppoID"] = this.gruppoID !== undefined ? this.gruppoID : null as any;
        data["nomeGruppo"] = this.nomeGruppo !== undefined ? this.nomeGruppo : null as any;
        data["nomiPax"] = this.nomiPax !== undefined ? this.nomiPax : null as any;
        if (Array.isArray(this.macroTipologie)) {
            data["macroTipologie"] = [];
            for (let item of this.macroTipologie)
                data["macroTipologie"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IAbbinamentoTipologie {
    gruppoID?: number;
    nomeGruppo?: string;
    nomiPax?: string;
    macroTipologie?: GruppoMacroTipologie[];
}

export class GruppoMacroTipologie implements IGruppoMacroTipologie {
    nome?: string | null;
    tipologie?: TipologiaSearch[];

    constructor(data?: IGruppoMacroTipologie) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            if (Array.isArray(_data["tipologie"])) {
                this.tipologie = [] as any;
                for (let item of _data["tipologie"])
                    this.tipologie!.push(TipologiaSearch.fromJS(item));
            }
            else {
                this.tipologie = null as any;
            }
        }
    }

    static fromJS(data: any): GruppoMacroTipologie {
        data = typeof data === 'object' ? data : {};
        let result = new GruppoMacroTipologie();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        if (Array.isArray(this.tipologie)) {
            data["tipologie"] = [];
            for (let item of this.tipologie)
                data["tipologie"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IGruppoMacroTipologie {
    nome?: string | null;
    tipologie?: TipologiaSearch[];
}

export class TipologiaSearch implements ITipologiaSearch {
    id?: string | null;
    sourceMainCacheID?: string | null;
    sourceResultItemID?: number;
    sourceResultID?: number;
    supplierID?: number;
    fornitore?: string | null;
    gruppoID?: number;
    nome?: string | null;
    prezzoPieno?: number | null;
    prezzoPienoValuta?: number | null;
    prezzo?: number;
    prezzoValuta?: number | null;
    prezzoIndicativo?: boolean;
    disponibilita?: EStatoDisponibilita;
    nonRimborsabile?: boolean;
    instantPurchase?: boolean;
    supplementi?: Supplemento[] | null;
    partenze?: PartenzaSearch[] | null;
    hashcode?: string | null;
    fullContent?: boolean;
    hashMacro?: string | null;
    score?: number;

    constructor(data?: ITipologiaSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.sourceMainCacheID = _data["sourceMainCacheID"] !== undefined ? _data["sourceMainCacheID"] : null as any;
            this.sourceResultItemID = _data["sourceResultItemID"] !== undefined ? _data["sourceResultItemID"] : null as any;
            this.sourceResultID = _data["sourceResultID"] !== undefined ? _data["sourceResultID"] : null as any;
            this.supplierID = _data["supplierID"] !== undefined ? _data["supplierID"] : null as any;
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : null as any;
            this.gruppoID = _data["gruppoID"] !== undefined ? _data["gruppoID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.prezzoPieno = _data["prezzoPieno"] !== undefined ? _data["prezzoPieno"] : null as any;
            this.prezzoPienoValuta = _data["prezzoPienoValuta"] !== undefined ? _data["prezzoPienoValuta"] : null as any;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : null as any;
            this.prezzoValuta = _data["prezzoValuta"] !== undefined ? _data["prezzoValuta"] : null as any;
            this.prezzoIndicativo = _data["prezzoIndicativo"] !== undefined ? _data["prezzoIndicativo"] : null as any;
            this.disponibilita = _data["disponibilita"] !== undefined ? _data["disponibilita"] : null as any;
            this.nonRimborsabile = _data["nonRimborsabile"] !== undefined ? _data["nonRimborsabile"] : null as any;
            this.instantPurchase = _data["instantPurchase"] !== undefined ? _data["instantPurchase"] : null as any;
            if (Array.isArray(_data["supplementi"])) {
                this.supplementi = [] as any;
                for (let item of _data["supplementi"])
                    this.supplementi!.push(Supplemento.fromJS(item));
            }
            else {
                this.supplementi = null as any;
            }
            if (Array.isArray(_data["partenze"])) {
                this.partenze = [] as any;
                for (let item of _data["partenze"])
                    this.partenze!.push(PartenzaSearch.fromJS(item));
            }
            else {
                this.partenze = null as any;
            }
            this.hashcode = _data["hashcode"] !== undefined ? _data["hashcode"] : null as any;
            this.fullContent = _data["fullContent"] !== undefined ? _data["fullContent"] : null as any;
            this.hashMacro = _data["hashMacro"] !== undefined ? _data["hashMacro"] : null as any;
            this.score = _data["score"] !== undefined ? _data["score"] : null as any;
        }
    }

    static fromJS(data: any): TipologiaSearch {
        data = typeof data === 'object' ? data : {};
        let result = new TipologiaSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["sourceMainCacheID"] = this.sourceMainCacheID !== undefined ? this.sourceMainCacheID : null as any;
        data["sourceResultItemID"] = this.sourceResultItemID !== undefined ? this.sourceResultItemID : null as any;
        data["sourceResultID"] = this.sourceResultID !== undefined ? this.sourceResultID : null as any;
        data["supplierID"] = this.supplierID !== undefined ? this.supplierID : null as any;
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : null as any;
        data["gruppoID"] = this.gruppoID !== undefined ? this.gruppoID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["prezzoPieno"] = this.prezzoPieno !== undefined ? this.prezzoPieno : null as any;
        data["prezzoPienoValuta"] = this.prezzoPienoValuta !== undefined ? this.prezzoPienoValuta : null as any;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : null as any;
        data["prezzoValuta"] = this.prezzoValuta !== undefined ? this.prezzoValuta : null as any;
        data["prezzoIndicativo"] = this.prezzoIndicativo !== undefined ? this.prezzoIndicativo : null as any;
        data["disponibilita"] = this.disponibilita !== undefined ? this.disponibilita : null as any;
        data["nonRimborsabile"] = this.nonRimborsabile !== undefined ? this.nonRimborsabile : null as any;
        data["instantPurchase"] = this.instantPurchase !== undefined ? this.instantPurchase : null as any;
        if (Array.isArray(this.supplementi)) {
            data["supplementi"] = [];
            for (let item of this.supplementi)
                data["supplementi"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.partenze)) {
            data["partenze"] = [];
            for (let item of this.partenze)
                data["partenze"].push(item ? item.toJSON() : null as any);
        }
        data["hashcode"] = this.hashcode !== undefined ? this.hashcode : null as any;
        data["fullContent"] = this.fullContent !== undefined ? this.fullContent : null as any;
        data["hashMacro"] = this.hashMacro !== undefined ? this.hashMacro : null as any;
        data["score"] = this.score !== undefined ? this.score : null as any;
        return data;
    }
}

export interface ITipologiaSearch {
    id?: string | null;
    sourceMainCacheID?: string | null;
    sourceResultItemID?: number;
    sourceResultID?: number;
    supplierID?: number;
    fornitore?: string | null;
    gruppoID?: number;
    nome?: string | null;
    prezzoPieno?: number | null;
    prezzoPienoValuta?: number | null;
    prezzo?: number;
    prezzoValuta?: number | null;
    prezzoIndicativo?: boolean;
    disponibilita?: EStatoDisponibilita;
    nonRimborsabile?: boolean;
    instantPurchase?: boolean;
    supplementi?: Supplemento[] | null;
    partenze?: PartenzaSearch[] | null;
    hashcode?: string | null;
    fullContent?: boolean;
    hashMacro?: string | null;
    score?: number;
}

export class PartenzaSearch implements IPartenzaSearch {
    sourceReferenceID?: number;
    data?: string;
    prezzoPieno?: number | null;
    prezzoPienoValuta?: number | null;
    prezzo?: number;
    prezzoValuta?: number | null;
    prezzoIndicativo?: boolean;
    disponibilita?: EStatoDisponibilita;
    supplementi?: Supplemento[] | null;
    garantita?: boolean;
    italiano?: boolean;
    inglese?: boolean;
    francese?: boolean;
    tedesco?: boolean;
    spagnolo?: boolean;
    olandese?: boolean;

    constructor(data?: IPartenzaSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceReferenceID = _data["sourceReferenceID"] !== undefined ? _data["sourceReferenceID"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
            this.prezzoPieno = _data["prezzoPieno"] !== undefined ? _data["prezzoPieno"] : null as any;
            this.prezzoPienoValuta = _data["prezzoPienoValuta"] !== undefined ? _data["prezzoPienoValuta"] : null as any;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : null as any;
            this.prezzoValuta = _data["prezzoValuta"] !== undefined ? _data["prezzoValuta"] : null as any;
            this.prezzoIndicativo = _data["prezzoIndicativo"] !== undefined ? _data["prezzoIndicativo"] : null as any;
            this.disponibilita = _data["disponibilita"] !== undefined ? _data["disponibilita"] : null as any;
            if (Array.isArray(_data["supplementi"])) {
                this.supplementi = [] as any;
                for (let item of _data["supplementi"])
                    this.supplementi!.push(Supplemento.fromJS(item));
            }
            else {
                this.supplementi = null as any;
            }
            this.garantita = _data["garantita"] !== undefined ? _data["garantita"] : null as any;
            this.italiano = _data["italiano"] !== undefined ? _data["italiano"] : null as any;
            this.inglese = _data["inglese"] !== undefined ? _data["inglese"] : null as any;
            this.francese = _data["francese"] !== undefined ? _data["francese"] : null as any;
            this.tedesco = _data["tedesco"] !== undefined ? _data["tedesco"] : null as any;
            this.spagnolo = _data["spagnolo"] !== undefined ? _data["spagnolo"] : null as any;
            this.olandese = _data["olandese"] !== undefined ? _data["olandese"] : null as any;
        }
    }

    static fromJS(data: any): PartenzaSearch {
        data = typeof data === 'object' ? data : {};
        let result = new PartenzaSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceReferenceID"] = this.sourceReferenceID !== undefined ? this.sourceReferenceID : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["prezzoPieno"] = this.prezzoPieno !== undefined ? this.prezzoPieno : null as any;
        data["prezzoPienoValuta"] = this.prezzoPienoValuta !== undefined ? this.prezzoPienoValuta : null as any;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : null as any;
        data["prezzoValuta"] = this.prezzoValuta !== undefined ? this.prezzoValuta : null as any;
        data["prezzoIndicativo"] = this.prezzoIndicativo !== undefined ? this.prezzoIndicativo : null as any;
        data["disponibilita"] = this.disponibilita !== undefined ? this.disponibilita : null as any;
        if (Array.isArray(this.supplementi)) {
            data["supplementi"] = [];
            for (let item of this.supplementi)
                data["supplementi"].push(item ? item.toJSON() : null as any);
        }
        data["garantita"] = this.garantita !== undefined ? this.garantita : null as any;
        data["italiano"] = this.italiano !== undefined ? this.italiano : null as any;
        data["inglese"] = this.inglese !== undefined ? this.inglese : null as any;
        data["francese"] = this.francese !== undefined ? this.francese : null as any;
        data["tedesco"] = this.tedesco !== undefined ? this.tedesco : null as any;
        data["spagnolo"] = this.spagnolo !== undefined ? this.spagnolo : null as any;
        data["olandese"] = this.olandese !== undefined ? this.olandese : null as any;
        return data;
    }
}

export interface IPartenzaSearch {
    sourceReferenceID?: number;
    data?: string;
    prezzoPieno?: number | null;
    prezzoPienoValuta?: number | null;
    prezzo?: number;
    prezzoValuta?: number | null;
    prezzoIndicativo?: boolean;
    disponibilita?: EStatoDisponibilita;
    supplementi?: Supplemento[] | null;
    garantita?: boolean;
    italiano?: boolean;
    inglese?: boolean;
    francese?: boolean;
    tedesco?: boolean;
    spagnolo?: boolean;
    olandese?: boolean;
}

export class Best implements IBest {
    attributoID?: number | null;
    nomeMacro?: string | null;
    prezzoPieno?: number | null;
    prezzoPienoValuta?: number | null;
    prezzo?: number;
    prezzoValuta?: number | null;
    nonRimborsabile?: boolean;
    instantPurchase?: boolean;
    haPartenze?: boolean;
    disponibilita?: EStatoDisponibilita;
    gruppo?: string | null;
    chiave?: string;
    acquistabile?: boolean;
    serviceSearchDataBuffer?: string | null;
    nomeMacroDescID?: number | null;
    gruppoDescID?: number | null;

    constructor(data?: IBest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributoID = _data["attributoID"] !== undefined ? _data["attributoID"] : null as any;
            this.nomeMacro = _data["nomeMacro"] !== undefined ? _data["nomeMacro"] : null as any;
            this.prezzoPieno = _data["prezzoPieno"] !== undefined ? _data["prezzoPieno"] : null as any;
            this.prezzoPienoValuta = _data["prezzoPienoValuta"] !== undefined ? _data["prezzoPienoValuta"] : null as any;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : null as any;
            this.prezzoValuta = _data["prezzoValuta"] !== undefined ? _data["prezzoValuta"] : null as any;
            this.nonRimborsabile = _data["nonRimborsabile"] !== undefined ? _data["nonRimborsabile"] : null as any;
            this.instantPurchase = _data["instantPurchase"] !== undefined ? _data["instantPurchase"] : null as any;
            this.haPartenze = _data["haPartenze"] !== undefined ? _data["haPartenze"] : null as any;
            this.disponibilita = _data["disponibilita"] !== undefined ? _data["disponibilita"] : null as any;
            this.gruppo = _data["gruppo"] !== undefined ? _data["gruppo"] : null as any;
            this.chiave = _data["chiave"] !== undefined ? _data["chiave"] : null as any;
            this.acquistabile = _data["acquistabile"] !== undefined ? _data["acquistabile"] : null as any;
            this.serviceSearchDataBuffer = _data["serviceSearchDataBuffer"] !== undefined ? _data["serviceSearchDataBuffer"] : null as any;
            this.nomeMacroDescID = _data["nomeMacroDescID"] !== undefined ? _data["nomeMacroDescID"] : null as any;
            this.gruppoDescID = _data["gruppoDescID"] !== undefined ? _data["gruppoDescID"] : null as any;
        }
    }

    static fromJS(data: any): Best {
        data = typeof data === 'object' ? data : {};
        let result = new Best();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributoID"] = this.attributoID !== undefined ? this.attributoID : null as any;
        data["nomeMacro"] = this.nomeMacro !== undefined ? this.nomeMacro : null as any;
        data["prezzoPieno"] = this.prezzoPieno !== undefined ? this.prezzoPieno : null as any;
        data["prezzoPienoValuta"] = this.prezzoPienoValuta !== undefined ? this.prezzoPienoValuta : null as any;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : null as any;
        data["prezzoValuta"] = this.prezzoValuta !== undefined ? this.prezzoValuta : null as any;
        data["nonRimborsabile"] = this.nonRimborsabile !== undefined ? this.nonRimborsabile : null as any;
        data["instantPurchase"] = this.instantPurchase !== undefined ? this.instantPurchase : null as any;
        data["haPartenze"] = this.haPartenze !== undefined ? this.haPartenze : null as any;
        data["disponibilita"] = this.disponibilita !== undefined ? this.disponibilita : null as any;
        data["gruppo"] = this.gruppo !== undefined ? this.gruppo : null as any;
        data["chiave"] = this.chiave !== undefined ? this.chiave : null as any;
        data["acquistabile"] = this.acquistabile !== undefined ? this.acquistabile : null as any;
        data["serviceSearchDataBuffer"] = this.serviceSearchDataBuffer !== undefined ? this.serviceSearchDataBuffer : null as any;
        data["nomeMacroDescID"] = this.nomeMacroDescID !== undefined ? this.nomeMacroDescID : null as any;
        data["gruppoDescID"] = this.gruppoDescID !== undefined ? this.gruppoDescID : null as any;
        return data;
    }
}

export interface IBest {
    attributoID?: number | null;
    nomeMacro?: string | null;
    prezzoPieno?: number | null;
    prezzoPienoValuta?: number | null;
    prezzo?: number;
    prezzoValuta?: number | null;
    nonRimborsabile?: boolean;
    instantPurchase?: boolean;
    haPartenze?: boolean;
    disponibilita?: EStatoDisponibilita;
    gruppo?: string | null;
    chiave?: string;
    acquistabile?: boolean;
    serviceSearchDataBuffer?: string | null;
    nomeMacroDescID?: number | null;
    gruppoDescID?: number | null;
}

export class SourceResultPointer implements ISourceResultPointer {
    fornitore?: EFornitore;
    resultID?: string;
    resultIDStr?: string;
    pricedObjectID?: string | null;
    pricedResultIDStr?: string | null;
    expired?: boolean;
    offersApplied?: boolean;

    constructor(data?: ISourceResultPointer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : null as any;
            this.resultID = _data["resultID"] !== undefined ? _data["resultID"] : null as any;
            this.resultIDStr = _data["resultIDStr"] !== undefined ? _data["resultIDStr"] : null as any;
            this.pricedObjectID = _data["pricedObjectID"] !== undefined ? _data["pricedObjectID"] : null as any;
            this.pricedResultIDStr = _data["pricedResultIDStr"] !== undefined ? _data["pricedResultIDStr"] : null as any;
            this.expired = _data["expired"] !== undefined ? _data["expired"] : null as any;
            this.offersApplied = _data["offersApplied"] !== undefined ? _data["offersApplied"] : null as any;
        }
    }

    static fromJS(data: any): SourceResultPointer {
        data = typeof data === 'object' ? data : {};
        let result = new SourceResultPointer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : null as any;
        data["resultID"] = this.resultID !== undefined ? this.resultID : null as any;
        data["resultIDStr"] = this.resultIDStr !== undefined ? this.resultIDStr : null as any;
        data["pricedObjectID"] = this.pricedObjectID !== undefined ? this.pricedObjectID : null as any;
        data["pricedResultIDStr"] = this.pricedResultIDStr !== undefined ? this.pricedResultIDStr : null as any;
        data["expired"] = this.expired !== undefined ? this.expired : null as any;
        data["offersApplied"] = this.offersApplied !== undefined ? this.offersApplied : null as any;
        return data;
    }
}

export interface ISourceResultPointer {
    fornitore?: EFornitore;
    resultID?: string;
    resultIDStr?: string;
    pricedObjectID?: string | null;
    pricedResultIDStr?: string | null;
    expired?: boolean;
    offersApplied?: boolean;
}

export class GetResultsRequest extends SiteRequest implements IGetResultsRequest {
    jobID!: string;

    constructor(data?: IGetResultsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : null as any;
        }
    }

    static override fromJS(data: any): GetResultsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetResultsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobID"] = this.jobID !== undefined ? this.jobID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetResultsRequest extends ISiteRequest {
    jobID: string;
}

export class GetSearchLogFileResponse extends OkApiResponse implements IGetSearchLogFileResponse {
    logContent?: string | null;
    dataType?: ELogDataType;

    constructor(data?: IGetSearchLogFileResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.logContent = _data["logContent"] !== undefined ? _data["logContent"] : null as any;
            this.dataType = _data["dataType"] !== undefined ? _data["dataType"] : null as any;
        }
    }

    static override fromJS(data: any): GetSearchLogFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSearchLogFileResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logContent"] = this.logContent !== undefined ? this.logContent : null as any;
        data["dataType"] = this.dataType !== undefined ? this.dataType : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetSearchLogFileResponse extends IOkApiResponse {
    logContent?: string | null;
    dataType?: ELogDataType;
}

export class GetSearchLogFileRequest extends ApiRequest implements IGetSearchLogFileRequest {
    /** Source job ID */
    jobID!: string;
    /** Log ID */
    logID!: string;
    getRequest?: boolean;
    download?: boolean;

    constructor(data?: IGetSearchLogFileRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : null as any;
            this.logID = _data["logID"] !== undefined ? _data["logID"] : null as any;
            this.getRequest = _data["getRequest"] !== undefined ? _data["getRequest"] : null as any;
            this.download = _data["download"] !== undefined ? _data["download"] : null as any;
        }
    }

    static override fromJS(data: any): GetSearchLogFileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSearchLogFileRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobID"] = this.jobID !== undefined ? this.jobID : null as any;
        data["logID"] = this.logID !== undefined ? this.logID : null as any;
        data["getRequest"] = this.getRequest !== undefined ? this.getRequest : null as any;
        data["download"] = this.download !== undefined ? this.download : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetSearchLogFileRequest extends IApiRequest {
    /** Source job ID */
    jobID: string;
    /** Log ID */
    logID: string;
    getRequest?: boolean;
    download?: boolean;
}

export class GetServiceDrilldownResponse extends OkApiResponse implements IGetServiceDrilldownResponse {
    servizio?: ServizioSearch | null;

    constructor(data?: IGetServiceDrilldownResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizio = _data["servizio"] ? ServizioSearch.fromJS(_data["servizio"]) : null as any;
        }
    }

    static override fromJS(data: any): GetServiceDrilldownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceDrilldownResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio ? this.servizio.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetServiceDrilldownResponse extends IOkApiResponse {
    servizio?: ServizioSearch | null;
}

export class GetServiceDrilldownRequest extends ApiRequest implements IGetServiceDrilldownRequest {
    jobID?: string;
    generationID?: number;
    serviceID?: string;

    constructor(data?: IGetServiceDrilldownRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : null as any;
            this.generationID = _data["generationID"] !== undefined ? _data["generationID"] : null as any;
            this.serviceID = _data["serviceID"] !== undefined ? _data["serviceID"] : null as any;
        }
    }

    static override fromJS(data: any): GetServiceDrilldownRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceDrilldownRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobID"] = this.jobID !== undefined ? this.jobID : null as any;
        data["generationID"] = this.generationID !== undefined ? this.generationID : null as any;
        data["serviceID"] = this.serviceID !== undefined ? this.serviceID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetServiceDrilldownRequest extends IApiRequest {
    jobID?: string;
    generationID?: number;
    serviceID?: string;
}

export class GetSingleServicePriceResponse extends OkApiResponse implements IGetSingleServicePriceResponse {
    datiServizio?: ServiceData | null;
    servizio?: ServizioSearch | null;
    abbinamentiTipologiePartenze?: AbbinamentoTipologiaPartenza[] | null;
    jobID?: string | null;
    searchKey?: string | null;
    generationID?: number;

    constructor(data?: IGetSingleServicePriceResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.datiServizio = _data["datiServizio"] ? ServiceData.fromJS(_data["datiServizio"]) : null as any;
            this.servizio = _data["servizio"] ? ServizioSearch.fromJS(_data["servizio"]) : null as any;
            if (Array.isArray(_data["abbinamentiTipologiePartenze"])) {
                this.abbinamentiTipologiePartenze = [] as any;
                for (let item of _data["abbinamentiTipologiePartenze"])
                    this.abbinamentiTipologiePartenze!.push(AbbinamentoTipologiaPartenza.fromJS(item));
            }
            else {
                this.abbinamentiTipologiePartenze = null as any;
            }
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : null as any;
            this.searchKey = _data["searchKey"] !== undefined ? _data["searchKey"] : null as any;
            this.generationID = _data["generationID"] !== undefined ? _data["generationID"] : null as any;
        }
    }

    static override fromJS(data: any): GetSingleServicePriceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSingleServicePriceResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datiServizio"] = this.datiServizio ? this.datiServizio.toJSON() : null as any;
        data["servizio"] = this.servizio ? this.servizio.toJSON() : null as any;
        if (Array.isArray(this.abbinamentiTipologiePartenze)) {
            data["abbinamentiTipologiePartenze"] = [];
            for (let item of this.abbinamentiTipologiePartenze)
                data["abbinamentiTipologiePartenze"].push(item ? item.toJSON() : null as any);
        }
        data["jobID"] = this.jobID !== undefined ? this.jobID : null as any;
        data["searchKey"] = this.searchKey !== undefined ? this.searchKey : null as any;
        data["generationID"] = this.generationID !== undefined ? this.generationID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetSingleServicePriceResponse extends IOkApiResponse {
    datiServizio?: ServiceData | null;
    servizio?: ServizioSearch | null;
    abbinamentiTipologiePartenze?: AbbinamentoTipologiaPartenza[] | null;
    jobID?: string | null;
    searchKey?: string | null;
    generationID?: number;
}

export class ServiceData implements IServiceData {
    id?: string;
    servizioID?: number;
    interno?: boolean;
    prezzoBase?: number | null;
    nome?: string | null;
    sottoTitolo?: string | null;
    stringaRicerca?: string | null;
    indirizzo?: string | null;
    altroLuogo?: boolean;
    luogo?: string | null;
    destinazioneID?: number | null;
    cover?: string | null;
    durata?: ServiceDuration | null;
    stelle?: number | null;
    urlName?: string | null;
    mappa?: Mappa | null;
    attributiFiltro?: number[] | null;
    haAttributiTestata?: boolean;
    haCategoria?: boolean;
    categoria?: string | null;
    haNuovo?: boolean;
    nuovo?: string | null;
    haVantaggi?: boolean;
    vantaggi?: string | null;
    haServizi?: boolean;
    inRistrutturazione?: string | null;
    tipoServizio?: ETipoServizio;
    popolarita?: number | null;
    haAttributiNoleggi?: boolean;
    attributiNoleggi?: ElencoAttributiNoleggio[] | null;
    tappe?: (string | null)[] | null;
    luoghi?: number[] | null;
    date?: ServiceDeparture[] | null;
    attributi?: ServiceAttribute[] | null;
    preferito?: boolean;
    prezzi?: ServizioSearch | null;
    testiPrincipali?: TestoCompleto[] | null;
    testiGiorni?: TestoCompleto[] | null;
    testiNote?: TestoCompleto[] | null;
    itinerario?: (ServiceItineraryStep | null)[] | null;
    immagini?: ServiceImage[] | null;
    partenzePerFiltri?: ServiceDepartureFilterValues | null;
    regolePacchetto?: ServizioRegolaScontoPacchetto[] | null;
    tipologie?: TipologieServiziItinerario[] | null;
    providerContact?: ServiceProviderContact;
    departureAirports?: PackageDepartureAirports[] | null;
    airlines?: PackageAirlines[] | null;

    constructor(data?: IServiceData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.interno = _data["interno"] !== undefined ? _data["interno"] : null as any;
            this.prezzoBase = _data["prezzoBase"] !== undefined ? _data["prezzoBase"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.sottoTitolo = _data["sottoTitolo"] !== undefined ? _data["sottoTitolo"] : null as any;
            this.stringaRicerca = _data["stringaRicerca"] !== undefined ? _data["stringaRicerca"] : null as any;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : null as any;
            this.altroLuogo = _data["altroLuogo"] !== undefined ? _data["altroLuogo"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.destinazioneID = _data["destinazioneID"] !== undefined ? _data["destinazioneID"] : null as any;
            this.cover = _data["cover"] !== undefined ? _data["cover"] : null as any;
            this.durata = _data["durata"] ? ServiceDuration.fromJS(_data["durata"]) : null as any;
            this.stelle = _data["stelle"] !== undefined ? _data["stelle"] : null as any;
            this.urlName = _data["urlName"] !== undefined ? _data["urlName"] : null as any;
            this.mappa = _data["mappa"] ? Mappa.fromJS(_data["mappa"]) : null as any;
            if (Array.isArray(_data["attributiFiltro"])) {
                this.attributiFiltro = [] as any;
                for (let item of _data["attributiFiltro"])
                    this.attributiFiltro!.push(item);
            }
            else {
                this.attributiFiltro = null as any;
            }
            this.haAttributiTestata = _data["haAttributiTestata"] !== undefined ? _data["haAttributiTestata"] : null as any;
            this.haCategoria = _data["haCategoria"] !== undefined ? _data["haCategoria"] : null as any;
            this.categoria = _data["categoria"] !== undefined ? _data["categoria"] : null as any;
            this.haNuovo = _data["haNuovo"] !== undefined ? _data["haNuovo"] : null as any;
            this.nuovo = _data["nuovo"] !== undefined ? _data["nuovo"] : null as any;
            this.haVantaggi = _data["haVantaggi"] !== undefined ? _data["haVantaggi"] : null as any;
            this.vantaggi = _data["vantaggi"] !== undefined ? _data["vantaggi"] : null as any;
            this.haServizi = _data["haServizi"] !== undefined ? _data["haServizi"] : null as any;
            this.inRistrutturazione = _data["inRistrutturazione"] !== undefined ? _data["inRistrutturazione"] : null as any;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
            this.popolarita = _data["popolarita"] !== undefined ? _data["popolarita"] : null as any;
            this.haAttributiNoleggi = _data["haAttributiNoleggi"] !== undefined ? _data["haAttributiNoleggi"] : null as any;
            if (Array.isArray(_data["attributiNoleggi"])) {
                this.attributiNoleggi = [] as any;
                for (let item of _data["attributiNoleggi"])
                    this.attributiNoleggi!.push(ElencoAttributiNoleggio.fromJS(item));
            }
            else {
                this.attributiNoleggi = null as any;
            }
            if (Array.isArray(_data["tappe"])) {
                this.tappe = [] as any;
                for (let item of _data["tappe"])
                    this.tappe!.push(item);
            }
            else {
                this.tappe = null as any;
            }
            if (Array.isArray(_data["luoghi"])) {
                this.luoghi = [] as any;
                for (let item of _data["luoghi"])
                    this.luoghi!.push(item);
            }
            else {
                this.luoghi = null as any;
            }
            if (Array.isArray(_data["date"])) {
                this.date = [] as any;
                for (let item of _data["date"])
                    this.date!.push(ServiceDeparture.fromJS(item));
            }
            else {
                this.date = null as any;
            }
            if (Array.isArray(_data["attributi"])) {
                this.attributi = [] as any;
                for (let item of _data["attributi"])
                    this.attributi!.push(ServiceAttribute.fromJS(item));
            }
            else {
                this.attributi = null as any;
            }
            this.preferito = _data["preferito"] !== undefined ? _data["preferito"] : null as any;
            this.prezzi = _data["prezzi"] ? ServizioSearch.fromJS(_data["prezzi"]) : null as any;
            if (Array.isArray(_data["testiPrincipali"])) {
                this.testiPrincipali = [] as any;
                for (let item of _data["testiPrincipali"])
                    this.testiPrincipali!.push(TestoCompleto.fromJS(item));
            }
            else {
                this.testiPrincipali = null as any;
            }
            if (Array.isArray(_data["testiGiorni"])) {
                this.testiGiorni = [] as any;
                for (let item of _data["testiGiorni"])
                    this.testiGiorni!.push(TestoCompleto.fromJS(item));
            }
            else {
                this.testiGiorni = null as any;
            }
            if (Array.isArray(_data["testiNote"])) {
                this.testiNote = [] as any;
                for (let item of _data["testiNote"])
                    this.testiNote!.push(TestoCompleto.fromJS(item));
            }
            else {
                this.testiNote = null as any;
            }
            if (Array.isArray(_data["itinerario"])) {
                this.itinerario = [] as any;
                for (let item of _data["itinerario"])
                    this.itinerario!.push(ServiceItineraryStep.fromJS(item));
            }
            else {
                this.itinerario = null as any;
            }
            if (Array.isArray(_data["immagini"])) {
                this.immagini = [] as any;
                for (let item of _data["immagini"])
                    this.immagini!.push(ServiceImage.fromJS(item));
            }
            else {
                this.immagini = null as any;
            }
            this.partenzePerFiltri = _data["partenzePerFiltri"] ? ServiceDepartureFilterValues.fromJS(_data["partenzePerFiltri"]) : null as any;
            if (Array.isArray(_data["regolePacchetto"])) {
                this.regolePacchetto = [] as any;
                for (let item of _data["regolePacchetto"])
                    this.regolePacchetto!.push(ServizioRegolaScontoPacchetto.fromJS(item));
            }
            else {
                this.regolePacchetto = null as any;
            }
            if (Array.isArray(_data["tipologie"])) {
                this.tipologie = [] as any;
                for (let item of _data["tipologie"])
                    this.tipologie!.push(TipologieServiziItinerario.fromJS(item));
            }
            else {
                this.tipologie = null as any;
            }
            this.providerContact = _data["providerContact"] ? ServiceProviderContact.fromJS(_data["providerContact"]) : null as any;
            if (Array.isArray(_data["departureAirports"])) {
                this.departureAirports = [] as any;
                for (let item of _data["departureAirports"])
                    this.departureAirports!.push(PackageDepartureAirports.fromJS(item));
            }
            else {
                this.departureAirports = null as any;
            }
            if (Array.isArray(_data["airlines"])) {
                this.airlines = [] as any;
                for (let item of _data["airlines"])
                    this.airlines!.push(PackageAirlines.fromJS(item));
            }
            else {
                this.airlines = null as any;
            }
        }
    }

    static fromJS(data: any): ServiceData {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["interno"] = this.interno !== undefined ? this.interno : null as any;
        data["prezzoBase"] = this.prezzoBase !== undefined ? this.prezzoBase : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["sottoTitolo"] = this.sottoTitolo !== undefined ? this.sottoTitolo : null as any;
        data["stringaRicerca"] = this.stringaRicerca !== undefined ? this.stringaRicerca : null as any;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : null as any;
        data["altroLuogo"] = this.altroLuogo !== undefined ? this.altroLuogo : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["destinazioneID"] = this.destinazioneID !== undefined ? this.destinazioneID : null as any;
        data["cover"] = this.cover !== undefined ? this.cover : null as any;
        data["durata"] = this.durata ? this.durata.toJSON() : null as any;
        data["stelle"] = this.stelle !== undefined ? this.stelle : null as any;
        data["urlName"] = this.urlName !== undefined ? this.urlName : null as any;
        data["mappa"] = this.mappa ? this.mappa.toJSON() : null as any;
        if (Array.isArray(this.attributiFiltro)) {
            data["attributiFiltro"] = [];
            for (let item of this.attributiFiltro)
                data["attributiFiltro"].push(item);
        }
        data["haAttributiTestata"] = this.haAttributiTestata !== undefined ? this.haAttributiTestata : null as any;
        data["haCategoria"] = this.haCategoria !== undefined ? this.haCategoria : null as any;
        data["categoria"] = this.categoria !== undefined ? this.categoria : null as any;
        data["haNuovo"] = this.haNuovo !== undefined ? this.haNuovo : null as any;
        data["nuovo"] = this.nuovo !== undefined ? this.nuovo : null as any;
        data["haVantaggi"] = this.haVantaggi !== undefined ? this.haVantaggi : null as any;
        data["vantaggi"] = this.vantaggi !== undefined ? this.vantaggi : null as any;
        data["haServizi"] = this.haServizi !== undefined ? this.haServizi : null as any;
        data["inRistrutturazione"] = this.inRistrutturazione !== undefined ? this.inRistrutturazione : null as any;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        data["popolarita"] = this.popolarita !== undefined ? this.popolarita : null as any;
        data["haAttributiNoleggi"] = this.haAttributiNoleggi !== undefined ? this.haAttributiNoleggi : null as any;
        if (Array.isArray(this.attributiNoleggi)) {
            data["attributiNoleggi"] = [];
            for (let item of this.attributiNoleggi)
                data["attributiNoleggi"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.tappe)) {
            data["tappe"] = [];
            for (let item of this.tappe)
                data["tappe"].push(item);
        }
        if (Array.isArray(this.luoghi)) {
            data["luoghi"] = [];
            for (let item of this.luoghi)
                data["luoghi"].push(item);
        }
        if (Array.isArray(this.date)) {
            data["date"] = [];
            for (let item of this.date)
                data["date"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.attributi)) {
            data["attributi"] = [];
            for (let item of this.attributi)
                data["attributi"].push(item ? item.toJSON() : null as any);
        }
        data["preferito"] = this.preferito !== undefined ? this.preferito : null as any;
        data["prezzi"] = this.prezzi ? this.prezzi.toJSON() : null as any;
        if (Array.isArray(this.testiPrincipali)) {
            data["testiPrincipali"] = [];
            for (let item of this.testiPrincipali)
                data["testiPrincipali"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.testiGiorni)) {
            data["testiGiorni"] = [];
            for (let item of this.testiGiorni)
                data["testiGiorni"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.testiNote)) {
            data["testiNote"] = [];
            for (let item of this.testiNote)
                data["testiNote"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.itinerario)) {
            data["itinerario"] = [];
            for (let item of this.itinerario)
                data["itinerario"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.immagini)) {
            data["immagini"] = [];
            for (let item of this.immagini)
                data["immagini"].push(item ? item.toJSON() : null as any);
        }
        data["partenzePerFiltri"] = this.partenzePerFiltri ? this.partenzePerFiltri.toJSON() : null as any;
        if (Array.isArray(this.regolePacchetto)) {
            data["regolePacchetto"] = [];
            for (let item of this.regolePacchetto)
                data["regolePacchetto"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.tipologie)) {
            data["tipologie"] = [];
            for (let item of this.tipologie)
                data["tipologie"].push(item ? item.toJSON() : null as any);
        }
        data["providerContact"] = this.providerContact ? this.providerContact.toJSON() : null as any;
        if (Array.isArray(this.departureAirports)) {
            data["departureAirports"] = [];
            for (let item of this.departureAirports)
                data["departureAirports"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.airlines)) {
            data["airlines"] = [];
            for (let item of this.airlines)
                data["airlines"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IServiceData {
    id?: string;
    servizioID?: number;
    interno?: boolean;
    prezzoBase?: number | null;
    nome?: string | null;
    sottoTitolo?: string | null;
    stringaRicerca?: string | null;
    indirizzo?: string | null;
    altroLuogo?: boolean;
    luogo?: string | null;
    destinazioneID?: number | null;
    cover?: string | null;
    durata?: ServiceDuration | null;
    stelle?: number | null;
    urlName?: string | null;
    mappa?: Mappa | null;
    attributiFiltro?: number[] | null;
    haAttributiTestata?: boolean;
    haCategoria?: boolean;
    categoria?: string | null;
    haNuovo?: boolean;
    nuovo?: string | null;
    haVantaggi?: boolean;
    vantaggi?: string | null;
    haServizi?: boolean;
    inRistrutturazione?: string | null;
    tipoServizio?: ETipoServizio;
    popolarita?: number | null;
    haAttributiNoleggi?: boolean;
    attributiNoleggi?: ElencoAttributiNoleggio[] | null;
    tappe?: (string | null)[] | null;
    luoghi?: number[] | null;
    date?: ServiceDeparture[] | null;
    attributi?: ServiceAttribute[] | null;
    preferito?: boolean;
    prezzi?: ServizioSearch | null;
    testiPrincipali?: TestoCompleto[] | null;
    testiGiorni?: TestoCompleto[] | null;
    testiNote?: TestoCompleto[] | null;
    itinerario?: (ServiceItineraryStep | null)[] | null;
    immagini?: ServiceImage[] | null;
    partenzePerFiltri?: ServiceDepartureFilterValues | null;
    regolePacchetto?: ServizioRegolaScontoPacchetto[] | null;
    tipologie?: TipologieServiziItinerario[] | null;
    providerContact?: ServiceProviderContact;
    departureAirports?: PackageDepartureAirports[] | null;
    airlines?: PackageAirlines[] | null;
}

export class ElencoAttributiNoleggio implements IElencoAttributiNoleggio {
    titolo?: string | null;
    attributiNoleggio?: AttributoNoleggio[] | null;

    constructor(data?: IElencoAttributiNoleggio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            if (Array.isArray(_data["attributiNoleggio"])) {
                this.attributiNoleggio = [] as any;
                for (let item of _data["attributiNoleggio"])
                    this.attributiNoleggio!.push(AttributoNoleggio.fromJS(item));
            }
            else {
                this.attributiNoleggio = null as any;
            }
        }
    }

    static fromJS(data: any): ElencoAttributiNoleggio {
        data = typeof data === 'object' ? data : {};
        let result = new ElencoAttributiNoleggio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        if (Array.isArray(this.attributiNoleggio)) {
            data["attributiNoleggio"] = [];
            for (let item of this.attributiNoleggio)
                data["attributiNoleggio"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IElencoAttributiNoleggio {
    titolo?: string | null;
    attributiNoleggio?: AttributoNoleggio[] | null;
}

export class AttributoNoleggio implements IAttributoNoleggio {
    icona?: string | null;
    nome?: string | null;
    valore?: string | null;
    titolo?: string | null;

    constructor(data?: IAttributoNoleggio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.icona = _data["icona"] !== undefined ? _data["icona"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.valore = _data["valore"] !== undefined ? _data["valore"] : null as any;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
        }
    }

    static fromJS(data: any): AttributoNoleggio {
        data = typeof data === 'object' ? data : {};
        let result = new AttributoNoleggio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["icona"] = this.icona !== undefined ? this.icona : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["valore"] = this.valore !== undefined ? this.valore : null as any;
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        return data;
    }
}

export interface IAttributoNoleggio {
    icona?: string | null;
    nome?: string | null;
    valore?: string | null;
    titolo?: string | null;
}

export class ServiceDeparture implements IServiceDeparture {
    anno?: number;
    mese?: number;
    annoSuccessivo?: boolean;
    tag?: number;
    giorni?: string[] | null;
    flags?: EPartenzaFlags;
    prezzi?: PartenzaPrezzo[] | null;

    constructor(data?: IServiceDeparture) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.anno = _data["anno"] !== undefined ? _data["anno"] : null as any;
            this.mese = _data["mese"] !== undefined ? _data["mese"] : null as any;
            this.annoSuccessivo = _data["annoSuccessivo"] !== undefined ? _data["annoSuccessivo"] : null as any;
            this.tag = _data["tag"] !== undefined ? _data["tag"] : null as any;
            if (Array.isArray(_data["giorni"])) {
                this.giorni = [] as any;
                for (let item of _data["giorni"])
                    this.giorni!.push(item);
            }
            else {
                this.giorni = null as any;
            }
            this.flags = _data["flags"] !== undefined ? _data["flags"] : null as any;
            if (Array.isArray(_data["prezzi"])) {
                this.prezzi = [] as any;
                for (let item of _data["prezzi"])
                    this.prezzi!.push(PartenzaPrezzo.fromJS(item));
            }
            else {
                this.prezzi = null as any;
            }
        }
    }

    static fromJS(data: any): ServiceDeparture {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDeparture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["anno"] = this.anno !== undefined ? this.anno : null as any;
        data["mese"] = this.mese !== undefined ? this.mese : null as any;
        data["annoSuccessivo"] = this.annoSuccessivo !== undefined ? this.annoSuccessivo : null as any;
        data["tag"] = this.tag !== undefined ? this.tag : null as any;
        if (Array.isArray(this.giorni)) {
            data["giorni"] = [];
            for (let item of this.giorni)
                data["giorni"].push(item);
        }
        data["flags"] = this.flags !== undefined ? this.flags : null as any;
        if (Array.isArray(this.prezzi)) {
            data["prezzi"] = [];
            for (let item of this.prezzi)
                data["prezzi"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IServiceDeparture {
    anno?: number;
    mese?: number;
    annoSuccessivo?: boolean;
    tag?: number;
    giorni?: string[] | null;
    flags?: EPartenzaFlags;
    prezzi?: PartenzaPrezzo[] | null;
}

export class PartenzaPrezzo implements IPartenzaPrezzo {
    id?: number;
    departureID?: number;
    departureAirport?: string | null;
    price?: number;
    updatedAt?: string | null;
    expiresAt?: string | null;

    constructor(data?: IPartenzaPrezzo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.departureID = _data["departureID"] !== undefined ? _data["departureID"] : null as any;
            this.departureAirport = _data["departureAirport"] !== undefined ? _data["departureAirport"] : null as any;
            this.price = _data["price"] !== undefined ? _data["price"] : null as any;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : null as any;
            this.expiresAt = _data["expiresAt"] !== undefined ? _data["expiresAt"] : null as any;
        }
    }

    static fromJS(data: any): PartenzaPrezzo {
        data = typeof data === 'object' ? data : {};
        let result = new PartenzaPrezzo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["departureID"] = this.departureID !== undefined ? this.departureID : null as any;
        data["departureAirport"] = this.departureAirport !== undefined ? this.departureAirport : null as any;
        data["price"] = this.price !== undefined ? this.price : null as any;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : null as any;
        data["expiresAt"] = this.expiresAt !== undefined ? this.expiresAt : null as any;
        return data;
    }
}

export interface IPartenzaPrezzo {
    id?: number;
    departureID?: number;
    departureAirport?: string | null;
    price?: number;
    updatedAt?: string | null;
    expiresAt?: string | null;
}

export class ServiceItineraryStep implements IServiceItineraryStep {
    luogoID?: number;
    luogo?: string | null;
    latitudine?: number;
    longitudine?: number;
    notti?: number;
    tipoTrasporto?: ETipoTrasporto;
    ordine?: number;
    giorno?: number;
    compagniaAerea?: string | null;
    classe?: string | null;
    compagniaAerea2?: string | null;
    classe2?: string | null;
    cambioHotel?: boolean;

    constructor(data?: IServiceItineraryStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.latitudine = _data["latitudine"] !== undefined ? _data["latitudine"] : null as any;
            this.longitudine = _data["longitudine"] !== undefined ? _data["longitudine"] : null as any;
            this.notti = _data["notti"] !== undefined ? _data["notti"] : null as any;
            this.tipoTrasporto = _data["tipoTrasporto"] !== undefined ? _data["tipoTrasporto"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : null as any;
            this.compagniaAerea = _data["compagniaAerea"] !== undefined ? _data["compagniaAerea"] : null as any;
            this.classe = _data["classe"] !== undefined ? _data["classe"] : null as any;
            this.compagniaAerea2 = _data["compagniaAerea2"] !== undefined ? _data["compagniaAerea2"] : null as any;
            this.classe2 = _data["classe2"] !== undefined ? _data["classe2"] : null as any;
            this.cambioHotel = _data["cambioHotel"] !== undefined ? _data["cambioHotel"] : null as any;
        }
    }

    static fromJS(data: any): ServiceItineraryStep {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceItineraryStep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["latitudine"] = this.latitudine !== undefined ? this.latitudine : null as any;
        data["longitudine"] = this.longitudine !== undefined ? this.longitudine : null as any;
        data["notti"] = this.notti !== undefined ? this.notti : null as any;
        data["tipoTrasporto"] = this.tipoTrasporto !== undefined ? this.tipoTrasporto : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["giorno"] = this.giorno !== undefined ? this.giorno : null as any;
        data["compagniaAerea"] = this.compagniaAerea !== undefined ? this.compagniaAerea : null as any;
        data["classe"] = this.classe !== undefined ? this.classe : null as any;
        data["compagniaAerea2"] = this.compagniaAerea2 !== undefined ? this.compagniaAerea2 : null as any;
        data["classe2"] = this.classe2 !== undefined ? this.classe2 : null as any;
        data["cambioHotel"] = this.cambioHotel !== undefined ? this.cambioHotel : null as any;
        return data;
    }
}

export interface IServiceItineraryStep {
    luogoID?: number;
    luogo?: string | null;
    latitudine?: number;
    longitudine?: number;
    notti?: number;
    tipoTrasporto?: ETipoTrasporto;
    ordine?: number;
    giorno?: number;
    compagniaAerea?: string | null;
    classe?: string | null;
    compagniaAerea2?: string | null;
    classe2?: string | null;
    cambioHotel?: boolean;
}

export class ServiceImage implements IServiceImage {
    url?: string | null;
    title?: string | null;

    constructor(data?: IServiceImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
        }
    }

    static fromJS(data: any): ServiceImage {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url !== undefined ? this.url : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        return data;
    }
}

export interface IServiceImage {
    url?: string | null;
    title?: string | null;
}

export class ServiceDepartureFilterValues implements IServiceDepartureFilterValues {
    dataMinima?: number | null;
    dataMassima?: number | null;
    dateValide?: number[] | null;
    giornaliero?: boolean;

    constructor(data?: IServiceDepartureFilterValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataMinima = _data["dataMinima"] !== undefined ? _data["dataMinima"] : null as any;
            this.dataMassima = _data["dataMassima"] !== undefined ? _data["dataMassima"] : null as any;
            if (Array.isArray(_data["dateValide"])) {
                this.dateValide = [] as any;
                for (let item of _data["dateValide"])
                    this.dateValide!.push(item);
            }
            else {
                this.dateValide = null as any;
            }
            this.giornaliero = _data["giornaliero"] !== undefined ? _data["giornaliero"] : null as any;
        }
    }

    static fromJS(data: any): ServiceDepartureFilterValues {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDepartureFilterValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataMinima"] = this.dataMinima !== undefined ? this.dataMinima : null as any;
        data["dataMassima"] = this.dataMassima !== undefined ? this.dataMassima : null as any;
        if (Array.isArray(this.dateValide)) {
            data["dateValide"] = [];
            for (let item of this.dateValide)
                data["dateValide"].push(item);
        }
        data["giornaliero"] = this.giornaliero !== undefined ? this.giornaliero : null as any;
        return data;
    }
}

export interface IServiceDepartureFilterValues {
    dataMinima?: number | null;
    dataMassima?: number | null;
    dateValide?: number[] | null;
    giornaliero?: boolean;
}

export class TipologieServiziItinerario implements ITipologieServiziItinerario {
    tipologia?: string;
    giorni?: TipologieServiziItinerarioGiorno[];

    constructor(data?: ITipologieServiziItinerario) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipologia = _data["tipologia"] !== undefined ? _data["tipologia"] : null as any;
            if (Array.isArray(_data["giorni"])) {
                this.giorni = [] as any;
                for (let item of _data["giorni"])
                    this.giorni!.push(TipologieServiziItinerarioGiorno.fromJS(item));
            }
            else {
                this.giorni = null as any;
            }
        }
    }

    static fromJS(data: any): TipologieServiziItinerario {
        data = typeof data === 'object' ? data : {};
        let result = new TipologieServiziItinerario();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipologia"] = this.tipologia !== undefined ? this.tipologia : null as any;
        if (Array.isArray(this.giorni)) {
            data["giorni"] = [];
            for (let item of this.giorni)
                data["giorni"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ITipologieServiziItinerario {
    tipologia?: string;
    giorni?: TipologieServiziItinerarioGiorno[];
}

export class TipologieServiziItinerarioGiorno implements ITipologieServiziItinerarioGiorno {
    luogo?: string;
    giorno?: number;
    durata?: number;
    servizi?: TipologieServiziItinerarioGiornoServizio[];

    constructor(data?: ITipologieServiziItinerarioGiorno) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : null as any;
            this.durata = _data["durata"] !== undefined ? _data["durata"] : null as any;
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(TipologieServiziItinerarioGiornoServizio.fromJS(item));
            }
            else {
                this.servizi = null as any;
            }
        }
    }

    static fromJS(data: any): TipologieServiziItinerarioGiorno {
        data = typeof data === 'object' ? data : {};
        let result = new TipologieServiziItinerarioGiorno();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["giorno"] = this.giorno !== undefined ? this.giorno : null as any;
        data["durata"] = this.durata !== undefined ? this.durata : null as any;
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ITipologieServiziItinerarioGiorno {
    luogo?: string;
    giorno?: number;
    durata?: number;
    servizi?: TipologieServiziItinerarioGiornoServizio[];
}

export class TipologieServiziItinerarioGiornoServizio implements ITipologieServiziItinerarioGiornoServizio {
    nome?: string;
    alternativa?: boolean;
    url?: string | null;

    constructor(data?: ITipologieServiziItinerarioGiornoServizio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.alternativa = _data["alternativa"] !== undefined ? _data["alternativa"] : null as any;
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
        }
    }

    static fromJS(data: any): TipologieServiziItinerarioGiornoServizio {
        data = typeof data === 'object' ? data : {};
        let result = new TipologieServiziItinerarioGiornoServizio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["alternativa"] = this.alternativa !== undefined ? this.alternativa : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        return data;
    }
}

export interface ITipologieServiziItinerarioGiornoServizio {
    nome?: string;
    alternativa?: boolean;
    url?: string | null;
}

export class ServiceProviderContact implements IServiceProviderContact {
    contact?: Contatto | null;
    logo?: string | null;

    constructor(data?: IServiceProviderContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contact = _data["contact"] ? Contatto.fromJS(_data["contact"]) : null as any;
            this.logo = _data["logo"] !== undefined ? _data["logo"] : null as any;
        }
    }

    static fromJS(data: any): ServiceProviderContact {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceProviderContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contact"] = this.contact ? this.contact.toJSON() : null as any;
        data["logo"] = this.logo !== undefined ? this.logo : null as any;
        return data;
    }
}

export interface IServiceProviderContact {
    contact?: Contatto | null;
    logo?: string | null;
}

export class PackageDepartureAirports implements IPackageDepartureAirports {
    airportID?: number;
    airportCode?: string;
    airportName?: string;
    city?: number | null;

    constructor(data?: IPackageDepartureAirports) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.airportID = _data["airportID"] !== undefined ? _data["airportID"] : null as any;
            this.airportCode = _data["airportCode"] !== undefined ? _data["airportCode"] : null as any;
            this.airportName = _data["airportName"] !== undefined ? _data["airportName"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
        }
    }

    static fromJS(data: any): PackageDepartureAirports {
        data = typeof data === 'object' ? data : {};
        let result = new PackageDepartureAirports();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airportID"] = this.airportID !== undefined ? this.airportID : null as any;
        data["airportCode"] = this.airportCode !== undefined ? this.airportCode : null as any;
        data["airportName"] = this.airportName !== undefined ? this.airportName : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        return data;
    }
}

export interface IPackageDepartureAirports {
    airportID?: number;
    airportCode?: string;
    airportName?: string;
    city?: number | null;
}

export class PackageAirlines implements IPackageAirlines {
    airlineID?: number;
    airlineCode?: string;
    airlineName?: string;

    constructor(data?: IPackageAirlines) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.airlineID = _data["airlineID"] !== undefined ? _data["airlineID"] : null as any;
            this.airlineCode = _data["airlineCode"] !== undefined ? _data["airlineCode"] : null as any;
            this.airlineName = _data["airlineName"] !== undefined ? _data["airlineName"] : null as any;
        }
    }

    static fromJS(data: any): PackageAirlines {
        data = typeof data === 'object' ? data : {};
        let result = new PackageAirlines();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airlineID"] = this.airlineID !== undefined ? this.airlineID : null as any;
        data["airlineCode"] = this.airlineCode !== undefined ? this.airlineCode : null as any;
        data["airlineName"] = this.airlineName !== undefined ? this.airlineName : null as any;
        return data;
    }
}

export interface IPackageAirlines {
    airlineID?: number;
    airlineCode?: string;
    airlineName?: string;
}

export class AbbinamentoTipologiaPartenza implements IAbbinamentoTipologiaPartenza {
    abbinamento?: AbbinamentoTipologie | null;
    tipologia?: TipologiaSearch | null;
    partenza?: PartenzaSearch | null;

    constructor(data?: IAbbinamentoTipologiaPartenza) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.abbinamento = _data["abbinamento"] ? AbbinamentoTipologie.fromJS(_data["abbinamento"]) : null as any;
            this.tipologia = _data["tipologia"] ? TipologiaSearch.fromJS(_data["tipologia"]) : null as any;
            this.partenza = _data["partenza"] ? PartenzaSearch.fromJS(_data["partenza"]) : null as any;
        }
    }

    static fromJS(data: any): AbbinamentoTipologiaPartenza {
        data = typeof data === 'object' ? data : {};
        let result = new AbbinamentoTipologiaPartenza();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["abbinamento"] = this.abbinamento ? this.abbinamento.toJSON() : null as any;
        data["tipologia"] = this.tipologia ? this.tipologia.toJSON() : null as any;
        data["partenza"] = this.partenza ? this.partenza.toJSON() : null as any;
        return data;
    }
}

export interface IAbbinamentoTipologiaPartenza {
    abbinamento?: AbbinamentoTipologie | null;
    tipologia?: TipologiaSearch | null;
    partenza?: PartenzaSearch | null;
}

export class StartPriceSearchRequest extends SiteRequest implements IStartPriceSearchRequest {
    tipoServizio?: ETipoServizio;
    luogoID?: number | null;
    luogoDestinazioneID?: number | null;
    offertaID?: number | null;
    tappaID?: number | null;
    dal?: string | null;
    daOre?: number | null;
    al?: string | null;
    aOre?: number | null;
    paxIds?: number[] | null;
    abbinamentiIds?: number[] | null;
    paxDefs?: PaxDef[] | null;
    abbinamentiDefs?: AbbinamentoDef[] | null;
    nomeGruppoCustom?: string | null;
    abilitaLog?: boolean;
    bypassCache?: boolean;

    constructor(data?: IStartPriceSearchRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.luogoDestinazioneID = _data["luogoDestinazioneID"] !== undefined ? _data["luogoDestinazioneID"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.tappaID = _data["tappaID"] !== undefined ? _data["tappaID"] : null as any;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.daOre = _data["daOre"] !== undefined ? _data["daOre"] : null as any;
            this.al = _data["al"] !== undefined ? _data["al"] : null as any;
            this.aOre = _data["aOre"] !== undefined ? _data["aOre"] : null as any;
            if (Array.isArray(_data["paxIds"])) {
                this.paxIds = [] as any;
                for (let item of _data["paxIds"])
                    this.paxIds!.push(item);
            }
            else {
                this.paxIds = null as any;
            }
            if (Array.isArray(_data["abbinamentiIds"])) {
                this.abbinamentiIds = [] as any;
                for (let item of _data["abbinamentiIds"])
                    this.abbinamentiIds!.push(item);
            }
            else {
                this.abbinamentiIds = null as any;
            }
            if (Array.isArray(_data["paxDefs"])) {
                this.paxDefs = [] as any;
                for (let item of _data["paxDefs"])
                    this.paxDefs!.push(PaxDef.fromJS(item));
            }
            else {
                this.paxDefs = null as any;
            }
            if (Array.isArray(_data["abbinamentiDefs"])) {
                this.abbinamentiDefs = [] as any;
                for (let item of _data["abbinamentiDefs"])
                    this.abbinamentiDefs!.push(AbbinamentoDef.fromJS(item));
            }
            else {
                this.abbinamentiDefs = null as any;
            }
            this.nomeGruppoCustom = _data["nomeGruppoCustom"] !== undefined ? _data["nomeGruppoCustom"] : null as any;
            this.abilitaLog = _data["abilitaLog"] !== undefined ? _data["abilitaLog"] : null as any;
            this.bypassCache = _data["bypassCache"] !== undefined ? _data["bypassCache"] : null as any;
        }
    }

    static override fromJS(data: any): StartPriceSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StartPriceSearchRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["luogoDestinazioneID"] = this.luogoDestinazioneID !== undefined ? this.luogoDestinazioneID : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["tappaID"] = this.tappaID !== undefined ? this.tappaID : null as any;
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["daOre"] = this.daOre !== undefined ? this.daOre : null as any;
        data["al"] = this.al !== undefined ? this.al : null as any;
        data["aOre"] = this.aOre !== undefined ? this.aOre : null as any;
        if (Array.isArray(this.paxIds)) {
            data["paxIds"] = [];
            for (let item of this.paxIds)
                data["paxIds"].push(item);
        }
        if (Array.isArray(this.abbinamentiIds)) {
            data["abbinamentiIds"] = [];
            for (let item of this.abbinamentiIds)
                data["abbinamentiIds"].push(item);
        }
        if (Array.isArray(this.paxDefs)) {
            data["paxDefs"] = [];
            for (let item of this.paxDefs)
                data["paxDefs"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.abbinamentiDefs)) {
            data["abbinamentiDefs"] = [];
            for (let item of this.abbinamentiDefs)
                data["abbinamentiDefs"].push(item ? item.toJSON() : null as any);
        }
        data["nomeGruppoCustom"] = this.nomeGruppoCustom !== undefined ? this.nomeGruppoCustom : null as any;
        data["abilitaLog"] = this.abilitaLog !== undefined ? this.abilitaLog : null as any;
        data["bypassCache"] = this.bypassCache !== undefined ? this.bypassCache : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IStartPriceSearchRequest extends ISiteRequest {
    tipoServizio?: ETipoServizio;
    luogoID?: number | null;
    luogoDestinazioneID?: number | null;
    offertaID?: number | null;
    tappaID?: number | null;
    dal?: string | null;
    daOre?: number | null;
    al?: string | null;
    aOre?: number | null;
    paxIds?: number[] | null;
    abbinamentiIds?: number[] | null;
    paxDefs?: PaxDef[] | null;
    abbinamentiDefs?: AbbinamentoDef[] | null;
    nomeGruppoCustom?: string | null;
    abilitaLog?: boolean;
    bypassCache?: boolean;
}

export class GetSingleServicePriceRequest extends StartPriceSearchRequest implements IGetSingleServicePriceRequest {
    servizioID?: number;
    tipologiaID?: number;
    trattamentoID?: number | null;
    partenza?: string;

    constructor(data?: IGetSingleServicePriceRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.tipologiaID = _data["tipologiaID"] !== undefined ? _data["tipologiaID"] : null as any;
            this.trattamentoID = _data["trattamentoID"] !== undefined ? _data["trattamentoID"] : null as any;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : null as any;
        }
    }

    static override fromJS(data: any): GetSingleServicePriceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSingleServicePriceRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["tipologiaID"] = this.tipologiaID !== undefined ? this.tipologiaID : null as any;
        data["trattamentoID"] = this.trattamentoID !== undefined ? this.trattamentoID : null as any;
        data["partenza"] = this.partenza !== undefined ? this.partenza : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetSingleServicePriceRequest extends IStartPriceSearchRequest {
    servizioID?: number;
    tipologiaID?: number;
    trattamentoID?: number | null;
    partenza?: string;
}

export class PaxDef implements IPaxDef {
    id?: number;
    titolo?: ETitolo;
    nome?: string | null;
    cognome?: string | null;
    dataDiNascita?: string;

    constructor(data?: IPaxDef) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : null as any;
            this.dataDiNascita = _data["dataDiNascita"] !== undefined ? _data["dataDiNascita"] : null as any;
        }
    }

    static fromJS(data: any): PaxDef {
        data = typeof data === 'object' ? data : {};
        let result = new PaxDef();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["cognome"] = this.cognome !== undefined ? this.cognome : null as any;
        data["dataDiNascita"] = this.dataDiNascita !== undefined ? this.dataDiNascita : null as any;
        return data;
    }
}

export interface IPaxDef {
    id?: number;
    titolo?: ETitolo;
    nome?: string | null;
    cognome?: string | null;
    dataDiNascita?: string;
}

export class AbbinamentoDef implements IAbbinamentoDef {
    id?: number;
    nome?: string | null;
    paxDefs?: PaxDef[] | null;

    constructor(data?: IAbbinamentoDef) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            if (Array.isArray(_data["paxDefs"])) {
                this.paxDefs = [] as any;
                for (let item of _data["paxDefs"])
                    this.paxDefs!.push(PaxDef.fromJS(item));
            }
            else {
                this.paxDefs = null as any;
            }
        }
    }

    static fromJS(data: any): AbbinamentoDef {
        data = typeof data === 'object' ? data : {};
        let result = new AbbinamentoDef();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        if (Array.isArray(this.paxDefs)) {
            data["paxDefs"] = [];
            for (let item of this.paxDefs)
                data["paxDefs"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IAbbinamentoDef {
    id?: number;
    nome?: string | null;
    paxDefs?: PaxDef[] | null;
}

export class GetTripAutocompleteResponse extends OkApiResponse implements IGetTripAutocompleteResponse {
    jobID?: string;

    constructor(data?: IGetTripAutocompleteResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : null as any;
        }
    }

    static override fromJS(data: any): GetTripAutocompleteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripAutocompleteResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobID"] = this.jobID !== undefined ? this.jobID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTripAutocompleteResponse extends IOkApiResponse {
    jobID?: string;
}

export class UpdateWebRequest extends TripGetRequest implements IUpdateWebRequest {
    /** Nome interno del viaggio */
    descrizione!: string;
    /** Note o meglio descrizione */
    note?: string | null;
    /** Titolo facoltativo da usare nei documenti */
    titolo?: string | null;
    nozze?: boolean;
    fatturaAlNetto?: boolean;

    constructor(data?: IUpdateWebRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            this.nozze = _data["nozze"] !== undefined ? _data["nozze"] : null as any;
            this.fatturaAlNetto = _data["fatturaAlNetto"] !== undefined ? _data["fatturaAlNetto"] : null as any;
        }
    }

    static override fromJS(data: any): UpdateWebRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWebRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        data["nozze"] = this.nozze !== undefined ? this.nozze : null as any;
        data["fatturaAlNetto"] = this.fatturaAlNetto !== undefined ? this.fatturaAlNetto : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateWebRequest extends ITripGetRequest {
    /** Nome interno del viaggio */
    descrizione: string;
    /** Note o meglio descrizione */
    note?: string | null;
    /** Titolo facoltativo da usare nei documenti */
    titolo?: string | null;
    nozze?: boolean;
    fatturaAlNetto?: boolean;
}

export class CreateTripRequest extends UpdateWebRequest implements ICreateTripRequest {
    viaggioDiNozze?: boolean;
    fatturazioneAlNetto?: boolean;
    tipoViaggio?: ETipoViaggio;
    operatoreID?: number;
    contattoAgenziaID?: number;
    utenteID?: number | null;
    partenza?: string;
    servizioID?: number | null;
    tipologiaID?: number | null;
    /** Se true la tipologia usa le descrizioni macro */
    usaTipologieMacro?: boolean;
    itinerario!: OffertaItinerario[];
    clienti!: ClienteDatoUpdate[];
    servizi?: DatiServizioAdd[] | null;
    /** Data from massive autofill, if any */
    autofillData?: StepService[] | null;
    /** Se presente è una singola camera da cache */
    cameraCache?: string | null;
    /** ID della tappa per la camera cache */
    tappaCameraCache?: number | null;
    /** Optional flight data */
    flightData?: TripCreateFlightData | null;

    constructor(data?: ICreateTripRequest) {
        super(data);
        if (!data) {
            this.itinerario = [];
            this.clienti = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.viaggioDiNozze = _data["viaggioDiNozze"] !== undefined ? _data["viaggioDiNozze"] : null as any;
            this.fatturazioneAlNetto = _data["fatturazioneAlNetto"] !== undefined ? _data["fatturazioneAlNetto"] : null as any;
            this.tipoViaggio = _data["tipoViaggio"] !== undefined ? _data["tipoViaggio"] : null as any;
            this.operatoreID = _data["operatoreID"] !== undefined ? _data["operatoreID"] : null as any;
            this.contattoAgenziaID = _data["contattoAgenziaID"] !== undefined ? _data["contattoAgenziaID"] : null as any;
            this.utenteID = _data["utenteID"] !== undefined ? _data["utenteID"] : null as any;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.tipologiaID = _data["tipologiaID"] !== undefined ? _data["tipologiaID"] : null as any;
            this.usaTipologieMacro = _data["usaTipologieMacro"] !== undefined ? _data["usaTipologieMacro"] : null as any;
            if (Array.isArray(_data["itinerario"])) {
                this.itinerario = [] as any;
                for (let item of _data["itinerario"])
                    this.itinerario!.push(OffertaItinerario.fromJS(item));
            }
            else {
                this.itinerario = null as any;
            }
            if (Array.isArray(_data["clienti"])) {
                this.clienti = [] as any;
                for (let item of _data["clienti"])
                    this.clienti!.push(ClienteDatoUpdate.fromJS(item));
            }
            else {
                this.clienti = null as any;
            }
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(DatiServizioAdd.fromJS(item));
            }
            else {
                this.servizi = null as any;
            }
            if (Array.isArray(_data["autofillData"])) {
                this.autofillData = [] as any;
                for (let item of _data["autofillData"])
                    this.autofillData!.push(StepService.fromJS(item));
            }
            else {
                this.autofillData = null as any;
            }
            this.cameraCache = _data["cameraCache"] !== undefined ? _data["cameraCache"] : null as any;
            this.tappaCameraCache = _data["tappaCameraCache"] !== undefined ? _data["tappaCameraCache"] : null as any;
            this.flightData = _data["flightData"] ? TripCreateFlightData.fromJS(_data["flightData"]) : null as any;
        }
    }

    static override fromJS(data: any): CreateTripRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTripRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["viaggioDiNozze"] = this.viaggioDiNozze !== undefined ? this.viaggioDiNozze : null as any;
        data["fatturazioneAlNetto"] = this.fatturazioneAlNetto !== undefined ? this.fatturazioneAlNetto : null as any;
        data["tipoViaggio"] = this.tipoViaggio !== undefined ? this.tipoViaggio : null as any;
        data["operatoreID"] = this.operatoreID !== undefined ? this.operatoreID : null as any;
        data["contattoAgenziaID"] = this.contattoAgenziaID !== undefined ? this.contattoAgenziaID : null as any;
        data["utenteID"] = this.utenteID !== undefined ? this.utenteID : null as any;
        data["partenza"] = this.partenza !== undefined ? this.partenza : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["tipologiaID"] = this.tipologiaID !== undefined ? this.tipologiaID : null as any;
        data["usaTipologieMacro"] = this.usaTipologieMacro !== undefined ? this.usaTipologieMacro : null as any;
        if (Array.isArray(this.itinerario)) {
            data["itinerario"] = [];
            for (let item of this.itinerario)
                data["itinerario"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.clienti)) {
            data["clienti"] = [];
            for (let item of this.clienti)
                data["clienti"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.autofillData)) {
            data["autofillData"] = [];
            for (let item of this.autofillData)
                data["autofillData"].push(item ? item.toJSON() : null as any);
        }
        data["cameraCache"] = this.cameraCache !== undefined ? this.cameraCache : null as any;
        data["tappaCameraCache"] = this.tappaCameraCache !== undefined ? this.tappaCameraCache : null as any;
        data["flightData"] = this.flightData ? this.flightData.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateTripRequest extends IUpdateWebRequest {
    viaggioDiNozze?: boolean;
    fatturazioneAlNetto?: boolean;
    tipoViaggio?: ETipoViaggio;
    operatoreID?: number;
    contattoAgenziaID?: number;
    utenteID?: number | null;
    partenza?: string;
    servizioID?: number | null;
    tipologiaID?: number | null;
    /** Se true la tipologia usa le descrizioni macro */
    usaTipologieMacro?: boolean;
    itinerario: OffertaItinerario[];
    clienti: ClienteDatoUpdate[];
    servizi?: DatiServizioAdd[] | null;
    /** Data from massive autofill, if any */
    autofillData?: StepService[] | null;
    /** Se presente è una singola camera da cache */
    cameraCache?: string | null;
    /** ID della tappa per la camera cache */
    tappaCameraCache?: number | null;
    /** Optional flight data */
    flightData?: TripCreateFlightData | null;
}

export class GetTripAutocompleteRequest extends CreateTripRequest implements IGetTripAutocompleteRequest {

    constructor(data?: IGetTripAutocompleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetTripAutocompleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripAutocompleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetTripAutocompleteRequest extends ICreateTripRequest {
}

export class DatiServizioAdd implements IDatiServizioAdd {
    jobID!: string;
    resultID!: string;
    serviceID!: number;
    typeID!: number;
    supplierID?: number;
    departureID?: number | null;
    optionID?: number | null;
    optionItemID?: number | null;
    clienteID?: number | null;
    tappaID?: number;
    supplementi?: DatiOpzioneAdd[] | null;
    paxIds?: number[] | null;
    nomeGruppoCustom?: string | null;
    usaHashcode?: boolean;

    constructor(data?: IDatiServizioAdd) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : null as any;
            this.resultID = _data["resultID"] !== undefined ? _data["resultID"] : null as any;
            this.serviceID = _data["serviceID"] !== undefined ? _data["serviceID"] : null as any;
            this.typeID = _data["typeID"] !== undefined ? _data["typeID"] : null as any;
            this.supplierID = _data["supplierID"] !== undefined ? _data["supplierID"] : null as any;
            this.departureID = _data["departureID"] !== undefined ? _data["departureID"] : null as any;
            this.optionID = _data["optionID"] !== undefined ? _data["optionID"] : null as any;
            this.optionItemID = _data["optionItemID"] !== undefined ? _data["optionItemID"] : null as any;
            this.clienteID = _data["clienteID"] !== undefined ? _data["clienteID"] : null as any;
            this.tappaID = _data["tappaID"] !== undefined ? _data["tappaID"] : null as any;
            if (Array.isArray(_data["supplementi"])) {
                this.supplementi = [] as any;
                for (let item of _data["supplementi"])
                    this.supplementi!.push(DatiOpzioneAdd.fromJS(item));
            }
            else {
                this.supplementi = null as any;
            }
            if (Array.isArray(_data["paxIds"])) {
                this.paxIds = [] as any;
                for (let item of _data["paxIds"])
                    this.paxIds!.push(item);
            }
            else {
                this.paxIds = null as any;
            }
            this.nomeGruppoCustom = _data["nomeGruppoCustom"] !== undefined ? _data["nomeGruppoCustom"] : null as any;
            this.usaHashcode = _data["usaHashcode"] !== undefined ? _data["usaHashcode"] : null as any;
        }
    }

    static fromJS(data: any): DatiServizioAdd {
        data = typeof data === 'object' ? data : {};
        let result = new DatiServizioAdd();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobID"] = this.jobID !== undefined ? this.jobID : null as any;
        data["resultID"] = this.resultID !== undefined ? this.resultID : null as any;
        data["serviceID"] = this.serviceID !== undefined ? this.serviceID : null as any;
        data["typeID"] = this.typeID !== undefined ? this.typeID : null as any;
        data["supplierID"] = this.supplierID !== undefined ? this.supplierID : null as any;
        data["departureID"] = this.departureID !== undefined ? this.departureID : null as any;
        data["optionID"] = this.optionID !== undefined ? this.optionID : null as any;
        data["optionItemID"] = this.optionItemID !== undefined ? this.optionItemID : null as any;
        data["clienteID"] = this.clienteID !== undefined ? this.clienteID : null as any;
        data["tappaID"] = this.tappaID !== undefined ? this.tappaID : null as any;
        if (Array.isArray(this.supplementi)) {
            data["supplementi"] = [];
            for (let item of this.supplementi)
                data["supplementi"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.paxIds)) {
            data["paxIds"] = [];
            for (let item of this.paxIds)
                data["paxIds"].push(item);
        }
        data["nomeGruppoCustom"] = this.nomeGruppoCustom !== undefined ? this.nomeGruppoCustom : null as any;
        data["usaHashcode"] = this.usaHashcode !== undefined ? this.usaHashcode : null as any;
        return data;
    }
}

export interface IDatiServizioAdd {
    jobID: string;
    resultID: string;
    serviceID: number;
    typeID: number;
    supplierID?: number;
    departureID?: number | null;
    optionID?: number | null;
    optionItemID?: number | null;
    clienteID?: number | null;
    tappaID?: number;
    supplementi?: DatiOpzioneAdd[] | null;
    paxIds?: number[] | null;
    nomeGruppoCustom?: string | null;
    usaHashcode?: boolean;
}

export class DatiOpzioneAdd implements IDatiOpzioneAdd {
    optionID?: number;
    optionItemID?: number;

    constructor(data?: IDatiOpzioneAdd) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.optionID = _data["optionID"] !== undefined ? _data["optionID"] : null as any;
            this.optionItemID = _data["optionItemID"] !== undefined ? _data["optionItemID"] : null as any;
        }
    }

    static fromJS(data: any): DatiOpzioneAdd {
        data = typeof data === 'object' ? data : {};
        let result = new DatiOpzioneAdd();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["optionID"] = this.optionID !== undefined ? this.optionID : null as any;
        data["optionItemID"] = this.optionItemID !== undefined ? this.optionItemID : null as any;
        return data;
    }
}

export interface IDatiOpzioneAdd {
    optionID?: number;
    optionItemID?: number;
}

export class StepService implements IStepService {
    stepID?: number;
    data!: string;

    constructor(data?: IStepService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stepID = _data["stepID"] !== undefined ? _data["stepID"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
        }
    }

    static fromJS(data: any): StepService {
        data = typeof data === 'object' ? data : {};
        let result = new StepService();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stepID"] = this.stepID !== undefined ? this.stepID : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        return data;
    }
}

export interface IStepService {
    stepID?: number;
    data: string;
}

export class TripCreateFlightData implements ITripCreateFlightData {
    jupiterInput?: string | null;
    singleFlightAvailResult?: string | null;

    constructor(data?: ITripCreateFlightData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jupiterInput = _data["jupiterInput"] !== undefined ? _data["jupiterInput"] : null as any;
            this.singleFlightAvailResult = _data["singleFlightAvailResult"] !== undefined ? _data["singleFlightAvailResult"] : null as any;
        }
    }

    static fromJS(data: any): TripCreateFlightData {
        data = typeof data === 'object' ? data : {};
        let result = new TripCreateFlightData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jupiterInput"] = this.jupiterInput !== undefined ? this.jupiterInput : null as any;
        data["singleFlightAvailResult"] = this.singleFlightAvailResult !== undefined ? this.singleFlightAvailResult : null as any;
        return data;
    }
}

export interface ITripCreateFlightData {
    jupiterInput?: string | null;
    singleFlightAvailResult?: string | null;
}

export class GetTripAutocompleteDataResponse extends OkApiResponse implements IGetTripAutocompleteDataResponse {
    fillStatus?: PackageFillStatus;
    status?: TaskStatus;
    autofillStatus?: AutofillStatus | null;
    completionPercentage?: number;
    steps?: TripAutocompleteStep[];
    flights?: PackageFlight[];

    constructor(data?: IGetTripAutocompleteDataResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fillStatus = _data["fillStatus"] !== undefined ? _data["fillStatus"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.autofillStatus = _data["autofillStatus"] ? AutofillStatus.fromJS(_data["autofillStatus"]) : null as any;
            this.completionPercentage = _data["completionPercentage"] !== undefined ? _data["completionPercentage"] : null as any;
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(TripAutocompleteStep.fromJS(item));
            }
            else {
                this.steps = null as any;
            }
            if (Array.isArray(_data["flights"])) {
                this.flights = [] as any;
                for (let item of _data["flights"])
                    this.flights!.push(PackageFlight.fromJS(item));
            }
            else {
                this.flights = null as any;
            }
        }
    }

    static override fromJS(data: any): GetTripAutocompleteDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripAutocompleteDataResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fillStatus"] = this.fillStatus !== undefined ? this.fillStatus : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["autofillStatus"] = this.autofillStatus ? this.autofillStatus.toJSON() : null as any;
        data["completionPercentage"] = this.completionPercentage !== undefined ? this.completionPercentage : null as any;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.flights)) {
            data["flights"] = [];
            for (let item of this.flights)
                data["flights"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetTripAutocompleteDataResponse extends IOkApiResponse {
    fillStatus?: PackageFillStatus;
    status?: TaskStatus;
    autofillStatus?: AutofillStatus | null;
    completionPercentage?: number;
    steps?: TripAutocompleteStep[];
    flights?: PackageFlight[];
}

/** UI related status */
export enum PackageFillStatus {
    Setup = "Setup",
    Running = "Running",
    Enhancement = "Enhancement",
    Done = "Done",
    Error = "Error",
}

export enum TaskStatus {
    Pronto = "Pronto",
    InCorso = "InCorso",
    Terminato = "Terminato",
    Errore = "Errore",
    Sospeso = "Sospeso",
    Annullato = "Annullato",
}

export class TripBatchStatus implements ITripBatchStatus {
    status?: EBatchStatus;
    batchType?: EBatchType;
    lingua?: ELingua;
    offertaID?: number;
    rigaID?: number | null;
    total?: number;
    current?: number;
    errorCode?: string | null;
    errorMessage?: string | null;
    errorValues?: { [key: string]: string; } | null;

    constructor(data?: ITripBatchStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.batchType = _data["batchType"] !== undefined ? _data["batchType"] : null as any;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : null as any;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.rigaID = _data["rigaID"] !== undefined ? _data["rigaID"] : null as any;
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
            this.current = _data["current"] !== undefined ? _data["current"] : null as any;
            this.errorCode = _data["errorCode"] !== undefined ? _data["errorCode"] : null as any;
            this.errorMessage = _data["errorMessage"] !== undefined ? _data["errorMessage"] : null as any;
            if (_data["errorValues"]) {
                this.errorValues = {} as any;
                for (let key in _data["errorValues"]) {
                    if (_data["errorValues"].hasOwnProperty(key))
                        (this.errorValues as any)![key] = _data["errorValues"][key] !== undefined ? _data["errorValues"][key] : null as any;
                }
            }
            else {
                this.errorValues = null as any;
            }
        }
    }

    static fromJS(data: any): TripBatchStatus {
        data = typeof data === 'object' ? data : {};
        let result = new TripBatchStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["batchType"] = this.batchType !== undefined ? this.batchType : null as any;
        data["lingua"] = this.lingua !== undefined ? this.lingua : null as any;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["rigaID"] = this.rigaID !== undefined ? this.rigaID : null as any;
        data["total"] = this.total !== undefined ? this.total : null as any;
        data["current"] = this.current !== undefined ? this.current : null as any;
        data["errorCode"] = this.errorCode !== undefined ? this.errorCode : null as any;
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : null as any;
        if (this.errorValues) {
            data["errorValues"] = {};
            for (let key in this.errorValues) {
                if (this.errorValues.hasOwnProperty(key))
                    (data["errorValues"] as any)[key] = this.errorValues[key] !== undefined ? this.errorValues[key] : null as any;
            }
        }
        return data;
    }
}

export interface ITripBatchStatus {
    status?: EBatchStatus;
    batchType?: EBatchType;
    lingua?: ELingua;
    offertaID?: number;
    rigaID?: number | null;
    total?: number;
    current?: number;
    errorCode?: string | null;
    errorMessage?: string | null;
    errorValues?: { [key: string]: string; } | null;
}

export class AutofillStatus extends TripBatchStatus implements IAutofillStatus {
    exists?: boolean;
    done?: boolean;
    startedAt?: string;
    tasks?: AutofillTask[];

    constructor(data?: IAutofillStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.exists = _data["exists"] !== undefined ? _data["exists"] : null as any;
            this.done = _data["done"] !== undefined ? _data["done"] : null as any;
            this.startedAt = _data["startedAt"] !== undefined ? _data["startedAt"] : null as any;
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(AutofillTask.fromJS(item));
            }
            else {
                this.tasks = null as any;
            }
        }
    }

    static override fromJS(data: any): AutofillStatus {
        data = typeof data === 'object' ? data : {};
        let result = new AutofillStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exists"] = this.exists !== undefined ? this.exists : null as any;
        data["done"] = this.done !== undefined ? this.done : null as any;
        data["startedAt"] = this.startedAt !== undefined ? this.startedAt : null as any;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAutofillStatus extends ITripBatchStatus {
    exists?: boolean;
    done?: boolean;
    startedAt?: string;
    tasks?: AutofillTask[];
}

export class AutofillTask implements IAutofillTask {
    tappaID?: number;
    luogoID?: number | null;
    luogo?: string | null;
    dal?: string | null;
    al?: string | null;
    tipoServizio?: ETipoServizio;
    nomeServizio?: string;
    status?: EAutofillTaskStatus;
    warnings?: AutofillTaskWarning[];
    errors?: string[];
    advancedSearchOnly?: boolean;
    foundResults?: number;

    constructor(data?: IAutofillTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tappaID = _data["tappaID"] !== undefined ? _data["tappaID"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.al = _data["al"] !== undefined ? _data["al"] : null as any;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
            this.nomeServizio = _data["nomeServizio"] !== undefined ? _data["nomeServizio"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(AutofillTaskWarning.fromJS(item));
            }
            else {
                this.warnings = null as any;
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            else {
                this.errors = null as any;
            }
            this.advancedSearchOnly = _data["advancedSearchOnly"] !== undefined ? _data["advancedSearchOnly"] : null as any;
            this.foundResults = _data["foundResults"] !== undefined ? _data["foundResults"] : null as any;
        }
    }

    static fromJS(data: any): AutofillTask {
        data = typeof data === 'object' ? data : {};
        let result = new AutofillTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tappaID"] = this.tappaID !== undefined ? this.tappaID : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["al"] = this.al !== undefined ? this.al : null as any;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        data["nomeServizio"] = this.nomeServizio !== undefined ? this.nomeServizio : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["advancedSearchOnly"] = this.advancedSearchOnly !== undefined ? this.advancedSearchOnly : null as any;
        data["foundResults"] = this.foundResults !== undefined ? this.foundResults : null as any;
        return data;
    }
}

export interface IAutofillTask {
    tappaID?: number;
    luogoID?: number | null;
    luogo?: string | null;
    dal?: string | null;
    al?: string | null;
    tipoServizio?: ETipoServizio;
    nomeServizio?: string;
    status?: EAutofillTaskStatus;
    warnings?: AutofillTaskWarning[];
    errors?: string[];
    advancedSearchOnly?: boolean;
    foundResults?: number;
}

export enum EAutofillTaskStatus {
    Queued = "Queued",
    Ready = "Ready",
    Running = "Running",
    Ok = "Ok",
    Warning = "Warning",
    Error = "Error",
}

export class AutofillTaskWarning implements IAutofillTaskWarning {
    gruppoID?: number;
    gruppo?: string | null;
    tipo?: EAutofillWarningType;
    luogoID?: number | null;
    luogo?: string | null;
    dal?: string | null;
    al?: string | null;
    servizioID?: number | null;
    servizio?: string | null;
    servizioUrl?: string | null;
    rigaID?: number | null;

    constructor(data?: IAutofillTaskWarning) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gruppoID = _data["gruppoID"] !== undefined ? _data["gruppoID"] : null as any;
            this.gruppo = _data["gruppo"] !== undefined ? _data["gruppo"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.al = _data["al"] !== undefined ? _data["al"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : null as any;
            this.servizioUrl = _data["servizioUrl"] !== undefined ? _data["servizioUrl"] : null as any;
            this.rigaID = _data["rigaID"] !== undefined ? _data["rigaID"] : null as any;
        }
    }

    static fromJS(data: any): AutofillTaskWarning {
        data = typeof data === 'object' ? data : {};
        let result = new AutofillTaskWarning();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gruppoID"] = this.gruppoID !== undefined ? this.gruppoID : null as any;
        data["gruppo"] = this.gruppo !== undefined ? this.gruppo : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["al"] = this.al !== undefined ? this.al : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["servizio"] = this.servizio !== undefined ? this.servizio : null as any;
        data["servizioUrl"] = this.servizioUrl !== undefined ? this.servizioUrl : null as any;
        data["rigaID"] = this.rigaID !== undefined ? this.rigaID : null as any;
        return data;
    }
}

export interface IAutofillTaskWarning {
    gruppoID?: number;
    gruppo?: string | null;
    tipo?: EAutofillWarningType;
    luogoID?: number | null;
    luogo?: string | null;
    dal?: string | null;
    al?: string | null;
    servizioID?: number | null;
    servizio?: string | null;
    servizioUrl?: string | null;
    rigaID?: number | null;
}

export enum EAutofillWarningType {
    VoliNonTrovati = "VoliNonTrovati",
    TappeModificatePerInserimentoVoli = "TappeModificatePerInserimentoVoli",
    HotelNonTrovato = "HotelNonTrovato",
    HotelNonCorrispondenteAiCriteri = "HotelNonCorrispondenteAiCriteri",
    TrasferimentoNonTrovato = "TrasferimentoNonTrovato",
}

export enum EBatchStatus {
    Missing = "Missing",
    Running = "Running",
    Done = "Done",
    Error = "Error",
}

export enum EBatchType {
    VerificaPrezzi = "VerificaPrezzi",
    Autofill = "Autofill",
}

export class TripAutocompleteStep implements ITripAutocompleteStep {
    stepId?: number;
    stepName?: string;
    /** Hotels */
    availableServices?: TripAutocompleteStepService[];
    /** Transfers, visits and so on */
    extras?: TripAutocompleteStepService[] | null;

    constructor(data?: ITripAutocompleteStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stepId = _data["stepId"] !== undefined ? _data["stepId"] : null as any;
            this.stepName = _data["stepName"] !== undefined ? _data["stepName"] : null as any;
            if (Array.isArray(_data["availableServices"])) {
                this.availableServices = [] as any;
                for (let item of _data["availableServices"])
                    this.availableServices!.push(TripAutocompleteStepService.fromJS(item));
            }
            else {
                this.availableServices = null as any;
            }
            if (Array.isArray(_data["extras"])) {
                this.extras = [] as any;
                for (let item of _data["extras"])
                    this.extras!.push(TripAutocompleteStepService.fromJS(item));
            }
            else {
                this.extras = null as any;
            }
        }
    }

    static fromJS(data: any): TripAutocompleteStep {
        data = typeof data === 'object' ? data : {};
        let result = new TripAutocompleteStep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stepId"] = this.stepId !== undefined ? this.stepId : null as any;
        data["stepName"] = this.stepName !== undefined ? this.stepName : null as any;
        if (Array.isArray(this.availableServices)) {
            data["availableServices"] = [];
            for (let item of this.availableServices)
                data["availableServices"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.extras)) {
            data["extras"] = [];
            for (let item of this.extras)
                data["extras"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ITripAutocompleteStep {
    stepId?: number;
    stepName?: string;
    /** Hotels */
    availableServices?: TripAutocompleteStepService[];
    /** Transfers, visits and so on */
    extras?: TripAutocompleteStepService[] | null;
}

export class TripAutocompleteStepService implements ITripAutocompleteStepService {
    serviceId?: number;
    name?: string;
    coverUrl?: string;
    stelle?: number | null;
    address?: string | null;
    category?: string | null;
    position?: string | null;
    urlPart?: string;
    isExternal?: boolean;
    types?: PackageServiceType[];
    categoryIDs?: number[];

    constructor(data?: ITripAutocompleteStepService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.coverUrl = _data["coverUrl"] !== undefined ? _data["coverUrl"] : null as any;
            this.stelle = _data["stelle"] !== undefined ? _data["stelle"] : null as any;
            this.address = _data["address"] !== undefined ? _data["address"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.position = _data["position"] !== undefined ? _data["position"] : null as any;
            this.urlPart = _data["urlPart"] !== undefined ? _data["urlPart"] : null as any;
            this.isExternal = _data["isExternal"] !== undefined ? _data["isExternal"] : null as any;
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(PackageServiceType.fromJS(item));
            }
            else {
                this.types = null as any;
            }
            if (Array.isArray(_data["categoryIDs"])) {
                this.categoryIDs = [] as any;
                for (let item of _data["categoryIDs"])
                    this.categoryIDs!.push(item);
            }
            else {
                this.categoryIDs = null as any;
            }
        }
    }

    static fromJS(data: any): TripAutocompleteStepService {
        data = typeof data === 'object' ? data : {};
        let result = new TripAutocompleteStepService();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["coverUrl"] = this.coverUrl !== undefined ? this.coverUrl : null as any;
        data["stelle"] = this.stelle !== undefined ? this.stelle : null as any;
        data["address"] = this.address !== undefined ? this.address : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["position"] = this.position !== undefined ? this.position : null as any;
        data["urlPart"] = this.urlPart !== undefined ? this.urlPart : null as any;
        data["isExternal"] = this.isExternal !== undefined ? this.isExternal : null as any;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.categoryIDs)) {
            data["categoryIDs"] = [];
            for (let item of this.categoryIDs)
                data["categoryIDs"].push(item);
        }
        return data;
    }
}

export interface ITripAutocompleteStepService {
    serviceId?: number;
    name?: string;
    coverUrl?: string;
    stelle?: number | null;
    address?: string | null;
    category?: string | null;
    position?: string | null;
    urlPart?: string;
    isExternal?: boolean;
    types?: PackageServiceType[];
    categoryIDs?: number[];
}

export class PackageServiceType implements IPackageServiceType {
    description?: string;
    price?: number;
    serviceData?: string[] | null;
    nrf?: boolean;
    ip?: boolean;
    stepID?: number;

    constructor(data?: IPackageServiceType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.price = _data["price"] !== undefined ? _data["price"] : null as any;
            if (Array.isArray(_data["serviceData"])) {
                this.serviceData = [] as any;
                for (let item of _data["serviceData"])
                    this.serviceData!.push(item);
            }
            else {
                this.serviceData = null as any;
            }
            this.nrf = _data["nrf"] !== undefined ? _data["nrf"] : null as any;
            this.ip = _data["ip"] !== undefined ? _data["ip"] : null as any;
            this.stepID = _data["stepID"] !== undefined ? _data["stepID"] : null as any;
        }
    }

    static fromJS(data: any): PackageServiceType {
        data = typeof data === 'object' ? data : {};
        let result = new PackageServiceType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["price"] = this.price !== undefined ? this.price : null as any;
        if (Array.isArray(this.serviceData)) {
            data["serviceData"] = [];
            for (let item of this.serviceData)
                data["serviceData"].push(item);
        }
        data["nrf"] = this.nrf !== undefined ? this.nrf : null as any;
        data["ip"] = this.ip !== undefined ? this.ip : null as any;
        data["stepID"] = this.stepID !== undefined ? this.stepID : null as any;
        return data;
    }
}

export interface IPackageServiceType {
    description?: string;
    price?: number;
    serviceData?: string[] | null;
    nrf?: boolean;
    ip?: boolean;
    stepID?: number;
}

export class PackageFlight implements IPackageFlight {
    solutionKind?: EFlightSolutionKind;
    segments?: TripFlightSegment[];
    price?: number;
    availabilityInput?: JupiterFlightAvailabilityInput;
    selectedResult?: SingleFlightAvailResult;
    totalDuration?: string;

    constructor(data?: IPackageFlight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.solutionKind = _data["solutionKind"] !== undefined ? _data["solutionKind"] : null as any;
            if (Array.isArray(_data["segments"])) {
                this.segments = [] as any;
                for (let item of _data["segments"])
                    this.segments!.push(TripFlightSegment.fromJS(item));
            }
            else {
                this.segments = null as any;
            }
            this.price = _data["price"] !== undefined ? _data["price"] : null as any;
            this.availabilityInput = _data["availabilityInput"] ? JupiterFlightAvailabilityInput.fromJS(_data["availabilityInput"]) : null as any;
            this.selectedResult = _data["selectedResult"] ? SingleFlightAvailResult.fromJS(_data["selectedResult"]) : null as any;
            this.totalDuration = _data["totalDuration"] !== undefined ? _data["totalDuration"] : null as any;
        }
    }

    static fromJS(data: any): PackageFlight {
        data = typeof data === 'object' ? data : {};
        let result = new PackageFlight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["solutionKind"] = this.solutionKind !== undefined ? this.solutionKind : null as any;
        if (Array.isArray(this.segments)) {
            data["segments"] = [];
            for (let item of this.segments)
                data["segments"].push(item ? item.toJSON() : null as any);
        }
        data["price"] = this.price !== undefined ? this.price : null as any;
        data["availabilityInput"] = this.availabilityInput ? this.availabilityInput.toJSON() : null as any;
        data["selectedResult"] = this.selectedResult ? this.selectedResult.toJSON() : null as any;
        data["totalDuration"] = this.totalDuration !== undefined ? this.totalDuration : null as any;
        return data;
    }
}

export interface IPackageFlight {
    solutionKind?: EFlightSolutionKind;
    segments?: TripFlightSegment[];
    price?: number;
    availabilityInput?: JupiterFlightAvailabilityInput;
    selectedResult?: SingleFlightAvailResult;
    totalDuration?: string;
}

export enum EFlightSolutionKind {
    Fastest = "Fastest",
    Cheapest = "Cheapest",
    Best = "Best",
}

export class GetTripAutocompleteDataRequest extends TripGetRequest implements IGetTripAutocompleteDataRequest {
    jobId?: string;

    constructor(data?: IGetTripAutocompleteDataRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : null as any;
        }
    }

    static override fromJS(data: any): GetTripAutocompleteDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripAutocompleteDataRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId !== undefined ? this.jobId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTripAutocompleteDataRequest extends ITripGetRequest {
    jobId?: string;
}

export class StartPriceSearchResponse extends OkApiResponse implements IStartPriceSearchResponse {
    startSearchResult?: EStartSearchResult;
    jobID?: string | null;
    searchKey?: string | null;
    gruppi?: DisponibilitaGruppo[] | null;
    dati?: RicercaDati | null;
    idsByPrice?: string[] | null;

    constructor(data?: IStartPriceSearchResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.startSearchResult = _data["startSearchResult"] !== undefined ? _data["startSearchResult"] : null as any;
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : null as any;
            this.searchKey = _data["searchKey"] !== undefined ? _data["searchKey"] : null as any;
            if (Array.isArray(_data["gruppi"])) {
                this.gruppi = [] as any;
                for (let item of _data["gruppi"])
                    this.gruppi!.push(DisponibilitaGruppo.fromJS(item));
            }
            else {
                this.gruppi = null as any;
            }
            this.dati = _data["dati"] ? RicercaDati.fromJS(_data["dati"]) : null as any;
            if (Array.isArray(_data["idsByPrice"])) {
                this.idsByPrice = [] as any;
                for (let item of _data["idsByPrice"])
                    this.idsByPrice!.push(item);
            }
            else {
                this.idsByPrice = null as any;
            }
        }
    }

    static override fromJS(data: any): StartPriceSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StartPriceSearchResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startSearchResult"] = this.startSearchResult !== undefined ? this.startSearchResult : null as any;
        data["jobID"] = this.jobID !== undefined ? this.jobID : null as any;
        data["searchKey"] = this.searchKey !== undefined ? this.searchKey : null as any;
        if (Array.isArray(this.gruppi)) {
            data["gruppi"] = [];
            for (let item of this.gruppi)
                data["gruppi"].push(item ? item.toJSON() : null as any);
        }
        data["dati"] = this.dati ? this.dati.toJSON() : null as any;
        if (Array.isArray(this.idsByPrice)) {
            data["idsByPrice"] = [];
            for (let item of this.idsByPrice)
                data["idsByPrice"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IStartPriceSearchResponse extends IOkApiResponse {
    startSearchResult?: EStartSearchResult;
    jobID?: string | null;
    searchKey?: string | null;
    gruppi?: DisponibilitaGruppo[] | null;
    dati?: RicercaDati | null;
    idsByPrice?: string[] | null;
}

export enum EStartSearchResult {
    Ok = "Ok",
    Error = "Error",
    Busy = "Busy",
}

export class PricingGetRequest extends ApiRequest implements IPricingGetRequest {
    /** L'ID del pricing */
    id?: number;

    constructor(data?: IPricingGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): PricingGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PricingGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPricingGetRequest extends IApiRequest {
    /** L'ID del pricing */
    id?: number;
}

export class PricingDeleteRequest extends PricingGetRequest implements IPricingDeleteRequest {

    constructor(data?: IPricingDeleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PricingDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PricingDeleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPricingDeleteRequest extends IPricingGetRequest {
}

export class PricingGetResponse extends OkApiResponse implements IPricingGetResponse {
    pricing?: Pricing;

    constructor(data?: IPricingGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pricing = _data["pricing"] ? Pricing.fromJS(_data["pricing"]) : null as any;
        }
    }

    static override fromJS(data: any): PricingGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PricingGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pricing"] = this.pricing ? this.pricing.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPricingGetResponse extends IOkApiResponse {
    pricing?: Pricing;
}

export class NrTableResponseOfPricingRow extends OkApiResponse implements INrTableResponseOfPricingRow {
    /** Array delle righe della pagina richiesta */
    rows?: PricingRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfPricingRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(PricingRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfPricingRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfPricingRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfPricingRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: PricingRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class PricingRow implements IPricingRow {
    id?: number;
    nome?: string | null;
    operatore?: EOperatore | null;
    rulesCount?: number;

    constructor(data?: IPricingRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.rulesCount = _data["rulesCount"] !== undefined ? _data["rulesCount"] : null as any;
        }
    }

    static fromJS(data: any): PricingRow {
        data = typeof data === 'object' ? data : {};
        let result = new PricingRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["rulesCount"] = this.rulesCount !== undefined ? this.rulesCount : null as any;
        return data;
    }
}

export interface IPricingRow {
    id?: number;
    nome?: string | null;
    operatore?: EOperatore | null;
    rulesCount?: number;
}

export class PricingListRequest extends NrTableRequest implements IPricingListRequest {
    term?: string | null;
    operatore?: EOperatore | null;

    constructor(data?: IPricingListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
        }
    }

    static override fromJS(data: any): PricingListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PricingListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPricingListRequest extends INrTableRequest {
    term?: string | null;
    operatore?: EOperatore | null;
}

export class PricingRulesListRequest extends PricingGetRequest implements IPricingRulesListRequest {

    constructor(data?: IPricingRulesListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PricingRulesListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PricingRulesListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPricingRulesListRequest extends IPricingGetRequest {
}

export class PricingRulesDeleteRequest extends PricingRulesListRequest implements IPricingRulesDeleteRequest {
    ruleID?: number;

    constructor(data?: IPricingRulesDeleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ruleID = _data["ruleID"] !== undefined ? _data["ruleID"] : null as any;
        }
    }

    static override fromJS(data: any): PricingRulesDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PricingRulesDeleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ruleID"] = this.ruleID !== undefined ? this.ruleID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPricingRulesDeleteRequest extends IPricingRulesListRequest {
    ruleID?: number;
}

export class PricingRulesListResponse extends OkApiResponse implements IPricingRulesListResponse {
    rules?: PricingRule[];

    constructor(data?: IPricingRulesListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(PricingRule.fromJS(item));
            }
            else {
                this.rules = null as any;
            }
        }
    }

    static override fromJS(data: any): PricingRulesListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PricingRulesListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPricingRulesListResponse extends IOkApiResponse {
    rules?: PricingRule[];
}

export class PricingRulesUpsertRequest extends PricingRulesListRequest implements IPricingRulesUpsertRequest {
    rule?: PricingRule;

    constructor(data?: IPricingRulesUpsertRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rule = _data["rule"] ? PricingRule.fromJS(_data["rule"]) : null as any;
        }
    }

    static override fromJS(data: any): PricingRulesUpsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PricingRulesUpsertRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rule"] = this.rule ? this.rule.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPricingRulesUpsertRequest extends IPricingRulesListRequest {
    rule?: PricingRule;
}

export class PricingUpsertRequest extends ApiRequest implements IPricingUpsertRequest {
    id?: number;
    nome?: string;
    eOperatore?: EOperatore;

    constructor(data?: IPricingUpsertRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.eOperatore = _data["eOperatore"] !== undefined ? _data["eOperatore"] : null as any;
        }
    }

    static override fromJS(data: any): PricingUpsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PricingUpsertRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["eOperatore"] = this.eOperatore !== undefined ? this.eOperatore : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPricingUpsertRequest extends IApiRequest {
    id?: number;
    nome?: string;
    eOperatore?: EOperatore;
}

export class NrTableResponseOfAdvancePaymentsReportRow extends OkApiResponse implements INrTableResponseOfAdvancePaymentsReportRow {
    /** Array delle righe della pagina richiesta */
    rows?: AdvancePaymentsReportRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfAdvancePaymentsReportRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AdvancePaymentsReportRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfAdvancePaymentsReportRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfAdvancePaymentsReportRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfAdvancePaymentsReportRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: AdvancePaymentsReportRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class GetAdvancePaymentsReportResponse extends NrTableResponseOfAdvancePaymentsReportRow implements IGetAdvancePaymentsReportResponse {

    constructor(data?: IGetAdvancePaymentsReportResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetAdvancePaymentsReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdvancePaymentsReportResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetAdvancePaymentsReportResponse extends INrTableResponseOfAdvancePaymentsReportRow {
}

export class AdvancePaymentsReportRow implements IAdvancePaymentsReportRow {
    /** ID dell'offerta di riferimento */
    offertaID?: number;
    /** ID della riga di riferimento */
    rigaID?: number;
    /** Data di effettuazione del servizio */
    dataServizio?: string;
    /** Descrizione (come da offerta) */
    descrizione?: string;
    /** ID dell'accordo */
    accordoID?: number;
    /** Nome dell'accordo */
    accordo?: string;
    /** ID del contatto dell'accordo */
    contattoID?: number;
    /** Nome del contatto dell'accordo */
    contatto?: string;
    /** Importo da versare */
    importo?: number;
    /** Codice della valuta */
    codiceValuta?: string;
    /** Data del pagamento (se presente) */
    data?: string | null;

    constructor(data?: IAdvancePaymentsReportRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.rigaID = _data["rigaID"] !== undefined ? _data["rigaID"] : null as any;
            this.dataServizio = _data["dataServizio"] !== undefined ? _data["dataServizio"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.accordo = _data["accordo"] !== undefined ? _data["accordo"] : null as any;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.contatto = _data["contatto"] !== undefined ? _data["contatto"] : null as any;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : null as any;
            this.codiceValuta = _data["codiceValuta"] !== undefined ? _data["codiceValuta"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
        }
    }

    static fromJS(data: any): AdvancePaymentsReportRow {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancePaymentsReportRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["rigaID"] = this.rigaID !== undefined ? this.rigaID : null as any;
        data["dataServizio"] = this.dataServizio !== undefined ? this.dataServizio : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["accordo"] = this.accordo !== undefined ? this.accordo : null as any;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["contatto"] = this.contatto !== undefined ? this.contatto : null as any;
        data["importo"] = this.importo !== undefined ? this.importo : null as any;
        data["codiceValuta"] = this.codiceValuta !== undefined ? this.codiceValuta : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        return data;
    }
}

export interface IAdvancePaymentsReportRow {
    /** ID dell'offerta di riferimento */
    offertaID?: number;
    /** ID della riga di riferimento */
    rigaID?: number;
    /** Data di effettuazione del servizio */
    dataServizio?: string;
    /** Descrizione (come da offerta) */
    descrizione?: string;
    /** ID dell'accordo */
    accordoID?: number;
    /** Nome dell'accordo */
    accordo?: string;
    /** ID del contatto dell'accordo */
    contattoID?: number;
    /** Nome del contatto dell'accordo */
    contatto?: string;
    /** Importo da versare */
    importo?: number;
    /** Codice della valuta */
    codiceValuta?: string;
    /** Data del pagamento (se presente) */
    data?: string | null;
}

export class GetAdvancePaymentsReportRequest extends NrTableRequest implements IGetAdvancePaymentsReportRequest {
    /** Filtro su singola offerta */
    offertaID?: number | null;
    /** Filtro sull'ID dell'accordo */
    accordoID?: number | null;
    /** Filtro sull'ID del contatto dell'accordo */
    contattoID?: number | null;
    /** Filtro data partenza "dal" */
    partenzaDal?: string | null;
    /** Filtro data partenza "al" */
    partenzaAl?: string | null;
    /** Filtro da pagare "dal" */
    daPagareDal?: string | null;
    /** Filtro da pagare "al" */
    daPagareAl?: string | null;

    constructor(data?: IGetAdvancePaymentsReportRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : null as any;
            this.partenzaDal = _data["partenzaDal"] !== undefined ? _data["partenzaDal"] : null as any;
            this.partenzaAl = _data["partenzaAl"] !== undefined ? _data["partenzaAl"] : null as any;
            this.daPagareDal = _data["daPagareDal"] !== undefined ? _data["daPagareDal"] : null as any;
            this.daPagareAl = _data["daPagareAl"] !== undefined ? _data["daPagareAl"] : null as any;
        }
    }

    static override fromJS(data: any): GetAdvancePaymentsReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdvancePaymentsReportRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : null as any;
        data["partenzaDal"] = this.partenzaDal !== undefined ? this.partenzaDal : null as any;
        data["partenzaAl"] = this.partenzaAl !== undefined ? this.partenzaAl : null as any;
        data["daPagareDal"] = this.daPagareDal !== undefined ? this.daPagareDal : null as any;
        data["daPagareAl"] = this.daPagareAl !== undefined ? this.daPagareAl : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetAdvancePaymentsReportRequest extends INrTableRequest {
    /** Filtro su singola offerta */
    offertaID?: number | null;
    /** Filtro sull'ID dell'accordo */
    accordoID?: number | null;
    /** Filtro sull'ID del contatto dell'accordo */
    contattoID?: number | null;
    /** Filtro data partenza "dal" */
    partenzaDal?: string | null;
    /** Filtro data partenza "al" */
    partenzaAl?: string | null;
    /** Filtro da pagare "dal" */
    daPagareDal?: string | null;
    /** Filtro da pagare "al" */
    daPagareAl?: string | null;
}

export class OfferteIncompleteReportResponse extends OkApiResponse implements IOfferteIncompleteReportResponse {
    offerteIncomplete?: OfferteIncompleteReportRow[];

    constructor(data?: IOfferteIncompleteReportResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["offerteIncomplete"])) {
                this.offerteIncomplete = [] as any;
                for (let item of _data["offerteIncomplete"])
                    this.offerteIncomplete!.push(OfferteIncompleteReportRow.fromJS(item));
            }
            else {
                this.offerteIncomplete = null as any;
            }
        }
    }

    static override fromJS(data: any): OfferteIncompleteReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OfferteIncompleteReportResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.offerteIncomplete)) {
            data["offerteIncomplete"] = [];
            for (let item of this.offerteIncomplete)
                data["offerteIncomplete"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IOfferteIncompleteReportResponse extends IOkApiResponse {
    offerteIncomplete?: OfferteIncompleteReportRow[];
}

export abstract class OfferteIncompleteReportRowBase implements IOfferteIncompleteReportRowBase {
    offertaID?: number;
    partenza?: string;
    agenziaID?: number | null;
    agenzia?: string | null;
    utente?: string | null;
    emailUtente?: string | null;
    utentePreventivo?: string | null;
    emailUtentePreventivo?: string | null;
    utenteConferma?: string | null;
    emailUtenteConferma?: string | null;

    constructor(data?: IOfferteIncompleteReportRowBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : null as any;
            this.agenziaID = _data["agenziaID"] !== undefined ? _data["agenziaID"] : null as any;
            this.agenzia = _data["agenzia"] !== undefined ? _data["agenzia"] : null as any;
            this.utente = _data["utente"] !== undefined ? _data["utente"] : null as any;
            this.emailUtente = _data["emailUtente"] !== undefined ? _data["emailUtente"] : null as any;
            this.utentePreventivo = _data["utentePreventivo"] !== undefined ? _data["utentePreventivo"] : null as any;
            this.emailUtentePreventivo = _data["emailUtentePreventivo"] !== undefined ? _data["emailUtentePreventivo"] : null as any;
            this.utenteConferma = _data["utenteConferma"] !== undefined ? _data["utenteConferma"] : null as any;
            this.emailUtenteConferma = _data["emailUtenteConferma"] !== undefined ? _data["emailUtenteConferma"] : null as any;
        }
    }

    static fromJS(data: any): OfferteIncompleteReportRowBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'OfferteIncompleteReportRowBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["partenza"] = this.partenza !== undefined ? this.partenza : null as any;
        data["agenziaID"] = this.agenziaID !== undefined ? this.agenziaID : null as any;
        data["agenzia"] = this.agenzia !== undefined ? this.agenzia : null as any;
        data["utente"] = this.utente !== undefined ? this.utente : null as any;
        data["emailUtente"] = this.emailUtente !== undefined ? this.emailUtente : null as any;
        data["utentePreventivo"] = this.utentePreventivo !== undefined ? this.utentePreventivo : null as any;
        data["emailUtentePreventivo"] = this.emailUtentePreventivo !== undefined ? this.emailUtentePreventivo : null as any;
        data["utenteConferma"] = this.utenteConferma !== undefined ? this.utenteConferma : null as any;
        data["emailUtenteConferma"] = this.emailUtenteConferma !== undefined ? this.emailUtenteConferma : null as any;
        return data;
    }
}

export interface IOfferteIncompleteReportRowBase {
    offertaID?: number;
    partenza?: string;
    agenziaID?: number | null;
    agenzia?: string | null;
    utente?: string | null;
    emailUtente?: string | null;
    utentePreventivo?: string | null;
    emailUtentePreventivo?: string | null;
    utenteConferma?: string | null;
    emailUtenteConferma?: string | null;
}

export class OfferteIncompleteReportRow extends OfferteIncompleteReportRowBase implements IOfferteIncompleteReportRow {
    datiMancantiOfferta?: EDatoClienteMancante[];
    datiMancantiClienti?: ClienteDatiMancanti[];

    constructor(data?: IOfferteIncompleteReportRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datiMancantiOfferta"])) {
                this.datiMancantiOfferta = [] as any;
                for (let item of _data["datiMancantiOfferta"])
                    this.datiMancantiOfferta!.push(item);
            }
            else {
                this.datiMancantiOfferta = null as any;
            }
            if (Array.isArray(_data["datiMancantiClienti"])) {
                this.datiMancantiClienti = [] as any;
                for (let item of _data["datiMancantiClienti"])
                    this.datiMancantiClienti!.push(ClienteDatiMancanti.fromJS(item));
            }
            else {
                this.datiMancantiClienti = null as any;
            }
        }
    }

    static override fromJS(data: any): OfferteIncompleteReportRow {
        data = typeof data === 'object' ? data : {};
        let result = new OfferteIncompleteReportRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datiMancantiOfferta)) {
            data["datiMancantiOfferta"] = [];
            for (let item of this.datiMancantiOfferta)
                data["datiMancantiOfferta"].push(item);
        }
        if (Array.isArray(this.datiMancantiClienti)) {
            data["datiMancantiClienti"] = [];
            for (let item of this.datiMancantiClienti)
                data["datiMancantiClienti"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IOfferteIncompleteReportRow extends IOfferteIncompleteReportRowBase {
    datiMancantiOfferta?: EDatoClienteMancante[];
    datiMancantiClienti?: ClienteDatiMancanti[];
}

export enum EDatoClienteMancante {
    NumeroPassaporto = "NumeroPassaporto",
    ScadenzaPassaporto = "ScadenzaPassaporto",
    PaeseRilascioPassaporto = "PaeseRilascioPassaporto",
    NumeroCellulare = "NumeroCellulare",
    Email = "Email",
    CodiceFiscale = "CodiceFiscale",
}

export class ClienteDatiMancanti implements IClienteDatiMancanti {
    cliente?: Cliente;
    datiMancanti?: EDatoClienteMancante[];
    traduzioniDatoClienteMancante?: { [key in keyof typeof EDatoClienteMancante]?: string; } | null;
    datiMancantiStr?: string;

    constructor(data?: IClienteDatiMancanti) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cliente = _data["cliente"] ? Cliente.fromJS(_data["cliente"]) : null as any;
            if (Array.isArray(_data["datiMancanti"])) {
                this.datiMancanti = [] as any;
                for (let item of _data["datiMancanti"])
                    this.datiMancanti!.push(item);
            }
            else {
                this.datiMancanti = null as any;
            }
            if (_data["traduzioniDatoClienteMancante"]) {
                this.traduzioniDatoClienteMancante = {} as any;
                for (let key in _data["traduzioniDatoClienteMancante"]) {
                    if (_data["traduzioniDatoClienteMancante"].hasOwnProperty(key))
                        (this.traduzioniDatoClienteMancante as any)![key] = _data["traduzioniDatoClienteMancante"][key] !== undefined ? _data["traduzioniDatoClienteMancante"][key] : null as any;
                }
            }
            else {
                this.traduzioniDatoClienteMancante = null as any;
            }
            this.datiMancantiStr = _data["datiMancantiStr"] !== undefined ? _data["datiMancantiStr"] : null as any;
        }
    }

    static fromJS(data: any): ClienteDatiMancanti {
        data = typeof data === 'object' ? data : {};
        let result = new ClienteDatiMancanti();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cliente"] = this.cliente ? this.cliente.toJSON() : null as any;
        if (Array.isArray(this.datiMancanti)) {
            data["datiMancanti"] = [];
            for (let item of this.datiMancanti)
                data["datiMancanti"].push(item);
        }
        if (this.traduzioniDatoClienteMancante) {
            data["traduzioniDatoClienteMancante"] = {};
            for (let key in this.traduzioniDatoClienteMancante) {
                if (this.traduzioniDatoClienteMancante.hasOwnProperty(key))
                    (data["traduzioniDatoClienteMancante"] as any)[key] = this.traduzioniDatoClienteMancante[key] !== undefined ? this.traduzioniDatoClienteMancante[key] : null as any;
            }
        }
        data["datiMancantiStr"] = this.datiMancantiStr !== undefined ? this.datiMancantiStr : null as any;
        return data;
    }
}

export interface IClienteDatiMancanti {
    cliente?: Cliente;
    datiMancanti?: EDatoClienteMancante[];
    traduzioniDatoClienteMancante?: { [key in keyof typeof EDatoClienteMancante]?: string; } | null;
    datiMancantiStr?: string;
}

export class OfferteIncompleteReportRequest extends ApiRequest implements IOfferteIncompleteReportRequest {
    giorniPartenza?: number | null;
    contattoAgenziaID?: number | null;
    export?: boolean;

    constructor(data?: IOfferteIncompleteReportRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.giorniPartenza = _data["giorniPartenza"] !== undefined ? _data["giorniPartenza"] : null as any;
            this.contattoAgenziaID = _data["contattoAgenziaID"] !== undefined ? _data["contattoAgenziaID"] : null as any;
            this.export = _data["export"] !== undefined ? _data["export"] : null as any;
        }
    }

    static override fromJS(data: any): OfferteIncompleteReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OfferteIncompleteReportRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giorniPartenza"] = this.giorniPartenza !== undefined ? this.giorniPartenza : null as any;
        data["contattoAgenziaID"] = this.contattoAgenziaID !== undefined ? this.contattoAgenziaID : null as any;
        data["export"] = this.export !== undefined ? this.export : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IOfferteIncompleteReportRequest extends IApiRequest {
    giorniPartenza?: number | null;
    contattoAgenziaID?: number | null;
    export?: boolean;
}

export class SendOfferteIncompleteEmail extends OfferteIncompleteReportRequest implements ISendOfferteIncompleteEmail {
    recipient?: EOfferteIncompleteEmailRecipient;
    traduzioniDatoClienteMancante?: { [key in keyof typeof EDatoClienteMancante]?: string; } | null;

    constructor(data?: ISendOfferteIncompleteEmail) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.recipient = _data["recipient"] !== undefined ? _data["recipient"] : null as any;
            if (_data["traduzioniDatoClienteMancante"]) {
                this.traduzioniDatoClienteMancante = {} as any;
                for (let key in _data["traduzioniDatoClienteMancante"]) {
                    if (_data["traduzioniDatoClienteMancante"].hasOwnProperty(key))
                        (this.traduzioniDatoClienteMancante as any)![key] = _data["traduzioniDatoClienteMancante"][key] !== undefined ? _data["traduzioniDatoClienteMancante"][key] : null as any;
                }
            }
            else {
                this.traduzioniDatoClienteMancante = null as any;
            }
        }
    }

    static override fromJS(data: any): SendOfferteIncompleteEmail {
        data = typeof data === 'object' ? data : {};
        let result = new SendOfferteIncompleteEmail();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipient"] = this.recipient !== undefined ? this.recipient : null as any;
        if (this.traduzioniDatoClienteMancante) {
            data["traduzioniDatoClienteMancante"] = {};
            for (let key in this.traduzioniDatoClienteMancante) {
                if (this.traduzioniDatoClienteMancante.hasOwnProperty(key))
                    (data["traduzioniDatoClienteMancante"] as any)[key] = this.traduzioniDatoClienteMancante[key] !== undefined ? this.traduzioniDatoClienteMancante[key] : null as any;
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISendOfferteIncompleteEmail extends IOfferteIncompleteReportRequest {
    recipient?: EOfferteIncompleteEmailRecipient;
    traduzioniDatoClienteMancante?: { [key in keyof typeof EDatoClienteMancante]?: string; } | null;
}

export enum EOfferteIncompleteEmailRecipient {
    Agenzia = "Agenzia",
    Utente = "Utente",
    UtentePreventivo = "UtentePreventivo",
    UtenteConferma = "UtenteConferma",
}

export class NrTableResponseOfReservationRow extends OkApiResponse implements INrTableResponseOfReservationRow {
    /** Array delle righe della pagina richiesta */
    rows?: ReservationRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfReservationRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ReservationRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfReservationRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfReservationRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfReservationRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: ReservationRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class ReservationsListRequestResponse extends NrTableResponseOfReservationRow implements IReservationsListRequestResponse {

    constructor(data?: IReservationsListRequestResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ReservationsListRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationsListRequestResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IReservationsListRequestResponse extends INrTableResponseOfReservationRow {
}

export class ReservationRow implements IReservationRow {
    contattoNome?: string | null;
    contattoValuta?: string | null;
    contattoId?: number | null;
    valutaId?: number | null;
    reservationIndex?: number;

    constructor(data?: IReservationRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contattoNome = _data["contattoNome"] !== undefined ? _data["contattoNome"] : null as any;
            this.contattoValuta = _data["contattoValuta"] !== undefined ? _data["contattoValuta"] : null as any;
            this.contattoId = _data["contattoId"] !== undefined ? _data["contattoId"] : null as any;
            this.valutaId = _data["valutaId"] !== undefined ? _data["valutaId"] : null as any;
            this.reservationIndex = _data["reservationIndex"] !== undefined ? _data["reservationIndex"] : null as any;
        }
    }

    static fromJS(data: any): ReservationRow {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoNome"] = this.contattoNome !== undefined ? this.contattoNome : null as any;
        data["contattoValuta"] = this.contattoValuta !== undefined ? this.contattoValuta : null as any;
        data["contattoId"] = this.contattoId !== undefined ? this.contattoId : null as any;
        data["valutaId"] = this.valutaId !== undefined ? this.valutaId : null as any;
        data["reservationIndex"] = this.reservationIndex !== undefined ? this.reservationIndex : null as any;
        return data;
    }
}

export interface IReservationRow {
    contattoNome?: string | null;
    contattoValuta?: string | null;
    contattoId?: number | null;
    valutaId?: number | null;
    reservationIndex?: number;
}

export class ReservationsListRequestRequest extends NrTableRequest implements IReservationsListRequestRequest {
    offertaID?: number;

    constructor(data?: IReservationsListRequestRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
        }
    }

    static override fromJS(data: any): ReservationsListRequestRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationsListRequestRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IReservationsListRequestRequest extends INrTableRequest {
    offertaID?: number;
}

export class IntranetSearchResponse extends OkApiResponse implements IIntranetSearchResponse {
    luoghiCount?: number;
    luoghi?: LuogoSearchRow[] | null;
    serviziCount?: number;
    servizi?: ServizioSearchRow[] | null;
    contattiCount?: number;
    contatti?: ContattoSearchRow[] | null;
    accordiCount?: number;
    accordi?: AccordoSearchRow[] | null;
    articoliCount?: number;
    articoli?: ArticoloSearchRow[] | null;

    constructor(data?: IIntranetSearchResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luoghiCount = _data["luoghiCount"] !== undefined ? _data["luoghiCount"] : null as any;
            if (Array.isArray(_data["luoghi"])) {
                this.luoghi = [] as any;
                for (let item of _data["luoghi"])
                    this.luoghi!.push(LuogoSearchRow.fromJS(item));
            }
            else {
                this.luoghi = null as any;
            }
            this.serviziCount = _data["serviziCount"] !== undefined ? _data["serviziCount"] : null as any;
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(ServizioSearchRow.fromJS(item));
            }
            else {
                this.servizi = null as any;
            }
            this.contattiCount = _data["contattiCount"] !== undefined ? _data["contattiCount"] : null as any;
            if (Array.isArray(_data["contatti"])) {
                this.contatti = [] as any;
                for (let item of _data["contatti"])
                    this.contatti!.push(ContattoSearchRow.fromJS(item));
            }
            else {
                this.contatti = null as any;
            }
            this.accordiCount = _data["accordiCount"] !== undefined ? _data["accordiCount"] : null as any;
            if (Array.isArray(_data["accordi"])) {
                this.accordi = [] as any;
                for (let item of _data["accordi"])
                    this.accordi!.push(AccordoSearchRow.fromJS(item));
            }
            else {
                this.accordi = null as any;
            }
            this.articoliCount = _data["articoliCount"] !== undefined ? _data["articoliCount"] : null as any;
            if (Array.isArray(_data["articoli"])) {
                this.articoli = [] as any;
                for (let item of _data["articoli"])
                    this.articoli!.push(ArticoloSearchRow.fromJS(item));
            }
            else {
                this.articoli = null as any;
            }
        }
    }

    static override fromJS(data: any): IntranetSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IntranetSearchResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luoghiCount"] = this.luoghiCount !== undefined ? this.luoghiCount : null as any;
        if (Array.isArray(this.luoghi)) {
            data["luoghi"] = [];
            for (let item of this.luoghi)
                data["luoghi"].push(item ? item.toJSON() : null as any);
        }
        data["serviziCount"] = this.serviziCount !== undefined ? this.serviziCount : null as any;
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item ? item.toJSON() : null as any);
        }
        data["contattiCount"] = this.contattiCount !== undefined ? this.contattiCount : null as any;
        if (Array.isArray(this.contatti)) {
            data["contatti"] = [];
            for (let item of this.contatti)
                data["contatti"].push(item ? item.toJSON() : null as any);
        }
        data["accordiCount"] = this.accordiCount !== undefined ? this.accordiCount : null as any;
        if (Array.isArray(this.accordi)) {
            data["accordi"] = [];
            for (let item of this.accordi)
                data["accordi"].push(item ? item.toJSON() : null as any);
        }
        data["articoliCount"] = this.articoliCount !== undefined ? this.articoliCount : null as any;
        if (Array.isArray(this.articoli)) {
            data["articoli"] = [];
            for (let item of this.articoli)
                data["articoli"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IIntranetSearchResponse extends IOkApiResponse {
    luoghiCount?: number;
    luoghi?: LuogoSearchRow[] | null;
    serviziCount?: number;
    servizi?: ServizioSearchRow[] | null;
    contattiCount?: number;
    contatti?: ContattoSearchRow[] | null;
    accordiCount?: number;
    accordi?: AccordoSearchRow[] | null;
    articoliCount?: number;
    articoli?: ArticoloSearchRow[] | null;
}

export class LuogoSearchRow implements ILuogoSearchRow {
    id?: number;
    nome?: string | null;
    tipo?: ETipoLuogo;
    regione?: string | null;
    paese?: string | null;

    constructor(data?: ILuogoSearchRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.regione = _data["regione"] !== undefined ? _data["regione"] : null as any;
            this.paese = _data["paese"] !== undefined ? _data["paese"] : null as any;
        }
    }

    static fromJS(data: any): LuogoSearchRow {
        data = typeof data === 'object' ? data : {};
        let result = new LuogoSearchRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["regione"] = this.regione !== undefined ? this.regione : null as any;
        data["paese"] = this.paese !== undefined ? this.paese : null as any;
        return data;
    }
}

export interface ILuogoSearchRow {
    id?: number;
    nome?: string | null;
    tipo?: ETipoLuogo;
    regione?: string | null;
    paese?: string | null;
}

export class ServizioSearchRow implements IServizioSearchRow {
    id?: number;
    nome?: string | null;
    tipo?: ETipoServizio;
    luogo?: string | null;

    constructor(data?: IServizioSearchRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
        }
    }

    static fromJS(data: any): ServizioSearchRow {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioSearchRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        return data;
    }
}

export interface IServizioSearchRow {
    id?: number;
    nome?: string | null;
    tipo?: ETipoServizio;
    luogo?: string | null;
}

export class ContattoSearchRow implements IContattoSearchRow {
    id?: number;
    nome?: string | null;
    luogo?: string | null;
    tipo?: ETipoContatto;

    constructor(data?: IContattoSearchRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
        }
    }

    static fromJS(data: any): ContattoSearchRow {
        data = typeof data === 'object' ? data : {};
        let result = new ContattoSearchRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        return data;
    }
}

export interface IContattoSearchRow {
    id?: number;
    nome?: string | null;
    luogo?: string | null;
    tipo?: ETipoContatto;
}

export class AccordoSearchRow implements IAccordoSearchRow {
    id?: number;
    nome?: string | null;
    tipo?: ETipoAccordo;

    constructor(data?: IAccordoSearchRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
        }
    }

    static fromJS(data: any): AccordoSearchRow {
        data = typeof data === 'object' ? data : {};
        let result = new AccordoSearchRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        return data;
    }
}

export interface IAccordoSearchRow {
    id?: number;
    nome?: string | null;
    tipo?: ETipoAccordo;
}

export class ArticoloSearchRow implements IArticoloSearchRow {
    id?: number;
    titolo?: string | null;
    luogo?: string | null;
    servizio?: string | null;

    constructor(data?: IArticoloSearchRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : null as any;
        }
    }

    static fromJS(data: any): ArticoloSearchRow {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloSearchRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["servizio"] = this.servizio !== undefined ? this.servizio : null as any;
        return data;
    }
}

export interface IArticoloSearchRow {
    id?: number;
    titolo?: string | null;
    luogo?: string | null;
    servizio?: string | null;
}

export class IntranetSearchRequest extends LocalizedRequest implements IIntranetSearchRequest {
    term!: string;

    constructor(data?: IIntranetSearchRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : null as any;
        }
    }

    static override fromJS(data: any): IntranetSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IntranetSearchRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IIntranetSearchRequest extends ILocalizedRequest {
    term: string;
}

export class SiteSearchResponse extends OkApiResponse implements ISiteSearchResponse {
    conteggioLuoghi?: number;
    altriLuoghi?: boolean;
    luoghi?: LuogoSiteSearchRow[] | null;
    conteggioServizi?: number;
    altriServizi?: boolean;
    servizi?: ServizioSiteSearchRow[] | null;

    constructor(data?: ISiteSearchResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.conteggioLuoghi = _data["conteggioLuoghi"] !== undefined ? _data["conteggioLuoghi"] : null as any;
            this.altriLuoghi = _data["altriLuoghi"] !== undefined ? _data["altriLuoghi"] : null as any;
            if (Array.isArray(_data["luoghi"])) {
                this.luoghi = [] as any;
                for (let item of _data["luoghi"])
                    this.luoghi!.push(LuogoSiteSearchRow.fromJS(item));
            }
            else {
                this.luoghi = null as any;
            }
            this.conteggioServizi = _data["conteggioServizi"] !== undefined ? _data["conteggioServizi"] : null as any;
            this.altriServizi = _data["altriServizi"] !== undefined ? _data["altriServizi"] : null as any;
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(ServizioSiteSearchRow.fromJS(item));
            }
            else {
                this.servizi = null as any;
            }
        }
    }

    static override fromJS(data: any): SiteSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SiteSearchResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conteggioLuoghi"] = this.conteggioLuoghi !== undefined ? this.conteggioLuoghi : null as any;
        data["altriLuoghi"] = this.altriLuoghi !== undefined ? this.altriLuoghi : null as any;
        if (Array.isArray(this.luoghi)) {
            data["luoghi"] = [];
            for (let item of this.luoghi)
                data["luoghi"].push(item ? item.toJSON() : null as any);
        }
        data["conteggioServizi"] = this.conteggioServizi !== undefined ? this.conteggioServizi : null as any;
        data["altriServizi"] = this.altriServizi !== undefined ? this.altriServizi : null as any;
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISiteSearchResponse extends IOkApiResponse {
    conteggioLuoghi?: number;
    altriLuoghi?: boolean;
    luoghi?: LuogoSiteSearchRow[] | null;
    conteggioServizi?: number;
    altriServizi?: boolean;
    servizi?: ServizioSiteSearchRow[] | null;
}

export class LuogoSiteSearchRow implements ILuogoSiteSearchRow {
    id?: number;
    nome?: string | null;
    nomeClean?: string | null;
    urlPart?: string | null;
    regione?: string | null;
    paese?: string | null;
    hotel?: number;
    tour?: number;
    selfDrive?: number;
    trasferimenti?: number;
    visite?: number;
    itinerariConsigliati?: number;

    constructor(data?: ILuogoSiteSearchRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nomeClean = _data["nomeClean"] !== undefined ? _data["nomeClean"] : null as any;
            this.urlPart = _data["urlPart"] !== undefined ? _data["urlPart"] : null as any;
            this.regione = _data["regione"] !== undefined ? _data["regione"] : null as any;
            this.paese = _data["paese"] !== undefined ? _data["paese"] : null as any;
            this.hotel = _data["hotel"] !== undefined ? _data["hotel"] : null as any;
            this.tour = _data["tour"] !== undefined ? _data["tour"] : null as any;
            this.selfDrive = _data["selfDrive"] !== undefined ? _data["selfDrive"] : null as any;
            this.trasferimenti = _data["trasferimenti"] !== undefined ? _data["trasferimenti"] : null as any;
            this.visite = _data["visite"] !== undefined ? _data["visite"] : null as any;
            this.itinerariConsigliati = _data["itinerariConsigliati"] !== undefined ? _data["itinerariConsigliati"] : null as any;
        }
    }

    static fromJS(data: any): LuogoSiteSearchRow {
        data = typeof data === 'object' ? data : {};
        let result = new LuogoSiteSearchRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nomeClean"] = this.nomeClean !== undefined ? this.nomeClean : null as any;
        data["urlPart"] = this.urlPart !== undefined ? this.urlPart : null as any;
        data["regione"] = this.regione !== undefined ? this.regione : null as any;
        data["paese"] = this.paese !== undefined ? this.paese : null as any;
        data["hotel"] = this.hotel !== undefined ? this.hotel : null as any;
        data["tour"] = this.tour !== undefined ? this.tour : null as any;
        data["selfDrive"] = this.selfDrive !== undefined ? this.selfDrive : null as any;
        data["trasferimenti"] = this.trasferimenti !== undefined ? this.trasferimenti : null as any;
        data["visite"] = this.visite !== undefined ? this.visite : null as any;
        data["itinerariConsigliati"] = this.itinerariConsigliati !== undefined ? this.itinerariConsigliati : null as any;
        return data;
    }
}

export interface ILuogoSiteSearchRow {
    id?: number;
    nome?: string | null;
    nomeClean?: string | null;
    urlPart?: string | null;
    regione?: string | null;
    paese?: string | null;
    hotel?: number;
    tour?: number;
    selfDrive?: number;
    trasferimenti?: number;
    visite?: number;
    itinerariConsigliati?: number;
}

export class ServizioSiteSearchRow implements IServizioSiteSearchRow {
    id?: number;
    nome?: string | null;
    esterno?: boolean;
    nomeClean?: string | null;
    urlPart?: string | null;
    tipo?: ETipoServizio;
    isVisita?: boolean;
    luogoID?: number;
    luogo?: string | null;
    luogoUrlPart?: string | null;
    regione?: string | null;
    paese?: string | null;
    giornaliero?: boolean;
    partenze?: PartenzaSiteSearch[] | null;

    constructor(data?: IServizioSiteSearchRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.esterno = _data["esterno"] !== undefined ? _data["esterno"] : null as any;
            this.nomeClean = _data["nomeClean"] !== undefined ? _data["nomeClean"] : null as any;
            this.urlPart = _data["urlPart"] !== undefined ? _data["urlPart"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.isVisita = _data["isVisita"] !== undefined ? _data["isVisita"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.luogoUrlPart = _data["luogoUrlPart"] !== undefined ? _data["luogoUrlPart"] : null as any;
            this.regione = _data["regione"] !== undefined ? _data["regione"] : null as any;
            this.paese = _data["paese"] !== undefined ? _data["paese"] : null as any;
            this.giornaliero = _data["giornaliero"] !== undefined ? _data["giornaliero"] : null as any;
            if (Array.isArray(_data["partenze"])) {
                this.partenze = [] as any;
                for (let item of _data["partenze"])
                    this.partenze!.push(PartenzaSiteSearch.fromJS(item));
            }
            else {
                this.partenze = null as any;
            }
        }
    }

    static fromJS(data: any): ServizioSiteSearchRow {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioSiteSearchRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["esterno"] = this.esterno !== undefined ? this.esterno : null as any;
        data["nomeClean"] = this.nomeClean !== undefined ? this.nomeClean : null as any;
        data["urlPart"] = this.urlPart !== undefined ? this.urlPart : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["isVisita"] = this.isVisita !== undefined ? this.isVisita : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["luogoUrlPart"] = this.luogoUrlPart !== undefined ? this.luogoUrlPart : null as any;
        data["regione"] = this.regione !== undefined ? this.regione : null as any;
        data["paese"] = this.paese !== undefined ? this.paese : null as any;
        data["giornaliero"] = this.giornaliero !== undefined ? this.giornaliero : null as any;
        if (Array.isArray(this.partenze)) {
            data["partenze"] = [];
            for (let item of this.partenze)
                data["partenze"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IServizioSiteSearchRow {
    id?: number;
    nome?: string | null;
    esterno?: boolean;
    nomeClean?: string | null;
    urlPart?: string | null;
    tipo?: ETipoServizio;
    isVisita?: boolean;
    luogoID?: number;
    luogo?: string | null;
    luogoUrlPart?: string | null;
    regione?: string | null;
    paese?: string | null;
    giornaliero?: boolean;
    partenze?: PartenzaSiteSearch[] | null;
}

export class PartenzaSiteSearch implements IPartenzaSiteSearch {
    data?: string;
    prima?: boolean;
    dopo?: boolean;

    constructor(data?: IPartenzaSiteSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
            this.prima = _data["prima"] !== undefined ? _data["prima"] : null as any;
            this.dopo = _data["dopo"] !== undefined ? _data["dopo"] : null as any;
        }
    }

    static fromJS(data: any): PartenzaSiteSearch {
        data = typeof data === 'object' ? data : {};
        let result = new PartenzaSiteSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["prima"] = this.prima !== undefined ? this.prima : null as any;
        data["dopo"] = this.dopo !== undefined ? this.dopo : null as any;
        return data;
    }
}

export interface IPartenzaSiteSearch {
    data?: string;
    prima?: boolean;
    dopo?: boolean;
}

export class SiteSearchRequest extends SiteRequest implements ISiteSearchRequest {
    term?: string | null;
    fullResult?: boolean;
    fromDate?: string;
    toDate?: string;

    constructor(data?: ISiteSearchRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : null as any;
            this.fullResult = _data["fullResult"] !== undefined ? _data["fullResult"] : null as any;
            this.fromDate = _data["fromDate"] !== undefined ? _data["fromDate"] : null as any;
            this.toDate = _data["toDate"] !== undefined ? _data["toDate"] : null as any;
        }
    }

    static override fromJS(data: any): SiteSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SiteSearchRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : null as any;
        data["fullResult"] = this.fullResult !== undefined ? this.fullResult : null as any;
        data["fromDate"] = this.fromDate !== undefined ? this.fromDate : null as any;
        data["toDate"] = this.toDate !== undefined ? this.toDate : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISiteSearchRequest extends ISiteRequest {
    term?: string | null;
    fullResult?: boolean;
    fromDate?: string;
    toDate?: string;
}

export class TripsSearchResponse extends OkApiResponse implements ITripsSearchResponse {
    offerte?: OffertaSearchRow[] | null;

    constructor(data?: ITripsSearchResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["offerte"])) {
                this.offerte = [] as any;
                for (let item of _data["offerte"])
                    this.offerte!.push(OffertaSearchRow.fromJS(item));
            }
            else {
                this.offerte = null as any;
            }
        }
    }

    static override fromJS(data: any): TripsSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TripsSearchResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.offerte)) {
            data["offerte"] = [];
            for (let item of this.offerte)
                data["offerte"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITripsSearchResponse extends IOkApiResponse {
    offerte?: OffertaSearchRow[] | null;
}

export class OffertaSearchRow implements IOffertaSearchRow {
    id?: number;
    nome?: string | null;
    destinazione?: string | null;
    partenza?: string;
    conferma?: boolean;
    annullamentoTO?: boolean;
    nomiPax?: string | null;

    constructor(data?: IOffertaSearchRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.destinazione = _data["destinazione"] !== undefined ? _data["destinazione"] : null as any;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : null as any;
            this.conferma = _data["conferma"] !== undefined ? _data["conferma"] : null as any;
            this.annullamentoTO = _data["annullamentoTO"] !== undefined ? _data["annullamentoTO"] : null as any;
            this.nomiPax = _data["nomiPax"] !== undefined ? _data["nomiPax"] : null as any;
        }
    }

    static fromJS(data: any): OffertaSearchRow {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaSearchRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["destinazione"] = this.destinazione !== undefined ? this.destinazione : null as any;
        data["partenza"] = this.partenza !== undefined ? this.partenza : null as any;
        data["conferma"] = this.conferma !== undefined ? this.conferma : null as any;
        data["annullamentoTO"] = this.annullamentoTO !== undefined ? this.annullamentoTO : null as any;
        data["nomiPax"] = this.nomiPax !== undefined ? this.nomiPax : null as any;
        return data;
    }
}

export interface IOffertaSearchRow {
    id?: number;
    nome?: string | null;
    destinazione?: string | null;
    partenza?: string;
    conferma?: boolean;
    annullamentoTO?: boolean;
    nomiPax?: string | null;
}

export class ServizioGetResponse extends OkApiResponse implements IServizioGetResponse {
    nome?: string | null;
    luogo?: string | null;
    servizio?: Servizio | null;

    constructor(data?: IServizioGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.servizio = _data["servizio"] ? Servizio.fromJS(_data["servizio"]) : null as any;
        }
    }

    static override fromJS(data: any): ServizioGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["servizio"] = this.servizio ? this.servizio.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IServizioGetResponse extends IOkApiResponse {
    nome?: string | null;
    luogo?: string | null;
    servizio?: Servizio | null;
}

export class ServizioGetRequest extends LocalizedRequest implements IServizioGetRequest {
    servizioID?: number;

    constructor(data?: IServizioGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
        }
    }

    static override fromJS(data: any): ServizioGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IServizioGetRequest extends ILocalizedRequest {
    servizioID?: number;
}

export class CloneServizioRequest extends ServizioGetRequest implements ICloneServizioRequest {
    tipologie?: boolean;
    itinerari?: boolean;
    attributi?: boolean;
    partenze?: boolean;
    accordi?: boolean;
    validita?: boolean;
    regoleServizio?: boolean;
    regoleVendita?: boolean;
    costi?: boolean;
    associazioni?: boolean;
    multiluogo?: boolean;
    immagini?: boolean;

    constructor(data?: ICloneServizioRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tipologie = _data["tipologie"] !== undefined ? _data["tipologie"] : null as any;
            this.itinerari = _data["itinerari"] !== undefined ? _data["itinerari"] : null as any;
            this.attributi = _data["attributi"] !== undefined ? _data["attributi"] : null as any;
            this.partenze = _data["partenze"] !== undefined ? _data["partenze"] : null as any;
            this.accordi = _data["accordi"] !== undefined ? _data["accordi"] : null as any;
            this.validita = _data["validita"] !== undefined ? _data["validita"] : null as any;
            this.regoleServizio = _data["regoleServizio"] !== undefined ? _data["regoleServizio"] : null as any;
            this.regoleVendita = _data["regoleVendita"] !== undefined ? _data["regoleVendita"] : null as any;
            this.costi = _data["costi"] !== undefined ? _data["costi"] : null as any;
            this.associazioni = _data["associazioni"] !== undefined ? _data["associazioni"] : null as any;
            this.multiluogo = _data["multiluogo"] !== undefined ? _data["multiluogo"] : null as any;
            this.immagini = _data["immagini"] !== undefined ? _data["immagini"] : null as any;
        }
    }

    static override fromJS(data: any): CloneServizioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CloneServizioRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipologie"] = this.tipologie !== undefined ? this.tipologie : null as any;
        data["itinerari"] = this.itinerari !== undefined ? this.itinerari : null as any;
        data["attributi"] = this.attributi !== undefined ? this.attributi : null as any;
        data["partenze"] = this.partenze !== undefined ? this.partenze : null as any;
        data["accordi"] = this.accordi !== undefined ? this.accordi : null as any;
        data["validita"] = this.validita !== undefined ? this.validita : null as any;
        data["regoleServizio"] = this.regoleServizio !== undefined ? this.regoleServizio : null as any;
        data["regoleVendita"] = this.regoleVendita !== undefined ? this.regoleVendita : null as any;
        data["costi"] = this.costi !== undefined ? this.costi : null as any;
        data["associazioni"] = this.associazioni !== undefined ? this.associazioni : null as any;
        data["multiluogo"] = this.multiluogo !== undefined ? this.multiluogo : null as any;
        data["immagini"] = this.immagini !== undefined ? this.immagini : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICloneServizioRequest extends IServizioGetRequest {
    tipologie?: boolean;
    itinerari?: boolean;
    attributi?: boolean;
    partenze?: boolean;
    accordi?: boolean;
    validita?: boolean;
    regoleServizio?: boolean;
    regoleVendita?: boolean;
    costi?: boolean;
    associazioni?: boolean;
    multiluogo?: boolean;
    immagini?: boolean;
}

export class GetValiditaResponse extends OkApiResponse implements IGetValiditaResponse {
    validita?: ValiditaListRow[] | null;

    constructor(data?: IGetValiditaResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["validita"])) {
                this.validita = [] as any;
                for (let item of _data["validita"])
                    this.validita!.push(ValiditaListRow.fromJS(item));
            }
            else {
                this.validita = null as any;
            }
        }
    }

    static override fromJS(data: any): GetValiditaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetValiditaResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.validita)) {
            data["validita"] = [];
            for (let item of this.validita)
                data["validita"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetValiditaResponse extends IOkApiResponse {
    validita?: ValiditaListRow[] | null;
}

export class ValiditaListRow implements IValiditaListRow {
    id?: number;
    validita?: Validita | null;
    giorni?: EGiornoSettimana[] | null;
    scaduta?: boolean;

    constructor(data?: IValiditaListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.validita = _data["validita"] ? Validita.fromJS(_data["validita"]) : null as any;
            if (Array.isArray(_data["giorni"])) {
                this.giorni = [] as any;
                for (let item of _data["giorni"])
                    this.giorni!.push(item);
            }
            else {
                this.giorni = null as any;
            }
            this.scaduta = _data["scaduta"] !== undefined ? _data["scaduta"] : null as any;
        }
    }

    static fromJS(data: any): ValiditaListRow {
        data = typeof data === 'object' ? data : {};
        let result = new ValiditaListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["validita"] = this.validita ? this.validita.toJSON() : null as any;
        if (Array.isArray(this.giorni)) {
            data["giorni"] = [];
            for (let item of this.giorni)
                data["giorni"].push(item);
        }
        data["scaduta"] = this.scaduta !== undefined ? this.scaduta : null as any;
        return data;
    }
}

export interface IValiditaListRow {
    id?: number;
    validita?: Validita | null;
    giorni?: EGiornoSettimana[] | null;
    scaduta?: boolean;
}

export enum EGiornoSettimana {
    Lunedi = "Lunedi",
    Martedi = "Martedi",
    Mercoledi = "Mercoledi",
    Giovedi = "Giovedi",
    Venerdi = "Venerdi",
    Sabato = "Sabato",
    Domenica = "Domenica",
}

export class CloneValiditaRequest extends ServizioGetRequest implements ICloneValiditaRequest {
    validitaIDs?: number[] | null;
    deltaDays?: number;
    deltaCostoPercentuale?: number;

    constructor(data?: ICloneValiditaRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["validitaIDs"])) {
                this.validitaIDs = [] as any;
                for (let item of _data["validitaIDs"])
                    this.validitaIDs!.push(item);
            }
            else {
                this.validitaIDs = null as any;
            }
            this.deltaDays = _data["deltaDays"] !== undefined ? _data["deltaDays"] : null as any;
            this.deltaCostoPercentuale = _data["deltaCostoPercentuale"] !== undefined ? _data["deltaCostoPercentuale"] : null as any;
        }
    }

    static override fromJS(data: any): CloneValiditaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CloneValiditaRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.validitaIDs)) {
            data["validitaIDs"] = [];
            for (let item of this.validitaIDs)
                data["validitaIDs"].push(item);
        }
        data["deltaDays"] = this.deltaDays !== undefined ? this.deltaDays : null as any;
        data["deltaCostoPercentuale"] = this.deltaCostoPercentuale !== undefined ? this.deltaCostoPercentuale : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICloneValiditaRequest extends IServizioGetRequest {
    validitaIDs?: number[] | null;
    deltaDays?: number;
    deltaCostoPercentuale?: number;
}

export class GetPartenzeResponse extends OkApiResponse implements IGetPartenzeResponse {
    /** Partenze raggruppare per mese, in ordine di data */
    partenzeMese?: PartenzeMese[];

    constructor(data?: IGetPartenzeResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["partenzeMese"])) {
                this.partenzeMese = [] as any;
                for (let item of _data["partenzeMese"])
                    this.partenzeMese!.push(PartenzeMese.fromJS(item));
            }
            else {
                this.partenzeMese = null as any;
            }
        }
    }

    static override fromJS(data: any): GetPartenzeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPartenzeResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.partenzeMese)) {
            data["partenzeMese"] = [];
            for (let item of this.partenzeMese)
                data["partenzeMese"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPartenzeResponse extends IOkApiResponse {
    /** Partenze raggruppare per mese, in ordine di data */
    partenzeMese?: PartenzeMese[];
}

export class PartenzeMese implements IPartenzeMese {
    /** Data fissata al primo del mese che rappresenta questo raggruppamento */
    primoDelMese?: string;
    /** Elenco delle partenze, in ordine di data */
    partenze?: Partenza[];

    constructor(data?: IPartenzeMese) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primoDelMese = _data["primoDelMese"] !== undefined ? _data["primoDelMese"] : null as any;
            if (Array.isArray(_data["partenze"])) {
                this.partenze = [] as any;
                for (let item of _data["partenze"])
                    this.partenze!.push(Partenza.fromJS(item));
            }
            else {
                this.partenze = null as any;
            }
        }
    }

    static fromJS(data: any): PartenzeMese {
        data = typeof data === 'object' ? data : {};
        let result = new PartenzeMese();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primoDelMese"] = this.primoDelMese !== undefined ? this.primoDelMese : null as any;
        if (Array.isArray(this.partenze)) {
            data["partenze"] = [];
            for (let item of this.partenze)
                data["partenze"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPartenzeMese {
    /** Data fissata al primo del mese che rappresenta questo raggruppamento */
    primoDelMese?: string;
    /** Elenco delle partenze, in ordine di data */
    partenze?: Partenza[];
}

export class CreatePartenzeRequest extends ServizioGetRequest implements ICreatePartenzeRequest {
    /** Partenza stampino usata per i flag */
    stampino!: IPartenzaBase;
    /** Data iniziale */
    start?: string;
    /** Data finale */
    stop?: string;
    /** Incremento in giorni, da 1 a 255 */
    step?: number;

    constructor(data?: ICreatePartenzeRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.stampino = _data["stampino"] ? IPartenzaBase.fromJS(_data["stampino"]) : null as any;
            this.start = _data["start"] !== undefined ? _data["start"] : null as any;
            this.stop = _data["stop"] !== undefined ? _data["stop"] : null as any;
            this.step = _data["step"] !== undefined ? _data["step"] : null as any;
        }
    }

    static override fromJS(data: any): CreatePartenzeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePartenzeRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stampino"] = this.stampino ? this.stampino.toJSON() : null as any;
        data["start"] = this.start !== undefined ? this.start : null as any;
        data["stop"] = this.stop !== undefined ? this.stop : null as any;
        data["step"] = this.step !== undefined ? this.step : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICreatePartenzeRequest extends IServizioGetRequest {
    /** Partenza stampino usata per i flag */
    stampino: IPartenzaBase;
    /** Data iniziale */
    start?: string;
    /** Data finale */
    stop?: string;
    /** Incremento in giorni, da 1 a 255 */
    step?: number;
}

export abstract class IPartenzaBase implements IIPartenzaBase {
    partenzaID?: number;
    servizioID?: number;
    data?: string | null;
    flags?: EPartenzaFlags;

    constructor(data?: IIPartenzaBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partenzaID = _data["partenzaID"] !== undefined ? _data["partenzaID"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
            this.flags = _data["flags"] !== undefined ? _data["flags"] : null as any;
        }
    }

    static fromJS(data: any): IPartenzaBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IPartenzaBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partenzaID"] = this.partenzaID !== undefined ? this.partenzaID : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["flags"] = this.flags !== undefined ? this.flags : null as any;
        return data;
    }
}

export interface IIPartenzaBase {
    partenzaID?: number;
    servizioID?: number;
    data?: string | null;
    flags?: EPartenzaFlags;
}

export class GetAssociazioniResponse extends OkApiResponse implements IGetAssociazioniResponse {
    /** Elenco delle associazioni non specifiche di questo servizio */
    associazioni?: ServizioAssociazioneRow[];
    /** Elenco delle associazioni specifiche tipologia / supplemento */
    associazioniSupplementi?: ServizioAssociazioneRow[];
    /** Elenco delle associazioni specifiche di regole vendita aggiuntive */
    associazioniRegoleVenditaAggiuntive?: ServizioAssociazioneRow[];
    /** Elenco delle associazioni specifiche di offerte */
    associazioniOfferte?: ServizioAssociazioneRow[];
    /** Elenco delle associazioni specifiche di penali di cancellazione */
    associazioniPenali?: ServizioAssociazioneRow[];

    constructor(data?: IGetAssociazioniResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["associazioni"])) {
                this.associazioni = [] as any;
                for (let item of _data["associazioni"])
                    this.associazioni!.push(ServizioAssociazioneRow.fromJS(item));
            }
            else {
                this.associazioni = null as any;
            }
            if (Array.isArray(_data["associazioniSupplementi"])) {
                this.associazioniSupplementi = [] as any;
                for (let item of _data["associazioniSupplementi"])
                    this.associazioniSupplementi!.push(ServizioAssociazioneRow.fromJS(item));
            }
            else {
                this.associazioniSupplementi = null as any;
            }
            if (Array.isArray(_data["associazioniRegoleVenditaAggiuntive"])) {
                this.associazioniRegoleVenditaAggiuntive = [] as any;
                for (let item of _data["associazioniRegoleVenditaAggiuntive"])
                    this.associazioniRegoleVenditaAggiuntive!.push(ServizioAssociazioneRow.fromJS(item));
            }
            else {
                this.associazioniRegoleVenditaAggiuntive = null as any;
            }
            if (Array.isArray(_data["associazioniOfferte"])) {
                this.associazioniOfferte = [] as any;
                for (let item of _data["associazioniOfferte"])
                    this.associazioniOfferte!.push(ServizioAssociazioneRow.fromJS(item));
            }
            else {
                this.associazioniOfferte = null as any;
            }
            if (Array.isArray(_data["associazioniPenali"])) {
                this.associazioniPenali = [] as any;
                for (let item of _data["associazioniPenali"])
                    this.associazioniPenali!.push(ServizioAssociazioneRow.fromJS(item));
            }
            else {
                this.associazioniPenali = null as any;
            }
        }
    }

    static override fromJS(data: any): GetAssociazioniResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssociazioniResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.associazioni)) {
            data["associazioni"] = [];
            for (let item of this.associazioni)
                data["associazioni"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.associazioniSupplementi)) {
            data["associazioniSupplementi"] = [];
            for (let item of this.associazioniSupplementi)
                data["associazioniSupplementi"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.associazioniRegoleVenditaAggiuntive)) {
            data["associazioniRegoleVenditaAggiuntive"] = [];
            for (let item of this.associazioniRegoleVenditaAggiuntive)
                data["associazioniRegoleVenditaAggiuntive"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.associazioniOfferte)) {
            data["associazioniOfferte"] = [];
            for (let item of this.associazioniOfferte)
                data["associazioniOfferte"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.associazioniPenali)) {
            data["associazioniPenali"] = [];
            for (let item of this.associazioniPenali)
                data["associazioniPenali"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetAssociazioniResponse extends IOkApiResponse {
    /** Elenco delle associazioni non specifiche di questo servizio */
    associazioni?: ServizioAssociazioneRow[];
    /** Elenco delle associazioni specifiche tipologia / supplemento */
    associazioniSupplementi?: ServizioAssociazioneRow[];
    /** Elenco delle associazioni specifiche di regole vendita aggiuntive */
    associazioniRegoleVenditaAggiuntive?: ServizioAssociazioneRow[];
    /** Elenco delle associazioni specifiche di offerte */
    associazioniOfferte?: ServizioAssociazioneRow[];
    /** Elenco delle associazioni specifiche di penali di cancellazione */
    associazioniPenali?: ServizioAssociazioneRow[];
}

/** Rappresentazione tabulare di un'associazione + Dati per ricavare la maschera di edit */
export class ServizioAssociazioneRow implements IServizioAssociazioneRow {
    /** ID dell'associazione */
    id?: number;
    /** Entità dell'associazione */
    associazione?: ServizioAssociazione;
    /** Eventuale configurazione di un'offerta componibile */
    offertaComponibile?: OffertaComponibile | null;
    /** Nome della tipologia associata. Se null => si associa a tutte le tipologie */
    tipologiaParent?: string | null;
    /** Nome del supplemento specifico. Se null => si associa a tutti i supplementi */
    supplementoSpecifico?: string | null;
    /** Nome della tabella costi commissioni. Se null => si associa a tutte le tabelle */
    tabellaCostiCommissioni?: string | null;
    /** Nome della regola vendita. Se null => si associa a tutte le regole vendita */
    regolaVendita?: string | null;
    /** Nome della sistemazione. Se null => si associa a tutte le sistemazioni */
    sistemazione?: string | null;
    /** Nome del trattamento. Se null => si associa a tutti i trattamenti */
    trattamento?: string | null;
    /** Periodi di esclusione (solo offerte componibili) */
    esclusioni?: string | null;
    /** Flag di disabilitazione (solo offerte componibili) */
    disabilitata?: boolean;
    /** Label dell'offerta (solo offerte componibili) */
    labelOfferta?: string | null;
    /** Codice dell'offerta (solo offerte componibili) */
    codice?: string | null;
    /** Ordine di priorità (solo offerte componibili) */
    priorita?: number | null;
    /** Codici di cumulabilità (solo offerte componibili, T=tutte) */
    cumulabilita?: string | null;
    /** True se l'associazione è generica e può essere convertita in tipo supplemento */
    convertibileSupplemento?: boolean;
    /** True se l'associazione è generica e può essere convertita in tipo regola vendita aggiuntiva */
    convertibileRegola?: boolean;
    /** True se l'associazione è generica e può essere convertita in tipo regola vendita penale */
    convertibilePenale?: boolean;
    /** True se l'associazione è generica e può essere convertita in tipo offerta componibile */
    convertibileOfferta?: boolean;

    constructor(data?: IServizioAssociazioneRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.associazione = _data["associazione"] ? ServizioAssociazione.fromJS(_data["associazione"]) : null as any;
            this.offertaComponibile = _data["offertaComponibile"] ? OffertaComponibile.fromJS(_data["offertaComponibile"]) : null as any;
            this.tipologiaParent = _data["tipologiaParent"] !== undefined ? _data["tipologiaParent"] : null as any;
            this.supplementoSpecifico = _data["supplementoSpecifico"] !== undefined ? _data["supplementoSpecifico"] : null as any;
            this.tabellaCostiCommissioni = _data["tabellaCostiCommissioni"] !== undefined ? _data["tabellaCostiCommissioni"] : null as any;
            this.regolaVendita = _data["regolaVendita"] !== undefined ? _data["regolaVendita"] : null as any;
            this.sistemazione = _data["sistemazione"] !== undefined ? _data["sistemazione"] : null as any;
            this.trattamento = _data["trattamento"] !== undefined ? _data["trattamento"] : null as any;
            this.esclusioni = _data["esclusioni"] !== undefined ? _data["esclusioni"] : null as any;
            this.disabilitata = _data["disabilitata"] !== undefined ? _data["disabilitata"] : null as any;
            this.labelOfferta = _data["labelOfferta"] !== undefined ? _data["labelOfferta"] : null as any;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
            this.priorita = _data["priorita"] !== undefined ? _data["priorita"] : null as any;
            this.cumulabilita = _data["cumulabilita"] !== undefined ? _data["cumulabilita"] : null as any;
            this.convertibileSupplemento = _data["convertibileSupplemento"] !== undefined ? _data["convertibileSupplemento"] : null as any;
            this.convertibileRegola = _data["convertibileRegola"] !== undefined ? _data["convertibileRegola"] : null as any;
            this.convertibilePenale = _data["convertibilePenale"] !== undefined ? _data["convertibilePenale"] : null as any;
            this.convertibileOfferta = _data["convertibileOfferta"] !== undefined ? _data["convertibileOfferta"] : null as any;
        }
    }

    static fromJS(data: any): ServizioAssociazioneRow {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioAssociazioneRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["associazione"] = this.associazione ? this.associazione.toJSON() : null as any;
        data["offertaComponibile"] = this.offertaComponibile ? this.offertaComponibile.toJSON() : null as any;
        data["tipologiaParent"] = this.tipologiaParent !== undefined ? this.tipologiaParent : null as any;
        data["supplementoSpecifico"] = this.supplementoSpecifico !== undefined ? this.supplementoSpecifico : null as any;
        data["tabellaCostiCommissioni"] = this.tabellaCostiCommissioni !== undefined ? this.tabellaCostiCommissioni : null as any;
        data["regolaVendita"] = this.regolaVendita !== undefined ? this.regolaVendita : null as any;
        data["sistemazione"] = this.sistemazione !== undefined ? this.sistemazione : null as any;
        data["trattamento"] = this.trattamento !== undefined ? this.trattamento : null as any;
        data["esclusioni"] = this.esclusioni !== undefined ? this.esclusioni : null as any;
        data["disabilitata"] = this.disabilitata !== undefined ? this.disabilitata : null as any;
        data["labelOfferta"] = this.labelOfferta !== undefined ? this.labelOfferta : null as any;
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        data["priorita"] = this.priorita !== undefined ? this.priorita : null as any;
        data["cumulabilita"] = this.cumulabilita !== undefined ? this.cumulabilita : null as any;
        data["convertibileSupplemento"] = this.convertibileSupplemento !== undefined ? this.convertibileSupplemento : null as any;
        data["convertibileRegola"] = this.convertibileRegola !== undefined ? this.convertibileRegola : null as any;
        data["convertibilePenale"] = this.convertibilePenale !== undefined ? this.convertibilePenale : null as any;
        data["convertibileOfferta"] = this.convertibileOfferta !== undefined ? this.convertibileOfferta : null as any;
        return data;
    }
}

/** Rappresentazione tabulare di un'associazione + Dati per ricavare la maschera di edit */
export interface IServizioAssociazioneRow {
    /** ID dell'associazione */
    id?: number;
    /** Entità dell'associazione */
    associazione?: ServizioAssociazione;
    /** Eventuale configurazione di un'offerta componibile */
    offertaComponibile?: OffertaComponibile | null;
    /** Nome della tipologia associata. Se null => si associa a tutte le tipologie */
    tipologiaParent?: string | null;
    /** Nome del supplemento specifico. Se null => si associa a tutti i supplementi */
    supplementoSpecifico?: string | null;
    /** Nome della tabella costi commissioni. Se null => si associa a tutte le tabelle */
    tabellaCostiCommissioni?: string | null;
    /** Nome della regola vendita. Se null => si associa a tutte le regole vendita */
    regolaVendita?: string | null;
    /** Nome della sistemazione. Se null => si associa a tutte le sistemazioni */
    sistemazione?: string | null;
    /** Nome del trattamento. Se null => si associa a tutti i trattamenti */
    trattamento?: string | null;
    /** Periodi di esclusione (solo offerte componibili) */
    esclusioni?: string | null;
    /** Flag di disabilitazione (solo offerte componibili) */
    disabilitata?: boolean;
    /** Label dell'offerta (solo offerte componibili) */
    labelOfferta?: string | null;
    /** Codice dell'offerta (solo offerte componibili) */
    codice?: string | null;
    /** Ordine di priorità (solo offerte componibili) */
    priorita?: number | null;
    /** Codici di cumulabilità (solo offerte componibili, T=tutte) */
    cumulabilita?: string | null;
    /** True se l'associazione è generica e può essere convertita in tipo supplemento */
    convertibileSupplemento?: boolean;
    /** True se l'associazione è generica e può essere convertita in tipo regola vendita aggiuntiva */
    convertibileRegola?: boolean;
    /** True se l'associazione è generica e può essere convertita in tipo regola vendita penale */
    convertibilePenale?: boolean;
    /** True se l'associazione è generica e può essere convertita in tipo offerta componibile */
    convertibileOfferta?: boolean;
}

export class DeleteAssocizioneRequest extends ServizioGetRequest implements IDeleteAssocizioneRequest {
    /** ID dell'associazione da eliminare */
    associazioneID?: number;

    constructor(data?: IDeleteAssocizioneRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.associazioneID = _data["associazioneID"] !== undefined ? _data["associazioneID"] : null as any;
        }
    }

    static override fromJS(data: any): DeleteAssocizioneRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteAssocizioneRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["associazioneID"] = this.associazioneID !== undefined ? this.associazioneID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteAssocizioneRequest extends IServizioGetRequest {
    /** ID dell'associazione da eliminare */
    associazioneID?: number;
}

export class DeleteAssocizioniRequest extends ServizioGetRequest implements IDeleteAssocizioniRequest {
    /** Lista degli ID delle associazioni da eliminare */
    associazioniIDs!: number[];

    constructor(data?: IDeleteAssocizioniRequest) {
        super(data);
        if (!data) {
            this.associazioniIDs = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["associazioniIDs"])) {
                this.associazioniIDs = [] as any;
                for (let item of _data["associazioniIDs"])
                    this.associazioniIDs!.push(item);
            }
            else {
                this.associazioniIDs = null as any;
            }
        }
    }

    static override fromJS(data: any): DeleteAssocizioniRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteAssocizioniRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.associazioniIDs)) {
            data["associazioniIDs"] = [];
            for (let item of this.associazioniIDs)
                data["associazioniIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteAssocizioniRequest extends IServizioGetRequest {
    /** Lista degli ID delle associazioni da eliminare */
    associazioniIDs: number[];
}

export class GetCostiResponse extends OkApiResponse implements IGetCostiResponse {
    tabelle?: CostiTabellaCostoRow[];

    constructor(data?: IGetCostiResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tabelle"])) {
                this.tabelle = [] as any;
                for (let item of _data["tabelle"])
                    this.tabelle!.push(CostiTabellaCostoRow.fromJS(item));
            }
            else {
                this.tabelle = null as any;
            }
        }
    }

    static override fromJS(data: any): GetCostiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCostiResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tabelle)) {
            data["tabelle"] = [];
            for (let item of this.tabelle)
                data["tabelle"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetCostiResponse extends IOkApiResponse {
    tabelle?: CostiTabellaCostoRow[];
}

export class CostiTabellaCostoRow implements ICostiTabellaCostoRow {
    /** ID della tabella costi commissioni */
    tabellaID?: number;
    /** Nome localizzato della tabella costi commissioni */
    nomeTabella?: string;
    /** Data di inizio validit� della tabella costi commissioni */
    tabellaValidaDal?: string;
    /** Data di fine validit� della tabella costi commissioni */
    tabellaValidaAl?: string;
    /** ID dell'accordo a cui appartiene la tabella costi commissioni */
    accordoID?: number;
    /** Nome dell'accordo a cui appartiene la tabella costi commissioni */
    nomeAccordo?: string | null;
    /** Codice della valuta dell'accordo a cui appartiene la tabella costi commissioni */
    codiceValuta?: string | null;
    /** Raggruppamento per tipologie e trattamenti */
    tipologie?: CostiTipologiaRow[];
    /** Campo ad uso della UI, per selezionare i valori */
    selected?: boolean;

    constructor(data?: ICostiTabellaCostoRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tabellaID = _data["tabellaID"] !== undefined ? _data["tabellaID"] : null as any;
            this.nomeTabella = _data["nomeTabella"] !== undefined ? _data["nomeTabella"] : null as any;
            this.tabellaValidaDal = _data["tabellaValidaDal"] !== undefined ? _data["tabellaValidaDal"] : null as any;
            this.tabellaValidaAl = _data["tabellaValidaAl"] !== undefined ? _data["tabellaValidaAl"] : null as any;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.nomeAccordo = _data["nomeAccordo"] !== undefined ? _data["nomeAccordo"] : null as any;
            this.codiceValuta = _data["codiceValuta"] !== undefined ? _data["codiceValuta"] : null as any;
            if (Array.isArray(_data["tipologie"])) {
                this.tipologie = [] as any;
                for (let item of _data["tipologie"])
                    this.tipologie!.push(CostiTipologiaRow.fromJS(item));
            }
            else {
                this.tipologie = null as any;
            }
            this.selected = _data["selected"] !== undefined ? _data["selected"] : null as any;
        }
    }

    static fromJS(data: any): CostiTabellaCostoRow {
        data = typeof data === 'object' ? data : {};
        let result = new CostiTabellaCostoRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tabellaID"] = this.tabellaID !== undefined ? this.tabellaID : null as any;
        data["nomeTabella"] = this.nomeTabella !== undefined ? this.nomeTabella : null as any;
        data["tabellaValidaDal"] = this.tabellaValidaDal !== undefined ? this.tabellaValidaDal : null as any;
        data["tabellaValidaAl"] = this.tabellaValidaAl !== undefined ? this.tabellaValidaAl : null as any;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["nomeAccordo"] = this.nomeAccordo !== undefined ? this.nomeAccordo : null as any;
        data["codiceValuta"] = this.codiceValuta !== undefined ? this.codiceValuta : null as any;
        if (Array.isArray(this.tipologie)) {
            data["tipologie"] = [];
            for (let item of this.tipologie)
                data["tipologie"].push(item ? item.toJSON() : null as any);
        }
        data["selected"] = this.selected !== undefined ? this.selected : null as any;
        return data;
    }
}

export interface ICostiTabellaCostoRow {
    /** ID della tabella costi commissioni */
    tabellaID?: number;
    /** Nome localizzato della tabella costi commissioni */
    nomeTabella?: string;
    /** Data di inizio validit� della tabella costi commissioni */
    tabellaValidaDal?: string;
    /** Data di fine validit� della tabella costi commissioni */
    tabellaValidaAl?: string;
    /** ID dell'accordo a cui appartiene la tabella costi commissioni */
    accordoID?: number;
    /** Nome dell'accordo a cui appartiene la tabella costi commissioni */
    nomeAccordo?: string | null;
    /** Codice della valuta dell'accordo a cui appartiene la tabella costi commissioni */
    codiceValuta?: string | null;
    /** Raggruppamento per tipologie e trattamenti */
    tipologie?: CostiTipologiaRow[];
    /** Campo ad uso della UI, per selezionare i valori */
    selected?: boolean;
}

export class CostiTipologiaRow implements ICostiTipologiaRow {
    /** ID della tipologia */
    servizioTipologiaID?: number;
    /** Nome localizzato della tipologia */
    tipologia?: string;
    /** True se la tiplogia ha il "verifica partenze" */
    verificaPartenze?: boolean;
    /** ID del trattamento */
    trattamentoID?: number | null;
    /** Nome localizzato del trattamento */
    trattamento?: string | null;
    /** Raggruppamento per regole servizio / vendita / codice prenotazione / vincoli et� / regole bambino */
    regole?: CostoRegolaRow[];
    /** Campo ad uso della UI, per selezionare i valori */
    selected?: boolean;

    constructor(data?: ICostiTipologiaRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servizioTipologiaID = _data["servizioTipologiaID"] !== undefined ? _data["servizioTipologiaID"] : null as any;
            this.tipologia = _data["tipologia"] !== undefined ? _data["tipologia"] : null as any;
            this.verificaPartenze = _data["verificaPartenze"] !== undefined ? _data["verificaPartenze"] : null as any;
            this.trattamentoID = _data["trattamentoID"] !== undefined ? _data["trattamentoID"] : null as any;
            this.trattamento = _data["trattamento"] !== undefined ? _data["trattamento"] : null as any;
            if (Array.isArray(_data["regole"])) {
                this.regole = [] as any;
                for (let item of _data["regole"])
                    this.regole!.push(CostoRegolaRow.fromJS(item));
            }
            else {
                this.regole = null as any;
            }
            this.selected = _data["selected"] !== undefined ? _data["selected"] : null as any;
        }
    }

    static fromJS(data: any): CostiTipologiaRow {
        data = typeof data === 'object' ? data : {};
        let result = new CostiTipologiaRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioTipologiaID"] = this.servizioTipologiaID !== undefined ? this.servizioTipologiaID : null as any;
        data["tipologia"] = this.tipologia !== undefined ? this.tipologia : null as any;
        data["verificaPartenze"] = this.verificaPartenze !== undefined ? this.verificaPartenze : null as any;
        data["trattamentoID"] = this.trattamentoID !== undefined ? this.trattamentoID : null as any;
        data["trattamento"] = this.trattamento !== undefined ? this.trattamento : null as any;
        if (Array.isArray(this.regole)) {
            data["regole"] = [];
            for (let item of this.regole)
                data["regole"].push(item ? item.toJSON() : null as any);
        }
        data["selected"] = this.selected !== undefined ? this.selected : null as any;
        return data;
    }
}

export interface ICostiTipologiaRow {
    /** ID della tipologia */
    servizioTipologiaID?: number;
    /** Nome localizzato della tipologia */
    tipologia?: string;
    /** True se la tiplogia ha il "verifica partenze" */
    verificaPartenze?: boolean;
    /** ID del trattamento */
    trattamentoID?: number | null;
    /** Nome localizzato del trattamento */
    trattamento?: string | null;
    /** Raggruppamento per regole servizio / vendita / codice prenotazione / vincoli et� / regole bambino */
    regole?: CostoRegolaRow[];
    /** Campo ad uso della UI, per selezionare i valori */
    selected?: boolean;
}

export class CostoRegolaRow implements ICostoRegolaRow {
    /** Se true la regola di inserimento costi indica uno sconto percentuale sull'omologo costo adulto invece di una cifra */
    scontoBambinoPercentuale?: boolean;
    /** Regola servizio */
    regolaServizio?: ServizioRegola | null;
    /** Regola vendita, se c'� */
    regolaVendita?: ServizioRegolaVendita | null;
    /** Nome localizzato della regola vendita */
    nomeRegolaVendita?: string | null;
    /** Et� massima bambino, se questo � un costo bambino */
    etaMassima?: number | null;
    /** Tipo di applicazione costi bambino, se sono costi bambino */
    regolaCostiBambino?: ERegolaCostiBambino | null;
    /** Codice di prenotazione facoltativo */
    codicePrenotazione?: string | null;
    /** Raggruppamento per validit� */
    validita?: CostoValiditaRow[];
    /** Campo ad uso della UI, per selezionare i valori */
    selected?: boolean;

    constructor(data?: ICostoRegolaRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scontoBambinoPercentuale = _data["scontoBambinoPercentuale"] !== undefined ? _data["scontoBambinoPercentuale"] : null as any;
            this.regolaServizio = _data["regolaServizio"] ? ServizioRegola.fromJS(_data["regolaServizio"]) : null as any;
            this.regolaVendita = _data["regolaVendita"] ? ServizioRegolaVendita.fromJS(_data["regolaVendita"]) : null as any;
            this.nomeRegolaVendita = _data["nomeRegolaVendita"] !== undefined ? _data["nomeRegolaVendita"] : null as any;
            this.etaMassima = _data["etaMassima"] !== undefined ? _data["etaMassima"] : null as any;
            this.regolaCostiBambino = _data["regolaCostiBambino"] !== undefined ? _data["regolaCostiBambino"] : null as any;
            this.codicePrenotazione = _data["codicePrenotazione"] !== undefined ? _data["codicePrenotazione"] : null as any;
            if (Array.isArray(_data["validita"])) {
                this.validita = [] as any;
                for (let item of _data["validita"])
                    this.validita!.push(CostoValiditaRow.fromJS(item));
            }
            else {
                this.validita = null as any;
            }
            this.selected = _data["selected"] !== undefined ? _data["selected"] : null as any;
        }
    }

    static fromJS(data: any): CostoRegolaRow {
        data = typeof data === 'object' ? data : {};
        let result = new CostoRegolaRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scontoBambinoPercentuale"] = this.scontoBambinoPercentuale !== undefined ? this.scontoBambinoPercentuale : null as any;
        data["regolaServizio"] = this.regolaServizio ? this.regolaServizio.toJSON() : null as any;
        data["regolaVendita"] = this.regolaVendita ? this.regolaVendita.toJSON() : null as any;
        data["nomeRegolaVendita"] = this.nomeRegolaVendita !== undefined ? this.nomeRegolaVendita : null as any;
        data["etaMassima"] = this.etaMassima !== undefined ? this.etaMassima : null as any;
        data["regolaCostiBambino"] = this.regolaCostiBambino !== undefined ? this.regolaCostiBambino : null as any;
        data["codicePrenotazione"] = this.codicePrenotazione !== undefined ? this.codicePrenotazione : null as any;
        if (Array.isArray(this.validita)) {
            data["validita"] = [];
            for (let item of this.validita)
                data["validita"].push(item ? item.toJSON() : null as any);
        }
        data["selected"] = this.selected !== undefined ? this.selected : null as any;
        return data;
    }
}

export interface ICostoRegolaRow {
    /** Se true la regola di inserimento costi indica uno sconto percentuale sull'omologo costo adulto invece di una cifra */
    scontoBambinoPercentuale?: boolean;
    /** Regola servizio */
    regolaServizio?: ServizioRegola | null;
    /** Regola vendita, se c'� */
    regolaVendita?: ServizioRegolaVendita | null;
    /** Nome localizzato della regola vendita */
    nomeRegolaVendita?: string | null;
    /** Et� massima bambino, se questo � un costo bambino */
    etaMassima?: number | null;
    /** Tipo di applicazione costi bambino, se sono costi bambino */
    regolaCostiBambino?: ERegolaCostiBambino | null;
    /** Codice di prenotazione facoltativo */
    codicePrenotazione?: string | null;
    /** Raggruppamento per validit� */
    validita?: CostoValiditaRow[];
    /** Campo ad uso della UI, per selezionare i valori */
    selected?: boolean;
}

export class CostoValiditaRow implements ICostoValiditaRow {
    /** ID della validit� */
    validitaID?: number;
    /** True se la validit� associata ha i prezzi indicativi */
    prezziIndicativi?: boolean;
    /** Elenco dei giorni della settimana della validit� associata */
    giorni?: EGiornoSettimana[];
    /** True se la regola � valida tutti i giorni */
    tuttiIGiorni?: boolean;
    /** Data di inizio della validit� */
    dataInizio?: string;
    /** Data di fine della validit� */
    dataFine?: string;
    /** True se le date di validit� sono nel passato */
    scaduta?: boolean;
    /** Raggruppamento per sistemazione */
    beddings?: CostoBeddingRow[];
    /** Flag ad uso della UI */
    selected?: boolean;

    constructor(data?: ICostoValiditaRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validitaID = _data["validitaID"] !== undefined ? _data["validitaID"] : null as any;
            this.prezziIndicativi = _data["prezziIndicativi"] !== undefined ? _data["prezziIndicativi"] : null as any;
            if (Array.isArray(_data["giorni"])) {
                this.giorni = [] as any;
                for (let item of _data["giorni"])
                    this.giorni!.push(item);
            }
            else {
                this.giorni = null as any;
            }
            this.tuttiIGiorni = _data["tuttiIGiorni"] !== undefined ? _data["tuttiIGiorni"] : null as any;
            this.dataInizio = _data["dataInizio"] !== undefined ? _data["dataInizio"] : null as any;
            this.dataFine = _data["dataFine"] !== undefined ? _data["dataFine"] : null as any;
            this.scaduta = _data["scaduta"] !== undefined ? _data["scaduta"] : null as any;
            if (Array.isArray(_data["beddings"])) {
                this.beddings = [] as any;
                for (let item of _data["beddings"])
                    this.beddings!.push(CostoBeddingRow.fromJS(item));
            }
            else {
                this.beddings = null as any;
            }
            this.selected = _data["selected"] !== undefined ? _data["selected"] : null as any;
        }
    }

    static fromJS(data: any): CostoValiditaRow {
        data = typeof data === 'object' ? data : {};
        let result = new CostoValiditaRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validitaID"] = this.validitaID !== undefined ? this.validitaID : null as any;
        data["prezziIndicativi"] = this.prezziIndicativi !== undefined ? this.prezziIndicativi : null as any;
        if (Array.isArray(this.giorni)) {
            data["giorni"] = [];
            for (let item of this.giorni)
                data["giorni"].push(item);
        }
        data["tuttiIGiorni"] = this.tuttiIGiorni !== undefined ? this.tuttiIGiorni : null as any;
        data["dataInizio"] = this.dataInizio !== undefined ? this.dataInizio : null as any;
        data["dataFine"] = this.dataFine !== undefined ? this.dataFine : null as any;
        data["scaduta"] = this.scaduta !== undefined ? this.scaduta : null as any;
        if (Array.isArray(this.beddings)) {
            data["beddings"] = [];
            for (let item of this.beddings)
                data["beddings"].push(item ? item.toJSON() : null as any);
        }
        data["selected"] = this.selected !== undefined ? this.selected : null as any;
        return data;
    }
}

export interface ICostoValiditaRow {
    /** ID della validit� */
    validitaID?: number;
    /** True se la validit� associata ha i prezzi indicativi */
    prezziIndicativi?: boolean;
    /** Elenco dei giorni della settimana della validit� associata */
    giorni?: EGiornoSettimana[];
    /** True se la regola � valida tutti i giorni */
    tuttiIGiorni?: boolean;
    /** Data di inizio della validit� */
    dataInizio?: string;
    /** Data di fine della validit� */
    dataFine?: string;
    /** True se le date di validit� sono nel passato */
    scaduta?: boolean;
    /** Raggruppamento per sistemazione */
    beddings?: CostoBeddingRow[];
    /** Flag ad uso della UI */
    selected?: boolean;
}

export class CostoBeddingRow implements ICostoBeddingRow {
    /** Questa voce � un segnaposto (vuoto) per creare la griglia */
    placeholder?: boolean;
    /** ID della riga di costo */
    costoID?: number;
    /** ID del bedding associato. Null se corrispondente a "nessuno" */
    beddingID?: number | null;
    /** Sigla del tipo di bedding (S1, D2, D3, ecc) */
    codice?: string | null;
    /** Prezzo associato in EURO */
    prezzo?: number | null;
    /** Ad uso della UI */
    prezzoOriginale?: number | null;
    /** Costo associato nella valuta dell'accordo */
    costo?: number;
    /** Ad uso della UI */
    costoOriginale?: number;
    /** Margine personalizzato, se diverso da quello previsto da accordo e tabella costi */
    margine?: number | null;
    /** True se questo costo � molteplice. E non dovrebbe esserlo... */
    haConflitti?: boolean;
    /** True se si tratta di uno sconto percentuale. Da capire se serve davvero. */
    scontoBambinoPercentuale?: boolean;
    /** Lista dei conflitti */
    conflitti?: CostoBeddingRow[];
    /** Campo ad uso della UI, per selezionare i valori */
    selected?: boolean;

    constructor(data?: ICostoBeddingRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.placeholder = _data["placeholder"] !== undefined ? _data["placeholder"] : null as any;
            this.costoID = _data["costoID"] !== undefined ? _data["costoID"] : null as any;
            this.beddingID = _data["beddingID"] !== undefined ? _data["beddingID"] : null as any;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : null as any;
            this.prezzoOriginale = _data["prezzoOriginale"] !== undefined ? _data["prezzoOriginale"] : null as any;
            this.costo = _data["costo"] !== undefined ? _data["costo"] : null as any;
            this.costoOriginale = _data["costoOriginale"] !== undefined ? _data["costoOriginale"] : null as any;
            this.margine = _data["margine"] !== undefined ? _data["margine"] : null as any;
            this.haConflitti = _data["haConflitti"] !== undefined ? _data["haConflitti"] : null as any;
            this.scontoBambinoPercentuale = _data["scontoBambinoPercentuale"] !== undefined ? _data["scontoBambinoPercentuale"] : null as any;
            if (Array.isArray(_data["conflitti"])) {
                this.conflitti = [] as any;
                for (let item of _data["conflitti"])
                    this.conflitti!.push(CostoBeddingRow.fromJS(item));
            }
            else {
                this.conflitti = null as any;
            }
            this.selected = _data["selected"] !== undefined ? _data["selected"] : null as any;
        }
    }

    static fromJS(data: any): CostoBeddingRow {
        data = typeof data === 'object' ? data : {};
        let result = new CostoBeddingRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["placeholder"] = this.placeholder !== undefined ? this.placeholder : null as any;
        data["costoID"] = this.costoID !== undefined ? this.costoID : null as any;
        data["beddingID"] = this.beddingID !== undefined ? this.beddingID : null as any;
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : null as any;
        data["prezzoOriginale"] = this.prezzoOriginale !== undefined ? this.prezzoOriginale : null as any;
        data["costo"] = this.costo !== undefined ? this.costo : null as any;
        data["costoOriginale"] = this.costoOriginale !== undefined ? this.costoOriginale : null as any;
        data["margine"] = this.margine !== undefined ? this.margine : null as any;
        data["haConflitti"] = this.haConflitti !== undefined ? this.haConflitti : null as any;
        data["scontoBambinoPercentuale"] = this.scontoBambinoPercentuale !== undefined ? this.scontoBambinoPercentuale : null as any;
        if (Array.isArray(this.conflitti)) {
            data["conflitti"] = [];
            for (let item of this.conflitti)
                data["conflitti"].push(item ? item.toJSON() : null as any);
        }
        data["selected"] = this.selected !== undefined ? this.selected : null as any;
        return data;
    }
}

export interface ICostoBeddingRow {
    /** Questa voce � un segnaposto (vuoto) per creare la griglia */
    placeholder?: boolean;
    /** ID della riga di costo */
    costoID?: number;
    /** ID del bedding associato. Null se corrispondente a "nessuno" */
    beddingID?: number | null;
    /** Sigla del tipo di bedding (S1, D2, D3, ecc) */
    codice?: string | null;
    /** Prezzo associato in EURO */
    prezzo?: number | null;
    /** Ad uso della UI */
    prezzoOriginale?: number | null;
    /** Costo associato nella valuta dell'accordo */
    costo?: number;
    /** Ad uso della UI */
    costoOriginale?: number;
    /** Margine personalizzato, se diverso da quello previsto da accordo e tabella costi */
    margine?: number | null;
    /** True se questo costo � molteplice. E non dovrebbe esserlo... */
    haConflitti?: boolean;
    /** True se si tratta di uno sconto percentuale. Da capire se serve davvero. */
    scontoBambinoPercentuale?: boolean;
    /** Lista dei conflitti */
    conflitti?: CostoBeddingRow[];
    /** Campo ad uso della UI, per selezionare i valori */
    selected?: boolean;
}

export class DeleteCostiRequest extends ServizioGetRequest implements IDeleteCostiRequest {
    costiIDs?: number[] | null;

    constructor(data?: IDeleteCostiRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["costiIDs"])) {
                this.costiIDs = [] as any;
                for (let item of _data["costiIDs"])
                    this.costiIDs!.push(item);
            }
            else {
                this.costiIDs = null as any;
            }
        }
    }

    static override fromJS(data: any): DeleteCostiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCostiRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.costiIDs)) {
            data["costiIDs"] = [];
            for (let item of this.costiIDs)
                data["costiIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteCostiRequest extends IServizioGetRequest {
    costiIDs?: number[] | null;
}

export class GetDynamicPackageRulesResponse extends OkApiResponse implements IGetDynamicPackageRulesResponse {
    regole?: ServizioRegolaScontoPacchettoRow[] | null;

    constructor(data?: IGetDynamicPackageRulesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["regole"])) {
                this.regole = [] as any;
                for (let item of _data["regole"])
                    this.regole!.push(ServizioRegolaScontoPacchettoRow.fromJS(item));
            }
            else {
                this.regole = null as any;
            }
        }
    }

    static override fromJS(data: any): GetDynamicPackageRulesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDynamicPackageRulesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.regole)) {
            data["regole"] = [];
            for (let item of this.regole)
                data["regole"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetDynamicPackageRulesResponse extends IOkApiResponse {
    regole?: ServizioRegolaScontoPacchettoRow[] | null;
}

export class ServizioRegolaScontoPacchettoRow extends ServizioRegolaScontoPacchetto implements IServizioRegolaScontoPacchettoRow {
    servizioSconto?: string | null;

    constructor(data?: IServizioRegolaScontoPacchettoRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioSconto = _data["servizioSconto"] !== undefined ? _data["servizioSconto"] : null as any;
        }
    }

    static override fromJS(data: any): ServizioRegolaScontoPacchettoRow {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioRegolaScontoPacchettoRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioSconto"] = this.servizioSconto !== undefined ? this.servizioSconto : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IServizioRegolaScontoPacchettoRow extends IServizioRegolaScontoPacchetto {
    servizioSconto?: string | null;
}

export class GetDynamicPackageRulesRequest extends ServizioGetRequest implements IGetDynamicPackageRulesRequest {

    constructor(data?: IGetDynamicPackageRulesRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetDynamicPackageRulesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDynamicPackageRulesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetDynamicPackageRulesRequest extends IServizioGetRequest {
}

export class DeleteDynamicPackageRuleRequest extends GetDynamicPackageRulesRequest implements IDeleteDynamicPackageRuleRequest {
    regolaPacchettoID?: number;

    constructor(data?: IDeleteDynamicPackageRuleRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.regolaPacchettoID = _data["regolaPacchettoID"] !== undefined ? _data["regolaPacchettoID"] : null as any;
        }
    }

    static override fromJS(data: any): DeleteDynamicPackageRuleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteDynamicPackageRuleRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regolaPacchettoID"] = this.regolaPacchettoID !== undefined ? this.regolaPacchettoID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteDynamicPackageRuleRequest extends IGetDynamicPackageRulesRequest {
    regolaPacchettoID?: number;
}

export class DeleteDynamicPackageRulesRequest extends GetDynamicPackageRulesRequest implements IDeleteDynamicPackageRulesRequest {
    regolePacchettoIDs?: number[] | null;

    constructor(data?: IDeleteDynamicPackageRulesRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["regolePacchettoIDs"])) {
                this.regolePacchettoIDs = [] as any;
                for (let item of _data["regolePacchettoIDs"])
                    this.regolePacchettoIDs!.push(item);
            }
            else {
                this.regolePacchettoIDs = null as any;
            }
        }
    }

    static override fromJS(data: any): DeleteDynamicPackageRulesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteDynamicPackageRulesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.regolePacchettoIDs)) {
            data["regolePacchettoIDs"] = [];
            for (let item of this.regolePacchettoIDs)
                data["regolePacchettoIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteDynamicPackageRulesRequest extends IGetDynamicPackageRulesRequest {
    regolePacchettoIDs?: number[] | null;
}

export class GetItinerariResponse extends OkApiResponse implements IGetItinerariResponse {
    itinerari?: ItinerarioListRow[] | null;

    constructor(data?: IGetItinerariResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["itinerari"])) {
                this.itinerari = [] as any;
                for (let item of _data["itinerari"])
                    this.itinerari!.push(ItinerarioListRow.fromJS(item));
            }
            else {
                this.itinerari = null as any;
            }
        }
    }

    static override fromJS(data: any): GetItinerariResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetItinerariResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.itinerari)) {
            data["itinerari"] = [];
            for (let item of this.itinerari)
                data["itinerari"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetItinerariResponse extends IOkApiResponse {
    itinerari?: ItinerarioListRow[] | null;
}

export class ItinerarioListRow implements IItinerarioListRow {
    id?: number;
    nome?: string | null;
    giorni?: number;
    notti?: number;
    origine?: string[] | null;
    destinazione?: string | null;
    compagniaAerea?: string[] | null;
    itinerario?: ServizioItinerario | null;
    tappe?: ServizioItinerarioGiornoRow[] | null;

    constructor(data?: IItinerarioListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.giorni = _data["giorni"] !== undefined ? _data["giorni"] : null as any;
            this.notti = _data["notti"] !== undefined ? _data["notti"] : null as any;
            if (Array.isArray(_data["origine"])) {
                this.origine = [] as any;
                for (let item of _data["origine"])
                    this.origine!.push(item);
            }
            else {
                this.origine = null as any;
            }
            this.destinazione = _data["destinazione"] !== undefined ? _data["destinazione"] : null as any;
            if (Array.isArray(_data["compagniaAerea"])) {
                this.compagniaAerea = [] as any;
                for (let item of _data["compagniaAerea"])
                    this.compagniaAerea!.push(item);
            }
            else {
                this.compagniaAerea = null as any;
            }
            this.itinerario = _data["itinerario"] ? ServizioItinerario.fromJS(_data["itinerario"]) : null as any;
            if (Array.isArray(_data["tappe"])) {
                this.tappe = [] as any;
                for (let item of _data["tappe"])
                    this.tappe!.push(ServizioItinerarioGiornoRow.fromJS(item));
            }
            else {
                this.tappe = null as any;
            }
        }
    }

    static fromJS(data: any): ItinerarioListRow {
        data = typeof data === 'object' ? data : {};
        let result = new ItinerarioListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["giorni"] = this.giorni !== undefined ? this.giorni : null as any;
        data["notti"] = this.notti !== undefined ? this.notti : null as any;
        if (Array.isArray(this.origine)) {
            data["origine"] = [];
            for (let item of this.origine)
                data["origine"].push(item);
        }
        data["destinazione"] = this.destinazione !== undefined ? this.destinazione : null as any;
        if (Array.isArray(this.compagniaAerea)) {
            data["compagniaAerea"] = [];
            for (let item of this.compagniaAerea)
                data["compagniaAerea"].push(item);
        }
        data["itinerario"] = this.itinerario ? this.itinerario.toJSON() : null as any;
        if (Array.isArray(this.tappe)) {
            data["tappe"] = [];
            for (let item of this.tappe)
                data["tappe"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IItinerarioListRow {
    id?: number;
    nome?: string | null;
    giorni?: number;
    notti?: number;
    origine?: string[] | null;
    destinazione?: string | null;
    compagniaAerea?: string[] | null;
    itinerario?: ServizioItinerario | null;
    tappe?: ServizioItinerarioGiornoRow[] | null;
}

export class ServizioItinerarioGiornoRow implements IServizioItinerarioGiornoRow {
    tappa?: ServizioItinerarioGiorno | null;
    luogo?: string | null;
    compagniaAerea?: string | null;
    classe?: string | null;
    compagniaAerea2?: string | null;
    classe2?: string | null;
    cambioHotel?: boolean;
    servizi?: ServizioItinerarioGiornoServizioRow[] | null;

    constructor(data?: IServizioItinerarioGiornoRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tappa = _data["tappa"] ? ServizioItinerarioGiorno.fromJS(_data["tappa"]) : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.compagniaAerea = _data["compagniaAerea"] !== undefined ? _data["compagniaAerea"] : null as any;
            this.classe = _data["classe"] !== undefined ? _data["classe"] : null as any;
            this.compagniaAerea2 = _data["compagniaAerea2"] !== undefined ? _data["compagniaAerea2"] : null as any;
            this.classe2 = _data["classe2"] !== undefined ? _data["classe2"] : null as any;
            this.cambioHotel = _data["cambioHotel"] !== undefined ? _data["cambioHotel"] : null as any;
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(ServizioItinerarioGiornoServizioRow.fromJS(item));
            }
            else {
                this.servizi = null as any;
            }
        }
    }

    static fromJS(data: any): ServizioItinerarioGiornoRow {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioItinerarioGiornoRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tappa"] = this.tappa ? this.tappa.toJSON() : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["compagniaAerea"] = this.compagniaAerea !== undefined ? this.compagniaAerea : null as any;
        data["classe"] = this.classe !== undefined ? this.classe : null as any;
        data["compagniaAerea2"] = this.compagniaAerea2 !== undefined ? this.compagniaAerea2 : null as any;
        data["classe2"] = this.classe2 !== undefined ? this.classe2 : null as any;
        data["cambioHotel"] = this.cambioHotel !== undefined ? this.cambioHotel : null as any;
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IServizioItinerarioGiornoRow {
    tappa?: ServizioItinerarioGiorno | null;
    luogo?: string | null;
    compagniaAerea?: string | null;
    classe?: string | null;
    compagniaAerea2?: string | null;
    classe2?: string | null;
    cambioHotel?: boolean;
    servizi?: ServizioItinerarioGiornoServizioRow[] | null;
}

export class ServizioItinerarioGiornoServizioRow implements IServizioItinerarioGiornoServizioRow {
    servizio?: ServizioItinerarioGiornoServizio | null;
    tipoServizio?: ETipoServizio;
    nomeServizio?: string | null;
    nomeTipologia?: string | null;

    constructor(data?: IServizioItinerarioGiornoServizioRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servizio = _data["servizio"] ? ServizioItinerarioGiornoServizio.fromJS(_data["servizio"]) : null as any;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
            this.nomeServizio = _data["nomeServizio"] !== undefined ? _data["nomeServizio"] : null as any;
            this.nomeTipologia = _data["nomeTipologia"] !== undefined ? _data["nomeTipologia"] : null as any;
        }
    }

    static fromJS(data: any): ServizioItinerarioGiornoServizioRow {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioItinerarioGiornoServizioRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio ? this.servizio.toJSON() : null as any;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        data["nomeServizio"] = this.nomeServizio !== undefined ? this.nomeServizio : null as any;
        data["nomeTipologia"] = this.nomeTipologia !== undefined ? this.nomeTipologia : null as any;
        return data;
    }
}

export interface IServizioItinerarioGiornoServizioRow {
    servizio?: ServizioItinerarioGiornoServizio | null;
    tipoServizio?: ETipoServizio;
    nomeServizio?: string | null;
    nomeTipologia?: string | null;
}

export class DeleteItinerarioRequest extends ServizioGetRequest implements IDeleteItinerarioRequest {
    servizioItinerarioID?: number;

    constructor(data?: IDeleteItinerarioRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioItinerarioID = _data["servizioItinerarioID"] !== undefined ? _data["servizioItinerarioID"] : null as any;
        }
    }

    static override fromJS(data: any): DeleteItinerarioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteItinerarioRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioItinerarioID"] = this.servizioItinerarioID !== undefined ? this.servizioItinerarioID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteItinerarioRequest extends IServizioGetRequest {
    servizioItinerarioID?: number;
}

export class DeletePartenzeRequest extends ServizioGetRequest implements IDeletePartenzeRequest {
    /** Data iniziale */
    start?: string;
    /** Data finale */
    stop?: string;

    constructor(data?: IDeletePartenzeRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.start = _data["start"] !== undefined ? _data["start"] : null as any;
            this.stop = _data["stop"] !== undefined ? _data["stop"] : null as any;
        }
    }

    static override fromJS(data: any): DeletePartenzeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePartenzeRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start !== undefined ? this.start : null as any;
        data["stop"] = this.stop !== undefined ? this.stop : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDeletePartenzeRequest extends IServizioGetRequest {
    /** Data iniziale */
    start?: string;
    /** Data finale */
    stop?: string;
}

export class GetRegoleServizioResponse extends OkApiResponse implements IGetRegoleServizioResponse {
    regole?: ServizioRegola[] | null;

    constructor(data?: IGetRegoleServizioResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["regole"])) {
                this.regole = [] as any;
                for (let item of _data["regole"])
                    this.regole!.push(ServizioRegola.fromJS(item));
            }
            else {
                this.regole = null as any;
            }
        }
    }

    static override fromJS(data: any): GetRegoleServizioResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegoleServizioResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.regole)) {
            data["regole"] = [];
            for (let item of this.regole)
                data["regole"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetRegoleServizioResponse extends IOkApiResponse {
    regole?: ServizioRegola[] | null;
}

export class DeleteRegolaServizioRequest extends ServizioGetRequest implements IDeleteRegolaServizioRequest {
    regolaServizioID?: number;

    constructor(data?: IDeleteRegolaServizioRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.regolaServizioID = _data["regolaServizioID"] !== undefined ? _data["regolaServizioID"] : null as any;
        }
    }

    static override fromJS(data: any): DeleteRegolaServizioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRegolaServizioRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regolaServizioID"] = this.regolaServizioID !== undefined ? this.regolaServizioID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteRegolaServizioRequest extends IServizioGetRequest {
    regolaServizioID?: number;
}

export class GetRegoleVenditaResponse extends OkApiResponse implements IGetRegoleVenditaResponse {
    regole?: RegolaVenditaRow[];

    constructor(data?: IGetRegoleVenditaResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["regole"])) {
                this.regole = [] as any;
                for (let item of _data["regole"])
                    this.regole!.push(RegolaVenditaRow.fromJS(item));
            }
            else {
                this.regole = null as any;
            }
        }
    }

    static override fromJS(data: any): GetRegoleVenditaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegoleVenditaResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.regole)) {
            data["regole"] = [];
            for (let item of this.regole)
                data["regole"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetRegoleVenditaResponse extends IOkApiResponse {
    regole?: RegolaVenditaRow[];
}

export class RegolaVenditaRow implements IRegolaVenditaRow {
    id?: number;
    nome?: string | null;
    regola?: ServizioRegolaVendita;
    testoPenale?: TripTextHtml | null;

    constructor(data?: IRegolaVenditaRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.regola = _data["regola"] ? ServizioRegolaVendita.fromJS(_data["regola"]) : null as any;
            this.testoPenale = _data["testoPenale"] ? TripTextHtml.fromJS(_data["testoPenale"]) : null as any;
        }
    }

    static fromJS(data: any): RegolaVenditaRow {
        data = typeof data === 'object' ? data : {};
        let result = new RegolaVenditaRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["regola"] = this.regola ? this.regola.toJSON() : null as any;
        data["testoPenale"] = this.testoPenale ? this.testoPenale.toJSON() : null as any;
        return data;
    }
}

export interface IRegolaVenditaRow {
    id?: number;
    nome?: string | null;
    regola?: ServizioRegolaVendita;
    testoPenale?: TripTextHtml | null;
}

export class DeleteRegolaVenditaRequest extends ServizioGetRequest implements IDeleteRegolaVenditaRequest {
    regolaVenditaID?: number;

    constructor(data?: IDeleteRegolaVenditaRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.regolaVenditaID = _data["regolaVenditaID"] !== undefined ? _data["regolaVenditaID"] : null as any;
        }
    }

    static override fromJS(data: any): DeleteRegolaVenditaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRegolaVenditaRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regolaVenditaID"] = this.regolaVenditaID !== undefined ? this.regolaVenditaID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteRegolaVenditaRequest extends IServizioGetRequest {
    regolaVenditaID?: number;
}

export class DeleteRegoleServizioRequest extends ServizioGetRequest implements IDeleteRegoleServizioRequest {
    regoleServizioIDs?: number[] | null;

    constructor(data?: IDeleteRegoleServizioRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["regoleServizioIDs"])) {
                this.regoleServizioIDs = [] as any;
                for (let item of _data["regoleServizioIDs"])
                    this.regoleServizioIDs!.push(item);
            }
            else {
                this.regoleServizioIDs = null as any;
            }
        }
    }

    static override fromJS(data: any): DeleteRegoleServizioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRegoleServizioRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.regoleServizioIDs)) {
            data["regoleServizioIDs"] = [];
            for (let item of this.regoleServizioIDs)
                data["regoleServizioIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteRegoleServizioRequest extends IServizioGetRequest {
    regoleServizioIDs?: number[] | null;
}

export class DeleteRegoleVenditaRequest extends ServizioGetRequest implements IDeleteRegoleVenditaRequest {
    regoleVenditaIDs?: number[] | null;

    constructor(data?: IDeleteRegoleVenditaRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["regoleVenditaIDs"])) {
                this.regoleVenditaIDs = [] as any;
                for (let item of _data["regoleVenditaIDs"])
                    this.regoleVenditaIDs!.push(item);
            }
            else {
                this.regoleVenditaIDs = null as any;
            }
        }
    }

    static override fromJS(data: any): DeleteRegoleVenditaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRegoleVenditaRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.regoleVenditaIDs)) {
            data["regoleVenditaIDs"] = [];
            for (let item of this.regoleVenditaIDs)
                data["regoleVenditaIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteRegoleVenditaRequest extends IServizioGetRequest {
    regoleVenditaIDs?: number[] | null;
}

export class GetTipologieResponse extends OkApiResponse implements IGetTipologieResponse {
    tipologie?: TipologiaListRow[] | null;

    constructor(data?: IGetTipologieResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tipologie"])) {
                this.tipologie = [] as any;
                for (let item of _data["tipologie"])
                    this.tipologie!.push(TipologiaListRow.fromJS(item));
            }
            else {
                this.tipologie = null as any;
            }
        }
    }

    static override fromJS(data: any): GetTipologieResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTipologieResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tipologie)) {
            data["tipologie"] = [];
            for (let item of this.tipologie)
                data["tipologie"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetTipologieResponse extends IOkApiResponse {
    tipologie?: TipologiaListRow[] | null;
}

export class TipologiaListRow implements ITipologiaListRow {
    id?: number;
    nome?: string | null;
    tipologia?: ServizioTipologia | null;

    constructor(data?: ITipologiaListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.tipologia = _data["tipologia"] ? ServizioTipologia.fromJS(_data["tipologia"]) : null as any;
        }
    }

    static fromJS(data: any): TipologiaListRow {
        data = typeof data === 'object' ? data : {};
        let result = new TipologiaListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["tipologia"] = this.tipologia ? this.tipologia.toJSON() : null as any;
        return data;
    }
}

export interface ITipologiaListRow {
    id?: number;
    nome?: string | null;
    tipologia?: ServizioTipologia | null;
}

export class GetTipologieRequest extends ServizioGetRequest implements IGetTipologieRequest {
    showDeleted?: boolean;

    constructor(data?: IGetTipologieRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.showDeleted = _data["showDeleted"] !== undefined ? _data["showDeleted"] : null as any;
        }
    }

    static override fromJS(data: any): GetTipologieRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTipologieRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showDeleted"] = this.showDeleted !== undefined ? this.showDeleted : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTipologieRequest extends IServizioGetRequest {
    showDeleted?: boolean;
}

export class DeleteTipologiaRequest extends GetTipologieRequest implements IDeleteTipologiaRequest {
    servizioTipologiaID?: number;

    constructor(data?: IDeleteTipologiaRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioTipologiaID = _data["servizioTipologiaID"] !== undefined ? _data["servizioTipologiaID"] : null as any;
        }
    }

    static override fromJS(data: any): DeleteTipologiaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTipologiaRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioTipologiaID"] = this.servizioTipologiaID !== undefined ? this.servizioTipologiaID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteTipologiaRequest extends IGetTipologieRequest {
    servizioTipologiaID?: number;
}

export class DeleteTipologieRequest extends GetTipologieRequest implements IDeleteTipologieRequest {
    tipologieIDs?: number[] | null;

    constructor(data?: IDeleteTipologieRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tipologieIDs"])) {
                this.tipologieIDs = [] as any;
                for (let item of _data["tipologieIDs"])
                    this.tipologieIDs!.push(item);
            }
            else {
                this.tipologieIDs = null as any;
            }
        }
    }

    static override fromJS(data: any): DeleteTipologieRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTipologieRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tipologieIDs)) {
            data["tipologieIDs"] = [];
            for (let item of this.tipologieIDs)
                data["tipologieIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteTipologieRequest extends IGetTipologieRequest {
    tipologieIDs?: number[] | null;
}

export class DeleteValiditaRequest extends ServizioGetRequest implements IDeleteValiditaRequest {
    validitaID?: number;

    constructor(data?: IDeleteValiditaRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validitaID = _data["validitaID"] !== undefined ? _data["validitaID"] : null as any;
        }
    }

    static override fromJS(data: any): DeleteValiditaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteValiditaRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validitaID"] = this.validitaID !== undefined ? this.validitaID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteValiditaRequest extends IServizioGetRequest {
    validitaID?: number;
}

export class DeleteServiceValiditiesRequest extends ServizioGetRequest implements IDeleteServiceValiditiesRequest {
    serviceValiditiesIDs?: number[] | null;

    constructor(data?: IDeleteServiceValiditiesRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["serviceValiditiesIDs"])) {
                this.serviceValiditiesIDs = [] as any;
                for (let item of _data["serviceValiditiesIDs"])
                    this.serviceValiditiesIDs!.push(item);
            }
            else {
                this.serviceValiditiesIDs = null as any;
            }
        }
    }

    static override fromJS(data: any): DeleteServiceValiditiesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteServiceValiditiesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.serviceValiditiesIDs)) {
            data["serviceValiditiesIDs"] = [];
            for (let item of this.serviceValiditiesIDs)
                data["serviceValiditiesIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteServiceValiditiesRequest extends IServizioGetRequest {
    serviceValiditiesIDs?: number[] | null;
}

export class GetAccordiServizioResponse extends OkApiResponse implements IGetAccordiServizioResponse {
    accordi?: ServizioAccordoRow[];

    constructor(data?: IGetAccordiServizioResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["accordi"])) {
                this.accordi = [] as any;
                for (let item of _data["accordi"])
                    this.accordi!.push(ServizioAccordoRow.fromJS(item));
            }
            else {
                this.accordi = null as any;
            }
        }
    }

    static override fromJS(data: any): GetAccordiServizioResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccordiServizioResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accordi)) {
            data["accordi"] = [];
            for (let item of this.accordi)
                data["accordi"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetAccordiServizioResponse extends IOkApiResponse {
    accordi?: ServizioAccordoRow[];
}

export class ServizioAccordoRow implements IServizioAccordoRow {
    /** ID dell'accordo */
    accordoID?: number;
    /** Nome dell'accordo */
    nome?: string;
    /** True se l'accordo è scaduto */
    scaduto?: boolean;

    constructor(data?: IServizioAccordoRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.scaduto = _data["scaduto"] !== undefined ? _data["scaduto"] : null as any;
        }
    }

    static fromJS(data: any): ServizioAccordoRow {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioAccordoRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["scaduto"] = this.scaduto !== undefined ? this.scaduto : null as any;
        return data;
    }
}

export interface IServizioAccordoRow {
    /** ID dell'accordo */
    accordoID?: number;
    /** Nome dell'accordo */
    nome?: string;
    /** True se l'accordo è scaduto */
    scaduto?: boolean;
}

export class GetArticoliServizioResponse extends OkApiResponse implements IGetArticoliServizioResponse {
    articoli?: ArticoloServizio[];

    constructor(data?: IGetArticoliServizioResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["articoli"])) {
                this.articoli = [] as any;
                for (let item of _data["articoli"])
                    this.articoli!.push(ArticoloServizio.fromJS(item));
            }
            else {
                this.articoli = null as any;
            }
        }
    }

    static override fromJS(data: any): GetArticoliServizioResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetArticoliServizioResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.articoli)) {
            data["articoli"] = [];
            for (let item of this.articoli)
                data["articoli"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetArticoliServizioResponse extends IOkApiResponse {
    articoli?: ArticoloServizio[];
}

export class ArticoloServizio implements IArticoloServizio {
    id?: number;
    /** Titolo nella lingua dell'utente */
    titolo?: string | null;
    /** Sunto nella lingua dell'utente */
    sunto?: string | null;
    /** Testo nella lingua dell'utente */
    testo?: string;
    giorno?: number;
    ordine?: number;
    /** Concatenazione ordinabile di giorno / ordine / priorità */
    ordineAssoluto?: string;
    /** Data di inizio pubblicazione se prevista */
    pubblicatoDal?: string | null;
    /** Data di fine pubblicazione se prevista */
    pubblicatoAl?: string | null;
    pubblicaWeb?: boolean;
    pubblicaOfferta?: boolean;
    pubblicaPreventivo?: boolean;
    pubblicaProgramma?: boolean;
    pubblicaVoucher?: boolean;
    pubblicaEstrattoConto?: boolean;
    categoria?: ECategoriaArticolo | null;
    intestazione?: string | null;
    articolo?: Articolo;

    constructor(data?: IArticoloServizio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : null as any;
            this.sunto = _data["sunto"] !== undefined ? _data["sunto"] : null as any;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : null as any;
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.ordineAssoluto = _data["ordineAssoluto"] !== undefined ? _data["ordineAssoluto"] : null as any;
            this.pubblicatoDal = _data["pubblicatoDal"] !== undefined ? _data["pubblicatoDal"] : null as any;
            this.pubblicatoAl = _data["pubblicatoAl"] !== undefined ? _data["pubblicatoAl"] : null as any;
            this.pubblicaWeb = _data["pubblicaWeb"] !== undefined ? _data["pubblicaWeb"] : null as any;
            this.pubblicaOfferta = _data["pubblicaOfferta"] !== undefined ? _data["pubblicaOfferta"] : null as any;
            this.pubblicaPreventivo = _data["pubblicaPreventivo"] !== undefined ? _data["pubblicaPreventivo"] : null as any;
            this.pubblicaProgramma = _data["pubblicaProgramma"] !== undefined ? _data["pubblicaProgramma"] : null as any;
            this.pubblicaVoucher = _data["pubblicaVoucher"] !== undefined ? _data["pubblicaVoucher"] : null as any;
            this.pubblicaEstrattoConto = _data["pubblicaEstrattoConto"] !== undefined ? _data["pubblicaEstrattoConto"] : null as any;
            this.categoria = _data["categoria"] !== undefined ? _data["categoria"] : null as any;
            this.intestazione = _data["intestazione"] !== undefined ? _data["intestazione"] : null as any;
            this.articolo = _data["articolo"] ? Articolo.fromJS(_data["articolo"]) : null as any;
        }
    }

    static fromJS(data: any): ArticoloServizio {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloServizio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["titolo"] = this.titolo !== undefined ? this.titolo : null as any;
        data["sunto"] = this.sunto !== undefined ? this.sunto : null as any;
        data["testo"] = this.testo !== undefined ? this.testo : null as any;
        data["giorno"] = this.giorno !== undefined ? this.giorno : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["ordineAssoluto"] = this.ordineAssoluto !== undefined ? this.ordineAssoluto : null as any;
        data["pubblicatoDal"] = this.pubblicatoDal !== undefined ? this.pubblicatoDal : null as any;
        data["pubblicatoAl"] = this.pubblicatoAl !== undefined ? this.pubblicatoAl : null as any;
        data["pubblicaWeb"] = this.pubblicaWeb !== undefined ? this.pubblicaWeb : null as any;
        data["pubblicaOfferta"] = this.pubblicaOfferta !== undefined ? this.pubblicaOfferta : null as any;
        data["pubblicaPreventivo"] = this.pubblicaPreventivo !== undefined ? this.pubblicaPreventivo : null as any;
        data["pubblicaProgramma"] = this.pubblicaProgramma !== undefined ? this.pubblicaProgramma : null as any;
        data["pubblicaVoucher"] = this.pubblicaVoucher !== undefined ? this.pubblicaVoucher : null as any;
        data["pubblicaEstrattoConto"] = this.pubblicaEstrattoConto !== undefined ? this.pubblicaEstrattoConto : null as any;
        data["categoria"] = this.categoria !== undefined ? this.categoria : null as any;
        data["intestazione"] = this.intestazione !== undefined ? this.intestazione : null as any;
        data["articolo"] = this.articolo ? this.articolo.toJSON() : null as any;
        return data;
    }
}

export interface IArticoloServizio {
    id?: number;
    /** Titolo nella lingua dell'utente */
    titolo?: string | null;
    /** Sunto nella lingua dell'utente */
    sunto?: string | null;
    /** Testo nella lingua dell'utente */
    testo?: string;
    giorno?: number;
    ordine?: number;
    /** Concatenazione ordinabile di giorno / ordine / priorità */
    ordineAssoluto?: string;
    /** Data di inizio pubblicazione se prevista */
    pubblicatoDal?: string | null;
    /** Data di fine pubblicazione se prevista */
    pubblicatoAl?: string | null;
    pubblicaWeb?: boolean;
    pubblicaOfferta?: boolean;
    pubblicaPreventivo?: boolean;
    pubblicaProgramma?: boolean;
    pubblicaVoucher?: boolean;
    pubblicaEstrattoConto?: boolean;
    categoria?: ECategoriaArticolo | null;
    intestazione?: string | null;
    articolo?: Articolo;
}

export class GetDatiAggiuntiviResponse extends OkApiResponse implements IGetDatiAggiuntiviResponse {
    /** Elenco dei valori di dati aggiuntivi */
    dati?: DatoAggiuntivoServizioValoreRow[];

    constructor(data?: IGetDatiAggiuntiviResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["dati"])) {
                this.dati = [] as any;
                for (let item of _data["dati"])
                    this.dati!.push(DatoAggiuntivoServizioValoreRow.fromJS(item));
            }
            else {
                this.dati = null as any;
            }
        }
    }

    static override fromJS(data: any): GetDatiAggiuntiviResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDatiAggiuntiviResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dati)) {
            data["dati"] = [];
            for (let item of this.dati)
                data["dati"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetDatiAggiuntiviResponse extends IOkApiResponse {
    /** Elenco dei valori di dati aggiuntivi */
    dati?: DatoAggiuntivoServizioValoreRow[];
}

export class DatoAggiuntivoServizioValoreRow implements IDatoAggiuntivoServizioValoreRow {
    /** ID del tipo di dato, per recuperare l'intestazione e fare raggruppamento */
    tipoDatoID?: number;
    /** Entità con i valori specifici */
    valore?: ServizioDatoAggiuntivo;

    constructor(data?: IDatoAggiuntivoServizioValoreRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoDatoID = _data["tipoDatoID"] !== undefined ? _data["tipoDatoID"] : null as any;
            this.valore = _data["valore"] ? ServizioDatoAggiuntivo.fromJS(_data["valore"]) : null as any;
        }
    }

    static fromJS(data: any): DatoAggiuntivoServizioValoreRow {
        data = typeof data === 'object' ? data : {};
        let result = new DatoAggiuntivoServizioValoreRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoDatoID"] = this.tipoDatoID !== undefined ? this.tipoDatoID : null as any;
        data["valore"] = this.valore ? this.valore.toJSON() : null as any;
        return data;
    }
}

export interface IDatoAggiuntivoServizioValoreRow {
    /** ID del tipo di dato, per recuperare l'intestazione e fare raggruppamento */
    tipoDatoID?: number;
    /** Entità con i valori specifici */
    valore?: ServizioDatoAggiuntivo;
}

export class GetDestinationsListResponse extends OkApiResponse implements IGetDestinationsListResponse {
    destinationsAreas?: DestinationGroupRow[];

    constructor(data?: IGetDestinationsListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["destinationsAreas"])) {
                this.destinationsAreas = [] as any;
                for (let item of _data["destinationsAreas"])
                    this.destinationsAreas!.push(DestinationGroupRow.fromJS(item));
            }
            else {
                this.destinationsAreas = null as any;
            }
        }
    }

    static override fromJS(data: any): GetDestinationsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDestinationsListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.destinationsAreas)) {
            data["destinationsAreas"] = [];
            for (let item of this.destinationsAreas)
                data["destinationsAreas"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetDestinationsListResponse extends IOkApiResponse {
    destinationsAreas?: DestinationGroupRow[];
}

export class DestinationRow implements IDestinationRow {
    id?: number;
    name?: string;
    cover?: string | null;
    servicesCount?: number;
    isFavorite?: boolean;
    isExpertDestination?: boolean;

    constructor(data?: IDestinationRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.cover = _data["cover"] !== undefined ? _data["cover"] : null as any;
            this.servicesCount = _data["servicesCount"] !== undefined ? _data["servicesCount"] : null as any;
            this.isFavorite = _data["isFavorite"] !== undefined ? _data["isFavorite"] : null as any;
            this.isExpertDestination = _data["isExpertDestination"] !== undefined ? _data["isExpertDestination"] : null as any;
        }
    }

    static fromJS(data: any): DestinationRow {
        data = typeof data === 'object' ? data : {};
        let result = new DestinationRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["cover"] = this.cover !== undefined ? this.cover : null as any;
        data["servicesCount"] = this.servicesCount !== undefined ? this.servicesCount : null as any;
        data["isFavorite"] = this.isFavorite !== undefined ? this.isFavorite : null as any;
        data["isExpertDestination"] = this.isExpertDestination !== undefined ? this.isExpertDestination : null as any;
        return data;
    }
}

export interface IDestinationRow {
    id?: number;
    name?: string;
    cover?: string | null;
    servicesCount?: number;
    isFavorite?: boolean;
    isExpertDestination?: boolean;
}

export class DestinationGroupRow extends DestinationRow implements IDestinationGroupRow {
    destinations?: DestinationRow[];

    constructor(data?: IDestinationGroupRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["destinations"])) {
                this.destinations = [] as any;
                for (let item of _data["destinations"])
                    this.destinations!.push(DestinationRow.fromJS(item));
            }
            else {
                this.destinations = null as any;
            }
        }
    }

    static override fromJS(data: any): DestinationGroupRow {
        data = typeof data === 'object' ? data : {};
        let result = new DestinationGroupRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.destinations)) {
            data["destinations"] = [];
            for (let item of this.destinations)
                data["destinations"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDestinationGroupRow extends IDestinationRow {
    destinations?: DestinationRow[];
}

export class GetDestinationsListRequest extends SiteRequest implements IGetDestinationsListRequest {

    constructor(data?: IGetDestinationsListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetDestinationsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDestinationsListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetDestinationsListRequest extends ISiteRequest {
}

export class GetInsurancesResponse extends OkApiResponse implements IGetInsurancesResponse {
    assicurazioni?: Insurance[] | null;

    constructor(data?: IGetInsurancesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["assicurazioni"])) {
                this.assicurazioni = [] as any;
                for (let item of _data["assicurazioni"])
                    this.assicurazioni!.push(Insurance.fromJS(item));
            }
            else {
                this.assicurazioni = null as any;
            }
        }
    }

    static override fromJS(data: any): GetInsurancesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInsurancesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assicurazioni)) {
            data["assicurazioni"] = [];
            for (let item of this.assicurazioni)
                data["assicurazioni"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetInsurancesResponse extends IOkApiResponse {
    assicurazioni?: Insurance[] | null;
}

export class Insurance implements IInsurance {
    servizio?: EServizioAutomatico;
    nome?: string | null;
    descrizione?: string | null;
    allegati?: ArticoloAllegato[] | null;
    consentiSceltaAbbinamento?: boolean;

    constructor(data?: IInsurance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            if (Array.isArray(_data["allegati"])) {
                this.allegati = [] as any;
                for (let item of _data["allegati"])
                    this.allegati!.push(ArticoloAllegato.fromJS(item));
            }
            else {
                this.allegati = null as any;
            }
            this.consentiSceltaAbbinamento = _data["consentiSceltaAbbinamento"] !== undefined ? _data["consentiSceltaAbbinamento"] : null as any;
        }
    }

    static fromJS(data: any): Insurance {
        data = typeof data === 'object' ? data : {};
        let result = new Insurance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio !== undefined ? this.servizio : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        if (Array.isArray(this.allegati)) {
            data["allegati"] = [];
            for (let item of this.allegati)
                data["allegati"].push(item ? item.toJSON() : null as any);
        }
        data["consentiSceltaAbbinamento"] = this.consentiSceltaAbbinamento !== undefined ? this.consentiSceltaAbbinamento : null as any;
        return data;
    }
}

export interface IInsurance {
    servizio?: EServizioAutomatico;
    nome?: string | null;
    descrizione?: string | null;
    allegati?: ArticoloAllegato[] | null;
    consentiSceltaAbbinamento?: boolean;
}

export class GetItinerariRequest extends ServizioGetRequest implements IGetItinerariRequest {
    includiDati?: boolean;

    constructor(data?: IGetItinerariRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.includiDati = _data["includiDati"] !== undefined ? _data["includiDati"] : null as any;
        }
    }

    static override fromJS(data: any): GetItinerariRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetItinerariRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includiDati"] = this.includiDati !== undefined ? this.includiDati : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetItinerariRequest extends IServizioGetRequest {
    includiDati?: boolean;
}

export class GetLuoghiServizioResponse extends OkApiResponse implements IGetLuoghiServizioResponse {
    /** Elenco dei luoghi del servizio */
    luoghi?: ServizioLuogoView[];

    constructor(data?: IGetLuoghiServizioResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["luoghi"])) {
                this.luoghi = [] as any;
                for (let item of _data["luoghi"])
                    this.luoghi!.push(ServizioLuogoView.fromJS(item));
            }
            else {
                this.luoghi = null as any;
            }
        }
    }

    static override fromJS(data: any): GetLuoghiServizioResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLuoghiServizioResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.luoghi)) {
            data["luoghi"] = [];
            for (let item of this.luoghi)
                data["luoghi"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetLuoghiServizioResponse extends IOkApiResponse {
    /** Elenco dei luoghi del servizio */
    luoghi?: ServizioLuogoView[];
}

export class ServizioLuogoView implements IServizioLuogoView {
    /** ID del luogo associato */
    luogoID?: number;
    /** Nome del luogo associato */
    luogo?: string;
    /** Nome della regione del luogo associato */
    regione?: string | null;
    /** Nome del paese del luogo associato */
    paese?: string | null;

    constructor(data?: IServizioLuogoView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.regione = _data["regione"] !== undefined ? _data["regione"] : null as any;
            this.paese = _data["paese"] !== undefined ? _data["paese"] : null as any;
        }
    }

    static fromJS(data: any): ServizioLuogoView {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioLuogoView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["regione"] = this.regione !== undefined ? this.regione : null as any;
        data["paese"] = this.paese !== undefined ? this.paese : null as any;
        return data;
    }
}

export interface IServizioLuogoView {
    /** ID del luogo associato */
    luogoID?: number;
    /** Nome del luogo associato */
    luogo?: string;
    /** Nome della regione del luogo associato */
    regione?: string | null;
    /** Nome del paese del luogo associato */
    paese?: string | null;
}

export class GetPublishedServiceResponse extends OkApiResponse implements IGetPublishedServiceResponse {
    servizio?: ServiceData | null;

    constructor(data?: IGetPublishedServiceResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizio = _data["servizio"] ? ServiceData.fromJS(_data["servizio"]) : null as any;
        }
    }

    static override fromJS(data: any): GetPublishedServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublishedServiceResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio ? this.servizio.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPublishedServiceResponse extends IOkApiResponse {
    servizio?: ServiceData | null;
}

export class GetPublishedServiceRequest extends SiteRequest implements IGetPublishedServiceRequest {
    /** ID del servizio Naar (se Esterno � false) oppure del servizio hh */
    servizioID?: number;
    /** Se true � un servizio hh, altrimenti un servizio Naar */
    esterno?: boolean;
    /** Tipo di articoli da utilizzare */
    tipoArticoliRichiesti?: ETipoArticoliRichiesti;

    constructor(data?: IGetPublishedServiceRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.esterno = _data["esterno"] !== undefined ? _data["esterno"] : null as any;
            this.tipoArticoliRichiesti = _data["tipoArticoliRichiesti"] !== undefined ? _data["tipoArticoliRichiesti"] : null as any;
        }
    }

    static override fromJS(data: any): GetPublishedServiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublishedServiceRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["esterno"] = this.esterno !== undefined ? this.esterno : null as any;
        data["tipoArticoliRichiesti"] = this.tipoArticoliRichiesti !== undefined ? this.tipoArticoliRichiesti : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPublishedServiceRequest extends ISiteRequest {
    /** ID del servizio Naar (se Esterno � false) oppure del servizio hh */
    servizioID?: number;
    /** Se true � un servizio hh, altrimenti un servizio Naar */
    esterno?: boolean;
    /** Tipo di articoli da utilizzare */
    tipoArticoliRichiesti?: ETipoArticoliRichiesti;
}

export enum ETipoArticoliRichiesti {
    PreferTraducibili = "preferTraducibili",
    SoloTraducibili = "soloTraducibili",
    SoloCanonici = "soloCanonici",
    Tutti = "tutti",
}

export class GetTabelleCostiAssociateResponse extends OkApiResponse implements IGetTabelleCostiAssociateResponse {
    tabelle?: TabellaCostoListRow[];

    constructor(data?: IGetTabelleCostiAssociateResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tabelle"])) {
                this.tabelle = [] as any;
                for (let item of _data["tabelle"])
                    this.tabelle!.push(TabellaCostoListRow.fromJS(item));
            }
            else {
                this.tabelle = null as any;
            }
        }
    }

    static override fromJS(data: any): GetTabelleCostiAssociateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTabelleCostiAssociateResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tabelle)) {
            data["tabelle"] = [];
            for (let item of this.tabelle)
                data["tabelle"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetTabelleCostiAssociateResponse extends IOkApiResponse {
    tabelle?: TabellaCostoListRow[];
}

export class TabellaCostoListRow implements ITabellaCostoListRow {
    id?: number;
    accordoID?: number;
    accordo?: string;
    accordoScaduto?: boolean;
    tabella?: string;
    tabellaScaduta?: boolean;
    dal?: string;
    al?: string;
    codiceValuta?: string | null;
    ordine?: number | null;

    constructor(data?: ITabellaCostoListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.accordo = _data["accordo"] !== undefined ? _data["accordo"] : null as any;
            this.accordoScaduto = _data["accordoScaduto"] !== undefined ? _data["accordoScaduto"] : null as any;
            this.tabella = _data["tabella"] !== undefined ? _data["tabella"] : null as any;
            this.tabellaScaduta = _data["tabellaScaduta"] !== undefined ? _data["tabellaScaduta"] : null as any;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.al = _data["al"] !== undefined ? _data["al"] : null as any;
            this.codiceValuta = _data["codiceValuta"] !== undefined ? _data["codiceValuta"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
        }
    }

    static fromJS(data: any): TabellaCostoListRow {
        data = typeof data === 'object' ? data : {};
        let result = new TabellaCostoListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["accordo"] = this.accordo !== undefined ? this.accordo : null as any;
        data["accordoScaduto"] = this.accordoScaduto !== undefined ? this.accordoScaduto : null as any;
        data["tabella"] = this.tabella !== undefined ? this.tabella : null as any;
        data["tabellaScaduta"] = this.tabellaScaduta !== undefined ? this.tabellaScaduta : null as any;
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["al"] = this.al !== undefined ? this.al : null as any;
        data["codiceValuta"] = this.codiceValuta !== undefined ? this.codiceValuta : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        return data;
    }
}

export interface ITabellaCostoListRow {
    id?: number;
    accordoID?: number;
    accordo?: string;
    accordoScaduto?: boolean;
    tabella?: string;
    tabellaScaduta?: boolean;
    dal?: string;
    al?: string;
    codiceValuta?: string | null;
    ordine?: number | null;
}

export class GetTypesResponse extends OkApiResponse implements IGetTypesResponse {
    tipologie?: TipologiaTradotta[] | null;

    constructor(data?: IGetTypesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tipologie"])) {
                this.tipologie = [] as any;
                for (let item of _data["tipologie"])
                    this.tipologie!.push(TipologiaTradotta.fromJS(item));
            }
            else {
                this.tipologie = null as any;
            }
        }
    }

    static override fromJS(data: any): GetTypesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTypesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tipologie)) {
            data["tipologie"] = [];
            for (let item of this.tipologie)
                data["tipologie"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetTypesResponse extends IOkApiResponse {
    tipologie?: TipologiaTradotta[] | null;
}

export class TipologiaTradotta implements ITipologiaTradotta {
    tipologia?: ServizioTipologia | null;
    nome?: string | null;

    constructor(data?: ITipologiaTradotta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipologia = _data["tipologia"] ? ServizioTipologia.fromJS(_data["tipologia"]) : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
        }
    }

    static fromJS(data: any): TipologiaTradotta {
        data = typeof data === 'object' ? data : {};
        let result = new TipologiaTradotta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipologia"] = this.tipologia ? this.tipologia.toJSON() : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        return data;
    }
}

export interface ITipologiaTradotta {
    tipologia?: ServizioTipologia | null;
    nome?: string | null;
}

export class GetTypesRequest extends SiteRequest implements IGetTypesRequest {
    servizioID?: number;

    constructor(data?: IGetTypesRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
        }
    }

    static override fromJS(data: any): GetTypesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTypesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTypesRequest extends ISiteRequest {
    servizioID?: number;
}

export class InsertCostiRequest extends ServizioGetRequest implements IInsertCostiRequest {
    /** Regola di inserimento dei costi per maneggiare i dati */
    regola?: ERegolaInserimentoCosti;
    /** ID del trattamento, se specificato */
    trattamentoID?: number | null;
    /** ID della regola servizio, se specificata */
    regolaServizioID?: number | null;
    /** ID della regola vendita, se specificata */
    regolaVenditaID?: number | null;
    /** Codice prenotazione facoltativo */
    codicePrenotazione?: string | null;
    /** Regola inserimento costi bambino, se richiesta */
    regolaCostiBambino?: ERegolaCostiBambino;
    /** Età bambino. Obbligatoria se presente la regola costi bambino, ignorata altrimenti */
    etaChild?: number | null;
    /** Se si stanno inserendo i costi bambino considera i valori come sconti percentuali sulle corrispondenti tipologie */
    scontoChildPercentuale?: boolean;
    /** ID delle tabelle costo da associare. Almeno una */
    tabelleCostoIDs?: number[];
    /** ID delle tipologie da associare. Almeno una */
    tipologieIDs?: number[];
    /** ID delle validità da associare. Almeno una */
    validitaIDs?: number[];
    /** ID bedding associato al costo 1 */
    beddingID1?: number | null;
    /** Costo associato al bedding 1, obbligatorio se presente */
    costo1?: number | null;
    /** ID bedding associato al costo 2 */
    beddingID2?: number | null;
    /** Costo associato al bedding 2, obbligatorio se presente */
    costo2?: number | null;
    /** ID bedding associato al costo 3 */
    beddingID3?: number | null;
    /** Costo associato al bedding 3, obbligatorio se presente */
    costo3?: number | null;
    /** ID bedding associato al costo 4 */
    beddingID4?: number | null;
    /** Costo associato al bedding 4, obbligatorio se presente */
    costo4?: number | null;
    /** ID bedding associato al costo 5 */
    beddingID5?: number | null;
    /** Costo associato al bedding 1. Viene inserito comunque indipendentemente dal bedding */
    costo5?: number | null;
    /** ID aggiuntivo per la gestione delle regole di inserimento costi 9, 10 e 12 */
    extraID?: number | null;

    constructor(data?: IInsertCostiRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.regola = _data["regola"] !== undefined ? _data["regola"] : null as any;
            this.trattamentoID = _data["trattamentoID"] !== undefined ? _data["trattamentoID"] : null as any;
            this.regolaServizioID = _data["regolaServizioID"] !== undefined ? _data["regolaServizioID"] : null as any;
            this.regolaVenditaID = _data["regolaVenditaID"] !== undefined ? _data["regolaVenditaID"] : null as any;
            this.codicePrenotazione = _data["codicePrenotazione"] !== undefined ? _data["codicePrenotazione"] : null as any;
            this.regolaCostiBambino = _data["regolaCostiBambino"] !== undefined ? _data["regolaCostiBambino"] : null as any;
            this.etaChild = _data["etaChild"] !== undefined ? _data["etaChild"] : null as any;
            this.scontoChildPercentuale = _data["scontoChildPercentuale"] !== undefined ? _data["scontoChildPercentuale"] : null as any;
            if (Array.isArray(_data["tabelleCostoIDs"])) {
                this.tabelleCostoIDs = [] as any;
                for (let item of _data["tabelleCostoIDs"])
                    this.tabelleCostoIDs!.push(item);
            }
            else {
                this.tabelleCostoIDs = null as any;
            }
            if (Array.isArray(_data["tipologieIDs"])) {
                this.tipologieIDs = [] as any;
                for (let item of _data["tipologieIDs"])
                    this.tipologieIDs!.push(item);
            }
            else {
                this.tipologieIDs = null as any;
            }
            if (Array.isArray(_data["validitaIDs"])) {
                this.validitaIDs = [] as any;
                for (let item of _data["validitaIDs"])
                    this.validitaIDs!.push(item);
            }
            else {
                this.validitaIDs = null as any;
            }
            this.beddingID1 = _data["beddingID1"] !== undefined ? _data["beddingID1"] : null as any;
            this.costo1 = _data["costo1"] !== undefined ? _data["costo1"] : null as any;
            this.beddingID2 = _data["beddingID2"] !== undefined ? _data["beddingID2"] : null as any;
            this.costo2 = _data["costo2"] !== undefined ? _data["costo2"] : null as any;
            this.beddingID3 = _data["beddingID3"] !== undefined ? _data["beddingID3"] : null as any;
            this.costo3 = _data["costo3"] !== undefined ? _data["costo3"] : null as any;
            this.beddingID4 = _data["beddingID4"] !== undefined ? _data["beddingID4"] : null as any;
            this.costo4 = _data["costo4"] !== undefined ? _data["costo4"] : null as any;
            this.beddingID5 = _data["beddingID5"] !== undefined ? _data["beddingID5"] : null as any;
            this.costo5 = _data["costo5"] !== undefined ? _data["costo5"] : null as any;
            this.extraID = _data["extraID"] !== undefined ? _data["extraID"] : null as any;
        }
    }

    static override fromJS(data: any): InsertCostiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertCostiRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regola"] = this.regola !== undefined ? this.regola : null as any;
        data["trattamentoID"] = this.trattamentoID !== undefined ? this.trattamentoID : null as any;
        data["regolaServizioID"] = this.regolaServizioID !== undefined ? this.regolaServizioID : null as any;
        data["regolaVenditaID"] = this.regolaVenditaID !== undefined ? this.regolaVenditaID : null as any;
        data["codicePrenotazione"] = this.codicePrenotazione !== undefined ? this.codicePrenotazione : null as any;
        data["regolaCostiBambino"] = this.regolaCostiBambino !== undefined ? this.regolaCostiBambino : null as any;
        data["etaChild"] = this.etaChild !== undefined ? this.etaChild : null as any;
        data["scontoChildPercentuale"] = this.scontoChildPercentuale !== undefined ? this.scontoChildPercentuale : null as any;
        if (Array.isArray(this.tabelleCostoIDs)) {
            data["tabelleCostoIDs"] = [];
            for (let item of this.tabelleCostoIDs)
                data["tabelleCostoIDs"].push(item);
        }
        if (Array.isArray(this.tipologieIDs)) {
            data["tipologieIDs"] = [];
            for (let item of this.tipologieIDs)
                data["tipologieIDs"].push(item);
        }
        if (Array.isArray(this.validitaIDs)) {
            data["validitaIDs"] = [];
            for (let item of this.validitaIDs)
                data["validitaIDs"].push(item);
        }
        data["beddingID1"] = this.beddingID1 !== undefined ? this.beddingID1 : null as any;
        data["costo1"] = this.costo1 !== undefined ? this.costo1 : null as any;
        data["beddingID2"] = this.beddingID2 !== undefined ? this.beddingID2 : null as any;
        data["costo2"] = this.costo2 !== undefined ? this.costo2 : null as any;
        data["beddingID3"] = this.beddingID3 !== undefined ? this.beddingID3 : null as any;
        data["costo3"] = this.costo3 !== undefined ? this.costo3 : null as any;
        data["beddingID4"] = this.beddingID4 !== undefined ? this.beddingID4 : null as any;
        data["costo4"] = this.costo4 !== undefined ? this.costo4 : null as any;
        data["beddingID5"] = this.beddingID5 !== undefined ? this.beddingID5 : null as any;
        data["costo5"] = this.costo5 !== undefined ? this.costo5 : null as any;
        data["extraID"] = this.extraID !== undefined ? this.extraID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IInsertCostiRequest extends IServizioGetRequest {
    /** Regola di inserimento dei costi per maneggiare i dati */
    regola?: ERegolaInserimentoCosti;
    /** ID del trattamento, se specificato */
    trattamentoID?: number | null;
    /** ID della regola servizio, se specificata */
    regolaServizioID?: number | null;
    /** ID della regola vendita, se specificata */
    regolaVenditaID?: number | null;
    /** Codice prenotazione facoltativo */
    codicePrenotazione?: string | null;
    /** Regola inserimento costi bambino, se richiesta */
    regolaCostiBambino?: ERegolaCostiBambino;
    /** Età bambino. Obbligatoria se presente la regola costi bambino, ignorata altrimenti */
    etaChild?: number | null;
    /** Se si stanno inserendo i costi bambino considera i valori come sconti percentuali sulle corrispondenti tipologie */
    scontoChildPercentuale?: boolean;
    /** ID delle tabelle costo da associare. Almeno una */
    tabelleCostoIDs?: number[];
    /** ID delle tipologie da associare. Almeno una */
    tipologieIDs?: number[];
    /** ID delle validità da associare. Almeno una */
    validitaIDs?: number[];
    /** ID bedding associato al costo 1 */
    beddingID1?: number | null;
    /** Costo associato al bedding 1, obbligatorio se presente */
    costo1?: number | null;
    /** ID bedding associato al costo 2 */
    beddingID2?: number | null;
    /** Costo associato al bedding 2, obbligatorio se presente */
    costo2?: number | null;
    /** ID bedding associato al costo 3 */
    beddingID3?: number | null;
    /** Costo associato al bedding 3, obbligatorio se presente */
    costo3?: number | null;
    /** ID bedding associato al costo 4 */
    beddingID4?: number | null;
    /** Costo associato al bedding 4, obbligatorio se presente */
    costo4?: number | null;
    /** ID bedding associato al costo 5 */
    beddingID5?: number | null;
    /** Costo associato al bedding 1. Viene inserito comunque indipendentemente dal bedding */
    costo5?: number | null;
    /** ID aggiuntivo per la gestione delle regole di inserimento costi 9, 10 e 12 */
    extraID?: number | null;
}

export enum ERegolaInserimentoCosti {
    Nessuna = "Nessuna",
    SingolaDoppiaTriplaQuadruplaPerPax = "SingolaDoppiaTriplaQuadruplaPerPax",
    SingolaDoppiaPerCameraSupplementoTriplaQuadruplaPerPax = "SingolaDoppiaPerCameraSupplementoTriplaQuadruplaPerPax",
    DoppiaPerPaxSupplementoSingolaRiduzioneTriplaQuadruplaPerPax = "DoppiaPerPaxSupplementoSingolaRiduzioneTriplaQuadruplaPerPax",
    DoppiaTriplaQuadruplaPerPaxSupplementoSingolaPerPax = "DoppiaTriplaQuadruplaPerPaxSupplementoSingolaPerPax",
    DoppiaPerPaxSupplementoSingolaPerTriplaQuadruplaPerPax = "DoppiaPerPaxSupplementoSingolaPerTriplaQuadruplaPerPax",
    DoppiaPerPaxSupplementoSingolaTriplaQuadruplaPerPax = "DoppiaPerPaxSupplementoSingolaTriplaQuadruplaPerPax",
    DoppiaPerPaxSupplementoSingolaGlobaleRiduzioneTerzoQuartoLettoPerc = "DoppiaPerPaxSupplementoSingolaGlobaleRiduzioneTerzoQuartoLettoPerc",
    DoppiaPerPaxSupplementoSingolaPercRiduzioneTerzoQuartoLettoPerc = "DoppiaPerPaxSupplementoSingolaPercRiduzioneTerzoQuartoLettoPerc",
    SupplementoSuTipologiaGlobale = "SupplementoSuTipologiaGlobale",
    SupplementoSuTipologiaPerPax = "SupplementoSuTipologiaPerPax",
    DoppiaPerPaxSupplementoSingolaRiduzioneTerzoQuartoLetto = "DoppiaPerPaxSupplementoSingolaRiduzioneTerzoQuartoLetto",
    SupplementoSuTrattamentoBasePerPax = "SupplementoSuTrattamentoBasePerPax",
    DoppiaPerPaxSupplementoSingolaTriplaQuadruplaGlobale = "DoppiaPerPaxSupplementoSingolaTriplaQuadruplaGlobale",
    SingolaDoppiaPerPaxSupplementoTriplaQuadruplaGlobale = "SingolaDoppiaPerPaxSupplementoTriplaQuadruplaGlobale",
}

export class InsertTipologiaStandardRequest extends ApiRequest implements IInsertTipologiaStandardRequest {
    nome?: string | null;
    nome_en?: string | null;
    eTipoServizio?: ETipoServizio;

    constructor(data?: IInsertTipologiaStandardRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : null as any;
            this.eTipoServizio = _data["eTipoServizio"] !== undefined ? _data["eTipoServizio"] : null as any;
        }
    }

    static override fromJS(data: any): InsertTipologiaStandardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertTipologiaStandardRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : null as any;
        data["eTipoServizio"] = this.eTipoServizio !== undefined ? this.eTipoServizio : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IInsertTipologiaStandardRequest extends IApiRequest {
    nome?: string | null;
    nome_en?: string | null;
    eTipoServizio?: ETipoServizio;
}

export class NrTableResponseOfAPI_ServiceGetRow extends OkApiResponse implements INrTableResponseOfAPI_ServiceGetRow {
    /** Array delle righe della pagina richiesta */
    rows?: API_ServiceGetRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfAPI_ServiceGetRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(API_ServiceGetRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfAPI_ServiceGetRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfAPI_ServiceGetRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfAPI_ServiceGetRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: API_ServiceGetRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class API_ServiceGetRow implements IAPI_ServiceGetRow {
    idServizio?: number;
    category?: string | null;
    englishName?: string | null;
    languageName?: string | null;
    productName?: string | null;
    supplier?: string | null;
    city?: string | null;
    region?: string | null;
    country?: string | null;
    publish?: EStatoPubblicazioneServizio | null;
    publishFR?: EStatoPubblicazioneServizio | null;
    publishDE?: EStatoPubblicazioneServizio | null;
    publishBE?: EStatoPubblicazioneServizio | null;
    publishCH?: EStatoPubblicazioneServizio | null;
    status?: EStatoUtilizzoServizio | null;
    lastUpdate?: string | null;
    deleted?: boolean;
    publishes?: PublishData[];

    constructor(data?: IAPI_ServiceGetRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idServizio = _data["idServizio"] !== undefined ? _data["idServizio"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.englishName = _data["englishName"] !== undefined ? _data["englishName"] : null as any;
            this.languageName = _data["languageName"] !== undefined ? _data["languageName"] : null as any;
            this.productName = _data["productName"] !== undefined ? _data["productName"] : null as any;
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.region = _data["region"] !== undefined ? _data["region"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.publish = _data["publish"] !== undefined ? _data["publish"] : null as any;
            this.publishFR = _data["publishFR"] !== undefined ? _data["publishFR"] : null as any;
            this.publishDE = _data["publishDE"] !== undefined ? _data["publishDE"] : null as any;
            this.publishBE = _data["publishBE"] !== undefined ? _data["publishBE"] : null as any;
            this.publishCH = _data["publishCH"] !== undefined ? _data["publishCH"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : null as any;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : null as any;
            if (Array.isArray(_data["publishes"])) {
                this.publishes = [] as any;
                for (let item of _data["publishes"])
                    this.publishes!.push(PublishData.fromJS(item));
            }
            else {
                this.publishes = null as any;
            }
        }
    }

    static fromJS(data: any): API_ServiceGetRow {
        data = typeof data === 'object' ? data : {};
        let result = new API_ServiceGetRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idServizio"] = this.idServizio !== undefined ? this.idServizio : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["englishName"] = this.englishName !== undefined ? this.englishName : null as any;
        data["languageName"] = this.languageName !== undefined ? this.languageName : null as any;
        data["productName"] = this.productName !== undefined ? this.productName : null as any;
        data["supplier"] = this.supplier !== undefined ? this.supplier : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["region"] = this.region !== undefined ? this.region : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["publish"] = this.publish !== undefined ? this.publish : null as any;
        data["publishFR"] = this.publishFR !== undefined ? this.publishFR : null as any;
        data["publishDE"] = this.publishDE !== undefined ? this.publishDE : null as any;
        data["publishBE"] = this.publishBE !== undefined ? this.publishBE : null as any;
        data["publishCH"] = this.publishCH !== undefined ? this.publishCH : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : null as any;
        data["deleted"] = this.deleted !== undefined ? this.deleted : null as any;
        if (Array.isArray(this.publishes)) {
            data["publishes"] = [];
            for (let item of this.publishes)
                data["publishes"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IAPI_ServiceGetRow {
    idServizio?: number;
    category?: string | null;
    englishName?: string | null;
    languageName?: string | null;
    productName?: string | null;
    supplier?: string | null;
    city?: string | null;
    region?: string | null;
    country?: string | null;
    publish?: EStatoPubblicazioneServizio | null;
    publishFR?: EStatoPubblicazioneServizio | null;
    publishDE?: EStatoPubblicazioneServizio | null;
    publishBE?: EStatoPubblicazioneServizio | null;
    publishCH?: EStatoPubblicazioneServizio | null;
    status?: EStatoUtilizzoServizio | null;
    lastUpdate?: string | null;
    deleted?: boolean;
    publishes?: PublishData[];
}

export class PublishData implements IPublishData {
    id?: number;
    name?: string;
    status?: EStatoPubblicazioneServizio | null;

    constructor(data?: IPublishData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
        }
    }

    static fromJS(data: any): PublishData {
        data = typeof data === 'object' ? data : {};
        let result = new PublishData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        return data;
    }
}

export interface IPublishData {
    id?: number;
    name?: string;
    status?: EStatoPubblicazioneServizio | null;
}

export class ListServicesRequest extends NrTableRequest implements IListServicesRequest {
    term?: string | null;
    luogoID?: number | null;
    luogoPaeseID?: number | null;
    tipo?: ETipoServizio | null;
    showDeleted?: boolean | null;
    language?: ELingua | null;
    statoUtilizzo?: EStatoUtilizzoServizio | null;
    sitoPubblicazioneID?: number | null;
    statoPubblicazione?: EStatoPubblicazioneServizio | null;
    fornitoreTerziID?: number | null;
    showOnlyPublished?: boolean | null;
    additionalData?: number[] | null;
    nomiStatiUtilizzo?: { [key in keyof typeof EStatoUtilizzoServizio]?: string; } | null;
    nomiStatiPubblicazione?: { [key in keyof typeof EStatoPubblicazioneServizio]?: string; } | null;

    constructor(data?: IListServicesRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.luogoPaeseID = _data["luogoPaeseID"] !== undefined ? _data["luogoPaeseID"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.showDeleted = _data["showDeleted"] !== undefined ? _data["showDeleted"] : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
            this.statoUtilizzo = _data["statoUtilizzo"] !== undefined ? _data["statoUtilizzo"] : null as any;
            this.sitoPubblicazioneID = _data["sitoPubblicazioneID"] !== undefined ? _data["sitoPubblicazioneID"] : null as any;
            this.statoPubblicazione = _data["statoPubblicazione"] !== undefined ? _data["statoPubblicazione"] : null as any;
            this.fornitoreTerziID = _data["fornitoreTerziID"] !== undefined ? _data["fornitoreTerziID"] : null as any;
            this.showOnlyPublished = _data["showOnlyPublished"] !== undefined ? _data["showOnlyPublished"] : null as any;
            if (Array.isArray(_data["additionalData"])) {
                this.additionalData = [] as any;
                for (let item of _data["additionalData"])
                    this.additionalData!.push(item);
            }
            else {
                this.additionalData = null as any;
            }
            if (_data["nomiStatiUtilizzo"]) {
                this.nomiStatiUtilizzo = {} as any;
                for (let key in _data["nomiStatiUtilizzo"]) {
                    if (_data["nomiStatiUtilizzo"].hasOwnProperty(key))
                        (this.nomiStatiUtilizzo as any)![key] = _data["nomiStatiUtilizzo"][key] !== undefined ? _data["nomiStatiUtilizzo"][key] : null as any;
                }
            }
            else {
                this.nomiStatiUtilizzo = null as any;
            }
            if (_data["nomiStatiPubblicazione"]) {
                this.nomiStatiPubblicazione = {} as any;
                for (let key in _data["nomiStatiPubblicazione"]) {
                    if (_data["nomiStatiPubblicazione"].hasOwnProperty(key))
                        (this.nomiStatiPubblicazione as any)![key] = _data["nomiStatiPubblicazione"][key] !== undefined ? _data["nomiStatiPubblicazione"][key] : null as any;
                }
            }
            else {
                this.nomiStatiPubblicazione = null as any;
            }
        }
    }

    static override fromJS(data: any): ListServicesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListServicesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["luogoPaeseID"] = this.luogoPaeseID !== undefined ? this.luogoPaeseID : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["showDeleted"] = this.showDeleted !== undefined ? this.showDeleted : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        data["statoUtilizzo"] = this.statoUtilizzo !== undefined ? this.statoUtilizzo : null as any;
        data["sitoPubblicazioneID"] = this.sitoPubblicazioneID !== undefined ? this.sitoPubblicazioneID : null as any;
        data["statoPubblicazione"] = this.statoPubblicazione !== undefined ? this.statoPubblicazione : null as any;
        data["fornitoreTerziID"] = this.fornitoreTerziID !== undefined ? this.fornitoreTerziID : null as any;
        data["showOnlyPublished"] = this.showOnlyPublished !== undefined ? this.showOnlyPublished : null as any;
        if (Array.isArray(this.additionalData)) {
            data["additionalData"] = [];
            for (let item of this.additionalData)
                data["additionalData"].push(item);
        }
        if (this.nomiStatiUtilizzo) {
            data["nomiStatiUtilizzo"] = {};
            for (let key in this.nomiStatiUtilizzo) {
                if (this.nomiStatiUtilizzo.hasOwnProperty(key))
                    (data["nomiStatiUtilizzo"] as any)[key] = this.nomiStatiUtilizzo[key] !== undefined ? this.nomiStatiUtilizzo[key] : null as any;
            }
        }
        if (this.nomiStatiPubblicazione) {
            data["nomiStatiPubblicazione"] = {};
            for (let key in this.nomiStatiPubblicazione) {
                if (this.nomiStatiPubblicazione.hasOwnProperty(key))
                    (data["nomiStatiPubblicazione"] as any)[key] = this.nomiStatiPubblicazione[key] !== undefined ? this.nomiStatiPubblicazione[key] : null as any;
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IListServicesRequest extends INrTableRequest {
    term?: string | null;
    luogoID?: number | null;
    luogoPaeseID?: number | null;
    tipo?: ETipoServizio | null;
    showDeleted?: boolean | null;
    language?: ELingua | null;
    statoUtilizzo?: EStatoUtilizzoServizio | null;
    sitoPubblicazioneID?: number | null;
    statoPubblicazione?: EStatoPubblicazioneServizio | null;
    fornitoreTerziID?: number | null;
    showOnlyPublished?: boolean | null;
    additionalData?: number[] | null;
    nomiStatiUtilizzo?: { [key in keyof typeof EStatoUtilizzoServizio]?: string; } | null;
    nomiStatiPubblicazione?: { [key in keyof typeof EStatoPubblicazioneServizio]?: string; } | null;
}

export class ListPublishedServicesResponse extends OkApiResponse implements IListPublishedServicesResponse {
    filters?: ServiceFilter[] | null;
    services?: { [key: string]: ServiceData; } | null;
    location?: string | null;
    locationUrlPart?: string | null;
    unmappedMode?: EModalitaNonMappati;
    idsByName?: string[] | null;
    idsByPopularity?: string[] | null;
    idsShown?: string[] | null;
    idsExternal?: string[] | null;
    destinazioni?: ServiceDestination[] | null;
    luoghiTappe?: ServiceDestination[] | null;
    abilitaFiltroDurata?: boolean;
    abilitaFiltroCittaTappa?: boolean;
    nascondiNrf?: boolean;
    deleted?: boolean;
    isExpertDestination?: boolean;
    serviceTypeListCount?: { [key in keyof typeof ETipoServizio]?: number; } | null;

    constructor(data?: IListPublishedServicesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(ServiceFilter.fromJS(item));
            }
            else {
                this.filters = null as any;
            }
            if (_data["services"]) {
                this.services = {} as any;
                for (let key in _data["services"]) {
                    if (_data["services"].hasOwnProperty(key))
                        (this.services as any)![key] = _data["services"][key] ? ServiceData.fromJS(_data["services"][key]) : new ServiceData();
                }
            }
            else {
                this.services = null as any;
            }
            this.location = _data["location"] !== undefined ? _data["location"] : null as any;
            this.locationUrlPart = _data["locationUrlPart"] !== undefined ? _data["locationUrlPart"] : null as any;
            this.unmappedMode = _data["unmappedMode"] !== undefined ? _data["unmappedMode"] : null as any;
            if (Array.isArray(_data["idsByName"])) {
                this.idsByName = [] as any;
                for (let item of _data["idsByName"])
                    this.idsByName!.push(item);
            }
            else {
                this.idsByName = null as any;
            }
            if (Array.isArray(_data["idsByPopularity"])) {
                this.idsByPopularity = [] as any;
                for (let item of _data["idsByPopularity"])
                    this.idsByPopularity!.push(item);
            }
            else {
                this.idsByPopularity = null as any;
            }
            if (Array.isArray(_data["idsShown"])) {
                this.idsShown = [] as any;
                for (let item of _data["idsShown"])
                    this.idsShown!.push(item);
            }
            else {
                this.idsShown = null as any;
            }
            if (Array.isArray(_data["idsExternal"])) {
                this.idsExternal = [] as any;
                for (let item of _data["idsExternal"])
                    this.idsExternal!.push(item);
            }
            else {
                this.idsExternal = null as any;
            }
            if (Array.isArray(_data["destinazioni"])) {
                this.destinazioni = [] as any;
                for (let item of _data["destinazioni"])
                    this.destinazioni!.push(ServiceDestination.fromJS(item));
            }
            else {
                this.destinazioni = null as any;
            }
            if (Array.isArray(_data["luoghiTappe"])) {
                this.luoghiTappe = [] as any;
                for (let item of _data["luoghiTappe"])
                    this.luoghiTappe!.push(ServiceDestination.fromJS(item));
            }
            else {
                this.luoghiTappe = null as any;
            }
            this.abilitaFiltroDurata = _data["abilitaFiltroDurata"] !== undefined ? _data["abilitaFiltroDurata"] : null as any;
            this.abilitaFiltroCittaTappa = _data["abilitaFiltroCittaTappa"] !== undefined ? _data["abilitaFiltroCittaTappa"] : null as any;
            this.nascondiNrf = _data["nascondiNrf"] !== undefined ? _data["nascondiNrf"] : null as any;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : null as any;
            this.isExpertDestination = _data["isExpertDestination"] !== undefined ? _data["isExpertDestination"] : null as any;
            if (_data["serviceTypeListCount"]) {
                this.serviceTypeListCount = {} as any;
                for (let key in _data["serviceTypeListCount"]) {
                    if (_data["serviceTypeListCount"].hasOwnProperty(key))
                        (this.serviceTypeListCount as any)![key] = _data["serviceTypeListCount"][key] !== undefined ? _data["serviceTypeListCount"][key] : null as any;
                }
            }
            else {
                this.serviceTypeListCount = null as any;
            }
        }
    }

    static override fromJS(data: any): ListPublishedServicesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListPublishedServicesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item ? item.toJSON() : null as any);
        }
        if (this.services) {
            data["services"] = {};
            for (let key in this.services) {
                if (this.services.hasOwnProperty(key))
                    (data["services"] as any)[key] = this.services[key] ? this.services[key].toJSON() : null as any;
            }
        }
        data["location"] = this.location !== undefined ? this.location : null as any;
        data["locationUrlPart"] = this.locationUrlPart !== undefined ? this.locationUrlPart : null as any;
        data["unmappedMode"] = this.unmappedMode !== undefined ? this.unmappedMode : null as any;
        if (Array.isArray(this.idsByName)) {
            data["idsByName"] = [];
            for (let item of this.idsByName)
                data["idsByName"].push(item);
        }
        if (Array.isArray(this.idsByPopularity)) {
            data["idsByPopularity"] = [];
            for (let item of this.idsByPopularity)
                data["idsByPopularity"].push(item);
        }
        if (Array.isArray(this.idsShown)) {
            data["idsShown"] = [];
            for (let item of this.idsShown)
                data["idsShown"].push(item);
        }
        if (Array.isArray(this.idsExternal)) {
            data["idsExternal"] = [];
            for (let item of this.idsExternal)
                data["idsExternal"].push(item);
        }
        if (Array.isArray(this.destinazioni)) {
            data["destinazioni"] = [];
            for (let item of this.destinazioni)
                data["destinazioni"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.luoghiTappe)) {
            data["luoghiTappe"] = [];
            for (let item of this.luoghiTappe)
                data["luoghiTappe"].push(item ? item.toJSON() : null as any);
        }
        data["abilitaFiltroDurata"] = this.abilitaFiltroDurata !== undefined ? this.abilitaFiltroDurata : null as any;
        data["abilitaFiltroCittaTappa"] = this.abilitaFiltroCittaTappa !== undefined ? this.abilitaFiltroCittaTappa : null as any;
        data["nascondiNrf"] = this.nascondiNrf !== undefined ? this.nascondiNrf : null as any;
        data["deleted"] = this.deleted !== undefined ? this.deleted : null as any;
        data["isExpertDestination"] = this.isExpertDestination !== undefined ? this.isExpertDestination : null as any;
        if (this.serviceTypeListCount) {
            data["serviceTypeListCount"] = {};
            for (let key in this.serviceTypeListCount) {
                if (this.serviceTypeListCount.hasOwnProperty(key))
                    (data["serviceTypeListCount"] as any)[key] = this.serviceTypeListCount[key] !== undefined ? this.serviceTypeListCount[key] : null as any;
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IListPublishedServicesResponse extends IOkApiResponse {
    filters?: ServiceFilter[] | null;
    services?: { [key: string]: ServiceData; } | null;
    location?: string | null;
    locationUrlPart?: string | null;
    unmappedMode?: EModalitaNonMappati;
    idsByName?: string[] | null;
    idsByPopularity?: string[] | null;
    idsShown?: string[] | null;
    idsExternal?: string[] | null;
    destinazioni?: ServiceDestination[] | null;
    luoghiTappe?: ServiceDestination[] | null;
    abilitaFiltroDurata?: boolean;
    abilitaFiltroCittaTappa?: boolean;
    nascondiNrf?: boolean;
    deleted?: boolean;
    isExpertDestination?: boolean;
    serviceTypeListCount?: { [key in keyof typeof ETipoServizio]?: number; } | null;
}

export class ServiceFilter implements IServiceFilter {
    id?: number;
    name?: string | null;
    logic?: EServiceFilterLogic;
    primary?: boolean;
    values?: ServiceFilterValue[] | null;
    sortOrder?: number;

    constructor(data?: IServiceFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.logic = _data["logic"] !== undefined ? _data["logic"] : null as any;
            this.primary = _data["primary"] !== undefined ? _data["primary"] : null as any;
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(ServiceFilterValue.fromJS(item));
            }
            else {
                this.values = null as any;
            }
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null as any;
        }
    }

    static fromJS(data: any): ServiceFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["logic"] = this.logic !== undefined ? this.logic : null as any;
        data["primary"] = this.primary !== undefined ? this.primary : null as any;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item ? item.toJSON() : null as any);
        }
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        return data;
    }
}

export interface IServiceFilter {
    id?: number;
    name?: string | null;
    logic?: EServiceFilterLogic;
    primary?: boolean;
    values?: ServiceFilterValue[] | null;
    sortOrder?: number;
}

export enum EServiceFilterLogic {
    AND = "AND",
    OR = "OR",
}

export class ServiceFilterValue implements IServiceFilterValue {
    id?: number;
    name?: string | null;
    sortOrder?: number;

    constructor(data?: IServiceFilterValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null as any;
        }
    }

    static fromJS(data: any): ServiceFilterValue {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceFilterValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        return data;
    }
}

export interface IServiceFilterValue {
    id?: number;
    name?: string | null;
    sortOrder?: number;
}

export class ServiceDestination implements IServiceDestination {
    destinazioneID?: number;
    nome?: string | null;
    regione?: string | null;
    paese?: string | null;

    constructor(data?: IServiceDestination) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.destinazioneID = _data["destinazioneID"] !== undefined ? _data["destinazioneID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.regione = _data["regione"] !== undefined ? _data["regione"] : null as any;
            this.paese = _data["paese"] !== undefined ? _data["paese"] : null as any;
        }
    }

    static fromJS(data: any): ServiceDestination {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDestination();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["destinazioneID"] = this.destinazioneID !== undefined ? this.destinazioneID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["regione"] = this.regione !== undefined ? this.regione : null as any;
        data["paese"] = this.paese !== undefined ? this.paese : null as any;
        return data;
    }
}

export interface IServiceDestination {
    destinazioneID?: number;
    nome?: string | null;
    regione?: string | null;
    paese?: string | null;
}

export class ListPublishedServicesRequest extends SiteRequest implements IListPublishedServicesRequest {
    /** Eventuale offerta associata alla richiesta */
    offertaID?: number | null;
    /** Tappa associata all'offerta, obbligatorio se OffertaID � non nullo */
    tappaID?: number | null;
    luogoID?: number | null;
    luogoDestinazioneID?: number | null;
    tipoServizio?: ETipoServizio;
    sottoTipoServizio?: ESottoTipoServizio | null;
    filtroCatalogoTour?: boolean;
    filtriAttributo?: number[] | null;
    showValid?: boolean | null;
    page?: number;
    pageSize?: number;
    allServiceTypes?: boolean;

    constructor(data?: IListPublishedServicesRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.tappaID = _data["tappaID"] !== undefined ? _data["tappaID"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.luogoDestinazioneID = _data["luogoDestinazioneID"] !== undefined ? _data["luogoDestinazioneID"] : null as any;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
            this.sottoTipoServizio = _data["sottoTipoServizio"] !== undefined ? _data["sottoTipoServizio"] : null as any;
            this.filtroCatalogoTour = _data["filtroCatalogoTour"] !== undefined ? _data["filtroCatalogoTour"] : null as any;
            if (Array.isArray(_data["filtriAttributo"])) {
                this.filtriAttributo = [] as any;
                for (let item of _data["filtriAttributo"])
                    this.filtriAttributo!.push(item);
            }
            else {
                this.filtriAttributo = null as any;
            }
            this.showValid = _data["showValid"] !== undefined ? _data["showValid"] : null as any;
            this.page = _data["page"] !== undefined ? _data["page"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
            this.allServiceTypes = _data["allServiceTypes"] !== undefined ? _data["allServiceTypes"] : null as any;
        }
    }

    static override fromJS(data: any): ListPublishedServicesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListPublishedServicesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["tappaID"] = this.tappaID !== undefined ? this.tappaID : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["luogoDestinazioneID"] = this.luogoDestinazioneID !== undefined ? this.luogoDestinazioneID : null as any;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        data["sottoTipoServizio"] = this.sottoTipoServizio !== undefined ? this.sottoTipoServizio : null as any;
        data["filtroCatalogoTour"] = this.filtroCatalogoTour !== undefined ? this.filtroCatalogoTour : null as any;
        if (Array.isArray(this.filtriAttributo)) {
            data["filtriAttributo"] = [];
            for (let item of this.filtriAttributo)
                data["filtriAttributo"].push(item);
        }
        data["showValid"] = this.showValid !== undefined ? this.showValid : null as any;
        data["page"] = this.page !== undefined ? this.page : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        data["allServiceTypes"] = this.allServiceTypes !== undefined ? this.allServiceTypes : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IListPublishedServicesRequest extends ISiteRequest {
    /** Eventuale offerta associata alla richiesta */
    offertaID?: number | null;
    /** Tappa associata all'offerta, obbligatorio se OffertaID � non nullo */
    tappaID?: number | null;
    luogoID?: number | null;
    luogoDestinazioneID?: number | null;
    tipoServizio?: ETipoServizio;
    sottoTipoServizio?: ESottoTipoServizio | null;
    filtroCatalogoTour?: boolean;
    filtriAttributo?: number[] | null;
    showValid?: boolean | null;
    page?: number;
    pageSize?: number;
    allServiceTypes?: boolean;
}

export enum ESottoTipoServizio {
    Minitour = "Minitour",
    FullTour = "FullTour",
    FlyBeach = "FlyBeach",
    FlyCity = "FlyCity",
    FlyTour = "FlyTour",
    FlyCruise = "FlyCruise",
}

export class RestoreTipologiaRequest extends GetTipologieRequest implements IRestoreTipologiaRequest {
    servizioTipologiaID?: number;

    constructor(data?: IRestoreTipologiaRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioTipologiaID = _data["servizioTipologiaID"] !== undefined ? _data["servizioTipologiaID"] : null as any;
        }
    }

    static override fromJS(data: any): RestoreTipologiaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreTipologiaRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioTipologiaID"] = this.servizioTipologiaID !== undefined ? this.servizioTipologiaID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IRestoreTipologiaRequest extends IGetTipologieRequest {
    servizioTipologiaID?: number;
}

export class RestoreTipologieRequest extends GetTipologieRequest implements IRestoreTipologieRequest {
    tipologieIDs?: number[] | null;

    constructor(data?: IRestoreTipologieRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tipologieIDs"])) {
                this.tipologieIDs = [] as any;
                for (let item of _data["tipologieIDs"])
                    this.tipologieIDs!.push(item);
            }
            else {
                this.tipologieIDs = null as any;
            }
        }
    }

    static override fromJS(data: any): RestoreTipologieRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreTipologieRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tipologieIDs)) {
            data["tipologieIDs"] = [];
            for (let item of this.tipologieIDs)
                data["tipologieIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IRestoreTipologieRequest extends IGetTipologieRequest {
    tipologieIDs?: number[] | null;
}

export class SetAccordiServizioRequest extends ServizioGetRequest implements ISetAccordiServizioRequest {
    /** Elenco degli ID degli accordi da associare */
    accordiIDs?: number[];

    constructor(data?: ISetAccordiServizioRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["accordiIDs"])) {
                this.accordiIDs = [] as any;
                for (let item of _data["accordiIDs"])
                    this.accordiIDs!.push(item);
            }
            else {
                this.accordiIDs = null as any;
            }
        }
    }

    static override fromJS(data: any): SetAccordiServizioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetAccordiServizioRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accordiIDs)) {
            data["accordiIDs"] = [];
            for (let item of this.accordiIDs)
                data["accordiIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetAccordiServizioRequest extends IServizioGetRequest {
    /** Elenco degli ID degli accordi da associare */
    accordiIDs?: number[];
}

export class SetDatiAggiuntiviRequest extends ServizioGetRequest implements ISetDatiAggiuntiviRequest {
    /** Elenco dei dati aggiuntivi da impostare */
    dati?: ServizioDatoAggiuntivoBase[];

    constructor(data?: ISetDatiAggiuntiviRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["dati"])) {
                this.dati = [] as any;
                for (let item of _data["dati"])
                    this.dati!.push(ServizioDatoAggiuntivoBase.fromJS(item));
            }
            else {
                this.dati = null as any;
            }
        }
    }

    static override fromJS(data: any): SetDatiAggiuntiviRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetDatiAggiuntiviRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dati)) {
            data["dati"] = [];
            for (let item of this.dati)
                data["dati"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetDatiAggiuntiviRequest extends IServizioGetRequest {
    /** Elenco dei dati aggiuntivi da impostare */
    dati?: ServizioDatoAggiuntivoBase[];
}

export abstract class ServizioDatoAggiuntivoBase implements IServizioDatoAggiuntivoBase {
    id?: number;
    servizioID?: number;
    datoAggiuntivoID?: number;
    tipoServizio?: ETipoServizio | null;
    valore?: string | null;
    dal?: string | null;
    al?: string | null;
    valore_fr?: string | null;
    valore_de?: string | null;
    valore_es?: string | null;
    valore_en?: string | null;

    constructor(data?: IServizioDatoAggiuntivoBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.datoAggiuntivoID = _data["datoAggiuntivoID"] !== undefined ? _data["datoAggiuntivoID"] : null as any;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
            this.valore = _data["valore"] !== undefined ? _data["valore"] : null as any;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.al = _data["al"] !== undefined ? _data["al"] : null as any;
            this.valore_fr = _data["valore_fr"] !== undefined ? _data["valore_fr"] : null as any;
            this.valore_de = _data["valore_de"] !== undefined ? _data["valore_de"] : null as any;
            this.valore_es = _data["valore_es"] !== undefined ? _data["valore_es"] : null as any;
            this.valore_en = _data["valore_en"] !== undefined ? _data["valore_en"] : null as any;
        }
    }

    static fromJS(data: any): ServizioDatoAggiuntivoBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ServizioDatoAggiuntivoBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["datoAggiuntivoID"] = this.datoAggiuntivoID !== undefined ? this.datoAggiuntivoID : null as any;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        data["valore"] = this.valore !== undefined ? this.valore : null as any;
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["al"] = this.al !== undefined ? this.al : null as any;
        data["valore_fr"] = this.valore_fr !== undefined ? this.valore_fr : null as any;
        data["valore_de"] = this.valore_de !== undefined ? this.valore_de : null as any;
        data["valore_es"] = this.valore_es !== undefined ? this.valore_es : null as any;
        data["valore_en"] = this.valore_en !== undefined ? this.valore_en : null as any;
        return data;
    }
}

export interface IServizioDatoAggiuntivoBase {
    id?: number;
    servizioID?: number;
    datoAggiuntivoID?: number;
    tipoServizio?: ETipoServizio | null;
    valore?: string | null;
    dal?: string | null;
    al?: string | null;
    valore_fr?: string | null;
    valore_de?: string | null;
    valore_es?: string | null;
    valore_en?: string | null;
}

export class SetLuoghiServizioRequest extends ServizioGetRequest implements ISetLuoghiServizioRequest {
    /** Elenco degli ID dei luoghi */
    luoghiIDs?: number[];

    constructor(data?: ISetLuoghiServizioRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["luoghiIDs"])) {
                this.luoghiIDs = [] as any;
                for (let item of _data["luoghiIDs"])
                    this.luoghiIDs!.push(item);
            }
            else {
                this.luoghiIDs = null as any;
            }
        }
    }

    static override fromJS(data: any): SetLuoghiServizioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetLuoghiServizioRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.luoghiIDs)) {
            data["luoghiIDs"] = [];
            for (let item of this.luoghiIDs)
                data["luoghiIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetLuoghiServizioRequest extends IServizioGetRequest {
    /** Elenco degli ID dei luoghi */
    luoghiIDs?: number[];
}

export class SetPartenzeRequest extends ServizioGetRequest implements ISetPartenzeRequest {
    /** Elenco delle partenze da impostare */
    partenze?: IPartenzaBase[];

    constructor(data?: ISetPartenzeRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["partenze"])) {
                this.partenze = [] as any;
                for (let item of _data["partenze"])
                    this.partenze!.push(IPartenzaBase.fromJS(item));
            }
            else {
                this.partenze = null as any;
            }
        }
    }

    static override fromJS(data: any): SetPartenzeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetPartenzeRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.partenze)) {
            data["partenze"] = [];
            for (let item of this.partenze)
                data["partenze"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetPartenzeRequest extends IServizioGetRequest {
    /** Elenco delle partenze da impostare */
    partenze?: IPartenzaBase[];
}

export class UpdateCostiRequest extends ServizioGetRequest implements IUpdateCostiRequest {
    /** Costi da aggiornare */
    costi?: Costo[];
    /** Lista di ID di costi doppi che vanno eliminati */
    doppioniDaEliminareIDs?: number[] | null;

    constructor(data?: IUpdateCostiRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["costi"])) {
                this.costi = [] as any;
                for (let item of _data["costi"])
                    this.costi!.push(Costo.fromJS(item));
            }
            else {
                this.costi = null as any;
            }
            if (Array.isArray(_data["doppioniDaEliminareIDs"])) {
                this.doppioniDaEliminareIDs = [] as any;
                for (let item of _data["doppioniDaEliminareIDs"])
                    this.doppioniDaEliminareIDs!.push(item);
            }
            else {
                this.doppioniDaEliminareIDs = null as any;
            }
        }
    }

    static override fromJS(data: any): UpdateCostiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCostiRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.costi)) {
            data["costi"] = [];
            for (let item of this.costi)
                data["costi"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.doppioniDaEliminareIDs)) {
            data["doppioniDaEliminareIDs"] = [];
            for (let item of this.doppioniDaEliminareIDs)
                data["doppioniDaEliminareIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCostiRequest extends IServizioGetRequest {
    /** Costi da aggiornare */
    costi?: Costo[];
    /** Lista di ID di costi doppi che vanno eliminati */
    doppioniDaEliminareIDs?: number[] | null;
}

export class UpdateDatiCostiRequest extends ServizioGetRequest implements IUpdateDatiCostiRequest {
    /** Lista degli ID dei costi da modificare */
    costiIDs?: number[];
    /** Dati da aggiornare */
    dati?: CostiUpdateData;

    constructor(data?: IUpdateDatiCostiRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["costiIDs"])) {
                this.costiIDs = [] as any;
                for (let item of _data["costiIDs"])
                    this.costiIDs!.push(item);
            }
            else {
                this.costiIDs = null as any;
            }
            this.dati = _data["dati"] ? CostiUpdateData.fromJS(_data["dati"]) : null as any;
        }
    }

    static override fromJS(data: any): UpdateDatiCostiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDatiCostiRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.costiIDs)) {
            data["costiIDs"] = [];
            for (let item of this.costiIDs)
                data["costiIDs"].push(item);
        }
        data["dati"] = this.dati ? this.dati.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateDatiCostiRequest extends IServizioGetRequest {
    /** Lista degli ID dei costi da modificare */
    costiIDs?: number[];
    /** Dati da aggiornare */
    dati?: CostiUpdateData;
}

export class CostiUpdateData implements ICostiUpdateData {
    tabellaCostiID?: number | null;
    tipologiaID?: number | null;
    validitaID?: number | null;
    updateRegolaServizio?: boolean;
    regolaServizioID?: number | null;
    updateRegolaVendita?: boolean;
    regolaVenditaID?: number | null;
    updateTrattamento?: boolean;
    trattamentoID?: number | null;
    updateCodicePrenotazione?: boolean;
    codicePrenotazione?: string | null;
    updateRegolaCostiBambino?: boolean;
    regolaCostiBambino?: ERegolaCostiBambino | null;
    updateEtaChild?: boolean;
    etaChild?: number | null;

    constructor(data?: ICostiUpdateData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tabellaCostiID = _data["tabellaCostiID"] !== undefined ? _data["tabellaCostiID"] : null as any;
            this.tipologiaID = _data["tipologiaID"] !== undefined ? _data["tipologiaID"] : null as any;
            this.validitaID = _data["validitaID"] !== undefined ? _data["validitaID"] : null as any;
            this.updateRegolaServizio = _data["updateRegolaServizio"] !== undefined ? _data["updateRegolaServizio"] : null as any;
            this.regolaServizioID = _data["regolaServizioID"] !== undefined ? _data["regolaServizioID"] : null as any;
            this.updateRegolaVendita = _data["updateRegolaVendita"] !== undefined ? _data["updateRegolaVendita"] : null as any;
            this.regolaVenditaID = _data["regolaVenditaID"] !== undefined ? _data["regolaVenditaID"] : null as any;
            this.updateTrattamento = _data["updateTrattamento"] !== undefined ? _data["updateTrattamento"] : null as any;
            this.trattamentoID = _data["trattamentoID"] !== undefined ? _data["trattamentoID"] : null as any;
            this.updateCodicePrenotazione = _data["updateCodicePrenotazione"] !== undefined ? _data["updateCodicePrenotazione"] : null as any;
            this.codicePrenotazione = _data["codicePrenotazione"] !== undefined ? _data["codicePrenotazione"] : null as any;
            this.updateRegolaCostiBambino = _data["updateRegolaCostiBambino"] !== undefined ? _data["updateRegolaCostiBambino"] : null as any;
            this.regolaCostiBambino = _data["regolaCostiBambino"] !== undefined ? _data["regolaCostiBambino"] : null as any;
            this.updateEtaChild = _data["updateEtaChild"] !== undefined ? _data["updateEtaChild"] : null as any;
            this.etaChild = _data["etaChild"] !== undefined ? _data["etaChild"] : null as any;
        }
    }

    static fromJS(data: any): CostiUpdateData {
        data = typeof data === 'object' ? data : {};
        let result = new CostiUpdateData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tabellaCostiID"] = this.tabellaCostiID !== undefined ? this.tabellaCostiID : null as any;
        data["tipologiaID"] = this.tipologiaID !== undefined ? this.tipologiaID : null as any;
        data["validitaID"] = this.validitaID !== undefined ? this.validitaID : null as any;
        data["updateRegolaServizio"] = this.updateRegolaServizio !== undefined ? this.updateRegolaServizio : null as any;
        data["regolaServizioID"] = this.regolaServizioID !== undefined ? this.regolaServizioID : null as any;
        data["updateRegolaVendita"] = this.updateRegolaVendita !== undefined ? this.updateRegolaVendita : null as any;
        data["regolaVenditaID"] = this.regolaVenditaID !== undefined ? this.regolaVenditaID : null as any;
        data["updateTrattamento"] = this.updateTrattamento !== undefined ? this.updateTrattamento : null as any;
        data["trattamentoID"] = this.trattamentoID !== undefined ? this.trattamentoID : null as any;
        data["updateCodicePrenotazione"] = this.updateCodicePrenotazione !== undefined ? this.updateCodicePrenotazione : null as any;
        data["codicePrenotazione"] = this.codicePrenotazione !== undefined ? this.codicePrenotazione : null as any;
        data["updateRegolaCostiBambino"] = this.updateRegolaCostiBambino !== undefined ? this.updateRegolaCostiBambino : null as any;
        data["regolaCostiBambino"] = this.regolaCostiBambino !== undefined ? this.regolaCostiBambino : null as any;
        data["updateEtaChild"] = this.updateEtaChild !== undefined ? this.updateEtaChild : null as any;
        data["etaChild"] = this.etaChild !== undefined ? this.etaChild : null as any;
        return data;
    }
}

export interface ICostiUpdateData {
    tabellaCostiID?: number | null;
    tipologiaID?: number | null;
    validitaID?: number | null;
    updateRegolaServizio?: boolean;
    regolaServizioID?: number | null;
    updateRegolaVendita?: boolean;
    regolaVenditaID?: number | null;
    updateTrattamento?: boolean;
    trattamentoID?: number | null;
    updateCodicePrenotazione?: boolean;
    codicePrenotazione?: string | null;
    updateRegolaCostiBambino?: boolean;
    regolaCostiBambino?: ERegolaCostiBambino | null;
    updateEtaChild?: boolean;
    etaChild?: number | null;
}

export class UpdateMargineRequest extends ServizioGetRequest implements IUpdateMargineRequest {
    /** Costi da aggiornare */
    costi?: Costo[];
    /** Margine da impostare */
    margine?: number;

    constructor(data?: IUpdateMargineRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["costi"])) {
                this.costi = [] as any;
                for (let item of _data["costi"])
                    this.costi!.push(Costo.fromJS(item));
            }
            else {
                this.costi = null as any;
            }
            this.margine = _data["margine"] !== undefined ? _data["margine"] : null as any;
        }
    }

    static override fromJS(data: any): UpdateMargineRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMargineRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.costi)) {
            data["costi"] = [];
            for (let item of this.costi)
                data["costi"].push(item ? item.toJSON() : null as any);
        }
        data["margine"] = this.margine !== undefined ? this.margine : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateMargineRequest extends IServizioGetRequest {
    /** Costi da aggiornare */
    costi?: Costo[];
    /** Margine da impostare */
    margine?: number;
}

export class UpdatePublishingRequest extends ApiRequest implements IUpdatePublishingRequest {
    servizioId?: number;
    siteId?: number;
    status?: EStatoPubblicazioneServizio;

    constructor(data?: IUpdatePublishingRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioId = _data["servizioId"] !== undefined ? _data["servizioId"] : null as any;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
        }
    }

    static override fromJS(data: any): UpdatePublishingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePublishingRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioId"] = this.servizioId !== undefined ? this.servizioId : null as any;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdatePublishingRequest extends IApiRequest {
    servizioId?: number;
    siteId?: number;
    status?: EStatoPubblicazioneServizio;
}

export class ServizioUpsertRequest extends ServizioGetRequest implements IServizioUpsertRequest {
    servizio?: Servizio | null;

    constructor(data?: IServizioUpsertRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizio = _data["servizio"] ? Servizio.fromJS(_data["servizio"]) : null as any;
        }
    }

    static override fromJS(data: any): ServizioUpsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioUpsertRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio ? this.servizio.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IServizioUpsertRequest extends IServizioGetRequest {
    servizio?: Servizio | null;
}

export class UpsertAssociazioneResponse extends GetAssociazioniResponse implements IUpsertAssociazioneResponse {
    associazione?: ServizioAssociazione;
    offerta?: OffertaComponibile | null;

    constructor(data?: IUpsertAssociazioneResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.associazione = _data["associazione"] ? ServizioAssociazione.fromJS(_data["associazione"]) : null as any;
            this.offerta = _data["offerta"] ? OffertaComponibile.fromJS(_data["offerta"]) : null as any;
        }
    }

    static override fromJS(data: any): UpsertAssociazioneResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertAssociazioneResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["associazione"] = this.associazione ? this.associazione.toJSON() : null as any;
        data["offerta"] = this.offerta ? this.offerta.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertAssociazioneResponse extends IGetAssociazioniResponse {
    associazione?: ServizioAssociazione;
    offerta?: OffertaComponibile | null;
}

export class UpsertAssociazioneRequest extends ServizioGetRequest implements IUpsertAssociazioneRequest {
    /** Entità dell'associazione */
    associazione!: ServizioAssociazione;
    /** Entità dell'offerta componibile. Compilare se l'associazione è di tipo Offerta */
    offerta?: OffertaComponibile | null;
    /** Lista delle configurazioni delle precondizioni di un'offerta componibile */
    configurazionePrecondizioni?: ConfigValue[] | null;
    /** Configurazione dell'eventuale algorirmo dell'offerta componibile */
    configurazioneAlgoritmo?: ConfigValue | null;

    constructor(data?: IUpsertAssociazioneRequest) {
        super(data);
        if (!data) {
            this.associazione = new ServizioAssociazione();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.associazione = _data["associazione"] ? ServizioAssociazione.fromJS(_data["associazione"]) : new ServizioAssociazione();
            this.offerta = _data["offerta"] ? OffertaComponibile.fromJS(_data["offerta"]) : null as any;
            if (Array.isArray(_data["configurazionePrecondizioni"])) {
                this.configurazionePrecondizioni = [] as any;
                for (let item of _data["configurazionePrecondizioni"])
                    this.configurazionePrecondizioni!.push(ConfigValue.fromJS(item));
            }
            else {
                this.configurazionePrecondizioni = null as any;
            }
            this.configurazioneAlgoritmo = _data["configurazioneAlgoritmo"] ? ConfigValue.fromJS(_data["configurazioneAlgoritmo"]) : null as any;
        }
    }

    static override fromJS(data: any): UpsertAssociazioneRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertAssociazioneRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["associazione"] = this.associazione ? this.associazione.toJSON() : null as any;
        data["offerta"] = this.offerta ? this.offerta.toJSON() : null as any;
        if (Array.isArray(this.configurazionePrecondizioni)) {
            data["configurazionePrecondizioni"] = [];
            for (let item of this.configurazionePrecondizioni)
                data["configurazionePrecondizioni"].push(item ? item.toJSON() : null as any);
        }
        data["configurazioneAlgoritmo"] = this.configurazioneAlgoritmo ? this.configurazioneAlgoritmo.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertAssociazioneRequest extends IServizioGetRequest {
    /** Entità dell'associazione */
    associazione: ServizioAssociazione;
    /** Entità dell'offerta componibile. Compilare se l'associazione è di tipo Offerta */
    offerta?: OffertaComponibile | null;
    /** Lista delle configurazioni delle precondizioni di un'offerta componibile */
    configurazionePrecondizioni?: ConfigValue[] | null;
    /** Configurazione dell'eventuale algorirmo dell'offerta componibile */
    configurazioneAlgoritmo?: ConfigValue | null;
}

export class ConfigValue implements IConfigValue {
    codice?: string;
    configurazione?: any;

    constructor(data?: IConfigValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
            this.configurazione = _data["configurazione"] !== undefined ? _data["configurazione"] : null as any;
        }
    }

    static fromJS(data: any): ConfigValue {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        data["configurazione"] = this.configurazione !== undefined ? this.configurazione : null as any;
        return data;
    }
}

export interface IConfigValue {
    codice?: string;
    configurazione?: any;
}

export class UpsertDynamicPackageRulesResponse extends GetDynamicPackageRulesResponse implements IUpsertDynamicPackageRulesResponse {
    regola?: ServizioRegolaScontoPacchetto | null;

    constructor(data?: IUpsertDynamicPackageRulesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.regola = _data["regola"] ? ServizioRegolaScontoPacchetto.fromJS(_data["regola"]) : null as any;
        }
    }

    static override fromJS(data: any): UpsertDynamicPackageRulesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertDynamicPackageRulesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regola"] = this.regola ? this.regola.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertDynamicPackageRulesResponse extends IGetDynamicPackageRulesResponse {
    regola?: ServizioRegolaScontoPacchetto | null;
}

export class UpsertDynamicPackageRulesRequest extends GetDynamicPackageRulesRequest implements IUpsertDynamicPackageRulesRequest {
    regola?: ServizioRegolaScontoPacchetto | null;

    constructor(data?: IUpsertDynamicPackageRulesRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.regola = _data["regola"] ? ServizioRegolaScontoPacchetto.fromJS(_data["regola"]) : null as any;
        }
    }

    static override fromJS(data: any): UpsertDynamicPackageRulesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertDynamicPackageRulesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regola"] = this.regola ? this.regola.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertDynamicPackageRulesRequest extends IGetDynamicPackageRulesRequest {
    regola?: ServizioRegolaScontoPacchetto | null;
}

export class UpsertItinerarioResponse extends GetItinerariResponse implements IUpsertItinerarioResponse {
    itinerario?: ServizioItinerario | null;

    constructor(data?: IUpsertItinerarioResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.itinerario = _data["itinerario"] ? ServizioItinerario.fromJS(_data["itinerario"]) : null as any;
        }
    }

    static override fromJS(data: any): UpsertItinerarioResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertItinerarioResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itinerario"] = this.itinerario ? this.itinerario.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertItinerarioResponse extends IGetItinerariResponse {
    itinerario?: ServizioItinerario | null;
}

export class UpsertItinerarioRequest extends ServizioGetRequest implements IUpsertItinerarioRequest {
    itinerario?: ServizioItinerario | null;
    tappe?: ItinerioGiornoServizi[] | null;

    constructor(data?: IUpsertItinerarioRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.itinerario = _data["itinerario"] ? ServizioItinerario.fromJS(_data["itinerario"]) : null as any;
            if (Array.isArray(_data["tappe"])) {
                this.tappe = [] as any;
                for (let item of _data["tappe"])
                    this.tappe!.push(ItinerioGiornoServizi.fromJS(item));
            }
            else {
                this.tappe = null as any;
            }
        }
    }

    static override fromJS(data: any): UpsertItinerarioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertItinerarioRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itinerario"] = this.itinerario ? this.itinerario.toJSON() : null as any;
        if (Array.isArray(this.tappe)) {
            data["tappe"] = [];
            for (let item of this.tappe)
                data["tappe"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertItinerarioRequest extends IServizioGetRequest {
    itinerario?: ServizioItinerario | null;
    tappe?: ItinerioGiornoServizi[] | null;
}

export class ItinerioGiornoServizi implements IItinerioGiornoServizi {
    giorno?: ServizioItinerarioGiorno | null;
    servizi?: ServizioItinerarioGiornoServizio[] | null;

    constructor(data?: IItinerioGiornoServizi) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.giorno = _data["giorno"] ? ServizioItinerarioGiorno.fromJS(_data["giorno"]) : null as any;
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(ServizioItinerarioGiornoServizio.fromJS(item));
            }
            else {
                this.servizi = null as any;
            }
        }
    }

    static fromJS(data: any): ItinerioGiornoServizi {
        data = typeof data === 'object' ? data : {};
        let result = new ItinerioGiornoServizi();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giorno"] = this.giorno ? this.giorno.toJSON() : null as any;
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IItinerioGiornoServizi {
    giorno?: ServizioItinerarioGiorno | null;
    servizi?: ServizioItinerarioGiornoServizio[] | null;
}

export class UpsertRegolaServizioResponse extends GetRegoleServizioResponse implements IUpsertRegolaServizioResponse {
    regola?: ServizioRegola | null;

    constructor(data?: IUpsertRegolaServizioResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.regola = _data["regola"] ? ServizioRegola.fromJS(_data["regola"]) : null as any;
        }
    }

    static override fromJS(data: any): UpsertRegolaServizioResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertRegolaServizioResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regola"] = this.regola ? this.regola.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertRegolaServizioResponse extends IGetRegoleServizioResponse {
    regola?: ServizioRegola | null;
}

export class UpsertRegolaServizioRequest extends ServizioGetRequest implements IUpsertRegolaServizioRequest {
    regola?: ServizioRegola | null;

    constructor(data?: IUpsertRegolaServizioRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.regola = _data["regola"] ? ServizioRegola.fromJS(_data["regola"]) : null as any;
        }
    }

    static override fromJS(data: any): UpsertRegolaServizioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertRegolaServizioRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regola"] = this.regola ? this.regola.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertRegolaServizioRequest extends IServizioGetRequest {
    regola?: ServizioRegola | null;
}

export class UpsertRegolaVenditaResponse extends GetRegoleVenditaResponse implements IUpsertRegolaVenditaResponse {
    regola?: ServizioRegolaVendita | null;

    constructor(data?: IUpsertRegolaVenditaResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.regola = _data["regola"] ? ServizioRegolaVendita.fromJS(_data["regola"]) : null as any;
        }
    }

    static override fromJS(data: any): UpsertRegolaVenditaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertRegolaVenditaResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regola"] = this.regola ? this.regola.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertRegolaVenditaResponse extends IGetRegoleVenditaResponse {
    regola?: ServizioRegolaVendita | null;
}

export class UpsertRegolaVenditaRequest extends ServizioGetRequest implements IUpsertRegolaVenditaRequest {
    regola?: IServizioRegolaVendita | null;

    constructor(data?: IUpsertRegolaVenditaRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.regola = _data["regola"] ? IServizioRegolaVendita.fromJS(_data["regola"]) : null as any;
        }
    }

    static override fromJS(data: any): UpsertRegolaVenditaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertRegolaVenditaRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regola"] = this.regola ? this.regola.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertRegolaVenditaRequest extends IServizioGetRequest {
    regola?: IServizioRegolaVendita | null;
}

export abstract class IServizioRegolaVendita implements IIServizioRegolaVendita {
    id?: number;
    servizioID?: number;
    nome?: string | null;
    numeroGiorni?: number | null;
    minimoGiorni?: number | null;
    massimoGiorni?: number | null;
    etaMinima?: number | null;
    etaMassima?: number | null;
    dal?: string | null;
    al?: string | null;
    commissioniAgenzia?: number | null;
    commissioniTourOperator?: number | null;
    minimoNottiPeriodo?: number | null;
    giorniEntrata?: string | null;
    giorniUscita?: string | null;
    prenotaEntroData?: string | null;
    prenotaEntroGiorni?: number | null;
    deregolamentaSuRichiesta?: boolean | null;
    penaleID?: number | null;
    giorniPenale?: number | null;
    percentualePenale?: number | null;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    articoloID?: number | null;

    constructor(data?: IIServizioRegolaVendita) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.numeroGiorni = _data["numeroGiorni"] !== undefined ? _data["numeroGiorni"] : null as any;
            this.minimoGiorni = _data["minimoGiorni"] !== undefined ? _data["minimoGiorni"] : null as any;
            this.massimoGiorni = _data["massimoGiorni"] !== undefined ? _data["massimoGiorni"] : null as any;
            this.etaMinima = _data["etaMinima"] !== undefined ? _data["etaMinima"] : null as any;
            this.etaMassima = _data["etaMassima"] !== undefined ? _data["etaMassima"] : null as any;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : null as any;
            this.al = _data["al"] !== undefined ? _data["al"] : null as any;
            this.commissioniAgenzia = _data["commissioniAgenzia"] !== undefined ? _data["commissioniAgenzia"] : null as any;
            this.commissioniTourOperator = _data["commissioniTourOperator"] !== undefined ? _data["commissioniTourOperator"] : null as any;
            this.minimoNottiPeriodo = _data["minimoNottiPeriodo"] !== undefined ? _data["minimoNottiPeriodo"] : null as any;
            this.giorniEntrata = _data["giorniEntrata"] !== undefined ? _data["giorniEntrata"] : null as any;
            this.giorniUscita = _data["giorniUscita"] !== undefined ? _data["giorniUscita"] : null as any;
            this.prenotaEntroData = _data["prenotaEntroData"] !== undefined ? _data["prenotaEntroData"] : null as any;
            this.prenotaEntroGiorni = _data["prenotaEntroGiorni"] !== undefined ? _data["prenotaEntroGiorni"] : null as any;
            this.deregolamentaSuRichiesta = _data["deregolamentaSuRichiesta"] !== undefined ? _data["deregolamentaSuRichiesta"] : null as any;
            this.penaleID = _data["penaleID"] !== undefined ? _data["penaleID"] : null as any;
            this.giorniPenale = _data["giorniPenale"] !== undefined ? _data["giorniPenale"] : null as any;
            this.percentualePenale = _data["percentualePenale"] !== undefined ? _data["percentualePenale"] : null as any;
            this.nome_fr = _data["nome_fr"] !== undefined ? _data["nome_fr"] : null as any;
            this.nome_de = _data["nome_de"] !== undefined ? _data["nome_de"] : null as any;
            this.nome_es = _data["nome_es"] !== undefined ? _data["nome_es"] : null as any;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : null as any;
            this.articoloID = _data["articoloID"] !== undefined ? _data["articoloID"] : null as any;
        }
    }

    static fromJS(data: any): IServizioRegolaVendita {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IServizioRegolaVendita' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["numeroGiorni"] = this.numeroGiorni !== undefined ? this.numeroGiorni : null as any;
        data["minimoGiorni"] = this.minimoGiorni !== undefined ? this.minimoGiorni : null as any;
        data["massimoGiorni"] = this.massimoGiorni !== undefined ? this.massimoGiorni : null as any;
        data["etaMinima"] = this.etaMinima !== undefined ? this.etaMinima : null as any;
        data["etaMassima"] = this.etaMassima !== undefined ? this.etaMassima : null as any;
        data["dal"] = this.dal !== undefined ? this.dal : null as any;
        data["al"] = this.al !== undefined ? this.al : null as any;
        data["commissioniAgenzia"] = this.commissioniAgenzia !== undefined ? this.commissioniAgenzia : null as any;
        data["commissioniTourOperator"] = this.commissioniTourOperator !== undefined ? this.commissioniTourOperator : null as any;
        data["minimoNottiPeriodo"] = this.minimoNottiPeriodo !== undefined ? this.minimoNottiPeriodo : null as any;
        data["giorniEntrata"] = this.giorniEntrata !== undefined ? this.giorniEntrata : null as any;
        data["giorniUscita"] = this.giorniUscita !== undefined ? this.giorniUscita : null as any;
        data["prenotaEntroData"] = this.prenotaEntroData !== undefined ? this.prenotaEntroData : null as any;
        data["prenotaEntroGiorni"] = this.prenotaEntroGiorni !== undefined ? this.prenotaEntroGiorni : null as any;
        data["deregolamentaSuRichiesta"] = this.deregolamentaSuRichiesta !== undefined ? this.deregolamentaSuRichiesta : null as any;
        data["penaleID"] = this.penaleID !== undefined ? this.penaleID : null as any;
        data["giorniPenale"] = this.giorniPenale !== undefined ? this.giorniPenale : null as any;
        data["percentualePenale"] = this.percentualePenale !== undefined ? this.percentualePenale : null as any;
        data["nome_fr"] = this.nome_fr !== undefined ? this.nome_fr : null as any;
        data["nome_de"] = this.nome_de !== undefined ? this.nome_de : null as any;
        data["nome_es"] = this.nome_es !== undefined ? this.nome_es : null as any;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : null as any;
        data["articoloID"] = this.articoloID !== undefined ? this.articoloID : null as any;
        return data;
    }
}

export interface IIServizioRegolaVendita {
    id?: number;
    servizioID?: number;
    nome?: string | null;
    numeroGiorni?: number | null;
    minimoGiorni?: number | null;
    massimoGiorni?: number | null;
    etaMinima?: number | null;
    etaMassima?: number | null;
    dal?: string | null;
    al?: string | null;
    commissioniAgenzia?: number | null;
    commissioniTourOperator?: number | null;
    minimoNottiPeriodo?: number | null;
    giorniEntrata?: string | null;
    giorniUscita?: string | null;
    prenotaEntroData?: string | null;
    prenotaEntroGiorni?: number | null;
    deregolamentaSuRichiesta?: boolean | null;
    penaleID?: number | null;
    giorniPenale?: number | null;
    percentualePenale?: number | null;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    articoloID?: number | null;
}

export class UpsertTipologiaResponse extends GetTipologieResponse implements IUpsertTipologiaResponse {
    tipologia?: ServizioTipologia | null;
    nome?: string | null;

    constructor(data?: IUpsertTipologiaResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tipologia = _data["tipologia"] ? ServizioTipologia.fromJS(_data["tipologia"]) : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
        }
    }

    static override fromJS(data: any): UpsertTipologiaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertTipologiaResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipologia"] = this.tipologia ? this.tipologia.toJSON() : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertTipologiaResponse extends IGetTipologieResponse {
    tipologia?: ServizioTipologia | null;
    nome?: string | null;
}

export class UpsertTiplogiaRequest extends GetTipologieRequest implements IUpsertTiplogiaRequest {
    tipologia?: ServizioTipologia | null;

    constructor(data?: IUpsertTiplogiaRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tipologia = _data["tipologia"] ? ServizioTipologia.fromJS(_data["tipologia"]) : null as any;
        }
    }

    static override fromJS(data: any): UpsertTiplogiaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertTiplogiaRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipologia"] = this.tipologia ? this.tipologia.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertTiplogiaRequest extends IGetTipologieRequest {
    tipologia?: ServizioTipologia | null;
}

export class UpsertValiditaResponse extends GetValiditaResponse implements IUpsertValiditaResponse {
    validitaEdit?: Validita | null;

    constructor(data?: IUpsertValiditaResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validitaEdit = _data["validitaEdit"] ? Validita.fromJS(_data["validitaEdit"]) : null as any;
        }
    }

    static override fromJS(data: any): UpsertValiditaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertValiditaResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validitaEdit"] = this.validitaEdit ? this.validitaEdit.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertValiditaResponse extends IGetValiditaResponse {
    validitaEdit?: Validita | null;
}

export class UpsertValiditaRequest extends ServizioGetRequest implements IUpsertValiditaRequest {
    validita?: Validita | null;

    constructor(data?: IUpsertValiditaRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validita = _data["validita"] ? Validita.fromJS(_data["validita"]) : null as any;
        }
    }

    static override fromJS(data: any): UpsertValiditaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertValiditaRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validita"] = this.validita ? this.validita.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertValiditaRequest extends IServizioGetRequest {
    validita?: Validita | null;
}

export class ChangeMacroTypeRequest extends LocalizedRequest implements IChangeMacroTypeRequest {
    servizioHHID?: number;
    tipologiaHHID?: number;
    newMacroTypeID?: number;

    constructor(data?: IChangeMacroTypeRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHID = _data["servizioHHID"] !== undefined ? _data["servizioHHID"] : null as any;
            this.tipologiaHHID = _data["tipologiaHHID"] !== undefined ? _data["tipologiaHHID"] : null as any;
            this.newMacroTypeID = _data["newMacroTypeID"] !== undefined ? _data["newMacroTypeID"] : null as any;
        }
    }

    static override fromJS(data: any): ChangeMacroTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeMacroTypeRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHID"] = this.servizioHHID !== undefined ? this.servizioHHID : null as any;
        data["tipologiaHHID"] = this.tipologiaHHID !== undefined ? this.tipologiaHHID : null as any;
        data["newMacroTypeID"] = this.newMacroTypeID !== undefined ? this.newMacroTypeID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IChangeMacroTypeRequest extends ILocalizedRequest {
    servizioHHID?: number;
    tipologiaHHID?: number;
    newMacroTypeID?: number;
}

export class ConfirmAutomatchServizioH2HRequest extends ApiRequest implements IConfirmAutomatchServizioH2HRequest {
    servizioHHId?: number;

    constructor(data?: IConfirmAutomatchServizioH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : null as any;
        }
    }

    static override fromJS(data: any): ConfirmAutomatchServizioH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmAutomatchServizioH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IConfirmAutomatchServizioH2HRequest extends IApiRequest {
    servizioHHId?: number;
}

export class ConfirmAutomatchServizioH2HMultiRequest extends ApiRequest implements IConfirmAutomatchServizioH2HMultiRequest {
    servizioHHIds?: number[] | null;

    constructor(data?: IConfirmAutomatchServizioH2HMultiRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["servizioHHIds"])) {
                this.servizioHHIds = [] as any;
                for (let item of _data["servizioHHIds"])
                    this.servizioHHIds!.push(item);
            }
            else {
                this.servizioHHIds = null as any;
            }
        }
    }

    static override fromJS(data: any): ConfirmAutomatchServizioH2HMultiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmAutomatchServizioH2HMultiRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.servizioHHIds)) {
            data["servizioHHIds"] = [];
            for (let item of this.servizioHHIds)
                data["servizioHHIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IConfirmAutomatchServizioH2HMultiRequest extends IApiRequest {
    servizioHHIds?: number[] | null;
}

export class ConfirmMappingServizioH2HRequest extends ApiRequest implements IConfirmMappingServizioH2HRequest {
    servizioHHId?: number;

    constructor(data?: IConfirmMappingServizioH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : null as any;
        }
    }

    static override fromJS(data: any): ConfirmMappingServizioH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmMappingServizioH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IConfirmMappingServizioH2HRequest extends IApiRequest {
    servizioHHId?: number;
}

export class ConfirmTypeMappingResponse extends OkApiResponse implements IConfirmTypeMappingResponse {
    codice?: HHTipologiaFornitore | null;

    constructor(data?: IConfirmTypeMappingResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.codice = _data["codice"] ? HHTipologiaFornitore.fromJS(_data["codice"]) : null as any;
        }
    }

    static override fromJS(data: any): ConfirmTypeMappingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmTypeMappingResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codice"] = this.codice ? this.codice.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IConfirmTypeMappingResponse extends IOkApiResponse {
    codice?: HHTipologiaFornitore | null;
}

export class ConfirmTypeMappingRequest extends ApiRequest implements IConfirmTypeMappingRequest {
    servizioHHId?: number;
    tipologiaHHID?: number;

    constructor(data?: IConfirmTypeMappingRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : null as any;
            this.tipologiaHHID = _data["tipologiaHHID"] !== undefined ? _data["tipologiaHHID"] : null as any;
        }
    }

    static override fromJS(data: any): ConfirmTypeMappingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmTypeMappingRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : null as any;
        data["tipologiaHHID"] = this.tipologiaHHID !== undefined ? this.tipologiaHHID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IConfirmTypeMappingRequest extends IApiRequest {
    servizioHHId?: number;
    tipologiaHHID?: number;
}

export class CreateServizioH2HResponse extends OkApiResponse implements ICreateServizioH2HResponse {
    servizio?: HHServizio | null;
    luogo?: string | null;

    constructor(data?: ICreateServizioH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizio = _data["servizio"] ? HHServizio.fromJS(_data["servizio"]) : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
        }
    }

    static override fromJS(data: any): CreateServizioH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServizioH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio ? this.servizio.toJSON() : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateServizioH2HResponse extends IOkApiResponse {
    servizio?: HHServizio | null;
    luogo?: string | null;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class CreateServizioH2HRequest extends ApiRequest implements ICreateServizioH2HRequest {
    servizioHH?: HHServizio | null;
    createNaarService?: boolean;
    servizioNaar?: CreateServizioNaarRequest | null;
    mappa?: CreateMappaRequest | null;

    constructor(data?: ICreateServizioH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHH = _data["servizioHH"] ? HHServizio.fromJS(_data["servizioHH"]) : null as any;
            this.createNaarService = _data["createNaarService"] !== undefined ? _data["createNaarService"] : null as any;
            this.servizioNaar = _data["servizioNaar"] ? CreateServizioNaarRequest.fromJS(_data["servizioNaar"]) : null as any;
            this.mappa = _data["mappa"] ? CreateMappaRequest.fromJS(_data["mappa"]) : null as any;
        }
    }

    static override fromJS(data: any): CreateServizioH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServizioH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHH"] = this.servizioHH ? this.servizioHH.toJSON() : null as any;
        data["createNaarService"] = this.createNaarService !== undefined ? this.createNaarService : null as any;
        data["servizioNaar"] = this.servizioNaar ? this.servizioNaar.toJSON() : null as any;
        data["mappa"] = this.mappa ? this.mappa.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface ICreateServizioH2HRequest extends IApiRequest {
    servizioHH?: HHServizio | null;
    createNaarService?: boolean;
    servizioNaar?: CreateServizioNaarRequest | null;
    mappa?: CreateMappaRequest | null;
}

export class CreateServizioNaarRequest implements ICreateServizioNaarRequest {
    ordine?: number | null;
    preferito?: boolean;
    pubblicazione?: EStatoPubblicazioneServizio | null;
    status?: EStatoUtilizzoServizio | null;
    attributiIDs?: number[] | null;

    constructor(data?: ICreateServizioNaarRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.preferito = _data["preferito"] !== undefined ? _data["preferito"] : null as any;
            this.pubblicazione = _data["pubblicazione"] !== undefined ? _data["pubblicazione"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            if (Array.isArray(_data["attributiIDs"])) {
                this.attributiIDs = [] as any;
                for (let item of _data["attributiIDs"])
                    this.attributiIDs!.push(item);
            }
            else {
                this.attributiIDs = null as any;
            }
        }
    }

    static fromJS(data: any): CreateServizioNaarRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServizioNaarRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["preferito"] = this.preferito !== undefined ? this.preferito : null as any;
        data["pubblicazione"] = this.pubblicazione !== undefined ? this.pubblicazione : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        if (Array.isArray(this.attributiIDs)) {
            data["attributiIDs"] = [];
            for (let item of this.attributiIDs)
                data["attributiIDs"].push(item);
        }
        return data;
    }
}

export interface ICreateServizioNaarRequest {
    ordine?: number | null;
    preferito?: boolean;
    pubblicazione?: EStatoPubblicazioneServizio | null;
    status?: EStatoUtilizzoServizio | null;
    attributiIDs?: number[] | null;
}

export class CreateMappaRequest implements ICreateMappaRequest {
    latitude?: number | null;
    longitude?: number | null;
    zoom?: number | null;

    constructor(data?: ICreateMappaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : null as any;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : null as any;
            this.zoom = _data["zoom"] !== undefined ? _data["zoom"] : null as any;
        }
    }

    static fromJS(data: any): CreateMappaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMappaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude !== undefined ? this.latitude : null as any;
        data["longitude"] = this.longitude !== undefined ? this.longitude : null as any;
        data["zoom"] = this.zoom !== undefined ? this.zoom : null as any;
        return data;
    }
}

export interface ICreateMappaRequest {
    latitude?: number | null;
    longitude?: number | null;
    zoom?: number | null;
}

export class CreateServiceResponse extends OkApiResponse implements ICreateServiceResponse {
    servizio?: Servizio | null;

    constructor(data?: ICreateServiceResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizio = _data["servizio"] ? Servizio.fromJS(_data["servizio"]) : null as any;
        }
    }

    static override fromJS(data: any): CreateServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio ? this.servizio.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateServiceResponse extends IOkApiResponse {
    servizio?: Servizio | null;
}

export class CreateServiceRequest extends ApiRequest implements ICreateServiceRequest {
    nome!: string;
    nomeInglese?: string | null;
    luogoID!: number;
    giataID?: number | null;
    ordine?: number | null;
    preferito?: boolean;
    pubblicazione?: EStatoPubblicazioneServizio | null;
    status?: EStatoUtilizzoServizio | null;
    cap?: string | null;
    indirizzo?: string | null;
    telefono?: string | null;
    latitudine?: number | null;
    longitudine?: number | null;
    zoom?: number | null;
    attributiIDs?: number[] | null;

    constructor(data?: ICreateServiceRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nomeInglese = _data["nomeInglese"] !== undefined ? _data["nomeInglese"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.giataID = _data["giataID"] !== undefined ? _data["giataID"] : null as any;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : null as any;
            this.preferito = _data["preferito"] !== undefined ? _data["preferito"] : null as any;
            this.pubblicazione = _data["pubblicazione"] !== undefined ? _data["pubblicazione"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : null as any;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : null as any;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : null as any;
            this.latitudine = _data["latitudine"] !== undefined ? _data["latitudine"] : null as any;
            this.longitudine = _data["longitudine"] !== undefined ? _data["longitudine"] : null as any;
            this.zoom = _data["zoom"] !== undefined ? _data["zoom"] : null as any;
            if (Array.isArray(_data["attributiIDs"])) {
                this.attributiIDs = [] as any;
                for (let item of _data["attributiIDs"])
                    this.attributiIDs!.push(item);
            }
            else {
                this.attributiIDs = null as any;
            }
        }
    }

    static override fromJS(data: any): CreateServiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nomeInglese"] = this.nomeInglese !== undefined ? this.nomeInglese : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["giataID"] = this.giataID !== undefined ? this.giataID : null as any;
        data["ordine"] = this.ordine !== undefined ? this.ordine : null as any;
        data["preferito"] = this.preferito !== undefined ? this.preferito : null as any;
        data["pubblicazione"] = this.pubblicazione !== undefined ? this.pubblicazione : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["cap"] = this.cap !== undefined ? this.cap : null as any;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : null as any;
        data["telefono"] = this.telefono !== undefined ? this.telefono : null as any;
        data["latitudine"] = this.latitudine !== undefined ? this.latitudine : null as any;
        data["longitudine"] = this.longitudine !== undefined ? this.longitudine : null as any;
        data["zoom"] = this.zoom !== undefined ? this.zoom : null as any;
        if (Array.isArray(this.attributiIDs)) {
            data["attributiIDs"] = [];
            for (let item of this.attributiIDs)
                data["attributiIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICreateServiceRequest extends IApiRequest {
    nome: string;
    nomeInglese?: string | null;
    luogoID: number;
    giataID?: number | null;
    ordine?: number | null;
    preferito?: boolean;
    pubblicazione?: EStatoPubblicazioneServizio | null;
    status?: EStatoUtilizzoServizio | null;
    cap?: string | null;
    indirizzo?: string | null;
    telefono?: string | null;
    latitudine?: number | null;
    longitudine?: number | null;
    zoom?: number | null;
    attributiIDs?: number[] | null;
}

export class DeleteServizioH2HRequest extends ApiRequest implements IDeleteServizioH2HRequest {
    servizioHHId?: number;

    constructor(data?: IDeleteServizioH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : null as any;
        }
    }

    static override fromJS(data: any): DeleteServizioH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteServizioH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteServizioH2HRequest extends IApiRequest {
    servizioHHId?: number;
}

export class DeleteServizioAggregatoH2HRequest extends ApiRequest implements IDeleteServizioAggregatoH2HRequest {
    servizioAggregatoHHId?: number;

    constructor(data?: IDeleteServizioAggregatoH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioAggregatoHHId = _data["servizioAggregatoHHId"] !== undefined ? _data["servizioAggregatoHHId"] : null as any;
        }
    }

    static override fromJS(data: any): DeleteServizioAggregatoH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteServizioAggregatoH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioAggregatoHHId"] = this.servizioAggregatoHHId !== undefined ? this.servizioAggregatoHHId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteServizioAggregatoH2HRequest extends IApiRequest {
    servizioAggregatoHHId?: number;
}

export class DeleteMapH2HRequest extends ApiRequest implements IDeleteMapH2HRequest {
    servizioHHId?: number;

    constructor(data?: IDeleteMapH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : null as any;
        }
    }

    static override fromJS(data: any): DeleteMapH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMapH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteMapH2HRequest extends IApiRequest {
    servizioHHId?: number;
}

export class DeleteServiceHashcodesRequest extends ApiRequest implements IDeleteServiceHashcodesRequest {
    h2HServiceID?: number;
    hashcodeID?: number;

    constructor(data?: IDeleteServiceHashcodesRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.h2HServiceID = _data["h2HServiceID"] !== undefined ? _data["h2HServiceID"] : null as any;
            this.hashcodeID = _data["hashcodeID"] !== undefined ? _data["hashcodeID"] : null as any;
        }
    }

    static override fromJS(data: any): DeleteServiceHashcodesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteServiceHashcodesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["h2HServiceID"] = this.h2HServiceID !== undefined ? this.h2HServiceID : null as any;
        data["hashcodeID"] = this.hashcodeID !== undefined ? this.hashcodeID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteServiceHashcodesRequest extends IApiRequest {
    h2HServiceID?: number;
    hashcodeID?: number;
}

export class DisableServizioH2HResponse extends OkApiResponse implements IDisableServizioH2HResponse {
    servizio?: HHServizio | null;

    constructor(data?: IDisableServizioH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizio = _data["servizio"] ? HHServizio.fromJS(_data["servizio"]) : null as any;
        }
    }

    static override fromJS(data: any): DisableServizioH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DisableServizioH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio ? this.servizio.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDisableServizioH2HResponse extends IOkApiResponse {
    servizio?: HHServizio | null;
}

export class DisableServizioH2HRequest extends ApiRequest implements IDisableServizioH2HRequest {
    servizioHHId?: number;

    constructor(data?: IDisableServizioH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : null as any;
        }
    }

    static override fromJS(data: any): DisableServizioH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DisableServizioH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDisableServizioH2HRequest extends IApiRequest {
    servizioHHId?: number;
}

export class DisableDescriptionH2HResponse extends OkApiResponse implements IDisableDescriptionH2HResponse {
    description?: HHDescrizione | null;

    constructor(data?: IDisableDescriptionH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.description = _data["description"] ? HHDescrizione.fromJS(_data["description"]) : null as any;
        }
    }

    static override fromJS(data: any): DisableDescriptionH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DisableDescriptionH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description ? this.description.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDisableDescriptionH2HResponse extends IOkApiResponse {
    description?: HHDescrizione | null;
}

export class DisableDescriptionH2HRequest extends ApiRequest implements IDisableDescriptionH2HRequest {
    descriptionH2HId?: number;

    constructor(data?: IDisableDescriptionH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.descriptionH2HId = _data["descriptionH2HId"] !== undefined ? _data["descriptionH2HId"] : null as any;
        }
    }

    static override fromJS(data: any): DisableDescriptionH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DisableDescriptionH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descriptionH2HId"] = this.descriptionH2HId !== undefined ? this.descriptionH2HId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDisableDescriptionH2HRequest extends IApiRequest {
    descriptionH2HId?: number;
}

export class DisableImageH2HResponse extends OkApiResponse implements IDisableImageH2HResponse {
    image?: HHImmagine | null;

    constructor(data?: IDisableImageH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.image = _data["image"] ? HHImmagine.fromJS(_data["image"]) : null as any;
        }
    }

    static override fromJS(data: any): DisableImageH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DisableImageH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image ? this.image.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDisableImageH2HResponse extends IOkApiResponse {
    image?: HHImmagine | null;
}

export class DisableImageH2HRequest extends ApiRequest implements IDisableImageH2HRequest {
    imageH2HId?: number;

    constructor(data?: IDisableImageH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.imageH2HId = _data["imageH2HId"] !== undefined ? _data["imageH2HId"] : null as any;
        }
    }

    static override fromJS(data: any): DisableImageH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DisableImageH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageH2HId"] = this.imageH2HId !== undefined ? this.imageH2HId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDisableImageH2HRequest extends IApiRequest {
    imageH2HId?: number;
}

export class EnableServizioH2HResponse extends OkApiResponse implements IEnableServizioH2HResponse {
    servizio?: HHServizio | null;

    constructor(data?: IEnableServizioH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizio = _data["servizio"] ? HHServizio.fromJS(_data["servizio"]) : null as any;
        }
    }

    static override fromJS(data: any): EnableServizioH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnableServizioH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio ? this.servizio.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IEnableServizioH2HResponse extends IOkApiResponse {
    servizio?: HHServizio | null;
}

export class EnableServizioH2HRequest extends ApiRequest implements IEnableServizioH2HRequest {
    servizioHHId?: number;

    constructor(data?: IEnableServizioH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : null as any;
        }
    }

    static override fromJS(data: any): EnableServizioH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnableServizioH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IEnableServizioH2HRequest extends IApiRequest {
    servizioHHId?: number;
}

export class EnableDescriptionH2HResponse extends OkApiResponse implements IEnableDescriptionH2HResponse {
    description?: HHDescrizione | null;

    constructor(data?: IEnableDescriptionH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.description = _data["description"] ? HHDescrizione.fromJS(_data["description"]) : null as any;
        }
    }

    static override fromJS(data: any): EnableDescriptionH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnableDescriptionH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description ? this.description.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IEnableDescriptionH2HResponse extends IOkApiResponse {
    description?: HHDescrizione | null;
}

export class EnableDescriptionH2HRequest extends ApiRequest implements IEnableDescriptionH2HRequest {
    descriptionH2HId?: number;

    constructor(data?: IEnableDescriptionH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.descriptionH2HId = _data["descriptionH2HId"] !== undefined ? _data["descriptionH2HId"] : null as any;
        }
    }

    static override fromJS(data: any): EnableDescriptionH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnableDescriptionH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descriptionH2HId"] = this.descriptionH2HId !== undefined ? this.descriptionH2HId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IEnableDescriptionH2HRequest extends IApiRequest {
    descriptionH2HId?: number;
}

export class EnableImageH2HResponse extends OkApiResponse implements IEnableImageH2HResponse {
    image?: HHImmagine | null;

    constructor(data?: IEnableImageH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.image = _data["image"] ? HHImmagine.fromJS(_data["image"]) : null as any;
        }
    }

    static override fromJS(data: any): EnableImageH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnableImageH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image ? this.image.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IEnableImageH2HResponse extends IOkApiResponse {
    image?: HHImmagine | null;
}

export class EnableImageH2HRequest extends ApiRequest implements IEnableImageH2HRequest {
    imageH2HId?: number;

    constructor(data?: IEnableImageH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.imageH2HId = _data["imageH2HId"] !== undefined ? _data["imageH2HId"] : null as any;
        }
    }

    static override fromJS(data: any): EnableImageH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnableImageH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageH2HId"] = this.imageH2HId !== undefined ? this.imageH2HId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IEnableImageH2HRequest extends IApiRequest {
    imageH2HId?: number;
}

export class GetServizioFornitoreResponse extends OkApiResponse implements IGetServizioFornitoreResponse {
    servizioFornitore?: SVCRow | null;

    constructor(data?: IGetServizioFornitoreResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioFornitore = _data["servizioFornitore"] ? SVCRow.fromJS(_data["servizioFornitore"]) : null as any;
        }
    }

    static override fromJS(data: any): GetServizioFornitoreResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetServizioFornitoreResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioFornitore"] = this.servizioFornitore ? this.servizioFornitore.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetServizioFornitoreResponse extends IOkApiResponse {
    servizioFornitore?: SVCRow | null;
}

export class SVCRow implements ISVCRow {
    id?: number;
    giataID?: number | null;
    codiceRicercaGiata?: string | null;
    codiceGiataFornitore?: string | null;
    luogoNaar?: string | null;
    luogoNaarID?: number | null;
    luogoFornitore?: string | null;
    codiceLuogoFornitore?: string | null;
    fornitore?: string | null;
    codiceFornitore?: string | null;
    nomeServizioFornitore?: string | null;
    servizioNaarID?: number | null;
    servizioAggregatoID?: number | null;
    haServizioAggregato?: boolean;
    svcAggregatoMappato?: boolean;
    aggregatoDaConfermare?: boolean;
    indirizzoAggregato?: string | null;
    servizioNaar?: string | null;
    rating?: number | null;
    daConfermare?: boolean;
    indirizzoFornitore?: string | null;
    lat?: number | null;
    lon?: number | null;
    indirizzoNaar?: string | null;
    ultimoAggiornamento?: string | null;
    servizio?: HHServizioFornitore | null;
    deleted?: boolean;
    agreementId?: number | null;

    constructor(data?: ISVCRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.giataID = _data["giataID"] !== undefined ? _data["giataID"] : null as any;
            this.codiceRicercaGiata = _data["codiceRicercaGiata"] !== undefined ? _data["codiceRicercaGiata"] : null as any;
            this.codiceGiataFornitore = _data["codiceGiataFornitore"] !== undefined ? _data["codiceGiataFornitore"] : null as any;
            this.luogoNaar = _data["luogoNaar"] !== undefined ? _data["luogoNaar"] : null as any;
            this.luogoNaarID = _data["luogoNaarID"] !== undefined ? _data["luogoNaarID"] : null as any;
            this.luogoFornitore = _data["luogoFornitore"] !== undefined ? _data["luogoFornitore"] : null as any;
            this.codiceLuogoFornitore = _data["codiceLuogoFornitore"] !== undefined ? _data["codiceLuogoFornitore"] : null as any;
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : null as any;
            this.codiceFornitore = _data["codiceFornitore"] !== undefined ? _data["codiceFornitore"] : null as any;
            this.nomeServizioFornitore = _data["nomeServizioFornitore"] !== undefined ? _data["nomeServizioFornitore"] : null as any;
            this.servizioNaarID = _data["servizioNaarID"] !== undefined ? _data["servizioNaarID"] : null as any;
            this.servizioAggregatoID = _data["servizioAggregatoID"] !== undefined ? _data["servizioAggregatoID"] : null as any;
            this.haServizioAggregato = _data["haServizioAggregato"] !== undefined ? _data["haServizioAggregato"] : null as any;
            this.svcAggregatoMappato = _data["svcAggregatoMappato"] !== undefined ? _data["svcAggregatoMappato"] : null as any;
            this.aggregatoDaConfermare = _data["aggregatoDaConfermare"] !== undefined ? _data["aggregatoDaConfermare"] : null as any;
            this.indirizzoAggregato = _data["indirizzoAggregato"] !== undefined ? _data["indirizzoAggregato"] : null as any;
            this.servizioNaar = _data["servizioNaar"] !== undefined ? _data["servizioNaar"] : null as any;
            this.rating = _data["rating"] !== undefined ? _data["rating"] : null as any;
            this.daConfermare = _data["daConfermare"] !== undefined ? _data["daConfermare"] : null as any;
            this.indirizzoFornitore = _data["indirizzoFornitore"] !== undefined ? _data["indirizzoFornitore"] : null as any;
            this.lat = _data["lat"] !== undefined ? _data["lat"] : null as any;
            this.lon = _data["lon"] !== undefined ? _data["lon"] : null as any;
            this.indirizzoNaar = _data["indirizzoNaar"] !== undefined ? _data["indirizzoNaar"] : null as any;
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] !== undefined ? _data["ultimoAggiornamento"] : null as any;
            this.servizio = _data["servizio"] ? HHServizioFornitore.fromJS(_data["servizio"]) : null as any;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : null as any;
            this.agreementId = _data["agreementId"] !== undefined ? _data["agreementId"] : null as any;
        }
    }

    static fromJS(data: any): SVCRow {
        data = typeof data === 'object' ? data : {};
        let result = new SVCRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["giataID"] = this.giataID !== undefined ? this.giataID : null as any;
        data["codiceRicercaGiata"] = this.codiceRicercaGiata !== undefined ? this.codiceRicercaGiata : null as any;
        data["codiceGiataFornitore"] = this.codiceGiataFornitore !== undefined ? this.codiceGiataFornitore : null as any;
        data["luogoNaar"] = this.luogoNaar !== undefined ? this.luogoNaar : null as any;
        data["luogoNaarID"] = this.luogoNaarID !== undefined ? this.luogoNaarID : null as any;
        data["luogoFornitore"] = this.luogoFornitore !== undefined ? this.luogoFornitore : null as any;
        data["codiceLuogoFornitore"] = this.codiceLuogoFornitore !== undefined ? this.codiceLuogoFornitore : null as any;
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : null as any;
        data["codiceFornitore"] = this.codiceFornitore !== undefined ? this.codiceFornitore : null as any;
        data["nomeServizioFornitore"] = this.nomeServizioFornitore !== undefined ? this.nomeServizioFornitore : null as any;
        data["servizioNaarID"] = this.servizioNaarID !== undefined ? this.servizioNaarID : null as any;
        data["servizioAggregatoID"] = this.servizioAggregatoID !== undefined ? this.servizioAggregatoID : null as any;
        data["haServizioAggregato"] = this.haServizioAggregato !== undefined ? this.haServizioAggregato : null as any;
        data["svcAggregatoMappato"] = this.svcAggregatoMappato !== undefined ? this.svcAggregatoMappato : null as any;
        data["aggregatoDaConfermare"] = this.aggregatoDaConfermare !== undefined ? this.aggregatoDaConfermare : null as any;
        data["indirizzoAggregato"] = this.indirizzoAggregato !== undefined ? this.indirizzoAggregato : null as any;
        data["servizioNaar"] = this.servizioNaar !== undefined ? this.servizioNaar : null as any;
        data["rating"] = this.rating !== undefined ? this.rating : null as any;
        data["daConfermare"] = this.daConfermare !== undefined ? this.daConfermare : null as any;
        data["indirizzoFornitore"] = this.indirizzoFornitore !== undefined ? this.indirizzoFornitore : null as any;
        data["lat"] = this.lat !== undefined ? this.lat : null as any;
        data["lon"] = this.lon !== undefined ? this.lon : null as any;
        data["indirizzoNaar"] = this.indirizzoNaar !== undefined ? this.indirizzoNaar : null as any;
        data["ultimoAggiornamento"] = this.ultimoAggiornamento !== undefined ? this.ultimoAggiornamento : null as any;
        data["servizio"] = this.servizio ? this.servizio.toJSON() : null as any;
        data["deleted"] = this.deleted !== undefined ? this.deleted : null as any;
        data["agreementId"] = this.agreementId !== undefined ? this.agreementId : null as any;
        return data;
    }
}

export interface ISVCRow {
    id?: number;
    giataID?: number | null;
    codiceRicercaGiata?: string | null;
    codiceGiataFornitore?: string | null;
    luogoNaar?: string | null;
    luogoNaarID?: number | null;
    luogoFornitore?: string | null;
    codiceLuogoFornitore?: string | null;
    fornitore?: string | null;
    codiceFornitore?: string | null;
    nomeServizioFornitore?: string | null;
    servizioNaarID?: number | null;
    servizioAggregatoID?: number | null;
    haServizioAggregato?: boolean;
    svcAggregatoMappato?: boolean;
    aggregatoDaConfermare?: boolean;
    indirizzoAggregato?: string | null;
    servizioNaar?: string | null;
    rating?: number | null;
    daConfermare?: boolean;
    indirizzoFornitore?: string | null;
    lat?: number | null;
    lon?: number | null;
    indirizzoNaar?: string | null;
    ultimoAggiornamento?: string | null;
    servizio?: HHServizioFornitore | null;
    deleted?: boolean;
    agreementId?: number | null;
}

export class GetServizioFornitoreRequest extends ApiRequest implements IGetServizioFornitoreRequest {
    servizioFornitoreID?: number;

    constructor(data?: IGetServizioFornitoreRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioFornitoreID = _data["servizioFornitoreID"] !== undefined ? _data["servizioFornitoreID"] : null as any;
        }
    }

    static override fromJS(data: any): GetServizioFornitoreRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetServizioFornitoreRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioFornitoreID"] = this.servizioFornitoreID !== undefined ? this.servizioFornitoreID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetServizioFornitoreRequest extends IApiRequest {
    servizioFornitoreID?: number;
}

export class GetAdditionalDataServiziH2HResponse extends OkApiResponse implements IGetAdditionalDataServiziH2HResponse {
    rows?: DatiAggiuntiviServizioH2HRow[] | null;

    constructor(data?: IGetAdditionalDataServiziH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(DatiAggiuntiviServizioH2HRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
        }
    }

    static override fromJS(data: any): GetAdditionalDataServiziH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdditionalDataServiziH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetAdditionalDataServiziH2HResponse extends IOkApiResponse {
    rows?: DatiAggiuntiviServizioH2HRow[] | null;
}

export class DatiAggiuntiviServizioH2HRow implements IDatiAggiuntiviServizioH2HRow {
    id?: number;
    description?: string | null;
    updatedAt?: string;

    constructor(data?: IDatiAggiuntiviServizioH2HRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : null as any;
        }
    }

    static fromJS(data: any): DatiAggiuntiviServizioH2HRow {
        data = typeof data === 'object' ? data : {};
        let result = new DatiAggiuntiviServizioH2HRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : null as any;
        return data;
    }
}

export interface IDatiAggiuntiviServizioH2HRow {
    id?: number;
    description?: string | null;
    updatedAt?: string;
}

export class GetAdditionalDataServiziH2HRequest extends ApiRequest implements IGetAdditionalDataServiziH2HRequest {
    servizioFornitoreID?: number;

    constructor(data?: IGetAdditionalDataServiziH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioFornitoreID = _data["servizioFornitoreID"] !== undefined ? _data["servizioFornitoreID"] : null as any;
        }
    }

    static override fromJS(data: any): GetAdditionalDataServiziH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdditionalDataServiziH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioFornitoreID"] = this.servizioFornitoreID !== undefined ? this.servizioFornitoreID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetAdditionalDataServiziH2HRequest extends IApiRequest {
    servizioFornitoreID?: number;
}

export class GetDescriptionsServiziH2HResponse extends OkApiResponse implements IGetDescriptionsServiziH2HResponse {
    rows?: DescrizioneServizioH2HRow[] | null;

    constructor(data?: IGetDescriptionsServiziH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(DescrizioneServizioH2HRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
        }
    }

    static override fromJS(data: any): GetDescriptionsServiziH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDescriptionsServiziH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetDescriptionsServiziH2HResponse extends IOkApiResponse {
    rows?: DescrizioneServizioH2HRow[] | null;
}

export class DescrizioneServizioH2HRow implements IDescrizioneServizioH2HRow {
    id?: number;
    supplier?: string | null;
    sortOrder?: number;
    lang?: ELingua;
    enabled?: boolean;
    title?: string | null;
    text?: string | null;
    html?: boolean;
    updatedAt?: string;

    constructor(data?: IDescrizioneServizioH2HRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : null as any;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null as any;
            this.lang = _data["lang"] !== undefined ? _data["lang"] : null as any;
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
            this.html = _data["html"] !== undefined ? _data["html"] : null as any;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : null as any;
        }
    }

    static fromJS(data: any): DescrizioneServizioH2HRow {
        data = typeof data === 'object' ? data : {};
        let result = new DescrizioneServizioH2HRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["supplier"] = this.supplier !== undefined ? this.supplier : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        data["lang"] = this.lang !== undefined ? this.lang : null as any;
        data["enabled"] = this.enabled !== undefined ? this.enabled : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["text"] = this.text !== undefined ? this.text : null as any;
        data["html"] = this.html !== undefined ? this.html : null as any;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : null as any;
        return data;
    }
}

export interface IDescrizioneServizioH2HRow {
    id?: number;
    supplier?: string | null;
    sortOrder?: number;
    lang?: ELingua;
    enabled?: boolean;
    title?: string | null;
    text?: string | null;
    html?: boolean;
    updatedAt?: string;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class GetDescriptionsServiziH2HRequest extends ApiRequest implements IGetDescriptionsServiziH2HRequest {
    servizioAggregatoID?: number;

    constructor(data?: IGetDescriptionsServiziH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioAggregatoID = _data["servizioAggregatoID"] !== undefined ? _data["servizioAggregatoID"] : null as any;
        }
    }

    static override fromJS(data: any): GetDescriptionsServiziH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDescriptionsServiziH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioAggregatoID"] = this.servizioAggregatoID !== undefined ? this.servizioAggregatoID : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IGetDescriptionsServiziH2HRequest extends IApiRequest {
    servizioAggregatoID?: number;
}

export class GetGiataCodesResponse extends OkApiResponse implements IGetGiataCodesResponse {
    giataCity?: string | null;
    giataCityId?: string | null;
    giataCountryCode?: string | null;
    giataCountry?: string | null;
    giataId?: number;
    mapped?: boolean;
    suppliers?: SupplierRow2[] | null;

    constructor(data?: IGetGiataCodesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.giataCity = _data["giataCity"] !== undefined ? _data["giataCity"] : null as any;
            this.giataCityId = _data["giataCityId"] !== undefined ? _data["giataCityId"] : null as any;
            this.giataCountryCode = _data["giataCountryCode"] !== undefined ? _data["giataCountryCode"] : null as any;
            this.giataCountry = _data["giataCountry"] !== undefined ? _data["giataCountry"] : null as any;
            this.giataId = _data["giataId"] !== undefined ? _data["giataId"] : null as any;
            this.mapped = _data["mapped"] !== undefined ? _data["mapped"] : null as any;
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [] as any;
                for (let item of _data["suppliers"])
                    this.suppliers!.push(SupplierRow2.fromJS(item));
            }
            else {
                this.suppliers = null as any;
            }
        }
    }

    static override fromJS(data: any): GetGiataCodesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiataCodesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giataCity"] = this.giataCity !== undefined ? this.giataCity : null as any;
        data["giataCityId"] = this.giataCityId !== undefined ? this.giataCityId : null as any;
        data["giataCountryCode"] = this.giataCountryCode !== undefined ? this.giataCountryCode : null as any;
        data["giataCountry"] = this.giataCountry !== undefined ? this.giataCountry : null as any;
        data["giataId"] = this.giataId !== undefined ? this.giataId : null as any;
        data["mapped"] = this.mapped !== undefined ? this.mapped : null as any;
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetGiataCodesResponse extends IOkApiResponse {
    giataCity?: string | null;
    giataCityId?: string | null;
    giataCountryCode?: string | null;
    giataCountry?: string | null;
    giataId?: number;
    mapped?: boolean;
    suppliers?: SupplierRow2[] | null;
}

export class SupplierRow2 implements ISupplierRow2 {
    supplier?: EFornitore;
    codici?: CodiceGiataRow[] | null;

    constructor(data?: ISupplierRow2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : null as any;
            if (Array.isArray(_data["codici"])) {
                this.codici = [] as any;
                for (let item of _data["codici"])
                    this.codici!.push(CodiceGiataRow.fromJS(item));
            }
            else {
                this.codici = null as any;
            }
        }
    }

    static fromJS(data: any): SupplierRow2 {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierRow2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplier"] = this.supplier !== undefined ? this.supplier : null as any;
        if (Array.isArray(this.codici)) {
            data["codici"] = [];
            for (let item of this.codici)
                data["codici"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ISupplierRow2 {
    supplier?: EFornitore;
    codici?: CodiceGiataRow[] | null;
}

export class CodiceGiataRow implements ICodiceGiataRow {
    giataCode?: GiataCode | null;
    servizioH2H?: HHServizioFornitore | null;
    servizioID?: number | null;
    nomeServizio?: string | null;

    constructor(data?: ICodiceGiataRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.giataCode = _data["giataCode"] ? GiataCode.fromJS(_data["giataCode"]) : null as any;
            this.servizioH2H = _data["servizioH2H"] ? HHServizioFornitore.fromJS(_data["servizioH2H"]) : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.nomeServizio = _data["nomeServizio"] !== undefined ? _data["nomeServizio"] : null as any;
        }
    }

    static fromJS(data: any): CodiceGiataRow {
        data = typeof data === 'object' ? data : {};
        let result = new CodiceGiataRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giataCode"] = this.giataCode ? this.giataCode.toJSON() : null as any;
        data["servizioH2H"] = this.servizioH2H ? this.servizioH2H.toJSON() : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["nomeServizio"] = this.nomeServizio !== undefined ? this.nomeServizio : null as any;
        return data;
    }
}

export interface ICodiceGiataRow {
    giataCode?: GiataCode | null;
    servizioH2H?: HHServizioFornitore | null;
    servizioID?: number | null;
    nomeServizio?: string | null;
}

export class GiataCode implements IGiataCode {
    cityCode?: string | null;
    propertyCode?: string | null;

    constructor(data?: IGiataCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cityCode = _data["cityCode"] !== undefined ? _data["cityCode"] : null as any;
            this.propertyCode = _data["propertyCode"] !== undefined ? _data["propertyCode"] : null as any;
        }
    }

    static fromJS(data: any): GiataCode {
        data = typeof data === 'object' ? data : {};
        let result = new GiataCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cityCode"] = this.cityCode !== undefined ? this.cityCode : null as any;
        data["propertyCode"] = this.propertyCode !== undefined ? this.propertyCode : null as any;
        return data;
    }
}

export interface IGiataCode {
    cityCode?: string | null;
    propertyCode?: string | null;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class GetGiataCodesRequest extends ApiRequest implements IGetGiataCodesRequest {
    supplierGiataCode?: string | null;
    supplier?: EFornitore;

    constructor(data?: IGetGiataCodesRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.supplierGiataCode = _data["supplierGiataCode"] !== undefined ? _data["supplierGiataCode"] : null as any;
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : null as any;
        }
    }

    static override fromJS(data: any): GetGiataCodesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiataCodesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierGiataCode"] = this.supplierGiataCode !== undefined ? this.supplierGiataCode : null as any;
        data["supplier"] = this.supplier !== undefined ? this.supplier : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IGetGiataCodesRequest extends IApiRequest {
    supplierGiataCode?: string | null;
    supplier?: EFornitore;
}

export abstract class IGiataService implements IIGiataService {

    constructor(data?: IIGiataService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IGiataService {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IGiataService' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IIGiataService {
}

export class GetGroupedServizioH2HResponse extends OkApiResponse implements IGetGroupedServizioH2HResponse {
    servizio?: ServizioH2HRow | null;

    constructor(data?: IGetGroupedServizioH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizio = _data["servizio"] ? ServizioH2HRow.fromJS(_data["servizio"]) : null as any;
        }
    }

    static override fromJS(data: any): GetGroupedServizioH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetGroupedServizioH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio ? this.servizio.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetGroupedServizioH2HResponse extends IOkApiResponse {
    servizio?: ServizioH2HRow | null;
}

export class ServizioH2HRow implements IServizioH2HRow {
    id?: number;
    giataID?: number | null;
    luogoNaar?: string | null;
    luogoNaarID?: number;
    nomeServizioFornitore?: string | null;
    servizioNaarID?: number | null;
    idServizioFornitore?: number | null;
    servizioNaar?: string | null;
    attivo?: boolean;
    completo?: boolean;
    indirizzoFornitore?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    ultimoAggiornamento?: string;
    servizio?: HHServizio | null;

    constructor(data?: IServizioH2HRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.giataID = _data["giataID"] !== undefined ? _data["giataID"] : null as any;
            this.luogoNaar = _data["luogoNaar"] !== undefined ? _data["luogoNaar"] : null as any;
            this.luogoNaarID = _data["luogoNaarID"] !== undefined ? _data["luogoNaarID"] : null as any;
            this.nomeServizioFornitore = _data["nomeServizioFornitore"] !== undefined ? _data["nomeServizioFornitore"] : null as any;
            this.servizioNaarID = _data["servizioNaarID"] !== undefined ? _data["servizioNaarID"] : null as any;
            this.idServizioFornitore = _data["idServizioFornitore"] !== undefined ? _data["idServizioFornitore"] : null as any;
            this.servizioNaar = _data["servizioNaar"] !== undefined ? _data["servizioNaar"] : null as any;
            this.attivo = _data["attivo"] !== undefined ? _data["attivo"] : null as any;
            this.completo = _data["completo"] !== undefined ? _data["completo"] : null as any;
            this.indirizzoFornitore = _data["indirizzoFornitore"] !== undefined ? _data["indirizzoFornitore"] : null as any;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : null as any;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : null as any;
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] !== undefined ? _data["ultimoAggiornamento"] : null as any;
            this.servizio = _data["servizio"] ? HHServizio.fromJS(_data["servizio"]) : null as any;
        }
    }

    static fromJS(data: any): ServizioH2HRow {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioH2HRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["giataID"] = this.giataID !== undefined ? this.giataID : null as any;
        data["luogoNaar"] = this.luogoNaar !== undefined ? this.luogoNaar : null as any;
        data["luogoNaarID"] = this.luogoNaarID !== undefined ? this.luogoNaarID : null as any;
        data["nomeServizioFornitore"] = this.nomeServizioFornitore !== undefined ? this.nomeServizioFornitore : null as any;
        data["servizioNaarID"] = this.servizioNaarID !== undefined ? this.servizioNaarID : null as any;
        data["idServizioFornitore"] = this.idServizioFornitore !== undefined ? this.idServizioFornitore : null as any;
        data["servizioNaar"] = this.servizioNaar !== undefined ? this.servizioNaar : null as any;
        data["attivo"] = this.attivo !== undefined ? this.attivo : null as any;
        data["completo"] = this.completo !== undefined ? this.completo : null as any;
        data["indirizzoFornitore"] = this.indirizzoFornitore !== undefined ? this.indirizzoFornitore : null as any;
        data["latitude"] = this.latitude !== undefined ? this.latitude : null as any;
        data["longitude"] = this.longitude !== undefined ? this.longitude : null as any;
        data["ultimoAggiornamento"] = this.ultimoAggiornamento !== undefined ? this.ultimoAggiornamento : null as any;
        data["servizio"] = this.servizio ? this.servizio.toJSON() : null as any;
        return data;
    }
}

export interface IServizioH2HRow {
    id?: number;
    giataID?: number | null;
    luogoNaar?: string | null;
    luogoNaarID?: number;
    nomeServizioFornitore?: string | null;
    servizioNaarID?: number | null;
    idServizioFornitore?: number | null;
    servizioNaar?: string | null;
    attivo?: boolean;
    completo?: boolean;
    indirizzoFornitore?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    ultimoAggiornamento?: string;
    servizio?: HHServizio | null;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class GetGroupedServizioH2HRequest extends ApiRequest implements IGetGroupedServizioH2HRequest {
    servizioAggregatoID?: number;

    constructor(data?: IGetGroupedServizioH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioAggregatoID = _data["servizioAggregatoID"] !== undefined ? _data["servizioAggregatoID"] : null as any;
        }
    }

    static override fromJS(data: any): GetGroupedServizioH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetGroupedServizioH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioAggregatoID"] = this.servizioAggregatoID !== undefined ? this.servizioAggregatoID : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IGetGroupedServizioH2HRequest extends IApiRequest {
    servizioAggregatoID?: number;
}

export class NrTableResponseOfServizioH2HRow extends OkApiResponse implements INrTableResponseOfServizioH2HRow {
    /** Array delle righe della pagina richiesta */
    rows?: ServizioH2HRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfServizioH2HRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ServizioH2HRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfServizioH2HRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfServizioH2HRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfServizioH2HRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: ServizioH2HRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class GetServiziH2HResponse extends NrTableResponseOfServizioH2HRow implements IGetServiziH2HResponse {

    constructor(data?: IGetServiziH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetServiziH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiziH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetServiziH2HResponse extends INrTableResponseOfServizioH2HRow {
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class GetServiziH2HRequest extends NrTableRequest implements IGetServiziH2HRequest {
    supplier?: number | null;
    svcType?: ETipoServizio | null;
    luogoNaarID?: number | null;
    mapped?: boolean | null;
    confirmed?: boolean | null;
    enabled?: boolean | null;
    complete?: boolean | null;
    withoutRank?: boolean | null;
    excludeLowerRating?: boolean;
    hideLowerRating?: boolean;
    servizioNaarID?: number | null;
    nomeServizioFornitore?: string | null;
    luogoFornitoreID?: number | null;
    servizioAggregatoID?: number | null;
    giataID?: number | null;
    withoutGrouped?: boolean | null;
    luoghiVicini?: boolean;

    constructor(data?: IGetServiziH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : null as any;
            this.svcType = _data["svcType"] !== undefined ? _data["svcType"] : null as any;
            this.luogoNaarID = _data["luogoNaarID"] !== undefined ? _data["luogoNaarID"] : null as any;
            this.mapped = _data["mapped"] !== undefined ? _data["mapped"] : null as any;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : null as any;
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : null as any;
            this.complete = _data["complete"] !== undefined ? _data["complete"] : null as any;
            this.withoutRank = _data["withoutRank"] !== undefined ? _data["withoutRank"] : null as any;
            this.excludeLowerRating = _data["excludeLowerRating"] !== undefined ? _data["excludeLowerRating"] : null as any;
            this.hideLowerRating = _data["hideLowerRating"] !== undefined ? _data["hideLowerRating"] : null as any;
            this.servizioNaarID = _data["servizioNaarID"] !== undefined ? _data["servizioNaarID"] : null as any;
            this.nomeServizioFornitore = _data["nomeServizioFornitore"] !== undefined ? _data["nomeServizioFornitore"] : null as any;
            this.luogoFornitoreID = _data["luogoFornitoreID"] !== undefined ? _data["luogoFornitoreID"] : null as any;
            this.servizioAggregatoID = _data["servizioAggregatoID"] !== undefined ? _data["servizioAggregatoID"] : null as any;
            this.giataID = _data["giataID"] !== undefined ? _data["giataID"] : null as any;
            this.withoutGrouped = _data["withoutGrouped"] !== undefined ? _data["withoutGrouped"] : null as any;
            this.luoghiVicini = _data["luoghiVicini"] !== undefined ? _data["luoghiVicini"] : null as any;
        }
    }

    static override fromJS(data: any): GetServiziH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiziH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplier"] = this.supplier !== undefined ? this.supplier : null as any;
        data["svcType"] = this.svcType !== undefined ? this.svcType : null as any;
        data["luogoNaarID"] = this.luogoNaarID !== undefined ? this.luogoNaarID : null as any;
        data["mapped"] = this.mapped !== undefined ? this.mapped : null as any;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : null as any;
        data["enabled"] = this.enabled !== undefined ? this.enabled : null as any;
        data["complete"] = this.complete !== undefined ? this.complete : null as any;
        data["withoutRank"] = this.withoutRank !== undefined ? this.withoutRank : null as any;
        data["excludeLowerRating"] = this.excludeLowerRating !== undefined ? this.excludeLowerRating : null as any;
        data["hideLowerRating"] = this.hideLowerRating !== undefined ? this.hideLowerRating : null as any;
        data["servizioNaarID"] = this.servizioNaarID !== undefined ? this.servizioNaarID : null as any;
        data["nomeServizioFornitore"] = this.nomeServizioFornitore !== undefined ? this.nomeServizioFornitore : null as any;
        data["luogoFornitoreID"] = this.luogoFornitoreID !== undefined ? this.luogoFornitoreID : null as any;
        data["servizioAggregatoID"] = this.servizioAggregatoID !== undefined ? this.servizioAggregatoID : null as any;
        data["giataID"] = this.giataID !== undefined ? this.giataID : null as any;
        data["withoutGrouped"] = this.withoutGrouped !== undefined ? this.withoutGrouped : null as any;
        data["luoghiVicini"] = this.luoghiVicini !== undefined ? this.luoghiVicini : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IGetServiziH2HRequest extends INrTableRequest {
    supplier?: number | null;
    svcType?: ETipoServizio | null;
    luogoNaarID?: number | null;
    mapped?: boolean | null;
    confirmed?: boolean | null;
    enabled?: boolean | null;
    complete?: boolean | null;
    withoutRank?: boolean | null;
    excludeLowerRating?: boolean;
    hideLowerRating?: boolean;
    servizioNaarID?: number | null;
    nomeServizioFornitore?: string | null;
    luogoFornitoreID?: number | null;
    servizioAggregatoID?: number | null;
    giataID?: number | null;
    withoutGrouped?: boolean | null;
    luoghiVicini?: boolean;
}

export class GetImmaginiServiziH2HResponse extends OkApiResponse implements IGetImmaginiServiziH2HResponse {
    rows?: ImmagineServizioH2HRow[] | null;

    constructor(data?: IGetImmaginiServiziH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ImmagineServizioH2HRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
        }
    }

    static override fromJS(data: any): GetImmaginiServiziH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetImmaginiServiziH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetImmaginiServiziH2HResponse extends IOkApiResponse {
    rows?: ImmagineServizioH2HRow[] | null;
}

export class ImmagineServizioH2HRow implements IImmagineServizioH2HRow {
    id?: number;
    thumbUrl?: string | null;
    imageUrl?: string | null;
    sortOrder?: number;
    ordineNaar?: number | null;
    enabled?: boolean;
    updatedAt?: string;
    supplier?: string | null;
    descrizioni?: DescrizioneImmagineServizioH2H[] | null;

    constructor(data?: IImmagineServizioH2HRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.thumbUrl = _data["thumbUrl"] !== undefined ? _data["thumbUrl"] : null as any;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : null as any;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null as any;
            this.ordineNaar = _data["ordineNaar"] !== undefined ? _data["ordineNaar"] : null as any;
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : null as any;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : null as any;
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : null as any;
            if (Array.isArray(_data["descrizioni"])) {
                this.descrizioni = [] as any;
                for (let item of _data["descrizioni"])
                    this.descrizioni!.push(DescrizioneImmagineServizioH2H.fromJS(item));
            }
            else {
                this.descrizioni = null as any;
            }
        }
    }

    static fromJS(data: any): ImmagineServizioH2HRow {
        data = typeof data === 'object' ? data : {};
        let result = new ImmagineServizioH2HRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["thumbUrl"] = this.thumbUrl !== undefined ? this.thumbUrl : null as any;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        data["ordineNaar"] = this.ordineNaar !== undefined ? this.ordineNaar : null as any;
        data["enabled"] = this.enabled !== undefined ? this.enabled : null as any;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : null as any;
        data["supplier"] = this.supplier !== undefined ? this.supplier : null as any;
        if (Array.isArray(this.descrizioni)) {
            data["descrizioni"] = [];
            for (let item of this.descrizioni)
                data["descrizioni"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IImmagineServizioH2HRow {
    id?: number;
    thumbUrl?: string | null;
    imageUrl?: string | null;
    sortOrder?: number;
    ordineNaar?: number | null;
    enabled?: boolean;
    updatedAt?: string;
    supplier?: string | null;
    descrizioni?: DescrizioneImmagineServizioH2H[] | null;
}

export class DescrizioneImmagineServizioH2H implements IDescrizioneImmagineServizioH2H {
    lang?: ELingua;
    descrizione?: string | null;

    constructor(data?: IDescrizioneImmagineServizioH2H) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lang = _data["lang"] !== undefined ? _data["lang"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
        }
    }

    static fromJS(data: any): DescrizioneImmagineServizioH2H {
        data = typeof data === 'object' ? data : {};
        let result = new DescrizioneImmagineServizioH2H();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lang"] = this.lang !== undefined ? this.lang : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        return data;
    }
}

export interface IDescrizioneImmagineServizioH2H {
    lang?: ELingua;
    descrizione?: string | null;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class GetImmaginiServiziH2HRequest extends ApiRequest implements IGetImmaginiServiziH2HRequest {
    servizioAggregatoID?: number;

    constructor(data?: IGetImmaginiServiziH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioAggregatoID = _data["servizioAggregatoID"] !== undefined ? _data["servizioAggregatoID"] : null as any;
        }
    }

    static override fromJS(data: any): GetImmaginiServiziH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetImmaginiServiziH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioAggregatoID"] = this.servizioAggregatoID !== undefined ? this.servizioAggregatoID : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IGetImmaginiServiziH2HRequest extends IApiRequest {
    servizioAggregatoID?: number;
}

export class GetServiceAttrsResponse extends OkApiResponse implements IGetServiceAttrsResponse {
    categories?: ServiceAttrRow[] | null;
    stars?: ServiceAttrRow[] | null;
    positions?: ServiceAttrRow[] | null;
    classifications?: ServiceAttrRow[] | null;
    penalties?: ServiceAttrRow[] | null;

    constructor(data?: IGetServiceAttrsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(ServiceAttrRow.fromJS(item));
            }
            else {
                this.categories = null as any;
            }
            if (Array.isArray(_data["stars"])) {
                this.stars = [] as any;
                for (let item of _data["stars"])
                    this.stars!.push(ServiceAttrRow.fromJS(item));
            }
            else {
                this.stars = null as any;
            }
            if (Array.isArray(_data["positions"])) {
                this.positions = [] as any;
                for (let item of _data["positions"])
                    this.positions!.push(ServiceAttrRow.fromJS(item));
            }
            else {
                this.positions = null as any;
            }
            if (Array.isArray(_data["classifications"])) {
                this.classifications = [] as any;
                for (let item of _data["classifications"])
                    this.classifications!.push(ServiceAttrRow.fromJS(item));
            }
            else {
                this.classifications = null as any;
            }
            if (Array.isArray(_data["penalties"])) {
                this.penalties = [] as any;
                for (let item of _data["penalties"])
                    this.penalties!.push(ServiceAttrRow.fromJS(item));
            }
            else {
                this.penalties = null as any;
            }
        }
    }

    static override fromJS(data: any): GetServiceAttrsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceAttrsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.stars)) {
            data["stars"] = [];
            for (let item of this.stars)
                data["stars"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.positions)) {
            data["positions"] = [];
            for (let item of this.positions)
                data["positions"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.classifications)) {
            data["classifications"] = [];
            for (let item of this.classifications)
                data["classifications"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.penalties)) {
            data["penalties"] = [];
            for (let item of this.penalties)
                data["penalties"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetServiceAttrsResponse extends IOkApiResponse {
    categories?: ServiceAttrRow[] | null;
    stars?: ServiceAttrRow[] | null;
    positions?: ServiceAttrRow[] | null;
    classifications?: ServiceAttrRow[] | null;
    penalties?: ServiceAttrRow[] | null;
}

export class ServiceAttrRow implements IServiceAttrRow {
    id?: number;
    nome?: string | null;
    mostraDescrizione?: boolean;
    luogoID?: number | null;

    constructor(data?: IServiceAttrRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.mostraDescrizione = _data["mostraDescrizione"] !== undefined ? _data["mostraDescrizione"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
        }
    }

    static fromJS(data: any): ServiceAttrRow {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceAttrRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["mostraDescrizione"] = this.mostraDescrizione !== undefined ? this.mostraDescrizione : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        return data;
    }
}

export interface IServiceAttrRow {
    id?: number;
    nome?: string | null;
    mostraDescrizione?: boolean;
    luogoID?: number | null;
}

export class GetServiceAvailableHashcodesResponse extends OkApiResponse implements IGetServiceAvailableHashcodesResponse {
    hashcodes?: ServiceHascodeItem[];

    constructor(data?: IGetServiceAvailableHashcodesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["hashcodes"])) {
                this.hashcodes = [] as any;
                for (let item of _data["hashcodes"])
                    this.hashcodes!.push(ServiceHascodeItem.fromJS(item));
            }
            else {
                this.hashcodes = null as any;
            }
        }
    }

    static override fromJS(data: any): GetServiceAvailableHashcodesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceAvailableHashcodesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.hashcodes)) {
            data["hashcodes"] = [];
            for (let item of this.hashcodes)
                data["hashcodes"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetServiceAvailableHashcodesResponse extends IOkApiResponse {
    hashcodes?: ServiceHascodeItem[];
}

export class ServiceHascodeItem implements IServiceHascodeItem {
    id?: number;
    description?: string;
    supplier?: EFornitore | null;
    manual?: boolean;

    constructor(data?: IServiceHascodeItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : null as any;
            this.manual = _data["manual"] !== undefined ? _data["manual"] : null as any;
        }
    }

    static fromJS(data: any): ServiceHascodeItem {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceHascodeItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["supplier"] = this.supplier !== undefined ? this.supplier : null as any;
        data["manual"] = this.manual !== undefined ? this.manual : null as any;
        return data;
    }
}

export interface IServiceHascodeItem {
    id?: number;
    description?: string;
    supplier?: EFornitore | null;
    manual?: boolean;
}

export class GetServiceHashcodesResponse extends OkApiResponse implements IGetServiceHashcodesResponse {
    hashcodes?: HashcodeRow[];

    constructor(data?: IGetServiceHashcodesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["hashcodes"])) {
                this.hashcodes = [] as any;
                for (let item of _data["hashcodes"])
                    this.hashcodes!.push(HashcodeRow.fromJS(item));
            }
            else {
                this.hashcodes = null as any;
            }
        }
    }

    static override fromJS(data: any): GetServiceHashcodesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceHashcodesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.hashcodes)) {
            data["hashcodes"] = [];
            for (let item of this.hashcodes)
                data["hashcodes"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetServiceHashcodesResponse extends IOkApiResponse {
    hashcodes?: HashcodeRow[];
}

export class HashcodeRow implements IHashcodeRow {
    hashcode?: HHAttributoHashcode;
    description?: string;

    constructor(data?: IHashcodeRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hashcode = _data["hashcode"] ? HHAttributoHashcode.fromJS(_data["hashcode"]) : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
        }
    }

    static fromJS(data: any): HashcodeRow {
        data = typeof data === 'object' ? data : {};
        let result = new HashcodeRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hashcode"] = this.hashcode ? this.hashcode.toJSON() : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        return data;
    }
}

export interface IHashcodeRow {
    hashcode?: HHAttributoHashcode;
    description?: string;
}

export class GetServiceHashcodesRequest extends ApiRequest implements IGetServiceHashcodesRequest {
    h2HServiceID?: number;

    constructor(data?: IGetServiceHashcodesRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.h2HServiceID = _data["h2HServiceID"] !== undefined ? _data["h2HServiceID"] : null as any;
        }
    }

    static override fromJS(data: any): GetServiceHashcodesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceHashcodesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["h2HServiceID"] = this.h2HServiceID !== undefined ? this.h2HServiceID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetServiceHashcodesRequest extends IApiRequest {
    h2HServiceID?: number;
}

export class NrTableResponseOfSVCRow extends OkApiResponse implements INrTableResponseOfSVCRow {
    /** Array delle righe della pagina richiesta */
    rows?: SVCRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfSVCRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(SVCRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfSVCRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfSVCRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfSVCRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: SVCRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class GetSVCListResponse extends NrTableResponseOfSVCRow implements IGetSVCListResponse {

    constructor(data?: IGetSVCListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetSVCListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSVCListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetSVCListResponse extends INrTableResponseOfSVCRow {
}

export class GetSVCListRequest extends NrTableRequest implements IGetSVCListRequest {
    ratingRange?: number[] | null;
    supplier?: number | null;
    svcType?: ETipoServizio | null;
    luogoNaarID?: number | null;
    mapped?: boolean | null;
    confirmed?: boolean | null;
    enabled?: boolean | null;
    complete?: boolean | null;
    withoutRank?: boolean | null;
    excludeLowerRating?: boolean;
    hideLowerRating?: boolean;
    servizioNaarID?: number | null;
    nomeServizioFornitore?: string | null;
    luogoFornitoreID?: number | null;
    servizioAggregatoID?: number | null;
    giataID?: number | null;
    withoutGrouped?: boolean | null;
    luoghiVicini?: boolean;
    showDeleted?: boolean;

    constructor(data?: IGetSVCListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["ratingRange"])) {
                this.ratingRange = [] as any;
                for (let item of _data["ratingRange"])
                    this.ratingRange!.push(item);
            }
            else {
                this.ratingRange = null as any;
            }
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : null as any;
            this.svcType = _data["svcType"] !== undefined ? _data["svcType"] : null as any;
            this.luogoNaarID = _data["luogoNaarID"] !== undefined ? _data["luogoNaarID"] : null as any;
            this.mapped = _data["mapped"] !== undefined ? _data["mapped"] : null as any;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : null as any;
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : null as any;
            this.complete = _data["complete"] !== undefined ? _data["complete"] : null as any;
            this.withoutRank = _data["withoutRank"] !== undefined ? _data["withoutRank"] : null as any;
            this.excludeLowerRating = _data["excludeLowerRating"] !== undefined ? _data["excludeLowerRating"] : null as any;
            this.hideLowerRating = _data["hideLowerRating"] !== undefined ? _data["hideLowerRating"] : null as any;
            this.servizioNaarID = _data["servizioNaarID"] !== undefined ? _data["servizioNaarID"] : null as any;
            this.nomeServizioFornitore = _data["nomeServizioFornitore"] !== undefined ? _data["nomeServizioFornitore"] : null as any;
            this.luogoFornitoreID = _data["luogoFornitoreID"] !== undefined ? _data["luogoFornitoreID"] : null as any;
            this.servizioAggregatoID = _data["servizioAggregatoID"] !== undefined ? _data["servizioAggregatoID"] : null as any;
            this.giataID = _data["giataID"] !== undefined ? _data["giataID"] : null as any;
            this.withoutGrouped = _data["withoutGrouped"] !== undefined ? _data["withoutGrouped"] : null as any;
            this.luoghiVicini = _data["luoghiVicini"] !== undefined ? _data["luoghiVicini"] : null as any;
            this.showDeleted = _data["showDeleted"] !== undefined ? _data["showDeleted"] : null as any;
        }
    }

    static override fromJS(data: any): GetSVCListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSVCListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ratingRange)) {
            data["ratingRange"] = [];
            for (let item of this.ratingRange)
                data["ratingRange"].push(item);
        }
        data["supplier"] = this.supplier !== undefined ? this.supplier : null as any;
        data["svcType"] = this.svcType !== undefined ? this.svcType : null as any;
        data["luogoNaarID"] = this.luogoNaarID !== undefined ? this.luogoNaarID : null as any;
        data["mapped"] = this.mapped !== undefined ? this.mapped : null as any;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : null as any;
        data["enabled"] = this.enabled !== undefined ? this.enabled : null as any;
        data["complete"] = this.complete !== undefined ? this.complete : null as any;
        data["withoutRank"] = this.withoutRank !== undefined ? this.withoutRank : null as any;
        data["excludeLowerRating"] = this.excludeLowerRating !== undefined ? this.excludeLowerRating : null as any;
        data["hideLowerRating"] = this.hideLowerRating !== undefined ? this.hideLowerRating : null as any;
        data["servizioNaarID"] = this.servizioNaarID !== undefined ? this.servizioNaarID : null as any;
        data["nomeServizioFornitore"] = this.nomeServizioFornitore !== undefined ? this.nomeServizioFornitore : null as any;
        data["luogoFornitoreID"] = this.luogoFornitoreID !== undefined ? this.luogoFornitoreID : null as any;
        data["servizioAggregatoID"] = this.servizioAggregatoID !== undefined ? this.servizioAggregatoID : null as any;
        data["giataID"] = this.giataID !== undefined ? this.giataID : null as any;
        data["withoutGrouped"] = this.withoutGrouped !== undefined ? this.withoutGrouped : null as any;
        data["luoghiVicini"] = this.luoghiVicini !== undefined ? this.luoghiVicini : null as any;
        data["showDeleted"] = this.showDeleted !== undefined ? this.showDeleted : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetSVCListRequest extends INrTableRequest {
    ratingRange?: number[] | null;
    supplier?: number | null;
    svcType?: ETipoServizio | null;
    luogoNaarID?: number | null;
    mapped?: boolean | null;
    confirmed?: boolean | null;
    enabled?: boolean | null;
    complete?: boolean | null;
    withoutRank?: boolean | null;
    excludeLowerRating?: boolean;
    hideLowerRating?: boolean;
    servizioNaarID?: number | null;
    nomeServizioFornitore?: string | null;
    luogoFornitoreID?: number | null;
    servizioAggregatoID?: number | null;
    giataID?: number | null;
    withoutGrouped?: boolean | null;
    luoghiVicini?: boolean;
    showDeleted?: boolean;
}

export class NrTableResponseOfTypeRow extends OkApiResponse implements INrTableResponseOfTypeRow {
    /** Array delle righe della pagina richiesta */
    rows?: TypeRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfTypeRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TypeRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfTypeRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfTypeRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfTypeRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: TypeRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class GetTypesListResponse extends NrTableResponseOfTypeRow implements IGetTypesListResponse {

    constructor(data?: IGetTypesListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetTypesListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTypesListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetTypesListResponse extends INrTableResponseOfTypeRow {
}

export class TypeRow implements ITypeRow {
    id?: number;
    codice?: string | null;
    nome?: string | null;
    tipologiaNaar?: string | null;
    tipologiaNaarID?: number | null;
    regolaVenditaID?: number | null;
    nrf?: boolean | null;
    ultimoAggiornamento?: string | null;
    hashCodeID?: number | null;

    constructor(data?: ITypeRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.tipologiaNaar = _data["tipologiaNaar"] !== undefined ? _data["tipologiaNaar"] : null as any;
            this.tipologiaNaarID = _data["tipologiaNaarID"] !== undefined ? _data["tipologiaNaarID"] : null as any;
            this.regolaVenditaID = _data["regolaVenditaID"] !== undefined ? _data["regolaVenditaID"] : null as any;
            this.nrf = _data["nrf"] !== undefined ? _data["nrf"] : null as any;
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] !== undefined ? _data["ultimoAggiornamento"] : null as any;
            this.hashCodeID = _data["hashCodeID"] !== undefined ? _data["hashCodeID"] : null as any;
        }
    }

    static fromJS(data: any): TypeRow {
        data = typeof data === 'object' ? data : {};
        let result = new TypeRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["tipologiaNaar"] = this.tipologiaNaar !== undefined ? this.tipologiaNaar : null as any;
        data["tipologiaNaarID"] = this.tipologiaNaarID !== undefined ? this.tipologiaNaarID : null as any;
        data["regolaVenditaID"] = this.regolaVenditaID !== undefined ? this.regolaVenditaID : null as any;
        data["nrf"] = this.nrf !== undefined ? this.nrf : null as any;
        data["ultimoAggiornamento"] = this.ultimoAggiornamento !== undefined ? this.ultimoAggiornamento : null as any;
        data["hashCodeID"] = this.hashCodeID !== undefined ? this.hashCodeID : null as any;
        return data;
    }
}

export interface ITypeRow {
    id?: number;
    codice?: string | null;
    nome?: string | null;
    tipologiaNaar?: string | null;
    tipologiaNaarID?: number | null;
    regolaVenditaID?: number | null;
    nrf?: boolean | null;
    ultimoAggiornamento?: string | null;
    hashCodeID?: number | null;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class GetTypesListRequest extends NrTableRequest implements IGetTypesListRequest {
    hhSvcID?: number;

    constructor(data?: IGetTypesListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hhSvcID = _data["hhSvcID"] !== undefined ? _data["hhSvcID"] : null as any;
        }
    }

    static override fromJS(data: any): GetTypesListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTypesListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hhSvcID"] = this.hhSvcID !== undefined ? this.hhSvcID : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IGetTypesListRequest extends INrTableRequest {
    hhSvcID?: number;
}

export class LinkServizioH2HResponse extends OkApiResponse implements ILinkServizioH2HResponse {
    servizioAggregato?: HHServizio | null;
    address?: string | null;

    constructor(data?: ILinkServizioH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioAggregato = _data["servizioAggregato"] ? HHServizio.fromJS(_data["servizioAggregato"]) : null as any;
            this.address = _data["address"] !== undefined ? _data["address"] : null as any;
        }
    }

    static override fromJS(data: any): LinkServizioH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LinkServizioH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioAggregato"] = this.servizioAggregato ? this.servizioAggregato.toJSON() : null as any;
        data["address"] = this.address !== undefined ? this.address : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ILinkServizioH2HResponse extends IOkApiResponse {
    servizioAggregato?: HHServizio | null;
    address?: string | null;
}

export class LinkServizioH2HRequest extends ApiRequest implements ILinkServizioH2HRequest {
    servizioHHId?: number;
    servizioAggregatoHHID?: number | null;

    constructor(data?: ILinkServizioH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : null as any;
            this.servizioAggregatoHHID = _data["servizioAggregatoHHID"] !== undefined ? _data["servizioAggregatoHHID"] : null as any;
        }
    }

    static override fromJS(data: any): LinkServizioH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LinkServizioH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : null as any;
        data["servizioAggregatoHHID"] = this.servizioAggregatoHHID !== undefined ? this.servizioAggregatoHHID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ILinkServizioH2HRequest extends IApiRequest {
    servizioHHId?: number;
    servizioAggregatoHHID?: number | null;
}

export class MigrateServizioH2HRequest extends ApiRequest implements IMigrateServizioH2HRequest {
    sourceId?: number;
    destinationId?: number;

    constructor(data?: IMigrateServizioH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sourceId = _data["sourceId"] !== undefined ? _data["sourceId"] : null as any;
            this.destinationId = _data["destinationId"] !== undefined ? _data["destinationId"] : null as any;
        }
    }

    static override fromJS(data: any): MigrateServizioH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MigrateServizioH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId !== undefined ? this.sourceId : null as any;
        data["destinationId"] = this.destinationId !== undefined ? this.destinationId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IMigrateServizioH2HRequest extends IApiRequest {
    sourceId?: number;
    destinationId?: number;
}

export class RestoreServizioH2HRequest extends ApiRequest implements IRestoreServizioH2HRequest {
    servizioHHId?: number;

    constructor(data?: IRestoreServizioH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : null as any;
        }
    }

    static override fromJS(data: any): RestoreServizioH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreServizioH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IRestoreServizioH2HRequest extends IApiRequest {
    servizioHHId?: number;
}

export class SetAgreementServizioH2HResponse extends OkApiResponse implements ISetAgreementServizioH2HResponse {
    servizio?: HHServizioFornitore | null;

    constructor(data?: ISetAgreementServizioH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizio = _data["servizio"] ? HHServizioFornitore.fromJS(_data["servizio"]) : null as any;
        }
    }

    static override fromJS(data: any): SetAgreementServizioH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetAgreementServizioH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio ? this.servizio.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISetAgreementServizioH2HResponse extends IOkApiResponse {
    servizio?: HHServizioFornitore | null;
}

export class SetAgreementServizioH2HRequest extends ApiRequest implements ISetAgreementServizioH2HRequest {
    servizioHHId?: number;
    agreementId?: number;

    constructor(data?: ISetAgreementServizioH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : null as any;
            this.agreementId = _data["agreementId"] !== undefined ? _data["agreementId"] : null as any;
        }
    }

    static override fromJS(data: any): SetAgreementServizioH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetAgreementServizioH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : null as any;
        data["agreementId"] = this.agreementId !== undefined ? this.agreementId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISetAgreementServizioH2HRequest extends IApiRequest {
    servizioHHId?: number;
    agreementId?: number;
}

export class SetGiataIdResponse extends OkApiResponse implements ISetGiataIdResponse {
    servizi?: HHServizioFornitore[] | null;

    constructor(data?: ISetGiataIdResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(HHServizioFornitore.fromJS(item));
            }
            else {
                this.servizi = null as any;
            }
        }
    }

    static override fromJS(data: any): SetGiataIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetGiataIdResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetGiataIdResponse extends IOkApiResponse {
    servizi?: HHServizioFornitore[] | null;
}

export class SetGiataIdRequest extends ApiRequest implements ISetGiataIdRequest {
    giataID?: number;
    hhServIDs?: number[] | null;

    constructor(data?: ISetGiataIdRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.giataID = _data["giataID"] !== undefined ? _data["giataID"] : null as any;
            if (Array.isArray(_data["hhServIDs"])) {
                this.hhServIDs = [] as any;
                for (let item of _data["hhServIDs"])
                    this.hhServIDs!.push(item);
            }
            else {
                this.hhServIDs = null as any;
            }
        }
    }

    static override fromJS(data: any): SetGiataIdRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetGiataIdRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giataID"] = this.giataID !== undefined ? this.giataID : null as any;
        if (Array.isArray(this.hhServIDs)) {
            data["hhServIDs"] = [];
            for (let item of this.hhServIDs)
                data["hhServIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetGiataIdRequest extends IApiRequest {
    giataID?: number;
    hhServIDs?: number[] | null;
}

export class SetGroupedMappingServizioH2HResponse extends OkApiResponse implements ISetGroupedMappingServizioH2HResponse {
    servizio?: HHServizio | null;
    other?: HHServizioFornitore[] | null;
    address?: string | null;

    constructor(data?: ISetGroupedMappingServizioH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizio = _data["servizio"] ? HHServizio.fromJS(_data["servizio"]) : null as any;
            if (Array.isArray(_data["other"])) {
                this.other = [] as any;
                for (let item of _data["other"])
                    this.other!.push(HHServizioFornitore.fromJS(item));
            }
            else {
                this.other = null as any;
            }
            this.address = _data["address"] !== undefined ? _data["address"] : null as any;
        }
    }

    static override fromJS(data: any): SetGroupedMappingServizioH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetGroupedMappingServizioH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio ? this.servizio.toJSON() : null as any;
        if (Array.isArray(this.other)) {
            data["other"] = [];
            for (let item of this.other)
                data["other"].push(item ? item.toJSON() : null as any);
        }
        data["address"] = this.address !== undefined ? this.address : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISetGroupedMappingServizioH2HResponse extends IOkApiResponse {
    servizio?: HHServizio | null;
    other?: HHServizioFornitore[] | null;
    address?: string | null;
}

export class SetGroupedMappingServizioH2HRequest extends ApiRequest implements ISetGroupedMappingServizioH2HRequest {
    servizioHHId?: number;
    servizioNaarID?: number;

    constructor(data?: ISetGroupedMappingServizioH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : null as any;
            this.servizioNaarID = _data["servizioNaarID"] !== undefined ? _data["servizioNaarID"] : null as any;
        }
    }

    static override fromJS(data: any): SetGroupedMappingServizioH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetGroupedMappingServizioH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : null as any;
        data["servizioNaarID"] = this.servizioNaarID !== undefined ? this.servizioNaarID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISetGroupedMappingServizioH2HRequest extends IApiRequest {
    servizioHHId?: number;
    servizioNaarID?: number;
}

export class SetMapH2HResponse extends OkApiResponse implements ISetMapH2HResponse {
    latitude?: number | null;
    longitude?: number | null;
    zoom?: number | null;

    constructor(data?: ISetMapH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : null as any;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : null as any;
            this.zoom = _data["zoom"] !== undefined ? _data["zoom"] : null as any;
        }
    }

    static override fromJS(data: any): SetMapH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetMapH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude !== undefined ? this.latitude : null as any;
        data["longitude"] = this.longitude !== undefined ? this.longitude : null as any;
        data["zoom"] = this.zoom !== undefined ? this.zoom : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISetMapH2HResponse extends IOkApiResponse {
    latitude?: number | null;
    longitude?: number | null;
    zoom?: number | null;
}

export class SetMapH2HRequest extends ApiRequest implements ISetMapH2HRequest {
    servizio?: HHServizio | null;

    constructor(data?: ISetMapH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizio = _data["servizio"] ? HHServizio.fromJS(_data["servizio"]) : null as any;
        }
    }

    static override fromJS(data: any): SetMapH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetMapH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio ? this.servizio.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISetMapH2HRequest extends IApiRequest {
    servizio?: HHServizio | null;
}

export class SetMappingServizioH2HResponse extends OkApiResponse implements ISetMappingServizioH2HResponse {
    servizio?: HHServizioFornitore | null;
    other?: HHServizioFornitore[] | null;
    address?: string | null;

    constructor(data?: ISetMappingServizioH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizio = _data["servizio"] ? HHServizioFornitore.fromJS(_data["servizio"]) : null as any;
            if (Array.isArray(_data["other"])) {
                this.other = [] as any;
                for (let item of _data["other"])
                    this.other!.push(HHServizioFornitore.fromJS(item));
            }
            else {
                this.other = null as any;
            }
            this.address = _data["address"] !== undefined ? _data["address"] : null as any;
        }
    }

    static override fromJS(data: any): SetMappingServizioH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetMappingServizioH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio ? this.servizio.toJSON() : null as any;
        if (Array.isArray(this.other)) {
            data["other"] = [];
            for (let item of this.other)
                data["other"].push(item ? item.toJSON() : null as any);
        }
        data["address"] = this.address !== undefined ? this.address : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISetMappingServizioH2HResponse extends IOkApiResponse {
    servizio?: HHServizioFornitore | null;
    other?: HHServizioFornitore[] | null;
    address?: string | null;
}

export class SetMappingServizioH2HRequest extends ApiRequest implements ISetMappingServizioH2HRequest {
    servizioHHId?: number;
    servizioNaarID?: number;

    constructor(data?: ISetMappingServizioH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : null as any;
            this.servizioNaarID = _data["servizioNaarID"] !== undefined ? _data["servizioNaarID"] : null as any;
        }
    }

    static override fromJS(data: any): SetMappingServizioH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetMappingServizioH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : null as any;
        data["servizioNaarID"] = this.servizioNaarID !== undefined ? this.servizioNaarID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISetMappingServizioH2HRequest extends IApiRequest {
    servizioHHId?: number;
    servizioNaarID?: number;
}

export class SetMappingMultiResponse extends OkApiResponse implements ISetMappingMultiResponse {
    servizi?: HHServizioFornitore[] | null;

    constructor(data?: ISetMappingMultiResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(HHServizioFornitore.fromJS(item));
            }
            else {
                this.servizi = null as any;
            }
        }
    }

    static override fromJS(data: any): SetMappingMultiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetMappingMultiResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetMappingMultiResponse extends IOkApiResponse {
    servizi?: HHServizioFornitore[] | null;
}

export class SetMappingMultiRequest extends ApiRequest implements ISetMappingMultiRequest {
    servizioNaarID?: number;
    hhServIDs?: number[] | null;

    constructor(data?: ISetMappingMultiRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioNaarID = _data["servizioNaarID"] !== undefined ? _data["servizioNaarID"] : null as any;
            if (Array.isArray(_data["hhServIDs"])) {
                this.hhServIDs = [] as any;
                for (let item of _data["hhServIDs"])
                    this.hhServIDs!.push(item);
            }
            else {
                this.hhServIDs = null as any;
            }
        }
    }

    static override fromJS(data: any): SetMappingMultiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetMappingMultiRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioNaarID"] = this.servizioNaarID !== undefined ? this.servizioNaarID : null as any;
        if (Array.isArray(this.hhServIDs)) {
            data["hhServIDs"] = [];
            for (let item of this.hhServIDs)
                data["hhServIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetMappingMultiRequest extends IApiRequest {
    servizioNaarID?: number;
    hhServIDs?: number[] | null;
}

export class SetRuleMappingResponse extends OkApiResponse implements ISetRuleMappingResponse {
    codice?: HHTipologiaFornitore | null;

    constructor(data?: ISetRuleMappingResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.codice = _data["codice"] ? HHTipologiaFornitore.fromJS(_data["codice"]) : null as any;
        }
    }

    static override fromJS(data: any): SetRuleMappingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetRuleMappingResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codice"] = this.codice ? this.codice.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISetRuleMappingResponse extends IOkApiResponse {
    codice?: HHTipologiaFornitore | null;
}

export class SetRuleMappingRequest extends ApiRequest implements ISetRuleMappingRequest {
    servizioHHId?: number;
    tipologiaHHID?: number;
    servizioRegolaVenditaID?: number | null;

    constructor(data?: ISetRuleMappingRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : null as any;
            this.tipologiaHHID = _data["tipologiaHHID"] !== undefined ? _data["tipologiaHHID"] : null as any;
            this.servizioRegolaVenditaID = _data["servizioRegolaVenditaID"] !== undefined ? _data["servizioRegolaVenditaID"] : null as any;
        }
    }

    static override fromJS(data: any): SetRuleMappingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetRuleMappingRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : null as any;
        data["tipologiaHHID"] = this.tipologiaHHID !== undefined ? this.tipologiaHHID : null as any;
        data["servizioRegolaVenditaID"] = this.servizioRegolaVenditaID !== undefined ? this.servizioRegolaVenditaID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISetRuleMappingRequest extends IApiRequest {
    servizioHHId?: number;
    tipologiaHHID?: number;
    servizioRegolaVenditaID?: number | null;
}

export class SetTypeMappingResponse extends OkApiResponse implements ISetTypeMappingResponse {
    codice?: HHTipologiaFornitore | null;

    constructor(data?: ISetTypeMappingResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.codice = _data["codice"] ? HHTipologiaFornitore.fromJS(_data["codice"]) : null as any;
        }
    }

    static override fromJS(data: any): SetTypeMappingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetTypeMappingResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codice"] = this.codice ? this.codice.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISetTypeMappingResponse extends IOkApiResponse {
    codice?: HHTipologiaFornitore | null;
}

export class SetTypeMappingRequest extends ApiRequest implements ISetTypeMappingRequest {
    servizioHHId?: number;
    tipologiaHHID?: number;
    servizioTipologiaNaarID?: number | null;

    constructor(data?: ISetTypeMappingRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : null as any;
            this.tipologiaHHID = _data["tipologiaHHID"] !== undefined ? _data["tipologiaHHID"] : null as any;
            this.servizioTipologiaNaarID = _data["servizioTipologiaNaarID"] !== undefined ? _data["servizioTipologiaNaarID"] : null as any;
        }
    }

    static override fromJS(data: any): SetTypeMappingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetTypeMappingRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : null as any;
        data["tipologiaHHID"] = this.tipologiaHHID !== undefined ? this.tipologiaHHID : null as any;
        data["servizioTipologiaNaarID"] = this.servizioTipologiaNaarID !== undefined ? this.servizioTipologiaNaarID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISetTypeMappingRequest extends IApiRequest {
    servizioHHId?: number;
    tipologiaHHID?: number;
    servizioTipologiaNaarID?: number | null;
}

export class UnConfirmMappingServizioH2HRequest extends ApiRequest implements IUnConfirmMappingServizioH2HRequest {
    servizioHHId?: number;

    constructor(data?: IUnConfirmMappingServizioH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : null as any;
        }
    }

    static override fromJS(data: any): UnConfirmMappingServizioH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UnConfirmMappingServizioH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUnConfirmMappingServizioH2HRequest extends IApiRequest {
    servizioHHId?: number;
}

export class UnConfirmTypeMappingResponse extends OkApiResponse implements IUnConfirmTypeMappingResponse {
    codice?: HHTipologiaFornitore | null;

    constructor(data?: IUnConfirmTypeMappingResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.codice = _data["codice"] ? HHTipologiaFornitore.fromJS(_data["codice"]) : null as any;
        }
    }

    static override fromJS(data: any): UnConfirmTypeMappingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UnConfirmTypeMappingResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codice"] = this.codice ? this.codice.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUnConfirmTypeMappingResponse extends IOkApiResponse {
    codice?: HHTipologiaFornitore | null;
}

export class UnConfirmTypeMappingRequest extends ApiRequest implements IUnConfirmTypeMappingRequest {
    servizioHHId?: number;
    tipologiaHHID?: number;

    constructor(data?: IUnConfirmTypeMappingRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : null as any;
            this.tipologiaHHID = _data["tipologiaHHID"] !== undefined ? _data["tipologiaHHID"] : null as any;
        }
    }

    static override fromJS(data: any): UnConfirmTypeMappingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UnConfirmTypeMappingRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : null as any;
        data["tipologiaHHID"] = this.tipologiaHHID !== undefined ? this.tipologiaHHID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUnConfirmTypeMappingRequest extends IApiRequest {
    servizioHHId?: number;
    tipologiaHHID?: number;
}

export class UnlinkServizioH2HRequest extends ApiRequest implements IUnlinkServizioH2HRequest {
    servizioHHId?: number;

    constructor(data?: IUnlinkServizioH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : null as any;
        }
    }

    static override fromJS(data: any): UnlinkServizioH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UnlinkServizioH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUnlinkServizioH2HRequest extends IApiRequest {
    servizioHHId?: number;
}

export class UpdateServizioH2HResponse extends OkApiResponse implements IUpdateServizioH2HResponse {
    servizio?: HHServizio | null;
    luogo?: string | null;

    constructor(data?: IUpdateServizioH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizio = _data["servizio"] ? HHServizio.fromJS(_data["servizio"]) : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
        }
    }

    static override fromJS(data: any): UpdateServizioH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServizioH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio ? this.servizio.toJSON() : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateServizioH2HResponse extends IOkApiResponse {
    servizio?: HHServizio | null;
    luogo?: string | null;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class UpdateServizioH2HRequest extends ApiRequest implements IUpdateServizioH2HRequest {
    servizioHH?: HHServizio | null;

    constructor(data?: IUpdateServizioH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHH = _data["servizioHH"] ? HHServizio.fromJS(_data["servizioHH"]) : null as any;
        }
    }

    static override fromJS(data: any): UpdateServizioH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServizioH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHH"] = this.servizioHH ? this.servizioHH.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IUpdateServizioH2HRequest extends IApiRequest {
    servizioHH?: HHServizio | null;
}

export class UpdateDescriptionH2HResponse extends OkApiResponse implements IUpdateDescriptionH2HResponse {
    description?: HHDescrizione | null;

    constructor(data?: IUpdateDescriptionH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.description = _data["description"] ? HHDescrizione.fromJS(_data["description"]) : null as any;
        }
    }

    static override fromJS(data: any): UpdateDescriptionH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDescriptionH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description ? this.description.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateDescriptionH2HResponse extends IOkApiResponse {
    description?: HHDescrizione | null;
}

export class UpdateDescriptionH2HRequest extends ApiRequest implements IUpdateDescriptionH2HRequest {
    description?: HHDescrizione | null;

    constructor(data?: IUpdateDescriptionH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.description = _data["description"] ? HHDescrizione.fromJS(_data["description"]) : null as any;
        }
    }

    static override fromJS(data: any): UpdateDescriptionH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDescriptionH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description ? this.description.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateDescriptionH2HRequest extends IApiRequest {
    description?: HHDescrizione | null;
}

export class UpdateImageH2HResponse extends OkApiResponse implements IUpdateImageH2HResponse {
    image?: HHImmagine | null;

    constructor(data?: IUpdateImageH2HResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.image = _data["image"] ? HHImmagine.fromJS(_data["image"]) : null as any;
        }
    }

    static override fromJS(data: any): UpdateImageH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateImageH2HResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image ? this.image.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateImageH2HResponse extends IOkApiResponse {
    image?: HHImmagine | null;
}

export class UpdateImageH2HRequest extends ApiRequest implements IUpdateImageH2HRequest {
    image?: HHImmagine | null;

    constructor(data?: IUpdateImageH2HRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.image = _data["image"] ? HHImmagine.fromJS(_data["image"]) : null as any;
        }
    }

    static override fromJS(data: any): UpdateImageH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateImageH2HRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image ? this.image.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateImageH2HRequest extends IApiRequest {
    image?: HHImmagine | null;
}

/** Response for upserting an H2H attribute hashcode */
export class UpsertHHAttributoHashcodeResponse extends OkApiResponse implements IUpsertHHAttributoHashcodeResponse {
    /** Created or updated attribute hashcode */
    attribute?: HHAttributoHashcode;

    constructor(data?: IUpsertHHAttributoHashcodeResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.attribute = _data["attribute"] ? HHAttributoHashcode.fromJS(_data["attribute"]) : null as any;
        }
    }

    static override fromJS(data: any): UpsertHHAttributoHashcodeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertHHAttributoHashcodeResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attribute"] = this.attribute ? this.attribute.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Response for upserting an H2H attribute hashcode */
export interface IUpsertHHAttributoHashcodeResponse extends IOkApiResponse {
    /** Created or updated attribute hashcode */
    attribute?: HHAttributoHashcode;
}

/** Request to upsert an H2H attribute hashcode */
export class UpsertHHAttributoHashcodeRequest extends ApiRequest implements IUpsertHHAttributoHashcodeRequest {
    /** Attributo hashcode to insert (when ID is 0) or update */
    attribute!: HHAttributoHashcode;

    constructor(data?: IUpsertHHAttributoHashcodeRequest) {
        super(data);
        if (!data) {
            this.attribute = new HHAttributoHashcode();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.attribute = _data["attribute"] ? HHAttributoHashcode.fromJS(_data["attribute"]) : new HHAttributoHashcode();
        }
    }

    static override fromJS(data: any): UpsertHHAttributoHashcodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertHHAttributoHashcodeRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attribute"] = this.attribute ? this.attribute.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Request to upsert an H2H attribute hashcode */
export interface IUpsertHHAttributoHashcodeRequest extends IApiRequest {
    /** Attributo hashcode to insert (when ID is 0) or update */
    attribute: HHAttributoHashcode;
}

export class GetSharedDocumentResponse extends OkApiResponse implements IGetSharedDocumentResponse {
    /** Entità del documento condiviso */
    documento?: DocumentoCondiviso;

    constructor(data?: IGetSharedDocumentResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documento = _data["documento"] ? DocumentoCondiviso.fromJS(_data["documento"]) : null as any;
        }
    }

    static override fromJS(data: any): GetSharedDocumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSharedDocumentResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documento"] = this.documento ? this.documento.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetSharedDocumentResponse extends IOkApiResponse {
    /** Entità del documento condiviso */
    documento?: DocumentoCondiviso;
}

export class GetSharedDocumentRequest extends LocalizedRequest implements IGetSharedDocumentRequest {
    /** ID del documento condiviso */
    documentoCondivisoID?: number;

    constructor(data?: IGetSharedDocumentRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentoCondivisoID = _data["documentoCondivisoID"] !== undefined ? _data["documentoCondivisoID"] : null as any;
        }
    }

    static override fromJS(data: any): GetSharedDocumentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSharedDocumentRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoCondivisoID"] = this.documentoCondivisoID !== undefined ? this.documentoCondivisoID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetSharedDocumentRequest extends ILocalizedRequest {
    /** ID del documento condiviso */
    documentoCondivisoID?: number;
}

export class NrTableResponseOfSharedDocumentRow extends OkApiResponse implements INrTableResponseOfSharedDocumentRow {
    /** Array delle righe della pagina richiesta */
    rows?: SharedDocumentRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfSharedDocumentRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(SharedDocumentRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfSharedDocumentRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfSharedDocumentRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfSharedDocumentRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: SharedDocumentRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class GetSharedDocumentsListResponse extends NrTableResponseOfSharedDocumentRow implements IGetSharedDocumentsListResponse {

    constructor(data?: IGetSharedDocumentsListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetSharedDocumentsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSharedDocumentsListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetSharedDocumentsListResponse extends INrTableResponseOfSharedDocumentRow {
}

/** Rappresentazione di un documento allegato */
export class SharedDocumentRow implements ISharedDocumentRow {
    /** ID del documento */
    id?: number;
    /** True se l'allegato esiste (ancora...) */
    exists?: boolean;
    /** Nome dell'allegato */
    name?: string;
    /** Nome del servizio associato */
    servizio?: string | null;
    /** Nome del luogo associato */
    luogo?: string | null;
    /** Nome del luogo di destinazione associato */
    luogoDestinazione?: string | null;
    /** Nome del contatto associato */
    contatto?: string | null;
    /** Nome dell'accordo associato */
    accordo?: string | null;
    /** Se true è fuori range per data di pubblicazione / partenza */
    scaduto?: boolean;
    /** Dimensione del file associato */
    dimensioneFile?: number;
    /** Nome del file */
    nomeFile?: string | null;
    /** Content Type del file */
    contentType?: string | null;
    /** Url per il download (solo intranet!) */
    downloadUrl?: string | null;

    constructor(data?: ISharedDocumentRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.exists = _data["exists"] !== undefined ? _data["exists"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.luogoDestinazione = _data["luogoDestinazione"] !== undefined ? _data["luogoDestinazione"] : null as any;
            this.contatto = _data["contatto"] !== undefined ? _data["contatto"] : null as any;
            this.accordo = _data["accordo"] !== undefined ? _data["accordo"] : null as any;
            this.scaduto = _data["scaduto"] !== undefined ? _data["scaduto"] : null as any;
            this.dimensioneFile = _data["dimensioneFile"] !== undefined ? _data["dimensioneFile"] : null as any;
            this.nomeFile = _data["nomeFile"] !== undefined ? _data["nomeFile"] : null as any;
            this.contentType = _data["contentType"] !== undefined ? _data["contentType"] : null as any;
            this.downloadUrl = _data["downloadUrl"] !== undefined ? _data["downloadUrl"] : null as any;
        }
    }

    static fromJS(data: any): SharedDocumentRow {
        data = typeof data === 'object' ? data : {};
        let result = new SharedDocumentRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["exists"] = this.exists !== undefined ? this.exists : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["servizio"] = this.servizio !== undefined ? this.servizio : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["luogoDestinazione"] = this.luogoDestinazione !== undefined ? this.luogoDestinazione : null as any;
        data["contatto"] = this.contatto !== undefined ? this.contatto : null as any;
        data["accordo"] = this.accordo !== undefined ? this.accordo : null as any;
        data["scaduto"] = this.scaduto !== undefined ? this.scaduto : null as any;
        data["dimensioneFile"] = this.dimensioneFile !== undefined ? this.dimensioneFile : null as any;
        data["nomeFile"] = this.nomeFile !== undefined ? this.nomeFile : null as any;
        data["contentType"] = this.contentType !== undefined ? this.contentType : null as any;
        data["downloadUrl"] = this.downloadUrl !== undefined ? this.downloadUrl : null as any;
        return data;
    }
}

/** Rappresentazione di un documento allegato */
export interface ISharedDocumentRow {
    /** ID del documento */
    id?: number;
    /** True se l'allegato esiste (ancora...) */
    exists?: boolean;
    /** Nome dell'allegato */
    name?: string;
    /** Nome del servizio associato */
    servizio?: string | null;
    /** Nome del luogo associato */
    luogo?: string | null;
    /** Nome del luogo di destinazione associato */
    luogoDestinazione?: string | null;
    /** Nome del contatto associato */
    contatto?: string | null;
    /** Nome dell'accordo associato */
    accordo?: string | null;
    /** Se true è fuori range per data di pubblicazione / partenza */
    scaduto?: boolean;
    /** Dimensione del file associato */
    dimensioneFile?: number;
    /** Nome del file */
    nomeFile?: string | null;
    /** Content Type del file */
    contentType?: string | null;
    /** Url per il download (solo intranet!) */
    downloadUrl?: string | null;
}

export class GetSharedDocumentsListRequest extends NrTableRequest implements IGetSharedDocumentsListRequest {
    /** Termine di ricerca oppure ID */
    term?: string | null;

    constructor(data?: IGetSharedDocumentsListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : null as any;
        }
    }

    static override fromJS(data: any): GetSharedDocumentsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSharedDocumentsListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetSharedDocumentsListRequest extends INrTableRequest {
    /** Termine di ricerca oppure ID */
    term?: string | null;
}

export class StatisticMonthSalesResponse extends OkApiResponse implements IStatisticMonthSalesResponse {
    table?: StatisticTable;
    preventiviPerc?: number;
    venditePerc?: number;
    partitoPerc?: number;

    constructor(data?: IStatisticMonthSalesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.table = _data["table"] ? StatisticTable.fromJS(_data["table"]) : null as any;
            this.preventiviPerc = _data["preventiviPerc"] !== undefined ? _data["preventiviPerc"] : null as any;
            this.venditePerc = _data["venditePerc"] !== undefined ? _data["venditePerc"] : null as any;
            this.partitoPerc = _data["partitoPerc"] !== undefined ? _data["partitoPerc"] : null as any;
        }
    }

    static override fromJS(data: any): StatisticMonthSalesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticMonthSalesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["table"] = this.table ? this.table.toJSON() : null as any;
        data["preventiviPerc"] = this.preventiviPerc !== undefined ? this.preventiviPerc : null as any;
        data["venditePerc"] = this.venditePerc !== undefined ? this.venditePerc : null as any;
        data["partitoPerc"] = this.partitoPerc !== undefined ? this.partitoPerc : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IStatisticMonthSalesResponse extends IOkApiResponse {
    table?: StatisticTable;
    preventiviPerc?: number;
    venditePerc?: number;
    partitoPerc?: number;
}

export class StatisticMonthSalesRequest extends LocalizedRequest implements IStatisticMonthSalesRequest {
    operator?: EOperatore;
    dateLimit?: string;
    export?: boolean | null;

    constructor(data?: IStatisticMonthSalesRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operator = _data["operator"] !== undefined ? _data["operator"] : null as any;
            this.dateLimit = _data["dateLimit"] !== undefined ? _data["dateLimit"] : null as any;
            this.export = _data["export"] !== undefined ? _data["export"] : null as any;
        }
    }

    static override fromJS(data: any): StatisticMonthSalesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticMonthSalesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operator"] = this.operator !== undefined ? this.operator : null as any;
        data["dateLimit"] = this.dateLimit !== undefined ? this.dateLimit : null as any;
        data["export"] = this.export !== undefined ? this.export : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IStatisticMonthSalesRequest extends ILocalizedRequest {
    operator?: EOperatore;
    dateLimit?: string;
    export?: boolean | null;
}

export class QuotationsGetResponse extends OkApiResponse implements IQuotationsGetResponse {
    rows?: QuotationsRow[];
    totalSales?: number | null;
    totalQuotation?: number | null;
    percentage?: number | null;

    constructor(data?: IQuotationsGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(QuotationsRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.totalSales = _data["totalSales"] !== undefined ? _data["totalSales"] : null as any;
            this.totalQuotation = _data["totalQuotation"] !== undefined ? _data["totalQuotation"] : null as any;
            this.percentage = _data["percentage"] !== undefined ? _data["percentage"] : null as any;
        }
    }

    static override fromJS(data: any): QuotationsGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QuotationsGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["totalSales"] = this.totalSales !== undefined ? this.totalSales : null as any;
        data["totalQuotation"] = this.totalQuotation !== undefined ? this.totalQuotation : null as any;
        data["percentage"] = this.percentage !== undefined ? this.percentage : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IQuotationsGetResponse extends IOkApiResponse {
    rows?: QuotationsRow[];
    totalSales?: number | null;
    totalQuotation?: number | null;
    percentage?: number | null;
}

export class QuotationsRow implements IQuotationsRow {
    id?: number;
    network?: string | null;
    regione?: string | null;
    citta?: string | null;
    provincia?: string | null;
    agenzia?: string | null;
    pax?: number | null;
    destinazione?: string | null;
    idOfferta?: number | null;
    descrizione?: string | null;
    creazione?: string | null;
    partenza?: string | null;
    conferma?: string | null;
    cancellazioneADV?: string | null;
    pag?: string | null;
    totale?: number | null;
    dirittiAgenzia?: number | null;
    commissioneAgenzia?: number | null;
    percentualeCommissione?: number | null;
    margineNetto?: number | null;
    tipoV?: string | null;
    catADV?: string | null;
    mailSpedizioneADV?: string | null;
    qtApPr?: number | null;
    wcys?: number | null;
    wcysPlus?: number | null;
    int100K?: number | null;
    int300K?: number | null;
    int500K?: number | null;
    int1000K?: number | null;
    blcPrz?: number | null;
    intComm?: number | null;
    tipoPrev?: string | null;
    sGruppo?: string | null;
    gestPreventivo?: string | null;
    gestConferma?: string | null;
    accVoucher?: number | null;

    constructor(data?: IQuotationsRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.network = _data["network"] !== undefined ? _data["network"] : null as any;
            this.regione = _data["regione"] !== undefined ? _data["regione"] : null as any;
            this.citta = _data["citta"] !== undefined ? _data["citta"] : null as any;
            this.provincia = _data["provincia"] !== undefined ? _data["provincia"] : null as any;
            this.agenzia = _data["agenzia"] !== undefined ? _data["agenzia"] : null as any;
            this.pax = _data["pax"] !== undefined ? _data["pax"] : null as any;
            this.destinazione = _data["destinazione"] !== undefined ? _data["destinazione"] : null as any;
            this.idOfferta = _data["idOfferta"] !== undefined ? _data["idOfferta"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.creazione = _data["creazione"] !== undefined ? _data["creazione"] : null as any;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : null as any;
            this.conferma = _data["conferma"] !== undefined ? _data["conferma"] : null as any;
            this.cancellazioneADV = _data["cancellazioneADV"] !== undefined ? _data["cancellazioneADV"] : null as any;
            this.pag = _data["pag"] !== undefined ? _data["pag"] : null as any;
            this.totale = _data["totale"] !== undefined ? _data["totale"] : null as any;
            this.dirittiAgenzia = _data["dirittiAgenzia"] !== undefined ? _data["dirittiAgenzia"] : null as any;
            this.commissioneAgenzia = _data["commissioneAgenzia"] !== undefined ? _data["commissioneAgenzia"] : null as any;
            this.percentualeCommissione = _data["percentualeCommissione"] !== undefined ? _data["percentualeCommissione"] : null as any;
            this.margineNetto = _data["margineNetto"] !== undefined ? _data["margineNetto"] : null as any;
            this.tipoV = _data["tipoV"] !== undefined ? _data["tipoV"] : null as any;
            this.catADV = _data["catADV"] !== undefined ? _data["catADV"] : null as any;
            this.mailSpedizioneADV = _data["mailSpedizioneADV"] !== undefined ? _data["mailSpedizioneADV"] : null as any;
            this.qtApPr = _data["qtApPr"] !== undefined ? _data["qtApPr"] : null as any;
            this.wcys = _data["wcys"] !== undefined ? _data["wcys"] : null as any;
            this.wcysPlus = _data["wcysPlus"] !== undefined ? _data["wcysPlus"] : null as any;
            this.int100K = _data["int100K"] !== undefined ? _data["int100K"] : null as any;
            this.int300K = _data["int300K"] !== undefined ? _data["int300K"] : null as any;
            this.int500K = _data["int500K"] !== undefined ? _data["int500K"] : null as any;
            this.int1000K = _data["int1000K"] !== undefined ? _data["int1000K"] : null as any;
            this.blcPrz = _data["blcPrz"] !== undefined ? _data["blcPrz"] : null as any;
            this.intComm = _data["intComm"] !== undefined ? _data["intComm"] : null as any;
            this.tipoPrev = _data["tipoPrev"] !== undefined ? _data["tipoPrev"] : null as any;
            this.sGruppo = _data["sGruppo"] !== undefined ? _data["sGruppo"] : null as any;
            this.gestPreventivo = _data["gestPreventivo"] !== undefined ? _data["gestPreventivo"] : null as any;
            this.gestConferma = _data["gestConferma"] !== undefined ? _data["gestConferma"] : null as any;
            this.accVoucher = _data["accVoucher"] !== undefined ? _data["accVoucher"] : null as any;
        }
    }

    static fromJS(data: any): QuotationsRow {
        data = typeof data === 'object' ? data : {};
        let result = new QuotationsRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["network"] = this.network !== undefined ? this.network : null as any;
        data["regione"] = this.regione !== undefined ? this.regione : null as any;
        data["citta"] = this.citta !== undefined ? this.citta : null as any;
        data["provincia"] = this.provincia !== undefined ? this.provincia : null as any;
        data["agenzia"] = this.agenzia !== undefined ? this.agenzia : null as any;
        data["pax"] = this.pax !== undefined ? this.pax : null as any;
        data["destinazione"] = this.destinazione !== undefined ? this.destinazione : null as any;
        data["idOfferta"] = this.idOfferta !== undefined ? this.idOfferta : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["creazione"] = this.creazione !== undefined ? this.creazione : null as any;
        data["partenza"] = this.partenza !== undefined ? this.partenza : null as any;
        data["conferma"] = this.conferma !== undefined ? this.conferma : null as any;
        data["cancellazioneADV"] = this.cancellazioneADV !== undefined ? this.cancellazioneADV : null as any;
        data["pag"] = this.pag !== undefined ? this.pag : null as any;
        data["totale"] = this.totale !== undefined ? this.totale : null as any;
        data["dirittiAgenzia"] = this.dirittiAgenzia !== undefined ? this.dirittiAgenzia : null as any;
        data["commissioneAgenzia"] = this.commissioneAgenzia !== undefined ? this.commissioneAgenzia : null as any;
        data["percentualeCommissione"] = this.percentualeCommissione !== undefined ? this.percentualeCommissione : null as any;
        data["margineNetto"] = this.margineNetto !== undefined ? this.margineNetto : null as any;
        data["tipoV"] = this.tipoV !== undefined ? this.tipoV : null as any;
        data["catADV"] = this.catADV !== undefined ? this.catADV : null as any;
        data["mailSpedizioneADV"] = this.mailSpedizioneADV !== undefined ? this.mailSpedizioneADV : null as any;
        data["qtApPr"] = this.qtApPr !== undefined ? this.qtApPr : null as any;
        data["wcys"] = this.wcys !== undefined ? this.wcys : null as any;
        data["wcysPlus"] = this.wcysPlus !== undefined ? this.wcysPlus : null as any;
        data["int100K"] = this.int100K !== undefined ? this.int100K : null as any;
        data["int300K"] = this.int300K !== undefined ? this.int300K : null as any;
        data["int500K"] = this.int500K !== undefined ? this.int500K : null as any;
        data["int1000K"] = this.int1000K !== undefined ? this.int1000K : null as any;
        data["blcPrz"] = this.blcPrz !== undefined ? this.blcPrz : null as any;
        data["intComm"] = this.intComm !== undefined ? this.intComm : null as any;
        data["tipoPrev"] = this.tipoPrev !== undefined ? this.tipoPrev : null as any;
        data["sGruppo"] = this.sGruppo !== undefined ? this.sGruppo : null as any;
        data["gestPreventivo"] = this.gestPreventivo !== undefined ? this.gestPreventivo : null as any;
        data["gestConferma"] = this.gestConferma !== undefined ? this.gestConferma : null as any;
        data["accVoucher"] = this.accVoucher !== undefined ? this.accVoucher : null as any;
        return data;
    }
}

export interface IQuotationsRow {
    id?: number;
    network?: string | null;
    regione?: string | null;
    citta?: string | null;
    provincia?: string | null;
    agenzia?: string | null;
    pax?: number | null;
    destinazione?: string | null;
    idOfferta?: number | null;
    descrizione?: string | null;
    creazione?: string | null;
    partenza?: string | null;
    conferma?: string | null;
    cancellazioneADV?: string | null;
    pag?: string | null;
    totale?: number | null;
    dirittiAgenzia?: number | null;
    commissioneAgenzia?: number | null;
    percentualeCommissione?: number | null;
    margineNetto?: number | null;
    tipoV?: string | null;
    catADV?: string | null;
    mailSpedizioneADV?: string | null;
    qtApPr?: number | null;
    wcys?: number | null;
    wcysPlus?: number | null;
    int100K?: number | null;
    int300K?: number | null;
    int500K?: number | null;
    int1000K?: number | null;
    blcPrz?: number | null;
    intComm?: number | null;
    tipoPrev?: string | null;
    sGruppo?: string | null;
    gestPreventivo?: string | null;
    gestConferma?: string | null;
    accVoucher?: number | null;
}

export class QuotationsGetRequest extends ApiRequest implements IQuotationsGetRequest {
    operator!: EOperatore;
    departFrom!: string;
    departTo!: string;
    creationFrom!: string;
    creationTo!: string;
    confirmFrom?: string | null;
    confirmTo?: string | null;
    export?: boolean;

    constructor(data?: IQuotationsGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operator = _data["operator"] !== undefined ? _data["operator"] : null as any;
            this.departFrom = _data["departFrom"] !== undefined ? _data["departFrom"] : null as any;
            this.departTo = _data["departTo"] !== undefined ? _data["departTo"] : null as any;
            this.creationFrom = _data["creationFrom"] !== undefined ? _data["creationFrom"] : null as any;
            this.creationTo = _data["creationTo"] !== undefined ? _data["creationTo"] : null as any;
            this.confirmFrom = _data["confirmFrom"] !== undefined ? _data["confirmFrom"] : null as any;
            this.confirmTo = _data["confirmTo"] !== undefined ? _data["confirmTo"] : null as any;
            this.export = _data["export"] !== undefined ? _data["export"] : null as any;
        }
    }

    static override fromJS(data: any): QuotationsGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new QuotationsGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operator"] = this.operator !== undefined ? this.operator : null as any;
        data["departFrom"] = this.departFrom !== undefined ? this.departFrom : null as any;
        data["departTo"] = this.departTo !== undefined ? this.departTo : null as any;
        data["creationFrom"] = this.creationFrom !== undefined ? this.creationFrom : null as any;
        data["creationTo"] = this.creationTo !== undefined ? this.creationTo : null as any;
        data["confirmFrom"] = this.confirmFrom !== undefined ? this.confirmFrom : null as any;
        data["confirmTo"] = this.confirmTo !== undefined ? this.confirmTo : null as any;
        data["export"] = this.export !== undefined ? this.export : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IQuotationsGetRequest extends IApiRequest {
    operator: EOperatore;
    departFrom: string;
    departTo: string;
    creationFrom: string;
    creationTo: string;
    confirmFrom?: string | null;
    confirmTo?: string | null;
    export?: boolean;
}

export class DeleteReportValuesResponse extends OkApiResponse implements IDeleteReportValuesResponse {
    savedValues?: ReportValoreSalvato[];

    constructor(data?: IDeleteReportValuesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["savedValues"])) {
                this.savedValues = [] as any;
                for (let item of _data["savedValues"])
                    this.savedValues!.push(ReportValoreSalvato.fromJS(item));
            }
            else {
                this.savedValues = null as any;
            }
        }
    }

    static override fromJS(data: any): DeleteReportValuesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteReportValuesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.savedValues)) {
            data["savedValues"] = [];
            for (let item of this.savedValues)
                data["savedValues"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteReportValuesResponse extends IOkApiResponse {
    savedValues?: ReportValoreSalvato[];
}

export class ReportValoreSalvato implements IReportValoreSalvato {
    id?: number;
    reportID?: number;
    nome!: string;
    valori!: string;

    constructor(data?: IReportValoreSalvato) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.reportID = _data["reportID"] !== undefined ? _data["reportID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.valori = _data["valori"] !== undefined ? _data["valori"] : null as any;
        }
    }

    static fromJS(data: any): ReportValoreSalvato {
        data = typeof data === 'object' ? data : {};
        let result = new ReportValoreSalvato();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["reportID"] = this.reportID !== undefined ? this.reportID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["valori"] = this.valori !== undefined ? this.valori : null as any;
        return data;
    }
}

export interface IReportValoreSalvato {
    id?: number;
    reportID?: number;
    nome: string;
    valori: string;
}

export class DeleteReportValuesRequest extends ApiRequest implements IDeleteReportValuesRequest {
    reportID?: number;
    valuesID?: number;

    constructor(data?: IDeleteReportValuesRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.reportID = _data["reportID"] !== undefined ? _data["reportID"] : null as any;
            this.valuesID = _data["valuesID"] !== undefined ? _data["valuesID"] : null as any;
        }
    }

    static override fromJS(data: any): DeleteReportValuesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteReportValuesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportID"] = this.reportID !== undefined ? this.reportID : null as any;
        data["valuesID"] = this.valuesID !== undefined ? this.valuesID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteReportValuesRequest extends IApiRequest {
    reportID?: number;
    valuesID?: number;
}

export class ReportExportRequest extends ApiRequest implements IReportExportRequest {
    reportID?: number;
    parameters?: ReportExportParameters[] | null;

    constructor(data?: IReportExportRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.reportID = _data["reportID"] !== undefined ? _data["reportID"] : null as any;
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(ReportExportParameters.fromJS(item));
            }
            else {
                this.parameters = null as any;
            }
        }
    }

    static override fromJS(data: any): ReportExportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReportExportRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportID"] = this.reportID !== undefined ? this.reportID : null as any;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IReportExportRequest extends IApiRequest {
    reportID?: number;
    parameters?: ReportExportParameters[] | null;
}

export class ReportExportParameters implements IReportExportParameters {
    name?: string;
    value?: string | null;
    isArray?: boolean | null;

    constructor(data?: IReportExportParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
            this.isArray = _data["isArray"] !== undefined ? _data["isArray"] : null as any;
        }
    }

    static fromJS(data: any): ReportExportParameters {
        data = typeof data === 'object' ? data : {};
        let result = new ReportExportParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["isArray"] = this.isArray !== undefined ? this.isArray : null as any;
        return data;
    }
}

export interface IReportExportParameters {
    name?: string;
    value?: string | null;
    isArray?: boolean | null;
}

export class NrTableResponseOfReportRow extends OkApiResponse implements INrTableResponseOfReportRow {
    /** Array delle righe della pagina richiesta */
    rows?: ReportRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfReportRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ReportRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfReportRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfReportRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfReportRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: ReportRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class ReportsResponse extends NrTableResponseOfReportRow implements IReportsResponse {

    constructor(data?: IReportsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ReportsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IReportsResponse extends INrTableResponseOfReportRow {
}

export class ReportRow implements IReportRow {
    id?: number;
    name?: string | null;
    enabled?: boolean;
    sentTime?: string | null;
    lastSent?: ReportSend | null;
    parameters?: any | null;
    savedValues?: ReportValoreSalvato[] | null;
    calendarMode?: EModalitaCalendarioAssicurazione;
    report?: Report | null;

    constructor(data?: IReportRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : null as any;
            this.sentTime = _data["sentTime"] !== undefined ? _data["sentTime"] : null as any;
            this.lastSent = _data["lastSent"] ? ReportSend.fromJS(_data["lastSent"]) : null as any;
            this.parameters = _data["parameters"] !== undefined ? _data["parameters"] : null as any;
            if (Array.isArray(_data["savedValues"])) {
                this.savedValues = [] as any;
                for (let item of _data["savedValues"])
                    this.savedValues!.push(ReportValoreSalvato.fromJS(item));
            }
            else {
                this.savedValues = null as any;
            }
            this.calendarMode = _data["calendarMode"] !== undefined ? _data["calendarMode"] : null as any;
            this.report = _data["report"] ? Report.fromJS(_data["report"]) : null as any;
        }
    }

    static fromJS(data: any): ReportRow {
        data = typeof data === 'object' ? data : {};
        let result = new ReportRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["enabled"] = this.enabled !== undefined ? this.enabled : null as any;
        data["sentTime"] = this.sentTime !== undefined ? this.sentTime : null as any;
        data["lastSent"] = this.lastSent ? this.lastSent.toJSON() : null as any;
        data["parameters"] = this.parameters !== undefined ? this.parameters : null as any;
        if (Array.isArray(this.savedValues)) {
            data["savedValues"] = [];
            for (let item of this.savedValues)
                data["savedValues"].push(item ? item.toJSON() : null as any);
        }
        data["calendarMode"] = this.calendarMode !== undefined ? this.calendarMode : null as any;
        data["report"] = this.report ? this.report.toJSON() : null as any;
        return data;
    }
}

export interface IReportRow {
    id?: number;
    name?: string | null;
    enabled?: boolean;
    sentTime?: string | null;
    lastSent?: ReportSend | null;
    parameters?: any | null;
    savedValues?: ReportValoreSalvato[] | null;
    calendarMode?: EModalitaCalendarioAssicurazione;
    report?: Report | null;
}

export class ReportInvio implements IReportInvio {
    id?: number;
    reportID?: number;
    data?: string;
    esito?: EEsitoInvioAssicurazione;
    jsonData?: string | null;
    messaggio?: string | null;

    constructor(data?: IReportInvio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.reportID = _data["reportID"] !== undefined ? _data["reportID"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
            this.esito = _data["esito"] !== undefined ? _data["esito"] : null as any;
            this.jsonData = _data["jsonData"] !== undefined ? _data["jsonData"] : null as any;
            this.messaggio = _data["messaggio"] !== undefined ? _data["messaggio"] : null as any;
        }
    }

    static fromJS(data: any): ReportInvio {
        data = typeof data === 'object' ? data : {};
        let result = new ReportInvio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["reportID"] = this.reportID !== undefined ? this.reportID : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["esito"] = this.esito !== undefined ? this.esito : null as any;
        data["jsonData"] = this.jsonData !== undefined ? this.jsonData : null as any;
        data["messaggio"] = this.messaggio !== undefined ? this.messaggio : null as any;
        return data;
    }
}

export interface IReportInvio {
    id?: number;
    reportID?: number;
    data?: string;
    esito?: EEsitoInvioAssicurazione;
    jsonData?: string | null;
    messaggio?: string | null;
}

export class ReportSend extends ReportInvio implements IReportSend {
    reportEmails?: ReportSendEmail[] | null;

    constructor(data?: IReportSend) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["reportEmails"])) {
                this.reportEmails = [] as any;
                for (let item of _data["reportEmails"])
                    this.reportEmails!.push(ReportSendEmail.fromJS(item));
            }
            else {
                this.reportEmails = null as any;
            }
        }
    }

    static override fromJS(data: any): ReportSend {
        data = typeof data === 'object' ? data : {};
        let result = new ReportSend();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reportEmails)) {
            data["reportEmails"] = [];
            for (let item of this.reportEmails)
                data["reportEmails"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IReportSend extends IReportInvio {
    reportEmails?: ReportSendEmail[] | null;
}

export class ReportSendEmail implements IReportSendEmail {
    emailID?: number;
    recipients?: ReportSendEmailRecipient[];

    constructor(data?: IReportSendEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailID = _data["emailID"] !== undefined ? _data["emailID"] : null as any;
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(ReportSendEmailRecipient.fromJS(item));
            }
            else {
                this.recipients = null as any;
            }
        }
    }

    static fromJS(data: any): ReportSendEmail {
        data = typeof data === 'object' ? data : {};
        let result = new ReportSendEmail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailID"] = this.emailID !== undefined ? this.emailID : null as any;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IReportSendEmail {
    emailID?: number;
    recipients?: ReportSendEmailRecipient[];
}

export class ReportSendEmailRecipient implements IReportSendEmailRecipient {
    address?: string | null;
    name?: string | null;

    constructor(data?: IReportSendEmailRecipient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"] !== undefined ? _data["address"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): ReportSendEmailRecipient {
        data = typeof data === 'object' ? data : {};
        let result = new ReportSendEmailRecipient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address !== undefined ? this.address : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export interface IReportSendEmailRecipient {
    address?: string | null;
    name?: string | null;
}

export class Report implements IReport {
    id?: number;
    codice!: string;
    codiceTemplateEmail!: string;
    nome!: string;
    abilitato?: boolean;
    modalitaCalendario?: EModalitaCalendarioAssicurazione;
    permissions?: string | null;
    query?: string | null;
    parametri?: string | null;
    orarioInvio!: string;
    oraInvio?: number;
    minutoInvio?: number;

    constructor(data?: IReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
            this.codiceTemplateEmail = _data["codiceTemplateEmail"] !== undefined ? _data["codiceTemplateEmail"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.abilitato = _data["abilitato"] !== undefined ? _data["abilitato"] : null as any;
            this.modalitaCalendario = _data["modalitaCalendario"] !== undefined ? _data["modalitaCalendario"] : null as any;
            this.permissions = _data["permissions"] !== undefined ? _data["permissions"] : null as any;
            this.query = _data["query"] !== undefined ? _data["query"] : null as any;
            this.parametri = _data["parametri"] !== undefined ? _data["parametri"] : null as any;
            this.orarioInvio = _data["orarioInvio"] !== undefined ? _data["orarioInvio"] : null as any;
            this.oraInvio = _data["oraInvio"] !== undefined ? _data["oraInvio"] : null as any;
            this.minutoInvio = _data["minutoInvio"] !== undefined ? _data["minutoInvio"] : null as any;
        }
    }

    static fromJS(data: any): Report {
        data = typeof data === 'object' ? data : {};
        let result = new Report();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        data["codiceTemplateEmail"] = this.codiceTemplateEmail !== undefined ? this.codiceTemplateEmail : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["abilitato"] = this.abilitato !== undefined ? this.abilitato : null as any;
        data["modalitaCalendario"] = this.modalitaCalendario !== undefined ? this.modalitaCalendario : null as any;
        data["permissions"] = this.permissions !== undefined ? this.permissions : null as any;
        data["query"] = this.query !== undefined ? this.query : null as any;
        data["parametri"] = this.parametri !== undefined ? this.parametri : null as any;
        data["orarioInvio"] = this.orarioInvio !== undefined ? this.orarioInvio : null as any;
        data["oraInvio"] = this.oraInvio !== undefined ? this.oraInvio : null as any;
        data["minutoInvio"] = this.minutoInvio !== undefined ? this.minutoInvio : null as any;
        return data;
    }
}

export interface IReport {
    id?: number;
    codice: string;
    codiceTemplateEmail: string;
    nome: string;
    abilitato?: boolean;
    modalitaCalendario?: EModalitaCalendarioAssicurazione;
    permissions?: string | null;
    query?: string | null;
    parametri?: string | null;
    orarioInvio: string;
    oraInvio?: number;
    minutoInvio?: number;
}

export class ReportsRequest extends NrTableRequest implements IReportsRequest {
    name?: string | null;

    constructor(data?: IReportsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static override fromJS(data: any): ReportsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReportsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IReportsRequest extends INrTableRequest {
    name?: string | null;
}

export class SaveReportValuesResponse extends OkApiResponse implements ISaveReportValuesResponse {
    savedValues?: ReportValoreSalvato[];

    constructor(data?: ISaveReportValuesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["savedValues"])) {
                this.savedValues = [] as any;
                for (let item of _data["savedValues"])
                    this.savedValues!.push(ReportValoreSalvato.fromJS(item));
            }
            else {
                this.savedValues = null as any;
            }
        }
    }

    static override fromJS(data: any): SaveReportValuesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveReportValuesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.savedValues)) {
            data["savedValues"] = [];
            for (let item of this.savedValues)
                data["savedValues"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISaveReportValuesResponse extends IOkApiResponse {
    savedValues?: ReportValoreSalvato[];
}

export class SaveReportValuesRequest extends ApiRequest implements ISaveReportValuesRequest {
    reportID?: number;
    valuesID?: number | null;
    name?: string | null;
    values?: string | null;

    constructor(data?: ISaveReportValuesRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.reportID = _data["reportID"] !== undefined ? _data["reportID"] : null as any;
            this.valuesID = _data["valuesID"] !== undefined ? _data["valuesID"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.values = _data["values"] !== undefined ? _data["values"] : null as any;
        }
    }

    static override fromJS(data: any): SaveReportValuesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveReportValuesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportID"] = this.reportID !== undefined ? this.reportID : null as any;
        data["valuesID"] = this.valuesID !== undefined ? this.valuesID : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["values"] = this.values !== undefined ? this.values : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISaveReportValuesRequest extends IApiRequest {
    reportID?: number;
    valuesID?: number | null;
    name?: string | null;
    values?: string | null;
}

export class StatisticResultResponse extends OkApiResponse implements IStatisticResultResponse {
    table?: StatisticTable;

    constructor(data?: IStatisticResultResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.table = _data["table"] ? StatisticTable.fromJS(_data["table"]) : null as any;
        }
    }

    static override fromJS(data: any): StatisticResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticResultResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["table"] = this.table ? this.table.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IStatisticResultResponse extends IOkApiResponse {
    table?: StatisticTable;
}

export class StatisticResultRequest extends LocalizedRequest implements IStatisticResultRequest {
    statisticID?: number;
    parameters?: string | null;
    export?: boolean | null;

    constructor(data?: IStatisticResultRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.statisticID = _data["statisticID"] !== undefined ? _data["statisticID"] : null as any;
            this.parameters = _data["parameters"] !== undefined ? _data["parameters"] : null as any;
            this.export = _data["export"] !== undefined ? _data["export"] : null as any;
        }
    }

    static override fromJS(data: any): StatisticResultRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticResultRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statisticID"] = this.statisticID !== undefined ? this.statisticID : null as any;
        data["parameters"] = this.parameters !== undefined ? this.parameters : null as any;
        data["export"] = this.export !== undefined ? this.export : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IStatisticResultRequest extends ILocalizedRequest {
    statisticID?: number;
    parameters?: string | null;
    export?: boolean | null;
}

export class NrTableResponseOfSalesDetailsRow extends OkApiResponse implements INrTableResponseOfSalesDetailsRow {
    /** Array delle righe della pagina richiesta */
    rows?: SalesDetailsRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfSalesDetailsRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(SalesDetailsRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfSalesDetailsRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfSalesDetailsRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfSalesDetailsRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: SalesDetailsRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class SalesDetailsResponse extends NrTableResponseOfSalesDetailsRow implements ISalesDetailsResponse {

    constructor(data?: ISalesDetailsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SalesDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SalesDetailsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISalesDetailsResponse extends INrTableResponseOfSalesDetailsRow {
}

export class SalesDetailsRow implements ISalesDetailsRow {
    id?: number;
    descrizione?: string | null;
    totale?: number | null;
    riferimento?: number;
    creazione?: string | null;
    partenza?: string | null;
    conferma?: string | null;
    impiegato?: string | null;
    addetto?: string | null;

    constructor(data?: ISalesDetailsRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.totale = _data["totale"] !== undefined ? _data["totale"] : null as any;
            this.riferimento = _data["riferimento"] !== undefined ? _data["riferimento"] : null as any;
            this.creazione = _data["creazione"] !== undefined ? _data["creazione"] : null as any;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : null as any;
            this.conferma = _data["conferma"] !== undefined ? _data["conferma"] : null as any;
            this.impiegato = _data["impiegato"] !== undefined ? _data["impiegato"] : null as any;
            this.addetto = _data["addetto"] !== undefined ? _data["addetto"] : null as any;
        }
    }

    static fromJS(data: any): SalesDetailsRow {
        data = typeof data === 'object' ? data : {};
        let result = new SalesDetailsRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["totale"] = this.totale !== undefined ? this.totale : null as any;
        data["riferimento"] = this.riferimento !== undefined ? this.riferimento : null as any;
        data["creazione"] = this.creazione !== undefined ? this.creazione : null as any;
        data["partenza"] = this.partenza !== undefined ? this.partenza : null as any;
        data["conferma"] = this.conferma !== undefined ? this.conferma : null as any;
        data["impiegato"] = this.impiegato !== undefined ? this.impiegato : null as any;
        data["addetto"] = this.addetto !== undefined ? this.addetto : null as any;
        return data;
    }
}

export interface ISalesDetailsRow {
    id?: number;
    descrizione?: string | null;
    totale?: number | null;
    riferimento?: number;
    creazione?: string | null;
    partenza?: string | null;
    conferma?: string | null;
    impiegato?: string | null;
    addetto?: string | null;
}

export class SalesDetailsRequest extends NrTableRequest implements ISalesDetailsRequest {
    agencyID?: number;
    departFrom?: string | null;
    departTo?: string | null;
    quotationFrom?: string | null;
    quotationTo?: string | null;

    constructor(data?: ISalesDetailsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agencyID = _data["agencyID"] !== undefined ? _data["agencyID"] : null as any;
            this.departFrom = _data["departFrom"] !== undefined ? _data["departFrom"] : null as any;
            this.departTo = _data["departTo"] !== undefined ? _data["departTo"] : null as any;
            this.quotationFrom = _data["quotationFrom"] !== undefined ? _data["quotationFrom"] : null as any;
            this.quotationTo = _data["quotationTo"] !== undefined ? _data["quotationTo"] : null as any;
        }
    }

    static override fromJS(data: any): SalesDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SalesDetailsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agencyID"] = this.agencyID !== undefined ? this.agencyID : null as any;
        data["departFrom"] = this.departFrom !== undefined ? this.departFrom : null as any;
        data["departTo"] = this.departTo !== undefined ? this.departTo : null as any;
        data["quotationFrom"] = this.quotationFrom !== undefined ? this.quotationFrom : null as any;
        data["quotationTo"] = this.quotationTo !== undefined ? this.quotationTo : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISalesDetailsRequest extends INrTableRequest {
    agencyID?: number;
    departFrom?: string | null;
    departTo?: string | null;
    quotationFrom?: string | null;
    quotationTo?: string | null;
}

export class SalesGetResponse extends OkApiResponse implements ISalesGetResponse {
    table?: StatisticTable;
    totalQuotation?: number | null;
    totalSales?: number | null;
    avaragePercent?: number | null;
    totalNQuotation?: number | null;
    totalNSales?: number | null;
    avarageNPercent?: number | null;

    constructor(data?: ISalesGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.table = _data["table"] ? StatisticTable.fromJS(_data["table"]) : null as any;
            this.totalQuotation = _data["totalQuotation"] !== undefined ? _data["totalQuotation"] : null as any;
            this.totalSales = _data["totalSales"] !== undefined ? _data["totalSales"] : null as any;
            this.avaragePercent = _data["avaragePercent"] !== undefined ? _data["avaragePercent"] : null as any;
            this.totalNQuotation = _data["totalNQuotation"] !== undefined ? _data["totalNQuotation"] : null as any;
            this.totalNSales = _data["totalNSales"] !== undefined ? _data["totalNSales"] : null as any;
            this.avarageNPercent = _data["avarageNPercent"] !== undefined ? _data["avarageNPercent"] : null as any;
        }
    }

    static override fromJS(data: any): SalesGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SalesGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["table"] = this.table ? this.table.toJSON() : null as any;
        data["totalQuotation"] = this.totalQuotation !== undefined ? this.totalQuotation : null as any;
        data["totalSales"] = this.totalSales !== undefined ? this.totalSales : null as any;
        data["avaragePercent"] = this.avaragePercent !== undefined ? this.avaragePercent : null as any;
        data["totalNQuotation"] = this.totalNQuotation !== undefined ? this.totalNQuotation : null as any;
        data["totalNSales"] = this.totalNSales !== undefined ? this.totalNSales : null as any;
        data["avarageNPercent"] = this.avarageNPercent !== undefined ? this.avarageNPercent : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISalesGetResponse extends IOkApiResponse {
    table?: StatisticTable;
    totalQuotation?: number | null;
    totalSales?: number | null;
    avaragePercent?: number | null;
    totalNQuotation?: number | null;
    totalNSales?: number | null;
    avarageNPercent?: number | null;
}

export class SalesGetRequest extends ApiRequest implements ISalesGetRequest {
    operator!: EOperatore;
    name?: string | null;
    region?: string | null;
    city?: string | null;
    cap?: string | null;
    province?: string | null;
    departFrom!: string;
    departTo!: string;
    quotationFrom!: string;
    quotationTo!: string;
    export?: boolean;

    constructor(data?: ISalesGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operator = _data["operator"] !== undefined ? _data["operator"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.region = _data["region"] !== undefined ? _data["region"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : null as any;
            this.province = _data["province"] !== undefined ? _data["province"] : null as any;
            this.departFrom = _data["departFrom"] !== undefined ? _data["departFrom"] : null as any;
            this.departTo = _data["departTo"] !== undefined ? _data["departTo"] : null as any;
            this.quotationFrom = _data["quotationFrom"] !== undefined ? _data["quotationFrom"] : null as any;
            this.quotationTo = _data["quotationTo"] !== undefined ? _data["quotationTo"] : null as any;
            this.export = _data["export"] !== undefined ? _data["export"] : null as any;
        }
    }

    static override fromJS(data: any): SalesGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SalesGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operator"] = this.operator !== undefined ? this.operator : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["region"] = this.region !== undefined ? this.region : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["cap"] = this.cap !== undefined ? this.cap : null as any;
        data["province"] = this.province !== undefined ? this.province : null as any;
        data["departFrom"] = this.departFrom !== undefined ? this.departFrom : null as any;
        data["departTo"] = this.departTo !== undefined ? this.departTo : null as any;
        data["quotationFrom"] = this.quotationFrom !== undefined ? this.quotationFrom : null as any;
        data["quotationTo"] = this.quotationTo !== undefined ? this.quotationTo : null as any;
        data["export"] = this.export !== undefined ? this.export : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISalesGetRequest extends IApiRequest {
    operator: EOperatore;
    name?: string | null;
    region?: string | null;
    city?: string | null;
    cap?: string | null;
    province?: string | null;
    departFrom: string;
    departTo: string;
    quotationFrom: string;
    quotationTo: string;
    export?: boolean;
}

export class StatisticsAllResponse extends OkApiResponse implements IStatisticsAllResponse {
    statistics?: StatisticsRow[];

    constructor(data?: IStatisticsAllResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["statistics"])) {
                this.statistics = [] as any;
                for (let item of _data["statistics"])
                    this.statistics!.push(StatisticsRow.fromJS(item));
            }
            else {
                this.statistics = null as any;
            }
        }
    }

    static override fromJS(data: any): StatisticsAllResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticsAllResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.statistics)) {
            data["statistics"] = [];
            for (let item of this.statistics)
                data["statistics"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IStatisticsAllResponse extends IOkApiResponse {
    statistics?: StatisticsRow[];
}

export class StatisticsRow implements IStatisticsRow {
    id?: number;
    name?: string;
    alias?: string;
    statistica?: Statistica | null;

    constructor(data?: IStatisticsRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.alias = _data["alias"] !== undefined ? _data["alias"] : null as any;
            this.statistica = _data["statistica"] ? Statistica.fromJS(_data["statistica"]) : null as any;
        }
    }

    static fromJS(data: any): StatisticsRow {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticsRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["alias"] = this.alias !== undefined ? this.alias : null as any;
        data["statistica"] = this.statistica ? this.statistica.toJSON() : null as any;
        return data;
    }
}

export interface IStatisticsRow {
    id?: number;
    name?: string;
    alias?: string;
    statistica?: Statistica | null;
}

export class Statistica implements IStatistica {
    id?: number;
    nome!: string;
    alias?: string;
    query?: string;
    tipo?: number | null;

    constructor(data?: IStatistica) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.alias = _data["alias"] !== undefined ? _data["alias"] : null as any;
            this.query = _data["query"] !== undefined ? _data["query"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
        }
    }

    static fromJS(data: any): Statistica {
        data = typeof data === 'object' ? data : {};
        let result = new Statistica();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["alias"] = this.alias !== undefined ? this.alias : null as any;
        data["query"] = this.query !== undefined ? this.query : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        return data;
    }
}

export interface IStatistica {
    id?: number;
    nome: string;
    alias?: string;
    query?: string;
    tipo?: number | null;
}

export class StatisticsAllRequest extends LocalizedRequest implements IStatisticsAllRequest {

    constructor(data?: IStatisticsAllRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StatisticsAllRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticsAllRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStatisticsAllRequest extends ILocalizedRequest {
}

export class StatisticGetResponse extends OkApiResponse implements IStatisticGetResponse {
    statistic?: Statistica | null;
    /** Alias in inglese (da website_translations, idlingua = English) */
    aliasEn?: string | null;

    constructor(data?: IStatisticGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.statistic = _data["statistic"] ? Statistica.fromJS(_data["statistic"]) : null as any;
            this.aliasEn = _data["aliasEn"] !== undefined ? _data["aliasEn"] : null as any;
        }
    }

    static override fromJS(data: any): StatisticGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statistic"] = this.statistic ? this.statistic.toJSON() : null as any;
        data["aliasEn"] = this.aliasEn !== undefined ? this.aliasEn : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IStatisticGetResponse extends IOkApiResponse {
    statistic?: Statistica | null;
    /** Alias in inglese (da website_translations, idlingua = English) */
    aliasEn?: string | null;
}

export class StatisticGetRequest extends LocalizedRequest implements IStatisticGetRequest {
    statisticID?: number;

    constructor(data?: IStatisticGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.statisticID = _data["statisticID"] !== undefined ? _data["statisticID"] : null as any;
        }
    }

    static override fromJS(data: any): StatisticGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statisticID"] = this.statisticID !== undefined ? this.statisticID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IStatisticGetRequest extends ILocalizedRequest {
    statisticID?: number;
}

export class StatisticUpdateRequest extends StatisticGetRequest implements IStatisticUpdateRequest {
    statistic?: Statistica | null;
    /** Alias in inglese da salvare in website_translations (idlingua = English) */
    aliasEn?: string | null;

    constructor(data?: IStatisticUpdateRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.statistic = _data["statistic"] ? Statistica.fromJS(_data["statistic"]) : null as any;
            this.aliasEn = _data["aliasEn"] !== undefined ? _data["aliasEn"] : null as any;
        }
    }

    static override fromJS(data: any): StatisticUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticUpdateRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statistic"] = this.statistic ? this.statistic.toJSON() : null as any;
        data["aliasEn"] = this.aliasEn !== undefined ? this.aliasEn : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IStatisticUpdateRequest extends IStatisticGetRequest {
    statistic?: Statistica | null;
    /** Alias in inglese da salvare in website_translations (idlingua = English) */
    aliasEn?: string | null;
}

export class StatisticDeleteRequest extends LocalizedRequest implements IStatisticDeleteRequest {
    statisticID?: number;

    constructor(data?: IStatisticDeleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.statisticID = _data["statisticID"] !== undefined ? _data["statisticID"] : null as any;
        }
    }

    static override fromJS(data: any): StatisticDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticDeleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statisticID"] = this.statisticID !== undefined ? this.statisticID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IStatisticDeleteRequest extends ILocalizedRequest {
    statisticID?: number;
}

export class NrTableResponseOfStatisticsRow extends OkApiResponse implements INrTableResponseOfStatisticsRow {
    /** Array delle righe della pagina richiesta */
    rows?: StatisticsRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfStatisticsRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(StatisticsRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfStatisticsRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfStatisticsRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfStatisticsRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: StatisticsRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class StatisticsListResponse extends NrTableResponseOfStatisticsRow implements IStatisticsListResponse {

    constructor(data?: IStatisticsListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StatisticsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticsListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStatisticsListResponse extends INrTableResponseOfStatisticsRow {
}

export class StatisticsListRequest extends NrTableRequest implements IStatisticsListRequest {
    name?: string | null;

    constructor(data?: IStatisticsListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static override fromJS(data: any): StatisticsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticsListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IStatisticsListRequest extends INrTableRequest {
    name?: string | null;
}

export class SynchTripRequest extends ApiRequest implements ISynchTripRequest {
    offertaID?: number;

    constructor(data?: ISynchTripRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
        }
    }

    static override fromJS(data: any): SynchTripRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SynchTripRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISynchTripRequest extends IApiRequest {
    offertaID?: number;
}

export class SynchTripMidocoRequest extends SynchTripRequest implements ISynchTripMidocoRequest {

    constructor(data?: ISynchTripMidocoRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SynchTripMidocoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SynchTripMidocoRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISynchTripMidocoRequest extends ISynchTripRequest {
}

export class SynchTripBosysRequest extends SynchTripRequest implements ISynchTripBosysRequest {

    constructor(data?: ISynchTripBosysRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SynchTripBosysRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SynchTripBosysRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISynchTripBosysRequest extends ISynchTripRequest {
}

export class SynchTripWelcomeRequest extends SynchTripRequest implements ISynchTripWelcomeRequest {

    constructor(data?: ISynchTripWelcomeRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SynchTripWelcomeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SynchTripWelcomeRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISynchTripWelcomeRequest extends ISynchTripRequest {
}

export class SystemEmailGetResponse extends OkApiResponse implements ISystemEmailGetResponse {
    email?: SystemEmailRow2 | null;

    constructor(data?: ISystemEmailGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.email = _data["email"] ? SystemEmailRow2.fromJS(_data["email"]) : null as any;
        }
    }

    static override fromJS(data: any): SystemEmailGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEmailGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email ? this.email.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISystemEmailGetResponse extends IOkApiResponse {
    email?: SystemEmailRow2 | null;
}

export class SystemEmailRow2 implements ISystemEmailRow2 {
    id?: number;
    code?: string;
    operator?: EOperatore;
    hasDynamicBody?: boolean;
    hasDynamicRecipient?: boolean;
    isHtmlBody?: boolean;
    name?: string;
    texts?: SystemEmailTextRow2[];
    deleted?: boolean;

    constructor(data?: ISystemEmailRow2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.operator = _data["operator"] !== undefined ? _data["operator"] : null as any;
            this.hasDynamicBody = _data["hasDynamicBody"] !== undefined ? _data["hasDynamicBody"] : null as any;
            this.hasDynamicRecipient = _data["hasDynamicRecipient"] !== undefined ? _data["hasDynamicRecipient"] : null as any;
            this.isHtmlBody = _data["isHtmlBody"] !== undefined ? _data["isHtmlBody"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            if (Array.isArray(_data["texts"])) {
                this.texts = [] as any;
                for (let item of _data["texts"])
                    this.texts!.push(SystemEmailTextRow2.fromJS(item));
            }
            else {
                this.texts = null as any;
            }
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : null as any;
        }
    }

    static fromJS(data: any): SystemEmailRow2 {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEmailRow2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["operator"] = this.operator !== undefined ? this.operator : null as any;
        data["hasDynamicBody"] = this.hasDynamicBody !== undefined ? this.hasDynamicBody : null as any;
        data["hasDynamicRecipient"] = this.hasDynamicRecipient !== undefined ? this.hasDynamicRecipient : null as any;
        data["isHtmlBody"] = this.isHtmlBody !== undefined ? this.isHtmlBody : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        if (Array.isArray(this.texts)) {
            data["texts"] = [];
            for (let item of this.texts)
                data["texts"].push(item ? item.toJSON() : null as any);
        }
        data["deleted"] = this.deleted !== undefined ? this.deleted : null as any;
        return data;
    }
}

export interface ISystemEmailRow2 {
    id?: number;
    code?: string;
    operator?: EOperatore;
    hasDynamicBody?: boolean;
    hasDynamicRecipient?: boolean;
    isHtmlBody?: boolean;
    name?: string;
    texts?: SystemEmailTextRow2[];
    deleted?: boolean;
}

export class SystemEmailTextRow2 implements ISystemEmailTextRow2 {
    id?: number;
    body?: string | null;
    language?: ELingua;
    senderAddress?: string | null;
    senderName?: string | null;
    subject?: string | null;
    addresses?: SystemEmailAddress[];

    constructor(data?: ISystemEmailTextRow2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.body = _data["body"] !== undefined ? _data["body"] : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
            this.senderAddress = _data["senderAddress"] !== undefined ? _data["senderAddress"] : null as any;
            this.senderName = _data["senderName"] !== undefined ? _data["senderName"] : null as any;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : null as any;
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(SystemEmailAddress.fromJS(item));
            }
            else {
                this.addresses = null as any;
            }
        }
    }

    static fromJS(data: any): SystemEmailTextRow2 {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEmailTextRow2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["body"] = this.body !== undefined ? this.body : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        data["senderAddress"] = this.senderAddress !== undefined ? this.senderAddress : null as any;
        data["senderName"] = this.senderName !== undefined ? this.senderName : null as any;
        data["subject"] = this.subject !== undefined ? this.subject : null as any;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ISystemEmailTextRow2 {
    id?: number;
    body?: string | null;
    language?: ELingua;
    senderAddress?: string | null;
    senderName?: string | null;
    subject?: string | null;
    addresses?: SystemEmailAddress[];
}

export class SystemEmailGetRequest extends ApiRequest implements ISystemEmailGetRequest {
    emailID?: number;

    constructor(data?: ISystemEmailGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.emailID = _data["emailID"] !== undefined ? _data["emailID"] : null as any;
        }
    }

    static override fromJS(data: any): SystemEmailGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEmailGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailID"] = this.emailID !== undefined ? this.emailID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISystemEmailGetRequest extends IApiRequest {
    emailID?: number;
}

export class SystemEmailUpdateRequest extends SystemEmailGetRequest implements ISystemEmailUpdateRequest {
    email?: SystemEmailRow2 | null;

    constructor(data?: ISystemEmailUpdateRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.email = _data["email"] ? SystemEmailRow2.fromJS(_data["email"]) : null as any;
        }
    }

    static override fromJS(data: any): SystemEmailUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEmailUpdateRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email ? this.email.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISystemEmailUpdateRequest extends ISystemEmailGetRequest {
    email?: SystemEmailRow2 | null;
}

export class SystemEmailCreateRequest extends SystemEmailUpdateRequest implements ISystemEmailCreateRequest {

    constructor(data?: ISystemEmailCreateRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SystemEmailCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEmailCreateRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISystemEmailCreateRequest extends ISystemEmailUpdateRequest {
}

export class SystemEmailDeleteRequest extends SystemEmailGetRequest implements ISystemEmailDeleteRequest {

    constructor(data?: ISystemEmailDeleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SystemEmailDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEmailDeleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISystemEmailDeleteRequest extends ISystemEmailGetRequest {
}

export class NrTableResponseOfSystemEmailRow extends OkApiResponse implements INrTableResponseOfSystemEmailRow {
    /** Array delle righe della pagina richiesta */
    rows?: SystemEmailRow2[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfSystemEmailRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(SystemEmailRow2.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfSystemEmailRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfSystemEmailRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfSystemEmailRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: SystemEmailRow2[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class SystemEmailListResponse extends NrTableResponseOfSystemEmailRow implements ISystemEmailListResponse {

    constructor(data?: ISystemEmailListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SystemEmailListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEmailListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISystemEmailListResponse extends INrTableResponseOfSystemEmailRow {
}

export class SystemEmailListRequest extends NrTableRequest implements ISystemEmailListRequest {
    showDeleted?: boolean;
    term?: string | null;
    name?: string | null;
    operator?: EOperatore | null;

    constructor(data?: ISystemEmailListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.showDeleted = _data["showDeleted"] !== undefined ? _data["showDeleted"] : null as any;
            this.term = _data["term"] !== undefined ? _data["term"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.operator = _data["operator"] !== undefined ? _data["operator"] : null as any;
        }
    }

    static override fromJS(data: any): SystemEmailListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEmailListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showDeleted"] = this.showDeleted !== undefined ? this.showDeleted : null as any;
        data["term"] = this.term !== undefined ? this.term : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["operator"] = this.operator !== undefined ? this.operator : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISystemEmailListRequest extends INrTableRequest {
    showDeleted?: boolean;
    term?: string | null;
    name?: string | null;
    operator?: EOperatore | null;
}

export class SystemEmailRestoreRequest extends SystemEmailGetRequest implements ISystemEmailRestoreRequest {

    constructor(data?: ISystemEmailRestoreRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SystemEmailRestoreRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEmailRestoreRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISystemEmailRestoreRequest extends ISystemEmailGetRequest {
}

export class SystemEmailUpdateResponse extends SystemEmailGetResponse implements ISystemEmailUpdateResponse {

    constructor(data?: ISystemEmailUpdateResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SystemEmailUpdateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEmailUpdateResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISystemEmailUpdateResponse extends ISystemEmailGetResponse {
}

export class GetTasksLogsResponse extends OkApiResponse implements IGetTasksLogsResponse {
    logs?: TaskLogInfo[];

    constructor(data?: IGetTasksLogsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["logs"])) {
                this.logs = [] as any;
                for (let item of _data["logs"])
                    this.logs!.push(TaskLogInfo.fromJS(item));
            }
            else {
                this.logs = null as any;
            }
        }
    }

    static override fromJS(data: any): GetTasksLogsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTasksLogsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetTasksLogsResponse extends IOkApiResponse {
    logs?: TaskLogInfo[];
}

export class TaskLogInfo implements ITaskLogInfo {
    id?: number;
    taskLog?: TaskLog;
    operations?: TaskLogOperationInfo[];

    constructor(data?: ITaskLogInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.taskLog = _data["taskLog"] ? TaskLog.fromJS(_data["taskLog"]) : null as any;
            if (Array.isArray(_data["operations"])) {
                this.operations = [] as any;
                for (let item of _data["operations"])
                    this.operations!.push(TaskLogOperationInfo.fromJS(item));
            }
            else {
                this.operations = null as any;
            }
        }
    }

    static fromJS(data: any): TaskLogInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TaskLogInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["taskLog"] = this.taskLog ? this.taskLog.toJSON() : null as any;
        if (Array.isArray(this.operations)) {
            data["operations"] = [];
            for (let item of this.operations)
                data["operations"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ITaskLogInfo {
    id?: number;
    taskLog?: TaskLog;
    operations?: TaskLogOperationInfo[];
}

export class TaskLog implements ITaskLog {
    id?: number;
    operationType?: ETaskOperationType;
    starterProcess?: ETaskProcess;
    createdAt?: string;
    updatedAt?: string;
    status?: ETaskStatus;
    tripID?: number | null;
    tripRowID?: number | null;
    deleteAfter?: string | null;

    constructor(data?: ITaskLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.operationType = _data["operationType"] !== undefined ? _data["operationType"] : null as any;
            this.starterProcess = _data["starterProcess"] !== undefined ? _data["starterProcess"] : null as any;
            this.createdAt = _data["createdAt"] !== undefined ? _data["createdAt"] : null as any;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : null as any;
            this.tripRowID = _data["tripRowID"] !== undefined ? _data["tripRowID"] : null as any;
            this.deleteAfter = _data["deleteAfter"] !== undefined ? _data["deleteAfter"] : null as any;
        }
    }

    static fromJS(data: any): TaskLog {
        data = typeof data === 'object' ? data : {};
        let result = new TaskLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["operationType"] = this.operationType !== undefined ? this.operationType : null as any;
        data["starterProcess"] = this.starterProcess !== undefined ? this.starterProcess : null as any;
        data["createdAt"] = this.createdAt !== undefined ? this.createdAt : null as any;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["tripID"] = this.tripID !== undefined ? this.tripID : null as any;
        data["tripRowID"] = this.tripRowID !== undefined ? this.tripRowID : null as any;
        data["deleteAfter"] = this.deleteAfter !== undefined ? this.deleteAfter : null as any;
        return data;
    }
}

export interface ITaskLog {
    id?: number;
    operationType?: ETaskOperationType;
    starterProcess?: ETaskProcess;
    createdAt?: string;
    updatedAt?: string;
    status?: ETaskStatus;
    tripID?: number | null;
    tripRowID?: number | null;
    deleteAfter?: string | null;
}

export enum ETaskOperationType {
    PriceVerify = "PriceVerify",
    Booking = "Booking",
}

export enum ETaskProcess {
    API = "API",
    Pricer = "Pricer",
    Functions = "Functions",
    Lrt = "Lrt",
    Agent = "Agent",
    DataManager = "DataManager",
    CacheFiller = "CacheFiller",
}

export enum ETaskStatus {
    Ready = "Ready",
    Running = "Running",
    Ok = "Ok",
    Fail = "Fail",
}

export class TaskLogOperationInfo implements ITaskLogOperationInfo {
    hasAttachment?: boolean;
    id?: number;
    logOperation?: TaskLogOperation;
    attachment?: TaskLogAttachment | null;

    constructor(data?: ITaskLogOperationInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasAttachment = _data["hasAttachment"] !== undefined ? _data["hasAttachment"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.logOperation = _data["logOperation"] ? TaskLogOperation.fromJS(_data["logOperation"]) : null as any;
            this.attachment = _data["attachment"] ? TaskLogAttachment.fromJS(_data["attachment"]) : null as any;
        }
    }

    static fromJS(data: any): TaskLogOperationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TaskLogOperationInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasAttachment"] = this.hasAttachment !== undefined ? this.hasAttachment : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["logOperation"] = this.logOperation ? this.logOperation.toJSON() : null as any;
        data["attachment"] = this.attachment ? this.attachment.toJSON() : null as any;
        return data;
    }
}

export interface ITaskLogOperationInfo {
    hasAttachment?: boolean;
    id?: number;
    logOperation?: TaskLogOperation;
    attachment?: TaskLogAttachment | null;
}

export class TaskLogOperation implements ITaskLogOperation {
    id?: number;
    taskID?: number;
    tripID?: number | null;
    tripRowID?: number | null;
    date?: string;
    process?: ETaskProcess;
    level?: ETaskLogOperationLevel;
    name!: string;
    message?: string | null;
    filePath?: string | null;

    constructor(data?: ITaskLogOperation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.taskID = _data["taskID"] !== undefined ? _data["taskID"] : null as any;
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : null as any;
            this.tripRowID = _data["tripRowID"] !== undefined ? _data["tripRowID"] : null as any;
            this.date = _data["date"] !== undefined ? _data["date"] : null as any;
            this.process = _data["process"] !== undefined ? _data["process"] : null as any;
            this.level = _data["level"] !== undefined ? _data["level"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
            this.filePath = _data["filePath"] !== undefined ? _data["filePath"] : null as any;
        }
    }

    static fromJS(data: any): TaskLogOperation {
        data = typeof data === 'object' ? data : {};
        let result = new TaskLogOperation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["taskID"] = this.taskID !== undefined ? this.taskID : null as any;
        data["tripID"] = this.tripID !== undefined ? this.tripID : null as any;
        data["tripRowID"] = this.tripRowID !== undefined ? this.tripRowID : null as any;
        data["date"] = this.date !== undefined ? this.date : null as any;
        data["process"] = this.process !== undefined ? this.process : null as any;
        data["level"] = this.level !== undefined ? this.level : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        data["filePath"] = this.filePath !== undefined ? this.filePath : null as any;
        return data;
    }
}

export interface ITaskLogOperation {
    id?: number;
    taskID?: number;
    tripID?: number | null;
    tripRowID?: number | null;
    date?: string;
    process?: ETaskProcess;
    level?: ETaskLogOperationLevel;
    name: string;
    message?: string | null;
    filePath?: string | null;
}

export enum ETaskLogOperationLevel {
    Info = "Info",
    Warning = "Warning",
    Error = "Error",
}

export class TaskLogAttachment implements ITaskLogAttachment {
    filePath?: string | null;
    mimeType?: string | null;
    sizeBytes?: number;

    constructor(data?: ITaskLogAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filePath = _data["filePath"] !== undefined ? _data["filePath"] : null as any;
            this.mimeType = _data["mimeType"] !== undefined ? _data["mimeType"] : null as any;
            this.sizeBytes = _data["sizeBytes"] !== undefined ? _data["sizeBytes"] : null as any;
        }
    }

    static fromJS(data: any): TaskLogAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new TaskLogAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filePath"] = this.filePath !== undefined ? this.filePath : null as any;
        data["mimeType"] = this.mimeType !== undefined ? this.mimeType : null as any;
        data["sizeBytes"] = this.sizeBytes !== undefined ? this.sizeBytes : null as any;
        return data;
    }
}

export interface ITaskLogAttachment {
    filePath?: string | null;
    mimeType?: string | null;
    sizeBytes?: number;
}

export class GetTasksLogsRequest extends ApiRequest implements IGetTasksLogsRequest {
    /** Single log ID */
    logID?: number | null;
    /** Single trip ID */
    tripID?: number | null;
    /** Optional trip row ID */
    tripRowID?: number | null;

    constructor(data?: IGetTasksLogsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.logID = _data["logID"] !== undefined ? _data["logID"] : null as any;
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : null as any;
            this.tripRowID = _data["tripRowID"] !== undefined ? _data["tripRowID"] : null as any;
        }
    }

    static override fromJS(data: any): GetTasksLogsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTasksLogsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logID"] = this.logID !== undefined ? this.logID : null as any;
        data["tripID"] = this.tripID !== undefined ? this.tripID : null as any;
        data["tripRowID"] = this.tripRowID !== undefined ? this.tripRowID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTasksLogsRequest extends IApiRequest {
    /** Single log ID */
    logID?: number | null;
    /** Single trip ID */
    tripID?: number | null;
    /** Optional trip row ID */
    tripRowID?: number | null;
}

export class GetTaskLogAttachmentResponse extends OkApiResponse implements IGetTaskLogAttachmentResponse {
    attachmentContent?: string;

    constructor(data?: IGetTaskLogAttachmentResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.attachmentContent = _data["attachmentContent"] !== undefined ? _data["attachmentContent"] : null as any;
        }
    }

    static override fromJS(data: any): GetTaskLogAttachmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskLogAttachmentResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachmentContent"] = this.attachmentContent !== undefined ? this.attachmentContent : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTaskLogAttachmentResponse extends IOkApiResponse {
    attachmentContent?: string;
}

export class GetTaskLogAttachmentRequest extends ApiRequest implements IGetTaskLogAttachmentRequest {
    logID!: number;
    operationID!: number;

    constructor(data?: IGetTaskLogAttachmentRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.logID = _data["logID"] !== undefined ? _data["logID"] : null as any;
            this.operationID = _data["operationID"] !== undefined ? _data["operationID"] : null as any;
        }
    }

    static override fromJS(data: any): GetTaskLogAttachmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskLogAttachmentRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logID"] = this.logID !== undefined ? this.logID : null as any;
        data["operationID"] = this.operationID !== undefined ? this.operationID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTaskLogAttachmentRequest extends IApiRequest {
    logID: number;
    operationID: number;
}

export class TicketCreateResponse extends OkApiResponse implements ITicketCreateResponse {
    ticket?: ImportTicket | null;
    created?: boolean;

    constructor(data?: ITicketCreateResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ticket = _data["ticket"] ? ImportTicket.fromJS(_data["ticket"]) : null as any;
            this.created = _data["created"] !== undefined ? _data["created"] : null as any;
        }
    }

    static override fromJS(data: any): TicketCreateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TicketCreateResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticket"] = this.ticket ? this.ticket.toJSON() : null as any;
        data["created"] = this.created !== undefined ? this.created : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITicketCreateResponse extends IOkApiResponse {
    ticket?: ImportTicket | null;
    created?: boolean;
}

export class TicketCreateRequest extends ApiRequest implements ITicketCreateRequest {
    ticket?: ImportTicket | null;

    constructor(data?: ITicketCreateRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ticket = _data["ticket"] ? ImportTicket.fromJS(_data["ticket"]) : null as any;
        }
    }

    static override fromJS(data: any): TicketCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TicketCreateRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticket"] = this.ticket ? this.ticket.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITicketCreateRequest extends IApiRequest {
    ticket?: ImportTicket | null;
}

export class TranslationsAllResponse extends OkApiResponse implements ITranslationsAllResponse {
    total?: number;
    totalToTranslate?: number;
    totalTranslated?: number;

    constructor(data?: ITranslationsAllResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
            this.totalToTranslate = _data["totalToTranslate"] !== undefined ? _data["totalToTranslate"] : null as any;
            this.totalTranslated = _data["totalTranslated"] !== undefined ? _data["totalTranslated"] : null as any;
        }
    }

    static override fromJS(data: any): TranslationsAllResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsAllResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total !== undefined ? this.total : null as any;
        data["totalToTranslate"] = this.totalToTranslate !== undefined ? this.totalToTranslate : null as any;
        data["totalTranslated"] = this.totalTranslated !== undefined ? this.totalTranslated : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsAllResponse extends IOkApiResponse {
    total?: number;
    totalToTranslate?: number;
    totalTranslated?: number;
}

export class TranslationsAllRequest extends ApiRequest implements ITranslationsAllRequest {
    from?: ELingua;
    to?: ELingua;

    constructor(data?: ITranslationsAllRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.from = _data["from"] !== undefined ? _data["from"] : null as any;
            this.to = _data["to"] !== undefined ? _data["to"] : null as any;
        }
    }

    static override fromJS(data: any): TranslationsAllRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsAllRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from !== undefined ? this.from : null as any;
        data["to"] = this.to !== undefined ? this.to : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsAllRequest extends IApiRequest {
    from?: ELingua;
    to?: ELingua;
}

export class NrTableResponseOfTranslationsArticleRow extends OkApiResponse implements INrTableResponseOfTranslationsArticleRow {
    /** Array delle righe della pagina richiesta */
    rows?: TranslationsArticleRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfTranslationsArticleRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TranslationsArticleRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfTranslationsArticleRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfTranslationsArticleRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfTranslationsArticleRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: TranslationsArticleRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

/** Classe base per la RESPONSE della lista di traduzioni */
export class TranslationsListRow implements ITranslationsListRow {
    id?: number;
    title?: string | null;
    translations?: TranslationsListRowTranslation[];
    lastUpdate?: string | null;

    constructor(data?: ITranslationsListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(TranslationsListRowTranslation.fromJS(item));
            }
            else {
                this.translations = null as any;
            }
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : null as any;
        }
    }

    static fromJS(data: any): TranslationsListRow {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item ? item.toJSON() : null as any);
        }
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : null as any;
        return data;
    }
}

/** Classe base per la RESPONSE della lista di traduzioni */
export interface ITranslationsListRow {
    id?: number;
    title?: string | null;
    translations?: TranslationsListRowTranslation[];
    lastUpdate?: string | null;
}

export class TranslationsArticleRow extends TranslationsListRow implements ITranslationsArticleRow {
    originalTitle?: string | null;

    constructor(data?: ITranslationsArticleRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.originalTitle = _data["originalTitle"] !== undefined ? _data["originalTitle"] : null as any;
        }
    }

    static override fromJS(data: any): TranslationsArticleRow {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsArticleRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalTitle"] = this.originalTitle !== undefined ? this.originalTitle : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsArticleRow extends ITranslationsListRow {
    originalTitle?: string | null;
}

/** Traduzione di una riga della lista di traduzioni */
export class TranslationsListRowTranslation implements ITranslationsListRowTranslation {
    language?: ELingua;
    value?: string;
    update?: string | null;

    constructor(data?: ITranslationsListRowTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
            this.update = _data["update"] !== undefined ? _data["update"] : null as any;
        }
    }

    static fromJS(data: any): TranslationsListRowTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsListRowTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language !== undefined ? this.language : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["update"] = this.update !== undefined ? this.update : null as any;
        return data;
    }
}

/** Traduzione di una riga della lista di traduzioni */
export interface ITranslationsListRowTranslation {
    language?: ELingua;
    value?: string;
    update?: string | null;
}

/** Classe base per la REQUEST della lista di traduzioni */
export class TranslationsListRequest extends NrTableRequest implements ITranslationsListRequest {
    term?: string | null;
    text?: string | null;
    notTranslatedIn?: ELingua | null;
    lastLanguageUpdate?: TranslationsLastLanguageUpdate | null;
    automated?: boolean | null;
    toBeUpdatedIn?: ELingua | null;

    constructor(data?: ITranslationsListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : null as any;
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
            this.notTranslatedIn = _data["notTranslatedIn"] !== undefined ? _data["notTranslatedIn"] : null as any;
            this.lastLanguageUpdate = _data["lastLanguageUpdate"] ? TranslationsLastLanguageUpdate.fromJS(_data["lastLanguageUpdate"]) : null as any;
            this.automated = _data["automated"] !== undefined ? _data["automated"] : null as any;
            this.toBeUpdatedIn = _data["toBeUpdatedIn"] !== undefined ? _data["toBeUpdatedIn"] : null as any;
        }
    }

    static override fromJS(data: any): TranslationsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : null as any;
        data["text"] = this.text !== undefined ? this.text : null as any;
        data["notTranslatedIn"] = this.notTranslatedIn !== undefined ? this.notTranslatedIn : null as any;
        data["lastLanguageUpdate"] = this.lastLanguageUpdate ? this.lastLanguageUpdate.toJSON() : null as any;
        data["automated"] = this.automated !== undefined ? this.automated : null as any;
        data["toBeUpdatedIn"] = this.toBeUpdatedIn !== undefined ? this.toBeUpdatedIn : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Classe base per la REQUEST della lista di traduzioni */
export interface ITranslationsListRequest extends INrTableRequest {
    term?: string | null;
    text?: string | null;
    notTranslatedIn?: ELingua | null;
    lastLanguageUpdate?: TranslationsLastLanguageUpdate | null;
    automated?: boolean | null;
    toBeUpdatedIn?: ELingua | null;
}

/** Ultimo aggiornamento lingua per la REQUEST */
export class TranslationsLastLanguageUpdate implements ITranslationsLastLanguageUpdate {
    language?: ELingua | null;
    lastModify?: string | null;

    constructor(data?: ITranslationsLastLanguageUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
            this.lastModify = _data["lastModify"] !== undefined ? _data["lastModify"] : null as any;
        }
    }

    static fromJS(data: any): TranslationsLastLanguageUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsLastLanguageUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language !== undefined ? this.language : null as any;
        data["lastModify"] = this.lastModify !== undefined ? this.lastModify : null as any;
        return data;
    }
}

/** Ultimo aggiornamento lingua per la REQUEST */
export interface ITranslationsLastLanguageUpdate {
    language?: ELingua | null;
    lastModify?: string | null;
}

export class TranslationsArticlesTranslateResponse extends OkApiResponse implements ITranslationsArticlesTranslateResponse {
    translatedText?: string | null;
    translatedTitle?: string | null;
    language?: ELingua | null;

    constructor(data?: ITranslationsArticlesTranslateResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.translatedText = _data["translatedText"] !== undefined ? _data["translatedText"] : null as any;
            this.translatedTitle = _data["translatedTitle"] !== undefined ? _data["translatedTitle"] : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
        }
    }

    static override fromJS(data: any): TranslationsArticlesTranslateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsArticlesTranslateResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["translatedText"] = this.translatedText !== undefined ? this.translatedText : null as any;
        data["translatedTitle"] = this.translatedTitle !== undefined ? this.translatedTitle : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsArticlesTranslateResponse extends IOkApiResponse {
    translatedText?: string | null;
    translatedTitle?: string | null;
    language?: ELingua | null;
}

export class TranslationsArticlesTranslateRequest extends ApiRequest implements ITranslationsArticlesTranslateRequest {
    articleID?: number;
    from?: ELingua;
    to?: ELingua;

    constructor(data?: ITranslationsArticlesTranslateRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.articleID = _data["articleID"] !== undefined ? _data["articleID"] : null as any;
            this.from = _data["from"] !== undefined ? _data["from"] : null as any;
            this.to = _data["to"] !== undefined ? _data["to"] : null as any;
        }
    }

    static override fromJS(data: any): TranslationsArticlesTranslateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsArticlesTranslateRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleID"] = this.articleID !== undefined ? this.articleID : null as any;
        data["from"] = this.from !== undefined ? this.from : null as any;
        data["to"] = this.to !== undefined ? this.to : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsArticlesTranslateRequest extends IApiRequest {
    articleID?: number;
    from?: ELingua;
    to?: ELingua;
}

export class TranslationsArticlesTranslateTextResponse extends OkApiResponse implements ITranslationsArticlesTranslateTextResponse {
    translatedText?: string | null;
    translatedTitle?: string | null;
    language?: ELingua | null;

    constructor(data?: ITranslationsArticlesTranslateTextResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.translatedText = _data["translatedText"] !== undefined ? _data["translatedText"] : null as any;
            this.translatedTitle = _data["translatedTitle"] !== undefined ? _data["translatedTitle"] : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
        }
    }

    static override fromJS(data: any): TranslationsArticlesTranslateTextResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsArticlesTranslateTextResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["translatedText"] = this.translatedText !== undefined ? this.translatedText : null as any;
        data["translatedTitle"] = this.translatedTitle !== undefined ? this.translatedTitle : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsArticlesTranslateTextResponse extends IOkApiResponse {
    translatedText?: string | null;
    translatedTitle?: string | null;
    language?: ELingua | null;
}

export class TranslationsArticlesTranslateTextRequest extends ApiRequest implements ITranslationsArticlesTranslateTextRequest {
    title?: string;
    text?: string;
    from?: ELingua;
    to?: ELingua;

    constructor(data?: ITranslationsArticlesTranslateTextRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
            this.from = _data["from"] !== undefined ? _data["from"] : null as any;
            this.to = _data["to"] !== undefined ? _data["to"] : null as any;
        }
    }

    static override fromJS(data: any): TranslationsArticlesTranslateTextRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsArticlesTranslateTextRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["text"] = this.text !== undefined ? this.text : null as any;
        data["from"] = this.from !== undefined ? this.from : null as any;
        data["to"] = this.to !== undefined ? this.to : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsArticlesTranslateTextRequest extends IApiRequest {
    title?: string;
    text?: string;
    from?: ELingua;
    to?: ELingua;
}

export class NrTableResponseOfTranslationsLocationRow extends OkApiResponse implements INrTableResponseOfTranslationsLocationRow {
    /** Array delle righe della pagina richiesta */
    rows?: TranslationsLocationRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfTranslationsLocationRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TranslationsLocationRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfTranslationsLocationRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfTranslationsLocationRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfTranslationsLocationRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: TranslationsLocationRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class TranslationsLocationsListResponse extends NrTableResponseOfTranslationsLocationRow implements ITranslationsLocationsListResponse {

    constructor(data?: ITranslationsLocationsListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): TranslationsLocationsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsLocationsListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsLocationsListResponse extends INrTableResponseOfTranslationsLocationRow {
}

export class TranslationsLocationRow implements ITranslationsLocationRow {
    luogoID?: number;
    ultimoAggiornamento?: string | null;
    nome?: string | null;
    nomeInglese?: string | null;
    lingueDisponibili?: ELingua[] | null;
    traduzioni?: IWebTranslationEntity[];

    constructor(data?: ITranslationsLocationRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] !== undefined ? _data["ultimoAggiornamento"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nomeInglese = _data["nomeInglese"] !== undefined ? _data["nomeInglese"] : null as any;
            if (Array.isArray(_data["lingueDisponibili"])) {
                this.lingueDisponibili = [] as any;
                for (let item of _data["lingueDisponibili"])
                    this.lingueDisponibili!.push(item);
            }
            else {
                this.lingueDisponibili = null as any;
            }
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(IWebTranslationEntity.fromJS(item));
            }
            else {
                this.traduzioni = null as any;
            }
        }
    }

    static fromJS(data: any): TranslationsLocationRow {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsLocationRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["ultimoAggiornamento"] = this.ultimoAggiornamento !== undefined ? this.ultimoAggiornamento : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nomeInglese"] = this.nomeInglese !== undefined ? this.nomeInglese : null as any;
        if (Array.isArray(this.lingueDisponibili)) {
            data["lingueDisponibili"] = [];
            for (let item of this.lingueDisponibili)
                data["lingueDisponibili"].push(item);
        }
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ITranslationsLocationRow {
    luogoID?: number;
    ultimoAggiornamento?: string | null;
    nome?: string | null;
    nomeInglese?: string | null;
    lingueDisponibili?: ELingua[] | null;
    traduzioni?: IWebTranslationEntity[];
}

export class TranslationsLocationsListRequest extends NrTableRequest implements ITranslationsLocationsListRequest {
    term?: string | null;
    lastModify?: string | null;
    automated?: boolean | null;
    languageLastUpdate?: TranslationsLastLanguageUpdate | null;
    notTranslated?: ELingua | null;

    constructor(data?: ITranslationsLocationsListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : null as any;
            this.lastModify = _data["lastModify"] !== undefined ? _data["lastModify"] : null as any;
            this.automated = _data["automated"] !== undefined ? _data["automated"] : null as any;
            this.languageLastUpdate = _data["languageLastUpdate"] ? TranslationsLastLanguageUpdate.fromJS(_data["languageLastUpdate"]) : null as any;
            this.notTranslated = _data["notTranslated"] !== undefined ? _data["notTranslated"] : null as any;
        }
    }

    static override fromJS(data: any): TranslationsLocationsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsLocationsListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : null as any;
        data["lastModify"] = this.lastModify !== undefined ? this.lastModify : null as any;
        data["automated"] = this.automated !== undefined ? this.automated : null as any;
        data["languageLastUpdate"] = this.languageLastUpdate ? this.languageLastUpdate.toJSON() : null as any;
        data["notTranslated"] = this.notTranslated !== undefined ? this.notTranslated : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsLocationsListRequest extends INrTableRequest {
    term?: string | null;
    lastModify?: string | null;
    automated?: boolean | null;
    languageLastUpdate?: TranslationsLastLanguageUpdate | null;
    notTranslated?: ELingua | null;
}

export class NrTableResponseOfTranslationsPhraseRow extends OkApiResponse implements INrTableResponseOfTranslationsPhraseRow {
    /** Array delle righe della pagina richiesta */
    rows?: TranslationsPhraseRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfTranslationsPhraseRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TranslationsPhraseRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfTranslationsPhraseRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfTranslationsPhraseRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfTranslationsPhraseRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: TranslationsPhraseRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class TranslationsPhraseRow extends TranslationsListRow implements ITranslationsPhraseRow {
    text?: string | null;

    constructor(data?: ITranslationsPhraseRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
        }
    }

    static override fromJS(data: any): TranslationsPhraseRow {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsPhraseRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text !== undefined ? this.text : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsPhraseRow extends ITranslationsListRow {
    text?: string | null;
}

export class TranslationsPhrasesTranslateResponse extends OkApiResponse implements ITranslationsPhrasesTranslateResponse {
    translation?: string | null;
    language?: ELingua | null;

    constructor(data?: ITranslationsPhrasesTranslateResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.translation = _data["translation"] !== undefined ? _data["translation"] : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
        }
    }

    static override fromJS(data: any): TranslationsPhrasesTranslateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsPhrasesTranslateResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["translation"] = this.translation !== undefined ? this.translation : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsPhrasesTranslateResponse extends IOkApiResponse {
    translation?: string | null;
    language?: ELingua | null;
}

export class TranslationsPhrasesTranslateRequest extends ApiRequest implements ITranslationsPhrasesTranslateRequest {
    phraseID?: number;
    from?: ELingua;
    to?: ELingua;

    constructor(data?: ITranslationsPhrasesTranslateRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phraseID = _data["phraseID"] !== undefined ? _data["phraseID"] : null as any;
            this.from = _data["from"] !== undefined ? _data["from"] : null as any;
            this.to = _data["to"] !== undefined ? _data["to"] : null as any;
        }
    }

    static override fromJS(data: any): TranslationsPhrasesTranslateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsPhrasesTranslateRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phraseID"] = this.phraseID !== undefined ? this.phraseID : null as any;
        data["from"] = this.from !== undefined ? this.from : null as any;
        data["to"] = this.to !== undefined ? this.to : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsPhrasesTranslateRequest extends IApiRequest {
    phraseID?: number;
    from?: ELingua;
    to?: ELingua;
}

export class TranslationsPhrasesTranslateTextResponse extends OkApiResponse implements ITranslationsPhrasesTranslateTextResponse {
    translation?: string | null;
    language?: ELingua | null;

    constructor(data?: ITranslationsPhrasesTranslateTextResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.translation = _data["translation"] !== undefined ? _data["translation"] : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
        }
    }

    static override fromJS(data: any): TranslationsPhrasesTranslateTextResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsPhrasesTranslateTextResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["translation"] = this.translation !== undefined ? this.translation : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsPhrasesTranslateTextResponse extends IOkApiResponse {
    translation?: string | null;
    language?: ELingua | null;
}

export class TranslationsPhrasesTranslateTextRequest extends ApiRequest implements ITranslationsPhrasesTranslateTextRequest {
    text?: string;
    from?: ELingua;
    to?: ELingua;

    constructor(data?: ITranslationsPhrasesTranslateTextRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
            this.from = _data["from"] !== undefined ? _data["from"] : null as any;
            this.to = _data["to"] !== undefined ? _data["to"] : null as any;
        }
    }

    static override fromJS(data: any): TranslationsPhrasesTranslateTextRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsPhrasesTranslateTextRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text !== undefined ? this.text : null as any;
        data["from"] = this.from !== undefined ? this.from : null as any;
        data["to"] = this.to !== undefined ? this.to : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsPhrasesTranslateTextRequest extends IApiRequest {
    text?: string;
    from?: ELingua;
    to?: ELingua;
}

export class NrTableResponseOfTranslationsServicesRow extends OkApiResponse implements INrTableResponseOfTranslationsServicesRow {
    /** Array delle righe della pagina richiesta */
    rows?: TranslationsServicesRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfTranslationsServicesRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TranslationsServicesRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfTranslationsServicesRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfTranslationsServicesRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfTranslationsServicesRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: TranslationsServicesRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class TranslationsServicesListResponse extends NrTableResponseOfTranslationsServicesRow implements ITranslationsServicesListResponse {

    constructor(data?: ITranslationsServicesListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): TranslationsServicesListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsServicesListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsServicesListResponse extends INrTableResponseOfTranslationsServicesRow {
}

export class TranslationsServicesRow implements ITranslationsServicesRow {
    servizioID?: number;
    ultimoAggiornamento?: string | null;
    nome?: string | null;
    nomeInglese?: string | null;
    lingueDisponibili?: ELingua[] | null;
    traduzioni?: IWebTranslationEntity[];

    constructor(data?: ITranslationsServicesRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] !== undefined ? _data["ultimoAggiornamento"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nomeInglese = _data["nomeInglese"] !== undefined ? _data["nomeInglese"] : null as any;
            if (Array.isArray(_data["lingueDisponibili"])) {
                this.lingueDisponibili = [] as any;
                for (let item of _data["lingueDisponibili"])
                    this.lingueDisponibili!.push(item);
            }
            else {
                this.lingueDisponibili = null as any;
            }
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(IWebTranslationEntity.fromJS(item));
            }
            else {
                this.traduzioni = null as any;
            }
        }
    }

    static fromJS(data: any): TranslationsServicesRow {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsServicesRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["ultimoAggiornamento"] = this.ultimoAggiornamento !== undefined ? this.ultimoAggiornamento : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nomeInglese"] = this.nomeInglese !== undefined ? this.nomeInglese : null as any;
        if (Array.isArray(this.lingueDisponibili)) {
            data["lingueDisponibili"] = [];
            for (let item of this.lingueDisponibili)
                data["lingueDisponibili"].push(item);
        }
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ITranslationsServicesRow {
    servizioID?: number;
    ultimoAggiornamento?: string | null;
    nome?: string | null;
    nomeInglese?: string | null;
    lingueDisponibili?: ELingua[] | null;
    traduzioni?: IWebTranslationEntity[];
}

export class TranslationsServicesListRequest extends NrTableRequest implements ITranslationsServicesListRequest {
    term?: string | null;
    lastModify?: string | null;
    automated?: boolean | null;
    languageLastUpdate?: TranslationsLastLanguageUpdate | null;
    notTranslated?: ELingua | null;

    constructor(data?: ITranslationsServicesListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : null as any;
            this.lastModify = _data["lastModify"] !== undefined ? _data["lastModify"] : null as any;
            this.automated = _data["automated"] !== undefined ? _data["automated"] : null as any;
            this.languageLastUpdate = _data["languageLastUpdate"] ? TranslationsLastLanguageUpdate.fromJS(_data["languageLastUpdate"]) : null as any;
            this.notTranslated = _data["notTranslated"] !== undefined ? _data["notTranslated"] : null as any;
        }
    }

    static override fromJS(data: any): TranslationsServicesListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsServicesListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : null as any;
        data["lastModify"] = this.lastModify !== undefined ? this.lastModify : null as any;
        data["automated"] = this.automated !== undefined ? this.automated : null as any;
        data["languageLastUpdate"] = this.languageLastUpdate ? this.languageLastUpdate.toJSON() : null as any;
        data["notTranslated"] = this.notTranslated !== undefined ? this.notTranslated : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsServicesListRequest extends INrTableRequest {
    term?: string | null;
    lastModify?: string | null;
    automated?: boolean | null;
    languageLastUpdate?: TranslationsLastLanguageUpdate | null;
    notTranslated?: ELingua | null;
}

export class TranslationsServiceTranslateResponse extends OkApiResponse implements ITranslationsServiceTranslateResponse {
    translation?: string | null;
    language?: ELingua | null;

    constructor(data?: ITranslationsServiceTranslateResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.translation = _data["translation"] !== undefined ? _data["translation"] : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
        }
    }

    static override fromJS(data: any): TranslationsServiceTranslateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsServiceTranslateResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["translation"] = this.translation !== undefined ? this.translation : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsServiceTranslateResponse extends IOkApiResponse {
    translation?: string | null;
    language?: ELingua | null;
}

export class TranslationsServiceTranslateRequest extends ApiRequest implements ITranslationsServiceTranslateRequest {
    serviceID?: number;
    from?: ELingua;
    to?: ELingua;

    constructor(data?: ITranslationsServiceTranslateRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.serviceID = _data["serviceID"] !== undefined ? _data["serviceID"] : null as any;
            this.from = _data["from"] !== undefined ? _data["from"] : null as any;
            this.to = _data["to"] !== undefined ? _data["to"] : null as any;
        }
    }

    static override fromJS(data: any): TranslationsServiceTranslateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsServiceTranslateRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceID"] = this.serviceID !== undefined ? this.serviceID : null as any;
        data["from"] = this.from !== undefined ? this.from : null as any;
        data["to"] = this.to !== undefined ? this.to : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsServiceTranslateRequest extends IApiRequest {
    serviceID?: number;
    from?: ELingua;
    to?: ELingua;
}

export class TranslationsTranslateResponse extends OkApiResponse implements ITranslationsTranslateResponse {
    translation?: string | null;
    language?: ELingua | null;

    constructor(data?: ITranslationsTranslateResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.translation = _data["translation"] !== undefined ? _data["translation"] : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
        }
    }

    static override fromJS(data: any): TranslationsTranslateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsTranslateResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["translation"] = this.translation !== undefined ? this.translation : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsTranslateResponse extends IOkApiResponse {
    translation?: string | null;
    language?: ELingua | null;
}

export class TranslationsTranslateRequest extends ApiRequest implements ITranslationsTranslateRequest {
    message?: string;
    from?: ELingua;
    to?: ELingua;

    constructor(data?: ITranslationsTranslateRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
            this.from = _data["from"] !== undefined ? _data["from"] : null as any;
            this.to = _data["to"] !== undefined ? _data["to"] : null as any;
        }
    }

    static override fromJS(data: any): TranslationsTranslateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsTranslateRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : null as any;
        data["from"] = this.from !== undefined ? this.from : null as any;
        data["to"] = this.to !== undefined ? this.to : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsTranslateRequest extends IApiRequest {
    message?: string;
    from?: ELingua;
    to?: ELingua;
}

export class WebTranslatableGetResponse extends OkApiResponse implements IWebTranslatableGetResponse {
    nome?: string | null;
    nome_en?: string | null;
    traduzioni?: IWebTranslationEntity[] | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean | null;
    confirmed_en?: boolean | null;

    constructor(data?: IWebTranslatableGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : null as any;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(IWebTranslationEntity.fromJS(item));
            }
            else {
                this.traduzioni = null as any;
            }
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : null as any;
            this.lastUpdate_en = _data["lastUpdate_en"] !== undefined ? _data["lastUpdate_en"] : null as any;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : null as any;
            this.confirmed_en = _data["confirmed_en"] !== undefined ? _data["confirmed_en"] : null as any;
        }
    }

    static override fromJS(data: any): WebTranslatableGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WebTranslatableGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : null as any;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item ? item.toJSON() : null as any);
        }
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : null as any;
        data["lastUpdate_en"] = this.lastUpdate_en !== undefined ? this.lastUpdate_en : null as any;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : null as any;
        data["confirmed_en"] = this.confirmed_en !== undefined ? this.confirmed_en : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IWebTranslatableGetResponse extends IOkApiResponse {
    nome?: string | null;
    nome_en?: string | null;
    traduzioni?: IWebTranslationEntity[] | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean | null;
    confirmed_en?: boolean | null;
}

export class WebTranslatableGetRequest extends LocalizedRequest implements IWebTranslatableGetRequest {
    id?: number;
    table?: string | null;

    constructor(data?: IWebTranslatableGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.table = _data["table"] !== undefined ? _data["table"] : null as any;
        }
    }

    static override fromJS(data: any): WebTranslatableGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WebTranslatableGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["table"] = this.table !== undefined ? this.table : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IWebTranslatableGetRequest extends ILocalizedRequest {
    id?: number;
    table?: string | null;
}

export class NrTableResponseOfAPI_Website_translationsGetRow extends OkApiResponse implements INrTableResponseOfAPI_Website_translationsGetRow {
    /** Array delle righe della pagina richiesta */
    rows?: API_Website_translationsGetRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfAPI_Website_translationsGetRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(API_Website_translationsGetRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfAPI_Website_translationsGetRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfAPI_Website_translationsGetRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfAPI_Website_translationsGetRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: API_Website_translationsGetRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class API_Website_translationsGetRow implements IAPI_Website_translationsGetRow {
    id?: number;
    category?: string | null;
    englishName?: string | null;
    translated?: number;
    languageName?: string | null;
    info?: string | null;
    dateUpdated?: string | null;
    dateUpdatedLingua?: string | null;
    isTranslated?: boolean;

    constructor(data?: IAPI_Website_translationsGetRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.englishName = _data["englishName"] !== undefined ? _data["englishName"] : null as any;
            this.translated = _data["translated"] !== undefined ? _data["translated"] : null as any;
            this.languageName = _data["languageName"] !== undefined ? _data["languageName"] : null as any;
            this.info = _data["info"] !== undefined ? _data["info"] : null as any;
            this.dateUpdated = _data["dateUpdated"] !== undefined ? _data["dateUpdated"] : null as any;
            this.dateUpdatedLingua = _data["dateUpdatedLingua"] !== undefined ? _data["dateUpdatedLingua"] : null as any;
            this.isTranslated = _data["isTranslated"] !== undefined ? _data["isTranslated"] : null as any;
        }
    }

    static fromJS(data: any): API_Website_translationsGetRow {
        data = typeof data === 'object' ? data : {};
        let result = new API_Website_translationsGetRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["englishName"] = this.englishName !== undefined ? this.englishName : null as any;
        data["translated"] = this.translated !== undefined ? this.translated : null as any;
        data["languageName"] = this.languageName !== undefined ? this.languageName : null as any;
        data["info"] = this.info !== undefined ? this.info : null as any;
        data["dateUpdated"] = this.dateUpdated !== undefined ? this.dateUpdated : null as any;
        data["dateUpdatedLingua"] = this.dateUpdatedLingua !== undefined ? this.dateUpdatedLingua : null as any;
        data["isTranslated"] = this.isTranslated !== undefined ? this.isTranslated : null as any;
        return data;
    }
}

export interface IAPI_Website_translationsGetRow {
    id?: number;
    category?: string | null;
    englishName?: string | null;
    translated?: number;
    languageName?: string | null;
    info?: string | null;
    dateUpdated?: string | null;
    dateUpdatedLingua?: string | null;
    isTranslated?: boolean;
}

/** for LUOGHI, SERVIZI, DATI_AGG_SERVIZI show places entity and set @idluogo for LUOGHI, SERVIZI show countries entities and set @idpaese for LUOGHI show placetypes entities and set @idcategory for SERVIZI show servicetype entities and set @idcategory */
export class WebTranslatableListRequest extends NrTableRequest implements IWebTranslatableListRequest {
    tableName?: string;
    text?: string;
    language?: ELingua;
    toBeUpdated?: boolean;
    idLocation?: number | null;
    idCountry?: number | null;
    idCategory?: number | null;

    constructor(data?: IWebTranslatableListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tableName = _data["tableName"] !== undefined ? _data["tableName"] : null as any;
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
            this.toBeUpdated = _data["toBeUpdated"] !== undefined ? _data["toBeUpdated"] : null as any;
            this.idLocation = _data["idLocation"] !== undefined ? _data["idLocation"] : null as any;
            this.idCountry = _data["idCountry"] !== undefined ? _data["idCountry"] : null as any;
            this.idCategory = _data["idCategory"] !== undefined ? _data["idCategory"] : null as any;
        }
    }

    static override fromJS(data: any): WebTranslatableListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WebTranslatableListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName !== undefined ? this.tableName : null as any;
        data["text"] = this.text !== undefined ? this.text : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        data["toBeUpdated"] = this.toBeUpdated !== undefined ? this.toBeUpdated : null as any;
        data["idLocation"] = this.idLocation !== undefined ? this.idLocation : null as any;
        data["idCountry"] = this.idCountry !== undefined ? this.idCountry : null as any;
        data["idCategory"] = this.idCategory !== undefined ? this.idCategory : null as any;
        super.toJSON(data);
        return data;
    }
}

/** for LUOGHI, SERVIZI, DATI_AGG_SERVIZI show places entity and set @idluogo for LUOGHI, SERVIZI show countries entities and set @idpaese for LUOGHI show placetypes entities and set @idcategory for SERVIZI show servicetype entities and set @idcategory */
export interface IWebTranslatableListRequest extends INrTableRequest {
    tableName?: string;
    text?: string;
    language?: ELingua;
    toBeUpdated?: boolean;
    idLocation?: number | null;
    idCountry?: number | null;
    idCategory?: number | null;
}

export class WebTranslatableUpdateRequest extends LocalizedRequest implements IWebTranslatableUpdateRequest {
    id?: number;
    table?: string | null;
    nome?: string | null;
    nome_en?: string | null;
    confirmed_en?: boolean | null;
    traduzioni?: WebTranslation[] | null;

    constructor(data?: IWebTranslatableUpdateRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.table = _data["table"] !== undefined ? _data["table"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : null as any;
            this.confirmed_en = _data["confirmed_en"] !== undefined ? _data["confirmed_en"] : null as any;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(WebTranslation.fromJS(item));
            }
            else {
                this.traduzioni = null as any;
            }
        }
    }

    static override fromJS(data: any): WebTranslatableUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WebTranslatableUpdateRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["table"] = this.table !== undefined ? this.table : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : null as any;
        data["confirmed_en"] = this.confirmed_en !== undefined ? this.confirmed_en : null as any;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IWebTranslatableUpdateRequest extends ILocalizedRequest {
    id?: number;
    table?: string | null;
    nome?: string | null;
    nome_en?: string | null;
    confirmed_en?: boolean | null;
    traduzioni?: WebTranslation[] | null;
}

export class AddCameraHashcodeRequest extends TripGetRequest implements IAddCameraHashcodeRequest {
    dati!: string;
    /** ID della tappa */
    stepID?: number;

    constructor(data?: IAddCameraHashcodeRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dati = _data["dati"] !== undefined ? _data["dati"] : null as any;
            this.stepID = _data["stepID"] !== undefined ? _data["stepID"] : null as any;
        }
    }

    static override fromJS(data: any): AddCameraHashcodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddCameraHashcodeRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dati"] = this.dati !== undefined ? this.dati : null as any;
        data["stepID"] = this.stepID !== undefined ? this.stepID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAddCameraHashcodeRequest extends ITripGetRequest {
    dati: string;
    /** ID della tappa */
    stepID?: number;
}

export class AddServiziRequest extends TripGetRequest implements IAddServiziRequest {
    /** Servizi i cui search data sono da recuperare dal pricer */
    servizi?: DatiServizioAdd[] | null;
    /** Servizi i cui search data siano già noti */
    serviziSearch?: ServizioDaAggiungere[] | null;

    constructor(data?: IAddServiziRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(DatiServizioAdd.fromJS(item));
            }
            else {
                this.servizi = null as any;
            }
            if (Array.isArray(_data["serviziSearch"])) {
                this.serviziSearch = [] as any;
                for (let item of _data["serviziSearch"])
                    this.serviziSearch!.push(ServizioDaAggiungere.fromJS(item));
            }
            else {
                this.serviziSearch = null as any;
            }
        }
    }

    static override fromJS(data: any): AddServiziRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddServiziRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.serviziSearch)) {
            data["serviziSearch"] = [];
            for (let item of this.serviziSearch)
                data["serviziSearch"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAddServiziRequest extends ITripGetRequest {
    /** Servizi i cui search data sono da recuperare dal pricer */
    servizi?: DatiServizioAdd[] | null;
    /** Servizi i cui search data siano già noti */
    serviziSearch?: ServizioDaAggiungere[] | null;
}

export class ServizioDaAggiungere implements IServizioDaAggiungere {
    bufferDati?: string | null;
    dati?: ServiceSearchData | null;
    tappaID?: number;
    clienteID?: number | null;
    supplementi?: ServizioDaAggiungere[] | null;
    paxIds?: number[] | null;
    nomeGruppoCustom?: string | null;
    usaHashcode?: boolean;

    constructor(data?: IServizioDaAggiungere) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bufferDati = _data["bufferDati"] !== undefined ? _data["bufferDati"] : null as any;
            this.dati = _data["dati"] ? ServiceSearchData.fromJS(_data["dati"]) : null as any;
            this.tappaID = _data["tappaID"] !== undefined ? _data["tappaID"] : null as any;
            this.clienteID = _data["clienteID"] !== undefined ? _data["clienteID"] : null as any;
            if (Array.isArray(_data["supplementi"])) {
                this.supplementi = [] as any;
                for (let item of _data["supplementi"])
                    this.supplementi!.push(ServizioDaAggiungere.fromJS(item));
            }
            else {
                this.supplementi = null as any;
            }
            if (Array.isArray(_data["paxIds"])) {
                this.paxIds = [] as any;
                for (let item of _data["paxIds"])
                    this.paxIds!.push(item);
            }
            else {
                this.paxIds = null as any;
            }
            this.nomeGruppoCustom = _data["nomeGruppoCustom"] !== undefined ? _data["nomeGruppoCustom"] : null as any;
            this.usaHashcode = _data["usaHashcode"] !== undefined ? _data["usaHashcode"] : null as any;
        }
    }

    static fromJS(data: any): ServizioDaAggiungere {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioDaAggiungere();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bufferDati"] = this.bufferDati !== undefined ? this.bufferDati : null as any;
        data["dati"] = this.dati ? this.dati.toJSON() : null as any;
        data["tappaID"] = this.tappaID !== undefined ? this.tappaID : null as any;
        data["clienteID"] = this.clienteID !== undefined ? this.clienteID : null as any;
        if (Array.isArray(this.supplementi)) {
            data["supplementi"] = [];
            for (let item of this.supplementi)
                data["supplementi"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.paxIds)) {
            data["paxIds"] = [];
            for (let item of this.paxIds)
                data["paxIds"].push(item);
        }
        data["nomeGruppoCustom"] = this.nomeGruppoCustom !== undefined ? this.nomeGruppoCustom : null as any;
        data["usaHashcode"] = this.usaHashcode !== undefined ? this.usaHashcode : null as any;
        return data;
    }
}

export interface IServizioDaAggiungere {
    bufferDati?: string | null;
    dati?: ServiceSearchData | null;
    tappaID?: number;
    clienteID?: number | null;
    supplementi?: ServizioDaAggiungere[] | null;
    paxIds?: number[] | null;
    nomeGruppoCustom?: string | null;
    usaHashcode?: boolean;
}

export class ServiceSearchData implements IServiceSearchData {
    gruppoID?: number;
    dataInizio?: string;
    servizioID?: number;
    servizioTipologiaID?: number;
    servizioTipologiaParentID?: number;
    beddingID?: number | null;
    quantita?: number;
    accordoID?: number;
    servizioFornitoreID?: number;
    codPrenotazione?: string | null;
    trattamentoID?: number;
    supplemento?: boolean;
    prezzo?: number;
    costo?: number;
    maxEta?: number;
    numeroPax?: number;
    tabAllotmentID?: number;
    disponibilita?: number;
    costoID?: number;
    tabellaCostoID?: number;
    fornitoreID?: number;
    numeroChild?: number;
    prezzoChild?: number;
    costoChild?: number;
    descrizione?: string | null;
    descrizioneFornitore?: string | null;
    notRefundable?: boolean;
    instantPurchase?: boolean;
    weddingRate?: boolean;
    penaleID?: number;
    hasFurtherInfo?: boolean;
    offerte?: DisponibilitaTipologiaOfferta[] | null;
    opzioni?: ServiceSearchSupplement[] | null;
    paxIDs?: number[] | null;
    dataFine?: string;
    luogoDestinazioneID?: number | null;
    luogoID?: number;
    tipoServizio?: ETipoServizioSearch;
    nota?: string | null;
    notaAgenzia?: string | null;
    notFound?: boolean;
    providerCustomData?: string | null;
    dataPenale?: string | null;
    importoPenale?: number | null;
    articoloPenaleID?: number | null;
    supplementi?: DisponibilitaSupplemento[] | null;
    supplementiAlt?: Supplemento[] | null;
    hashCode?: string | null;
    descrizioneHashCode?: string | null;
    supplementiDaInserire?: ServiceSearchData[] | null;
    servizioH2hID?: number | null;
    qualifier?: string | null;

    constructor(data?: IServiceSearchData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gruppoID = _data["gruppoID"] !== undefined ? _data["gruppoID"] : null as any;
            this.dataInizio = _data["dataInizio"] !== undefined ? _data["dataInizio"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.servizioTipologiaID = _data["servizioTipologiaID"] !== undefined ? _data["servizioTipologiaID"] : null as any;
            this.servizioTipologiaParentID = _data["servizioTipologiaParentID"] !== undefined ? _data["servizioTipologiaParentID"] : null as any;
            this.beddingID = _data["beddingID"] !== undefined ? _data["beddingID"] : null as any;
            this.quantita = _data["quantita"] !== undefined ? _data["quantita"] : null as any;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : null as any;
            this.servizioFornitoreID = _data["servizioFornitoreID"] !== undefined ? _data["servizioFornitoreID"] : null as any;
            this.codPrenotazione = _data["codPrenotazione"] !== undefined ? _data["codPrenotazione"] : null as any;
            this.trattamentoID = _data["trattamentoID"] !== undefined ? _data["trattamentoID"] : null as any;
            this.supplemento = _data["supplemento"] !== undefined ? _data["supplemento"] : null as any;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : null as any;
            this.costo = _data["costo"] !== undefined ? _data["costo"] : null as any;
            this.maxEta = _data["maxEta"] !== undefined ? _data["maxEta"] : null as any;
            this.numeroPax = _data["numeroPax"] !== undefined ? _data["numeroPax"] : null as any;
            this.tabAllotmentID = _data["tabAllotmentID"] !== undefined ? _data["tabAllotmentID"] : null as any;
            this.disponibilita = _data["disponibilita"] !== undefined ? _data["disponibilita"] : null as any;
            this.costoID = _data["costoID"] !== undefined ? _data["costoID"] : null as any;
            this.tabellaCostoID = _data["tabellaCostoID"] !== undefined ? _data["tabellaCostoID"] : null as any;
            this.fornitoreID = _data["fornitoreID"] !== undefined ? _data["fornitoreID"] : null as any;
            this.numeroChild = _data["numeroChild"] !== undefined ? _data["numeroChild"] : null as any;
            this.prezzoChild = _data["prezzoChild"] !== undefined ? _data["prezzoChild"] : null as any;
            this.costoChild = _data["costoChild"] !== undefined ? _data["costoChild"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.descrizioneFornitore = _data["descrizioneFornitore"] !== undefined ? _data["descrizioneFornitore"] : null as any;
            this.notRefundable = _data["notRefundable"] !== undefined ? _data["notRefundable"] : null as any;
            this.instantPurchase = _data["instantPurchase"] !== undefined ? _data["instantPurchase"] : null as any;
            this.weddingRate = _data["weddingRate"] !== undefined ? _data["weddingRate"] : null as any;
            this.penaleID = _data["penaleID"] !== undefined ? _data["penaleID"] : null as any;
            this.hasFurtherInfo = _data["hasFurtherInfo"] !== undefined ? _data["hasFurtherInfo"] : null as any;
            if (Array.isArray(_data["offerte"])) {
                this.offerte = [] as any;
                for (let item of _data["offerte"])
                    this.offerte!.push(DisponibilitaTipologiaOfferta.fromJS(item));
            }
            else {
                this.offerte = null as any;
            }
            if (Array.isArray(_data["opzioni"])) {
                this.opzioni = [] as any;
                for (let item of _data["opzioni"])
                    this.opzioni!.push(ServiceSearchSupplement.fromJS(item));
            }
            else {
                this.opzioni = null as any;
            }
            if (Array.isArray(_data["paxIDs"])) {
                this.paxIDs = [] as any;
                for (let item of _data["paxIDs"])
                    this.paxIDs!.push(item);
            }
            else {
                this.paxIDs = null as any;
            }
            this.dataFine = _data["dataFine"] !== undefined ? _data["dataFine"] : null as any;
            this.luogoDestinazioneID = _data["luogoDestinazioneID"] !== undefined ? _data["luogoDestinazioneID"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : null as any;
            this.nota = _data["nota"] !== undefined ? _data["nota"] : null as any;
            this.notaAgenzia = _data["notaAgenzia"] !== undefined ? _data["notaAgenzia"] : null as any;
            this.notFound = _data["notFound"] !== undefined ? _data["notFound"] : null as any;
            this.providerCustomData = _data["providerCustomData"] !== undefined ? _data["providerCustomData"] : null as any;
            this.dataPenale = _data["dataPenale"] !== undefined ? _data["dataPenale"] : null as any;
            this.importoPenale = _data["importoPenale"] !== undefined ? _data["importoPenale"] : null as any;
            this.articoloPenaleID = _data["articoloPenaleID"] !== undefined ? _data["articoloPenaleID"] : null as any;
            if (Array.isArray(_data["supplementi"])) {
                this.supplementi = [] as any;
                for (let item of _data["supplementi"])
                    this.supplementi!.push(DisponibilitaSupplemento.fromJS(item));
            }
            else {
                this.supplementi = null as any;
            }
            if (Array.isArray(_data["supplementiAlt"])) {
                this.supplementiAlt = [] as any;
                for (let item of _data["supplementiAlt"])
                    this.supplementiAlt!.push(Supplemento.fromJS(item));
            }
            else {
                this.supplementiAlt = null as any;
            }
            this.hashCode = _data["hashCode"] !== undefined ? _data["hashCode"] : null as any;
            this.descrizioneHashCode = _data["descrizioneHashCode"] !== undefined ? _data["descrizioneHashCode"] : null as any;
            if (Array.isArray(_data["supplementiDaInserire"])) {
                this.supplementiDaInserire = [] as any;
                for (let item of _data["supplementiDaInserire"])
                    this.supplementiDaInserire!.push(ServiceSearchData.fromJS(item));
            }
            else {
                this.supplementiDaInserire = null as any;
            }
            this.servizioH2hID = _data["servizioH2hID"] !== undefined ? _data["servizioH2hID"] : null as any;
            this.qualifier = _data["qualifier"] !== undefined ? _data["qualifier"] : null as any;
        }
    }

    static fromJS(data: any): ServiceSearchData {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceSearchData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gruppoID"] = this.gruppoID !== undefined ? this.gruppoID : null as any;
        data["dataInizio"] = this.dataInizio !== undefined ? this.dataInizio : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["servizioTipologiaID"] = this.servizioTipologiaID !== undefined ? this.servizioTipologiaID : null as any;
        data["servizioTipologiaParentID"] = this.servizioTipologiaParentID !== undefined ? this.servizioTipologiaParentID : null as any;
        data["beddingID"] = this.beddingID !== undefined ? this.beddingID : null as any;
        data["quantita"] = this.quantita !== undefined ? this.quantita : null as any;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : null as any;
        data["servizioFornitoreID"] = this.servizioFornitoreID !== undefined ? this.servizioFornitoreID : null as any;
        data["codPrenotazione"] = this.codPrenotazione !== undefined ? this.codPrenotazione : null as any;
        data["trattamentoID"] = this.trattamentoID !== undefined ? this.trattamentoID : null as any;
        data["supplemento"] = this.supplemento !== undefined ? this.supplemento : null as any;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : null as any;
        data["costo"] = this.costo !== undefined ? this.costo : null as any;
        data["maxEta"] = this.maxEta !== undefined ? this.maxEta : null as any;
        data["numeroPax"] = this.numeroPax !== undefined ? this.numeroPax : null as any;
        data["tabAllotmentID"] = this.tabAllotmentID !== undefined ? this.tabAllotmentID : null as any;
        data["disponibilita"] = this.disponibilita !== undefined ? this.disponibilita : null as any;
        data["costoID"] = this.costoID !== undefined ? this.costoID : null as any;
        data["tabellaCostoID"] = this.tabellaCostoID !== undefined ? this.tabellaCostoID : null as any;
        data["fornitoreID"] = this.fornitoreID !== undefined ? this.fornitoreID : null as any;
        data["numeroChild"] = this.numeroChild !== undefined ? this.numeroChild : null as any;
        data["prezzoChild"] = this.prezzoChild !== undefined ? this.prezzoChild : null as any;
        data["costoChild"] = this.costoChild !== undefined ? this.costoChild : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["descrizioneFornitore"] = this.descrizioneFornitore !== undefined ? this.descrizioneFornitore : null as any;
        data["notRefundable"] = this.notRefundable !== undefined ? this.notRefundable : null as any;
        data["instantPurchase"] = this.instantPurchase !== undefined ? this.instantPurchase : null as any;
        data["weddingRate"] = this.weddingRate !== undefined ? this.weddingRate : null as any;
        data["penaleID"] = this.penaleID !== undefined ? this.penaleID : null as any;
        data["hasFurtherInfo"] = this.hasFurtherInfo !== undefined ? this.hasFurtherInfo : null as any;
        if (Array.isArray(this.offerte)) {
            data["offerte"] = [];
            for (let item of this.offerte)
                data["offerte"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.opzioni)) {
            data["opzioni"] = [];
            for (let item of this.opzioni)
                data["opzioni"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.paxIDs)) {
            data["paxIDs"] = [];
            for (let item of this.paxIDs)
                data["paxIDs"].push(item);
        }
        data["dataFine"] = this.dataFine !== undefined ? this.dataFine : null as any;
        data["luogoDestinazioneID"] = this.luogoDestinazioneID !== undefined ? this.luogoDestinazioneID : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : null as any;
        data["nota"] = this.nota !== undefined ? this.nota : null as any;
        data["notaAgenzia"] = this.notaAgenzia !== undefined ? this.notaAgenzia : null as any;
        data["notFound"] = this.notFound !== undefined ? this.notFound : null as any;
        data["providerCustomData"] = this.providerCustomData !== undefined ? this.providerCustomData : null as any;
        data["dataPenale"] = this.dataPenale !== undefined ? this.dataPenale : null as any;
        data["importoPenale"] = this.importoPenale !== undefined ? this.importoPenale : null as any;
        data["articoloPenaleID"] = this.articoloPenaleID !== undefined ? this.articoloPenaleID : null as any;
        if (Array.isArray(this.supplementi)) {
            data["supplementi"] = [];
            for (let item of this.supplementi)
                data["supplementi"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.supplementiAlt)) {
            data["supplementiAlt"] = [];
            for (let item of this.supplementiAlt)
                data["supplementiAlt"].push(item ? item.toJSON() : null as any);
        }
        data["hashCode"] = this.hashCode !== undefined ? this.hashCode : null as any;
        data["descrizioneHashCode"] = this.descrizioneHashCode !== undefined ? this.descrizioneHashCode : null as any;
        if (Array.isArray(this.supplementiDaInserire)) {
            data["supplementiDaInserire"] = [];
            for (let item of this.supplementiDaInserire)
                data["supplementiDaInserire"].push(item ? item.toJSON() : null as any);
        }
        data["servizioH2hID"] = this.servizioH2hID !== undefined ? this.servizioH2hID : null as any;
        data["qualifier"] = this.qualifier !== undefined ? this.qualifier : null as any;
        return data;
    }
}

export interface IServiceSearchData {
    gruppoID?: number;
    dataInizio?: string;
    servizioID?: number;
    servizioTipologiaID?: number;
    servizioTipologiaParentID?: number;
    beddingID?: number | null;
    quantita?: number;
    accordoID?: number;
    servizioFornitoreID?: number;
    codPrenotazione?: string | null;
    trattamentoID?: number;
    supplemento?: boolean;
    prezzo?: number;
    costo?: number;
    maxEta?: number;
    numeroPax?: number;
    tabAllotmentID?: number;
    disponibilita?: number;
    costoID?: number;
    tabellaCostoID?: number;
    fornitoreID?: number;
    numeroChild?: number;
    prezzoChild?: number;
    costoChild?: number;
    descrizione?: string | null;
    descrizioneFornitore?: string | null;
    notRefundable?: boolean;
    instantPurchase?: boolean;
    weddingRate?: boolean;
    penaleID?: number;
    hasFurtherInfo?: boolean;
    offerte?: DisponibilitaTipologiaOfferta[] | null;
    opzioni?: ServiceSearchSupplement[] | null;
    paxIDs?: number[] | null;
    dataFine?: string;
    luogoDestinazioneID?: number | null;
    luogoID?: number;
    tipoServizio?: ETipoServizioSearch;
    nota?: string | null;
    notaAgenzia?: string | null;
    notFound?: boolean;
    providerCustomData?: string | null;
    dataPenale?: string | null;
    importoPenale?: number | null;
    articoloPenaleID?: number | null;
    supplementi?: DisponibilitaSupplemento[] | null;
    supplementiAlt?: Supplemento[] | null;
    hashCode?: string | null;
    descrizioneHashCode?: string | null;
    supplementiDaInserire?: ServiceSearchData[] | null;
    servizioH2hID?: number | null;
    qualifier?: string | null;
}

export class ServiceSearchSupplement implements IServiceSearchSupplement {
    supplierID?: number;
    resultID?: number;
    resultItemID?: number;
    departureID?: number | null;
    optionID?: number;
    mandatory?: boolean;

    constructor(data?: IServiceSearchSupplement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierID = _data["supplierID"] !== undefined ? _data["supplierID"] : null as any;
            this.resultID = _data["resultID"] !== undefined ? _data["resultID"] : null as any;
            this.resultItemID = _data["resultItemID"] !== undefined ? _data["resultItemID"] : null as any;
            this.departureID = _data["departureID"] !== undefined ? _data["departureID"] : null as any;
            this.optionID = _data["optionID"] !== undefined ? _data["optionID"] : null as any;
            this.mandatory = _data["mandatory"] !== undefined ? _data["mandatory"] : null as any;
        }
    }

    static fromJS(data: any): ServiceSearchSupplement {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceSearchSupplement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierID"] = this.supplierID !== undefined ? this.supplierID : null as any;
        data["resultID"] = this.resultID !== undefined ? this.resultID : null as any;
        data["resultItemID"] = this.resultItemID !== undefined ? this.resultItemID : null as any;
        data["departureID"] = this.departureID !== undefined ? this.departureID : null as any;
        data["optionID"] = this.optionID !== undefined ? this.optionID : null as any;
        data["mandatory"] = this.mandatory !== undefined ? this.mandatory : null as any;
        return data;
    }
}

export interface IServiceSearchSupplement {
    supplierID?: number;
    resultID?: number;
    resultItemID?: number;
    departureID?: number | null;
    optionID?: number;
    mandatory?: boolean;
}

export class AddServizioAutomaticoRequest extends TripGetRequest implements IAddServizioAutomaticoRequest {
    servizioAutomatico?: EServizioAutomatico;
    importo?: number | null;
    abbinamentoID?: number | null;
    paxIDs?: number[] | null;
    /** Se true per i servizi che lo supportano richiede che l'aggiornamento sia manuale */
    aggiornamentoManuale?: boolean;

    constructor(data?: IAddServizioAutomaticoRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioAutomatico = _data["servizioAutomatico"] !== undefined ? _data["servizioAutomatico"] : null as any;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : null as any;
            this.abbinamentoID = _data["abbinamentoID"] !== undefined ? _data["abbinamentoID"] : null as any;
            if (Array.isArray(_data["paxIDs"])) {
                this.paxIDs = [] as any;
                for (let item of _data["paxIDs"])
                    this.paxIDs!.push(item);
            }
            else {
                this.paxIDs = null as any;
            }
            this.aggiornamentoManuale = _data["aggiornamentoManuale"] !== undefined ? _data["aggiornamentoManuale"] : null as any;
        }
    }

    static override fromJS(data: any): AddServizioAutomaticoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddServizioAutomaticoRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioAutomatico"] = this.servizioAutomatico !== undefined ? this.servizioAutomatico : null as any;
        data["importo"] = this.importo !== undefined ? this.importo : null as any;
        data["abbinamentoID"] = this.abbinamentoID !== undefined ? this.abbinamentoID : null as any;
        if (Array.isArray(this.paxIDs)) {
            data["paxIDs"] = [];
            for (let item of this.paxIDs)
                data["paxIDs"].push(item);
        }
        data["aggiornamentoManuale"] = this.aggiornamentoManuale !== undefined ? this.aggiornamentoManuale : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAddServizioAutomaticoRequest extends ITripGetRequest {
    servizioAutomatico?: EServizioAutomatico;
    importo?: number | null;
    abbinamentoID?: number | null;
    paxIDs?: number[] | null;
    /** Se true per i servizi che lo supportano richiede che l'aggiornamento sia manuale */
    aggiornamentoManuale?: boolean;
}

export class AddServizioMacroRequest extends TripGetRequest implements IAddServizioMacroRequest {
    jobID!: string;
    resultID!: string;
    serviceID!: number;
    typeID!: number;
    tappaID!: number;
    nomeGruppoCustom?: string | null;

    constructor(data?: IAddServizioMacroRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : null as any;
            this.resultID = _data["resultID"] !== undefined ? _data["resultID"] : null as any;
            this.serviceID = _data["serviceID"] !== undefined ? _data["serviceID"] : null as any;
            this.typeID = _data["typeID"] !== undefined ? _data["typeID"] : null as any;
            this.tappaID = _data["tappaID"] !== undefined ? _data["tappaID"] : null as any;
            this.nomeGruppoCustom = _data["nomeGruppoCustom"] !== undefined ? _data["nomeGruppoCustom"] : null as any;
        }
    }

    static override fromJS(data: any): AddServizioMacroRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddServizioMacroRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobID"] = this.jobID !== undefined ? this.jobID : null as any;
        data["resultID"] = this.resultID !== undefined ? this.resultID : null as any;
        data["serviceID"] = this.serviceID !== undefined ? this.serviceID : null as any;
        data["typeID"] = this.typeID !== undefined ? this.typeID : null as any;
        data["tappaID"] = this.tappaID !== undefined ? this.tappaID : null as any;
        data["nomeGruppoCustom"] = this.nomeGruppoCustom !== undefined ? this.nomeGruppoCustom : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAddServizioMacroRequest extends ITripGetRequest {
    jobID: string;
    resultID: string;
    serviceID: number;
    typeID: number;
    tappaID: number;
    nomeGruppoCustom?: string | null;
}

export class TripCancellationRequest extends TripGetRequest implements ITripCancellationRequest {
    /** User Id */
    userId!: number;

    constructor(data?: ITripCancellationRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
        }
    }

    static override fromJS(data: any): TripCancellationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TripCancellationRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITripCancellationRequest extends ITripGetRequest {
    /** User Id */
    userId: number;
}

export class AvviaCompletamentoResponse extends OkApiResponse implements IAvviaCompletamentoResponse {
    autofillResponse?: AutofillResponse;

    constructor(data?: IAvviaCompletamentoResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.autofillResponse = _data["autofillResponse"] ? AutofillResponse.fromJS(_data["autofillResponse"]) : null as any;
        }
    }

    static override fromJS(data: any): AvviaCompletamentoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AvviaCompletamentoResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["autofillResponse"] = this.autofillResponse ? this.autofillResponse.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAvviaCompletamentoResponse extends IOkApiResponse {
    autofillResponse?: AutofillResponse;
}

export class AutofillResponse implements IAutofillResponse {
    ok?: boolean;
    error?: string | null;
    jobID?: string | null;

    constructor(data?: IAutofillResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"] !== undefined ? _data["ok"] : null as any;
            this.error = _data["error"] !== undefined ? _data["error"] : null as any;
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : null as any;
        }
    }

    static fromJS(data: any): AutofillResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AutofillResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok !== undefined ? this.ok : null as any;
        data["error"] = this.error !== undefined ? this.error : null as any;
        data["jobID"] = this.jobID !== undefined ? this.jobID : null as any;
        return data;
    }
}

export interface IAutofillResponse {
    ok?: boolean;
    error?: string | null;
    jobID?: string | null;
}

export class AvviaCompletamentoRequest extends TripGetRequest implements IAvviaCompletamentoRequest {
    completaLand?: boolean;
    completaVoli?: boolean;

    constructor(data?: IAvviaCompletamentoRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.completaLand = _data["completaLand"] !== undefined ? _data["completaLand"] : null as any;
            this.completaVoli = _data["completaVoli"] !== undefined ? _data["completaVoli"] : null as any;
        }
    }

    static override fromJS(data: any): AvviaCompletamentoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AvviaCompletamentoRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completaLand"] = this.completaLand !== undefined ? this.completaLand : null as any;
        data["completaVoli"] = this.completaVoli !== undefined ? this.completaVoli : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAvviaCompletamentoRequest extends ITripGetRequest {
    completaLand?: boolean;
    completaVoli?: boolean;
}

export class AvviaVerificaPrezziResponse extends OkApiResponse implements IAvviaVerificaPrezziResponse {
    priceVerifyRequestResult?: PriceVerifyRequestResult | null;

    constructor(data?: IAvviaVerificaPrezziResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.priceVerifyRequestResult = _data["priceVerifyRequestResult"] ? PriceVerifyRequestResult.fromJS(_data["priceVerifyRequestResult"]) : null as any;
        }
    }

    static override fromJS(data: any): AvviaVerificaPrezziResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AvviaVerificaPrezziResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priceVerifyRequestResult"] = this.priceVerifyRequestResult ? this.priceVerifyRequestResult.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAvviaVerificaPrezziResponse extends IOkApiResponse {
    priceVerifyRequestResult?: PriceVerifyRequestResult | null;
}

export class PriceVerifyRequestResult implements IPriceVerifyRequestResult {
    result?: EPriceVerifyRequestResult;
    jobID?: string | null;
    error?: string | null;

    constructor(data?: IPriceVerifyRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] !== undefined ? _data["result"] : null as any;
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : null as any;
            this.error = _data["error"] !== undefined ? _data["error"] : null as any;
        }
    }

    static fromJS(data: any): PriceVerifyRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new PriceVerifyRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result !== undefined ? this.result : null as any;
        data["jobID"] = this.jobID !== undefined ? this.jobID : null as any;
        data["error"] = this.error !== undefined ? this.error : null as any;
        return data;
    }
}

export interface IPriceVerifyRequestResult {
    result?: EPriceVerifyRequestResult;
    jobID?: string | null;
    error?: string | null;
}

export enum EPriceVerifyRequestResult {
    OK = "OK",
    ALREADY_RUNNING = "ALREADY_RUNNING",
    AUTOCOMPLETE_RUNNING = "AUTOCOMPLETE_RUNNING",
    ERROR = "ERROR",
    TIMEOUT = "TIMEOUT",
}

export class AvviaVerificaPrezziRequest extends TripGetRequest implements IAvviaVerificaPrezziRequest {
    /** Se true è richiesta una contestuale conferma */
    confirming?: boolean;
    /** Lista opzionale di righe singole */
    rowIDs?: number[] | null;

    constructor(data?: IAvviaVerificaPrezziRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.confirming = _data["confirming"] !== undefined ? _data["confirming"] : null as any;
            if (Array.isArray(_data["rowIDs"])) {
                this.rowIDs = [] as any;
                for (let item of _data["rowIDs"])
                    this.rowIDs!.push(item);
            }
            else {
                this.rowIDs = null as any;
            }
        }
    }

    static override fromJS(data: any): AvviaVerificaPrezziRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AvviaVerificaPrezziRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["confirming"] = this.confirming !== undefined ? this.confirming : null as any;
        if (Array.isArray(this.rowIDs)) {
            data["rowIDs"] = [];
            for (let item of this.rowIDs)
                data["rowIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAvviaVerificaPrezziRequest extends ITripGetRequest {
    /** Se true è richiesta una contestuale conferma */
    confirming?: boolean;
    /** Lista opzionale di righe singole */
    rowIDs?: number[] | null;
}

export class CheckTripStatusResponse extends OkApiResponse implements ICheckTripStatusResponse {
    status?: TripBatch | null;
    priceVerifyStatus?: UiPriceVerifyStatus | null;

    constructor(data?: ICheckTripStatusResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"] ? TripBatch.fromJS(_data["status"]) : null as any;
            this.priceVerifyStatus = _data["priceVerifyStatus"] ? UiPriceVerifyStatus.fromJS(_data["priceVerifyStatus"]) : null as any;
        }
    }

    static override fromJS(data: any): CheckTripStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CheckTripStatusResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status ? this.status.toJSON() : null as any;
        data["priceVerifyStatus"] = this.priceVerifyStatus ? this.priceVerifyStatus.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICheckTripStatusResponse extends IOkApiResponse {
    status?: TripBatch | null;
    priceVerifyStatus?: UiPriceVerifyStatus | null;
}

export class TripBatch implements ITripBatch {
    offertaID?: number;
    batchType?: EBatchType;
    status?: EBatchStatus;
    autofillStatus?: AutofillStatus | null;
    priceVerifyStatus?: PriceVerifyStatus | null;
    statusJson?: string | null;

    constructor(data?: ITripBatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.batchType = _data["batchType"] !== undefined ? _data["batchType"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.autofillStatus = _data["autofillStatus"] ? AutofillStatus.fromJS(_data["autofillStatus"]) : null as any;
            this.priceVerifyStatus = _data["priceVerifyStatus"] ? PriceVerifyStatus.fromJS(_data["priceVerifyStatus"]) : null as any;
            this.statusJson = _data["statusJson"] !== undefined ? _data["statusJson"] : null as any;
        }
    }

    static fromJS(data: any): TripBatch {
        data = typeof data === 'object' ? data : {};
        let result = new TripBatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["batchType"] = this.batchType !== undefined ? this.batchType : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["autofillStatus"] = this.autofillStatus ? this.autofillStatus.toJSON() : null as any;
        data["priceVerifyStatus"] = this.priceVerifyStatus ? this.priceVerifyStatus.toJSON() : null as any;
        data["statusJson"] = this.statusJson !== undefined ? this.statusJson : null as any;
        return data;
    }
}

export interface ITripBatch {
    offertaID?: number;
    batchType?: EBatchType;
    status?: EBatchStatus;
    autofillStatus?: AutofillStatus | null;
    priceVerifyStatus?: PriceVerifyStatus | null;
    statusJson?: string | null;
}

export class PriceVerifyStatus extends TripBatchStatus implements IPriceVerifyStatus {
    confirming?: boolean;
    canConfirm?: boolean;
    result?: EPriceVerifyResult;
    rowResults?: PriceVerifyRowStatus[] | null;
    percentage?: number;

    constructor(data?: IPriceVerifyStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.confirming = _data["confirming"] !== undefined ? _data["confirming"] : null as any;
            this.canConfirm = _data["canConfirm"] !== undefined ? _data["canConfirm"] : null as any;
            this.result = _data["result"] !== undefined ? _data["result"] : null as any;
            if (Array.isArray(_data["rowResults"])) {
                this.rowResults = [] as any;
                for (let item of _data["rowResults"])
                    this.rowResults!.push(PriceVerifyRowStatus.fromJS(item));
            }
            else {
                this.rowResults = null as any;
            }
            this.percentage = _data["percentage"] !== undefined ? _data["percentage"] : null as any;
        }
    }

    static override fromJS(data: any): PriceVerifyStatus {
        data = typeof data === 'object' ? data : {};
        let result = new PriceVerifyStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["confirming"] = this.confirming !== undefined ? this.confirming : null as any;
        data["canConfirm"] = this.canConfirm !== undefined ? this.canConfirm : null as any;
        data["result"] = this.result !== undefined ? this.result : null as any;
        if (Array.isArray(this.rowResults)) {
            data["rowResults"] = [];
            for (let item of this.rowResults)
                data["rowResults"].push(item ? item.toJSON() : null as any);
        }
        data["percentage"] = this.percentage !== undefined ? this.percentage : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPriceVerifyStatus extends ITripBatchStatus {
    confirming?: boolean;
    canConfirm?: boolean;
    result?: EPriceVerifyResult;
    rowResults?: PriceVerifyRowStatus[] | null;
    percentage?: number;
}

export enum EPriceVerifyResult {
    NONE = "NONE",
    OK = "OK",
    PRICE_AVAIL_CHANGED = "PRICE_AVAIL_CHANGED",
    INVALID = "INVALID",
    ERROR = "ERROR",
    NOT_AVAILABLE = "NOT_AVAILABLE",
    RUNNING = "RUNNING",
}

export class PriceVerifyRowStatus implements IPriceVerifyRowStatus {
    id?: number;
    date?: string;
    group?: string | null;
    description?: string | null;
    verifyError?: boolean;
    priceChanged?: boolean;
    previousPrice?: number;
    newPrice?: number | null;
    availabilityChanged?: boolean;
    previousAvailability?: EStatoDisponibilita;
    newAvailability?: EStatoDisponibilita | null;
    result?: EPriceVerifyResult;

    constructor(data?: IPriceVerifyRowStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.date = _data["date"] !== undefined ? _data["date"] : null as any;
            this.group = _data["group"] !== undefined ? _data["group"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.verifyError = _data["verifyError"] !== undefined ? _data["verifyError"] : null as any;
            this.priceChanged = _data["priceChanged"] !== undefined ? _data["priceChanged"] : null as any;
            this.previousPrice = _data["previousPrice"] !== undefined ? _data["previousPrice"] : null as any;
            this.newPrice = _data["newPrice"] !== undefined ? _data["newPrice"] : null as any;
            this.availabilityChanged = _data["availabilityChanged"] !== undefined ? _data["availabilityChanged"] : null as any;
            this.previousAvailability = _data["previousAvailability"] !== undefined ? _data["previousAvailability"] : null as any;
            this.newAvailability = _data["newAvailability"] !== undefined ? _data["newAvailability"] : null as any;
            this.result = _data["result"] !== undefined ? _data["result"] : null as any;
        }
    }

    static fromJS(data: any): PriceVerifyRowStatus {
        data = typeof data === 'object' ? data : {};
        let result = new PriceVerifyRowStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["date"] = this.date !== undefined ? this.date : null as any;
        data["group"] = this.group !== undefined ? this.group : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["verifyError"] = this.verifyError !== undefined ? this.verifyError : null as any;
        data["priceChanged"] = this.priceChanged !== undefined ? this.priceChanged : null as any;
        data["previousPrice"] = this.previousPrice !== undefined ? this.previousPrice : null as any;
        data["newPrice"] = this.newPrice !== undefined ? this.newPrice : null as any;
        data["availabilityChanged"] = this.availabilityChanged !== undefined ? this.availabilityChanged : null as any;
        data["previousAvailability"] = this.previousAvailability !== undefined ? this.previousAvailability : null as any;
        data["newAvailability"] = this.newAvailability !== undefined ? this.newAvailability : null as any;
        data["result"] = this.result !== undefined ? this.result : null as any;
        return data;
    }
}

export interface IPriceVerifyRowStatus {
    id?: number;
    date?: string;
    group?: string | null;
    description?: string | null;
    verifyError?: boolean;
    priceChanged?: boolean;
    previousPrice?: number;
    newPrice?: number | null;
    availabilityChanged?: boolean;
    previousAvailability?: EStatoDisponibilita;
    newAvailability?: EStatoDisponibilita | null;
    result?: EPriceVerifyResult;
}

export class UiPriceVerifyStatus extends PriceVerifyStatus implements IUiPriceVerifyStatus {

    constructor(data?: IUiPriceVerifyStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UiPriceVerifyStatus {
        data = typeof data === 'object' ? data : {};
        let result = new UiPriceVerifyStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUiPriceVerifyStatus extends IPriceVerifyStatus {
}

export class CheckTripStatusRequest extends LocalizedRequest implements ICheckTripStatusRequest {
    offertaID?: number;

    constructor(data?: ICheckTripStatusRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
        }
    }

    static override fromJS(data: any): CheckTripStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckTripStatusRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICheckTripStatusRequest extends ILocalizedRequest {
    offertaID?: number;
}

export class ConfermaRequest extends TripGetRequest implements IConfermaRequest {
    manuale?: boolean;
    inviaEmailConferma?: boolean;
    recipientUserID?: number | null;

    constructor(data?: IConfermaRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.manuale = _data["manuale"] !== undefined ? _data["manuale"] : null as any;
            this.inviaEmailConferma = _data["inviaEmailConferma"] !== undefined ? _data["inviaEmailConferma"] : null as any;
            this.recipientUserID = _data["recipientUserID"] !== undefined ? _data["recipientUserID"] : null as any;
        }
    }

    static override fromJS(data: any): ConfermaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfermaRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manuale"] = this.manuale !== undefined ? this.manuale : null as any;
        data["inviaEmailConferma"] = this.inviaEmailConferma !== undefined ? this.inviaEmailConferma : null as any;
        data["recipientUserID"] = this.recipientUserID !== undefined ? this.recipientUserID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IConfermaRequest extends ITripGetRequest {
    manuale?: boolean;
    inviaEmailConferma?: boolean;
    recipientUserID?: number | null;
}

export class CopiaDocumentoResponse extends TripGetResponse implements ICopiaDocumentoResponse {
    documentoCopia?: Documento | null;

    constructor(data?: ICopiaDocumentoResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentoCopia = _data["documentoCopia"] ? Documento.fromJS(_data["documentoCopia"]) : null as any;
        }
    }

    static override fromJS(data: any): CopiaDocumentoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CopiaDocumentoResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoCopia"] = this.documentoCopia ? this.documentoCopia.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICopiaDocumentoResponse extends ITripGetResponse {
    documentoCopia?: Documento | null;
}

export class CopiaDocumentoRequest extends TripGetRequest implements ICopiaDocumentoRequest {
    documentoID?: number;

    constructor(data?: ICopiaDocumentoRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : null as any;
        }
    }

    static override fromJS(data: any): CopiaDocumentoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopiaDocumentoRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICopiaDocumentoRequest extends ITripGetRequest {
    documentoID?: number;
}

export class CopiaRigaResponse extends TripGetResponse implements ICopiaRigaResponse {
    rigaCopiata?: OffertaDato | null;

    constructor(data?: ICopiaRigaResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rigaCopiata = _data["rigaCopiata"] ? OffertaDato.fromJS(_data["rigaCopiata"]) : null as any;
        }
    }

    static override fromJS(data: any): CopiaRigaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CopiaRigaResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rigaCopiata"] = this.rigaCopiata ? this.rigaCopiata.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICopiaRigaResponse extends ITripGetResponse {
    rigaCopiata?: OffertaDato | null;
}

export class CopiaRigaRequest extends TripGetRequest implements ICopiaRigaRequest {
    offertaDatoID?: number;

    constructor(data?: ICopiaRigaRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : null as any;
        }
    }

    static override fromJS(data: any): CopiaRigaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopiaRigaRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICopiaRigaRequest extends ITripGetRequest {
    offertaDatoID?: number;
}

export class CopiaVoucherResponse extends TripGetResponse implements ICopiaVoucherResponse {
    voucherCopia?: Voucher | null;

    constructor(data?: ICopiaVoucherResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.voucherCopia = _data["voucherCopia"] ? Voucher.fromJS(_data["voucherCopia"]) : null as any;
        }
    }

    static override fromJS(data: any): CopiaVoucherResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CopiaVoucherResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherCopia"] = this.voucherCopia ? this.voucherCopia.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICopiaVoucherResponse extends ITripGetResponse {
    voucherCopia?: Voucher | null;
}

export class CopiaVoucherRequest extends TripGetRequest implements ICopiaVoucherRequest {
    voucherID?: number;

    constructor(data?: ICopiaVoucherRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.voucherID = _data["voucherID"] !== undefined ? _data["voucherID"] : null as any;
        }
    }

    static override fromJS(data: any): CopiaVoucherRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopiaVoucherRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherID"] = this.voucherID !== undefined ? this.voucherID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICopiaVoucherRequest extends ITripGetRequest {
    voucherID?: number;
}

export class CreateDocumentiAllegatiRequest extends TripGetRequest implements ICreateDocumentiAllegatiRequest {
    allegatiIds?: number[] | null;

    constructor(data?: ICreateDocumentiAllegatiRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["allegatiIds"])) {
                this.allegatiIds = [] as any;
                for (let item of _data["allegatiIds"])
                    this.allegatiIds!.push(item);
            }
            else {
                this.allegatiIds = null as any;
            }
        }
    }

    static override fromJS(data: any): CreateDocumentiAllegatiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDocumentiAllegatiRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allegatiIds)) {
            data["allegatiIds"] = [];
            for (let item of this.allegatiIds)
                data["allegatiIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICreateDocumentiAllegatiRequest extends ITripGetRequest {
    allegatiIds?: number[] | null;
}

export class CreateDocumentoResponse extends TripGetResponse implements ICreateDocumentoResponse {
    documentoID?: number;

    constructor(data?: ICreateDocumentoResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : null as any;
        }
    }

    static override fromJS(data: any): CreateDocumentoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDocumentoResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateDocumentoResponse extends ITripGetResponse {
    documentoID?: number;
}

export class CreateDocumentoRequest extends TripGetRequest implements ICreateDocumentoRequest {
    tipoDocumento?: ETipoDocumento;
    extraArgs?: string | null;

    constructor(data?: ICreateDocumentoRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tipoDocumento = _data["tipoDocumento"] !== undefined ? _data["tipoDocumento"] : null as any;
            this.extraArgs = _data["extraArgs"] !== undefined ? _data["extraArgs"] : null as any;
        }
    }

    static override fromJS(data: any): CreateDocumentoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDocumentoRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoDocumento"] = this.tipoDocumento !== undefined ? this.tipoDocumento : null as any;
        data["extraArgs"] = this.extraArgs !== undefined ? this.extraArgs : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateDocumentoRequest extends ITripGetRequest {
    tipoDocumento?: ETipoDocumento;
    extraArgs?: string | null;
}

export class EditNotaResponse extends TripGetResponse implements IEditNotaResponse {
    /** Entit� della nota creata / modificata */
    nota?: OffertaNota;
    /** Dati aggiuntivi ad uso della UI */
    tripNote?: TripNote;

    constructor(data?: IEditNotaResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nota = _data["nota"] ? OffertaNota.fromJS(_data["nota"]) : null as any;
            this.tripNote = _data["tripNote"] ? TripNote.fromJS(_data["tripNote"]) : null as any;
        }
    }

    static override fromJS(data: any): EditNotaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditNotaResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nota"] = this.nota ? this.nota.toJSON() : null as any;
        data["tripNote"] = this.tripNote ? this.tripNote.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IEditNotaResponse extends ITripGetResponse {
    /** Entit� della nota creata / modificata */
    nota?: OffertaNota;
    /** Dati aggiuntivi ad uso della UI */
    tripNote?: TripNote;
}

export class EditNotaRequest extends TripGetRequest implements IEditNotaRequest {
    nota?: OffertaNota;

    constructor(data?: IEditNotaRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nota = _data["nota"] ? OffertaNota.fromJS(_data["nota"]) : null as any;
        }
    }

    static override fromJS(data: any): EditNotaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditNotaRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nota"] = this.nota ? this.nota.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IEditNotaRequest extends ITripGetRequest {
    nota?: OffertaNota;
}

export class CreateQuotationRequest extends CreateTripRequest implements ICreateQuotationRequest {
    /** Tipo di viaggio, combina tipo e nozze */
    tipoViaggioPreventivo!: ETipoViaggioPreventivo;
    /** ID del luogo di partenza */
    luogoPartenzaID?: number | null;
    /** Data dell'appuntamento dell'ADV con il cliente */
    dataAppuntamentoADV?: string | null;
    /** Note abbinate all'appuntamento ADV */
    noteAppuntamento?: string | null;
    /** Descrizione testuale della destinazione */
    destinazione!: string;
    teamID?: number;
    /** Descrizione testuale delle opzioni di volo */
    opzioniVolo!: string;
    /** Descrizione testuale del budget */
    budget!: string;
    /** Descrizione testuale dei trasferimenti */
    trasferimenti?: string | null;
    /** Descrizione testuale dei noleggi */
    noleggi?: string | null;
    /** Descrizione testuale della categoria hotel */
    categoriaHotel?: string | null;
    /** Tolleranza della data di partenza in giorni */
    tolleranzaPartenza?: number | null;

    constructor(data?: ICreateQuotationRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tipoViaggioPreventivo = _data["tipoViaggioPreventivo"] !== undefined ? _data["tipoViaggioPreventivo"] : null as any;
            this.luogoPartenzaID = _data["luogoPartenzaID"] !== undefined ? _data["luogoPartenzaID"] : null as any;
            this.dataAppuntamentoADV = _data["dataAppuntamentoADV"] !== undefined ? _data["dataAppuntamentoADV"] : null as any;
            this.noteAppuntamento = _data["noteAppuntamento"] !== undefined ? _data["noteAppuntamento"] : null as any;
            this.destinazione = _data["destinazione"] !== undefined ? _data["destinazione"] : null as any;
            this.teamID = _data["teamID"] !== undefined ? _data["teamID"] : null as any;
            this.opzioniVolo = _data["opzioniVolo"] !== undefined ? _data["opzioniVolo"] : null as any;
            this.budget = _data["budget"] !== undefined ? _data["budget"] : null as any;
            this.trasferimenti = _data["trasferimenti"] !== undefined ? _data["trasferimenti"] : null as any;
            this.noleggi = _data["noleggi"] !== undefined ? _data["noleggi"] : null as any;
            this.categoriaHotel = _data["categoriaHotel"] !== undefined ? _data["categoriaHotel"] : null as any;
            this.tolleranzaPartenza = _data["tolleranzaPartenza"] !== undefined ? _data["tolleranzaPartenza"] : null as any;
        }
    }

    static override fromJS(data: any): CreateQuotationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQuotationRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoViaggioPreventivo"] = this.tipoViaggioPreventivo !== undefined ? this.tipoViaggioPreventivo : null as any;
        data["luogoPartenzaID"] = this.luogoPartenzaID !== undefined ? this.luogoPartenzaID : null as any;
        data["dataAppuntamentoADV"] = this.dataAppuntamentoADV !== undefined ? this.dataAppuntamentoADV : null as any;
        data["noteAppuntamento"] = this.noteAppuntamento !== undefined ? this.noteAppuntamento : null as any;
        data["destinazione"] = this.destinazione !== undefined ? this.destinazione : null as any;
        data["teamID"] = this.teamID !== undefined ? this.teamID : null as any;
        data["opzioniVolo"] = this.opzioniVolo !== undefined ? this.opzioniVolo : null as any;
        data["budget"] = this.budget !== undefined ? this.budget : null as any;
        data["trasferimenti"] = this.trasferimenti !== undefined ? this.trasferimenti : null as any;
        data["noleggi"] = this.noleggi !== undefined ? this.noleggi : null as any;
        data["categoriaHotel"] = this.categoriaHotel !== undefined ? this.categoriaHotel : null as any;
        data["tolleranzaPartenza"] = this.tolleranzaPartenza !== undefined ? this.tolleranzaPartenza : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateQuotationRequest extends ICreateTripRequest {
    /** Tipo di viaggio, combina tipo e nozze */
    tipoViaggioPreventivo: ETipoViaggioPreventivo;
    /** ID del luogo di partenza */
    luogoPartenzaID?: number | null;
    /** Data dell'appuntamento dell'ADV con il cliente */
    dataAppuntamentoADV?: string | null;
    /** Note abbinate all'appuntamento ADV */
    noteAppuntamento?: string | null;
    /** Descrizione testuale della destinazione */
    destinazione: string;
    teamID?: number;
    /** Descrizione testuale delle opzioni di volo */
    opzioniVolo: string;
    /** Descrizione testuale del budget */
    budget: string;
    /** Descrizione testuale dei trasferimenti */
    trasferimenti?: string | null;
    /** Descrizione testuale dei noleggi */
    noleggi?: string | null;
    /** Descrizione testuale della categoria hotel */
    categoriaHotel?: string | null;
    /** Tolleranza della data di partenza in giorni */
    tolleranzaPartenza?: number | null;
}

export enum ETipoViaggioPreventivo {
    Indefinito = "Indefinito",
    Nozze = "Nozze",
    Gruppo = "Gruppo",
}

export class CreateRigaResponse extends TripGetResponse implements ICreateRigaResponse {
    rigaCreata?: TripService;

    constructor(data?: ICreateRigaResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rigaCreata = _data["rigaCreata"] ? TripService.fromJS(_data["rigaCreata"]) : null as any;
        }
    }

    static override fromJS(data: any): CreateRigaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRigaResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rigaCreata"] = this.rigaCreata ? this.rigaCreata.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateRigaResponse extends ITripGetResponse {
    rigaCreata?: TripService;
}

export class CreateRigaRequest extends TripGetRequest implements ICreateRigaRequest {
    riga?: OffertaDato;
    stato?: OffertaDatoStato | null;

    constructor(data?: ICreateRigaRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.riga = _data["riga"] ? OffertaDato.fromJS(_data["riga"]) : null as any;
            this.stato = _data["stato"] ? OffertaDatoStato.fromJS(_data["stato"]) : null as any;
        }
    }

    static override fromJS(data: any): CreateRigaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRigaRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["riga"] = this.riga ? this.riga.toJSON() : null as any;
        data["stato"] = this.stato ? this.stato.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateRigaRequest extends ITripGetRequest {
    riga?: OffertaDato;
    stato?: OffertaDatoStato | null;
}

export class CreateSegnapostoPagamentoRequest extends TripGetRequest implements ICreateSegnapostoPagamentoRequest {
    rigaOriginaleID?: number;

    constructor(data?: ICreateSegnapostoPagamentoRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rigaOriginaleID = _data["rigaOriginaleID"] !== undefined ? _data["rigaOriginaleID"] : null as any;
        }
    }

    static override fromJS(data: any): CreateSegnapostoPagamentoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSegnapostoPagamentoRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rigaOriginaleID"] = this.rigaOriginaleID !== undefined ? this.rigaOriginaleID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateSegnapostoPagamentoRequest extends ITripGetRequest {
    rigaOriginaleID?: number;
}

export class CreateTripFromQuotationRequest extends CreateTripRequest implements ICreateTripFromQuotationRequest {

    constructor(data?: ICreateTripFromQuotationRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CreateTripFromQuotationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTripFromQuotationRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreateTripFromQuotationRequest extends ICreateTripRequest {
}

export class DeleteDocumentoRequest extends TripGetRequest implements IDeleteDocumentoRequest {
    documentoID?: number;

    constructor(data?: IDeleteDocumentoRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : null as any;
        }
    }

    static override fromJS(data: any): DeleteDocumentoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteDocumentoRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteDocumentoRequest extends ITripGetRequest {
    documentoID?: number;
}

export class DeleteDocumentoMultiRequest extends TripGetRequest implements IDeleteDocumentoMultiRequest {
    documentiIds?: number[] | null;

    constructor(data?: IDeleteDocumentoMultiRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["documentiIds"])) {
                this.documentiIds = [] as any;
                for (let item of _data["documentiIds"])
                    this.documentiIds!.push(item);
            }
            else {
                this.documentiIds = null as any;
            }
        }
    }

    static override fromJS(data: any): DeleteDocumentoMultiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteDocumentoMultiRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documentiIds)) {
            data["documentiIds"] = [];
            for (let item of this.documentiIds)
                data["documentiIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteDocumentoMultiRequest extends ITripGetRequest {
    documentiIds?: number[] | null;
}

export class DeleteNotaMultiRequest extends TripGetRequest implements IDeleteNotaMultiRequest {
    noteIds?: number[] | null;

    constructor(data?: IDeleteNotaMultiRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["noteIds"])) {
                this.noteIds = [] as any;
                for (let item of _data["noteIds"])
                    this.noteIds!.push(item);
            }
            else {
                this.noteIds = null as any;
            }
        }
    }

    static override fromJS(data: any): DeleteNotaMultiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteNotaMultiRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.noteIds)) {
            data["noteIds"] = [];
            for (let item of this.noteIds)
                data["noteIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteNotaMultiRequest extends ITripGetRequest {
    noteIds?: number[] | null;
}

export class DeleteServiziRequest extends TripGetRequest implements IDeleteServiziRequest {
    righeIds?: number[] | null;
    eliminaItinerariTour?: boolean;

    constructor(data?: IDeleteServiziRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["righeIds"])) {
                this.righeIds = [] as any;
                for (let item of _data["righeIds"])
                    this.righeIds!.push(item);
            }
            else {
                this.righeIds = null as any;
            }
            this.eliminaItinerariTour = _data["eliminaItinerariTour"] !== undefined ? _data["eliminaItinerariTour"] : null as any;
        }
    }

    static override fromJS(data: any): DeleteServiziRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteServiziRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.righeIds)) {
            data["righeIds"] = [];
            for (let item of this.righeIds)
                data["righeIds"].push(item);
        }
        data["eliminaItinerariTour"] = this.eliminaItinerariTour !== undefined ? this.eliminaItinerariTour : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteServiziRequest extends ITripGetRequest {
    righeIds?: number[] | null;
    eliminaItinerariTour?: boolean;
}

export class UpdateVoloRequest extends TripGetRequest implements IUpdateVoloRequest {
    volo?: Volo | null;
    segmenti?: VoloTratta[] | null;

    constructor(data?: IUpdateVoloRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.volo = _data["volo"] ? Volo.fromJS(_data["volo"]) : null as any;
            if (Array.isArray(_data["segmenti"])) {
                this.segmenti = [] as any;
                for (let item of _data["segmenti"])
                    this.segmenti!.push(VoloTratta.fromJS(item));
            }
            else {
                this.segmenti = null as any;
            }
        }
    }

    static override fromJS(data: any): UpdateVoloRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVoloRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["volo"] = this.volo ? this.volo.toJSON() : null as any;
        if (Array.isArray(this.segmenti)) {
            data["segmenti"] = [];
            for (let item of this.segmenti)
                data["segmenti"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateVoloRequest extends ITripGetRequest {
    volo?: Volo | null;
    segmenti?: VoloTratta[] | null;
}

export class DeleteVoucherRequest extends TripGetRequest implements IDeleteVoucherRequest {
    voucherID?: number;

    constructor(data?: IDeleteVoucherRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.voucherID = _data["voucherID"] !== undefined ? _data["voucherID"] : null as any;
        }
    }

    static override fromJS(data: any): DeleteVoucherRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteVoucherRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherID"] = this.voucherID !== undefined ? this.voucherID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteVoucherRequest extends ITripGetRequest {
    voucherID?: number;
}

export class DeleteVoucherMultiRequest extends TripGetRequest implements IDeleteVoucherMultiRequest {
    voucherIds?: number[] | null;

    constructor(data?: IDeleteVoucherMultiRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["voucherIds"])) {
                this.voucherIds = [] as any;
                for (let item of _data["voucherIds"])
                    this.voucherIds!.push(item);
            }
            else {
                this.voucherIds = null as any;
            }
        }
    }

    static override fromJS(data: any): DeleteVoucherMultiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteVoucherMultiRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.voucherIds)) {
            data["voucherIds"] = [];
            for (let item of this.voucherIds)
                data["voucherIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteVoucherMultiRequest extends ITripGetRequest {
    voucherIds?: number[] | null;
}

export class NrTableResponseOfTripActivityLogRow extends OkApiResponse implements INrTableResponseOfTripActivityLogRow {
    /** Array delle righe della pagina richiesta */
    rows?: TripActivityLogRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfTripActivityLogRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TripActivityLogRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfTripActivityLogRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfTripActivityLogRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfTripActivityLogRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: TripActivityLogRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class TripActivityLogRow implements ITripActivityLogRow {
    log?: SqlTripActivityLogItem | null;
    username?: string | null;
    agency?: string | null;

    constructor(data?: ITripActivityLogRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.log = _data["log"] ? SqlTripActivityLogItem.fromJS(_data["log"]) : null as any;
            this.username = _data["username"] !== undefined ? _data["username"] : null as any;
            this.agency = _data["agency"] !== undefined ? _data["agency"] : null as any;
        }
    }

    static fromJS(data: any): TripActivityLogRow {
        data = typeof data === 'object' ? data : {};
        let result = new TripActivityLogRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["log"] = this.log ? this.log.toJSON() : null as any;
        data["username"] = this.username !== undefined ? this.username : null as any;
        data["agency"] = this.agency !== undefined ? this.agency : null as any;
        return data;
    }
}

export interface ITripActivityLogRow {
    log?: SqlTripActivityLogItem | null;
    username?: string | null;
    agency?: string | null;
}

export class GetActivityLogsRequest extends NrTableRequest implements IGetActivityLogsRequest {
    offertaID?: number;
    date?: string | null;
    username?: string | null;
    message?: string | null;

    constructor(data?: IGetActivityLogsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.date = _data["date"] !== undefined ? _data["date"] : null as any;
            this.username = _data["username"] !== undefined ? _data["username"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
        }
    }

    static override fromJS(data: any): GetActivityLogsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivityLogsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["date"] = this.date !== undefined ? this.date : null as any;
        data["username"] = this.username !== undefined ? this.username : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetActivityLogsRequest extends INrTableRequest {
    offertaID?: number;
    date?: string | null;
    username?: string | null;
    message?: string | null;
}

export class GetFlightsTicketsResponse extends OkApiResponse implements IGetFlightsTicketsResponse {
    tickets?: VoloTickets[] | null;

    constructor(data?: IGetFlightsTicketsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tickets"])) {
                this.tickets = [] as any;
                for (let item of _data["tickets"])
                    this.tickets!.push(VoloTickets.fromJS(item));
            }
            else {
                this.tickets = null as any;
            }
        }
    }

    static override fromJS(data: any): GetFlightsTicketsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFlightsTicketsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tickets)) {
            data["tickets"] = [];
            for (let item of this.tickets)
                data["tickets"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetFlightsTicketsResponse extends IOkApiResponse {
    tickets?: VoloTickets[] | null;
}

export class GetFlightsTicketsRequest extends ApiRequest implements IGetFlightsTicketsRequest {
    offertaID?: number;

    constructor(data?: IGetFlightsTicketsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
        }
    }

    static override fromJS(data: any): GetFlightsTicketsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFlightsTicketsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetFlightsTicketsRequest extends IApiRequest {
    offertaID?: number;
}

export class GetPaxConnectTripResponse extends OkApiResponse implements IGetPaxConnectTripResponse {
    paxConnectSerializedXML?: string | null;

    constructor(data?: IGetPaxConnectTripResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.paxConnectSerializedXML = _data["paxConnectSerializedXML"] !== undefined ? _data["paxConnectSerializedXML"] : null as any;
        }
    }

    static override fromJS(data: any): GetPaxConnectTripResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaxConnectTripResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paxConnectSerializedXML"] = this.paxConnectSerializedXML !== undefined ? this.paxConnectSerializedXML : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPaxConnectTripResponse extends IOkApiResponse {
    paxConnectSerializedXML?: string | null;
}

export class GetPaxConnectTripRequest extends ApiRequest implements IGetPaxConnectTripRequest {
    tripID?: number;

    constructor(data?: IGetPaxConnectTripRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : null as any;
        }
    }

    static override fromJS(data: any): GetPaxConnectTripRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaxConnectTripRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripID"] = this.tripID !== undefined ? this.tripID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPaxConnectTripRequest extends IApiRequest {
    tripID?: number;
}

export class GetQuotesResponse extends OkApiResponse implements IGetQuotesResponse {
    quotes?: string[];

    constructor(data?: IGetQuotesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["quotes"])) {
                this.quotes = [] as any;
                for (let item of _data["quotes"])
                    this.quotes!.push(item);
            }
            else {
                this.quotes = null as any;
            }
        }
    }

    static override fromJS(data: any): GetQuotesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetQuotesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.quotes)) {
            data["quotes"] = [];
            for (let item of this.quotes)
                data["quotes"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetQuotesResponse extends IOkApiResponse {
    quotes?: string[];
}

export class GetQuotesRequest extends SiteRequest implements IGetQuotesRequest {

    constructor(data?: IGetQuotesRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetQuotesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetQuotesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetQuotesRequest extends ISiteRequest {
}

export class GetServiziOffertaResponse extends OkApiResponse implements IGetServiziOffertaResponse {
    services?: TripService[] | null;

    constructor(data?: IGetServiziOffertaResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(TripService.fromJS(item));
            }
            else {
                this.services = null as any;
            }
        }
    }

    static override fromJS(data: any): GetServiziOffertaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiziOffertaResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetServiziOffertaResponse extends IOkApiResponse {
    services?: TripService[] | null;
}

export class GetServiziOffertaRequest extends TripGetRequest implements IGetServiziOffertaRequest {

    constructor(data?: IGetServiziOffertaRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetServiziOffertaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiziOffertaRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetServiziOffertaRequest extends ITripGetRequest {
}

export class GetServizioManualeResponse extends TripGetResponse implements IGetServizioManualeResponse {
    rigaServizioManuale?: OffertaDato | null;

    constructor(data?: IGetServizioManualeResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rigaServizioManuale = _data["rigaServizioManuale"] ? OffertaDato.fromJS(_data["rigaServizioManuale"]) : null as any;
        }
    }

    static override fromJS(data: any): GetServizioManualeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetServizioManualeResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rigaServizioManuale"] = this.rigaServizioManuale ? this.rigaServizioManuale.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetServizioManualeResponse extends ITripGetResponse {
    rigaServizioManuale?: OffertaDato | null;
}

export class GetServizioManualeRequest extends TripGetRequest implements IGetServizioManualeRequest {
    servizio?: EServizioManuale;
    itinerarioID?: number | null;

    constructor(data?: IGetServizioManualeRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : null as any;
            this.itinerarioID = _data["itinerarioID"] !== undefined ? _data["itinerarioID"] : null as any;
        }
    }

    static override fromJS(data: any): GetServizioManualeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetServizioManualeRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio !== undefined ? this.servizio : null as any;
        data["itinerarioID"] = this.itinerarioID !== undefined ? this.itinerarioID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetServizioManualeRequest extends ITripGetRequest {
    servizio?: EServizioManuale;
    itinerarioID?: number | null;
}

export enum EServizioManuale {
    ServizioManuale = "ServizioManuale",
    TariffaAerea = "TariffaAerea",
    TariffaAereaInstantPurchase = "TariffaAereaInstantPurchase",
    TasseAeroportuali = "TasseAeroportuali",
    InterventoCommerciale = "InterventoCommerciale",
    InterventoOperativo = "InterventoOperativo",
    RettificaPrezzi = "RettificaPrezzi",
    DirittiAgenzia = "DirittiAgenzia",
    Traghetti = "Traghetti",
    RailAndFly = "RailAndFly",
}

export class GetTripDescriptionsResponse extends OkApiResponse implements IGetTripDescriptionsResponse {
    descriptions?: TripDescriptionDay[];

    constructor(data?: IGetTripDescriptionsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["descriptions"])) {
                this.descriptions = [] as any;
                for (let item of _data["descriptions"])
                    this.descriptions!.push(TripDescriptionDay.fromJS(item));
            }
            else {
                this.descriptions = null as any;
            }
        }
    }

    static override fromJS(data: any): GetTripDescriptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripDescriptionsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.descriptions)) {
            data["descriptions"] = [];
            for (let item of this.descriptions)
                data["descriptions"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetTripDescriptionsResponse extends IOkApiResponse {
    descriptions?: TripDescriptionDay[];
}

export class GetTripDefaultDescriptionsResponse extends GetTripDescriptionsResponse implements IGetTripDefaultDescriptionsResponse {

    constructor(data?: IGetTripDefaultDescriptionsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetTripDefaultDescriptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripDefaultDescriptionsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetTripDefaultDescriptionsResponse extends IGetTripDescriptionsResponse {
}

export class TripDescriptionDay implements ITripDescriptionDay {
    stop?: number;
    day?: number;
    order?: number;
    description?: string;
    canEdit?: boolean;

    constructor(data?: ITripDescriptionDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stop = _data["stop"] !== undefined ? _data["stop"] : null as any;
            this.day = _data["day"] !== undefined ? _data["day"] : null as any;
            this.order = _data["order"] !== undefined ? _data["order"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.canEdit = _data["canEdit"] !== undefined ? _data["canEdit"] : null as any;
        }
    }

    static fromJS(data: any): TripDescriptionDay {
        data = typeof data === 'object' ? data : {};
        let result = new TripDescriptionDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stop"] = this.stop !== undefined ? this.stop : null as any;
        data["day"] = this.day !== undefined ? this.day : null as any;
        data["order"] = this.order !== undefined ? this.order : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["canEdit"] = this.canEdit !== undefined ? this.canEdit : null as any;
        return data;
    }
}

export interface ITripDescriptionDay {
    stop?: number;
    day?: number;
    order?: number;
    description?: string;
    canEdit?: boolean;
}

export class GetTripDefaultDescriptionsRequest extends SiteRequest implements IGetTripDefaultDescriptionsRequest {
    days!: GetTripDefaultDescriptionsDay[];

    constructor(data?: IGetTripDefaultDescriptionsRequest) {
        super(data);
        if (!data) {
            this.days = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(GetTripDefaultDescriptionsDay.fromJS(item));
            }
            else {
                this.days = null as any;
            }
        }
    }

    static override fromJS(data: any): GetTripDefaultDescriptionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripDefaultDescriptionsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetTripDefaultDescriptionsRequest extends ISiteRequest {
    days: GetTripDefaultDescriptionsDay[];
}

export class GetTripDefaultDescriptionsDay implements IGetTripDefaultDescriptionsDay {
    stopID?: number;
    day?: number;
    placeID?: number;
    transportType?: ETipoTrasporto;

    constructor(data?: IGetTripDefaultDescriptionsDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stopID = _data["stopID"] !== undefined ? _data["stopID"] : null as any;
            this.day = _data["day"] !== undefined ? _data["day"] : null as any;
            this.placeID = _data["placeID"] !== undefined ? _data["placeID"] : null as any;
            this.transportType = _data["transportType"] !== undefined ? _data["transportType"] : null as any;
        }
    }

    static fromJS(data: any): GetTripDefaultDescriptionsDay {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripDefaultDescriptionsDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stopID"] = this.stopID !== undefined ? this.stopID : null as any;
        data["day"] = this.day !== undefined ? this.day : null as any;
        data["placeID"] = this.placeID !== undefined ? this.placeID : null as any;
        data["transportType"] = this.transportType !== undefined ? this.transportType : null as any;
        return data;
    }
}

export interface IGetTripDefaultDescriptionsDay {
    stopID?: number;
    day?: number;
    placeID?: number;
    transportType?: ETipoTrasporto;
}

export class GetTripDescriptionsRequest extends SiteRequest implements IGetTripDescriptionsRequest {
    offertaID?: number;

    constructor(data?: IGetTripDescriptionsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
        }
    }

    static override fromJS(data: any): GetTripDescriptionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripDescriptionsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTripDescriptionsRequest extends ISiteRequest {
    offertaID?: number;
}

export class GetTripSkelethonResponse extends TripGetResponse implements IGetTripSkelethonResponse {
    servizioID?: number | null;
    servizio?: string | null;
    tipologiaID?: number | null;
    trattamentoID?: number | null;
    tipologiaKey?: string | null;
    partenza?: string | null;
    luogoServizioTappaID?: number | null;
    tipologieDisponibili?: TripCreateType[] | null;
    richiediQuotazione?: boolean;
    roomsDef?: string;
    roomsDefDefault?: boolean;
    fromQuotationID?: number | null;

    constructor(data?: IGetTripSkelethonResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : null as any;
            this.tipologiaID = _data["tipologiaID"] !== undefined ? _data["tipologiaID"] : null as any;
            this.trattamentoID = _data["trattamentoID"] !== undefined ? _data["trattamentoID"] : null as any;
            this.tipologiaKey = _data["tipologiaKey"] !== undefined ? _data["tipologiaKey"] : null as any;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : null as any;
            this.luogoServizioTappaID = _data["luogoServizioTappaID"] !== undefined ? _data["luogoServizioTappaID"] : null as any;
            if (Array.isArray(_data["tipologieDisponibili"])) {
                this.tipologieDisponibili = [] as any;
                for (let item of _data["tipologieDisponibili"])
                    this.tipologieDisponibili!.push(TripCreateType.fromJS(item));
            }
            else {
                this.tipologieDisponibili = null as any;
            }
            this.richiediQuotazione = _data["richiediQuotazione"] !== undefined ? _data["richiediQuotazione"] : null as any;
            this.roomsDef = _data["roomsDef"] !== undefined ? _data["roomsDef"] : null as any;
            this.roomsDefDefault = _data["roomsDefDefault"] !== undefined ? _data["roomsDefDefault"] : null as any;
            this.fromQuotationID = _data["fromQuotationID"] !== undefined ? _data["fromQuotationID"] : null as any;
        }
    }

    static override fromJS(data: any): GetTripSkelethonResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripSkelethonResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["servizio"] = this.servizio !== undefined ? this.servizio : null as any;
        data["tipologiaID"] = this.tipologiaID !== undefined ? this.tipologiaID : null as any;
        data["trattamentoID"] = this.trattamentoID !== undefined ? this.trattamentoID : null as any;
        data["tipologiaKey"] = this.tipologiaKey !== undefined ? this.tipologiaKey : null as any;
        data["partenza"] = this.partenza !== undefined ? this.partenza : null as any;
        data["luogoServizioTappaID"] = this.luogoServizioTappaID !== undefined ? this.luogoServizioTappaID : null as any;
        if (Array.isArray(this.tipologieDisponibili)) {
            data["tipologieDisponibili"] = [];
            for (let item of this.tipologieDisponibili)
                data["tipologieDisponibili"].push(item ? item.toJSON() : null as any);
        }
        data["richiediQuotazione"] = this.richiediQuotazione !== undefined ? this.richiediQuotazione : null as any;
        data["roomsDef"] = this.roomsDef !== undefined ? this.roomsDef : null as any;
        data["roomsDefDefault"] = this.roomsDefDefault !== undefined ? this.roomsDefDefault : null as any;
        data["fromQuotationID"] = this.fromQuotationID !== undefined ? this.fromQuotationID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTripSkelethonResponse extends ITripGetResponse {
    servizioID?: number | null;
    servizio?: string | null;
    tipologiaID?: number | null;
    trattamentoID?: number | null;
    tipologiaKey?: string | null;
    partenza?: string | null;
    luogoServizioTappaID?: number | null;
    tipologieDisponibili?: TripCreateType[] | null;
    richiediQuotazione?: boolean;
    roomsDef?: string;
    roomsDefDefault?: boolean;
    fromQuotationID?: number | null;
}

export class TripCreateType implements ITripCreateType {
    key?: string;
    tipologiaID?: number;
    nome?: string;
    trattamentoID?: number | null;
    trattamento?: string | null;
    aPartireDa?: number | null;

    constructor(data?: ITripCreateType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
            this.tipologiaID = _data["tipologiaID"] !== undefined ? _data["tipologiaID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.trattamentoID = _data["trattamentoID"] !== undefined ? _data["trattamentoID"] : null as any;
            this.trattamento = _data["trattamento"] !== undefined ? _data["trattamento"] : null as any;
            this.aPartireDa = _data["aPartireDa"] !== undefined ? _data["aPartireDa"] : null as any;
        }
    }

    static fromJS(data: any): TripCreateType {
        data = typeof data === 'object' ? data : {};
        let result = new TripCreateType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["tipologiaID"] = this.tipologiaID !== undefined ? this.tipologiaID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["trattamentoID"] = this.trattamentoID !== undefined ? this.trattamentoID : null as any;
        data["trattamento"] = this.trattamento !== undefined ? this.trattamento : null as any;
        data["aPartireDa"] = this.aPartireDa !== undefined ? this.aPartireDa : null as any;
        return data;
    }
}

export interface ITripCreateType {
    key?: string;
    tipologiaID?: number;
    nome?: string;
    trattamentoID?: number | null;
    trattamento?: string | null;
    aPartireDa?: number | null;
}

export class GetTripSkelethonRequest extends SiteRequest implements IGetTripSkelethonRequest {
    nomeCameraFormat!: string;
    nomeAdultoFormat!: string;
    nomeBambinoFormat!: string;
    offerta?: OffertaBase;
    servizioID?: number | null;
    tipologiaID?: number | null;
    itinerarioID?: number | null;
    quotationID?: number | null;
    partenza?: string | null;
    notti?: number | null;
    soloItinerario?: boolean;
    luogoID?: number | null;
    roomsDef?: string | null;

    constructor(data?: IGetTripSkelethonRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nomeCameraFormat = _data["nomeCameraFormat"] !== undefined ? _data["nomeCameraFormat"] : null as any;
            this.nomeAdultoFormat = _data["nomeAdultoFormat"] !== undefined ? _data["nomeAdultoFormat"] : null as any;
            this.nomeBambinoFormat = _data["nomeBambinoFormat"] !== undefined ? _data["nomeBambinoFormat"] : null as any;
            this.offerta = _data["offerta"] ? OffertaBase.fromJS(_data["offerta"]) : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.tipologiaID = _data["tipologiaID"] !== undefined ? _data["tipologiaID"] : null as any;
            this.itinerarioID = _data["itinerarioID"] !== undefined ? _data["itinerarioID"] : null as any;
            this.quotationID = _data["quotationID"] !== undefined ? _data["quotationID"] : null as any;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : null as any;
            this.notti = _data["notti"] !== undefined ? _data["notti"] : null as any;
            this.soloItinerario = _data["soloItinerario"] !== undefined ? _data["soloItinerario"] : null as any;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : null as any;
            this.roomsDef = _data["roomsDef"] !== undefined ? _data["roomsDef"] : null as any;
        }
    }

    static override fromJS(data: any): GetTripSkelethonRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripSkelethonRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nomeCameraFormat"] = this.nomeCameraFormat !== undefined ? this.nomeCameraFormat : null as any;
        data["nomeAdultoFormat"] = this.nomeAdultoFormat !== undefined ? this.nomeAdultoFormat : null as any;
        data["nomeBambinoFormat"] = this.nomeBambinoFormat !== undefined ? this.nomeBambinoFormat : null as any;
        data["offerta"] = this.offerta ? this.offerta.toJSON() : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["tipologiaID"] = this.tipologiaID !== undefined ? this.tipologiaID : null as any;
        data["itinerarioID"] = this.itinerarioID !== undefined ? this.itinerarioID : null as any;
        data["quotationID"] = this.quotationID !== undefined ? this.quotationID : null as any;
        data["partenza"] = this.partenza !== undefined ? this.partenza : null as any;
        data["notti"] = this.notti !== undefined ? this.notti : null as any;
        data["soloItinerario"] = this.soloItinerario !== undefined ? this.soloItinerario : null as any;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : null as any;
        data["roomsDef"] = this.roomsDef !== undefined ? this.roomsDef : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTripSkelethonRequest extends ISiteRequest {
    nomeCameraFormat: string;
    nomeAdultoFormat: string;
    nomeBambinoFormat: string;
    offerta?: OffertaBase;
    servizioID?: number | null;
    tipologiaID?: number | null;
    itinerarioID?: number | null;
    quotationID?: number | null;
    partenza?: string | null;
    notti?: number | null;
    soloItinerario?: boolean;
    luogoID?: number | null;
    roomsDef?: string | null;
}

export abstract class OffertaBase implements IOffertaBase {
    offertaID?: number;
    riferimento?: number;
    descrizione?: string | null;
    destinazioneID?: number | null;
    creazione?: string;
    partenza?: string;
    tipo?: ETipoViaggio | null;
    impiegatoUtenteID?: number;
    totale?: number | null;
    totaleCommissione?: number | null;
    totaleCommissioneCee?: number | null;
    totaleCosto?: number | null;
    operatore?: EOperatore;
    codiceAeroportoPartenza?: string | null;
    note?: string | null;
    numeroPax?: number | null;
    versione?: number;
    cookie?: string | null;
    nozze?: boolean;
    templateID?: number | null;
    servizioID?: number | null;
    tipologiaID?: number | null;
    offertaOrigineID?: number | null;
    titoloViaggio?: string | null;
    ritorno?: string | null;

    constructor(data?: IOffertaBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.riferimento = _data["riferimento"] !== undefined ? _data["riferimento"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.destinazioneID = _data["destinazioneID"] !== undefined ? _data["destinazioneID"] : null as any;
            this.creazione = _data["creazione"] !== undefined ? _data["creazione"] : null as any;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : null as any;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : null as any;
            this.impiegatoUtenteID = _data["impiegatoUtenteID"] !== undefined ? _data["impiegatoUtenteID"] : null as any;
            this.totale = _data["totale"] !== undefined ? _data["totale"] : null as any;
            this.totaleCommissione = _data["totaleCommissione"] !== undefined ? _data["totaleCommissione"] : null as any;
            this.totaleCommissioneCee = _data["totaleCommissioneCee"] !== undefined ? _data["totaleCommissioneCee"] : null as any;
            this.totaleCosto = _data["totaleCosto"] !== undefined ? _data["totaleCosto"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.codiceAeroportoPartenza = _data["codiceAeroportoPartenza"] !== undefined ? _data["codiceAeroportoPartenza"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.numeroPax = _data["numeroPax"] !== undefined ? _data["numeroPax"] : null as any;
            this.versione = _data["versione"] !== undefined ? _data["versione"] : null as any;
            this.cookie = _data["cookie"] !== undefined ? _data["cookie"] : null as any;
            this.nozze = _data["nozze"] !== undefined ? _data["nozze"] : null as any;
            this.templateID = _data["templateID"] !== undefined ? _data["templateID"] : null as any;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : null as any;
            this.tipologiaID = _data["tipologiaID"] !== undefined ? _data["tipologiaID"] : null as any;
            this.offertaOrigineID = _data["offertaOrigineID"] !== undefined ? _data["offertaOrigineID"] : null as any;
            this.titoloViaggio = _data["titoloViaggio"] !== undefined ? _data["titoloViaggio"] : null as any;
            this.ritorno = _data["ritorno"] !== undefined ? _data["ritorno"] : null as any;
        }
    }

    static fromJS(data: any): OffertaBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'OffertaBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["riferimento"] = this.riferimento !== undefined ? this.riferimento : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["destinazioneID"] = this.destinazioneID !== undefined ? this.destinazioneID : null as any;
        data["creazione"] = this.creazione !== undefined ? this.creazione : null as any;
        data["partenza"] = this.partenza !== undefined ? this.partenza : null as any;
        data["tipo"] = this.tipo !== undefined ? this.tipo : null as any;
        data["impiegatoUtenteID"] = this.impiegatoUtenteID !== undefined ? this.impiegatoUtenteID : null as any;
        data["totale"] = this.totale !== undefined ? this.totale : null as any;
        data["totaleCommissione"] = this.totaleCommissione !== undefined ? this.totaleCommissione : null as any;
        data["totaleCommissioneCee"] = this.totaleCommissioneCee !== undefined ? this.totaleCommissioneCee : null as any;
        data["totaleCosto"] = this.totaleCosto !== undefined ? this.totaleCosto : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["codiceAeroportoPartenza"] = this.codiceAeroportoPartenza !== undefined ? this.codiceAeroportoPartenza : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["numeroPax"] = this.numeroPax !== undefined ? this.numeroPax : null as any;
        data["versione"] = this.versione !== undefined ? this.versione : null as any;
        data["cookie"] = this.cookie !== undefined ? this.cookie : null as any;
        data["nozze"] = this.nozze !== undefined ? this.nozze : null as any;
        data["templateID"] = this.templateID !== undefined ? this.templateID : null as any;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : null as any;
        data["tipologiaID"] = this.tipologiaID !== undefined ? this.tipologiaID : null as any;
        data["offertaOrigineID"] = this.offertaOrigineID !== undefined ? this.offertaOrigineID : null as any;
        data["titoloViaggio"] = this.titoloViaggio !== undefined ? this.titoloViaggio : null as any;
        data["ritorno"] = this.ritorno !== undefined ? this.ritorno : null as any;
        return data;
    }
}

export interface IOffertaBase {
    offertaID?: number;
    riferimento?: number;
    descrizione?: string | null;
    destinazioneID?: number | null;
    creazione?: string;
    partenza?: string;
    tipo?: ETipoViaggio | null;
    impiegatoUtenteID?: number;
    totale?: number | null;
    totaleCommissione?: number | null;
    totaleCommissioneCee?: number | null;
    totaleCosto?: number | null;
    operatore?: EOperatore;
    codiceAeroportoPartenza?: string | null;
    note?: string | null;
    numeroPax?: number | null;
    versione?: number;
    cookie?: string | null;
    nozze?: boolean;
    templateID?: number | null;
    servizioID?: number | null;
    tipologiaID?: number | null;
    offertaOrigineID?: number | null;
    titoloViaggio?: string | null;
    ritorno?: string | null;
}

export class InviaDocumentiRequest extends TripGetRequest implements IInviaDocumentiRequest {
    recipient?: string | null;
    documentiId?: number[] | null;
    testo?: string | null;
    nomiDocumenti?: { [key in keyof typeof ETipoDocumento]?: string; } | null;

    constructor(data?: IInviaDocumentiRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.recipient = _data["recipient"] !== undefined ? _data["recipient"] : null as any;
            if (Array.isArray(_data["documentiId"])) {
                this.documentiId = [] as any;
                for (let item of _data["documentiId"])
                    this.documentiId!.push(item);
            }
            else {
                this.documentiId = null as any;
            }
            this.testo = _data["testo"] !== undefined ? _data["testo"] : null as any;
            if (_data["nomiDocumenti"]) {
                this.nomiDocumenti = {} as any;
                for (let key in _data["nomiDocumenti"]) {
                    if (_data["nomiDocumenti"].hasOwnProperty(key))
                        (this.nomiDocumenti as any)![key] = _data["nomiDocumenti"][key] !== undefined ? _data["nomiDocumenti"][key] : null as any;
                }
            }
            else {
                this.nomiDocumenti = null as any;
            }
        }
    }

    static override fromJS(data: any): InviaDocumentiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InviaDocumentiRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipient"] = this.recipient !== undefined ? this.recipient : null as any;
        if (Array.isArray(this.documentiId)) {
            data["documentiId"] = [];
            for (let item of this.documentiId)
                data["documentiId"].push(item);
        }
        data["testo"] = this.testo !== undefined ? this.testo : null as any;
        if (this.nomiDocumenti) {
            data["nomiDocumenti"] = {};
            for (let key in this.nomiDocumenti) {
                if (this.nomiDocumenti.hasOwnProperty(key))
                    (data["nomiDocumenti"] as any)[key] = this.nomiDocumenti[key] !== undefined ? this.nomiDocumenti[key] : null as any;
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInviaDocumentiRequest extends ITripGetRequest {
    recipient?: string | null;
    documentiId?: number[] | null;
    testo?: string | null;
    nomiDocumenti?: { [key in keyof typeof ETipoDocumento]?: string; } | null;
}

export class InviaDocumentoAgenziaRequest extends TripGetRequest implements IInviaDocumentoAgenziaRequest {
    tipoDocumento?: ETipoDocumento;
    recipient?: string | null;
    cc?: string | null;
    testo?: string | null;
    nomiDocumenti?: { [key in keyof typeof ETipoDocumento]?: string; } | null;

    constructor(data?: IInviaDocumentoAgenziaRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tipoDocumento = _data["tipoDocumento"] !== undefined ? _data["tipoDocumento"] : null as any;
            this.recipient = _data["recipient"] !== undefined ? _data["recipient"] : null as any;
            this.cc = _data["cc"] !== undefined ? _data["cc"] : null as any;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : null as any;
            if (_data["nomiDocumenti"]) {
                this.nomiDocumenti = {} as any;
                for (let key in _data["nomiDocumenti"]) {
                    if (_data["nomiDocumenti"].hasOwnProperty(key))
                        (this.nomiDocumenti as any)![key] = _data["nomiDocumenti"][key] !== undefined ? _data["nomiDocumenti"][key] : null as any;
                }
            }
            else {
                this.nomiDocumenti = null as any;
            }
        }
    }

    static override fromJS(data: any): InviaDocumentoAgenziaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InviaDocumentoAgenziaRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoDocumento"] = this.tipoDocumento !== undefined ? this.tipoDocumento : null as any;
        data["recipient"] = this.recipient !== undefined ? this.recipient : null as any;
        data["cc"] = this.cc !== undefined ? this.cc : null as any;
        data["testo"] = this.testo !== undefined ? this.testo : null as any;
        if (this.nomiDocumenti) {
            data["nomiDocumenti"] = {};
            for (let key in this.nomiDocumenti) {
                if (this.nomiDocumenti.hasOwnProperty(key))
                    (data["nomiDocumenti"] as any)[key] = this.nomiDocumenti[key] !== undefined ? this.nomiDocumenti[key] : null as any;
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInviaDocumentoAgenziaRequest extends ITripGetRequest {
    tipoDocumento?: ETipoDocumento;
    recipient?: string | null;
    cc?: string | null;
    testo?: string | null;
    nomiDocumenti?: { [key in keyof typeof ETipoDocumento]?: string; } | null;
}

export class InviaQuotationReadyRequest extends SiteRequest implements IInviaQuotationReadyRequest {
    offertaID!: number;
    recipient!: string;
    recipientID!: number;
    quotationLink!: string;
    checkFileExistence?: boolean;

    constructor(data?: IInviaQuotationReadyRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.recipient = _data["recipient"] !== undefined ? _data["recipient"] : null as any;
            this.recipientID = _data["recipientID"] !== undefined ? _data["recipientID"] : null as any;
            this.quotationLink = _data["quotationLink"] !== undefined ? _data["quotationLink"] : null as any;
            this.checkFileExistence = _data["checkFileExistence"] !== undefined ? _data["checkFileExistence"] : null as any;
        }
    }

    static override fromJS(data: any): InviaQuotationReadyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InviaQuotationReadyRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["recipient"] = this.recipient !== undefined ? this.recipient : null as any;
        data["recipientID"] = this.recipientID !== undefined ? this.recipientID : null as any;
        data["quotationLink"] = this.quotationLink !== undefined ? this.quotationLink : null as any;
        data["checkFileExistence"] = this.checkFileExistence !== undefined ? this.checkFileExistence : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IInviaQuotationReadyRequest extends ISiteRequest {
    offertaID: number;
    recipient: string;
    recipientID: number;
    quotationLink: string;
    checkFileExistence?: boolean;
}

export class InviaVoucherRequest extends TripGetRequest implements IInviaVoucherRequest {
    recipient?: string | null;
    voucherIds?: number[] | null;
    testo?: string | null;

    constructor(data?: IInviaVoucherRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.recipient = _data["recipient"] !== undefined ? _data["recipient"] : null as any;
            if (Array.isArray(_data["voucherIds"])) {
                this.voucherIds = [] as any;
                for (let item of _data["voucherIds"])
                    this.voucherIds!.push(item);
            }
            else {
                this.voucherIds = null as any;
            }
            this.testo = _data["testo"] !== undefined ? _data["testo"] : null as any;
        }
    }

    static override fromJS(data: any): InviaVoucherRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InviaVoucherRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipient"] = this.recipient !== undefined ? this.recipient : null as any;
        if (Array.isArray(this.voucherIds)) {
            data["voucherIds"] = [];
            for (let item of this.voucherIds)
                data["voucherIds"].push(item);
        }
        data["testo"] = this.testo !== undefined ? this.testo : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IInviaVoucherRequest extends ITripGetRequest {
    recipient?: string | null;
    voucherIds?: number[] | null;
    testo?: string | null;
}

export class RecalcAnticipoFornitoreResponse extends OkApiResponse implements IRecalcAnticipoFornitoreResponse {
    riga?: OffertaDato;
    stato?: OffertaDatoStato;
    nomeRegola?: string | null;

    constructor(data?: IRecalcAnticipoFornitoreResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.riga = _data["riga"] ? OffertaDato.fromJS(_data["riga"]) : null as any;
            this.stato = _data["stato"] ? OffertaDatoStato.fromJS(_data["stato"]) : null as any;
            this.nomeRegola = _data["nomeRegola"] !== undefined ? _data["nomeRegola"] : null as any;
        }
    }

    static override fromJS(data: any): RecalcAnticipoFornitoreResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RecalcAnticipoFornitoreResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["riga"] = this.riga ? this.riga.toJSON() : null as any;
        data["stato"] = this.stato ? this.stato.toJSON() : null as any;
        data["nomeRegola"] = this.nomeRegola !== undefined ? this.nomeRegola : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IRecalcAnticipoFornitoreResponse extends IOkApiResponse {
    riga?: OffertaDato;
    stato?: OffertaDatoStato;
    nomeRegola?: string | null;
}

export class RecalcAnticipoFornitoreRequest extends SiteRequest implements IRecalcAnticipoFornitoreRequest {
    riga!: OffertaDato;
    stato!: OffertaDatoStato;

    constructor(data?: IRecalcAnticipoFornitoreRequest) {
        super(data);
        if (!data) {
            this.riga = new OffertaDato();
            this.stato = new OffertaDatoStato();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.riga = _data["riga"] ? OffertaDato.fromJS(_data["riga"]) : new OffertaDato();
            this.stato = _data["stato"] ? OffertaDatoStato.fromJS(_data["stato"]) : new OffertaDatoStato();
        }
    }

    static override fromJS(data: any): RecalcAnticipoFornitoreRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RecalcAnticipoFornitoreRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["riga"] = this.riga ? this.riga.toJSON() : null as any;
        data["stato"] = this.stato ? this.stato.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IRecalcAnticipoFornitoreRequest extends ISiteRequest {
    riga: OffertaDato;
    stato: OffertaDatoStato;
}

export class RecalcPricesResponse extends OkApiResponse implements IRecalcPricesResponse {
    riga?: OffertaDato | null;

    constructor(data?: IRecalcPricesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.riga = _data["riga"] ? OffertaDato.fromJS(_data["riga"]) : null as any;
        }
    }

    static override fromJS(data: any): RecalcPricesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RecalcPricesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["riga"] = this.riga ? this.riga.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IRecalcPricesResponse extends IOkApiResponse {
    riga?: OffertaDato | null;
}

export class RecalcPricesRequest extends SiteRequest implements IRecalcPricesRequest {
    riga?: OffertaDato | null;
    moltiplicaPax?: boolean;

    constructor(data?: IRecalcPricesRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.riga = _data["riga"] ? OffertaDato.fromJS(_data["riga"]) : null as any;
            this.moltiplicaPax = _data["moltiplicaPax"] !== undefined ? _data["moltiplicaPax"] : null as any;
        }
    }

    static override fromJS(data: any): RecalcPricesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RecalcPricesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["riga"] = this.riga ? this.riga.toJSON() : null as any;
        data["moltiplicaPax"] = this.moltiplicaPax !== undefined ? this.moltiplicaPax : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IRecalcPricesRequest extends ISiteRequest {
    riga?: OffertaDato | null;
    moltiplicaPax?: boolean;
}

export class ResetVerificaPaxVoloRequest extends TripGetRequest implements IResetVerificaPaxVoloRequest {
    /** ID del volo del quale resettare il flag */
    voloID?: number;

    constructor(data?: IResetVerificaPaxVoloRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.voloID = _data["voloID"] !== undefined ? _data["voloID"] : null as any;
        }
    }

    static override fromJS(data: any): ResetVerificaPaxVoloRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetVerificaPaxVoloRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voloID"] = this.voloID !== undefined ? this.voloID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IResetVerificaPaxVoloRequest extends ITripGetRequest {
    /** ID del volo del quale resettare il flag */
    voloID?: number;
}

export class RichiestaSupportoBookingRequest extends TripGetRequest implements IRichiestaSupportoBookingRequest {
    messaggio!: string;
    teamID?: number | null;

    constructor(data?: IRichiestaSupportoBookingRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.messaggio = _data["messaggio"] !== undefined ? _data["messaggio"] : null as any;
            this.teamID = _data["teamID"] !== undefined ? _data["teamID"] : null as any;
        }
    }

    static override fromJS(data: any): RichiestaSupportoBookingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RichiestaSupportoBookingRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messaggio"] = this.messaggio !== undefined ? this.messaggio : null as any;
        data["teamID"] = this.teamID !== undefined ? this.teamID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IRichiestaSupportoBookingRequest extends ITripGetRequest {
    messaggio: string;
    teamID?: number | null;
}

export class SbloccaConfermaRequest extends TripGetRequest implements ISbloccaConfermaRequest {
    righeDaSbloccareIDs?: number[];

    constructor(data?: ISbloccaConfermaRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["righeDaSbloccareIDs"])) {
                this.righeDaSbloccareIDs = [] as any;
                for (let item of _data["righeDaSbloccareIDs"])
                    this.righeDaSbloccareIDs!.push(item);
            }
            else {
                this.righeDaSbloccareIDs = null as any;
            }
        }
    }

    static override fromJS(data: any): SbloccaConfermaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SbloccaConfermaRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.righeDaSbloccareIDs)) {
            data["righeDaSbloccareIDs"] = [];
            for (let item of this.righeDaSbloccareIDs)
                data["righeDaSbloccareIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISbloccaConfermaRequest extends ITripGetRequest {
    righeDaSbloccareIDs?: number[];
}

export class SbloccaItinerarioRequest extends TripGetRequest implements ISbloccaItinerarioRequest {

    constructor(data?: ISbloccaItinerarioRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SbloccaItinerarioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SbloccaItinerarioRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISbloccaItinerarioRequest extends ITripGetRequest {
}

export class SetTripDescriptionsResponse extends GetTripDescriptionsResponse implements ISetTripDescriptionsResponse {

    constructor(data?: ISetTripDescriptionsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SetTripDescriptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetTripDescriptionsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISetTripDescriptionsResponse extends IGetTripDescriptionsResponse {
}

export class SetTripDescriptionsRequest extends SiteRequest implements ISetTripDescriptionsRequest {
    offertaID?: number;
    descriptions?: TripDescriptionDay[];

    constructor(data?: ISetTripDescriptionsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            if (Array.isArray(_data["descriptions"])) {
                this.descriptions = [] as any;
                for (let item of _data["descriptions"])
                    this.descriptions!.push(TripDescriptionDay.fromJS(item));
            }
            else {
                this.descriptions = null as any;
            }
        }
    }

    static override fromJS(data: any): SetTripDescriptionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetTripDescriptionsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        if (Array.isArray(this.descriptions)) {
            data["descriptions"] = [];
            for (let item of this.descriptions)
                data["descriptions"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetTripDescriptionsRequest extends ISiteRequest {
    offertaID?: number;
    descriptions?: TripDescriptionDay[];
}

export class UpdateRequest extends TripGetRequest implements IUpdateRequest {
    offerta?: OffertaBase | null;

    constructor(data?: IUpdateRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offerta = _data["offerta"] ? OffertaBase.fromJS(_data["offerta"]) : null as any;
        }
    }

    static override fromJS(data: any): UpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offerta"] = this.offerta ? this.offerta.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateRequest extends ITripGetRequest {
    offerta?: OffertaBase | null;
}

export class UpdateAgenziaRequest extends TripGetRequest implements IUpdateAgenziaRequest {
    /** Operatore da assegnare alla pratica.
Se null (campo assente dal JSON) l'operatore della pratica resta invariato.
Indefinito non è un valore ammesso e viene rifiutato da
UpdateAgenzia. */
    operatore?: EOperatore | null;
    /** Entit� dell'offerta agenzia */
    offertaAgenzia?: OffertaAgenzia | null;
    /** Elenco degli id dei tag da assegnare */
    tagIds?: number[] | null;

    constructor(data?: IUpdateAgenziaRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.offertaAgenzia = _data["offertaAgenzia"] ? OffertaAgenzia.fromJS(_data["offertaAgenzia"]) : null as any;
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            else {
                this.tagIds = null as any;
            }
        }
    }

    static override fromJS(data: any): UpdateAgenziaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAgenziaRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["offertaAgenzia"] = this.offertaAgenzia ? this.offertaAgenzia.toJSON() : null as any;
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateAgenziaRequest extends ITripGetRequest {
    /** Operatore da assegnare alla pratica.
Se null (campo assente dal JSON) l'operatore della pratica resta invariato.
Indefinito non è un valore ammesso e viene rifiutato da
UpdateAgenzia. */
    operatore?: EOperatore | null;
    /** Entit� dell'offerta agenzia */
    offertaAgenzia?: OffertaAgenzia | null;
    /** Elenco degli id dei tag da assegnare */
    tagIds?: number[] | null;
}

export class UpdateCamereSempliciRequest extends TripGetRequest implements IUpdateCamereSempliciRequest {
    camere?: CameraConClienti[] | null;

    constructor(data?: IUpdateCamereSempliciRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["camere"])) {
                this.camere = [] as any;
                for (let item of _data["camere"])
                    this.camere!.push(CameraConClienti.fromJS(item));
            }
            else {
                this.camere = null as any;
            }
        }
    }

    static override fromJS(data: any): UpdateCamereSempliciRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCamereSempliciRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.camere)) {
            data["camere"] = [];
            for (let item of this.camere)
                data["camere"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCamereSempliciRequest extends ITripGetRequest {
    camere?: CameraConClienti[] | null;
}

export class UpdateCamereCompletoRequest extends UpdateCamereSempliciRequest implements IUpdateCamereCompletoRequest {

    constructor(data?: IUpdateCamereCompletoRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UpdateCamereCompletoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCamereCompletoRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCamereCompletoRequest extends IUpdateCamereSempliciRequest {
}

export class CameraConClienti implements ICameraConClienti {
    abbinamento?: Abbinamento | null;
    clienti?: Cliente[] | null;

    constructor(data?: ICameraConClienti) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.abbinamento = _data["abbinamento"] ? Abbinamento.fromJS(_data["abbinamento"]) : null as any;
            if (Array.isArray(_data["clienti"])) {
                this.clienti = [] as any;
                for (let item of _data["clienti"])
                    this.clienti!.push(Cliente.fromJS(item));
            }
            else {
                this.clienti = null as any;
            }
        }
    }

    static fromJS(data: any): CameraConClienti {
        data = typeof data === 'object' ? data : {};
        let result = new CameraConClienti();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["abbinamento"] = this.abbinamento ? this.abbinamento.toJSON() : null as any;
        if (Array.isArray(this.clienti)) {
            data["clienti"] = [];
            for (let item of this.clienti)
                data["clienti"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ICameraConClienti {
    abbinamento?: Abbinamento | null;
    clienti?: Cliente[] | null;
}

export class UpdateClientiRequest extends TripGetRequest implements IUpdateClientiRequest {
    clienti?: ClienteDatoUpdate[] | null;

    constructor(data?: IUpdateClientiRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["clienti"])) {
                this.clienti = [] as any;
                for (let item of _data["clienti"])
                    this.clienti!.push(ClienteDatoUpdate.fromJS(item));
            }
            else {
                this.clienti = null as any;
            }
        }
    }

    static override fromJS(data: any): UpdateClientiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientiRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.clienti)) {
            data["clienti"] = [];
            for (let item of this.clienti)
                data["clienti"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateClientiRequest extends ITripGetRequest {
    clienti?: ClienteDatoUpdate[] | null;
}

export class UpdateConfirmDataRequest extends TripGetRequest implements IUpdateConfirmDataRequest {
    datiConferme!: DatiConfermaRiga[];

    constructor(data?: IUpdateConfirmDataRequest) {
        super(data);
        if (!data) {
            this.datiConferme = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datiConferme"])) {
                this.datiConferme = [] as any;
                for (let item of _data["datiConferme"])
                    this.datiConferme!.push(DatiConfermaRiga.fromJS(item));
            }
            else {
                this.datiConferme = null as any;
            }
        }
    }

    static override fromJS(data: any): UpdateConfirmDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConfirmDataRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datiConferme)) {
            data["datiConferme"] = [];
            for (let item of this.datiConferme)
                data["datiConferme"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateConfirmDataRequest extends ITripGetRequest {
    datiConferme: DatiConfermaRiga[];
}

export class UpdateDocumentDataRequest extends TripGetRequest implements IUpdateDocumentDataRequest {
    datiDocumenti!: DatiDocumentoRiga[];

    constructor(data?: IUpdateDocumentDataRequest) {
        super(data);
        if (!data) {
            this.datiDocumenti = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datiDocumenti"])) {
                this.datiDocumenti = [] as any;
                for (let item of _data["datiDocumenti"])
                    this.datiDocumenti!.push(DatiDocumentoRiga.fromJS(item));
            }
            else {
                this.datiDocumenti = null as any;
            }
        }
    }

    static override fromJS(data: any): UpdateDocumentDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentDataRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datiDocumenti)) {
            data["datiDocumenti"] = [];
            for (let item of this.datiDocumenti)
                data["datiDocumenti"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateDocumentDataRequest extends ITripGetRequest {
    datiDocumenti: DatiDocumentoRiga[];
}

export class UpdateFlightsTicketsRequest extends GetFlightsTicketsRequest implements IUpdateFlightsTicketsRequest {
    tickets!: VoloTickets[];

    constructor(data?: IUpdateFlightsTicketsRequest) {
        super(data);
        if (!data) {
            this.tickets = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tickets"])) {
                this.tickets = [] as any;
                for (let item of _data["tickets"])
                    this.tickets!.push(VoloTickets.fromJS(item));
            }
            else {
                this.tickets = null as any;
            }
        }
    }

    static override fromJS(data: any): UpdateFlightsTicketsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFlightsTicketsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tickets)) {
            data["tickets"] = [];
            for (let item of this.tickets)
                data["tickets"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateFlightsTicketsRequest extends IGetFlightsTicketsRequest {
    tickets: VoloTickets[];
}

export class UpdateItinerarioCompletoRequest extends TripGetRequest implements IUpdateItinerarioCompletoRequest {
    partenza?: string;
    itinerario?: OffertaItinerario[] | null;
    eliminaServiziSuCambioLuogo?: boolean;
    aggiustaServizi?: boolean;

    constructor(data?: IUpdateItinerarioCompletoRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : null as any;
            if (Array.isArray(_data["itinerario"])) {
                this.itinerario = [] as any;
                for (let item of _data["itinerario"])
                    this.itinerario!.push(OffertaItinerario.fromJS(item));
            }
            else {
                this.itinerario = null as any;
            }
            this.eliminaServiziSuCambioLuogo = _data["eliminaServiziSuCambioLuogo"] !== undefined ? _data["eliminaServiziSuCambioLuogo"] : null as any;
            this.aggiustaServizi = _data["aggiustaServizi"] !== undefined ? _data["aggiustaServizi"] : null as any;
        }
    }

    static override fromJS(data: any): UpdateItinerarioCompletoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateItinerarioCompletoRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partenza"] = this.partenza !== undefined ? this.partenza : null as any;
        if (Array.isArray(this.itinerario)) {
            data["itinerario"] = [];
            for (let item of this.itinerario)
                data["itinerario"].push(item ? item.toJSON() : null as any);
        }
        data["eliminaServiziSuCambioLuogo"] = this.eliminaServiziSuCambioLuogo !== undefined ? this.eliminaServiziSuCambioLuogo : null as any;
        data["aggiustaServizi"] = this.aggiustaServizi !== undefined ? this.aggiustaServizi : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateItinerarioCompletoRequest extends ITripGetRequest {
    partenza?: string;
    itinerario?: OffertaItinerario[] | null;
    eliminaServiziSuCambioLuogo?: boolean;
    aggiustaServizi?: boolean;
}

export class UpdateRigaResponse extends TripGetResponse implements IUpdateRigaResponse {
    /** Entit� della riga salvata */
    riga?: OffertaDato | null;
    /** Entit� dello status salvato */
    stato?: OffertaDatoStato | null;
    /** Dati Host-2-Host e aggiuntivi */
    datiH2H?: OffertaDatoH2H | null;
    /** Dati del servizio utili alla UI */
    servizio?: TripService | null;

    constructor(data?: IUpdateRigaResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.riga = _data["riga"] ? OffertaDato.fromJS(_data["riga"]) : null as any;
            this.stato = _data["stato"] ? OffertaDatoStato.fromJS(_data["stato"]) : null as any;
            this.datiH2H = _data["datiH2H"] ? OffertaDatoH2H.fromJS(_data["datiH2H"]) : null as any;
            this.servizio = _data["servizio"] ? TripService.fromJS(_data["servizio"]) : null as any;
        }
    }

    static override fromJS(data: any): UpdateRigaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRigaResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["riga"] = this.riga ? this.riga.toJSON() : null as any;
        data["stato"] = this.stato ? this.stato.toJSON() : null as any;
        data["datiH2H"] = this.datiH2H ? this.datiH2H.toJSON() : null as any;
        data["servizio"] = this.servizio ? this.servizio.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateRigaResponse extends ITripGetResponse {
    /** Entit� della riga salvata */
    riga?: OffertaDato | null;
    /** Entit� dello status salvato */
    stato?: OffertaDatoStato | null;
    /** Dati Host-2-Host e aggiuntivi */
    datiH2H?: OffertaDatoH2H | null;
    /** Dati del servizio utili alla UI */
    servizio?: TripService | null;
}

export class UpdateRigaRequest extends TripGetRequest implements IUpdateRigaRequest {
    riga!: OffertaDato;
    stato?: OffertaDatoStato | null;
    datiH2H?: OffertaDatoH2H | null;

    constructor(data?: IUpdateRigaRequest) {
        super(data);
        if (!data) {
            this.riga = new OffertaDato();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.riga = _data["riga"] ? OffertaDato.fromJS(_data["riga"]) : new OffertaDato();
            this.stato = _data["stato"] ? OffertaDatoStato.fromJS(_data["stato"]) : null as any;
            this.datiH2H = _data["datiH2H"] ? OffertaDatoH2H.fromJS(_data["datiH2H"]) : null as any;
        }
    }

    static override fromJS(data: any): UpdateRigaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRigaRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["riga"] = this.riga ? this.riga.toJSON() : null as any;
        data["stato"] = this.stato ? this.stato.toJSON() : null as any;
        data["datiH2H"] = this.datiH2H ? this.datiH2H.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateRigaRequest extends ITripGetRequest {
    riga: OffertaDato;
    stato?: OffertaDatoStato | null;
    datiH2H?: OffertaDatoH2H | null;
}

export class UpdateSkelethonRequest extends TripGetRequest implements IUpdateSkelethonRequest {
    departureDate!: string;
    tripSteps!: TripStepData[];

    constructor(data?: IUpdateSkelethonRequest) {
        super(data);
        if (!data) {
            this.tripSteps = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.departureDate = _data["departureDate"] !== undefined ? _data["departureDate"] : null as any;
            if (Array.isArray(_data["tripSteps"])) {
                this.tripSteps = [] as any;
                for (let item of _data["tripSteps"])
                    this.tripSteps!.push(TripStepData.fromJS(item));
            }
            else {
                this.tripSteps = null as any;
            }
        }
    }

    static override fromJS(data: any): UpdateSkelethonRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSkelethonRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departureDate"] = this.departureDate !== undefined ? this.departureDate : null as any;
        if (Array.isArray(this.tripSteps)) {
            data["tripSteps"] = [];
            for (let item of this.tripSteps)
                data["tripSteps"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateSkelethonRequest extends ITripGetRequest {
    departureDate: string;
    tripSteps: TripStepData[];
}

export class TripStepData implements ITripStepData {
    stepID?: number;
    durationNights?: number;

    constructor(data?: ITripStepData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stepID = _data["stepID"] !== undefined ? _data["stepID"] : null as any;
            this.durationNights = _data["durationNights"] !== undefined ? _data["durationNights"] : null as any;
        }
    }

    static fromJS(data: any): TripStepData {
        data = typeof data === 'object' ? data : {};
        let result = new TripStepData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stepID"] = this.stepID !== undefined ? this.stepID : null as any;
        data["durationNights"] = this.durationNights !== undefined ? this.durationNights : null as any;
        return data;
    }
}

export interface ITripStepData {
    stepID?: number;
    durationNights?: number;
}

export class UpdateStatoRequest extends TripGetRequest implements IUpdateStatoRequest {
    offertaAgenziaStato?: OffertaAgenziaStato | null;

    constructor(data?: IUpdateStatoRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaAgenziaStato = _data["offertaAgenziaStato"] ? OffertaAgenziaStato.fromJS(_data["offertaAgenziaStato"]) : null as any;
        }
    }

    static override fromJS(data: any): UpdateStatoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStatoRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaAgenziaStato"] = this.offertaAgenziaStato ? this.offertaAgenziaStato.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateStatoRequest extends ITripGetRequest {
    offertaAgenziaStato?: OffertaAgenziaStato | null;
}

export class UpdateStatoPreventivoRequest extends TripGetRequest implements IUpdateStatoPreventivoRequest {
    statusPreventivo?: EStatusPreventivo;

    constructor(data?: IUpdateStatoPreventivoRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.statusPreventivo = _data["statusPreventivo"] !== undefined ? _data["statusPreventivo"] : null as any;
        }
    }

    static override fromJS(data: any): UpdateStatoPreventivoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStatoPreventivoRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusPreventivo"] = this.statusPreventivo !== undefined ? this.statusPreventivo : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateStatoPreventivoRequest extends ITripGetRequest {
    statusPreventivo?: EStatusPreventivo;
}

export class UpdateItinerarioRequest extends TripGetRequest implements IUpdateItinerarioRequest {
    itinerario?: OffertaItinerario | null;
    eliminaServiziSuCambioLuogo?: boolean;
    aggiustaServizi?: boolean;

    constructor(data?: IUpdateItinerarioRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.itinerario = _data["itinerario"] ? OffertaItinerario.fromJS(_data["itinerario"]) : null as any;
            this.eliminaServiziSuCambioLuogo = _data["eliminaServiziSuCambioLuogo"] !== undefined ? _data["eliminaServiziSuCambioLuogo"] : null as any;
            this.aggiustaServizi = _data["aggiustaServizi"] !== undefined ? _data["aggiustaServizi"] : null as any;
        }
    }

    static override fromJS(data: any): UpdateItinerarioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateItinerarioRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itinerario"] = this.itinerario ? this.itinerario.toJSON() : null as any;
        data["eliminaServiziSuCambioLuogo"] = this.eliminaServiziSuCambioLuogo !== undefined ? this.eliminaServiziSuCambioLuogo : null as any;
        data["aggiustaServizi"] = this.aggiustaServizi !== undefined ? this.aggiustaServizi : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateItinerarioRequest extends ITripGetRequest {
    itinerario?: OffertaItinerario | null;
    eliminaServiziSuCambioLuogo?: boolean;
    aggiustaServizi?: boolean;
}

export class UpdateVoucherResponse extends TripGetResponse implements IUpdateVoucherResponse {
    voucher?: Voucher | null;

    constructor(data?: IUpdateVoucherResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.voucher = _data["voucher"] ? Voucher.fromJS(_data["voucher"]) : null as any;
        }
    }

    static override fromJS(data: any): UpdateVoucherResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVoucherResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucher"] = this.voucher ? this.voucher.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateVoucherResponse extends ITripGetResponse {
    voucher?: Voucher | null;
}

export class UpdateVoucherRequest extends TripGetRequest implements IUpdateVoucherRequest {
    voucher?: Voucher | null;

    constructor(data?: IUpdateVoucherRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.voucher = _data["voucher"] ? Voucher.fromJS(_data["voucher"]) : null as any;
        }
    }

    static override fromJS(data: any): UpdateVoucherRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVoucherRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucher"] = this.voucher ? this.voucher.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateVoucherRequest extends ITripGetRequest {
    voucher?: Voucher | null;
}

/** Richiesta di cancellazione di una sincronizzazione. */
export class TripSyncJobDeleteRequest extends LocalizedRequest implements ITripSyncJobDeleteRequest {
    /** Identificativo della sincronizzazione da cancellare. */
    jobID?: number;

    constructor(data?: ITripSyncJobDeleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : null as any;
        }
    }

    static override fromJS(data: any): TripSyncJobDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TripSyncJobDeleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobID"] = this.jobID !== undefined ? this.jobID : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Richiesta di cancellazione di una sincronizzazione. */
export interface ITripSyncJobDeleteRequest extends ILocalizedRequest {
    /** Identificativo della sincronizzazione da cancellare. */
    jobID?: number;
}

/** Dettaglio di una sincronizzazione. */
export class TripSyncJobGetResponse extends OkApiResponse implements ITripSyncJobGetResponse {
    /** Sincronizzazione richiesta. */
    job?: TripSyncJobRow;

    constructor(data?: ITripSyncJobGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.job = _data["job"] ? TripSyncJobRow.fromJS(_data["job"]) : null as any;
        }
    }

    static override fromJS(data: any): TripSyncJobGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TripSyncJobGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["job"] = this.job ? this.job.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Dettaglio di una sincronizzazione. */
export interface ITripSyncJobGetResponse extends IOkApiResponse {
    /** Sincronizzazione richiesta. */
    job?: TripSyncJobRow;
}

/** Riga del registro. Condivisa da elenco, dettaglio e salvataggio. */
export class TripSyncJobRow implements ITripSyncJobRow {
    /** Identificativo della sincronizzazione. Valori minori o uguali a zero indicano una riga nuova
(il frontend usa identificativi negativi per i record non ancora salvati). */
    id?: number;
    /** Codice tecnico, univoco. Lunghezza massima: 50 caratteri. */
    code?: string;
    /** Nome leggibile, usato nei log. Lunghezza massima: 100 caratteri. */
    name?: string;
    /** Gestionale di destinazione. */
    provider?: ETripSyncProviders;
    /** Se la sincronizzazione va eseguita. Ad true la function oraria inizia a
inviare pratiche reali al gestionale. */
    enabled?: boolean;
    /** Stored procedure che restituisce l'elenco delle pratiche. Prefisso TripSync_
obbligatorio. Lunghezza massima: 128 caratteri. */
    selectionProcedure?: string;
    /** Note libere. Lunghezza massima: 400 caratteri. */
    notes?: string | null;
    /** Ultima modifica, già convertita nel fuso applicativo (a database è UTC). */
    updatedAt?: string;

    constructor(data?: ITripSyncJobRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.provider = _data["provider"] !== undefined ? _data["provider"] : null as any;
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : null as any;
            this.selectionProcedure = _data["selectionProcedure"] !== undefined ? _data["selectionProcedure"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : null as any;
        }
    }

    static fromJS(data: any): TripSyncJobRow {
        data = typeof data === 'object' ? data : {};
        let result = new TripSyncJobRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["provider"] = this.provider !== undefined ? this.provider : null as any;
        data["enabled"] = this.enabled !== undefined ? this.enabled : null as any;
        data["selectionProcedure"] = this.selectionProcedure !== undefined ? this.selectionProcedure : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : null as any;
        return data;
    }
}

/** Riga del registro. Condivisa da elenco, dettaglio e salvataggio. */
export interface ITripSyncJobRow {
    /** Identificativo della sincronizzazione. Valori minori o uguali a zero indicano una riga nuova
(il frontend usa identificativi negativi per i record non ancora salvati). */
    id?: number;
    /** Codice tecnico, univoco. Lunghezza massima: 50 caratteri. */
    code?: string;
    /** Nome leggibile, usato nei log. Lunghezza massima: 100 caratteri. */
    name?: string;
    /** Gestionale di destinazione. */
    provider?: ETripSyncProviders;
    /** Se la sincronizzazione va eseguita. Ad true la function oraria inizia a
inviare pratiche reali al gestionale. */
    enabled?: boolean;
    /** Stored procedure che restituisce l'elenco delle pratiche. Prefisso TripSync_
obbligatorio. Lunghezza massima: 128 caratteri. */
    selectionProcedure?: string;
    /** Note libere. Lunghezza massima: 400 caratteri. */
    notes?: string | null;
    /** Ultima modifica, già convertita nel fuso applicativo (a database è UTC). */
    updatedAt?: string;
}

/** Richiesta di dettaglio di una sincronizzazione. */
export class TripSyncJobGetRequest extends LocalizedRequest implements ITripSyncJobGetRequest {
    /** Identificativo della sincronizzazione da leggere. */
    jobID?: number;

    constructor(data?: ITripSyncJobGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : null as any;
        }
    }

    static override fromJS(data: any): TripSyncJobGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TripSyncJobGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobID"] = this.jobID !== undefined ? this.jobID : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Richiesta di dettaglio di una sincronizzazione. */
export interface ITripSyncJobGetRequest extends ILocalizedRequest {
    /** Identificativo della sincronizzazione da leggere. */
    jobID?: number;
}

/** Esito del salvataggio, con la riga come risulta a database. */
export class TripSyncJobSaveResponse extends OkApiResponse implements ITripSyncJobSaveResponse {
    /** Riga salvata, con l'identificativo reale e l'istante di modifica effettivo. */
    job?: TripSyncJobRow;

    constructor(data?: ITripSyncJobSaveResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.job = _data["job"] ? TripSyncJobRow.fromJS(_data["job"]) : null as any;
        }
    }

    static override fromJS(data: any): TripSyncJobSaveResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TripSyncJobSaveResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["job"] = this.job ? this.job.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Esito del salvataggio, con la riga come risulta a database. */
export interface ITripSyncJobSaveResponse extends IOkApiResponse {
    /** Riga salvata, con l'identificativo reale e l'istante di modifica effettivo. */
    job?: TripSyncJobRow;
}

/** Richiesta di inserimento o aggiornamento di una sincronizzazione. */
export class TripSyncJobSaveRequest extends LocalizedRequest implements ITripSyncJobSaveRequest {
    /** Sincronizzazione da salvare. */
    job?: TripSyncJobRow;

    constructor(data?: ITripSyncJobSaveRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.job = _data["job"] ? TripSyncJobRow.fromJS(_data["job"]) : null as any;
        }
    }

    static override fromJS(data: any): TripSyncJobSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TripSyncJobSaveRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["job"] = this.job ? this.job.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Richiesta di inserimento o aggiornamento di una sincronizzazione. */
export interface ITripSyncJobSaveRequest extends ILocalizedRequest {
    /** Sincronizzazione da salvare. */
    job?: TripSyncJobRow;
}

export class NrTableResponseOfTripSyncJobRow extends OkApiResponse implements INrTableResponseOfTripSyncJobRow {
    /** Array delle righe della pagina richiesta */
    rows?: TripSyncJobRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfTripSyncJobRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TripSyncJobRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfTripSyncJobRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfTripSyncJobRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfTripSyncJobRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: TripSyncJobRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

/** Filtri per l'elenco del registro. */
export class TripSyncJobsListRequest extends NrTableRequest implements ITripSyncJobsListRequest {
    /** Gestionale di destinazione; null per tutti. */
    provider?: ETripSyncProviders | null;
    /** Filtro su acceso/spento; null per entrambi. */
    enabled?: boolean | null;
    /** Ricerca parziale, senza distinzione di maiuscole, su codice, nome e note. */
    term?: string | null;

    constructor(data?: ITripSyncJobsListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.provider = _data["provider"] !== undefined ? _data["provider"] : null as any;
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : null as any;
            this.term = _data["term"] !== undefined ? _data["term"] : null as any;
        }
    }

    static override fromJS(data: any): TripSyncJobsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TripSyncJobsListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provider"] = this.provider !== undefined ? this.provider : null as any;
        data["enabled"] = this.enabled !== undefined ? this.enabled : null as any;
        data["term"] = this.term !== undefined ? this.term : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Filtri per l'elenco del registro. */
export interface ITripSyncJobsListRequest extends INrTableRequest {
    /** Gestionale di destinazione; null per tutti. */
    provider?: ETripSyncProviders | null;
    /** Filtro su acceso/spento; null per entrambi. */
    enabled?: boolean | null;
    /** Ricerca parziale, senza distinzione di maiuscole, su codice, nome e note. */
    term?: string | null;
}

/** Dettaglio di una riga di audit, con i corpi JSON di request e response. */
export class TripSyncLogGetResponse extends OkApiResponse implements ITripSyncLogGetResponse {
    /** Riga di audit, con gli stessi campi dell'elenco. */
    row?: TripSyncLogRow;
    /** Corpo inviato al gestionale. null se azzerato dalla retention: in quel caso
HasRequest è false e non è un errore. */
    requestJson?: string | null;
    /** Corpo grezzo ricevuto; null se azzerato dalla retention. */
    responseJson?: string | null;

    constructor(data?: ITripSyncLogGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.row = _data["row"] ? TripSyncLogRow.fromJS(_data["row"]) : null as any;
            this.requestJson = _data["requestJson"] !== undefined ? _data["requestJson"] : null as any;
            this.responseJson = _data["responseJson"] !== undefined ? _data["responseJson"] : null as any;
        }
    }

    static override fromJS(data: any): TripSyncLogGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TripSyncLogGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["row"] = this.row ? this.row.toJSON() : null as any;
        data["requestJson"] = this.requestJson !== undefined ? this.requestJson : null as any;
        data["responseJson"] = this.responseJson !== undefined ? this.responseJson : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Dettaglio di una riga di audit, con i corpi JSON di request e response. */
export interface ITripSyncLogGetResponse extends IOkApiResponse {
    /** Riga di audit, con gli stessi campi dell'elenco. */
    row?: TripSyncLogRow;
    /** Corpo inviato al gestionale. null se azzerato dalla retention: in quel caso
HasRequest è false e non è un errore. */
    requestJson?: string | null;
    /** Corpo grezzo ricevuto; null se azzerato dalla retention. */
    responseJson?: string | null;
}

/** Riga dell'elenco: tutte le colonne dell'audit tranne i corpi JSON, che si leggono solo aprendo il dettaglio. */
export class TripSyncLogRow implements ITripSyncLogRow {
    /** Identificativo della riga di audit. */
    id?: number;
    /** Gestionale di destinazione. */
    provider?: ETripSyncProviders;
    /** Pratica inviata (offerte.idofferta). */
    tripID?: number;
    /** Agenzia della pratica, quando disponibile. */
    agencyID?: number | null;
    /** Network dell'agenzia al momento dell'invio, quando disponibile: l'affiliazione corrente del
contatto, non lo snapshot scritto sulla pratica. */
    networkID?: number | null;
    /** Chi ha originato l'invio. */
    origin?: ETripSyncOrigin;
    /** Utente che ha richiesto l'invio; null per gli invii automatici. */
    userID?: number | null;
    /** Numero di tentativo per la stessa pratica nello stesso ciclo di invio. */
    attempt?: number;
    /** Istante di inizio dell'invio, già convertito nel fuso applicativo (a database è UTC). */
    startedAt?: string;
    /** Durata dell'invio in millisecondi; null se non misurata. */
    durationMs?: number | null;
    /** URL effettivamente chiamato, query string inclusa. */
    endpoint?: string | null;
    /** Status HTTP della risposta. null se la chiamata non è mai partita,
0 se è fallito il trasporto. */
    httpStatus?: number | null;
    /** Esito dell'invio. */
    outcome?: ETripSyncOutcome;
    /** Identificativo del preventivo restituito dal gestionale esterno. */
    remoteQuoteID?: string | null;
    /** Identificativo dell'opportunità restituito dal gestionale esterno. */
    remoteOpportunityID?: string | null;
    /** Operazione dichiarata dal gestionale esterno. */
    remoteOperation?: string | null;
    /** Descrizione sintetica dell'errore, quando l'invio non è riuscito. */
    errorMessage?: string | null;
    /** Nome dell'utente che ha richiesto l'invio; non ordinabile. */
    userName?: string | null;
    /** Nome dell'agenzia della pratica; non ordinabile. */
    agencyName?: string | null;
    /** Se il corpo della request è ancora conservato. A false quando la retention
lo ha azzerato: permette di distinguere "nulla da mostrare" da "errore di caricamento". */
    hasRequest?: boolean;
    /** Come HasRequest, per il corpo della response. */
    hasResponse?: boolean;

    constructor(data?: ITripSyncLogRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.provider = _data["provider"] !== undefined ? _data["provider"] : null as any;
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : null as any;
            this.agencyID = _data["agencyID"] !== undefined ? _data["agencyID"] : null as any;
            this.networkID = _data["networkID"] !== undefined ? _data["networkID"] : null as any;
            this.origin = _data["origin"] !== undefined ? _data["origin"] : null as any;
            this.userID = _data["userID"] !== undefined ? _data["userID"] : null as any;
            this.attempt = _data["attempt"] !== undefined ? _data["attempt"] : null as any;
            this.startedAt = _data["startedAt"] !== undefined ? _data["startedAt"] : null as any;
            this.durationMs = _data["durationMs"] !== undefined ? _data["durationMs"] : null as any;
            this.endpoint = _data["endpoint"] !== undefined ? _data["endpoint"] : null as any;
            this.httpStatus = _data["httpStatus"] !== undefined ? _data["httpStatus"] : null as any;
            this.outcome = _data["outcome"] !== undefined ? _data["outcome"] : null as any;
            this.remoteQuoteID = _data["remoteQuoteID"] !== undefined ? _data["remoteQuoteID"] : null as any;
            this.remoteOpportunityID = _data["remoteOpportunityID"] !== undefined ? _data["remoteOpportunityID"] : null as any;
            this.remoteOperation = _data["remoteOperation"] !== undefined ? _data["remoteOperation"] : null as any;
            this.errorMessage = _data["errorMessage"] !== undefined ? _data["errorMessage"] : null as any;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
            this.agencyName = _data["agencyName"] !== undefined ? _data["agencyName"] : null as any;
            this.hasRequest = _data["hasRequest"] !== undefined ? _data["hasRequest"] : null as any;
            this.hasResponse = _data["hasResponse"] !== undefined ? _data["hasResponse"] : null as any;
        }
    }

    static fromJS(data: any): TripSyncLogRow {
        data = typeof data === 'object' ? data : {};
        let result = new TripSyncLogRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["provider"] = this.provider !== undefined ? this.provider : null as any;
        data["tripID"] = this.tripID !== undefined ? this.tripID : null as any;
        data["agencyID"] = this.agencyID !== undefined ? this.agencyID : null as any;
        data["networkID"] = this.networkID !== undefined ? this.networkID : null as any;
        data["origin"] = this.origin !== undefined ? this.origin : null as any;
        data["userID"] = this.userID !== undefined ? this.userID : null as any;
        data["attempt"] = this.attempt !== undefined ? this.attempt : null as any;
        data["startedAt"] = this.startedAt !== undefined ? this.startedAt : null as any;
        data["durationMs"] = this.durationMs !== undefined ? this.durationMs : null as any;
        data["endpoint"] = this.endpoint !== undefined ? this.endpoint : null as any;
        data["httpStatus"] = this.httpStatus !== undefined ? this.httpStatus : null as any;
        data["outcome"] = this.outcome !== undefined ? this.outcome : null as any;
        data["remoteQuoteID"] = this.remoteQuoteID !== undefined ? this.remoteQuoteID : null as any;
        data["remoteOpportunityID"] = this.remoteOpportunityID !== undefined ? this.remoteOpportunityID : null as any;
        data["remoteOperation"] = this.remoteOperation !== undefined ? this.remoteOperation : null as any;
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        data["agencyName"] = this.agencyName !== undefined ? this.agencyName : null as any;
        data["hasRequest"] = this.hasRequest !== undefined ? this.hasRequest : null as any;
        data["hasResponse"] = this.hasResponse !== undefined ? this.hasResponse : null as any;
        return data;
    }
}

/** Riga dell'elenco: tutte le colonne dell'audit tranne i corpi JSON, che si leggono solo aprendo il dettaglio. */
export interface ITripSyncLogRow {
    /** Identificativo della riga di audit. */
    id?: number;
    /** Gestionale di destinazione. */
    provider?: ETripSyncProviders;
    /** Pratica inviata (offerte.idofferta). */
    tripID?: number;
    /** Agenzia della pratica, quando disponibile. */
    agencyID?: number | null;
    /** Network dell'agenzia al momento dell'invio, quando disponibile: l'affiliazione corrente del
contatto, non lo snapshot scritto sulla pratica. */
    networkID?: number | null;
    /** Chi ha originato l'invio. */
    origin?: ETripSyncOrigin;
    /** Utente che ha richiesto l'invio; null per gli invii automatici. */
    userID?: number | null;
    /** Numero di tentativo per la stessa pratica nello stesso ciclo di invio. */
    attempt?: number;
    /** Istante di inizio dell'invio, già convertito nel fuso applicativo (a database è UTC). */
    startedAt?: string;
    /** Durata dell'invio in millisecondi; null se non misurata. */
    durationMs?: number | null;
    /** URL effettivamente chiamato, query string inclusa. */
    endpoint?: string | null;
    /** Status HTTP della risposta. null se la chiamata non è mai partita,
0 se è fallito il trasporto. */
    httpStatus?: number | null;
    /** Esito dell'invio. */
    outcome?: ETripSyncOutcome;
    /** Identificativo del preventivo restituito dal gestionale esterno. */
    remoteQuoteID?: string | null;
    /** Identificativo dell'opportunità restituito dal gestionale esterno. */
    remoteOpportunityID?: string | null;
    /** Operazione dichiarata dal gestionale esterno. */
    remoteOperation?: string | null;
    /** Descrizione sintetica dell'errore, quando l'invio non è riuscito. */
    errorMessage?: string | null;
    /** Nome dell'utente che ha richiesto l'invio; non ordinabile. */
    userName?: string | null;
    /** Nome dell'agenzia della pratica; non ordinabile. */
    agencyName?: string | null;
    /** Se il corpo della request è ancora conservato. A false quando la retention
lo ha azzerato: permette di distinguere "nulla da mostrare" da "errore di caricamento". */
    hasRequest?: boolean;
    /** Come HasRequest, per il corpo della response. */
    hasResponse?: boolean;
}

export enum ETripSyncOrigin {
    OnDemand = "OnDemand",
    Scheduled = "Scheduled",
}

/** Richiesta di dettaglio di una riga di audit. */
export class TripSyncLogGetRequest extends LocalizedRequest implements ITripSyncLogGetRequest {
    /** Identificativo della riga di audit da leggere. */
    logID?: number;

    constructor(data?: ITripSyncLogGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.logID = _data["logID"] !== undefined ? _data["logID"] : null as any;
        }
    }

    static override fromJS(data: any): TripSyncLogGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TripSyncLogGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logID"] = this.logID !== undefined ? this.logID : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Richiesta di dettaglio di una riga di audit. */
export interface ITripSyncLogGetRequest extends ILocalizedRequest {
    /** Identificativo della riga di audit da leggere. */
    logID?: number;
}

export class NrTableResponseOfTripSyncLogRow extends OkApiResponse implements INrTableResponseOfTripSyncLogRow {
    /** Array delle righe della pagina richiesta */
    rows?: TripSyncLogRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfTripSyncLogRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TripSyncLogRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfTripSyncLogRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfTripSyncLogRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfTripSyncLogRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: TripSyncLogRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

/** Filtri per l'elenco paginato dell'audit degli invii. */
export class TripSyncLogsListRequest extends NrTableRequest implements ITripSyncLogsListRequest {
    /** Gestionale di destinazione; null per tutti. */
    provider?: ETripSyncProviders | null;
    /** Pratica (offerte.idofferta); null per tutte. */
    tripID?: number | null;
    /** Utente che ha richiesto l'invio; null per tutti. */
    userID?: number | null;
    /** Origine dell'invio; null per tutte. */
    origin?: ETripSyncOrigin | null;
    /** Esito dell'invio; null per tutti. */
    outcome?: ETripSyncOutcome | null;
    /** Se true restituisce solo gli invii non riusciti
(sfrutta l'indice filtrato IX_TripSyncLog_Failures). */
    onlyFailures?: boolean;
    /** Estremo iniziale su StartedAt, espresso nel fuso applicativo. Inclusivo dall'inizio
della giornata. */
    dateFrom?: string | null;
    /** Estremo finale su StartedAt, espresso nel fuso applicativo. Inclusivo di tutta
la giornata indicata. */
    dateTo?: string | null;
    /** Identificativo del preventivo restituito dal gestionale; confronto esatto. */
    remoteQuoteID?: string | null;

    constructor(data?: ITripSyncLogsListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.provider = _data["provider"] !== undefined ? _data["provider"] : null as any;
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : null as any;
            this.userID = _data["userID"] !== undefined ? _data["userID"] : null as any;
            this.origin = _data["origin"] !== undefined ? _data["origin"] : null as any;
            this.outcome = _data["outcome"] !== undefined ? _data["outcome"] : null as any;
            this.onlyFailures = _data["onlyFailures"] !== undefined ? _data["onlyFailures"] : null as any;
            this.dateFrom = _data["dateFrom"] !== undefined ? _data["dateFrom"] : null as any;
            this.dateTo = _data["dateTo"] !== undefined ? _data["dateTo"] : null as any;
            this.remoteQuoteID = _data["remoteQuoteID"] !== undefined ? _data["remoteQuoteID"] : null as any;
        }
    }

    static override fromJS(data: any): TripSyncLogsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TripSyncLogsListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provider"] = this.provider !== undefined ? this.provider : null as any;
        data["tripID"] = this.tripID !== undefined ? this.tripID : null as any;
        data["userID"] = this.userID !== undefined ? this.userID : null as any;
        data["origin"] = this.origin !== undefined ? this.origin : null as any;
        data["outcome"] = this.outcome !== undefined ? this.outcome : null as any;
        data["onlyFailures"] = this.onlyFailures !== undefined ? this.onlyFailures : null as any;
        data["dateFrom"] = this.dateFrom !== undefined ? this.dateFrom : null as any;
        data["dateTo"] = this.dateTo !== undefined ? this.dateTo : null as any;
        data["remoteQuoteID"] = this.remoteQuoteID !== undefined ? this.remoteQuoteID : null as any;
        super.toJSON(data);
        return data;
    }
}

/** Filtri per l'elenco paginato dell'audit degli invii. */
export interface ITripSyncLogsListRequest extends INrTableRequest {
    /** Gestionale di destinazione; null per tutti. */
    provider?: ETripSyncProviders | null;
    /** Pratica (offerte.idofferta); null per tutte. */
    tripID?: number | null;
    /** Utente che ha richiesto l'invio; null per tutti. */
    userID?: number | null;
    /** Origine dell'invio; null per tutte. */
    origin?: ETripSyncOrigin | null;
    /** Esito dell'invio; null per tutti. */
    outcome?: ETripSyncOutcome | null;
    /** Se true restituisce solo gli invii non riusciti
(sfrutta l'indice filtrato IX_TripSyncLog_Failures). */
    onlyFailures?: boolean;
    /** Estremo iniziale su StartedAt, espresso nel fuso applicativo. Inclusivo dall'inizio
della giornata. */
    dateFrom?: string | null;
    /** Estremo finale su StartedAt, espresso nel fuso applicativo. Inclusivo di tutta
la giornata indicata. */
    dateTo?: string | null;
    /** Identificativo del preventivo restituito dal gestionale; confronto esatto. */
    remoteQuoteID?: string | null;
}

export class ChangePasswordRequest extends ApiRequest implements IChangePasswordRequest {
    /** Password attuale */
    currentPassword!: string;
    /** Nuova password */
    newPassword!: string;

    constructor(data?: IChangePasswordRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.currentPassword = _data["currentPassword"] !== undefined ? _data["currentPassword"] : null as any;
            this.newPassword = _data["newPassword"] !== undefined ? _data["newPassword"] : null as any;
        }
    }

    static override fromJS(data: any): ChangePasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword !== undefined ? this.currentPassword : null as any;
        data["newPassword"] = this.newPassword !== undefined ? this.newPassword : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IChangePasswordRequest extends IApiRequest {
    /** Password attuale */
    currentPassword: string;
    /** Nuova password */
    newPassword: string;
}

export class CreateCrossLoginResponse extends OkApiResponse implements ICreateCrossLoginResponse {
    /** Codice univoco monouso */
    codice?: string;

    constructor(data?: ICreateCrossLoginResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
        }
    }

    static override fromJS(data: any): CreateCrossLoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCrossLoginResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateCrossLoginResponse extends IOkApiResponse {
    /** Codice univoco monouso */
    codice?: string;
}

export class CreateCrossLoginRequest extends ApiRequest implements ICreateCrossLoginRequest {
    /** ID dell'utente da impersonare */
    targetUserID!: number;

    constructor(data?: ICreateCrossLoginRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.targetUserID = _data["targetUserID"] !== undefined ? _data["targetUserID"] : null as any;
        }
    }

    static override fromJS(data: any): CreateCrossLoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCrossLoginRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetUserID"] = this.targetUserID !== undefined ? this.targetUserID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateCrossLoginRequest extends IApiRequest {
    /** ID dell'utente da impersonare */
    targetUserID: number;
}

export class ListTeamsResponse extends OkApiResponse implements IListTeamsResponse {
    teams?: Team[];

    constructor(data?: IListTeamsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["teams"])) {
                this.teams = [] as any;
                for (let item of _data["teams"])
                    this.teams!.push(Team.fromJS(item));
            }
            else {
                this.teams = null as any;
            }
        }
    }

    static override fromJS(data: any): ListTeamsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListTeamsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.teams)) {
            data["teams"] = [];
            for (let item of this.teams)
                data["teams"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IListTeamsResponse extends IOkApiResponse {
    teams?: Team[];
}

export class UpdateTeamResponse extends ListTeamsResponse implements IUpdateTeamResponse {
    /** Entità Team modificata */
    team?: Team;

    constructor(data?: IUpdateTeamResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.team = _data["team"] ? Team.fromJS(_data["team"]) : null as any;
        }
    }

    static override fromJS(data: any): UpdateTeamResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTeamResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["team"] = this.team ? this.team.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateTeamResponse extends IListTeamsResponse {
    /** Entità Team modificata */
    team?: Team;
}

export class UpdateTeamRequest extends ApiRequest implements IUpdateTeamRequest {
    team!: TeamBase;

    constructor(data?: IUpdateTeamRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.team = _data["team"] ? TeamBase.fromJS(_data["team"]) : null as any;
        }
    }

    static override fromJS(data: any): UpdateTeamRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTeamRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["team"] = this.team ? this.team.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateTeamRequest extends IApiRequest {
    team: TeamBase;
}

export abstract class TeamBase implements ITeamBase {
    teamID?: string;
    nome?: string;
    email?: string | null;
    visibilita?: EVisibilitaTeam;

    constructor(data?: ITeamBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamID = _data["teamID"] !== undefined ? _data["teamID"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.visibilita = _data["visibilita"] !== undefined ? _data["visibilita"] : null as any;
        }
    }

    static fromJS(data: any): TeamBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'TeamBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamID"] = this.teamID !== undefined ? this.teamID : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["visibilita"] = this.visibilita !== undefined ? this.visibilita : null as any;
        return data;
    }
}

export interface ITeamBase {
    teamID?: string;
    nome?: string;
    email?: string | null;
    visibilita?: EVisibilitaTeam;
}

export class UserGetRequest extends LocalizedRequest implements IUserGetRequest {
    /** ID dell'utente di cui chiedere i dati */
    id!: number;

    constructor(data?: IUserGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): UserGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUserGetRequest extends ILocalizedRequest {
    /** ID dell'utente di cui chiedere i dati */
    id: number;
}

export class UserDeleteRequest extends UserGetRequest implements IUserDeleteRequest {

    constructor(data?: IUserDeleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UserDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserDeleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUserDeleteRequest extends IUserGetRequest {
}

export class DeleteMultiUserRequest extends ApiRequest implements IDeleteMultiUserRequest {
    /** Lista degli ID da eliminare */
    userIDs!: number[];

    constructor(data?: IDeleteMultiUserRequest) {
        super(data);
        if (!data) {
            this.userIDs = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["userIDs"])) {
                this.userIDs = [] as any;
                for (let item of _data["userIDs"])
                    this.userIDs!.push(item);
            }
            else {
                this.userIDs = null as any;
            }
        }
    }

    static override fromJS(data: any): DeleteMultiUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMultiUserRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIDs)) {
            data["userIDs"] = [];
            for (let item of this.userIDs)
                data["userIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteMultiUserRequest extends IApiRequest {
    /** Lista degli ID da eliminare */
    userIDs: number[];
}

export class EnableFastLoginFromExcelResponse extends OkApiResponse implements IEnableFastLoginFromExcelResponse {

    constructor(data?: IEnableFastLoginFromExcelResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): EnableFastLoginFromExcelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnableFastLoginFromExcelResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IEnableFastLoginFromExcelResponse extends IOkApiResponse {
}

export class UserGetResponse extends OkApiResponse implements IUserGetResponse {
    /** Dati dell'utente con l'ID richiesto oppure null */
    row?: UsersListRow | null;

    constructor(data?: IUserGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.row = _data["row"] ? UsersListRow.fromJS(_data["row"]) : null as any;
        }
    }

    static override fromJS(data: any): UserGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["row"] = this.row ? this.row.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUserGetResponse extends IOkApiResponse {
    /** Dati dell'utente con l'ID richiesto oppure null */
    row?: UsersListRow | null;
}

/** Classe di visualizzazione della riga nella lista utenti */
export class UsersListRow implements IUsersListRow {
    /** ID dell'utente */
    id?: number;
    /** Indirizzo email dell'utente */
    email?: string | null;
    /** Nome completo */
    nomeVisualizzato?: string;
    /** Tipo di utente */
    tipoUtente?: ETipoUtente;
    /** Data e ora di creazione dell'utente */
    dataRegistrazione?: string;
    /** Nome dell'eventuale agenzia associata all'utente */
    nomeAgenzia?: string | null;
    /** Entità dell'utente (evita un roundtrip sul server quando si apre l'editor) */
    utente?: Utente;
    fastLoginTokenIsValid?: boolean;
    emailLoginEnabled?: boolean;

    constructor(data?: IUsersListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.nomeVisualizzato = _data["nomeVisualizzato"] !== undefined ? _data["nomeVisualizzato"] : null as any;
            this.tipoUtente = _data["tipoUtente"] !== undefined ? _data["tipoUtente"] : null as any;
            this.dataRegistrazione = _data["dataRegistrazione"] !== undefined ? _data["dataRegistrazione"] : null as any;
            this.nomeAgenzia = _data["nomeAgenzia"] !== undefined ? _data["nomeAgenzia"] : null as any;
            this.utente = _data["utente"] ? Utente.fromJS(_data["utente"]) : null as any;
            this.fastLoginTokenIsValid = _data["fastLoginTokenIsValid"] !== undefined ? _data["fastLoginTokenIsValid"] : null as any;
            this.emailLoginEnabled = _data["emailLoginEnabled"] !== undefined ? _data["emailLoginEnabled"] : null as any;
        }
    }

    static fromJS(data: any): UsersListRow {
        data = typeof data === 'object' ? data : {};
        let result = new UsersListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["nomeVisualizzato"] = this.nomeVisualizzato !== undefined ? this.nomeVisualizzato : null as any;
        data["tipoUtente"] = this.tipoUtente !== undefined ? this.tipoUtente : null as any;
        data["dataRegistrazione"] = this.dataRegistrazione !== undefined ? this.dataRegistrazione : null as any;
        data["nomeAgenzia"] = this.nomeAgenzia !== undefined ? this.nomeAgenzia : null as any;
        data["utente"] = this.utente ? this.utente.toJSON() : null as any;
        data["fastLoginTokenIsValid"] = this.fastLoginTokenIsValid !== undefined ? this.fastLoginTokenIsValid : null as any;
        data["emailLoginEnabled"] = this.emailLoginEnabled !== undefined ? this.emailLoginEnabled : null as any;
        return data;
    }
}

/** Classe di visualizzazione della riga nella lista utenti */
export interface IUsersListRow {
    /** ID dell'utente */
    id?: number;
    /** Indirizzo email dell'utente */
    email?: string | null;
    /** Nome completo */
    nomeVisualizzato?: string;
    /** Tipo di utente */
    tipoUtente?: ETipoUtente;
    /** Data e ora di creazione dell'utente */
    dataRegistrazione?: string;
    /** Nome dell'eventuale agenzia associata all'utente */
    nomeAgenzia?: string | null;
    /** Entità dell'utente (evita un roundtrip sul server quando si apre l'editor) */
    utente?: Utente;
    fastLoginTokenIsValid?: boolean;
    emailLoginEnabled?: boolean;
}

export class GetUserRolesResponse extends OkApiResponse implements IGetUserRolesResponse {
    /** Lista degli ID degli ruoli assegnati a questo utente */
    rolesIds?: number[];

    constructor(data?: IGetUserRolesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rolesIds"])) {
                this.rolesIds = [] as any;
                for (let item of _data["rolesIds"])
                    this.rolesIds!.push(item);
            }
            else {
                this.rolesIds = null as any;
            }
        }
    }

    static override fromJS(data: any): GetUserRolesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserRolesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rolesIds)) {
            data["rolesIds"] = [];
            for (let item of this.rolesIds)
                data["rolesIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetUserRolesResponse extends IOkApiResponse {
    /** Lista degli ID degli ruoli assegnati a questo utente */
    rolesIds?: number[];
}

export class NrTableResponseOfUsersListRow extends OkApiResponse implements INrTableResponseOfUsersListRow {
    /** Array delle righe della pagina richiesta */
    rows?: UsersListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfUsersListRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(UsersListRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfUsersListRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfUsersListRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfUsersListRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: UsersListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class UsersListResponse extends NrTableResponseOfUsersListRow implements IUsersListResponse {

    constructor(data?: IUsersListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UsersListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UsersListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUsersListResponse extends INrTableResponseOfUsersListRow {
}

export class UsersListRequest extends NrTableRequest implements IUsersListRequest {
    /** True show only valid, false show also the deleted users */
    showValid?: boolean;
    /** Termine di ricerca / ID facoltativo */
    term?: string | null;
    /** ID di un'agenzia alla quale restringere la ricerca */
    agencyContactID?: number | null;
    /** Dizionario per tradurre i tipi utente (solo export) */
    nomiTipoUtente?: { [key in keyof typeof ETipoUtente]?: string; } | null;

    constructor(data?: IUsersListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.showValid = _data["showValid"] !== undefined ? _data["showValid"] : null as any;
            this.term = _data["term"] !== undefined ? _data["term"] : null as any;
            this.agencyContactID = _data["agencyContactID"] !== undefined ? _data["agencyContactID"] : null as any;
            if (_data["nomiTipoUtente"]) {
                this.nomiTipoUtente = {} as any;
                for (let key in _data["nomiTipoUtente"]) {
                    if (_data["nomiTipoUtente"].hasOwnProperty(key))
                        (this.nomiTipoUtente as any)![key] = _data["nomiTipoUtente"][key] !== undefined ? _data["nomiTipoUtente"][key] : null as any;
                }
            }
            else {
                this.nomiTipoUtente = null as any;
            }
        }
    }

    static override fromJS(data: any): UsersListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UsersListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showValid"] = this.showValid !== undefined ? this.showValid : null as any;
        data["term"] = this.term !== undefined ? this.term : null as any;
        data["agencyContactID"] = this.agencyContactID !== undefined ? this.agencyContactID : null as any;
        if (this.nomiTipoUtente) {
            data["nomiTipoUtente"] = {};
            for (let key in this.nomiTipoUtente) {
                if (this.nomiTipoUtente.hasOwnProperty(key))
                    (data["nomiTipoUtente"] as any)[key] = this.nomiTipoUtente[key] !== undefined ? this.nomiTipoUtente[key] : null as any;
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUsersListRequest extends INrTableRequest {
    /** True show only valid, false show also the deleted users */
    showValid?: boolean;
    /** Termine di ricerca / ID facoltativo */
    term?: string | null;
    /** ID di un'agenzia alla quale restringere la ricerca */
    agencyContactID?: number | null;
    /** Dizionario per tradurre i tipi utente (solo export) */
    nomiTipoUtente?: { [key in keyof typeof ETipoUtente]?: string; } | null;
}

export class ListRolesResponse extends OkApiResponse implements IListRolesResponse {
    /** Elenco degli ruoli */
    roles?: RoleListData[];

    constructor(data?: IListRolesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(RoleListData.fromJS(item));
            }
            else {
                this.roles = null as any;
            }
        }
    }

    static override fromJS(data: any): ListRolesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListRolesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IListRolesResponse extends IOkApiResponse {
    /** Elenco degli ruoli */
    roles?: RoleListData[];
}

export class RoleListData implements IRoleListData {
    /** ID del ruolo */
    id?: number;
    /** Nome del ruolo */
    name?: string;
    /** Entità del ruolo */
    ruolo?: Ruolo;
    /** Lista degli ID dei permessi associati */
    permissionsIDs?: number[];

    constructor(data?: IRoleListData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.ruolo = _data["ruolo"] ? Ruolo.fromJS(_data["ruolo"]) : null as any;
            if (Array.isArray(_data["permissionsIDs"])) {
                this.permissionsIDs = [] as any;
                for (let item of _data["permissionsIDs"])
                    this.permissionsIDs!.push(item);
            }
            else {
                this.permissionsIDs = null as any;
            }
        }
    }

    static fromJS(data: any): RoleListData {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["ruolo"] = this.ruolo ? this.ruolo.toJSON() : null as any;
        if (Array.isArray(this.permissionsIDs)) {
            data["permissionsIDs"] = [];
            for (let item of this.permissionsIDs)
                data["permissionsIDs"].push(item);
        }
        return data;
    }
}

export interface IRoleListData {
    /** ID del ruolo */
    id?: number;
    /** Nome del ruolo */
    name?: string;
    /** Entità del ruolo */
    ruolo?: Ruolo;
    /** Lista degli ID dei permessi associati */
    permissionsIDs?: number[];
}

export class Ruolo implements IRuolo {
    id?: number;
    nome!: string;

    constructor(data?: IRuolo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
        }
    }

    static fromJS(data: any): Ruolo {
        data = typeof data === 'object' ? data : {};
        let result = new Ruolo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        return data;
    }
}

export interface IRuolo {
    id?: number;
    nome: string;
}

export class NrTableResponseOfUsersLoggedListRow extends OkApiResponse implements INrTableResponseOfUsersLoggedListRow {
    /** Array delle righe della pagina richiesta */
    rows?: UsersLoggedListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfUsersLoggedListRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(UsersLoggedListRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfUsersLoggedListRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfUsersLoggedListRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfUsersLoggedListRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: UsersLoggedListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class UsersLoggedListRow extends UsersListRow implements IUsersLoggedListRow {
    /** Data e ora dell'ultima richiesta */
    ultimaRichiesta?: string | null;

    constructor(data?: IUsersLoggedListRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ultimaRichiesta = _data["ultimaRichiesta"] !== undefined ? _data["ultimaRichiesta"] : null as any;
        }
    }

    static override fromJS(data: any): UsersLoggedListRow {
        data = typeof data === 'object' ? data : {};
        let result = new UsersLoggedListRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ultimaRichiesta"] = this.ultimaRichiesta !== undefined ? this.ultimaRichiesta : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUsersLoggedListRow extends IUsersListRow {
    /** Data e ora dell'ultima richiesta */
    ultimaRichiesta?: string | null;
}

export class UsersLoggedListRequest extends NrTableRequest implements IUsersLoggedListRequest {
    /** Termine di ricerca / ID facoltativo */
    term?: string | null;
    /** Minuti di inattività */
    minutes?: number | null;

    constructor(data?: IUsersLoggedListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : null as any;
            this.minutes = _data["minutes"] !== undefined ? _data["minutes"] : null as any;
        }
    }

    static override fromJS(data: any): UsersLoggedListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UsersLoggedListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : null as any;
        data["minutes"] = this.minutes !== undefined ? this.minutes : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUsersLoggedListRequest extends INrTableRequest {
    /** Termine di ricerca / ID facoltativo */
    term?: string | null;
    /** Minuti di inattività */
    minutes?: number | null;
}

export class PasswordResetRequest extends ApiRequest implements IPasswordResetRequest {
    /** Codice monouso di cambio password */
    codice!: string;
    /** Nuova password */
    password!: string;

    constructor(data?: IPasswordResetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.codice = _data["codice"] !== undefined ? _data["codice"] : null as any;
            this.password = _data["password"] !== undefined ? _data["password"] : null as any;
        }
    }

    static override fromJS(data: any): PasswordResetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordResetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codice"] = this.codice !== undefined ? this.codice : null as any;
        data["password"] = this.password !== undefined ? this.password : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPasswordResetRequest extends IApiRequest {
    /** Codice monouso di cambio password */
    codice: string;
    /** Nuova password */
    password: string;
}

export class UserRestoreRequest extends UserGetRequest implements IUserRestoreRequest {

    constructor(data?: IUserRestoreRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UserRestoreRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserRestoreRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUserRestoreRequest extends IUserGetRequest {
}

export class SendPasswordRecoveryRequest extends LocalizedRequest implements ISendPasswordRecoveryRequest {
    /** Email dell'utente che vuole recuperare la password */
    email!: string;
    /** Stringa di formato con la url per il recupero password.
Deve essere nel formato
https://itb2b.naar.com/auth/reset/{0}
dove il segnaposto {0} è il codice univoco monouso */
    passwordResetUrl!: string;

    constructor(data?: ISendPasswordRecoveryRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.passwordResetUrl = _data["passwordResetUrl"] !== undefined ? _data["passwordResetUrl"] : null as any;
        }
    }

    static override fromJS(data: any): SendPasswordRecoveryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendPasswordRecoveryRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["passwordResetUrl"] = this.passwordResetUrl !== undefined ? this.passwordResetUrl : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISendPasswordRecoveryRequest extends ILocalizedRequest {
    /** Email dell'utente che vuole recuperare la password */
    email: string;
    /** Stringa di formato con la url per il recupero password.
Deve essere nel formato
https://itb2b.naar.com/auth/reset/{0}
dove il segnaposto {0} è il codice univoco monouso */
    passwordResetUrl: string;
}

export class SetRolesRequest extends UserGetRequest implements ISetRolesRequest {
    rolesIds!: number[];

    constructor(data?: ISetRolesRequest) {
        super(data);
        if (!data) {
            this.rolesIds = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rolesIds"])) {
                this.rolesIds = [] as any;
                for (let item of _data["rolesIds"])
                    this.rolesIds!.push(item);
            }
            else {
                this.rolesIds = null as any;
            }
        }
    }

    static override fromJS(data: any): SetRolesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetRolesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rolesIds)) {
            data["rolesIds"] = [];
            for (let item of this.rolesIds)
                data["rolesIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetRolesRequest extends IUserGetRequest {
    rolesIds: number[];
}

export class UpsertUserRequest extends ApiRequest implements IUpsertUserRequest {
    utente!: UtenteBase;
    withNaarGoAccount?: boolean | null;

    constructor(data?: IUpsertUserRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.utente = _data["utente"] ? UtenteBase.fromJS(_data["utente"]) : null as any;
            this.withNaarGoAccount = _data["withNaarGoAccount"] !== undefined ? _data["withNaarGoAccount"] : null as any;
        }
    }

    static override fromJS(data: any): UpsertUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertUserRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utente"] = this.utente ? this.utente.toJSON() : null as any;
        data["withNaarGoAccount"] = this.withNaarGoAccount !== undefined ? this.withNaarGoAccount : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertUserRequest extends IApiRequest {
    utente: UtenteBase;
    withNaarGoAccount?: boolean | null;
}

export abstract class UtenteBase implements IUtenteBase {
    id?: number;
    contattoAgenziaID?: number | null;
    contattoUtenteID?: number | null;
    tipoUtente?: ETipoUtente | null;
    registrationDate?: string;
    email?: string | null;
    nome?: string | null;
    cognome?: string | null;
    passwordInChiaro?: string | null;
    passwordCifrata?: string | null;
    abilitato?: boolean;
    eliminato?: boolean;
    deleted?: string | null;
    operatoreID?: number | null;
    abilitazioneCrs?: number | null;
    telefono?: string | null;
    teamID?: string | null;
    npr?: boolean;
    uiOptions?: string | null;
    fuorisede?: boolean;
    emailFuorisede?: string | null;
    categoriaContattoID?: number | null;
    utentePadreID?: number | null;
    fastLoginEnabled?: boolean | null;
    fastLogingEnabledDate?: string | null;
    fastLoginTokenValidityDays?: number | null;
    fastLoginToken?: string | null;
    emailLoginEnabled?: boolean | null;
    basecampRefreshToken?: string | null;
    master?: EUserMaster | null;
    onboardingProgress?: string | null;

    constructor(data?: IUtenteBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.contattoAgenziaID = _data["contattoAgenziaID"] !== undefined ? _data["contattoAgenziaID"] : null as any;
            this.contattoUtenteID = _data["contattoUtenteID"] !== undefined ? _data["contattoUtenteID"] : null as any;
            this.tipoUtente = _data["tipoUtente"] !== undefined ? _data["tipoUtente"] : null as any;
            this.registrationDate = _data["registrationDate"] !== undefined ? _data["registrationDate"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : null as any;
            this.passwordInChiaro = _data["passwordInChiaro"] !== undefined ? _data["passwordInChiaro"] : null as any;
            this.passwordCifrata = _data["passwordCifrata"] !== undefined ? _data["passwordCifrata"] : null as any;
            this.abilitato = _data["abilitato"] !== undefined ? _data["abilitato"] : null as any;
            this.eliminato = _data["eliminato"] !== undefined ? _data["eliminato"] : null as any;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : null as any;
            this.operatoreID = _data["operatoreID"] !== undefined ? _data["operatoreID"] : null as any;
            this.abilitazioneCrs = _data["abilitazioneCrs"] !== undefined ? _data["abilitazioneCrs"] : null as any;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : null as any;
            this.teamID = _data["teamID"] !== undefined ? _data["teamID"] : null as any;
            this.npr = _data["npr"] !== undefined ? _data["npr"] : null as any;
            this.uiOptions = _data["uiOptions"] !== undefined ? _data["uiOptions"] : null as any;
            this.fuorisede = _data["fuorisede"] !== undefined ? _data["fuorisede"] : null as any;
            this.emailFuorisede = _data["emailFuorisede"] !== undefined ? _data["emailFuorisede"] : null as any;
            this.categoriaContattoID = _data["categoriaContattoID"] !== undefined ? _data["categoriaContattoID"] : null as any;
            this.utentePadreID = _data["utentePadreID"] !== undefined ? _data["utentePadreID"] : null as any;
            this.fastLoginEnabled = _data["fastLoginEnabled"] !== undefined ? _data["fastLoginEnabled"] : null as any;
            this.fastLogingEnabledDate = _data["fastLogingEnabledDate"] !== undefined ? _data["fastLogingEnabledDate"] : null as any;
            this.fastLoginTokenValidityDays = _data["fastLoginTokenValidityDays"] !== undefined ? _data["fastLoginTokenValidityDays"] : null as any;
            this.fastLoginToken = _data["fastLoginToken"] !== undefined ? _data["fastLoginToken"] : null as any;
            this.emailLoginEnabled = _data["emailLoginEnabled"] !== undefined ? _data["emailLoginEnabled"] : null as any;
            this.basecampRefreshToken = _data["basecampRefreshToken"] !== undefined ? _data["basecampRefreshToken"] : null as any;
            this.master = _data["master"] !== undefined ? _data["master"] : null as any;
            this.onboardingProgress = _data["onboardingProgress"] !== undefined ? _data["onboardingProgress"] : null as any;
        }
    }

    static fromJS(data: any): UtenteBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'UtenteBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["contattoAgenziaID"] = this.contattoAgenziaID !== undefined ? this.contattoAgenziaID : null as any;
        data["contattoUtenteID"] = this.contattoUtenteID !== undefined ? this.contattoUtenteID : null as any;
        data["tipoUtente"] = this.tipoUtente !== undefined ? this.tipoUtente : null as any;
        data["registrationDate"] = this.registrationDate !== undefined ? this.registrationDate : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["cognome"] = this.cognome !== undefined ? this.cognome : null as any;
        data["passwordInChiaro"] = this.passwordInChiaro !== undefined ? this.passwordInChiaro : null as any;
        data["passwordCifrata"] = this.passwordCifrata !== undefined ? this.passwordCifrata : null as any;
        data["abilitato"] = this.abilitato !== undefined ? this.abilitato : null as any;
        data["eliminato"] = this.eliminato !== undefined ? this.eliminato : null as any;
        data["deleted"] = this.deleted !== undefined ? this.deleted : null as any;
        data["operatoreID"] = this.operatoreID !== undefined ? this.operatoreID : null as any;
        data["abilitazioneCrs"] = this.abilitazioneCrs !== undefined ? this.abilitazioneCrs : null as any;
        data["telefono"] = this.telefono !== undefined ? this.telefono : null as any;
        data["teamID"] = this.teamID !== undefined ? this.teamID : null as any;
        data["npr"] = this.npr !== undefined ? this.npr : null as any;
        data["uiOptions"] = this.uiOptions !== undefined ? this.uiOptions : null as any;
        data["fuorisede"] = this.fuorisede !== undefined ? this.fuorisede : null as any;
        data["emailFuorisede"] = this.emailFuorisede !== undefined ? this.emailFuorisede : null as any;
        data["categoriaContattoID"] = this.categoriaContattoID !== undefined ? this.categoriaContattoID : null as any;
        data["utentePadreID"] = this.utentePadreID !== undefined ? this.utentePadreID : null as any;
        data["fastLoginEnabled"] = this.fastLoginEnabled !== undefined ? this.fastLoginEnabled : null as any;
        data["fastLogingEnabledDate"] = this.fastLogingEnabledDate !== undefined ? this.fastLogingEnabledDate : null as any;
        data["fastLoginTokenValidityDays"] = this.fastLoginTokenValidityDays !== undefined ? this.fastLoginTokenValidityDays : null as any;
        data["fastLoginToken"] = this.fastLoginToken !== undefined ? this.fastLoginToken : null as any;
        data["emailLoginEnabled"] = this.emailLoginEnabled !== undefined ? this.emailLoginEnabled : null as any;
        data["basecampRefreshToken"] = this.basecampRefreshToken !== undefined ? this.basecampRefreshToken : null as any;
        data["master"] = this.master !== undefined ? this.master : null as any;
        data["onboardingProgress"] = this.onboardingProgress !== undefined ? this.onboardingProgress : null as any;
        return data;
    }
}

export interface IUtenteBase {
    id?: number;
    contattoAgenziaID?: number | null;
    contattoUtenteID?: number | null;
    tipoUtente?: ETipoUtente | null;
    registrationDate?: string;
    email?: string | null;
    nome?: string | null;
    cognome?: string | null;
    passwordInChiaro?: string | null;
    passwordCifrata?: string | null;
    abilitato?: boolean;
    eliminato?: boolean;
    deleted?: string | null;
    operatoreID?: number | null;
    abilitazioneCrs?: number | null;
    telefono?: string | null;
    teamID?: string | null;
    npr?: boolean;
    uiOptions?: string | null;
    fuorisede?: boolean;
    emailFuorisede?: string | null;
    categoriaContattoID?: number | null;
    utentePadreID?: number | null;
    fastLoginEnabled?: boolean | null;
    fastLogingEnabledDate?: string | null;
    fastLoginTokenValidityDays?: number | null;
    fastLoginToken?: string | null;
    emailLoginEnabled?: boolean | null;
    basecampRefreshToken?: string | null;
    master?: EUserMaster | null;
    onboardingProgress?: string | null;
}

export class UpsertRoleResponse extends ListRolesResponse implements IUpsertRoleResponse {
    /** Ruolo modificato */
    ruolo?: Ruolo;

    constructor(data?: IUpsertRoleResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ruolo = _data["ruolo"] ? Ruolo.fromJS(_data["ruolo"]) : null as any;
        }
    }

    static override fromJS(data: any): UpsertRoleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertRoleResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ruolo"] = this.ruolo ? this.ruolo.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertRoleResponse extends IListRolesResponse {
    /** Ruolo modificato */
    ruolo?: Ruolo;
}

export class UpsertRoleRequest extends LocalizedRequest implements IUpsertRoleRequest {
    /** Entità ruolo */
    ruolo!: Ruolo;
    /** ID dei permessi associati */
    permessiIDs!: number[];

    constructor(data?: IUpsertRoleRequest) {
        super(data);
        if (!data) {
            this.ruolo = new Ruolo();
            this.permessiIDs = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ruolo = _data["ruolo"] ? Ruolo.fromJS(_data["ruolo"]) : new Ruolo();
            if (Array.isArray(_data["permessiIDs"])) {
                this.permessiIDs = [] as any;
                for (let item of _data["permessiIDs"])
                    this.permessiIDs!.push(item);
            }
            else {
                this.permessiIDs = null as any;
            }
        }
    }

    static override fromJS(data: any): UpsertRoleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertRoleRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ruolo"] = this.ruolo ? this.ruolo.toJSON() : null as any;
        if (Array.isArray(this.permessiIDs)) {
            data["permessiIDs"] = [];
            for (let item of this.permessiIDs)
                data["permessiIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertRoleRequest extends ILocalizedRequest {
    /** Entità ruolo */
    ruolo: Ruolo;
    /** ID dei permessi associati */
    permessiIDs: number[];
}

export class ClientAppSettings implements IClientAppSettings {
    applicationName?: string | null;
    naarDomain?: string | null;
    commonPathsSettings?: CommonPathsSettings | null;

    constructor(data?: IClientAppSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationName = _data["applicationName"] !== undefined ? _data["applicationName"] : null as any;
            this.naarDomain = _data["naarDomain"] !== undefined ? _data["naarDomain"] : null as any;
            this.commonPathsSettings = _data["commonPathsSettings"] ? CommonPathsSettings.fromJS(_data["commonPathsSettings"]) : null as any;
        }
    }

    static fromJS(data: any): ClientAppSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAppSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationName"] = this.applicationName !== undefined ? this.applicationName : null as any;
        data["naarDomain"] = this.naarDomain !== undefined ? this.naarDomain : null as any;
        data["commonPathsSettings"] = this.commonPathsSettings ? this.commonPathsSettings.toJSON() : null as any;
        return data;
    }
}

export interface IClientAppSettings {
    applicationName?: string | null;
    naarDomain?: string | null;
    commonPathsSettings?: CommonPathsSettings | null;
}

export class CommonPathsSettings implements ICommonPathsSettings {
    infoAttachmentsRoot?: string | null;
    infoAttachmentsBaseUrl?: string | null;
    articleAttachmentsRoot?: string | null;
    imagesBaseUrl?: string | null;
    imagesBasePath?: string | null;
    generalVoidImage?: string | null;
    mediaBaseUrl?: string | null;
    articleUrlFormatString?: string | null;

    constructor(data?: ICommonPathsSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.infoAttachmentsRoot = _data["infoAttachmentsRoot"] !== undefined ? _data["infoAttachmentsRoot"] : null as any;
            this.infoAttachmentsBaseUrl = _data["infoAttachmentsBaseUrl"] !== undefined ? _data["infoAttachmentsBaseUrl"] : null as any;
            this.articleAttachmentsRoot = _data["articleAttachmentsRoot"] !== undefined ? _data["articleAttachmentsRoot"] : null as any;
            this.imagesBaseUrl = _data["imagesBaseUrl"] !== undefined ? _data["imagesBaseUrl"] : null as any;
            this.imagesBasePath = _data["imagesBasePath"] !== undefined ? _data["imagesBasePath"] : null as any;
            this.generalVoidImage = _data["generalVoidImage"] !== undefined ? _data["generalVoidImage"] : null as any;
            this.mediaBaseUrl = _data["mediaBaseUrl"] !== undefined ? _data["mediaBaseUrl"] : null as any;
            this.articleUrlFormatString = _data["articleUrlFormatString"] !== undefined ? _data["articleUrlFormatString"] : null as any;
        }
    }

    static fromJS(data: any): CommonPathsSettings {
        data = typeof data === 'object' ? data : {};
        let result = new CommonPathsSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["infoAttachmentsRoot"] = this.infoAttachmentsRoot !== undefined ? this.infoAttachmentsRoot : null as any;
        data["infoAttachmentsBaseUrl"] = this.infoAttachmentsBaseUrl !== undefined ? this.infoAttachmentsBaseUrl : null as any;
        data["articleAttachmentsRoot"] = this.articleAttachmentsRoot !== undefined ? this.articleAttachmentsRoot : null as any;
        data["imagesBaseUrl"] = this.imagesBaseUrl !== undefined ? this.imagesBaseUrl : null as any;
        data["imagesBasePath"] = this.imagesBasePath !== undefined ? this.imagesBasePath : null as any;
        data["generalVoidImage"] = this.generalVoidImage !== undefined ? this.generalVoidImage : null as any;
        data["mediaBaseUrl"] = this.mediaBaseUrl !== undefined ? this.mediaBaseUrl : null as any;
        data["articleUrlFormatString"] = this.articleUrlFormatString !== undefined ? this.articleUrlFormatString : null as any;
        return data;
    }
}

export interface ICommonPathsSettings {
    infoAttachmentsRoot?: string | null;
    infoAttachmentsBaseUrl?: string | null;
    articleAttachmentsRoot?: string | null;
    imagesBaseUrl?: string | null;
    imagesBasePath?: string | null;
    generalVoidImage?: string | null;
    mediaBaseUrl?: string | null;
    articleUrlFormatString?: string | null;
}

export class SwaggerUrlRequest extends ApiRequest implements ISwaggerUrlRequest {
    /** Url of Swagger API to Generate the Typescript Client */
    url!: string;
    /** The Generated Client ClassName -> {ClassName}{controller}Client */
    clientClassName!: string;

    constructor(data?: ISwaggerUrlRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
            this.clientClassName = _data["clientClassName"] !== undefined ? _data["clientClassName"] : null as any;
        }
    }

    static override fromJS(data: any): SwaggerUrlRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SwaggerUrlRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url !== undefined ? this.url : null as any;
        data["clientClassName"] = this.clientClassName !== undefined ? this.clientClassName : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISwaggerUrlRequest extends IApiRequest {
    /** Url of Swagger API to Generate the Typescript Client */
    url: string;
    /** The Generated Client ClassName -> {ClassName}{controller}Client */
    clientClassName: string;
}

export class SwaggerJsonRequest extends ApiRequest implements ISwaggerJsonRequest {
    openApiJson!: string;

    constructor(data?: ISwaggerJsonRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.openApiJson = _data["openApiJson"] !== undefined ? _data["openApiJson"] : null as any;
        }
    }

    static override fromJS(data: any): SwaggerJsonRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SwaggerJsonRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["openApiJson"] = this.openApiJson !== undefined ? this.openApiJson : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISwaggerJsonRequest extends IApiRequest {
    openApiJson: string;
}

export class VoidContainer implements IVoidContainer {
    aiChatResponse?: AIChatResponse | null;
    getToolsResponse?: GetToolsResponse | null;
    tripsBatches?: TripsBatches | null;
    priceVerifyStatus?: PriceVerifyStatus | null;
    uiPriceVerifyStatus?: UiPriceVerifyStatus | null;
    autofillStatus?: AutofillStatus | null;
    addAttachmentRequest?: AddAttachmentRequest | null;
    giorniGratis?: GiorniGratis | null;
    scontoPercentuale?: ScontoPercentuale | null;
    scontoValore?: ScontoValore | null;
    abbinamentoSettimana?: AbbinamentoSettimana | null;
    composizioneGruppo?: ComposizioneGruppo | null;
    dataPartenza?: DataPartenza | null;
    dataPrenotazione?: DataPrenotazione | null;
    durataSoggiorno?: DurataSoggiorno | null;
    giorniEntrataUscita?: GiorniEntrataUscita | null;
    presenzaQuoteBambino?: PresenzaQuoteBambino | null;
    partenza?: Partenza | null;
    servizio?: Servizio | null;
    tipologia?: ServizioTipologia | null;
    regolaVendita?: ServizioRegolaVendita | null;
    permesso?: EPermesso;

    constructor(data?: IVoidContainer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aiChatResponse = _data["aiChatResponse"] ? AIChatResponse.fromJS(_data["aiChatResponse"]) : null as any;
            this.getToolsResponse = _data["getToolsResponse"] ? GetToolsResponse.fromJS(_data["getToolsResponse"]) : null as any;
            this.tripsBatches = _data["tripsBatches"] ? TripsBatches.fromJS(_data["tripsBatches"]) : null as any;
            this.priceVerifyStatus = _data["priceVerifyStatus"] ? PriceVerifyStatus.fromJS(_data["priceVerifyStatus"]) : null as any;
            this.uiPriceVerifyStatus = _data["uiPriceVerifyStatus"] ? UiPriceVerifyStatus.fromJS(_data["uiPriceVerifyStatus"]) : null as any;
            this.autofillStatus = _data["autofillStatus"] ? AutofillStatus.fromJS(_data["autofillStatus"]) : null as any;
            this.addAttachmentRequest = _data["addAttachmentRequest"] ? AddAttachmentRequest.fromJS(_data["addAttachmentRequest"]) : null as any;
            this.giorniGratis = _data["giorniGratis"] ? GiorniGratis.fromJS(_data["giorniGratis"]) : null as any;
            this.scontoPercentuale = _data["scontoPercentuale"] ? ScontoPercentuale.fromJS(_data["scontoPercentuale"]) : null as any;
            this.scontoValore = _data["scontoValore"] ? ScontoValore.fromJS(_data["scontoValore"]) : null as any;
            this.abbinamentoSettimana = _data["abbinamentoSettimana"] ? AbbinamentoSettimana.fromJS(_data["abbinamentoSettimana"]) : null as any;
            this.composizioneGruppo = _data["composizioneGruppo"] ? ComposizioneGruppo.fromJS(_data["composizioneGruppo"]) : null as any;
            this.dataPartenza = _data["dataPartenza"] ? DataPartenza.fromJS(_data["dataPartenza"]) : null as any;
            this.dataPrenotazione = _data["dataPrenotazione"] ? DataPrenotazione.fromJS(_data["dataPrenotazione"]) : null as any;
            this.durataSoggiorno = _data["durataSoggiorno"] ? DurataSoggiorno.fromJS(_data["durataSoggiorno"]) : null as any;
            this.giorniEntrataUscita = _data["giorniEntrataUscita"] ? GiorniEntrataUscita.fromJS(_data["giorniEntrataUscita"]) : null as any;
            this.presenzaQuoteBambino = _data["presenzaQuoteBambino"] ? PresenzaQuoteBambino.fromJS(_data["presenzaQuoteBambino"]) : null as any;
            this.partenza = _data["partenza"] ? Partenza.fromJS(_data["partenza"]) : null as any;
            this.servizio = _data["servizio"] ? Servizio.fromJS(_data["servizio"]) : null as any;
            this.tipologia = _data["tipologia"] ? ServizioTipologia.fromJS(_data["tipologia"]) : null as any;
            this.regolaVendita = _data["regolaVendita"] ? ServizioRegolaVendita.fromJS(_data["regolaVendita"]) : null as any;
            this.permesso = _data["permesso"] !== undefined ? _data["permesso"] : null as any;
        }
    }

    static fromJS(data: any): VoidContainer {
        data = typeof data === 'object' ? data : {};
        let result = new VoidContainer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aiChatResponse"] = this.aiChatResponse ? this.aiChatResponse.toJSON() : null as any;
        data["getToolsResponse"] = this.getToolsResponse ? this.getToolsResponse.toJSON() : null as any;
        data["tripsBatches"] = this.tripsBatches ? this.tripsBatches.toJSON() : null as any;
        data["priceVerifyStatus"] = this.priceVerifyStatus ? this.priceVerifyStatus.toJSON() : null as any;
        data["uiPriceVerifyStatus"] = this.uiPriceVerifyStatus ? this.uiPriceVerifyStatus.toJSON() : null as any;
        data["autofillStatus"] = this.autofillStatus ? this.autofillStatus.toJSON() : null as any;
        data["addAttachmentRequest"] = this.addAttachmentRequest ? this.addAttachmentRequest.toJSON() : null as any;
        data["giorniGratis"] = this.giorniGratis ? this.giorniGratis.toJSON() : null as any;
        data["scontoPercentuale"] = this.scontoPercentuale ? this.scontoPercentuale.toJSON() : null as any;
        data["scontoValore"] = this.scontoValore ? this.scontoValore.toJSON() : null as any;
        data["abbinamentoSettimana"] = this.abbinamentoSettimana ? this.abbinamentoSettimana.toJSON() : null as any;
        data["composizioneGruppo"] = this.composizioneGruppo ? this.composizioneGruppo.toJSON() : null as any;
        data["dataPartenza"] = this.dataPartenza ? this.dataPartenza.toJSON() : null as any;
        data["dataPrenotazione"] = this.dataPrenotazione ? this.dataPrenotazione.toJSON() : null as any;
        data["durataSoggiorno"] = this.durataSoggiorno ? this.durataSoggiorno.toJSON() : null as any;
        data["giorniEntrataUscita"] = this.giorniEntrataUscita ? this.giorniEntrataUscita.toJSON() : null as any;
        data["presenzaQuoteBambino"] = this.presenzaQuoteBambino ? this.presenzaQuoteBambino.toJSON() : null as any;
        data["partenza"] = this.partenza ? this.partenza.toJSON() : null as any;
        data["servizio"] = this.servizio ? this.servizio.toJSON() : null as any;
        data["tipologia"] = this.tipologia ? this.tipologia.toJSON() : null as any;
        data["regolaVendita"] = this.regolaVendita ? this.regolaVendita.toJSON() : null as any;
        data["permesso"] = this.permesso !== undefined ? this.permesso : null as any;
        return data;
    }
}

export interface IVoidContainer {
    aiChatResponse?: AIChatResponse | null;
    getToolsResponse?: GetToolsResponse | null;
    tripsBatches?: TripsBatches | null;
    priceVerifyStatus?: PriceVerifyStatus | null;
    uiPriceVerifyStatus?: UiPriceVerifyStatus | null;
    autofillStatus?: AutofillStatus | null;
    addAttachmentRequest?: AddAttachmentRequest | null;
    giorniGratis?: GiorniGratis | null;
    scontoPercentuale?: ScontoPercentuale | null;
    scontoValore?: ScontoValore | null;
    abbinamentoSettimana?: AbbinamentoSettimana | null;
    composizioneGruppo?: ComposizioneGruppo | null;
    dataPartenza?: DataPartenza | null;
    dataPrenotazione?: DataPrenotazione | null;
    durataSoggiorno?: DurataSoggiorno | null;
    giorniEntrataUscita?: GiorniEntrataUscita | null;
    presenzaQuoteBambino?: PresenzaQuoteBambino | null;
    partenza?: Partenza | null;
    servizio?: Servizio | null;
    tipologia?: ServizioTipologia | null;
    regolaVendita?: ServizioRegolaVendita | null;
    permesso?: EPermesso;
}

export class AIChatResponse implements IAIChatResponse {
    inputTokens?: number;
    totalInputTokens?: number;
    outputTokens?: number;
    totalOutputTokens?: number;
    stopReason?: string;
    contents?: ChatMessageContent[];
    tripID?: number | null;

    constructor(data?: IAIChatResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inputTokens = _data["inputTokens"] !== undefined ? _data["inputTokens"] : null as any;
            this.totalInputTokens = _data["totalInputTokens"] !== undefined ? _data["totalInputTokens"] : null as any;
            this.outputTokens = _data["outputTokens"] !== undefined ? _data["outputTokens"] : null as any;
            this.totalOutputTokens = _data["totalOutputTokens"] !== undefined ? _data["totalOutputTokens"] : null as any;
            this.stopReason = _data["stopReason"] !== undefined ? _data["stopReason"] : null as any;
            if (Array.isArray(_data["contents"])) {
                this.contents = [] as any;
                for (let item of _data["contents"])
                    this.contents!.push(ChatMessageContent.fromJS(item));
            }
            else {
                this.contents = null as any;
            }
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : null as any;
        }
    }

    static fromJS(data: any): AIChatResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AIChatResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputTokens"] = this.inputTokens !== undefined ? this.inputTokens : null as any;
        data["totalInputTokens"] = this.totalInputTokens !== undefined ? this.totalInputTokens : null as any;
        data["outputTokens"] = this.outputTokens !== undefined ? this.outputTokens : null as any;
        data["totalOutputTokens"] = this.totalOutputTokens !== undefined ? this.totalOutputTokens : null as any;
        data["stopReason"] = this.stopReason !== undefined ? this.stopReason : null as any;
        if (Array.isArray(this.contents)) {
            data["contents"] = [];
            for (let item of this.contents)
                data["contents"].push(item ? item.toJSON() : null as any);
        }
        data["tripID"] = this.tripID !== undefined ? this.tripID : null as any;
        return data;
    }
}

export interface IAIChatResponse {
    inputTokens?: number;
    totalInputTokens?: number;
    outputTokens?: number;
    totalOutputTokens?: number;
    stopReason?: string;
    contents?: ChatMessageContent[];
    tripID?: number | null;
}

export class ChatMessageContent implements IChatMessageContent {
    type?: ChatMessageContentType;
    typeString?: string;
    text?: string;
    toolInput?: string | null;

    constructor(data?: IChatMessageContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.typeString = _data["typeString"] !== undefined ? _data["typeString"] : null as any;
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
            this.toolInput = _data["toolInput"] !== undefined ? _data["toolInput"] : null as any;
        }
    }

    static fromJS(data: any): ChatMessageContent {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMessageContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["typeString"] = this.typeString !== undefined ? this.typeString : null as any;
        data["text"] = this.text !== undefined ? this.text : null as any;
        data["toolInput"] = this.toolInput !== undefined ? this.toolInput : null as any;
        return data;
    }
}

export interface IChatMessageContent {
    type?: ChatMessageContentType;
    typeString?: string;
    text?: string;
    toolInput?: string | null;
}

export enum ChatMessageContentType {
    Error = "Error",
    Text = "Text",
    ToolUsage = "ToolUsage",
}

/** Represents the response returned when retrieving a collection of available tools. */
export class GetToolsResponse implements IGetToolsResponse {
    /** List of available tools in the current session */
    tools?: ToolInfo[];

    constructor(data?: IGetToolsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tools"])) {
                this.tools = [] as any;
                for (let item of _data["tools"])
                    this.tools!.push(ToolInfo.fromJS(item));
            }
            else {
                this.tools = null as any;
            }
        }
    }

    static fromJS(data: any): GetToolsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetToolsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tools)) {
            data["tools"] = [];
            for (let item of this.tools)
                data["tools"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** Represents the response returned when retrieving a collection of available tools. */
export interface IGetToolsResponse {
    /** List of available tools in the current session */
    tools?: ToolInfo[];
}

/** Single session tool information */
export class ToolInfo implements IToolInfo {
    /** Short tool code/name used in messages and as key */
    code?: string;
    /** Friendly tool name */
    name?: string;
    /** true if the tool is enabled in the current session */
    enabled?: boolean;

    constructor(data?: IToolInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : null as any;
        }
    }

    static fromJS(data: any): ToolInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ToolInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["enabled"] = this.enabled !== undefined ? this.enabled : null as any;
        return data;
    }
}

/** Single session tool information */
export interface IToolInfo {
    /** Short tool code/name used in messages and as key */
    code?: string;
    /** Friendly tool name */
    name?: string;
    /** true if the tool is enabled in the current session */
    enabled?: boolean;
}

export class TripsBatches implements ITripsBatches {
    ok?: boolean;
    batches?: TripBatch[] | null;

    constructor(data?: ITripsBatches) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"] !== undefined ? _data["ok"] : null as any;
            if (Array.isArray(_data["batches"])) {
                this.batches = [] as any;
                for (let item of _data["batches"])
                    this.batches!.push(TripBatch.fromJS(item));
            }
            else {
                this.batches = null as any;
            }
        }
    }

    static fromJS(data: any): TripsBatches {
        data = typeof data === 'object' ? data : {};
        let result = new TripsBatches();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok !== undefined ? this.ok : null as any;
        if (Array.isArray(this.batches)) {
            data["batches"] = [];
            for (let item of this.batches)
                data["batches"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ITripsBatches {
    ok?: boolean;
    batches?: TripBatch[] | null;
}

export class AddAttachmentRequest extends ApiRequest implements IAddAttachmentRequest {
    articoloID?: number;
    descrizione?: string | null;

    constructor(data?: IAddAttachmentRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.articoloID = _data["articoloID"] !== undefined ? _data["articoloID"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
        }
    }

    static override fromJS(data: any): AddAttachmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddAttachmentRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articoloID"] = this.articoloID !== undefined ? this.articoloID : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAddAttachmentRequest extends IApiRequest {
    articoloID?: number;
    descrizione?: string | null;
}

export class GiorniGratis implements IGiorniGratis {
    giorniDaScontare?: number;
    percentualeSconto?: number;
    periodo?: EPeriodoGiorniGratis;
    gruppoApplicazione?: EGruppoApplicazione;
    applicaMulipliPeriodo?: boolean;
    maxQuoteDaTogliere?: number;

    constructor(data?: IGiorniGratis) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.giorniDaScontare = _data["giorniDaScontare"] !== undefined ? _data["giorniDaScontare"] : null as any;
            this.percentualeSconto = _data["percentualeSconto"] !== undefined ? _data["percentualeSconto"] : null as any;
            this.periodo = _data["periodo"] !== undefined ? _data["periodo"] : null as any;
            this.gruppoApplicazione = _data["gruppoApplicazione"] !== undefined ? _data["gruppoApplicazione"] : null as any;
            this.applicaMulipliPeriodo = _data["applicaMulipliPeriodo"] !== undefined ? _data["applicaMulipliPeriodo"] : null as any;
            this.maxQuoteDaTogliere = _data["maxQuoteDaTogliere"] !== undefined ? _data["maxQuoteDaTogliere"] : null as any;
        }
    }

    static fromJS(data: any): GiorniGratis {
        data = typeof data === 'object' ? data : {};
        let result = new GiorniGratis();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giorniDaScontare"] = this.giorniDaScontare !== undefined ? this.giorniDaScontare : null as any;
        data["percentualeSconto"] = this.percentualeSconto !== undefined ? this.percentualeSconto : null as any;
        data["periodo"] = this.periodo !== undefined ? this.periodo : null as any;
        data["gruppoApplicazione"] = this.gruppoApplicazione !== undefined ? this.gruppoApplicazione : null as any;
        data["applicaMulipliPeriodo"] = this.applicaMulipliPeriodo !== undefined ? this.applicaMulipliPeriodo : null as any;
        data["maxQuoteDaTogliere"] = this.maxQuoteDaTogliere !== undefined ? this.maxQuoteDaTogliere : null as any;
        return data;
    }
}

export interface IGiorniGratis {
    giorniDaScontare?: number;
    percentualeSconto?: number;
    periodo?: EPeriodoGiorniGratis;
    gruppoApplicazione?: EGruppoApplicazione;
    applicaMulipliPeriodo?: boolean;
    maxQuoteDaTogliere?: number;
}

export enum EPeriodoGiorniGratis {
    PrimaNotte = "PrimaNotte",
    UltimaNotte = "UltimaNotte",
    GiornoPiuCostoso = "GiornoPiuCostoso",
    GiornoMenoCostoso = "GiornoMenoCostoso",
    PrimaSettimana = "PrimaSettimana",
    SecondaSettimana = "SecondaSettimana",
    SecondaSettimanaESuccessive = "SecondaSettimanaESuccessive",
    SettimanaMenoCostosa = "SettimanaMenoCostosa",
}

export enum EGruppoApplicazione {
    Tutti = "Tutti",
    SottoEta1 = "SottoEta1",
    TraEta1e2 = "TraEta1e2",
    OltreEta2 = "OltreEta2",
}

export class ScontoPercentuale implements IScontoPercentuale {
    percentuale?: number;
    applicaSuMezzaDoppia?: boolean;
    moltiplicaMezzaDoppiaPerPax?: boolean;
    gruppoApplicazione?: EGruppoApplicazione;
    soloQuoteBambino?: boolean;
    maxQuoteDaTogliere?: number;
    applicazioneSuSettimaneAbbinate?: EApplSettAbbinata;

    constructor(data?: IScontoPercentuale) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.percentuale = _data["percentuale"] !== undefined ? _data["percentuale"] : null as any;
            this.applicaSuMezzaDoppia = _data["applicaSuMezzaDoppia"] !== undefined ? _data["applicaSuMezzaDoppia"] : null as any;
            this.moltiplicaMezzaDoppiaPerPax = _data["moltiplicaMezzaDoppiaPerPax"] !== undefined ? _data["moltiplicaMezzaDoppiaPerPax"] : null as any;
            this.gruppoApplicazione = _data["gruppoApplicazione"] !== undefined ? _data["gruppoApplicazione"] : null as any;
            this.soloQuoteBambino = _data["soloQuoteBambino"] !== undefined ? _data["soloQuoteBambino"] : null as any;
            this.maxQuoteDaTogliere = _data["maxQuoteDaTogliere"] !== undefined ? _data["maxQuoteDaTogliere"] : null as any;
            this.applicazioneSuSettimaneAbbinate = _data["applicazioneSuSettimaneAbbinate"] !== undefined ? _data["applicazioneSuSettimaneAbbinate"] : null as any;
        }
    }

    static fromJS(data: any): ScontoPercentuale {
        data = typeof data === 'object' ? data : {};
        let result = new ScontoPercentuale();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["percentuale"] = this.percentuale !== undefined ? this.percentuale : null as any;
        data["applicaSuMezzaDoppia"] = this.applicaSuMezzaDoppia !== undefined ? this.applicaSuMezzaDoppia : null as any;
        data["moltiplicaMezzaDoppiaPerPax"] = this.moltiplicaMezzaDoppiaPerPax !== undefined ? this.moltiplicaMezzaDoppiaPerPax : null as any;
        data["gruppoApplicazione"] = this.gruppoApplicazione !== undefined ? this.gruppoApplicazione : null as any;
        data["soloQuoteBambino"] = this.soloQuoteBambino !== undefined ? this.soloQuoteBambino : null as any;
        data["maxQuoteDaTogliere"] = this.maxQuoteDaTogliere !== undefined ? this.maxQuoteDaTogliere : null as any;
        data["applicazioneSuSettimaneAbbinate"] = this.applicazioneSuSettimaneAbbinate !== undefined ? this.applicazioneSuSettimaneAbbinate : null as any;
        return data;
    }
}

export interface IScontoPercentuale {
    percentuale?: number;
    applicaSuMezzaDoppia?: boolean;
    moltiplicaMezzaDoppiaPerPax?: boolean;
    gruppoApplicazione?: EGruppoApplicazione;
    soloQuoteBambino?: boolean;
    maxQuoteDaTogliere?: number;
    applicazioneSuSettimaneAbbinate?: EApplSettAbbinata;
}

export enum EApplSettAbbinata {
    Tutto = "Tutto",
    SettimanaIndicata = "SettimanaIndicata",
    SettimanaAbbinata = "SettimanaAbbinata",
}

export class ScontoValore implements IScontoValore {
    valorePrezzo?: number;
    valoreCosto?: number;
    perGiorno?: boolean;
    perPersona?: boolean;
    quotaBambiniProporzionale?: boolean;
    applicaMulipliPeriodo?: boolean;
    gruppoApplicazione?: EGruppoApplicazione;
    ricostruisciTariffaAdultiSuMezzeDoppie?: boolean;
    maxQuoteDaTogliere?: number;

    constructor(data?: IScontoValore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorePrezzo = _data["valorePrezzo"] !== undefined ? _data["valorePrezzo"] : null as any;
            this.valoreCosto = _data["valoreCosto"] !== undefined ? _data["valoreCosto"] : null as any;
            this.perGiorno = _data["perGiorno"] !== undefined ? _data["perGiorno"] : null as any;
            this.perPersona = _data["perPersona"] !== undefined ? _data["perPersona"] : null as any;
            this.quotaBambiniProporzionale = _data["quotaBambiniProporzionale"] !== undefined ? _data["quotaBambiniProporzionale"] : null as any;
            this.applicaMulipliPeriodo = _data["applicaMulipliPeriodo"] !== undefined ? _data["applicaMulipliPeriodo"] : null as any;
            this.gruppoApplicazione = _data["gruppoApplicazione"] !== undefined ? _data["gruppoApplicazione"] : null as any;
            this.ricostruisciTariffaAdultiSuMezzeDoppie = _data["ricostruisciTariffaAdultiSuMezzeDoppie"] !== undefined ? _data["ricostruisciTariffaAdultiSuMezzeDoppie"] : null as any;
            this.maxQuoteDaTogliere = _data["maxQuoteDaTogliere"] !== undefined ? _data["maxQuoteDaTogliere"] : null as any;
        }
    }

    static fromJS(data: any): ScontoValore {
        data = typeof data === 'object' ? data : {};
        let result = new ScontoValore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorePrezzo"] = this.valorePrezzo !== undefined ? this.valorePrezzo : null as any;
        data["valoreCosto"] = this.valoreCosto !== undefined ? this.valoreCosto : null as any;
        data["perGiorno"] = this.perGiorno !== undefined ? this.perGiorno : null as any;
        data["perPersona"] = this.perPersona !== undefined ? this.perPersona : null as any;
        data["quotaBambiniProporzionale"] = this.quotaBambiniProporzionale !== undefined ? this.quotaBambiniProporzionale : null as any;
        data["applicaMulipliPeriodo"] = this.applicaMulipliPeriodo !== undefined ? this.applicaMulipliPeriodo : null as any;
        data["gruppoApplicazione"] = this.gruppoApplicazione !== undefined ? this.gruppoApplicazione : null as any;
        data["ricostruisciTariffaAdultiSuMezzeDoppie"] = this.ricostruisciTariffaAdultiSuMezzeDoppie !== undefined ? this.ricostruisciTariffaAdultiSuMezzeDoppie : null as any;
        data["maxQuoteDaTogliere"] = this.maxQuoteDaTogliere !== undefined ? this.maxQuoteDaTogliere : null as any;
        return data;
    }
}

export interface IScontoValore {
    valorePrezzo?: number;
    valoreCosto?: number;
    perGiorno?: boolean;
    perPersona?: boolean;
    quotaBambiniProporzionale?: boolean;
    applicaMulipliPeriodo?: boolean;
    gruppoApplicazione?: EGruppoApplicazione;
    ricostruisciTariffaAdultiSuMezzeDoppie?: boolean;
    maxQuoteDaTogliere?: number;
}

export class AbbinamentoSettimana implements IAbbinamentoSettimana {
    tipoAbbinamento?: EAbbinamentoSettimana;
    giornoIniziale?: string;

    constructor(data?: IAbbinamentoSettimana) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoAbbinamento = _data["tipoAbbinamento"] !== undefined ? _data["tipoAbbinamento"] : null as any;
            this.giornoIniziale = _data["giornoIniziale"] !== undefined ? _data["giornoIniziale"] : null as any;
        }
    }

    static fromJS(data: any): AbbinamentoSettimana {
        data = typeof data === 'object' ? data : {};
        let result = new AbbinamentoSettimana();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoAbbinamento"] = this.tipoAbbinamento !== undefined ? this.tipoAbbinamento : null as any;
        data["giornoIniziale"] = this.giornoIniziale !== undefined ? this.giornoIniziale : null as any;
        return data;
    }
}

export interface IAbbinamentoSettimana {
    tipoAbbinamento?: EAbbinamentoSettimana;
    giornoIniziale?: string;
}

export enum EAbbinamentoSettimana {
    SettimanaPrecedente = "SettimanaPrecedente",
    SettimanaSuccessiva = "SettimanaSuccessiva",
    SettimanaPrimaODopo = "SettimanaPrimaODopo",
}

export class ComposizioneGruppo implements IComposizioneGruppo {
    sottoEta1?: number;
    operatoreEta1?: EOperatoreDisuguaglianza;
    eta1?: number;
    traEta1e2?: number;
    operatoreEta1e2?: EOperatoreDisuguaglianza;
    eta2?: number;
    oltreEta2?: number;
    operatoreEta2?: EOperatoreDisuguaglianza;

    constructor(data?: IComposizioneGruppo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sottoEta1 = _data["sottoEta1"] !== undefined ? _data["sottoEta1"] : null as any;
            this.operatoreEta1 = _data["operatoreEta1"] !== undefined ? _data["operatoreEta1"] : null as any;
            this.eta1 = _data["eta1"] !== undefined ? _data["eta1"] : null as any;
            this.traEta1e2 = _data["traEta1e2"] !== undefined ? _data["traEta1e2"] : null as any;
            this.operatoreEta1e2 = _data["operatoreEta1e2"] !== undefined ? _data["operatoreEta1e2"] : null as any;
            this.eta2 = _data["eta2"] !== undefined ? _data["eta2"] : null as any;
            this.oltreEta2 = _data["oltreEta2"] !== undefined ? _data["oltreEta2"] : null as any;
            this.operatoreEta2 = _data["operatoreEta2"] !== undefined ? _data["operatoreEta2"] : null as any;
        }
    }

    static fromJS(data: any): ComposizioneGruppo {
        data = typeof data === 'object' ? data : {};
        let result = new ComposizioneGruppo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sottoEta1"] = this.sottoEta1 !== undefined ? this.sottoEta1 : null as any;
        data["operatoreEta1"] = this.operatoreEta1 !== undefined ? this.operatoreEta1 : null as any;
        data["eta1"] = this.eta1 !== undefined ? this.eta1 : null as any;
        data["traEta1e2"] = this.traEta1e2 !== undefined ? this.traEta1e2 : null as any;
        data["operatoreEta1e2"] = this.operatoreEta1e2 !== undefined ? this.operatoreEta1e2 : null as any;
        data["eta2"] = this.eta2 !== undefined ? this.eta2 : null as any;
        data["oltreEta2"] = this.oltreEta2 !== undefined ? this.oltreEta2 : null as any;
        data["operatoreEta2"] = this.operatoreEta2 !== undefined ? this.operatoreEta2 : null as any;
        return data;
    }
}

export interface IComposizioneGruppo {
    sottoEta1?: number;
    operatoreEta1?: EOperatoreDisuguaglianza;
    eta1?: number;
    traEta1e2?: number;
    operatoreEta1e2?: EOperatoreDisuguaglianza;
    eta2?: number;
    oltreEta2?: number;
    operatoreEta2?: EOperatoreDisuguaglianza;
}

export enum EOperatoreDisuguaglianza {
    Esattamente = "Esattamente",
    Minimo = "Minimo",
    Massimo = "Massimo",
}

export class DataPartenza implements IDataPartenza {
    dataDal?: string | null;
    dataAl?: string | null;

    constructor(data?: IDataPartenza) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataDal = _data["dataDal"] !== undefined ? _data["dataDal"] : null as any;
            this.dataAl = _data["dataAl"] !== undefined ? _data["dataAl"] : null as any;
        }
    }

    static fromJS(data: any): DataPartenza {
        data = typeof data === 'object' ? data : {};
        let result = new DataPartenza();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataDal"] = this.dataDal !== undefined ? this.dataDal : null as any;
        data["dataAl"] = this.dataAl !== undefined ? this.dataAl : null as any;
        return data;
    }
}

export interface IDataPartenza {
    dataDal?: string | null;
    dataAl?: string | null;
}

export class DataPrenotazione implements IDataPrenotazione {
    tipoRaffronto?: EPrenotaEntro;
    giorni?: number;
    dataDal?: string | null;
    dataAl?: string | null;

    constructor(data?: IDataPrenotazione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoRaffronto = _data["tipoRaffronto"] !== undefined ? _data["tipoRaffronto"] : null as any;
            this.giorni = _data["giorni"] !== undefined ? _data["giorni"] : null as any;
            this.dataDal = _data["dataDal"] !== undefined ? _data["dataDal"] : null as any;
            this.dataAl = _data["dataAl"] !== undefined ? _data["dataAl"] : null as any;
        }
    }

    static fromJS(data: any): DataPrenotazione {
        data = typeof data === 'object' ? data : {};
        let result = new DataPrenotazione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoRaffronto"] = this.tipoRaffronto !== undefined ? this.tipoRaffronto : null as any;
        data["giorni"] = this.giorni !== undefined ? this.giorni : null as any;
        data["dataDal"] = this.dataDal !== undefined ? this.dataDal : null as any;
        data["dataAl"] = this.dataAl !== undefined ? this.dataAl : null as any;
        return data;
    }
}

export interface IDataPrenotazione {
    tipoRaffronto?: EPrenotaEntro;
    giorni?: number;
    dataDal?: string | null;
    dataAl?: string | null;
}

export enum EPrenotaEntro {
    Giorni = "Giorni",
    Periodo = "Periodo",
}

export class DurataSoggiorno implements IDurataSoggiorno {
    operatore?: EOperatoreDisuguaglianza;
    valore?: number;
    accettaMultipli?: boolean;
    ignoraEsclusioni?: boolean;

    constructor(data?: IDurataSoggiorno) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.valore = _data["valore"] !== undefined ? _data["valore"] : null as any;
            this.accettaMultipli = _data["accettaMultipli"] !== undefined ? _data["accettaMultipli"] : null as any;
            this.ignoraEsclusioni = _data["ignoraEsclusioni"] !== undefined ? _data["ignoraEsclusioni"] : null as any;
        }
    }

    static fromJS(data: any): DurataSoggiorno {
        data = typeof data === 'object' ? data : {};
        let result = new DurataSoggiorno();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["valore"] = this.valore !== undefined ? this.valore : null as any;
        data["accettaMultipli"] = this.accettaMultipli !== undefined ? this.accettaMultipli : null as any;
        data["ignoraEsclusioni"] = this.ignoraEsclusioni !== undefined ? this.ignoraEsclusioni : null as any;
        return data;
    }
}

export interface IDurataSoggiorno {
    operatore?: EOperatoreDisuguaglianza;
    valore?: number;
    accettaMultipli?: boolean;
    ignoraEsclusioni?: boolean;
}

export class GiorniEntrataUscita implements IGiorniEntrataUscita {
    giorni?: string;
    tipoGiorni?: EEntrataUscita;

    constructor(data?: IGiorniEntrataUscita) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.giorni = _data["giorni"] !== undefined ? _data["giorni"] : null as any;
            this.tipoGiorni = _data["tipoGiorni"] !== undefined ? _data["tipoGiorni"] : null as any;
        }
    }

    static fromJS(data: any): GiorniEntrataUscita {
        data = typeof data === 'object' ? data : {};
        let result = new GiorniEntrataUscita();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giorni"] = this.giorni !== undefined ? this.giorni : null as any;
        data["tipoGiorni"] = this.tipoGiorni !== undefined ? this.tipoGiorni : null as any;
        return data;
    }
}

export interface IGiorniEntrataUscita {
    giorni?: string;
    tipoGiorni?: EEntrataUscita;
}

export enum EEntrataUscita {
    Entrata = "Entrata",
    Uscita = "Uscita",
    InOut = "InOut",
}

export class PresenzaQuoteBambino implements IPresenzaQuoteBambino {
    operatore?: EOperatoreDisuguaglianza;
    numeroQuoteBambino?: number;

    constructor(data?: IPresenzaQuoteBambino) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            this.numeroQuoteBambino = _data["numeroQuoteBambino"] !== undefined ? _data["numeroQuoteBambino"] : null as any;
        }
    }

    static fromJS(data: any): PresenzaQuoteBambino {
        data = typeof data === 'object' ? data : {};
        let result = new PresenzaQuoteBambino();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        data["numeroQuoteBambino"] = this.numeroQuoteBambino !== undefined ? this.numeroQuoteBambino : null as any;
        return data;
    }
}

export interface IPresenzaQuoteBambino {
    operatore?: EOperatoreDisuguaglianza;
    numeroQuoteBambino?: number;
}

export enum EPermesso {
    Dev = "dev",
    Services_advance_payments_read = "services_advance_payments_read",
    Services_advance_payments_readwrite = "services_advance_payments_readwrite",
    Services_advance_payments = "services_advance_payments",
    Contab_fatture = "contab_fatture",
    Contab_fatture_read = "contab_fatture_read",
    Contab_fatture_readwrite = "contab_fatture_readwrite",
    Contab_fatture_creazione = "contab_fatture_creazione",
    Payments = "payments",
    Payments_read = "payments_read",
    Payments_readwrite = "payments_readwrite",
    Contab_ciclopassivo = "contab_ciclopassivo",
    Services_margins = "services_margins",
    Services_margins_read = "services_margins_read",
    Services_margins_readwrite = "services_margins_readwrite",
    Contacts = "contacts",
    Contacts_read = "contacts_read",
    Contacts_readwrite = "contacts_readwrite",
    Contacts_contracts_read = "contacts_contracts_read",
    Contacts_contracts_readwrite = "contacts_contracts_readwrite",
    Contacts_relations_read = "contacts_relations_read",
    Contacts_relations_readwrite = "contacts_relations_readwrite",
    Contacts_data_read = "contacts_data_read",
    Contacts_data_readwrite = "contacts_data_readwrite",
    Contacts_addresses_read = "contacts_addresses_read",
    Contacts_addresses_readwrite = "contacts_addresses_readwrite",
    Contacts_maps_read = "contacts_maps_read",
    Contacts_users_read = "contacts_users_read",
    Contacts_users_readwrite = "contacts_users_readwrite",
    Contacts_maps_readwrite = "contacts_maps_readwrite",
    Places = "places",
    Places_read = "places_read",
    Places_readwrite = "places_readwrite",
    Places_maps_readwrite = "places_maps_readwrite",
    Places_relations_read = "places_relations_read",
    Places_relations_readwrite = "places_relations_readwrite",
    Places_near_read = "places_near_read",
    Places_near_readwrite = "places_near_readwrite",
    H2hsvcs_read = "h2hsvcs_read",
    H2hsvcs_readwrite = "h2hsvcs_readwrite",
    Attacheddocs = "attacheddocs",
    Attacheddocs_read = "attacheddocs_read",
    Attacheddocs_readwrite = "attacheddocs_readwrite",
    Offert_optimize_hotel = "offert_optimize_hotel",
    Currencies_read = "currencies_read",
    Currencies_readwrite = "currencies_readwrite",
    Operators = "operators",
    Operators_read = "operators_read",
    Operators_readwrite = "operators_readwrite",
    Operators_quoteoptions_read = "operators_quoteoptions_read",
    Operators_quoteoptions_readwrite = "operators_quoteoptions_readwrite",
    Agency_users = "agency_users",
    Agency_users_read = "agency_users_read",
    Agency_users_readwrite = "agency_users_readwrite",
    Users = "users",
    Users_read = "users_read",
    Users_readwrite = "users_readwrite",
    Users_impersonate = "users_impersonate",
}

export class ValidateTripExistsResponse extends OkApiResponse implements IValidateTripExistsResponse {
    exists?: boolean;

    constructor(data?: IValidateTripExistsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.exists = _data["exists"] !== undefined ? _data["exists"] : null as any;
        }
    }

    static override fromJS(data: any): ValidateTripExistsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateTripExistsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exists"] = this.exists !== undefined ? this.exists : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IValidateTripExistsResponse extends IOkApiResponse {
    exists?: boolean;
}

export class ValidateTripExistsRequest extends ApiRequest implements IValidateTripExistsRequest {
    offertaID?: number;

    constructor(data?: IValidateTripExistsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
        }
    }

    static override fromJS(data: any): ValidateTripExistsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateTripExistsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IValidateTripExistsRequest extends IApiRequest {
    offertaID?: number;
}

export class NrTableResponseOfVoucherRow extends OkApiResponse implements INrTableResponseOfVoucherRow {
    /** Array delle righe della pagina richiesta */
    rows?: VoucherRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfVoucherRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(VoucherRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfVoucherRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfVoucherRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfVoucherRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: VoucherRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class VoucherRow implements IVoucherRow {
    id?: number;
    luogo?: string;
    abbinamento?: string | null;
    descrizione?: string;
    nomeContatto?: string;
    data?: string;
    tipoEmissione?: string;
    cumulativeVouchers?: VoucherRow[] | null;

    constructor(data?: IVoucherRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : null as any;
            this.abbinamento = _data["abbinamento"] !== undefined ? _data["abbinamento"] : null as any;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : null as any;
            this.nomeContatto = _data["nomeContatto"] !== undefined ? _data["nomeContatto"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
            this.tipoEmissione = _data["tipoEmissione"] !== undefined ? _data["tipoEmissione"] : null as any;
            if (Array.isArray(_data["cumulativeVouchers"])) {
                this.cumulativeVouchers = [] as any;
                for (let item of _data["cumulativeVouchers"])
                    this.cumulativeVouchers!.push(VoucherRow.fromJS(item));
            }
            else {
                this.cumulativeVouchers = null as any;
            }
        }
    }

    static fromJS(data: any): VoucherRow {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["luogo"] = this.luogo !== undefined ? this.luogo : null as any;
        data["abbinamento"] = this.abbinamento !== undefined ? this.abbinamento : null as any;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : null as any;
        data["nomeContatto"] = this.nomeContatto !== undefined ? this.nomeContatto : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["tipoEmissione"] = this.tipoEmissione !== undefined ? this.tipoEmissione : null as any;
        if (Array.isArray(this.cumulativeVouchers)) {
            data["cumulativeVouchers"] = [];
            for (let item of this.cumulativeVouchers)
                data["cumulativeVouchers"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IVoucherRow {
    id?: number;
    luogo?: string;
    abbinamento?: string | null;
    descrizione?: string;
    nomeContatto?: string;
    data?: string;
    tipoEmissione?: string;
    cumulativeVouchers?: VoucherRow[] | null;
}

export class VouchersCreateRequest extends LocalizedRequest implements IVouchersCreateRequest {
    offertaID?: number;
    quantity?: number;

    constructor(data?: IVouchersCreateRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : null as any;
        }
    }

    static override fromJS(data: any): VouchersCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VouchersCreateRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        data["quantity"] = this.quantity !== undefined ? this.quantity : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IVouchersCreateRequest extends ILocalizedRequest {
    offertaID?: number;
    quantity?: number;
}

export class VouchersListRequest extends NrTableRequest implements IVouchersListRequest {
    offertaID?: number;

    constructor(data?: IVouchersListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : null as any;
        }
    }

    static override fromJS(data: any): VouchersListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VouchersListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IVouchersListRequest extends INrTableRequest {
    offertaID?: number;
}

export class GetPlaceWeatherResponse extends OkApiResponse implements IGetPlaceWeatherResponse {
    weather?: OWWeather | null;

    constructor(data?: IGetPlaceWeatherResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.weather = _data["weather"] ? OWWeather.fromJS(_data["weather"]) : null as any;
        }
    }

    static override fromJS(data: any): GetPlaceWeatherResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlaceWeatherResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weather"] = this.weather ? this.weather.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPlaceWeatherResponse extends IOkApiResponse {
    weather?: OWWeather | null;
}

export class OWWeather implements IOWWeather {
    description?: string;
    icon?: string;
    name?: string | null;
    temperature?: string | null;

    constructor(data?: IOWWeather) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.icon = _data["icon"] !== undefined ? _data["icon"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.temperature = _data["temperature"] !== undefined ? _data["temperature"] : null as any;
        }
    }

    static fromJS(data: any): OWWeather {
        data = typeof data === 'object' ? data : {};
        let result = new OWWeather();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["icon"] = this.icon !== undefined ? this.icon : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["temperature"] = this.temperature !== undefined ? this.temperature : null as any;
        return data;
    }
}

export interface IOWWeather {
    description?: string;
    icon?: string;
    name?: string | null;
    temperature?: string | null;
}

export class GetPlaceWeatherRequest extends LocalizedRequest implements IGetPlaceWeatherRequest {
    latitude?: number | null;
    longitude?: number | null;
    placeID?: number | null;

    constructor(data?: IGetPlaceWeatherRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : null as any;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : null as any;
            this.placeID = _data["placeID"] !== undefined ? _data["placeID"] : null as any;
        }
    }

    static override fromJS(data: any): GetPlaceWeatherRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlaceWeatherRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude !== undefined ? this.latitude : null as any;
        data["longitude"] = this.longitude !== undefined ? this.longitude : null as any;
        data["placeID"] = this.placeID !== undefined ? this.placeID : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPlaceWeatherRequest extends ILocalizedRequest {
    latitude?: number | null;
    longitude?: number | null;
    placeID?: number | null;
}

export class WebsiteLabelsGetResponse extends OkApiResponse implements IWebsiteLabelsGetResponse {
    id?: number;
    website?: EWebsite;
    label?: string | null;
    nome?: string | null;
    nomeInglese?: string | null;
    translations?: WebsiteLabelTranslation[] | null;

    constructor(data?: IWebsiteLabelsGetResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.website = _data["website"] !== undefined ? _data["website"] : null as any;
            this.label = _data["label"] !== undefined ? _data["label"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nomeInglese = _data["nomeInglese"] !== undefined ? _data["nomeInglese"] : null as any;
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(WebsiteLabelTranslation.fromJS(item));
            }
            else {
                this.translations = null as any;
            }
        }
    }

    static override fromJS(data: any): WebsiteLabelsGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WebsiteLabelsGetResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["website"] = this.website !== undefined ? this.website : null as any;
        data["label"] = this.label !== undefined ? this.label : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nomeInglese"] = this.nomeInglese !== undefined ? this.nomeInglese : null as any;
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IWebsiteLabelsGetResponse extends IOkApiResponse {
    id?: number;
    website?: EWebsite;
    label?: string | null;
    nome?: string | null;
    nomeInglese?: string | null;
    translations?: WebsiteLabelTranslation[] | null;
}

export enum EWebsite {
    App = "app",
    B2b = "b2b",
    B2c = "b2c",
    Intranet = "intranet",
    Print = "print",
}

export class WebsiteLabelTranslation implements IWebsiteLabelTranslation {
    id?: number;
    labelID?: number;
    lingua?: ELingua;
    translation?: string | null;
    confirmed?: boolean | null;
    aggiornato?: string | null;
    eliminato?: string | null;

    constructor(data?: IWebsiteLabelTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.labelID = _data["labelID"] !== undefined ? _data["labelID"] : null as any;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : null as any;
            this.translation = _data["translation"] !== undefined ? _data["translation"] : null as any;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : null as any;
            this.aggiornato = _data["aggiornato"] !== undefined ? _data["aggiornato"] : null as any;
            this.eliminato = _data["eliminato"] !== undefined ? _data["eliminato"] : null as any;
        }
    }

    static fromJS(data: any): WebsiteLabelTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new WebsiteLabelTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["labelID"] = this.labelID !== undefined ? this.labelID : null as any;
        data["lingua"] = this.lingua !== undefined ? this.lingua : null as any;
        data["translation"] = this.translation !== undefined ? this.translation : null as any;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : null as any;
        data["aggiornato"] = this.aggiornato !== undefined ? this.aggiornato : null as any;
        data["eliminato"] = this.eliminato !== undefined ? this.eliminato : null as any;
        return data;
    }
}

export interface IWebsiteLabelTranslation {
    id?: number;
    labelID?: number;
    lingua?: ELingua;
    translation?: string | null;
    confirmed?: boolean | null;
    aggiornato?: string | null;
    eliminato?: string | null;
}

export class WebsiteLabelsGetRequest extends ApiRequest implements IWebsiteLabelsGetRequest {
    id?: number;

    constructor(data?: IWebsiteLabelsGetRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): WebsiteLabelsGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WebsiteLabelsGetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IWebsiteLabelsGetRequest extends IApiRequest {
    id?: number;
}

export class WebsiteLabelsCreateRequest extends WebsiteLabelsGetRequest implements IWebsiteLabelsCreateRequest {
    label?: string | null;
    website?: EWebsite;
    nome?: string | null;
    nomeInglese?: string | null;
    translations?: WebsiteLabelTranslation[] | null;

    constructor(data?: IWebsiteLabelsCreateRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.label = _data["label"] !== undefined ? _data["label"] : null as any;
            this.website = _data["website"] !== undefined ? _data["website"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
            this.nomeInglese = _data["nomeInglese"] !== undefined ? _data["nomeInglese"] : null as any;
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(WebsiteLabelTranslation.fromJS(item));
            }
            else {
                this.translations = null as any;
            }
        }
    }

    static override fromJS(data: any): WebsiteLabelsCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WebsiteLabelsCreateRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label !== undefined ? this.label : null as any;
        data["website"] = this.website !== undefined ? this.website : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        data["nomeInglese"] = this.nomeInglese !== undefined ? this.nomeInglese : null as any;
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IWebsiteLabelsCreateRequest extends IWebsiteLabelsGetRequest {
    label?: string | null;
    website?: EWebsite;
    nome?: string | null;
    nomeInglese?: string | null;
    translations?: WebsiteLabelTranslation[] | null;
}

export class WebsiteLabelsDeleteRequest extends ApiRequest implements IWebsiteLabelsDeleteRequest {
    id?: number;

    constructor(data?: IWebsiteLabelsDeleteRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): WebsiteLabelsDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WebsiteLabelsDeleteRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IWebsiteLabelsDeleteRequest extends IApiRequest {
    id?: number;
}

export class NrTableResponseOfWebsiteLabelsRow extends OkApiResponse implements INrTableResponseOfWebsiteLabelsRow {
    /** Array delle righe della pagina richiesta */
    rows?: WebsiteLabelsRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfWebsiteLabelsRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(WebsiteLabelsRow.fromJS(item));
            }
            else {
                this.rows = null as any;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static override fromJS(data: any): NrTableResponseOfWebsiteLabelsRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfWebsiteLabelsRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : null as any);
        }
        data["total"] = this.total !== undefined ? this.total : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfWebsiteLabelsRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: WebsiteLabelsRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class WebsiteLabelsRow extends TranslationsListRow implements IWebsiteLabelsRow {
    website?: EWebsite | null;

    constructor(data?: IWebsiteLabelsRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.website = _data["website"] !== undefined ? _data["website"] : null as any;
        }
    }

    static override fromJS(data: any): WebsiteLabelsRow {
        data = typeof data === 'object' ? data : {};
        let result = new WebsiteLabelsRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["website"] = this.website !== undefined ? this.website : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IWebsiteLabelsRow extends ITranslationsListRow {
    website?: EWebsite | null;
}

export class WebsiteLabelsListRequest extends TranslationsListRequest implements IWebsiteLabelsListRequest {
    website?: EWebsite | null;
    /** Optional filter on label IDs, used to export only the rows selected in the intranet.
Ignored when null or empty. */
    labelIDs?: number[] | null;

    constructor(data?: IWebsiteLabelsListRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.website = _data["website"] !== undefined ? _data["website"] : null as any;
            if (Array.isArray(_data["labelIDs"])) {
                this.labelIDs = [] as any;
                for (let item of _data["labelIDs"])
                    this.labelIDs!.push(item);
            }
            else {
                this.labelIDs = null as any;
            }
        }
    }

    static override fromJS(data: any): WebsiteLabelsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WebsiteLabelsListRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["website"] = this.website !== undefined ? this.website : null as any;
        if (Array.isArray(this.labelIDs)) {
            data["labelIDs"] = [];
            for (let item of this.labelIDs)
                data["labelIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IWebsiteLabelsListRequest extends ITranslationsListRequest {
    website?: EWebsite | null;
    /** Optional filter on label IDs, used to export only the rows selected in the intranet.
Ignored when null or empty. */
    labelIDs?: number[] | null;
}

export class MissingLabelRequest extends ApiRequest implements IMissingLabelRequest {
    label?: string | null;
    website?: EWebsite;
    langCode?: string | null;
    url?: string | null;

    constructor(data?: IMissingLabelRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.label = _data["label"] !== undefined ? _data["label"] : null as any;
            this.website = _data["website"] !== undefined ? _data["website"] : null as any;
            this.langCode = _data["langCode"] !== undefined ? _data["langCode"] : null as any;
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
        }
    }

    static override fromJS(data: any): MissingLabelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MissingLabelRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label !== undefined ? this.label : null as any;
        data["website"] = this.website !== undefined ? this.website : null as any;
        data["langCode"] = this.langCode !== undefined ? this.langCode : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IMissingLabelRequest extends IApiRequest {
    label?: string | null;
    website?: EWebsite;
    langCode?: string | null;
    url?: string | null;
}

export class WebsiteLabelsUpdateRequest extends WebsiteLabelsCreateRequest implements IWebsiteLabelsUpdateRequest {

    constructor(data?: IWebsiteLabelsUpdateRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): WebsiteLabelsUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WebsiteLabelsUpdateRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IWebsiteLabelsUpdateRequest extends IWebsiteLabelsCreateRequest {
}

export class GetWebsitesResponse extends OkApiResponse implements IGetWebsitesResponse {
    websites?: WebsiteDef[] | null;
    siti?: Site[] | null;

    constructor(data?: IGetWebsitesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["websites"])) {
                this.websites = [] as any;
                for (let item of _data["websites"])
                    this.websites!.push(WebsiteDef.fromJS(item));
            }
            else {
                this.websites = null as any;
            }
            if (Array.isArray(_data["siti"])) {
                this.siti = [] as any;
                for (let item of _data["siti"])
                    this.siti!.push(Site.fromJS(item));
            }
            else {
                this.siti = null as any;
            }
        }
    }

    static override fromJS(data: any): GetWebsitesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWebsitesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.websites)) {
            data["websites"] = [];
            for (let item of this.websites)
                data["websites"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.siti)) {
            data["siti"] = [];
            for (let item of this.siti)
                data["siti"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetWebsitesResponse extends IOkApiResponse {
    websites?: WebsiteDef[] | null;
    siti?: Site[] | null;
}

export class WebsiteDef implements IWebsiteDef {
    id?: number;
    host?: string | null;
    defaultLangCode?: string | null;
    operatore?: EOperatore;
    availableLanguages?: WebsiteLanguage[] | null;
    currencyName?: string | null;
    currencyValue?: number | null;

    constructor(data?: IWebsiteDef) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.host = _data["host"] !== undefined ? _data["host"] : null as any;
            this.defaultLangCode = _data["defaultLangCode"] !== undefined ? _data["defaultLangCode"] : null as any;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : null as any;
            if (Array.isArray(_data["availableLanguages"])) {
                this.availableLanguages = [] as any;
                for (let item of _data["availableLanguages"])
                    this.availableLanguages!.push(WebsiteLanguage.fromJS(item));
            }
            else {
                this.availableLanguages = null as any;
            }
            this.currencyName = _data["currencyName"] !== undefined ? _data["currencyName"] : null as any;
            this.currencyValue = _data["currencyValue"] !== undefined ? _data["currencyValue"] : null as any;
        }
    }

    static fromJS(data: any): WebsiteDef {
        data = typeof data === 'object' ? data : {};
        let result = new WebsiteDef();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["host"] = this.host !== undefined ? this.host : null as any;
        data["defaultLangCode"] = this.defaultLangCode !== undefined ? this.defaultLangCode : null as any;
        data["operatore"] = this.operatore !== undefined ? this.operatore : null as any;
        if (Array.isArray(this.availableLanguages)) {
            data["availableLanguages"] = [];
            for (let item of this.availableLanguages)
                data["availableLanguages"].push(item ? item.toJSON() : null as any);
        }
        data["currencyName"] = this.currencyName !== undefined ? this.currencyName : null as any;
        data["currencyValue"] = this.currencyValue !== undefined ? this.currencyValue : null as any;
        return data;
    }
}

export interface IWebsiteDef {
    id?: number;
    host?: string | null;
    defaultLangCode?: string | null;
    operatore?: EOperatore;
    availableLanguages?: WebsiteLanguage[] | null;
    currencyName?: string | null;
    currencyValue?: number | null;
}

export class Site implements ISite {
    id?: number;
    nome?: string | null;

    constructor(data?: ISite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : null as any;
        }
    }

    static fromJS(data: any): Site {
        data = typeof data === 'object' ? data : {};
        let result = new Site();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nome"] = this.nome !== undefined ? this.nome : null as any;
        return data;
    }
}

export interface ISite {
    id?: number;
    nome?: string | null;
}

export class Trip implements ITrip {
    tripID?: string;
    tripName!: string;
    tourOperatorID!: string;
    tourOperatorTripID!: string;
    quoteUUID?: string;
    previewUUID?: string;
    desc?: string;
    dateStart!: string;
    dateEnd!: string;
    locale!: string;
    status!: TripStatus2;
    generalContacts?: number[];
    featuredImage?: number;
    agency!: Agency;
    itinerary!: Step2[];
    images?: Image[];
    documents?: Document[];
    contacts!: Contact[];
    services!: Service[];
    paxList!: Pax[];
    mobiles?: MobileTuple[];
    prices?: Price[];
    updatedAt?: string;
    createdAt?: string;

    [key: string]: any;

    constructor(data?: ITrip) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.agency = new Agency();
            this.itinerary = [];
            this.contacts = [];
            this.services = [];
            this.paxList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : null as any;
            this.tripName = _data["tripName"] !== undefined ? _data["tripName"] : null as any;
            this.tourOperatorID = _data["tourOperatorID"] !== undefined ? _data["tourOperatorID"] : null as any;
            this.tourOperatorTripID = _data["tourOperatorTripID"] !== undefined ? _data["tourOperatorTripID"] : null as any;
            this.quoteUUID = _data["quoteUUID"] !== undefined ? _data["quoteUUID"] : null as any;
            this.previewUUID = _data["previewUUID"] !== undefined ? _data["previewUUID"] : null as any;
            this.desc = _data["desc"] !== undefined ? _data["desc"] : null as any;
            this.dateStart = _data["dateStart"] !== undefined ? _data["dateStart"] : null as any;
            this.dateEnd = _data["dateEnd"] !== undefined ? _data["dateEnd"] : null as any;
            this.locale = _data["locale"] !== undefined ? _data["locale"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            if (Array.isArray(_data["generalContacts"])) {
                this.generalContacts = [] as any;
                for (let item of _data["generalContacts"])
                    this.generalContacts!.push(item);
            }
            else {
                this.generalContacts = null as any;
            }
            this.featuredImage = _data["featuredImage"] !== undefined ? _data["featuredImage"] : null as any;
            this.agency = _data["agency"] ? Agency.fromJS(_data["agency"]) : new Agency();
            if (Array.isArray(_data["itinerary"])) {
                this.itinerary = [] as any;
                for (let item of _data["itinerary"])
                    this.itinerary!.push(Step2.fromJS(item));
            }
            else {
                this.itinerary = null as any;
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(Image.fromJS(item));
            }
            else {
                this.images = null as any;
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(Document.fromJS(item));
            }
            else {
                this.documents = null as any;
            }
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(Contact.fromJS(item));
            }
            else {
                this.contacts = null as any;
            }
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(Service.fromJS(item));
            }
            else {
                this.services = null as any;
            }
            if (Array.isArray(_data["paxList"])) {
                this.paxList = [] as any;
                for (let item of _data["paxList"])
                    this.paxList!.push(Pax.fromJS(item));
            }
            else {
                this.paxList = null as any;
            }
            if (Array.isArray(_data["mobiles"])) {
                this.mobiles = [] as any;
                for (let item of _data["mobiles"])
                    this.mobiles!.push(MobileTuple.fromJS(item));
            }
            else {
                this.mobiles = null as any;
            }
            if (Array.isArray(_data["prices"])) {
                this.prices = [] as any;
                for (let item of _data["prices"])
                    this.prices!.push(Price.fromJS(item));
            }
            else {
                this.prices = null as any;
            }
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : null as any;
            this.createdAt = _data["createdAt"] !== undefined ? _data["createdAt"] : null as any;
        }
    }

    static fromJS(data: any): Trip {
        data = typeof data === 'object' ? data : {};
        let result = new Trip();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["tripID"] = this.tripID !== undefined ? this.tripID : null as any;
        data["tripName"] = this.tripName !== undefined ? this.tripName : null as any;
        data["tourOperatorID"] = this.tourOperatorID !== undefined ? this.tourOperatorID : null as any;
        data["tourOperatorTripID"] = this.tourOperatorTripID !== undefined ? this.tourOperatorTripID : null as any;
        data["quoteUUID"] = this.quoteUUID !== undefined ? this.quoteUUID : null as any;
        data["previewUUID"] = this.previewUUID !== undefined ? this.previewUUID : null as any;
        data["desc"] = this.desc !== undefined ? this.desc : null as any;
        data["dateStart"] = this.dateStart !== undefined ? this.dateStart : null as any;
        data["dateEnd"] = this.dateEnd !== undefined ? this.dateEnd : null as any;
        data["locale"] = this.locale !== undefined ? this.locale : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        if (Array.isArray(this.generalContacts)) {
            data["generalContacts"] = [];
            for (let item of this.generalContacts)
                data["generalContacts"].push(item);
        }
        data["featuredImage"] = this.featuredImage !== undefined ? this.featuredImage : null as any;
        data["agency"] = this.agency ? this.agency.toJSON() : null as any;
        if (Array.isArray(this.itinerary)) {
            data["itinerary"] = [];
            for (let item of this.itinerary)
                data["itinerary"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.paxList)) {
            data["paxList"] = [];
            for (let item of this.paxList)
                data["paxList"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.mobiles)) {
            data["mobiles"] = [];
            for (let item of this.mobiles)
                data["mobiles"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.prices)) {
            data["prices"] = [];
            for (let item of this.prices)
                data["prices"].push(item ? item.toJSON() : null as any);
        }
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : null as any;
        data["createdAt"] = this.createdAt !== undefined ? this.createdAt : null as any;
        return data;
    }
}

export interface ITrip {
    tripID?: string;
    tripName: string;
    tourOperatorID: string;
    tourOperatorTripID: string;
    quoteUUID?: string;
    previewUUID?: string;
    desc?: string;
    dateStart: string;
    dateEnd: string;
    locale: string;
    status: TripStatus2;
    generalContacts?: number[];
    featuredImage?: number;
    agency: Agency;
    itinerary: Step2[];
    images?: Image[];
    documents?: Document[];
    contacts: Contact[];
    services: Service[];
    paxList: Pax[];
    mobiles?: MobileTuple[];
    prices?: Price[];
    updatedAt?: string;
    createdAt?: string;

    [key: string]: any;
}

export enum TripStatus2 {
    CONFIRMED = "CONFIRMED",
    PENDING = "PENDING",
    CANCELED = "CANCELED",
    QUOTE = "QUOTE",
}

export class Agency implements IAgency {
    id!: number;
    title!: string;
    desc?: string;
    image?: number;
    contacts?: number[];

    [key: string]: any;

    constructor(data?: IAgency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.desc = _data["desc"] !== undefined ? _data["desc"] : null as any;
            this.image = _data["image"] !== undefined ? _data["image"] : null as any;
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(item);
            }
            else {
                this.contacts = null as any;
            }
        }
    }

    static fromJS(data: any): Agency {
        data = typeof data === 'object' ? data : {};
        let result = new Agency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["desc"] = this.desc !== undefined ? this.desc : null as any;
        data["image"] = this.image !== undefined ? this.image : null as any;
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item);
        }
        return data;
    }
}

export interface IAgency {
    id: number;
    title: string;
    desc?: string;
    image?: number;
    contacts?: number[];

    [key: string]: any;
}

export class Step2 implements IStep2 {
    stepID!: number;
    type!: StepType;
    cityID?: string;
    cityCode?: string;
    cityName!: string;
    cityDesc?: string;
    dateStart!: string;
    dateEnd!: string;
    autoGuide?: boolean;
    map?: Map;
    images?: number[];
    services?: number[];
    contacts?: number[];
    documents?: number[];
    references?: Reference[];

    [key: string]: any;

    constructor(data?: IStep2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.stepID = _data["stepID"] !== undefined ? _data["stepID"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.cityID = _data["cityID"] !== undefined ? _data["cityID"] : null as any;
            this.cityCode = _data["cityCode"] !== undefined ? _data["cityCode"] : null as any;
            this.cityName = _data["cityName"] !== undefined ? _data["cityName"] : null as any;
            this.cityDesc = _data["cityDesc"] !== undefined ? _data["cityDesc"] : null as any;
            this.dateStart = _data["dateStart"] !== undefined ? _data["dateStart"] : null as any;
            this.dateEnd = _data["dateEnd"] !== undefined ? _data["dateEnd"] : null as any;
            this.autoGuide = _data["autoGuide"] !== undefined ? _data["autoGuide"] : null as any;
            this.map = _data["map"] ? Map.fromJS(_data["map"]) : null as any;
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(item);
            }
            else {
                this.images = null as any;
            }
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(item);
            }
            else {
                this.services = null as any;
            }
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(item);
            }
            else {
                this.contacts = null as any;
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(item);
            }
            else {
                this.documents = null as any;
            }
            if (Array.isArray(_data["references"])) {
                this.references = [] as any;
                for (let item of _data["references"])
                    this.references!.push(Reference.fromJS(item));
            }
            else {
                this.references = null as any;
            }
        }
    }

    static fromJS(data: any): Step2 {
        data = typeof data === 'object' ? data : {};
        let result = new Step2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["stepID"] = this.stepID !== undefined ? this.stepID : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["cityID"] = this.cityID !== undefined ? this.cityID : null as any;
        data["cityCode"] = this.cityCode !== undefined ? this.cityCode : null as any;
        data["cityName"] = this.cityName !== undefined ? this.cityName : null as any;
        data["cityDesc"] = this.cityDesc !== undefined ? this.cityDesc : null as any;
        data["dateStart"] = this.dateStart !== undefined ? this.dateStart : null as any;
        data["dateEnd"] = this.dateEnd !== undefined ? this.dateEnd : null as any;
        data["autoGuide"] = this.autoGuide !== undefined ? this.autoGuide : null as any;
        data["map"] = this.map ? this.map.toJSON() : null as any;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item);
        }
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item);
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item);
        }
        if (Array.isArray(this.references)) {
            data["references"] = [];
            for (let item of this.references)
                data["references"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IStep2 {
    stepID: number;
    type: StepType;
    cityID?: string;
    cityCode?: string;
    cityName: string;
    cityDesc?: string;
    dateStart: string;
    dateEnd: string;
    autoGuide?: boolean;
    map?: Map;
    images?: number[];
    services?: number[];
    contacts?: number[];
    documents?: number[];
    references?: Reference[];

    [key: string]: any;
}

export enum StepType {
    START = "START",
    TRANSFERT = "TRANSFERT",
    STEP = "STEP",
    END = "END",
}

export class Map implements IMap {
    lat!: number;
    lng!: number;
    zoom?: number;
    minZoom?: number;
    maxZoom?: number;

    [key: string]: any;

    constructor(data?: IMap) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.lat = _data["lat"] !== undefined ? _data["lat"] : null as any;
            this.lng = _data["lng"] !== undefined ? _data["lng"] : null as any;
            this.zoom = _data["zoom"] !== undefined ? _data["zoom"] : null as any;
            this.minZoom = _data["minZoom"] !== undefined ? _data["minZoom"] : null as any;
            this.maxZoom = _data["maxZoom"] !== undefined ? _data["maxZoom"] : null as any;
        }
    }

    static fromJS(data: any): Map {
        data = typeof data === 'object' ? data : {};
        let result = new Map();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["lat"] = this.lat !== undefined ? this.lat : null as any;
        data["lng"] = this.lng !== undefined ? this.lng : null as any;
        data["zoom"] = this.zoom !== undefined ? this.zoom : null as any;
        data["minZoom"] = this.minZoom !== undefined ? this.minZoom : null as any;
        data["maxZoom"] = this.maxZoom !== undefined ? this.maxZoom : null as any;
        return data;
    }
}

export interface IMap {
    lat: number;
    lng: number;
    zoom?: number;
    minZoom?: number;
    maxZoom?: number;

    [key: string]: any;
}

export class Reference implements IReference {
    id?: number;
    title?: string;
    type?: string;
    languageId?: string;
    url?: string;
    supplier?: string;
    enabled?: boolean;

    [key: string]: any;

    constructor(data?: IReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.languageId = _data["languageId"] !== undefined ? _data["languageId"] : null as any;
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : null as any;
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : null as any;
        }
    }

    static fromJS(data: any): Reference {
        data = typeof data === 'object' ? data : {};
        let result = new Reference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["languageId"] = this.languageId !== undefined ? this.languageId : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        data["supplier"] = this.supplier !== undefined ? this.supplier : null as any;
        data["enabled"] = this.enabled !== undefined ? this.enabled : null as any;
        return data;
    }
}

export interface IReference {
    id?: number;
    title?: string;
    type?: string;
    languageId?: string;
    url?: string;
    supplier?: string;
    enabled?: boolean;

    [key: string]: any;
}

export class Image implements IImage {
    id!: number;
    type!: ImageType;
    isFeatured!: boolean;
    url!: string;
    source!: ImageSource;
    updatedAt?: string;

    [key: string]: any;

    constructor(data?: IImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.isFeatured = _data["isFeatured"] !== undefined ? _data["isFeatured"] : null as any;
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : null as any;
        }
    }

    static fromJS(data: any): Image {
        data = typeof data === 'object' ? data : {};
        let result = new Image();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["isFeatured"] = this.isFeatured !== undefined ? this.isFeatured : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : null as any;
        return data;
    }
}

export interface IImage {
    id: number;
    type: ImageType;
    isFeatured: boolean;
    url: string;
    source: ImageSource;
    updatedAt?: string;

    [key: string]: any;
}

export enum ImageType {
    CITY = "CITY",
    SERVICE = "SERVICE",
    AGENCY = "AGENCY",
    OTHER = "OTHER",
}

export enum ImageSource {
    WEELLGODRIVE = "WEELLGODRIVE",
    PUBLIC = "PUBLIC",
}

export class Document implements IDocument {
    id!: number;
    type!: DocumentType2;
    title!: string;
    desc?: string;
    url!: string;
    source!: DocumentSource;
    updatedAt?: string;

    [key: string]: any;

    constructor(data?: IDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.desc = _data["desc"] !== undefined ? _data["desc"] : null as any;
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : null as any;
        }
    }

    static fromJS(data: any): Document {
        data = typeof data === 'object' ? data : {};
        let result = new Document();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["desc"] = this.desc !== undefined ? this.desc : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : null as any;
        return data;
    }
}

export interface IDocument {
    id: number;
    type: DocumentType2;
    title: string;
    desc?: string;
    url: string;
    source: DocumentSource;
    updatedAt?: string;

    [key: string]: any;
}

export enum DocumentType2 {
    VOUCHER = "VOUCHER",
    GUIDE = "GUIDE",
    INFO = "INFO",
    EXTRA = "EXTRA",
    TICKET = "TICKET",
    BOARDING_PASS = "BOARDING_PASS",
    PROGRAM = "PROGRAM",
    INSURANCE = "INSURANCE",
}

export enum DocumentSource {
    WEELLGODRIVE = "WEELLGODRIVE",
    PUBLIC = "PUBLIC",
}

export class Contact implements IContact {
    id!: number;
    type!: ContactType;
    title!: string;
    desc?: string;
    phones?: Phone2[];
    emails?: Email2[];
    address?: string;
    website?: string;

    [key: string]: any;

    constructor(data?: IContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.desc = _data["desc"] !== undefined ? _data["desc"] : null as any;
            if (Array.isArray(_data["phones"])) {
                this.phones = [] as any;
                for (let item of _data["phones"])
                    this.phones!.push(Phone2.fromJS(item));
            }
            else {
                this.phones = null as any;
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(Email2.fromJS(item));
            }
            else {
                this.emails = null as any;
            }
            this.address = _data["address"] !== undefined ? _data["address"] : null as any;
            this.website = _data["website"] !== undefined ? _data["website"] : null as any;
        }
    }

    static fromJS(data: any): Contact {
        data = typeof data === 'object' ? data : {};
        let result = new Contact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["desc"] = this.desc !== undefined ? this.desc : null as any;
        if (Array.isArray(this.phones)) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item ? item.toJSON() : null as any);
        }
        data["address"] = this.address !== undefined ? this.address : null as any;
        data["website"] = this.website !== undefined ? this.website : null as any;
        return data;
    }
}

export interface IContact {
    id: number;
    type: ContactType;
    title: string;
    desc?: string;
    phones?: Phone2[];
    emails?: Email2[];
    address?: string;
    website?: string;

    [key: string]: any;
}

export enum ContactType {
    AGENCY = "AGENCY",
    TO = "TO",
    HOTEL = "HOTEL",
    POLICE = "POLICE",
    HOSPITAL = "HOSPITAL",
    SERVICE = "SERVICE",
    OTHER = "OTHER",
    INSURANCE = "INSURANCE",
    GUIDE = "GUIDE",
    CORRESPONDING = "CORRESPONDING",
    EMERGENCY = "EMERGENCY",
    CONSULATE_EMBASSY = "CONSULATE_EMBASSY",
}

export class Phone2 implements IPhone2 {
    title!: string;
    phone!: string;
    type?: PhoneType;

    [key: string]: any;

    constructor(data?: IPhone2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
        }
    }

    static fromJS(data: any): Phone2 {
        data = typeof data === 'object' ? data : {};
        let result = new Phone2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        return data;
    }
}

export interface IPhone2 {
    title: string;
    phone: string;
    type?: PhoneType;

    [key: string]: any;
}

export enum PhoneType {
    WHATSAPP = "WHATSAPP",
}

export class Email2 implements IEmail2 {
    title!: string;
    email!: string;

    [key: string]: any;

    constructor(data?: IEmail2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
        }
    }

    static fromJS(data: any): Email2 {
        data = typeof data === 'object' ? data : {};
        let result = new Email2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        return data;
    }
}

export interface IEmail2 {
    title: string;
    email: string;

    [key: string]: any;
}

export class Service implements IService {
    id!: number;
    type!: ServiceType;
    title!: string;
    desc?: string;
    images?: number[];
    documents?: number[];
    serviceData?: any;
    servicePaxList?: number[];
    markers?: Marker[];
    contacts?: number[];
    date!: string;
    status!: ServiceStatus;
    price?: Price;
    parentID?: number;

    [key: string]: any;

    constructor(data?: IService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.desc = _data["desc"] !== undefined ? _data["desc"] : null as any;
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(item);
            }
            else {
                this.images = null as any;
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(item);
            }
            else {
                this.documents = null as any;
            }
            this.serviceData = _data["serviceData"] !== undefined ? _data["serviceData"] : null as any;
            if (Array.isArray(_data["servicePaxList"])) {
                this.servicePaxList = [] as any;
                for (let item of _data["servicePaxList"])
                    this.servicePaxList!.push(item);
            }
            else {
                this.servicePaxList = null as any;
            }
            if (Array.isArray(_data["markers"])) {
                this.markers = [] as any;
                for (let item of _data["markers"])
                    this.markers!.push(Marker.fromJS(item));
            }
            else {
                this.markers = null as any;
            }
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(item);
            }
            else {
                this.contacts = null as any;
            }
            this.date = _data["date"] !== undefined ? _data["date"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.price = _data["price"] ? Price.fromJS(_data["price"]) : null as any;
            this.parentID = _data["parentID"] !== undefined ? _data["parentID"] : null as any;
        }
    }

    static fromJS(data: any): Service {
        data = typeof data === 'object' ? data : {};
        let result = new Service();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["desc"] = this.desc !== undefined ? this.desc : null as any;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item);
        }
        data["serviceData"] = this.serviceData !== undefined ? this.serviceData : null as any;
        if (Array.isArray(this.servicePaxList)) {
            data["servicePaxList"] = [];
            for (let item of this.servicePaxList)
                data["servicePaxList"].push(item);
        }
        if (Array.isArray(this.markers)) {
            data["markers"] = [];
            for (let item of this.markers)
                data["markers"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item);
        }
        data["date"] = this.date !== undefined ? this.date : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["price"] = this.price ? this.price.toJSON() : null as any;
        data["parentID"] = this.parentID !== undefined ? this.parentID : null as any;
        return data;
    }
}

export interface IService {
    id: number;
    type: ServiceType;
    title: string;
    desc?: string;
    images?: number[];
    documents?: number[];
    serviceData?: any;
    servicePaxList?: number[];
    markers?: Marker[];
    contacts?: number[];
    date: string;
    status: ServiceStatus;
    price?: Price;
    parentID?: number;

    [key: string]: any;
}

export enum ServiceType {
    FLIGHT = "FLIGHT",
    TRANSFER = "TRANSFER",
    EXCURSION = "EXCURSION",
    TOUR = "TOUR",
    HOTEL = "HOTEL",
    PARKING = "PARKING",
    CAR_RENT = "CAR_RENT",
    TRAIN = "TRAIN",
    FERRY = "FERRY",
    LUNCH_DINNER = "LUNCH_DINNER",
    OTHER = "OTHER",
}

export class Marker implements IMarker {
    lat!: number;
    lng!: number;
    title?: string;

    [key: string]: any;

    constructor(data?: IMarker) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.lat = _data["lat"] !== undefined ? _data["lat"] : null as any;
            this.lng = _data["lng"] !== undefined ? _data["lng"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
        }
    }

    static fromJS(data: any): Marker {
        data = typeof data === 'object' ? data : {};
        let result = new Marker();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["lat"] = this.lat !== undefined ? this.lat : null as any;
        data["lng"] = this.lng !== undefined ? this.lng : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        return data;
    }
}

export interface IMarker {
    lat: number;
    lng: number;
    title?: string;

    [key: string]: any;
}

export enum ServiceStatus {
    CONFIRMED = "CONFIRMED",
    PENDING = "PENDING",
    CANCELED = "CANCELED",
    QUOTE = "QUOTE",
}

export class Price implements IPrice {
    label?: string;
    amount?: number;
    currency?: PriceCurrency;

    [key: string]: any;

    constructor(data?: IPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.label = _data["label"] !== undefined ? _data["label"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : null as any;
        }
    }

    static fromJS(data: any): Price {
        data = typeof data === 'object' ? data : {};
        let result = new Price();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["label"] = this.label !== undefined ? this.label : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["currency"] = this.currency !== undefined ? this.currency : null as any;
        return data;
    }
}

export interface IPrice {
    label?: string;
    amount?: number;
    currency?: PriceCurrency;

    [key: string]: any;
}

export enum PriceCurrency {
    EUR = "EUR",
    USD = "USD",
    CHF = "CHF",
}

export class Pax implements IPax {
    id!: number;
    lastname!: string;
    firstname!: string;
    type!: PaxType;
    birthday?: string;
    isMainPax?: boolean;
    email?: string;
    phone?: string;

    [key: string]: any;

    constructor(data?: IPax) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.lastname = _data["lastname"] !== undefined ? _data["lastname"] : null as any;
            this.firstname = _data["firstname"] !== undefined ? _data["firstname"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.birthday = _data["birthday"] !== undefined ? _data["birthday"] : null as any;
            this.isMainPax = _data["isMainPax"] !== undefined ? _data["isMainPax"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
        }
    }

    static fromJS(data: any): Pax {
        data = typeof data === 'object' ? data : {};
        let result = new Pax();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["lastname"] = this.lastname !== undefined ? this.lastname : null as any;
        data["firstname"] = this.firstname !== undefined ? this.firstname : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["birthday"] = this.birthday !== undefined ? this.birthday : null as any;
        data["isMainPax"] = this.isMainPax !== undefined ? this.isMainPax : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        return data;
    }
}

export interface IPax {
    id: number;
    lastname: string;
    firstname: string;
    type: PaxType;
    birthday?: string;
    isMainPax?: boolean;
    email?: string;
    phone?: string;

    [key: string]: any;
}

export enum PaxType {
    ADULT = "ADULT",
    CHILD = "CHILD",
    INFANT = "INFANT",
}

export class MobileTuple implements IMobileTuple {
    id?: string;
    token!: string;
    os!: string;
    identityId?: string;

    [key: string]: any;

    constructor(data?: IMobileTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.token = _data["token"] !== undefined ? _data["token"] : null as any;
            this.os = _data["os"] !== undefined ? _data["os"] : null as any;
            this.identityId = _data["identityId"] !== undefined ? _data["identityId"] : null as any;
        }
    }

    static fromJS(data: any): MobileTuple {
        data = typeof data === 'object' ? data : {};
        let result = new MobileTuple();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["token"] = this.token !== undefined ? this.token : null as any;
        data["os"] = this.os !== undefined ? this.os : null as any;
        data["identityId"] = this.identityId !== undefined ? this.identityId : null as any;
        return data;
    }
}

export interface IMobileTuple {
    id?: string;
    token: string;
    os: string;
    identityId?: string;

    [key: string]: any;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}